(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["able-react"] = factory();
	else
		root["able-react"] = factory();
})(this, () => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 493:
/***/ (() => {



/***/ }),

/***/ 1116:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 2015:
/***/ ((module) => {

"use strict";
module.exports = require("react");

/***/ }),

/***/ 2462:
/***/ ((module) => {

"use strict";
module.exports = require("@babel/runtime/helpers/objectWithoutProperties");

/***/ }),

/***/ 5547:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  QPr: () => (/* reexport */ GeneratedPictoComponents_Accessories104),
  _Zu: () => (/* reexport */ GeneratedPictoComponents_Accessories56),
  d0I: () => (/* reexport */ GeneratedPictoComponents_AccountsPayments104),
  REj: () => (/* reexport */ GeneratedPictoComponents_AccountsPayments56),
  Utp: () => (/* reexport */ GeneratedPictoComponents_AdaptiveCollaborationCloud104),
  uZA: () => (/* reexport */ GeneratedPictoComponents_AdaptiveCollaborationCloud56),
  HcZ: () => (/* reexport */ GeneratedPictoComponents_AdaptiveCollaborationPhone104),
  xZ_: () => (/* reexport */ GeneratedPictoComponents_AdaptiveCollaborationPhone56),
  g4K: () => (/* reexport */ GeneratedPictoComponents_AdaptiveNetworksCentre104),
  oje: () => (/* reexport */ GeneratedPictoComponents_AdaptiveNetworksCentre56),
  vsu: () => (/* reexport */ GeneratedPictoComponents_Add104),
  NXV: () => (/* reexport */ GeneratedPictoComponents_Add56),
  fWu: () => (/* reexport */ GeneratedPictoComponents_AddPhone104),
  V7t: () => (/* reexport */ GeneratedPictoComponents_AddPhone56),
  eXj: () => (/* reexport */ GeneratedPictoComponents_AdultFemale104),
  E3S: () => (/* reexport */ GeneratedPictoComponents_AdultFemale56),
  tcT: () => (/* reexport */ GeneratedPictoComponents_AdultMale104),
  Zi1: () => (/* reexport */ GeneratedPictoComponents_AdultMale56),
  ch_: () => (/* reexport */ GeneratedPictoComponents_AndrogynousPersonOne104),
  Q8C: () => (/* reexport */ GeneratedPictoComponents_AndrogynousPersonOne56),
  Cx_: () => (/* reexport */ GeneratedPictoComponents_AndrogynousPersonTwo104),
  AhW: () => (/* reexport */ GeneratedPictoComponents_AndrogynousPersonTwo56),
  WSR: () => (/* reexport */ GeneratedPictoComponents_AppMyTelstra104),
  qDK: () => (/* reexport */ GeneratedPictoComponents_AppMyTelstra56),
  FOm: () => (/* reexport */ GeneratedPictoComponents_Appointment104),
  hI1: () => (/* reexport */ GeneratedPictoComponents_Appointment56),
  QEx: () => (/* reexport */ GeneratedPictoComponents_Arts104),
  ac3: () => (/* reexport */ GeneratedPictoComponents_Arts56),
  aIk: () => (/* reexport */ GeneratedPictoComponents_Australia104),
  O3F: () => (/* reexport */ GeneratedPictoComponents_Australia56),
  v6m: () => (/* reexport */ GeneratedPictoComponents_AvatarAdultFemale104),
  jwJ: () => (/* reexport */ GeneratedPictoComponents_AvatarAdultFemale56),
  Ah2: () => (/* reexport */ GeneratedPictoComponents_AvatarAdultMale104),
  I0M: () => (/* reexport */ GeneratedPictoComponents_AvatarAdultMale56),
  h9e: () => (/* reexport */ GeneratedPictoComponents_AvatarAndrogynousPersonOne104),
  Z1y: () => (/* reexport */ GeneratedPictoComponents_AvatarAndrogynousPersonOne56),
  BuJ: () => (/* reexport */ GeneratedPictoComponents_AvatarAndrogynousPersonTwo104),
  nhX: () => (/* reexport */ GeneratedPictoComponents_AvatarAndrogynousPersonTwo56),
  XAp: () => (/* reexport */ GeneratedPictoComponents_AvatarBaby104),
  xJt: () => (/* reexport */ GeneratedPictoComponents_AvatarBaby56),
  Rjr: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldMale104),
  xX7: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldMale56),
  UQg: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldManBeard104),
  QT5: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldManBeard56),
  WG: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldManGlasses104),
  AAs: () => (/* reexport */ GeneratedPictoComponents_AvatarBaldManGlasses56),
  pgS: () => (/* reexport */ GeneratedPictoComponents_AvatarBeardMan104),
  $l4: () => (/* reexport */ GeneratedPictoComponents_AvatarBeardMan56),
  zHm: () => (/* reexport */ GeneratedPictoComponents_AvatarBoy104),
  RmD: () => (/* reexport */ GeneratedPictoComponents_AvatarBoy56),
  rcj: () => (/* reexport */ GeneratedPictoComponents_AvatarCat104),
  voT: () => (/* reexport */ GeneratedPictoComponents_AvatarCat56),
  b5x: () => (/* reexport */ GeneratedPictoComponents_AvatarChild104),
  t8E: () => (/* reexport */ GeneratedPictoComponents_AvatarChild56),
  SHB: () => (/* reexport */ GeneratedPictoComponents_AvatarDoctorFemale104),
  otz: () => (/* reexport */ GeneratedPictoComponents_AvatarDoctorFemale56),
  Hh7: () => (/* reexport */ GeneratedPictoComponents_AvatarDog104),
  N0t: () => (/* reexport */ GeneratedPictoComponents_AvatarDog56),
  Gx1: () => (/* reexport */ GeneratedPictoComponents_AvatarElderlyFemale104),
  Q1i: () => (/* reexport */ GeneratedPictoComponents_AvatarElderlyFemale56),
  N0n: () => (/* reexport */ GeneratedPictoComponents_AvatarElderlyMale104),
  axd: () => (/* reexport */ GeneratedPictoComponents_AvatarElderlyMan56),
  $NO: () => (/* reexport */ GeneratedPictoComponents_AvatarFemaleOveralls104),
  Tjc: () => (/* reexport */ GeneratedPictoComponents_AvatarFemaleOveralls56),
  tMu: () => (/* reexport */ GeneratedPictoComponents_AvatarFirstNationsFemale104),
  BOo: () => (/* reexport */ GeneratedPictoComponents_AvatarFirstNationsFemale56),
  CB9: () => (/* reexport */ GeneratedPictoComponents_AvatarFirstNationsMale104),
  Qll: () => (/* reexport */ GeneratedPictoComponents_AvatarFirstNationsMale56),
  SQV: () => (/* reexport */ GeneratedPictoComponents_AvatarGirlPigTails104),
  YsU: () => (/* reexport */ GeneratedPictoComponents_AvatarGirlPigTails56),
  jeu: () => (/* reexport */ GeneratedPictoComponents_AvatarHatAndSunglasses104),
  Rlz: () => (/* reexport */ GeneratedPictoComponents_AvatarHatAndSunglasses56),
  FPx: () => (/* reexport */ GeneratedPictoComponents_AvatarHijabFemale104),
  juj: () => (/* reexport */ GeneratedPictoComponents_AvatarHijabFemale56),
  dPE: () => (/* reexport */ GeneratedPictoComponents_AvatarLady104),
  XMD: () => (/* reexport */ GeneratedPictoComponents_AvatarLady56),
  xFb: () => (/* reexport */ GeneratedPictoComponents_AvatarLadyGlasses104),
  ni: () => (/* reexport */ GeneratedPictoComponents_AvatarLadyGlasses56),
  $E6: () => (/* reexport */ GeneratedPictoComponents_AvatarLonghairGirl104),
  Nvw: () => (/* reexport */ GeneratedPictoComponents_AvatarLonghairGirl56),
  dlZ: () => (/* reexport */ GeneratedPictoComponents_AvatarMiddleAgeFemale104),
  nMy: () => (/* reexport */ GeneratedPictoComponents_AvatarMiddleAgeFemale56),
  Vdx: () => (/* reexport */ GeneratedPictoComponents_AvatarMiddleAgeMan104),
  DyI: () => (/* reexport */ GeneratedPictoComponents_AvatarMiddleAgeMan56),
  sXJ: () => (/* reexport */ GeneratedPictoComponents_AvatarMoustacheMan104),
  a9B: () => (/* reexport */ GeneratedPictoComponents_AvatarMoustacheMan56),
  nXY: () => (/* reexport */ GeneratedPictoComponents_AvatarOutbackMale104),
  V87: () => (/* reexport */ GeneratedPictoComponents_AvatarOutbackMale56),
  WMr: () => (/* reexport */ GeneratedPictoComponents_AvatarPerson104),
  gUx: () => (/* reexport */ GeneratedPictoComponents_AvatarPerson56),
  yiK: () => (/* reexport */ GeneratedPictoComponents_AvatarPersonAfro104),
  mB0: () => (/* reexport */ GeneratedPictoComponents_AvatarPersonAfro56),
  M_z: () => (/* reexport */ GeneratedPictoComponents_AvatarPersonBusiness104),
  KoE: () => (/* reexport */ GeneratedPictoComponents_AvatarPersonBusiness56),
  P5: () => (/* reexport */ GeneratedPictoComponents_AvatarSunSmartMale104),
  pgU: () => (/* reexport */ GeneratedPictoComponents_AvatarSunSmartMale56),
  La4: () => (/* reexport */ GeneratedPictoComponents_AvatarTeen104),
  HaM: () => (/* reexport */ GeneratedPictoComponents_AvatarTeen56),
  lx0: () => (/* reexport */ GeneratedPictoComponents_AvatarTeenFemale104),
  tLD: () => (/* reexport */ GeneratedPictoComponents_AvatarTeenFemale56),
  r9k: () => (/* reexport */ GeneratedPictoComponents_AvatarTeenGirl104),
  xAC: () => (/* reexport */ GeneratedPictoComponents_AvatarTeenGirl56),
  YoX: () => (/* reexport */ GeneratedPictoComponents_AvatarTelstraHardHat104),
  aMR: () => (/* reexport */ GeneratedPictoComponents_AvatarTelstraHardHat56),
  AxB: () => (/* reexport */ GeneratedPictoComponents_AvatarTurbanMale104),
  YSO: () => (/* reexport */ GeneratedPictoComponents_AvatarTurbanMale56),
  AVi: () => (/* reexport */ GeneratedPictoComponents_AvatarYoungAdultMale104),
  EIq: () => (/* reexport */ GeneratedPictoComponents_AvatarYoungAdultMale56),
  wbc: () => (/* reexport */ GeneratedPictoComponents_Baby104),
  SbQ: () => (/* reexport */ GeneratedPictoComponents_Baby56),
  gfv: () => (/* reexport */ GeneratedPictoComponents_BaldMale104),
  Aam: () => (/* reexport */ GeneratedPictoComponents_BaldMale56),
  GBo: () => (/* reexport */ GeneratedPictoComponents_Bank104),
  EJI: () => (/* reexport */ GeneratedPictoComponents_Bank56),
  aGk: () => (/* reexport */ GeneratedPictoComponents_BillEmails104),
  QAs: () => (/* reexport */ GeneratedPictoComponents_BillEmails56),
  CTE: () => (/* reexport */ GeneratedPictoComponents_BillOverview104),
  eoU: () => (/* reexport */ GeneratedPictoComponents_BillOverview56),
  F80: () => (/* reexport */ GeneratedPictoComponents_BillPaid104),
  pc: () => (/* reexport */ GeneratedPictoComponents_BillPaid56),
  Zce: () => (/* reexport */ GeneratedPictoComponents_BroadbandEnterpriseSim104),
  BCV: () => (/* reexport */ GeneratedPictoComponents_BroadbandEnterpriseSim56),
  YsL: () => (/* reexport */ GeneratedPictoComponents_BroadbandHome104),
  KSw: () => (/* reexport */ GeneratedPictoComponents_BroadbandHome56),
  zhB: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobile104),
  xik: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobile56),
  yOw: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobileSim104),
  Ysk: () => (/* reexport */ GeneratedPictoComponents_BroadbandMobileSim56),
  ElF: () => (/* reexport */ GeneratedPictoComponents_Building104),
  AAo: () => (/* reexport */ GeneratedPictoComponents_Building56),
  Fe3: () => (/* reexport */ GeneratedPictoComponents_Bundles104),
  V6E: () => (/* reexport */ GeneratedPictoComponents_Bundles56),
  s$5: () => (/* reexport */ GeneratedPictoComponents_Bus104),
  GRV: () => (/* reexport */ GeneratedPictoComponents_Bus56),
  kxm: () => (/* reexport */ GeneratedPictoComponents_BusinessIdeas104),
  c84: () => (/* reexport */ GeneratedPictoComponents_BusinessIdeas56),
  HIS: () => (/* reexport */ GeneratedPictoComponents_BusinessOperation104),
  FhU: () => (/* reexport */ GeneratedPictoComponents_BusinessOperation56),
  Hrr: () => (/* reexport */ GeneratedPictoComponents_BusinessSoftware104),
  pkN: () => (/* reexport */ GeneratedPictoComponents_BusinessSoftware56),
  D1f: () => (/* reexport */ GeneratedPictoComponents_BusinessStrategy104),
  D7j: () => (/* reexport */ GeneratedPictoComponents_BusinessStrategy56),
  sm2: () => (/* reexport */ GeneratedPictoComponents_Calendar104),
  a04: () => (/* reexport */ GeneratedPictoComponents_Calendar56),
  _x_: () => (/* reexport */ GeneratedPictoComponents_CardAdded104),
  Sy8: () => (/* reexport */ GeneratedPictoComponents_CardAdded56),
  Yer: () => (/* reexport */ GeneratedPictoComponents_Cart104),
  u_n: () => (/* reexport */ GeneratedPictoComponents_Cart56),
  Yyr: () => (/* reexport */ GeneratedPictoComponents_Cat104),
  eIj: () => (/* reexport */ GeneratedPictoComponents_Cat56),
  $$c: () => (/* reexport */ GeneratedPictoComponents_ChangePlan104),
  VUw: () => (/* reexport */ GeneratedPictoComponents_ChangePlan56),
  myR: () => (/* reexport */ GeneratedPictoComponents_Charger104),
  EEn: () => (/* reexport */ GeneratedPictoComponents_Charger56),
  cI7: () => (/* reexport */ GeneratedPictoComponents_Chat104),
  QBb: () => (/* reexport */ GeneratedPictoComponents_Chat56),
  SYq: () => (/* reexport */ GeneratedPictoComponents_Child104),
  ijV: () => (/* reexport */ GeneratedPictoComponents_Child56),
  PzM: () => (/* reexport */ GeneratedPictoComponents_ClickAndCollect104),
  $9K: () => (/* reexport */ GeneratedPictoComponents_ClickAndCollect56),
  uwy: () => (/* reexport */ GeneratedPictoComponents_Clock104),
  sQX: () => (/* reexport */ GeneratedPictoComponents_Clock56),
  xFn: () => (/* reexport */ GeneratedPictoComponents_Compare104),
  dNn: () => (/* reexport */ GeneratedPictoComponents_Compare56),
  yro: () => (/* reexport */ GeneratedPictoComponents_CoverageMap104),
  WIc: () => (/* reexport */ GeneratedPictoComponents_CoverageMap56),
  uUp: () => (/* reexport */ GeneratedPictoComponents_CoverageMobile104),
  upS: () => (/* reexport */ GeneratedPictoComponents_CoverageMobile56),
  qHv: () => (/* reexport */ GeneratedPictoComponents_CoverageNetwork104),
  kxy: () => (/* reexport */ GeneratedPictoComponents_CoverageNetwork56),
  P$D: () => (/* reexport */ GeneratedPictoComponents_Cyclone104),
  lkG: () => (/* reexport */ GeneratedPictoComponents_Cyclone56),
  c38: () => (/* reexport */ GeneratedPictoComponents_CycloneandStorms104),
  Gl9: () => (/* reexport */ GeneratedPictoComponents_CycloneandStorms56),
  OwO: () => (/* reexport */ GeneratedPictoComponents_DataPacks104),
  ASF: () => (/* reexport */ GeneratedPictoComponents_DataPacks56),
  MW9: () => (/* reexport */ GeneratedPictoComponents_DataPool104),
  wfL: () => (/* reexport */ GeneratedPictoComponents_DataPool56),
  S9t: () => (/* reexport */ GeneratedPictoComponents_Deal104),
  GmQ: () => (/* reexport */ GeneratedPictoComponents_Deal56),
  I1h: () => (/* reexport */ GeneratedPictoComponents_Delivery104),
  Klo: () => (/* reexport */ GeneratedPictoComponents_Delivery56),
  iF7: () => (/* reexport */ GeneratedPictoComponents_DeviceLocator104),
  OKz: () => (/* reexport */ GeneratedPictoComponents_DeviceLocator56),
  Nue: () => (/* reexport */ GeneratedPictoComponents_DeviceProtect104),
  pUO: () => (/* reexport */ GeneratedPictoComponents_DeviceProtect56),
  p5u: () => (/* reexport */ GeneratedPictoComponents_Devices104),
  pZ_: () => (/* reexport */ GeneratedPictoComponents_Devices56),
  WGS: () => (/* reexport */ GeneratedPictoComponents_Disruptions104),
  kY4: () => (/* reexport */ GeneratedPictoComponents_Disruptions56),
  JSp: () => (/* reexport */ GeneratedPictoComponents_DoctorFemale104),
  $hd: () => (/* reexport */ GeneratedPictoComponents_DoctorFemale56),
  HWe: () => (/* reexport */ GeneratedPictoComponents_Document104),
  BZN: () => (/* reexport */ GeneratedPictoComponents_Document56),
  i2u: () => (/* reexport */ GeneratedPictoComponents_Dog104),
  ih7: () => (/* reexport */ GeneratedPictoComponents_Dog56),
  QBH: () => (/* reexport */ GeneratedPictoComponents_Download104),
  Kfi: () => (/* reexport */ GeneratedPictoComponents_Download56),
  G2q: () => (/* reexport */ GeneratedPictoComponents_DownloadDoc104),
  KPY: () => (/* reexport */ GeneratedPictoComponents_DownloadDoc56),
  f9x: () => (/* reexport */ GeneratedPictoComponents_DriverLicence104),
  xGl: () => (/* reexport */ GeneratedPictoComponents_DriverLicence56),
  Qmz: () => (/* reexport */ GeneratedPictoComponents_ESIM104),
  Az$: () => (/* reexport */ GeneratedPictoComponents_ESIM56),
  xhX: () => (/* reexport */ GeneratedPictoComponents_EarnPoints104),
  txR: () => (/* reexport */ GeneratedPictoComponents_EarnPoints56),
  zAX: () => (/* reexport */ GeneratedPictoComponents_Earthquake104),
  Bbp: () => (/* reexport */ GeneratedPictoComponents_Earthquake56),
  I7o: () => (/* reexport */ GeneratedPictoComponents_Edit104),
  erH: () => (/* reexport */ GeneratedPictoComponents_Edit56),
  TiV: () => (/* reexport */ GeneratedPictoComponents_ElderlyFemale104),
  jqV: () => (/* reexport */ GeneratedPictoComponents_ElderlyFemale56),
  qOU: () => (/* reexport */ GeneratedPictoComponents_ElderlyMale104),
  Guf: () => (/* reexport */ GeneratedPictoComponents_ElderyMale56),
  hMn: () => (/* reexport */ GeneratedPictoComponents_Electricity104),
  XDi: () => (/* reexport */ GeneratedPictoComponents_Electricity56),
  Wl_: () => (/* reexport */ GeneratedPictoComponents_ElectricityMeter104),
  kjk: () => (/* reexport */ GeneratedPictoComponents_ElectricityMeter56),
  NNB: () => (/* reexport */ GeneratedPictoComponents_EmptyStateBox104),
  f0I: () => (/* reexport */ GeneratedPictoComponents_EmptyStateBox56),
  iBJ: () => (/* reexport */ GeneratedPictoComponents_EmptyStateTray104),
  iyr: () => (/* reexport */ GeneratedPictoComponents_EmptyStateTray56),
  _Q_: () => (/* reexport */ GeneratedPictoComponents_Energy104),
  AkG: () => (/* reexport */ GeneratedPictoComponents_Energy56),
  FUz: () => (/* reexport */ GeneratedPictoComponents_EnergySolar104),
  TxP: () => (/* reexport */ GeneratedPictoComponents_EnergySolar56),
  yhb: () => (/* reexport */ GeneratedPictoComponents_EnergyWind104),
  gNE: () => (/* reexport */ GeneratedPictoComponents_EnergyWind56),
  _TJ: () => (/* reexport */ GeneratedPictoComponents_EnterpriseCloud104),
  Qbz: () => (/* reexport */ GeneratedPictoComponents_EnterpriseCloud56),
  Q7K: () => (/* reexport */ GeneratedPictoComponents_Entertainment104),
  UgD: () => (/* reexport */ GeneratedPictoComponents_Entertainment56),
  Jr6: () => (/* reexport */ GeneratedPictoComponents_EntertainmentPackages104),
  jAx: () => (/* reexport */ GeneratedPictoComponents_EntertainmentPackages56),
  sZs: () => (/* reexport */ GeneratedPictoComponents_Error104),
  uzh: () => (/* reexport */ GeneratedPictoComponents_Error56),
  TXC: () => (/* reexport */ GeneratedPictoComponents_ErrorServer104),
  pC6: () => (/* reexport */ GeneratedPictoComponents_ErrorServer56),
  hpL: () => (/* reexport */ GeneratedPictoComponents_FailedConnection104),
  ltI: () => (/* reexport */ GeneratedPictoComponents_FailedConnection56),
  lIE: () => (/* reexport */ GeneratedPictoComponents_Feedback104),
  r3K: () => (/* reexport */ GeneratedPictoComponents_Feedback56),
  w_5: () => (/* reexport */ GeneratedPictoComponents_FieldExecution104),
  Epc: () => (/* reexport */ GeneratedPictoComponents_FieldExecution56),
  iU6: () => (/* reexport */ GeneratedPictoComponents_Fire104),
  OVP: () => (/* reexport */ GeneratedPictoComponents_Fire56),
  axl: () => (/* reexport */ GeneratedPictoComponents_FirstNationsFemale104),
  Irh: () => (/* reexport */ GeneratedPictoComponents_FirstNationsFemale56),
  JQZ: () => (/* reexport */ GeneratedPictoComponents_FirstNationsMale104),
  f9g: () => (/* reexport */ GeneratedPictoComponents_FirstNationsMale56),
  RZG: () => (/* reexport */ GeneratedPictoComponents_Floods104),
  zW: () => (/* reexport */ GeneratedPictoComponents_Floods56),
  qR6: () => (/* reexport */ GeneratedPictoComponents_Foxtel104),
  ay8: () => (/* reexport */ GeneratedPictoComponents_Foxtel56),
  Fj$: () => (/* reexport */ GeneratedPictoComponents_Gaming104),
  Vl2: () => (/* reexport */ GeneratedPictoComponents_Gaming56),
  vtR: () => (/* reexport */ GeneratedPictoComponents_Gas104),
  PJz: () => (/* reexport */ GeneratedPictoComponents_Gas56),
  Shi: () => (/* reexport */ GeneratedPictoComponents_GasMeter104),
  WEo: () => (/* reexport */ GeneratedPictoComponents_GasMeter56),
  Asf: () => (/* reexport */ GeneratedPictoComponents_GetInTouch104),
  IdC: () => (/* reexport */ GeneratedPictoComponents_GetInTouch56),
  ISd: () => (/* reexport */ GeneratedPictoComponents_Gift104),
  GCG: () => (/* reexport */ GeneratedPictoComponents_Gift56),
  $dF: () => (/* reexport */ GeneratedPictoComponents_GlobalMapMarker104),
  jZt: () => (/* reexport */ GeneratedPictoComponents_GlobalMapMarker56),
  KMy: () => (/* reexport */ GeneratedPictoComponents_GlobalNetworks104),
  Yc$: () => (/* reexport */ GeneratedPictoComponents_GlobalNetworks56),
  nC5: () => (/* reexport */ GeneratedPictoComponents_GreenEnergy104),
  R53: () => (/* reexport */ GeneratedPictoComponents_GreenEnergy56),
  v9L: () => (/* reexport */ GeneratedPictoComponents_Headphones104),
  Zor: () => (/* reexport */ GeneratedPictoComponents_Headphones56),
  vNJ: () => (/* reexport */ GeneratedPictoComponents_Help104),
  FE_: () => (/* reexport */ GeneratedPictoComponents_Help56),
  Khh: () => (/* reexport */ GeneratedPictoComponents_HijabFemale104),
  COb: () => (/* reexport */ GeneratedPictoComponents_HijabFemale56),
  ax6: () => (/* reexport */ GeneratedPictoComponents_History104),
  WmI: () => (/* reexport */ GeneratedPictoComponents_History56),
  rp8: () => (/* reexport */ GeneratedPictoComponents_Home104),
  Bw6: () => (/* reexport */ GeneratedPictoComponents_Home56),
  EVk: () => (/* reexport */ GeneratedPictoComponents_IDGeneric104),
  ehO: () => (/* reexport */ GeneratedPictoComponents_IDGeneric56),
  ilR: () => (/* reexport */ GeneratedPictoComponents_IOT104),
  yWR: () => (/* reexport */ GeneratedPictoComponents_IOT56),
  ZCJ: () => (/* reexport */ GeneratedPictoComponents_IOTUpdate104),
  VOZ: () => (/* reexport */ GeneratedPictoComponents_IOTUpdate56),
  sEK: () => (/* reexport */ GeneratedPictoComponents_IRCallingPack104),
  agt: () => (/* reexport */ GeneratedPictoComponents_IRCallingPack56),
  MFY: () => (/* reexport */ GeneratedPictoComponents_Information104),
  O19: () => (/* reexport */ GeneratedPictoComponents_Information56),
  sHe: () => (/* reexport */ GeneratedPictoComponents_Installation104),
  eh: () => (/* reexport */ GeneratedPictoComponents_Installation56),
  FbT: () => (/* reexport */ GeneratedPictoComponents_InternationalCalls104),
  HOF: () => (/* reexport */ GeneratedPictoComponents_InternationalCalls56),
  fzU: () => (/* reexport */ GeneratedPictoComponents_InternationalMobileCalls104),
  hmm: () => (/* reexport */ GeneratedPictoComponents_InternationalMobileCalls56),
  vUf: () => (/* reexport */ GeneratedPictoComponents_Internet104),
  dlB: () => (/* reexport */ GeneratedPictoComponents_Internet56),
  kLK: () => (/* reexport */ GeneratedPictoComponents_InternetCalls104),
  OjF: () => (/* reexport */ GeneratedPictoComponents_InternetCalls56),
  mZb: () => (/* reexport */ GeneratedPictoComponents_InternetExtras104),
  aAp: () => (/* reexport */ GeneratedPictoComponents_InternetExtras56),
  C78: () => (/* reexport */ GeneratedPictoComponents_InternetMobileCalls104),
  CWx: () => (/* reexport */ GeneratedPictoComponents_InternetMobileCalls56),
  TYU: () => (/* reexport */ GeneratedPictoComponents_InternetOptimiser104),
  hTj: () => (/* reexport */ GeneratedPictoComponents_InternetOptimiser56),
  Pdp: () => (/* reexport */ GeneratedPictoComponents_Landline104),
  LVH: () => (/* reexport */ GeneratedPictoComponents_Landline56),
  _Ej: () => (/* reexport */ GeneratedPictoComponents_Laptop104),
  uVd: () => (/* reexport */ GeneratedPictoComponents_Laptop56),
  ezI: () => (/* reexport */ GeneratedPictoComponents_LatencyOptimiser104),
  k9Q: () => (/* reexport */ GeneratedPictoComponents_LatencyOptimiser56),
  Fie: () => (/* reexport */ GeneratedPictoComponents_LatestInvoices104),
  RS6: () => (/* reexport */ GeneratedPictoComponents_LatestInvoices56),
  tsg: () => (/* reexport */ GeneratedPictoComponents_Legal104),
  rB1: () => (/* reexport */ GeneratedPictoComponents_Legal56),
  CFv: () => (/* reexport */ GeneratedPictoComponents_MBBRoaming104),
  iAD: () => (/* reexport */ GeneratedPictoComponents_MBBRoaming56),
  Uv0: () => (/* reexport */ GeneratedPictoComponents_MIddleAgeFemale56),
  r$C: () => (/* reexport */ GeneratedPictoComponents_Mail104),
  TBT: () => (/* reexport */ GeneratedPictoComponents_Mail56),
  qN0: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesAccess104),
  cj4: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesAccess56),
  HU9: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesEnrolled104),
  Jv6: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesEnrolled56),
  h_F: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesLock104),
  T79: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesLock56),
  mMu: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesMonitor104),
  EKF: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesMonitor56),
  lvr: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesSettings104),
  R3y: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesSettings56),
  tv3: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesShield104),
  JhC: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesShield56),
  SLB: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesUnenrolled104),
  Up: () => (/* reexport */ GeneratedPictoComponents_ManageDevicesUnenrolled56),
  Ywy: () => (/* reexport */ GeneratedPictoComponents_MapMarker104),
  UzT: () => (/* reexport */ GeneratedPictoComponents_MapMarker56),
  Syz: () => (/* reexport */ GeneratedPictoComponents_Membership104),
  kmc: () => (/* reexport */ GeneratedPictoComponents_Membership56),
  M8b: () => (/* reexport */ GeneratedPictoComponents_MiddleAgeFemale104),
  jVO: () => (/* reexport */ GeneratedPictoComponents_MiddleAgeMale104),
  H5g: () => (/* reexport */ GeneratedPictoComponents_MiddleAgeMale56),
  qdN: () => (/* reexport */ GeneratedPictoComponents_Mobile104),
  c9y: () => (/* reexport */ GeneratedPictoComponents_Mobile56),
  Zec: () => (/* reexport */ GeneratedPictoComponents_MobileAccelerator104),
  PPY: () => (/* reexport */ GeneratedPictoComponents_MobileAccelerator56),
  BCc: () => (/* reexport */ GeneratedPictoComponents_MobileSim104),
  ZgE: () => (/* reexport */ GeneratedPictoComponents_MobileSim56),
  FT5: () => (/* reexport */ GeneratedPictoComponents_MoveHouse104),
  xRY: () => (/* reexport */ GeneratedPictoComponents_MoveHouse56),
  r4: () => (/* reexport */ GeneratedPictoComponents_Movies104),
  DqT: () => (/* reexport */ GeneratedPictoComponents_Movies56),
  HWt: () => (/* reexport */ GeneratedPictoComponents_Music104),
  FnS: () => (/* reexport */ GeneratedPictoComponents_Music56),
  gNp: () => (/* reexport */ GeneratedPictoComponents_NBN104),
  edA: () => (/* reexport */ GeneratedPictoComponents_NBN56),
  eju: () => (/* reexport */ GeneratedPictoComponents_NBNHealth104),
  Avv: () => (/* reexport */ GeneratedPictoComponents_NBNHealth56),
  boV: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeed104),
  XaR: () => (/* reexport */ GeneratedPictoComponents_NetworkSpeed56),
  SNl: () => (/* reexport */ GeneratedPictoComponents_NewMobile104),
  KWE: () => (/* reexport */ GeneratedPictoComponents_NewMobile56),
  H7H: () => (/* reexport */ GeneratedPictoComponents_News104),
  LdO: () => (/* reexport */ GeneratedPictoComponents_News56),
  B3j: () => (/* reexport */ GeneratedPictoComponents_NoBills104),
  PSB: () => (/* reexport */ GeneratedPictoComponents_NoBills56),
  Lxz: () => (/* reexport */ GeneratedPictoComponents_NotificationCall104),
  TbB: () => (/* reexport */ GeneratedPictoComponents_NotificationCall56),
  ug6: () => (/* reexport */ GeneratedPictoComponents_NotificationCentre104),
  C7v: () => (/* reexport */ GeneratedPictoComponents_NotificationCentre56),
  DVq: () => (/* reexport */ GeneratedPictoComponents_NotificationEmail104),
  n1w: () => (/* reexport */ GeneratedPictoComponents_NotificationEmail56),
  wVI: () => (/* reexport */ GeneratedPictoComponents_NotificationMessage104),
  kQL: () => (/* reexport */ GeneratedPictoComponents_NotificationMessage56),
  BdC: () => (/* reexport */ GeneratedPictoComponents_NotificationReminder104),
  RDZ: () => (/* reexport */ GeneratedPictoComponents_NotificationReminder56),
  ejq: () => (/* reexport */ GeneratedPictoComponents_Notifications104),
  sHk: () => (/* reexport */ GeneratedPictoComponents_Notifications56),
  JKR: () => (/* reexport */ GeneratedPictoComponents_OneNumber104),
  ZYu: () => (/* reexport */ GeneratedPictoComponents_OneNumber56),
  kj: () => (/* reexport */ GeneratedPictoComponents_OutbackMale104),
  om6: () => (/* reexport */ GeneratedPictoComponents_OutbackMale56),
  cwp: () => (/* reexport */ GeneratedPictoComponents_PassportAustralia104),
  OQY: () => (/* reexport */ GeneratedPictoComponents_PassportAustralia56),
  OEK: () => (/* reexport */ GeneratedPictoComponents_PassportInternational104),
  YWh: () => (/* reexport */ GeneratedPictoComponents_PassportInternational56),
  ECP: () => (/* reexport */ GeneratedPictoComponents_PayPhone104),
  qE5: () => (/* reexport */ GeneratedPictoComponents_PayPhone56),
  K44: () => (/* reexport */ GeneratedPictoComponents_Payment104),
  sCk: () => (/* reexport */ GeneratedPictoComponents_Payment56),
  SB$: () => (/* reexport */ GeneratedPictoComponents_PaymentCalendar104),
  Ip5: () => (/* reexport */ GeneratedPictoComponents_PaymentCalendar56),
  p_k: () => (/* reexport */ GeneratedPictoComponents_PaymentHelp104),
  r5L: () => (/* reexport */ GeneratedPictoComponents_PaymentHelp56),
  dmk: () => (/* reexport */ GeneratedPictoComponents_PaymentPlan104),
  hS6: () => (/* reexport */ GeneratedPictoComponents_PaymentPlan56),
  LCd: () => (/* reexport */ GeneratedPictoComponents_PeaceOfMind104),
  rSY: () => (/* reexport */ GeneratedPictoComponents_PeaceOfMind56),
  PBf: () => (/* reexport */ GeneratedPictoComponents_Perfect104),
  RUz: () => (/* reexport */ GeneratedPictoComponents_Perfect56),
  GFF: () => (/* reexport */ GeneratedPictoComponents_Phone104),
  __7: () => (/* reexport */ GeneratedPictoComponents_Phone56),
  q5w: () => (/* reexport */ GeneratedPictoComponents_PhoneCase104),
  Yt1: () => (/* reexport */ GeneratedPictoComponents_PhoneCase56),
  X7E: () => (/* reexport */ GeneratedPictoComponents_PhoneSound104),
  pmP: () => (/* reexport */ GeneratedPictoComponents_PhoneSound56),
  E4c: () => (/* reexport */ GeneratedPictoComponents_Picto4G104),
  CaI: () => (/* reexport */ GeneratedPictoComponents_Picto4G56),
  Aly: () => (/* reexport */ GeneratedPictoComponents_Picto4GX104),
  ACQ: () => (/* reexport */ GeneratedPictoComponents_Picto4GX56),
  dg: () => (/* reexport */ GeneratedPictoComponents_Picto5G104),
  tCC: () => (/* reexport */ GeneratedPictoComponents_Picto5G56),
  hhS: () => (/* reexport */ GeneratedPictoComponents_Pin104),
  bkA: () => (/* reexport */ GeneratedPictoComponents_Pin56),
  nJX: () => (/* reexport */ GeneratedPictoComponents_Placeholder104),
  vTw: () => (/* reexport */ GeneratedPictoComponents_Placeholder56),
  qyB: () => (/* reexport */ GeneratedPictoComponents_PoleInspection104),
  kA1: () => (/* reexport */ GeneratedPictoComponents_PoleInspection56),
  dVf: () => (/* reexport */ GeneratedPictoComponents_PortMobile104),
  tPE: () => (/* reexport */ GeneratedPictoComponents_PortMobile56),
  f9$: () => (/* reexport */ GeneratedPictoComponents_PortPhone104),
  pSK: () => (/* reexport */ GeneratedPictoComponents_PortPhone56),
  iWy: () => (/* reexport */ GeneratedPictoComponents_PortSIM104),
  e3H: () => (/* reexport */ GeneratedPictoComponents_PortSIM56),
  Ce6: () => (/* reexport */ GeneratedPictoComponents_PostPaid104),
  i7Z: () => (/* reexport */ GeneratedPictoComponents_PostPaid56),
  pxL: () => (/* reexport */ GeneratedPictoComponents_PrePaid104),
  HEv: () => (/* reexport */ GeneratedPictoComponents_PrePaid56),
  aK$: () => (/* reexport */ GeneratedPictoComponents_Preferences104),
  cs1: () => (/* reexport */ GeneratedPictoComponents_Preferences56),
  Wux: () => (/* reexport */ GeneratedPictoComponents_PriorityAssistance104),
  ObM: () => (/* reexport */ GeneratedPictoComponents_PriorityAssistance56),
  xMj: () => (/* reexport */ GeneratedPictoComponents_Profile104),
  hKF: () => (/* reexport */ GeneratedPictoComponents_Profile56),
  rCZ: () => (/* reexport */ GeneratedPictoComponents_ProfileCompletion104),
  rU9: () => (/* reexport */ GeneratedPictoComponents_ProfileCompletion56),
  QKK: () => (/* reexport */ GeneratedPictoComponents_PromoCombined104),
  MFI: () => (/* reexport */ GeneratedPictoComponents_PromoCombined56),
  dxk: () => (/* reexport */ GeneratedPictoComponents_PromoData104),
  Ds7: () => (/* reexport */ GeneratedPictoComponents_PromoData56),
  GDQ: () => (/* reexport */ GeneratedPictoComponents_PromoDiscount104),
  QtP: () => (/* reexport */ GeneratedPictoComponents_PromoDiscount56),
  NZ9: () => (/* reexport */ GeneratedPictoComponents_RaisedSurface104),
  tJd: () => (/* reexport */ GeneratedPictoComponents_RaisedSurface56),
  mhJ: () => (/* reexport */ GeneratedPictoComponents_Receipt104),
  ysT: () => (/* reexport */ GeneratedPictoComponents_Receipt56),
  jxB: () => (/* reexport */ GeneratedPictoComponents_RecurringPayment104),
  pSi: () => (/* reexport */ GeneratedPictoComponents_RecurringPayment56),
  nb7: () => (/* reexport */ GeneratedPictoComponents_RedeemPoints104),
  p8Q: () => (/* reexport */ GeneratedPictoComponents_RedeemPoints56),
  uhr: () => (/* reexport */ GeneratedPictoComponents_Rewards104),
  MrV: () => (/* reexport */ GeneratedPictoComponents_Rewards56),
  P2L: () => (/* reexport */ GeneratedPictoComponents_Roaming104),
  Vp3: () => (/* reexport */ GeneratedPictoComponents_Roaming56),
  kNs: () => (/* reexport */ GeneratedPictoComponents_RoamingOn104),
  uHK: () => (/* reexport */ GeneratedPictoComponents_RoamingOn56),
  riU: () => (/* reexport */ GeneratedPictoComponents_SIM104),
  PUQ: () => (/* reexport */ GeneratedPictoComponents_SIM56),
  nlH: () => (/* reexport */ GeneratedPictoComponents_SMS104),
  Trx: () => (/* reexport */ GeneratedPictoComponents_SMS56),
  FWK: () => (/* reexport */ GeneratedPictoComponents_Satellite104),
  VoM: () => (/* reexport */ GeneratedPictoComponents_Satellite56),
  iMn: () => (/* reexport */ GeneratedPictoComponents_Search104),
  YOP: () => (/* reexport */ GeneratedPictoComponents_Search56),
  MKc: () => (/* reexport */ GeneratedPictoComponents_Security104),
  AR2: () => (/* reexport */ GeneratedPictoComponents_Security56),
  TWq: () => (/* reexport */ GeneratedPictoComponents_SecurityHome104),
  za5: () => (/* reexport */ GeneratedPictoComponents_SecurityHome56),
  blr: () => (/* reexport */ GeneratedPictoComponents_SecurityInternet104),
  dMq: () => (/* reexport */ GeneratedPictoComponents_SecurityInternet56),
  u_c: () => (/* reexport */ GeneratedPictoComponents_SecurityMobile104),
  _Vo: () => (/* reexport */ GeneratedPictoComponents_SecurityMobile56),
  J5G: () => (/* reexport */ GeneratedPictoComponents_SendOldPhone104),
  V5c: () => (/* reexport */ GeneratedPictoComponents_SendOldPhone56),
  GyB: () => (/* reexport */ GeneratedPictoComponents_Services104),
  QIL: () => (/* reexport */ GeneratedPictoComponents_Services56),
  T49: () => (/* reexport */ GeneratedPictoComponents_Settings104),
  NJv: () => (/* reexport */ GeneratedPictoComponents_Settings56),
  ZhN: () => (/* reexport */ GeneratedPictoComponents_Share104),
  DQA: () => (/* reexport */ GeneratedPictoComponents_Share56),
  mCS: () => (/* reexport */ GeneratedPictoComponents_SharedWiFi104),
  YS1: () => (/* reexport */ GeneratedPictoComponents_SharedWiFi56),
  iMj: () => (/* reexport */ GeneratedPictoComponents_Shop104),
  W7L: () => (/* reexport */ GeneratedPictoComponents_Shop56),
  YcG: () => (/* reexport */ GeneratedPictoComponents_Signin104),
  YxN: () => (/* reexport */ GeneratedPictoComponents_Signin56),
  WKQ: () => (/* reexport */ GeneratedPictoComponents_SmartHome104),
  CdG: () => (/* reexport */ GeneratedPictoComponents_SmartHome56),
  yCn: () => (/* reexport */ GeneratedPictoComponents_SmartWiFiBooster104),
  GzR: () => (/* reexport */ GeneratedPictoComponents_SmartWiFiBooster56),
  nF8: () => (/* reexport */ GeneratedPictoComponents_SomethingWentWrong104),
  Lj6: () => (/* reexport */ GeneratedPictoComponents_SomethingWentWrong56),
  nWK: () => (/* reexport */ GeneratedPictoComponents_SpeedOptimiser104),
  XSh: () => (/* reexport */ GeneratedPictoComponents_SpeedOptimiser56),
  coY: () => (/* reexport */ GeneratedPictoComponents_Sporting104),
  SC9: () => (/* reexport */ GeneratedPictoComponents_Sporting56),
  Zc: () => (/* reexport */ GeneratedPictoComponents_StarlinkSatellite104),
  VEW: () => (/* reexport */ GeneratedPictoComponents_StarlinkSatellite56),
  jlN: () => (/* reexport */ GeneratedPictoComponents_Store104),
  jXv: () => (/* reexport */ GeneratedPictoComponents_Store56),
  zhQ: () => (/* reexport */ GeneratedPictoComponents_StoreAddress104),
  xiF: () => (/* reexport */ GeneratedPictoComponents_StoreAddress56),
  Jlz: () => (/* reexport */ GeneratedPictoComponents_StoreClock104),
  NFH: () => (/* reexport */ GeneratedPictoComponents_StoreClock56),
  kd7: () => (/* reexport */ GeneratedPictoComponents_StoreSuccess104),
  cG7: () => (/* reexport */ GeneratedPictoComponents_StoreSuccess56),
  hQc: () => (/* reexport */ GeneratedPictoComponents_Storm104),
  tgD: () => (/* reexport */ GeneratedPictoComponents_Storm56),
  $OG: () => (/* reexport */ GeneratedPictoComponents_Success104),
  n_b: () => (/* reexport */ GeneratedPictoComponents_Success56),
  yvl: () => (/* reexport */ GeneratedPictoComponents_SunSmartMale104),
  a2o: () => (/* reexport */ GeneratedPictoComponents_SunSmartMale56),
  byX: () => (/* reexport */ GeneratedPictoComponents_SupportPhone104),
  hjK: () => (/* reexport */ GeneratedPictoComponents_SupportPhone56),
  akr: () => (/* reexport */ GeneratedPictoComponents_Swipe104),
  cO9: () => (/* reexport */ GeneratedPictoComponents_Swipe56),
  NAZ: () => (/* reexport */ GeneratedPictoComponents_SwitchOff104),
  zTi: () => (/* reexport */ GeneratedPictoComponents_SwitchOff56),
  Ds0: () => (/* reexport */ GeneratedPictoComponents_SwitchOn104),
  R$E: () => (/* reexport */ GeneratedPictoComponents_SwitchOn56),
  EsA: () => (/* reexport */ GeneratedPictoComponents_TV104),
  Cct: () => (/* reexport */ GeneratedPictoComponents_TV56),
  G_W: () => (/* reexport */ GeneratedPictoComponents_Tablet104),
  Qyr: () => (/* reexport */ GeneratedPictoComponents_Tablet56),
  H2V: () => (/* reexport */ GeneratedPictoComponents_TabletSim104),
  FJB: () => (/* reexport */ GeneratedPictoComponents_TabletSim56),
  II8: () => (/* reexport */ GeneratedPictoComponents_Technician104),
  wjg: () => (/* reexport */ GeneratedPictoComponents_Technician56),
  Qx8: () => (/* reexport */ GeneratedPictoComponents_Teen104),
  _rh: () => (/* reexport */ GeneratedPictoComponents_Teen56),
  yau: () => (/* reexport */ GeneratedPictoComponents_TeenFemale104),
  csD: () => (/* reexport */ GeneratedPictoComponents_TeenFemale56),
  P8Q: () => (/* reexport */ GeneratedPictoComponents_Telstra104),
  N5X: () => (/* reexport */ GeneratedPictoComponents_Telstra56),
  Tef: () => (/* reexport */ GeneratedPictoComponents_TelstraAir104),
  D2: () => (/* reexport */ GeneratedPictoComponents_TelstraAir56),
  paw: () => (/* reexport */ GeneratedPictoComponents_TelstraConnect104),
  Jy_: () => (/* reexport */ GeneratedPictoComponents_TelstraConnect56),
  R4e: () => (/* reexport */ GeneratedPictoComponents_TelstraLocator104),
  rvT: () => (/* reexport */ GeneratedPictoComponents_TelstraLocator56),
  F77: () => (/* reexport */ GeneratedPictoComponents_TelstraPlus104),
  lJW: () => (/* reexport */ GeneratedPictoComponents_TelstraPlus56),
  d2l: () => (/* reexport */ GeneratedPictoComponents_TelstraTV104),
  Hh1: () => (/* reexport */ GeneratedPictoComponents_TelstraTV56),
  MNu: () => (/* reexport */ GeneratedPictoComponents_Ticket104),
  cgG: () => (/* reexport */ GeneratedPictoComponents_Ticket56),
  PuU: () => (/* reexport */ GeneratedPictoComponents_TrackOrder104),
  jol: () => (/* reexport */ GeneratedPictoComponents_TrackOrder56),
  zHC: () => (/* reexport */ GeneratedPictoComponents_TradeIn104),
  f1k: () => (/* reexport */ GeneratedPictoComponents_TradeIn56),
  mGY: () => (/* reexport */ GeneratedPictoComponents_Train104),
  uLQ: () => (/* reexport */ GeneratedPictoComponents_Train56),
  WDh: () => (/* reexport */ GeneratedPictoComponents_TransferRequest104),
  GQJ: () => (/* reexport */ GeneratedPictoComponents_TransferRequest56),
  QPi: () => (/* reexport */ GeneratedPictoComponents_Translate104),
  qj3: () => (/* reexport */ GeneratedPictoComponents_Translate56),
  oUq: () => (/* reexport */ GeneratedPictoComponents_Troubleshoot104),
  Gyd: () => (/* reexport */ GeneratedPictoComponents_Troubleshoot56),
  vo0: () => (/* reexport */ GeneratedPictoComponents_TruckFire104),
  nm5: () => (/* reexport */ GeneratedPictoComponents_TruckFire56),
  P8i: () => (/* reexport */ GeneratedPictoComponents_TurbanMale104),
  rkx: () => (/* reexport */ GeneratedPictoComponents_TurbanMale56),
  gVL: () => (/* reexport */ GeneratedPictoComponents_UnderseaCable104),
  yTN: () => (/* reexport */ GeneratedPictoComponents_UnderseaCable56),
  QP2: () => (/* reexport */ GeneratedPictoComponents_UnderseaCableNetwork104),
  e7c: () => (/* reexport */ GeneratedPictoComponents_UnderseaCableNetwork56),
  Dj4: () => (/* reexport */ GeneratedPictoComponents_UnifiedComms104),
  z9t: () => (/* reexport */ GeneratedPictoComponents_UnifiedComms56),
  x9o: () => (/* reexport */ GeneratedPictoComponents_Unlimited104),
  hps: () => (/* reexport */ GeneratedPictoComponents_Unlimited56),
  Kfj: () => (/* reexport */ GeneratedPictoComponents_Upgrade104),
  usf: () => (/* reexport */ GeneratedPictoComponents_Upgrade56),
  j9N: () => (/* reexport */ GeneratedPictoComponents_UploadDoc104),
  ZCb: () => (/* reexport */ GeneratedPictoComponents_UploadDoc56),
  fa_: () => (/* reexport */ GeneratedPictoComponents_VIP104),
  rOZ: () => (/* reexport */ GeneratedPictoComponents_VIP56),
  nc0: () => (/* reexport */ GeneratedPictoComponents_Video104),
  Bpe: () => (/* reexport */ GeneratedPictoComponents_Video56),
  KzG: () => (/* reexport */ GeneratedPictoComponents_Warning104),
  gtZ: () => (/* reexport */ GeneratedPictoComponents_Warning56),
  fKR: () => (/* reexport */ GeneratedPictoComponents_Watch104),
  $oy: () => (/* reexport */ GeneratedPictoComponents_Watch56),
  ZN$: () => (/* reexport */ GeneratedPictoComponents_WeCare104),
  l1A: () => (/* reexport */ GeneratedPictoComponents_WeCare56),
  b_r: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelAboutApp104),
  Hif: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelAboutApp56),
  mjM: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelAccountsPayments104),
  wFT: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelAccountsPayments56),
  ZEQ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBank104),
  Zmq: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBank56),
  VAJ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBillOverview104),
  nJ9: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBillOverview56),
  QA6: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBillPaid104),
  G2E: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBillPaid56),
  E1T: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBroadbandMobile104),
  s4u: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelBroadbandMobile56),
  NDH: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelCardAdded104),
  xp4: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelCardAdded56),
  uH4: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelChangePlan104),
  Gmf: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelChangePlan56),
  vxK: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelChat104),
  vTY: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelChat56),
  bPk: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDataPacks104),
  xgE: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDataPacks56),
  PH7: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDataPool104),
  Z4L: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDataPool56),
  hdJ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDelivery104),
  Fr$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDelivery56),
  L6n: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDownload104),
  nOp: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelDownload56),
  Fy$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelESIM104),
  But: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelESIM56),
  ibb: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelEmptyStateBox104),
  _0: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelEmptyStateBox56),
  t6w: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelError104),
  DXp: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelError56),
  OOd: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelFailedConnection104),
  G1g: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelFailedConnection56),
  eZm: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelFeedback104),
  q_Z: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelFeedback56),
  l2: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelGift104),
  DHs: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelGift56),
  W3I: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelHelp104),
  qe$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelHelp56),
  N80: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInformation104),
  DX6: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInformation56),
  PaP: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInstallation104),
  DKi: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInstallation56),
  sNB: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternationalCalls104),
  CzF: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternationalCalls56),
  LPl: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternationalMobileCall104),
  dYY: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternationalMobileCall56),
  Kmb: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternet104),
  A89: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelInternet56),
  i15: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMail104),
  QpZ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMail56),
  xAl: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMobile104),
  DpP: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMobile56),
  gwI: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMobileAndTablet104),
  oNg: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelMobileAndTablet56),
  i89: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelNetworkSpeed104),
  CNK: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelNetworkSpeed56),
  Fms: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPayment104),
  tS6: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPayment56),
  dDm: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPaymentCalendar104),
  lBq: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPaymentCalendar56),
  WGp: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPaymentHelp104),
  Y2d: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPaymentHelp56),
  w0r: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPin104),
  u8S: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPin56),
  sNH: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPlaceholder104),
  ONp: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPlaceholder56),
  Xe3: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPostPaid104),
  Pcs: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPostPaid56),
  kmf: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPrePaid104),
  wpk: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPrePaid56),
  EnQ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelProfile104),
  owW: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelProfile56),
  hTM: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoCombined104),
  p7M: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoCombined56),
  CRn: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoData104),
  G60: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoData56),
  n2z: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoDiscount104),
  jgx: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelPromoDiscount56),
  HMf: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelReceipt104),
  jK4: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelReceipt56),
  EM$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelRecurringPayment104),
  eYW: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelRecurringPayment56),
  Q_$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelRoaming104),
  KmN: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelRoaming56),
  ma1: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSMS104),
  YOr: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSMS56),
  zzv: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSecurity104),
  FwZ: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSecurity56),
  T2u: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelServices104),
  lJr: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelServices56),
  m8_: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSettings104),
  wwD: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSettings56),
  J4O: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSignIn104),
  rrn: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSignIn56),
  EIm: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSomethingWentWrong104),
  k9C: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSomethingWentWrong56),
  gQz: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSuccess104),
  iSF: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSuccess56),
  ycN: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSupportPhone104),
  iZ9: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelSupportPhone56),
  J2I: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelTechnician104),
  n1$: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelTechnician56),
  svY: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelTrackOrder104),
  MGw: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelTrackOrder56),
  jc1: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWarning104),
  FRY: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWarning56),
  OC8: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWeCare104),
  W5O: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWeCare56),
  KSp: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWiFi104),
  IqK: () => (/* reexport */ GeneratedPictoComponents_WhiteLabelWiFi56),
  ny$: () => (/* reexport */ GeneratedPictoComponents_WiFi104),
  VhO: () => (/* reexport */ GeneratedPictoComponents_WiFi56),
  ZBc: () => (/* reexport */ GeneratedPictoComponents_WiFiBooster104),
  L6U: () => (/* reexport */ GeneratedPictoComponents_WiFiBooster56),
  E30: () => (/* reexport */ GeneratedPictoComponents_Window104),
  mJS: () => (/* reexport */ GeneratedPictoComponents_Window56),
  V7K: () => (/* reexport */ GeneratedPictoComponents_YoungAdultMale104),
  fuE: () => (/* reexport */ GeneratedPictoComponents_YoungAdultMale56)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/Picto/GeneratedPictoComponents/AvatarAdultFemale104.tsx


var _excluded = ["className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAdultFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, _excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.19 49.68c-2.39-.24-4.83-2.21-6.08-5.19-1.64-3.92-.59-8.09 2.35-9.32.65-.27 1.34-.38 2.03-.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.96 34.74c.79-.1 1.57 0 2.3.29 2.94 1.21 4.02 5.37 2.41 9.3-1.25 3.05-3.76 5.06-6.2 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.21 30.62c.5 2.44.77 5.01.78 7.67.05 15.92-9.37 28.86-21.04 28.9-11.67.04-21.18-12.84-21.23-28.76 0-2.64.24-5.2.72-7.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.9 30.61A24.973 24.973 0 0 0 64.34 9.02a24.948 24.948 0 0 0-24.97.08 24.99 24.99 0 0 0-12.42 21.67l24.97-.09V19.16l5.8 11.51 19.18-.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.44 30.8 20.49-17.05 20.28 16.87-40.77.18z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.17 87.75c-.56-.56-1.15-1.09-1.76-1.59-4.28-3.32-9.63-6.23-14.27-9.01v.06V77l1.12.82c-5.93-3.04-4.68-6.08-4.71-13.81H42.34c0 7.78 1.06 10.77-4.65 13.81l1.01-.6c-4.54 2.76-10.09 5.65-14.29 8.95-.6.49-1.18 1.02-1.73 1.58 0 0 11.08 11.5 29.17 11.5s29.31-11.49 29.31-11.49Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M63.86 79.46s1.87.18.3 2.57c-2.7 4.1-16.16 8.49-25.08 3.47-9.99-5.63-.5-8.06-.5-8.06s5.18 4.64 11.29 4.89c7.94.32 6.08-.11 13.99-2.87Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.86 63.68c-3.03-1.8-5.39-4.55-6.7-7.83-.81-2.01-2.79-4.77-2.39-2.6.41 3.68.41 7.39 0 11.06l.23 4.81c-.35 1.01-.35 1.91 1.03 1.89l6.49-.12c.64-.06 1.21-.46 1.46-1.06.26-.59.17-1.28-.23-1.79.49-.18.88-.56 1.06-1.05s.13-1.04-.13-1.49c.19-.73-.15-1.49-.83-1.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.48 6.62c-11.56.39-19.44 11.4-21.56 21.92-.37 1.93.62 2.46 1.93 2.21.81.06 1.62.06 2.42 0 6.27 0 11.22.46 17.09 0 .32.19 1.17 0 1.61.16 1.04.42 2.14-.65 2.14-1.64 0-3.44-.11-6.88-.32-10.3.14.19.27.42.41.65.58 1.04 1.1 2.14 1.66 3.2.8 1.89 1.83 3.67 3.08 5.3.16.18 0 1.1 0 1.13 0 1.47 2.33 2.12 3.39 1.43 2.15.44 4.36.44 6.5 0 .74-.19 1.25-.86 1.24-1.63-.44-10.53-7.94-22.8-19.58-22.43Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.41 35.93a5.853 5.853 0 0 1 7.69 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.76 35.89a5.83 5.83 0 0 1 7.69 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.76 50.54.06 20.56 9.21-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.76 77.82c5.71-3.04 4.65-6.03 4.65-13.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.62 64.01c.03 7.73-1.22 10.77 4.71 13.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.26 49.68c-2.39-.24-4.83-2.21-6.08-5.19-1.64-3.92-.59-8.09 2.35-9.32.65-.27 1.34-.38 2.03-.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.03 34.74c.79-.1 1.57 0 2.3.29 2.94 1.21 4.02 5.37 2.41 9.3-1.25 3.05-3.76 5.06-6.2 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.28 30.62c.5 2.44.77 5.01.78 7.67.05 15.92-9.37 28.86-21.04 28.9-11.67.04-21.18-12.84-21.23-28.76 0-2.64.24-5.2.72-7.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 40.29c0 4.33 2.85 4.52 2.85 7.07s-2.86 2.6-2.86 2.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.07 57.01c1.91.95 4.22.6 5.76-.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.97 30.61A24.973 24.973 0 0 0 64.41 9.02a24.948 24.948 0 0 0-24.97.08 24.99 24.99 0 0 0-12.42 21.67l24.97-.09V19.16l5.8 11.51 19.18-.05Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.21 77.15c4.63 2.78 9.99 5.69 14.27 9.01.62.5 1.2 1.03 1.76 1.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.76 87.74c.55-.56 1.12-1.09 1.73-1.58 4.2-3.3 9.74-6.19 14.29-8.95 0 0 4.76 5.14 13.3 5.14 5.51-.02 8.84-1.73 13.13-5.14"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.12",
        cy: "40.28",
        r: "1.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.56",
        cy: "40.22",
        r: "1.96"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAdultFemale104 = (AvatarAdultFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarAdultFemale56.tsx


var AvatarAdultFemale56_excluded = ["className"];
function AvatarAdultFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAdultFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAdultFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAdultFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAdultFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAdultFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAdultFemale56_objectSpread(AvatarAdultFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.71 35.04c-1.68-.17-3.39-1.55-4.26-3.64-1.15-2.75-.41-5.67 1.65-6.53.46-.19.94-.26 1.42-.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.31 24.56c.55-.07 1.1 0 1.62.21 2.06.85 2.82 3.77 1.69 6.52-.88 2.14-2.64 3.55-4.35 3.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.78 21.67c.35 1.71.54 3.52.55 5.38.04 11.17-6.57 20.24-14.76 20.27-8.19.03-14.86-9-14.89-20.17 0-1.85.17-3.65.51-5.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.07 21.66A17.518 17.518 0 0 0 19.74 6.58a17.522 17.522 0 0 0-8.71 15.2l17.52-.06v-8.08l4.07 8.07 13.45-.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.5 11.56h13.46v13.46H22.5z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.46 44.86a11.211 11.211 0 0 1-4.7-5.49c-.57-1.41-1.96-3.35-1.67-1.82.29 2.58.29 5.18 0 7.76l.16 3.37c-.25.71-.25 1.34.72 1.33l4.55-.09c.45-.04.85-.32 1.03-.74.18-.42.12-.9-.16-1.26.35-.12.27-.57.39-.92s.1-.62-.09-.94c.14-.51.24-.97-.23-1.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.11 4.84c-8.11.27-13.64 8-15.12 15.37-.26 1.35.43 1.72 1.35 1.55.57.04 1.13.04 1.7 0 4.4 0 7.87.32 11.99 0 .22.14.82 0 1.13.11.73.3 1.5-.46 1.5-1.15 0-2.41-.07-4.82-.22-7.23.1.14.19.3.29.46.41.73.77 1.5 1.17 2.24.56 1.32 1.29 2.57 2.16 3.72.11.12 0 .77 0 .79 0 1.03 1.64 1.49 2.38 1 1.5.31 3.06.31 4.56 0 .52-.14.87-.61.87-1.14-.31-7.39-5.57-15.99-13.74-15.73Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.45 25.39a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.22 25.37a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.08 35.59.05 14.47 6.46-.02v-5.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.73 35.04c-1.68-.17-3.39-1.55-4.26-3.64-1.15-2.75-.41-5.67 1.65-6.53.46-.19.94-.26 1.42-.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.33 24.56c.55-.07 1.1 0 1.62.21 2.06.85 2.82 3.77 1.69 6.52-.88 2.14-2.64 3.55-4.35 3.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.8 21.67c.35 1.71.54 3.52.55 5.38.04 11.17-6.57 20.24-14.76 20.27-8.19.03-14.86-9-14.89-20.17 0-1.85.17-3.65.51-5.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.58 28.46c0 3.04 2 3.17 2 4.96s-2.01 1.82-2.01 1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.23 40.18c1.34.67 2.96.42 4.04-.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.09 21.66A17.518 17.518 0 0 0 19.76 6.58a17.522 17.522 0 0 0-8.71 15.2l17.52-.06v-8.08l4.07 8.07 13.45-.04Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.05",
        cy: "28.44",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.88",
        cy: "28.41",
        r: "1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAdultFemale56 = (AvatarAdultFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarAdultMale104.tsx


var AvatarAdultMale104_excluded = ["className"];
function AvatarAdultMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAdultMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAdultMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAdultMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAdultMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAdultMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAdultMale104_objectSpread(AvatarAdultMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.2 52.71c-2.23-.21-4.51-2.06-5.66-4.84-1.51-3.64-.52-7.52 2.22-8.65.63-.26 1.3-.35 1.98-.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.62 38.91c.55 0 1.09.1 1.61.31 2.73 1.13 3.72 5 2.22 8.65-1.16 2.79-3.45 4.64-5.69 4.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.6",
        cy: "42.25",
        rx: "19.72",
        ry: "26.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.37 38.67s1.72.14 1.72-5.89c.08-3.47-1.01-6.87-3.09-9.65 6.04-9.73-5.72-16.6-5.72-16.6-3.26 2.83-8.84 2.76-12.57 2.76-15.24 0-21.46 12.02-21.46 23.48 0 6.03 1.72 5.89 1.72 5.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.03 87.91c-3.51-4.27-12.61-8.86-12.61-8.86l.9.47c-6.14-3.11-9.77-6.26-10.45-13.49l-18.06.27c-.76 7.04-4.32 9.43-10.18 12.9l.25-.16s-9.76 6.11-11.13 8.86c0 0 12.35 11.33 29.82 11.33S83.04 87.9 83.04 87.9Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.11 35.06c.18-3.94-.73-7.85-2.63-11.31-.03-.33-.03-.65 0-.98.95-2.25 1.32-4.7 1.06-7.12-.18-.82-.52-1.6-1-2.3 0 0-.72-1.63-.76-1.44l-.31-.34c-4.43 2.85-12.17.69-17.05 0-4.57-.6-9.29-1.03-13.3 1.51-6.87 4.31-8.24 12.36-8.91 19.93v1.08c0 .05.57 3.04.57 3.18 1.1 2.68 1.72-.5 1.84-2.51v-.09s4.45-18.66 18.97-19.02c14.52-.36 17.89 17.17 17.89 17.17.1.64 1.08 3.14 1.1 3.52.27 3.61 2.39 2.01 2.52 0 .02-.48.02-.88 0-1.27Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.62 79.41c5.86-3.47 9.43-5.86 10.18-12.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.87 66.23c.69 7.23 4.32 10.38 10.45 13.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.2 52.9c-2.23-.21-4.51-2.06-5.66-4.84-1.51-3.64-.52-7.52 2.22-8.65.63-.26 1.3-.35 1.98-.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.62 39.1c.55 0 1.09.1 1.61.31 2.73 1.13 3.72 5 2.22 8.65-1.16 2.79-3.45 4.64-5.69 4.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.6",
        cy: "42.44",
        rx: "19.72",
        ry: "26.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.55 44.23c0 4.02 2.63 4.21 2.63 6.52s-2.68 2.4-2.68 2.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.78 40.14a5.418 5.418 0 0 1 7.14 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.07 40.14a5.418 5.418 0 0 1 7.14 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.71 59.76c1.78.88 3.92.56 5.36-.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.37 38.87s1.72.14 1.72-5.89c.08-3.47-1.01-6.87-3.09-9.65 6.04-9.73-5.72-16.6-5.72-16.6-3.26 2.83-8.84 2.76-12.57 2.76-15.24 0-21.46 12.02-21.46 23.48 0 6.03 1.72 5.89 1.72 5.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.22",
        cy: "44.19",
        r: "1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.57",
        cy: "44.19",
        r: "1.82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M67.78 81.88s2.49.18.4 2.5c-3.6 3.98-19.51 10.3-33.41 3.37-12.87-6.42-1.89-8.5-1.89-8.5s8.91 6.83 17.06 6.89c11.88.09 7.69-.45 17.84-4.26Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.03 88.11c-3.51-4.27-12.61-8.86-12.61-8.86-4.53 4.08-10.83 6.95-18.37 7.03-6.1-.09-14.66-2.94-19.18-7.03 0 0-9.76 6.11-11.13 8.86"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAdultMale104 = (AvatarAdultMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarAdultMale56.tsx


var AvatarAdultMale56_excluded = ["className"];
function AvatarAdultMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAdultMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAdultMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAdultMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAdultMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAdultMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAdultMale56_objectSpread(AvatarAdultMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.77 40c-1.68-.16-3.4-1.55-4.28-3.66-1.14-2.75-.39-5.68 1.67-6.53.48-.2.99-.27 1.5-.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.79 29.58c.42 0 .83.07 1.22.24 2.06.86 2.81 3.78 1.67 6.53-.87 2.11-2.61 3.51-4.3 3.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.67",
        cy: "32.1",
        rx: "14.9",
        ry: "20.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.6 29.4s1.3.1 1.3-4.45c.06-2.62-.76-5.19-2.33-7.29 4.56-7.35-4.32-12.54-4.32-12.54-2.46 2.14-6.68 2.09-9.49 2.09-11.52 0-16.21 9.08-16.21 17.74 0 4.55 1.3 4.45 1.3 4.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.03 26.34c.13-2.98-.55-5.93-1.98-8.55-.03-.25-.03-.49 0-.74.72-1.7 1-3.55.8-5.38a5.08 5.08 0 0 0-.75-1.74s-.54-1.23-.57-1.09l-.23-.26c-3.35 2.15-9.19.52-12.88 0-3.45-.45-7.02-.78-10.05 1.14-5.19 3.26-6.22 9.34-6.73 15.06v.82s.43 2.3.43 2.4c.83 2.02 1.3-.38 1.39-1.89v-.06s3.36-14.1 14.33-14.37c10.97-.27 13.51 12.97 13.51 12.97.08.48.82 2.37.83 2.66.21 2.72 1.8 1.52 1.91 0 .01-.36.01-.66 0-.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.88 39.82c-1.68-.16-3.4-1.55-4.28-3.66-1.14-2.75-.39-5.68 1.67-6.53.48-.2.99-.27 1.5-.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.9 29.39c.42 0 .83.07 1.22.24 2.06.86 2.81 3.78 1.67 6.53-.87 2.11-2.61 3.51-4.3 3.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.78",
        cy: "31.91",
        rx: "14.9",
        ry: "20.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.74 33.26c0 3.03 1.98 3.18 1.98 4.93s-2.02 1.82-2.02 1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.61 30.18a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.4 30.18a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.35 45c1.34.67 2.96.42 4.05-.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.72 29.22s1.3.1 1.3-4.45c.06-2.62-.76-5.19-2.33-7.29 4.56-7.35-4.32-12.54-4.32-12.54-2.46 2.14-6.68 2.09-9.49 2.09-11.52 0-16.21 9.08-16.21 17.74 0 4.55 1.3 4.45 1.3 4.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.2",
        cy: "33.24",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.04",
        cy: "33.24",
        r: "1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAdultMale56 = (AvatarAdultMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarAndrogynousPersonOne104.tsx


var AvatarAndrogynousPersonOne104_excluded = ["className"];
function AvatarAndrogynousPersonOne104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAndrogynousPersonOne104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAndrogynousPersonOne104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAndrogynousPersonOne104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAndrogynousPersonOne104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAndrogynousPersonOne104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAndrogynousPersonOne104_objectSpread(AvatarAndrogynousPersonOne104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.37 32.51c-.95-.24-1.9-.2-2.78.17-2.88 1.19-3.86 5.42-2.2 9.44 1.46 3.52 4.46 5.71 7.11 5.41M72.5 47.54c2.66.37 5.71-1.85 7.19-5.42 1.67-4.02.71-8.24-2.13-9.42-.99-.41-2.07-.4-3.13-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.26 35.91c0 16.33-9.71 29.57-21.68 29.57S30.9 52.24 30.9 35.91l.43-5.96c2.1-13.57 10.8-23.76 21.23-23.76s19.12 10.18 21.22 23.76l.49 5.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.97 86.89c-.58-.6-1.2-1.17-1.87-1.7-3.86-3.09-8.06-5.51-11.83-7.89-6.07-3.82-7.8-4.91-7.8-14.68H42.76c0 9.77-1.9 10.86-7.97 14.68-3.77 2.37-7.96 4.79-11.83 7.89-.64.51-1.24 1.06-1.8 1.63 0 0 12.34 12.42 31.43 12.42s31.38-12.35 31.38-12.35Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.67 21.89c-1.83-7.87-7.61-15.15-16.71-16.26-10.5-1.28-17.26 7.26-21.41 15.02-1.29 2.41-1.52 6.28 2.31 6.65 1.7.16 3.02-.72 4.23-1.69 2.19-1.74 4.16-3.45 6.89-4.42 5.85-2.08 11.75.13 16.71 3.09 2.99 1.78 6.79 3.29 9.18-.18 0 0-.17-2.05-1.2-2.21ZM60.01 80.51s1.67.39-.05 2.72c-2.94 3.99-16.56 6.74-23.05.95-4.4-3.92.54-8.47.54-8.47s4.1 5.4 9.59 6.31c7.13 1.18 5.5.53 12.97-1.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56.34",
        cy: "9.69",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "54.59",
        cy: "11.32",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.72",
        cy: "8.48",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.1",
        cy: "9.69",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "47.61",
        cy: "8.88",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "48.48",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "45.86",
        cy: "11.32",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "43.06",
        cy: "11.56",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "44.12",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.62",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "41.5",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "44.99",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "46.74",
        cy: "14.57",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.23",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "57.21",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "59.83",
        cy: "10.51",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "59.83",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "55.46",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.72",
        cy: "15.38",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "54.59",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.07",
        cy: "19.22",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56.34",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.96",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.96",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "61.57",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "63.32",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "65.07",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "63.27",
        cy: "21.06",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "66.2",
        cy: "21.88",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "68.56",
        cy: "23.5",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "67.69",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "65.94",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "64.19",
        cy: "14.57",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "62.45",
        cy: "12.94",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.84",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "47.92",
        cy: "16.72",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "45.86",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "43.24",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.75",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.62",
        cy: "21.06",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.31",
        cy: "23.26",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.26",
        cy: "24.07",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.13",
        cy: "20.25",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.88",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.97",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.19 86.62c.56-.57 1.16-1.12 1.8-1.63 3.86-3.09 8.06-5.51 11.83-7.89 6.07-3.82 7.97-4.91 7.97-14.68M84 86.69c-.58-.6-1.2-1.17-1.87-1.7-3.86-3.09-8.06-5.51-11.83-7.89-6.07-3.82-7.8-4.91-7.8-14.68M67.28 75.91c-4.35 3.75-9.5 5.91-15.03 5.91s-10.68-2.17-15.02-5.91M30.39 32.31c-.95-.24-1.9-.2-2.78.17-2.88 1.19-3.86 5.42-2.2 9.44 1.46 3.52 4.46 5.71 7.11 5.41M72.52 47.34c2.66.37 5.71-1.85 7.19-5.42 1.67-4.02.71-8.24-2.13-9.42-.99-.41-2.07-.4-3.13-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.81 29.75c.29 1.92.44 3.92.44 5.96 0 16.33-9.71 29.57-21.68 29.57S30.89 52.04 30.89 35.71c0-2.04.15-4.02.44-5.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.59 54.84c2.34 1.33 4.84.12 5.91-.89M31.33 29.75c2.1-13.57 10.8-23.76 21.23-23.76s19.12 10.18 21.22 23.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.28 35.71c0 16.33-9.71 29.57-21.68 29.57S30.92 52.04 30.92 35.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63 32.49c-2.32 2.33-4.63 4.66-6.95 6.99 0 0 3.11 4.06 3.99 3.17l7.81-7.81s-.56-1.4-1.63-2.07c-1.14-.72-2.81-.7-3.22-.28ZM44.7 32.27c-2.44 2.45-4.88 4.91-7.32 7.36 0 0 .11 3.15 1.52 2.92.52.87 1.75 1.35 2.68.42l8.22-8.22c1.57-1.57-4.26-3.33-5.11-2.48ZM76.89 37.27c-1-.15-1.94.56-2.08 1.57l-1.05 7.35c-.14 1.01.56 1.95 1.56 2.1 1 .15 1.94-.56 2.08-1.57l1.05-7.35c.14-1.01-.56-1.95-1.56-2.1ZM27.39 37.53c-.99.18-1.66 1.15-1.48 2.15l1.23 6.86c.18 1 1.14 1.67 2.13 1.49.99-.18 1.66-1.15 1.48-2.15l-1.23-6.86c-.18-1-1.14-1.67-2.13-1.49Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.59 48.37c.98 9.19 11.34 25.65 22.48 25.65s18.26-7.94 23.17-25.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m77.2 36.99-.33-.04c-1-.13-1.93.55-2.07 1.51l-1.12 7.94c-.14.96.57 1.85 1.57 1.99l.33.04c1 .13 1.93-.55 2.07-1.51l1.12-7.94c.14-.96-.57-1.85-1.57-1.99ZM27.88 36.95l-.33.05c-1 .14-1.7 1.04-1.55 2l1.19 7.93c.14.96 1.08 1.63 2.08 1.49l.33-.05c1-.14 1.7-1.04 1.55-2l-1.19-7.93c-.14-.96-1.08-1.63-2.08-1.49Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52.79 36.62c0 4.37 3.08 5.64 3.08 8.15s-2.91 2.62-2.91 2.62",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.31 36.62c0 4.36-3.31 7-7.39 7s-6.41-1.56-6.41-5.92c0-3.99.8-6.32 6.05-6.32 3.99 0 7.75.26 7.75 5.24ZM54.61 36.62c0 4.36 3.31 7 7.39 7s6.41-1.56 6.41-5.92c0-3.99-.8-6.32-6.05-6.32-3.99 0-7.75.26-7.75 5.24ZM50.31 36.62c0-1.27.96-1.72 2.15-1.72s2.15.45 2.15 1.72M30.53 31.96l5.98 3.98M74.39 32.05l-5.98 3.99"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAndrogynousPersonOne104 = (AvatarAndrogynousPersonOne104);
;// ./src/Picto/GeneratedPictoComponents/AvatarAndrogynousPersonOne56.tsx


var AvatarAndrogynousPersonOne56_excluded = ["className"];
function AvatarAndrogynousPersonOne56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAndrogynousPersonOne56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAndrogynousPersonOne56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAndrogynousPersonOne56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAndrogynousPersonOne56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAndrogynousPersonOne56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAndrogynousPersonOne56_objectSpread(AvatarAndrogynousPersonOne56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 23.32c-.68-.17-1.37-.14-2 .12-2.07.86-2.78 3.9-1.58 6.79 1.05 2.53 3.2 4.11 5.11 3.89M42.49 34.12c1.91.27 4.1-1.33 5.17-3.9 1.2-2.89.51-5.92-1.53-6.77-.71-.29-1.49-.29-2.25-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.73 25.91c0 11.73-6.97 21.24-15.58 21.24s-15.58-9.51-15.58-21.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.57 25.91c0 11.73 6.97 21.24 15.58 21.24s15.58-9.51 15.58-21.24l-.32-4.43C41.9 11.72 35.65 4.4 28.15 4.4s-13.76 7.32-15.26 17.08l-.32 4.43Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.67 15.98c-1.3-5.6-5.42-10.78-11.89-11.57-7.47-.91-12.29 5.16-15.24 10.69-.91 1.71-1.08 4.47 1.64 4.73 1.21.12 2.15-.52 3.01-1.2 1.56-1.24 2.96-2.46 4.91-3.15 4.16-1.48 8.37.09 11.89 2.2 2.13 1.27 4.84 2.34 6.53-.13 0 0-.12-1.46-.85-1.57Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.74 22.66-5.51 5.54s2.46 3.22 3.16 2.52l6.19-6.19s-.44-1.11-1.29-1.64c-.9-.57-2.22-.56-2.55-.23ZM21.85 22.54l-5.54 5.57s.09 2.38 1.15 2.21c.4.66 1.33 1.02 2.03.32l6.22-6.22c1.19-1.19-3.22-2.52-3.86-1.88ZM45.96 26.7c-.76-.11-1.46.42-1.57 1.19l-.79 5.55a1.388 1.388 0 1 0 2.75.39l.79-5.55c.11-.76-.42-1.47-1.18-1.58ZM10.49 26.85c-.75.14-1.25.87-1.12 1.63l.93 5.19c.14.76.86 1.26 1.61 1.13.75-.14 1.25-.87 1.12-1.63l-.93-5.19c-.14-.76-.86-1.26-1.61-1.13Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.21 23.29c-.68-.17-1.37-.14-2 .12-2.07.86-2.78 3.9-1.58 6.79 1.05 2.53 3.2 4.11 5.11 3.89M42.49 34.1c1.91.27 4.1-1.33 5.17-3.9 1.2-2.89.51-5.92-1.53-6.77-.71-.29-1.49-.29-2.25-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.42 21.46c.21 1.38.32 2.82.32 4.28C43.74 37.48 36.76 47 28.15 47s-15.59-9.52-15.59-21.26c0-1.46.11-2.89.32-4.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.73 39.49c1.68.96 3.48.09 4.25-.64M12.88 21.46c1.51-9.76 7.76-17.08 15.26-17.08S41.89 11.7 43.4 21.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.72 25.89c0 11.73-6.97 21.24-15.58 21.24s-15.58-9.51-15.58-21.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.93 34.9c.27 5.78 6.73 16.78 15.98 16.78 8.17 0 13.57-5.19 16.48-16.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.78 26.81-.23-.03c-.71-.09-1.37.39-1.47 1.07l-.8 5.65c-.1.68.41 1.32 1.12 1.41l.23.03c.71.09 1.37-.39 1.47-1.07l.8-5.65c.1-.68-.41-1.32-1.12-1.41ZM10.71 26.78l-.23.03c-.71.1-1.21.74-1.11 1.42l.85 5.64c.1.68.77 1.16 1.48 1.06l.23-.03c.71-.1 1.21-.74 1.11-1.42l-.85-5.64c-.1-.68-.77-1.16-1.48-1.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.41 26.01c0 3.16-2.4 5.08-5.37 5.08s-4.66-1.14-4.66-4.3c0-2.9.58-4.59 4.39-4.59 2.9 0 5.63.19 5.63 3.81ZM29.53 26.01c0 3.16 2.4 5.08 5.37 5.08s4.66-1.14 4.66-4.3c0-2.9-.58-4.59-4.39-4.59-2.9 0-5.63.19-5.63 3.81ZM26.41 26.01c0-.92.7-1.25 1.56-1.25s1.56.33 1.56 1.25M12.05 22.62l4.34 2.89M43.9 22.69l-4.34 2.89"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28.57 25.78c0 3.07 2.17 3.97 2.17 5.73s-2.05 1.84-2.05 1.84",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.2",
        cy: "7.08",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.88",
        cy: "8.3",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.22",
        cy: "6.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.24",
        cy: "7.08",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.6",
        cy: "6.46",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "25.26",
        cy: "8.92",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.28",
        cy: "8.3",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.16",
        cy: "8.48",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.96",
        cy: "10.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.32",
        cy: "10.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.98",
        cy: "11.99",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "22.62",
        cy: "11.99",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.94",
        cy: "10.76",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.58",
        cy: "10.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.86",
        cy: "8.92",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.84",
        cy: "7.69",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.84",
        cy: "10.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.54",
        cy: "10.15",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.22",
        cy: "11.37",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.88",
        cy: "13.83",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.47",
        cy: "14.28",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.2",
        cy: "12.6",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.18",
        cy: "11.99",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.18",
        cy: "14.44",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.16",
        cy: "13.83",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.48",
        cy: "12.6",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.8",
        cy: "14.44",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.44",
        cy: "15.67",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.66",
        cy: "16.29",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.44",
        cy: "17.52",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.78",
        cy: "14.44",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.46",
        cy: "12.6",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.14",
        cy: "10.76",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.82",
        cy: "9.53",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.05",
        cy: "12.6",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.84",
        cy: "12.39",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.28",
        cy: "14.44",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.3",
        cy: "13.83",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.66",
        cy: "13.83",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.32",
        cy: "15.67",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.33",
        cy: "17.33",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "16.02",
        cy: "17.95",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "16.68",
        cy: "15.06",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18",
        cy: "12.6",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.9",
        cy: "8.92",
        rx: ".33",
        ry: ".31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAndrogynousPersonOne56 = (AvatarAndrogynousPersonOne56);
;// ./src/Picto/GeneratedPictoComponents/AvatarAndrogynousPersonTwo104.tsx


var AvatarAndrogynousPersonTwo104_excluded = ["className"];
function AvatarAndrogynousPersonTwo104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAndrogynousPersonTwo104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAndrogynousPersonTwo104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAndrogynousPersonTwo104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAndrogynousPersonTwo104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAndrogynousPersonTwo104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAndrogynousPersonTwo104_objectSpread(AvatarAndrogynousPersonTwo104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.87 35.17a4.76 4.76 0 0 0-2.42.29c-2.98 1.24-4.07 5.46-2.42 9.44 1.65 3.98 4.84 4.85 8.21 4.85M69.54 49.76c3.15.35 6.17-.87 7.82-4.85s.57-8.21-2.42-9.44c-.74-.31-1.53-.4-2.32-.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.37 29.02c.47 2.98.45 6.31-.21 9.96-2.88 16.32-12.24 29.06-20.92 29.04-8.68.02-18.04-12.73-20.92-29.04-3.5-19.51 11.14-29.47 20.92-29.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.1 87.19-8.35-6.03c-2.82-2.04-5.37-4.45-7.41-7.27-.2-.28-.4-.56-.6-.85-1.84-2.71-3.44-6.08-3.71-9.75l-19.6.38c-.33 3.37-1.77 6.47-3.45 9.03l-.23.34c-.2.29-.4.57-.6.85-2.05 2.81-4.59 5.23-7.41 7.27l-8.35 6.03s11.24 12.05 30.07 12.05S81.1 87.19 81.1 87.19ZM43.66 7.73l15.51 20.72h3.08l-2.55-6.88 7.65 6.88h9.35s-1.75-22.4-23.92-22.4c-3.57 0-6.62.54-9.23 1.46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.5 85.15c-.65.61-.13 1.37.59.92 3.79-2.36 10.19 1.95 13.42-2.66.46.2-.05-1.74-.2-2.23-.27-.87-.34-3.97-2.22-4.39-2.1-1.31-8.74 5.21-11.58 8.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.42 92.21-3.49-5.02 5.24-5.03 5.24 5.03-3.49 5.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.86 85.24c.63.62.06 1.41-.66.95-3.77-2.41-10.61 2.04-13.67-2.69-.48.2.15-1.79.34-2.3.33-.9.58-4.09 2.53-4.53 2.23-1.36 8.7 5.33 11.45 8.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.82 22.2c-.16-1.54-1.79-3.02-2.69-4.25-1.42-1.94-2.83-3.89-4.25-5.83-.41-.57-1.23-1-1.99-.75-7.42 2.41-10.87 6.4-14.04 12.54-.15.29-1.42 3.18-.82 4.12-.37.46-.15 1.36.18 2.02 1.2 2.41 3.57 1.97 5.51.53 1.69-1.25 2.98-2.67 4.94-3.61 2.46-1.17 4.9-1.43 7.61-1.57 2.23-.12 5.86-.26 5.55-3.19ZM49.42 92.21l-.57 4.48s.51 2.54 2.6 2.54 2.41-2.54 2.41-2.54l-.87-4.82-3.36-.62-.21.94M43.98 6.99l15.51 21.64h3.08l-2.07-5.85 7.17 5.85h4.86S67.79-.04 43.98 6.99Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.24 81.84 5.25 5.03-3.5 5.02 1.62 7.35M51.24 81.84 46 86.87l3.5 5.02-.98 7.35M37.98 72.7c1.68-2.56 3.12-5.66 3.45-9.03M61.03 63.29c.26 3.67 1.87 7.04 3.71 9.75M59.85 98.42c-.41-15.41 6.38-23.35 6.38-23.35M42.36 98.28c1.21-15.52-6.1-23.21-6.1-23.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.75 73.04 13.49 8.62-8.93 8.56M64.73 73.04l-13.49 8.62 8.93 8.56M29.87 35.17a4.76 4.76 0 0 0-2.42.29c-2.98 1.24-4.07 5.46-2.42 9.44 1.65 3.98 4.84 4.85 8.21 4.85M69.54 49.76c3.15.35 6.17-.87 7.82-4.85s.57-8.21-2.42-9.44c-.74-.31-1.53-.4-2.32-.31M49.46 57.69c2.31 1.31 4.78.12 5.85-.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.37 29.02c.47 2.98.45 6.31-.21 9.96-2.88 16.32-12.24 29.06-20.92 29.04-8.68.02-18.04-12.73-20.92-29.04-3.5-19.51 11.14-29.47 20.92-29.45M64.73 73.04c.2.29.4.57.6.85 2.05 2.81 4.59 5.23 7.41 7.27l8.35 6.03M37.75 73.04c-.2.29-.4.57-.6.85-2.05 2.81-4.59 5.23-7.41 7.27l-8.35 6.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.66 7.73 15.51 20.72h3.08l-2.55-6.88 7.65 6.88h9.35s-1.75-22.4-23.92-22.4c-3.57 0-6.62.54-9.23 1.46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.14 38.9c0 4.26-3.24 6.84-7.23 6.84s-6.27-1.53-6.27-5.79c0-3.9.78-6.18 5.92-6.18 3.9 0 7.58.25 7.58 5.13ZM53.34 38.9c0 4.26 3.24 6.84 7.23 6.84s6.27-1.53 6.27-5.79c0-3.9-.78-6.18-5.92-6.18-3.9 0-7.58.25-7.58 5.13ZM49.14 38.9c0-1.24.94-1.68 2.1-1.68s2.1.44 2.1 1.68M29.8 34.05l5.85 3.89M72.69 34.05l-5.85 3.89"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.46 39.12c0 4.39 3.1 5.67 3.1 8.19s-2.92 2.63-2.92 2.63",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.93",
        cy: "24.73",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.97",
        cy: "22.25",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.4",
        cy: "39.76",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.09",
        cy: "39.76",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.58",
        cy: "23.43",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "50.01",
        cy: "20.99",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.6",
        cy: "20.02",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.09",
        cy: "16.12",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.16",
        cy: "14.66",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.01",
        cy: "16.12",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.48",
        cy: "18.55",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.18",
        cy: "20.85",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.85",
        cy: "26.84",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.12",
        cy: "29.28",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.61",
        cy: "25.87",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.32",
        cy: "23.92",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.18",
        cy: "22.13",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.83",
        cy: "18.55",
        r: ".49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAndrogynousPersonTwo104 = (AvatarAndrogynousPersonTwo104);
;// ./src/Picto/GeneratedPictoComponents/AvatarAndrogynousPersonTwo56.tsx


var AvatarAndrogynousPersonTwo56_excluded = ["className"];
function AvatarAndrogynousPersonTwo56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarAndrogynousPersonTwo56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarAndrogynousPersonTwo56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarAndrogynousPersonTwo56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarAndrogynousPersonTwo56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarAndrogynousPersonTwo56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarAndrogynousPersonTwo56_objectSpread(AvatarAndrogynousPersonTwo56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.23 27.21c-.6-.08-1.2-.02-1.76.21-2.18.9-2.97 3.99-1.76 6.89 1.2 2.9 3.53 3.54 5.99 3.54M41.16 37.85c2.3.26 4.5-.63 5.7-3.54 1.2-2.9.41-5.99-1.76-6.89-.54-.22-1.11-.29-1.69-.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.23 22.72c.34 2.18.33 4.6-.15 7.27-2.1 11.9-8.93 21.2-15.26 21.18-6.33.01-13.16-9.28-15.26-21.18C10.01 15.76 20.68 8.5 27.82 8.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.01 6.97 10.8 15.34h2.15l-1.77-5.09 5.32 5.09h6.51S44.8 5.73 29.36 5.73c-2.49 0-4.61.4-6.43 1.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.57 17.89c-.14-1.27-1.52-2.49-2.28-3.51-1.2-1.6-2.4-3.21-3.6-4.81-.35-.47-1.04-.82-1.69-.62-6.29 1.99-9.21 5.28-11.9 10.35-.13.24-1.2 2.63-.7 3.4-.31.38-.12 1.13.15 1.66 1.02 1.99 3.03 1.62 4.67.44 1.43-1.03 2.52-2.21 4.19-2.98 2.08-.97 4.15-1.18 6.45-1.3 1.89-.1 4.97-.22 4.7-2.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.9 6.71 11.15 15.56h2.21l-1.49-4.2 5.16 4.2h3.49S40.02 1.65 22.9 6.71Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.75",
        cy: "31.09",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.02",
        cy: "31.09",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.04",
        cy: "19.14",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.03",
        cy: "17.15",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.24",
        cy: "16.35",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.64",
        cy: "13.16",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.25",
        cy: "11.96",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.67",
        cy: "13.16",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.69",
        cy: "15.15",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "19.99",
        cy: "17.03",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.42",
        cy: "20.21",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.09",
        cy: "18.18",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.27",
        cy: "21.93",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.22",
        cy: "23.92",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.61",
        cy: "21.13",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.46",
        cy: "19.54",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.9",
        cy: "18.08",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.06",
        cy: "15.15",
        r: ".4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.19 27.28c-.6-.08-1.2-.02-1.76.21-2.18.9-2.97 3.99-1.76 6.89 1.2 2.9 3.53 3.54 5.99 3.54M41.13 37.92c2.3.26 4.5-.63 5.7-3.54 1.2-2.9.41-5.99-1.76-6.89-.54-.22-1.11-.29-1.69-.22M26.48 43.7c1.69.96 3.49.09 4.27-.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.19 22.79c.34 2.18.33 4.6-.15 7.27-2.1 11.9-8.93 21.2-15.26 21.18-6.33.01-13.16-9.28-15.26-21.18C9.97 15.83 20.64 8.57 27.78 8.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.97 7.04 10.8 15.34h2.15l-1.77-5.09 5.32 5.09h6.51S44.76 5.8 29.32 5.8c-2.49 0-4.61.4-6.43 1.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.29 30.52c0 3.05-2.37 4.89-5.29 4.89s-4.58-1.09-4.58-4.14c0-2.79.57-4.42 4.33-4.42 2.85 0 5.54.18 5.54 3.66ZM29.36 30.52c0 3.05 2.37 4.89 5.29 4.89s4.58-1.09 4.58-4.14c0-2.79-.57-4.42-4.33-4.42-2.85 0-5.54.18-5.54 3.66Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.29 30.52c0-.88.69-1.2 1.54-1.2s1.54.32 1.54 1.2M12.14 27.05l4.28 2.79M43.51 27.05l-4.28 2.79"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28.37 30.3c0 3.45 2.38 4.46 2.38 6.44s-2.24 2.07-2.24 2.07",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarAndrogynousPersonTwo56 = (AvatarAndrogynousPersonTwo56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaby104.tsx


var AvatarBaby104_excluded = ["className"];
function AvatarBaby104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaby104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaby104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaby104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaby104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaby104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaby104_objectSpread(AvatarBaby104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.23 37.8c-1.24-.47-2.53-.51-3.7-.04-2.99 1.22-4.08 5.4-2.43 9.32 1.32 3.13 3.97 5.16 6.52 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.03 68.05c-11.88 0-21.51-10.79-21.51-24.11s9.63-24.11 21.51-24.11 21.51 10.79 21.51 24.11-9.63 24.11-21.51 24.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.71 86.54c1.91-9.3.99-14.23.99-14.23-1.04-5.31-4.11-9.87-11.77-12.75l-33.78.34c-9.19 2.8-12.71 7.69-13.83 13.45v-.15s-1 4.96 1 14.23c0 0 6.33 11.81 28.68 11.81s28.71-12.7 28.71-12.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.96 37.8c1.24-.47 2.53-.51 3.7-.04 2.99 1.22 4.08 5.4 2.43 9.32-1.32 3.13-3.97 5.16-6.52 5.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.91 49.29c-2.07-.28-2.81 1.61-4.94 1.65-2.13-.04-2.87-1.93-4.94-1.65-2.22.3-4.59 2.79-3.04 7.06.72 1.99 3.48 4.27 7.98 4.35 4.5-.08 7.26-2.36 7.98-4.35 1.55-4.27-.82-6.76-3.04-7.06Zm-4.94 8.28c-1.18 0-2.14-.96-2.14-2.14s.96-2.14 2.14-2.14 2.14.96 2.14 2.14-.96 2.14-2.14 2.14Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.33 70.43c.06 1.12 1 1.59 2.24 1.2.01 0-.02 0 0 0 4.89-.44 9.03.73 13.82 5.54a9.947 9.947 0 0 0 3.47 2.27c2.46.97 3.36-2.03 1.15-3.49l-.65-.34c-.29-.19 0 0-.17-.3l-1.12-.83c-.13-.23-1.49-1.24-1.53-1.49l-.7-.63c-.12-.7-.93-.98-1.56-1.29L36.84 70c-.24-.12-1.5-1.15-1.78-1.17L32.08 67c-.4-.04-1.74-1.2-2.1-1.03l-2.27-.39c-.34.16-1.24-.83-1.46-.52l-2.54 3.49c-.3.42-.46.93-.43 1.44l.02.43ZM81.25 80.14c-1.28 2.02-2.46-.16-3.32-1.52 0-.02.01.01 0 0-4.11-4.28-8.69-6.37-16.4-5.26-1.73.25-3.32.04-4.74-.43-2.91-.96-2.08-5.88.95-5.62.4.03.79-.04 1.16-.21l5.42-2.52c.28-.13.53-.31.75-.54l3.46-3.58c.6-.62 1.42-.88 2.22-.7l1.54.35c.3.07.59.2.86.39l5.22 4.5c-.84.74.85.98 1.06 1.44l1.82 4.24c.19.43.4.96.39 1.44l.12 4.81c-.02.66.48 1.53.1 2.03l-.61 1.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.13 52.15c2.61.04 5.4-2.01 6.75-5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.16 37.62c-1.24-.47-2.53-.51-3.7-.04-2.99 1.22-4.08 5.4-2.43 9.32 1.32 3.13 3.97 5.16 6.52 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.89 46.9c1.65-3.93.57-8.1-2.43-9.32-1.17-.48-2.46-.43-3.7.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.96 67.88c-11.88 0-21.51-10.79-21.51-24.11s9.63-24.11 21.51-24.11 21.51 10.79 21.51 24.11-9.63 24.11-21.51 24.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.96 19.66s-6.61-1.78-5.17-6.94c1.43-5.16 7.9-3.13 6.15 1-1.75 4.14-14.78 1.71-7.84-8.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.52 41.61c-.74 1.44-2.27 2.28-3.83 2.13-1.41-.14-2.63-1.07-3.19-2.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.42 41.61c-.74 1.44-2.27 2.28-3.83 2.13-1.41-.14-2.63-1.07-3.19-2.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.64 86.36c1.91-9.3.99-14.23.99-14.23M22.26 73.02s-1.01 4.96.99 14.23M79.97 67.85c-12.14-.35-41.67 3.23-40.76 29.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.52 65.79c8.56 1.77 14.46 6.81 18.81 12.32M69.86 59.38c7.66 2.88 10.73 7.44 11.77 12.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.08 59.72c-9.19 2.8-12.71 7.69-13.83 13.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.11 54.81a5.09 5.09 0 0 1 2.95 4.61 5.08 5.08 0 0 1-10.16 0c0-2.04 1.21-3.81 2.95-4.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.97 60.7c4.5-.08 7.26-2.36 7.98-4.35 1.55-4.27-.82-6.76-3.04-7.06-2.07-.28-2.81 1.61-4.94 1.65-2.13-.04-2.87-1.93-4.94-1.65-2.22.3-4.59 2.79-3.04 7.06.72 1.99 3.48 4.27 7.98 4.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.11 55.44c0 1.18-.96 2.14-2.14 2.14s-2.14-.96-2.14-2.14.96-2.14 2.14-2.14 2.14.96 2.14 2.14Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.46",
        cy: "52.91",
        r: "1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.59",
        cy: "52.91",
        r: "1.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaby104 = (AvatarBaby104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaby56.tsx


var AvatarBaby56_excluded = ["className"];
function AvatarBaby56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaby56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaby56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaby56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaby56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaby56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaby56_objectSpread(AvatarBaby56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.82 27.92c-.96-.36-1.97-.4-2.88-.03-2.33.95-3.17 4.2-1.89 7.25 1.02 2.44 3.09 4.02 5.07 4.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.18 27.92c.96-.37 1.97-.4 2.88-.03 2.33.95 3.17 4.2 1.89 7.25-1.06 2.51-3.22 4.11-5.25 4.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 51.46c-9.24 0-16.73-8.4-16.73-18.75S18.76 13.95 28 13.95s16.73 8.4 16.73 18.76S37.24 51.46 28 51.46Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M31.89 36.62c-1.63-.22-2.21 1.27-3.89 1.29-1.68-.03-2.25-1.52-3.89-1.29-1.75.24-3.61 2.2-2.39 5.56.57 1.57 2.74 3.36 6.28 3.42 3.54-.06 5.71-1.85 6.28-3.42 1.22-3.36-.64-5.32-2.39-5.56ZM28 43.13c-.93 0-1.68-.75-1.68-1.68s.75-1.68 1.68-1.68 1.68.75 1.68 1.68-.75 1.68-1.68 1.68Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.7 39.23c2.03.03 4.2-1.56 5.25-4.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.82 27.93c-.96-.36-1.97-.4-2.88-.03-2.33.95-3.17 4.2-1.89 7.25 1.02 2.44 3.09 4.02 5.07 4.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.95 35.16c1.29-3.06.44-6.3-1.89-7.25-.91-.37-1.92-.34-2.88.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 51.47c-9.24 0-16.73-8.4-16.73-18.75S18.76 13.96 28 13.96s16.73 8.4 16.73 18.76S37.24 51.47 28 51.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 13.96s-5.14-1.38-4.02-5.4c1.12-4.02 6.15-2.43 4.78.78-1.36 3.22-11.5 1.33-6.1-6.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.77 31.04c-.58 1.12-1.77 1.78-2.98 1.66a3.035 3.035 0 0 1-2.48-1.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.69 31.04c-.58 1.12-1.77 1.78-2.98 1.66a3.035 3.035 0 0 1-2.48-1.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.61 40.97a3.82 3.82 0 1 1-3.2 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 45.39c3.39-.06 5.46-1.77 6-3.27 1.16-3.21-.62-5.08-2.29-5.31-1.56-.21-2.11 1.21-3.71 1.24-1.6-.03-2.16-1.45-3.71-1.24-1.67.23-3.45 2.1-2.29 5.31.54 1.5 2.62 3.21 6 3.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.61 41.44c0 .89-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.37",
        cy: "39.71",
        r: ".8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.78",
        cy: "39.71",
        r: ".8"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaby56 = (AvatarBaby56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldMale104.tsx


var AvatarBaldMale104_excluded = ["className"];
function AvatarBaldMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldMale104_objectSpread(AvatarBaldMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.95 30.2c-1.02-.26-2.06-.22-3.01.17-2.96 1.23-4.04 5.42-2.4 9.37 1.21 2.93 3.58 4.9 5.93 5.22M72.82 44.97c2.37-.29 4.78-2.27 6-5.23 1.64-3.95.56-8.14-2.4-9.37-1-.41-2.08-.44-3.14-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.47 33.65c0 16.03-1.6 29.02-21.28 29.02S30.91 49.68 30.91 33.65 40.43 4.63 52.18 4.63s21.28 12.99 21.28 29.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.69 85.03c-6.31-6.91-16.62-13.04-16.62-13.04-3.47-1.96-5.9-3.63-5.9-10.82l-19.35.25c0 7.15-2.72 8.05-6.02 10.57-10.98 7.4-16.57 13.04-16.57 13.04s12.54 14.21 31.33 14.21 33.13-14.21 33.13-14.21Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.62 22.43C68.78 13.8 62.97 5.82 53.82 4.6c-10.56-1.41-17.36 7.95-21.53 16.47-1.29 2.64-1.53 6.89 2.32 7.29 1.71.18 3.03-.79 4.25-1.85 2.2-1.9 4.18-3.78 6.93-4.85 5.88-2.28 11.82.14 16.8 3.39 3.01 1.96 6.83 3.6 9.23-.2 0 0-.17-2.25-1.21-2.42ZM21.01 83.96s2.02 2.19 3.14 1.59c1.12-.6 10.17-8.81 14.13-4.84 3.96 3.97 11.67 3.78 13.08.56.76-1.74-15.38-9.49-15.38-9.49L21.01 83.97Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.17 72c3.3-2.53 6.02-3.43 6.02-10.57M61.54 61.18c0 7.19 2.43 8.86 5.9 10.82M30.32 30.2c-1.02-.26-2.06-.22-3.01.17-2.96 1.23-4.04 5.42-2.4 9.37 1.21 2.93 3.58 4.9 5.93 5.22M72.28 44.96c2.37-.29 4.69-2.26 5.92-5.22 1.64-3.95.56-8.14-2.4-9.37-1-.41-2.08-.44-3.14-.14M39.94 31.16c2.14-1.93 5.6-1.93 7.74 0M55.42 31.16c2.14-1.93 5.6-1.93 7.74 0M51.4 35.59c0 4.36 2.85 4.56 2.85 7.06s-2.9 2.61-2.9 2.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.84 33.65c0 16.03-1.6 29.02-21.28 29.02S30.28 49.68 30.28 33.65 39.8 4.63 51.55 4.63s21.28 12.99 21.28 29.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.62 52.42c2.3 1.3 4.75.12 5.8-.88M19.6 85.03s5.6-5.64 16.57-13.04l15.2 8.46 16.07-8.46s10.31 6.13 16.62 13.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.93",
        cy: "7.01",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "55.75",
        cy: "8.89",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.87",
        cy: "10.77",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "50.1",
        cy: "8.89",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.34",
        cy: "7.95",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.28",
        cy: "11.71",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.45",
        cy: "10.77",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.43",
        cy: "11.05",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.57",
        cy: "13.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.8",
        cy: "13.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.75",
        cy: "16.42",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.51",
        cy: "16.42",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.4",
        cy: "14.54",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "49.16",
        cy: "13.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "56.7",
        cy: "11.71",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.52",
        cy: "9.83",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "62.1",
        cy: "12.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "61.4",
        cy: "15.48",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.52",
        cy: "13.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "54.81",
        cy: "13.6",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.93",
        cy: "15.48",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.87",
        cy: "19.25",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "55.75",
        cy: "17.36",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.58",
        cy: "16.42",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.58",
        cy: "20.19",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "61.4",
        cy: "19.25",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.29",
        cy: "17.36",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "65.17",
        cy: "20.19",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.23",
        cy: "22.07",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "66.39",
        cy: "23.01",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "68.94",
        cy: "24.9",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "68",
        cy: "20.19",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "66.11",
        cy: "17.36",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "64.23",
        cy: "14.54",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "49.83",
        cy: "17.36",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.67",
        cy: "17.03",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.45",
        cy: "20.19",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.63",
        cy: "19.25",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.86",
        cy: "19.25",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.8",
        cy: "22.07",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.39",
        cy: "24.62",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.1",
        cy: "25.56",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.04",
        cy: "21.13",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.92",
        cy: "17.36",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.05",
        cy: "11.71",
        r: ".47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.65 35.17c0 .76-.84.42-1.87.42s-1.87.34-1.87-.42.84-1.38 1.87-1.38 1.87.62 1.87 1.38ZM60.64 35.17c0 .76-.84.5-1.87.5s-1.87.26-1.87-.5.84-1.38 1.87-1.38 1.87.62 1.87 1.38Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m49.05 57.53 3.38 10.21 3.09-10.32-6.47.11z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m49.05 57.53 3.38 10.21 3.09-10.32-6.47.11z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldMale104 = (AvatarBaldMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldMale56.tsx


var AvatarBaldMale56_excluded = ["className"];
function AvatarBaldMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldMale56_objectSpread(AvatarBaldMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.31 24.37c-.76-.2-1.53-.17-2.24.13-2.2.91-3 4.03-1.78 6.96.9 2.18 2.66 3.64 4.4 3.88M43.39 35.34c1.76-.21 3.55-1.69 4.46-3.88 1.21-2.93.42-6.05-1.78-6.96-.74-.31-1.54-.32-2.33-.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.87 26.93c0 11.9-1.19 21.54-15.8 21.54s-15.8-9.65-15.8-21.54 7.07-21.54 15.8-21.54 15.8 9.65 15.8 21.54Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.38 18.99c-1.39-6.37-5.79-12.26-12.71-13.16-7.98-1.04-13.13 5.87-16.28 12.16-.98 1.95-1.15 5.08 1.76 5.38 1.29.13 2.29-.59 3.21-1.36 1.66-1.4 3.16-2.79 5.24-3.58 4.45-1.68 8.94.1 12.71 2.5 2.27 1.44 5.17 2.66 6.98-.15 0 0-.13-1.66-.91-1.79Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.25 24.44c-.76-.2-1.53-.17-2.24.13-2.2.91-3 4.03-1.78 6.96.9 2.18 2.66 3.64 4.4 3.88M43.65 35.41c1.76-.21 3.23-1.69 4.14-3.88 1.21-2.93.42-6.05-1.78-6.96-.74-.31-1.35-.32-2.07-.16M19.4 25.16c1.59-1.44 4.16-1.44 5.75 0M30.89 25.16c1.59-1.44 4.16-1.44 5.75 0M27.9 28.44c0 3.24 2.11 3.39 2.11 5.24s-2.15 1.94-2.15 1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.82 27c0 11.9-1.19 21.54-15.8 21.54S12.22 38.89 12.22 27s7.07-21.54 15.8-21.54 15.8 9.65 15.8 21.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.58 40.94c1.71.97 3.52.09 4.31-.65"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.09",
        cy: "7.3",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.24",
        cy: "8.73",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.81",
        cy: "10.16",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.94",
        cy: "8.73",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.08",
        cy: "8.01",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.8",
        cy: "10.88",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.65",
        cy: "10.16",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.35",
        cy: "10.37",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.22",
        cy: "12.31",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.35",
        cy: "12.31",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "19.07",
        cy: "14.46",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.93",
        cy: "14.46",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.36",
        cy: "13.02",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.23",
        cy: "12.31",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.96",
        cy: "10.88",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.1",
        cy: "9.44",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.06",
        cy: "11.55",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.54",
        cy: "13.74",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.1",
        cy: "12.31",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "30.52",
        cy: "12.31",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.09",
        cy: "13.74",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.81",
        cy: "16.6",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.24",
        cy: "15.17",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.39",
        cy: "14.46",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.39",
        cy: "17.32",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.54",
        cy: "16.6",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.97",
        cy: "15.17",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.4",
        cy: "17.32",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.93",
        cy: "18.75",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.33",
        cy: "19.47",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.26",
        cy: "20.9",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.55",
        cy: "17.32",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.11",
        cy: "15.17",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.68",
        cy: "13.02",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.73",
        cy: "15.17",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.33",
        cy: "14.92",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.65",
        cy: "17.32",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.5",
        cy: "16.6",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.64",
        cy: "16.6",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.35",
        cy: "18.75",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.27",
        cy: "20.69",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.77",
        cy: "21.4",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.49",
        cy: "18.03",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.92",
        cy: "15.17",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.66",
        cy: "10.88",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.59 27.98c0 .58-.64.32-1.43.32s-1.43.26-1.43-.32.64-1.05 1.43-1.05 1.43.47 1.43 1.05ZM34.99 27.98c0 .58-.64.38-1.43.38s-1.43.2-1.43-.38.64-1.05 1.43-1.05 1.43.47 1.43 1.05Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m25.9 44.95 2.24 6.77 2.05-6.84-4.29.07z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m25.62 44.73 2.56 7.72 2.34-7.81-4.9.09z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldMale56 = (AvatarBaldMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldManBeard104.tsx


var AvatarBaldManBeard104_excluded = ["className"];
function AvatarBaldManBeard104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldManBeard104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldManBeard104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldManBeard104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldManBeard104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldManBeard104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldManBeard104_objectSpread(AvatarBaldManBeard104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.49 31.28c-.97-.24-1.94-.2-2.84.17-2.94 1.22-3.94 5.53-2.24 9.63 1.49 3.59 4.54 5.82 7.25 5.52M71.44 46.6c2.71.38 5.82-1.88 7.33-5.53 1.7-4.1.73-8.4-2.17-9.6-1-.42-2.11-.41-3.19-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.24 34.75c0 16.65-9.9 30.15-22.11 30.15S29.02 51.4 29.02 34.75l.07-4.09C31.27 16.59 40.29 6.03 51.1 6.03s19.83 10.56 22 24.63l.14 4.09Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.56 85.5c-8.37-7.74-11.19-11.71-11.19-11.71h-.07c-6.98-3.99-9.34-6.13-10.14-14.52l-20.98.32c-.88 8.18-3.29 9.41-10.33 14.2h.07c-7.61 4.73-12.29 10.29-12.29 10.29s11.14 15.16 32.7 15.16 32.24-13.75 32.24-13.75Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.84 73.47c7.04-4.79 9.46-6.03 10.33-14.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.16 58.95c.8 8.4 3.16 10.54 10.14 14.52"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.79 33.93c0 1-1.1.56-2.46.56s-2.46.44-2.46-.56 1.1-1.81 2.46-1.81 2.46.81 2.46 1.81ZM62.6 33.9c0 1-1.1.65-2.46.65s-2.46.35-2.46-.65 1.1-1.81 2.46-1.81 2.46.81 2.46 1.81Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.35 82.81s-.55.59.82 1.31c1.91 1.01 8.56-5.88 14.35-3.38 6.78 2.92 15.5 5.6 15.9 3.04.44-2.85-20.2-9.81-20.2-9.81l-10.87 8.84Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.63 83.76s4.68-5.56 12.29-10.29l20.15 9.47 21.3-9.47s4.2 2.82 11.19 12.03",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.15 18.7c-1.73-6.24-7.19-12.01-15.78-12.89-9.92-1.02-16.31 5.75-20.23 11.91-1.21 1.91-1.43 4.98 2.18 5.27 1.6.13 2.85-.57 3.99-1.34 2.06-1.38 3.93-2.73 6.51-3.51 5.53-1.65 11.1.1 15.79 2.45 2.82 1.41 6.42 2.6 8.67-.15 0 0-.16-1.63-1.13-1.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.95 52.47c-.88 1.86-2.72 2.83-3.63 4.56-9.21 5.67-16.39 5.13-27.21-.42-.95-1.8-3.94-3.78-4.61-5.7-.73-2.06-2.61-.18-1.87 1.91 1.71 4.81 3.26 10.19 6.94 13.83 1.69 1.67 3.64 3.06 5.79 4.1 1.37.66 2.39 1.77 3.77 2.4.91.41 2.91 1.74 3.85 1.91 1.89.33 3.56-2.11 5.17-3.01 2.24-1.24 4.44-1.97 6.5-3.5 1.76-1.31 2.9-3.1 4.18-4.93 1.03-1.48 2.09-3.72 2.84-5.47.79-1.31 1.13-4.3 1.55-5.83.51-1.82-.87-4.09-1.71-2.3l-1.56 2.45Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.75 28.35c.29 1.96.45 3.99.45 6.08 0 16.65-10.01 26.82-22.22 26.82S28.99 51.08 28.99 34.43c0-2.08.15-4.1.45-6.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.49 30.95c-.97-.24-1.94-.2-2.84.17-2.94 1.22-3.94 5.53-2.24 9.63 1.49 3.59 4.54 5.82 7.25 5.52M71.44 46.28c2.71.38 5.82-1.88 7.33-5.53 1.7-4.1.73-8.4-2.17-9.6-1-.42-2.11-.41-3.19-.04M51.33 35.35c0 4.45 3.14 5.75 3.14 8.31s-2.97 2.67-2.97 2.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.66 45.86c-1.06-3.53-1.65-7.39-1.65-11.43M73.24 34.43c0 4.16-.62 8.13-1.74 11.74M38.15 30.28c2.41-2.18 6.31-2.18 8.72 0M55.59 30.28c2.41-2.18 6.31-2.18 8.72 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.92 51.39c1.49 2.4 5.95 2.89 7.73-.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.09 30.34C31.27 16.27 40.29 5.71 51.1 5.71s19.83 10.56 22 24.63M50.98 76.61c0-4.31-8.24-2.01-15.85-13-5.74-8.24-4.65-18.06-4.65-18.06s3.34 15.24 20.5 15.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.98 76.61c0-4.31 8.24-2.01 15.85-13 5.74-8.24 4.98-18.53 4.98-18.53S68.12 60.79 50.97 60.7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "55.02",
        cy: "9.69",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.28",
        cy: "11.32",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.41",
        cy: "8.48",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "49.79",
        cy: "9.69",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "46.3",
        cy: "8.88",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "47.17",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "44.55",
        cy: "11.32",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "41.75",
        cy: "11.56",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42.8",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.31",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.18",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "43.68",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "45.42",
        cy: "14.57",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "48.91",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "55.9",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.52",
        cy: "10.51",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.52",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "54.15",
        cy: "13.76",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.41",
        cy: "15.38",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "55.02",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "57.64",
        cy: "16.19",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "60.26",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "62.01",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "63.75",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "66.37",
        cy: "19.44",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "64.63",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "62.88",
        cy: "14.57",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "61.13",
        cy: "12.94",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "49.53",
        cy: "16",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "46.6",
        cy: "16.72",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "41.93",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.44",
        cy: "18.63",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.82",
        cy: "20.25",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.57",
        cy: "17",
        rx: ".44",
        ry: ".41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.66",
        cy: "12.13",
        rx: ".44",
        ry: ".41"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldManBeard104 = (AvatarBaldManBeard104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldManBeard56.tsx


var AvatarBaldManBeard56_excluded = ["className"];
function AvatarBaldManBeard56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldManBeard56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldManBeard56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldManBeard56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldManBeard56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldManBeard56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldManBeard56_objectSpread(AvatarBaldManBeard56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.38 21.12c-.62-.15-1.25-.13-1.82.11-1.89.78-2.53 3.55-1.44 6.19.95 2.3 2.92 3.74 4.66 3.55M40.98 30.96c1.74.24 3.74-1.21 4.71-3.55 1.09-2.64.47-5.4-1.4-6.17-.65-.27-1.35-.26-2.05-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.13 23.35c0 10.7-6.36 19.37-14.2 19.37s-14.2-8.67-14.2-19.37l.04-2.62c1.4-9.04 7.19-15.82 14.14-15.82s12.74 6.78 14.13 15.82l.09 2.62Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.99 23.11c0 .65-.71.36-1.6.36s-1.6.29-1.6-.36.71-1.17 1.6-1.17 1.6.52 1.6 1.17ZM35.52 23.09c0 .65-.71.42-1.6.42s-1.6.22-1.6-.42.71-1.17 1.6-1.17 1.6.52 1.6 1.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.49 13.49c-1.11-4.01-4.61-7.71-10.13-8.27-6.36-.65-10.47 3.69-12.98 7.64-.78 1.22-.92 3.2 1.4 3.38 1.03.08 1.83-.37 2.56-.86 1.33-.88 2.52-1.75 4.18-2.25 3.55-1.06 7.13.07 10.13 1.57 1.81.91 4.12 1.67 5.57-.09 0 0-.1-1.04-.73-1.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.2 35.38c-.56 1.28-1.6 1.52-2.85 2.73-5.45 3.33-11.01 4.24-17.47-.6-.6-1.23-2.49-2.85-2.91-4.17-.47-1.42-1.38-.08-.91 1.35 1.09 3.3 1.78 7.21 4.11 9.71 1.07 1.15 2.31 2.1 3.67 2.81.87.45 1.78.79 2.66 1.22.58.28 1.91 1.32 2.51 1.44 1.29-.39 2.01-.84 3.03-1.46 1.42-.85 2.73-1.66 4.03-2.71 1.11-.9 2.46-2.4 3.27-3.65.65-1.02 1.17-2.21 1.64-3.42.5-.9.68-2.81.95-3.87.32-1.25-.09-2.49-.62-1.25l-1.11 1.87Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.33",
        cy: "6.09",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.32",
        cy: "7.03",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.81",
        cy: "5.38",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.29",
        cy: "6.09",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "25.77",
        cy: "7.5",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.25",
        cy: "7.03",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "22.63",
        cy: "7.17",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.24",
        cy: "8.45",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.22",
        cy: "8.45",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.72",
        cy: "9.86",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.75",
        cy: "9.86",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.76",
        cy: "8.92",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.79",
        cy: "8.45",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.84",
        cy: "7.5",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "32.36",
        cy: "6.56",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "32.36",
        cy: "8.45",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.83",
        cy: "8.45",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.81",
        cy: "9.39",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.32",
        cy: "11.27",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.7",
        cy: "11.62",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.33",
        cy: "10.33",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.85",
        cy: "9.86",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.85",
        cy: "11.74",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.37",
        cy: "11.27",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.38",
        cy: "10.33",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.4",
        cy: "11.74",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.35",
        cy: "12.69",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.05",
        cy: "13.16",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.42",
        cy: "14.1",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.68",
        cy: "13.16",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.92",
        cy: "11.74",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.9",
        cy: "10.33",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.89",
        cy: "8.92",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.88",
        cy: "7.97",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.14",
        cy: "10.33",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "25.45",
        cy: "10.16",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.25",
        cy: "11.74",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "22.74",
        cy: "11.27",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "20.71",
        cy: "11.27",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.22",
        cy: "12.69",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "20.45",
        cy: "13.96",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.18",
        cy: "13.28",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.68",
        cy: "14.43",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.19",
        cy: "12.22",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "20.2",
        cy: "10.33",
        rx: ".25",
        ry: ".24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.8",
        cy: "7.5",
        rx: ".25",
        ry: ".24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.51 21.15c-.62-.15-1.25-.13-1.82.11-1.88.78-2.53 3.55-1.44 6.18.95 2.3 2.91 3.74 4.65 3.54M41.07 30.98c1.74.24 3.73-1.21 4.7-3.54 1.09-2.63.47-5.39-1.39-6.16-.64-.27-1.35-.26-2.05-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.9 19.48c.19 1.26.29 2.56.29 3.9 0 10.68-6.42 17.2-14.25 17.2s-14.11-6.52-14.11-17.2c0-1.33.1-2.63.29-3.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.16 23.97c0 2.86 2.02 3.69 2.02 5.33s-1.9 1.71-1.9 1.71M14.98 30.95c-.73-2.33-1.13-4.89-1.13-7.58M42.21 23.38c0 2.67-.4 5.21-1.11 7.53M19.71 20.72c1.55-1.4 4.05-1.4 5.6 0M30.9 20.72c1.55-1.4 4.05-1.4 5.6 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.98 34.26c.96 1.54 3.82 1.86 4.96-.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.83 21.03c1.4-9.06 7.21-15.86 14.18-15.86s12.77 6.8 14.17 15.86M28.06 50.83c0-2.76-5.25-1.29-10.11-8.33-3.66-5.28-3.09-12.05-3.09-12.05s2.26 10.25 13.2 10.19M28.06 50.83c0-2.76 5.25-1.29 10.11-8.33 3.66-5.28 3.09-12.05 3.09-12.05S39 40.7 28.06 40.64"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldManBeard56 = (AvatarBaldManBeard56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldManGlasses104.tsx


var AvatarBaldManGlasses104_excluded = ["className"];
function AvatarBaldManGlasses104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldManGlasses104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldManGlasses104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldManGlasses104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldManGlasses104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldManGlasses104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldManGlasses104_objectSpread(AvatarBaldManGlasses104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.75 34.69c-.98-.18-1.97-.1-2.89.28-3.25 1.34-4.42 5.94-2.63 10.27 1.57 3.79 4.89 6.11 7.87 5.73M73.51 51c2.89.17 6.02-2.12 7.53-5.76 1.79-4.33.61-8.92-2.63-10.27-1.06-.44-2.21-.48-3.34-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.85",
        cy: "38.56",
        rx: "23.32",
        ry: "31.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.13 85.93-11.02-9.75c-2.34-2.07-3.46-2.91-5.16-5.77-1.65-2.23-1.61-5.07-1.61-5.07l-24.74.36s.18 2.17-2.01 5.14l.23-.43c-2.25 2.61-2.78 3.7-5.12 5.77L20.99 86.54s11.36 12.69 30.67 12.69 30.46-13.31 30.46-13.31Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.01 77.04s1.48.03.39 2.42c-1.87 4.1-13.05 9.11-19.52 5.22-4.38-2.64-.89-7.6-.89-7.6s4.36 4 9.19 3.77c6.27-.31 4.78-.57 10.83-3.8ZM54.42 51.63l2.09.13 2.06 1.01 1.29 1.2.4.49-.94.19-1.98-.37-1.66-1.02-1.26-1.63zM50.26 51.85l-.95.92-.99 1.08-1.38.58-1.76.22-.92-.4 1.54-1.42 1.75-.98 1.85-.22.86.22z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.38 76.61c-3.34 2.07-7.02 3.22-10.9 3.22s-7.5-1.13-10.81-3.16M64.08 65.39s-.04 2.84 1.61 5.07M39.33 65.75s.18 2.17-2.01 5.14M66.69 13.08c5.17-.48 9.81 6.77 10.51 13.86.7 7.14-2.26 7.05-2.26 7.05M27.52 34.63c-.98-.18-1.97-.1-2.89.28-3.25 1.34-4.42 5.94-2.63 10.27 1.57 3.79 4.89 6.11 7.87 5.73M73.29 50.94c2.89.17 6.02-2.12 7.53-5.76 1.79-4.33.61-8.92-2.63-10.27-1.06-.44-2.21-.48-3.34-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.62",
        cy: "38.5",
        rx: "23.32",
        ry: "31.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.68 40.62c0 4.78 3.12 5 3.12 7.74s-3.18 2.86-3.18 2.86M38.9 35.77c2.34-2.12 6.14-2.12 8.48 0M55.86 35.77c2.34-2.12 6.14-2.12 8.48 0M28.54 34s-3.19.09-2.48-7.05c.7-7.1 5.34-14.35 10.51-13.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.29 51.88s-.63-.93-2.81-.93c-3.33 0-5.86 3.82-7.57 3.82 0 0 4.85 1.55 7.1-.75 2.24-2.3 3.29-2.14 3.29-2.14Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.29 51.88s.63-.93 2.81-.93c3.33 0 5.86 3.82 7.57 3.82 0 0-4.85 1.55-7.1-.75s-3.29-2.14-3.29-2.14Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.78 58.36c2.04 1.16 4.2.11 5.14-.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.98",
        cy: "40.18",
        r: "1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.32",
        cy: "40.18",
        r: "1.94"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.03 71.53-2.46 3.19-3.46 3.15-.48.66 2.74 2.38 3.89 2.7.75.66s2.19.37 5.75 8.21L41.5 80.17l-3.06-6.31-1.39-2.34ZM66.04 71.53l2.46 3.24 3.46 3.2.48.67-2.74 2.42-3.89 2.74-.75.67s-3.37 1.36-5.56 7.69l2.07-11.86 3.06-6.41 1.39-2.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.55 70.46c-2.25 2.61-2.78 3.7-5.12 5.77L20.72 86.59M58.53 98.77c.4-20.93 7.15-28.31 7.15-28.31M73.59 79.11l-7.91 5.45 5.7 3.17-4.69 8.66M44.55 98.77c.67-17.21-6.99-28.31-6.99-28.31M65.68 70.46c1.7 2.86 2.82 3.7 5.16 5.77l11.02 9.75M29.8 78.93l7.75 5.35-5.53 3.27 5.16 9.19M35.97 41.95c1 2.66 3.69 4.57 6.86 4.57s5.86-1.91 6.86-4.57H35.97ZM54.27 41.95c1 2.66 3.69 4.57 6.86 4.57s5.86-1.91 6.86-4.57H54.27ZM27.51 34l8.46 7.95h32.02l7.75-7.87"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldManGlasses104 = (AvatarBaldManGlasses104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBaldManGlasses56.tsx


var AvatarBaldManGlasses56_excluded = ["className"];
function AvatarBaldManGlasses56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBaldManGlasses56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBaldManGlasses56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBaldManGlasses56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBaldManGlasses56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBaldManGlasses56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBaldManGlasses56_objectSpread(AvatarBaldManGlasses56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.69 26.1c-.72-.13-1.44-.08-2.11.2-2.37.98-3.23 4.34-1.92 7.51 1.15 2.77 3.58 4.47 5.75 4.19M44.15 38.03c2.11.12 4.4-1.55 5.51-4.21 1.31-3.16.45-6.52-1.92-7.51-.78-.32-1.62-.35-2.44-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.31",
        cy: "28.93",
        rx: "17.05",
        ry: "23.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39 10.55 2.67.46 1.94 1.94 1.4 2.25.94 2.49.66 3.27-.06 3.28-1.15 1.05-.22-.98-1.09-4.9-1.86-4.35-2.09-3.14L39 10.55zM16.92 10.31l.03.91-1.78 2.47-2.12 3.71-1.01 3.07-.7 2.73-.38 2.32-.65.02-.79-3.27.59-4.24 1.44-3.71 3.03-3.23 1.28-.75 1.06-.03zM29.06 38.34l2.12-.08 2.18.81 1.42 1.08.45.45-.92.28-2.04-.17-1.77-.85-1.44-1.52zM27.84 38.52l-.91.88-.94 1.03-1.33.56-1.68.21-.88-.38 1.47-1.36 1.68-.94 1.77-.21.82.21z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.17 10.36c3.78-.35 7.17 4.95 7.68 10.13.52 5.22-1.65 5.15-1.65 5.15M10.54 26.1c-.72-.13-1.44-.08-2.11.2-2.37.98-3.23 4.34-1.92 7.5 1.15 2.77 3.57 4.47 5.75 4.19M43.99 38.03c2.11.12 4.4-1.55 5.5-4.21 1.31-3.16.45-6.52-1.92-7.5-.78-.32-1.62-.35-2.44-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.16",
        cy: "28.93",
        rx: "17.04",
        ry: "23.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.2 30.48c0 3.49 2.28 3.65 2.28 5.66s-2.32 2.09-2.32 2.09M18.86 26.94c1.71-1.55 4.49-1.55 6.2 0M31.25 26.94c1.71-1.55 4.49-1.55 6.2 0M11.28 25.64s-2.33.07-1.81-5.15c.51-5.19 3.9-10.49 7.68-10.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.64 38.71s-.46-.68-2.05-.68c-2.44 0-4.28 2.79-5.54 2.79 0 0 3.54 1.13 5.19-.55 1.64-1.68 2.41-1.56 2.41-1.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.64 38.71s.46-.68 2.05-.68c2.44 0 4.28 2.79 5.54 2.79 0 0-3.54 1.13-5.19-.55-1.64-1.68-2.41-1.56-2.41-1.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.81 43.45c1.49.85 3.07.08 3.76-.57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.08",
        cy: "30.22",
        r: "1.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.4",
        cy: "30.22",
        r: "1.56"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.91 31.54c.72 1.98 2.67 3.39 4.96 3.39s4.24-1.42 4.96-3.39H16.9ZM30.15 31.54c.72 1.98 2.67 3.39 4.96 3.39s4.24-1.42 4.96-3.39h-9.93ZM10.78 25.64l6.13 5.9h23.17l5.61-5.84"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBaldManGlasses56 = (AvatarBaldManGlasses56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBeardMan104.tsx


var AvatarBeardMan104_excluded = ["className"];
function AvatarBeardMan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBeardMan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBeardMan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBeardMan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBeardMan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBeardMan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBeardMan104_objectSpread(AvatarBeardMan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.45 34.14c2.07.88 2.13 2.79 2.06 4.35-.12 2.75-2.07 4.83-4.14 4.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.2 42.72s2.18 6.92-.02 9.55c-.35.42 1.19 2.96-5.77 9.7 0 0-.39-.4-.53-1.14 0 0-3.71 6.45-11.27 6.45h-.14c-7.55 0-11.56-6.46-11.56-6.46-.14.74-.53 1.14-.53 1.14-6.97-6.73-5.42-9.28-5.77-9.7-2.21-2.63-.45-9.54-.45-9.54.85 6.49 5.19 6.75 6.91 6.89l.52 1.84h.02c6.58-5.71 10.8-4.98 10.8-4.98s4.25-.72 10.8 4.98h.02l.52-1.84s5.71.89 6.49-6.89Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.68 33.53c-1.43.62-2.51 2.23-2.3 4.97.22 2.74 2.07 4.83 4.14 4.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.22 71.93c3.15 1.61 12.94 7.56 16.16 9.66 2.06 1.34 3.18 3.07 4.33 4.83 0 0-8.38 12.41-33.5 12.41s-33.02-13.4-33.02-13.4c1.16-1.74 2.3-3.46 4.38-4.79 3.26-2.08 13.16-7.97 16.35-9.57 0 0 3.54-.91 3.03-8.28C41.44 55.42 60.3 61 60.3 61s-1.73 6.81.76 9.16c2.49 2.35 3.16 1.77 3.16 1.77ZM68.81 16.12s3.05 4.12 3.3 11.08c.08 2.41-.27 4.82-.88 7.15-1.25 4.77-1.96 5.11-1.96 5.11s-.47-11.45-3.67-17.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.73 9.28c0-2.75 2.07-4.97 4.62-4.97s4.62 2.23 4.62 4.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.61 15.6c-1.94-5.61-12.74-6.71-17.39-6.71S35.77 9.98 33.83 15.6c-2.38 6.88 16.98 10.83 17.39 10.92h.02c.41-.08 19.76-4.04 17.39-10.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.88 22.02c-3.2 5.98-3.67 17.43-3.67 17.43s-.71-.34-1.96-5.11c-.61-2.33-.96-4.74-.88-7.15.24-6.96 3.3-11.08 3.3-11.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.95",
        cy: "36.42",
        rx: "19.26",
        ry: "26.27",
        transform: "rotate(-2.06 51.088 36.527)"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M62.15 53.04h-.02c-6.49-5.46-10.67-4.79-10.72-4.77 0 0-.17-.03-.52-.03-1.3 0-5 .45-10.19 4.8h-.02l-.52-1.77c-.81-1.24-5.39.46-6.24-5.76 0 0-2.37 5.78-.17 8.3.34.4-1.19 2.84 5.73 9.3 0 0 .39-.38.52-1.09 0 0 3.99 6.19 11.48 6.2h.14c7.5 0 6.45-2.35 6.45-2.35s6.83-3.65 4.06-12.83Zm-4.63 6.11c-1.3.59-2.32.97-4-.56H49.5c-1.68 1.53-3.21.94-4 .56-2.04-.98-3.12-4.24-1.03-5.12 1.03-.49 7-2.98 7.04-3.01 0 0 1.5.63 3.13 1.32 1.64.69 3.39 1.44 3.91 1.69 1.5.54 1.02 4.17-1.03 5.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.77",
        cy: "38.36",
        r: "1.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "57.66",
        cy: "38.36",
        r: "1.63"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.9 71.87c-3.41-2.47-3.54-2.97-3.54-6.85M39.69 71.53c2.48-3.21 2.26-3.08 2.25-6.85"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.16 82.28c.88.71.33 1.69-.62 1.18-4.99-2.67-8.34 4.33-12.91-1.15-.8-1.8-1.57-5.13-1.44-5.75.23-1.1-3.09-3.09-.81-3.73 2.44-1.76 11.22 6.54 15.78 9.45Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.87 80.99c-.88.72-.32 1.69.62 1.17 4.97-2.71 8.37 4.27 12.9-1.25.79-1.81 1.53-5.15 1.4-5.76-.24-1.09 3.07-3.12.78-3.74-2.46-1.74-11.17 6.62-15.71 9.57Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.06 85.77c-1.14-1.76-2.27-3.49-4.33-4.83-3.23-2.1-13.01-8.04-16.16-9.66M39.66 70.32 34.7 87.75s5.72-2.33 8.68-2.82c3.14-.52 6.55.43 8.08 3.34l-11.8-17.94ZM64.48 71.26l3.74 17.73s-5.54-2.73-8.46-3.42c-3.09-.73-6.56-.03-8.3 2.76l13.02-17.08ZM18.55 84.78c1.16-1.74 2.3-3.46 4.38-4.79 3.26-2.08 13.16-7.97 16.35-9.57"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.36 4.57s3.09 1.22 3.09 4.45c0 2.3-6.84.82-6.84.82V6.82l3.76-2.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.83 9.93-5.7.77-6.41 2.43-2.9 3.43 1.81 4.73L45.52 26s5.53 3.91 14.85-1.81c6.13-3.76 2.8-8.31-.19-10.97-1.56-1.39-3.02-2.27-3.02-2.27l-8.34-1.01M32.63 36.69l.88-4.48 1.14-5.57 1.58-3.92-2.31-2.51-.9-.58-1.48 4.12-.71 4.41.13 4.16.62 2.29 1.05 2.08z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.45 35.09c2.07.88 2.13 2.79 2.06 4.35-.12 2.75-2.07 4.83-4.14 4.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.2 43.67s2.18 6.92-.02 9.55c-.35.42 1.19 2.96-5.77 9.7 0 0-.39-.4-.53-1.14 0 0-3.71 6.45-11.27 6.45h-.14c-7.55 0-11.56-6.46-11.56-6.46-.14.74-.53 1.14-.53 1.14-6.97-6.73-5.42-9.28-5.77-9.7-2.21-2.63-.45-9.54-.45-9.54.85 6.49 5.19 6.75 6.91 6.89l.52 1.84h.02c6.58-5.71 10.8-4.98 10.8-4.98s4.25-.72 10.8 4.98h.02l.52-1.84s5.71.89 6.49-6.89Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.54 59.28c-1.31.62-2.33 1.01-4.03-.58h-4.05c-1.69 1.59-3.23.98-4.03.58-2.06-1.02-3.14-4.41-1.04-5.34 1.04-.51 7.05-3.1 7.09-3.13s6.05 2.62 7.09 3.13c1.51.57 1.03 4.35-1.04 5.34Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.01 55.13c1.06.83 2.18.46 2.95-.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.68 34.48c-1.43.62-2.51 2.23-2.3 4.97.22 2.74 2.07 4.83 4.14 4.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.49 38.33c-.1 2.52 1.61 2.56 1.61 4.43 0 2.21-1.88 2.38-1.88 2.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.43 35.09c1.8-1.63 4.72-1.63 6.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.48 35.09c1.8-1.63 4.72-1.63 6.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.81 17.07s3.05 4.12 3.3 11.08c.08 2.41-.27 4.82-.88 7.15-1.25 4.77-1.96 5.11-1.96 5.11s-.47-11.45-3.67-17.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.6 9.03c0-2.75 2.07-4.97 4.62-4.97s4.62 2.23 4.62 4.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.61 16.55c-1.94-5.61-12.74-6.71-17.39-6.71s-15.45 1.09-17.39 6.71c-2.38 6.88 16.98 10.83 17.39 10.92h.02c.41-.08 19.76-4.04 17.39-10.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.88 22.97c-3.2 5.98-3.67 17.43-3.67 17.43s-.71-.34-1.96-5.11c-.61-2.33-.96-4.74-.88-7.15.24-6.96 3.3-11.08 3.3-11.08"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBeardMan104 = (AvatarBeardMan104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBeardMan56.tsx


var AvatarBeardMan56_excluded = ["className"];
function AvatarBeardMan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBeardMan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBeardMan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBeardMan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBeardMan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBeardMan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBeardMan56_objectSpread(AvatarBeardMan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.33 26.87c1.63.69 1.67 2.19 1.62 3.43-.09 2.16-1.63 3.8-3.26 3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.55 33.62s1.72 5.44-.02 7.52c-.27.33.94 2.33-4.54 7.63 0 0-.31-.32-.42-.9 0 0-2.92 5.08-8.87 5.08h-.11c-5.94 0-9.1-5.08-9.1-5.08-.11.58-.42.9-.42.9-5.49-5.3-4.27-7.3-4.54-7.63-1.74-2.07-.35-7.51-.35-7.51.67 5.11 4.08 5.32 5.44 5.42l.41 1.45h.01c5.18-4.5 8.5-3.92 8.5-3.92s3.35-.57 8.5 3.92h.01l.41-1.45s4.49.7 5.1-5.42Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.24 26.39c-1.13.49-1.98 1.75-1.81 3.91.17 2.16 1.63 3.8 3.26 3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.25 12.69s2.4 3.24 2.6 8.72c.07 1.9-.21 3.79-.69 5.63-.98 3.75-1.54 4.02-1.54 4.02s-.37-9.01-2.89-13.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.87 7.3c0-2.16 1.63-3.91 3.64-3.91s3.64 1.75 3.64 3.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.09 12.28C39.56 7.86 31.06 7 27.4 7s-12.16.86-13.69 5.28c-1.87 5.41 13.37 8.53 13.68 8.59h.01c.32-.06 15.55-3.18 13.68-8.59Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.12 17.34c-2.52 4.7-2.89 13.72-2.89 13.72s-.56-.27-1.54-4.02c-.48-1.84-.76-3.73-.69-5.63.19-5.48 2.6-8.72 2.6-8.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.19",
        cy: "28.67",
        rx: "15.16",
        ry: "20.67",
        transform: "rotate(-2.06 27.305 28.589)"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.11",
        cy: "28.84",
        r: "1.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.65",
        cy: "28.84",
        r: "1.33"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.43 40.67h-.01c-5.32-4.47-8.74-3.92-8.78-3.91 0 0-.14-.02-.42-.02-1.07 0-4.1.37-8.35 3.93h-.01l-.42-1.45c-.67-1.02-4.42.38-5.11-4.72 0 0-1.94 4.73-.14 6.8.28.33-.98 2.33 4.69 7.62 0 0 .32-.31.43-.89 0 0 3.27 5.07 9.4 5.08h.12c6.14 0 5.29-1.93 5.29-1.93s5.59-2.99 3.32-10.51Zm-3.78 5c-1.07.49-1.9.79-3.28-.46h-3.29c-1.38 1.25-2.63.77-3.28.46-1.67-.8-2.56-3.47-.84-4.2.84-.4 5.74-2.44 5.76-2.46 0 0 1.23.52 2.56 1.08 1.34.57 2.78 1.18 3.2 1.38 1.23.44.84 3.42-.84 4.2ZM26.86 2.74s2.59 1.02 2.59 3.73c0 1.93-5.73.69-5.73.69V4.63l3.15-1.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.1 7.39-4.83.62-5.43 1.95-2.46 2.75 1.54 3.8 8.39 3.78S28 23.43 35.9 18.84c5.2-3.02 2.38-6.67-.16-8.81a19.594 19.594 0 0 0-2.56-1.82l-7.07-.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.68 29.76.74-4.04.95-5.03 1.33-3.54-1.94-2.27-.75-.52-1.24 3.72-.6 3.98.11 3.75.52 2.07.88 1.88z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.48 46.08c-1.05.5-1.87.82-3.23-.47h-3.24c-1.36 1.29-2.59.79-3.23.47-1.65-.82-2.52-3.57-.83-4.32.83-.41 5.65-2.51 5.68-2.53s4.84 2.12 5.68 2.53c1.21.46.82 3.52-.83 4.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.46 42.72c.85.67 1.75.38 2.36-.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.62 26.52c1.66.71 1.7 2.25 1.65 3.52-.1 2.22-1.66 3.91-3.31 3.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.82 33.45s1.75 5.6-.02 7.73c-.28.34.95 2.4-4.62 7.84 0 0-.31-.32-.43-.92 0 0-2.97 5.22-9.02 5.22h-.11c-6.05 0-9.26-5.23-9.26-5.23-.11.6-.43.92-.43.92-5.58-5.45-4.34-7.5-4.62-7.84-1.77-2.13-.36-7.72-.36-7.72.68 5.25 4.16 5.46 5.53 5.57l.41 1.49h.01c5.27-4.62 8.65-4.02 8.65-4.02s3.4-.58 8.65 4.02h.01l.41-1.49s4.57.72 5.19-5.57Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.98 26.02c-1.15.5-2.01 1.8-1.84 4.02.17 2.22 1.66 3.91 3.31 3.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.64 29.14c-.08 2.04 1.29 2.07 1.29 3.59 0 1.78-1.5 1.92-1.5 1.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.58 26.52c1.44-1.32 3.78-1.32 5.22 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.03 26.52c1.44-1.32 3.78-1.32 5.22 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.38 13.09s2.43 3.28 2.62 8.81c.07 1.92-.21 3.83-.7 5.69-.99 3.79-1.56 4.06-1.56 4.06s-.38-9.11-2.92-13.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.71 7.12c0-2.18 1.64-3.95 3.67-3.95s3.67 1.77 3.67 3.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.21 12.68c-1.54-4.46-10.13-5.33-13.83-5.33s-12.29.87-13.83 5.33c-1.89 5.47 13.51 8.62 13.83 8.68h.01c.33-.07 15.72-3.21 13.83-8.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.98 17.79c-2.54 4.75-2.92 13.86-2.92 13.86s-.57-.27-1.56-4.06c-.49-1.85-.76-3.77-.7-5.69.19-5.53 2.62-8.81 2.62-8.81"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBeardMan56 = (AvatarBeardMan56);
;// ./src/Picto/GeneratedPictoComponents/AvatarBoy104.tsx


var AvatarBoy104_excluded = ["className"];
function AvatarBoy104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBoy104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBoy104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBoy104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBoy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBoy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBoy104_objectSpread(AvatarBoy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.97",
        cy: "41.79",
        rx: "22.88",
        ry: "31.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.02 38.1c-1.13-.31-2.28-.28-3.34.16-3.18 1.32-4.34 5.83-2.58 10.08 1.54 3.71 4.8 6 7.72 5.62M72.1 54c2.81.11 5.83-2.13 7.29-5.66 1.76-4.25.6-8.76-2.58-10.08-1.01-.42-2.09-.46-3.16-.2M32.33 24.42c-.59-2.69.13-5.53 1.37-7.98 2.73-5.36 8.05-9.25 13.91-10.4 5.86-1.15 12.15.39 16.98 3.94 2.26 1.66 4.19 3.73 5.98 5.89 1.4 1.7 2.74 3.49 4.42 4.91 2.58 2.17 5.83 3.36 9.07 4.24.33.82-.79 1.43-1.65 1.6l-5.3 1.08c1.17 1.92 5.34 3.35 6.65 4.31-11.2 1.53-23.7.31-34.82-1.69-3.94-.71-7.54-1.33-11.3-2.56-1.44-.47-4.44-1.97-5.2-3.3M68.08 80.29l-17.73 7.88-16.78-7.88c-6.33 3.94-10.59 9.19-10.59 9.19s16.58 9.77 28.22 9.77c15.75 0 28.7-10.17 28.7-10.17l-11.59-8.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.08 80.29c-4.42-2.7-5.24-2.72-5.24-11.66H38.79c0 9.1-1.95 9.74-6.52 12.5l19.23 9.56 16.58-10.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.87 88.58s-.49.53.73 1.17c1.7.9 7.62-5.24 12.77-3.01 6.03 2.6 13.8 4.98 14.16 2.7.39-2.54-17.98-8.74-17.98-8.74l-9.68 7.87Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m80.74 32.93.85-1.07c-6.15-4.11-7.1-3.18-11.71-11.24-2.86-4.99-9.61-10.4-16.56-11.13-9.34-.98-22.16 5.78-20.63 14.82.15.89.75 1.45 1.46 1.66.87.26 1.66.7 2.39 1.24.16.12.34.24.53.35 2.59 1.54 6.26 1.95 9.17 2.53 3.41.68 6.86 1.18 10.32 1.56 8.03.89 16.12 1.08 24.19 1.27",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.15 33.2c.6 2.79.92 5.75.92 8.81 0 17.23-10.24 31.2-22.88 31.2s-22.88-13.97-22.88-31.2c0-6.46 1.44-12.47 3.91-17.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.24 38.33c-1.13-.31-2.28-.28-3.34.16-3.18 1.32-4.34 5.83-2.58 10.08 1.54 3.71 4.8 6 7.72 5.62M72.33 54.22c2.81.11 5.83-2.13 7.29-5.66 1.76-4.25.6-8.76-2.58-10.08-1.01-.42-1.72-.54-2.79-.28M32.5 81.35c4.57-2.76 6.52-3.4 6.52-12.5M63.07 68.85c0 8.94.81 8.95 5.24 11.66M32.55 24.64c-.59-2.69.13-5.53 1.37-7.98 2.73-5.36 8.05-9.25 13.91-10.4 5.86-1.15 12.15.39 16.98 3.94 2.26 1.66 4.19 3.73 5.98 5.89 1.4 1.7 2.74 3.49 4.42 4.91 2.58 2.17 5.83 3.36 9.07 4.24.33.82-.79 1.43-1.65 1.6l-5.3 1.08c1.17 1.92 5.34 3.35 6.65 4.31-11.2 1.53-23.7.31-34.82-1.69-3.94-.71-7.54-1.33-11.3-2.56-1.44-.47-4.44-1.97-5.2-3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.25 44.24c0 4.54 2.97 4.76 2.97 7.37s-3.03 2.73-3.03 2.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.08 39.63c2.23-2.02 5.84-2.02 8.07 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.23 39.63c2.23-2.02 5.84-2.02 8.07 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.18 61.81c2.4 1.36 4.95.12 6.05-.91"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.56 89.08s3.9-4.63 10.23-8.57l16.78 7.88 17.73-7.88s4.62 2.13 11.59 8.57",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.97",
        cy: "44.21",
        r: "2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.19",
        cy: "44.21",
        r: "2.05"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBoy104 = (AvatarBoy104);
;// ./src/Picto/GeneratedPictoComponents/AvatarBoy56.tsx


var AvatarBoy56_excluded = ["className"];
function AvatarBoy56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarBoy56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarBoy56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarBoy56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarBoy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarBoy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarBoy56_objectSpread(AvatarBoy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "28",
      r: "28",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.39",
        cy: "30.29",
        rx: "16.67",
        ry: "22.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.67 27.61c-.82-.23-1.66-.21-2.43.11-2.32.96-3.16 4.25-1.88 7.34 1.12 2.71 3.5 4.37 5.63 4.1M42.78 39.19c2.04.08 4.24-1.55 5.31-4.12 1.28-3.09.44-6.38-1.88-7.34-.73-.3-1.52-.34-2.31-.15M15.57 15.38c-.38-1.76.08-3.61.9-5.21 1.78-3.5 5.26-6.04 9.08-6.79 3.83-.75 7.93.25 11.08 2.57 1.47 1.08 2.74 2.43 3.9 3.85.92 1.11 1.79 2.28 2.89 3.21 1.68 1.42 3.81 2.19 5.92 2.77.21.54-.52.93-1.08 1.05-1.15.23-2.31.47-3.46.7.76 1.26 3.49 2.19 4.34 2.82-7.31 1-15.47.2-22.73-1.1-2.57-.46-4.92-.87-7.38-1.67-.94-.31-2.9-1.28-3.39-2.15"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m47.35 20.79.56-.68c-4.06-2.61-4.68-2.02-7.73-7.13-1.89-3.16-6.34-6.6-10.93-7.06-6.16-.62-14.63 3.67-13.62 9.4.1.57.5.92.97 1.06.58.16 1.1.45 1.58.79.11.08.22.15.35.22 1.71.98 4.13 1.24 6.05 1.61 2.25.43 4.53.75 6.81.99 5.3.57 10.64.68 15.96.8",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.66 20.83c.96 2.86 1.49 6.04 1.49 9.4 0 12.5-7.43 22.64-16.6 22.64s-16.6-10.14-16.6-22.64c0-5.95 1.68-11.36 4.43-15.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.9 27.55c-.82-.23-1.65-.2-2.42.11-2.31.96-3.15 4.23-1.87 7.31 1.12 2.7 3.48 4.35 5.6 4.08M42.89 39.08c2.04.08 4.23-1.54 5.29-4.11 1.28-3.08.44-6.35-1.87-7.31-.73-.3-1.12-.27-1.9-.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.59 31.85c0 3.3 2.15 3.45 2.15 5.35s-2.2 1.98-2.2 1.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.77 28.5c1.62-1.46 4.24-1.46 5.86 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.48 28.5c1.62-1.46 4.24-1.46 5.86 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.09 44.59c1.74.99 3.59.09 4.39-.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.57 15.38c-.38-1.76.08-3.61.9-5.21 1.78-3.5 5.26-6.04 9.08-6.79 3.83-.75 7.93.25 11.08 2.57 1.47 1.08 2.74 2.43 3.9 3.85.92 1.11 1.79 2.28 2.89 3.21 1.68 1.42 3.81 2.19 5.92 2.77.21.54-.52.93-1.08 1.05-1.15.23-2.31.47-3.46.7.76 1.26 3.49 2.19 4.34 2.82-7.31 1-15.47.2-22.73-1.1-2.57-.46-4.92-.87-7.38-1.67-.94-.31-2.9-1.28-3.39-2.15"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.67",
        cy: "31.38",
        rx: "1.49",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.44",
        cy: "31.38",
        rx: "1.49",
        ry: "1.45"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarBoy56 = (AvatarBoy56);
;// ./src/Picto/GeneratedPictoComponents/AvatarCat104.tsx


var AvatarCat104_excluded = ["className"];
function AvatarCat104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarCat104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarCat104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarCat104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarCat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarCat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarCat104_objectSpread(AvatarCat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.4 89.96c-1.57-6.33-.89-15.94-9.9-21.81h-.01c-1.9-1.23-.97-4.01-1.9-5.81-.83-1.63-.09-3.65 1.6-4.36 9.09-3.86 15.2-11.09 15.2-19.38 0-3.3-.97-6.42-2.72-9.24.39-3.24 1.43-13.96-1.22-17.18-2.49-3.04-8.9 3.96-11.44 6.98-4.43-1.86-9.56-2.92-15.02-2.92S41.4 17.3 36.97 19.16c-2.54-3.01-8.95-10.01-11.44-6.98-2.65 3.23-1.61 13.95-1.22 17.18-1.74 2.82-2.72 5.95-2.72 9.24 0 8.28 6.12 15.51 15.2 19.38 1.69.71 2.42 2.73 1.6 4.36-.53 2.54 0 4.58-1.9 5.81-9.01 5.87-8.33 15.47-9.9 21.81 0 0 9.39 9.29 24.99 9.29s25.84-9.29 25.84-9.29Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.45 82.39c1.06.85 6.29 3.16 9.99-1.59.01-.01-.01.01 0 0 4.37-4.22 9.45-6.57 18.44-6.49 2.02.02 3.83-.35 5.43-.92 3.27-1.17 1.88-5.38-1.58-4.8-.45.08-.92.06-1.35-.05l-.57.51c-.33-.08-.64.27-.91.1l-3.78.23c-.74-.47-4.57-.42-5.47-.16l-2.67-.31c-.34.1-2.64-.72-2.93-.52l-4.53-1.46c-.42.29-2.65 2.84-2.84 3.27l-2.78 1.67c-.19.4-2.23 2.83-2.17 3.25l-1.3 3.24c.08.58-.51 1.22-.02 1.61l-.95 2.43Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.68 16.21h4.62c.15 0 .25.14.22.27L52.21 26.7c-.06.24-.39.24-.44 0l-2.31-10.22c-.03-.14.08-.27.22-.27h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m57.3 16.56 4.31.75c.27.05.42.33.32.58l-3.58 8.62c-.17.42-.8.31-.82-.14l-.49-9.58c0-.15.12-.26.26-.23ZM46.68 16.56l-4.36.76c-.24.04-.38.3-.29.52l3.68 8.86c.16.37.71.28.73-.13l.5-9.78c0-.15-.12-.26-.26-.23Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.72 26.33a.59.59 0 0 1-.94-.36c-.36-2.08-1.06-7.01.11-8.29.66-.7 4.47 2.66 5.87 3.94.27.25.25.67-.05.89l-5 3.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.26 26.06c.35.27.86.07.94-.36.36-2.08 1.06-7.01-.11-8.29-.66-.7-4.47 2.66-5.87 3.94-.27.25-.25.67.05.89l5 3.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.15 41.35c0 .98-1.57 3.8-4.11 3.88-2.54-.08-4.11-2.9-4.11-3.88-.04-1.02 1.84-2.07 4.11-2.18 2.28.11 4.15 1.16 4.11 2.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.3 38.27s-7.86-4.26-15.47 0M27.3 42.86s-5.71-2.71-10.08 2.85"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.7 38.27s7.86-4.26 15.47 0M76.7 42.86s5.71-2.71 10.08 2.85"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.41 90.02c-1.57-6.33-.89-15.94-9.9-21.81h-.01c-1.9-1.23-.97-4.01-1.9-5.81-.83-1.63-.09-3.65 1.6-4.36 9.09-3.86 15.2-11.09 15.2-19.38 0-3.3-.97-6.42-2.72-9.24.39-3.24 1.43-13.96-1.22-17.18-2.49-3.04-8.9 3.96-11.44 6.98-4.43-1.86-9.56-2.92-15.02-2.92s-10.59 1.06-15.02 2.92c-2.54-3.01-8.95-10.01-11.44-6.98-2.65 3.23-1.61 13.95-1.22 17.18-1.74 2.82-2.72 5.95-2.72 9.24 0 8.28 6.12 15.51 15.2 19.38 1.69.71 2.42 2.73 1.6 4.36-.53 2.54 0 4.58-1.9 5.81-9.01 5.87-8.33 15.47-9.9 21.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 45.97v3.33c0 3.05-5.26 3.97-7.69 1.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 45.97v3.33c0 3.05 5.26 3.97 7.69 1.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.1 41.18c0 .98-1.57 3.8-4.11 3.88-2.54-.08-4.11-2.9-4.11-3.88-.04-1.02 1.84-2.07 4.11-2.18 2.28.11 4.15 1.16 4.11 2.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "64.89",
        cy: "34.28",
        r: "2.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.09",
        cy: "34.28",
        r: "2.38"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.14 69.39c-5.12 0-10.04-.83-14.63-2.48l1.07-5.53c3.89 1.39 9.18 1.6 13.55 1.6s9.56-.71 13.45-2.1l1.16 6.04c-4.58 1.64-9.5 2.48-14.63 2.48h.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.04 69.34c-5.12 0-10.04-.83-14.63-2.48l1.07-5.53c3.89 1.39 9.18 1.6 13.55 1.6s9.56-.71 13.45-2.1l1.16 6.04c-4.58 1.64-9.5 2.48-14.63 2.48h.02Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarCat104 = (AvatarCat104);
;// ./src/Picto/GeneratedPictoComponents/AvatarCat56.tsx


var AvatarCat56_excluded = ["className"];
function AvatarCat56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarCat56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarCat56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarCat56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarCat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarCat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarCat56_objectSpread(AvatarCat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.7 43.2s-.06-2.32 1.02-2.77c5.78-2.46 9.67-7.05 9.67-12.33 0-2.1-.62-4.08-1.73-5.88.24-2.06.91-8.88-.78-10.93-1.58-1.93-5.66 2.52-7.28 4.44-2.82-1.18-6.08-1.86-9.55-1.86s-6.74.68-9.55 1.86c-1.61-1.92-5.69-6.37-7.28-4.44-1.69 2.05-1.02 8.87-.78 10.93C9.33 24.01 8.71 26 8.71 28.1c0 5.27 3.89 9.86 9.67 12.33 1.07.45 1.21 1.56 1.02 2.77h17.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.54 43.11h16.84s-1.77 2-8.33 2-8.51-2-8.51-2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.62 14.05h2.87c.09 0 .15.08.13.17l-1.43 6.34c-.04.15-.24.15-.27 0l-1.43-6.34c-.02-.08.05-.17.13-.17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.34 14.27 2.67.47c.17.03.26.2.2.36l-2.22 5.35c-.11.26-.49.19-.51-.09l-.3-5.94c0-.09.08-.16.16-.14ZM24.75 14.27l-2.71.47c-.15.03-.24.18-.18.32l2.28 5.49c.1.23.44.17.45-.08l.31-6.07c0-.09-.08-.16-.16-.14Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.62 20.32c-.22.17-.53.04-.58-.22-.22-1.29-.66-4.35.07-5.14.41-.44 2.78 1.65 3.64 2.45.17.15.15.41-.03.56l-3.1 2.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.48 20.16c.22.17.53.04.58-.22.22-1.29.66-4.35-.07-5.14-.41-.44-2.78 1.65-3.64 2.45-.17.15-.15.41.03.56l3.1 2.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.63 29.64c0 .61-.98 2.35-2.55 2.41-1.58-.05-2.55-1.8-2.55-2.41-.02-.63 1.14-1.28 2.55-1.35 1.42.07 2.57.72 2.55 1.35Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.36 27.97s-5-2.71-9.84 0M12.36 30.88s-3.63-1.72-6.41 1.82M43.77 27.97s5-2.71 9.84 0M43.77 30.88s3.63-1.72 6.41 1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.71 43.31c-.36-1.12-.06-2.32 1.02-2.77 5.78-2.46 9.67-7.05 9.67-12.33 0-2.1-.62-4.08-1.73-5.88.24-2.06.91-8.88-.78-10.93-1.58-1.93-5.66 2.52-7.28 4.44-2.82-1.18-6.08-1.86-9.55-1.86s-6.74.68-9.55 1.86c-1.61-1.92-5.69-6.37-7.28-4.44-1.69 2.05-1.02 8.87-.78 10.93-1.11 1.79-1.73 3.78-1.73 5.88 0 5.27 3.89 9.86 9.67 12.33 1.07.45 1.21 1.56 1.02 2.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.05 32.86v2.12c0 1.94-3.35 2.53-4.89.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.05 32.86v2.12c0 1.94 3.35 2.53 4.89.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.67 29.81c0 .62-1 2.41-2.62 2.47-1.62-.05-2.62-1.84-2.62-2.47-.02-.65 1.17-1.32 2.62-1.38 1.45.07 2.64.74 2.62 1.38Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.72",
        cy: "25.64",
        r: "1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.43",
        cy: "25.64",
        r: "1.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.91 48.37c-3.33 0-6.52-.54-9.5-1.61l.69-3.59c2.52.9 5.96 1.04 8.8 1.04s6.21-.46 8.73-1.37l.76 3.92c-2.97 1.07-6.17 1.61-9.5 1.61h.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.06 48.49c-3.28 0-6.42-.53-9.35-1.58l.68-3.54c2.49.89 5.87 1.02 8.67 1.02s6.12-.46 8.6-1.35l.74 3.86c-2.93 1.05-6.08 1.58-9.35 1.58h.01Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarCat56 = (AvatarCat56);
;// ./src/Picto/GeneratedPictoComponents/AvatarChild104.tsx


var AvatarChild104_excluded = ["className"];
function AvatarChild104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarChild104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarChild104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarChild104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarChild104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarChild104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarChild104_objectSpread(AvatarChild104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.21 33.34c.32 1.97.49 4.01.49 6.1 0 16.04-9.91 29.04-22.12 29.04s-22.12-13-22.12-29.04c0-2.11.17-4.17.5-6.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.68 6.95C25.72 8.3 25.72 33.21 25.72 33.21c2.91 1.02 29.45-3.12 30.43-16.81 0 0 .99 17.18 20.11 16.81.38 0 1.1.67 1.11.51 1.84-15.58-7.83-25.88-19.88-25.1-1.68-.32-3.47-2.14-10.81-1.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.31 88.15c-.49-.56-1.01-1.09-1.55-1.58-3.77-3.3-8.48-6.19-12.56-8.96-2.75-1.85-3.61-3.25-3.61-10.48l-15.74-.14c0 7.23-.4 8.33-3.93 10.67-4 2.75-8.88 5.62-12.58 8.9-.53.49-1.04 1.01-1.52 1.57 0 0 8.9 11.09 25.74 11.09S77.3 88.13 77.3 88.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.95 33.29 55.6 12.56l17.61 20.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.53 64.45c-3.16 0-3.49 2.99-3.32 4.44.12.97.17 2.18.17 3.62 2.71-.43 4.46-1.32 5.27-2.67 1.44-2.42 0-5.39-2.13-5.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.59 64.45c3.16 0 3.49 2.99 3.32 4.44-.12.97-.17 2.18-.17 3.62-2.71-.43-4.46-1.32-5.27-2.67-1.44-2.42 0-5.39 2.13-5.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.58 32.7c-2.04.19-3.37 1.38-4.02 3.58-.64 2.2-.45 4.46.57 6.79l-.79 2.69c-.82 2.05-.26 4.02 1.67 5.9-.47 3.07-.47 6.69.84 7.87.87.78 2.24 1.18 4.12 1.19.91-.5 1.56-.99 1.96-1.45s.86-1.28 1.39-2.47l-3.06-7.11-1.4-14.96v-1.67l-1.28-.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.54 32.7c2.04.19 3.37 1.38 4.02 3.58.64 2.2.45 4.46-.57 6.79l.79 2.69c.82 2.05.26 4.02-1.67 5.9.47 3.07.47 6.69-.84 7.87-.87.78-2.24 1.18-4.12 1.19-1.11-.05-1.9-.35-2.36-.89-.46-.54-.21-1.35-.41-2.83l3.67-8.07 1.05-12.97-.84-2.9 1.28-.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.21 30.4c-.62 2.8 2.6 1.86 4.43 1.77 2.42-.25 4.68-.89 7.12-1.44 3.94-.89 8.01-1.98 11.42-4.11 2.17-1.36 4.12-2.3 5.66-4.35.31-.41 1.39-3.81 1.89-4.94.18.88.43 3.68.54 4.05.55 1.78 2.05 3.16 3.18 4.68 2.49 3.34 5.37 4.74 9.27 5.53.73.15 4.65.74 4.65.7-.55-13.74-12-24.94-24.56-25.39-17.56-.39-20.9 11.33-23.59 23.51Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.55 46.88a.76.76 0 1 1-1.52 0 .76.76 0 0 1 1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.03 47.45a.76.76 0 1 1-1.52 0 .76.76 0 0 1 1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.77 50.45a.76.76 0 1 1-1.52 0 .76.76 0 0 1 1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.12 48.93a.76.76 0 1 1-1.52 0 .76.76 0 0 1 1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.41 46.88a.76.76 0 1 0 1.52 0 .76.76 0 0 0-1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.94 47.45a.76.76 0 1 0 1.52 0 .76.76 0 0 0-1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.2 50.45a.76.76 0 1 0 1.52 0 .76.76 0 0 0-1.52 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.85 48.93a.76.76 0 1 0 1.52 0 .76.76 0 0 0-1.52 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.53 64.45c-3.16 0-3.49 2.99-3.32 4.44.12.97.17 2.18.17 3.62 2.71-.43 4.46-1.32 5.27-2.67 1.44-2.42 0-5.39-2.13-5.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.34 32.68c-1.02.92-1.74 2.39-2.14 4.42-.41 2.03.31 3.98 2.14 5.85-1.72 1.13-2.59 2.65-2.63 4.56-.04 1.91 1.01 3.58 3.14 5-2.34 3.38-1.89 6.21 1.33 8.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.24 56.8c-.09 1.56-1.01 2.96-2.76 4.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.59 64.45c3.16 0 3.49 2.99 3.32 4.44-.12.97-.17 2.18-.17 3.62-2.71-.43-4.46-1.32-5.27-2.67-1.44-2.42 0-5.39 2.13-5.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.01 32.97c.87.73 1.51 2.11 1.92 4.13.41 2.03-.31 3.98-2.14 5.85 1.72 1.13 2.59 2.65 2.63 4.56.04 1.91-1.01 3.58-3.14 5 2.34 3.38 1.89 6.21-1.33 8.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.83 57.93c.3 1.24 1.16 2.36 2.57 3.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.62 32.96c.32 1.97.49 4.01.49 6.1 0 16.04-9.91 29.04-22.12 29.04s-22.12-13-22.12-29.04c0-2.11.17-4.17.5-6.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.04 42.03c0 4.51 2.96 4.72 2.96 7.3s-3.02 2.7-3.02 2.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.92 37.46c2.22-2 5.82-2 8.04 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.01 37.46c2.22-2 5.82-2 8.04 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.09 6.57C26.13 7.92 26.13 32.83 26.13 32.83c2.91 1.02 29.45-3.12 30.43-16.81 0 0 .99 17.18 20.11 16.81.38 0 1.1.67 1.11.51 1.84-15.58-7.83-25.88-19.88-25.1-1.68-.32-3.47-2.14-10.81-1.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.66 59.24c2.38 1.35 4.92.12 6.01-.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.34 77.3c3.52-2.34 3.93-3.44 3.93-10.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.61 77.24C60.86 75.39 60 73.99 60 66.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.84 41.99a2.05 2.05 0 0 1-4.1 0c0-1.13.92-2.04 2.05-2.04s2.05.91 2.05 2.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62 41.99a2.05 2.05 0 0 1-4.1 0c0-1.13.92-2.04 2.05-2.04s2.05.91 2.05 2.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.42 60.7a.594.594 0 0 0-.26-.07l-5-.31c-.09 0-.18 0-.27.04-1.24.43-1.43 1.32-1.43 1.81 0 .84.47 1.48 1.32 1.78.06.02.12.03.19.04l4.89.31h.04c.04 0 .08 0 .12-.01.91-.16 1.46-.72 1.57-1.58.06-.49 0-1.41-1.17-2ZM76.24 60.36a.766.766 0 0 0-.27-.04l-5 .31c-.09 0-.18.03-.26.07-1.17.59-1.24 1.51-1.17 2 .11.87.67 1.43 1.57 1.58.04 0 .08.01.12.01h.04l4.89-.31c.06 0 .13-.02.19-.04.85-.31 1.32-.94 1.32-1.78 0-.49-.19-1.38-1.43-1.81Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.94 81.22s2.27-1.03 1.15 1.28c-1.93 3.96-10.83 7.01-18.2 3.89-11.39-4.81-1.24-8.61-1.24-8.61s8.05 4.39 12.41 4.63c0 0-.94 1.21 5.89-1.19Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.61 77.24C67.69 80 72.4 82.9 76.17 86.2c.54.49 1.06 1.02 1.55 1.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.24 87.77c.48-.56.99-1.08 1.52-1.57 3.7-3.28 8.58-6.15 12.58-8.9 0 0 4.19 5.11 11.71 5.11 4.85-.02 7.78-1.78 11.56-5.17"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarChild104 = (AvatarChild104);
;// ./src/Picto/GeneratedPictoComponents/AvatarChild56.tsx


var AvatarChild56_excluded = ["className"];
function AvatarChild56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarChild56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarChild56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarChild56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarChild56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarChild56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarChild56_objectSpread(AvatarChild56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.54 21.18c.22 1.32.33 2.69.33 4.1 0 10.77-6.65 19.49-14.85 19.49s-14.85-8.73-14.85-19.49c0-1.42.12-2.8.33-4.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.74 3.47C10.67 4.38 10.67 21.1 10.67 21.1c1.95.69 19.77-2.09 20.42-11.28 0 0 .66 11.53 13.5 11.28.26 0 .74.45.75.34C46.57 10.98 40.08 4.07 32 4.59c-1.13-.21-2.33-1.44-7.26-1.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.51 21.15 30.95 7.22l11.13 14.23-28.57-.3z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.29 41.99c-2.12 0-2.34 2.01-2.23 2.98.08.65.12 1.46.12 2.43 1.82-.29 3-.89 3.54-1.79.97-1.62 0-3.62-1.43-3.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.87 41.99c2.12 0 2.34 2.01 2.23 2.98-.08.65-.12 1.46-.12 2.43-1.82-.29-3-.89-3.54-1.79-.97-1.62 0-3.62 1.43-3.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.65 20.68c-1.37.13-2.26.93-2.7 2.4-.43 1.48-.3 3 .38 4.56l-.53 1.8c-.55 1.38-.18 2.7 1.12 3.96-.32 2.06-.32 4.49.56 5.28.58.53 1.51.79 2.77.8.61-.34 1.05-.66 1.31-.97s.58-.86.94-1.66l-2.06-4.78-.94-10.04v-1.12l-.86-.24Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.51 20.68c1.37.13 2.26.93 2.7 2.4.43 1.48.3 3-.38 4.56l.53 1.8c.55 1.38.18 2.7-1.12 3.96.32 2.06.32 4.49-.56 5.28-.58.53-1.51.79-2.77.8-.74-.03-1.27-.23-1.58-.6-.31-.36-.14-.91-.28-1.9l2.46-5.42.71-8.71-.57-1.94.86-.24Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.06 19.55c-.42 1.93 1.75 1.28 2.97 1.22 1.62-.17 3.14-.61 4.78-.99 2.65-.61 5.38-1.37 7.66-2.83 1.46-.94 2.34-1.67 3.37-3.09.21-.28 1.36-2.53 1.7-3.31.12.61.29 2.53.36 2.79.37 1.23 1.38 2.18 2.13 3.22 1.67 2.3 3.6 3.27 6.22 3.81.49.1 3.12.51 3.12.48C43 11.39 35.32 3.67 26.89 3.36c-11.79-.27-14.03 7.8-15.84 16.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.36 30.2c0 .28-.23.51-.51.51s-.51-.23-.51-.51.23-.51.51-.51.51.23.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.37 30.58c0 .28-.23.51-.51.51s-.51-.23-.51-.51.23-.51.51-.51.51.23.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.18 32.59c0 .28-.23.51-.51.51s-.51-.23-.51-.51.23-.51.51-.51.51.23.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.06 31.57c0 .28-.23.51-.51.51s-.51-.23-.51-.51.23-.51.51-.51.51.23.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.36 30.2c0 .28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51-.51.23-.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.36 30.58c0 .28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51-.51.23-.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.55 32.59c0 .28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51-.51.23-.51.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.67 31.57c0 .28.23.51.51.51s.51-.23.51-.51-.23-.51-.51-.51-.51.23-.51.51"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.21 42.25c-2.12 0-2.34 2.01-2.23 2.98.08.65.12 1.46.12 2.43 1.82-.29 3-.89 3.54-1.79.97-1.62 0-3.62-1.43-3.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.07 20.93c-.69.62-1.16 1.61-1.44 2.97-.27 1.36.21 2.67 1.44 3.92-1.15.76-1.74 1.78-1.76 3.06-.02 1.28.68 2.4 2.11 3.36-1.57 2.27-1.27 4.17.9 5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.38 37.11c-.06 1.05-.68 1.99-1.85 2.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.79 42.25c2.12 0 2.34 2.01 2.23 2.98-.08.65-.12 1.46-.12 2.43-1.82-.29-3-.89-3.54-1.79-.97-1.62 0-3.62 1.43-3.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.08 21.12c.59.49 1.02 1.41 1.29 2.78.27 1.36-.21 2.67-1.44 3.92 1.15.76 1.74 1.78 1.76 3.06.02 1.28-.68 2.4-2.11 3.36 1.57 2.27 1.27 4.17-.9 5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.59 37.87c.2.84.78 1.59 1.73 2.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.8 21.11c.22 1.32.33 2.69.33 4.1 0 10.77-6.65 19.49-14.85 19.49s-14.85-8.73-14.85-19.49c0-1.42.12-2.8.33-4.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.32 27.2c0 3.02 1.99 3.17 1.99 4.9s-2.02 1.81-2.02 1.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.18 24.13c1.49-1.34 3.91-1.34 5.4 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.98 24.13c1.49-1.34 3.91-1.34 5.4 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25 3.4c-14.07.91-14.07 17.63-14.07 17.63 1.95.69 19.77-2.09 20.42-11.28 0 0 .66 11.53 13.5 11.28.26 0 .43.23.44.12C46.52 10.69 40.34 4 32.25 4.52c-1.13-.21-2.33-1.44-7.26-1.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.72 38.75c1.6.91 3.3.08 4.04-.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.23 27.57c0 .75-.62 1.37-1.37 1.37s-1.37-.61-1.37-1.37.62-1.37 1.37-1.37 1.37.61 1.37 1.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.08 27.57c0 .75-.62 1.37-1.37 1.37s-1.37-.61-1.37-1.37.62-1.37 1.37-1.37 1.37.61 1.37 1.37"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.17 39.75c-.06-.03-.12-.04-.18-.05l-3.36-.21c-.06 0-.12 0-.18.02-.83.29-.96.89-.96 1.22 0 .57.31.99.88 1.2.04.01.08.02.13.03l3.29.21h.11c.61-.11.98-.48 1.06-1.06.04-.33 0-.95-.79-1.34ZM44.58 39.51a.372.372 0 0 0-.18-.02l-3.35.21c-.06 0-.12.02-.18.05-.79.4-.83 1.01-.79 1.34.07.58.45.96 1.06 1.06h.11l3.28-.21s.09-.01.13-.03c.57-.2.88-.63.88-1.2 0-.33-.12-.93-.96-1.22Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarChild56 = (AvatarChild56);
;// ./src/Picto/GeneratedPictoComponents/AvatarDoctorFemale104.tsx


var AvatarDoctorFemale104_excluded = ["className"];
function AvatarDoctorFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarDoctorFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarDoctorFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarDoctorFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarDoctorFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarDoctorFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarDoctorFemale104_objectSpread(AvatarDoctorFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.08 36.36c-.87-.23-1.76-.2-2.58.14-2.51 1.04-3.42 4.59-2.03 7.93 1.21 2.93 3.78 4.72 6.08 4.43M69.92 48.89c2.19.05 4.53-1.71 5.67-4.46 1.38-3.34.47-6.9-2.03-7.93a3.98 3.98 0 0 0-2.46-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.74 33.59c.32 1.82.48 3.72.48 5.68 0 9.92-4.31 18.46-10.51 22.34-2.29 1.43-4.83 2.23-7.51 2.23-9.95 0-18.02-11-18.02-24.57 0-2.01.18-3.97.51-5.85L47.47 18l15.74.64 7.52 14.95Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.41 12.49c-20.03 0-21 20.54-21 20.54 10.65 0 24.57-4.65 24.57-12.64 0 0-.27 12.64 16.38 12.64 0 0-.55-20.54-19.95-20.54ZM83.67 87.47c-1.09-3.77-3.89-7.16-7.53-10.07-3.21-2.57-6.7-4.58-9.83-6.55-.97-.61-1.73-1.02-2.35-1.35l-21.61.23c-3.13 1.97-8.87 5.11-12.08 7.68-3.6 2.88-7.58 6.33-8.68 10.07 0 0 12.86 11.77 31.62 11.77s30.46-11.77 30.46-11.77ZM71.22 62.13l-1.79-3.73-.86-4.69-1.71 1.86-1.92 2.35 1.02 5.02 5.26-.81z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "63.36",
      cy: "88.27",
      r: "2.46",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.61 71.43s1.51.15.24 2.17c-2.18 3.46-13.89 6.93-20.23 2.93-4.29-2.71-.4-6.8-.4-6.8s4.17 3.92 9.11 4.13c6.41.27 4.9-.09 11.28-2.42ZM43.41 59.67c-1.37-1.05-2.42-2.38-3.21-3.91-.21-.4-1.63-2.18-1.72-2.75-.26-1.68-1.92-3.57-1.66-1.89.37 2.34-.72 7.57-2.11 9.45-.47.63-1.34 1.84-.53 1.95 2.58.36 5.16 1.16 10.14-.69 1.17-.44-.04-1.51-.89-2.16ZM66.58 54.65c0-1.07-4.25 6.27-5.15 6.86-.79.52.56 1.02 1.29 1.59.9.71 4.92.7 5.85.42 0 0-1.99-4.54-1.99-8.87ZM48.49 11.73c-4.61.15-7.79 2.43-10.92 5.84-3.55 3.87-4.94 9.03-6.04 14.04-.41 1.86 1.14 1.24 2.87.85.05 0 .1.01.15 0 5.27-.54 10.82-1.1 15.45-3.91 1.79-1.09 3.41-2.47 4.68-4.13.65-.85 1.19-1.74 1.62-2.72.12-.07.25-.13.37-.19.22.99.68 2 .81 2.45.45 1.48 1.65 3.19 2.83 4.2 2.05 1.76 2.63 2.96 5.75 3.58.88.18 2.28 1.36 2.2.33-.8-10.19-9.06-20.67-19.78-20.33Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.43 87.2c1.1-3.74 5.08-7.19 8.68-10.07 3.21-2.57 8.95-5.7 12.08-7.68M63.81 69.22c.61.33 1.38.75 2.35 1.35 3.13 1.97 6.62 3.98 9.83 6.55 3.64 2.91 6.43 6.3 7.53 10.07"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.36",
        cy: "88.15",
        r: "2.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.89 92.12c-.06-.49-.2-.83-.2-.83s-3.08-11.14-10.93-7.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.69 97.23c-.28-.4-.41-.75-.41-.75S33.1 86.15 41.1 83.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.75 83.4-3.4-9.37s-3.45-6.85 14.25-7.08 16.18 6.18 16.18 6.18-1.87 7.17-2.55 9.03l-.96 3.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.23",
        cy: "40.56",
        r: "1.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.87",
        cy: "40.56",
        r: "1.73"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.24 20.44c3.98-1.16 15.84-3.93 27.86-.2 1.07.33 2.21-.21 2.61-1.24l2.27-5.86c.34-.87.14-1.87-.53-2.53C68.48 8.67 63.43 5.1 52.8 5.1s-16.23 3.46-18.41 5.31c-.72.61-.97 1.6-.63 2.47l2.54 6.59c.3.77 1.14 1.19 1.95.96ZM60.99 61.42c-.76 7.04 1.47 8.31 1.47 8.31s-2.09 3.78-9.37 3.78-10.37-3.13-10.37-3.13c2.98-1.15 2.71-8.79 2.71-8.79s4.04 2.38 7.66 2.38c4.9 0 7.91-2.54 7.91-2.54Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.31 48.59c.3 3.42 1.07 11.65-3.28 13.77 0 0 7.14 1.89 11.71-1.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.92 36.08c-.87-.23-1.76-.2-2.58.14-2.51 1.04-3.42 4.59-2.03 7.93 1.21 2.93 3.78 4.72 6.08 4.43M69.76 48.61c2.19.05 4.53-1.71 5.67-4.46 1.38-3.34.47-6.9-2.03-7.93a3.98 3.98 0 0 0-2.46-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.59 33.32c.32 1.82.48 3.72.48 5.68 0 9.92-4.31 18.46-10.51 22.34-2.29 1.43-4.83 2.23-7.51 2.23-9.95 0-18.02-11-18.02-24.57 0-2.01.18-3.97.51-5.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.22 36.89c1.81-1.64 4.74-1.64 6.55 0M56.33 36.89c1.81-1.64 4.74-1.64 6.55 0M59.64 53.11s-1.74 3.28-6.55 3.28M53.01 41.45c0 3.69 2.41 3.86 2.41 5.98s-2.46 2.21-2.46 2.21M36.39 20.57c-3.83 5.69-4.14 12.18-4.14 12.18 10.65 0 24.57-4.65 24.57-12.64 0 0-.27 12.64 16.38 12.64 0 0-.2-7.42-4.57-13.34M69.48 49.29S67.7 60 72.92 62.54c0 0-7.29 2.23-11.59-1.19M60.83 61.14c-.76 7.04 1.62 8.93 1.62 8.93s-2.25 3.16-9.53 3.16-10.37-3.13-10.37-3.13c2.98-1.15 2.71-8.79 2.71-8.79s4.04 2.38 7.66 2.38c4.9 0 7.91-2.54 7.91-2.54Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.64 5.74s.4.74-.17 1.68-6 5.12-6 8.13-1.89 3.38-1.89 3.38l-4.43 1.4-1.36-.96-1.78-6.59.44-2.47 5.01-3.74 5.8-1.48 4.38.66Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "48.76",
        y: "89.05",
        width: "5.38",
        height: "3.36",
        rx: "1.43",
        ry: "1.43",
        transform: "rotate(68.52 51.446 90.724)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "35.35",
        y: "94.22",
        width: "5.38",
        height: "3.36",
        rx: "1.43",
        ry: "1.43",
        transform: "rotate(68.52 38.037 95.902)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.75 12.69v3.12h-2.09v-3.12h-2.87V10.8h2.87V7.68h2.09v3.12h2.87v1.89h-2.87Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.24 20.44c3.98-1.16 15.84-3.93 27.86-.2 1.07.33 2.21-.21 2.61-1.24l2.27-5.86c.34-.87.14-1.87-.53-2.53C68.48 8.67 63.43 5.1 52.8 5.1s-16.23 3.46-18.41 5.31c-.72.61-.97 1.6-.63 2.47l2.54 6.59c.3.77 1.14 1.19 1.95.96Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarDoctorFemale104 = (AvatarDoctorFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarDoctorFemale56.tsx


var AvatarDoctorFemale56_excluded = ["className"];
function AvatarDoctorFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarDoctorFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarDoctorFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarDoctorFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarDoctorFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarDoctorFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarDoctorFemale56_objectSpread(AvatarDoctorFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.73 36.37c.22 2.53.79 8.63-2.43 10.2 0 0 5.29 1.4 8.68-.86M14.7 27.1c-.65-.17-1.3-.15-1.91.1-1.86.77-2.53 3.4-1.51 5.88.9 2.17 2.8 3.5 4.51 3.28M40.51 36.38c1.62.03 3.36-1.26 4.2-3.3 1.03-2.48.35-5.11-1.51-5.88-.58-.24-1.21-.27-1.82-.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.12 25.05c.23 1.35.36 2.76.36 4.21 0 7.35-3.19 13.68-7.79 16.55-1.69 1.06-3.58 1.65-5.56 1.65-7.37 0-13.35-8.15-13.35-18.2 0-1.49.13-2.94.38-4.33M28.28 9.42c-14.84 0-15.56 15.22-15.56 15.22 7.89 0 18.2-3.44 18.2-9.37 0 0-.2 9.37 12.14 9.37 0 0-.41-15.22-14.78-15.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.36 36.88s-1.33 8 2.57 9.91c0 0-5.45 1.67-8.67-.89M15.16 24.93l15.15-12.88 10.81 13-25.96-.12z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.8 44.84c-.97-.74-1.71-1.69-2.28-2.77-.15-.28-1.16-1.54-1.22-1.95-.19-1.19-1.36-2.52-1.18-1.34.26 1.66-.51 5.36-1.49 6.69-.33.45-.95 1.3-.38 1.38 1.83.25 3.65.82 7.18-.49.83-.31-.03-1.07-.63-1.53ZM38.46 41.35c.05-.71-3.34 3.92-4.01 4.26-.59.3.35.7.85 1.11.61.51 3.5.71 4.18.57 0 0-1.22-3.09-1.02-5.94ZM25.21 9.42c-3.26.1-5.51 1.72-7.73 4.13-2.51 2.74-3.5 6.4-4.27 9.94-.29 1.31.8.88 2.03.6h.11c3.73-.38 7.66-.78 10.93-2.77 1.26-.77 2.41-1.75 3.31-2.92.46-.6.84-1.23 1.15-1.93.09-.05.18-.09.27-.14.16.7.48 1.41.58 1.73.32 1.05 1.17 2.25 2 2.98 1.45 1.25 1.86 2.09 4.07 2.53.62.12 1.61.97 1.55.23-.56-7.21-6.41-14.63-14-14.4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.73 36.37c.22 2.53.79 8.63-2.43 10.2 0 0 5.29 1.4 8.68-.86M14.7 27.1c-.65-.17-1.3-.15-1.91.1-1.86.77-2.53 3.4-1.51 5.88.9 2.17 2.8 3.5 4.51 3.28M40.51 36.38c1.62.03 3.36-1.26 4.2-3.3 1.03-2.48.35-5.11-1.51-5.88-.58-.24-1.21-.27-1.82-.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.12 25.05c.23 1.35.36 2.76.36 4.21 0 7.35-3.19 13.68-7.79 16.55-1.69 1.06-3.58 1.65-5.56 1.65-7.37 0-13.35-8.15-13.35-18.2 0-1.49.13-2.94.38-4.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.85 27.7c1.34-1.21 3.51-1.21 4.85 0M30.56 27.7c1.34-1.21 3.51-1.21 4.85 0M33.01 39.72s-1.29 2.43-4.85 2.43M28.1 31.08c0 2.73 1.79 2.86 1.79 4.43s-1.82 1.64-1.82 1.64M28.28 9.42c-14.84 0-15.56 15.22-15.56 15.22 7.89 0 18.2-3.44 18.2-9.37 0 0-.2 9.37 12.14 9.37 0 0-.41-15.22-14.78-15.22ZM40.36 36.88s-1.33 8 2.57 9.91c0 0-5.45 1.67-8.67-.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.28",
        cy: "29.97",
        r: "1.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.11",
        cy: "29.97",
        r: "1.16"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.98 16.53c3.07-.89 12.22-3.03 21.49-.15.82.26 1.7-.16 2.01-.96l1.75-4.52c.26-.67.11-1.44-.41-1.95C40.3 7.45 36.4 4.7 28.21 4.7S15.7 7.37 14.01 8.8a1.69 1.69 0 0 0-.49 1.91l1.96 5.08c.23.6.88.92 1.5.74Z",
      className: "fillprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.39 5.05s.32.58-.13 1.33-4.75 4.05-4.75 6.43-1.49 2.67-1.49 2.67l-3.5 1.1-1.07-.76-1.93-5.11V9.22l4.33-2.78 4.72-1.11 3.83-.28Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29 10.63v2.53h-1.7v-2.53h-2.33V9.09h2.33V6.56H29v2.53h2.33v1.54H29Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M17.03 16.53c3.07-.89 12.22-3.03 21.49-.15.82.26 1.7-.16 2.01-.96l1.75-4.52c.26-.67.11-1.44-.41-1.95-1.52-1.5-5.42-4.25-13.61-4.25s-12.51 2.67-14.2 4.1a1.69 1.69 0 0 0-.49 1.91l1.96 5.08c.23.6.88.92 1.5.74Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarDoctorFemale56 = (AvatarDoctorFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarDog104.tsx


var AvatarDog104_excluded = ["className"];
function AvatarDog104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarDog104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarDog104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarDog104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarDog104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarDog104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarDog104_objectSpread(AvatarDog104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.92 31.69s.66 10.94-.3 15.47c-.95 4.53-3.31 9.19-3.31 12.44.01 4.28 2.14 9.53 4.07 15.01 1.83 5.18 3.49 10.56 3.07 15.5 0 0-8.66 9.12-26.68 9.12s-26.48-9.16-26.48-9.16c-.42-4.94 1.24-10.32 3.07-15.5 1.94-5.48 4.06-10.73 4.07-15.01 0-3.26-2.36-7.91-3.31-12.44-.96-4.53-.3-15.47-.3-15.47l2.05-6.34c-1.06 5.93-7.72 19.4-10.94 18.89-3.21-.51-2.98-11.17-2.13-16.15 1.08-6.23 3.23-11.27 5.58-13.2 2.37-1.93 5.46-2.42 7.48-2.16 2.02.26 4.22 4.52 4.22 4.52 5.52-3.25 13.44-3.99 16.77-3.99s11.26.74 16.77 3.99c0 0 2.2-4.26 4.22-4.52 2.02-.25 5.12.23 7.48 2.16 2.37 1.93 4.51 6.98 5.58 13.2.87 4.98 1.09 15.64-2.13 16.15-3.21.51-9.87-12.96-10.94-18.89"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.17 83.3c.96 1.07 2.32.8 3.3-.53.01-.02-.01.01 0 0 4.72-4.19 9.96-6.23 18.8-5.15 1.98.24 3.8.04 5.44-.42 3.34-.94 2.38-5.76-1.08-5.5-.45.03-.91-.04-1.33-.2l-.61.5c-.32-.13-.66.23-.91 0l-3.75-.16c-.69-.61-4.46-.97-5.37-.79l-2.6-.64c-.35.07-2.53-1.09-2.83-.91l-6.07-2.9c-.44.27-1.14 3.64-1.37 4.09l-1.42 4.56c-.22.42-.54 1.15-.53 1.62l-.75 4.26c.02.65.27 1.27.72 1.76l.37.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.08 28.7c2.2 8.38-.83 15.36-3.13 15.75-2.24.38-7.06-9.47-8.64-14.75-.23-.78.78-1.27 1.19-.57 1.83 3.12 4.88 7.96 6.35 8.32 2.27.54 2.1-9.5 2.1-9.5s-.27-2.22.71-1.76 1.43 2.52 1.43 2.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.53 28.57c-2.14 8.38.8 15.36 3.05 15.75 2.18.38 6.87-9.47 8.4-14.75.23-.78-.76-1.27-1.15-.57-1.78 3.12-4.75 7.96-6.17 8.32-2.21.54-2.04-9.5-2.04-9.5s.26-2.22-.69-1.76-1.39 2.52-1.39 2.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.88 42.48c0 1.88-2.27 3.4-5.06 3.4s-5.06-1.52-5.06-3.4 2.27-3.4 5.06-3.4 5.06 1.52 5.06 3.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.61 53.38v.52c0 1.88-1.7 3.41-3.79 3.41-2.1 0-3.79-1.53-3.79-3.41v-.52l3.79-3.29 3.79 3.29Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.61 53.06v.57c0 2.1-1.7 3.79-3.79 3.79-2.1 0-3.79-1.7-3.79-3.79v-.57"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.81 25.59c1.06 5.93 7.72 19.4 10.94 18.89 3.21-.51 2.99-11.17 2.13-16.15-1.08-6.22-3.21-11.27-5.58-13.2-2.36-1.93-5.46-2.41-7.48-2.16-2.02.26-4.22 4.52-4.22 4.52-5.51-3.25-13.44-3.99-16.77-3.99s-11.25.74-16.77 3.99c0 0-2.2-4.26-4.22-4.52-2.02-.26-5.11.23-7.48 2.16-2.36 1.93-4.51 6.97-5.58 13.2-.86 4.98-1.09 15.64 2.13 16.15 3.21.51 9.87-12.96 10.94-18.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.4 90.4c.42-4.94-1.24-10.32-3.07-15.5-1.94-5.48-4.06-10.73-4.07-15.01 0-3.26 2.36-7.91 3.31-12.44.96-4.53.3-15.47.3-15.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.24 90.36c-.42-4.94 1.24-10.32 3.07-15.5 1.94-5.48 4.06-10.73 4.07-15.01 0-3.26-2.36-7.91-3.31-12.44-.96-4.53-.3-15.47-.3-15.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.88 42.48c0 1.88-2.27 3.4-5.06 3.4s-5.06-1.52-5.06-3.4 2.27-3.4 5.06-3.4 5.06 1.52 5.06 3.4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.82 45.89v3.52c0 1.72 4.49 4.55 8.97 1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.82 45.89v3.52c0 1.72-4.49 4.55-8.97 1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.19 26.88c3.02-1.23 6.7.11 8.22 2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.45 26.88c-3.02-1.23-6.7.11-8.22 2.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "61.18",
        cy: "32.79",
        r: "2.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.43",
        cy: "32.79",
        r: "2.37"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.77 72c12.84 0 20.61-5.66 20.61-5.66s-.75-2.56-1.02-3.69c-.28-1.14-.64-2.39-.64-2.39s-10.23 5.76-18.95 5.76-18.95-5.76-18.95-5.76-.36 1.25-.64 2.39c-.28 1.14-1.02 3.95-1.02 3.95S38.94 72 51.77 72Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.81 72c12.83 0 20.58-5.66 20.58-5.66s-.12-.6-.28-1.31c-.3-1.36-.54-2.73-.72-4.11-.08-.59-.13-1.03-.13-1.03s-5.4 6.06-18.83 6.06c-12.36 0-20.05-5.58-20.05-5.58s-.22 2.24-.46 3.35c-.28 1.32-.75 2.88-.75 2.88S39 72 51.81 72Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarDog104 = (AvatarDog104);
;// ./src/Picto/GeneratedPictoComponents/AvatarDog56.tsx


var AvatarDog56_excluded = ["className"];
function AvatarDog56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarDog56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarDog56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarDog56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarDog56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarDog56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarDog56_objectSpread(AvatarDog56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.22 24.09s.44 7.28-.2 10.3c-.63 3.02-2.2 6.11-2.2 8.28l.08-.31s-3.61 4.05-12.59 4.05c-8.26 0-13.4-3.73-13.4-3.73l.04-.03c0-2.17-1.57-5.26-2.2-8.28-.64-3.02-.2-10.3-.2-10.3l1.37-4.22c-.71 3.95-5.14 12.91-7.28 12.57-2.14-.34-1.98-7.43-1.41-10.75.72-4.15 2.15-7.5 3.72-8.79 1.58-1.28 3.63-1.61 4.98-1.44 1.35.17 2.81 3.01 2.81 3.01 3.67-2.16 8.94-2.66 11.16-2.66s7.49.49 11.16 2.66c0 0 1.47-2.84 2.81-3.01 1.35-.16 3.41.16 4.98 1.44 1.58 1.28 3 4.65 3.72 8.79.58 3.31.72 10.41-1.41 10.75-2.14.34-6.57-8.62-7.28-12.57"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.74 21.87c1.49 5.68-.56 10.43-2.13 10.69-1.52.26-4.79-6.43-5.87-10.01-.16-.53.53-.86.81-.39 1.24 2.12 3.31 5.4 4.31 5.65 1.54.37 1.42-6.45 1.42-6.45s-.18-1.51.48-1.2.97 1.71.97 1.71Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M5.13 21.85c-1.46 5.71.55 10.47 2.08 10.73 1.49.26 4.68-6.45 5.73-10.05.15-.53-.52-.86-.79-.39-1.22 2.13-3.23 5.42-4.21 5.67-1.51.37-1.39-6.47-1.39-6.47s.18-1.51-.47-1.2-.95 1.72-.95 1.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.32 31.37c0 1.23-1.49 2.23-3.32 2.23s-3.32-1-3.32-2.23 1.49-2.23 3.32-2.23 3.32 1 3.32 2.23Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.04 38.11v.29c0 1.05-.94 1.9-2.11 1.9s-2.11-.85-2.11-1.9v-.29l2.11-1.83 2.11 1.83Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.99 38.09v.32c0 1.17-.94 2.11-2.11 2.11s-2.11-.94-2.11-2.11v-.32"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.86 42.75c0-2.17 1.57-5.26 2.2-8.28.64-3.02.2-10.3.2-10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.84 19.99c.71 3.95 5.14 12.91 7.28 12.57 2.14-.34 1.99-7.43 1.41-10.75-.72-4.14-2.14-7.5-3.72-8.79-1.57-1.28-3.63-1.6-4.98-1.44-1.35.17-2.81 3.01-2.81 3.01-3.67-2.16-8.94-2.66-11.16-2.66s-7.49.49-11.16 2.66c0 0-1.47-2.84-2.81-3.01-1.35-.17-3.4.16-4.98 1.44-1.57 1.28-3 4.64-3.72 8.79-.57 3.31-.72 10.41 1.41 10.75 2.14.34 6.57-8.62 7.28-12.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.99 42.72c0-2.17-1.57-5.26-2.2-8.28-.64-3.02-.2-10.3-.2-10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.3 31.17c0 1.25-1.51 2.27-3.37 2.27s-3.37-1.01-3.37-2.27 1.51-2.27 3.37-2.27 3.37 1.01 3.37 2.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.93 33.43v2.34c0 1.15 2.99 3.03 5.97.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.93 33.43v2.34c0 1.15-2.99 3.03-5.97.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.11 20.84c2.01-.82 4.46.07 5.47 1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.69 20.78c-2.01-.82-4.46.07-5.47 1.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.52",
        cy: "24.64",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.36",
        cy: "24.64",
        r: "1.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.88 50.81c8.56 0 13.74-3.78 13.74-3.78s-.5-1.7-.68-2.46c-.19-.76-.43-1.59-.43-1.59s-6.82 3.84-12.64 3.84-12.64-3.84-12.64-3.84-.24.83-.43 1.59c-.19.76-.68 2.63-.68 2.63s5.19 3.6 13.74 3.6Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.94 50.54c8.57 0 13.76-3.79 13.76-3.79s-.08-.4-.19-.88c-.2-.91-.36-1.83-.48-2.75-.05-.4-.09-.69-.09-.69s-3.61 4.05-12.59 4.05c-8.26 0-13.4-3.73-13.4-3.73s-.15 1.5-.31 2.24c-.19.88-.5 1.93-.5 1.93s5.23 3.61 13.8 3.61Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarDog56 = (AvatarDog56);
;// ./src/Picto/GeneratedPictoComponents/AvatarElderlyFemale104.tsx


var AvatarElderlyFemale104_excluded = ["className"];
function AvatarElderlyFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarElderlyFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarElderlyFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarElderlyFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarElderlyFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarElderlyFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarElderlyFemale104_objectSpread(AvatarElderlyFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.14 40.78c2.42.18 4.09 2.81 3.72 5.86-.36 3.06-2.62 5.39-5.04 5.21"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.56 43.3c0 14.06 8.46 24.77 18.88 24.77s19.21-10.11 19.21-29V23.44l-14.71-5.49-23.37 25.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.38 27.15c3.06-1.18 11.17-.92 21.78-6.18 10.61-5.27 25.14-7.64 34.94-6.94 0 0-10.06-.06-15.4 7.14S47.63 40.52 37.01 42.89 14.06 38 16.91 27.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.02 23.89s.23-10.15 11.7-13.67c11.95-3.67 17.84 4.59 17.84 4.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.27 40.78c-2.42.18-4.09 2.81-3.72 5.86s2.62 5.39 5.04 5.21"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.42 89.17c-.99-2.58-2.42-5.1-4.5-7.03-.63-.59-1.27-1.14-1.92-1.68-2.11-1.74-4.49-3.19-6.49-4.65-.54-.39-1-.78-1.41-1.16l.12.17c-2.1-1.98-2.57-3.63-2.67-7.5l-15.97-.54c-.09 4-.54 6.04-2.69 8.06l.75-.79c-.4.37-1.52 1.32-2.04 1.71-1.99 1.46-3.93 2.79-6.03 4.51l-.21.15c-.66.54-1.31 1.11-1.95 1.71-2.23 2.08-3.72 4.85-4.72 7.62 0 0 7.88 9.48 25.54 9.48S75.4 89.16 75.4 89.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.25 21.88c1.12-.22 2.18.5 2.4 1.63.22 1.12-.47 2.15-1.6 2.38h-.04c-1.11.2-2.17-.49-2.38-1.6s.51-2.19 1.64-2.41h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.89 62.11c30.17 1.3 20.74-33.58 20.74-33.58-3.27-10.69-9.67-14.14-17.29-14.71M32.15 63.41C.9 66.24 6.48 28.22 16.38 26.94"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.76 54.59v4.11l.46 2.83.81 2.83.62 1.88 1.53 1.87-1.53 1.11-3.77-.15-3.81-.5-2.72-1.08-.79-1.79 3.26-2.63 2.77-3.43 2.09-3.11 1.08-1.94zM33.43 54.93l-1.28 9.7-2.1 3.5 3.76 1.09 4.93-.15 3.17-2.49.68-1.02-4.86-3.9-2.85-4.42-1.45-2.31zM60.76 75.78c-5.28 3.06-13.78 4.4-18.69.45-.13-.1-.31-.06-.47-.06-.3-1.43-3.42-1-3.24.5.6 4.96 5.85 10.06 12.85 10.4 9.58.47 11.35-4.68 11.93-9.85.12-1.07-1.31-2.06-2.38-1.44ZM62.34 17.56l2.97 1.45 1.94 2.34 2.3 3.78.73 3.46.77 3.74-.55 4.69-.59 2.25-4.03-.86-3.77-1.97-3.55-2.22L56.64 31l-1.13-3.05-.71-2.14 1.59-2.57 2.96-3.46 2.99-2.22"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.58 58.43c1.08 1.69 3.66 2.12 5.06-.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.56 51.6s-2.07 13.88 4.03 16.85c0 0-9.43 3.55-14.26-1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.59 51.6s2.07 13.88-4.03 16.85c0 0 9.43 3.55 14.26-1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.59 66.58c-.09 4-.54 6.04-2.69 8.06M25.71 89.55c.99-2.78 2.48-5.54 4.72-7.62.64-.6 1.29-1.16 1.95-1.71M61.23 74.62c-2.1-1.98-2.57-3.63-2.67-7.5M75.42 88.96c-.99-2.58-2.42-5.1-4.5-7.03-.63-.59-1.27-1.14-1.92-1.68M60.88 74.62c-3.38 2.75-6.06 4.14-10.44 4.14S43.38 77.37 40 74.62M32.38 94.8l.21-14.39M68.83 94.91l-.09-14.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.58 80.07c2.1-1.73 4.04-3.05 6.03-4.51.53-.39 1.64-1.34 2.04-1.71M69 80.25c-2.11-1.74-4.49-3.19-6.49-4.65-.54-.39-1-.78-1.41-1.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.08 51.98c-2.43.15-4.43-3.01-4.76-5.55 0 0-.36-2.04.09-3.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.14 40.57c2.42.18 4.09 2.81 3.72 5.86-.36 3.06-2.62 5.39-5.04 5.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.65 38.87c0 18.89-8.8 29-19.21 29S31.56 57.15 31.56 43.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.6 44.35c0 3.8 2.48 3.98 2.48 6.17s-2.54 2.28-2.54 2.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.93 41.43c1.87-1.69 4.88-1.69 6.75 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.35 59.34s-2.99-3.17-1.75-8.27M44.88 51.06c1.13 5.25-1.87 8.28-1.87 8.28M46.41 41.41s-1.19-1.07-3.09-.99M54.79 25.45c-.08 1.9 1.33 11.6 15.12 13.45 0 0 5.29-15.2-6.86-21.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.67 14.81s-9.06-5.09-16.72 3.04-8.45 3.96-8.45 3.96l2.53-5.26 6.61-5.13 5.88-1.86 3.33-.26 4.6.82 3.11 1.55 2.82 2.56-3.54 1.06-.18-.48ZM68.74 60.17l-.03-3.03.03-2.55.44-2.67.47-.32 1.53-.44 1.41-1.13 1.13-1.98.64-2.07-.29-2.85-1.77-2.56-2.02-.93.77-2.62.48-3.97v-3.03l-.35-2.62-.82-2.64-1.01-2.41-2.19-2.43-1.85-1.76-1.32-1.51 3.54-1.58 3.39-.68h4.39l2.82.72 3.3 1.46 3.3 2.53 2.44 3 1.89 3.6 1.33 4.2.94 6.17v6.12l-.94 6.62-2.25 5.18-3.64 4.04-5.42 2.56-4.97.94h-4.92l-.45-1.36zM15.91 27.59l.47 2.37.47 3.82 1.18 3.24 1.86 1.85 3.05 2.16 3.34 1.64.94.51-.64 2.08.64 3.31 1.35 1.88 1.48.81 1.51.84.84 1.56v3.16l-.4 5.26-.44.61-1.51.31h-4.02l-4.46-1.09-5.19-2.27-3.68-4.44-2.79-5.48-.97-8.69 1.45-6.82 2.97-5.09 2.55-1.53zM20.47 21.63v3.5l1.46 4.55 3.56-1.62 1.7-1.93-.08-1.47-.46-2.09-6.18-.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.05 21.05.14 4.14 3.85.94 2.98.25.16-3.96-.89-2.22-.92-1.92-5.32 2.77"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.38 26.94c.84-.33 2.07-.54 3.64-.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.89 20.41c10.54-5.02 24.64-7.27 34.21-6.59 0 0-10.06-.06-15.4 7.14S47.63 40.31 37.01 42.68c-10.74 2.4-23.49-5.03-20.64-15.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.39 21.33c.81-3.22 3.35-8.86 11.32-11.31 11.95-3.67 17.84 4.59 17.84 4.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.24 21.4c.22-.03 1.06-.12 2.45-.05 1.46.07 3.22.33 4.59 1.02-.39.6-.57 1.33-.42 2.09.11.57.39 1.06.77 1.44-1.35 1.87-3.51 3.02-5.65 4.09a23.5 23.5 0 0 1-.72-1.27c-.47-.91-.99-2.03-1.15-2.76-.14-.74-.12-1.96-.04-2.99.07-.85.12-1.31.15-1.53h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.37 18.07c.11.19.34.6.72 1.35.46.92.95 2.05 1.08 2.78.12.73.07 1.96-.04 2.99-.08.8-.15 1.19-.19 1.45-2.38-.19-4.81-.45-6.76-1.67.22-.5.28-1.06.18-1.63-.15-.74-.57-1.37-1.15-1.76 2.28-2.32 5.74-3.4 6.15-3.52h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.25 21.88c1.12-.22 2.18.5 2.4 1.63.22 1.12-.47 2.15-1.6 2.38h-.04c-1.11.2-2.17-.49-2.38-1.6s.51-2.19 1.64-2.41h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.62",
        cy: "45.84",
        r: "1.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "57.35",
        cy: "45.95",
        r: "1.89"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarElderlyFemale104 = (AvatarElderlyFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarElderlyFemale56.tsx


var AvatarElderlyFemale56_excluded = ["className"];
function AvatarElderlyFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarElderlyFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarElderlyFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarElderlyFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarElderlyFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarElderlyFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarElderlyFemale56_objectSpread(AvatarElderlyFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.19 15.93c.8-.15 1.54.35 1.7 1.15s-.34 1.52-1.13 1.69h-.03c-.79.14-1.53-.35-1.69-1.13s.36-1.55 1.16-1.71Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.9 28.43c1.51.11 2.56 1.76 2.33 3.67-.23 1.91-1.64 3.37-3.15 3.26"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.77 30.01c0 8.8 5.3 15.5 11.81 15.5S39.6 39.19 39.6 27.37v-9.78l-9.21-3.43-14.62 15.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.27 19.91c1.91-.74 6.99-.58 13.63-3.87 6.64-3.29 15.73-4.78 21.86-4.34 0 0-6.3-.04-9.63 4.46-3.34 4.5-6.3 12.11-12.94 13.59-6.72 1.5-14.7-3.15-12.91-9.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.74 17.41s.14-6.35 7.32-8.55c7.48-2.3 11.16 2.87 11.16 2.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M14.96 28.43c-1.51.11-2.56 1.76-2.33 3.67s1.64 3.37 3.15 3.26"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.12 11.9s-5.57-3.13-10.27 1.87c-4.71 4.99-5.19 2.43-5.19 2.43l1.56-3.23 4.06-3.15 3.61-1.14 2.05-.16 2.83.51 1.91.95 1.74 1.57-2.18.65-.11-.29ZM38.76 39.53l-.02-1.86.02-1.57.27-1.64.22.56 1.01-.38 1.1-.89.97-1.36-.1-1.59-.18-1.76-1.96-1.09-.38-1.06.48-1.62.29-2.44v-1.86l-.21-1.62-.51-1.63-.62-1.48-1.35-1.49-1.14-1.09-.81-.93 2.18-.97 2.09-.42h2.7l1.74.44 2.03.9 2.03 1.56 1.5 1.85 1.17 2.22.82 2.58.58 3.8v3.77l-.58 4.08-1.39 3.19-2.24 2.48-3.34 1.58-3.06.58h-3.03l-.28-.84zM6.33 19.99l-.11 1.44.3 2.3 1.13 1.84 1.16 1.1 1.9 1.28 2.08.97.59.3-.41 1.23.17 2.55.84 1.11.96.67 1.26.57.4.08v1.87l-.25 3.11-.27.37-.94.18h-2.51l-2.78-.65-2.88-1.61-2.64-2.36-1.74-3.25-.6-5.14.9-4.04 1.85-3.02 1.59-.9z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.83 15.67v2.49l1.04 3.22 2.52-1.14 1.21-1.37-.06-1.05-.33-1.48-4.38-.67M19.04 15.26l.1 2.94 2.73.67 2.11.17.11-2.81-.62-1.57-.65-1.35-3.78 1.95"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.05 40.41c18.07.78 12.42-20.11 12.42-20.11-1.96-6.4-5.79-8.47-10.35-8.81M16.38 40.65C-2.33 42.35.79 20.22 6.72 19.45"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.82 35.37c-1.55.1-2.83-1.92-3.04-3.54 0 0-.23-1.3.06-2.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.11 28.09c1.54.12 2.61 1.79 2.38 3.74-.23 1.95-1.67 3.44-3.22 3.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.8 27.31c0 11.86-5.61 18.2-12.26 18.2s-12.05-6.73-12.05-15.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.65 30.5c0 2.43 1.58 2.54 1.58 3.94s-1.62 1.46-1.62 1.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.77 28.64c1.19-1.08 3.12-1.08 4.31 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.35 39.49c.69 1.08 2.34 1.35 3.23-.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.23 40.06s-1.91-2.02-1.11-5.28M24 34.78c.72 3.35-1.2 5.29-1.2 5.29M24.97 28.63s-.76-.68-1.97-.63M30.32 18.72c-.05 1.22.85 7.4 9.65 8.59 0 0 3.38-9.7-4.38-13.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.86 35.48s-1.5 9.11 2.29 10.95c0 0-6.07 3-9.11-1.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.5 36.25s1.27 8.52-2.47 10.34c0 0 4.48 3.55 8.97-1.59"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.52",
        cy: "31.15",
        r: "1.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.93",
        cy: "31.15",
        r: "1.15"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.53 14.25c5.92-2.18 12.69-3.12 17.72-2.76 0 0-5.86-.05-9.17 4.42S25.83 27.92 19.24 29.4c-6.67 1.49-14.58-3.12-12.81-9.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.43 19.55c.85-.33 2.33-.46 4.3-.8M15.12 15.9c.51-2 2.09-5.49 7.03-7.01 7.42-2.28 11.01 2.77 11.01 2.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.82 15.59c.15-.02.75-.09 1.73-.04 1.04.05 2.28.23 3.25.72-.28.42-.4.94-.3 1.48.08.4.28.75.55 1.02-.96 1.32-2.48 2.14-4 2.89-.1-.16-.24-.39-.51-.9-.34-.64-.7-1.44-.81-1.96-.1-.53-.09-1.39-.03-2.12.05-.6.09-.93.11-1.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.94 13.23c.08.13.24.42.51.96.33.65.67 1.45.77 1.96.09.52.05 1.39-.03 2.12-.06.57-.11.84-.13 1.03-1.69-.13-3.4-.32-4.78-1.18.15-.35.2-.75.12-1.15-.11-.53-.4-.97-.81-1.25 1.61-1.64 4.06-2.41 4.35-2.49Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.19 15.93c.8-.15 1.54.35 1.7 1.15s-.34 1.52-1.13 1.69h-.03c-.79.14-1.53-.35-1.69-1.13s.36-1.55 1.16-1.71Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarElderlyFemale56 = (AvatarElderlyFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarElderlyMale104.tsx


var AvatarElderlyMale104_excluded = ["className"];
function AvatarElderlyMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarElderlyMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarElderlyMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarElderlyMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarElderlyMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarElderlyMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarElderlyMale104_objectSpread(AvatarElderlyMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.12 87.01-10.78-9.75c-2.29-2.07-3.39-2.91-5.05-5.77l-.44-.42c-1.52-2.1-1.82-5.2-1.82-5.2l-23.2.21s-.31 3.09-1.82 5.2l-.23.21c-2.2 2.61-2.72 3.7-5.01 5.77L22.31 87.62s11.96 11.62 29.82 11.62 30-12.23 30-12.23ZM29.05 35.12c-.96-.18-1.92-.1-2.81.27-3.15 1.31-4.3 5.77-2.56 9.98 1.52 3.68 4.75 5.94 7.65 5.57M73.11 50.97c2.81.16 5.85-2.06 7.32-5.6 1.74-4.2.6-8.67-2.56-9.98-1.03-.43-2.15-.46-3.25-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.06",
        cy: "38.89",
        rx: "22.66",
        ry: "30.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.81 14.88c-3.99 4.44-6.19 9.85-6.4 15.82-.08 2.34 2.83 4.52 2.91 2.18.17-4.99 3.52-12.66 6.86-16.37 1.56-1.73-1.8-3.37-3.37-1.62ZM69.92 14.75c-1.79-1.48-4.23.2-2.42 1.7 4.35 3.61 6.69 10.76 6.78 16.43.04 2.34 2.95.89 2.91-1.45-.11-6.55-2.21-12.48-7.26-16.68ZM62.34 79.85s.82-.2.36 1.81c-.8 3.57-13.36 8.55-18.21 3.93-2.74-2.61-1.61-5.93-1.61-5.93s4.85 3.23 9.35 3.04c5.85-.24 4.46-.44 10.11-2.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.66 80.96c-.42-.21-.73.27-.39.55 1.81 1.5.57 6.11 3.46 6.74-.03.3.9-.46 1.13-.67.41-.37 2.01-1.18 1.93-2.32.35-1.48-4.06-3.52-6.13-4.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.56 81.4c.42-.21.74.26.39.54-1.85 1.51-.66 6.07-3.59 6.73.03.3-.9-.45-1.13-.65-.41-.36-2.02-1.14-1.93-2.28-.34-1.47 4.16-3.55 6.27-4.35Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.83 14.29c5.02-.47 9.53 6.58 10.21 13.47.68 6.94-2.2 6.85-2.2 6.85M29.18 35.22c-.96-.18-1.92-.1-2.81.27-3.15 1.31-4.3 5.77-2.56 9.98 1.52 3.68 4.25 6.24 7.15 5.88M73.24 51.07c2.81.16 5.85-2.06 7.32-5.6 1.74-4.2.6-8.67-2.56-9.98-1.03-.43-2.15-.46-3.25-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.18",
        cy: "38.98",
        rx: "22.66",
        ry: "30.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.24 41.05c0 4.64 3.03 4.86 3.03 7.52s-3.09 2.78-3.09 2.78M39.82 36.34c2.28-2.06 5.97-2.06 8.24 0M56.3 36.34c2.28-2.06 5.97-2.06 8.24 0M49.24 59.44h5.77M46 49.29c-1.84 6.34-8.24 3.48-8.24 3.48M66.6 52.76s-6.4 2.86-8.24-3.48M39.82 28.17s4.12-1.55 6.18-1.55 4.12 1.55 6.18 1.55 4.12-1.55 6.18-1.55 6.18 1.55 6.18 1.55M40.79 20.18s3.8-1.71 5.7-1.71 3.8 1.71 5.7 1.71 3.8-1.71 5.7-1.71 5.7 1.71 5.7 1.71M29.75 34.61s-3.1.09-2.41-6.85c.68-6.9 5.19-13.94 10.21-13.47M63.58 77.92c-3.28 3.02-6.9 3.93-10.88 3.93s-7.71-1.38-11.11-3.86M64.61 65.88s.32 3.12 1.88 5.24M40.73 66.09s-.32 3.12-1.88 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.38 98.79c2.07-18.54 7.11-27.09 7.11-27.09M74.91 80.25l-7.96 5.49 5.73 3.19-5.85 7.54M46 98.79c0-13.37-7.15-26.74-7.15-26.74M66.49 71.12c1.71 2.88 3.29 4.15 5.65 6.23l11.1 9.82M38.85 71.33c-1.97 2.86-3.04 3.94-5.4 6.02l-11.8 10.44M30.8 80.07l7.81 5.39-5.58 3.29 5.58 8.26"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.84",
        cy: "40.19",
        r: "2.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.4",
        cy: "40.19",
        r: "2.1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.01 42.02c.97 2.59 3.59 4.44 6.67 4.44s5.69-1.86 6.67-4.44H37.02ZM54.78 42.02c.97 2.59 3.59 4.44 6.67 4.44s5.69-1.86 6.67-4.44H54.79ZM28.78 34.3l8.23 7.72h31.11l7.53-7.65"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarElderlyMale104 = (AvatarElderlyMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarElderlyMan56.tsx


var AvatarElderlyMan56_excluded = ["className"];
function AvatarElderlyMan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarElderlyMan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarElderlyMan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarElderlyMan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarElderlyMan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarElderlyMan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarElderlyMan56_objectSpread(AvatarElderlyMan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.72 25.2c-.71-.13-1.43-.07-2.09.2-2.35.97-3.2 4.3-1.9 7.43 1.13 2.74 3.45 4.5 5.61 4.23M43.51 37c2.09.12 4.35-1.53 5.45-4.17 1.3-3.13.44-6.45-1.9-7.43-.77-.32-1.6-.34-2.42-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.84",
        cy: "28",
        rx: "16.87",
        ry: "23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.18 10.68c-2.97 3.3-4.54 6.81-4.69 11.25-.06 1.74 2.1 3.36 2.16 1.62.13-3.71 2.61-9.41 5.1-12.18 1.16-1.29-1.4-1.99-2.57-.7ZM41.06 10.35c-1.33-1.1-2.87-.11-1.53 1 3.23 2.68 4.7 8.26 4.77 12.48.03 1.74 2.19.66 2.16-1.08-.08-4.87-1.64-9.28-5.4-12.4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.9 9.83c3.74-.35 7.09 4.89 7.6 10.03.51 5.16-1.63 5.1-1.63 5.1M10.88 25.41c-.71-.13-1.43-.07-2.09.2-2.35.97-3.2 4.3-1.9 7.43 1.13 2.74 3.45 4.5 5.61 4.23M43.67 37.21c2.09.12 4.35-1.53 5.45-4.17 1.3-3.13.44-6.45-1.9-7.43-.77-.32-1.6-.34-2.42-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28",
        cy: "28.21",
        rx: "16.87",
        ry: "23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.04 29.75c0 3.45 2.26 3.61 2.26 5.6S28 37.42 28 37.42M18.8 26.24c1.69-1.53 4.44-1.53 6.13 0M31.07 26.24c1.69-1.53 4.44-1.53 6.13 0M25.81 43.44h4.29M23.4 35.88c-1.37 4.72-6.13 2.59-6.13 2.59M38.73 38.47s-4.76 2.13-6.13-2.59M18.8 20.16s3.07-1.15 4.6-1.15 3.07 1.15 4.6 1.15 3.07-1.15 4.6-1.15 4.6 1.15 4.6 1.15M20.33 15.56s2.56-1.15 3.83-1.15 2.56 1.15 3.83 1.15 2.56-1.15 3.83-1.15 3.83 1.15 3.83 1.15M11.3 24.96s-2.31.07-1.8-5.1c.51-5.13 3.86-10.38 7.6-10.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.87",
        cy: "28.84",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.13",
        cy: "28.84",
        r: "1.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.65 30.04c.72 1.89 2.64 3.24 4.91 3.24s4.19-1.35 4.91-3.24h-9.81ZM29.73 30.04c.72 1.89 2.64 3.24 4.91 3.24s4.19-1.35 4.91-3.24h-9.81ZM10.59 24.41l6.06 5.63h22.89l5.55-5.58"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarElderlyMan56 = (AvatarElderlyMan56);
;// ./src/Picto/GeneratedPictoComponents/AvatarFemaleOveralls104.tsx


var AvatarFemaleOveralls104_excluded = ["className"];
function AvatarFemaleOveralls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFemaleOveralls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFemaleOveralls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFemaleOveralls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFemaleOveralls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFemaleOveralls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFemaleOveralls104_objectSpread(AvatarFemaleOveralls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.34",
        cy: "38.47",
        rx: "19.61",
        ry: "26.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 19.44c-.72 9.89-11.78 4.77-19.39 16.13-6.82 9.57.41 21.44.41 21.44-1.55 2.33-6.76 6.74-6.76 6.74C9.39 34.05 33.36 5.76 51.99 6.07c0 0 .88.02 1.05.03 12.57.51 32.52 12.76 28.46 38.59 0 0-1.54 10-8.13 18.94 0 0-5.15-2.57-7.24-4.79 0 0-5.65-3.8 1.92-16.67 7.57-12.87-10.72-22.73-10.72-22.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.47 62.21H42.7c0 5.55-2.38 5.93-5.95 7.61l-3.86 2.4c-3.59 2.26-7.44 4.38-11.12 7.32-1.99 1.59-3.55 3.52-4.78 5.58 0 0 13.66 14.12 35.34 14.12S86.4 84.76 86.4 84.76c-1.19-1.92-2.68-3.72-4.56-5.22-3.68-2.94-7.67-5.25-11.26-7.51l-3.9-2.32c-3.45-1.64-5.21-2.07-5.21-7.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.75 70.12c3.57-1.68 5.95-2.07 5.95-7.61M17 85.41c1.22-2.05 2.79-3.98 4.78-5.58 3.68-2.94 7.53-5.06 11.12-7.32M70.58 72.33c3.59 2.26 7.58 4.57 11.26 7.51 1.87 1.5 3.37 3.3 4.56 5.22M61.47 62.5c0 5.43 1.75 5.86 5.21 7.5M36.68 70.12c4.35 3.74 9.5 5.91 15.02 5.91s10.67-2.17 15.02-5.91"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.8 32.12c-2.3-8.77-7.8-15.6-15.54-20.06-7.84-4.53-15.87-5.71-23.81-.3-8.52 5.82-12.42 13.08-13.37 22.13-1.06 10.18 1.75 20.26 7.97 28.24.83 1.06 1.33 1.25 2.4.6.53-.32 1.46-1.89 1.99-2.21 1.84-1.1 2.66-1.65 1.53-3.74-2.84-5.28-3.07-12.56-1.38-16.41 2.64-5.71 5.49-8.47 9.96-11.25 3.3-2.06 9.17-3.22 10.9-6.95.35-.77.59-1.89.72-2.71.29.05 1.1.11 1.42.23 4.32 1.69 7.97 6.95 10 11.2 2.24 4.7.24 9.58-2.73 14.91-.54.97-.91 1.99-1.13 3.03-1.2 3.95-1.38 7.41 1.89 10.14.07.08 1.3 1.28 1.37 1.36.5.53 4.49 2.72 5.03 2.83 0 0 2.72-2.98 2.83-3.83 1.28-9.02 2.28-18.25-.07-27.2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.19",
        cy: "40.5",
        r: "1.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.29",
        cy: "40.5",
        r: "1.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.41 58.5c-3.47 4.19-8.05 6.74-13.07 6.74-5.4 0-10.29-2.95-13.84-7.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.39 40.53c0 3.95 2.58 4.14 2.58 6.41s-2.64 2.37-2.64 2.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.81 36.52c1.94-1.76 5.08-1.76 7.02 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.85 36.52c1.94-1.76 5.08-1.76 7.02 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.59 55.81c2.09 1.19 4.3.11 5.27-.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 19.73c-.72 9.89-11.78 4.77-19.39 16.13-6.82 9.57.41 21.44.41 21.44-1.55 2.33-6.76 6.74-6.76 6.74C9.39 34.34 33.36 6.05 51.99 6.36c0 0 .88.02 1.05.03 12.57.51 32.52 12.76 28.46 38.59 0 0-1.54 10-8.13 18.94 0 0-5.15-2.57-7.24-4.79 0 0-5.65-3.8 1.92-16.67 7.57-12.87-10.72-22.73-10.72-22.73Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.92 91.33s-3.11 2.82-8.07.36-9.48-4.79-13.68-4.85c-4.2-.06-5.61-1.6-5.57-3.07.04-1.47 27.48-.46 27.48-.46l-.17 8.03ZM29.6 83.58h2.64v5.21s-1.09-2.06-2.64-1.61 0-3.6 0-3.6ZM33.93 71.81h2.64v8.27s-1.09-3.27-2.64-2.55 0-5.72 0-5.72ZM73.56 83.87h-2.64v5.21s1.09-2.06 2.64-1.61 0-3.6 0-3.6ZM69.6 71.61h-2.64v8.27s1.09-3.27 2.64-2.55 0-5.72 0-5.72Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.68 97.15V70l3.9 2.33-.1 23.41M66.68 82.96H36.75M70.83 82.96h3.51v10.95M32.89 82.96h-3.83v10.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.76 96.88-.08-26.76-3.79 2.39v22.92"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFemaleOveralls104 = (AvatarFemaleOveralls104);
;// ./src/Picto/GeneratedPictoComponents/AvatarFemaleOveralls56.tsx


var AvatarFemaleOveralls56_excluded = ["className"];
function AvatarFemaleOveralls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFemaleOveralls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFemaleOveralls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFemaleOveralls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFemaleOveralls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFemaleOveralls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFemaleOveralls56_objectSpread(AvatarFemaleOveralls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
          cx: "28",
          cy: "28.34",
          rx: "13.92",
          ry: "18.8"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.53 14.83c-.51 7.02-8.36 3.39-13.76 11.45-4.85 6.79.29 15.22.29 15.22-1.1 1.66-4.8 4.79-4.8 4.79C-2.5 25.2 14.52 5.11 27.74 5.34c0 0 .63.01.74.02 8.93.36 23.09 9.06 20.2 27.4 0 0-1.09 7.1-5.77 13.45 0 0-3.66-1.82-5.14-3.4 0 0-4.01-2.7 1.36-11.84 5.37-9.13-7.61-16.14-7.61-16.14Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.63",
        cy: "30.84",
        r: "1.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.22",
        cy: "30.84",
        r: "1.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.11 24.04c-1.6-6.13-5.46-10.91-10.86-14.02-5.48-3.17-11.1-3.99-16.64-.21-5.95 4.07-8.68 9.14-9.35 15.47-.74 7.12 1.22 14.16 5.57 19.74.58.74.93.87 1.68.42.37-.22 1.02-1.32 1.39-1.54 1.28-.77 2.28-2.39 1.5-3.85-1.99-3.69-2.57-7.54-1.39-10.23 1.84-3.99 3.11-6.11 6.24-8.06 2.31-1.44 7.14-2.06 8.35-4.67.25-.54.41-1.32.51-1.89.2.03.77.08.99.16 3.02 1.18 6.35 4.8 7.77 7.77 1.56 3.28.08 6.93-2 10.66-.38.68-.79 2.54-.94 3.27-.84 2.76-.78 3.2.78 5.76.05.06.91.89.96.95.35.37 3.93 2.21 4.3 2.28 0 0 1.34-1.2 1.42-1.8.89-6.31 1.37-13.94-.27-20.19Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.58 42.44c-2.34 3.16-5.58 5.12-9.16 5.12-4.1 0-8.11-2.4-10.49-6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.46 31.24c0 2.61 1.7 2.73 1.7 4.24s-1.74 1.57-1.74 1.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.47 28.59c1.28-1.16 3.36-1.16 4.64 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.74 28.59c1.28-1.16 3.36-1.16 4.64 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.26 41.33c1.38.78 2.84.07 3.48-.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.54 14.56c-.51 7.05-8.39 3.4-13.8 11.49-4.86 6.81.29 15.27.29 15.27-1.1 1.66-4.82 4.8-4.82 4.8-15.8-21.15 1.27-41.3 14.53-41.07 0 0 .63.01.75.02 8.95.36 23.15 9.08 20.26 27.47 0 0-1.1 7.12-5.79 13.49 0 0-3.67-1.83-5.15-3.41 0 0-4.02-2.71 1.37-11.87s-7.63-16.18-7.63-16.18Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFemaleOveralls56 = (AvatarFemaleOveralls56);
;// ./src/Picto/GeneratedPictoComponents/AvatarFirstNationsFemale104.tsx


var AvatarFirstNationsFemale104_excluded = ["className"];
function AvatarFirstNationsFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFirstNationsFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFirstNationsFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFirstNationsFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFirstNationsFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFirstNationsFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFirstNationsFemale104_objectSpread(AvatarFirstNationsFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.24 35.28c2.31 6.03 1.74 9.88 1.74 9.88 0 14.18-9.01 25.67-20.13 25.67S32.72 59.34 32.72 45.16c0 0-.44-11.6 2.26-13.91s34.84 0 34.84 0l1.41 4.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.38 34.6c14.7-7.08 33.83-.46 36.86.69.21.08.43-.07.38-.26l-1.12-7.28c-.33-1.44-3.24-3.33-4.73-4.06-14.46-7.07-26.96-1.8-31.56 1.28-1.14.76-1.74 1.94-1.63 3.15l-.18 5.61c.07.81 1.14 1.28 1.98.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.46 26.25c1.98 1.5 4.4.04 4.79-1.61.36-1.53-.21-3.14-1.29-3.78 0-.09.02-.18.02-.28 0-1.51-.8-2.76-1.86-3.06-.19-1.47-1.14-2.58-2.29-2.58-.39 0-.76.14-1.08.37-.31-2.77-2.08-4.9-4.24-4.9-.98 0-1.87.45-2.59 1.19-.69-1.96-2.16-3.32-3.89-3.32-1.21 0-2.3.67-3.08 1.75-.29-1.29-1.17-2.23-2.22-2.23s-1.94.95-2.23 2.24c-.69-.62-1.51-.98-2.4-.98-1.12 0-2.13.59-2.89 1.52-.39-.4-.88-.65-1.41-.65-1.29 0-2.33 1.4-2.33 3.12 0 .14.02.28.03.42-.34-.26-.73-.42-1.14-.42-.76 0-1.42.49-1.85 1.24-.43-.75-1.09-1.24-1.85-1.24-1.29 0-2.33 1.4-2.33 3.12 0 .51.1.98.26 1.4-.28-.08.26.15 0 0-1.72-.97-6.63 1.16-1.63 8.66h37.51ZM71.98 34.95c2.03-1.47 4.08-.62 4.75 1.41 1.4-.13 2.71.63 3.18 1.83 3.17-.43 6.2 1.5 6.82 4.39.11.52.13 1.03.08 1.53 2.2.51 4.01 2.12 4.47 4.29.41 1.93-.35 3.81-1.82 5.04.8.38 1.42 1.06 1.61 1.93.27 1.24-.44 2.44-1.63 2.97.49.39.86.92 1 1.55.32 1.49-.75 2.93-2.39 3.21-.18.03-.36.04-.54.04.07.2.13.41.18.62.64 2.96-1.49 5.82-4.75 6.37-3.06.52-6.02-1.17-6.9-3.83-.37.14-.76.24-1.17.31-3.26.55-6.24-.78-6.87-3.74l3.99-27.91ZM34.96 57.39c.86 1.56 1.22 2.25 1.22 3.63 0 3.16-2.82 6.72-5.79 6.72-.37 0-.74-.04-1.09-.12-.27 2.89-2.56 5.15-5.35 5.15-2.97 0-5.38-2.57-5.38-5.73 0-.23.02-.45.04-.67-.16.03-.32.05-.49.05-1.5 0-2.71-1.29-2.71-2.89 0-.67.22-1.28.58-1.77-1.15-.34-1.99-1.44-1.99-2.77 0-.92.41-1.74 1.05-2.27-1.53-1.01-2.55-2.81-2.55-4.87 0-2.31 1.28-4.29 3.13-5.2-.14-.5-.21-1.04-.21-1.59 0-3.09 2.3-5.6 5.17-5.72.18-1.32 1.19-2.33 2.45-2.44l15.68-7.58-3.75 28.06ZM79.68 89.72c-1.06-2.75-2.59-5.44-4.8-7.51a42.32 42.32 0 0 0-2.05-1.79l-8.3-6.02c-2.24-2.12-2.74-2.04-2.85-6.17l-17.05.55c-.1 4.27-.57 3.49-2.87 5.65l-8.04 5.96c-.7.58-1.4 1.18-2.08 1.82-2.38 2.22-3.97 5.17-5.03 8.14 0 0 11.45 8.89 26.2 8.89s26.87-9.52 26.87-9.52Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.43 47.92s-10.46 2.32 2.9 20.58l-2.04 3.87-3.14 1.12-3.57-1.87-1.6-3.02v-1.31l-2.75-1.37-.27-2.01.49-1.08-1.93-2.69 1.02-2.2-2.19-2.92-.29-3.29 1.65-3.81.67-2.45 1.71-3.74 2.47-1.8 2.55-.77.51-1.32.86-.63.7 1.33 2.25 9.39ZM80.35 38.49s11.89 11.75-3.42 28.08l2.1 3.62 3.23 1.05 3.67-1.75 1.64-2.83v-1.22l1.66-2.28 1.44-.89-.5-1.01.2-2.92.74-1.64-.57-3.62 1.28-2.48.14-3.27-1.52-1.57-3.2-1.36-.78-3.22-2.11-2.05-.24-.57-.88-.08-1.01.07-1.88-.07ZM66.14 11.88c1.86 2.9 2.62 8.86-12.4 8.86-.8 0-4.53-2.15-18.17 3.58l-2.94 1.87-1.85-2.78-.71-3.82 2.78-1.3.97-1.72 1.88-3.17 5.22-.05 1.8-3.23 4.38-.37L50.55 9l2.9-.32 3.96.39 1.72-.06 2.33 1.94 2.31.16c.5.85 1.1-1.25 2.39.76Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.42 63.17c.64 2.96 3.62 4.3 6.87 3.74.41-.07.8-.18 1.17-.31.88 2.66 3.85 4.35 6.9 3.83 3.26-.55 5.38-3.41 4.75-6.37a6.32 6.32 0 0 0-.18-.62c.18 0 .36-.01.54-.04 1.64-.28 2.71-1.72 2.39-3.21-.13-.63-.5-1.16-1-1.55 1.19-.53 1.89-1.72 1.63-2.97-.19-.87-.8-1.55-1.61-1.93 1.48-1.23 2.24-3.11 1.82-5.04-.46-2.16-2.27-3.78-4.47-4.29.05-.5.03-1.01-.08-1.53-.62-2.89-3.64-4.82-6.82-4.39-.47-1.2-1.77-1.96-3.18-1.83-.66-2.03-2.72-2.88-4.75-1.41M69.9 26.55c1.98 1.5 4.4.04 4.79-1.61.36-1.53-.21-3.14-1.29-3.78 0-.09.02-.18.02-.28 0-1.51-.8-2.76-1.86-3.06-.19-1.47-1.14-2.58-2.29-2.58-.39 0-.76.14-1.08.37-.31-2.77-2.08-4.9-4.24-4.9-.98 0-1.87.45-2.59 1.19-.69-1.96-2.16-3.32-3.89-3.32-1.21 0-2.3.67-3.08 1.75-.29-1.29-1.17-2.23-2.22-2.23s-1.94.95-2.23 2.24c-.69-.62-1.51-.98-2.4-.98-1.12 0-2.13.59-2.89 1.52-.39-.4-.88-.65-1.41-.65-1.29 0-2.33 1.4-2.33 3.12 0 .14.02.28.03.42-.34-.26-.73-.42-1.14-.42-.76 0-1.42.49-1.85 1.24-.43-.75-1.09-1.24-1.85-1.24-1.29 0-2.33 1.4-2.33 3.12 0 .51.1.98.26 1.4-.28-.08.26.15 0 0-1.72-.97-6.63 1.16-1.63 8.66M35.4 57.69c.86 1.56 1.22 2.25 1.22 3.63 0 3.16-2.82 6.72-5.79 6.72-.37 0-.74-.04-1.09-.12-.27 2.89-2.56 5.15-5.35 5.15-2.97 0-5.38-2.57-5.38-5.73 0-.23.02-.45.04-.67-.16.03-.32.05-.49.05-1.5 0-2.71-1.29-2.71-2.89 0-.67.22-1.28.58-1.77-1.15-.34-1.99-1.44-1.99-2.77 0-.92.41-1.74 1.05-2.27-1.53-1.01-2.55-2.81-2.55-4.87 0-2.31 1.28-4.29 3.13-5.2-.14-.5-.21-1.04-.21-1.59 0-3.09 2.3-5.6 5.17-5.72.18-1.32 1.19-2.33 2.45-2.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.37 58.35c2.76 1.14 6.22-.9 7.74-4.55s.8-7.11-1.8-8.61c0 0-1.43-.9-3.43-.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.21 74.73c2.3-2.16 2.78-1.38 2.87-5.65M34.17 80.7c-.7.58-1.4 1.18-2.08 1.82-2.38 2.22-3.97 5.17-5.03 8.14M64.98 74.71c-2.24-2.12-2.74-2.04-2.85-6.17M73.27 80.73c.69.57 1.38 1.16 2.05 1.79 2.21 2.07 3.74 4.76 4.8 7.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.68 35.59c2.31 6.03 1.74 9.88 1.74 9.88 0 14.18-9.01 25.67-20.13 25.67S33.16 59.65 33.16 45.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.52 61.79c2.45.92 5.04.51 6.81-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.94 42.58c1.58-2.18 4.73-2.84 7.05-1.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.42 42.83c-1.41-2.29-4.5-3.19-6.92-2.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.23 46.22s.55 3.61 1.82 5.05c.01.02.03.03.04.05 1.03 1.21-.11 2.85-1.88 2.85-1.01 0-2.16.16-2.67.83M49.79 46.22s-.55 3.61-1.82 5.05c-.01.02-.03.03-.04.05-1.03 1.21.11 2.85 1.88 2.85 1.01 0 2.16.16 2.67.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.34 58.3c-1.72.71-3.56.2-5.17-1.18-1.7-1.47-2.93-3.76-3.01-6.01-.03-.93 0-2.15.26-3.18"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.69",
        cy: "44.74",
        r: "1.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.17",
        cy: "44.74",
        r: "1.83"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.57 75.81c-5.68 2.39-14.9 3.33-20.31.02-.14-.09-.34-.05-.51-.06-.35-1.17-3.74-.88-3.51.35.75 4.06 6.63 7.08 14.23 7.82 9.37.91 12.19-2.71 12.72-6.92.11-.87-1.46-1.7-2.61-1.22ZM32.92 26.52s-6.51-8.07-15.96-3.87c-.84.37-1.73.65-2.62.85-1.5.34-3.47.72-3.67.47 0 0 4.78 9.28 21.95 8.7 0 0-8.49-.87-8.84 2.94-.16 1.69.93 2.77.97 5.26s-1.35 4.64-2.02 5.48c0 0 17.61 3.67 9.89-13.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.96 23.23c-12.97-5.97-23.7-1.04-28.3 2.04-1.14.76-1.25 1.19-1.14 2.4l-.18 5.61c.07.81.39 1.43 1.24 1.02 0 0 38.24-6.54 28.39-11.07Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.71 77.49c5.18 0 9.42-1.42 11.18-2.12a1.78 1.78 0 0 1 1.7.21l6.02 4.36c.36.26.55.69.5 1.13-.21 1.81-2.14 4.3-.94 13.21M34.83 34.9c14.7-7.08 33.83-.46 36.86.69.21.08.43-.07.38-.26l-1.12-7.28c-.33-1.44-3.24-3.33-4.73-4.06-14.46-7.07-26.96-1.8-31.56 1.28-1.14.76-1.74 1.94-1.63 3.15l-.18 5.61c.07.81 1.14 1.28 1.98.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.92 27.12s-6.51-8.07-15.96-3.87c-.84.37-1.73.65-2.62.85-1.5.34-3.47.72-3.67.47 0 0 4.78 9.28 21.95 8.7 0 0-8.49-.87-8.84 2.94-.16 1.69.93 2.77.97 5.26s-1.35 4.64-2.02 5.48c0 0 17.61 3.67 9.89-13.67M53.57 77.49c-5.18 0-9.42-1.42-11.18-2.12a1.78 1.78 0 0 0-1.7.21l-6.02 4.36c-.36.26-.55.69-.5 1.13.21 1.81 2.23 4.6.97 14.16"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFirstNationsFemale104 = (AvatarFirstNationsFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarFirstNationsFemale56.tsx


var AvatarFirstNationsFemale56_excluded = ["className"];
function AvatarFirstNationsFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFirstNationsFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFirstNationsFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFirstNationsFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFirstNationsFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFirstNationsFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFirstNationsFemale56_objectSpread(AvatarFirstNationsFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.02 23.7c1.36 3.56 1.03 5.84 1.03 5.84 0 8.38-5.32 15.17-11.89 15.17s-11.89-6.79-11.89-15.17c0 0-.26-6.85 1.34-8.22 1.6-1.37 20.58 0 20.58 0l.83 2.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.24 23.3c8.68-4.19 19.99-.27 21.77.41.12.05.25-.04.23-.15l-.66-4.3c-.19-.85-1.91-1.97-2.8-2.4-8.54-4.18-15.93-1.06-18.65.75-.67.45-1.03 1.15-.96 1.86l-.11 3.32c.04.48.67.75 1.17.51Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.96 18.36c1.17.88 2.6.02 2.83-.95.21-.9-.13-1.86-.76-2.23 0-.06.01-.11.01-.17 0-.89-.47-1.63-1.1-1.81-.11-.87-.67-1.53-1.35-1.53-.23 0-.45.08-.64.22-.18-1.64-1.23-2.89-2.5-2.89-.58 0-1.1.27-1.53.7-.41-1.16-1.28-1.96-2.3-1.96-.72 0-1.36.4-1.82 1.03-.17-.76-.69-1.32-1.31-1.32s-1.15.56-1.32 1.32c-.41-.37-.89-.58-1.42-.58-.66 0-1.26.35-1.71.9-.23-.24-.52-.38-.83-.38-.76 0-1.38.83-1.38 1.84 0 .08.01.16.02.25-.2-.15-.43-.25-.68-.25-.45 0-.84.29-1.09.73-.25-.44-.65-.73-1.09-.73-.76 0-1.38.83-1.38 1.84 0 .3.06.58.15.83-.16-.04.15.09 0 0-1.02-.57-3.92.69-.97 5.11h22.16ZM40.45 23.51c1.2-.87 2.41-.36 2.81.83.83-.08 1.6.37 1.88 1.08 1.88-.25 3.66.88 4.03 2.59.07.3.08.61.05.9 1.3.3 2.37 1.26 2.64 2.53.24 1.14-.2 2.25-1.08 2.98.47.22.84.63.95 1.14.16.73-.26 1.44-.96 1.75.29.23.51.54.59.92.19.88-.44 1.73-1.41 1.9-.11.02-.22.02-.32.02.04.12.08.24.11.37.38 1.75-.88 3.44-2.8 3.76-1.81.31-3.56-.69-4.08-2.26-.22.08-.45.14-.69.18-1.92.33-3.69-.46-4.06-2.21l2.36-16.49ZM18.58 36.76c.51.92.72 1.33.72 2.14 0 1.87-1.67 3.97-3.42 3.97-.22 0-.43-.02-.64-.07-.16 1.71-1.51 3.04-3.16 3.04-1.76 0-3.18-1.52-3.18-3.39 0-.13 0-.27.02-.4-.09.02-.19.03-.29.03-.88 0-1.6-.76-1.6-1.71 0-.4.13-.76.34-1.05-.68-.2-1.18-.85-1.18-1.64 0-.55.24-1.03.62-1.34-.9-.6-1.51-1.66-1.51-2.88s.76-2.53 1.85-3.07c-.08-.3-.13-.61-.13-.94 0-1.83 1.36-3.31 3.06-3.38.11-.78.7-1.38 1.45-1.44l9.26-4.48-2.22 16.58Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.22 30.72s-6.28 1.39 1.74 12.37l-1.23 2.33-1.89.67-2.15-1.12-.96-1.82v-.79l-1.65-.83-.16-1.21.29-.65-1.16-1.61.61-1.32-1.31-1.75-.17-1.98 1.45-2.39-.06-1.38 1.03-2.25 1.49-1.08 1.53-.47.31-.79.52-.38.42.8 1.35 5.64ZM45.04 25.37s7.18 7.01-2.06 16.77l1.27 2.16 1.95.63 2.22-1.04.99-1.69v-.73l1-1.36.87-.53-.3-.6.12-1.74.45-.98-.34-2.16.77-1.48.08-1.95-.92-.94-1.93-.81-.47-1.92-1.27-1.23-.15-.34-.53-.05-.61.04-1.13-.04ZM36.87 9.7c1.11 1.73 1.56 5.29-7.4 5.29-.47 0-2.7-1.28-10.84 2.14l-1.75 1.12-1.1-1.66-.43-2.28 1.66-.77.58-1.03 1.12-1.89 3.12-.03 1.08-1.93 2.62-.22 2.06-.45 1.73-.19 2.36.23L32.71 8l1.39 1.16 1.38.09c.3.51.66-.75 1.42.45Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.09 40.2c.38 1.76 2.15 2.55 4.09 2.22.24-.04.47-.1.69-.19.52 1.58 2.29 2.58 4.1 2.27 1.94-.33 3.2-2.02 2.82-3.79a2.26 2.26 0 0 0-.11-.37c.11 0 .22 0 .32-.02.98-.17 1.61-1.02 1.42-1.91-.08-.37-.3-.69-.59-.92.71-.32 1.13-1.03.97-1.76-.11-.51-.48-.92-.95-1.15.88-.73 1.33-1.85 1.08-2.99-.28-1.28-1.35-2.25-2.66-2.55.03-.3.02-.6-.05-.91-.37-1.72-2.17-2.86-4.05-2.61-.28-.71-1.06-1.17-1.89-1.09-.4-1.21-1.62-1.71-2.82-.84M39.12 18.93c1.52.82 2.46-.48 2.69-1.45.21-.91-.13-1.87-.76-2.25 0-.06.01-.11.01-.17 0-.9-.47-1.64-1.11-1.82-.11-.87-.68-1.53-1.36-1.53-.23 0-.45.08-.64.22-.19-1.65-1.24-2.91-2.52-2.91-.58 0-1.11.27-1.54.71-.41-1.16-1.29-1.98-2.31-1.98-.72 0-1.37.4-1.83 1.04-.17-.77-.69-1.33-1.32-1.33s-1.15.56-1.32 1.33c-.41-.37-.9-.58-1.43-.58-.67 0-1.27.35-1.72.91-.23-.24-.52-.39-.84-.39-.77 0-1.39.83-1.39 1.85 0 .08.01.17.02.25-.2-.15-.43-.25-.68-.25-.45 0-.85.29-1.1.74-.25-.45-.65-.74-1.1-.74-.77 0-1.39.83-1.39 1.85 0 .3.06.58.15.83-.17-.05.15.09 0 0-1.02-.57-3.94.69-.97 5.15M18.46 36.94c.51.93.72 1.34.72 2.16 0 1.88-1.68 3.99-3.44 3.99-.22 0-.44-.02-.65-.07-.16 1.72-1.52 3.06-3.18 3.06-1.77 0-3.2-1.52-3.2-3.41 0-.14 0-.27.02-.4-.09.02-.19.03-.29.03-.89 0-1.61-.77-1.61-1.72 0-.4.13-.76.35-1.05-.68-.2-1.18-.86-1.18-1.65 0-.55.25-1.03.62-1.35-.91-.6-1.52-1.67-1.52-2.89s.76-2.55 1.86-3.09c-.08-.3-.13-.62-.13-.94 0-1.84 1.37-3.33 3.07-3.4.11-.78.42-1.56 1.17-1.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.84 37.33c1.64.68 3.7-.53 4.6-2.71.9-2.17.48-4.23-1.07-5.12 0 0-.85-.53-2.04-.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.03 23.8c1.37 3.58 1.04 5.87 1.04 5.87 0 8.43-5.36 15.26-11.97 15.26s-12.12-7.18-12.12-15.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.86 39.38c1.46.54 3 .31 4.05-.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.76 27.96c.94-1.29 2.81-1.69 4.19-.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.71 28.11c-.84-1.36-2.68-1.89-4.11-1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.25 30.12s.33 2.15 1.08 3l.03.03c.61.72-.07 1.7-1.12 1.7-.6 0-1.28.1-1.59.49M27.02 30.12s-.33 2.15-1.08 3l-.03.03c-.61.72.07 1.7 1.12 1.7.6 0 1.28.1 1.59.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.83 37.3c-1.02.42-2.12.12-3.07-.7-1.01-.87-1.74-2.24-1.79-3.57-.02-.55 0-1.28.15-1.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.4",
        cy: "29.33",
        r: "1.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.71",
        cy: "29.33",
        r: "1.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.49 18.81s-3.74-4.63-9.17-2.22c-.48.21-.99.37-1.51.49-.86.19-1.99.42-2.11.27 0 0 2.75 5.33 12.61 5 0 0-4.88-.5-5.08 1.69-.09.97.53 1.59.56 3.02s-.77 2.66-1.16 3.15c0 0 10.12 2.11 5.68-7.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.43 16.28c-8.19-3.77-14.97-.66-17.87 1.29-.72.48-.79.75-.72 1.51l-.12 3.55c.05.51.25.9.78.64 0 0 24.15-4.13 17.93-6.99Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.86 23.49c8.75-4.22 20.13-.27 21.93.41.12.05.25-.04.23-.15l-.66-4.33c-.2-.86-1.93-1.98-2.82-2.41-8.61-4.21-16.04-1.07-18.78.76-.68.45-1.03 1.15-.97 1.88l-.11 3.34c.04.48.68.76 1.18.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.73 18.86s-3.87-4.8-9.5-2.3c-.5.22-1.03.38-1.56.51-.89.2-2.07.43-2.19.28 0 0 2.85 5.52 13.06 5.18 0 0-5.05-.52-5.26 1.75-.09 1 .55 1.65.58 3.13.02 1.49-.8 2.76-1.2 3.26 0 0 10.48 2.18 5.88-8.13"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFirstNationsFemale56 = (AvatarFirstNationsFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarFirstNationsMale104.tsx


var AvatarFirstNationsMale104_excluded = ["className"];
function AvatarFirstNationsMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFirstNationsMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFirstNationsMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFirstNationsMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFirstNationsMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFirstNationsMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFirstNationsMale104_objectSpread(AvatarFirstNationsMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.44 37.16c1.51-.95 2.52-2.63 2.52-4.54s-1-3.59-2.51-4.54c1.04-.84 1.72-2.11 1.72-3.55a4.56 4.56 0 0 0-3.38-4.4c.27-.64.42-1.35.42-2.09 0-2.91-2.31-5.27-5.2-5.36-.11-1.59-1.43-2.86-3.05-2.86-.22 0-.44.03-.65.07-.79-1.32-2.22-2.22-3.88-2.22-.66 0-1.29.15-1.86.41a5.371 5.371 0 0 0-8.58-1.25 4.552 4.552 0 0 0-3.45-1.59c-1.96 0-3.62 1.24-4.28 2.97a5.35 5.35 0 0 0-2.98-.91c-2.81 0-5.11 2.16-5.35 4.9h-.02c-2.97 0-5.37 2.41-5.37 5.37 0 .74.15 1.45.42 2.09-1.94.53-3.38 2.29-3.38 4.4 0 1.27.52 2.42 1.35 3.25a6.242 6.242 0 0 0-1.45 4.02c0 1.19.33 2.29.91 3.24a5.392 5.392 0 0 0-2.05 4.24c0 2.31 1.44 4.27 3.47 5.05-.88.84-1.44 2.01-1.44 3.32 0 1.67.9 3.12 2.24 3.92-.05.21-.08.44-.08.66 0 1.7 1.37 3.07 3.07 3.07s3.07-1.37 3.07-3.07c0-.53-.15-1.02-.38-1.46.77-.82 1.25-1.91 1.25-3.13 0-1.78-1.02-3.3-2.51-4.07 1.3-.99 1.43-2.17 1.43-3.93 0-.7-.35-2.58-.59-3.19 1.93-1.07 2.77-1.14 3.72-3.94 1.01-3.01-.27-5.89-.75-6.79.61.3 1.28.49 2.01.49 2.09 0 3.83-1.42 4.35-3.35.5.19 1.04.31 1.61.31 1.44 0 2.7-.68 3.53-1.73.83 1.05 2.1 1.73 3.53 1.73s2.61-.63 3.44-1.61c.83.98 2.05 1.61 3.44 1.61.46 0 .9-.09 1.31-.22.41 2.64 2.69 4.67 5.44 4.67.3 0 .58-.03.87-.08a5.353 5.353 0 0 0 1.91 7.02c-1.05.84-1.98 3.38-1.79 4.81.34 2.62 1.84 3.38 2.53 4.18-.69.8-2.04 2.44-2.04 3.59 0 1.22.48 2.31 1.25 3.14-.71.56-1.18 1.42-1.18 2.4 0 1.7 1.37 3.07 3.07 3.07s3.07-1.37 3.07-3.07c0-.42-.09-.82-.24-1.19a4.56 4.56 0 0 0 3.19-4.35c0-1.15-.44-2.18-1.13-2.98.69-.8 1.13-1.84 1.13-2.98 0-1.45-.68-2.72-1.73-3.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.01 56.8c-.39 7.88-3.69 25.17-17.42 25.69 0 0-1.14.06-3.85 0-14.15-.31-17.03-17.81-17.42-25.69L30.3 25.29l23.27-12.34 18.17 13.37-.73 30.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.18 82.51c-1.91-5.62-3.97-9.27-8.17-13.03-.73-.65-1.46-1.25-2.05-1.6l.85 6.46c1.69-6.25-6.66-15.39-6.66-15.39l-39.24-.53s-8.35 9.13-6.66 15.39l.28-5.93c-.59.36-1.32.95-2.05 1.6-4.2 3.77-5.7 6.57-7.43 12.05 0 0 10.55 17.71 35.48 17.71s35.66-16.73 35.66-16.73Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.34 82.78s-1.18 1.98-2.89 0c-1.71-1.98-2.4-5.29-7.91-3.25-5.52 2.04-10.49 9.65-12.87 7.93-2.38-1.72 8.87-10.28 8.87-10.28l2.7-1.5 3.52-1.07.75-5 3.81 2.9 3.48 6.53.55 3.75ZM16.89 81.38s1.11 1.87 2.73 0c1.61-1.87 2.53-4.16 7.74-2.23 5.21 1.92 11.19 10.17 13.44 8.55 2.25-1.62-1.01-3.66-1.01-3.66l-4.76-4.5-9.54-5.97-.81-4.16-4.04 3.56-3.28 6.16-.46 2.26Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.92 21.8c-.81.95-2 1.57-3.35 1.57s-2.64-.67-3.45-1.69c-.81 1.02-2.04 1.69-3.45 1.69-.55 0-1.08-.11-1.57-.3-.51 1.88-2.21 3.27-4.25 3.27-.71 0-1.37-.18-1.96-.48.48.87 1.72 3.69.74 6.62-.92 2.73-1.74 2.8-3.63 3.84.24.6.58 2.43.58 3.12 0 1.72-.13 2.87-1.4 3.84 1.45.74 2.44 2.23 2.44 3.97 0 1.18-.47 2.25-1.22 3.05.23.43.38.91.38 1.42 0 1.66-1.34 3-3 3a2.996 2.996 0 0 1-2.93-3.65 4.453 4.453 0 0 1-2.19-3.83c0-1.28.54-2.42 1.4-3.24a5.283 5.283 0 0 1-1.39-9.07c-.56-.92-.88-2-.88-3.16 0-1.49.53-2.86 1.42-3.92a4.475 4.475 0 0 1-1.32-3.17c0-2.06 1.4-3.78 3.3-4.3-.27-.63-.41-1.32-.41-2.04 0-2.9 2.35-5.24 5.24-5.24h.02c.23-2.68 2.45-5.56 5.19-5.56 1.08 0 2.15.35 2.98.91.64-1.69 2.36-2.97 4.28-2.97 1.35 0 4.02.43 4.84 1.37 0 0 8.21 4.6 3.57 14.95ZM57.4 60.58l-3.04-1.18-2.18-.2-7.41 1.25-2.09 2.8-2.71-1.17-2.85-2.23-3.04-4.46-2.3 1.01.76 8.64 3.01 7.83 4.42 5.81 7.76 4.26h8.09l4.31-2.02c9.61-14.87-2.73-20.34-2.73-20.34Zm1.49 11.1c-1.48.7-2.63 1.13-4.53-.66h-4.55c-1.91 1.78-3.64 1.1-4.53.66-2.32-1.15-3.54-4.97-1.17-6.02 1.17-.57 7.94-3.49 7.98-3.52 0 0 1.7.74 3.55 1.54 1.85.81 3.85 1.69 4.43 1.98 1.7.65 1.16 4.9-1.17 6.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.86 58.68s-8.35 9.13-6.66 15.39c0 0 10.88 4.65 16.68 13.38 0 0 1.69-5.01-.15-7.23M87.13 82.78c-1.91-5.62-3.97-9.27-8.17-13.03-.73-.65-1.46-1.25-2.05-1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.1 59.21s8.35 9.13 6.66 15.39c0 0-10.8 4.65-16.6 13.38 0 0-2.37-5.15-.53-7.38M15.99 81.8c1.73-5.49 3.24-8.29 7.43-12.05.73-.65 1.46-1.25 2.05-1.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.66 32.47c.08-.03 6.51-2.24 13.22.1M47.03 36.26c.05-.02 4.37-1.51 8.87.06M59.15 52.68s2.27 2 1.72 5.76M41.97 58.47c-.67-3.74 1.53-5.81 1.53-5.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.04 44.46c1.54-2.13 4.63-2.78 6.9-1.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.03 44.71c-1.38-2.24-4.41-3.12-6.78-1.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.04 48.03s.54 3.54 1.78 4.94c.01.02.03.03.04.05 1.01 1.18-.11 2.8-1.84 2.8-.99 0-2.12.16-2.61.81M48.71 48.03s-.54 3.54-1.78 4.94c-.01.02-.03.03-.04.05-1.01 1.18.11 2.8 1.84 2.8.99 0 2.12.16 2.61.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.39 37.43c1.51-.95 2.52-2.63 2.52-4.54s-1-3.59-2.51-4.54c1.04-.84 1.72-2.11 1.72-3.55a4.56 4.56 0 0 0-3.38-4.4c.27-.64.42-1.35.42-2.09 0-2.91-2.31-5.27-5.2-5.36-.11-1.59-1.43-2.86-3.05-2.86-.22 0-.44.03-.65.07-.79-1.32-2.22-2.22-3.88-2.22-.66 0-1.29.15-1.86.41a5.371 5.371 0 0 0-8.58-1.25 4.552 4.552 0 0 0-3.45-1.59c-1.96 0-3.62 1.24-4.28 2.97a5.35 5.35 0 0 0-2.98-.91c-2.81 0-5.11 2.16-5.35 4.9h-.02c-2.97 0-5.37 2.41-5.37 5.37 0 .74.15 1.45.42 2.09-1.94.53-3.38 2.29-3.38 4.4 0 1.27.52 2.42 1.35 3.25a6.242 6.242 0 0 0-1.45 4.02c0 1.19.33 2.29.91 3.24a5.392 5.392 0 0 0-2.05 4.24c0 2.31 1.44 4.27 3.47 5.05-.88.84-1.44 2.01-1.44 3.32 0 1.67.9 3.12 2.24 3.92-.05.21-.08.44-.08.66 0 1.7 1.37 3.07 3.07 3.07s3.07-1.37 3.07-3.07c0-.53-.15-1.02-.38-1.46.77-.82 1.25-1.91 1.25-3.13 0-1.78-1.02-3.3-2.51-4.07 1.3-.99 1.43-2.17 1.43-3.93 0-.7-.35-2.58-.59-3.19 1.93-1.07 2.77-1.14 3.72-3.94 1.01-3.01-.27-5.89-.75-6.79.61.3 1.28.49 2.01.49 2.09 0 3.83-1.42 4.35-3.35.5.19 1.04.31 1.61.31 1.44 0 2.7-.68 3.53-1.73.83 1.05 2.1 1.73 3.53 1.73s2.61-.63 3.44-1.61c.83.98 2.05 1.61 3.44 1.61.46 0 .9-.09 1.31-.22.41 2.64 2.69 4.67 5.44 4.67.3 0 .58-.03.87-.08a5.353 5.353 0 0 0 1.91 7.02c-1.05.84-1.98 3.38-1.79 4.81.34 2.62 1.84 3.38 2.53 4.18-.69.8-2.04 2.44-2.04 3.59 0 1.22.48 2.31 1.25 3.14-.71.56-1.18 1.42-1.18 2.4 0 1.7 1.37 3.07 3.07 3.07s3.07-1.37 3.07-3.07c0-.42-.09-.82-.24-1.19a4.56 4.56 0 0 0 3.19-4.35c0-1.15-.44-2.18-1.13-2.98.69-.8 1.13-1.84 1.13-2.98 0-1.45-.68-2.72-1.73-3.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.69 82.75c-14.15-.31-17.03-17.81-17.42-25.69-.07-1.38 1.45-2.04 2.22-.97 2.32 3.24 6.28 8.1 8.19 6.4 2.99-2.66 5.92-3.29 8.13-3.29h1.37c2.22 0 5.56.63 8.56 3.29 1.91 1.7 5.69-3.16 8.01-6.4.76-1.07 2.28-.41 2.22.97-.39 7.88-3.69 25.17-17.42 25.69 0 0-1.14.06-3.85 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.29 71.69c-1.42.67-2.52 1.09-4.36-.63h-4.38c-1.83 1.72-3.5 1.06-4.36.63-2.23-1.1-3.4-4.78-1.12-5.78 1.12-.55 7.63-3.35 7.67-3.39s6.54 2.83 7.67 3.39c1.64.62 1.11 4.71-1.12 5.78Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.13 67.03c1.03.94 3.47 1.17 4.79-.05"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.42",
        cy: "47.22",
        r: "1.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.6",
        cy: "47.22",
        r: "1.79"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFirstNationsMale104 = (AvatarFirstNationsMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarFirstNationsMale56.tsx


var AvatarFirstNationsMale56_excluded = ["className"];
function AvatarFirstNationsMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarFirstNationsMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarFirstNationsMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarFirstNationsMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarFirstNationsMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarFirstNationsMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarFirstNationsMale56_objectSpread(AvatarFirstNationsMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.4 23.74c.96-.61 1.6-1.67 1.6-2.89s-.64-2.28-1.6-2.89c.66-.53 1.1-1.34 1.1-2.26 0-1.34-.91-2.46-2.15-2.8a3.407 3.407 0 0 0-3.04-4.74 1.954 1.954 0 0 0-1.94-1.82c-.14 0-.28.02-.41.05-.5-.84-1.41-1.41-2.47-1.41-.42 0-.82.1-1.18.26a3.422 3.422 0 0 0-5.46-.8 2.88 2.88 0 0 0-2.19-1.01c-1.25 0-2.3.79-2.72 1.89a3.41 3.41 0 0 0-5.3 2.54h-.02a3.418 3.418 0 0 0-3.15 4.75 2.907 2.907 0 0 0-1.29 4.87c-.58.69-.93 1.58-.93 2.56 0 .75.21 1.46.58 2.06-.79.63-1.3 1.61-1.3 2.7 0 1.47.92 2.72 2.21 3.22-.56.53-.91 1.28-.91 2.11 0 1.06.58 1.99 1.43 2.5-.03.14-.05.28-.05.42 0 1.08.88 1.95 1.95 1.95s1.95-.88 1.95-1.95c0-.34-.09-.65-.24-.93.49-.52.79-1.22.79-1.99 0-1.13-.65-2.1-1.59-2.59.83-.63.91-1.38.91-2.5 0-.45-.22-1.64-.38-2.03 1.23-.68 1.77-.73 2.37-2.51.65-1.91-.17-3.75-.48-4.32.39.19.82.31 1.28.31 1.33 0 2.44-.91 2.77-2.13.32.12.66.2 1.02.2.92 0 1.72-.44 2.25-1.1.53.67 1.33 1.1 2.25 1.1s1.66-.4 2.19-1.03c.53.62 1.31 1.03 2.19 1.03.29 0 .57-.06.84-.14a3.508 3.508 0 0 0 3.46 2.97c.19 0 .37-.02.55-.05a3.403 3.403 0 0 0 1.21 4.47c-.67.53-1.26 2.15-1.14 3.06.22 1.67 1.17 2.15 1.61 2.66-.44.51-1.3 1.56-1.3 2.28 0 .77.31 1.47.8 2-.45.36-.75.91-.75 1.53 0 1.08.88 1.95 1.95 1.95a1.959 1.959 0 0 0 1.8-2.71 2.909 2.909 0 0 0 2.03-2.77c0-.73-.28-1.39-.72-1.9.44-.51.72-1.17.72-1.9 0-.92-.43-1.73-1.1-2.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.21 36.24c-.25 5.01-2.35 16.02-11.09 16.35 0 0-.73.04-2.45 0-9.01-.2-10.84-11.34-11.09-16.35l-1.29-20.05L29.1 8.33l11.57 8.51-.47 19.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.8 13.93c-.52.61-.89.61-1.75.61s-1.21-.2-1.73-.85c-.52.65-2.16 1.25-3.06 1.25-.35 0-.69-.07-1-.19a2.802 2.802 0 0 1-2.71 2.08c-.45 0-.87-.12-1.25-.3.3.56 1.1 2.35.47 4.22-.59 1.74-1.11 1.78-2.31 2.45.15.38.37 1.55.37 1.99 0 1.09-.08 1.83-.89 2.45a2.84 2.84 0 0 1 1.56 2.53c0 .75-.3 1.44-.78 1.95.15.27.24.58.24.91a1.91 1.91 0 1 1-3.82 0c0-.14.02-.28.05-.41-.83-.5-1.4-1.4-1.4-2.44 0-.82.35-1.55.89-2.07a3.38 3.38 0 0 1-2.16-3.15c0-1.07.5-2.02 1.28-2.64-.36-.59-.56-1.28-.56-2.01 0-.95.34-1.82.91-2.5a2.841 2.841 0 0 1 1.26-4.76c-.17-.4-.26-.84-.26-1.3 0-1.85 1.63-3.89 3.48-3.89 0 0-.13.54-.12.54.15-1.71 1.56-3.54 3.31-3.54.69 0 1.37.22 1.9.58.41-1.08 1.51-1.89 2.73-1.89.86 0 2.56.27 3.09.88 0 0 5.24 2.93 2.28 9.53ZM31.78 38.42l-2.35-.51-1.39-.13-4.73.8-1.11 1.12-1.95-.08-1.52-1.78-2.23-2.48-.92.88.65 5.05 1.56 4.83 2.46 4.08 5.26 2.29 4.81-.03 2.79-.84c6.13-9.48-1.33-13.21-1.33-13.21Zm.55 7.31c-.94.44-1.67.72-2.89-.42h-2.9c-1.22 1.14-2.32.7-2.89.42-1.48-.73-2.26-3.17-.75-3.84.75-.37 5.06-2.22 5.09-2.24 0 0 1.09.47 2.26.98 1.18.52 2.45 1.08 2.83 1.26 1.09.41.74 3.13-.75 3.84Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.47 20.59s4.14-1.43 8.42.06M24.98 23s2.78-.96 5.64.04M32.69 33.45s1.44 1.27 1.1 3.66M21.76 37.13c-.43-2.38.97-3.7.97-3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.54 28.22c.98-1.36 2.95-1.77 4.39-.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.17 28.37c-.88-1.43-2.81-1.99-4.31-1.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.44 30.49s.34 2.25 1.13 3.14c0 .01.02.02.03.03.64.75-.07 1.78-1.17 1.78-.63 0-1.35.1-1.66.51M26.05 30.49s-.34 2.25-1.13 3.14c0 .01-.02.02-.03.03-.64.75.07 1.78 1.17 1.78.63 0 1.35.1 1.66.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.4 23.74c.96-.61 1.6-1.67 1.6-2.89s-.64-2.28-1.6-2.89c.66-.53 1.1-1.34 1.1-2.26 0-1.34-.91-2.46-2.15-2.8a3.407 3.407 0 0 0-3.04-4.74 1.954 1.954 0 0 0-1.94-1.82c-.14 0-.28.02-.41.05-.5-.84-1.41-1.41-2.47-1.41-.42 0-.82.1-1.18.26a3.422 3.422 0 0 0-5.46-.8 2.88 2.88 0 0 0-2.19-1.01c-1.25 0-2.3.79-2.72 1.89a3.41 3.41 0 0 0-5.3 2.54h-.02a3.418 3.418 0 0 0-3.15 4.75 2.907 2.907 0 0 0-1.29 4.87c-.58.69-.93 1.58-.93 2.56 0 .75.21 1.46.58 2.06-.79.63-1.3 1.61-1.3 2.7 0 1.47.92 2.72 2.21 3.22-.56.53-.91 1.28-.91 2.11 0 1.06.58 1.99 1.43 2.5-.03.14-.05.28-.05.42 0 1.08.88 1.95 1.95 1.95s1.95-.88 1.95-1.95c0-.34-.09-.65-.24-.93.49-.52.79-1.22.79-1.99 0-1.13-.65-2.1-1.59-2.59.83-.63.91-1.38.91-2.5 0-.45-.22-1.64-.38-2.03 1.23-.68 1.77-.73 2.37-2.51.65-1.91-.17-3.75-.48-4.32.39.19.82.31 1.28.31 1.33 0 2.44-.91 2.77-2.13.32.12.66.2 1.02.2.92 0 1.72-.44 2.25-1.1.53.67 1.33 1.1 2.25 1.1s1.66-.4 2.19-1.03c.53.62 1.31 1.03 2.19 1.03.29 0 .57-.06.84-.14a3.508 3.508 0 0 0 3.46 2.97c.19 0 .37-.02.55-.05a3.403 3.403 0 0 0 1.21 4.47c-.67.53-1.26 2.15-1.14 3.06.22 1.67 1.17 2.15 1.61 2.66-.44.51-1.3 1.56-1.3 2.28 0 .77.31 1.47.8 2-.45.36-.75.91-.75 1.53 0 1.08.88 1.95 1.95 1.95a1.959 1.959 0 0 0 1.8-2.71 2.909 2.909 0 0 0 2.03-2.77c0-.73-.28-1.39-.72-1.9.44-.51.72-1.17.72-1.9 0-.92-.43-1.73-1.1-2.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.67 52.59c-9.01-.2-10.84-11.34-11.09-16.35-.04-.88.93-1.3 1.41-.61 1.47 2.06 4 5.16 5.21 4.08 1.9-1.69 3.77-2.1 5.18-2.1h.87c1.41 0 3.54.4 5.45 2.1 1.22 1.08 3.62-2.01 5.1-4.08.48-.68 1.45-.26 1.41.61-.25 5.01-2.35 16.02-11.09 16.35 0 0-.73.04-2.45 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.15 45.55c-.9.43-1.61.69-2.77-.4h-2.79c-1.17 1.09-2.23.67-2.77.4-1.42-.7-2.16-3.04-.72-3.68.72-.35 4.86-2.13 4.88-2.15s4.17 1.8 4.88 2.15c1.04.39.71 3-.72 3.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.32 42.58c.65.6 2.21.75 3.05-.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.56",
        cy: "29.63",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.12",
        cy: "29.63",
        r: "1.05"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarFirstNationsMale56 = (AvatarFirstNationsMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarGirlPigTails104.tsx


var AvatarGirlPigTails104_excluded = ["className"];
function AvatarGirlPigTails104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarGirlPigTails104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarGirlPigTails104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarGirlPigTails104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarGirlPigTails104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarGirlPigTails104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarGirlPigTails104_objectSpread(AvatarGirlPigTails104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.42 88.88c-1-6.6-7.43-11.41-7.43-11.41-.7-.64-1.42-1.24-2.15-1.82l-.46-.33-3.64-3.31-.09-.16c-2.44-2.3-4.2-2.83-4.32-7.31l-18.88.28c-.11 4.64-1.82 4.4-4.31 6.74l-.48.44-3.64 3.31-.64.5c-.76.63-1.52 1.29-2.26 1.98 0 0-6.78 5.21-7.82 12.4 0 0 8.36 9.15 28.29 9.15s27.84-10.46 27.84-10.46Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.67 39.77c0 15.89-9.44 28.77-21.1 28.77s-21.1-12.88-21.1-28.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.51 14.87c-3.43-2.67-8.24-5.54-13.94-3.34-5.7-2.17-10.49.68-13.91 3.35-7.81 6.09-7.29 25.2-7.15 24.87 3.99-9.38 7.3-13.33 12.76-14 3.47-.43 6.08-1.32 8.33-2.38 2.25 1.06 4.84 1.96 8.3 2.38 5.46.67 8.77 4.61 12.76 14 .14.33.66-18.79-7.15-24.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.96 19.23-1.02-2.53c-.03-.12 2-2.55 7.76-2.39 3.42.1 7.39 1.78 7.19 9 0 7 .82 8.39 3.52 13.56 1.13 2.15 1.92 4.45 2.22 6.81.87 7.02-2.75 9.37-5.74 14.2-2.16 3.47 2.31 14.86 2.31 14.86s-12.84 0-15.28-9.84c0 0-1.23-3.56-1.48-5.74l4.79-21.89s4.21-12.63 2.72-15.74-6.98-.29-6.98-.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.48 39.77 4.94-16.26 16.27-6.61 17.39 10.09 3.59 12.78H30.48z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.87 35.96c-1.04-.29-2.1-.26-3.08.14-2.94 1.22-4 5.37-2.38 9.29 1.42 3.42 4.42 5.53 7.12 5.19"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.22 36.12 5.34-7.54 6.37-2.74 7.12-1.86 1.09-.49 3.65 1.41 6.69 1.42 4.93 3.48 3.24 5 1.28.25s-6.07-19.62-20.14-22.59C37.72 9.48 34.7 19.95 34.7 19.95l-2.47 8.47v7.71ZM75.3 30.88s9.83 2.74 9.37 11.53c-.44 8.39-3.64 7.77-5.12 10.93-2.85 6.09 5.12 18.6 5.12 18.6l-9.38-2.48-4.74-5.74-1.82-6.85 3.21-6.19 6.03-3.3 1.28-5.31-1.4-4.25-3.68-2.13 1.14-4.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.28 70.54 4.84-.72L27.54 68l4.17-4.36 2.12-6.63.41-1.71-1.7-4.27-5.07-2.83-2.83-5.87 1.17-4.62 2.05-1.68 1.93-.64-1.87-6.32-1.3-8.74 2.15-3 3.77.28 1.7-2.56-2.75-.57h-5.72l-3.57 1.66-1.64 5.02-.21 6.93-1.58 4.71-3.49 7.89-.1 6.51 4.61 8.13 1.47 2.93-.47 6.3-1.12 3.87-.39 2.11z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.78",
        cy: "41.42",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.78",
        cy: "41.42",
        r: "1.77"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.75 71.87c2.46-2.31 4.15-2.08 4.25-6.65M34.06 76.06c-.75.62-1.5 1.27-2.23 1.95 0 0-6.69 5.14-7.71 12.22M70 75.89c.71.57 1.42 1.17 2.11 1.79 0 0 6.34 4.73 7.33 11.24M65.86 72.15c-2.4-2.27-4.14-2.78-4.26-7.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.24 16.92c-.03-.12 1.97-2.51 7.65-2.35 3.37.1 7.28 1.76 7.08 8.87 0 6.9.81 8.27 3.47 13.36 1.11 2.12 1.89 4.38 2.18 6.71.86 6.91-2.71 9.24-5.66 13.99-2.13 3.42 2.27 14.64 2.27 14.64s-12.65 0-15.06-9.69c0 0-1.21-3.51-1.46-5.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.25 19.42s5.41-2.77 6.88.29-2.68 15.51-2.68 15.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.62 55.86c-.25 2.15-1.47 5.66-1.47 5.66C29.92 71.35 18 71.21 18 71.21s4.43-11.23 2.29-14.64c-2.97-4.76-6.55-7.08-5.69-13.99.29-2.33 1.08-4.59 2.2-6.71 2.68-5.09 3.49-6.46 3.49-13.36-.2-7.11 3.73-8.77 7.12-8.87 5.71-.16 7.73 2.23 7.7 2.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.25 34.81S26.1 22.36 27.57 19.3s6.88-.29 6.88-.29M72.91 39.65C72.91 55.31 63.6 68 52.12 68S31.33 55.31 31.33 39.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.27 36.31c-1.03-.28-2.07-.26-3.04.14-2.89 1.2-3.94 5.3-2.35 9.15 1.4 3.38 4.36 5.45 7.02 5.11M71.32 50.75c2.55.1 5.29-1.93 6.62-5.14 1.6-3.86.55-7.96-2.35-9.15-.91-.38-1.9-.42-2.88-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.17 41.68c0 4.13 2.69 4.32 2.69 6.7s-2.76 2.48-2.76 2.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.11 37.49c2.03-1.83 5.31-1.83 7.33 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.78 37.49c2.03-1.83 5.31-1.83 7.33 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.65 57.09c1.32 2.13 5.28 2.57 6.86-.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.85 15.13c-3.38-2.63-8.12-5.46-13.73-3.29-5.61-2.14-10.33.67-13.71 3.3-7.7 6-7.19 24.83-7.05 24.51 3.93-9.24 7.2-13.14 12.58-13.8 3.42-.42 5.99-1.3 8.2-2.35 2.21 1.05 4.77 1.93 8.18 2.35 5.38.66 8.64 4.54 12.58 13.8.14.33.65-18.52-7.05-24.51Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.37 72.48c-6.35 2.73-16.65 3.8-22.69.05-.16-.1-.38-.06-.57-.07-.39-1.33-4.17-.99-3.92.4.83 4.6 7.4 8.03 15.88 8.86 10.47 1.03 13.62-3.09 14.22-7.87.12-.99-1.63-1.93-2.91-1.38Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.23 74.35c5.52 0 10.03-1.52 11.91-2.27.6-.24 1.28-.16 1.81.23l3.59 3.26c.38.28.59.74.53 1.21-.22 1.93-4.53 2.35-2.29 19.81M52 74.35c-5.52 0-10.03-1.52-11.91-2.27a1.87 1.87 0 0 0-1.81.23l-3.59 3.26c-.38.28-.59.74-.53 1.21.22 1.93 4.91 2.93 1.14 20.08"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.15",
        y: "15.12",
        width: "6.59",
        height: "4.98",
        rx: "1.88",
        ry: "1.88",
        transform: "rotate(-60.15 34.446 17.607)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "67.16",
        y: "14.26",
        width: "5.11",
        height: "6.77",
        rx: "1.93",
        ry: "1.93",
        transform: "rotate(-32.49 69.715 17.651)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarGirlPigTails104 = (AvatarGirlPigTails104);
;// ./src/Picto/GeneratedPictoComponents/AvatarGirlPigTails56.tsx


var AvatarGirlPigTails56_excluded = ["className"];
function AvatarGirlPigTails56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarGirlPigTails56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarGirlPigTails56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarGirlPigTails56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarGirlPigTails56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarGirlPigTails56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarGirlPigTails56_objectSpread(AvatarGirlPigTails56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.4 24.75c0 9.41-5.6 17.05-12.5 17.05s-12.5-7.63-12.5-17.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.15 10c-2.03-1.58-4.88-3.28-8.26-1.98-3.38-1.29-6.21.4-8.25 1.99-4.63 3.61-4.32 14.93-4.24 14.74 2.37-5.56 4.33-7.9 7.56-8.3 2.06-.25 3.6-.78 4.93-1.41 1.33.63 2.87 1.16 4.92 1.41 3.24.4 5.2 2.73 7.56 8.3.08.2.39-11.13-4.24-14.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.2 12.59-.6-1.5c-.02-.07 1.19-1.51 4.6-1.41 2.03.06 4.38 1.06 4.26 5.33 0 4.15.49 4.97 2.09 8.03.67 1.28 1.14 2.64 1.31 4.04.52 4.16-1.63 5.55-3.4 8.42-1.28 2.05 1.37 8.8 1.37 8.8s-7.61 0-9.06-5.83c0 0-.73-2.11-.88-3.4l2.84-12.97s2.49-7.48 1.61-9.33c-.88-1.84-4.14-.17-4.14-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.39 24.75 2.93-9.63 9.64-3.92 10.3 5.98 2.14 7.57H15.39z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.35 22.82c-.62-.17-1.25-.15-1.83.09-1.74.72-2.37 3.19-1.41 5.5.84 2.03 2.62 3.28 4.22 3.07"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.67 23.49 3.36-4.82 2.78-1.92 5.71-1.02.69-.31 2.3.9 4.21.91 3.1 2.22 2.04 3.19.8.16S36.84 10.26 27.98 8.36s-10.76 4.79-10.76 4.79l-1.55 5.41v4.92ZM42.12 19.49s5.92 1.65 5.64 6.94c-.26 5.05-2.19 4.68-3.08 6.58-1.71 3.67 3.08 11.2 3.08 11.2l-5.65-1.49-2.85-3.46-1.1-4.12 1.93-3.73 3.39-2.13.96-3.05-.8-2.57-2.21-1.28.69-2.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m8.02 43.76 2.91-.43 2.06-1.09 2.51-2.62 1.28-4 .24-1.02-.84-2.76-3.24-1.52-1.7-3.54.71-2.77 1.23-1.02 1.65-.54-1.27-3.83-.66-5.1.83-1.78 3.81.63.8-.96-2.97-1.39-2.83-.28-2.77 1.28-.98 3.02-.13 4.18-.95 2.83-2.1 4.75-.06 3.92 2.78 4.89.88 1.77-.28 3.79-.68 2.33-.23 1.26z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.94 11.43c-.02-.07 1.17-1.49 4.54-1.4 2 .06 4.32 1.04 4.2 5.26 0 4.09.48 4.9 2.06 7.92.66 1.26 1.12 2.6 1.29 3.98.51 4.1-1.6 5.48-3.35 8.3-1.26 2.02 1.35 8.68 1.35 8.68s-7.5 0-8.93-5.75c0 0-.72-2.08-.87-3.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.54 12.91s3.21-1.64 4.08.17c.87 1.82-1.59 9.2-1.59 9.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.46 34.52c-.15 1.28-.87 3.36-.87 3.36-1.92 5.83-8.98 5.75-8.98 5.75s2.62-6.66 1.36-8.68c-1.76-2.82-3.89-4.2-3.37-8.3.17-1.38.64-2.72 1.3-3.98 1.59-3.02 2.07-3.83 2.07-7.92-.12-4.21 2.21-5.2 4.22-5.26 3.39-.09 4.58 1.32 4.56 1.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.87 22.03s-2.46-7.38-1.59-9.2c.87-1.82 4.08-.17 4.08-.17M40.53 24.86c0 9.47-5.63 17.15-12.58 17.15s-12.58-7.68-12.58-17.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.34 22.83c-.62-.17-1.25-.16-1.84.09-1.75.72-2.39 3.2-1.42 5.54.85 2.04 2.64 3.3 4.24 3.09M39.57 31.57c1.54.06 3.2-1.17 4.01-3.11.97-2.33.33-4.81-1.42-5.54-.55-.23-1.15-.26-1.74-.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 26.08c0 2.5 1.63 2.61 1.63 4.05s-1.67 1.5-1.67 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.3 23.55c1.23-1.11 3.21-1.11 4.44 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.17 23.55c1.23-1.11 3.21-1.11 4.44 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.46 35.4c.8 1.29 3.2 1.55 4.15-.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.26 10.02c-2.04-1.59-4.91-3.3-8.31-1.99-3.4-1.29-6.25.41-8.29 2-4.66 3.63-4.35 15.02-4.26 14.82 2.38-5.59 4.35-7.95 7.61-8.34 2.07-.25 3.62-.79 4.96-1.42 1.34.63 2.89 1.17 4.95 1.42 3.26.4 5.23 2.75 7.61 8.34.08.2.39-11.2-4.26-14.82Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.46",
        cy: "25.61",
        r: "1.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.44",
        cy: "25.61",
        r: "1.14"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "15.02",
        y: "9.89",
        width: "4.09",
        height: "3.09",
        rx: "1.16",
        ry: "1.16",
        transform: "rotate(-60.15 17.068 11.44)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.33",
        y: "9.47",
        width: "3.17",
        height: "4.2",
        rx: "1.2",
        ry: "1.2",
        transform: "rotate(-32.49 38.91 11.56)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarGirlPigTails56 = (AvatarGirlPigTails56);
;// ./src/Picto/GeneratedPictoComponents/AvatarHatAndSunglasses104.tsx


var AvatarHatAndSunglasses104_excluded = ["className"];
function AvatarHatAndSunglasses104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarHatAndSunglasses104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarHatAndSunglasses104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarHatAndSunglasses104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarHatAndSunglasses104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarHatAndSunglasses104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarHatAndSunglasses104_objectSpread(AvatarHatAndSunglasses104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.22 35.45c3.22 19.89-9.26 35.63-20.94 35.63S29.3 54.69 31.13 35.45l17.16-12.87 16.64.26 8.29 12.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.13 37.53c-1.09-.3-2.19-.27-3.21.15-3.06 1.27-4.17 5.61-2.48 9.69 1.48 3.57 4.62 5.77 7.43 5.41M72.53 52.82c2.7.1 5.6-2.05 7.01-5.44 1.69-4.08.58-8.42-2.48-9.69-.97-.4-1.63-.6-2.66-.35M72.35 28.01S74.36 6.97 52.27 6.97 32.19 28.01 32.19 28.01s-4.02 5.74 0 7.65c4.02 1.91 14.05-5.74 20.08-5.74s16.06 7.65 20.08 5.74c4.02-1.91 0-7.65 0-7.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.92 76.61s3.56-1.42 8.43-3.66c-.94-.14-2.75-1.63-3.09-2.53l5.87-1.28c-2.04-.79-3.05-2.9-3.05-2.9 1.12.12 5.56.62 7.2-2.4s-6.16-1.4-7.03-6.19c-1.08-5.95-.96-5.27-.96-5.27L55.04 66.56l3.99 13.25 5.9-3.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.26 89.04c-3.15-4.62-11.32-9.58-11.32-9.58l.55.34c-6.2-4.1-5.85-4.08-6.59-11.9l-18.89-.23c-.82 7.61-2.06 8.5-8.79 11.8 0 0-8.76 6.61-10 9.58 0 0 10.31 10.2 27.36 10.2s27.68-10.2 27.68-10.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m66.49 35.86-.16.15c-.64-.72-1.82-1.05-2.74-.19-2.64 2.45-5.76 4.54-7.94 7.36-.37.47 1.65 2.92 1.65 2.92.57.87 1.9 1.35 2.91.42 2.98-2.74 5.95-5.48 8.93-8.22 0 0-1.95-3.06-2.64-2.44ZM46.82 35.86l-.16.15c-.64-.72-1.82-1.05-2.74-.19-2.64 2.45-5.3 4.91-7.94 7.36 0 0 .92 3.06 1.65 2.92.57.87 1.9 1.35 2.91.42 2.98-2.74 5.95-5.48 8.93-8.22l-2.64-2.44ZM65.01 81.58s2.27.23.4 3.63c-3.2 5.83-19.44 12.24-30.34 5.27-12.2-7.8-.74-11.38-.74-11.38s6.35 6.48 13.77 6.74c9.63.33 7.37-.25 16.91-4.26Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.92 54.16 2.18 4.64 2.11 3.24 5.51 5.94-1.29 4.38-2.68 3.93-6.23-3.45 2.28-2.58-4.96-1.63 2-2.92-5.1-.73-1.8-1.87 5.83-2.62 2.15-6.33zM71.62 54.89l-1.99 3.95-2.32 3.85-5.58 4.89 1.04 4.97 1.24 3.74 4.29-1.99 2.28-1.26.37-.44-.54-.87-.95-1.74-.13-.51s3.05-1.7 2.29-14.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.12 7.33c-3.44.36-8.64 2.04-11.06 4.6-3.04 3.21-4.05 6.88-5.04 11.93-.35 1.81.11 3.61 1.3 2.64.26.07 1.74-.89 2.03-.97 1.81-.47 3.64-.92 5.45-1.39.76-.2 2.86-.26 2.92-.9 2.36-.36 3.16-.89 5.28-.98 4.7-.21 9.3.09 13.83 1.38 1.11.32 2.22-.55 2.22-1.65.07-8.92-7.86-15.61-16.94-14.66Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.75 76.29s.96.21-6.95-3.65c.94-.14 2.75-1.63 3.09-2.53l-5.87-1.28c2.04-.79 3.05-2.9 3.05-2.9-1.12.12-5.56.62-7.2-2.4s7.23-1.33 7.03-6.19l-.2-4.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.76 76.29s3.56-1.42 8.43-3.66c-.94-.14-2.75-1.63-3.09-2.53l5.87-1.28c-2.04-.79-3.05-2.9-3.05-2.9 1.12.12 5.56.62 7.2-2.4s-6.16-1.4-7.03-6.19c-1.08-5.95-.96-5.27-.96-5.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.05 35.13c3.22 19.89-9.26 35.63-20.94 35.63S29.13 54.37 30.96 35.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.97 37.21c-1.09-.3-2.19-.27-3.21.15-3.06 1.27-4.17 5.61-2.48 9.69 1.48 3.57 4.62 5.77 7.43 5.41M72.37 52.5c2.7.1 5.6-2.05 7.01-5.44 1.69-4.08.58-8.42-2.48-9.69-.97-.4-1.63-.6-2.66-.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.72 59.36c1.4 2.25 5.59 2.72 7.26-.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.06 79.14c6.72-3.29 7.97-4.18 8.79-11.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.73 67.58c.74 7.82.39 7.8 6.59 11.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.14 40.7c0 4.48-3.4 7.18-7.6 7.18s-6.59-1.61-6.59-6.08c0-4.1.83-6.5 6.21-6.5 4.1 0 7.96.26 7.96 5.38h.01ZM54.55 40.7c0 4.48 3.4 7.18 7.6 7.18s6.59-1.61 6.59-6.08c0-4.1-.83-6.5-6.21-6.5-4.1 0-7.96.26-7.96 5.38h-.01ZM50.14 40.7c0-1.3.99-1.77 2.2-1.77s2.2.47 2.2 1.77M29.83 35.6l6.14 4.1M74.88 35.6l-6.14 4.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.1 88.72c-3.15-4.62-11.32-9.58-11.32-9.58-4.07 4.42-9.72 7.52-16.49 7.6-5.47-.1-13.16-3.18-17.23-7.6 0 0-8.76 6.61-10 9.58"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.19 27.69S74.2 6.65 52.11 6.65 32.03 27.69 32.03 27.69s-4.02 5.74 0 7.65c4.02 1.91 14.05-5.74 20.08-5.74s16.06 7.65 20.08 5.74c4.02-1.91 0-7.65 0-7.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.5 27.28s19.66-11.24 39.31 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.63 40.84c0 4.14 3.35 4.34 3.35 6.72s-3.43 2.49-3.43 2.49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarHatAndSunglasses104 = (AvatarHatAndSunglasses104);
;// ./src/Picto/GeneratedPictoComponents/AvatarHatAndSunglasses56.tsx


var AvatarHatAndSunglasses56_excluded = ["className"];
function AvatarHatAndSunglasses56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarHatAndSunglasses56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarHatAndSunglasses56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarHatAndSunglasses56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarHatAndSunglasses56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarHatAndSunglasses56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarHatAndSunglasses56_objectSpread(AvatarHatAndSunglasses56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.88 22.96c2.04 12.65-5.87 22.66-13.27 22.66S13.04 35.2 14.21 22.96l10.88-8.19 10.54.16 5.26 8.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.42 24.81c-.7-.19-1.41-.17-2.06.1-1.97.81-2.68 3.57-1.59 6.16.95 2.27 2.96 3.67 4.77 3.44M40.32 34.57c1.73.07 3.6-1.3 4.5-3.46 1.09-2.6.37-5.36-1.59-6.16-.62-.25-1.04-.38-1.71-.22M40.32 18.22s1.29-13.38-12.9-13.38-12.9 13.38-12.9 13.38-2.58 3.65 0 4.87c2.58 1.21 9.03-3.65 12.9-3.65s10.32 4.87 12.9 3.65c2.58-1.21 0-4.87 0-4.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.03 49.09s1.8-.18 4.93-1.61c-.6-.09-1.77-1.04-1.99-1.61l3.77-.81c-1.31-.5-1.96-1.85-1.96-1.85.72.08 3.57.39 4.62-1.53s-3.95-.89-4.51-3.94c-.69-3.79-.62-3.35-.62-3.35l-9.71 8.74 2.21 3.69 3.26 2.27Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.26 36.98 1.46 2.2L18.99 41l5.21 4.47-2.49 2.71-3.54.38-2.01-1.52 1.38-1.45-2.99-.91 1.2-1.63-3.07-.41-1.09-1.05 3.15-1.09 1.52-3.52zM40.28 35.41l-1.53 2.75-1.79 2.68-2.52 2.65-2.76 1.75 2.92 3.3 3.12.37 1.76-.88.29-.31.61-.36-1.27-1.29-.33-.46s2.09-1.24 1.5-10.21Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.35 45.2s-2.86 6.64-8.67 2.15c.58-.09 1.69-1 1.89-1.55l-3.59-.78c1.25-.48 1.87-1.78 1.87-1.78-.69.07-3.4.38-4.41-1.47s4.43-.81 4.3-3.79c-.12-2.88-.13-3.18-.13-3.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.72 45.07c3.97 7.02 9.31 2.28 9.31 2.28-.58-.09-1.69-1-1.89-1.55l3.59-.78c-1.25-.48-1.87-1.78-1.87-1.78.69.07 3.4.38 4.41-1.47s-3.77-.86-4.3-3.79c-.66-3.64-.59-3.23-.59-3.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.81 23.75c2.01 12.18-5.8 21.82-13.1 21.82S13.33 35.53 14.48 23.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.85 25.02c-.68-.18-1.37-.17-2.01.09-1.92.78-2.61 3.43-1.55 5.93.93 2.19 2.89 3.53 4.65 3.31M40.38 34.38c1.69.06 3.51-1.25 4.39-3.33 1.06-2.5.36-5.16-1.55-5.93-.6-.25-1.02-.37-1.66-.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.54 24.06-.1.09c-.39-.44-1.12-.64-1.68-.12-1.62 1.5-3.53 2.78-4.86 4.5-.22.29 1.01 1.79 1.01 1.79.35.53 1.16.83 1.78.26 1.82-1.68 3.64-3.35 5.46-5.03 0 0-1.19-1.87-1.62-1.49ZM24.51 24.06l-.1.09c-.39-.44-1.12-.64-1.68-.12l-4.86 4.5s.56 1.87 1.01 1.79c.35.53 1.16.83 1.78.26 1.82-1.68 3.64-3.35 5.46-5.03l-1.62-1.49Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.34 26.75c0 2.8-2.13 4.5-4.76 4.5s-4.13-1.01-4.13-3.81c0-2.57.52-4.07 3.89-4.07 2.57 0 4.99.17 4.99 3.37ZM29.1 26.75c0 2.8 2.13 4.5 4.76 4.5s4.13-1.01 4.13-3.81c0-2.57-.52-4.07-3.89-4.07-2.57 0-4.99.17-4.99 3.37ZM26.34 26.75c0-.81.62-1.11 1.38-1.11s1.38.29 1.38 1.11M13.61 23.56l3.85 2.56M41.84 23.56l-3.85 2.56"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.14 4.9c-2.29.25-5.75 1.4-7.36 3.15-2.02 2.2-2.7 4.72-3.35 8.19-.23 1.24.07 2.47.87 1.81.17.04 1.16-.61 1.35-.66 1.21-.32 2.42-.63 3.63-.95.51-.13 1.9-.18 1.94-.62 1.57-.25 2.1-.61 3.51-.67 3.13-.14 6.19.06 9.2.95.74.22 1.47-.38 1.47-1.13.04-6.12-5.23-10.71-11.27-10.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.59 38.58c.88 1.38 3.5 1.67 4.54-.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.67 18.54S41.98 4.77 27.53 4.77 14.39 18.54 14.39 18.54s-2.63 3.76 0 5.01 9.2-3.76 13.14-3.76 10.51 5.01 13.14 3.76c2.63-1.25 0-5.01 0-5.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.51 18.5s13.03-7.45 26.05 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.07 26.56c0 3.08 2.49 3.22 2.49 4.99s-2.55 1.85-2.55 1.85"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarHatAndSunglasses56 = (AvatarHatAndSunglasses56);
;// ./src/Picto/GeneratedPictoComponents/AvatarHijabFemale104.tsx


var AvatarHijabFemale104_excluded = ["className"];
function AvatarHijabFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarHijabFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarHijabFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarHijabFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarHijabFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarHijabFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarHijabFemale104_objectSpread(AvatarHijabFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.95 15.29c-3.7 4.46-5.68 9.98-5.93 15.52-.23 5.17.99 10.35 3.22 15.12 1.99 4.27 2.99 9.76 1.85 14.33-.73 2.92-2.09 5.68-3.57 8.36-1.39 2.51-2.93 5.23-2.23 7.95.81 3.16 4.04 4.74 7.01 6.18a47.76 47.76 0 0 0 10.05 3.54c7 1.62 14.45 1.73 21.47.17l.21-.05c4.58-1.04 9.14-2.87 12.11-6.13 1.82-1.99 2.9-4.57 2.86-7.14-.05-3.08-2.2-5.23-3.58-7.9-1.53-2.95-2.03-6.25-1.97-9.5.19-9.53 4.79-18.79 3.37-28.38-1.66-11.24-12.83-22.15-26.3-21.39-6.79.38-13.22 3.55-17.57 8.18-.35.37-.68.75-1 1.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.41 83.87c-1.19-2.85-2.92-5.69-5.41-7.96l-53.89.32c-2.49 2.27-4.22 5.11-5.41 7.96 0 0 8.82 15.05 33.81 15.05 21.72 0 30.9-15.37 30.9-15.37Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m44.63 86.83 2.91 1.01c-4.34 5.37-16.38 3.52-25.09-3.57-3.71-3.02 2.83-7.71 2.83-7.71s3.86 5.35 9.43 7.45c7.22 2.73.48.19 9.92 2.82Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.24 64.67c-.73-.52-2.77-.3-5.24-1.78-3.87-2.32-4.93-5.55-7.32-9.1-4.75-7.07-5.02-19.15-1.99-26.96 1.14-2.93 2.34-5.92 4.37-8.48 1.35-1.7 3.15-3.04 5.17-4.08 1.7-.87 3.52-1.53 5.35-2.14 1.23-.4 2.59-.69 3.77-1.21.99-.44 1.92-3.87.04-4.78-.71-.34.04-.38-.86-.48-.49-.06-1-.02-1.49 0-7.85.37-15.26 5.24-18.27 9.7-.25.37-.94 1.12-1.14 1.51-.36.44-1 2.71-1.23 3.22-2.93 6.45-3.71 11.72-2.39 18.64.57 2.97 2.96 6.13 3.84 9.05 1.42 7.92 1.21 12.29-1.84 19.18-.76 1.71-3.09 5.14-3.16 6.81-.42 1.71-.52 4.06.78 5.74.21.27 1.6 1.1 1.89 1.21 1.87 2.58 3.71 2.54 6.82 3.83.53.22 12.72 2.91 13.12 2.75 0 0 14.37-12.25-.22-22.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.76 11.44c.18.03.37.08.54.15 1.06.41 1.31 1.63 1.18 2.67-.4 3.05-3.2 4.65-5.62 5.92-1.94 1.01-5.12 1.77-7.05 2.81-.29.15-.58.31-.86.46l-4.82 2.91c.14-.08.27-.94.32-1.09.31-.95.68-1.88 1.1-2.78 1.28-2.75 3.06-5.3 5.36-7.27 1.35-1.16 2.87-2.1 4.51-2.76.9-.37 1.83-.65 2.77-.85.81-.17 1.73-.33 2.58-.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79 75.91c2.49 2.27 4.22 5.11 5.41 7.96M25.11 76.23c-2.49 2.27-4.22 5.11-5.41 7.96"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.32 27.53c-3.31-9.03-10.23-15.82-18.21-15.82s-15.15 7.12-18.46 16.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.95 15.29c-3.7 4.46-5.68 9.98-5.93 15.52-.23 5.17.99 10.35 3.22 15.12 1.99 4.27 2.99 9.76 1.85 14.33-.73 2.92-2.09 5.68-3.57 8.36-1.39 2.51-2.93 5.23-2.23 7.95.81 3.16 4.04 4.74 7.01 6.18a47.76 47.76 0 0 0 10.05 3.54c7 1.62 14.45 1.73 21.47.17l.21-.05c4.58-1.04 9.14-2.87 12.11-6.13 1.82-1.99 2.9-4.57 2.86-7.14-.05-3.08-2.2-5.23-3.58-7.9-1.53-2.95-2.03-6.25-1.97-9.5.19-9.53 4.79-18.79 3.37-28.38-1.66-11.24-12.83-22.15-26.3-21.39-6.79.38-13.22 3.55-17.57 8.18-.35.37-.68.75-1 1.13Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.1 40.33c0 4.11 2.68 4.3 2.68 6.66s-2.74 2.46-2.74 2.46M41.14 36.65c1.75-2.08 4.99-2.52 7.23-.98M55.77 35.49c2.32-1.41 5.53-.79 7.16 1.38M50.23 56.2c2.17 1.23 4.47.11 5.47-.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.65 28.23c.94 3.17 1.46 6.64 1.46 10.27 0 15.11-8.98 27.36-20.06 27.36S31.99 53.61 31.99 38.5c0-3.45.47-6.76 1.33-9.8.05-.19.12-.37.21-.55.2-.41.48-.77.83-1.05 3.16-2.54 19.54-14.3 35.93.45l.36.67Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.06",
        cy: "40.03",
        r: "1.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.35",
        cy: "40.03",
        r: "1.86"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarHijabFemale104 = (AvatarHijabFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarHijabFemale56.tsx


var AvatarHijabFemale56_excluded = ["className"];
function AvatarHijabFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarHijabFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarHijabFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarHijabFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarHijabFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarHijabFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarHijabFemale56_objectSpread(AvatarHijabFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.52 9.86c-2.11 2.53-3.23 5.68-3.38 8.83-.13 2.94.56 5.89 1.83 8.6 1.13 2.43 1.7 5.55 1.05 8.15-.41 1.66-1.19 3.23-2.03 4.76-.79 1.43-1.67 2.98-1.27 4.53.46 1.8 2.3 2.69 3.99 3.52 1.8.88 3.73 1.55 5.72 2.01 3.98.92 8.22.98 12.22.09l.12-.03c2.61-.59 5.2-1.63 6.89-3.49 1.03-1.13 1.65-2.6 1.63-4.06-.03-1.75-1.25-2.97-2.04-4.5-.87-1.68-1.16-3.56-1.12-5.4.11-5.42 2.73-10.69 1.92-16.14-.95-6.39-7.3-12.6-14.96-12.17-3.86.22-7.52 2.02-9.99 4.65-.2.21-.39.43-.57.65Z",
      className: "fillprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.72 38.08c-.41-.29-1.57-.17-2.97-1.01-2.19-1.31-2.8-3.15-4.15-5.16-2.7-4.01-2.85-10.87-1.13-15.3.64-1.66 1.33-3.36 2.48-4.81.77-.96 1.79-1.73 2.93-2.32.96-.49 2-.87 3.04-1.21.7-.23 1.47-.39 2.14-.68.56-.25 1.09-2.2.02-2.71-.4-.19.02-.21-.49-.27-.28-.03-.57 0-.85 0-4.46.21-8.66 2.97-10.36 5.5-.14.21-.53.64-.65.86-.21.25-.56 1.54-.7 1.83-1.66 3.66-2.11 6.65-1.36 10.58.32 1.68 1.68 3.48 2.18 5.13.81 4.5.68 6.97-1.04 10.88-.43.97-1.75 2.91-1.79 3.86-.24.97-.29 2.31.44 3.26.12.15.91.63 1.07.68 1.06 1.46 2.11 1.44 3.87 2.17.3.13 7.22 1.65 7.45 1.56 0 0 8.16-6.95-.13-12.84Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.69 7.89c.11.02.21.05.31.09.61.23.76.92.68 1.52-.23 1.73-1.85 2.64-3.26 3.36-1.13.57-2.97 1-4.09 1.59-.17.09-.33.18-.5.26l-2.79 1.65c.08-.05.15-.53.18-.62.18-.54.39-1.06.64-1.58.75-1.56 1.78-3.01 3.11-4.12.78-.66 1.67-1.19 2.62-1.57.52-.21 1.06-.37 1.61-.48.47-.1 1-.19 1.49-.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.76 16.61c-1.93-5.26-5.96-9.21-10.6-9.21s-8.82 4.15-10.75 9.42",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.18 23.9c0 2.38 1.56 2.49 1.56 3.86s-1.59 1.43-1.59 1.43M21.82 21.77c1.02-1.2 2.89-1.46 4.19-.57M30.3 21.1c1.35-.82 3.21-.46 4.15.8M27.09 33.11c1.26.71 2.59.06 3.17-.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.93 16.89c.55 1.84.85 3.85.85 5.96 0 8.76-5.21 15.86-11.63 15.86s-11.63-7.1-11.63-15.86c0-2 .27-3.92.77-5.68.03-.11.07-.21.12-.32.11-.24.28-.45.48-.61 1.83-1.47 11.33-8.29 20.84.26l.21.39Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.02",
        cy: "23.9",
        r: "1.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.27",
        cy: "23.9",
        r: "1.01"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.52 9.93c-2.11 2.53-3.23 5.68-3.38 8.83-.13 2.94.56 5.89 1.83 8.6 1.13 2.43 1.7 5.55 1.05 8.15-.41 1.66-1.19 3.23-2.03 4.76-.79 1.43-1.67 2.98-1.27 4.53.46 1.8 2.3 2.69 3.99 3.52 1.8.88 3.73 1.55 5.72 2.01 3.98.92 8.22.98 12.22.09l.12-.03c2.61-.59 5.2-1.63 6.89-3.49 1.03-1.13 1.65-2.6 1.63-4.06-.03-1.75-1.25-2.97-2.04-4.5-.87-1.68-1.16-3.56-1.12-5.4.11-5.42 2.73-10.69 1.92-16.14-.95-6.39-7.3-12.6-14.96-12.17-3.86.22-7.52 2.02-9.99 4.65-.2.21-.39.43-.57.65Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarHijabFemale56 = (AvatarHijabFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarLady104.tsx


var AvatarLady104_excluded = ["className"];
function AvatarLady104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLady104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLady104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLady104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLady104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLady104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLady104_objectSpread(AvatarLady104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.14 77.16c-12.91-5.12-14.13-18.27-14.13-18.27C21.93 41 20.17 8.36 49.32 5.12c14.83-2.03 21.73 8.08 24.15 14.72 2.23 6.13 3.9 13.15 5.98 23.36.8 3.95 1.78 7.87 2.81 11.76 1.6 6.07 2.62 18.66-14.82 22.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.96 41.6c.06-12.92-8.87-25.07-19.93-25.07S32 28.65 32 43.59v-.6c-.06 12.92 8.87 25.07 19.93 25.07S71.96 55.94 71.96 41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.69 76.89c-3.82-2.64-5.31-5.65-5.31-12.04l-18.18.77c0 5.99-1.56 8.71-5.38 11.19 0 0-17.7 10.71-17.93 11.8 0 0 12.03 10.63 32.11 10.63s31.82-10.66 31.82-10.66L66.69 76.89Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.28",
        cy: "43.05",
        r: "1.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.8",
        cy: "43.05",
        r: "1.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.57 14.86c-5.59-5.09-15.28-9.52-23.04-6.43-7.63 3.03-12.46 10.21-15.04 17.29-3.23 8.82-2.96 19.39-2.51 28.63.21 4.26.48 12.18 3.88 15.22 3.33 2.98 5.91 5.93 10.2 7.19.73.21 4.55-3.57 4.94-4.15 1.17-1.7.52-6.06.07-6.52-10.9-10.61-10.62-17.14-10.63-17.36-.17-1.7.45-6.14.82-7.93.86-4.02 2.22-11.79 5.09-15.35.33-.42 3.19-3.15 4.12-4.31.6-.74 2.91-2.79 2.94-2.74 8 12.84 12.06 9.18 24.1 12.62.13.07 2.25 3.31 2.36 3.76.59 1.43 1.56 1.3 1.54-.51-.09-7.35-3.23-14.3-8.86-19.43v.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.57 77.36c-3.82-2.64-5.31-5.65-5.31-12.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.14 34.12c.46 2.28.7 4.67.7 7.14 0 15.06-9.04 27.27-20.2 27.27-7.31 0-13.7-5.32-17.24-13.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.69 43.08c0 4.07 2.66 4.26 2.66 6.6s-2.72 2.44-2.72 2.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.8 38.95c2-1.81 5.23-1.81 7.23 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.26 38.95c2-1.81 5.23-1.81 7.23 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.83 58.82c2.15 1.22 4.43.11 5.42-.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.02 77.62c-12.71-4.57-14.15-14.77-14.77-20.28-.7-6.25-4.47-48.71 26.95-51.76 14.83-2.03 21.73 8.08 24.15 14.72 2.23 6.13 3.9 13.15 5.98 23.36.8 3.95 1.78 7.87 2.81 11.76 1.6 6.07 2.62 18.66-14.82 22.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.77 38.95c-.3-9.97-4.44-8.16-13.38-9.77-10.04-1.8-13.42-11.23-13.42-11.23h.01S29.23 27.34 32.26 48.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.84 41.47c0 14.95-8.97 27.06-20.03 27.06s-20-12.15-19.93-25.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.7 77.28c3.82-2.47 5.38-5.2 5.38-11.19"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.23 79.08s1.97.22.37 3.51c-2.75 5.65-16.78 11.88-26.27 5.18-10.62-7.51-.71-10.99-.71-10.99s5.54 6.25 11.98 6.47c8.35.3 6.39-.26 14.63-4.17Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.57 77.36c5.11 3.07 11.02 6.28 15.74 9.94.68.55 1.33 1.13 1.94 1.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.75 89.04c.6-.62 1.24-1.2 1.91-1.74 4.63-3.64 10.75-6.82 15.76-9.87 0 0 5.25 5.67 14.67 5.67 6.08-.02 9.75-1.91 14.49-5.67"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLady104 = (AvatarLady104);
;// ./src/Picto/GeneratedPictoComponents/AvatarLady56.tsx


var AvatarLady56_excluded = ["className"];
function AvatarLady56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLady56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLady56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLady56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLady56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLady56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLady56_objectSpread(AvatarLady56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.77 49.02c11.21-2.26 10.39-9.09 9.36-13-.66-2.51-1.29-5.02-1.81-7.56-1.33-6.56-2.41-11.08-3.84-15.02-1.55-4.27-5.99-10.77-15.53-9.47C6.21 6.06 7.34 27.04 8.04 38.54c0 0 .6 8.79 9.73 10.17 0 0 5.6.32 6.8-3.79.5-1.71-1.78-1.73-1.78-1.73l4.73.8 1.12-.05s.57 1.54 3.23 3.28c2.46 1.61 4.91 1.79 4.91 1.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.43 27.4c.04-8.31-5.7-16.12-12.82-16.12s-12.88 7.79-12.88 17.4v-.38c-.04 8.31 5.7 16.12 12.82 16.12s12.88-7.79 12.88-17.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.2 9.51c-3.6-3.28-9.86-6.14-14.86-4.15-4.92 1.95-8.03 6.59-9.7 11.15-2.08 5.69-1.91 12.51-1.62 18.47.14 2.75.31 7.85 2.5 9.82 2.15 1.92 3.76 3.01 6.52 3.82 2.52.59 6.78-1.71 7.7-4.14.31-.59-3.4-1.89-3.68-2.19-7.03-6.84-6.68-9.97-6.69-10.11-.11-1.1-.61-4.78-.37-5.94.56-2.59 1.43-7.6 3.28-9.9.21-.27 2.06-2.03 2.66-2.78.38-.48 1.88-1.8 1.9-1.77 5.16 8.28 7.78 5.92 15.54 8.14.08.05 1.45 2.13 1.52 2.42.38.92 1.01.84 1-.33-.06-4.74-2.08-9.22-5.71-12.53Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.4 25.08c.04.53.05 1.07.05 1.61 0 9.53-5.74 17.3-12.8 17.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.7 27.84c0 2.58 1.68 2.7 1.68 4.18s-1.72 1.55-1.72 1.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.8 25.23c1.27-1.14 3.31-1.14 4.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.95 25.23c1.27-1.14 3.31-1.14 4.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.52 37.8c1.36.77 2.81.07 3.43-.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.95 43.91c-.07.24-.11.35-.2.57-1.88 4.9-7.71 5.31-12.11 2.45-4-2.59-4.48-8.8-4.48-8.8-.7-11.44-1.82-32.31 16.82-34.38 9.48-1.3 13.89 5.17 15.44 9.41 1.44 3.95 2.51 8.48 3.85 15.1.5 2.47 1.12 4.92 1.76 7.36.87 3.32 1.5 8.65-5.01 12.24-4.06 2.23-9.29.46-11.98-3.31-.03-.05-.38-.55-.41-.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.41 25.08c-.19-6.38-2.84-5.22-8.55-6.24-6.42-1.15-8.58-7.18-8.58-7.18s-10.07 6-8.13 19.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.45 26.69c0 9.55-5.73 17.3-12.8 17.3s-12.79-7.77-12.74-16.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.15",
        cy: "27.69",
        r: "1.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.15",
        cy: "27.69",
        r: "1.14"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLady56 = (AvatarLady56);
;// ./src/Picto/GeneratedPictoComponents/AvatarLadyGlasses104.tsx


var AvatarLadyGlasses104_excluded = ["className"];
function AvatarLadyGlasses104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLadyGlasses104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLadyGlasses104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLadyGlasses104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLadyGlasses104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLadyGlasses104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLadyGlasses104_objectSpread(AvatarLadyGlasses104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.98 86.85c-.3-3.01.62-4.04 1.54-4.94.74-.72 1.62-1.46 1.75-2.55.25-2.04-2.73-4.37-2.58-6.33.16-2.05 3.48-3.88 3.54-5.85.07-2.06-3.13-4.1-3.16-6.06-.04-2.07 3.07-4.23 2.92-6.19-.15-2.06-3.55-3.73-3.82-5.67-.28-2.05 2.54-4.58 2.14-6.5-.42-2.03-4.02-3.22-4.56-5.1-.58-2 1.82-4.93 1.12-6.75-.75-1.95-4.5-2.49-5.37-4.22-.95-1.87.8-5.23-.27-6.83-1.17-1.75-4.93-1.38-6.22-2.81-1.41-1.57-.72-5.28-2.25-6.46-1.67-1.28-5.03.4-6.79-.39-1.9-.86-2.94-4.48-4.88-4.76s-3.97 2.91-5.96 3.27c-1.93.34-4.85-2.01-6.71-1.04-1.7.88-1.55 4.65-3.14 6.06-1.42 1.26-5.12.57-6.42 2.27-1.16 1.51.42 4.95-.62 6.81-.93 1.67-4.69 2.08-5.51 4.04-.74 1.77 1.58 4.76.94 6.77-.58 1.84-4.21 2.92-4.69 4.96-.45 1.88 2.29 4.5 1.93 6.56-.33 1.91-3.8 3.44-4.05 5.51-.23 1.94 2.76 4.25 2.61 6.32-.15 1.95-3.46 3.78-3.53 5.85-.07 1.96 3.1 4.03 3.1 6.1 0 1.96-3.18 4.02-3.12 6.09.06 1.97 2.55 4.26 3.48 5.89 0 0 1.71 3.51-.18 6.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.32 72.55c-.81.72-1.39 1.14-2.6 1.95-5.85 3.9-11.14 7.08-14.5 12.55 0 0 13.69 12.2 29.38 12.2s29.38-12.39 29.38-12.39c-1.19-2.14-2.76-4.17-4.82-5.82-3.44-2.76-7.18-4.91-10.54-7.03-.84-.53-1.53-.99-2.1-1.44"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.05 83.34s-1.74 1.92.58 2.34 10.48-1.38 12.92-4.98c2.44-3.6 10.22-2.38 12.73-.64 2.51 1.74 4.76.45 4.76.45v-3.28l-.31-3.6-1.81-2.1-1.09.62-2.21-1.14-.96.09-.96.79-1.67-.06-1.65-.82-.79.3-.71.71-2.01-.13-1.52-.36-.75.49-1.33 1.42-5.93 4.03-5.38 3.99-1.89 1.89Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.93",
        cy: "76.55",
        r: "1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "82.81",
        r: "1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "89.21",
        r: "1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "95.49",
        r: "1.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.19 85.68c3.16-6.91 12.63-8.91 17.61-14.16 2.16-2.28 2.76-5.05 2.25-8.39-.28-1.83-2.28-1.87-3.44-3.21-1.56-1.8-2.32-3.66-3.44-5.77A29.425 29.425 0 0 1 32.72 41c-.06-2.53-.99-6.59 2.37-6.75 1.58-.07 3.11-.13 4.65-.52 5.46-1.37 10-5.38 12.29-10.49.33 2.81 1.26 5.18 3.55 7.05 1.54 1.25 4.75 2.73 6.54 3.56 2.01.94 4.67.29 6.71 1.05.37.14 1.34.34 1.52.63.32.52.3 3.64.17 6.26-.09 1.94-.64 4.3-1.12 6.18-1.12 2.7-1.67 5.15-2.75 8-.22.36-1.11 1.2-1.34 1.55-1.36 2-3.32 3.13-5.47 5.21-1.67 1.61-1.01 7.23 1.5 8.28.78.33 2.51 2 3.14 2.37 4.02 2.3 7.39 4.28 10.94 7.54 1.04.96.64.34 1.07.4.49.06 1.89-.41 2.37-1.1.43-.62.96-1.15 1.02-1.95.07-1.01-.32-1.99-.62-2.94-.38-1.22-1.11-2.59-1.02-3.9.07-1.06.29-1.32.77-2.19.63-1.17.66-1.79.68-3.13.02-1.1-.92-2.22-1.27-3-.31-.69-.63-1.47-.39-2.42.2-.81 1.28-2.1 1.47-2.94.38-1.69.01-2.47-.82-3.99-.42-.77-1.51-1.87-1.59-2.77-.08-1.01.93-3.17.95-4.24.03-1.59-.19-2.38-1.04-3.65-.66-.98-1.54-2.04-1.5-3.32.05-1.5.73-2.86.58-4.42-.13-1.37-.6-2.69-1.39-3.82-1.35-1.93-3.6-2.54-4.26-4.89-.29-1.02-.21-2.07-.62-3.08-1.05-2.59-3.65-4-6.33-4.1-1.66-.06-1.86-1.1-2.29-2.49-.7-2.26-2.07-4.43-4.69-4.38-2.83.05-3.98 1.64-6.64-.52-1.2-.98-2.32-1.8-3.92-1.84-2.21-.05-3.67 1.6-5.67 2.19-3.4.99-3.74 1.94-9.19 4.33-1.06.47.9 2.82.65 3.97-.3 1.35-1.07 1.83-2.14 2.68-1.21.97-3.16 1.37-3.72 2.89-.92 2.51 2.37 4.17.78 6.44-1.05 1.5-3.93 3.28-4.17 5.32-.28 2.35 2.25 4.54 1.16 6.68-.88 1.73-2.7 2.6-3.19 4.64-.48 1.97.44 3.52 1.22 5.25.8 1.79.73 2.41-.47 4.07-.5.69-1.11 1.23-1.46 2.04-.72 1.66-.22 3.25.66 4.72 1.07 1.8 1.72 3.58 1.38 5.25-.08.06-.16.12-.24.2-.66.65-1.11 1.39-1.38 2.16-.2.33-.4.65-.6.98-.53.86-.66 2.06-.02 2.45.28 1.02.71 2.03 1.6 2.7",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.03 40.63c0 .94-1.04.52-2.31.52s-2.31.42-2.31-.52 1.04-1.7 2.31-1.7 2.31.76 2.31 1.7ZM62.21 40.61c0 .94-1.04.61-2.31.61s-2.31.32-2.31-.61 1.04-1.7 2.31-1.7 2.31.76 2.31 1.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.9 86.85c-.3-3.01.62-4.04 1.54-4.94.74-.72 1.62-1.46 1.75-2.55.25-2.04-2.73-4.37-2.58-6.33.16-2.05 3.48-3.88 3.54-5.85.07-2.06-3.13-4.1-3.16-6.06-.04-2.07 3.07-4.23 2.92-6.19-.15-2.06-3.55-3.73-3.82-5.67-.28-2.05 2.54-4.58 2.14-6.5-.42-2.03-4.02-3.22-4.56-5.1-.58-2 1.82-4.93 1.12-6.75-.75-1.95-4.5-2.49-5.37-4.22-.95-1.87.8-5.23-.27-6.83-1.17-1.75-4.93-1.38-6.22-2.81-1.41-1.57-.72-5.28-2.25-6.46-1.67-1.28-5.03.4-6.79-.39-1.9-.86-2.94-4.48-4.88-4.76s-3.97 2.91-5.96 3.27c-1.93.34-4.85-2.01-6.71-1.04-1.7.88-1.55 4.65-3.14 6.06-1.42 1.26-5.12.57-6.42 2.27-1.16 1.51.42 4.95-.62 6.81-.93 1.67-4.69 2.08-5.51 4.04-.74 1.77 1.58 4.76.94 6.77-.58 1.84-4.21 2.92-4.69 4.96-.45 1.88 2.29 4.5 1.93 6.56-.33 1.91-3.8 3.44-4.05 5.51-.23 1.94 2.76 4.25 2.61 6.32-.15 1.95-3.46 3.78-3.53 5.85-.07 1.96 3.1 4.03 3.1 6.1 0 1.96-3.18 4.02-3.12 6.09.06 1.97 2.55 4.26 3.48 5.89 0 0 1.71 3.51-.18 6.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.88 63.11c.01 5.56.89 4.81-2.43 7.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.87 21.48c0 12.3-17.27 14-19.15 14.06-.11 1.15-.18 2.32-.18 3.52 0 14.56 8.65 26.36 19.33 26.36S71.2 53.62 71.2 39.06c0-1.19-.06-2.37-.18-3.52-1.89-.05-19.15-1.75-19.15-14.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.92 56.1c2.09 1.18 4.31.11 5.27-.8M59.46 63.63c-.01 5.31-.89 4.59 2.43 7.38"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.9 86.85c-1.19-2.14-2.76-4.17-4.82-5.82-3.44-2.76-7.18-4.91-10.54-7.03-.84-.53-1.53-.99-2.1-1.44M22.14 87.04c3.36-5.47 8.65-8.65 14.5-12.55 1.21-.81 1.8-1.23 2.6-1.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.67 72.75c-1.57-1.26-1.27-1.75-2.13-1.89-.8-.12-1.82 1.01-2.69.93-.81-.08-1.53-1.38-2.4-1.42-.81-.04-1.71 1.19-2.57 1.18-.82 0-1.67-1.24-2.53-1.22M39.03 72.73c.64-.49 1.25-1.74 2.11-1.87.8-.12 1.82 1.01 2.69.93.81-.08 1.53-1.38 2.4-1.42.81-.04 1.71 1.19 2.57 1.18.82 0 1.67-1.24 2.53-1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.67 71.01c.5 1.28 1.85 2.45 1.95 4.21.09 1.63-1.23 3.8-1.19 5.58.04 1.65 1.44 3.06 1.43 4.84 0 1.67-1.42 3.57-1.47 5.35-.05 1.68 1.28 3.34 1.19 5.12l-.07 2.55M49.91 40.09c0 3.85-2.92 6.18-6.54 6.18s-5.67-1.38-5.67-5.24c0-3.53.71-5.59 5.34-5.59 3.53 0 6.86.23 6.86 4.63ZM53.71 40.09c0 3.85 2.92 6.18 6.54 6.18s5.67-1.38 5.67-5.24c0-3.53-.71-5.59-5.34-5.59-3.53 0-6.86.23-6.86 4.63ZM49.91 40.09c0-1.12.85-1.52 1.9-1.52s1.9.4 1.9 1.52M32.72 35.53l4.99 3.7M71.02 35.53l-5.1 3.7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52.05 40.42c0 3.96 2.59 4.14 2.59 6.42S52 49.21 52 49.21",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLadyGlasses104 = (AvatarLadyGlasses104);
;// ./src/Picto/GeneratedPictoComponents/AvatarLadyGlasses56.tsx


var AvatarLadyGlasses56_excluded = ["className"];
function AvatarLadyGlasses56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLadyGlasses56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLadyGlasses56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLadyGlasses56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLadyGlasses56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLadyGlasses56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLadyGlasses56_objectSpread(AvatarLadyGlasses56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.45 46.73c-1.59 1.34-2.55-1.22-3.66-.86-1.02.33-1.42 1.58-2.55 1.82-1.05.23-2.45-1.34-3.6-1.19-1.07.13-2.03 2-3.18 2.05-1.08.05-2.22-1.71-3.37-1.73-1.09-.02-2.29 1.7-3.43 1.6-1.08-.09-2-1.98-3.13-2.13s-2.47 1.42-3.59 1.21c-1.07-.2-1.79-2.17-2.9-2.44s-2.59 1.18-3.69.87c-.58-.17-1.02-.56-1.35-1.03-.7-.87-.88-1.9-.91-2.99-.03-1.14 1.72-2.28 1.73-3.37 0-1.15-1.75-2.29-1.72-3.38.04-1.15 1.88-2.16 1.96-3.24.09-1.15-1.57-2.43-1.44-3.5.14-1.15 2.06-1.99 2.24-3.05.2-1.14-1.32-2.59-1.07-3.63.27-1.13 2.28-1.73 2.6-2.75.35-1.11-.93-2.77-.52-3.75.45-1.08 2.53-1.31 3.05-2.24.57-1.03-.3-2.94.34-3.77.72-.94 2.77-.56 3.56-1.26.88-.78.8-2.87 1.74-3.36 1.03-.53 2.65.77 3.72.58 1.1-.2 2.19-1.97 3.3-1.81s1.65 2.16 2.7 2.64c.97.44 2.84-.49 3.76.22.84.65.46 2.71 1.24 3.58.71.79 2.8.59 3.44 1.56.59.89-.37 2.75.15 3.79.49.96 2.56 1.26 2.98 2.34.39 1.01-.94 2.63-.62 3.74.3 1.04 2.29 1.7 2.52 2.82.22 1.06-1.34 2.46-1.19 3.6.15 1.08 2.03 2 2.12 3.14.08 1.08-1.64 2.28-1.62 3.43.02 1.09 1.79 2.22 1.75 3.36-.04 1.09-1.87 2.1-1.96 3.24s1.96 1.77 1.8 3.66c-.1 1.23-.81 1.88-1.22 2.27Z",
      className: "fillprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.93 24.64c7.39-.28 10.9-3.84 11.56-7.5 1.19 3.65-1.38-.84.07.22.97.71.64 3.01 1.77 3.48 1.27.53 3.63 2.32 4.92 2.75.23.08-1.01-.53 2.61.65.35.11-.38.09 1.12.42 2 .43 1.73.12 1.43 1.19-.13 1.67-.72 6.35-1.41 7.98-.14.2-2.65 4.88-2.79 5.08-.86 1.14-1.53 1.94-4.82 3.22-4.03 1.57.98 5.37 1.78 6.38.31.39 2.88-2.26 3.28-2.05 2.54 1.31.07-.68 2.31 1.18.66.54 2.76-1.84 3.03-1.81.31.04 1.55.97 1.85.58.27-.36.33-1.02.36-1.47.05-.58-.2-1.13-.39-1.67-.24-.7-.7-1.47-.65-2.22.05-.6.63-.99.93-1.48.4-.67.67-1.43.69-2.2.01-.48-.08-.95-.29-1.4-.19-.39-.62-.71-.69-1.14-.07-.47.44-1.15.56-1.63.24-.96.12-1.93-.41-2.8-.27-.44-.96-.92-1.01-1.43-.05-.58.47-1.11.49-1.72.02-.91-.5-1.62-1.04-2.34-.42-.56-.97-1.16-.95-1.89.03-.86.46-1.63.37-2.52a4.22 4.22 0 0 0-.88-2.17c-.85-1.1-2.27-1.45-2.69-2.78-.18-.58-.13-1.18-.39-1.75-.66-1.48-2.31-2.28-3.99-2.34-1.04-.03-1.18-.62-1.45-1.42-.44-1.29-1.31-2.52-2.96-2.5-1.79.03-2.51.94-4.19-.3-.76-.56-2.09-.92-3.09-.94l-.81 1.68-3.67 1.25-.14 2.82-1.31 1.77-2.05 1.41.51 2.68.03 1.07-2.68 2.75 1.1 3.63-2.31 3.05 1.49 3.5-1.09 1.98-.93 1.25 1.16 2.03.61 1.34-1.38 2.99.35 2.78 1.43 1.24h1.25l2.29-.88 1.69.88.78.92.94 1.03 3.7-1.21 1.48.95 1.75 1.18 1.99-1.18 1.55-.42 1.48 1.17 1.99.55-2.16-6.21-3.61.45-4.25-1.81-3.97-4.6-1.91-5.3-.42-4.71.04-.92",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.99 27.33c0 .58-.63.32-1.42.32s-1.42.26-1.42-.32.63-1.04 1.42-1.04 1.42.47 1.42 1.04ZM34.73 27.32c0 .58-.63.38-1.42.38s-1.42.2-1.42-.38.63-1.04 1.42-1.04 1.42.47 1.42 1.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.57 16.1c0 7.47-10.48 8.5-11.63 8.53-.07.7-.11 1.41-.11 2.14 0 8.84 5.25 16 11.74 16s11.74-7.17 11.74-16c0-.72-.04-1.44-.11-2.14-1.15-.03-11.63-1.06-11.63-8.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.39 37.13c1.27.72 2.62.06 3.2-.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.45 46.73c.41-.4 1.12-1.05 1.22-2.27.16-1.89-1.89-2.57-1.8-3.66s1.93-2.15 1.96-3.24c.04-1.14-1.73-2.27-1.75-3.36-.02-1.14 1.7-2.34 1.62-3.43-.09-1.14-1.97-2.06-2.12-3.14-.16-1.14 1.41-2.54 1.19-3.6-.23-1.13-2.22-1.78-2.52-2.82-.32-1.11 1.01-2.73.62-3.74-.42-1.08-2.49-1.38-2.98-2.34-.52-1.04.44-2.89-.15-3.79-.65-.97-2.73-.76-3.44-1.56-.78-.87-.4-2.93-1.24-3.58-.92-.71-2.79.22-3.76-.22-1.05-.48-1.63-2.48-2.7-2.64s-2.2 1.61-3.3 1.81c-1.07.19-2.69-1.11-3.72-.58-.94.49-.86 2.57-1.74 3.36-.79.7-2.84.31-3.56 1.26-.64.84.23 2.74-.34 3.77-.51.92-2.6 1.15-3.05 2.24-.41.98.87 2.64.52 3.75-.32 1.02-2.33 1.62-2.6 2.75-.25 1.04 1.27 2.49 1.07 3.63-.18 1.06-2.1 1.9-2.24 3.05-.13 1.07 1.53 2.36 1.44 3.5-.08 1.08-1.92 2.09-1.96 3.24-.04 1.08 1.72 2.23 1.72 3.38s-1.76 2.23-1.73 3.37.21 2.12.91 2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.01 44.89c.33.47.76.86 1.35 1.03 1.1.31 2.63-1.12 3.69-.87s1.83 2.24 2.9 2.44c1.12.21 2.51-1.36 3.59-1.21 1.13.16 2.05 2.04 3.13 2.13 1.14.09 2.35-1.62 3.43-1.6 1.15.02 2.29 1.78 3.37 1.73 1.15-.06 2.11-1.92 3.18-2.05 1.14-.14 2.54 1.42 3.6 1.19 1.13-.24 1.52-1.49 2.55-1.82 1.1-.36 2.07 2.2 3.66.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.36 27.26c0 2.32-1.76 3.72-3.93 3.72s-3.41-.83-3.41-3.15c0-2.12.43-3.36 3.21-3.36 2.12 0 4.12.14 4.12 2.79ZM29.64 27.26c0 2.32 1.76 3.72 3.93 3.72s3.41-.83 3.41-3.15c0-2.12-.43-3.36-3.21-3.36-2.12 0-4.12.14-4.12 2.79ZM27.36 27.26c0-.67.51-.91 1.14-.91s1.14.24 1.14.91M16.85 24.63l3.18 2.12M40.27 24.63l-3.28 2.12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28.73 27.26c0 2.4 1.57 2.52 1.57 3.9s-1.6 1.44-1.6 1.44",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLadyGlasses56 = (AvatarLadyGlasses56);
;// ./src/Picto/GeneratedPictoComponents/AvatarLonghairGirl104.tsx


var AvatarLonghairGirl104_excluded = ["className"];
function AvatarLonghairGirl104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLonghairGirl104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLonghairGirl104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLonghairGirl104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLonghairGirl104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLonghairGirl104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLonghairGirl104_objectSpread(AvatarLonghairGirl104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.4 41.25c0 14.4-9.51 26.07-21.25 26.07S29.9 55.65 29.9 41.25c0 0 .14-23.46 6.06-24.41s28.96 3.45 30.41 11.17 6.03 13.25 6.03 13.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.29 88.3c-1.17-3.04-2.52-5.03-4.97-7.32L63.1 71.95c-3-1.49-3.55-1.49-3.55-6.41H43.24c0 5-1.32 5.35-4.42 6.87l-11.85 8.64c-2.86 4.28-4.2 4.67-5.37 7.94 0 0 12.71 10.25 29.34 10.25 18.09 0 29.34-10.94 29.34-10.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.37 28.88c1.57-7.94 6.37-18.9 20.02-20.95 3.67-.55 7.98-.8 12.71.91 12.74 4.61 16.25 21.63 16.86 25.04 0 0 13.38 35.72 1.15 50.55L64.43 91 27.37 28.88Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.99 72.82c-5.61 3.61-14.61 5.24-19.77.67-.14-.12-.33-.06-.5-.07-.3-1.67-3.61-1.14-3.43.61.6 5.79 6.23 9.95 13.6 10.77 9.09 1.02 11.94-4.27 12.59-10.31.13-1.25-1.37-2.39-2.5-1.66Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.95 9.99h.01c-8.85 1.42-12.03 13.51-13.95 21.93-1.14 5.01-7.66 18.46-9.95 25.95.03 4.74-1.8 7.2.2 16.44 1.28 2.44.4 1.6 1.37 3.52 1.72 2.99 2.37 1.94 2.55 3.45 1.46.43-.18 1.62 1.31 2.06 2.45 2.08 2.85-2.89 4.87-2.76 2.92 1.84.96 11.38 1.58 10.97 3.71-1.63 4.98-9.2 8.58-4.85.62-.96 2.59-9.95.8-16.04.9 1.28 5.93-.12 5.01-2.39 2.41-3.8-11.01-8.81-10.89-16.8-.38-3.2-3.76-10.71 0-13.37 4.95-4.66 4.79-13.61 6.77-16.14 1.02 1.29 4.73 6.79 5.73 8.1 1.06 3.08 3.8 4.54 6.74 6.92 3.22 3.29 7.25 6.25 6.02 4.56-.94-1.3-.17-1.07.53-.41 1.55 1.47 2.84.52 4.16 2.2.96 1.22 2.13 1.43 1.73.58-.21-.46 2.15 1.33 1.35-.21-1.35-2.57-1.62-4.79-1.06-6.89.52 1.1 3.85 3.36 5.61 3.72.6.12 1.55.45 1.93-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.93 40.49S71.16 7.85 40.96 9.98M66.69 65.07l-.99 1.77-1.59 6.95-.27 6.79 1.96 5.78.89-1.52 1.09-1.76 2.43 3.69 3.89 5.08.24-7.53 3.01-7.56s3.64-11.17-10.67-11.68M66.69 65.07s1.02-1.62 2.05 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.77",
        cy: "40.04",
        r: "1.93"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.92 65.07c0 4.91.55 4.92 3.55 6.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.37 83.67c12.23-14.83-1.15-50.55-1.15-50.55-.61-3.41-4.13-20.43-16.86-25.04-4.73-1.71-9.04-1.46-12.71-.91C34.01 9.22 29.2 20.18 27.63 28.12c0 0-1.01 7.54-2.67 11.58 0 0-19.18 26.75-.75 45.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.19 71.94c3.1-1.52 4.42-1.87 4.42-6.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.19 71.87c3.99 3.25 7.15 4.88 12.32 4.88s8.33-1.64 12.32-4.88M22.31 89.5c1.17-3.28 2.17-4.65 5.03-8.93M81 88.81c-1.17-3.04-2.86-6.02-5.31-8.3"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.57 41.14c0 4.28 2.79 4.48 2.79 6.95s-2.86 2.57-2.86 2.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.1 35.73c2.1-1.9 5.5-1.9 7.61 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.61 57.69c2.26 1.29 4.66.12 5.71-.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.34 42.98c13.61-10.22 10.69-19.46 11.69-21.82 0 0 9.33 19.14 26.8 23.22 0 0-2.45-4.35-1.23-8.53 0 0 3.23 6.77 9.79 3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.76 40.77c0 14.4-9.51 26.07-21.25 26.07S30.26 55.17 30.26 40.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.84 64.07s-7.59 15.35 0 25.43c0 0-.97-4.27 1.21-5.84 0 0 2.36 6.83 7.21 9.16 0 0-3.05-11.55 2.53-15.27M35.82 64.07s7.59 15.35 0 25.43c0 0 .97-4.27-1.21-5.84 0 0-1.94 6.94-6.79 9.26 0 0 2.63-11.65-2.95-15.38"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLonghairGirl104 = (AvatarLonghairGirl104);
;// ./src/Picto/GeneratedPictoComponents/AvatarLonghairGirl56.tsx


var AvatarLonghairGirl56_excluded = ["className"];
function AvatarLonghairGirl56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarLonghairGirl56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarLonghairGirl56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarLonghairGirl56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarLonghairGirl56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarLonghairGirl56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarLonghairGirl56_objectSpread(AvatarLonghairGirl56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "28",
      r: "28",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.18 19.96c0 7.85-5.52 16.01-11.74 16.01S16.56 29.16 16.56 21.3c0 0 .69-12.35 3.82-12.87s15.36 1.88 16.13 6.09 3.67 5.43 3.67 5.43Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.46 48.06 15.4 14.43c.85-4.3 3.45-10.23 10.83-11.34 1.98-.3 4.32-.43 6.88.49 6.89 2.5 8.8 11.71 9.13 13.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.24 17.14 2.02 7.29 1.89 8.03-.51 7.04-1.59 5.01-.79.24 1.61 2.29-1.9.55-3.26-.71-15.56-10.49-1.08-5.17 19.17-14.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.82 3.62-4.18.75c-4.5.73-6.37 7.56-7.35 11.85-.58 2.55-4.55 9.73-5.72 13.54.02 2.41-.85 1.43-.85 6.17.65 1.24-.17 1.6.32 2.58l.81 2.63 1.79 2.67.46 1.55-.49.84 3.77-.08 1.08-.63-1.19 3.16.97.07 1.97-.7 2.63-1.71.98 2.89 4.72-3.6 2.06-5.63s-.37-1.85-4.38-4.58c-4.02-2.73-3.46-2.43-3.46-2.43l-2.45-3.43-1.53-4.56-.04-3.49 1.8-2.23 2.07-3.44.73-4.31-.04-.79 1.61 2.41 1.5 2.15 2.38 2.68 2.86 2.48 3.9 2.57 2.48.84-.45-2.03-.08-1.96 1.88 1.29 2.76.78C39.11 8.23 26.84 3.61 26.84 3.61Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.2 39.17v.8l1.41 5.25 2.63 3.67 2.81 1.16-.39-1.21.41-1.88 2.28 1.59 2.78.18-.88-3.92 1.38-2.7s-4.3-7.38-12.08-3.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.19",
        cy: "20.76",
        r: ".74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.51 46.67s2.48 1.37 5.58.39c0 0-2.08-1.29-1.98-3.54M16.45 45.51s-2.35 1.56-5.47.85c0 0 2.86-.82 1.42-3.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.34 39.17s.34 10.42 6.71 10.68c0 0-1.2-1.71.02-2.89 0 0 2.09 2.33 5.57 2.33 0 0-3.16-4.3-.01-7.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.34 39.17s.6 8.24-7.5 10.05c0 0 1.2-1.71-.02-2.89 0 0-2.09 2.33-5.57 2.33 0 0 3.16-4.3.01-7.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.42 22.13c0 2.36 1.54 2.48 1.54 3.84s-1.58 1.42-1.58 1.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.09 19.14c1.16-1.05 3.04-1.05 4.2 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.34 31.26c1.25.71 2.57.06 3.15-.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.05 23.14c7.52-5.64 5.9-10.75 6.45-12.05 0 0 5.15 10.56 14.8 12.82 0 0-1.35-2.4-.68-4.71 0 0 1.78 3.74 5.41 2.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.52 45.22c6.75-8.19-.94-27.53-.94-27.53-.34-1.89-2.28-11.28-9.31-13.83-2.61-.95-4.99-.81-7.01-.5-7.53 1.13-10.19 7.18-11.05 11.57 0 0-.56 4.16-1.48 6.4 0 0-10.17 13.22-1.53 23.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.13 21.93c0 7.95-5.25 14.4-11.73 14.4s-11.73-6.44-11.73-14.4"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarLonghairGirl56 = (AvatarLonghairGirl56);
;// ./src/Picto/GeneratedPictoComponents/AvatarMiddleAgeFemale104.tsx


var AvatarMiddleAgeFemale104_excluded = ["className"];
function AvatarMiddleAgeFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMiddleAgeFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMiddleAgeFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMiddleAgeFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMiddleAgeFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMiddleAgeFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMiddleAgeFemale104_objectSpread(AvatarMiddleAgeFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.52 42.04c-.46.01-.92.1-1.36.29-2.51 1.04-3.42 4.59-2.03 7.93 1.29 3.11 4.11 4.94 6.51 4.34M67.4 54.6c2.4.6 5.22-1.24 6.51-4.34 1.38-3.34.47-6.89-2.03-7.93a3.77 3.77 0 0 0-1.4-.29M39.94 21.21c-.39-1.24-.6-2.56-.6-3.93 0-7.23 5.86-13.09 13.09-13.09s13.09 5.86 13.09 13.09c0 1.36-.21 2.66-.59 3.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.71 38.56H31.15c0-11.75 9.15-21.28 20.9-21.28s21.66 9.52 21.66 21.28Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.45 38.54c.17 2.07.07 4.32-.37 6.74-2.42 13.7-10.28 24.4-17.56 24.38-7.28.02-15.14-10.68-17.56-24.38-.43-2.37-.53-4.58-.38-6.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.87 88.34c-1.02-2.65-2.49-5.24-4.62-7.23-.65-.6-1.31-1.18-1.97-1.72-2.17-1.79-4.62-3.27-6.67-4.78-.55-.4-1.03-.8-1.45-1.19l.13.18c-2.16-2.04-2.64-3.74-2.74-7.71l-16.41-.55c-.09 4.11-.55 6.21-2.77 8.29l.77-.81c-.41.39-1.56 1.36-2.1 1.76-2.04 1.5-4.04 2.86-6.2 4.64l-.22.16c-.68.56-1.35 1.14-2.01 1.75-2.29 2.14-3.82 4.98-4.85 7.83 0 0 10.19 10.3 25.75 10.3s25.34-10.9 25.34-10.9Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.68 74.63c-5.63 2.86-14.73 4.06-20.03.27-.14-.1-.34-.06-.5-.06-.33-1.36-3.68-.97-3.47.45.69 4.71 6.45 8.17 13.93 8.94 9.23.95 12.05-3.31 12.62-8.21.12-1.01-1.42-1.96-2.56-1.39ZM42.38 16.8c4.37-3.07 10.49-2.07 15.74-1.16.14.02.27.03.41.03.34 1.27 3 .69 2.76-.65-.81-4.42-5.56-7.92-11.6-8.17-7.47-.31-9.57 4.51-9.77 9.19-.04.97 1.58 1.38 2.46.76ZM49.09 18.68c-9.85.3-16.25 9.02-18.02 18.09-.33 1.66 1.91 2.46 2.61 1.23.19.1.42.17.68.21 5 .59 9.98.66 14.99.22.26.17.57.33.93.49.73.31 1.48-.27 1.73-.95.06.01.12.03.18.03l3.98.33c.26.02.49-.02.68-.11.59 0 1.21-.02 1.83-.06 1.77.59 3.79.4 5.7.12.6-.09 1.08-.83 1.06-1.41-.37-9.13-6.42-18.48-16.35-18.18Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.37 73.62c2.22-2.08 2.67-4.18 2.77-8.29M26.78 88.95c1.02-2.85 2.55-5.69 4.85-7.83.66-.61 1.33-1.2 2.01-1.75M63.29 73.59c-2.16-2.04-2.64-3.74-2.74-7.71M77.87 88.34c-1.02-2.65-2.49-5.24-4.62-7.23-.65-.6-1.31-1.18-1.97-1.72M62.93 73.59c-3.47 2.83-6.23 4.25-10.73 4.25s-7.25-1.42-10.73-4.25M33.55 93.94l.31-14.39M70.98 93.82l.03-14.27M34.52 42.04c-.46.01-.92.1-1.36.29-2.51 1.04-3.42 4.59-2.03 7.93 1.29 3.11 4.11 4.94 6.51 4.34M67.4 54.6c2.4.6 5.22-1.24 6.51-4.34 1.38-3.34.47-6.89-2.03-7.93a3.77 3.77 0 0 0-1.4-.29M52.57 46.74c0 3.69 2.41 3.86 2.41 5.98s-2.46 2.21-2.46 2.21M55.8 43c1.81-1.64 4.74-1.64 6.55 0M42.61 43.06c1.81-1.64 4.74-1.64 6.55 0M50.8 61.05c1.94 1.1 4.02.1 4.91-.74M39.94 21.21c-.39-1.24-.6-2.56-.6-3.93 0-7.23 5.86-13.09 13.09-13.09s13.09 5.86 13.09 13.09c0 1.36-.21 2.66-.59 3.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.71 38.56H31.15c0-11.75 9.15-21.28 20.9-21.28s21.66 9.52 21.66 21.28Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.45 38.54c.17 2.07.07 4.32-.37 6.74-2.42 13.7-10.28 24.4-17.56 24.38-7.28.02-15.14-10.68-17.56-24.38-.43-2.37-.53-4.58-.38-6.62M33.85 79.2c2.15-1.77 4.15-3.14 6.2-4.64.54-.4 1.69-1.37 2.1-1.76M71.28 79.39c-2.17-1.79-4.62-3.27-6.67-4.78-.55-.4-1.03-.8-1.45-1.19"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.73",
        cy: "46.74",
        r: "1.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.88",
        cy: "46.74",
        r: "1.67"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.76 15.32-.54 5.89c-5.44-3.23-9.12-4.06-13.24-4.06s-8.3 1.08-12.72 4.06l-.38-5.63c.83-.27 1.94-.62 2.79-.9a33.9 33.9 0 0 1 18.6-.75c1.52.37 3.33.83 5.49 1.39Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.83 15.27-.54 6.46c-5.44-3.55-9.12-4.45-13.24-4.45s-8.3 1.18-12.72 4.45l-.38-6.18c.83-.3 1.94-.68 2.79-.99a30.934 30.934 0 0 1 18.6-.82c1.52.41 3.33.91 5.49 1.53Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMiddleAgeFemale104 = (AvatarMiddleAgeFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarMiddleAgeFemale56.tsx


var AvatarMiddleAgeFemale56_excluded = ["className"];
function AvatarMiddleAgeFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMiddleAgeFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMiddleAgeFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMiddleAgeFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMiddleAgeFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMiddleAgeFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMiddleAgeFemale56_objectSpread(AvatarMiddleAgeFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.61 31.66c-.34 0-.67.08-.99.21-1.83.76-2.49 3.35-1.48 5.79.94 2.27 3 3.61 4.76 3.17M38.63 40.83c1.76.44 3.82-.9 4.76-3.17 1.01-2.44.35-5.03-1.48-5.79-.33-.14-.68-.2-1.03-.21M18.28 16.27c-.28-.91-.15-1.7-.15-2.7C18.13 8.29 22.41 4 27.7 4s9.57 4.28 9.57 9.57c0 .99.05 2.3-.09 3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.24 29.11H12.15c0-8.58 6.68-15.54 15.27-15.54s15.82 6.96 15.82 15.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.86 29.1c.12 1.51.05 3.15-.27 4.92-1.77 10.01-7.51 17.82-12.83 17.81-5.32.01-11.06-7.8-12.83-17.81-.31-1.73-.39-3.35-.27-4.83"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.35 12.99c3.24-2.28 7.8-1.54 11.69-.86.1.02.2.02.3.02.25.94 2.23.51 2.05-.48-.6-3.28-4.13-5.89-8.62-6.07-5.55-.23-7.11 3.35-7.25 6.82-.03.72 1.18 1.03 1.83.57ZM25.33 14.39c-7.32.22-12.07 6.7-13.39 13.44-.24 1.23 1.42 1.82 1.94.91.14.08.31.13.5.15 3.71.44 7.41.49 11.13.16.2.13.42.25.69.36.54.23 1.1-.2 1.29-.71.04 0 .09.02.13.02.99.08 1.97.16 2.96.25.2.02.36-.02.5-.08.44 0 .9-.01 1.36-.05 1.31.44 2.81.3 4.23.09.44-.06.8-.62.79-1.05-.28-6.78-4.77-13.73-12.14-13.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.68 31.66c-.34 0-.67.08-.99.21-1.83.76-2.49 3.35-1.48 5.79.94 2.27 3 3.61 4.76 3.17M38.69 40.83c1.76.44 3.82-.9 4.76-3.17 1.01-2.44.35-5.03-1.48-5.79-.33-.14-.68-.2-1.03-.21M27.86 35.09c0 2.69 1.76 2.82 1.76 4.37s-1.79 1.61-1.79 1.61M30.22 32.35c1.32-1.2 3.46-1.2 4.78 0M20.59 32.4c1.32-1.2 3.46-1.2 4.78 0M26.56 45.54c1.42.81 2.93.07 3.59-.54M18.34 16.27c-.28-.91-.15-1.7-.15-2.7 0-5.28 4.28-9.57 9.57-9.57s9.57 4.28 9.57 9.57c0 .99.05 2.3-.09 3.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.3 29.11H12.22c0-8.58 6.68-15.54 15.27-15.54s15.82 6.96 15.82 15.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.92 29.1c.12 1.51.05 3.15-.27 4.92-1.77 10.01-7.51 17.82-12.83 17.81-5.32.01-11.06-7.8-12.83-17.81-.31-1.73-.39-3.35-.27-4.83"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.98",
        cy: "34.87",
        r: "1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.61",
        cy: "34.87",
        r: "1.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.4 12.33-.38 4.14c-3.83-2.28-6.42-2.85-9.32-2.85s-5.85.76-8.95 2.85l-.27-3.96c.59-.19 1.36-.44 1.96-.63 4.2-1.4 8.77-1.58 13.09-.53 1.07.26 2.35.58 3.86.98Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.62 12.15-.39 4.72c-3.97-2.59-6.66-3.25-9.67-3.25s-6.08.66-9.3 3.05l-.27-4.31c.61-.22 1.42-.5 2.04-.72 4.36-1.59 9.1-1.8 13.59-.6 1.11.3 2.44.66 4.01 1.12Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMiddleAgeFemale56 = (AvatarMiddleAgeFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarMiddleAgeMan104.tsx


var AvatarMiddleAgeMan104_excluded = ["className"];
function AvatarMiddleAgeMan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMiddleAgeMan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMiddleAgeMan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMiddleAgeMan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMiddleAgeMan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMiddleAgeMan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMiddleAgeMan104_objectSpread(AvatarMiddleAgeMan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.66 36.41s1.69.13 1.69-5.75-3.02-9.43-3.02-9.43c5.9-9.5-5.59-16.2-5.59-16.2-3.18 2.75-8.62 2.68-12.25 2.68-14.89 0-20.96 11.73-20.96 22.94 0 5.88 1.69 5.75 1.69 5.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.97 35.4c2.17.17 5.24 3.89 5.02 6.76-.23 2.87-4.07 6-6.24 5.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.47 35.4c-2.17.17-5.8 3.43-5.57 6.3.23 2.87 4.09 6.46 6.26 6.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.09 46.9s2.29 7.25-.02 10.01c-.36.44 1.25 3.1-6.05 10.16 0 0-.41-.42-.56-1.19 0 0-3.89 6.76-11.81 6.76h-.15c-7.91 0-12.12-6.77-12.12-6.77-.15.77-.56 1.19-.56 1.19-7.31-7.06-5.69-9.72-6.05-10.16-2.31-2.76-.47-10-.47-10l-.65-17.03h39.44L70.08 46.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m80.65 87.79-10.6-9.38c-2.25-1.99-3.76-3.2-5.4-5.95-1.49-2.02-1.79-5-1.79-5l-22.81.2s-.3 2.98-1.79 5c-1.89 2.73-2.9 3.76-5.15 5.75l-11.27 9.97s9.76 10.86 29.52 10.86 29.3-11.45 29.3-11.45Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.64 20.24c0-.11-.09-.24-.04-.34.87-1.87 2.63-4.19.84-6.85 0 0-1.9-4.14-3.14-3.35-4.34 2.78-9.78 1.65-14.53 1.02-4.47-.59-9.07-.4-12.99 2.08-6.66 4.22-8.95 9.72-9.61 17.13-.11 2.71.5 4.56.53 4.15-.02.22 1.04 1.9 1.67 1.11.46-.57.99-3.71.99-3.71 2.47-10.37 8.47-18.41 16.97-18.41S68.15 19.7 68.64 30.5c.27.87.53 2.11.52 2.44.07.32.4 1.75.46 2.08.54 1.05 2.31-.38 2.42-2 .03-.4 1.36-7.21-2.39-12.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.71 56.07h-.02c-6.73-5.86-11.07-5.14-11.11-5.12 0 0-.18-.03-.53-.03-1.35 0-5.19.48-10.57 5.15h-.02l-.53-1.89c-.84-1.33-5.59.5-6.47-6.18 0 0-2.45 6.2-.17 8.91.36.43-1.24 3.05 5.94 9.98 0 0 .4-.41.54-1.17 0 0 4.14 6.64 11.9 6.65h.15c7.77 0 3.34-1.14 3.34-1.14s10.44-5.3 7.56-15.15Zm-4.79 6.55c-1.35.64-2.4 1.04-4.15-.6h-4.16c-1.74 1.64-3.33 1-4.15.6-2.12-1.05-3.24-4.55-1.07-5.5 1.07-.53 7.26-3.2 7.3-3.23 0 0 1.56.68 3.24 1.42 1.7.74 3.52 1.55 4.05 1.81 1.56.58 1.06 4.47-1.07 5.5ZM60.8 80.24s.78-.19.35 1.73c-.77 3.41-12.76 8.16-17.39 3.75-2.62-2.49-1.53-5.66-1.53-5.66s4.63 3.08 8.93 2.91c5.58-.23 4.26-.42 9.65-2.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.55 81.3c-.4-.2-.7.26-.37.53 1.73 1.43.55 5.83 3.31 6.44-.03.29.86-.44 1.07-.64.39-.35 1.92-1.13 1.85-2.22.34-1.42-3.88-3.36-5.86-4.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.47 81.73c.41-.2.71.25.37.52-1.77 1.44-.63 5.8-3.43 6.43.03.29-.86-.43-1.08-.62-.39-.34-1.93-1.09-1.84-2.17-.33-1.4 3.97-3.39 5.99-4.15Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.51 35.95s1.69.13 1.69-5.75-3.02-9.43-3.02-9.43c5.9-9.5-5.59-16.2-5.59-16.2-3.18 2.75-8.62 2.68-12.25 2.68-14.89 0-20.96 11.73-20.96 22.94 0 5.88 1.69 5.75 1.69 5.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.95 36.51c2.17.17 3.74 2.64 3.51 5.52-.23 2.87-2.17 5.06-4.34 4.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.15 36.51c1.24-14.14 8.55-23.46 19.1-23.46s17.23 9.56 18.87 23.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.94 46.44s2.29 7.25-.02 10.01c-.36.44 1.25 3.1-6.05 10.16 0 0-.41-.42-.56-1.19 0 0-3.89 6.76-11.81 6.76h-.15c-7.91 0-12.12-6.77-12.12-6.77-.15.77-.56 1.19-.56 1.19-7.31-7.06-5.69-9.72-6.05-10.16-2.31-2.76-.47-10-.47-10 .89 6.8 5.44 7.08 7.24 7.22l.54 1.93h.02c6.9-5.99 11.31-5.21 11.31-5.21s4.46-.75 11.31 5.21h.02l.54-1.93s5.98.93 6.8-7.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.72 62.8c-1.38.65-2.44 1.06-4.22-.61h-4.24c-1.78 1.67-3.39 1.03-4.22.61-2.16-1.07-3.29-4.63-1.09-5.6 1.09-.53 7.39-3.25 7.43-3.28s6.34 2.75 7.43 3.28c1.59.6 1.08 4.56-1.09 5.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.84 58.45c1.11.87 2.29.49 3.09-.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.68 36.51c-2.17.17-3.74 2.64-3.51 5.52.23 2.87 2.17 5.06 4.34 4.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.73 78.5c-3.13 2.88-6.58 3.75-10.39 3.75s-7.36-1.32-10.61-3.69M62.71 67s.3 2.98 1.79 5M39.9 67.2s-.3 2.98-1.79 5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.72 98.76c1.47-18.39 6.79-26.21 6.79-26.21M72.55 80.72l-7.61 5.24 5.48 3.05-5.48 8.24M44.94 98.76c0-13.56-6.83-25.87-6.83-25.87M64.51 72c1.64 2.76 3.15 3.96 5.4 5.95l10.6 9.38M38.11 72.2c-1.89 2.73-2.9 3.76-5.15 5.75l-11.27 9.97M30.43 80.55l7.45 5.15-5.32 3.14 5.32 8.56"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.38",
        cy: "40.43",
        r: "1.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.11",
        cy: "40.43",
        r: "1.74"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.28 40.62c0 3.96-3.01 6.36-6.74 6.36s-5.84-1.42-5.84-5.39c0-3.63.73-5.75 5.5-5.75 3.63 0 7.06.23 7.06 4.77h.01ZM53.18 40.62c0 3.96 3.01 6.36 6.74 6.36s5.84-1.42 5.84-5.39c0-3.63-.73-5.75-5.5-5.75-3.63 0-7.06.23-7.06 4.77h-.01Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.28 40.62c0-1.15.88-1.57 1.95-1.57s1.95.42 1.95 1.57"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.26 36.11 5.45 3.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.2 36.11-5.45 3.63"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.38 40.85c-.11 2.64 1.69 2.68 1.69 4.65 0 2.31-1.97 2.49-1.97 2.49"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMiddleAgeMan104 = (AvatarMiddleAgeMan104);
;// ./src/Picto/GeneratedPictoComponents/AvatarMiddleAgeMan56.tsx


var AvatarMiddleAgeMan56_excluded = ["className"];
function AvatarMiddleAgeMan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMiddleAgeMan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMiddleAgeMan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMiddleAgeMan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMiddleAgeMan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMiddleAgeMan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMiddleAgeMan56_objectSpread(AvatarMiddleAgeMan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.85 26.73s1.2.09 1.2-4.07-2.13-6.67-2.13-6.67c4.17-6.72-3.95-11.45-3.95-11.45-2.25 1.95-6.1 1.9-8.67 1.9-10.53 0-14.82 8.29-14.82 16.22 0 4.16 1.2 4.07 1.2 4.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.98 26.03c1.53.12 3.68 2.96 3.52 5-.16 2.03-2.47 4.02-4.01 3.9"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.98 26.52c-1.53.12-4.08 2.47-3.92 4.5.16 2.03 2.73 4.02 4.26 3.9"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.44 34.15s1.62 5.13-.02 7.08c-.26.31.88 2.2-4.28 7.19 0 0-.29-.3-.4-.84 0 0-2.75 4.78-8.35 4.78h-.11c-5.6 0-8.57-4.79-8.57-4.79-.11.55-.4.84-.4.84-5.17-4.99-4.02-6.88-4.28-7.19-1.63-1.95-.33-7.07-.33-7.07l-.46-12.04h27.9l-.72 12.04Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40 15.64c0-.08-.06-.17-.03-.24.61-1.32 1.85-2.94.59-4.82 0 0-1.34-2.91-2.21-2.36-3.05 1.95-6.87 1.16-10.22.72-3.14-.42-6.38-.28-9.13 1.46-4.68 2.97-6.29 6.84-6.76 12.04-.08 1.91.35 3.21.38 2.92-.01.15.73 1.34 1.17.78.32-.4.7-2.6.7-2.6 1.74-7.29 5.95-12.94 11.93-12.94s12.52 4.66 12.87 12.25c.19.61.37 1.48.36 1.71.05.23.28 1.23.32 1.46.38.74 1.62-.27 1.7-1.4.02-.28.95-5.07-1.68-8.99Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.92 40.88h-.01c-4.68-4.07-7.49-4.07-7.52-4.06 0 0-.12-.02-.37-.02-.94 0-3.8.83-7.54 4.08h-.01l-.37-1.32c.63-1.66-4.71.35-5.32-4.29 0 0-1.44 4.08.15 5.96.25.3-.71 2.37 4.28 7.19 0 0 .68-.31.78-.84 0 0 2.87 4.61 8.27 4.62h.1c5.26-.65 2.27-.34 2.27-.34s7.3-4.14 5.3-10.98Zm-3.33 4.55c-.94.44-1.67.72-2.88-.42h-2.89c-1.21 1.14-2.31.7-2.88.42-1.47-.73-2.25-3.16-.74-3.82.74-.36 5.04-2.22 5.07-2.24l2.25.98c1.18.51 2.44 1.08 2.82 1.26 1.08.4.74 3.11-.74 3.82Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.71 26.73s1.2.09 1.2-4.07-2.13-6.67-2.13-6.67c4.17-6.72-3.95-11.45-3.95-11.45-2.25 1.95-6.1 1.9-8.67 1.9-10.53 0-14.82 8.29-14.82 16.22 0 4.16 1.2 4.07 1.2 4.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.02 27.12c1.53.12 2.64 1.87 2.48 3.9s-1.53 3.58-3.07 3.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.58 27.12c.88-10 6.05-16.59 13.51-16.59s12.19 6.76 13.35 16.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.3 34.15s1.62 5.13-.02 7.08c-.26.31.88 2.2-4.28 7.19 0 0-.29-.3-.4-.84 0 0-2.75 4.78-8.35 4.78h-.11c-5.6 0-8.57-4.79-8.57-4.79-.11.55-.4.84-.4.84-5.17-4.99-4.02-6.88-4.28-7.19-1.63-1.95-.33-7.07-.33-7.07.63 4.81 3.85 5.01 5.12 5.11l.38 1.36h.01c4.88-4.23 8-3.69 8-3.69s3.15-.53 8 3.69h.01l.38-1.36s4.23.66 4.81-5.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.66 45.72c-.97.46-1.73.75-2.99-.43h-3c-1.26 1.18-2.4.73-2.99.43-1.53-.76-2.33-3.27-.77-3.96.77-.38 5.23-2.3 5.25-2.32s4.48 1.94 5.25 2.32c1.12.42.76 3.23-.77 3.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.09 42.65c.79.61 1.62.34 2.19-.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.54 27.12c-1.53.12-2.64 1.87-2.48 3.9s1.53 3.58 3.07 3.46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.8",
        cy: "30.04",
        r: "1.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.21",
        cy: "30.04",
        r: "1.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.75 30.04c0 2.78-2.11 4.46-4.72 4.46s-4.09-1-4.09-3.77c0-2.54.51-4.03 3.86-4.03 2.54 0 4.95.16 4.95 3.34ZM28.48 30.04c0 2.78 2.11 4.46 4.72 4.46s4.09-1 4.09-3.77c0-2.54-.51-4.03-3.86-4.03-2.54 0-4.95.16-4.95 3.34Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.75 30.04c0-.8.61-1.1 1.37-1.1s1.37.29 1.37 1.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.12 26.88 3.82 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.11 26.88-3.82 2.54"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.48 29.91c-.09 2.08 1.33 2.12 1.33 3.67 0 1.82-1.55 1.97-1.55 1.97"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMiddleAgeMan56 = (AvatarMiddleAgeMan56);
;// ./src/Picto/GeneratedPictoComponents/AvatarMoustacheMan104.tsx


var AvatarMoustacheMan104_excluded = ["className"];
function AvatarMoustacheMan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMoustacheMan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMoustacheMan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMoustacheMan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMoustacheMan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMoustacheMan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMoustacheMan104_objectSpread(AvatarMoustacheMan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.23",
        cy: "41.76",
        rx: "21.15",
        ry: "30.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.09 38.21c-1.09-.3-2.19-.27-3.21.15-3.06 1.27-4.17 5.61-2.48 9.69 1.48 3.57 4.62 5.77 7.43 5.41M72.49 53.5c2.7.1 5.6-2.05 7.01-5.44 1.69-4.08.58-8.42-2.48-9.69-.97-.4-1.63-.6-2.66-.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.22 20.18c-2.56-10.69-9.74-9.68-10.95-10.8C63.16 7.44 59 6.76 55.03 6.56v-.08c-.88-.01-1.87-.02-2.92-.01-1.05 0-2.04 0-2.91.01v.08c-3.97.22-8.13.88-10.24 2.82-1.22 1.12-8.39.1-10.95 10.8-2.56 10.7-.17 16.9-.17 16.9l.68-.23c.84 0 1.65.55 1.68 1.59 0 0 .15 8.25 1.9 13.9.13.42.52.71.95.71h1.9c.39 0 .68-.37.61-.78-.46-2.51-1.86-10.71-2.17-18.12-.27-6.47 1.99-12.13 2.99-11.96 11.85 2.1 19.63 2.22 31.48 0 .99-.18 3.26 5.49 2.99 11.96-.32 7.41-1.72 15.6-2.17 18.12-.08.4.22.78.61.78h1.9c.42 0 .82-.27.95-.71 1.74-5.65 1.9-13.9 1.9-13.9.03-1.05.85-1.59 1.68-1.59l.68.23s2.39-6.22-.17-16.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.45 75.87 4.87-2.24c-.94-.14-2.75-1.63-3.09-2.53l5.87-1.28c-2.04-.79-3.05-2.9-3.05-2.9 1.12.12 5.56.62 7.2-2.4s-6.16-1.4-7.03-6.19c-1.08-5.95-.96-5.27-.96-5.27L59.5 62.44l8.96 13.44Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.78 88.5 71 78.96c-2.29-2.03-3.39-2.84-5.05-5.65l-.44-.41c-1.52-2.06-1.82-5.08-1.82-5.08l-23.2.2s-.31 3.03-1.82 5.08l-.23.2c-2.2 2.56-2.72 3.62-5.01 5.65L21.97 89.09s12.18 10.14 30.04 10.14 29.78-10.74 29.78-10.74Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.8 74.29-2.4 3.11-3.38 3.07-.47.65 2.67 2.33 3.79 2.64.73.64s2.14.36 5.61 8.01l-2.21-12.01-2.99-6.15-1.36-2.28ZM66.3 74.6l2.4 3.11 3.38 3.07.47.65-2.67 2.33-3.79 2.64-.73.64s-3.28 1.31-5.42 7.39l2.02-11.39 2.99-6.15 1.36-2.28Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.95 56.66 2.3 3.74 2 3.09 3.71 3.77-1.27 3.44-2.76 4.47-4.14-1.41 2.17-2.46-4.71-1.55 1.9-2.78-4.85-.69-1.71-1.78 5.45-3.08 1.91-4.76zM71.62 56.04l-1.97 3.92-2.3 3.82-3.24 3.78.76 4.16 2.06 2.29 1.41 1.29 2.27-1.25.37-.44-.54-.86-.95-1.72-.13-.5s3.02-1.69 2.27-14.48ZM61.57 80.01s1.37.03.36 2.23c-1.73 3.77-12.02 8.39-17.97 4.8-4.04-2.43-.82-7-.82-7s4.01 3.69 8.46 3.47c5.77-.28 4.4-.53 9.97-3.5Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m58.63 54.44 3.65.78 1.64 1.25.38 2.36.58 2.64.8 2.09.98 2.12.61 1.4-.57.39-2-.61-3.99-6.15-.84-2.23-3.01-1.08-2.57-.2-3.71-.07-2.77-.03-2.64.88-.81.5-1.08 1.45-1.33 2.69-1.22 2.08-1.61 2.16-1.17.01-1.02-.37.5-1.84 1.32-2.18.6-2.23.24-1.96.34-1.64 1.3-1.4 3.01-.81 4.07-.78 5.42.17 4.9.61zM34.64 52.26l-2.67.08-2.29-15.99-2.1-.27-.65-8.29 1.35-7.48 1.53-4.64 2.61-2.84 2.88-1.76 2.79-1.04 2.93-1.53 7.12-1.4S70.3 8.45 75.12 36.07l-1.67 2.88-.86 9.79-1.17 3.81-2.9-.3 2.27-13.54-.05-9.32-1.13-5.09-2.57-2.25-11.15 1.31-6.1-.05-6.22-.41-3.6-.5-3.76-.23-2.5 4.15-.5 6.17.41 12.57.72 4.41.27 2.75Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.87 79.52c-3.33 2.45-7.01 3.82-10.88 3.82S44.51 82 41.2 79.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.51 74.93s5.19 2.57-2.72-1.3c.94-.14 2.75-1.63 3.09-2.53l-5.87-1.28c2.04-.79 3.05-2.9 3.05-2.9-1.12.12-5.56.62-7.2-2.4s7.23-1.33 7.03-6.19l-.2-4.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.32 75.87 4.87-2.24c-.94-.14-2.75-1.63-3.09-2.53l5.87-1.28c-2.04-.79-3.05-2.9-3.05-2.9 1.12.12 5.56.62 7.2-2.4s-6.16-1.4-7.03-6.19c-1.08-5.95-.96-5.27-.96-5.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.56 67.82s.31 3.03 1.82 5.08M40.36 68.03s-.31 3.03-1.82 5.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.82 98.72c1.1-14.35 7.01-25.4 7.01-25.4M73.57 81.78l-7.74 5.33 5.57 3.1-5.16 6.73M45.51 98.72c0-10.54-7.2-25.4-7.2-25.4M65.83 73.32c1.66 2.8 2.76 3.62 5.05 5.65l10.78 9.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.31 73.32c-2.2 2.56-2.72 3.62-5.01 5.65L21.84 89.11M30.72 81.6l7.59 5.24-5.42 3.2 5.06 6.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.02",
        cy: "43.46",
        r: "2.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.04",
        cy: "43.46",
        r: "2.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.58 53.5c-1.12 3.72-2.74 7.05-4.76 9.82M37.39 63.31c-2.05-2.81-3.69-6.21-4.81-10M63.75 66.82c-3.34 3.13-7.34 4.95-11.64 4.95s-8.39-1.86-11.75-5.05M29.97 38.21c-1.09-.3-2.19-.27-3.21.15-3.06 1.27-4.17 5.61-2.48 9.69 1.48 3.57 4.62 5.77 7.43 5.41M72.37 53.5c2.7.1 5.6-2.05 7.01-5.44 1.69-4.08.58-8.42-2.48-9.69-.97-.4-1.63-.6-2.66-.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.1 43.9c0 3.52 2.85 3.69 2.85 5.71s-2.92 2.11-2.92 2.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.4 39.47c2.15-1.94 5.62-1.94 7.77 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.93 39.47c2.15-1.94 5.62-1.94 7.77 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.47 61.68c1.4 2.25 5.59 2.72 7.26-.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.78 57.75s.12.02 2.17.02 5.73.6 5.83 2.25c.1 1.65 3.91 6.62 4.26 7.02s1.27 1.09 2.48.62c1.49-.59 1.5-1.35 1.33-1.92-.14-.49-2.47-4.18-2.92-7.51s-4.44-4.19-4.79-4.28c-3.24-.86-7.63-.61-7.63-.61h-1.25s-4.32-.24-7.51.61c-.34.09-4.27.95-4.71 4.28-.44 3.33-2.73 7.02-2.87 7.51-.16.57-.16 1.33 1.31 1.92 1.19.47 2.1-.22 2.44-.62s4.09-5.36 4.19-7.02c.1-1.65 3.73-2.25 5.74-2.25s2.13-.02 2.13-.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.1 20.18c-2.56-10.69-9.74-9.68-10.95-10.8-2.11-1.94-6.27-2.62-10.24-2.82v-.08c-.88-.01-1.87-.02-2.92-.01-1.05 0-2.04 0-2.91.01v.08c-3.97.22-8.13.88-10.24 2.82-1.22 1.12-8.39.1-10.95 10.8-2.56 10.7-.17 16.9-.17 16.9l.68-.23c.84 0 1.65.55 1.68 1.59 0 0 .15 8.25 1.9 13.9.13.42.52.71.95.71h1.9c.39 0 .68-.37.61-.78-.46-2.51-1.86-10.71-2.17-18.12-.27-6.47 1.99-12.13 2.99-11.96 11.85 2.1 19.63 2.22 31.48 0 .99-.18 3.26 5.49 2.99 11.96-.32 7.41-1.72 15.6-2.17 18.12-.08.4.22.78.61.78h1.9c.42 0 .82-.27.95-.71 1.74-5.65 1.9-13.9 1.9-13.9.03-1.05.85-1.59 1.68-1.59l.68.23s2.39-6.22-.17-16.9Z"
        })
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMoustacheMan104 = (AvatarMoustacheMan104);
;// ./src/Picto/GeneratedPictoComponents/AvatarMoustacheMan56.tsx


var AvatarMoustacheMan56_excluded = ["className"];
function AvatarMoustacheMan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarMoustacheMan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarMoustacheMan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarMoustacheMan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarMoustacheMan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarMoustacheMan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarMoustacheMan56_objectSpread(AvatarMoustacheMan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.23",
        cy: "27.87",
        rx: "13.71",
        ry: "19.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.88 25.57c-.7-.19-1.42-.18-2.08.1-1.98.82-2.71 3.63-1.61 6.28.96 2.32 2.99 3.74 4.81 3.51M41.36 35.48c1.75.07 3.63-1.33 4.54-3.53 1.1-2.65.38-5.46-1.61-6.28-.63-.26-1.05-.39-1.72-.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.78 13.89c-1.66-6.93-6.31-6.27-7.1-7-1.37-1.26-4.06-1.7-6.63-1.83v-.05c-.57 0-1.21-.01-1.89 0h-1.89v.05c-2.57.14-5.27.57-6.63 1.83-.79.73-5.44.07-7.1 7-1.66 6.93-.11 10.96-.11 10.96l.44-.15c.54 0 1.07.36 1.09 1.03 0 0 .1 5.35 1.23 9.01.08.27.34.46.61.46h1.23c.25 0 .44-.24.39-.5-.3-1.63-1.2-6.94-1.41-11.74-.18-4.19 1.29-7.86 1.94-7.75 7.68 1.36 12.72 1.44 20.4 0 .64-.12 2.11 3.56 1.94 7.75-.2 4.8-1.11 10.11-1.41 11.74-.05.26.14.5.39.5h1.23c.27 0 .53-.18.61-.46 1.13-3.66 1.23-9.01 1.23-9.01.02-.68.55-1.03 1.09-1.03l.44.15s1.55-4.03-.11-10.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m38.74 49.98 3.16-1.45c-.61-.09-1.78-1.06-2-1.64l3.8-.83c-1.32-.51-1.98-1.88-1.98-1.88.73.08 3.6.4 4.66-1.56s-3.99-.91-4.55-4.01c-.7-3.86-.62-3.41-.62-3.41l-8.27 6.08 5.81 8.71Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.87",
        cy: "28.37",
        r: "1.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.13",
        cy: "28.37",
        r: "1.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.83 37.67 1.51 2.34 1.32 1.93 5.39 4.76-2.58 2.89-3.67.4-2.07-1.62 1.42-1.54-3.09-.97 1.24-1.74-3.18-.43-1.13-1.12 3.26-1.16 1.58-3.74zM40.71 37.08l-1.5 2.68-1.74 2.61-2.46 2.59-2.69 1.71 2.85 3.22 3.04.36 1.72-.85.28-.3.59-.35-1.24-1.26-.43-.59s2.15-1.06 1.57-9.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.3 35.21 2.65.51 1.19.83.27 1.57.43 1.74.58 1.39.7 1.4.45.93-.42.26-1.44-.4-1.35-.47-2.61-4.67-1.74-.85-1.85-.42-2.68.2-1.93.05-1.78.47-.59.22-.57 1.29-.92 1.39-.94 1.51-1.06 1.46-1.38-.18-.74-.25.37-1.21.96-1.45.43-1.47.17-1.3.25-1.09.94-.93 2.18-.53 2.95-.52 3.93.11 3.55.41z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.82 35.17-2.13.07-1.49-10.68-1.37-.18-.42-5.54.88-5 1-3.1 1.7-1.9 1.88-1.17 1.82-.69 1.91-1.02 4.65-.93s14.46.9 17.6 19.36l-1.09 1.93-.56 6.54-.76 2.55-1.89-.2 1.48-9.05-.03-6.23-.73-3.4-1.68-1.51-7.27.87-3.98-.03-4.06-.27-2.35-.33-2.45-.16-1.63 2.78-.33 4.12.66 8.25.35 2.9.3 2.02Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.21 46.38s-2.98 6.93-9.06 2.25c.6-.09 1.76-1.05 1.98-1.62l-3.75-.82c1.31-.51 1.95-1.85 1.95-1.85-.72.08-3.55.39-4.6-1.54s4.62-.85 4.49-3.96l-.13-3.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.06 46.54c4.15 7.33 9.56 2.08 9.56 2.08-.6-.09-1.76-1.05-1.98-1.62l3.75-.82c-1.31-.51-1.95-1.85-1.95-1.85.72.08 3.55.39 4.6-1.54s-3.93-.89-4.49-3.96l-.61-3.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.73 35.39c-.59 1.9-1.38 3.64-2.34 5.16M18.06 41.02c-1.13-1.69-2.05-3.66-2.71-5.83M36.46 43.09c-2.33 2.52-5.23 4.02-8.39 4.02s-5.82-1.38-8.09-3.71M13.6 25.18c-.71-.2-1.43-.18-2.1.1-2 .83-2.73 3.67-1.62 6.33.97 2.34 3.02 3.77 4.86 3.54M41.32 35.17c1.76.07 3.66-1.34 4.58-3.56 1.11-2.67.38-5.51-1.62-6.33-.63-.26-1.06-.39-1.74-.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.07 28.9c0 2.3 1.86 2.41 1.86 3.73s-1.91 1.38-1.91 1.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.42 26c1.4-1.27 3.67-1.27 5.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.57 26c1.4-1.27 3.67-1.27 5.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.01 39.84c.92 1.47 3.66 1.78 4.75-.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.22 37.48s.09.01 1.5.01 3.95.38 4.02 1.42c.07 1.05 2.7 4.18 2.94 4.43s.88.69 1.71.39c1.03-.37 1.04-.85.92-1.21-.1-.31-1.7-2.64-2.01-4.74-.31-2.1-3.07-2.65-3.3-2.7-2.24-.54-5.27-.39-5.27-.39h-.86s-2.98-.15-5.18.39c-.23.06-2.95.6-3.25 2.7s-1.88 4.43-1.98 4.74c-.11.36-.11.84.91 1.21.82.3 1.45-.14 1.69-.39s2.83-3.39 2.89-4.43c.07-1.05 2.57-1.42 3.96-1.42 1.39 0 1.47-.01 1.47-.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.61 13.96c-1.67-6.97-6.35-6.31-7.14-7.04-1.37-1.27-4.09-1.71-6.67-1.84v-.05c-.57 0-1.22-.01-1.91 0h-1.9v.05c-2.59.14-5.3.57-6.67 1.84-.79.73-5.47.07-7.14 7.04s-.11 11.02-.11 11.02l.45-.15c.55 0 1.08.36 1.1 1.04 0 0 .1 5.38 1.24 9.06.09.28.34.46.62.46h1.24c.26 0 .45-.24.4-.51-.3-1.64-1.21-6.98-1.42-11.81-.18-4.22 1.3-7.91 1.95-7.79 7.72 1.37 12.79 1.45 20.52 0 .64-.12 2.13 3.58 1.95 7.79-.21 4.83-1.12 10.17-1.42 11.81-.05.26.14.51.4.51h1.24c.28 0 .53-.18.62-.46 1.13-3.68 1.24-9.06 1.24-9.06.02-.69.55-1.04 1.1-1.04l.45.15s1.56-4.05-.11-11.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarMoustacheMan56 = (AvatarMoustacheMan56);
;// ./src/Picto/GeneratedPictoComponents/AvatarOutbackMale104.tsx


var AvatarOutbackMale104_excluded = ["className"];
function AvatarOutbackMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarOutbackMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarOutbackMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarOutbackMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarOutbackMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarOutbackMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarOutbackMale104_objectSpread(AvatarOutbackMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.92 35.48c-.88-.22-1.78-.18-2.6.16-2.61 1.08-3.56 4.78-2.12 8.26 1.25 3.02 3.89 4.89 6.27 4.62M69.11 48.55c2.33.14 4.85-1.7 6.07-4.64 1.44-3.48.49-7.18-2.12-8.26-.82-.34-1.7-.38-2.58-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.81 31.85c.42 2.13.65 4.38.65 6.69 0 14.13-8.4 25.59-18.76 25.59S32.94 52.67 32.94 38.54c0-2.27.22-4.48.62-6.57M68.74 26.19a.374.374 0 0 1-.27-.33c-.23-2.28-2.26-19.22-11.34-19.22h-9.74c-9.08 0-11.1 16.94-11.34 19.22-.02.16-.12.28-.27.33l-13.44 4.03c-.43.13-.34.76.11.76h59.61c.45 0 .54-.63.11-.76l-13.44-4.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.97 81.5c-1.59-1.9-1.47-1.79-4.03-3.42-4.01-2.56-8.36-4.57-12.27-6.54-5.72-2.88-8.96-4.12-9.51-10.4l-18.35.47c-.48 6.42-3.17 7.02-8.95 9.94-3.91 1.97-8.26 3.98-12.27 6.54-2.56 1.64-2.22 1.36-4.03 3.42 0 0 9.8 17.74 34.69 17.74s34.71-17.74 34.71-17.74ZM79.28 42.62h3.25v6.49h-3.25zM21.99 46.72h3.25v6.49h-3.25z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.26 47.43s0 3.32.93 3.65.19 1.33.19 1.33h-1.54l-.12-4.98h.54ZM35.61 42.92s0 3.3.93 3.63.19 1.33.19 1.33h-1.55l-.12-4.96h.54ZM67.39 39.47s0 3.28-.97 3.61-.2 1.32-.2 1.32h1.61l.13-4.94h-.56ZM63.87 13.75c-.2-4.03-2.14-6.82-6.05-7.75-.63-.15-2.01-.63-2.34-.24-.66.24-6.37-.96-9.25.41-2.52 1.2-4.44 3.17-5.97 5.5-1.94 2.97-2.78 6.46-3.2 9.94-.16 1.33-.16 3.51-.95 4.65-.9 1.29-10.92 3.79-13.19 4.29-1.64.36 9.9 1.11 11.6 1 10.5-.69 15.23-.4 23.93-7.19 3.22-2.51 5.62-6.42 5.41-10.61Zm-26.29 14.3c-.05 0-.1.01-.15.02.04-.03.07-.07.11-.1.01.03.03.05.04.08ZM81.36 43.4s0 3.26-.97 3.58-.2 1.31-.2 1.31h1.61l.13-4.89h-.56Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.55 76.39c.86.55.46 1.49-.44 1.12-4.76-1.91-7.08 4.72-11.73.23-.9-1.54-1.92-4.47-1.86-5.03.1-1.01-3.09-2.48-1.1-3.28 2.02-1.82 10.74 4.78 15.13 6.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.53 76.68c-.86.55-.46 1.49.44 1.12 4.76-1.91 7.08 4.72 11.73.23.9-1.54 1.92-4.47 1.86-5.03-.1-1.01 3.09-2.48 1.1-3.28-2.02-1.82-10.74 4.78-15.13 6.96Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.45 81.4c1.81-2.06 1.47-1.79 4.03-3.42 4.01-2.56 8.36-4.57 12.27-6.54 5.78-2.91 8.47-3.51 8.95-9.94M86.85 81.4c-1.59-1.9-1.47-1.79-4.03-3.42-4.01-2.56-8.36-4.57-12.27-6.54-5.72-2.88-8.96-4.12-9.51-10.4M32.8 35.38c-.88-.22-1.78-.18-2.6.16-2.61 1.08-3.56 4.78-2.12 8.26 1.25 3.02 3.89 4.89 6.27 4.62M69 48.44c2.33.14 4.85-1.7 6.07-4.64 1.44-3.48.49-7.18-2.12-8.26-.82-.34-1.7-.38-2.58-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.69 31.74c.42 2.13.65 4.38.65 6.69 0 14.13-8.4 25.59-18.76 25.59S32.82 52.56 32.82 38.43c0-2.27.22-4.48.62-6.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.62 40.14c0 3.84 2.51 4.02 2.51 6.23s-2.56 2.3-2.56 2.3M41.34 36.24c1.88-1.71 4.94-1.71 6.82 0M54.98 36.24c1.88-1.71 4.94-1.71 6.82 0M49.87 54.99c2.03 1.15 4.19.1 5.12-.77M42.34 64.89l-8.18 17.99s6.54-1.59 9.82-1.64c3.47-.05 7 1.52 8.18 4.91l-9.82-21.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m61.97 64.89 8.18 17.99s-6.54-1.59-9.82-1.64c-3.47-.05-7 1.52-8.18 4.91l9.82-21.27Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.46",
        cy: "40.93",
        r: "1.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.17",
        cy: "40.93",
        r: "1.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.15",
        cy: "90.22",
        r: "1.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.15",
        cy: "94.73",
        r: "1.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.15",
        cy: "99.24",
        r: "1.26"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.28 42.62h3.25v6.49h-3.25zM80.91 42.62V31.17M65.47 38.65h3.25v6.49h-3.25zM67.09 38.08v-6.59M21.99 46.72h3.25v6.49h-3.25zM23.61 46.72V31.45M68.62 26.08a.374.374 0 0 1-.27-.33c-.23-2.28-2.26-19.22-11.34-19.22h-9.74c-9.08 0-11.1 16.94-11.34 19.22-.02.16-.12.28-.27.33l-13.44 4.03c-.43.13-.34.76.11.76h59.61c.45 0 .54-.63.11-.76l-13.44-4.03ZM34.34 42.18h3.25v6.49h-3.25zM35.96 41.61V31.45"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarOutbackMale104 = (AvatarOutbackMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarOutbackMale56.tsx


var AvatarOutbackMale56_excluded = ["className"];
function AvatarOutbackMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarOutbackMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarOutbackMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarOutbackMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarOutbackMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarOutbackMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarOutbackMale56_objectSpread(AvatarOutbackMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.31 26.15c-.69-.17-1.4-.14-2.05.13-2.05.85-2.8 3.76-1.67 6.5.98 2.38 3.06 3.84 4.94 3.63M41.79 36.43c1.83.11 3.82-1.34 4.77-3.65 1.13-2.74.39-5.65-1.67-6.5-.64-.27-1.34-.3-2.03-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.33 23.29c.33 1.68.51 3.44.51 5.27 0 11.12-6.61 20.13-14.76 20.13s-14.76-9.01-14.76-20.13c0-1.79.17-3.52.49-5.17M49.03 31.96h2.51v5.01h-2.51z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.29 28.97h2.51v5.01h-2.51zM4.81 35.13h2.51v5.01H4.81zM40.8 19.2a.277.277 0 0 1-.21-.25c-.18-1.76-1.74-14.84-8.75-14.84h-7.52c-7.01 0-8.57 13.07-8.75 14.84a.29.29 0 0 1-.21.25L4.99 22.31c-.33.1-.26.59.09.59h46.01c.35 0 .42-.49.09-.59L40.81 19.2ZM14.34 31.53h2.51v5.01h-2.51z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M5.76 35.51s0 2.92.82 3.21.17 1.17.17 1.17H5.4l-.11-4.39h.47ZM15.26 31.67s0 3.14.89 3.45.18 1.26.18 1.26h-1.47l-.12-4.71h.51ZM40.99 29.57s0 2.75-.81 3.03-.17 1.11-.17 1.11h1.35l.11-4.13H41ZM37.38 10.18c-.16-2.93-1.69-4.96-4.79-5.64-.5-.11-1.59-.46-1.85-.18-.52.18-5.03-.69-7.32.3-1.99.87-3.51 2.3-4.72 4-1.54 2.16-2.2 4.7-2.53 7.23-.13.96-.12 2.55-.75 3.38-.71.94-8.64 2.76-10.43 3.12-1.3.26 7.83.81 9.17.73 8.3-.51 12.04-.29 18.92-5.23 2.55-1.83 4.45-4.66 4.28-7.72ZM50.74 32.43s0 2.79-.83 3.07-.17 1.12-.17 1.12h1.38l.11-4.2h-.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.39 26.22c-.69-.17-1.4-.14-2.05.13-2.05.85-2.8 3.76-1.67 6.5.98 2.38 3.06 3.84 4.94 3.63M41.87 36.5c1.83.11 3.82-1.34 4.77-3.65 1.13-2.74.39-5.65-1.67-6.5-.64-.27-1.34-.3-2.03-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.41 23.36c.33 1.68.51 3.44.51 5.27 0 11.12-6.61 20.13-14.76 20.13S13.4 39.75 13.4 28.63c0-1.79.17-3.52.49-5.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.19 29.97c0 3.02 1.98 3.16 1.98 4.9s-2.01 1.81-2.01 1.81M20.1 26.9c1.48-1.34 3.89-1.34 5.37 0M30.84 26.9c1.48-1.34 3.89-1.34 5.37 0M26.81 41.65c1.59.91 3.29.08 4.03-.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.94",
        cy: "29.49",
        r: "1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.37",
        cy: "29.49",
        r: "1.22"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.11 32.04h2.51v5.01h-2.51zM50.36 32.04v-8.85M39.36 29.04h2.51v5.01h-2.51zM40.61 28.6v-5.08M4.88 35.2h2.51v5.01H4.88zM6.13 35.2V23.41M40.87 19.27a.277.277 0 0 1-.21-.25c-.18-1.76-1.74-14.84-8.75-14.84h-7.52c-7.01 0-8.57 13.07-8.75 14.84a.29.29 0 0 1-.21.25L5.06 22.38c-.33.1-.26.59.09.59h46.01c.35 0 .42-.49.09-.59l-10.37-3.11ZM14.41 31.61h2.51v5.01h-2.51zM15.67 31.16v-7.84"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarOutbackMale56 = (AvatarOutbackMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarPerson104.tsx


var AvatarPerson104_excluded = ["className"];
function AvatarPerson104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPerson104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPerson104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPerson104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPerson104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPerson104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPerson104_objectSpread(AvatarPerson104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "52.05",
        cy: "41.39",
        rx: "20.94",
        ry: "28.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.05 38.01c-1.03-.29-2.09-.26-3.06.14-2.91 1.21-3.97 5.34-2.36 9.22 1.41 3.4 4.39 5.49 7.07 5.15M71.39 52.56c2.57.1 5.33-1.95 6.67-5.18 1.61-3.89.55-8.01-2.36-9.22-.92-.38-1.91-.43-2.9-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.45 79.23c5.1-2.45 4.15-4.86 4.15-11.11h17.14c.03 6.22-1.09 8.66 4.21 11.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.94 6.19c-20.26 0-23.79 18.71-24.37 23.64-.07.62.42 1.19 1.05 1.17 12.24-.33 27.48-5.89 27.48-15.25 0 0-.3 14.67 17.96 15.25.62.02 1.11-.52 1.05-1.13-.46-4.89-3.52-23.66-23.16-23.66h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.67 78.76s-15.08 9.08-15.21 9.95 14.31 10.53 27.78 10.53 26.92-10.52 26.92-10.52L63.9 78.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.7 79.8c-6.55 3.54-17.13 5.05-23.26.42-.16-.12-.39-.07-.58-.07-.38-1.67-4.26-1.18-4.03.57.78 5.79 7.46 10 16.14 10.91 10.72 1.12 14.01-4.12 14.7-10.14.14-1.24-1.64-2.4-2.96-1.69Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.14 8.15c-5.3.16-10.57 2.36-14.17 6.16-4.09 4.3-5.68 10.03-6.94 15.59-.47 2.07 3.42.97 3.48.96 6.07-.61 12.3-1.57 17.62-4.69 2.05-1.2 3.5-2.53 4.97-4.37.75-.95 1.62-2.84 1.76-2.91.26 1.1 1.47 2.05 1.69 2.52 2.26 4.96 8.24 8.59 11.83 9.28 1.01.2 2.28-.45 2.18-1.6-.92-11.32-10.07-21.3-22.41-20.93h-.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.33",
        cy: "43.04",
        r: "1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.57",
        cy: "43.04",
        r: "1.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.95 38.04c-1.03-.29-2.09-.26-3.06.14-2.91 1.21-3.97 5.34-2.36 9.22 1.41 3.4 4.39 5.49 7.07 5.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.39 30.77c.97 3.29 1.5 6.88 1.5 10.64 0 15.77-9.38 28.55-20.94 28.55S31.01 57.18 31.01 41.41c0-3.62.49-7.07 1.39-10.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.64 52.56c2.57.1 5.33-1.95 6.67-5.18 1.61-3.89.55-8.01-2.36-9.22-.92-.38-1.91-.43-2.9-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.01 43.46c0 4.16 2.71 4.35 2.71 6.75s-2.78 2.5-2.78 2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.88 39.24c2.04-1.85 5.34-1.85 7.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.65 39.24c2.04-1.85 5.34-1.85 7.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.47 58.97c1.33 2.14 5.32 2.59 6.91-.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.35 79.26c5.1-2.45 4.15-4.86 4.15-11.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.64 68.15c.03 6.22-1.09 8.66 4.21 11.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.84 6.21c-20.26 0-23.79 18.71-24.37 23.64-.07.62.42 1.19 1.05 1.17C41.76 30.69 57 25.13 57 15.77c0 0-.3 14.67 17.96 15.25.62.02 1.11-.52 1.05-1.13C75.55 25 72.49 6.23 52.85 6.23h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.48 78.99c4.38 2.63 9.44 5.38 13.48 8.51.58.47 1.14.97 1.67 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.37 89c.52-.53 1.06-1.03 1.63-1.49 3.97-3.11 9.21-5.85 13.5-8.46 0 0 4.5 4.85 12.57 4.85 5.21-.02 8.35-1.63 12.41-4.85"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPerson104 = (AvatarPerson104);
;// ./src/Picto/GeneratedPictoComponents/AvatarPerson56.tsx


var AvatarPerson56_excluded = ["className"];
function AvatarPerson56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPerson56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPerson56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPerson56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPerson56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPerson56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPerson56_objectSpread(AvatarPerson56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.16",
        cy: "32.4",
        rx: "16.4",
        ry: "21.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.71 28.79c-.81-.22-1.63-.2-2.39.11-2.28.95-3.11 4.18-1.85 7.22 1.1 2.66 3.44 4.3 5.54 4.03M43.31 40.18c2.01.08 4.18-1.53 5.22-4.06 1.26-3.04.43-6.28-1.85-7.22-.72-.3-1.5-.33-2.27-.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.6 4.44c-14.73 0-17.3 13.6-17.72 17.19-.05.45.3.86.76.85 8.9-.24 19.98-4.28 19.98-11.09 0 0-.22 10.67 13.06 11.09.45.02.81-.38.76-.82-.33-3.56-2.56-17.2-16.84-17.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.14",
        cy: "32.32",
        r: "1.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.18",
        cy: "32.32",
        r: "1.52"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.69 6.28c-3.96.12-7.9 1.68-10.59 4.37-3.06 3.05-4.25 7.12-5.19 11.07-.35 1.47 2.55.69 2.6.68 4.54-.43 8.75-1.27 12.73-3.49 1.54-.85 2.8-1.76 3.9-3.06.56-.67 1.28-2.89 1.38-2.94.19.78.96 3.26 1.13 3.6 1.69 3.52 6.49 5.28 9.18 5.77.76.14 1.7-.32 1.63-1.14-.68-8.03-7.53-15.12-16.75-14.85Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.62 22.61c1.12 2.91 1.76 6.21 1.76 9.7 0 11.82-7.26 21.41-16.22 21.41s-16.22-9.58-16.22-21.41c0-3.46.62-6.72 1.72-9.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.61 28.98c-.8-.22-1.62-.2-2.37.11-2.26.94-3.08 4.13-1.83 7.14 1.09 2.63 3.4 4.25 5.47 3.99M43.65 40.34c1.99.08 3.62-1.6 4.65-4.1 1.25-3.01.43-6.21-1.83-7.14-.71-.3-1.48-.33-2.24-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.2 33.17c0 3.22 2.1 3.37 2.1 5.23s-2.15 1.93-2.15 1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.58 29.9c1.58-1.43 4.14-1.43 5.72 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.02 29.9c1.58-1.43 4.14-1.43 5.72 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.24 45.19c1.03 1.66 4.12 2.01 5.35-.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.6 4.57c-14.73 0-17.3 13.6-17.72 17.19-.05.45.3.86.76.85 8.9-.24 19.98-4.28 19.98-11.09 0 0-.22 10.67 13.06 11.09.45.02.81-.38.76-.82-.33-3.56-2.56-17.2-16.84-17.2Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPerson56 = (AvatarPerson56);
;// ./src/Picto/GeneratedPictoComponents/AvatarPersonAfro104.tsx


var AvatarPersonAfro104_excluded = ["className"];
function AvatarPersonAfro104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPersonAfro104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPersonAfro104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPersonAfro104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPersonAfro104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPersonAfro104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPersonAfro104_objectSpread(AvatarPersonAfro104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.87 45.36c-1.87.46-3.55.77-5.3.79h-.08c-1.91-.01-3.43-.33-5.3-.79-7.38-1.82-9.05.42-9.89 2.81a28.93 28.93 0 0 0-1.07 7.8c0 12.15 7.29 21.99 16.3 21.99s16.3-9.85 16.3-21.99c0-2.75-.39-5.37-1.07-7.8-.5-2.19-2.5-4.63-9.89-2.81h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.51 69.55c-1.04-.45-2.65.21-3.65-.35-1-.56-1.25-2.28-2.18-2.95-.93-.67-2.64-.34-3.49-1.1-.85-.76-.76-2.49-1.52-3.33-.77-.84-2.51-.88-3.19-1.8-.68-.92-.22-2.58-.8-3.57-.58-.99-2.27-1.38-2.75-2.42s.34-2.57-.02-3.66c-.36-1.08-1.93-1.83-2.17-2.95s.88-2.44.76-3.58c-.12-1.14-1.49-2.19-1.49-3.34s1.37-2.22 1.49-3.34c.12-1.12-1-2.48-.76-3.58.24-1.11 1.81-1.87 2.17-2.95.36-1.07-.45-2.63.02-3.66.47-1.03 2.17-1.45 2.75-2.42.58-.97.12-2.66.8-3.57.68-.91 2.42-.95 3.19-1.8.77-.84.67-2.57 1.52-3.33s2.56-.43 3.49-1.1c.93-.67 1.18-2.38 2.18-2.95 1-.57 2.6.11 3.65-.35 1.05-.46 1.64-2.08 2.74-2.43 1.1-.35 2.51.64 3.64.41 1.13-.23 2.04-1.7 3.18-1.82 1.14-.12 2.32 1.14 3.48 1.14s2.35-1.25 3.48-1.14c1.13.11 2.07 1.59 3.18 1.82 1.11.23 2.56-.74 3.64-.41 1.07.34 1.7 1.98 2.74 2.43 1.04.45 2.65-.21 3.65.35 1 .56 1.25 2.28 2.18 2.95.93.67 2.64.34 3.49 1.1.85.76.76 2.49 1.52 3.33.77.84 2.51.88 3.19 1.8.68.92.22 2.58.8 3.57.58.99 2.27 1.38 2.75 2.42s-.34 2.57.02 3.66c.36 1.08 1.93 1.83 2.17 2.95s-.88 2.44-.76 3.58c.12 1.14 1.49 2.19 1.49 3.34s-1.37 2.22-1.49 3.34c-.12 1.12 1 2.48.76 3.58-.24 1.11-1.81 1.87-2.17 2.95-.36 1.07.45 2.63-.02 3.66-.47 1.03-2.17 1.45-2.75 2.42-.58.97-.12 2.66-.8 3.57-.68.91-2.42.95-3.19 1.8-.77.84-.67 2.57-1.52 3.33-.85.76-2.56.43-3.49 1.1s-1.18 2.38-2.18 2.95c-1 .57-2.6-.11-3.65.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.2 92.06c-3.49-2.7-7.84-5.07-11.61-7.33v.05l.99.53c-4.5-2.31-3.55-4.61-3.57-10.48l-16.36.05c0 5.9.81 8.17-3.53 10.48l.95-.58c-3.7 2.25-8.21 4.6-11.63 7.29 0 0 9.34 7.17 22.08 7.17s22.67-7.18 22.67-7.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m56.02 7.91-3.34 1.55-3.79-.93-2.83 1.86-3.63-.64-2.7 2.54-3.73.42-1.96 2.86-3.6.96-1.38 3.37-3.02 1.64-.71 3.25-.51.8-1.57 1.22-.74.93v3.15l-1 1.32-.93 1.06v1l.22 1.45.39 1.48-.26 1.45-1.12 1.77v.9l.77 1.03.39 1-.03.84.1.64-.32 1.38-.29.8.26 1 .87 1.19 1.06 1.29.1 1.53-.26 1.59.29.9 1.25.64 1.06 1 .51 1 .22 1.61.13.93.45.48 1.03.42 1.35.9.77.74.45 1.03.29.83.35 1.2 1.22.13 1 .16.77.29.87.55.51.96.74 1.22.9.42 1.96-.19-2.25-6.16-.64-6.05.87-7.75 2.19-3.25 3.82-1.32 2.86.26 2.7.61 4.18.58 2.41-.16L58 45l1.99-.47 2.35-.29 2.15.29 1.96 1.09 1.29 1.16 1.02 2.09.23 2.51.51 5.4-.16 2.7-.74 2.31-.42 2.3-.55 2.26-.67 1.7-.06.8 1.12.16 1.16-.39 1.22-1.67.74-1.06 1.29-.55 1.35-.29 1.06-.84.37-.93.89-2.14 1.37-.6 2.13-.22s8.41-31.5-23.58-52.39Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.87 45.63c-1.87.46-3.55.77-5.3.79h-.08c-1.91-.01-3.43-.33-5.3-.79-7.38-1.82-9.05.42-9.89 2.81a28.93 28.93 0 0 0-1.07 7.8c0 12.15 7.29 21.99 16.3 21.99s16.3-9.85 16.3-21.99c0-2.75-.39-5.37-1.07-7.8-.5-2.19-2.5-4.63-9.89-2.81h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.98 69.83c1.85 1.05 3.82.1 4.68-.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.51 69.82c-1.04-.45-2.65.21-3.65-.35-1-.56-1.25-2.28-2.18-2.95-.93-.67-2.64-.34-3.49-1.1-.85-.76-.76-2.49-1.52-3.33-.77-.84-2.51-.88-3.19-1.8-.68-.92-.22-2.58-.8-3.57-.58-.99-2.27-1.38-2.75-2.42s.34-2.57-.02-3.66c-.36-1.08-1.93-1.83-2.17-2.95s.88-2.44.76-3.58c-.12-1.14-1.49-2.19-1.49-3.34s1.37-2.22 1.49-3.34c.12-1.12-1-2.48-.76-3.58.24-1.11 1.81-1.87 2.17-2.95.36-1.07-.45-2.63.02-3.66.47-1.03 2.17-1.45 2.75-2.42.58-.97.12-2.66.8-3.57.68-.91 2.42-.95 3.19-1.8.77-.84.67-2.57 1.52-3.33s2.56-.43 3.49-1.1c.93-.67 1.18-2.38 2.18-2.95 1-.57 2.6.11 3.65-.35 1.05-.46 1.64-2.08 2.74-2.43 1.1-.35 2.51.64 3.64.41 1.13-.23 2.04-1.7 3.18-1.82 1.14-.12 2.32 1.14 3.48 1.14s2.35-1.25 3.48-1.14c1.13.11 2.07 1.59 3.18 1.82 1.11.23 2.56-.74 3.64-.41 1.07.34 1.7 1.98 2.74 2.43 1.04.45 2.65-.21 3.65.35 1 .56 1.25 2.28 2.18 2.95.93.67 2.64.34 3.49 1.1.85.76.76 2.49 1.52 3.33.77.84 2.51.88 3.19 1.8.68.92.22 2.58.8 3.57.58.99 2.27 1.38 2.75 2.42s-.34 2.57.02 3.66c.36 1.08 1.93 1.83 2.17 2.95s-.88 2.44-.76 3.58c.12 1.14 1.49 2.19 1.49 3.34s-1.37 2.22-1.49 3.34c-.12 1.12 1 2.48.76 3.58-.24 1.11-1.81 1.87-2.17 2.95-.36 1.07.45 2.63-.02 3.66-.47 1.03-2.17 1.45-2.75 2.42-.58.97-.12 2.66-.8 3.57-.68.91-2.42.95-3.19 1.8-.77.84-.67 2.57-1.52 3.33-.85.76-2.56.43-3.49 1.1s-1.18 2.38-2.18 2.95c-1 .57-2.6-.11-3.65.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.01 75.56c.02 5.86-.92 8.17 3.57 10.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.12 86.09c4.33-2.31 3.53-4.58 3.53-10.48"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m66.17 51.71-.16.15c-.62-.71-1.78-1.02-2.68-.19-2.59 2.4-5.64 4.44-7.77 7.2-.36.46 1.61 2.86 1.61 2.86.56.85 1.86 1.32 2.85.41l8.73-8.04s-1.91-3-2.59-2.39ZM46.94 51.71l-.16.15c-.62-.71-1.78-1.02-2.68-.19l-7.77 7.2s.9 3 1.61 2.86c.56.85 1.86 1.32 2.85.41l8.73-8.04-2.59-2.39ZM64.24 86.26s1.58.1.44 2.88c-1.94 4.77-12.84 10.48-20.66 5.32-8.76-5.78-1.03-9.06-1.03-9.06s4.67 4.94 9.79 4.87c6.65-.09 5.06-.47 11.45-4.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.59 85.46c3.77 2.26 8.13 4.63 11.61 7.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.44 92.8c3.42-2.68 7.93-5.03 11.63-7.29 0 0 3.87 4.18 10.83 4.18 4.49-.01 7.19-1.41 10.69-4.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.33 56.04c0 4.24-3.38 6.81-7.55 6.81s-6.55-1.52-6.55-5.76c0-3.88.82-6.15 6.18-6.15 4.08 0 7.92.25 7.92 5.1ZM54.72 56.04c0 4.24 3.38 6.81 7.55 6.81s6.55-1.52 6.55-5.76c0-3.88-.82-6.15-6.18-6.15-4.08 0-7.92.25-7.92 5.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.33 56.04c0-1.23.99-1.67 2.19-1.67s2.19.44 2.19 1.67"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.94 56.04c0 3.5 2.29 3.67 2.29 5.68s-2.33 2.1-2.33 2.1"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPersonAfro104 = (AvatarPersonAfro104);
;// ./src/Picto/GeneratedPictoComponents/AvatarPersonAfro56.tsx


var AvatarPersonAfro56_excluded = ["className"];
function AvatarPersonAfro56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPersonAfro56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPersonAfro56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPersonAfro56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPersonAfro56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPersonAfro56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPersonAfro56_objectSpread(AvatarPersonAfro56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.42 30.67c-1.21.3-2.29.49-3.42.51h-.05c-1.23 0-2.21-.21-3.42-.51-4.77-1.17-5.84.27-6.39 1.82-.44 1.57-.69 3.26-.69 5.03 0 7.84 4.71 14.2 10.52 14.2s10.52-6.36 10.52-14.2c0-1.77-.25-3.46-.69-5.03-.33-1.41-1.61-2.99-6.39-1.82Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.57 46.29c-.67-.29-1.71.13-2.35-.23-.64-.36-.81-1.47-1.41-1.9-.6-.43-1.7-.22-2.26-.71s-.49-1.61-.98-2.15c-.49-.54-1.62-.57-2.06-1.16-.44-.59-.14-1.67-.52-2.31-.37-.64-1.46-.89-1.77-1.56-.31-.67.22-1.66-.01-2.36s-1.24-1.18-1.4-1.9c-.16-.72.57-1.58.49-2.31-.08-.74-.96-1.41-.96-2.16s.88-1.44.96-2.16-.64-1.6-.49-2.31c.16-.71 1.17-1.21 1.4-1.9.23-.69-.29-1.7.01-2.36.3-.66 1.4-.93 1.77-1.56.37-.63.08-1.72.52-2.31.44-.59 1.56-.62 2.06-1.16.49-.54.43-1.66.98-2.15s1.65-.28 2.26-.71c.6-.43.76-1.53 1.41-1.9.64-.37 1.68.07 2.35-.23.68-.3 1.06-1.34 1.77-1.57.71-.23 1.62.41 2.35.26.73-.15 1.32-1.1 2.05-1.17.74-.08 1.5.74 2.25.74s1.52-.81 2.25-.74c.73.07 1.34 1.03 2.05 1.17.71.15 1.65-.48 2.35-.26.69.22 1.1 1.28 1.77 1.57.67.29 1.71-.13 2.35.23.64.36.81 1.47 1.41 1.9.6.43 1.7.22 2.26.71.55.49.49 1.61.98 2.15.49.54 1.62.57 2.06 1.16.44.59.14 1.67.52 2.31.37.64 1.46.89 1.77 1.56.31.67-.22 1.66.01 2.36s1.24 1.18 1.4 1.9-.57 1.58-.49 2.31c.08.74.96 1.41.96 2.16s-.88 1.44-.96 2.16.64 1.6.49 2.31c-.16.71-1.17 1.21-1.4 1.9-.23.69.29 1.7-.01 2.36-.3.66-1.4.93-1.77 1.56-.37.63-.08 1.72-.52 2.31-.44.59-1.56.62-2.06 1.16-.49.54-.43 1.66-.98 2.15s-1.65.28-2.26.71-.76 1.53-1.41 1.9c-.64.37-1.68-.07-2.35.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m30.18 6.53-1.93.8-2.49-1.01-1.9 1.48-2.3-.37-1.77 1.46-2.25.24-1.53 1.93-2.11.59-1.17 2.41-1.8.79-.59 2.19-.32.59-1 .77-.58.8.29 1.38-.21.79-.58.77-.67.74.06.88.31.88v.89l-.21.69-.74.9.31 1.11.5.66.25.64-.02.54-.1.3-.37.71-.03.79.34.66.56.76.57.7-.13 1.07.14 1.06.19.58.8.41.68.64.33.64.14 1.03.08.6.29.31.66.27.87.58.5.47.29.66.19.53.23.77.78.08.64.1.5.19.56.35.33.62.47.78.58.27 1.26-.12-1.44-3.96-.41-3.89.56-4.97 1.4-2.08 2.46-.85 1.84.17 1.73.39 2.68.37 1.55-.1 2.1-.38 1.28-.3 1.51-.19 1.38.19 1.26.7.83.74.66 1.34.15 1.61.33 3.47-.21 1.74-.37 1.48-.27 1.48-.6 1.37-.5 1.15.27.54.72.1.74-.25.78-1.07.47-.68.83-.35.87-.19.68-.54.24-.6.57-1.38.88-.39 1.4-.51S50.73 19.92 30.19 6.5Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.04 34.55-.1.09c-.4-.45-1.14-.66-1.72-.12-1.66 1.54-3.62 2.85-4.98 4.62-.23.3 1.04 1.84 1.04 1.84.36.55 1.19.85 1.83.26 1.87-1.72 3.73-3.44 5.6-5.16 0 0-1.23-1.92-1.66-1.53ZM24.7 34.55l-.1.09c-.4-.45-1.14-.66-1.72-.12-1.66 1.54-3.33 3.08-4.98 4.62 0 0 .58 1.92 1.04 1.84.36.55 1.19.85 1.83.26 1.87-1.72 3.73-3.44 5.6-5.16l-1.66-1.53Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.44 30.61c-1.21.3-2.29.49-3.41.51h-.05c-1.23 0-2.21-.21-3.41-.51-4.75-1.17-5.83.27-6.37 1.81a18.56 18.56 0 0 0-.69 5.02c0 7.82 4.7 14.17 10.5 14.17s10.5-6.34 10.5-14.17c0-1.77-.25-3.46-.69-5.02-.32-1.41-1.61-2.98-6.37-1.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27 46.2c1.19.68 2.46.06 3.01-.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.71 46.15c-.67-.29-1.81.18-2.45-.18-.64-.36-.8-1.47-1.4-1.9-.6-.43-1.7-.22-2.25-.71s-.49-1.6-.98-2.14-1.62-.56-2.05-1.16c-.44-.59-.14-1.66-.51-2.3-.37-.63-1.46-.89-1.77-1.56-.31-.67.22-1.66-.01-2.36s-1.24-1.18-1.4-1.9c-.16-.72.56-1.57.49-2.31-.08-.73-.96-1.41-.96-2.15s.88-1.43.96-2.15-.64-1.59-.49-2.31c.16-.71 1.16-1.21 1.4-1.9.23-.69-.29-1.69.01-2.36.3-.66 1.4-.93 1.77-1.56.37-.63.08-1.71.51-2.3.44-.59 1.56-.61 2.05-1.16.49-.54.43-1.66.98-2.14s1.65-.28 2.25-.71c.6-.43.76-1.53 1.4-1.9.64-.37 1.67.07 2.35-.23.68-.3 1.06-1.34 1.76-1.57.71-.23 1.62.41 2.34.26.73-.15 1.31-1.09 2.05-1.17.73-.08 1.5.73 2.24.73s1.52-.8 2.24-.73c.73.07 1.33 1.02 2.05 1.17.71.15 1.65-.48 2.34-.26.69.22 1.09 1.28 1.76 1.57.67.29 1.71-.13 2.35.23.64.36.8 1.47 1.4 1.9.6.43 1.7.22 2.25.71s.49 1.6.98 2.14 1.62.56 2.05 1.16c.44.59.14 1.66.51 2.3.37.63 1.46.89 1.77 1.56.31.67-.22 1.66.01 2.36s1.24 1.18 1.4 1.9-.56 1.57-.49 2.31c.08.73.96 1.41.96 2.15s-.88 1.43-.96 2.15.64 1.59.49 2.31c-.16.71-1.16 1.21-1.4 1.9-.23.69.29 1.69-.01 2.36-.3.66-1.4.93-1.77 1.56-.37.63-.08 1.71-.51 2.3-.44.59-1.56.61-2.05 1.16-.49.54-.43 1.66-.98 2.14-.55.49-1.65.28-2.25.71s-.76 1.53-1.4 1.9c-.64.37-1.72-.14-2.4.16"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.57 37.25c0 2.73-2.18 4.39-4.87 4.39s-4.22-.98-4.22-3.71c0-2.5.53-3.96 3.98-3.96 2.63 0 5.1.16 5.1 3.28ZM29.4 37.25c0 2.73 2.18 4.39 4.87 4.39s4.22-.98 4.22-3.71c0-2.5-.53-3.96-3.98-3.96-2.63 0-5.1.16-5.1 3.28ZM26.57 37.25c0-.79.64-1.08 1.41-1.08s1.41.28 1.41 1.08"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.53 37.14c0 2.25 1.47 2.35 1.47 3.64s-1.5 1.35-1.5 1.35"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPersonAfro56 = (AvatarPersonAfro56);
;// ./src/Picto/GeneratedPictoComponents/AvatarPersonBusiness104.tsx


var AvatarPersonBusiness104_excluded = ["className"];
function AvatarPersonBusiness104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPersonBusiness104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPersonBusiness104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPersonBusiness104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPersonBusiness104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPersonBusiness104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPersonBusiness104_objectSpread(AvatarPersonBusiness104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.95 10.14c-2.18 2.27-2.11 4.75-2.11 4.75-10.59-1.4-7.88 7.75-7.88 7.75-8.65 1.53-6.89 8.97-4.1 13.46-8.99 7.06 1.49 10.03 1.49 10.03-5.13 6.87 4.15 7.51 4.15 7.51-1.81 4.55 2.71 11.48 12.16 3.88 0 0-5.08-8.88-3.97-16.94 0 0 5.01-.28 6.36-3.62 0 0 4.06 1.27 5.69-2.27 0 0 4 3.82 7.22-.36 0 0 1.08 5.32 6.03 1.86 0 0 .75 3.9 3.9 1.95 0 0 1.49 2.94 3.57 2.44 1.04 6.91-3.19 15.92-3.19 15.92s1.27 4.11 7.74 4.11c5.32 0 5.52-6.5 5.52-6.5s4.46 2.66 6.24-.76c1.97-3.81-1.67-6.13-1.67-6.13.45-.21.89-.46 1.32-.71 5.06-2.95 5.13-10.26.08-13.25a1.11 1.11 0 0 0-.16-.09s3.15-6.43.09-10.75a8.89 8.89 0 0 0-1.33-1.5c-3.19-2.84-7.34-2.21-7.35-2.2.54-.08-.07-3.26-.16-3.52-1.23-3.82-5.85-5.95-9.64-4.24-.14.06-1.73.79-1.69.99-1.34-5.19-9.95-7.73-12.88-1.55-3.32-4.88-9.24-3.39-9.24-3.39-3.04.66-4.98 1.86-6.2 3.13h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.45 40.58c5.56 7.13-9.68 27.93-16.44 27.92-6.76.02-11.45-9.55-12.36-10.99L28 42.96l9.69-10.97 26.57-2.66 4.19 11.25ZM52.01 79.17l-10.57-6.76c-.15.23-.31.45-.47.67-1.6 2.21-3.6 4.1-5.81 5.7l-10.99 7.93s8.89 12.54 27.39 12.54 27.9-12.82 27.9-12.82l-10.6-7.65c-2.21-1.6-4.21-3.49-5.81-5.7-.16-.22-.31-.44-.47-.67l-10.57 6.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.52 72.41c-1.43-2.11-2.68-4.74-2.89-7.6l-15.27.3c-.25 2.63-1.38 5.04-2.68 7.04l9.38 13.82 11.47-13.55Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.55 47.93c0 .64-.71.36-1.59.36s-1.59.29-1.59-.36.71-1.17 1.59-1.17 1.59.52 1.59 1.17ZM59.04 47.91c0 .64-.71.42-1.59.42s-1.59.22-1.59-.42.71-1.17 1.59-1.17 1.59.52 1.59 1.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.16 44.76c1.85-3.7.96-7.82-2.19-10.33a10.576 10.576 0 0 0-7.48-13.22c-.6-4.18-4.58-6.77-8.6-5.95-1.19-2.3-2.46-3.29-5.2-3.75-2.66-.44-4.9.47-6.92 1.96-4.22-5.07-11.68-6.98-15.52-.6-.03.06-.93 2.02-2.04 1.35-.96.08-1.9.24-2.74.57-1.53.59-2.63 1.72-3.23 3.24-.52 1.29-.27 3.16-1.22 4.22-1.05 1.17-2.73 1.43-3.7 2.85-1.06 1.56-1.22 3.48-.86 5.28.27 1.39 1.16 5.55 1.16 5.55-.38.54-.89 1.48-1.48 1.9-.73.52-1.24 1.18-1.49 2.04-.53 1.72-.06 3.29 1.3 4.43.75.62 1.61.93 2.5 1.26.84.32 2 .49.7 1.78-1.16 1.15-1.66 3.54-.13 4.91 1.24 1.1 1.47 1.09 3.11 1.26.39.04 1.56.83 1.57.58.17.44-.14 1.89 0 2.44 1.11 4.32 3.34 4.59 9.59 2.71 1.67-.3 2.46-1.93 1.62-3.28-2.22-3.54-3.42-7.35-3.64-11.41.13-.3.19-.65.16-1.03-.05-.59.17-1.18.12-1.77-.01-.16-.04-.29-.07-.43.37-.55.91-.87 1.86-1.44 1.76.06 3.63-1.03 4.56-2.55.08-.04.16-.07.21-.11.55-.28 1.09.21 1.64-.08.16.04.28-.45.36-.45.91.03 1.75-.42 2.48-.97.39-.28.71-.64.95-1.03 1.09-.02 1.96.7 3.23.93 1.18.21 2.31-.05 3.38-.55 1.28-.59.9-.84 1.8.15.77.84 1.77 1.81 2.89 1.91.57.05 1.12-.52 1.69-.61l.62-.13c.14 0 .24-.01.35-.03.39 1 1.29 1.81 2.43 1.67.75-.08 1.4.02 1.97.27.2.44.54.85 1 1.19l.61.44c.12.08.24.16.37.22.82 1.39 1.18 3.21 1.2 4.71.03 3.64-1.47 7.12-2.82 10.43-.33.81-.84 2.07-.2 2.63.52.45 1.95 1.06 2.52 1.39 2.13 2.33 5.95 2.08 8.41-.03.71-.61.9-1.42.77-2.18.89-1.61 1.09-3.51.99-5.41 1.75-1.82 2.4-4.53 1.45-6.89v-.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.67 72.19c1.31-1.99 2.43-4.41 2.68-7.04M59.63 64.86c.2 2.86 1.46 5.48 2.89 7.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.95 10.19c-2.18 2.27-2.11 4.75-2.11 4.75-10.59-1.4-7.88 7.75-7.88 7.75-8.65 1.53-6.89 8.97-4.1 13.46-8.99 7.06 1.49 10.03 1.49 10.03-5.13 6.87 4.15 7.51 4.15 7.51-1.81 4.55 2.71 11.48 12.16 3.88 0 0-5.08-8.88-3.97-16.94 0 0 5.01-.28 6.36-3.62 0 0 4.06 1.27 5.69-2.27 0 0 4 3.82 7.22-.36 0 0 1.08 5.32 6.03 1.86 0 0 .75 3.9 3.9 1.95 0 0 1.49 2.94 3.57 2.44 1.04 6.91-3.19 15.92-3.19 15.92s1.27 4.11 7.74 4.11c5.32 0 5.52-6.5 5.52-6.5s4.46 2.66 6.24-.76c1.97-3.81-1.67-6.13-1.67-6.13.45-.21.89-.46 1.32-.71 5.06-2.95 5.13-10.26.08-13.25a1.11 1.11 0 0 0-.16-.09s3.15-6.43.09-10.75a8.89 8.89 0 0 0-1.33-1.5c-3.19-2.84-7.34-2.21-7.35-2.2.54-.08-.07-3.26-.16-3.52-1.23-3.82-5.85-5.95-9.64-4.24-.14.06-1.73.79-1.69.99-1.34-5.19-9.95-7.73-12.88-1.55-3.32-4.88-9.24-3.39-9.24-3.39-3.04.66-4.98 1.86-6.2 3.13h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.45 40.63c.8 15.55-9.68 27.93-16.44 27.92-6.76.02-11.45-9.55-12.36-10.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.75 47.57c0 3.23 2.11 3.39 2.11 5.25s-2.16 1.94-2.16 1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.09 44.29c1.59-1.44 4.16-1.44 5.75 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.58 44.29c1.59-1.44 4.16-1.44 5.75 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.78 59.64c1.04 1.67 4.14 2.01 5.37-.65"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.02 82.08c-.51.47-.1 1.07.46.72 2.95-1.84 7.95 1.52 10.46-2.07.36.15-.04-1.36-.16-1.74-.21-.68-.27-3.1-1.73-3.42-1.63-1.02-6.81 4.06-9.03 6.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.68 87.59-2.73-3.92 4.09-3.92 4.09 3.92-2.73 3.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.07 82.15c.49.49.05 1.1-.51.74-2.94-1.88-8.27 1.59-10.66-2.09-.38.16.12-1.4.26-1.79.26-.7.45-3.19 1.98-3.53 1.74-1.06 6.79 4.16 8.93 6.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53.4 87.59 1.02 8.79c.17 1.44-.96 2.86-2.41 2.86-1.46 0-2.58-1.43-2.4-2.88l1.07-8.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.01 79.36 4.11 3.93-2.74 3.94L55.6 98.7M52.01 79.36l-4.11 3.93 2.74 3.94-2.31 11.66M58.7 98.27c-1.68-14.94 5.06-24.22 5.06-24.22M45.14 98.36c.92-14.31-4.88-24.31-4.88-24.31M41.44 72.46l10.57 6.76-7 6.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m62.58 72.46-10.57 6.76 7 6.7M62.58 72.46c.15.23.31.45.47.66 1.6 2.21 3.6 4.1 5.81 5.7l10.6 7.65M41.44 72.46c-.15.23-.31.45-.47.66-1.6 2.21-3.6 4.1-5.81 5.7l-10.99 7.93"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPersonBusiness104 = (AvatarPersonBusiness104);
;// ./src/Picto/GeneratedPictoComponents/AvatarPersonBusiness56.tsx


var AvatarPersonBusiness56_excluded = ["className"];
function AvatarPersonBusiness56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarPersonBusiness56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarPersonBusiness56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarPersonBusiness56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarPersonBusiness56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarPersonBusiness56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarPersonBusiness56_objectSpread(AvatarPersonBusiness56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.34 9.1c-1.47 1.56-1.42 3.27-1.42 3.27C7.77 11.4 9.6 17.7 9.6 17.7c-5.84 1.05-4.65 6.17-2.77 9.25-6.07 4.86 1.01 6.89 1.01 6.89-3.47 4.72 2.8 5.16 2.8 5.16-1.22 3.13 1.83 7.89 8.21 2.67 0 0-3.43-6.1-2.68-11.64 0 0 3.38-.2 4.3-2.49 0 0 2.74.87 3.84-1.56 0 0 2.7 2.62 4.88-.24 0 0 .73 3.66 4.07 1.28 0 0 .5 2.68 2.64 1.34 0 0 1.01 2.02 2.41 1.68.7 4.75-2.15 10.95-2.15 10.95s.86 2.83 5.22 2.83c3.59 0 3.73-4.47 3.73-4.47s3.01 1.83 4.21-.52c1.33-2.62-1.13-4.21-1.13-4.21.3-.15.6-.31.89-.49 3.42-2.03 3.47-7.05.06-9.11-.06-.04-.11-.06-.11-.06s2.13-4.42.06-7.39c-.28-.4-.58-.74-.9-1.03-2.15-1.95-4.95-1.52-4.96-1.51.36-.06-.05-2.24-.11-2.42-.83-2.62-3.95-4.09-6.51-2.92-.09.04-1.17.55-1.14.68-.91-3.57-6.72-5.31-8.7-1.06-2.24-3.35-6.24-2.33-6.24-2.33-2.06.45-3.36 1.28-4.19 2.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.28 30.03c3.75 4.91-6.54 19.21-11.1 19.19-4.56.01-7.73-6.56-8.35-7.56l-7.86-10 6.54-7.54 17.94-1.83 2.83 7.74Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.4 34.55c0 .43-.48.24-1.06.24s-1.06.19-1.06-.24.48-.79 1.06-.79 1.06.35 1.06.79ZM32.1 34.54c0 .43-.48.28-1.06.28s-1.06.15-1.06-.28.48-.79 1.06-.79 1.06.35 1.06.79Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.14 33.11c1.25-2.5.65-5.28-1.48-6.97a7.134 7.134 0 0 0-5.05-8.92c-.4-2.82-3.09-4.57-5.8-4.01-.8-1.55-1.66-2.22-3.51-2.53-1.79-.3-3.3.32-4.67 1.32-2.84-3.42-7.88-4.71-10.47-.41-.02.04-.62 1.36-1.38.91-.65.06-1.28.16-1.85.38-1.04.4-1.77 1.16-2.18 2.18-.35.87-.18 2.14-.82 2.84-.71.79-1.84.96-2.5 1.92-.72 1.05-.82 2.35-.58 3.56.18.94.78 3.75.78 3.75-.26.36-.6 1-1 1.28-.49.35-.84.79-1.01 1.38-.35 1.16-.04 2.22.88 2.99.5.42 1.09.62 1.69.85.57.21 1.35.33.48 1.2-.78.77-1.12 2.39-.09 3.31.84.74.99.74 2.1.85.26.03 1.05.56 1.06.39.11.3-.09 1.28 0 1.65.75 2.92 2.25 3.1 6.47 1.83 1.13-.21 1.66-1.3 1.09-2.21-1.5-2.39-2.31-4.96-2.45-7.7.09-.21.13-.44.11-.7-.04-.4.11-.79.08-1.19 0-.11-.03-.2-.05-.29.25-.37.62-.59 1.26-.97 1.18.04 2.45-.7 3.08-1.72.06-.03.11-.05.14-.07.37-.19.74.14 1.11-.06.11.03.19-.31.24-.31.62.02 1.18-.28 1.67-.65.26-.19.48-.43.64-.7.74-.01 1.32.48 2.18.62.79.14 1.56-.04 2.28-.37.87-.4.61-.57 1.21.1.52.57 1.19 1.22 1.95 1.29.38.04.76-.35 1.14-.41l.42-.09c.09 0 .16 0 .23-.02.26.67.87 1.22 1.64 1.13.5-.06.94.01 1.33.18.13.3.36.57.67.8l.41.3c.08.06.16.11.25.15.55.94.79 2.16.81 3.18.02 2.45-.99 4.8-1.9 7.04-.22.55-.57 1.4-.14 1.77.35.31 1.31.72 1.7.94 1.44 1.57 4.01 1.4 5.67-.02.48-.41.61-.96.52-1.47.6-1.09.74-2.37.67-3.65 1.18-1.23 1.62-3.06.98-4.65Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.48 9.3c-1.48 1.54-1.43 3.23-1.43 3.23-7.2-.96-5.36 5.27-5.36 5.27-5.88 1.04-4.68 6.1-2.79 9.15-6.11 4.8 1.01 6.82 1.01 6.82-3.49 4.67 2.82 5.11 2.82 5.11-1.23 3.09 1.84 7.81 8.26 2.64 0 0-3.46-6.04-2.7-11.52 0 0 3.4-.19 4.33-2.46 0 0 2.76.87 3.87-1.54 0 0 2.72 2.6 4.91-.24 0 0 .74 3.62 4.1 1.27 0 0 .51 2.65 2.66 1.33 0 0 1.01 2 2.43 1.66.71 4.7-2.17 10.82-2.17 10.82s.86 2.79 5.26 2.79c3.62 0 3.75-4.42 3.75-4.42s3.03 1.81 4.24-.52c1.34-2.59-1.13-4.17-1.13-4.17.31-.15.61-.31.9-.48 3.44-2.01 3.49-6.98.06-9.01-.06-.04-.11-.06-.11-.06s2.14-4.37.06-7.31c-.28-.39-.59-.73-.91-1.02-2.17-1.93-4.99-1.5-5-1.49.36-.06-.05-2.21-.11-2.39-.84-2.6-3.98-4.05-6.55-2.89-.09.04-1.18.54-1.15.67-.91-3.53-6.77-5.25-8.76-1.05-2.26-3.31-6.28-2.3-6.28-2.3-2.07.45-3.38 1.27-4.22 2.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.57 30c.54 10.57-6.58 18.99-11.18 18.98-4.6.01-7.79-6.49-8.41-7.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.22 34.73c0 2.2 1.44 2.3 1.44 3.57s-1.47 1.32-1.47 1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.33 32.49c1.08-.98 2.83-.98 3.91 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.14 32.49c1.08-.98 2.83-.98 3.91 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.88 42.93c.71 1.13 2.81 1.37 3.65-.44"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarPersonBusiness56 = (AvatarPersonBusiness56);
;// ./src/Picto/GeneratedPictoComponents/AvatarSunSmartMale104.tsx


var AvatarSunSmartMale104_excluded = ["className"];
function AvatarSunSmartMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarSunSmartMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarSunSmartMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarSunSmartMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarSunSmartMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarSunSmartMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarSunSmartMale104_objectSpread(AvatarSunSmartMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.95 65.79s-7.36-4.15-12.49-.47c0 0-10.53-27.29 1.06-37.09M61.1 65.7s7.34-4.14 12.46-.47c0 0 10.57-23.45-1.89-37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.1 37.19c1.73 14.57-8.75 30.57-19.55 30.57s-21.6-14.98-20.61-30.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.12 84.49c-8.62-7.12-10.9-7.54-10.9-7.54l-.22-.08c-6.62-3.38-9.95-4.02-10.68-11.74H42.63c-.81 7.52-3.71 8.48-10.27 11.74l-.17.08c-7.16 4.36-9.7 7.53-9.7 7.53s10.09 14.76 29.07 14.76 30.56-14.75 30.56-14.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.67 28.23S73.73 6.06 51.09 6.06 30.51 28.23 30.51 28.23s-4.12 6.05 0 8.06c4.12 2.02 14.4-6.05 20.58-6.05s16.46 8.06 20.58 6.05c4.12-2.02 0-8.06 0-8.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.67 28.23c-18.8-14.71-41.15 0-41.15 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.93 37.03 51.1 20l20 17.19-40.17-.16z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.68 50.42s-.53-.45-.97-.09-2.85 11.29-11.15 10l-3.59 4.48 12.4-.72c2.82-3.67 3.3-13.66 3.3-13.66ZM47.49 6.37c-3.52.38-8.84 2.15-11.33 4.83-3.12 3.37-4.01 6.15-4.87 10.91-.35 1.91-1.11 5.87.11 4.86.27.07 2.72-1.36 3.02-1.44 1.86-.49 3.72-.98 5.59-1.47.78-.2 6.23-1.89 8.4-1.99 4.81-.22 9.53.09 14.16 1.45 1.13.33 2.27-.58 2.27-1.73.06-9.39-8.05-16.43-17.35-15.43ZM26.61 50.68s.53-.45.97-.09 2.85 11.29 11.15 10l3.59 4.48-12.4-.72c-2.82-3.67-3.3-13.66-3.3-13.66Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.82 65.76s-7.36-4.15-12.49-.47c0 0-10.53-27.29 1.06-37.09M60.98 65.67s7.34-4.14 12.46-.47c0 0 10.57-23.45-1.89-37"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.57 82.97s.67 1.38 2.04 1.84c2.06.69 2.06-2.34 7.4.27 5.4 2.64 19.45 5.27 19.29 2.01-.08-1.75-21.07-9.75-21.07-9.75l-7.66 5.63Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.09 42.93c0 .72-.8.4-1.78.4s-1.78.32-1.78-.4.8-1.31 1.78-1.31 1.78.58 1.78 1.31ZM60.31 42.93c0 .72-.8.47-1.78.47s-1.78.25-1.78-.47.8-1.31 1.78-1.31 1.78.58 1.78 1.31Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.2 37.03c-.52-.07-1.04 0-1.53.19-1.95.8-2.67 3.56-1.6 6.17.83 2.02 2.49 3.36 4.11 3.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.06 37.03c.52-.07 1.04 0 1.53.19 1.95.8 2.67 3.56 1.6 6.17-.83 2.02-2.49 3.36-4.11 3.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.97 37.16c1.73 14.57-8.75 30.57-19.55 30.57S29.82 52.75 30.81 37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.47 42.84c0 4 2.62 4.19 2.62 6.49s-2.67 2.4-2.67 2.4M40.75 38.8c1.96-1.78 5.15-1.78 7.11 0M54.97 38.8c1.96-1.78 5.15-1.78 7.11 0M49.64 58.31c2.11 1.2 4.36.11 5.33-.8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.37 84.45s2.54-3.17 9.7-7.53l20.4 9.36 18.62-9.36s2.28.42 10.9 7.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.24 76.83c6.55-3.27 9.46-4.22 10.27-11.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.2 65.09c.73 7.72 4.06 8.37 10.68 11.74"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.55 28.19S73.61 6.02 50.97 6.02 30.39 28.19 30.39 28.19s-4.12 6.05 0 8.06c4.12 2.02 14.4-6.05 20.58-6.05s16.46 8.06 20.58 6.05c4.12-2.02 0-8.06 0-8.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.55 28.19c-18.8-14.71-41.15 0-41.15 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarSunSmartMale104 = (AvatarSunSmartMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarSunSmartMale56.tsx


var AvatarSunSmartMale56_excluded = ["className"];
function AvatarSunSmartMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarSunSmartMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarSunSmartMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarSunSmartMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarSunSmartMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarSunSmartMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarSunSmartMale56_objectSpread(AvatarSunSmartMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.8 47.54s-8.39-3.55-12.13-.87c0 0-7.28-19.67 1.18-26.82M32.26 47.35s7.86-3.42 11.59-.75c0 0 7.71-17.11-1.38-27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.53 25.66c1.08 11.02-6.52 22.8-14.63 22.8S11.69 37.21 12.43 25.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.53 19.85S44.01 3.87 27.69 3.87 12.85 19.85 12.85 19.85s-2.97 4.36 0 5.81c2.97 1.45 10.39-4.36 14.84-4.36s11.87 5.81 14.84 4.36c2.97-1.45 0-5.81 0-5.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.53 19.85c-13.55-10.6-29.67 0-29.67 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.86 25.66 14.98-14.84 13.01 14.84H12.86z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.66 35.56s-.38-.33-.7-.07-2.07 8.2-8.1 7.26L35.5 45.7l8.72.3c1.82-2.75 2.44-10.45 2.44-10.45ZM25.46 4.03c-2.56.28-6.42 1.56-8.23 3.51-2.26 2.45-2.91 4.47-3.54 7.92-.25 1.39-.81 4.27.08 3.53.2.05 1.97-.99 2.19-1.04 1.35-.35 2.71-.71 4.06-1.06.57-.15 4.53-1.37 6.1-1.44 3.5-.16 6.92.06 10.29 1.05.82.24 1.65-.42 1.65-1.26.05-6.82-5.84-11.94-12.6-11.21ZM9.58 35.65s.38-.33.7-.07 2.07 8.2 8.1 7.26l2.39 2.98-8.56.18c-2.05-2.67-2.63-10.36-2.63-10.36Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.13 47.45S15.74 43.9 12 46.58c0 0-7.28-19.67 1.18-26.82M32.59 47.26s7.86-3.42 11.59-.75c0 0 7.71-17.11-1.38-27"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.14 29.32c0 .55-.61.31-1.36.31s-1.36.25-1.36-.31.61-1 1.36-1 1.36.45 1.36 1ZM35.06 29.32c0 .55-.61.36-1.36.36s-1.36.19-1.36-.36.61-1 1.36-1 1.36.45 1.36 1Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.3 25.33c-.39-.05-.78 0-1.15.15-1.47.6-2 2.67-1.2 4.63.62 1.52 1.87 2.52 3.09 2.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.72 25.33c.39-.05.78 0 1.15.15 1.47.6 2 2.67 1.2 4.63-.62 1.52-1.87 2.52-3.09 2.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.86 25.57c1.08 11.02-6.52 22.8-14.63 22.8S12.02 37.12 12.76 25.31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.27 29.7c0 3.01 1.96 3.15 1.96 4.87s-2 1.8-2 1.8M20.23 26.66c1.47-1.33 3.86-1.33 5.34 0M30.9 26.66c1.47-1.33 3.86-1.33 5.34 0M26.9 41.31c1.58.9 3.27.08 4-.6"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.86 19.76S44.34 3.78 28.02 3.78 13.18 19.76 13.18 19.76s-2.97 4.36 0 5.81c2.97 1.45 10.39-4.36 14.84-4.36s11.87 5.81 14.84 4.36c2.97-1.45 0-5.81 0-5.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.86 19.76c-13.55-10.6-29.67 0-29.67 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarSunSmartMale56 = (AvatarSunSmartMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeen104.tsx


var AvatarTeen104_excluded = ["className"];
function AvatarTeen104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeen104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeen104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeen104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeen104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeen104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeen104_objectSpread(AvatarTeen104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.28 54.99c1.3.8 1.5 4.25 1.5 4.25 3.05-3.69 3.23-7.57 3.23-7.57 1.93 1.79 4.61-.34 4.61-.34-1.93-1.3-3.27-7.13-2.23-7.39 1.03-.26 3.2 1.62 3.2 1.62.9-4.1-2.26-8.29-2.26-8.29 1.68 1.64 4.88 1.4 4.88 1.4s-1.65-.51-2.51-5.27c-.65-3.67-4.43-21.93-18.1-26.88-5.07-1.84-9.7-1.57-13.64-.98-14.64 2.2-19.8 13.97-21.49 22.49 0 0-1.08 8.09-2.87 12.44 0 0 3.13-.67 3.67-1.83.54-1.16-1.34 5.11-.36 10.03 0 0 .94-2.96 2.95-3.76 0 0-.83 8.26.51 10.58 0 0 1.4-2.74 2.92-1.04 1.14 1.22.93 4.8.93 5.34s2.14-1.39 2.76-3.71c0 0-2.42-3.76-4.05-10.29-1.04-4.18-.77-10.29 1.09-14.17 1.68-3.51 4.7-7.04 5.68-9.36 0 0 9.16 18.8 26.33 22.8 0 0-2.41-4.27-1.2-8.38 0 0 3.18 6.65 9.62 3.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.48 41.75c-1.36 13.94-10.11 24.69-20.7 24.69-5.78 0-11.02-3.21-14.8-8.39l-5.44-6.37-3.47-19.16 10.35-13.37 21.02 6.56L70.5 37.28l1.99 4.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.41 85.43c-7.52-6.95-12.5-9.25-12.5-9.25-6.27-3.58-8.39-5.5-9.11-13.05l-18.85.29c-.79 7.35-2.96 8.46-9.28 12.76-6.83 4.25-11.04 9.25-11.04 9.25s10.42 13.81 29.95 13.81 30.84-13.81 30.84-13.81Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.8 29.67c-.99-1.29-2.32-3.24-3.16-4.63-.26-.42-.97-1.71-1.27-2.07-1.18-1.4-.22-.69-.3-.72-.41.09.68.57.3.72-.25.34-.8.64-1.09 1.06-4.28 6.19-7.82 12.88-6.13 19.91l1.74 5.62 2.74 6.93s-1.77 3.31-2.08 1.92c-.45-2.01-3.05-2.54-2.53-4.45-1.4 0-2.28.27-2.28.27-1.42-.67.37-9.86.37-9.86-.66-.73-3.01 3.44-3.01 3.44-.78-1.07.7-10.78.42-9.7-.28 1.08-3.67 1.83-3.67 1.83l2.03-7.47c.11-1.59.4-3.6.75-5.16 1.9-8.35 4.32-13.14 11.48-18.97 23.47-8.78 39.22 18.24 35.7 32.07l-3.23.61-3.38-.93-2.82-3.15-.52 2.23.62 3.67v1.99l-11.02-5.45-7.48-7.01-2.18-2.7Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.23 57.37c-.21-.28-.41-.57-.6-.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.74 41.07c-1.36 13.94-10.11 24.69-20.7 24.69-5.78 0-11.02-3.21-14.8-8.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.64 34.83c2.1-1.9 5.5-1.9 7.6 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.56 39.17 2.57 5.12c.55 1.09.27 2.44-.67 3.18l-1.49 1.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.65 54.99c1.3.8 1.5 4.25 1.5 4.25 3.05-3.69 3.23-7.57 3.23-7.57 1.93 1.79 4.61-.34 4.61-.34-1.93-1.3-3.27-7.13-2.23-7.39 1.03-.26 3.2 1.62 3.2 1.62.9-4.1-2.26-8.29-2.26-8.29 1.68 1.64 4.88 1.4 4.88 1.4s-1.65-.51-2.51-5.27c-.65-3.67-4.43-21.93-18.1-26.88-5.07-1.84-9.7-1.57-13.64-.98-14.64 2.2-19.8 13.97-21.49 22.49 0 0-1.08 8.09-2.87 12.44 0 0 3.13-.67 3.67-1.83.54-1.16-1.34 5.11-.36 10.03 0 0 .94-2.96 2.95-3.76 0 0-.83 8.26.51 10.58 0 0 1.4-2.74 2.92-1.04 1.14 1.22.93 4.8.93 5.34s2.14-1.39 2.76-3.71c0 0-2.42-3.76-4.05-10.29-1.04-4.18-.77-10.29 1.09-14.17 1.68-3.51 4.7-7.04 5.68-9.36 0 0 9.16 18.8 26.33 22.8 0 0-2.41-4.27-1.2-8.38 0 0 3.18 6.65 9.62 3.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.22 53.59s-2.02 3.79-7.62 3.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.02 76.19c6.32-4.31 8.5-5.41 9.28-12.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.16 63.14c.72 7.54 2.84 9.47 9.11 13.05"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.85 84.76s-.49.53.74 1.18c1.72.9 7.69-5.28 12.89-3.04 6.09 2.63 13.93 5.03 14.29 2.73.4-2.56-18.15-8.82-18.15-8.82l-9.77 7.95Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.98 85.43s4.21-4.99 11.04-9.25l18.11 8.51 19.14-8.51s4.99 2.3 12.5 9.25",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.16",
        cy: "39.12",
        r: "1.9"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeen104 = (AvatarTeen104);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeen56.tsx


var AvatarTeen56_excluded = ["className"];
function AvatarTeen56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeen56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeen56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeen56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeen56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeen56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeen56_objectSpread(AvatarTeen56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.81 42.95c1 .61 1.14 3.25 1.14 3.25 2.33-2.82 2.47-5.79 2.47-5.79 1.48 1.37 3.52-.26 3.52-.26-1.48-1-2.5-5.45-1.71-5.65.79-.2 2.45 1.24 2.45 1.24.69-3.14-1.73-6.34-1.73-6.34 1.29 1.25 3.73 1.07 3.73 1.07s-1.26-.39-1.92-4.03c-.5-2.8-3.39-16.77-13.84-20.56-3.88-1.41-7.42-1.2-10.43-.75-11.2 1.69-15.15 10.68-16.44 17.2 0 0-.83 6.19-2.19 9.51 0 0 2.4-.51 2.81-1.4.41-.89-1.03 3.91-.27 7.67 0 0 .72-2.27 2.26-2.88 0 0-.64 6.31.39 8.09 0 0 1.07-2.1 2.23-.79.87.94.71 3.67.71 4.08s1.64-1.06 2.11-2.84c0 0-1.85-2.87-3.09-7.87-.8-3.2-.59-7.87.84-10.84 1.28-2.68 3.59-5.38 4.34-7.16 0 0 7.01 14.38 20.14 17.44 0 0-1.84-3.27-.92-6.41 0 0 2.43 5.08 7.36 2.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.9 32.46c-1.04 10.66-7.73 18.88-15.84 18.88-4.42 0-8.43-2.45-11.32-6.42l-4.16-4.88-2.66-14.65 7.91-10.23 16.08 5.02 8.46 8.85 1.52 3.42Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.63 23.57c-.76-1-1.87-2.63-2.52-3.71-.2-.32-.85-1.38-1.16-1.56-.06-.04.02-.25-.03-.27-.32.07-.08.4-.38.52-.19.26.07.36-.16.68-3.3 4.76-6.02 9.91-4.72 15.33L14 38.89l2.11 5.34s-1.8 2.81-2.04 1.74c-.35-1.55-.57-2.8-1.51-3.69-1.07 0-1.75.21-1.75.21-1.09-.51-.39-7.19-.39-7.19-.51-.56-2.15 1.71-2.15 1.71-.6-.83.61-7.47.39-6.64-.21.83-2.38 1.12-2.38 1.12l1.23-5.74c.09-1.22.64-2.77.92-3.97 1.46-6.43 3.32-10.12 8.84-14.6C35.33.41 47.46 21.2 44.75 31.85l-2.48.47-2.6-.72-2.17-2.43-.4 1.72.47 2.82v1.53l-8.48-4.19-5.75-5.4-1.68-2.08Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.57 44.88c-.16-.22-.31-.44-.47-.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.9 32.34c-1.05 10.73-7.78 19-15.94 19-4.45 0-8.48-2.47-11.39-6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.19 27.54c1.61-1.46 4.23-1.46 5.85 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.6 30.88 1.98 3.94c.42.84.2 1.88-.51 2.45l-1.15.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.75 43.06c1 .62 1.15 3.27 1.15 3.27 2.35-2.84 2.48-5.83 2.48-5.83 1.48 1.38 3.55-.26 3.55-.26-1.49-1-2.51-5.49-1.72-5.69.8-.2 2.46 1.25 2.46 1.25.7-3.15-1.74-6.38-1.74-6.38 1.29 1.26 3.76 1.08 3.76 1.08s-1.27-.4-1.93-4.05c-.5-2.82-3.41-16.88-13.93-20.69-3.91-1.42-7.47-1.21-10.5-.75C13.06 6.71 9.09 15.76 7.79 22.32c0 0-.83 6.23-2.21 9.57 0 0 2.41-.51 2.82-1.41.41-.9-1.03 3.93-.28 7.72 0 0 .72-2.28 2.27-2.9 0 0-.64 6.35.39 8.15 0 0 1.08-2.11 2.25-.8.88.94.71 3.7.71 4.11s1.65-1.07 2.13-2.85c0 0-1.86-2.89-3.11-7.92-.8-3.22-.59-7.92.84-10.91 1.29-2.7 3.62-5.42 4.37-7.2 0 0 7.05 14.47 20.26 17.55 0 0-1.85-3.29-.93-6.45 0 0 2.44 5.12 7.4 2.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.72 41.98s-1.55 2.92-5.87 2.92"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.46",
        cy: "30.88",
        r: "1.5"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeen56 = (AvatarTeen56);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeenFemale104.tsx


var AvatarTeenFemale104_excluded = ["className"];
function AvatarTeenFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeenFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeenFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeenFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeenFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeenFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeenFemale104_objectSpread(AvatarTeenFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.63 85.28c-.3-3.01.62-4.04 1.54-4.93.74-.72 1.62-1.46 1.75-2.55.25-2.04-2.73-4.36-2.57-6.32.16-2.05 3.47-3.88 3.54-5.84.07-2.06-3.12-4.09-3.16-6.06-.04-2.06 3.07-4.22 2.92-6.18-.15-2.06-3.55-3.72-3.81-5.66-.28-2.05 2.53-4.57 2.14-6.49-.42-2.03-4.01-3.22-4.55-5.09-.58-2 1.82-4.92 1.12-6.74-.75-1.95-4.49-2.49-5.37-4.21-.95-1.87.8-5.22-.27-6.82-1.17-1.75-4.92-1.38-6.21-2.81-1.41-1.56-.72-5.28-2.24-6.45-1.67-1.28-5.03.4-6.78-.39-1.89-.86-2.94-4.47-4.88-4.75s-3.96 2.91-5.95 3.26c-1.92.34-4.85-2.01-6.7-1.04-1.69.88-1.54 4.64-3.13 6.06-1.42 1.26-5.12.57-6.41 2.26-1.15 1.51.42 4.94-.62 6.8-.93 1.67-4.68 2.08-5.5 4.03-.74 1.77 1.57 4.76.94 6.76-.58 1.84-4.2 2.92-4.69 4.96-.45 1.88 2.28 4.5 1.93 6.55-.33 1.91-3.79 3.43-4.04 5.5-.23 1.93 2.76 4.25 2.6 6.32-.15 1.95-3.46 3.77-3.53 5.84-.07 1.96 3.1 4.02 3.09 6.09 0 1.96-3.17 4.02-3.11 6.08.06 1.96 2.54 4.26 3.47 5.88 0 0 2.06 3.99-.18 6.13 0 0 8.71 13.77 29.82 13.77s28.86-13.96 28.86-13.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m53.6 86.17 1.56-2.71c.43-.74.34-1.75-.2-2.38l-3.19-3.7-3.19 3.7c-.54.63-.62 1.63-.2 2.38l1.56 2.71c.28.49.75.79 1.25.79h1.16c.5 0 .96-.29 1.25-.79Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M53.41 85.71 54.97 83c.43-.74.34-1.75-.2-2.38l-3.19-3.7-3.19 3.7c-.54.63-.62 1.63-.2 2.38l1.56 2.71c.28.49.75.79 1.25.79h1.16c.5 0 .96-.29 1.25-.79Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.23 84.5c3.12-6.75 12.49-8.7 17.42-13.83 2.14-2.22 2.73-4.93 2.23-8.19-.28-1.78-2.26-1.82-3.4-3.13-1.54-1.76-2.29-3.57-3.41-5.63a28.522 28.522 0 0 1-3.41-12.83c-.05-2.47-.98-6.43 2.35-6.59 1.56-.07 3.07-.12 4.6-.5 5.4-1.34 9.9-5.25 12.16-10.24 1.45 2.43 3.27 4.6 5.54 6.42 1.52 1.22 3.17 2.25 4.94 3.07 1.99.92 4.11 1.15 6.13 1.89.37.14 2.44.2 2.62.48.32.5.43 3.9.3 6.45-.09 1.89-.39 3.77-.86 5.61-1.11 2.63-2.43 5.37-3.5 8.15-.22.35-.43.7-.67 1.04-1.35 1.95-2.84 3.26-4.97 5.29-1.65 1.57-1.28 5.57-.02 7.3.49.68 2.17 2.87 2.8 3.22 3.97 2.25 7.31 4.18 10.83 7.36 1.03.93 1.23.06 1.66.12.48.06 1.27-.13 1.75-.8.43-.61.95-1.12 1.01-1.9.07-.99-.32-1.94-.61-2.87-.38-1.19-1.1-2.53-1.01-3.81.07-1.03.98-1.69 1.45-2.54.63-1.14 1.04-2.46 1.07-3.76a5.48 5.48 0 0 0-.46-2.39c-.3-.67-.97-1.21-1.08-1.96-.12-.8.69-1.97.88-2.79.37-1.65.18-3.31-.65-4.79-.42-.75-1.51-1.57-1.58-2.44-.08-.99.74-1.91.76-2.95.03-1.56-.79-2.78-1.63-4.02-.65-.96-1.52-1.99-1.48-3.24.05-1.47.72-2.79.57-4.31-.13-1.34-.6-2.63-1.37-3.73-1.33-1.89-3.56-2.48-4.21-4.77-.29-1-.21-2.02-.61-3-1.04-2.53-3.61-3.91-6.26-4-1.64-.06-1.84-1.07-2.27-2.43-.69-2.2-2.05-4.33-4.64-4.28-2.8.05-3.93 1.6-6.57-.51-1.19-.95-2.3-1.76-3.88-1.79-2.18-.05-3.63 1.57-5.61 2.13-3.36.96-8.28-.67-9.09 4.23-.19 1.13.89 2.76.64 3.87-.3 1.32-1.06 1.78-2.12 2.62-1.2.95-3.12 1.34-3.68 2.83-.91 2.45 2.34 4.07.77 6.29-1.04 1.47-3.89 3.21-4.12 5.19-.27 2.29 2.22 4.43 1.15 6.52-.87 1.69-2.67 2.54-3.15 4.52-.47 1.92.44 3.44 1.2 5.12.8 1.75.72 2.35-.46 3.97-.49.67-1.1 1.21-1.45 1.99-.71 1.62-.22 3.17.65 4.61 1.06 1.76 1.7 3.49 1.36 5.12-.08.05-.16.12-.24.19-.65.64-1.1 1.36-1.36 2.11l-.6.96c-.52.84-.65 2.01-.02 2.39.27 1 .7 1.98 1.58 2.63",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.86 86.01c-.3-3.01.62-4.04 1.54-4.93.74-.72 1.62-1.46 1.75-2.55.25-2.04-2.73-4.36-2.57-6.32.16-2.05 3.47-3.88 3.54-5.84.07-2.06-3.12-4.09-3.16-6.06-.04-2.06 3.07-4.22 2.92-6.18-.15-2.06-3.55-3.72-3.81-5.66-.28-2.05 2.53-4.57 2.14-6.49-.42-2.03-4.01-3.22-4.55-5.09-.58-2 1.82-4.92 1.12-6.74-.75-1.95-4.49-2.49-5.37-4.21-.95-1.87.8-5.22-.27-6.82-1.17-1.75-4.92-1.38-6.21-2.81-1.41-1.56-.72-5.28-2.24-6.45-1.67-1.28-5.03.4-6.78-.39-1.89-.86-2.94-4.47-4.88-4.75s-3.96 2.91-5.95 3.26c-1.92.34-4.85-2.01-6.7-1.04-1.69.88-1.54 4.64-3.13 6.06-1.42 1.26-5.12.57-6.41 2.26-1.15 1.51.42 4.94-.62 6.8-.93 1.67-4.68 2.08-5.5 4.03-.74 1.77 1.57 4.76.94 6.76-.58 1.84-4.2 2.92-4.69 4.96-.45 1.88 2.28 4.5 1.93 6.55-.33 1.91-3.79 3.43-4.04 5.5-.23 1.93 2.76 4.25 2.6 6.32-.15 1.95-3.46 3.77-3.53 5.84-.07 1.96 3.1 4.02 3.09 6.09 0 1.96-3.17 4.02-3.11 6.08.06 1.96 2.54 4.26 3.47 5.88 0 0 2.06 3.99-.18 6.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.42 71.74c-3.11-2.42-2.7-2-2.7-9.35M80.86 86.01c-1.19-2.14-2.76-4.17-4.81-5.81-3.44-2.75-7.17-4.91-10.53-7.02-.84-.53-1.53-.99-2.1-1.43M43.17 62.39c.01 5.61-.2 6.07-3.51 9.01M63.2 72.03c-3.93 3.35-6.67 4.66-11.72 4.66S43.4 75 39.47 71.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.87 20.73c0 12.28-17.24 13.98-19.13 14.03-.11 1.15-.18 2.32-.18 3.51 0 14.54 8.64 26.32 19.3 26.32s19.3-11.78 19.3-26.32c0-1.19-.06-2.36-.18-3.51-1.89-.05-19.13-1.75-19.13-14.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.73 40.03c0 3.95 2.58 4.14 2.58 6.41s-2.63 2.37-2.63 2.37M41.15 36.24c1.94-1.75 5.08-1.75 7.02 0M55.19 36.24c1.94-1.75 5.08-1.75 7.02 0M49.93 55.3c2.08 1.18 4.31.11 5.26-.79M69.58 75.7c-3.97-1.53-9.86 4.08-11.91 4.16-1.96.08-4.04-3.08-6.09-3.09-1.97 0-4.06 3.14-6.11 3.04-1.09-.05-1.9-.87-2.67-1.55-.96-.85-6.86-4.35-10.67-1.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.18 86.2c3.35-5.46 8.64-8.64 14.48-12.53 1.21-.8 1.79-1.23 2.6-1.94"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.02",
        cy: "40.17",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.98",
        cy: "40.17",
        r: "1.77"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeenFemale104 = (AvatarTeenFemale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeenFemale56.tsx


var AvatarTeenFemale56_excluded = ["className"];
function AvatarTeenFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeenFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeenFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeenFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeenFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeenFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeenFemale56_objectSpread(AvatarTeenFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "fillprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.52 46.45c-1.56 1.31-2.5-1.2-3.59-.85-1 .32-1.39 1.55-2.5 1.78-1.03.22-2.4-1.31-3.52-1.17-1.05.13-1.99 1.96-3.12 2.01-1.06.05-2.18-1.67-3.3-1.7-1.06-.02-2.24 1.66-3.36 1.57-1.06-.09-1.96-1.94-3.07-2.09s-2.42 1.39-3.52 1.18c-1.05-.2-1.75-2.13-2.84-2.39s-2.54 1.16-3.61.85c-.57-.16-1-.55-1.32-1.01-.68-.85-.86-1.87-.89-2.93-.03-1.12 1.69-2.24 1.69-3.31 0-1.12-1.72-2.25-1.68-3.31.04-1.12 1.84-2.12 1.92-3.18.08-1.12-1.54-2.38-1.41-3.43.14-1.12 2.02-1.95 2.2-2.99.19-1.12-1.29-2.54-1.05-3.56.26-1.11 2.23-1.7 2.55-2.69.35-1.09-.91-2.72-.51-3.68.44-1.06 2.48-1.29 2.99-2.19.56-1.01-.29-2.88.34-3.7.71-.92 2.72-.54 3.49-1.23.86-.77.78-2.81 1.7-3.29 1.01-.52 2.6.75 3.64.57 1.08-.19 2.15-1.93 3.23-1.77s1.62 2.12 2.65 2.58c.95.43 2.78-.48 3.69.21.83.64.45 2.65 1.22 3.5.7.78 2.74.58 3.38 1.52.58.87-.37 2.69.15 3.71.48.94 2.51 1.23 2.92 2.29.38.99-.92 2.58-.61 3.66.29 1.02 2.25 1.66 2.47 2.77.22 1.04-1.31 2.41-1.16 3.53.14 1.05 1.99 1.96 2.07 3.08.08 1.06-1.61 2.24-1.59 3.36s1.75 2.17 1.72 3.29-1.83 2.06-1.92 3.18c-.08 1.07 1.92 1.73 1.77 3.58-.1 1.2-.8 1.84-1.2 2.23Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.59 25.2c7.24-.27 10.68-3.77 11.33-7.36 1.17 3.59-1.35-.83.07.21.95.7.63 2.95 1.73 3.42 1.25.52 3.56 2.27 4.82 2.7.23.08-.99-.52 2.55.64.34.11-.38.09 1.1.41 1.96.43 1.69.12 1.4 1.17-.13 1.64-.71 6.24-1.38 7.83-.14.2-2.59 4.79-2.74 4.99-.84 1.12-1.5 1.91-4.72 3.16-3.95 1.54.25 5.31 1.03 6.31.31.39 2.75-2.26 3.14-2.05 2.48 1.29.85-.66 3.05 1.16.64.53 2.71-1.81 2.97-1.78.3.03 1.52.95 1.81.57.27-.35.32-1 .36-1.45.05-.57-.2-1.11-.38-1.64-.23-.68-.69-1.45-.63-2.18.05-.59.62-.97.91-1.46.39-.65.65-1.41.67-2.16.01-.47-.07-.93-.29-1.37-.19-.38-.61-.69-.67-1.12-.07-.46.43-1.13.55-1.6.23-.94.11-1.9-.4-2.75-.26-.43-.94-.9-.99-1.4-.05-.57.46-1.09.48-1.69.02-.89-.49-1.59-1.02-2.3-.41-.55-.95-1.14-.93-1.86.03-.84.45-1.6.36-2.47-.08-.77-.37-1.51-.86-2.13-.83-1.08-2.22-1.42-2.63-2.73-.18-.57-.13-1.16-.38-1.72-.65-1.45-2.26-2.24-3.91-2.29-1.02-.03-1.15-.61-1.42-1.39-.43-1.26-1.28-2.48-2.9-2.45-1.75.03-2.46.92-4.11-.29-.74-.55-2.05-.9-3.03-.92l-.79 1.65-3.6 1.23-.14 2.77-1.28 1.74-2.01 1.38.5 2.63.03 1.05-2.63 2.69 1.08 3.56-2.27 2.99 1.46 3.43-1.07 1.94-.91 1.23 1.13 1.99.6 1.32-1.35 2.93.34 2.73 1.4 1.22h1.23l2.24-.86 1.65.86.76.9.92 1.01 3.63-1.18 1.45.93 1.71 1.16 1.95-1.16 1.51-.41 1.38.84 2.02.86-2.12-6.1-3.54.44-4.16-1.78-3.89-4.52-1.87-5.2-.41-4.62.04-.9",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 16.84c0 7.32-10.27 8.33-11.4 8.36-.07.69-.11 1.38-.11 2.09 0 8.66 5.15 15.69 11.5 15.69s11.5-7.02 11.5-15.69c0-.71-.04-1.41-.11-2.09-1.12-.03-11.4-1.04-11.4-8.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.9 28.34c0 2.36 1.54 2.47 1.54 3.82s-1.57 1.41-1.57 1.41M21.6 26.08c1.16-1.05 3.03-1.05 4.18 0M29.97 26.08c1.16-1.05 3.03-1.05 4.18 0M26.83 37.45c1.24.71 2.57.06 3.14-.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.53 46.86c.4-.39 1.1-1.02 1.2-2.23.15-1.85-1.85-2.52-1.77-3.58s1.89-2.11 1.92-3.18-1.7-2.22-1.72-3.29c-.02-1.12 1.67-2.29 1.59-3.36-.08-1.12-1.93-2.02-2.07-3.08-.15-1.11 1.38-2.49 1.16-3.53-.23-1.1-2.18-1.75-2.47-2.77-.31-1.09.99-2.68.61-3.66-.41-1.06-2.44-1.35-2.92-2.29-.51-1.02.44-2.84-.15-3.71-.63-.95-2.68-.75-3.38-1.52-.77-.85-.39-2.87-1.22-3.5-.91-.7-2.73.22-3.69-.21-1.03-.47-1.6-2.43-2.65-2.58s-2.15 1.58-3.23 1.77c-1.05.19-2.64-1.09-3.64-.57-.92.48-.84 2.52-1.7 3.29-.77.69-2.78.31-3.49 1.23-.63.82.23 2.69-.34 3.7-.5.91-2.54 1.13-2.99 2.19-.4.96.86 2.59.51 3.68-.32 1-2.28 1.59-2.55 2.69-.24 1.02 1.24 2.44 1.05 3.56-.18 1.04-2.06 1.87-2.2 2.99-.13 1.05 1.5 2.31 1.41 3.43-.08 1.06-1.88 2.05-1.92 3.18-.04 1.06 1.68 2.19 1.68 3.31S9.83 41 9.87 42.13c.03 1.07.21 2.08.89 2.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.78 45.06c.32.46.75.85 1.32 1.01 1.07.31 2.57-1.1 3.61-.85s1.79 2.19 2.84 2.39c1.1.21 2.46-1.33 3.52-1.18 1.11.15 2.01 2 3.07 2.09 1.12.09 2.3-1.59 3.36-1.57 1.12.02 2.24 1.75 3.3 1.7 1.13-.05 2.07-1.88 3.12-2.01 1.12-.14 2.49 1.39 3.52 1.17 1.11-.24 1.49-1.46 2.5-1.78 1.08-.35 2.03 2.16 3.59.85"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.71",
        cy: "28.34",
        r: "1.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.06",
        cy: "28.34",
        r: "1.15"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeenFemale56 = (AvatarTeenFemale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeenGirl104.tsx


var AvatarTeenGirl104_excluded = ["className"];
function AvatarTeenGirl104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeenGirl104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeenGirl104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeenGirl104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeenGirl104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeenGirl104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeenGirl104_objectSpread(AvatarTeenGirl104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.06",
        cy: "39.93",
        rx: "20.94",
        ry: "28.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.05 36.56c-1.03-.29-2.09-.26-3.06.14-2.91 1.21-3.97 5.34-2.36 9.22 1.41 3.4 4.39 5.49 7.07 5.15M72.4 51.1c2.57.1 5.33-1.95 6.67-5.18 1.61-3.89.55-8.01-2.36-9.22-.92-.38-1.91-.43-2.9-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.65 6.01c-20.26 0-23.79 20.36-24.37 25.72-.07.68.42 1.29 1.05 1.27 12.24-.36 24.85.37 31.67-12.36 0 0-.49 14.76 13.77 12.36.62.02 1.11-.57 1.05-1.23-.46-5.32-3.52-25.75-23.16-25.75h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.81 77.43c.72.57 1.43 1.18 2.13 1.81 0 0 6.58 4.08 7.57 10.64 0 0-9.8 9.37-28.51 9.37s-27.2-9-27.2-9c1.03-7.14 7.57-10.69 7.57-10.69.74-.69 1.49-1.34 2.25-1.96l4.7-4.48c2.42-2.28 4.17-2.8 4.29-7.25l18.75.54c.11 4.45 1.87 4.97 4.29 7.25l4.16 3.78Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.17",
        cy: "42.28",
        r: "1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.41",
        cy: "42.28",
        r: "1.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.53 72.69c2.48-2.33 4.18-2.09 4.28-6.69M34.81 76.9c-.76.62-1.51 1.28-2.25 1.96 0 0-6.73 4.24-7.76 11.38M71 76.74c.72.57 1.43 1.18 2.13 1.81 0 0 6.39 4.77 7.38 11.32M66.84 72.96c-2.42-2.28-4.17-2.8-4.29-7.25"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M65.62 73.02c-6.4 2.75-16.77 3.83-22.86.05-.16-.1-.38-.06-.57-.07-.39-1.34-4.21-1-3.95.4.84 4.64 7.45 8.09 16 8.93 10.55 1.03 13.72-3.12 14.32-7.92.12-.99-1.65-1.94-2.93-1.39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.02 75.02c5.56 0 10.1-1.53 12-2.29.61-.24 1.29-.16 1.82.23l3.62 3.28c.39.28.59.75.54 1.22-.23 1.95-3.93 4.27-1.55 18.73M52.79 75.02c-5.56 0-10.1-1.53-12-2.29-.61-.24-1.29-.16-1.82.23l-3.62 3.28c-.39.28-.59.75-.54 1.22.23 1.95 3.94 4.89 1.56 19.36"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m72.14 53.85 1.19 6.96 2.52 4.88 1.51 2.8-2.61 1.23-6.09-.25-4.78-2.1-1.53-1.96 5.32-4.6 2.18-4.15 2.29-2.81zM33.9 54.36l3 4.16 3.75 4.68 2.97 2.49-1.58 1.96-4.01 1.74h-3.42l-4.23-.35-2.16-1.12 3.64-3.44.92-5.75 1.12-4.37z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.88 10.01c-5.3.16-10.57 2.37-14.17 6.17-4.09 4.31-5.68 10.06-6.94 15.63-.47 2.07 3.42.97 3.48.96 6.07-.61 13.43.5 18.75-2.63 2.05-1.21 3.95-1.67 5.42-3.52.75-.95 4.57-6.29 4.7-6.37.26 1.1.2 5.03.43 5.5 2.26 4.98 5.58 7.09 9.16 7.78 1.01.2 2.76.52 2.67-.63C73.46 21.55 63.23 9.63 50.89 10h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.39 33.74c.36 2.09.54 4.26.54 6.5 0 15.77-9.38 28.55-20.94 28.55S32.05 56.01 32.05 40.24c0-2.4.22-4.74.63-6.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.99 36.87c-1.03-.29-2.09-.26-3.06.14-2.91 1.21-3.97 5.34-2.36 9.22 1.41 3.4 4.39 5.49 7.07 5.15M72.34 51.41c2.57.1 5.33-1.95 6.67-5.18 1.61-3.89.55-8.01-2.36-9.22-.78-.32-1.62-.4-2.46-.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.05 42.28c0 4.16 2.71 4.35 2.71 6.75s-2.78 2.5-2.78 2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.91 38.06c2.04-1.85 5.34-1.85 7.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.69 38.06c2.04-1.85 5.34-1.85 7.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.51 57.8c1.33 2.14 5.32 2.59 6.91-.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.94 51.39s-.76 13.95 6.19 17.34c0 0-10.74 4.05-16.24-2.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.33 52.2s1.18 13.15-5.77 16.53c0 0 10.74 4.05 16.24-2.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.58 6.32c-20.26 0-23.79 20.36-24.37 25.72-.07.68.42 1.29 1.05 1.27 12.24-.36 24.85.37 31.67-12.36 0 0-.49 14.76 13.77 12.36.62.02 1.11-.57 1.05-1.23-.46-5.32-3.52-25.75-23.16-25.75h-.01Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeenGirl104 = (AvatarTeenGirl104);
;// ./src/Picto/GeneratedPictoComponents/AvatarTeenGirl56.tsx


var AvatarTeenGirl56_excluded = ["className"];
function AvatarTeenGirl56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTeenGirl56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTeenGirl56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTeenGirl56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTeenGirl56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTeenGirl56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTeenGirl56_objectSpread(AvatarTeenGirl56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.14",
        cy: "27.92",
        rx: "14.35",
        ry: "19.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.74 25.61c-.71-.2-1.43-.18-2.1.1-2 .83-2.72 3.66-1.62 6.32.97 2.33 3.01 3.76 4.84 3.53M41.4 35.58c1.76.07 3.65-1.33 4.57-3.55 1.1-2.66.38-5.49-1.62-6.32-.63-.26-1.31-.29-1.99-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.55 4.67c-13.89 0-16.31 13.96-16.7 17.63-.05.47.29.88.72.87 8.39-.25 17.04.25 21.71-8.47 0 0-.34 10.12 9.44 8.47.43.02.76-.39.72-.85-.31-3.65-2.41-17.65-15.88-17.65Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.05",
        cy: "28.46",
        r: "1.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.23",
        cy: "28.46",
        r: "1.29"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.47 36.69.84 4.9 1.77 3.44L45.14 47l-1.84.86-4.28-.18-3.36-1.48-1.08-1.37 3.74-3.24 1.54-2.92 1.61-1.98zM15.03 37.14l2.08 2.97 2.59 3.34 2.04 1.77-1.09 1.4-2.76 1.24h-2.37l-2.91-.25-1.49-.79 2.5-2.46.64-4.1.77-3.12z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.59 7.05c-3.69.11-7.36 1.65-9.87 4.3-2.85 3-3.96 7-4.83 10.89-.33 1.44 2.38.67 2.42.67 4.23-.42 9.35.35 13.06-1.83 1.43-.84 2.75-1.17 3.78-2.45.52-.66 2.84-3.96 2.93-4.01.18.77.34 3.45.49 3.78 1.57 3.47 3.02 4.31 5.52 4.79.7.14 2.93.62 2.87-.18-.64-7.9-7.77-16.2-16.36-15.95Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.17 23.18c.24 1.41.36 2.88.36 4.39 0 10.84-6.44 19.62-14.39 19.62s-14.39-8.78-14.39-19.62c0-1.53.13-3.02.37-4.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.71 25.26c-.71-.2-1.43-.18-2.1.1-2 .83-2.73 3.67-1.62 6.34.97 2.34 3.02 3.77 4.86 3.54M41.43 35.25c1.76.07 3.66-1.34 4.58-3.56 1.11-2.67.38-5.51-1.62-6.34-.63-.26-1.03-.35-1.7-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.18 28.98c0 2.86 1.86 2.99 1.86 4.64s-1.91 1.72-1.91 1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.53 26.08c1.4-1.27 3.67-1.27 5.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.68 26.08c1.4-1.27 3.67-1.27 5.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.44 39.64c.92 1.47 3.66 1.78 4.75-.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.84 35.24s-.52 9.59 4.25 11.91c0 0-7.38 2.78-11.16-1.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.63 35.8s.81 9.03-3.97 11.36c0 0 7.38 2.78 11.16-1.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.41 4.68c-13.75 0-16.16 13.82-16.54 17.47-.05.46.28.88.71.86 8.31-.25 16.87.25 21.5-8.39 0 0-.33 10.02 9.35 8.39.42.02.76-.38.71-.84-.31-3.61-2.39-17.48-15.72-17.48Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTeenGirl56 = (AvatarTeenGirl56);
;// ./src/Picto/GeneratedPictoComponents/AvatarTelstraHardHat104.tsx


var AvatarTelstraHardHat104_excluded = ["className"];
function AvatarTelstraHardHat104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTelstraHardHat104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTelstraHardHat104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTelstraHardHat104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTelstraHardHat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTelstraHardHat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTelstraHardHat104_objectSpread(AvatarTelstraHardHat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.05 52.08c-2.31-.23-4.66-2.13-5.86-5.01-1.58-3.78-.57-7.81 2.27-8.99.63-.26 1.29-.36 1.96-.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.39 37.65c.76-.09 1.51 0 2.22.28 2.84 1.17 3.88 5.18 2.33 8.97-1.21 2.95-3.63 4.89-5.98 5.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.67 33.68c.48 2.36.75 4.84.76 7.4.05 15.36-9.04 27.85-20.31 27.89-11.27.04-20.44-12.39-20.49-27.75 0-2.55.23-5.02.7-7.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.17 66.36c.69 7.31-.3 7.19 2.97 9.05l10.16 4.04s4.09 1.78 7.42 4.36c0 0-7.25 15.43-30.25 15.43S22.4 83.23 22.4 83.23c3.32-2.58 7.42-4.36 7.42-4.36l9.7-3.82c3.27-1.86 2.28-1.74 2.97-9.05l18.68.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.52 29.44V15.93s0-9.65 9.65-9.65 9.65 9.65 9.65 9.65v13.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.37 9.22c13.29 3.87 12.1 20.22 12.1 20.22h1.93c1.06 0 1.93.87 1.93 1.93s-.87 1.93-1.93 1.93H30.95c-1.06 0-1.93-.87-1.93-1.93s.87-1.93 1.93-1.93h1.97S31.49 13.47 44.98 9.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.55 77.46s1.31.02.34 2.05c-1.66 3.48-11.53 7.76-17.22 4.47-3.86-2.22-.76-6.44-.76-6.44s3.83 3.38 8.09 3.17c5.53-.28 4.21-.5 9.56-3.25ZM39.78 10.97c-.22.02-.45.11-.66.27-2.31 1.85-4.14 4.11-5.33 6.99-.57 1.38-.96 2.82-1.17 4.33-.14 1-.14 8.01-1.74 7.18-1.84-.95-3.46 2.08-1.61 3.03 1.36.71 2.62.65 3.66.1.16.06.35.1.56.1 2.68-.07 7.59.96 8.21-3.08.37-2.42-.02-5.15-.05-7.6-.03-2.54-.07-5.08-.1-7.61.28-.59.57-1.18.88-1.77 1.02-1.88-1.53-3.6-2.64-1.94h-.02ZM63.39 11.18c-1.05-1.66-3.48.05-2.51 1.94.3.59.57 1.18.84 1.77l-.09 7.61c-.03 2.45-.4 5.18-.05 7.6.59 4.05 5.26 3.01 7.81 3.08.2 0 .38-.03.54-.1.99.56 2.19.61 3.48-.1 1.76-.95.22-3.98-1.53-3.03-1.52.82-1.52-6.19-1.65-7.18-.2-1.51-.57-2.94-1.12-4.33-1.13-2.88-2.87-5.14-5.07-6.99-.2-.16-.42-.25-.63-.27h-.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.6 67.16c.69 7.31-.3 7.19 2.97 9.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.92 66.8c-.69 7.31.3 7.19-2.97 9.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.74 80.25s4.09 1.78 7.42 4.36M29.24 79.67s-4.09 1.78-7.42 4.36M39.8 76.21s4.16 4.04 11.61 4.04 10.68-4.4 10.68-4.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.78 80.25s.54 2.21 4.03 2.18 10.67 10.89 10.67 10.89l-.54-7.1-2.02-5.64-2.67-3.62-1.07-.4-3.96 1.49-4.43 2.2ZM72.45 80.61s-.54 2.21-4.03 2.18-10.67 10.89-10.67 10.89l.54-7.1 2.02-5.64 2.67-3.62 1.07-.4 3.96 1.49 4.43 2.2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.87 98.85c-.54-20.53 6.7-22.64 6.7-22.64s7.04 2.56 10.16 4.04c0 0-2.15 1.61-3.87 14.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.17 98.81c.84-20.9-6.52-22.96-6.52-22.96s-6.63 2.46-9.8 3.96c0 0 1.12.87 2.55 13.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.34 38.8a5.654 5.654 0 0 1 7.42 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.16 38.77a5.63 5.63 0 0 1 7.42 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.48 52.08c-2.31-.23-4.66-2.13-5.86-5.01-1.58-3.78-.57-7.81 2.27-8.99.63-.26 1.29-.36 1.96-.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.83 37.65c.76-.09 1.51 0 2.22.28 2.84 1.17 3.88 5.18 2.33 8.97-1.21 2.95-3.63 4.89-5.98 5.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.11 33.68c.48 2.36.75 4.84.76 7.4.05 15.36-9.04 27.85-20.31 27.89-11.27.04-20.44-12.39-20.49-27.75 0-2.55.23-5.02.7-7.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.53 43.01c0 4.18 2.75 4.37 2.75 6.82s-2.76 2.51-2.76 2.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.67 59.15c1.85.92 4.07.58 5.56-.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.95 29.44V15.93s0-9.65 9.65-9.65 9.65 9.65 9.65 9.65v13.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.8 9.22c13.29 3.87 12.1 20.22 12.1 20.22h1.93c1.06 0 1.93.87 1.93 1.93s-.87 1.93-1.93 1.93H30.38c-1.06 0-1.93-.87-1.93-1.93s.87-1.93 1.93-1.93h1.97S30.92 13.47 44.41 9.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.57 16.52-.34 2.02c-.07.36-.31.46-.52.46h-1.59l.67-3.69c-.67-.31-1.35-.51-1.9-.51s-.94.14-1.22.47c-.2.24-.3.53-.3.88 0 1.05.83 2.51 2.24 3.69 1.26 1.05 2.65 1.64 3.66 1.64.5 0 .91-.15 1.18-.46.21-.24.29-.55.29-.9 0-1.02-.83-2.45-2.17-3.61Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.71 12.61c-.25 0-.46.17-.52.43l-.22 1.22h2l-.86 4.73h1.59c.21 0 .45-.1.52-.46l.73-4.27h1.44c.25 0 .46-.17.52-.43l.22-1.22h-5.42Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.08",
        cy: "42.2",
        r: "1.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.8",
        cy: "42.2",
        r: "1.86"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTelstraHardHat104 = (AvatarTelstraHardHat104);
;// ./src/Picto/GeneratedPictoComponents/AvatarTelstraHardHat56.tsx


var AvatarTelstraHardHat56_excluded = ["className"];
function AvatarTelstraHardHat56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTelstraHardHat56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTelstraHardHat56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTelstraHardHat56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTelstraHardHat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTelstraHardHat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTelstraHardHat56_objectSpread(AvatarTelstraHardHat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.72 39.04c-1.73-.17-3.5-1.6-4.41-3.76-1.19-2.84-.42-5.87 1.7-6.76.47-.2.97-.27 1.47-.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.29 28.2c.57-.07 1.14 0 1.67.21 2.13.88 2.92 3.9 1.75 6.74-.91 2.21-2.73 3.67-4.5 3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.74 25.22c.36 1.77.56 3.64.57 5.56.04 11.55-6.79 20.93-15.26 20.96s-15.36-9.31-15.4-20.85c0-1.92.18-3.77.52-5.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.83 22.03V11.88s0-7.25 7.25-7.25 7.25 7.25 7.25 7.25v10.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.5 6.84c9.99 2.91 9.09 15.19 9.09 15.19h1.45c.79 0 1.45.65 1.45 1.45s-.65 1.45-1.45 1.45h-31.9c-.79 0-1.45-.65-1.45-1.45s.65-1.45 1.45-1.45h1.48s-1.07-12 9.07-15.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.87 7.7c-.18.02-.74.32-.91.44-1.81 1.46-3.18 2.95-4.11 5.21-.45 1.09-1.06 2.03-1.23 3.22-.11.78-.11 6.29-1.36 5.65-1.45-.75-2.72 1.63-1.27 2.38 1.07.56 2.06.51 2.87.08.13.05.27.08.44.08 2.1-.06 5.96.76 6.45-2.42.29-1.9-.02-4.05-.04-5.97-.02-1.99-.05-3.99-.08-5.98.22-.46.45-.93.69-1.39.8-1.48-.11-2.85-.98-1.55l-.49.27ZM35.69 7.43c-.87-1.3-1.78.07-.98 1.55.24.46.47.93.69 1.39-.02 1.99-.05 3.99-.08 5.98-.02 1.93-.33 4.07-.04 5.97.49 3.18 4.34 2.36 6.45 2.42.17 0 .31-.03.44-.08.82.44 1.81.48 2.87-.08 1.46-.75.18-3.13-1.27-2.38-1.26.65-1.26-4.86-1.36-5.65-.17-1.19-.78-2.13-1.23-3.22-.93-2.26-2.29-3.75-4.11-5.21-.17-.13-.73-.43-.91-.44l-.49-.27Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.63 29.21a4.255 4.255 0 0 1 5.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.76 29.19c1.6-1.4 3.98-1.4 5.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.72 39.19c-1.73-.17-3.5-1.6-4.41-3.76-1.19-2.84-.42-5.87 1.7-6.76.47-.2.97-.27 1.47-.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.29 28.35c.57-.07 1.14 0 1.67.21 2.13.88 2.92 3.9 1.75 6.74-.91 2.21-2.73 3.67-4.5 3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.74 25.36c.36 1.77.56 3.64.57 5.56.04 11.55-6.79 20.93-15.26 20.96-8.47.03-15.36-9.31-15.4-20.85 0-1.92.18-3.77.52-5.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.03 32.38c0 3.14 2.06 3.28 2.06 5.13s-2.08 1.88-2.08 1.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.64 44.5c1.39.69 3.06.44 4.18-.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.65 21.98V11.67s0-7.37 7.37-7.37 7.37 7.37 7.37 7.37v10.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.51 6.54c10.15 2.96 9.23 15.43 9.23 15.43h1.47c.81 0 1.47.66 1.47 1.47s-.66 1.47-1.47 1.47H11.82c-.81 0-1.47-.66-1.47-1.47s.66-1.47 1.47-1.47h1.5S12.23 9.78 22.53 6.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.78 12.67-.25 1.47c-.05.26-.23.33-.38.33h-1.16l.49-2.69c-.49-.22-.98-.37-1.38-.37s-.68.1-.89.35c-.14.17-.22.39-.22.64 0 .76.6 1.82 1.63 2.69.92.76 1.93 1.19 2.66 1.19.37 0 .66-.11.86-.34.15-.17.21-.4.21-.65 0-.74-.61-1.78-1.58-2.63Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.7 9.81c-.18 0-.34.12-.38.32l-.16.89h1.46l-.63 3.45h1.16c.15 0 .33-.07.38-.34l.53-3.11h1.05c.18 0 .34-.12.38-.32l.16-.89h-3.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.6",
        cy: "31.41",
        r: "1.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.33",
        cy: "31.41",
        r: "1.36"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTelstraHardHat56 = (AvatarTelstraHardHat56);
;// ./src/Picto/GeneratedPictoComponents/AvatarTurbanMale104.tsx


var AvatarTurbanMale104_excluded = ["className"];
function AvatarTurbanMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTurbanMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTurbanMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTurbanMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTurbanMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTurbanMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTurbanMale104_objectSpread(AvatarTurbanMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.56",
        cy: "52.41",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.9 65.31c12.64.07 15.39-12.83 15.39-12.83s.52 7.75-3.71 13.81c-5.62 8.06-11.68 6.37-11.68 9.54 0-3.16-5.9-1.48-11.51-9.54-4.22-6.05-4.14-13.81-4.14-13.81s3.02 12.9 15.66 12.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.35 10.44C30.2 33.5 36.73 54.56 36.73 54.56s-8.16-9.37-9.58-23.12C25.73 17.69 41.21 5.19 51.13 4.73c9.91.47 25.4 12.96 23.98 26.71-1.42 13.75-8.09 22.59-8.09 22.59s3.93-26.78-17.88-30.43l15.21-13.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.8",
        cy: "37.58",
        rx: "17.84",
        ry: "31.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m80.14 86.23-10.83-7.82c-2.26-1.63-4.3-3.57-5.94-5.82-.16-.22-.32-.45-.48-.68l.11.17c-.27-.4-.11-.17-1.77-2.96l-17.45-3.99c-.26 2.69-1.41 5.15-2.74 7.19l.25-.4c-.16.23-.32.46-.48.68-1.64 2.25-3.68 4.19-5.94 5.82l-11.23 8.1s8.82 12.73 28.08 12.73 28.4-13.01 28.4-13.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.15 57.16c.96-.45 1.85-.56 2.68-1.33.4-.37.98-.96.71-1.54-.23-.5-1.24-.37-1.65 0-.69.64-1.43.9-2.23 1.28-.47.22-1.17.6-1.03 1.24.12.56.68.57 1.15.35h.37ZM54.14 55.56c.89.31 1.72.96 2.58 1.37.49.24 1.61.19 1.91-.34.26-.46-.39-.83-.89-1.07-1.01-.49-2.04-1.1-3.1-1.46-1.24-.42-2.17.69-.94 1.12l.44.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.31 81.71c-.52.48-.1 1.09.47.73 3.02-1.88 8.12 1.55 10.69-2.12.37.16-.04-1.39-.16-1.78-.22-.7-.27-3.16-1.77-3.5-1.67-1.04-6.96 4.15-9.22 6.66Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.37 87.34-2.78-4.01 4.17-4 4.18 4-2.78 4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.23 81.78c.5.5.05 1.13-.52.76-3-1.92-8.45 1.63-10.89-2.14-.39.16.12-1.43.27-1.83.26-.72.46-3.26 2.02-3.61 1.78-1.08 6.93 4.25 9.12 6.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53.16 87.34 1.04 8.98c.17 1.47-.98 2.92-2.46 2.92-1.49 0-2.64-1.46-2.46-2.94l1.09-8.97M53.34 65.06c-4.32.45-6.7-.32-11.19-2.38-.29-.27-.83-.91-1.11-1.19-.97-1.68-2.05-1.58-2.64-3.29-.59-1.69-2.54-2.71-1.94-1 .54 1.56.46 3.75 1.26 5.25-.04.36.62 1.31.93 1.66.19.21.39.97.59 1.17.84 1.38 1.89 2.7 2.93 3.89 2.7 3.1 5.59 3.26 8.86 5.46.41.28 1 .24 1.41 0 3-1.71 5.04-2.32 7.64-5.34 0 0 .94-7.17-6.74-4.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.71 72.24c.61-.93 1.18-1.94 1.64-3.03M60.9 69.04c1.66 2.8 1.5 2.56 1.77 2.96M51.76 78.89l4.2 4.02-2.8 4.02 2.34 12.06M51.76 78.89l-4.2 4.02 2.8 4.02-2.38 12.06M58.56 98.65c-1.8-16.47 5.2-25.18 5.2-25.18M44.72 98.65c1.46-15.31-4.96-25.18-4.96-25.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.96 71.84 10.8 6.9-7.15 6.86M62.56 71.84l-10.8 6.9 7.15 6.86M62.56 71.84c.16.23.32.46.48.68 1.64 2.25 3.68 4.19 5.94 5.82l10.83 7.82M40.96 71.84c-.16.23-.32.46-.48.68-1.64 2.25-3.68 4.19-5.94 5.82l-11.23 8.1M51.61 46.18c0 3.51 2.29 3.67 2.29 5.68s-2.33 2.1-2.33 2.1M42.22 42.62c1.72-1.56 4.51-1.56 6.22 0M54.67 42.62c1.72-1.56 4.51-1.56 6.22 0M50.01 59.72c1.85 1.05 3.82.09 4.67-.7M51.56 54.47s-.57-.84-2.52-.84c-3 0-5.27 3.43-6.81 3.43 0 0 4.36 1.39 6.38-.67 2.02-2.06 2.96-1.92 2.96-1.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.56 54.47s.57-.84 2.52-.84c3 0 5.27 3.43 6.81 3.43 0 0-4.36 1.39-6.38-.67s-2.96-1.92-2.96-1.92ZM51.56 75.75c0-3.16 6.07-1.48 11.68-9.54 4.22-6.05 3.71-13.81 3.71-13.81S64.2 65.3 51.56 65.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.56 65.24c-12.64.07-15.66-12.83-15.66-12.83s-.08 7.75 4.14 13.81c5.62 8.06 11.51 6.37 11.51 9.54"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.41 21.22c-2.52-5.03-11.35-8.17-16.74-8.49C37.29 12.12 26.78 23.72 28 35.56c.04.36.2.64.43.82-.01.25-.06.51-.02.77.6 4.07 2.89 9.92 5.67 14.18 1.4 2.14 2.03.59 2.09-.58.35-6.52 2.37-12.83 5.97-18.22 1.34-2.01 3.3-5.37 4.11-6.14.84-.8 3.64-3.77 5.08-3.02 2.61 1.37 8.71 4.87 8.78 5.37.08.6.7.72.69 1.06-.03 1 .57 1.53 1.23.82 0 0 4.56-5.07 2.38-9.41Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.02 10.36C29.87 33.42 36.4 54.48 36.4 54.48s-8.16-9.37-9.58-23.12C25.4 17.61 40.88 5.11 50.8 4.65c9.91.47 25.4 12.96 23.98 26.71-1.42 13.75-8.09 22.59-8.09 22.59s3.93-26.78-17.88-30.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.35 19.2s19.05 3.49 17.77 26.51M58.34 14.55s14.3 3.51 16.3 17.9M30.77 45.36c-.05-.1 3.89-23.1 28.19-37.92M27.62 36.23s5.24-21.04 27.12-30.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.23",
        cy: "46.63",
        r: "1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "57.9",
        cy: "46.63",
        r: "1.6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTurbanMale104 = (AvatarTurbanMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarTurbanMale56.tsx


var AvatarTurbanMale56_excluded = ["className"];
function AvatarTurbanMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarTurbanMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarTurbanMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarTurbanMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarTurbanMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarTurbanMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarTurbanMale56_objectSpread(AvatarTurbanMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.17 45.27c8.72.05 10.62-8.85 10.62-8.85s.36 5.35-2.56 9.53c-3.88 5.56-8.06 4.4-8.06 6.58 0-2.18-4.07-1.02-7.94-6.58-2.91-4.18-2.86-9.53-2.86-9.53s2.09 8.9 10.8 8.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.76 7.42C13.2 23.33 17.71 37.86 17.71 37.86s-5.63-6.46-6.61-15.95S20.8 3.79 27.64 3.47c6.84.32 17.52 8.94 16.54 18.43-.98 9.49-5.58 15.59-5.58 15.59s2.71-18.48-12.33-21l10.5-9.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.11",
        cy: "26.14",
        rx: "12.31",
        ry: "21.48"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.06 38.7c.58.2 1.12.62 1.68.89.32.16 1.05.12 1.24-.22.17-.3-.25-.54-.58-.7-.66-.32-1.33-.71-2.02-.95-.81-.28-1.42.45-.61.73l.29.25ZM29.53 44.9c-2.82.29-4.37-.21-7.3-1.55-.19-.17-.54-.6-.72-.78-.63-1.09-1.34-1.03-1.72-2.14-.38-1.1-1.65-1.77-1.27-.65.35 1.02.3 2.44.82 3.42-.03.24.4.86.61 1.08.13.14.26.63.39.77.55.9 1.23 1.76 1.91 2.53 1.76 2.02 3.65 2.13 5.78 3.56.27.18.65.15.92 0 1.96-1.11 3.28-1.51 4.98-3.48 0 0 .61-4.67-4.39-2.76M26.58 38.74c-.65.23-1.26.71-1.88 1.02-.36.18-1.18.14-1.39-.25-.19-.34.28-.61.65-.79.74-.36 1.49-.81 2.26-1.08.9-.31 1.58.51.69.83l-.32.28Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.26 32.31c0 2.37 1.55 2.48 1.55 3.83s-1.58 1.42-1.58 1.42M20.85 29.91c1.16-1.05 3.04-1.05 4.2 0M31.33 29.91c1.16-1.05 3.04-1.05 4.2 0M28.23 37.9s-.38-.56-1.7-.56c-2.02 0-3.56 2.32-4.6 2.32 0 0 2.94.94 4.3-.45 1.36-1.39 2-1.3 2-1.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.23 37.9s.38-.56 1.7-.56c2.02 0 3.56 2.32 4.6 2.32 0 0-2.94.94-4.3-.45-1.36-1.39-2-1.3-2-1.3ZM28.23 52.27c0-2.13 4.09-1 7.89-6.43 2.85-4.09 2.5-9.32 2.5-9.32s-1.86 8.7-10.39 8.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.23 45.17c-8.53.04-10.57-8.66-10.57-8.66s-.05 5.23 2.8 9.32c3.79 5.44 7.77 4.3 7.77 6.43M27.07 41.82c1.54.88 3.19.08 3.9-.59"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.15 14.51c-1.69-3.38-7.63-5.49-11.25-5.7-6.97-.41-14.04 7.39-13.22 15.35.03.24.14.43.29.55 0 .17-.04.34-.02.52.4 2.73 1.94 6.66 3.81 9.53.94 1.44 1.48 1.15 1.53.36.23-4.38 1.47-9.37 3.89-13 .9-1.35 1.88-2.88 2.42-3.4s2.62-2.94 3.59-2.43c1.76.92 6.02 2.95 6.06 3.28.05.4 0 0 .65.29s.19 1.46.64.98c0 0 3.06-3.41 1.6-6.33Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.63 7.36c-23.2 15.67-18.77 29.98-18.77 29.98s-5.54-6.37-6.51-15.71c-.97-9.35 9.55-17.84 16.29-18.16 6.74.32 17.26 8.81 16.29 18.15-.97 9.35-5.5 15.35-5.5 15.35s2.67-18.2-12.15-20.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.38 13.36s12.94 2.37 12.08 18.01M32.77 10.2s9.72 2.38 11.08 12.16M14.03 31.14c-.03-.07 2.64-15.7 19.16-25.77M11.89 24.94s3.56-14.3 18.43-20.98"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.12",
        cy: "32.66",
        r: "1.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.34",
        cy: "32.66",
        r: "1.29"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarTurbanMale56 = (AvatarTurbanMale56);
;// ./src/Picto/GeneratedPictoComponents/AvatarYoungAdultMale104.tsx


var AvatarYoungAdultMale104_excluded = ["className"];
function AvatarYoungAdultMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarYoungAdultMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarYoungAdultMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarYoungAdultMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarYoungAdultMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarYoungAdultMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarYoungAdultMale104_objectSpread(AvatarYoungAdultMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.87",
        cy: "52",
        rx: "51.87",
        ry: "51.74"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.19 34.17c-1-.28-2.03-.25-2.97.14-2.83 1.17-3.86 5.19-2.3 8.97 1.37 3.31 4.27 5.34 6.87 5.01M70.42 48.32c2.5.1 5.18-1.89 6.49-5.04 1.57-3.78.54-7.79-2.3-8.97-.89-.37-1.86-.41-2.82-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.62",
        cy: "37.45",
        rx: "20.36",
        ry: "27.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.02 21.99c-.52-2.39.11-4.92 1.22-7.1 2.43-4.77 7.17-8.23 12.38-9.25 5.22-1.02 10.81.35 15.11 3.51 2.01 1.48 3.73 3.32 5.32 5.24 1.25 1.52 2.44 3.11 3.93 4.37 2.29 1.93 5.19 2.99 8.07 3.77.29.73-.7 1.27-1.47 1.43l-4.72.96c1.04 1.71 4.75 2.98 5.92 3.84-9.96 1.36-21.09.28-30.99-1.5-3.51-.63-6.71-1.19-10.05-2.28-1.29-.42-3.95-1.75-4.63-2.93M86.26 85.05c-1.19-1.92-2.68-3.72-4.56-5.22-3.68-2.94-7.67-5.25-11.26-7.51L66.54 70c-3.45-1.64-5.21-2.07-5.21-7.5H42.56c0 5.55-2.38 5.93-5.95 7.61h-.07l-3.79 2.4c-3.59 2.26-7.44 4.38-11.12 7.32-1.99 1.59-3.55 3.52-4.78 5.58 0 0 13.1 13.83 34.7 13.83s34.7-14.19 34.7-14.19Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.92 91.33s-3.11 2.82-8.07.36-9.48-4.79-13.68-4.85c-4.2-.06-5.61-1.6-5.57-3.07.04-1.47 27.48-.46 27.48-.46l-.17 8.03ZM29.6 83.58h2.64v5.21s-1.09-2.06-2.64-1.61 0-3.6 0-3.6ZM33.93 71.81h2.64v8.27s-1.09-3.27-2.64-2.55 0-5.72 0-5.72ZM73.56 83.87h-2.64v5.21s1.09-2.06 2.64-1.61 0-3.6 0-3.6ZM69.6 71.61h-2.64v8.27s1.09-3.27 2.64-2.55 0-5.72 0-5.72ZM78.01 29.22l.75-.95c-5.4-3.66-6.24-2.84-10.29-10.01-2.51-4.44-8.44-9.27-14.55-9.91-8.2-.87-19.47 5.15-18.13 13.2.13.79.66 1.29 1.29 1.48.77.23 1.46.63 2.1 1.11.14.11.3.21.46.31 2.28 1.37 5.5 1.74 8.06 2.26 3 .61 6.03 1.05 9.07 1.39 7.05.79 14.16.96 21.25 1.13"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.68 97.15V70l3.9 2.33-.1 23.41M66.68 82.96H36.75M70.83 82.96h3.51v10.95M36.76 96.88l-.08-26.76-3.79 2.39v22.92M36.75 70.12c3.57-1.68 5.95-2.07 5.95-7.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17 85.41c1.22-2.05 2.79-3.98 4.78-5.58 3.68-2.94 7.53-5.06 11.12-7.32M70.58 72.33c3.59 2.26 7.58 4.57 11.26 7.51 1.87 1.5 3.37 3.3 4.56 5.22M61.47 62.5c0 5.43 1.75 5.86 5.21 7.5M36.68 70.12c4.35 3.74 9.5 5.91 15.02 5.91s10.67-2.17 15.02-5.91M31.33 34.17c-1-.28-2.03-.25-2.97.14-2.83 1.17-3.86 5.19-2.3 8.97 1.37 3.31 4.27 5.34 6.87 5.01M70.56 48.32c2.5.1 5.18-1.89 6.49-5.04 1.57-3.78.54-7.79-2.3-8.97-.89-.37-1.86-.41-2.82-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.31 29.66c.53 2.47.81 5.09.81 7.79 0 15.34-9.12 27.77-20.36 27.77S31.4 52.79 31.4 37.45c0-5.73 1.27-11.05 3.45-15.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.9 55.41c2.2 1.25 4.54.11 5.55-.84M32.32 82.96h-3.5v10.95M35.16 21.99c-.52-2.39.11-4.92 1.22-7.1 2.43-4.77 7.17-8.23 12.38-9.25 5.22-1.02 10.81.35 15.11 3.51 2.01 1.48 3.73 3.32 5.32 5.24 1.25 1.52 2.44 3.11 3.93 4.37 2.29 1.93 5.19 2.99 8.07 3.77.29.73-.7 1.27-1.47 1.43l-4.72.96c1.04 1.71 4.75 2.98 5.92 3.84-9.96 1.36-21.09.28-30.99-1.5-3.51-.63-6.71-1.19-10.05-2.28-1.29-.42-3.95-1.75-4.63-2.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.27 38.5c0 3.99-3.03 6.4-6.76 6.4s-5.87-1.43-5.87-5.42c0-3.65.73-5.78 5.54-5.78 3.65 0 7.09.23 7.09 4.8ZM54.2 38.5c0 3.99 3.03 6.4 6.76 6.4 3.74 0 5.87-1.43 5.87-5.42 0-3.65-.73-5.78-5.54-5.78-3.65 0-7.09.23-7.09 4.8Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.27 38.5c0-1.16.88-1.57 1.96-1.57s1.96.41 1.96 1.57M31.28 33.89l6.36 3.72M72.47 33.89l-5.64 3.72"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m52.41 38.55 2.51 4.99c.53 1.06.26 2.38-.65 3.1l-1.45 1.16",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.79 39.69c0 .75-.83.42-1.85.42s-1.85.33-1.85-.42.83-1.36 1.85-1.36 1.85.61 1.85 1.36ZM61.6 39.69c0 .75-.83.49-1.85.49s-1.85.26-1.85-.49.83-1.36 1.85-1.36 1.85.61 1.85 1.36Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarYoungAdultMale104 = (AvatarYoungAdultMale104);
;// ./src/Picto/GeneratedPictoComponents/AvatarYoungAdultMale56.tsx


var AvatarYoungAdultMale56_excluded = ["className"];
function AvatarYoungAdultMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AvatarYoungAdultMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AvatarYoungAdultMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AvatarYoungAdultMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AvatarYoungAdultMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AvatarYoungAdultMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AvatarYoungAdultMale56_objectSpread(AvatarYoungAdultMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "fillprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.42 27.86c-.79-.22-1.59-.2-2.33.11-2.22.92-3.02 4.06-1.8 7.02 1.07 2.59 3.34 4.18 5.38 3.92M42.12 38.93c1.95.07 4.06-1.48 5.08-3.94 1.22-2.96.42-6.1-1.8-7.02-.7-.29-1.46-.32-2.2-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.4",
        cy: "30.43",
        rx: "15.94",
        ry: "21.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.13 17.28c-.4-1.85.09-3.8.94-5.49 1.88-3.69 5.54-6.36 9.57-7.15s8.36.27 11.68 2.71c1.55 1.14 2.89 2.56 4.11 4.05.97 1.17 1.88 2.4 3.04 3.38 1.77 1.5 4.01 2.31 6.24 2.92.22.57-.54.98-1.14 1.1-1.22.25-2.43.49-3.65.74.8 1.32 3.67 2.31 4.58 2.97-7.7 1.05-16.3.21-23.96-1.16-2.71-.49-5.19-.92-7.77-1.76-.99-.33-3.06-1.35-3.58-2.27"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m48.03 22.84.59-.71c-4.24-2.72-4.89-2.11-8.07-7.44-1.97-3.3-6.62-6.88-11.41-7.36-6.43-.65-15.27 3.82-14.21 9.8.1.59.52.96 1.01 1.1.6.17 1.14.46 1.64.82.11.08.23.16.36.23 1.78 1.02 4.32 1.29 6.32 1.68 2.35.45 4.73.78 7.11 1.03 5.53.59 11.1.71 16.66.84",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.99 27.86c-.79-.22-1.59-.2-2.33.11-2.22.92-3.02 4.06-1.8 7.02 1.07 2.59 3.34 4.18 5.38 3.92M41.69 38.93c1.95.07 4.06-1.48 5.08-3.94 1.22-2.96.42-6.1-1.8-7.02-.7-.29-1.46-.32-2.2-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.99 23.16c.59 2.27.91 4.72.91 7.26 0 12-7.13 21.73-15.94 21.73s-15.94-9.73-15.94-21.73c0-5.16 1.32-9.89 3.52-13.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.52 44.48c1.72.98 3.55.09 4.35-.66M14.69 17.28c-.4-1.85.09-3.8.94-5.49 1.88-3.69 5.54-6.36 9.57-7.15s8.36.27 11.68 2.71c1.55 1.14 2.89 2.56 4.11 4.05.97 1.17 1.88 2.4 3.04 3.38 1.77 1.5 4.01 2.31 6.24 2.92.22.57-.54.98-1.14 1.1-1.22.25-2.43.49-3.65.74.8 1.32 3.67 2.31 4.58 2.97-7.7 1.05-16.3.21-23.96-1.16-2.71-.49-5.19-.92-7.77-1.76-.99-.33-3.06-1.35-3.58-2.27"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.71 31.29c0 3.03-2.34 4.87-5.23 4.87s-4.53-1.09-4.53-4.12c0-2.77.57-4.4 4.28-4.4 2.82 0 5.48.18 5.48 3.65ZM28.74 31.29c0 3.03 2.34 4.87 5.23 4.87 2.89 0 4.53-1.09 4.53-4.12 0-2.77-.57-4.4-4.28-4.4-2.82 0-5.48.18-5.48 3.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.71 31.29c0-.88.68-1.19 1.52-1.19s1.52.32 1.52 1.19M11.03 27.79l4.92 2.82M42.87 27.79l-4.36 2.82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.66 31.11 1.96 3.91c.42.83.2 1.86-.51 2.43l-1.14.91",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.94 31.63c0 .58-.64.32-1.43.32s-1.43.26-1.43-.32.64-1.05 1.43-1.05 1.43.47 1.43 1.05ZM34.37 31.63c0 .58-.64.38-1.43.38s-1.43.2-1.43-.38.64-1.05 1.43-1.05 1.43.47 1.43 1.05Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AvatarYoungAdultMale56 = (AvatarYoungAdultMale56);
;// ./src/Picto/GeneratedPictoComponents/AdultFemale104.tsx


var AdultFemale104_excluded = ["className"];
function AdultFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdultFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdultFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdultFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdultFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdultFemale104_objectSpread(AdultFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.4 86.39s1.97.19.31 2.7c-2.84 4.31-16.98 8.93-26.35 3.64-10.49-5.91-.52-8.47-.52-8.47s5.44 4.88 11.87 5.14c8.35.34 6.39-.12 14.7-3.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.28 69.81a16.81 16.81 0 0 1-7.04-8.23c-.85-2.12-2.93-5.01-2.51-2.73.43 3.86.43 7.76 0 11.63l.24 5.05c-.37 1.06-.37 2.01 1.08 1.99l6.82-.13a1.854 1.854 0 0 0 1.3-2.99 1.864 1.864 0 0 0 .99-2.68c.2-.76-.16-1.57-.87-1.91Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.25 9.86c-12.15.41-20.43 11.98-22.66 23.03-.39 2.02.65 2.58 2.02 2.32.85.07 1.7.07 2.54 0 6.59 0 11.79.48 17.96 0 .33.2 1.23 0 1.69.17 1.1.45 2.25-.69 2.25-1.73 0-3.62-.11-7.22-.33-10.83.15.2.28.45.43.69.61 1.1 1.15 2.25 1.75 3.36.84 1.98 1.93 3.86 3.23 5.57.17.19 0 1.15 0 1.19 0 1.54 2.45 2.23 3.57 1.5 2.25.46 4.58.46 6.83 0 .77-.2 1.31-.91 1.3-1.71-.46-11.07-8.34-23.96-20.58-23.57Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.76 40.65a6.144 6.144 0 0 1 8.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.9 40.61a6.121 6.121 0 0 1 8.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.72 56 .07 21.61 9.68-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.99 84.67c6-3.2 4.89-6.34 4.88-14.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.05 70.15c.03 8.12-1.28 11.31 4.95 14.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.2 55.1c-2.51-.25-5.08-2.32-6.38-5.45-1.72-4.12-.62-8.5 2.47-9.79.68-.29 1.4-.4 2.13-.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.04 39.4c.83-.1 1.65-.01 2.42.31 3.09 1.27 4.23 5.64 2.53 9.77-1.32 3.21-3.95 5.32-6.51 5.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.26 35.07c.53 2.57.81 5.27.82 8.06.06 16.73-9.84 30.32-22.11 30.36C39.7 73.53 29.71 60 29.66 43.27c0-2.78.26-5.47.76-8.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.94 45.24c0 4.55 2.99 4.75 2.99 7.43s-3.01 2.73-3.01 2.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.92 62.8c2.01 1 4.44.63 6.05-.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.19 35.06A26.233 26.233 0 0 0 65 12.38a26.251 26.251 0 0 0-26.24.08 26.246 26.246 0 0 0-13.05 22.77l26.24-.09V23.03l6.09 12.09 20.15-.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.82 83.96c4.87 2.92 10.49 5.98 14.99 9.47.65.52 1.27 1.08 1.85 1.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.22 95.09c.58-.59 1.18-1.14 1.82-1.66 4.41-3.46 10.24-6.5 15.01-9.4 0 0 5 5.4 13.98 5.4 5.79-.02 9.29-1.82 13.8-5.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.66",
        cy: "45.22",
        r: "2.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.89",
        cy: "45.16",
        r: "2.06"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultFemale104 = (AdultFemale104);
;// ./src/Picto/GeneratedPictoComponents/AdultFemale56.tsx


var AdultFemale56_excluded = ["className"];
function AdultFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdultFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdultFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdultFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdultFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdultFemale56_objectSpread(AdultFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.77 45.65a11.211 11.211 0 0 1-4.7-5.49c-.57-1.41-1.96-3.35-1.67-1.82.29 2.58.29 5.18 0 7.76l.16 3.37c-.25.71-.25 1.34.72 1.33l4.55-.09c.45-.04.85-.32 1.03-.74.18-.42.12-.9-.16-1.26.35-.12.27-.57.39-.92s.1-.62-.09-.94c.14-.51.24-.97-.23-1.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.41 5.64c-8.11.27-13.64 8-15.12 15.37-.26 1.35.43 1.72 1.35 1.55.57.04 1.13.04 1.7 0 4.4 0 7.87.32 11.99 0 .22.14.82 0 1.13.11.73.3 1.5-.46 1.5-1.15 0-2.41-.07-4.82-.22-7.23.1.14.19.3.29.46.41.73.77 1.5 1.17 2.24.56 1.32 1.29 2.57 2.16 3.72.11.12 0 .77 0 .79 0 1.03 1.64 1.49 2.38 1 1.5.31 3.06.31 4.56 0 .52-.14.87-.61.87-1.14-.31-7.39-5.57-15.99-13.74-15.73Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.75 26.19a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.52 26.17a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.38 36.39.05 14.47 6.46-.03v-5.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.04 35.84c-1.68-.17-3.39-1.55-4.26-3.64-1.15-2.75-.41-5.67 1.65-6.53.46-.19.94-.26 1.42-.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.63 25.36c.55-.07 1.1 0 1.62.21 2.06.85 2.82 3.77 1.69 6.52-.88 2.14-2.64 3.55-4.35 3.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.11 22.47c.35 1.71.54 3.52.55 5.38.04 11.17-6.57 20.24-14.76 20.27-8.19.03-14.86-9-14.89-20.17 0-1.85.17-3.65.51-5.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.88 29.25c0 3.04 2 3.17 2 4.96s-2.01 1.82-2.01 1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.53 40.98c1.34.67 2.96.42 4.04-.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.4 22.46A17.518 17.518 0 0 0 19.07 7.38a17.522 17.522 0 0 0-8.71 15.2l17.52-.06v-8.08l4.07 8.07 13.45-.04Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.35",
        cy: "29.24",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.19",
        cy: "29.2",
        r: "1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultFemale56 = (AdultFemale56);
;// ./src/Picto/GeneratedPictoComponents/AdultMale104.tsx


var AdultMale104_excluded = ["className"];
function AdultMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdultMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdultMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdultMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdultMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdultMale104_objectSpread(AdultMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.07 38.05c.19-4.26-.79-8.5-2.84-12.24-.04-.35-.04-.71 0-1.06 1.03-2.43 1.43-5.08 1.15-7.71-.2-.89-.56-1.73-1.08-2.49 0 0-.78-1.76-.82-1.56l-.33-.37c-4.79 3.08-13.17.74-18.44 0-4.94-.65-10.05-1.11-14.39 1.63-7.43 4.66-8.91 13.37-9.64 21.56v1.17c0 .06.61 3.29.61 3.44 1.19 2.9 1.86-.54 1.99-2.71v-.09s4.81-20.19 20.52-20.58c15.71-.39 19.35 18.57 19.35 18.57.11.69 1.17 3.4 1.19 3.81.3 3.9 2.58 2.17 2.73 0 .02-.52.02-.95 0-1.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.27 86.03c6.34-3.75 10.2-6.34 11.02-13.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.82 71.77c.74 7.82 4.67 11.23 11.31 14.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.9 57.35c-2.41-.23-4.88-2.23-6.12-5.24-1.63-3.94-.56-8.13 2.4-9.36.68-.28 1.41-.38 2.14-.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.46 42.42c.6 0 1.18.11 1.74.34 2.96 1.22 4.03 5.41 2.4 9.36-1.25 3.02-3.73 5.02-6.15 5.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.8",
        cy: "46.03",
        rx: "21.34",
        ry: "28.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.74 47.96c0 4.35 2.84 4.55 2.84 7.06s-2.9 2.6-2.9 2.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.1 43.54a5.884 5.884 0 0 1 7.73 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.55 43.54a5.884 5.884 0 0 1 7.73 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.75 64.77c1.92.96 4.24.61 5.79-.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.19 42.17s1.86.15 1.86-6.37a16.76 16.76 0 0 0-3.34-10.44C78.25 14.83 65.53 7.4 65.53 7.4c-3.53 3.06-9.56 2.99-13.59 2.99-16.49 0-23.21 13-23.21 25.41 0 6.52 1.86 6.37 1.86 6.37"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.81",
        cy: "47.93",
        r: "1.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.34",
        cy: "47.93",
        r: "1.97"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M69.3 88.7s2.7.19.43 2.7c-3.89 4.31-21.1 11.15-36.14 3.64-13.92-6.95-2.04-9.2-2.04-9.2s9.64 7.39 18.46 7.46c12.85.1 8.32-.49 19.3-4.61Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.8 95.44c-3.8-4.62-13.64-9.58-13.64-9.58-4.9 4.42-11.71 7.52-19.87 7.6-6.59-.1-15.85-3.18-20.75-7.6 0 0-10.56 6.61-12.04 9.58"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultMale104 = (AdultMale104);
;// ./src/Picto/GeneratedPictoComponents/AdultMale56.tsx


var AdultMale56_excluded = ["className"];
function AdultMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdultMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdultMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdultMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdultMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdultMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdultMale56_objectSpread(AdultMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.32 25.4c.13-2.98-.55-5.93-1.98-8.55-.03-.25-.03-.49 0-.74.72-1.7 1-3.55.8-5.38a5.08 5.08 0 0 0-.75-1.74s-.54-1.23-.57-1.09l-.23-.26c-3.35 2.15-9.19.52-12.88 0-3.45-.45-7.02-.78-10.05 1.14-5.19 3.26-6.22 9.34-6.73 15.06v.82s.43 2.3.43 2.4c.83 2.02 1.3-.38 1.39-1.89v-.06s3.36-14.1 14.33-14.37c10.97-.27 13.51 12.97 13.51 12.97.08.48.82 2.37.83 2.66.21 2.72 1.8 1.52 1.91 0 .01-.36.01-.66 0-.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.18 38.88c-1.68-.16-3.4-1.55-4.28-3.66-1.14-2.75-.39-5.68 1.67-6.53.48-.2.99-.27 1.5-.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.2 28.45c.42 0 .83.07 1.22.24 2.06.86 2.81 3.78 1.67 6.53-.87 2.11-2.61 3.51-4.3 3.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.07",
        cy: "30.97",
        rx: "14.9",
        ry: "20.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.03 32.32c0 3.03 1.98 3.18 1.98 4.93s-2.02 1.82-2.02 1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.9 29.24a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.69 29.24a4.093 4.093 0 0 1 5.39 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.64 44.06c1.34.67 2.96.42 4.05-.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.01 28.28s1.3.1 1.3-4.45c.06-2.62-.76-5.19-2.33-7.29C46.54 9.19 37.66 4 37.66 4c-2.46 2.14-6.68 2.09-9.49 2.09-11.52 0-16.21 9.08-16.21 17.74 0 4.55 1.3 4.45 1.3 4.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.49",
        cy: "32.3",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.34",
        cy: "32.3",
        r: "1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdultMale56 = (AdultMale56);
;// ./src/Picto/GeneratedPictoComponents/AndrogynousPersonOne104.tsx


var AndrogynousPersonOne104_excluded = ["className"];
function AndrogynousPersonOne104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AndrogynousPersonOne104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AndrogynousPersonOne104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AndrogynousPersonOne104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AndrogynousPersonOne104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AndrogynousPersonOne104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AndrogynousPersonOne104_objectSpread(AndrogynousPersonOne104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.39 25.86c-1.95-8.42-8.14-16.2-17.86-17.39-11.22-1.37-18.45 7.76-22.89 16.06-1.37 2.57-1.62 6.72 2.47 7.11 1.81.17 3.22-.77 4.52-1.8 2.34-1.86 4.44-3.69 7.37-4.73 6.25-2.22 12.56.14 17.86 3.3 3.2 1.91 7.26 3.51 9.81-.2 0 0-.18-2.19-1.28-2.36ZM59.92 88.53s1.78.42-.05 2.91c-3.15 4.27-17.7 7.21-24.65 1.02-4.71-4.19.58-9.06.58-9.06s4.38 5.77 10.25 6.74c7.62 1.26 5.88.57 13.87-1.61Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.43 95.06c.6-.61 1.24-1.2 1.93-1.75 4.13-3.3 8.61-5.89 12.65-8.43 6.49-4.08 8.52-5.25 8.52-15.69M85.57 95.14c-.62-.64-1.28-1.25-2-1.82-4.13-3.3-8.61-5.89-12.65-8.43-6.49-4.08-8.34-5.25-8.34-15.69M67.7 83.61c-4.65 4-10.16 6.32-16.06 6.32s-11.41-2.32-16.06-6.32M28.26 36.99c-1.02-.25-2.04-.21-2.98.18-3.08 1.28-4.13 5.8-2.35 10.1 1.56 3.76 4.76 6.11 7.6 5.79M73.31 53.06c2.84.4 6.1-1.97 7.68-5.79 1.78-4.3.76-8.81-2.28-10.07-1.05-.44-2.21-.43-3.35-.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.68 34.26c.31 2.06.47 4.19.47 6.37 0 17.46-10.38 31.61-23.18 31.61S28.79 58.09 28.79 40.63c0-2.18.16-4.3.47-6.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.86 61.08c2.5 1.42 5.17.13 6.32-.95M29.27 34.26c2.24-14.51 11.55-25.4 22.7-25.4s20.44 10.89 22.69 25.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56",
        cy: "12.82",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "54.14",
        cy: "14.55",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.2",
        cy: "11.52",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.4",
        cy: "12.82",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "46.67",
        cy: "11.95",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "47.6",
        cy: "15.42",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "44.8",
        cy: "14.55",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "41.81",
        cy: "14.81",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42.94",
        cy: "17.16",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.2",
        cy: "17.16",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.14",
        cy: "19.76",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "43.87",
        cy: "19.76",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "45.74",
        cy: "18.03",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "49.47",
        cy: "17.16",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56.93",
        cy: "15.42",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "59.73",
        cy: "13.69",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "59.73",
        cy: "17.16",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "55.07",
        cy: "17.16",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "53.2",
        cy: "18.9",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "54.14",
        cy: "22.37",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "49.31",
        cy: "23",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56",
        cy: "20.63",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.8",
        cy: "19.76",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "58.8",
        cy: "23.24",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "61.6",
        cy: "22.37",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "63.47",
        cy: "20.63",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "65.33",
        cy: "23.24",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "63.41",
        cy: "24.97",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "66.54",
        cy: "25.84",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "69.07",
        cy: "27.58",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "68.13",
        cy: "23.24",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "66.27",
        cy: "20.63",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "64.4",
        cy: "18.03",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "62.53",
        cy: "16.29",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "50.13",
        cy: "20.63",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "47",
        cy: "20.33",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "44.8",
        cy: "23.24",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42",
        cy: "22.37",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.27",
        cy: "22.37",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.2",
        cy: "24.97",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.8",
        cy: "27.32",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.54",
        cy: "28.19",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.47",
        cy: "24.11",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.34",
        cy: "20.63",
        rx: ".47",
        ry: ".43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.34",
        cy: "15.42",
        rx: ".47",
        ry: ".43"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.12 37.19c-2.48 2.49-4.95 4.98-7.43 7.47 0 0 3.32 4.34 4.27 3.39l8.35-8.35s-.6-1.49-1.74-2.22c-1.22-.77-3-.75-3.44-.3ZM43.56 36.95c-2.61 2.62-5.21 5.24-7.82 7.87 0 0 .12 3.36 1.63 3.12.56.93 1.87 1.44 2.87.45l8.79-8.79c1.68-1.68-4.56-3.56-5.46-2.65ZM77.97 42.3c-1.07-.16-2.07.6-2.22 1.68l-1.12 7.85c-.15 1.08.59 2.08 1.66 2.24 1.07.16 2.07-.6 2.22-1.68l1.12-7.85c.15-1.08-.59-2.08-1.66-2.24ZM25.06 42.58c-1.06.19-1.77 1.23-1.58 2.3l1.32 7.34c.19 1.07 1.22 1.79 2.28 1.59 1.06-.19 1.77-1.23 1.58-2.3l-1.32-7.34c-.19-1.07-1.22-1.79-2.28-1.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.56 41.6c0 4.66-3.54 7.48-7.9 7.48s-6.85-1.67-6.85-6.33c0-4.26.85-6.76 6.47-6.76 4.26 0 8.29.27 8.29 5.6ZM54.15 41.6c0 4.66 3.54 7.48 7.9 7.48s6.85-1.67 6.85-6.33c0-4.26-.85-6.76-6.47-6.76-4.26 0-8.29.27-8.29 5.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.56 41.6c0-1.35 1.03-1.84 2.29-1.84s2.29.48 2.29 1.84M28.41 36.62l6.4 4.26M75.3 36.72l-6.39 4.26M27.41 54.17C28.46 64 39.53 81.6 51.44 81.6s19.52-8.49 24.77-27.42M78.3 42l-.35-.05c-1.07-.14-2.06.59-2.21 1.61l-1.2 8.49c-.15 1.03.61 1.98 1.68 2.12l.35.05c1.07.14 2.06-.59 2.21-1.61l1.2-8.49c.15-1.03-.61-1.98-1.68-2.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.58 41.96-.35.05c-1.07.15-1.82 1.11-1.66 2.14l1.27 8.48c.15 1.03 1.15 1.74 2.22 1.6l.35-.05c1.07-.15 1.82-1.11 1.66-2.14l-1.27-8.48c-.15-1.03-1.15-1.74-2.22-1.6Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.21 41.6c0 4.67 3.3 6.03 3.3 8.71s-3.11 2.8-3.11 2.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.18 40.64C75.18 58.1 64.8 72.25 52 72.25S28.82 58.1 28.82 40.64"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AndrogynousPersonOne104 = (AndrogynousPersonOne104);
;// ./src/Picto/GeneratedPictoComponents/AndrogynousPersonOne56.tsx


var AndrogynousPersonOne56_excluded = ["className"];
function AndrogynousPersonOne56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AndrogynousPersonOne56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AndrogynousPersonOne56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AndrogynousPersonOne56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AndrogynousPersonOne56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AndrogynousPersonOne56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AndrogynousPersonOne56_objectSpread(AndrogynousPersonOne56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.63 16.38c-1.3-5.6-5.42-10.78-11.89-11.57C22.27 3.9 17.45 9.97 14.5 15.5c-.91 1.71-1.08 4.47 1.64 4.73 1.21.12 2.15-.52 3.01-1.2 1.56-1.24 2.96-2.46 4.91-3.15 4.16-1.48 8.37.09 11.89 2.2 2.13 1.27 4.84 2.34 6.53-.13 0 0-.12-1.46-.85-1.57Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.17 23.69c-.68-.17-1.37-.14-2 .12-2.07.86-2.78 3.9-1.58 6.79 1.05 2.53 3.2 4.11 5.11 3.89M42.46 34.5c1.91.27 4.1-1.33 5.17-3.9 1.2-2.89.51-5.92-1.53-6.77-.71-.29-1.49-.29-2.25-.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.38 21.86c.21 1.38.32 2.82.32 4.28 0 11.74-6.98 21.26-15.59 21.26s-15.59-9.52-15.59-21.26c0-1.46.11-2.89.32-4.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.69 39.89c1.68.96 3.48.09 4.25-.64M12.84 21.86C14.35 12.1 20.6 4.78 28.1 4.78s13.75 7.32 15.26 17.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.7 23.06-5.51 5.54s2.46 3.22 3.16 2.52l6.19-6.19s-.44-1.11-1.29-1.64c-.9-.57-2.22-.56-2.55-.23ZM21.82 22.94l-5.54 5.57s.09 2.38 1.15 2.21c.4.66 1.33 1.02 2.03.32l6.22-6.22c1.19-1.19-3.22-2.52-3.86-1.88ZM45.93 27.1c-.76-.11-1.46.42-1.57 1.19l-.79 5.55a1.388 1.388 0 1 0 2.75.39l.79-5.55c.11-.76-.42-1.47-1.18-1.58ZM10.45 27.25c-.75.14-1.25.87-1.12 1.63l.93 5.19c.14.76.86 1.26 1.61 1.13.75-.14 1.25-.87 1.12-1.63l-.93-5.19c-.14-.76-.86-1.26-1.61-1.13Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.69 26.28c0 11.73-6.97 21.24-15.58 21.24s-15.58-9.51-15.58-21.24",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.38 26.41c0 3.16-2.4 5.08-5.37 5.08s-4.66-1.14-4.66-4.3c0-2.9.58-4.59 4.39-4.59 2.9 0 5.63.19 5.63 3.81ZM29.49 26.41c0 3.16 2.4 5.08 5.37 5.08s4.66-1.14 4.66-4.3c0-2.9-.58-4.59-4.39-4.59-2.9 0-5.63.19-5.63 3.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.38 26.41c0-.92.7-1.25 1.56-1.25s1.56.33 1.56 1.25M12.01 23.02l4.34 2.89M43.86 23.09l-4.34 2.89M11.89 35.3c.27 5.78 6.73 16.78 15.98 16.78 8.17 0 13.57-5.19 16.48-16.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.74 27.21-.23-.03c-.71-.09-1.37.39-1.47 1.07l-.8 5.65c-.1.68.41 1.32 1.12 1.41l.23.03c.71.09 1.37-.39 1.47-1.07l.8-5.65c.1-.68-.41-1.32-1.12-1.41ZM10.67 27.18l-.23.03c-.71.1-1.21.74-1.11 1.42l.85 5.64c.1.68.77 1.16 1.48 1.06l.23-.03c.71-.1 1.21-.74 1.11-1.42l-.85-5.64c-.1-.68-.77-1.16-1.48-1.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.53 26.18c0 3.07 2.17 3.97 2.17 5.73s-2.05 1.84-2.05 1.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.68 26.29c0 11.73-6.97 21.24-15.58 21.24s-15.58-9.51-15.58-21.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.16",
        cy: "7.48",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.84",
        cy: "8.7",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.18",
        cy: "6.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.2",
        cy: "7.48",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.56",
        cy: "6.86",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "25.22",
        cy: "9.32",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.24",
        cy: "8.7",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.12",
        cy: "8.88",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.92",
        cy: "10.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.28",
        cy: "10.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.94",
        cy: "12.39",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "22.58",
        cy: "12.39",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.9",
        cy: "11.16",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.54",
        cy: "10.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.82",
        cy: "9.32",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.8",
        cy: "8.09",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.8",
        cy: "10.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.5",
        cy: "10.55",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.18",
        cy: "11.77",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "29.84",
        cy: "14.23",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.43",
        cy: "14.68",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31.16",
        cy: "13",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.14",
        cy: "12.39",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "33.14",
        cy: "14.84",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.12",
        cy: "14.23",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.45",
        cy: "13",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.77",
        cy: "14.84",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.41",
        cy: "16.07",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.62",
        cy: "16.69",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.41",
        cy: "17.92",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.75",
        cy: "14.84",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "38.43",
        cy: "13",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.11",
        cy: "11.16",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.79",
        cy: "9.93",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.01",
        cy: "13",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "24.8",
        cy: "12.79",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "23.24",
        cy: "14.84",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "21.26",
        cy: "14.23",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.62",
        cy: "14.23",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.28",
        cy: "16.07",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.29",
        cy: "17.73",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "15.98",
        cy: "18.35",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "16.64",
        cy: "15.46",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "17.96",
        cy: "13",
        rx: ".33",
        ry: ".31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.86",
        cy: "9.32",
        rx: ".33",
        ry: ".31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AndrogynousPersonOne56 = (AndrogynousPersonOne56);
;// ./src/Picto/GeneratedPictoComponents/AndrogynousPersonTwo104.tsx


var AndrogynousPersonTwo104_excluded = ["className"];
function AndrogynousPersonTwo104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AndrogynousPersonTwo104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AndrogynousPersonTwo104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AndrogynousPersonTwo104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AndrogynousPersonTwo104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AndrogynousPersonTwo104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AndrogynousPersonTwo104_objectSpread(AndrogynousPersonTwo104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.24 87.39c-.65.61-.13 1.37.59.92 3.79-2.36 10.19 1.95 13.42-2.66.46.2-.05-1.74-.2-2.23-.27-.87-.34-3.97-2.22-4.39-2.1-1.31-8.74 5.21-11.58 8.36Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.16 94.46-3.49-5.03 5.24-5.02 5.25 5.02-3.5 5.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77.6 87.48c.63.62.06 1.41-.66.95-3.77-2.41-10.61 2.04-13.67-2.69-.48.2.15-1.79.34-2.3.33-.9.58-4.09 2.53-4.53 2.23-1.36 8.7 5.33 11.45 8.56Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.56 24.45c-.16-1.54-1.79-3.02-2.69-4.25-1.42-1.94-2.83-3.89-4.25-5.83-.41-.57-1.23-1-1.99-.75-7.42 2.41-10.87 6.4-14.04 12.54-.15.29-1.42 3.18-.82 4.12-.37.46-.15 1.36.18 2.02 1.2 2.41 3.57 1.97 5.51.53 1.69-1.25 2.98-2.67 4.94-3.61 2.46-1.17 4.9-1.43 7.61-1.57 2.23-.12 5.86-.26 5.55-3.19Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53.73 94.13 3.5-5.02-5.24-5.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.99 84.08-5.25 5.03 3.5 5.02M38.72 74.94c1.68-2.56 3.12-5.66 3.45-9.03M61.77 65.53c.26 3.67 1.87 7.04 3.71 9.75M60.87 96.13c0-10.89 6.1-18.82 6.1-18.82M43.1 96.13c0-10.89-6.1-18.82-6.1-18.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.49 75.28 13.5 8.62-8.93 8.56M65.48 75.28 51.99 83.9l8.93 8.56M30.61 37.41a4.76 4.76 0 0 0-2.42.29c-2.98 1.24-4.07 5.46-2.42 9.44 1.65 3.98 4.84 4.85 8.21 4.85M70.28 52c3.15.35 6.17-.87 7.82-4.85s.57-8.21-2.42-9.44c-.74-.31-1.53-.4-2.32-.31M50.2 59.93c2.31 1.31 4.78.12 5.85-.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.11 31.26c.47 2.98.45 6.31-.21 9.96-2.88 16.32-12.24 29.06-20.92 29.04-8.68.02-18.04-12.73-20.92-29.04-3.5-19.51 11.14-29.47 20.92-29.45M65.48 75.28c.2.29.4.57.6.85 2.05 2.81 4.59 5.23 7.41 7.27L89.6 95.02M38.49 75.28c-.2.29-.4.57-.6.85-2.05 2.81-4.59 5.23-7.41 7.27L14.37 95.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.89 41.14c0 4.26-3.24 6.84-7.23 6.84s-6.27-1.53-6.27-5.79c0-3.9.78-6.18 5.92-6.18 3.9 0 7.58.25 7.58 5.13ZM54.09 41.14c0 4.26 3.24 6.84 7.23 6.84s6.27-1.53 6.27-5.79c0-3.9-.78-6.18-5.92-6.18-3.9 0-7.58.25-7.58 5.13ZM49.89 41.14c0-1.24.94-1.68 2.1-1.68s2.1.44 2.1 1.68M30.54 36.29l5.85 3.9M73.43 36.29l-5.85 3.9"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m44.72 9.23 15.51 21.64h3.08l-2.07-5.85 7.17 5.85h4.86S68.53 2.2 44.72 9.23Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.2 41.36c0 4.39 3.1 5.67 3.1 8.19s-2.92 2.63-2.92 2.63M44.4 9.97l15.51 20.72h3.08l-2.55-6.88 7.65 6.88h9.35s-1.75-22.4-23.92-22.4c-3.57 0-6.62.54-9.23 1.46"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.14",
        cy: "42",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.83",
        cy: "42",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "48.32",
        cy: "25.67",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "50.76",
        cy: "23.23",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.34",
        cy: "22.26",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.83",
        cy: "18.36",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.91",
        cy: "16.9",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.75",
        cy: "18.36",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.23",
        cy: "20.8",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.92",
        cy: "23.09",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.67",
        cy: "26.97",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.71",
        cy: "24.49",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.6",
        cy: "29.08",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.87",
        cy: "31.52",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.35",
        cy: "28.11",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.06",
        cy: "26.16",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.92",
        cy: "24.38",
        r: ".49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.57",
        cy: "20.8",
        r: ".49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AndrogynousPersonTwo104 = (AndrogynousPersonTwo104);
;// ./src/Picto/GeneratedPictoComponents/AndrogynousPersonTwo56.tsx


var AndrogynousPersonTwo56_excluded = ["className"];
function AndrogynousPersonTwo56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AndrogynousPersonTwo56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AndrogynousPersonTwo56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AndrogynousPersonTwo56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AndrogynousPersonTwo56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AndrogynousPersonTwo56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AndrogynousPersonTwo56_objectSpread(AndrogynousPersonTwo56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.57 17.89c-.14-1.27-1.52-2.49-2.28-3.51-1.2-1.6-2.4-3.21-3.6-4.81-.35-.47-1.04-.82-1.69-.62-6.29 1.99-9.21 5.28-11.9 10.35-.13.24-1.2 2.63-.7 3.4-.31.38-.12 1.13.15 1.66 1.02 1.99 3.03 1.62 4.67.44 1.43-1.03 2.52-2.21 4.19-2.98 2.08-.97 4.15-1.18 6.45-1.3 1.89-.1 4.97-.22 4.7-2.64Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.19 27.28c-.6-.08-1.2-.02-1.76.21-2.18.9-2.97 3.99-1.76 6.89 1.2 2.9 3.53 3.54 5.99 3.54M41.13 37.92c2.3.26 4.5-.63 5.7-3.54 1.2-2.9.41-5.99-1.76-6.89-.54-.22-1.11-.29-1.69-.22M26.48 43.7c1.69.96 3.49.09 4.27-.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.19 22.79c.34 2.18.33 4.6-.15 7.27-2.1 11.9-8.93 21.2-15.26 21.18-6.33.01-13.16-9.28-15.26-21.18C9.97 15.83 20.64 8.57 27.78 8.58"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.75",
        cy: "31.09",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.02",
        cy: "31.09",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.04",
        cy: "19.14",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.03",
        cy: "17.15",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.24",
        cy: "16.35",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.64",
        cy: "13.16",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.25",
        cy: "11.96",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.67",
        cy: "13.16",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.69",
        cy: "15.15",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "19.99",
        cy: "17.03",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.42",
        cy: "20.21",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.09",
        cy: "18.18",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.27",
        cy: "21.93",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.22",
        cy: "23.92",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.61",
        cy: "21.13",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.46",
        cy: "19.54",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.9",
        cy: "18.08",
        r: ".4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.06",
        cy: "15.15",
        r: ".4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.29 30.52c0 3.05-2.37 4.89-5.29 4.89s-4.58-1.09-4.58-4.14c0-2.79.57-4.42 4.33-4.42 2.85 0 5.54.18 5.54 3.66ZM29.36 30.52c0 3.05 2.37 4.89 5.29 4.89s4.58-1.09 4.58-4.14c0-2.79-.57-4.42-4.33-4.42-2.85 0-5.54.18-5.54 3.66Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.29 30.52c0-.88.69-1.2 1.54-1.2s1.54.32 1.54 1.2M12.14 27.05l4.28 2.79M43.51 27.05l-4.28 2.79"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m22.9 6.71 11.15 15.56h2.21l-1.49-4.2 5.16 4.2h3.49S40.02 1.65 22.9 6.71Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.37 30.3c0 3.45 2.38 4.46 2.38 6.44s-2.24 2.07-2.24 2.07M22.97 7.04l10.8 15.34h2.15l-1.77-5.09 5.32 5.09h6.51S44.76 5.8 29.32 5.8c-2.49 0-4.61.4-6.43 1.08"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AndrogynousPersonTwo56 = (AndrogynousPersonTwo56);
;// ./src/Picto/GeneratedPictoComponents/Baby104.tsx


var Baby104_excluded = ["className"];
function Baby104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Baby104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Baby104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Baby104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Baby104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Baby104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Baby104_objectSpread(Baby104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.37 54.74c-2.25-.31-3.05 1.75-5.37 1.79-2.32-.04-3.12-2.1-5.37-1.79-2.41.33-4.99 3.04-3.31 7.68.79 2.17 3.78 4.64 8.68 4.73 4.89-.08 7.89-2.56 8.67-4.73 1.68-4.64-.89-7.35-3.3-7.68ZM52 63.75c-1.28 0-2.32-1.04-2.32-2.32s1.04-2.32 2.32-2.32 2.32 1.04 2.32 2.32-1.04 2.32-2.32 2.32Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.78 77.72c.06 1.22 1.09 1.73 2.44 1.31.02 0-.02 0 0 0 5.31-.48 9.82.79 15.02 6.02a10.87 10.87 0 0 0 3.77 2.47c2.68 1.05 3.65-2.21 1.25-3.79l-.7-.36c-.31-.21 0 0-.19-.33l-1.21-.9c-.14-.25-1.62-1.34-1.66-1.62l-.76-.68c-.13-.76-1.01-1.06-1.7-1.4l-1.56-1.16c-.26-.13-1.63-1.25-1.93-1.27l-3.24-1.99c-.43-.04-1.89-1.3-2.28-1.12l-2.46-.43c-.37.18-1.35-.9-1.59-.57l-2.76 3.79c-.33.46-.5 1.01-.47 1.57l.02.47ZM82.73 88.27c-1.39 2.2-2.68-.17-3.6-1.66-.01-.02.01.01 0 0-4.47-4.66-9.44-6.92-17.83-5.72-1.88.27-3.61.05-5.15-.46-3.16-1.04-2.26-6.39 1.03-6.11.43.04.86-.04 1.26-.22l5.89-2.74c.3-.14.58-.34.81-.58l3.76-3.9c.65-.67 1.55-.95 2.41-.76l1.68.38c.33.08.65.22.93.42l5.67 4.89c-.91.8.92 1.07 1.15 1.57l1.98 4.61c.21.47.43 1.04.42 1.57l.13 5.23c-.02.72.53 1.66.11 2.21l-.66 1.27Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.91 57.85c2.84.05 5.86-2.19 7.34-5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.38 42.06c-1.34-.51-2.75-.56-4.02-.04-3.25 1.33-4.43 5.86-2.64 10.13 1.43 3.4 4.32 5.61 7.08 5.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.25 52.15c1.8-4.27.62-8.81-2.64-10.13-1.28-.52-2.68-.47-4.02.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 74.94c-12.91 0-23.38-11.73-23.38-26.2s10.46-26.2 23.38-26.2 23.38 11.73 23.38 26.2-10.47 26.2-23.38 26.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 22.55s-7.18-1.93-5.62-7.54c1.56-5.61 8.58-3.4 6.68 1.09-1.9 4.5-16.06 1.86-8.52-9.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.08 46.4c-.8 1.57-2.47 2.48-4.17 2.31-1.53-.15-2.86-1.16-3.46-2.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.52 46.4c-.8 1.57-2.47 2.48-4.17 2.31-1.53-.15-2.86-1.16-3.46-2.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.15 79.57s1 5.36-1.08 15.46M18.62 80.54S17.52 85.93 19.7 96M81.34 74.91c-13.19-.38-32.5 6.24-43.1 20.1M23.26 72.67c9.3 1.92 15.71 7.4 20.44 13.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.36 65.71c8.32 3.13 11.66 8.09 12.79 13.86M33.64 66.08c-9.98 3.05-13.81 8.35-15.03 14.62"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.32 60.75c1.89.88 3.2 2.79 3.2 5.01 0 3.05-2.47 5.52-5.52 5.52s-5.53-2.47-5.53-5.52c0-2.22 1.31-4.14 3.2-5.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 67.15c4.89-.08 7.89-2.56 8.67-4.73 1.68-4.64-.89-7.35-3.3-7.68-2.25-.31-3.05 1.75-5.37 1.79-2.32-.04-3.12-2.1-5.37-1.79-2.41.33-4.99 3.04-3.31 7.68.79 2.17 3.78 4.64 8.68 4.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.32 61.43c0 1.28-1.04 2.32-2.32 2.32s-2.32-1.04-2.32-2.32 1.04-2.32 2.32-2.32 2.32 1.04 2.32 2.32Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.02",
        cy: "58.68",
        r: "1.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.1",
        cy: "58.68",
        r: "1.31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Baby104 = (Baby104);
;// ./src/Picto/GeneratedPictoComponents/Baby56.tsx


var Baby56_excluded = ["className"];
function Baby56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Baby56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Baby56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Baby56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Baby56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Baby56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Baby56_objectSpread(Baby56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.89 29.47c-1.21-.17-1.64.94-2.89.96-1.25-.02-1.68-1.13-2.89-.96-1.3.18-2.69 1.63-1.78 4.13.42 1.17 2.04 2.5 4.67 2.55 2.64-.05 4.25-1.38 4.67-2.55.91-2.5-.48-3.96-1.78-4.13ZM28 34.32a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.65 41.84c.03.65.59.93 1.31.7 2.86-.26 5.29.42 8.09 3.24.63.63 1.33 1.05 2.03 1.33 1.44.57 1.97-1.19.68-2.04l-.38-.2c-.17-.11 0 0-.1-.18l-.65-.49c-.08-.13-.87-.72-.9-.87l-.41-.37c-.07-.41-.54-.57-.91-.75l-.84-.62c-.14-.07-.88-.67-1.04-.69l-1.74-1.07c-.23-.02-1.02-.7-1.23-.6L13.23 39c-.2.09-.72-.49-.85-.31l-1.48 2.04c-.18.25-.27.54-.25.84v.25ZM44.55 47.52c-.75 1.18-1.44-.09-1.94-.89-2.41-2.51-5.08-3.73-9.6-3.08-1.01.14-1.94.02-2.77-.25-1.7-.56-1.21-3.44.55-3.29.23.02.46-.02.68-.12l3.17-1.47c.16-.08.31-.18.44-.31l2.03-2.1c.35-.36.83-.51 1.3-.41l.9.21c.18.04.35.12.5.23l3.06 2.63c-.49.43.5.58.62.84l1.07 2.48c.11.25.23.56.23.84l.07 2.81c-.01.39.28.89.06 1.19l-.35.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.8 31.14c1.53.03 3.16-1.18 3.95-3.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.82 22.64c-.72-.27-1.48-.3-2.17-.02-1.75.72-2.39 3.16-1.42 5.46.77 1.83 2.33 3.02 3.81 3.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.75 28.07c.97-2.3.33-4.74-1.42-5.46-.69-.28-1.44-.25-2.17.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 40.34c-6.95 0-12.59-6.32-12.59-14.11s5.63-14.11 12.59-14.11 12.59 6.32 12.59 14.11-5.64 14.11-12.59 14.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 12.13s-3.87-1.04-3.03-4.06c.84-3.02 4.62-1.83 3.6.59-1.03 2.42-8.65 1-4.59-4.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.81 24.97c-.43.84-1.33 1.34-2.24 1.25-.82-.08-1.54-.62-1.86-1.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.28 24.97c-.43.84-1.33 1.34-2.24 1.25-.82-.08-1.54-.62-1.86-1.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.77 42.83s.54 2.89-.58 8.33M10.03 43.36s-.59 2.9.58 8.33M43.8 40.33c-7.1-.2-17.5 3.36-23.21 10.82M12.52 39.12c5.01 1.04 8.46 3.99 11.01 7.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.88 35.37c4.48 1.68 6.28 4.35 6.89 7.46M18.12 35.57c-5.37 1.64-7.43 4.5-8.09 7.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.25 32.7a2.97 2.97 0 0 1-1.24 5.67c-1.64 0-2.98-1.33-2.98-2.97 0-1.2.71-2.23 1.73-2.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 36.15c2.64-.05 4.25-1.38 4.67-2.55.91-2.5-.48-3.96-1.78-4.13-1.21-.17-1.64.94-2.89.96-1.25-.02-1.68-1.13-2.89-.96-1.3.18-2.69 1.63-1.78 4.13.42 1.17 2.04 2.5 4.67 2.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.25 33.07a1.25 1.25 0 1 1-2.5 0 1.25 1.25 0 0 1 2.5 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.78",
        cy: "31.59",
        r: ".7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.29",
        cy: "31.59",
        r: ".7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Baby56 = (Baby56);
;// ./src/Picto/GeneratedPictoComponents/BaldMale104.tsx


var BaldMale104_excluded = ["className"];
function BaldMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaldMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaldMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaldMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaldMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaldMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BaldMale104_objectSpread(BaldMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.62 28.02c-1.97-9.24-8.19-17.78-17.99-19.08-11.3-1.5-18.58 8.51-23.05 17.63-1.38 2.82-1.63 7.37 2.49 7.8 1.83.19 3.25-.85 4.55-1.98 2.35-2.04 4.47-4.05 7.42-5.19 6.3-2.44 12.65.15 17.99 3.62 3.22 2.09 7.31 3.86 9.88-.22 0 0-.18-2.41-1.29-2.59ZM22.67 91s.13 1.64 1.33 1c1.2-.64 8.75-5.84 12.99-1.6 4.23 4.25 12.49 4.05 14 .6.81-1.87-16.46-10.16-16.46-10.16L22.67 91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.74 81.08c3.53-2.7 6.44-3.67 6.44-11.32M61.9 69.5c0 7.7 2.6 9.48 6.31 11.58M28.48 36.34c-1.09-.28-2.2-.24-3.22.18-3.17 1.31-4.32 5.8-2.57 10.03 1.3 3.14 3.83 5.25 6.35 5.59M73.3 52.15c2.54-.31 5.11-2.43 6.43-5.6 1.75-4.23.6-8.72-2.57-10.03-1.07-.44-2.23-.47-3.36-.15M38.78 37.37c2.29-2.07 6-2.07 8.28 0M55.35 37.37c2.29-2.07 6-2.07 8.28 0M51.04 42.1c0 4.67 3.05 4.88 3.05 7.56s-3.11 2.79-3.11 2.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.99 40.03c0 17.16-1.72 31.07-22.78 31.07S28.43 57.19 28.43 40.03 38.63 8.96 51.21 8.96s22.78 13.91 22.78 31.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.13 60.13c2.46 1.4 5.08.13 6.21-.94M17 95.04S22.99 89 34.74 81.08l16.27 9.06 17.2-9.06S79.25 87.64 86 95.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.68",
        cy: "11.51",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "55.7",
        cy: "13.53",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.69",
        cy: "15.54",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "49.65",
        cy: "13.53",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.62",
        cy: "12.52",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.63",
        cy: "16.55",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.61",
        cy: "15.54",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.37",
        cy: "15.84",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.59",
        cy: "18.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.56",
        cy: "18.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.57",
        cy: "21.59",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.6",
        cy: "21.59",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.61",
        cy: "19.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "48.65",
        cy: "18.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "56.71",
        cy: "16.55",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.73",
        cy: "14.53",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "62.5",
        cy: "17.5",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "61.75",
        cy: "20.58",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.73",
        cy: "18.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "54.69",
        cy: "18.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.68",
        cy: "20.58",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.69",
        cy: "24.61",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "55.7",
        cy: "22.6",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.73",
        cy: "21.59",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.73",
        cy: "25.62",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "61.75",
        cy: "24.61",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.77",
        cy: "22.6",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "65.78",
        cy: "25.62",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.71",
        cy: "27.64",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "67.09",
        cy: "28.65",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "69.81",
        cy: "30.66",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "68.81",
        cy: "25.62",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "66.79",
        cy: "22.6",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "64.77",
        cy: "19.57",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "49.36",
        cy: "22.6",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.98",
        cy: "22.24",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.61",
        cy: "25.62",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.58",
        cy: "24.61",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.55",
        cy: "24.61",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.56",
        cy: "27.64",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.04",
        cy: "30.36",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.52",
        cy: "31.37",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.53",
        cy: "26.63",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.54",
        cy: "22.6",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "50.66",
        cy: "16.55",
        r: ".5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.89 41.66c0 .81-.9.45-2.01.45s-2.01.36-2.01-.45.9-1.47 2.01-1.47 2.01.66 2.01 1.47ZM60.94 41.66c0 .81-.9.53-2.01.53s-2.01.28-2.01-.53.9-1.47 2.01-1.47 2.01.66 2.01 1.47Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m48.52 65.6 3.63 10.92 3.3-11.04-6.93.12z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m48.52 65.6 3.63 10.92 3.3-11.04-6.93.12z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BaldMale104 = (BaldMale104);
;// ./src/Picto/GeneratedPictoComponents/BaldMale56.tsx


var BaldMale56_excluded = ["className"];
function BaldMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BaldMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BaldMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BaldMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BaldMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BaldMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BaldMale56_objectSpread(BaldMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.36 18.54c-1.39-6.37-5.79-12.26-12.71-13.16-7.98-1.04-13.13 5.87-16.28 12.16-.98 1.95-1.15 5.08 1.76 5.38 1.29.13 2.29-.59 3.21-1.36 1.66-1.4 3.16-2.79 5.24-3.58 4.45-1.68 8.94.1 12.71 2.5 2.27 1.44 5.17 2.66 6.98-.15 0 0-.13-1.66-.91-1.79Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.24 23.98c-.76-.2-1.53-.17-2.24.13-2.2.91-3 4.03-1.78 6.96.9 2.18 2.66 3.64 4.4 3.88M43.32 34.95c1.76-.21 3.55-1.69 4.46-3.88 1.21-2.93.42-6.05-1.78-6.96-.74-.31-1.54-.32-2.33-.1M19.38 24.7c1.59-1.44 4.16-1.44 5.75 0M30.87 24.7c1.59-1.44 4.16-1.44 5.75 0M27.89 27.98c0 3.24 2.11 3.39 2.11 5.24s-2.15 1.94-2.15 1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.8 26.54c0 11.9-1.19 21.54-15.8 21.54s-15.8-9.65-15.8-21.54S19.28 5 28 5s15.8 9.65 15.8 21.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.56 40.48c1.71.97 3.52.09 4.31-.65"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m25.88 44.49 2.25 6.77 2.05-6.84-4.3.07z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m25.6 44.27 2.56 7.72 2.34-7.8-4.9.08z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.07",
        cy: "6.84",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.22",
        cy: "8.27",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.79",
        cy: "9.7",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.93",
        cy: "8.27",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.06",
        cy: "7.55",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.78",
        cy: "10.42",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.63",
        cy: "9.7",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.33",
        cy: "9.91",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.2",
        cy: "11.85",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.33",
        cy: "11.85",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "19.05",
        cy: "14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.91",
        cy: "14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.35",
        cy: "12.56",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.21",
        cy: "11.85",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.94",
        cy: "10.42",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.09",
        cy: "8.98",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.05",
        cy: "11.09",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.52",
        cy: "13.28",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.09",
        cy: "11.85",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "30.51",
        cy: "11.85",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.07",
        cy: "13.28",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.79",
        cy: "16.14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.22",
        cy: "14.71",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.37",
        cy: "14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.37",
        cy: "16.86",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.52",
        cy: "16.14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.95",
        cy: "14.71",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.38",
        cy: "16.86",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.91",
        cy: "18.29",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.31",
        cy: "19.01",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.25",
        cy: "20.44",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.53",
        cy: "16.86",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.1",
        cy: "14.71",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.67",
        cy: "12.56",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.72",
        cy: "14.71",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.32",
        cy: "14.46",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.63",
        cy: "16.86",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.48",
        cy: "16.14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.62",
        cy: "16.14",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.33",
        cy: "18.29",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.26",
        cy: "20.23",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.75",
        cy: "20.95",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.47",
        cy: "17.58",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.9",
        cy: "14.71",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.64",
        cy: "10.42",
        r: ".36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.57 27.52c0 .58-.64.32-1.43.32s-1.43.26-1.43-.32.64-1.05 1.43-1.05 1.43.47 1.43 1.05ZM34.97 27.52c0 .58-.64.38-1.43.38s-1.43.2-1.43-.38.64-1.05 1.43-1.05 1.43.47 1.43 1.05Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BaldMale56 = (BaldMale56);
;// ./src/Picto/GeneratedPictoComponents/Cat104.tsx


var Cat104_excluded = ["className"];
function Cat104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cat104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cat104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cat104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cat104_objectSpread(Cat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.8 87.02c1.17.94 6.93 3.48 11.01-1.75.01-.02-.02.01 0 0 4.81-4.65 10.42-7.24 20.32-7.16 2.22.02 4.22-.38 5.98-1.02 3.6-1.29 2.07-5.93-1.74-5.29-.5.08-1.01.07-1.49-.05l-.63.56c-.36-.09-.71.3-1.01.11l-4.17.26c-.82-.52-5.04-.46-6.03-.18l-2.94-.34c-.38.11-2.91-.79-3.22-.58l-4.99-1.61c-.46.31-2.92 3.13-3.13 3.6l-3.07 1.84c-.21.44-2.46 3.12-2.39 3.58l-1.43 3.57c.09.64-.56 1.35-.02 1.78l-1.05 2.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.3 14.09h5.09c.16 0 .27.15.24.3l-2.55 11.26c-.06.26-.42.26-.49 0l-2.55-11.26c-.04-.15.09-.3.24-.3h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.7 14.48 4.75.83c.3.05.47.36.35.64l-3.95 9.5c-.19.46-.88.34-.9-.16l-.54-10.56c0-.16.14-.29.29-.25ZM45.99 14.48l-4.81.84c-.26.05-.42.33-.32.57l4.06 9.76c.17.41.78.31.8-.14l.55-10.78c0-.16-.14-.29-.29-.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.2 25.24c-.39.3-.95.07-1.04-.4-.4-2.3-1.17-7.73.12-9.14.72-.77 4.93 2.93 6.47 4.34.3.27.27.74-.05.99l-5.51 4.21Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.49 24.94c.39.3.95.07 1.04-.4.4-2.3 1.17-7.73-.12-9.14-.72-.77-4.93 2.93-6.47 4.34-.3.27-.27.74.05.99l5.51 4.21Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M56.43 41.79c0 1.08-1.73 4.18-4.53 4.27-2.8-.09-4.53-3.19-4.53-4.27-.04-1.12 2.03-2.28 4.53-2.4 2.51.12 4.57 1.28 4.53 2.4Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.64 38.4s-8.66-4.69-17.05 0M24.64 43.46s-6.29-2.98-11.11 3.15M79.07 38.4s8.66-4.69 17.05 0M79.07 43.46s6.29-2.98 11.11 3.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.86 95.43c-1.74-6.98-.99-17.56-10.91-24.03h-.01c-2.1-1.36-1.07-4.42-2.1-6.4-.91-1.8-.1-4.02 1.76-4.81 10.01-4.26 16.75-12.22 16.75-21.36 0-3.63-1.07-7.08-3-10.19.42-3.57 1.57-15.38-1.35-18.94-2.75-3.35-9.81 4.37-12.61 7.69-4.88-2.05-10.54-3.22-16.55-3.22s-11.67 1.17-16.55 3.22c-2.8-3.32-9.86-11.04-12.61-7.69-2.92 3.56-1.77 15.37-1.35 18.94-1.92 3.11-3 6.55-3 10.19 0 9.13 6.74 17.09 16.75 21.36 1.86.79 2.67 3.01 1.76 4.81-.58 2.79 0 5.04-2.1 6.4-9.92 6.47-9.18 17.05-10.91 24.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.85 46.88v3.67c0 3.36-5.8 4.38-8.47 1.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.85 46.88v3.67c0 3.36 5.8 4.38 8.47 1.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.38 41.6c0 1.08-1.73 4.18-4.53 4.27-2.8-.09-4.53-3.19-4.53-4.27-.04-1.12 2.03-2.28 4.53-2.4 2.51.12 4.57 1.28 4.53 2.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "66.06",
        cy: "34",
        r: "2.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.63",
        cy: "34",
        r: "2.63"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.01 72.69c-5.64 0-11.06-.92-16.12-2.73l1.18-6.1c4.29 1.53 10.11 1.76 14.93 1.76s10.54-.78 14.82-2.32l1.28 6.65c-5.05 1.81-10.47 2.73-16.12 2.73H52Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.9 72.64c-5.64 0-11.06-.92-16.12-2.73l1.18-6.1c4.29 1.53 10.11 1.76 14.93 1.76s10.54-.78 14.82-2.32l1.28 6.65c-5.05 1.81-10.47 2.73-16.12 2.73h.02Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cat104 = (Cat104);
;// ./src/Picto/GeneratedPictoComponents/Cat56.tsx


var Cat56_excluded = ["className"];
function Cat56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cat56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cat56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cat56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cat56_objectSpread(Cat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.51 14.54h2.67c.08 0 .14.08.12.16l-1.33 5.89c-.03.14-.22.14-.25 0l-1.33-5.89c-.02-.08.05-.16.12-.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.91 14.74 2.48.43c.15.03.24.19.18.33l-2.07 4.97c-.1.24-.46.18-.47-.08l-.28-5.52c0-.08.07-.15.15-.13ZM24.78 14.74l-2.52.44c-.14.02-.22.17-.17.3l2.12 5.11c.09.22.41.16.42-.07l.29-5.64c0-.08-.07-.15-.15-.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.42 20.37c-.2.16-.5.04-.54-.21-.21-1.2-.61-4.04.07-4.78.38-.4 2.58 1.54 3.38 2.27.16.14.14.39-.03.52l-2.88 2.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.26 20.22c.2.16.5.04.54-.21.21-1.2.61-4.04-.07-4.78-.38-.4-2.58 1.54-3.38 2.27-.16.14-.14.39.03.52l2.88 2.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.24 29.04c0 .57-.91 2.19-2.37 2.24-1.47-.05-2.37-1.67-2.37-2.24-.02-.59 1.06-1.19 2.37-1.25 1.32.06 2.39.67 2.37 1.25Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.25 27.48s-4.65-2.52-9.15 0M13.25 30.19s-3.38-1.6-5.96 1.69M42.45 27.48s4.65-2.52 9.15 0M42.45 30.19s3.38-1.6 5.96 1.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.89 41.75c-.34-1.04-.05-2.16.94-2.58 5.37-2.28 8.99-6.56 8.99-11.46 0-1.95-.58-3.8-1.61-5.46.23-1.92.84-8.25-.72-10.16-1.47-1.79-5.26 2.34-6.76 4.13-2.62-1.1-5.65-1.73-8.88-1.73s-6.26.63-8.88 1.73c-1.5-1.78-5.29-5.92-6.76-4.13-1.57 1.91-.95 8.24-.72 10.16-1.03 1.67-1.61 3.52-1.61 5.46 0 4.9 3.62 9.17 8.99 11.46 1 .42 1.12 1.45.94 2.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.85 32.03V34c0 1.8-3.11 2.35-4.54.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.85 32.03V34c0 1.8 3.11 2.35 4.54.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.28 29.2c0 .58-.93 2.24-2.43 2.29-1.5-.05-2.43-1.71-2.43-2.29-.02-.6 1.09-1.22 2.43-1.29 1.35.06 2.45.69 2.43 1.29Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.71 46.45c-3.09 0-6.06-.5-8.83-1.49l.64-3.34c2.35.84 5.54.97 8.18.97s5.77-.43 8.12-1.27l.7 3.64c-2.76.99-5.74 1.49-8.83 1.49h.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.85 46.56c-3.05 0-5.97-.5-8.7-1.47l.63-3.29c2.31.83 5.46.95 8.06.95s5.69-.42 8-1.25l.69 3.59c-2.72.98-5.65 1.47-8.7 1.47h.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.97",
        cy: "25.31",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.76",
        cy: "25.31",
        r: "1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cat56 = (Cat56);
;// ./src/Picto/GeneratedPictoComponents/Child104.tsx


var Child104_excluded = ["className"];
function Child104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Child104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Child104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Child104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Child104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Child104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Child104_objectSpread(Child104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.7 69.91c-3.34 0-3.69 3.16-3.51 4.7.12 1.02.18 2.3.18 3.82 2.86-.45 4.72-1.39 5.57-2.82 1.52-2.55 0-5.7-2.25-5.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.27 69.91c3.34 0 3.69 3.16 3.51 4.7-.12 1.02-.18 2.3-.18 3.82-2.86-.45-4.72-1.39-5.57-2.82-1.52-2.55 0-5.7 2.25-5.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.69 36.36c-2.15.2-3.57 1.46-4.24 3.79-.68 2.32-.48 4.72.6 7.18l-.84 2.84c-.87 2.17-.28 4.25 1.77 6.24-.5 3.25-.5 7.08.88 8.32.92.83 2.37 1.25 4.35 1.25.96-.53 1.65-1.04 2.07-1.53s.91-1.36 1.47-2.61l-3.24-7.52-1.48-15.81v-1.77l-1.35-.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.28 36.36c2.15.2 3.57 1.46 4.24 3.79.68 2.32.48 4.72-.6 7.18l.84 2.84c.87 2.17.28 4.25-1.77 6.24.5 3.25.5 7.08-.88 8.32-.92.83-2.37 1.25-4.35 1.25-1.17-.05-2-.37-2.49-.94-.49-.57-.23-1.43-.43-2.99l3.88-8.53 1.11-13.71-.89-3.06 1.35-.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.19 33.92c-.65 2.96 2.75 1.97 4.68 1.87 2.56-.26 4.95-.94 7.53-1.52 4.17-.94 8.47-2.1 12.07-4.35 2.3-1.44 4.36-2.43 5.98-4.6.32-.43 1.47-4.02 2-5.22.19.93.46 3.89.57 4.28.58 1.89 2.17 3.34 3.36 4.94 2.63 3.53 5.67 5.02 9.8 5.85.77.15 4.91.79 4.91.74-.58-14.52-12.68-26.37-25.96-26.84-18.56-.41-22.09 11.97-24.94 24.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.41 51.34c0 .44-.36.8-.8.8s-.8-.36-.8-.8.36-.8.8-.8.8.36.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.14 51.95c0 .44-.36.8-.8.8s-.8-.36-.8-.8.36-.8.8-.8.8.36.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.69 55.11c0 .44-.36.8-.8.8s-.8-.36-.8-.8.36-.8.8-.8.8.36.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.77 53.51c0 .44-.36.8-.8.8s-.8-.36-.8-.8.36-.8.8-.8.8.36.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.46 51.34c0 .44.36.8.8.8s.8-.36.8-.8-.36-.8-.8-.8-.8.36-.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.72 51.95c0 .44.36.8.8.8s.8-.36.8-.8-.36-.8-.8-.8-.8.36-.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.17 55.11c0 .44.36.8.8.8s.8-.36.8-.8-.36-.8-.8-.8-.8.36-.8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.09 53.51c0 .44.36.8.8.8s.8-.36.8-.8-.36-.8-.8-.8-.8.36-.8.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.7 69.91c-3.34 0-3.69 3.16-3.51 4.7.12 1.02.18 2.3.18 3.82 2.86-.45 4.72-1.39 5.57-2.82 1.52-2.55 0-5.7-2.25-5.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.32 36.34c-1.08.97-1.83 2.53-2.26 4.68-.43 2.15.33 4.2 2.26 6.18-1.81 1.2-2.74 2.8-2.78 4.82-.04 2.02 1.07 3.78 3.32 5.28-2.47 3.58-2 6.57 1.41 8.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.68 61.83c-.09 1.65-1.07 3.13-2.92 4.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.27 69.91c3.34 0 3.69 3.16 3.51 4.7-.12 1.02-.18 2.3-.18 3.82-2.86-.45-4.72-1.39-5.57-2.82-1.52-2.55 0-5.7 2.25-5.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.88 36.64c.92.77 1.6 2.23 2.03 4.37.43 2.15-.33 4.2-2.26 6.18 1.81 1.2 2.74 2.8 2.78 4.82.04 2.02-1.07 3.78-3.32 5.28 2.47 3.58 2 6.57-1.41 8.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.24 63.02c.32 1.32 1.22 2.5 2.72 3.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.3 36.63c.34 2.08.52 4.24.52 6.45 0 16.96-10.47 30.7-23.38 30.7s-23.38-13.74-23.38-30.7c0-2.23.18-4.41.53-6.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.49 46.21c0 4.76 3.13 4.99 3.13 7.72s-3.19 2.85-3.19 2.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.68 41.38c2.35-2.12 6.16-2.12 8.5 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.68 41.38c2.35-2.12 6.16-2.12 8.5 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.26 8.74C26.11 10.17 26.11 36.5 26.11 36.5c3.07 1.08 31.13-3.29 32.16-17.77 0 0 1.05 18.16 21.26 17.77.4 0 1.16.71 1.18.54 1.94-16.47-8.28-27.36-21.01-26.53-1.77-.33-3.67-2.26-11.43-1.76Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.97 64.41c2.52 1.43 5.2.13 6.35-.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.12 83.5c3.72-2.48 4.15-3.64 4.15-11.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.72 83.43C62.81 81.47 61.9 80 61.9 72.36"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.93 46.18c0 1.19-.97 2.15-2.16 2.15s-2.16-.96-2.16-2.15.97-2.15 2.16-2.15 2.16.96 2.16 2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.02 46.18c0 1.19-.97 2.15-2.16 2.15s-2.16-.96-2.16-2.15.97-2.15 2.16-2.15 2.16.96 2.16 2.15"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.75 65.95a.9.9 0 0 0-.28-.08l-5.28-.33c-.09 0-.19 0-.28.04-1.31.46-1.51 1.4-1.51 1.92 0 .89.49 1.56 1.39 1.88.06.02.13.04.2.04l5.17.32h.04c.04 0 .08 0 .12-.01.96-.17 1.55-.76 1.66-1.68.07-.52 0-1.49-1.24-2.11ZM79.07 65.59a.658.658 0 0 0-.28-.04l-5.28.33c-.1 0-.19.03-.28.08-1.24.62-1.31 1.59-1.24 2.11.12.92.71 1.51 1.66 1.68.04 0 .08.01.12.01h.04l5.17-.32c.07 0 .13-.02.2-.04.9-.32 1.39-.99 1.39-1.88 0-.52-.2-1.46-1.51-1.92Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.73 87.64s2.4-1.09 1.21 1.35c-2.04 4.19-11.45 7.41-19.24 4.12-12.03-5.08-1.31-9.1-1.31-9.1s8.5 4.64 13.12 4.89c0 0-.99 1.28 6.22-1.25Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.72 83.43c4.31 2.92 9.29 5.98 13.28 9.47.57.52 1.12 1.08 1.64 1.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 94.56c.51-.59 1.05-1.14 1.61-1.66 3.91-3.46 9.07-6.5 13.29-9.4 0 0 4.43 5.4 12.38 5.4 5.13-.02 8.22-1.88 12.22-5.46"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Child104 = (Child104);
;// ./src/Picto/GeneratedPictoComponents/Child56.tsx


var Child56_excluded = ["className"];
function Child56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Child56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Child56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Child56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Child56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Child56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Child56_objectSpread(Child56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.99 37.63c-1.8 0-1.99 1.7-1.89 2.53.07.55.1 1.24.1 2.06 1.54-.24 2.54-.75 3-1.52.82-1.37 0-3.07-1.21-3.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.07 37.63c1.8 0 1.99 1.7 1.89 2.53-.07.55-.1 1.24-.1 2.06-1.54-.24-2.54-.75-3-1.52-.82-1.37 0-3.07 1.21-3.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.45 19.57c-1.16.11-1.92.79-2.29 2.04-.37 1.25-.26 2.54.32 3.86L13.03 27c-.47 1.17-.15 2.29.95 3.36-.27 1.75-.27 3.81.48 4.48.5.45 1.28.67 2.34.68.52-.29.89-.56 1.11-.82s.49-.73.79-1.41l-1.74-4.05-.79-8.51v-.95l-.73-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.61 19.57c1.16.11 1.92.79 2.29 2.04.37 1.25.26 2.54-.32 3.86l.45 1.53c.47 1.17.15 2.29-.95 3.36.27 1.75.27 3.81-.48 4.48-.5.45-1.28.67-2.34.68-.63-.03-1.08-.2-1.34-.51s-.12-.77-.23-1.61l2.09-4.59.6-7.38-.48-1.65.73-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.1 18.25c-.35 1.6 1.48 1.06 2.52 1.01 1.38-.14 2.67-.51 4.05-.82 2.25-.51 4.56-1.13 6.5-2.34 1.24-.77 2.35-1.31 3.22-2.48.17-.23.79-2.17 1.08-2.81.1.5.25 2.09.31 2.3.31 1.02 1.17 1.8 1.81 2.66 1.41 1.9 3.05 2.7 5.27 3.15.42.08 2.65.42 2.65.4-.31-7.82-6.83-14.2-13.98-14.45-9.99-.22-11.89 6.45-13.43 13.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.83 27.64c0 .24-.19.43-.43.43s-.43-.19-.43-.43.19-.43.43-.43.43.19.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.38 27.96c0 .24-.19.43-.43.43s-.43-.19-.43-.43.19-.43.43-.43.43.19.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.53 29.67c0 .24-.19.43-.43.43s-.43-.19-.43-.43.19-.43.43-.43.43.19.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.88 28.8c0 .24-.19.43-.43.43s-.43-.19-.43-.43.19-.43.43-.43.43.19.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.71 27.64c0 .24.19.43.43.43s.43-.19.43-.43-.19-.43-.43-.43-.43.19-.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.16 27.96c0 .24.19.43.43.43s.43-.19.43-.43-.19-.43-.43-.43-.43.19-.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.02 29.67c0 .24.19.43.43.43s.43-.19.43-.43-.19-.43-.43-.43-.43.19-.43.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.66 28.8c0 .24.19.43.43.43s.43-.19.43-.43-.19-.43-.43-.43-.43.19-.43.43"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.99 37.63c-1.8 0-1.99 1.7-1.89 2.53.07.55.1 1.24.1 2.06 1.54-.24 2.54-.75 3-1.52.82-1.37 0-3.07-1.21-3.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.17 19.55c-.58.52-.99 1.36-1.22 2.52-.23 1.16.18 2.26 1.22 3.33-.98.64-1.48 1.51-1.5 2.6-.02 1.09.58 2.04 1.79 2.84-1.33 1.93-1.08 3.54.76 4.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.67 33.28c-.05.89-.57 1.69-1.57 2.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.07 37.63c1.8 0 1.99 1.7 1.89 2.53-.07.55-.1 1.24-.1 2.06-1.54-.24-2.54-.75-3-1.52-.82-1.37 0-3.07 1.21-3.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.01 19.72c.5.41.86 1.2 1.09 2.35.23 1.16-.18 2.26-1.22 3.33.98.64 1.48 1.51 1.5 2.6.02 1.09-.58 2.04-1.79 2.84 1.33 1.93 1.08 3.54-.76 4.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.36 33.92c.17.71.66 1.35 1.46 1.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.08 19.71c.18 1.12.28 2.28.28 3.47 0 9.13-5.64 16.53-12.59 16.53s-12.59-7.4-12.59-16.53c0-1.2.1-2.37.28-3.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.8 24.87c0 2.56 1.68 2.68 1.68 4.16s-1.72 1.54-1.72 1.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.9 22.27c1.26-1.14 3.31-1.14 4.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.06 22.27c1.26-1.14 3.31-1.14 4.58 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.99 4.69c-11.93.77-11.93 14.95-11.93 14.95 1.66.58 16.76-1.77 17.32-9.57 0 0 .56 9.78 11.45 9.57.22 0 .62.38.63.29C44.51 11.06 39 5.2 32.14 5.65c-.95-.18-1.98-1.22-6.15-.95Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.45 34.67c1.35.77 2.8.07 3.42-.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.14 44.95c2-1.33 2.24-1.96 2.23-6.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.39 44.91c-1.57-1.06-2.06-1.85-2.05-5.96"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.27 24.85c0 .64-.52 1.16-1.17 1.16s-1.16-.52-1.16-1.16.52-1.16 1.16-1.16 1.17.52 1.17 1.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.47 24.85c0 .64-.52 1.16-1.16 1.16s-1.17-.52-1.17-1.16.52-1.16 1.17-1.16 1.16.52 1.16 1.16"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.63 35.5s-.1-.04-.15-.04l-2.84-.18c-.05 0-.1 0-.15.02-.71.25-.81.75-.81 1.03 0 .48.27.84.75 1.01.03.01.07.02.11.02l2.79.17H17.42c.52-.09.83-.41.9-.9.04-.28 0-.8-.67-1.14ZM42.57 35.31s-.1-.02-.15-.02l-2.84.18c-.05 0-.1.02-.15.04-.67.34-.7.86-.67 1.14.06.49.38.81.9.9H39.75l2.79-.17s.07 0 .11-.02c.48-.17.75-.53.75-1.01 0-.28-.11-.79-.81-1.03Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.16 47.18s1.29-.59.65.73c-1.1 2.26-6.16 3.99-10.36 2.22-6.48-2.74-.71-4.9-.71-4.9s4.58 2.5 7.06 2.63c0 0-.53.69 3.35-.68Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.39 44.91c2.32 1.57 5 3.22 7.15 5.1.31.28.6.58.88.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.12 50.91c.27-.32.56-.61.87-.89 2.1-1.86 4.88-3.5 7.16-5.06 0 0 2.38 2.91 6.66 2.91 2.76 0 4.43-1.01 6.58-2.94"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Child56 = (Child56);
;// ./src/Picto/GeneratedPictoComponents/DoctorFemale104.tsx


var DoctorFemale104_excluded = ["className"];
function DoctorFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DoctorFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DoctorFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DoctorFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DoctorFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DoctorFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DoctorFemale104_objectSpread(DoctorFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "63.76",
      cy: "92.43",
      r: "2.57",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.11 78.49s1.58.16.25 2.28c-2.28 3.62-14.55 7.26-21.18 3.07-4.49-2.84-.42-7.12-.42-7.12s4.37 4.1 9.54 4.32c6.71.28 5.13-.1 11.81-2.54ZM42.01 66.17c-1.44-1.1-2.53-2.49-3.37-4.09-.22-.42-1.71-2.28-1.8-2.88-.28-1.76-2.02-3.73-1.74-1.98.38 2.45-.75 7.93-2.21 9.9-.49.66-1.4 1.93-.56 2.04 2.71.38 5.4 1.22 10.62-.72 1.23-.46-.04-1.58-.93-2.26ZM66.27 60.92c0-1.12-4.45 6.57-5.39 7.18-.83.54.58 1.06 1.35 1.67.94.74 5.15.74 6.13.44 0 0-2.08-4.75-2.08-9.29ZM36.84 24.99c-.84.24-1.73-.2-2.04-1.01l-.15-.38c-2.82 3.83-4.07 8.57-5.08 13.18-.42 1.94 1.19 1.3 3 .89.05 0 .1.01.16 0 5.52-.57 11.33-1.15 16.17-4.1 1.87-1.14 3.57-2.58 4.9-4.32.68-.89 1.25-1.83 1.7-2.85.13-.07.26-.13.39-.2.23 1.03.71 2.09.85 2.56.47 1.55 1.72 3.34 2.96 4.4 2.14 1.84 2.75 3.1 6.02 3.75.92.18 2.38 1.43 2.3.34-.37-4.72-2.27-9.49-5.24-13.32-11.43-2.57-22.14-.06-25.96 1.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "63.76",
        cy: "92.3",
        r: "2.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.66 91.18c-.06-.51-.21-.87-.21-.87S45.22 78.64 37 82.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.84 96.53c-.3-.42-.43-.79-.43-.79s-5.43-10.82 2.95-13.8M60.84 74.65c7.65 1.76 6.69 5.62 6.69 5.62s-1.96 7.51-2.67 9.45M36.84 81.35s-3.33-5.08 6.31-6.91"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.58 54.58c.31 3.58 1.12 12.2-3.43 14.42 0 0 7.47 1.98 12.26-1.21M19 95c1.15-3.92 5.32-7.53 9.09-10.55 3.36-2.69 9.37-5.97 12.65-8.04M63.37 76.17c.64.35 1.45.78 2.46 1.42 3.28 2.06 6.93 4.17 10.29 6.86C79.93 87.5 82.86 91.05 84 95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.12 41.48c-.91-.24-1.84-.21-2.7.15-2.63 1.09-3.58 4.81-2.13 8.31 1.27 3.06 3.96 4.94 6.37 4.64M69.6 54.6c2.29.05 4.74-1.79 5.94-4.67 1.45-3.5.5-7.22-2.13-8.31-.82-.34-1.7-.38-2.58-.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.47 38.59c.33 1.91.51 3.9.51 5.95 0 10.38-4.51 19.33-11 23.39-2.39 1.5-5.06 2.33-7.86 2.33-10.42 0-18.87-11.52-18.87-25.73 0-2.11.19-4.16.54-6.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.81 42.33c1.89-1.72 4.97-1.72 6.86 0M55.54 42.33c1.89-1.72 4.97-1.72 6.86 0M59 59.31s-1.82 3.43-6.86 3.43M52.07 47.11c0 3.86 2.52 4.04 2.52 6.26s-2.57 2.31-2.57 2.31M35.16 24.54C30.68 30.65 30.33 38 30.33 38c11.15 0 25.73-4.86 25.73-13.24 0 0-.28 13.24 17.15 13.24 0 0-.21-7.93-4.93-14.16M69.31 55.3s-1.87 11.21 3.6 13.87c0 0-7.64 2.34-12.14-1.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M60.26 67.72c-.79 7.37 2.19 9.38 2.19 9.38s-2.85 3.28-10.47 3.28-10.86-3.28-10.86-3.28c3.12-1.21 2.84-9.21 2.84-9.21s4.23 2.49 8.02 2.49c5.13 0 8.28-2.66 8.28-2.66Z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.96",
        cy: "46.16",
        r: "1.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.25",
        cy: "46.16",
        r: "1.81"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.53 9.71s.42.77-.18 1.76-6.29 5.36-6.29 8.52-1.98 3.54-1.98 3.54l-4.63 1.46-1.42-1.01-1.86-6.9.46-2.59 5.24-3.92 6.07-1.55 4.59.69Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "45.38",
        y: "87.96",
        width: "5.63",
        height: "3.52",
        rx: "1.43",
        ry: "1.43",
        transform: "rotate(68.52 48.204 89.719)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.34",
        y: "93.38",
        width: "5.63",
        height: "3.52",
        rx: "1.43",
        ry: "1.43",
        transform: "rotate(68.52 34.154 95.14)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.84 16.99v3.27h-2.19v-3.27h-3.01v-1.98h3.01v-3.27h2.19v3.27h3.01v1.98h-3.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.56 24.1c.31.81 1.2 1.25 2.04 1.01 4.17-1.21 16.59-4.12 29.18-.2 1.12.35 2.31-.22 2.73-1.3l2.38-6.14c.35-.92.14-1.95-.56-2.65-2.06-2.03-7.35-5.77-18.48-5.77s-16.99 3.63-19.28 5.56c-.75.64-1.02 1.67-.66 2.59l2.66 6.9",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DoctorFemale104 = (DoctorFemale104);
;// ./src/Picto/GeneratedPictoComponents/DoctorFemale56.tsx


var DoctorFemale56_excluded = ["className"];
function DoctorFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DoctorFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DoctorFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DoctorFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DoctorFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DoctorFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DoctorFemale56_objectSpread(DoctorFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M15.18 17.77c-.53.15-1.07-.04-1.4-.45-1.35 2.45-2.07 5.24-2.67 7.97-.31 1.42.87.95 2.19.65h.12c4.03-.41 8.27-.84 11.81-2.99 1.37-.83 2.6-1.88 3.58-3.16.5-.65.91-1.33 1.24-2.08.1-.05.19-.1.29-.15.17.75.52 1.53.62 1.87.34 1.13 1.26 2.43 2.16 3.21 1.57 1.35 2.01 2.26 4.4 2.74.67.13 1.74 1.04 1.68.25-.24-3.01-1.33-6.05-3.05-8.63-9.21-2.16-17.89-.13-20.96.76Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.3 48.33c-1.05-.8-1.85-1.82-2.46-2.99-.16-.3-1.25-1.66-1.32-2.11-.2-1.29-1.47-2.73-1.27-1.45.28 1.79-.55 5.79-1.61 7.23-.36.48-1.02 1.41-.41 1.49 1.98.27 3.94.89 7.75-.53.9-.33-.03-1.15-.68-1.65ZM38.38 44.57c.05-.76-3.61 4.23-4.33 4.6-.64.32.38.75.92 1.2.66.55 3.77.77 4.51.62 0 0-1.32-3.33-1.1-6.41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.83 39.19c.24 2.73.86 9.32-2.62 11.01 0 0 5.71 1.52 9.37-.93M12.72 29.18c-.7-.18-1.41-.16-2.06.11-2.01.83-2.73 3.67-1.63 6.35.97 2.34 3.02 3.78 4.86 3.54M40.59 39.2c1.75.04 3.62-1.37 4.54-3.57 1.11-2.67.38-5.52-1.63-6.35-.63-.26-1.3-.29-1.97-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.25 26.97c.25 1.46.39 2.98.39 4.54 0 7.93-3.45 14.77-8.41 17.87-1.83 1.14-3.86 1.78-6.01 1.78-7.96 0-14.41-8.8-14.41-19.65 0-1.61.14-3.18.41-4.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.36 29.83c1.45-1.31 3.79-1.31 5.24 0M29.84 29.83c1.45-1.31 3.79-1.31 5.24 0M32.49 42.8s-1.39 2.62-5.24 2.62M27.19 33.48c0 2.95 1.93 3.09 1.93 4.78s-1.97 1.77-1.97 1.77M13.72 17.04c-2.9 4.48-3.14 9.48-3.14 9.48 8.52 0 19.65-3.72 19.65-10.11 0 0-.22 10.11 13.1 10.11 0 0-.13-5-2.86-9.48M40.42 39.74s-1.44 8.64 2.78 10.7c0 0-5.89 1.8-9.36-.96"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.98",
        cy: "32.28",
        r: "1.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.59",
        cy: "32.28",
        r: "1.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.16 11.39v2.73h-1.83v-2.73h-2.52V9.73h2.52V7h1.83v2.73h2.52v1.66h-2.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.16 11.39v2.73h-1.83v-2.73h-2.52V9.73h2.52V7h1.83v2.73h2.52v1.66h-2.52Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.34 5.37s.34.63-.15 1.43-5.12 4.37-5.12 6.94-1.61 2.88-1.61 2.88l-3.78 1.19-1.16-.82-2.08-5.52V9.86l4.67-3.01 5.1-1.2 4.13-.3Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M15.24 17.77c3.32-.96 13.19-3.27 23.2-.16.89.28 1.84-.17 2.17-1.03l1.89-4.88c.28-.73.11-1.55-.44-2.1-1.64-1.62-5.85-4.59-14.7-4.59S13.85 7.89 12.03 9.43c-.6.51-.81 1.33-.53 2.06l2.12 5.48c.25.64.95.99 1.62.8Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DoctorFemale56 = (DoctorFemale56);
;// ./src/Picto/GeneratedPictoComponents/Dog104.tsx


var Dog104_excluded = ["className"];
function Dog104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Dog104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Dog104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Dog104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Dog104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Dog104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Dog104_objectSpread(Dog104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.67 88.23c1.07 1.19 2.58.9 3.67-.59.01-.02-.02.01 0 0 5.25-4.67 11.09-6.94 20.94-5.73 2.21.27 4.24.05 6.05-.47 3.71-1.04 2.65-6.41-1.21-6.12-.5.04-1.01-.04-1.48-.23l-.68.56c-.35-.14-.73.26-1.01 0l-4.17-.18c-.76-.68-4.97-1.08-5.98-.88l-2.89-.71c-.39.08-2.82-1.21-3.15-1.01l-6.75-3.23c-.49.3-1.27 4.05-1.53 4.55l-1.58 5.07c-.25.47-.61 1.28-.59 1.81l-.84 4.75c.02.72.31 1.42.8 1.96l.41.46Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.15 27.45c2.45 9.32-.92 17.1-3.49 17.54-2.5.42-7.86-10.55-9.62-16.42-.26-.87.87-1.41 1.32-.64 2.04 3.48 5.44 8.87 7.07 9.26 2.53.6 2.33-10.58 2.33-10.58s-.3-2.47.79-1.96 1.59 2.81 1.59 2.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.83 27.31c-2.38 9.32.89 17.1 3.39 17.54 2.43.42 7.64-10.55 9.36-16.42.25-.87-.84-1.41-1.29-.64-1.99 3.48-5.29 8.87-6.87 9.26-2.46.6-2.27-10.58-2.27-10.58s.29-2.47-.77-1.96-1.55 2.81-1.55 2.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.64 42.79c0 2.1-2.53 3.79-5.64 3.79s-5.64-1.69-5.64-3.79S48.89 39 52 39s5.64 1.69 5.64 3.79Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.22 54.92v.57c0 2.1-1.89 3.8-4.22 3.8s-4.22-1.7-4.22-3.8v-.57L52 51.26l4.22 3.66Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.22 54.57v.64a4.22 4.22 0 0 1-8.44 0v-.64"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.37 23.98c1.18 6.61 8.6 21.6 12.18 21.03 3.58-.56 3.33-12.44 2.37-17.98-1.2-6.92-3.58-12.55-6.22-14.7-2.63-2.15-6.07-2.68-8.32-2.41-2.25.29-4.7 5.04-4.7 5.04-6.13-3.62-14.96-4.44-18.67-4.44s-12.52.82-18.67 4.44c0 0-2.45-4.75-4.7-5.04-2.25-.29-5.68.26-8.32 2.41-2.63 2.15-5.02 7.76-6.22 14.7-.95 5.54-1.21 17.41 2.37 17.98 3.58.56 10.99-14.43 12.18-21.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.59 96.14c.47-5.5-1.38-11.49-3.42-17.26-2.16-6.1-4.52-11.95-4.53-16.72 0-3.62 2.63-8.81 3.68-13.85 1.07-5.05.34-17.23.34-17.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.41 96.1c-.47-5.5 1.38-11.49 3.42-17.26 2.16-6.1 4.52-11.95 4.53-16.72 0-3.62-2.63-8.81-3.68-13.85-1.07-5.05-.34-17.23-.34-17.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.64 42.79c0 2.1-2.53 3.79-5.64 3.79s-5.64-1.69-5.64-3.79S48.89 39 52 39s5.64 1.69 5.64 3.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 46.58v3.92c0 1.92 5 5.07 9.98 1.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 46.58v3.92c0 1.92-5 5.07-9.98 1.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.1 25.42c3.36-1.37 7.46.12 9.15 3.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.9 25.42c-3.36-1.37-7.46.12-9.15 3.33"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "62.42",
        cy: "32",
        r: "2.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.55",
        cy: "32",
        r: "2.64"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.95 75.66c14.3 0 22.95-6.3 22.95-6.3s-.83-2.85-1.13-4.11c-.31-1.27-.72-2.66-.72-2.66s-11.39 6.42-21.1 6.42-21.1-6.42-21.1-6.42-.4 1.39-.72 2.66c-.31 1.27-1.13 4.4-1.13 4.4s8.66 6.02 22.95 6.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 75.66c14.28 0 22.92-6.3 22.92-6.3s-.14-.67-.31-1.46c-.33-1.51-.6-3.04-.8-4.58-.09-.66-.15-1.15-.15-1.15s-6.01 6.75-20.97 6.75c-13.77 0-22.32-6.21-22.32-6.21s-.24 2.5-.51 3.73c-.31 1.47-.84 3.21-.84 3.21s8.72 6.02 22.99 6.02Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Dog104 = (Dog104);
;// ./src/Picto/GeneratedPictoComponents/Dog56.tsx


var Dog56_excluded = ["className"];
function Dog56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Dog56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Dog56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Dog56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Dog56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Dog56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Dog56_objectSpread(Dog56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.77 18.78c1.49 5.68-.56 10.43-2.13 10.69-1.52.26-4.79-6.43-5.87-10.01-.16-.53.53-.86.81-.39 1.24 2.12 3.31 5.4 4.31 5.65 1.54.37 1.42-6.45 1.42-6.45s-.18-1.51.48-1.2.97 1.71.97 1.71Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M5.15 18.76c-1.46 5.71.55 10.47 2.08 10.73 1.49.26 4.68-6.45 5.73-10.05.15-.53-.52-.86-.79-.39-1.22 2.13-3.23 5.42-4.21 5.67-1.51.37-1.39-6.47-1.39-6.47s.18-1.51-.47-1.2-.95 1.72-.95 1.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.34 28.28c0 1.23-1.49 2.23-3.32 2.23s-3.32-1-3.32-2.23 1.49-2.23 3.32-2.23 3.32 1 3.32 2.23Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.96 16.91c.71 3.95 5.14 12.91 7.28 12.57 2.14-.34 1.99-7.43 1.41-10.75-.72-4.14-2.14-7.5-3.72-8.79-1.57-1.28-3.63-1.6-4.98-1.44-1.35.17-2.81 3.01-2.81 3.01-3.67-2.16-8.94-2.66-11.16-2.66s-7.49.49-11.16 2.66c0 0-1.47-2.84-2.81-3.01-1.35-.17-3.4.16-4.98 1.44-1.57 1.28-3 4.64-3.72 8.79-.57 3.31-.72 10.41 1.41 10.75 2.14.34 6.57-8.62 7.28-12.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.93 39.74c0-2.17 1.57-5.26 2.2-8.28.64-3.02.2-10.3.2-10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.06 39.71c0-2.17-1.57-5.26-2.2-8.28-.64-3.02-.2-10.3-.2-10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.36 28.16c0 1.25-1.51 2.27-3.37 2.27s-3.37-1.01-3.37-2.27 1.51-2.27 3.37-2.27 3.37 1.01 3.37 2.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 30.42v2.34c0 1.15 2.99 3.03 5.97.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 30.42v2.34c0 1.15-2.99 3.03-5.97.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.23 17.77c2.01-.82 4.46.07 5.47 1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.75 17.77c-2.01-.82-4.46.07-5.47 1.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.95 47.8c8.56 0 13.74-3.78 13.74-3.78s-.5-1.7-.68-2.46c-.19-.76-.43-1.59-.43-1.59s-6.82 3.84-12.64 3.84-12.64-3.84-12.64-3.84-.24.83-.43 1.59c-.19.76-.68 2.63-.68 2.63s5.19 3.6 13.74 3.6Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.01 47.53c8.57 0 13.76-3.79 13.76-3.79s-.08-.4-.19-.88c-.2-.91-.36-1.83-.48-2.75-.05-.4-.09-.69-.09-.69s-3.61 4.05-12.59 4.05c-8.26 0-13.4-3.73-13.4-3.73s-.15 1.5-.31 2.24c-.19.88-.5 1.93-.5 1.93s5.23 3.61 13.8 3.61Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "22.58",
          cy: "21.63",
          r: "1.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "33.42",
          cy: "21.63",
          r: "1.5"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Dog56 = (Dog56);
;// ./src/Picto/GeneratedPictoComponents/ElderlyFemale104.tsx


var ElderlyFemale104_excluded = ["className"];
function ElderlyFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElderlyFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElderlyFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElderlyFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElderlyFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElderlyFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElderlyFemale104_objectSpread(ElderlyFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.9 15.96s-9.61-5.4-17.74 3.22-8.39 3.38-8.39 3.38l2.11-4.75 7.01-5.45 6.24-1.97 3.54-.27 4.88.87 3.3 1.64 3 2.71-3.76 1.13-.19-.51ZM71.89 64.08l-.04-3.22.04-2.7.46-2.83.5-.35 1.62-.46 1.5-1.2 1.2-2.1.68-2.19-.31-3.02-1.88-2.72-2.15-.99.83-2.78.51-4.2V32.1l-.38-2.78-.87-2.8-1.07-2.56-2.32-2.57-1.97-1.87-1.39-1.6 3.75-1.67 3.6-.73h4.65l3 .77 3.49 1.54 3.51 2.69 2.58 3.18 2.01 3.82 1.41 4.46 1 6.54V45l-1 7.03-2.39 5.49-3.86 4.28-5.75 2.72-5.26 1h-5.23l-.47-1.44zM15.85 29.52l.5 2.52.5 4.05 1.25 3.43 1.97 1.96 3.24 2.3 3.54 1.74 1 .54-.69 2.2.69 3.52 1.42 1.99 1.58.85 1.6.9.89 1.66v3.34l-.43 5.58-.46.65-1.6.33h-4.26l-4.74-1.16-5.5-2.4-3.91-4.71L9.49 53l-1.03-9.22L10 36.54l3.15-5.4 2.7-1.62z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.11 66.13c32 1.38 22-35.61 22-35.61-3.46-11.34-10.26-15-18.33-15.61M33.07 67.52c-33.14 3-27.22-37.32-16.72-38.68"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.85 58.16v4.36l.48 3 .86 3 .66 2 1.62 1.98-1.62 1.18-4-.16-4.04-.53-2.88-1.15-.84-1.89 3.46-2.8 2.94-3.63 2.21-3.3 1.15-2.06zM34.43 58.52l-1.36 10.29-2.22 3.71 3.98 1.16 5.24-.16 3.36-2.65.72-1.07-5.16-4.14-3.02-4.69-1.54-2.45zM61.79 80.47c-5.18 2.56-13.56 3.62-18.43.21-.13-.09-.31-.05-.46-.06-.31-1.22-3.38-.88-3.19.4.64 4.23 5.86 8.62 12.77 8.98 9.45.49 11.15-3.88 11.67-8.28.11-.91-1.31-1.76-2.36-1.25Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.7 54.98s-2.2 14.72 4.27 17.87c0 0-10 3.77-15.12-2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.54 54.98s2.2 14.72-4.27 17.87c0 0 10 3.77 15.12-2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.15 70.87c-.1 4.24-.57 6.41-2.85 8.55M26.24 95.24c1.05-2.95 2.63-5.88 5-8.09.68-.63 1.37-1.23 2.07-1.81M63.92 79.4c-2.23-2.11-2.72-3.86-2.83-7.96M78.97 94.62c-1.05-2.73-2.57-5.41-4.77-7.46-.67-.62-1.35-1.21-2.03-1.78M63.55 79.4c-3.59 2.92-6.42 4.39-11.07 4.39s-7.49-1.47-11.07-4.39M32.91 94.92l.64-9.37M72.49 95.18l-.6-9.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.54 85.19c2.22-1.83 4.29-3.24 6.39-4.78.56-.41 1.74-1.42 2.17-1.81M72.16 85.38c-2.24-1.84-4.76-3.38-6.88-4.93-.57-.42-1.06-.82-1.49-1.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33 55.39c-2.57.16-4.7-3.19-5.05-5.89 0 0-.38-2.16.09-3.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.37 43.29c2.57.19 4.33 2.98 3.95 6.22-.39 3.24-2.78 5.72-5.35 5.53"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.85 41.48c0 20.04-9.33 30.76-20.37 30.76S32.46 60.87 32.46 45.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.65 47.3c0 4.03 2.63 4.22 2.63 6.54s-2.69 2.42-2.69 2.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.18 44.21c1.98-1.79 5.18-1.79 7.16 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.5 62.24c1.15 1.8 3.89 2.25 5.37-.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.93 63.19s-3.17-3.36-1.85-8.77M46.58 54.42c1.2 5.57-1.99 8.79-1.99 8.79M48.2 44.18s-1.26-1.13-3.28-1.06"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m65.09 18.88 3.16 1.55 2.05 2.48 2.44 4 .78 3.67.82 3.97-.58 4.97-.63 2.39-4.28-.91-4-2.09-3.76-2.35-2.04-3.43-1.2-3.22-.76-2.27 1.69-2.73 3.15-3.67 3.16-2.36",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.09 27.25c-.08 2.02 1.42 12.3 16.04 14.27 0 0 5.61-16.13-7.28-23.02",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.46 22.28c11.25-5.59 26.66-8.1 37.06-7.37 0 0-10.67-.06-16.33 7.57-5.66 7.63-10.68 20.53-21.94 23.04-11.39 2.54-24.34-5.19-21.32-16.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.35 28.84c.92-.36 2.27-.59 4-.87M30.1 23.08c.8-3.37 3.44-9.55 12.06-12.2 12.67-3.89 18.93 4.87 18.93 4.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.68 23.2v3.72l1.56 4.82 3.77-1.72 1.8-2.05-.09-1.56-.48-2.22-6.56-.99M32.97 22.58l.14 4.4 4.09 1 3.16.26.17-4.21-.94-2.35-.97-2.03-5.65 2.93"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.44 22.96c.23-.03 1.12-.13 2.6-.06 1.55.07 3.42.34 4.87 1.08-.42.63-.6 1.41-.45 2.21.11.6.42 1.12.82 1.52-1.44 1.98-3.72 3.2-5.99 4.34-.14-.24-.36-.59-.76-1.35-.5-.96-1.05-2.15-1.22-2.93-.14-.79-.13-2.08-.04-3.17.07-.91.13-1.39.16-1.62h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.62 19.43c.11.2.36.63.76 1.44.49.98 1.01 2.17 1.15 2.94.13.78.07 2.08-.04 3.17-.09.85-.16 1.26-.2 1.54-2.53-.2-5.1-.47-7.17-1.77a2.938 2.938 0 0 0-1.03-3.59c2.41-2.46 6.09-3.61 6.52-3.74h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30 23.46c1.19-.23 2.31.53 2.54 1.72.23 1.19-.5 2.28-1.7 2.53h-.04c-1.18.22-2.3-.52-2.53-1.7s.55-2.33 1.74-2.56H30Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.24",
        cy: "48.87",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.8",
        cy: "49",
        r: "2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElderlyFemale104 = (ElderlyFemale104);
;// ./src/Picto/GeneratedPictoComponents/ElderlyFemale56.tsx


var ElderlyFemale56_excluded = ["className"];
function ElderlyFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElderlyFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElderlyFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElderlyFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElderlyFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElderlyFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElderlyFemale56_objectSpread(ElderlyFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.56 13.27s-5.17-2.91-9.54 1.73c-4.37 4.64-4.71 2.02-4.71 2.02l1.33-2.76 3.77-2.93 3.36-1.06 1.9-.15 2.63.47 1.78.88 1.61 1.46-2.02.61-.1-.27ZM38.59 38.94l-.02-1.73.02-1.46.25-1.53.2.53.94-.35 1.01-.83.9-1.26-.09-1.48-.16-1.64-1.82-1.01-.36-.98.45-1.5.27-2.27V21.7l-.2-1.51-.47-1.51-.58-1.38-1.25-1.38-1.06-1.01-.75-.86 2.02-.91 1.94-.39h2.51l1.62.42 1.88.83 1.89 1.45 1.4 1.72 1.08 2.05.76 2.41.54 3.53v3.49l-.54 3.8-1.29 2.95-2.08 2.32-3.1 1.46-2.84.54h-2.82l-.25-.78zM8.34 20.36l-.1 1.37.27 2.19 1.03 1.74 1.04 1.04 1.72 1.22 1.87.92.53.29-.36 1.16.15 2.42.76 1.05.86.64 1.14.55.36.07v1.77l-.22 2.96-.25.34-.85.17h-2.26l-2.51-.61-2.6-1.53-2.38-2.24-1.57-3.08-.54-4.88.81-3.84 1.67-2.86 1.43-.86z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.19 14.19 1.8.88 1.17 1.41 1.39 2.29.44 2.09.47 2.27-.33 2.84-.36 1.36-2.44-.52-2.28-1.19-2.15-1.35-1.16-1.95-.69-1.84-.43-1.3.96-1.55 1.8-2.1 1.81-1.34M38.05 37.29v2.32l.26 1.59.45 1.6.35 1.06.87 1.05-.87.63-2.12-.08-2.15-.29-1.53-.61-.44-1 1.83-1.49 1.57-1.93 1.17-1.75.61-1.1zM18.1 37.21l-.75 5.71-1.24 2.06 2.22.65 2.9-.09 1.87-1.47.4-.6-2.86-2.3-1.68-2.6-.86-1.36z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.25 34.95c-1.44.09-2.63-1.78-2.82-3.29 0 0-.21-1.21.05-1.99"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.82 28.18c1.43.11 2.42 1.66 2.21 3.48s-1.55 3.2-2.99 3.09"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.53 27.17c0 11.2-5.21 17.19-11.39 17.19s-11.19-6.35-11.19-14.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.24 30.42c0 2.25 1.47 2.36 1.47 3.66s-1.5 1.35-1.5 1.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.21 28.69c1.11-1 2.9-1 4 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.04 38.77c.64 1 2.17 1.26 3-.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.42 39.31s-1.77-1.88-1.04-4.9M24.85 34.4c.67 3.11-1.11 4.91-1.11 4.91M25.75 28.68s-.71-.63-1.83-.59M30.72 19.22c-.05 1.13.79 6.88 8.96 7.98 0 0 3.14-9.01-4.07-12.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.89 39.66c16.78.73 11.54-18.68 11.54-18.68-1.82-5.95-5.38-7.87-9.62-8.19M17.64 39.88C.25 41.45 3.38 20.85 8.89 20.14"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.55 34.82s-1.39 8.46 2.12 10.17c0 0-5.64 2.79-8.46-1.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.7 35.29s1.18 7.91-2.3 9.6c0 0 4.17 3.29 8.33-1.48"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.19 16.24c5.94-2.65 13.32-3.82 18.62-3.44 0 0-5.44-.05-8.52 4.1-3.08 4.15-5.81 11.16-11.93 12.53-6.19 1.38-13.55-2.9-11.9-9.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.46 20.28c.35-.14.83-.24 1.4-.34M16.5 17.03c.43-1.83 1.86-5.2 6.56-6.65 6.89-2.12 10.23 2.57 10.23 2.57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.51",
        cy: "31.09",
        r: "1.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.25",
        cy: "31.09",
        r: "1.07"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.16 16.92v2.31l.96 3 2.34-1.07 1.12-1.27-.05-.97-.31-1.38-4.06-.62M17.78 16.54l.09 2.73 2.54.62 1.96.16.1-2.61-.58-1.46-.6-1.26-3.51 1.82"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.15 16.91c.14-.02.69-.08 1.61-.04.96.04 2.12.21 3.02.67-.26.39-.37.87-.28 1.37.07.37.26.69.51.94-.89 1.23-2.31 1.99-3.71 2.69-.09-.15-.22-.36-.47-.84-.31-.6-.65-1.34-.76-1.82-.09-.49-.08-1.29-.03-1.97.04-.56.08-.86.1-1.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.41 14.72c.07.12.22.39.47.89.3.61.62 1.34.71 1.82.08.48.04 1.29-.03 1.97-.05.53-.1.78-.12.95-1.57-.12-3.16-.29-4.44-1.09.14-.33.19-.69.12-1.07-.1-.49-.37-.9-.76-1.16 1.5-1.52 3.77-2.23 4.04-2.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.07 17.23c.74-.14 1.43.33 1.58 1.07s-.31 1.42-1.05 1.57h-.03c-.73.13-1.42-.32-1.57-1.05s.34-1.44 1.08-1.58Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElderlyFemale56 = (ElderlyFemale56);
;// ./src/Picto/GeneratedPictoComponents/ElderlyMale104.tsx


var ElderlyMale104_excluded = ["className"];
function ElderlyMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElderlyMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElderlyMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElderlyMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElderlyMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElderlyMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElderlyMale104_objectSpread(ElderlyMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.38 85.22s.98-.24.44 2.18c-.97 4.3-16.11 10.31-21.96 4.74-3.31-3.15-1.94-7.15-1.94-7.15s5.84 3.89 11.27 3.67c7.05-.29 5.37-.53 12.18-3.45ZM31.75 15.8c-4.29 4.77-6.65 10.58-6.87 17-.09 2.51 3.04 4.85 3.12 2.34.18-5.36 3.78-13.61 7.37-17.6 1.68-1.86-1.93-3.62-3.62-1.75ZM70.55 15.66c-1.92-1.59-4.54.22-2.6 1.82 4.67 3.88 7.18 11.57 7.29 17.66.04 2.51 3.17.96 3.12-1.56-.12-7.04-2.37-13.41-7.81-17.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.58 86.98c-.5-.25-.88.33-.47.67 2.18 1.81.69 7.37 4.17 8.13-.04.36 1.08-.56 1.36-.81.49-.44 2.42-1.42 2.33-2.8.43-1.79-4.89-4.25-7.39-5.19Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M79.26 87.06c.51-.25.89.31.46.66-2.24 1.82-.79 7.32-4.33 8.12.03.36-1.09-.54-1.37-.78-.5-.43-2.44-1.38-2.33-2.75-.41-1.77 5.02-4.28 7.56-5.25Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.23 84.17C61.13 86.64 56.6 88 51.84 88s-9.22-1.34-13.28-3.77M67.23 15.16c5.4-.5 10.24 7.07 10.97 14.48.74 7.46-2.36 7.36-2.36 7.36M26.77 37.66c-1.03-.19-2.06-.11-3.02.29-3.39 1.4-4.62 6.2-2.75 10.72 1.64 3.95 5.11 6.38 8.22 5.99M74.11 54.69c3.02.18 6.29-2.22 7.86-6.02 1.87-4.52.64-9.32-2.75-10.72-1.11-.46-2.31-.5-3.49-.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.49",
        cy: "41.7",
        rx: "24.35",
        ry: "33.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.55 43.92c0 4.99 3.26 5.22 3.26 8.08s-3.32 2.99-3.32 2.99M38.21 38.86c2.45-2.21 6.41-2.21 8.85 0M55.92 38.86c2.45-2.21 6.41-2.21 8.85 0M48.33 63.69h6.2M44.85 52.77C42.87 59.58 36 56.5 36 56.5M66.99 56.5s-6.87 3.08-8.85-3.73M38.21 30.08s4.43-1.66 6.64-1.66 4.43 1.66 6.64 1.66 4.43-1.66 6.64-1.66 6.64 1.66 6.64 1.66M40.42 23.44s3.69-1.66 5.53-1.66 3.69 1.66 5.53 1.66 3.69-1.66 5.53-1.66 5.53 1.66 5.53 1.66M34.89 78.21c1.68-2.11 3.4-4.74 4.54-7.69M64.11 70.18c1.06 2.89 2.7 5.48 4.33 7.59M62.29 94.72c1.41-9.77 6.49-16.52 6.49-16.52M78.31 86.7l-7.41 5.06 4.74 3.42M41.28 94.06c-1.54-9.41-6.39-15.85-6.39-15.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.99 75.76c.2.29.4.57.6.85 2.05 2.81 4.59 5.23 7.41 7.27L91.11 95.5M36.73 75.76c-.2.29-.4.57-.6.85-2.05 2.81-4.59 5.23-7.41 7.27L12.61 95.5M25.55 86.53l7.42 5.06L28.22 95M27.38 37s-3.33.1-2.59-7.36c.73-7.41 5.58-14.98 10.97-14.48"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.53",
        cy: "43",
        r: "2.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.32",
        cy: "43",
        r: "2.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.18 44.96c1.05 2.78 3.85 4.78 7.16 4.78s6.12-2 7.16-4.78H35.17ZM54.29 44.96c1.05 2.78 3.85 4.78 7.16 4.78s6.12-2 7.16-4.78H54.28ZM26.34 36.66l8.84 8.3h33.43l8.1-8.22"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElderlyMale104 = (ElderlyMale104);
;// ./src/Picto/GeneratedPictoComponents/ElderyMale56.tsx


var ElderyMale56_excluded = ["className"];
function ElderyMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElderyMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElderyMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElderyMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElderyMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElderyMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElderyMale56_objectSpread(ElderyMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.06 10.47c-2.97 3.3-4.54 6.81-4.69 11.25-.06 1.74 2.1 3.36 2.16 1.62.13-3.71 2.61-9.41 5.1-12.18 1.16-1.29-1.4-1.99-2.57-.7ZM40.94 10.13c-1.33-1.1-2.87-.11-1.53 1 3.23 2.68 4.7 8.26 4.77 12.48.03 1.74 2.19.66 2.16-1.08-.08-4.87-1.64-9.28-5.4-12.4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.78 9.62c3.74-.35 7.09 4.89 7.6 10.03.51 5.16-1.63 5.1-1.63 5.1M10.75 25.2c-.71-.13-1.43-.07-2.09.2-2.35.97-3.2 4.3-1.9 7.43 1.13 2.74 3.54 4.42 5.69 4.15M43.55 37c2.09.12 4.35-1.53 5.45-4.17 1.3-3.13.44-6.45-1.9-7.43-.77-.32-1.6-.34-2.42-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "27.88",
        cy: "28",
        rx: "16.87",
        ry: "23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.92 29.53c0 3.45 2.26 3.61 2.26 5.6s-2.3 2.07-2.3 2.07M18.68 26.03c1.69-1.53 4.44-1.53 6.13 0M30.94 26.03c1.69-1.53 4.44-1.53 6.13 0M25.68 43.23h4.3M23.28 35.67c-1.37 4.72-6.13 2.59-6.13 2.59M38.61 38.25s-4.76 2.13-6.13-2.59M18.68 19.95s3.07-1.15 4.6-1.15 3.07 1.15 4.6 1.15 3.07-1.15 4.6-1.15 4.6 1.15 4.6 1.15M20.21 15.35s2.56-1.15 3.83-1.15 2.56 1.15 3.83 1.15 2.56-1.15 3.83-1.15 3.83 1.15 3.83 1.15M11.18 24.74s-2.31.07-1.8-5.1c.51-5.13 3.86-10.38 7.6-10.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.74",
        cy: "28.63",
        r: "1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.01",
        cy: "28.63",
        r: "1.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.52 30.28c.72 1.89 2.64 3.24 4.91 3.24s4.19-1.35 4.91-3.24h-9.81ZM29.61 30.28c.72 1.89 2.64 3.24 4.91 3.24s4.19-1.35 4.91-3.24h-9.81ZM10.46 24.65l6.06 5.63h22.9l5.54-5.57"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElderyMale56 = (ElderyMale56);
;// ./src/Picto/GeneratedPictoComponents/FirstNationsFemale104.tsx


var FirstNationsFemale104_excluded = ["className"];
function FirstNationsFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FirstNationsFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FirstNationsFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FirstNationsFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FirstNationsFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FirstNationsFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FirstNationsFemale104_objectSpread(FirstNationsFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24 50.43s-11.27 2.5 3.13 22.19l-2.2 4.17L21.54 78l-3.85-2.02-1.73-3.26v-1.41l-2.97-1.48-.29-2.17.52-1.16-2.08-2.9 1.1-2.37-2.36-3.15-.31-3.55 1.78-4.11.72-2.64 1.84-4.03 2.67-1.94 2.75-.83.55-1.42.93-.68.76 1.44L24 50.44ZM82.13 40.26s12.82 12.66-3.68 30.27l2.27 3.9 3.48 1.13 3.96-1.88 1.77-3.05v-1.32l1.79-2.46 1.56-.96-.54-1.09.21-3.15.8-1.77-.61-3.9 1.38-2.68.15-3.53-1.64-1.69-3.45-1.46-.84-3.47-2.28-2.21-.26-.61-.95-.09-1.08.08-2.03-.08ZM66.81 11.57c2 3.13 2.82 9.56-13.37 9.56-.86 0-4.89-2.31-19.59 3.86l-3.17 2.02-1.99-3-.77-4.11 2.99-1.4 1.05-1.85 2.02-3.42 5.63-.05 1.94-3.48 4.73-.4L50 8.49l3.13-.35 4.27.42 1.85-.06 2.51 2.09 2.49.17c.54.92 1.19-1.35 2.57.81Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.28 66.86c.69 3.2 3.9 4.63 7.41 4.03.44-.07.86-.19 1.26-.34.95 2.87 4.15 4.69 7.44 4.13 3.51-.6 5.8-3.67 5.12-6.87-.05-.23-.12-.45-.19-.67.19 0 .39-.01.59-.05 1.77-.3 2.93-1.85 2.58-3.46-.15-.68-.54-1.25-1.07-1.67 1.28-.57 2.04-1.86 1.75-3.2-.2-.93-.87-1.67-1.73-2.08 1.59-1.33 2.41-3.35 1.97-5.43-.5-2.33-2.45-4.07-4.82-4.62.05-.54.03-1.09-.09-1.64-.67-3.12-3.93-5.19-7.35-4.73-.5-1.29-1.91-2.11-3.43-1.97-.72-2.19-2.93-3.11-5.12-1.52M70.87 27.39c2.13 1.61 4.75.04 5.16-1.73.39-1.65-.23-3.39-1.39-4.07 0-.1.02-.2.02-.3 0-1.62-.86-2.98-2-3.29-.21-1.58-1.23-2.78-2.47-2.78-.42 0-.81.15-1.16.4-.34-2.98-2.24-5.28-4.57-5.28-1.05 0-2.01.49-2.79 1.28-.74-2.11-2.33-3.58-4.19-3.58-1.31 0-2.48.73-3.32 1.89-.31-1.39-1.26-2.41-2.4-2.41s-2.09 1.02-2.4 2.42c-.74-.67-1.63-1.06-2.59-1.06-1.21 0-2.3.63-3.12 1.64-.42-.43-.95-.7-1.52-.7-1.39 0-2.51 1.51-2.51 3.36 0 .15.02.3.03.45-.37-.28-.78-.45-1.23-.45-.82 0-1.53.53-1.99 1.34-.46-.81-1.18-1.34-1.99-1.34-1.39 0-2.51 1.51-2.51 3.36 0 .55.11 1.05.28 1.51-.3-.08.28.16 0 0-1.85-1.04-7.15 1.25-1.76 9.33M33.68 60.96c.92 1.69 1.31 2.43 1.31 3.91 0 3.41-3.04 7.24-6.24 7.24-.4 0-.79-.04-1.17-.13-.29 3.12-2.76 5.55-5.77 5.55-3.2 0-5.8-2.77-5.8-6.18 0-.24.02-.49.04-.72-.17.03-.35.06-.53.06-1.61 0-2.92-1.39-2.92-3.11 0-.72.24-1.38.63-1.91-1.24-.36-2.15-1.56-2.15-2.99 0-1 .45-1.87 1.13-2.44-1.65-1.09-2.75-3.03-2.75-5.25 0-2.49 1.38-4.63 3.37-5.6-.15-.54-.23-1.12-.23-1.71 0-3.33 2.48-6.04 5.58-6.17.2-1.42 1.28-2.51 2.64-2.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.45 61.67c2.97 1.23 6.71-.97 8.34-4.91s.86-7.67-1.94-9.28c0 0-1.54-.97-3.69-.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.01 79.34c2.48-2.33 2.99-1.49 3.1-6.09M32.35 85.76c-.76.62-1.51 1.28-2.25 1.96-2.57 2.4-4.28 5.58-5.43 8.77M65.56 79.31c-2.42-2.28-2.95-2.2-3.07-6.65M74.51 85.8c.74.61 1.48 1.26 2.21 1.93 2.39 2.23 4.04 5.13 5.18 8.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.79 37.13c2.49 6.5 1.88 10.65 1.88 10.65 0 15.29-9.72 27.68-21.7 27.68s-21.7-12.39-21.7-27.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.9 65.38c2.64.99 5.43.55 7.34-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.65 44.67c1.7-2.35 5.1-3.06 7.6-1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.96 44.93c-1.52-2.47-4.85-3.44-7.46-2.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.06 48.59s.59 3.9 1.96 5.44l.05.05c1.11 1.3-.12 3.08-2.03 3.08-1.09 0-2.33.18-2.88.89M49.19 48.59s-.59 3.9-1.96 5.44l-.05.05c-1.11 1.3.12 3.08 2.03 3.08 1.09 0 2.33.18 2.88.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.53 61.62c-1.86.77-3.84.22-5.57-1.27-1.84-1.59-3.16-4.06-3.24-6.48-.03-1 0-2.31.28-3.43"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.77",
        cy: "47",
        r: "1.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.37",
        cy: "47",
        r: "1.97"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.13 80.5c-6.13 2.58-16.07 3.59-21.9.02-.15-.09-.37-.06-.55-.06-.38-1.27-4.03-.94-3.79.38.81 4.37 7.15 7.64 15.34 8.43 10.11.98 13.14-2.92 13.71-7.46.12-.94-1.58-1.83-2.81-1.31ZM31 27.36s-7.01-8.7-17.21-4.17c-.91.4-1.86.7-2.83.92-1.62.36-3.74.78-3.96.51 0 0 5.16 10.01 23.66 9.38 0 0-9.15-.93-9.54 3.17-.17 1.82 1 2.99 1.05 5.67s-1.45 5-2.18 5.91c0 0 18.99 3.95 10.66-14.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.38 23.81C49.4 17.38 37.83 22.69 32.87 26c-1.23.82-1.35 1.28-1.23 2.59l-.2 6.05c.08.88.42 1.54 1.33 1.1 0 0 41.23-7.05 30.61-11.93Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.05 36.39c15.85-7.64 36.47-.49 39.74.74.22.08.46-.08.41-.28L72 29c-.36-1.55-3.49-3.59-5.1-4.38C51.31 17 37.83 22.68 32.87 26c-1.23.82-1.87 2.09-1.75 3.4l-.2 6.05c.08.88 1.23 1.38 2.14.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31 28s-7.01-8.7-17.21-4.17c-.91.4-1.86.7-2.83.92-1.62.36-3.74.78-3.96.51 0 0 5.16 10.01 23.66 9.38 0 0-9.15-.93-9.54 3.17-.17 1.82 1 2.99 1.05 5.67s-1.45 5-2.18 5.91c0 0 18.99 3.95 10.66-14.74M53.42 82.31c5.58 0 10.15-1.53 12.06-2.29.61-.24 1.3-.16 1.83.23l6.49 4.7c.39.28.6.75.54 1.22-.23 1.95-.79 7.13-.7 9.94M53.26 82.31c-5.58 0-10.15-1.53-12.06-2.29-.61-.24-1.3-.16-1.83.23l-6.49 4.7c-.39.28-.6.75-.54 1.22.23 1.95.79 7.13.7 9.94"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FirstNationsFemale104 = (FirstNationsFemale104);
;// ./src/Picto/GeneratedPictoComponents/FirstNationsFemale56.tsx


var FirstNationsFemale56_excluded = ["className"];
function FirstNationsFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FirstNationsFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FirstNationsFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FirstNationsFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FirstNationsFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FirstNationsFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FirstNationsFemale56_objectSpread(FirstNationsFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.72 32.41s-6.18 1.37 1.71 12.17l-1.21 2.29-1.86.66-2.11-1.11-.95-1.79v-.77l-1.63-.81-.16-1.19.29-.64-1.14-1.59.6-1.3-1.29-1.72-.17-1.95.98-2.25.4-1.45 1.01-2.21 1.46-1.07 1.51-.46.3-.78.51-.37.41.79 1.33 5.55ZM44.02 27.15s7.06 6.9-2.03 16.49l1.25 2.12 1.92.62 2.18-1.03.98-1.66v-.72l.99-1.34.86-.52-.3-.59.12-1.72.44-.96-.34-2.12.76-1.46.08-1.92-.9-.92-1.9-.8-.46-1.89-1.25-1.21-.15-.33-.53-.05-.6.04-1.12-.04ZM35.98 11.73c1.09 1.7 1.54 5.21-7.28 5.21-.47 0-2.66-1.26-10.67 2.1l-1.73 1.1-1.09-1.63-.42-2.24 1.63-.76.57-1.01 1.1-1.86 3.07-.03 1.06-1.9 2.57-.22 2.02-.44 1.7-.19 2.32.23 1.01-.03 1.37 1.14 1.35.09c.29.5.65-.73 1.4.44Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.18 41.74c.37 1.73 2.11 2.51 4.02 2.19.24-.04.47-.1.68-.18.51 1.55 2.25 2.54 4.04 2.24 1.9-.32 3.15-1.99 2.78-3.73-.03-.12-.06-.24-.1-.36.11 0 .21 0 .32-.02.96-.16 1.59-1 1.4-1.88-.08-.37-.29-.68-.58-.91.69-.31 1.11-1.01.95-1.74-.11-.51-.47-.91-.94-1.13.86-.72 1.31-1.82 1.07-2.95-.27-1.26-1.33-2.21-2.62-2.51.03-.29.02-.59-.05-.89-.36-1.69-2.13-2.82-3.99-2.57-.27-.7-1.04-1.15-1.86-1.07-.39-1.19-1.59-1.68-2.78-.82M38.2 20.82c1.49.81 2.42-.47 2.65-1.43.21-.9-.13-1.84-.75-2.21 0-.05.01-.11.01-.16 0-.88-.47-1.62-1.09-1.79-.11-.86-.67-1.51-1.34-1.51-.23 0-.44.08-.63.22-.18-1.62-1.22-2.86-2.48-2.86-.57 0-1.09.26-1.51.69-.4-1.15-1.26-1.94-2.27-1.94-.71 0-1.35.39-1.8 1.02-.17-.75-.68-1.31-1.3-1.31s-1.14.56-1.3 1.31c-.4-.36-.88-.57-1.41-.57-.65 0-1.25.34-1.69.89-.23-.23-.51-.38-.82-.38-.75 0-1.36.82-1.36 1.82 0 .08.01.16.02.24-.2-.15-.42-.24-.67-.24-.44 0-.83.29-1.08.72-.25-.44-.64-.72-1.08-.72-.75 0-1.36.82-1.36 1.82 0 .3.06.57.15.82-.16-.04.15.08 0 0-1-.57-3.88.68-.96 5.06M17.88 38.54c.5.91.71 1.32.71 2.12 0 1.85-1.65 3.93-3.39 3.93-.22 0-.43-.02-.64-.07-.16 1.69-1.5 3.01-3.13 3.01-1.74 0-3.15-1.5-3.15-3.35 0-.13 0-.26.02-.39-.09.02-.19.03-.29.03-.88 0-1.59-.76-1.59-1.69 0-.39.13-.75.34-1.04-.67-.2-1.16-.84-1.16-1.62 0-.54.24-1.02.61-1.33-.9-.59-1.49-1.64-1.49-2.85 0-1.35.75-2.51 1.83-3.04-.08-.29-.12-.61-.12-.93 0-1.81 1.34-3.28 3.02-3.34.11-.77.41-1.53 1.15-1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.91 38.92c1.61.67 3.64-.52 4.52-2.66s.47-4.16-1.05-5.03c0 0-.83-.52-2-.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.09 25.61c1.35 3.52 1.02 5.78 1.02 5.78 0 8.29-5.27 15.01-11.77 15.01s-11.93-7.07-11.93-15.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.13 40.93c1.43.54 2.95.3 3.98-.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.12 29.7c.92-1.27 2.76-1.66 4.12-.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.84 29.85c-.82-1.34-2.63-1.86-4.05-1.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.47 31.83s.32 2.11 1.06 2.95c0 0 .02.02.02.03.6.71-.07 1.67-1.1 1.67-.59 0-1.26.1-1.56.48M26.29 31.83s-.32 2.11-1.06 2.95c0 0-.02.02-.02.03-.6.71.07 1.67 1.1 1.67.59 0 1.26.1 1.56.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.26 38.89c-1.01.42-2.08.12-3.02-.69-1-.86-1.71-2.2-1.76-3.52-.02-.54 0-1.26.15-1.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.72",
        cy: "31.04",
        r: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.89",
        cy: "31.04",
        r: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.93 20.7s-3.68-4.56-9.02-2.19c-.48.21-.98.37-1.48.48-.85.19-1.96.41-2.08.27 0 0 2.7 5.25 12.4 4.92 0 0-4.8-.49-5 1.66-.09.95.53 1.57.55 2.97s-.76 2.62-1.14 3.1c0 0 9.95 2.07 5.59-7.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.57 18.21c-8.05-3.71-14.72-.64-17.58 1.26-.71.47-.78.74-.71 1.49l-.11 3.49c.05.5.24.89.77.63 0 0 23.75-4.06 17.64-6.87Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.29 25.3c8.61-4.15 19.8-.27 21.58.4.12.05.25-.04.22-.15l-.65-4.26c-.19-.84-1.9-1.95-2.77-2.38-8.47-4.14-15.78-1.05-18.48.75-.67.44-1.02 1.14-.95 1.84l-.11 3.29c.04.48.67.75 1.16.51Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.17 20.75s-3.81-4.72-9.34-2.26c-.49.22-1.01.38-1.54.5-.88.2-2.03.42-2.15.28 0 0 2.8 5.43 12.85 5.09 0 0-4.97-.51-5.18 1.72-.09.99.55 1.62.57 3.08s-.79 2.71-1.18 3.21c0 0 10.31 2.15 5.79-8"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FirstNationsFemale56 = (FirstNationsFemale56);
;// ./src/Picto/GeneratedPictoComponents/FirstNationsMale104.tsx


var FirstNationsMale104_excluded = ["className"];
function FirstNationsMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FirstNationsMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FirstNationsMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FirstNationsMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FirstNationsMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FirstNationsMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FirstNationsMale104_objectSpread(FirstNationsMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.97 94.26s-1.28 2.14-3.12 0c-1.85-2.14-3.55-7.87-9.52-5.67-5.97 2.21-11.87 8.48-14.44 6.62-2.57-1.86 10.12-9.17 10.12-9.17l2.92-1.62 3.81-1.15.82-5.41L85.68 81l3.76 7.06 1.55 6.21ZM13.93 94.02s1.21 2.02 2.95 0 3.35-7.43 8.99-5.35c5.63 2.08 11.2 8 13.63 6.25 2.43-1.76.58-1.92.58-1.92l-5.14-4.85-10.74-5.99-.88-4.5-4.37 3.85-3.55 6.66-1.47 5.86Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.09 66.06s-9.03 9.88-7.2 16.64c0 0 11.72 3.1 18 12.54 0 0 1.88-3.48-.12-5.89M91 95.79s-.04-.86-.27-2.25c-1.01-6.02-4.16-11.45-8.7-15.53-.79-.71-1.58-1.35-2.22-1.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.53 66.63s9.03 9.88 7.2 16.64c0 0-11.72 3.1-18 12.54 0 0-2.52-3.64-.52-6.05M13 95.79s.04-.86.27-2.25c1.01-6.02 4.16-11.45 8.7-15.53.79-.71 1.58-1.35 2.22-1.73"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.03 26.17c-.88 1.03-2.17 1.7-3.63 1.7s-2.85-.72-3.73-1.83c-.88 1.1-2.21 1.83-3.73 1.83-.6 0-1.17-.12-1.7-.33-.55 2.03-2.39 3.54-4.59 3.54-.77 0-1.48-.2-2.12-.52.52.94 1.87 3.99.8 7.16-1 2.95-1.88 3.03-3.92 4.16.26.65.62 2.63.62 3.37 0 1.86-.14 3.1-1.51 4.15 1.56.8 2.64 2.41 2.64 4.29 0 1.28-.51 2.43-1.32 3.3.25.46.41.98.41 1.54a3.24 3.24 0 1 1-6.4-.7c-1.41-.85-2.37-2.37-2.37-4.14 0-1.38.59-2.62 1.52-3.5a5.72 5.72 0 0 1-3.66-5.33c0-1.81.85-3.43 2.16-4.48-.6-1-.96-2.17-.96-3.42a6.6 6.6 0 0 1 1.54-4.24 4.829 4.829 0 0 1-1.42-3.43 4.82 4.82 0 0 1 3.56-4.65 5.672 5.672 0 0 1 5.22-7.88h.03c.25-2.9 2.65-6.01 5.62-6.01 1.17 0 2.33.38 3.23.98.69-1.83 2.56-3.21 4.63-3.21 1.46 0 4.35.47 5.23 1.49 0 0 8.88 4.97 3.87 16.17ZM58.71 68.11l-3.29-1.27-2.36-.21-8.02 1.35-2.26 3.03-2.93-1.26-3.08-2.41-3.28-4.83-2.48 1.09.82 9.34 3.25 8.46 4.78 6.29 8.4 4.6h8.75l4.66-2.19c10.39-16.08-2.95-22-2.95-22Zm1.62 12c-1.6.75-2.84 1.22-4.9-.71h-4.92c-2.06 1.93-3.94 1.19-4.9.71-2.51-1.24-3.83-5.38-1.26-6.51 1.26-.62 8.59-3.77 8.63-3.8 0 0 1.84.8 3.84 1.66 2 .88 4.16 1.83 4.79 2.14 1.84.7 1.25 5.3-1.26 6.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.93 37.7c.08-.04 7.04-2.43 14.3.1M47.5 41.81c.05-.02 4.72-1.63 9.59.07M60.6 59.57s2.45 2.16 1.86 6.23M42.02 65.82c-.72-4.05 1.65-6.29 1.65-6.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.94 50.68c1.67-2.3 5.01-3.01 7.47-1.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.8 50.94c-1.49-2.42-4.77-3.38-7.33-2.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.07 54.54s.58 3.83 1.92 5.34c.02.02.03.03.04.05 1.09 1.28-.12 3.02-1.99 3.02-1.07 0-2.29.17-2.83.87M49.31 54.54s-.58 3.83-1.92 5.34c-.02.02-.03.03-.04.05-1.09 1.28.12 3.02 1.99 3.02 1.07 0 2.29.17 2.83.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.09 43.07c1.63-1.03 2.72-2.84 2.72-4.91s-1.08-3.88-2.71-4.91c1.13-.91 1.86-2.28 1.86-3.84 0-2.28-1.55-4.19-3.65-4.76.3-.7.46-1.46.46-2.27 0-3.15-2.5-5.7-5.63-5.8a3.312 3.312 0 0 0-3.3-3.09c-.24 0-.48.03-.7.08a4.87 4.87 0 0 0-4.19-2.4c-.72 0-1.39.16-2.01.44a5.81 5.81 0 0 0-5.13-3.09c-1.62 0-3.09.67-4.14 1.74-.91-1.05-2.23-1.72-3.73-1.72-2.12 0-3.92 1.34-4.63 3.21-.92-.62-2.03-.98-3.23-.98-3.04 0-5.53 2.33-5.79 5.3h-.03c-3.21 0-5.81 2.6-5.81 5.81 0 .8.16 1.57.46 2.27-2.1.58-3.65 2.48-3.65 4.76 0 1.37.56 2.61 1.46 3.51a6.773 6.773 0 0 0-1.57 4.35c0 1.28.36 2.48.98 3.5a5.848 5.848 0 0 0-2.22 4.59 5.87 5.87 0 0 0 3.76 5.47c-.95.9-1.55 2.17-1.55 3.59 0 1.81.98 3.38 2.43 4.24a3.325 3.325 0 0 0 3.24 4.04c1.83 0 3.32-1.49 3.32-3.32 0-.57-.16-1.11-.42-1.58.83-.89 1.35-2.07 1.35-3.38 0-1.92-1.11-3.57-2.71-4.4 1.4-1.07 1.55-2.35 1.55-4.25 0-.76-.38-2.79-.64-3.45 2.09-1.16 3-1.23 4.02-4.26 1.1-3.25-.29-6.37-.81-7.34.66.33 1.39.53 2.17.53 2.26 0 4.14-1.54 4.71-3.62.54.21 1.13.33 1.74.33 1.56 0 2.93-.74 3.82-1.87.9 1.13 2.27 1.87 3.82 1.87s2.82-.69 3.72-1.74c.9 1.06 2.22 1.74 3.72 1.74.5 0 .97-.1 1.42-.23a5.963 5.963 0 0 0 5.89 5.05c.32 0 .63-.03.94-.08a5.79 5.79 0 0 0 2.06 7.59c-1.13.91-2.14 3.65-1.94 5.2.37 2.83 1.99 3.65 2.74 4.52-.75.87-2.2 2.64-2.2 3.88 0 1.32.52 2.5 1.36 3.39-.77.61-1.27 1.54-1.27 2.6 0 1.83 1.49 3.32 3.32 3.32a3.325 3.325 0 0 0 3.06-4.61c2-.64 3.45-2.49 3.45-4.7 0-1.24-.47-2.36-1.22-3.23.75-.87 1.22-1.99 1.22-3.23 0-1.56-.74-2.94-1.87-3.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.37 92.09c-15.31-.33-18.42-19.26-18.84-27.78-.07-1.49 1.57-2.21 2.4-1.04 2.51 3.51 6.79 8.76 8.86 6.93 3.24-2.88 6.4-3.56 8.8-3.56h1.48c2.4 0 6.02.69 9.26 3.56 2.07 1.83 6.16-3.42 8.66-6.93.82-1.16 2.47-.45 2.4 1.04-.42 8.52-4 27.22-18.84 27.78 0 0-1.24.06-4.17 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.68 80.13c-1.54.73-2.73 1.18-4.71-.68h-4.73c-1.98 1.86-3.78 1.15-4.71.68-2.41-1.19-3.68-5.16-1.22-6.25 1.22-.6 8.25-3.63 8.29-3.66s7.08 3.07 8.29 3.66c1.77.67 1.2 5.09-1.22 6.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.76 75.09c1.11 1.02 3.75 1.27 5.18-.05"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.68",
        cy: "53.66",
        r: "1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.01",
        cy: "53.66",
        r: "1.94"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FirstNationsMale104 = (FirstNationsMale104);
;// ./src/Picto/GeneratedPictoComponents/FirstNationsMale56.tsx


var FirstNationsMale56_excluded = ["className"];
function FirstNationsMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FirstNationsMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FirstNationsMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FirstNationsMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FirstNationsMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FirstNationsMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FirstNationsMale56_objectSpread(FirstNationsMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.96 14.6c-.49.58-.85.58-1.67.58s-1.16-.19-1.65-.81c-.49.62-2.07 1.19-2.92 1.19-.34 0-.66-.07-.96-.18a2.682 2.682 0 0 1-2.59 1.99c-.43 0-.83-.11-1.19-.29.29.53 1.05 2.25.45 4.04-.56 1.66-1.06 1.7-2.21 2.34.14.37.35 1.48.35 1.9 0 1.05-.08 1.75-.85 2.34.88.45 1.49 1.36 1.49 2.42 0 .72-.29 1.37-.74 1.86.14.26.23.55.23.87a1.83 1.83 0 0 1-3.66 0c0-.14.02-.27.05-.39a2.71 2.71 0 0 1-.48-4.3 3.22 3.22 0 0 1-.84-5.53c-.34-.56-.54-1.22-.54-1.93 0-.91.33-1.74.86-2.39-.5-.49-.8-1.18-.8-1.93 0-1.26.85-2.3 2.01-2.62-.16-.38-.25-.8-.25-1.25 0-1.76 1.56-3.71 3.32-3.71 0 0-.12.52-.11.52.14-1.63 1.49-3.39 3.16-3.39.66 0 1.31.21 1.82.55.39-1.03 1.44-1.81 2.61-1.81.82 0 2.45.26 2.95.84 0 0 5 2.8 2.18 9.11ZM31.86 38l-2.24-.48-1.33-.12-4.52.76-1.06 1.07-1.87-.08-1.45-1.7-2.13-2.37-.88.84.63 4.83 1.49 4.62 2.35 3.9 5.03 2.19 4.6-.03 2.66-.8C39 41.57 31.87 38 31.87 38Zm.52 6.99c-.9.42-1.6.69-2.76-.4h-2.77c-1.16 1.09-2.22.67-2.76.4-1.41-.7-2.16-3.03-.71-3.67.71-.35 4.84-2.12 4.86-2.14 0 0 1.04.45 2.16.94 1.12.49 2.34 1.03 2.7 1.21 1.04.39.71 2.99-.71 3.67Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.92 20.96s3.96-1.36 8.04.06M25.36 23.27s2.66-.92 5.39.04M32.73 33.26s1.38 1.21 1.05 3.5M22.28 36.77c-.41-2.28.93-3.53.93-3.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.11 28.26c.94-1.3 2.82-1.69 4.2-.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.09 28.4c-.84-1.36-2.68-1.9-4.12-1.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.62 30.43s.33 2.15 1.08 3l.03.03c.61.72-.07 1.7-1.12 1.7-.6 0-1.29.1-1.59.49M26.38 30.43s-.33 2.15-1.08 3l-.03.03c-.61.72.07 1.7 1.12 1.7.6 0 1.29.1 1.59.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42 23.98c.92-.58 1.53-1.6 1.53-2.76s-.61-2.18-1.53-2.76c.63-.51 1.05-1.28 1.05-2.16 0-1.28-.87-2.35-2.05-2.68a3.26 3.26 0 0 0-2.9-4.53c-.07-.97-.87-1.74-1.85-1.74-.14 0-.27.02-.4.04a2.73 2.73 0 0 0-2.36-1.35c-.4 0-.78.09-1.13.25a3.283 3.283 0 0 0-2.89-1.74c-.91 0-1.74.37-2.33.98-.51-.59-1.26-.97-2.1-.97-1.19 0-2.2.75-2.6 1.81a3.23 3.23 0 0 0-1.82-.55c-1.71 0-3.11 1.31-3.25 2.98h-.01c-1.8 0-3.27 1.46-3.27 3.27 0 .45.09.88.26 1.27a2.772 2.772 0 0 0-2.05 2.68c0 .77.31 1.47.82 1.98-.55.66-.88 1.51-.88 2.44 0 .72.2 1.39.55 1.97-.76.6-1.25 1.53-1.25 2.58 0 1.4.88 2.6 2.11 3.07-.54.51-.87 1.22-.87 2.02 0 1.02.55 1.9 1.36 2.39-.03.13-.05.26-.05.4 0 1.03.84 1.87 1.87 1.87s1.87-.84 1.87-1.87c0-.32-.09-.62-.23-.89.47-.5.76-1.16.76-1.9 0-1.08-.62-2.01-1.52-2.47.79-.6.87-1.32.87-2.39 0-.43-.21-1.57-.36-1.94 1.17-.65 1.69-.69 2.26-2.39.62-1.83-.16-3.58-.46-4.13.37.18.78.3 1.22.3 1.27 0 2.33-.87 2.65-2.04.31.12.63.19.98.19.87 0 1.65-.42 2.15-1.05.5.64 1.27 1.05 2.15 1.05s1.59-.39 2.09-.98c.5.59 1.25.98 2.09.98.28 0 .54-.05.8-.13a3.349 3.349 0 0 0 3.31 2.84c.18 0 .36-.02.53-.05-.24.45-.37.96-.37 1.51 0 1.17.61 2.19 1.53 2.76-.64.51-1.2 2.05-1.09 2.93.21 1.59 1.12 2.05 1.54 2.54-.42.49-1.24 1.49-1.24 2.18 0 .74.29 1.41.76 1.91-.43.34-.72.87-.72 1.46 0 1.03.84 1.87 1.87 1.87s1.87-.84 1.87-1.87c0-.26-.05-.5-.15-.72a2.78 2.78 0 0 0 1.94-2.64c0-.7-.26-1.33-.69-1.81.42-.49.69-1.12.69-1.81 0-.88-.42-1.65-1.05-2.17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.98 51.54c-8.61-.19-10.36-10.83-10.59-15.62-.04-.84.88-1.24 1.35-.59 1.41 1.97 3.82 4.93 4.98 3.9 1.82-1.62 3.6-2 4.95-2h.83c1.35 0 3.38.39 5.2 2 1.16 1.03 3.46-1.92 4.87-3.9.46-.65 1.39-.25 1.35.59-.24 4.79-2.25 15.31-10.59 15.62 0 0-.7.04-2.34 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.21 44.82c-.86.41-1.53.66-2.65-.38H26.9c-1.12 1.05-2.13.64-2.65.38-1.35-.67-2.07-2.9-.68-3.51.68-.34 4.64-2.04 4.66-2.06s3.98 1.72 4.66 2.06c1 .38.68 2.86-.68 3.51Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.63 41.98c.62.57 2.11.71 2.91-.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24",
        cy: "29.6",
        r: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.18",
        cy: "29.6",
        r: "1"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FirstNationsMale56 = (FirstNationsMale56);
;// ./src/Picto/GeneratedPictoComponents/HijabFemale104.tsx


var HijabFemale104_excluded = ["className"];
function HijabFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function HijabFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? HijabFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HijabFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function HijabFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, HijabFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", HijabFemale104_objectSpread(HijabFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.85 93.2s5.64-.13 2.77.97c-5.65 2.16-14.89 2.63-24.04-3.02-5.2-3.22 3.42-4.21 3.42-4.21s3.08 1.59 8.38 3.61c6.88 2.63.46.18 9.47 2.65Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.3 69.96c-.76-.54-2.89-.31-5.47-1.85-4.04-2.42-5.15-5.8-7.64-9.5-4.96-7.38-5.24-19.99-2.08-28.14 1.19-3.06 2.44-6.18 4.56-8.85 1.41-1.77 3.29-3.18 5.4-4.26 1.77-.91 3.67-1.6 5.59-2.23 1.28-.42 2.71-.72 3.93-1.26 1.03-.45 2-4.04.04-4.99-.74-.36.04-.39-.9-.5-.51-.06-1.04-.02-1.55 0-8.2.39-15.93 5.47-19.06 10.13-.26.38-.98 1.17-1.19 1.58-.38.46-1.04 2.82-1.28 3.36-3.05 6.73-3.87 12.23-2.49 19.46.59 3.1 3.09 6.4 4.01 9.44 1.48 8.27 1.26 12.83-1.92 20.02-.79 1.79-3.22 5.36-3.3 7.11-.44 1.78-.54 4.24.82 5.99.22.28 1.67 1.15 1.98 1.26 1.95 2.69 3.87 2.65 7.12 4 .56.23 13.28 3.04 13.7 2.87 0 0 15-12.78-.23-23.63Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.93 14.41c.2.04.39.09.58.16 1.13.43 1.4 1.7 1.25 2.79-.43 3.18-3.41 4.86-6 6.17-2.07 1.05-5.46 1.85-7.52 2.93-.31.16-.61.32-.92.49l-5.14 3.04c.15-.09.28-.98.34-1.14.33-.99.72-1.96 1.17-2.9 1.37-2.87 3.27-5.53 5.72-7.59a17.42 17.42 0 0 1 4.81-2.88c.96-.38 1.95-.68 2.96-.89.87-.18 1.85-.35 2.75-.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M70.35 31.2c-3.46-9.43-10.68-16.51-19-16.51s-15.82 7.43-19.27 16.88",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.18 85.85c2.6 2.37 4.4 5.33 5.65 8.31M51.33 44.56c0 4.29 2.8 4.49 2.8 6.95s-2.86 2.57-2.86 2.57M39.89 40.72c1.83-2.17 5.21-2.63 7.55-1.02M55.16 39.51c2.42-1.47 5.77-.83 7.48 1.44M49.38 61.12c2.26 1.28 4.67.11 5.71-.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.69 31.93a37.83 37.83 0 0 1 1.53 10.72c0 15.77-9.37 28.55-20.94 28.55S30.34 58.42 30.34 42.65c0-3.6.49-7.05 1.38-10.23.06-.2.13-.39.22-.57.21-.43.5-.8.87-1.1 3.29-2.65 20.4-14.92 37.5.47l.38.7ZM24.7 86.18c-2.6 2.37-4.4 5.33-5.65 8.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.98",
        cy: "44.25",
        r: "1.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.89",
        cy: "44.25",
        r: "1.94"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.3 18.43c-3.86 4.65-5.93 10.41-6.19 16.19-.24 5.4 1.04 10.8 3.36 15.78 2.08 4.45 3.12 10.18 1.93 14.95-.76 3.04-2.18 5.93-3.73 8.72-1.45 2.61-3.06 5.46-2.33 8.3.85 3.3 4.22 4.94 7.32 6.45 3.31 1.61 6.84 2.85 10.49 3.69 7.3 1.69 15.08 1.8 22.41.17l.22-.05c4.78-1.09 9.54-2.99 12.64-6.39 1.9-2.08 3.02-4.77 2.98-7.45-.05-3.21-2.29-5.45-3.74-8.25-1.6-3.08-2.12-6.52-2.05-9.91.2-9.95 5-19.61 3.52-29.61C75.4 19.29 63.75 7.9 49.68 8.69c-7.09.4-13.8 3.7-18.33 8.54-.36.39-.71.78-1.05 1.18Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_HijabFemale104 = (HijabFemale104);
;// ./src/Picto/GeneratedPictoComponents/HijabFemale56.tsx


var HijabFemale56_excluded = ["className"];
function HijabFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function HijabFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? HijabFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : HijabFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function HijabFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, HijabFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", HijabFemale56_objectSpread(HijabFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.11 38.07c-.41-.29-1.56-.17-2.94-1-2.17-1.3-2.77-3.12-4.11-5.11-2.67-3.97-2.82-10.76-1.12-15.15.64-1.65 1.31-3.33 2.45-4.76.76-.95 1.77-1.71 2.9-2.29.95-.49 1.98-.86 3.01-1.2.69-.23 1.46-.39 2.12-.68.55-.24 1.08-2.18.02-2.69-.4-.19.02-.21-.49-.27-.28-.03-.56 0-.84 0-4.41.21-8.57 2.94-10.26 5.45-.14.21-.53.63-.64.85-.2.25-.56 1.52-.69 1.81-1.64 3.62-2.09 6.58-1.34 10.47.32 1.67 1.66 3.44 2.16 5.08.8 4.45.68 6.9-1.03 10.78-.42.96-1.74 2.88-1.78 3.82-.24.96-.29 2.28.44 3.22.12.15.9.62 1.06.68 1.05 1.45 2.08 1.43 3.83 2.15.3.12 7.15 1.64 7.37 1.55 0 0 8.07-6.88-.12-12.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.07 8.18c.11.02.21.05.31.08.61.23.75.92.68 1.5-.23 1.71-1.84 2.61-3.23 3.32-1.12.57-2.94.99-4.05 1.58-.17.09-.33.17-.5.26l-2.77 1.64c.08-.05.15-.53.18-.61.18-.53.39-1.05.63-1.56.74-1.55 1.76-2.98 3.08-4.08a9.48 9.48 0 0 1 2.59-1.55c.52-.21 1.05-.36 1.59-.48.47-.1.99-.19 1.48-.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.02 16.81c-1.91-5.21-5.9-9.12-10.5-9.12s-8.74 4.1-10.64 9.32",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.54 24.04c0 2.36 1.54 2.47 1.54 3.82s-1.57 1.41-1.57 1.41M21.25 21.92c1.01-1.19 2.86-1.44 4.15-.56M29.65 21.26c1.33-.81 3.18-.45 4.11.79M26.47 33.15c1.24.71 2.57.06 3.14-.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.19 17.09c.54 1.82.84 3.81.84 5.9 0 8.67-5.16 15.71-11.52 15.71s-11.52-7.03-11.52-15.71c0-1.98.27-3.88.76-5.63.03-.11.07-.21.12-.31.11-.23.28-.44.48-.6 1.81-1.46 11.22-8.21 20.63.26l.21.38Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.43",
        cy: "24.04",
        r: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.6",
        cy: "24.04",
        r: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16 10.2c-2.09 2.51-3.2 5.62-3.34 8.74-.13 2.91.56 5.83 1.81 8.52 1.12 2.4 1.68 5.5 1.04 8.07-.41 1.64-1.18 3.2-2.01 4.71-.78 1.41-1.65 2.95-1.26 4.48.46 1.78 2.28 2.67 3.95 3.48 1.78.87 3.69 1.54 5.66 1.99 3.94.91 8.14.97 12.1.09l.12-.03c2.58-.59 5.15-1.62 6.82-3.45 1.02-1.12 1.63-2.58 1.61-4.02-.03-1.73-1.24-2.94-2.02-4.45-.86-1.66-1.14-3.52-1.11-5.35.11-5.37 2.7-10.58 1.9-15.98-.94-6.33-7.22-12.48-14.81-12.05-3.82.22-7.45 2-9.9 4.61-.2.21-.38.42-.56.64Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_HijabFemale56 = (HijabFemale56);
;// ./src/Picto/GeneratedPictoComponents/MIddleAgeFemale56.tsx


var MIddleAgeFemale56_excluded = ["className"];
function MIddleAgeFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MIddleAgeFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MIddleAgeFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MIddleAgeFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MIddleAgeFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MIddleAgeFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MIddleAgeFemale56_objectSpread(MIddleAgeFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.71 13.83c3.11-2.19 7.48-1.48 11.21-.82.1.02.19.02.29.02.24.9 2.14.49 1.97-.46-.58-3.15-3.96-5.65-8.27-5.82-5.32-.22-6.82 3.21-6.96 6.55-.03.69 1.13.98 1.76.54ZM25.49 15.17c-7.02.21-11.58 6.42-12.84 12.89-.23 1.18 1.36 1.75 1.86.88.14.07.3.12.48.15 3.56.42 7.11.47 10.68.16.19.12.4.24.67.35.52.22 1.05-.19 1.23-.68.04 0 .08.02.13.02l2.84.24c.19.02.35-.02.48-.08.42 0 .86-.01 1.31-.04 1.26.42 2.7.28 4.06.09.42-.06.77-.59.76-1-.26-6.51-4.58-13.17-11.65-12.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.24",
        cy: "34.82",
        r: "1.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.48",
        cy: "34.82",
        r: "1.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.28 31.73c-.32 0-.64.07-.95.2-1.76.73-2.39 3.21-1.42 5.56.9 2.18 2.88 3.46 4.56 3.04M38.31 40.53c1.68.42 3.66-.87 4.56-3.04.97-2.34.33-4.83-1.42-5.56-.32-.13-.65-.2-.98-.2M27.92 35.03c0 2.58 1.69 2.7 1.69 4.19s-1.72 1.55-1.72 1.55M30.18 32.4c1.27-1.15 3.32-1.15 4.59 0M20.94 32.45c1.27-1.15 3.32-1.15 4.59 0M26.68 45.05c1.36.77 2.81.07 3.44-.52M18.79 16.97c-.27-.87-.14-1.63-.14-2.59a9.18 9.18 0 1 1 18.36 0c0 .95.05 2.21-.09 3.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.74 29.29H12.92c0-8.24 6.41-14.91 14.65-14.91s15.18 6.67 15.18 14.91Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.45 29.28c.12 1.45.05 3.03-.26 4.72-1.69 9.6-7.2 17.1-12.31 17.09-5.1.01-10.61-7.49-12.31-17.09-.3-1.66-.37-3.21-.26-4.64"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.07 13.19-.36 3.98c-3.67-2.18-6.16-2.74-8.94-2.74s-5.61.73-8.59 2.74l-.26-3.8c.56-.18 1.31-.42 1.88-.61 4.03-1.34 8.42-1.51 12.56-.51 1.03.25 2.25.56 3.7.94Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.29 13.02-.37 4.53c-3.81-2.49-6.39-3.12-9.27-3.12s-5.83.63-8.92 2.93l-.26-4.14c.58-.21 1.36-.48 1.95-.69 4.18-1.53 8.73-1.72 13.03-.58 1.07.28 2.34.64 3.84 1.07Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MIddleAgeFemale56 = (MIddleAgeFemale56);
;// ./src/Picto/GeneratedPictoComponents/MiddleAgeFemale104.tsx


var MiddleAgeFemale104_excluded = ["className"];
function MiddleAgeFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MiddleAgeFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MiddleAgeFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MiddleAgeFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MiddleAgeFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MiddleAgeFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MiddleAgeFemale104_objectSpread(MiddleAgeFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.7 80.96c-5.81 2.95-15.21 4.19-20.67.28-.14-.1-.35-.06-.52-.06-.34-1.41-3.79-1.01-3.58.46.71 4.86 6.66 8.43 14.38 9.22 9.53.98 12.43-3.41 13.03-8.47.12-1.05-1.47-2.02-2.64-1.43ZM41.74 21.28c4.51-3.17 10.83-2.14 16.24-1.19.14.02.28.03.42.03.35 1.31 3.1.71 2.85-.67-.83-4.56-5.73-8.18-11.98-8.44-7.71-.32-9.88 4.65-10.08 9.48-.04 1 1.64 1.43 2.54.79ZM48.66 23.22c-10.17.3-16.77 9.31-18.6 18.67-.34 1.71 1.97 2.53 2.7 1.27.2.11.43.18.7.21 5.16.61 10.3.68 15.47.23.27.18.59.34.96.5.75.32 1.53-.28 1.79-.98.06.01.12.03.18.03 1.37.11 2.74.23 4.11.34.27.02.5-.02.7-.11.61 0 1.25-.02 1.89-.06 1.83.61 3.91.41 5.88.12.62-.09 1.12-.86 1.09-1.45-.38-9.43-6.63-19.07-16.87-18.76Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.7 79.92c2.29-2.15 2.76-4.31 2.85-8.55M25.64 95.74c1.05-2.95 2.63-5.88 5-8.09.68-.63 1.37-1.23 2.07-1.81M63.32 79.89c-2.23-2.11-2.72-3.86-2.83-7.96M78.36 95.11c-1.05-2.73-2.57-5.41-4.77-7.46-.67-.62-1.35-1.21-2.03-1.78M62.94 79.89c-3.59 2.92-6.42 4.39-11.07 4.39s-7.49-1.47-11.07-4.39M32.31 95.42l.63-9.38M71.89 95.67l-.61-9.63M33.63 47.33c-.48.01-.95.11-1.4.29-2.59 1.07-3.52 4.73-2.1 8.18 1.33 3.21 4.24 5.1 6.72 4.48M67.56 60.29c2.48.62 5.39-1.28 6.72-4.48 1.43-3.45.49-7.11-2.1-8.18-.47-.19-.95-.29-1.45-.3M52.26 52.18c0 3.81 2.49 3.98 2.49 6.17s-2.53 2.28-2.53 2.28M55.59 48.32c1.87-1.69 4.89-1.69 6.76 0M41.98 48.38c1.87-1.69 4.89-1.69 6.76 0M50.43 66.95c2.01 1.14 4.14.1 5.07-.76M39.22 25.83c-.4-1.28-.62-2.64-.62-4.05 0-7.46 6.05-13.51 13.51-13.51s13.51 6.05 13.51 13.51c0 1.4-.21 2.75-.61 4.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.08 43.74H30.16c0-12.13 9.44-21.96 21.57-21.96s22.35 9.83 22.35 21.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.71 43.71c.17 2.14.07 4.46-.38 6.96-2.5 14.14-10.61 25.18-18.12 25.16-7.52.02-15.63-11.03-18.12-25.16-.44-2.45-.55-4.73-.39-6.83M32.93 85.68c2.22-1.83 4.29-3.24 6.39-4.78.56-.41 1.74-1.42 2.17-1.81M71.56 85.87c-2.24-1.84-4.76-3.38-6.88-4.93-.57-.42-1.06-.82-1.49-1.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.2",
        cy: "52.18",
        r: "1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.77",
        cy: "52.18",
        r: "1.72"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m65.87 19.76-.55 6.07c-5.61-3.34-9.41-4.19-13.66-4.19s-8.57 1.11-13.12 4.19l-.4-5.81c.86-.28 2-.64 2.88-.93 6.16-2.05 12.86-2.31 19.2-.77 1.57.38 3.44.85 5.66 1.44Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m65.94 19.71-.55 6.67c-5.61-3.66-9.41-4.6-13.66-4.6s-8.57 1.22-13.12 4.6l-.4-6.38c.86-.31 2-.7 2.88-1.02a31.956 31.956 0 0 1 19.2-.85c1.57.42 3.44.94 5.66 1.58Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MiddleAgeFemale104 = (MiddleAgeFemale104);
;// ./src/Picto/GeneratedPictoComponents/MiddleAgeMale104.tsx


var MiddleAgeMale104_excluded = ["className"];
function MiddleAgeMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MiddleAgeMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MiddleAgeMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MiddleAgeMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MiddleAgeMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MiddleAgeMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MiddleAgeMale104_objectSpread(MiddleAgeMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.21 24.87c0-.12-.09-.25-.04-.36.91-1.96 2.75-4.38.87-7.17 0-.01-1.99-4.34-3.29-3.51-4.54 2.91-10.24 1.73-15.22 1.07-4.68-.62-9.5-.42-13.6 2.18-6.97 4.42-9.37 10.18-10.06 17.93-.12 2.84.52 4.78.56 4.35-.02.23 1.09 1.99 1.75 1.16.48-.6 1.04-3.88 1.04-3.88 2.59-10.86 8.87-19.28 17.77-19.28s18.66 6.94 19.17 18.25c.28.91.55 2.21.54 2.55.07.34.42 1.83.48 2.18.57 1.1 2.42-.4 2.53-2.09.03-.42 1.42-7.55-2.5-13.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.43 87.05c-.39-.24-.67.27-.34.59 1.71 1.68.68 6.62 3.36 7.39-.02.33.82-.47 1.02-.69.37-.39 1.82-1.21 1.73-2.45.29-1.59-3.83-3.93-5.76-4.84Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.37 87.31c.36-.22.63.25.32.55-1.6 1.57-.63 6.19-3.14 6.91.02.3-.76-.44-.96-.64-.35-.36-1.7-1.13-1.61-2.29-.27-1.49 3.58-3.67 5.39-4.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.71 85.68s1.21.02.32 1.97c-1.53 3.34-10.64 7.43-15.92 4.25-3.58-2.15-.72-6.2-.72-6.2s3.55 3.27 7.49 3.07c5.11-.25 3.9-.47 8.83-3.1ZM62.9 62.38h-.02c-7.05-6.14-11.59-5.38-11.64-5.36 0 0-.19-.03-.56-.03-1.41 0-5.43.5-11.07 5.39h-.02l-.56-1.98c-.88-1.39-5.86.52-6.77-6.47 0 0-2.57 6.49-.18 9.33.37.45-1.3 3.19 6.22 10.45 0 0 .42-.43.57-1.23 0 0 4.33 6.95 12.46 6.96h.16c8.14 0 3.49-1.2 3.49-1.2s10.93-5.55 7.92-15.86Zm-5.01 6.86c-1.41.67-2.51 1.09-4.34-.63h-4.36c-1.83 1.72-3.49 1.05-4.34.63-2.22-1.1-3.39-4.76-1.12-5.75 1.12-.55 7.6-3.35 7.64-3.38l3.4 1.48c1.78.78 3.68 1.62 4.24 1.9 1.63.61 1.11 4.68-1.12 5.75Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.13 41.31s1.77.14 1.77-6.02-3.16-9.87-3.16-9.87c6.18-9.95-5.85-16.96-5.85-16.96-3.33 2.88-9.03 2.81-12.83 2.81-15.59 0-21.95 12.28-21.95 24.02 0 6.16 1.77 6.02 1.77 6.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.58 41.9c2.27.18 3.92 2.77 3.68 5.78-.24 3.01-2.27 5.3-4.54 5.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.96 41.9c1.3-14.81 8.95-24.56 20-24.56S70 27.35 71.72 42.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.5 94.76c1.15-9.77 5.3-16.52 5.3-16.52M73.57 86.74l-6.04 5.05 3.86 3.42M43.37 94.09c-1.25-9.41-5.21-15.85-5.21-15.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.31 73.93c.16.29 1.35 2.44 1.51 2.72 1.67 2.81 3.75 5.23 6.05 7.27l13.14 11.62M40.61 73.93c-.16.29-1.27 2.44-1.43 2.72-1.67 2.81-3.75 5.23-6.05 7.27L19.99 95.54M30.54 86.56l6.05 5.06-3.87 3.41M62.83 84.47c-3.34 2.47-7.04 3.83-10.92 3.83s-7.52-1.34-10.83-3.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.53 52.3s2.4 7.59-.02 10.48c-.38.46 1.31 3.25-6.33 10.64 0 0-.43-.44-.59-1.25 0 0-4.07 7.08-12.37 7.08h-.16c-8.29 0-12.69-7.09-12.69-7.09-.16.81-.59 1.25-.59 1.25-7.65-7.39-5.95-10.18-6.33-10.64-2.42-2.89-.49-10.47-.49-10.47.94 7.12 5.7 7.41 7.58 7.56l.57 2.02h.02c7.22-6.27 11.85-5.46 11.85-5.46s4.67-.79 11.85 5.46h.02l.57-2.02s6.26.98 7.12-7.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.73 69.43c-1.44.68-2.56 1.11-4.42-.64h-4.44c-1.86 1.75-3.55 1.07-4.42.64-2.26-1.12-3.45-4.84-1.14-5.86 1.14-.56 7.74-3.4 7.78-3.43s6.64 2.88 7.78 3.43c1.66.63 1.13 4.78-1.14 5.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.47 64.88c1.16.91 2.39.51 3.24-.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.42 41.9c-2.27.18-3.92 2.77-3.68 5.78.24 3.01 2.27 5.3 4.54 5.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.76",
        cy: "46",
        r: "1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.14",
        cy: "46",
        r: "1.82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.89 46.2c0 4.15-3.15 6.66-7.05 6.66s-6.12-1.49-6.12-5.64c0-3.8.77-6.02 5.76-6.02 3.8 0 7.39.24 7.39 4.99h.01ZM53.98 46.2c0 4.15 3.15 6.66 7.05 6.66s6.12-1.49 6.12-5.64c0-3.8-.77-6.02-5.76-6.02-3.8 0-7.39.24-7.39 4.99h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.89 46.2c0-1.2.92-1.64 2.05-1.64s2.05.44 2.05 1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.02 41.48 5.71 3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m72.85 41.48-5.71 3.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.09 46.45c-.11 2.76 1.77 2.81 1.77 4.86 0 2.42-2.06 2.61-2.06 2.61"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MiddleAgeMale104 = (MiddleAgeMale104);
;// ./src/Picto/GeneratedPictoComponents/MiddleAgeMale56.tsx


var MiddleAgeMale56_excluded = ["className"];
function MiddleAgeMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MiddleAgeMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MiddleAgeMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MiddleAgeMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MiddleAgeMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MiddleAgeMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MiddleAgeMale56_objectSpread(MiddleAgeMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.19 15.46c0-.08-.06-.16-.03-.24.59-1.28 1.8-2.86.57-4.68 0 0-1.3-2.83-2.15-2.29-2.96 1.9-6.69 1.13-9.94.7-3.06-.4-6.2-.27-8.88 1.42-4.55 2.89-6.12 6.65-6.57 11.71-.08 1.85.34 3.12.37 2.84-.01.15.71 1.3 1.14.76.31-.39.68-2.53.68-2.53 1.69-7.09 5.79-12.59 11.6-12.59s12.18 4.53 12.52 11.91c.18.59.36 1.44.35 1.66.05.22.27 1.19.31 1.42.37.72 1.58-.26 1.65-1.36.02-.27.93-4.93-1.63-8.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.24 39.99h-.01c-4.55-3.96-7.28-3.96-7.31-3.95 0 0-.12-.02-.36-.02-.91 0-3.7.81-7.33 3.96h-.01l-.36-1.28c.61-1.62-4.58.34-5.17-4.18 0 0-1.4 3.96.14 5.8.24.29-.69 2.31 4.16 6.99 0 0 .66-.3.76-.81 0 0 2.79 4.49 8.04 4.49h.1c5.12-.63 2.21-.33 2.21-.33s7.1-4.02 5.16-10.67ZM32 44.42c-.91.43-1.62.7-2.8-.41h-2.81c-1.18 1.11-2.25.68-2.8.41-1.43-.71-2.19-3.07-.72-3.71.72-.35 4.9-2.16 4.93-2.18l2.19.96c1.15.5 2.38 1.05 2.74 1.22 1.05.39.72 3.02-.72 3.71Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.87 26.24s1.16.09 1.16-3.95-2.08-6.48-2.08-6.48c4.06-6.53-3.84-11.14-3.84-11.14-2.19 1.89-5.93 1.85-8.43 1.85-10.24 0-14.42 8.06-14.42 15.78 0 4.05 1.16 3.95 1.16 3.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.17 26.62c1.49.12 2.57 1.82 2.41 3.79s-1.49 3.48-2.98 3.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.49 26.62c.85-9.73 5.88-16.13 13.14-16.13s11.85 6.57 12.98 16.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.48 33.46s1.57 4.99-.01 6.88c-.25.3.86 2.13-4.16 6.99 0 0-.28-.29-.38-.82 0 0-2.67 4.65-8.12 4.65h-.1c-5.44 0-8.33-4.66-8.33-4.66-.1.53-.38.82-.38.82-5.03-4.85-3.91-6.69-4.16-6.99-1.59-1.9-.32-6.88-.32-6.88.62 4.68 3.74 4.87 4.98 4.97l.37 1.33h.01c4.74-4.12 7.78-3.59 7.78-3.59s3.06-.52 7.78 3.59h.01l.37-1.33s4.11.64 4.67-4.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.08 44.71c-.95.45-1.68.73-2.9-.42h-2.92c-1.22 1.15-2.33.71-2.9.42-1.48-.73-2.27-3.18-.75-3.85.75-.37 5.08-2.23 5.11-2.26s4.36 1.89 5.11 2.26c1.09.41.74 3.14-.75 3.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.65 41.72c.76.6 1.57.33 2.13-.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.48 26.62c-1.49.12-2.57 1.82-2.41 3.79.16 1.98 1.49 3.48 2.98 3.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.01 29.33c-.08 2.03 1.29 2.06 1.29 3.57 0 1.77-1.51 1.91-1.51 1.91"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.46",
        cy: "29.46",
        r: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.64",
        cy: "29.46",
        r: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
          children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
            children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
              d: "M26.32 29.46c0 2.7-2.05 4.33-4.59 4.33s-3.98-.97-3.98-3.67c0-2.47.5-3.92 3.75-3.92 2.47 0 4.81.16 4.81 3.25ZM28.99 29.46c0 2.7 2.05 4.33 4.59 4.33s3.98-.97 3.98-3.67c0-2.47-.5-3.92-3.75-3.92-2.47 0-4.81.16-4.81 3.25ZM26.32 29.46c0-.78.6-1.07 1.33-1.07s1.33.28 1.33 1.07"
            })
          }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "m14.05 26.39 3.71 2.47"
          }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "m41.26 26.39-3.71 2.47"
          })]
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MiddleAgeMale56 = (MiddleAgeMale56);
;// ./src/Picto/GeneratedPictoComponents/OutbackMale104.tsx


var OutbackMale104_excluded = ["className"];
function OutbackMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function OutbackMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? OutbackMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : OutbackMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function OutbackMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OutbackMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", OutbackMale104_objectSpread(OutbackMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.84 53.86s0 3.69 1.03 4.06.21 1.48.21 1.48h-1.71l-.14-5.54h.6ZM33.59 48.84s0 3.67 1.04 4.04.21 1.48.21 1.48h-1.72l-.14-5.52h.6ZM68.95 45s0 3.66-1.08 4.02-.22 1.47-.22 1.47h1.79l.14-5.49h-.63ZM65.04 16.37c-.22-4.49-2.38-7.59-6.74-8.63-.71-.17-2.24-.7-2.6-.27-.74.27-7.09-1.06-10.3.46-2.8 1.33-4.94 3.53-6.64 6.13-2.16 3.3-3.09 7.19-3.56 11.06-.18 1.48-.17 3.91-1.06 5.17-1 1.43-12.16 4.22-14.68 4.77-1.82.4 11.02 1.24 12.91 1.11 11.68-.77 16.95-.45 26.64-8 3.58-2.79 6.26-7.14 6.03-11.81ZM35.78 32.29c-.06 0-.11.01-.17.02.04-.04.08-.07.12-.11.02.03.03.06.05.09ZM84.5 49.38s0 3.62-1.08 3.99-.22 1.46-.22 1.46h1.79l.14-5.45h-.63Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M82.5 86.09c.96.62.52 1.66-.49 1.25-5.29-2.13-7.88 5.25-13.05.26-1-1.72-2.14-4.97-2.07-5.6.11-1.12-3.44-2.76-1.22-3.65 2.25-2.03 11.95 5.32 16.84 7.74Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.26 86.41c-.96.62-.52 1.66.49 1.25 5.29-2.13 7.88 5.25 13.05.26 1-1.72 2.14-4.97 2.07-5.6-.11-1.12 3.44-2.76 1.22-3.65-2.25-2.03-11.95 5.32-16.84 7.74Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.32 94.34c1.58-2.39 3.7-4.67 6.55-6.49 4.46-2.85 9.3-5.09 13.65-7.28 6.44-3.24 9.43-3.91 9.97-11.06M92.69 94.34c-1.58-2.39-3.7-4.67-6.55-6.49-4.46-2.85-9.3-5.09-13.65-7.28-6.36-3.2-9.97-4.59-10.58-11.58M30.46 40.45c-.98-.24-1.98-.2-2.9.18-2.91 1.2-3.96 5.32-2.36 9.2 1.39 3.36 4.33 5.44 6.98 5.14M70.75 54.99c2.59.16 5.4-1.9 6.75-5.16 1.61-3.87.55-7.99-2.36-9.2-.91-.38-1.9-.42-2.87-.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.52 36.4c.47 2.37.72 4.87.72 7.45 0 15.73-9.35 28.48-20.88 28.48S30.48 59.58 30.48 43.85c0-2.53.24-4.98.7-7.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.41 45.75c0 4.28 2.79 4.48 2.79 6.93s-2.85 2.56-2.85 2.56M39.96 41.41c2.1-1.9 5.5-1.9 7.59 0M55.15 41.41c2.1-1.9 5.5-1.9 7.59 0M49.46 62.27c2.25 1.28 4.66.11 5.7-.86M41.08 73.29l-9.1 20.03s7.28-1.77 10.92-1.82c3.86-.05 7.79 1.69 9.1 5.46L41.08 73.29Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m62.92 73.29 9.1 20.03s-7.28-1.77-10.92-1.82c-3.86-.05-7.79 1.69-9.1 5.46l10.92-23.67Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.44",
        cy: "46.63",
        r: "1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.7",
        cy: "46.63",
        r: "1.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.19 48.51h3.61v7.22h-3.61zM84 48.51V35.76M66.82 44.09h3.61v7.22h-3.61zM68.63 43.45v-7.33M18.43 53.07h3.61v7.22h-3.61zM20.23 53.07v-17M70.33 30.1a.429.429 0 0 1-.31-.37c-.26-2.54-2.51-21.39-12.62-21.39H46.56c-10.11 0-12.36 18.85-12.62 21.39a.44.44 0 0 1-.31.37l-14.96 4.49c-.48.14-.37.85.12.85h66.34c.5 0 .6-.7.12-.85L70.29 30.1ZM32.18 48.02h3.61v7.22h-3.61zM33.98 47.38V36.07"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OutbackMale104 = (OutbackMale104);
;// ./src/Picto/GeneratedPictoComponents/OutbackMale56.tsx


var OutbackMale56_excluded = ["className"];
function OutbackMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function OutbackMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? OutbackMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : OutbackMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function OutbackMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OutbackMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", OutbackMale56_objectSpread(OutbackMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.77 27.66c-.71-.18-1.44-.14-2.1.13-2.11.87-2.87 3.86-1.71 6.67 1.01 2.44 3.14 3.94 5.06 3.73M42 38.21c1.88.11 3.92-1.38 4.9-3.74 1.16-2.81.4-5.8-1.71-6.67-.66-.27-1.38-.31-2.08-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.56 24.73c.34 1.72.52 3.53.52 5.41 0 11.41-6.78 20.66-15.15 20.66s-15.15-9.25-15.15-20.66c0-1.83.18-3.61.5-5.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.97 31.51c0 3.1 2.03 3.25 2.03 5.03s-2.07 1.86-2.07 1.86M19.66 28.36c1.52-1.38 3.99-1.38 5.51 0M30.68 28.36c1.52-1.38 3.99-1.38 5.51 0M26.55 43.5c1.64.93 3.38.08 4.13-.62"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M4.94 37.19s0 3 .84 3.3.17 1.21.17 1.21H4.56l-.11-4.51h.49ZM14.69 33.25s0 3.22.91 3.54.19 1.29.19 1.29h-1.51l-.12-4.84h.53ZM41.1 31.1s0 2.82-.83 3.1-.17 1.13-.17 1.13h1.38l.11-4.24h-.48ZM37.4 11.2c-.16-3.01-1.74-5.09-4.91-5.78-.51-.11-1.63-.47-1.9-.18-.54.18-5.17-.71-7.51.31-2.04.89-3.6 2.36-4.84 4.11-1.58 2.21-2.26 4.82-2.6 7.42-.13.99-.13 2.62-.77 3.47-.73.96-8.86 2.83-10.7 3.2-1.33.27 8.03.83 9.41.75 8.52-.52 12.36-.3 19.42-5.36 2.61-1.87 4.56-4.79 4.39-7.92ZM16.07 21.87s-.08 0-.12.01c.03-.02.06-.05.09-.07l.03.06ZM51.11 34.03s0 2.87-.86 3.15-.18 1.15-.18 1.15h1.42l.11-4.31h-.5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.43 33.63H52v5.14h-2.57zM50.71 33.63v-9.08M39.43 30.56H42v5.14h-2.57zM40.71 30.1v-5.21M4.04 36.87h2.57v5.14H4.04zM5.33 36.87V24.78M40.98 20.53a.326.326 0 0 1-.22-.26c-.18-1.81-1.79-15.23-8.98-15.23h-7.71c-7.19 0-8.8 13.42-8.98 15.23a.31.31 0 0 1-.22.26L4.22 23.72c-.34.1-.27.6.09.6h47.22c.35 0 .43-.5.09-.6l-10.65-3.19ZM13.83 33.19h2.57v5.14h-2.57zM15.11 32.73v-8.04"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.58",
        cy: "31.01",
        r: "1.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.28",
        cy: "31.01",
        r: "1.25"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OutbackMale56 = (OutbackMale56);
;// ./src/Picto/GeneratedPictoComponents/SunSmartMale104.tsx


var SunSmartMale104_excluded = ["className"];
function SunSmartMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SunSmartMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SunSmartMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SunSmartMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SunSmartMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SunSmartMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SunSmartMale104_objectSpread(SunSmartMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.53 56.31s-.56-.47-1.02-.1-3 11.91-11.76 10.55l-3.78 4.73 13.08-.76c2.97-3.87 3.48-14.41 3.48-14.41ZM46.74 9.84c-3.72.4-9.33 2.27-11.95 5.1-3.29 3.55-4.23 6.49-5.14 11.51-.36 2.02-1.17 6.2.11 5.12.29.07 2.87-1.43 3.18-1.52 1.96-.52 3.93-1.03 5.89-1.55.82-.22 6.58-1.99 8.86-2.1 5.08-.23 10.05.09 14.94 1.53 1.19.35 2.39-.62 2.4-1.83.07-9.9-8.49-17.33-18.3-16.27ZM24.71 56.59s.56-.47 1.02-.1c.46.37 3 11.91 11.76 10.55l3.78 4.73-13.08-.76c-2.97-3.87-3.48-14.41-3.48-14.41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.76 72.5s-7.77-4.37-13.18-.5c0 0-11.11-28.79 1.12-39.13M60.97 72.4s7.75-4.36 13.15-.5c0 0 11.15-24.74-2-39.04"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.05 93.94s-1.1 1.02.33 1.51c2.18.73 6.46-5.33 12.09-2.57S51.98 98.44 51.82 95c-.09-1.85-22.23-10.29-22.23-10.29l-10.55 9.23Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.26 48.42c0 .76-.84.42-1.88.42s-1.88.34-1.88-.42.84-1.38 1.88-1.38 1.88.62 1.88 1.38ZM60.26 48.42c0 .76-.84.5-1.88.5s-1.88.26-1.88-.5.84-1.38 1.88-1.38 1.88.62 1.88 1.38Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.5 42.19c-.55-.07-1.1 0-1.61.2-2.06.85-2.81 3.76-1.69 6.51.88 2.13 2.63 3.54 4.34 3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.66 42.19c.55-.07 1.1 0 1.61.2 2.06.85 2.81 3.76 1.69 6.51-.88 2.13-2.63 3.54-4.34 3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M71.51 42.33c1.83 15.37-9.23 32.25-20.63 32.25s-22.79-15.8-21.75-32.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.94 48.32c0 4.22 2.76 4.42 2.76 6.85s-2.81 2.53-2.81 2.53M39.64 44.06c2.07-1.88 5.43-1.88 7.5 0M54.64 44.06c2.07-1.88 5.43-1.88 7.5 0M49.01 64.64c2.23 1.26 4.6.11 5.63-.85"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.27 94.26s4.65-5.39 12.21-9.99L52 94.15l19.65-9.88s5.51 2.48 13.82 9.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.66 84.18c6.91-3.45 9.98-4.45 10.83-12.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.15 71.79c.77 8.15 4.28 8.83 11.27 12.39"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.12 32.87S74.29 9.49 50.41 9.49 28.7 32.87 28.7 32.87s-4.34 6.38 0 8.5c4.34 2.13 15.19-6.38 21.71-6.38s17.36 8.5 21.71 6.38c4.34-2.13 0-8.5 0-8.5Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.12 32.87c-19.83-15.52-43.41 0-43.41 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SunSmartMale104 = (SunSmartMale104);
;// ./src/Picto/GeneratedPictoComponents/SunSmartMale56.tsx


var SunSmartMale56_excluded = ["className"];
function SunSmartMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SunSmartMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SunSmartMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SunSmartMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SunSmartMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SunSmartMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SunSmartMale56_objectSpread(SunSmartMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.05 38.06s-.4-.34-.73-.07-2.15 8.52-8.42 7.55l-2.45 3.07 9.06.32c1.9-2.86 2.54-10.86 2.54-10.86ZM25.02 5.29c-2.66.29-6.68 1.62-8.55 3.65-2.35 2.54-3.03 4.64-3.68 8.23-.26 1.44-.84 4.43.08 3.67.2.05 2.05-1.02 2.28-1.08l4.22-1.11c.59-.15 4.71-1.43 6.34-1.5 3.63-.16 7.19.06 10.69 1.1.85.25 1.71-.44 1.72-1.31.05-7.09-6.07-12.4-13.09-11.64ZM8.52 38.15s.4-.34.73-.07 2.15 8.52 8.42 7.55l2.48 3.1-8.89.19c-2.13-2.77-2.73-10.76-2.73-10.76Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.64 50.41s-8.71-3.69-12.61-.9c0 0-7.56-20.44 1.23-27.87M32.43 50.22s8.16-3.56 12.05-.78c0 0 8.02-17.78-1.44-28.06"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.35 27.43c-.41-.05-.81 0-1.19.15-1.52.62-2.08 2.78-1.25 4.81.65 1.58 1.95 2.62 3.21 2.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.99 27.43c.41-.05.81 0 1.19.15 1.52.62 2.08 2.78 1.25 4.81-.65 1.58-1.95 2.62-3.21 2.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.1 27.68c1.12 11.46-6.78 23.7-15.2 23.7S11.05 39.69 11.82 27.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.94 31.96c0 3.12 2.04 3.27 2.04 5.06s-2.08 1.87-2.08 1.87M19.58 28.81c1.53-1.39 4.01-1.39 5.55 0M30.67 28.81c1.53-1.39 4.01-1.39 5.55 0M26.51 44.03c1.65.93 3.4.08 4.16-.63"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.64 31.57c0 .58-.63.32-1.42.32s-1.42.26-1.42-.32.63-1.04 1.42-1.04 1.42.47 1.42 1.04ZM34.99 31.57c0 .58-.63.38-1.42.38s-1.42.2-1.42-.38.63-1.04 1.42-1.04 1.42.47 1.42 1.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.1 21.64S44.64 5.03 27.68 5.03 12.26 21.64 12.26 21.64s-3.08 4.53 0 6.04c3.08 1.51 10.79-4.53 15.42-4.53s12.33 6.04 15.42 4.53c3.08-1.51 0-6.04 0-6.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.1 21.64c-14.08-11.02-30.83 0-30.83 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SunSmartMale56 = (SunSmartMale56);
;// ./src/Picto/GeneratedPictoComponents/Teen104.tsx


var Teen104_excluded = ["className"];
function Teen104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Teen104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Teen104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Teen104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Teen104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Teen104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Teen104_objectSpread(Teen104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.53 35.6c-1.06-1.38-2.46-3.45-3.37-4.93-.27-.45-1.03-1.82-1.35-2.2-1.25-1.49-.24-.73-.32-.76-.44.09.73.6.32.76-.27.36-.86.68-1.17 1.13-4.56 6.59-8.33 13.71-6.52 21.2l1.85 5.98 2.92 7.38s-1.88 3.53-2.21 2.04c-.48-2.14-3.24-2.7-2.69-4.74-1.49 0-2.43.29-2.43.29-1.51-.71.4-10.49.4-10.49-.7-.78-3.21 3.66-3.21 3.66-.83-1.14.74-11.47.45-10.33-.29 1.15-3.91 1.95-3.91 1.95l2.16-7.95c.12-1.69.42-3.83.8-5.49 2.02-8.89 4.59-13.99 12.22-20.19 24.98-9.37 41.75 19.39 38 34.12l-3.43.65-3.6-.99-3-3.36-.56 2.38.66 3.9v2.12l-11.73-5.8-7.96-7.47-2.32-2.87Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.53 65.07c-.22-.3-.43-.61-.64-.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.33 47.73c-1.45 14.83-10.76 26.28-22.04 26.28-6.16 0-11.73-3.41-15.76-8.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.16 41.08c2.23-2.02 5.85-2.02 8.09 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.78 45.7 2.74 5.45c.58 1.16.28 2.6-.71 3.39l-1.59 1.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.98 62.55c1.39.85 1.59 4.52 1.59 4.52 3.24-3.93 3.44-8.06 3.44-8.06 2.05 1.9 4.9-.36 4.9-.36-2.05-1.39-3.48-7.59-2.38-7.86 1.1-.27 3.4 1.72 3.4 1.72.96-4.36-2.41-8.82-2.41-8.82 1.79 1.74 5.2 1.49 5.2 1.49s-1.76-.55-2.67-5.61c-.69-3.9-4.71-23.34-19.27-28.61C55.38 9 50.45 9.29 46.26 9.92c-15.59 2.35-21.08 14.87-22.87 23.94 0 0-1.15 8.61-3.05 13.24 0 0 3.33-.71 3.91-1.95.57-1.24-1.43 5.44-.38 10.67 0 0 1-3.15 3.14-4.01 0 0-.89 8.79.54 11.26 0 0 1.5-2.92 3.11-1.1 1.22 1.3.99 5.11.99 5.68s2.28-1.48 2.94-3.95c0 0-2.57-4-4.31-10.96-1.11-4.45-.81-10.95 1.16-15.08 1.79-3.73 5-7.49 6.04-9.96 0 0 9.75 20.01 28.02 24.27 0 0-2.56-4.55-1.28-8.92 0 0 3.38 7.07 10.24 3.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.87 61.05s-2.15 4.04-8.11 4.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.12 85.11c6.73-4.58 9.04-5.76 9.88-13.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.07 71.22c.76 8.03 3.03 10.08 9.7 13.89"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.29 94.24s-.53.57.79 1.26c1.83.96 8.19-5.62 13.72-3.24 6.48 2.8 14.83 5.35 15.21 2.91.42-2.73-19.32-9.38-19.32-9.38l-10.4 8.46Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.36 94.95s4.48-5.31 11.75-9.84l19.27 9.05 20.37-9.05s5.31 2.44 13.31 9.84",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.97",
        cy: "45.66",
        r: "2.02"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Teen104 = (Teen104);
;// ./src/Picto/GeneratedPictoComponents/Teen56.tsx


var Teen56_excluded = ["className"];
function Teen56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Teen56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Teen56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Teen56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Teen56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Teen56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Teen56_objectSpread(Teen56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.48 23.57c-.76-1-1.87-2.63-2.52-3.71-.2-.32-.85-1.38-1.16-1.56-.06-.04.02-.25-.03-.27-.32.07-.08.4-.38.52-.19.26.07.36-.16.68-3.3 4.76-6.02 9.91-4.72 15.33l1.34 4.33 2.11 5.34s-1.8 2.81-2.04 1.74c-.35-1.55-.57-2.8-1.51-3.69-1.07 0-1.75.21-1.75.21-1.09-.51-.39-7.19-.39-7.19-.51-.56-2.15 1.71-2.15 1.71-.6-.83.61-7.47.39-6.64-.21.83-2.38 1.12-2.38 1.12l1.23-5.74c.09-1.22.64-2.77.92-3.97 1.46-6.43 3.32-10.12 8.84-14.6C35.18.41 47.31 21.2 44.6 31.85l-2.48.47-2.6-.72-2.17-2.43-.4 1.72.47 2.82v1.53l-8.48-4.19-5.75-5.4-1.68-2.08Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.42 44.88c-.16-.22-.31-.44-.47-.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.75 32.34c-1.05 10.73-7.78 19-15.94 19-4.45 0-8.48-2.47-11.39-6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.05 27.54c1.61-1.46 4.23-1.46 5.85 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.45 30.88 1.98 3.94c.42.84.2 1.88-.51 2.45l-1.15.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.61 43.06c1 .62 1.15 3.27 1.15 3.27 2.35-2.84 2.48-5.83 2.48-5.83 1.48 1.38 3.55-.26 3.55-.26-1.49-1-2.51-5.49-1.72-5.69.8-.2 2.46 1.25 2.46 1.25.7-3.15-1.74-6.38-1.74-6.38 1.29 1.26 3.76 1.08 3.76 1.08s-1.27-.4-1.93-4.05c-.5-2.82-3.41-16.88-13.93-20.69-3.91-1.42-7.47-1.21-10.5-.75C12.92 6.71 8.95 15.76 7.65 22.32c0 0-.83 6.23-2.21 9.57 0 0 2.41-.51 2.82-1.41.41-.9-1.03 3.93-.28 7.72 0 0 .72-2.28 2.27-2.9 0 0-.64 6.35.39 8.15 0 0 1.08-2.11 2.25-.8.88.94.71 3.7.71 4.11s1.65-1.07 2.13-2.85c0 0-1.86-2.89-3.11-7.92-.8-3.22-.59-7.92.84-10.91 1.29-2.7 3.62-5.42 4.37-7.2 0 0 7.05 14.47 20.26 17.55 0 0-1.85-3.29-.93-6.45 0 0 2.44 5.12 7.4 2.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.58 41.98s-1.55 2.92-5.87 2.92"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.32",
        cy: "30.88",
        r: "1.5"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Teen56 = (Teen56);
;// ./src/Picto/GeneratedPictoComponents/TeenFemale104.tsx


var TeenFemale104_excluded = ["className"];
function TeenFemale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TeenFemale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TeenFemale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TeenFemale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TeenFemale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TeenFemale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TeenFemale104_objectSpread(TeenFemale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m53.57 94.52 1.66-2.9c.46-.79.37-1.87-.21-2.54l-3.41-3.95-3.41 3.95c-.58.67-.67 1.75-.21 2.54l1.66 2.9c.3.53.8.84 1.33.84h1.24c.53 0 1.03-.31 1.33-.84Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m53.37 94.03 1.66-2.9c.46-.79.37-1.87-.21-2.54l-3.41-3.95L48 88.59c-.58.67-.67 1.75-.21 2.54l1.66 2.9c.3.53.8.84 1.33.84h1.24c.53 0 1.03-.31 1.33-.84Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.11 92.73c3.34-7.21 13.35-9.3 18.61-14.78 2.28-2.37 2.92-5.27 2.38-8.75-.29-1.9-2.41-1.95-3.64-3.35-1.65-1.88-2.45-3.82-3.64-6.02-2.27-4.2-3.54-8.94-3.65-13.71-.06-2.64-1.05-6.88 2.51-7.04 1.67-.08 3.29-.13 4.92-.54 5.77-1.43 10.57-5.61 12.99-10.94 1.55 2.6 3.5 4.92 5.92 6.86a25.46 25.46 0 0 0 5.28 3.28c2.13.98 4.4 1.23 6.55 2.02.39.15 2.61.21 2.8.51.34.54.46 4.17.32 6.9-.1 2.02-.42 4.03-.92 5.99-1.19 2.82-2.59 5.74-3.74 8.71-.23.37-.46.75-.71 1.12-1.44 2.09-3.04 3.49-5.31 5.66-1.76 1.68-1.37 5.95-.03 7.81.52.72 2.32 3.07 2.99 3.45 4.25 2.4 7.81 4.46 11.57 7.87 1.1 1 1.32.07 1.77.12.52.06 1.36-.13 1.87-.85.46-.65 1.01-1.2 1.08-2.03.08-1.06-.34-2.08-.65-3.06-.4-1.28-1.18-2.7-1.08-4.07.08-1.1 1.05-1.81 1.55-2.72.67-1.22 1.12-2.63 1.15-4.02a5.99 5.99 0 0 0-.49-2.56c-.32-.72-1.04-1.29-1.15-2.09-.12-.86.74-2.1.94-2.98.4-1.76.19-3.54-.69-5.12-.45-.8-1.61-1.68-1.69-2.61-.09-1.06.79-2.04.82-3.15.03-1.66-.84-2.97-1.74-4.29-.7-1.02-1.63-2.13-1.58-3.47.05-1.57.77-2.99.61-4.61a8.276 8.276 0 0 0-1.47-3.98c-1.43-2.02-3.8-2.65-4.5-5.1-.31-1.07-.22-2.16-.65-3.21-1.11-2.7-3.86-4.18-6.69-4.28-1.75-.06-1.97-1.14-2.42-2.59-.74-2.35-2.19-4.62-4.95-4.57-2.99.06-4.2 1.71-7.02-.55-1.27-1.02-2.46-1.88-4.14-1.92-2.33-.05-3.88 1.67-6 2.28-3.59 1.03-8.84-.71-9.72 4.52-.2 1.21.95 2.95.69 4.14-.32 1.41-1.14 1.91-2.26 2.8-1.28 1.01-3.34 1.43-3.93 3.02-.98 2.62 2.5 4.35.82 6.72-1.11 1.57-4.15 3.43-4.4 5.54-.29 2.45 2.38 4.73 1.23 6.97-.93 1.81-2.85 2.71-3.37 4.84-.5 2.05.47 3.67 1.29 5.48.85 1.87.77 2.51-.5 4.25-.53.72-1.18 1.29-1.55 2.13-.76 1.74-.23 3.39.7 4.93 1.13 1.88 1.82 3.73 1.46 5.47-.09.06-.17.13-.26.21-.7.68-1.17 1.45-1.46 2.26-.21.34-.43.68-.64 1.02-.56.9-.7 2.15-.02 2.56.29 1.07.75 2.11 1.69 2.81",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.7 94.34c-.32-3.22.66-4.32 1.65-5.27.79-.77 1.73-1.56 1.87-2.72.27-2.18-2.92-4.66-2.75-6.76.17-2.19 3.71-4.15 3.78-6.25.07-2.2-3.34-4.37-3.38-6.47-.04-2.2 3.28-4.51 3.12-6.6-.16-2.2-3.79-3.98-4.08-6.05-.3-2.19 2.71-4.89 2.28-6.93-.45-2.17-4.29-3.44-4.86-5.44-.62-2.14 1.94-5.26 1.19-7.2-.8-2.08-4.8-2.66-5.73-4.5-1.01-2 .86-5.58-.29-7.29-1.25-1.87-5.26-1.47-6.64-3-1.51-1.67-.77-5.64-2.4-6.89-1.78-1.37-5.37.43-7.25-.42-2.02-.92-3.14-4.78-5.21-5.08-2.14-.31-4.23 3.11-6.36 3.49-2.06.37-5.18-2.14-7.16-1.11-1.81.94-1.65 4.96-3.35 6.47-1.51 1.35-5.47.61-6.85 2.42-1.23 1.61.45 5.28-.66 7.27-.99 1.78-5 2.22-5.87 4.31-.79 1.89 1.68 5.08 1 7.23-.62 1.96-4.49 3.12-5.01 5.3-.48 2.01 2.44 4.8 2.06 7-.36 2.04-4.05 3.67-4.32 5.88-.25 2.07 2.95 4.54 2.78 6.75-.16 2.08-3.69 4.03-3.77 6.24-.07 2.09 3.31 4.3 3.31 6.51 0 2.1-3.39 4.29-3.32 6.5.06 2.1 2.72 4.55 3.71 6.29 0 0 2.2 4.26-.19 6.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.07 79.1c-3.33-2.58-2.89-2.14-2.89-9.99M82.7 94.34c-1.27-2.29-2.95-4.45-5.14-6.21-3.68-2.94-7.67-5.24-11.25-7.5-.89-.56-1.63-1.06-2.24-1.53M42.43 69.11c.01 5.99-.21 6.48-3.75 9.63M63.83 79.4c-4.2 3.57-7.13 4.98-12.52 4.98s-8.64-1.8-12.84-5.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.72 24.59c0 13.13-18.42 14.94-20.44 15-.12 1.23-.19 2.48-.19 3.75 0 15.53 9.23 28.13 20.63 28.13s20.63-12.59 20.63-28.13c0-1.27-.07-2.53-.19-3.75-2.01-.06-20.44-1.87-20.44-15Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.57 45.21c0 4.22 2.76 4.42 2.76 6.85s-2.81 2.53-2.81 2.53M40.27 41.16c2.07-1.88 5.43-1.88 7.5 0M55.27 41.16c2.07-1.88 5.43-1.88 7.5 0M49.64 61.53c2.23 1.26 4.6.11 5.63-.85M70.65 83.33c-4.24-1.63-10.53 4.36-12.73 4.45-2.1.09-4.32-3.29-6.51-3.3-2.1 0-4.34 3.36-6.53 3.25-1.17-.06-2.03-.93-2.86-1.66-1.02-.91-7.33-4.65-11.4-1.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20 94.54c3.58-5.83 9.23-9.23 15.47-13.39 1.29-.86 1.92-1.31 2.78-2.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.41",
        cy: "45.36",
        r: "1.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.32",
        cy: "45.36",
        r: "1.89"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TeenFemale104 = (TeenFemale104);
;// ./src/Picto/GeneratedPictoComponents/TeenFemale56.tsx


var TeenFemale56_excluded = ["className"];
function TeenFemale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TeenFemale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TeenFemale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TeenFemale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TeenFemale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TeenFemale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TeenFemale56_objectSpread(TeenFemale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M15.98 26.98c7.55-.28 11.14-3.94 11.82-7.68 1.22 3.74-1.41-.87.07.22.99.73.65 3.08 1.81 3.57 1.3.55 3.71 2.37 5.03 2.82.24.08-1.04-.54 2.66.66.35.12-.39.09 1.15.43 2.05.44 1.77.12 1.46 1.22-.13 1.71-.74 6.51-1.44 8.17-.14.21-2.7 5-2.86 5.21-.88 1.17-1.57 1.99-4.93 3.3-4.12 1.61 1 5.5 1.82 6.54.32.4 2.94-2.31 3.35-2.1 2.59 1.34.07-.69 2.37 1.21.67.56 2.83-1.88 3.1-1.85.31.04 1.59.99 1.89.59.28-.36.33-1.04.37-1.51.05-.59-.21-1.16-.4-1.71-.25-.71-.72-1.51-.66-2.28.05-.62.64-1.01.95-1.52.41-.68.68-1.47.7-2.25.01-.49-.08-.98-.3-1.43-.2-.4-.63-.72-.7-1.17-.08-.48.45-1.18.57-1.67.24-.98.12-1.98-.42-2.86-.27-.45-.98-.94-1.03-1.46-.05-.59.48-1.14.5-1.76.02-.93-.51-1.66-1.06-2.4-.43-.57-.99-1.19-.97-1.94.03-.88.47-1.67.37-2.58-.08-.8-.39-1.57-.9-2.23-.87-1.13-2.32-1.48-2.75-2.85-.19-.6-.14-1.21-.4-1.79-.68-1.51-2.36-2.34-4.08-2.39-1.07-.03-1.2-.64-1.48-1.45-.45-1.32-1.34-2.59-3.02-2.56-1.83.03-2.57.96-4.28-.31-.78-.57-2.13-.94-3.16-.96l-.83 1.72-3.75 1.28-.14 2.88-1.34 1.81-2.09 1.44.52 2.74.03 1.1-2.74 2.81 1.13 3.72-2.36 3.12 1.52 3.58-1.11 2.03-.95 1.28 1.18 2.08.63 1.38-1.41 3.06.35 2.85 1.46 1.27h1.28l2.34-.9 1.72.9.8.94.96 1.06 3.79-1.24 1.52.97 1.79 1.21 2.04-1.21 1.58-.43 1.51.43 2.04 1.34-2.21-6.36-3.69.46-4.35-1.85-4.06-4.71-1.96-5.43-.43-4.82.05-.94",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.88 18.25c0 7.64-10.72 8.69-11.89 8.73-.07.72-.11 1.44-.11 2.18 0 9.04 5.37 16.37 12 16.37s12-7.33 12-16.37c0-.74-.04-1.47-.11-2.18-1.17-.03-11.89-1.09-11.89-8.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.79 30.25c0 2.46 1.61 2.57 1.61 3.98s-1.64 1.47-1.64 1.47M21.21 27.89c1.21-1.09 3.16-1.09 4.36 0M29.94 27.89c1.21-1.09 3.16-1.09 4.36 0M26.67 39.75c1.3.74 2.68.07 3.27-.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.14 49.57c.42-.41 1.15-1.07 1.25-2.33.16-1.93-1.93-2.63-1.84-3.74s1.97-2.2 2.01-3.32-1.77-2.32-1.79-3.43c-.02-1.17 1.74-2.39 1.66-3.5-.09-1.17-2.01-2.11-2.16-3.21-.16-1.16 1.44-2.59 1.21-3.68-.24-1.15-2.27-1.82-2.58-2.89-.33-1.13 1.03-2.79.63-3.82-.43-1.1-2.55-1.41-3.04-2.39-.54-1.06.45-2.96-.15-3.87-.66-.99-2.79-.78-3.52-1.59-.8-.89-.41-2.99-1.27-3.66-.95-.73-2.85.23-3.85-.22-1.07-.49-1.67-2.54-2.77-2.69s-2.25 1.65-3.37 1.85c-1.09.19-2.75-1.14-3.8-.59-.96.5-.88 2.63-1.78 3.43-.8.72-2.9.32-3.64 1.28-.65.86.24 2.8-.35 3.86-.53.94-2.66 1.18-3.12 2.29-.42 1 .89 2.7.53 3.84-.33 1.04-2.38 1.66-2.66 2.81-.25 1.07 1.3 2.55 1.09 3.72-.19 1.08-2.15 1.95-2.29 3.12-.13 1.1 1.56 2.41 1.48 3.58-.08 1.1-1.96 2.14-2 3.31-.04 1.11 1.76 2.28 1.75 3.45 0 1.11-1.8 2.28-1.76 3.45.03 1.11.22 2.17.93 3.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.92 47.69c.34.48.78.88 1.38 1.05 1.12.32 2.68-1.15 3.77-.89s1.87 2.29 2.96 2.5c1.15.22 2.57-1.39 3.67-1.24 1.16.16 2.09 2.09 3.2 2.18 1.17.1 2.4-1.66 3.51-1.64 1.17.02 2.34 1.82 3.45 1.77 1.18-.06 2.16-1.96 3.25-2.1 1.17-.15 2.6 1.45 3.68 1.22 1.16-.25 1.56-1.52 2.6-1.86 1.13-.37 2.12 2.25 3.74.88"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.41",
        cy: "30.25",
        r: "1.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.12",
        cy: "30.25",
        r: "1.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TeenFemale56 = (TeenFemale56);
;// ./src/Picto/GeneratedPictoComponents/TurbanMale104.tsx


var TurbanMale104_excluded = ["className"];
function TurbanMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TurbanMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TurbanMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TurbanMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TurbanMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TurbanMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TurbanMale104_objectSpread(TurbanMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.45 89c-.7.56.07 2.38.84 2 4.04-2 10.85 2.71 14.43-1.7.47.26-.16-3.17-.29-3.7-.24-.94-1.21-2.27-1.88-3.5-1.56-1.08-8.96 3.37-12.07 6.31l-1.03.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M77.64 88.89c1.01.93.11 3.12-1.63 1.57-4.04-2-10.45 3.25-14.03-1.16-.47.26-.04-1.82.1-2.35.24-.94.67-4.45 2.59-5.12 2.1-1.62 7.52 4.8 11.96 6.85l1.01.21Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.71 96.57-3.53-5.07 5.29-5.07 5.28 5.07-3.52 5.07M46.59 63.18c1.02-.48 1.97-.6 2.85-1.41.43-.4 1.05-1.02.75-1.64-.25-.53-1.32-.4-1.76 0-.73.68-1.52.95-2.37 1.36-.5.24-1.24.64-1.09 1.32.13.6.72.61 1.22.37h.4ZM55.09 61.48c.95.32 1.83 1.02 2.74 1.46.53.26 1.71.2 2.03-.36.27-.49-.41-.88-.94-1.14-1.07-.52-2.17-1.16-3.29-1.55-1.32-.45-2.31.74-1 1.19l.47.41ZM54.23 71.57c-4.59.48-7.12-.34-11.89-2.53-.31-.28-.88-.97-1.18-1.26-1.03-1.78-2.18-1.68-2.8-3.49-.62-1.8-2.69-2.88-2.07-1.07.57 1.66.49 3.98 1.33 5.58-.05.39.65 1.39.99 1.76.2.22.42 1.03.63 1.25.89 1.47 2.01 2.86 3.11 4.13 2.87 3.29 5.94 3.47 9.41 5.81.44.29 1.06.25 1.5 0 3.19-1.82 5.35-2.46 8.11-5.68 0 0 1-7.62-7.16-4.49"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.18 76.49c-1.96 3.54-5.02 7.2-9.83 9.58l-15.28 7.37L14 94.99M62.85 76.49c1.91 3.51 5.46 7.82 9.05 9.58l12.66 6.22c1.56.77 3.05 1.67 4.45 2.71M59.88 96.61c0-9.24 5.25-15.86 5.25-15.86M44.81 96.61c0-9.24-5.25-15.86-5.25-15.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.9 78.93 11.44 7.31-7.71 7.4M63.79 78.93l-11.45 7.31 7.72 7.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.07 96.17 3.45-4.97-3.45-3.3M50.62 87.9l-3.45 3.3 3.45 4.97M52.39 51.52c0 3.72 2.43 3.9 2.43 6.04s-2.48 2.23-2.48 2.23M42.42 47.74c1.83-1.65 4.79-1.65 6.61 0M55.65 47.74c1.83-1.65 4.79-1.65 6.61 0M50.69 65.91c1.96 1.11 4.06.1 4.96-.75M52.34 60.32s-.61-.89-2.68-.89c-3.18 0-5.6 3.65-7.24 3.65 0 0 4.63 1.48 6.77-.71 2.14-2.19 3.15-2.04 3.15-2.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.34 60.32s.61-.89 2.68-.89c3.18 0 5.6 3.65 7.24 3.65 0 0-4.63 1.48-6.77-.71-2.14-2.19-3.15-2.04-3.15-2.04ZM52.34 82.94c0-3.36 6.44-1.57 12.42-10.13 4.49-6.43 3.94-14.67 3.94-14.67s-2.93 13.7-16.35 13.63M52.34 71.77c-13.43.07-16.64-13.63-16.64-13.63s-.08 8.24 4.4 14.67c5.97 8.56 12.24 6.77 12.24 10.13"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66 25c-2.67-5.34-12.06-8.68-17.79-9.02-11.02-.64-22.2 11.68-20.9 24.26.04.39.22.68.46.87-.02.27-.07.54-.03.82.64 4.32 3.07 10.54 6.03 15.06 1.48 2.27 2.16.63 2.22-.62.37-6.93 2.52-13.63 6.34-19.36 1.43-2.14 3.35-3.93 4.21-4.75.89-.85 4.02-5.79 5.56-4.98 2.78 1.45 9.26 5.18 9.33 5.71.09.64.74.76.73 1.13-.03 1.06.6 1.63 1.31.87 0 0 4.84-5.39 2.53-10Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.58 13.46C29.3 37.96 36.23 60.34 36.23 60.34s-8.67-9.96-10.18-24.57C24.54 21.15 40.99 7.88 51.53 7.39c10.53.49 26.99 13.77 25.48 28.38-1.51 14.62-8.59 24.01-8.59 24.01s4.17-28.46-18.99-32.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.25 22.85s20.24 3.7 18.88 28.16M59.55 17.91s15.19 3.73 17.32 19.02M30.25 50.64c-.05-.1 4.14-24.55 29.95-40.29M26.91 40.95S32.48 18.6 55.73 8.16"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.62",
        cy: "52",
        r: "1.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.07",
        cy: "52",
        r: "1.71"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TurbanMale104 = (TurbanMale104);
;// ./src/Picto/GeneratedPictoComponents/TurbanMale56.tsx


var TurbanMale56_excluded = ["className"];
function TurbanMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TurbanMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TurbanMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TurbanMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TurbanMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TurbanMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TurbanMale56_objectSpread(TurbanMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.63 38.62c.57.19 1.09.61 1.63.87.31.15 1.02.12 1.21-.21.16-.29-.25-.53-.56-.68-.64-.31-1.29-.69-1.96-.92-.79-.27-1.38.44-.6.71l.28.24ZM29.12 44.64c-2.74.29-4.25-.2-7.1-1.51-.18-.17-.52-.58-.7-.75-.62-1.06-1.3-1-1.67-2.08-.37-1.07-1.61-1.72-1.23-.64.34.99.29 2.38.8 3.33-.03.23.39.83.59 1.05.12.13.25.62.38.74.53.88 1.2 1.71 1.86 2.46 1.71 1.96 3.54 2.07 5.62 3.46.26.18.63.15.9 0 1.9-1.08 3.19-1.47 4.84-3.39 0 0 .6-4.54-4.27-2.68M26.41 38.41c-.57.19-1.09.61-1.63.87-.31.15-1.02.12-1.21-.21-.16-.29.25-.53.56-.68.64-.31 1.29-.69 1.96-.92.79-.27 1.38.44.6.71l-.28.24Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.89 32.41c0 2.3 1.5 2.41 1.5 3.73s-1.53 1.38-1.53 1.38M20.68 30.07c1.13-1.02 2.96-1.02 4.08 0M30.87 30.07c1.13-1.02 2.96-1.02 4.08 0M27.86 37.84s-.37-.55-1.66-.55c-1.97 0-3.46 2.25-4.47 2.25 0 0 2.86.91 4.18-.44 1.32-1.35 1.94-1.26 1.94-1.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.86 37.84s.37-.55 1.66-.55c1.97 0 3.46 2.25 4.47 2.25 0 0-2.86.91-4.18-.44s-1.94-1.26-1.94-1.26ZM27.86 51.81c0-2.08 3.98-.97 7.67-6.26 2.77-3.97 2.43-9.06 2.43-9.06s-1.81 8.46-10.1 8.42M27.86 44.91c-8.29.04-10.28-8.42-10.28-8.42s-.05 5.09 2.72 9.06c3.69 5.29 7.56 4.18 7.56 6.26M26.73 41.66c1.5.85 3.1.08 3.79-.57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.9",
        cy: "33.28",
        r: "1.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.84",
        cy: "33.28",
        r: "1.25"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.56 15.09c-1.65-3.29-7.42-5.34-10.94-5.55-6.78-.4-13.65 7.18-12.86 14.92.02.24.13.42.28.54 0 .17-.04.33-.02.5.39 2.66 1.89 6.48 3.71 9.27.91 1.4 1.33.39 1.37-.38.23-4.26 1.55-8.38 3.9-11.91.88-1.32 1.83-2.8 2.36-3.3s2.55-2.85 3.49-2.36c1.71.89 5.85 2.86 5.89 3.19.05.39 0 0 .63.28s.19 1.42.63.95c0 0 2.98-3.31 1.56-6.15Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.02 8.14C13.46 23.38 17.77 37.29 17.77 37.29s-5.39-6.19-6.33-15.28S20.73 4.67 27.28 4.36c6.55.31 16.78 8.56 15.84 17.65-.94 9.09-5.34 14.93-5.34 14.93s2.6-17.7-11.81-20.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.97 13.98s12.59 2.3 11.74 17.51M32.27 10.91s9.45 2.32 10.77 11.83M14.05 31.26C14.02 31.2 16.62 16 32.68 6.2M11.97 25.23s3.46-13.9 17.92-20.39"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TurbanMale56 = (TurbanMale56);
;// ./src/Picto/GeneratedPictoComponents/YoungAdultMale104.tsx


var YoungAdultMale104_excluded = ["className"];
function YoungAdultMale104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function YoungAdultMale104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? YoungAdultMale104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : YoungAdultMale104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function YoungAdultMale104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, YoungAdultMale104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", YoungAdultMale104_objectSpread(YoungAdultMale104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M62.84 83.06s1.86.17.29 2.42c-2.68 3.85-17.1 7.72-24.89 3.26-5.28-3.02-.49-7.58-.49-7.58s5.14 4.36 11.21 4.6c7.88.3 6.03-.11 13.88-2.7Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.78 39.38c-1.07-.3-2.16-.27-3.17.15-3.02 1.25-4.12 5.53-2.45 9.56 1.46 3.53 4.55 5.69 7.33 5.34M71.61 54.46c2.66.1 5.53-2.02 6.92-5.37 1.67-4.03.57-8.31-2.45-9.56-.95-.4-1.99-.44-3-.19M36.34 79.8c3.64-2.2 6.06-2.7 6.06-9.95M16.19 95.4c1.25-2.09 2.84-4.06 4.87-5.69 3.75-3 7.83-5.35 11.49-7.66M70.83 82.05c3.66 2.3 7.73 4.66 11.49 7.66 1.91 1.53 3.43 3.36 4.65 5.32M66.85 79.68c1.17.72 2.51 1.44 3.98 2.37M61.54 69.85c0 7.12 1.79 7.68 5.31 9.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "51.56",
        cy: "42.87",
        rx: "21.71",
        ry: "29.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.72 95.4V82.25M67 79.86c-4.43 3.82-9.68 6.03-15.32 6.03s-10.88-2.21-15.31-6.03V95.4M49.58 62.03c2.34 1.33 4.84.12 5.92-.89M71.08 95.4l-.24-13.15M67.18 80.37V95.4M36.37 92.9h30.81M75.08 95.41c-.11-1.46-.1-2.51-.1-2.51h-3.9M32.72 92.9h-3.9s.1 1-.08 2.51M32.91 81.88c1.39-.88 2.3-1.4 3.42-2.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.97 43.99c0 4.25-3.23 6.83-7.21 6.83s-6.25-1.53-6.25-5.78c0-3.89.78-6.17 5.9-6.17 3.89 0 7.56.25 7.56 5.11ZM54.16 43.99c0 4.25 3.23 6.83 7.21 6.83s6.25-1.53 6.25-5.78c0-3.89-.78-6.17-5.9-6.17-3.89 0-7.56.25-7.56 5.11ZM49.97 43.99c0-1.23.94-1.68 2.09-1.68s2.09.44 2.09 1.68M29.73 39.07l6.77 3.97M73.65 39.07l-6.02 3.97"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m78.63 34.09.78-1c-5.64-3.84-6.51-2.97-10.75-10.5-2.62-4.66-8.82-9.72-15.2-10.39-8.57-.91-20.34 5.4-18.94 13.84.14.83.69 1.36 1.34 1.55.8.24 1.52.66 2.19 1.16.15.11.31.22.48.33 2.38 1.44 5.75 1.82 8.42 2.37 3.13.64 6.3 1.1 9.47 1.46 7.37.83 14.79 1.01 22.2 1.18",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.86 26.39c-.56-2.55.12-5.25 1.3-7.57 2.59-5.09 7.64-8.78 13.2-9.87 5.56-1.09 11.53.37 16.11 3.74 2.14 1.58 3.98 3.54 5.67 5.59 1.33 1.62 2.6 3.31 4.2 4.66 2.45 2.06 5.53 3.18 8.61 4.02.31.78-.75 1.36-1.57 1.52l-5.03 1.02c1.11 1.83 5.07 3.18 6.31 4.09-10.63 1.45-22.49.29-33.04-1.6-3.74-.67-7.15-1.26-10.72-2.43-1.37-.45-4.22-1.87-4.93-3.13M52.26 44.04l2.67 5.32c.57 1.13.28 2.53-.69 3.31l-1.55 1.24"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.26 45.26c0 .8-.88.45-1.97.45s-1.97.36-1.97-.45.88-1.45 1.97-1.45 1.97.65 1.97 1.45ZM62.06 45.26c0 .8-.88.52-1.97.52s-1.97.28-1.97-.52.88-1.45 1.97-1.45 1.97.65 1.97 1.45Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_YoungAdultMale104 = (YoungAdultMale104);
;// ./src/Picto/GeneratedPictoComponents/YoungAdultMale56.tsx


var YoungAdultMale56_excluded = ["className"];
function YoungAdultMale56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function YoungAdultMale56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? YoungAdultMale56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : YoungAdultMale56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function YoungAdultMale56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, YoungAdultMale56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", YoungAdultMale56_objectSpread(YoungAdultMale56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.43 27.7c-.75-.21-1.52-.19-2.23.1-2.12.88-2.89 3.88-1.72 6.71 1.03 2.48 3.2 4 5.15 3.75M40.81 38.29c1.87.07 3.88-1.42 4.86-3.77 1.17-2.83.4-5.83-1.72-6.71-.67-.28-1.39-.31-2.11-.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "26.72",
        cy: "30.15",
        rx: "15.25",
        ry: "20.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.34 43.6c1.65.93 3.4.08 4.16-.63"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.52 30.98c0 2.9-2.24 4.66-5 4.66s-4.34-1.04-4.34-3.94c0-2.65.54-4.21 4.09-4.21 2.7 0 5.25.17 5.25 3.49ZM28.42 30.98c0 2.9 2.24 4.66 5 4.66s4.34-1.04 4.34-3.94c0-2.65-.54-4.21-4.09-4.21-2.7 0-5.25.17-5.25 3.49ZM25.52 30.98c0-.84.65-1.14 1.45-1.14s1.45.3 1.45 1.14M11.48 27.63l4.7 2.7M41.94 27.63l-4.18 2.7"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m46.88 22.89.56-.67c-4.05-2.6-4.68-2.01-7.72-7.11-1.88-3.16-6.33-6.58-10.92-7.04-6.15-.62-14.61 3.66-13.6 9.38.1.56.5.92.97 1.05.57.16 1.09.44 1.57.79.11.08.22.15.35.22 1.71.97 4.13 1.23 6.05 1.6 2.25.43 4.52.75 6.8.99 5.29.56 10.62.68 15.94.8",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.98 17.58c-.39-1.77.08-3.64.9-5.25 1.79-3.53 5.3-6.09 9.16-6.85 3.86-.76 8 .26 11.18 2.6 1.49 1.09 2.76 2.45 3.94 3.88.92 1.12 1.8 2.3 2.91 3.23 1.7 1.43 3.84 2.21 5.97 2.79.21.54-.52.94-1.09 1.06-1.16.24-2.33.47-3.49.71.77 1.27 3.51 2.21 4.38 2.84-7.37 1.01-15.6.2-22.92-1.11-2.6-.47-4.96-.88-7.44-1.69-.95-.31-2.93-1.3-3.42-2.17M27.38 30.81l1.88 3.74c.4.8.19 1.78-.49 2.32l-1.09.87"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.86 31.3c0 .56-.61.31-1.37.31s-1.37.25-1.37-.31.61-1.01 1.37-1.01 1.37.45 1.37 1.01ZM33.81 31.3c0 .56-.61.36-1.37.36s-1.37.19-1.37-.36.61-1.01 1.37-1.01 1.37.45 1.37 1.01Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_YoungAdultMale56 = (YoungAdultMale56);
;// ./src/Picto/GeneratedPictoComponents/AccountsPayments104.tsx


var AccountsPayments104_excluded = ["className"];
function AccountsPayments104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AccountsPayments104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AccountsPayments104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AccountsPayments104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AccountsPayments104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AccountsPayments104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AccountsPayments104_objectSpread(AccountsPayments104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.21 56.18a22.401 22.401 0 0 0-2.9 7.9c-.05.3.05.61.27.82 2.58 2.5 5.6 4.56 8.91 6.07.6.27 1.27-.18 1.27-.84v-3.8c0-2.77-1.16-5.39-3.17-7.29-1.01-.95-1.98-1.95-2.9-2.99a.916.916 0 0 0-1.48.14ZM42.64 42.93a18.36 18.36 0 0 1-11.66-12.05c-.25-.83-1.43-.83-1.66.01-.4 1.46-.52 3.04-.27 4.68.72 4.85 4.63 8.77 9.49 9.48 1.37.2 2.71.15 3.96-.1 1.05-.22 1.16-1.67.15-2.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.33 49.09c-3.62-2.47-8-3.91-12.72-3.91-11.39 0-20.81 8.42-22.38 19.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.76 72C17.41 67.41 9.41 56.28 9.41 43.29c0-17.1 13.86-30.96 30.96-30.96s30.96 13.86 30.96 30.96c0 1.98-.19 3.93-.54 5.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.37",
        cy: "33.62",
        r: "11.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.63 60.71h61.93v7.74H32.63zM38.44 73.29h27.09v5.81H38.44z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.44 73.29h27.09v5.81H38.44z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "32.63",
        y: "52.97",
        width: "61.93",
        height: "38.71",
        rx: "3.87",
        ry: "3.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.63 60.71h61.93v7.74H32.63z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AccountsPayments104 = (AccountsPayments104);
;// ./src/Picto/GeneratedPictoComponents/AccountsPayments56.tsx


var AccountsPayments56_excluded = ["className"];
function AccountsPayments56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AccountsPayments56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AccountsPayments56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AccountsPayments56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AccountsPayments56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AccountsPayments56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AccountsPayments56_objectSpread(AccountsPayments56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.93 28.94c-.63 1.13-1.08 2.37-1.32 3.68-.04.23.04.47.21.63 1.22 1.17 2.63 2.14 4.17 2.89.46.22 1-.1 1-.62V34c0-1.51-.65-2.93-1.75-3.97-.41-.39-.81-.8-1.2-1.23a.687.687 0 0 0-1.12.13ZM23.21 21.83a9.496 9.496 0 0 1-5.97-5.92c-.18-.53-.95-.46-1.06.09-.13.67-.15 1.39-.03 2.13.4 2.41 2.36 4.36 4.77 4.76.76.13 1.5.1 2.2-.04.53-.11.6-.85.09-1.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.7 25a11.603 11.603 0 0 0-6.57-2.02c-5.89 0-10.75 4.35-11.57 10.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16 36.84C10.14 34.47 6 28.72 6 22c0-8.84 7.16-16 16-16s16 7.16 16 16c0 1.03-.1 2.03-.28 3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22",
        cy: "17",
        r: "6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18 31h32v4H18zM21 37.5h14v3H21z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21 37.5h14v3H21z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18",
        y: "27",
        width: "32",
        height: "20",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18 31h32v4H18z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AccountsPayments56 = (AccountsPayments56);
;// ./src/Picto/GeneratedPictoComponents/Bank104.tsx


var Bank104_excluded = ["className"];
function Bank104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bank104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bank104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bank104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bank104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bank104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bank104_objectSpread(Bank104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.9 45.15c-.57 0-1.14-.17-1.64-.53L51.99 16.06 12.73 44.61c-1.25.91-2.99.63-3.9-.61s-.63-2.99.61-3.9l40.92-29.75c.98-.71 2.3-.71 3.28 0L94.55 40.1c1.25.91 1.52 2.65.61 3.9a2.8 2.8 0 0 1-2.26 1.15ZM13.78 90.58h76.33c1.25 0 2.26 1.01 2.26 2.26H11.52c0-1.25 1.01-2.26 2.26-2.26ZM18.24 61.98c0-1.01 1.34-1.38 1.85-.51C22.18 65 21.4 75.41 27.2 78.94c1.61.98-.08 2.47-1.96 2.47h-4.71c-1.32 0-2.39-1.08-2.38-2.4l.09-17.03ZM46.23 61.98c0-1.01 1.34-1.38 1.85-.51 2.09 3.53 1.31 13.94 7.11 17.47 1.61.98-.08 2.47-1.96 2.47h-4.71c-1.32 0-2.39-1.08-2.38-2.4l.09-17.03ZM74.24 61.98c0-1.01 1.34-1.38 1.85-.51C78.18 65 77.4 75.41 83.2 78.94c1.61.98-.08 2.47-1.96 2.47h-4.71c-1.32 0-2.39-1.08-2.38-2.4l.09-17.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.24 30.59-.65 1.63c-1.24 3.09-.48 7.06 1.67 8.78 1.39 1.1.65 3.34-1.12 3.4l-18.63.66c-1.32.05-2.5-.8-2.89-2.06l-.31-1 19.8-14.17c1.27-1.38 2.93.78 2.13 2.77Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.9 45.15c-.57 0-1.14-.17-1.64-.53L51.99 16.06 12.73 44.61c-1.25.91-2.99.63-3.9-.61s-.63-2.99.61-3.9l40.92-29.75c.98-.71 2.3-.71 3.28 0L94.55 40.1c1.25.91 1.52 2.65.61 3.9a2.8 2.8 0 0 1-2.26 1.15ZM18.53 81.41V44.22M29.69 44.22v37.19M46.42 81.41V54.38M57.58 54.38v27.03M74.63 81.41V44.22M85.78 44.22v37.19M14.81 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.81 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72M42.7 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.7 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72M70.59 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.59 86.98v-3.72c0-1.03.83-1.86 1.86-1.86h14.88c1.03 0 1.86.83 1.86 1.86v3.72M71.34 44.22H90M13.28 44.22h19.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11.52",
        y: "88",
        width: "80.95",
        height: "5.18",
        rx: "1",
        ry: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.45 36.35c1.16 7.36 3.82 15.85 11.02 19.02-6.97 2.33-11.57-4.95-14.03-10.8-1.26-3-1.59-6.07-1.11-8.63.44-2.37 3.74-2.03 4.12.41Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "40.5",
      r: "14.88",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.32 45.71v-4.54l-.65-.15c-2.4-.55-3.57-1.81-3.57-3.74 0-2.48 1.83-4.07 4.27-4.3v-1.74h1.6V33c2.12.29 3.91 1.66 4.12 4.12h-2.31c-.1-1.05-.67-1.89-1.81-2.16v4.3l.95.21c2.14.5 3.45 1.78 3.45 3.88 0 2.58-1.74 4.12-4.43 4.35v2.08h-1.6v-2.1c-2.69-.29-4.48-1.95-4.54-4.6h2.4c.06 1.32.76 2.33 2.14 2.62Zm.04-6.8v-3.99c-1.3.21-2.02 1.05-2.02 2.14 0 .88.53 1.47 2.02 1.85Zm1.55 2.6v4.24c1.32-.21 2.16-1.01 2.16-2.2 0-.99-.57-1.68-2.1-2.02l-.06-.02Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bank104 = (Bank104);
;// ./src/Picto/GeneratedPictoComponents/Bank56.tsx


var Bank56_excluded = ["className"];
function Bank56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bank56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bank56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bank56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bank56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bank56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bank56_objectSpread(Bank56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.28 24.49c-.3 0-.59-.09-.85-.28L28 9.35 7.57 24.21a1.454 1.454 0 0 1-1.71-2.35L27.15 6.39c.51-.37 1.2-.37 1.71 0l21.28 15.48a1.454 1.454 0 0 1-.85 2.63ZM11.62 34.79c.67 6.18 1.49 6.73 3.27 7.49.97.42.28 1.07-.77 1.07h-3.01c-.29 0-.52-.23-.52-.52l.04-7.83c0-.55.92-.76.98-.21ZM26.26 34.79c.67 6.18 1.49 6.73 3.27 7.49.97.42.28 1.07-.77 1.07h-3.01c-.29 0-.52-.23-.52-.52l.04-7.83c0-.55.92-.76.98-.21ZM41.15 34.79c.67 6.18 1.49 6.73 3.27 7.49.97.42.28 1.07-.77 1.07h-3.01c-.29 0-.52-.23-.52-.52l.04-7.83c0-.55.92-.76.98-.21Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.68 16.92-.34.85c-.65 1.61-.29 3.8.83 4.69 0 0 1.9.99 1.29 1.26-.33.15-11.52.72-11.52.72-.69.02-1.3-.42-1.5-1.07l-.16-.52 10.3-7.37c.66-.72 1.52.4 1.11 1.44Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.59 43.35V24.01M16.39 24.01v19.34M25.1 43.35V29.3M30.9 29.3v14.05M39.77 43.35V24.01M45.57 24.01v19.34M8.65 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.65 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93M23.16 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.16 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93M37.67 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.67 46.26v-1.93c0-.53.43-.97.97-.97h7.74c.53 0 .97.43.97.97v1.93M49.28 24.49c-.3 0-.59-.09-.85-.28L28 9.35 7.57 24.21a1.454 1.454 0 0 1-1.71-2.35L27.15 6.39c.51-.37 1.2-.37 1.71 0l21.28 15.48a1.454 1.454 0 0 1-.85 2.63ZM37.29 24.01h10.7M8.1 24.01h10.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "7.21",
        y: "46.62",
        width: "41.57",
        height: "2.9",
        rx: ".5",
        ry: ".5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.51 19.92c.6 3.83 1.99 8.25 5.73 9.9-3.63 1.21-6.02-2.57-7.3-5.62-.66-1.56-.83-3.16-.58-4.49.23-1.23 1.94-1.06 2.14.21Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "22.19",
      r: "7.62",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.55 24.79v-2.38l-.34-.08c-1.26-.29-1.87-.95-1.87-1.96 0-1.3.96-2.14 2.24-2.26v-.91h.84v.93c1.11.15 2.05.87 2.16 2.16h-1.21c-.06-.55-.35-.99-.95-1.13v2.26l.5.11c1.12.26 1.81.94 1.81 2.04 0 1.35-.92 2.16-2.33 2.28v1.09h-.84v-1.1c-1.41-.15-2.35-1.02-2.38-2.41h1.26c.03.69.4 1.22 1.12 1.38Zm.02-3.57v-2.09c-.68.11-1.06.55-1.06 1.12 0 .46.28.77 1.06.97Zm.82 1.37v2.22c.69-.11 1.14-.53 1.14-1.16 0-.52-.3-.88-1.1-1.06h-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bank56 = (Bank56);
;// ./src/Picto/GeneratedPictoComponents/BillEmails104.tsx


var BillEmails104_excluded = ["className"];
function BillEmails104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillEmails104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillEmails104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillEmails104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillEmails104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillEmails104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillEmails104_objectSpread(BillEmails104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.92 26.82H72.83c-1.58 0-2.86-1.4-2.86-3.13V11.82c0-.55-.45-1-1-1s-1 .45-1 1v11.87c0 2.83 2.18 5.13 4.86 5.13h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM11.09 60.9v24.55c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.6-2.79.72-3.59-10.06-4.24-24.52-12.59-29.62-26.89a.969.969 0 0 0-.9-.65.97.97 0 0 0-.97.97ZM85.08 47.16l5.7-2.8s.81-1.15-.17-2.25c-.55-.61-2.27-2.08-3.69-3.25-.7-.58-1.73 0-1.67.94.16 2.28-.19 4.41-1.12 6.35-.31.65.32 1.33.95 1.02ZM18.16 38.46l-5.71 3.97s-.62 1.3.76 2.15c.77.48 3.08 1.52 4.98 2.35.94.41 1.95-.39 1.64-1.28-.76-2.18-.91-4.32-.35-6.41.19-.7-.69-1.22-1.32-.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.32 41.78c1.03.88 1.62 2.16 1.62 3.51v40.64c0 2.55-2.06 4.61-4.61 4.61H15.7c-2.55 0-4.61-2.06-4.61-4.61v-40.6c0-1.37.61-2.68 1.67-3.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m88 38.71 3.33 3.07c1.03.88 1.62 2.16 1.62 3.51v40.64c0 2.55-2.06 4.61-4.61 4.61H15.7c-2.55 0-4.61-2.06-4.61-4.61v-40.6c0-1.37.61-2.68 1.67-3.55l4.14-3.86M12.31 89.06l17.25-9.66M74.43 79.35l17.29 9.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.54 43.4 54.33 65.52c-1.43.83-3.19.83-4.62 0l-38.2-22.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.07 48.26V14.82c0-2.2 1.73-3.98 3.86-3.98h45.93c.53 0 1.04.22 1.4.62l12.36 13.45c.34.37.53.86.53 1.37v21.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.18 11.6v11.21c0 2.28 1.73 4.13 3.86 4.13h10.09"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.49 45.91h21.09M51.49 33.43h21.09"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.57 46.6v-6.05l-.87-.2c-3.19-.73-4.76-2.41-4.76-4.98 0-3.3 2.44-5.43 5.69-5.74v-2.32h2.13v2.35c2.83.39 5.21 2.21 5.49 5.49h-3.08c-.14-1.4-.9-2.52-2.41-2.88v5.74l1.26.28c2.86.67 4.59 2.38 4.59 5.18 0 3.44-2.33 5.49-5.91 5.8v2.77h-2.13v-2.8c-3.59-.39-5.97-2.6-6.05-6.13h3.19c.08 1.76 1.01 3.11 2.86 3.5Zm.06-9.07v-5.32c-1.74.28-2.69 1.4-2.69 2.86 0 1.18.7 1.96 2.69 2.46ZM37.7 41v5.66c1.76-.28 2.89-1.34 2.89-2.94 0-1.32-.76-2.24-2.8-2.69l-.08-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillEmails104 = (BillEmails104);
;// ./src/Picto/GeneratedPictoComponents/BillEmails56.tsx


var BillEmails56_excluded = ["className"];
function BillEmails56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillEmails56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillEmails56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillEmails56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillEmails56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillEmails56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillEmails56_objectSpread(BillEmails56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M6.03 25.73v19.2c0 1.66 1.34 3 3 3h13.48c1.09 0 1.4-1.5.39-1.92-6.64-2.8-16.87-8.95-16.87-20.29Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49 21.55c.55.47.87 1.16.87 1.88v21.76c0 1.36-1.11 2.47-2.47 2.47H8.5c-1.36 0-2.47-1.11-2.47-2.47V23.45c0-.74.33-1.43.89-1.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.98 19.83 49 21.55c.55.47.87 1.16.87 1.88v21.76c0 1.36-1.11 2.47-2.47 2.47H8.5c-1.36 0-2.47-1.11-2.47-2.47V23.45c0-.74.33-1.43.89-1.9l1.54-1.27M6.69 46.87l9.23-5.18M39.95 41.67l9.26 5.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.65 22.42 29.19 34.26c-.77.44-1.71.44-2.47 0L6.26 22.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.84 24.8V7.65c0-1.18.92-2.13 2.07-2.13h24.6c.28 0 .55.12.75.33l6.62 7.2c.18.2.28.46.28.73v10.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.68 5.92v6c0 1.22.92 2.21 2.07 2.21h5.41"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.04h11.01M28 16.79h11.01"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.52 23.94V20.7l-.47-.11c-1.71-.39-2.55-1.29-2.55-2.67 0-1.77 1.3-2.91 3.04-3.07V13.6h1.14v1.26c1.51.21 2.79 1.19 2.94 2.94h-1.65c-.07-.75-.48-1.35-1.29-1.55v3.07l.67.15c1.53.36 2.46 1.28 2.46 2.78 0 1.84-1.24 2.94-3.16 3.1v1.48h-1.14v-1.5c-1.92-.21-3.19-1.39-3.24-3.28h1.71c.05.94.54 1.66 1.53 1.87Zm.03-4.86v-2.85c-.93.15-1.44.75-1.44 1.53 0 .63.37 1.05 1.44 1.32Zm1.11 1.86v3.03c.94-.15 1.54-.72 1.54-1.57 0-.7-.41-1.2-1.5-1.44l-.04-.02Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillEmails56 = (BillEmails56);
;// ./src/Picto/GeneratedPictoComponents/BillOverview104.tsx


var BillOverview104_excluded = ["className"];
function BillOverview104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillOverview104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillOverview104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillOverview104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillOverview104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillOverview104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillOverview104_objectSpread(BillOverview104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.51 47.11v-6.05l-.87-.2c-3.19-.73-4.76-2.41-4.76-4.98 0-3.3 2.44-5.43 5.69-5.74v-2.32h2.13v2.35c2.83.39 5.21 2.21 5.49 5.49h-3.08c-.14-1.4-.9-2.52-2.41-2.88v5.74l1.26.28c2.86.67 4.59 2.38 4.59 5.18 0 3.44-2.33 5.49-5.91 5.8v2.77h-2.13v-2.8c-3.59-.39-5.97-2.6-6.05-6.13h3.19c.08 1.76 1.01 3.11 2.86 3.5Zm.06-9.07v-5.32c-1.74.28-2.69 1.4-2.69 2.86 0 1.18.7 1.96 2.69 2.46Zm2.07 3.47v5.66c1.76-.28 2.89-1.34 2.89-2.94 0-1.32-.76-2.24-2.8-2.69l-.08-.03Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM19.04 60.45l1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.43 46.42h21.09M51.43 33.94h21.09M29.19 65.02h43.33M29.19 78.12h43.33M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.06 92.68h33.22c2.16 0 3.94-1.83 3.94-4.06V24.93c0-.52-.19-1.02-.54-1.4L72.07 9.81c-.37-.4-.89-.63-1.43-.63H23.78c-2.17 0-3.94 1.82-3.94 4.06v75.38c0 2.23 1.77 4.06 3.94 4.06H57"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillOverview104 = (BillOverview104);
;// ./src/Picto/GeneratedPictoComponents/BillOverview56.tsx


var BillOverview56_excluded = ["className"];
function BillOverview56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillOverview56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillOverview56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillOverview56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillOverview56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillOverview56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillOverview56_objectSpread(BillOverview56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.15 25.71v-3.14l-.45-.1c-1.66-.38-2.48-1.25-2.48-2.59 0-1.72 1.27-2.82 2.96-2.98v-1.21h1.11v1.22c1.47.2 2.71 1.15 2.85 2.85h-1.6c-.07-.73-.47-1.31-1.25-1.5v2.98l.65.15c1.49.35 2.39 1.24 2.39 2.69 0 1.79-1.21 2.85-3.07 3.01v1.44h-1.11v-1.46c-1.86-.2-3.1-1.35-3.14-3.19h1.66c.04.92.52 1.62 1.48 1.82Zm.03-4.71v-2.76c-.9.15-1.4.73-1.4 1.48 0 .61.36 1.02 1.4 1.28Zm1.08 1.8v2.94c.92-.15 1.5-.7 1.5-1.53 0-.68-.39-1.16-1.46-1.4h-.04Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m11.01 32.94.45 13.85c0 1.66 1.34 3 3 3h15.77c2.55 0 1.48-1.83.39-1.92-7.9-.63-17.44-5.88-18.65-14.81 0-.83-.95-.78-.95-.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.99 14.18v33.1c0 1.17-.92 2.11-2.05 2.11H13.06c-1.12 0-2.05-.95-2.05-2.11V8.1c0-1.17.92-2.11 2.05-2.11h24.35a1 1 0 0 1 .74.33l6.55 7.13c.18.2.28.46.28.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.58 6.4v5.94c0 1.21.92 2.19 2.05 2.19h5.35"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.43 25.35h10.96M27.43 18.86h10.96M15.87 35.01h22.52M15.87 41.82h22.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillOverview56 = (BillOverview56);
;// ./src/Picto/GeneratedPictoComponents/BillPaid104.tsx


var BillPaid104_excluded = ["className"];
function BillPaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillPaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillPaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillPaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillPaid104_objectSpread(BillPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.04 60.45 1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11ZM83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.43 46.42h21.09M51.43 33.94h21.09M29.19 78.12h25.5M29.19 65.02h27.28M57 92.68H23.78c-2.16 0-3.94-1.83-3.94-4.06V13.24c0-2.24 1.76-4.06 3.94-4.06h46.86c.54 0 1.06.23 1.43.63l12.61 13.72c.35.38.54.88.54 1.4v25.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M75.35 90.47c-9.12-3.39-14.42-11.99-16.36-19.98-.4-1.63-2.64-1.69-3.13-.08-.87 2.87-1.17 7.15 1.03 12.84 2.83 7.32 11.73 10.13 17.85 10.36 1.87.07 2.35-2.49.61-3.14Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "75.11",
        cy: "73.68",
        r: "20.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.72 74.24 6.52 6.52L86.8 66.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.51 47.11v-6.05l-.87-.2c-3.19-.73-4.76-2.41-4.76-4.98 0-3.3 2.44-5.43 5.69-5.74v-2.32h2.13v2.35c2.83.39 5.21 2.21 5.49 5.49h-3.08c-.14-1.4-.9-2.52-2.41-2.88v5.74l1.26.28c2.86.67 4.59 2.38 4.59 5.18 0 3.44-2.33 5.49-5.91 5.8v2.77h-2.13v-2.8c-3.59-.39-5.97-2.6-6.05-6.13h3.19c.08 1.76 1.01 3.11 2.86 3.5Zm.06-9.07v-5.32c-1.74.28-2.69 1.4-2.69 2.86 0 1.18.7 1.96 2.69 2.46Zm2.07 3.47v5.66c1.76-.28 2.89-1.34 2.89-2.94 0-1.32-.76-2.24-2.8-2.69l-.08-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillPaid104 = (BillPaid104);
;// ./src/Picto/GeneratedPictoComponents/BillPaid56.tsx


var BillPaid56_excluded = ["className"];
function BillPaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BillPaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BillPaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BillPaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BillPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BillPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BillPaid56_objectSpread(BillPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.01 33.1.61 14.2c0 1.65 1.34 2.98 2.98 2.98H27c1.09 0 1.39-1.49.39-1.91-5.6-2.36-13.21-6.44-15.55-14.68-.54-2.17-1.84-.95-1.82-.59ZM44.28 14.76h-5.37c-.84 0-1.52-.81-1.52-1.8V6.24c0-.29-.24-.53-.53-.53s-.53.24-.53.53v6.72c0 1.58 1.16 2.87 2.59 2.87h5.37c.29 0 .53-.24.53-.53s-.24-.53-.53-.53Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.35 48.23c-5.07-2.05-8.02-7.23-9.09-12.06-.22-.99-1.47-1.02-1.74-.05-.48 1.73-.65 4.31.57 7.75 1.58 4.42 6.52 6.11 9.92 6.25 1.04.04 1.31-1.5.34-1.9Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.08 25.61h11.18M27.08 19h11.18M15.29 42.41h13.52M15.29 35.47h14.46M30.03 50.12h-17.6c-1.15 0-2.09-.97-2.09-2.15V8.03c0-1.19.93-2.15 2.09-2.15h24.83c.29 0 .56.12.76.34l6.68 7.27c.18.2.29.46.29.74v13.43"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.43 6.29v6.06c0 1.23.93 2.23 2.09 2.23h5.46"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.86 24.64v-3.18l-.46-.1c-1.69-.38-2.52-1.27-2.52-2.62 0-1.74 1.29-2.86 3.01-3.02V14.5h1.13v1.24c1.5.21 2.76 1.16 2.91 2.89H21.3c-.07-.74-.47-1.33-1.28-1.52v3.02l.67.15c1.51.35 2.43 1.25 2.43 2.72 0 1.81-1.23 2.89-3.13 3.05v1.46h-1.13v-1.47c-1.9-.21-3.16-1.37-3.2-3.22h1.69c.04.93.53 1.63 1.51 1.84Zm.03-4.77v-2.8c-.92.15-1.42.74-1.42 1.5 0 .62.37 1.03 1.42 1.3Zm1.1 1.83v2.97c.93-.15 1.53-.71 1.53-1.55 0-.69-.4-1.18-1.48-1.41H20Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "39.63",
          cy: "39.65",
          r: "10.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m34.75 39.94 3.39 3.39 7.58-7.57"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BillPaid56 = (BillPaid56);
;// ./src/Picto/GeneratedPictoComponents/CardAdded104.tsx


var CardAdded104_excluded = ["className"];
function CardAdded104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CardAdded104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CardAdded104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CardAdded104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CardAdded104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CardAdded104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CardAdded104_objectSpread(CardAdded104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.51 75.78c-6.44 0-33.28 0-38.64-3.22-5.37-3.22-6.98-5.9-8.59-9.66-1.48-3.45-4.29-3.22-4.29-3.22v15.03A4.29 4.29 0 0 0 14.28 79h53.67s0-3.22-6.44-3.22ZM74.1 46.43a17.413 17.413 0 0 1-6-4.65c-.74-.89-1.83-1.43-2.99-1.43H12.34c-2.13 0-2.36 1.73-2.36 3.86s.32 3.86 2.45 3.86l61.3-.1c.86 0 1.14-1.18.36-1.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.78 53.88h30.91v7.73H15.78z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.54 48.09v27.05c0 2.13-1.73 3.86-3.86 3.86H13.85c-2.13 0-3.86-1.73-3.86-3.86V36.5c0-2.13 1.73-3.86 3.86-3.86h50.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.78 53.88h30.91v7.73H15.78zM67.03 40.36H9.99v7.73h69.55"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M80.56 41.69c-5.74-2.14-9.08-7.55-10.3-12.58-.25-1.03-1.66-1.06-1.97-.05-.55 1.81-.74 4.5.65 8.08 1.78 4.61 7.38 6.38 11.24 6.52 1.17.04 1.48-1.57.38-1.98Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "81.48",
        cy: "30.7",
        r: "13.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.96 31.6 3.74 3.74 8.33-8.32"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CardAdded104 = (CardAdded104);
;// ./src/Picto/GeneratedPictoComponents/CardAdded56.tsx


var CardAdded56_excluded = ["className"];
function CardAdded56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CardAdded56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CardAdded56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CardAdded56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CardAdded56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CardAdded56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CardAdded56_objectSpread(CardAdded56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.84 27.22a9.024 9.024 0 0 1-3.07-2.37c-.38-.46-.93-.73-1.53-.73H7.28c-1.09 0-1.2.88-1.2 1.97 0 1.09.16 1.97 1.25 1.97l31.32-.05c.44 0 .58-.6.18-.79ZM32.67 42.33c-3.33 0-17.22 0-20-1.67-2.78-1.67-3.61-3.06-4.44-5-.77-1.79-2.22-1.67-2.22-1.67v7.78c0 1.23.99 2.22 2.22 2.22h27.78s0-1.67-3.33-1.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9 31h16v4H9z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42 28v14c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2V22c0-1.1.9-2 2-2h26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9 31h16v4H9zM35.52 24H6v4h36"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.63 25.01c-2.87-1.07-4.54-3.77-5.15-6.29-.12-.51-.83-.53-.99-.02-.27.9-.37 2.25.32 4.04.89 2.31 3.69 3.19 5.62 3.26.59.02.74-.78.19-.99Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43",
        cy: "19",
        r: "7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.63 19.47 1.94 1.93 4.3-4.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CardAdded56 = (CardAdded56);
;// ./src/Picto/GeneratedPictoComponents/Cart104.tsx


var Cart104_excluded = ["className"];
function Cart104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cart104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cart104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cart104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cart104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cart104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cart104_objectSpread(Cart104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M69.86 63.86c-16.78-1.4-28.3-11.88-34.81-16.88-1.23-.95-2.95.22-2.54 1.71l5.41 19.76 32.13-1.02c2.96-.05 3.25-3.29-.19-3.58Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13 20.43h10.4c.86 0 1.61.59 1.81 1.43l11.8 45.97-3.94 7.35c-.3 1.04.49 2.08 1.57 2.08h41.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.57 67.83h40.07c.8 0 1.51-.51 1.77-1.27l5.2-24.5c.41-1.21-.49-2.46-1.77-2.46l-53.17-1.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.94 81.23c-1.12 3.19 1.39 5.06 1.8 5.35.04.03.07.04.11.07 2.24 1.18 3.97.69 5.11-.06.67-.44.41-1.5-.39-1.57-3.12-.28-4.45-2.2-5.01-3.78-.27-.77-1.36-.77-1.63 0ZM30.02 81.21c-1.14 3.2 1.39 5.09 1.79 5.37.04.02.07.04.11.06 2.25 1.19 3.99.68 5.13-.07.67-.44.41-1.49-.38-1.56-3.15-.27-4.48-2.21-5.04-3.8-.27-.76-1.34-.76-1.61 0Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "75.74",
        cy: "82.27",
        rx: "5.09",
        ry: "5.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.37",
        cy: "82.27",
        rx: "5.09",
        ry: "5.01"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cart104 = (Cart104);
;// ./src/Picto/GeneratedPictoComponents/Cart56.tsx


var Cart56_excluded = ["className"];
function Cart56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cart56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cart56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cart56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cart56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cart56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cart56_objectSpread(Cart56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m19.91 36.52 16.51-.15c.5-.02.95-1.15-.15-1.24-5.62-.47-13.88-6.11-17.51-10.17-.61-.68-1.74.15-1.5 1.03l2.55 10.45s.05.07.1.07Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7 11h5.6c.46 0 .87.32.98.77l6.35 24.75-2.12 3.96c-.16.56.26 1.12.84 1.12h22.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.23 36.52H41.8a1 1 0 0 0 .95-.68l2.8-13.19c.22-.65-.26-1.33-.95-1.33l-28.63-1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.4 43.48c-.62 1.75.76 2.78.99 2.93.02.01.04.02.06.04 1.23.65 2.18.38 2.81-.03.37-.24.23-.82-.21-.86-1.71-.15-2.44-1.21-2.75-2.07a.472.472 0 0 0-.89 0ZM16.16 43.47c-.63 1.76.76 2.79.99 2.95.02.01.04.02.06.04 1.24.65 2.19.38 2.82-.04.37-.24.22-.82-.21-.86-1.73-.15-2.46-1.22-2.77-2.09-.15-.42-.74-.42-.88 0Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "40.78",
        cy: "44.3",
        rx: "2.74",
        ry: "2.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "18.51",
        cy: "44.3",
        rx: "2.74",
        ry: "2.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cart56 = (Cart56);
;// ./src/Picto/GeneratedPictoComponents/Deal104.tsx


var Deal104_excluded = ["className"];
function Deal104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Deal104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Deal104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Deal104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Deal104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Deal104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Deal104_objectSpread(Deal104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.99 61.81 5.2-14.61c.48-1.34-1.31-2.3-2.16-1.16L19.88 66.2a7.065 7.065 0 0 0-1.42 5.32c.27 1.89 1.29 3.6 2.83 4.72L40.7 90.8c.22.16.45.31.69.45 1.22.7 2.46-.91 1.51-1.94l-8.49-9.16s-.07-.09-.11-.13c-2.63-3.8-5.55-6.26-2.35-18.1 0-.03.02-.07.03-.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.67 41.85c-2.59-1.08-3.88-4-2.95-6.65-.29.36-.54.76-.72 1.18a5.165 5.165 0 0 0 2.49 6.59 5.17 5.17 0 0 0 6.75-2.02 5.297 5.297 0 0 1-5.58.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.92 30.03c-.19.4-.43.77-.72 1.11.75-.53 1.36-1.25 1.76-2.08 1.25-2.77 1.57-5.86.92-8.82-.12-.3-2.43-4.96.23-8.19h-.18c-3.86 3.19-1.76 8.72-1.76 9.03 1.09 2.9 1 6.11-.25 8.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.89 36.2c-1.04.18-2.1.18-3.14 0-.99 0-1.92-.48-1.91-1.5 0-.24.05-.48.14-.71-.72.29-1.18.99-1.18 1.76 0 .97.79 1.76 1.76 1.76.16 0 1.46-.21 3.32-.3 3.3-.18 6.63-2.52 9.17-5.42a18.866 18.866 0 0 1-8.17 4.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73 26.62c.39-.71.73-1.45 1-2.22 1.62-4.62-1.18-9.42-3.37-12.23-.67-.88-1.4-1.71-2.19-2.49-.69-.68-1.8-.68-2.49 0-.33.33-.52.78-.52 1.25s.19.92.52 1.25c1.76 1.76 6.07 7.06 4.68 10.99-.27.72-.6 1.41-.99 2.06"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.99 32.13a7.042 7.042 0 0 0-2.81-4.9 7.061 7.061 0 0 0-5.5-1.27l-17.45 3.09a7.084 7.084 0 0 0-4.45 2.73L19.88 66.2a7.065 7.065 0 0 0-1.42 5.32c.27 1.89 1.29 3.6 2.83 4.72L40.7 90.8a7.04 7.04 0 0 0 5.28 1.38 7.08 7.08 0 0 0 4.69-2.8l25.81-34.51a7.116 7.116 0 0 0 1.38-5.1l-1.4-13.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.47 37.35c0 2.44-1.97 4.41-4.41 4.41s-4.41-1.97-4.41-4.41 1.97-4.41 4.41-4.41c1.16 0 2.22.45 3.01 1.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.21 37.95a24.2 24.2 0 0 1-3.3.26c-.97 0-1.76-.79-1.76-1.76s.79-1.76 1.76-1.76c2.45 0 9.21-.81 10.99-4.66 1.24-2.82 1.34-6.02.26-8.91-.12-.32-2.13-5.84 1.76-9.03.49-.4 1.15-.52 1.74-.3.59.22 1.02.74 1.13 1.36.11.62-.13 1.25-.61 1.66-1.92 1.59-.72 4.96-.72 4.99 1.47 3.78 1.36 8-.32 11.7-2.06 4.45-7.41 5.93-10.94 6.46Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73 26.62c.39-.71.73-1.45 1-2.22 1.62-4.62-1.18-9.42-3.37-12.23-.67-.88-1.4-1.71-2.19-2.49-.69-.68-1.8-.68-2.49 0-.33.33-.52.78-.52 1.25s.19.92.52 1.25c1.76 1.76 6.07 7.06 4.68 10.99-.27.72-.6 1.41-.99 2.06"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.79 37.56-7.96-3.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.16 30.81-6.7-5.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.13 25.41-5-7.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.29 21.74-2.95-8.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m58.16 20.04-.71-8.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m42.71 65.46 4.31-5.41-.64-.79c-2.33-2.92-2.54-5.54-.71-7.84 2.35-2.95 6.04-3.12 9.17-1.08l1.66-2.08 1.9 1.52-1.67 2.1c2.25 2.37 3.08 5.69 1 8.81l-2.75-2.19c.87-1.35.99-2.89-.1-4.29l-4.09 5.13.93 1.15c2.07 2.63 2.41 5.4.42 7.9-2.45 3.08-5.98 3.25-9.41.97l-1.97 2.48-1.9-1.52 1.99-2.5c-2.92-2.9-3.48-6.58-1.04-9.79l2.85 2.27c-1.18 1.64-1.31 3.5.06 5.16Zm5.89-3.49-4.03 5.05c1.78 1.01 3.53.85 4.67-.57.94-1.18.92-2.54-.59-4.4l-.06-.08Zm.62-4.58 3.79-4.76c-1.75-.99-3.4-.66-4.44.64-.84 1.05-.77 2.25.65 4.12Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Deal104 = (Deal104);
;// ./src/Picto/GeneratedPictoComponents/Deal56.tsx


var Deal56_excluded = ["className"];
function Deal56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Deal56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Deal56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Deal56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Deal56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Deal56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Deal56_objectSpread(Deal56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.85 13.14c.87-2.49-.64-5.07-1.81-6.58-.36-.48-.75-.92-1.18-1.34a.948.948 0 0 0-1.62.67c0 .25.1.5.28.67.95.95 3.27 3.8 2.52 5.92-.19.52-.47.99-.78 1.43.69.02 1.35.24 1.94.62.26-.44.48-.9.65-1.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.23 33.28 2.61-7.33c.29-.81-.79-1.4-1.31-.71l-7.82 10.41c-.63.81-.91 1.84-.76 2.86.14 1.02.69 1.94 1.52 2.54l10.45 7.84c.75.55 1.68.82 2.61.74l-6-6.47s-.04-.05-.06-.08c-1.42-2.04-2.98-3.37-1.26-9.74 0-.02.01-.04.02-.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.82 22.53a2.852 2.852 0 0 1-1.59-3.58c-.16.19-.29.41-.39.64-.55 1.35.03 2.9 1.34 3.55 1.31.65 2.9.17 3.63-1.09-.82.73-1.99.91-3 .48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.5 16.17c-.1.22-.23.42-.39.6.41-.29.73-.67.95-1.12.67-1.49.84-3.15.49-4.75-.07-.16-1.31-2.67.12-4.41h-.09c-2.08 1.72-.95 4.69-.95 4.86.59 1.56.54 3.29-.13 4.82Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.96 17.67-.04-.37a3.783 3.783 0 0 0-1.51-2.64c-.85-.63-1.92-.88-2.96-.69l-9.4 1.66c-.96.17-1.81.69-2.39 1.47L10.71 35.63c-.63.81-.91 1.84-.76 2.86.14 1.02.69 1.94 1.52 2.54l10.45 7.84c.81.62 1.83.89 2.84.75 1.01-.14 1.92-.69 2.52-1.51l13.9-18.58c.59-.78.86-1.77.74-2.75l-.76-7.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.95 20.11c0 1.31-1.06 2.38-2.38 2.38s-2.38-1.06-2.38-2.38 1.06-2.38 2.38-2.38c.75 0 1.42.35 1.86.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.35 20.43c-.59.09-1.18.14-1.78.14-.52 0-.95-.43-.95-.95s.43-.95.95-.95c1.32 0 4.96-.44 5.92-2.51.67-1.52.72-3.24.14-4.8-.07-.17-1.15-3.14.95-4.86.26-.22.62-.28.94-.16.32.12.55.4.61.73.06.33-.07.68-.33.89-1.04.86-.39 2.67-.39 2.69.79 2.04.73 4.31-.17 6.3-1.11 2.39-3.99 3.19-5.89 3.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.35 20.43c-.59.09-1.18.14-1.78.14-.52 0-.95-.43-.95-.95s.43-.95.95-.95c1.32 0 4.96-.44 5.92-2.51.67-1.52.72-3.24.14-4.8-.07-.17-1.15-3.14.95-4.86.26-.22.62-.28.94-.16.32.12.55.4.61.73.06.33-.07.68-.33.89-1.04.86-.39 2.67-.39 2.69.79 2.04.73 4.31-.17 6.3-1.11 2.39-3.99 3.19-5.89 3.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.85 13.14c.87-2.49-.64-5.07-1.81-6.58-.36-.48-.75-.92-1.18-1.34a.948.948 0 0 0-1.62.67c0 .25.1.5.28.67.95.95 3.27 3.8 2.52 5.92-.19.52-.47.99-.78 1.43.69.02 1.35.24 1.94.62.26-.44.48-.9.65-1.39Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.65 20.23-4.28-2.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.01 16.59-3.61-3.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.22 13.68-2.69-3.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.08 11.7-1.59-4.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.32 10.79-.38-4.73"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m23.03 35.65 2.15-2.71-.32-.4c-1.17-1.46-1.27-2.77-.35-3.92 1.18-1.48 3.02-1.56 4.59-.54l.83-1.04.95.76-.84 1.05c1.12 1.18 1.54 2.84.5 4.41l-1.38-1.1c.43-.67.5-1.45-.05-2.15l-2.04 2.57.46.57c1.04 1.32 1.21 2.7.21 3.95-1.23 1.54-2.99 1.63-4.71.49l-.99 1.24-.95-.76 1-1.25c-1.46-1.45-1.74-3.29-.52-4.9L23 33.06c-.59.82-.66 1.75.03 2.58Zm2.95-1.75-2.01 2.53c.89.5 1.77.43 2.34-.29.47-.59.46-1.27-.29-2.2l-.03-.04Zm.31-2.29 1.89-2.38c-.88-.49-1.7-.33-2.22.32-.42.53-.38 1.13.32 2.06Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Deal56 = (Deal56);
;// ./src/Picto/GeneratedPictoComponents/Delivery104.tsx


var Delivery104_excluded = ["className"];
function Delivery104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Delivery104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Delivery104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Delivery104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Delivery104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Delivery104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Delivery104_objectSpread(Delivery104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.94 44.03-1.36 19.11s9.17-.42 16.81-.68c2.11-.07 1.26-2.82-.72-3.47-8.76-2.89-9.43-8.62-11.54-14.23-.86-2.28-3.02-3.12-3.19-.73ZM49.33 76.4c-20.89 0-37.83.78-37.83 1.73s16.94 1.73 37.83 1.73 37.83-.78 37.83-1.73-16.94-1.73-37.83-1.73Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.34 68.71h3.95l2.57-14s.19-1.84-.93-3.92-6.37-10.78-6.37-10.78-.68-.93-1.58-1.44c-1.01-.57-2.97-.55-5.6-.58-5.92-.06-11.08.22-11.08.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.99 68.66h30.09v-5.65H19.07v5.65h4.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.07 63.08H17.96l3.1-39h50.4l-3.39 39z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.18 52.43c-.12.22-17.36.14-17.36.14-.72 0-1.27-.58-1.21-1.28l.71-8.56c.06-.71.7-1.28 1.42-1.28h9.13c.72 0 1.6.51 1.95 1.12 0 0 5.46 9.67 5.35 9.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.3 70.67c0 4.07-3.3 7.36-7.37 7.36s-7.37-3.3-7.37-7.36 3.3-7.36 7.37-7.36 7.37 3.3 7.37 7.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.75 70.71c0 2.13-1.73 3.86-3.86 3.86s-3.86-1.73-3.86-3.86 1.73-3.86 3.86-3.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.61 70.67c0 4.07-3.3 7.36-7.37 7.36s-7.37-3.3-7.37-7.36 3.3-7.36 7.37-7.36 7.37 3.3 7.37 7.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.1 70.71c0 2.13-1.73 3.86-3.86 3.86s-3.86-1.73-3.86-3.86 1.73-3.86 3.86-3.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.42 68.66 6.44.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.37 42.36H6.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.43 36.19h-5.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.71 30.41h-.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.33 30.41h-5.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.08 49.68h-3.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.11 49.68H31.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.35 49.68h-3.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.15 49.68H6.41"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Delivery104 = (Delivery104);
;// ./src/Picto/GeneratedPictoComponents/Delivery56.tsx


var Delivery56_excluded = ["className"];
function Delivery56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Delivery56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Delivery56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Delivery56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Delivery56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Delivery56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Delivery56_objectSpread(Delivery56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.56 41.14c-11.25 0-20.37.42-20.37.93s9.12.93 20.37.93 20.37-.42 20.37-.93-9.12-.93-20.37-.93ZM10.72 24.31l-.68 9.55s4.59-.21 8.4-.34c1.06-.04.63-1.41-.36-1.74-4.38-1.44-4.71-4.31-5.77-7.11-.43-1.14-1.51-1.56-1.59-.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.11 37h2.13l1.38-7.54s.1-.99-.5-2.11c-.6-1.12-3.43-5.81-3.43-5.81s-.37-.5-.85-.78c-.55-.31-1.6-.3-3.02-.31-3.19-.03-5.96.12-5.96.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.84 36.97h3.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.62 36.97h16.04v-3.04H10.27v3.04h2.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.65 33.97H9.67l1.67-21h27.14l-1.83 21z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.1 28.23c-.06.12-9.35.08-9.35.08-.39 0-.68-.31-.65-.69l.38-4.61c.03-.38.38-.69.76-.69h4.92c.39 0 .86.27 1.05.6 0 0 2.94 5.2 2.88 5.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.62 38.05c0 2.19-1.78 3.96-3.97 3.96s-3.97-1.77-3.97-3.96 1.78-3.96 3.97-3.96 3.97 1.77 3.97 3.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.71 38.08c0 1.15-.93 2.08-2.08 2.08s-2.08-.93-2.08-2.08.93-2.08 2.08-2.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.25 38.05c0 2.19-1.78 3.96-3.97 3.96s-3.97-1.77-3.97-3.96 1.78-3.96 3.97-3.96 3.97 1.77 3.97 3.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.36 38.08c0 1.15-.93 2.08-2.08 2.08s-2.08-.93-2.08-2.08.93-2.08 2.08-2.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.1 16.38H9.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.18 26.75H6.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.75 26.75h-3.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.28 22.81H3.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.85 19.49H5.73"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Delivery56 = (Delivery56);
;// ./src/Picto/GeneratedPictoComponents/Payment104.tsx


var Payment104_excluded = ["className"];
function Payment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Payment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Payment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Payment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Payment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Payment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Payment104_objectSpread(Payment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.37 79.29c-6.17 0-31.89 0-37.03-3.09-5.14-3.09-6.69-5.66-8.23-9.26-1.42-3.31-4.11-3.09-4.11-3.09v14.4a4.11 4.11 0 0 0 4.11 4.11h51.43s0-3.09-6.17-3.09ZM10 42.15h68.95v7.66H10zM15.75 55.56H46.4v7.66H15.75z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10",
        y: "36.41",
        width: "68.95",
        height: "45.97",
        rx: "3.83",
        ry: "3.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 42.15h68.95v7.66H10zM15.75 55.56H46.4v7.66H15.75z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m92.79 36.9.72-7.39H24.56v3.83h49.8c2.82 0 5.56 1.25 6.89 3.53l11.54.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.32 32.58v-5.75A3.83 3.83 0 0 1 29.15 23h61.29a3.83 3.83 0 0 1 3.83 3.83v38.31a3.83 3.83 0 0 1-3.83 3.83h-7.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.32 28.75h68.96v7.66H81.81"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Payment104 = (Payment104);
;// ./src/Picto/GeneratedPictoComponents/Payment56.tsx


var Payment56_excluded = ["className"];
function Payment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Payment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Payment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Payment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Payment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Payment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Payment56_objectSpread(Payment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.78 42.39c-3.22 0-16.65 0-19.33-1.61-2.69-1.61-3.49-2.95-4.3-4.83C7.41 34.22 6 34.34 6 34.34v7.52c0 1.19.96 2.15 2.15 2.15H35s0-1.61-3.22-1.61ZM6 23h36v4H6zM9 30h16v4H9z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "20",
        width: "36",
        height: "24",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 23h36v4H6zM9 30h16v4H9z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.29 16.29v2h26c1.47 0 2.75.81 3.44 2h6.56v-4h-36Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14 18v-3c0-1.1.9-2 2-2h32c1.1 0 2 .9 2 2v20c0 1.1-.9 2-2 2h-4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14 16h36v4h-6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Payment56 = (Payment56);
;// ./src/Picto/GeneratedPictoComponents/PaymentCalendar104.tsx


var PaymentCalendar104_excluded = ["className"];
function PaymentCalendar104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentCalendar104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentCalendar104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentCalendar104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentCalendar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentCalendar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentCalendar104_objectSpread(PaymentCalendar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.24 64.3h59.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.21 45.21v40.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.47 45.43c-3.76.18-7.56 1.38-10.46 3.85-2.77 2.36-3.79 6.1-2.5 9.52 1.94 5.15 7.31 7.58 12.57 7.1 4.85-.44 9.68-2.79 12.59-6.77 3.05-4.18 2.76-10.29-1.14-13.88-2.48-2.28-5.86-3.1-9.14-3.35-3.46-.27-6.97.1-10.4.52-.77.1-1.44.59-1.44 1.43 0 .7.66 1.53 1.44 1.43 2.85-.35 5.73-.65 8.6-.6 2.38.04 4.91.3 7 1.33 2.14 1.05 3.51 2.77 4.09 5 .24.92.29 1.6.2 2.71 0 .07-.05.36 0 .08-.02.13-.04.26-.07.39-.04.22-.1.43-.16.64-.06.21-.13.42-.2.63-.04.12-.09.25-.14.37.11-.27-.06.12-.07.14a11.56 11.56 0 0 1-3.61 4.2c-1.77 1.26-3.41 2-5.47 2.51-1.14.28-1.77.38-2.92.41-1.13.04-1.92-.02-2.84-.22-1.93-.41-3.39-1.17-4.71-2.62-1.99-2.18-2.65-5.67-.58-8.03 2.27-2.58 6.03-3.76 9.37-3.92 1.84-.09 1.85-2.96 0-2.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.6 41.75c5.99-11.21 11.78-16.96 16.07-19.91 1.56-1.07.9-3.49-.99-3.61l-11.18-.72-6.1 6.98-.4 16.59c-.04 1.46 1.92 1.96 2.6.68Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.56 60.74v-4.97l-.71-.16c-2.62-.6-3.91-1.98-3.91-4.09 0-2.71 2-4.46 4.67-4.71V44.9h1.75v1.93c2.32.32 4.28 1.82 4.51 4.51h-2.53c-.12-1.15-.74-2.07-1.98-2.37v4.71l1.04.23c2.35.55 3.77 1.95 3.77 4.25 0 2.83-1.91 4.51-4.85 4.76v2.28h-1.75v-2.3c-2.95-.32-4.9-2.14-4.97-5.04h2.62c.07 1.45.83 2.55 2.35 2.87Zm.05-7.45v-4.37c-1.43.23-2.21 1.15-2.21 2.35 0 .97.58 1.61 2.21 2.02Zm1.7 2.85v4.65c1.45-.23 2.37-1.1 2.37-2.41 0-1.08-.62-1.84-2.3-2.21l-.07-.02Z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.58 52.87v30c0 4.47-3.62 8.1-8.1 8.1H23.79c-4.47 0-8.1-3.62-8.1-8.1v-56.7c0-4.47 3.62-8.1 8.1-8.1h56.69c4.47 0 8.1 3.63 8.1 8.1v27.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.21 10.73v16.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.81 10.73v16.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.69 34.9h72.89"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentCalendar104 = (PaymentCalendar104);
;// ./src/Picto/GeneratedPictoComponents/PaymentCalendar56.tsx


var PaymentCalendar56_excluded = ["className"];
function PaymentCalendar56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentCalendar56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentCalendar56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentCalendar56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentCalendar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentCalendar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentCalendar56_objectSpread(PaymentCalendar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 34.8h32.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.23 24.54v21.52"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.87 21.86c2.97-5.47 5.83-8.36 7.99-9.89.85-.6.46-1.93-.58-2l-5.56-.36-3.16 3.61-.2 8.25c-.02.84 1.1 1.13 1.5.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.23 24.66c-2.02.1-4.07.74-5.62 2.07-1.49 1.27-2.04 3.28-1.34 5.12 1.05 2.77 3.93 4.08 6.76 3.82 2.61-.24 5.21-1.5 6.77-3.64 1.64-2.25 1.49-5.54-.61-7.46-1.34-1.23-3.15-1.67-4.92-1.8-1.86-.14-3.75.05-5.59.28-.41.05-.77.32-.77.77 0 .38.36.82.77.77 1.53-.19 3.08-.35 4.63-.33 1.28.02 2.64.16 3.76.71 1.15.57 1.89 1.49 2.2 2.69.13.5.16.86.11 1.45 0 .04-.03.19 0 .04-.01.07-.02.14-.04.21-.02.12-.05.23-.08.34-.03.11-.07.23-.11.34-.02.07-.05.13-.08.2.06-.15-.03.07-.04.08-.47.93-1.16 1.7-1.94 2.26-.95.68-1.83 1.07-2.94 1.35-.61.15-.95.2-1.57.22-.61.02-1.03-.01-1.53-.12-1.04-.22-1.83-.63-2.53-1.41-1.07-1.17-1.42-3.05-.31-4.32 1.22-1.39 3.24-2.02 5.04-2.11.99-.05 1-1.59 0-1.54"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.8 28.68v16.15c0 2.41-1.95 4.36-4.36 4.36H12.91c-2.41 0-4.36-1.95-4.36-4.36V14.3c0-2.41 1.95-4.36 4.36-4.36h30.53c2.41 0 4.36 1.95 4.36 4.36v14.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.83 5.99v8.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.38 5.99v8.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.55 19.43H47.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.25 32.89v-2.66l-.38-.09c-1.4-.32-2.09-1.06-2.09-2.19 0-1.45 1.07-2.39 2.5-2.52v-1.02h.93v1.03c1.24.17 2.29.97 2.41 2.41h-1.35c-.06-.61-.39-1.11-1.06-1.27v2.52l.55.12c1.25.29 2.02 1.04 2.02 2.28 0 1.51-1.02 2.41-2.59 2.55v1.22h-.93v-1.23c-1.57-.17-2.62-1.14-2.66-2.69H18c.04.77.44 1.37 1.25 1.54Zm.02-3.98v-2.34c-.76.12-1.18.62-1.18 1.25 0 .52.31.86 1.18 1.08Zm.91 1.52v2.48c.77-.12 1.27-.59 1.27-1.29 0-.58-.33-.98-1.23-1.18h-.04Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentCalendar56 = (PaymentCalendar56);
;// ./src/Picto/GeneratedPictoComponents/PaymentHelp104.tsx


var PaymentHelp104_excluded = ["className"];
function PaymentHelp104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentHelp104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentHelp104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentHelp104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentHelp104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentHelp104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentHelp104_objectSpread(PaymentHelp104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.91 82.86s-.05-.04-.07-.05c.3.16.59.3.85.39 1.25.46 2.65.43 3.78-.25-3.45.01-5.06-7.05-7.01-9.22-1.61-1.8-3.9-2.83-5.8-4.34-4.59-3.66-6.62-9.91-11.37-13.36-1.87-1.36-4.06-2.2-6.22-3-3.51-1.31-7.09-2.59-10.82-3.1-1.72-.24-6.07-1.22-7.32.32 4.54 2.19 9.11 4.38 13.65 6.59.14.07 8.18 3.98 8.18 3.98l.36.78c.36.78 2.36 3.43 3.27 4.94.91 1.5 5.4 5.77 5.4 5.77l6.86 5.99s.28.24.72.6",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.24 66.24c2.8-3.72 3.37-8.13 3.37-8.13 2.7-1.48 5.4-2.95 8.1-4.43.83-.45 2.91-1.76 4.39-3.2 1.89-1.84 2.79-3.89-1.16-4.65-1.42-.27-2.9.07-4.11.87l-8.49 5.63c-1.52 1.01-3.07 2.05-4.12 3.53-.7.99-1.14 2.12-1.58 3.25s-.24 2.33.49 3.25l3.11 3.88ZM69.73 52.91c-2.69-.37-6.15-4.09-8.79-5.13-2.64-1.05-9.9.42-12.7.3-.61-.03-1.2-.2-1.76-.43-1.43-.58-2.22-.3-2.7.2.14.2.31.38.5.55-.04.23-.22 1.88 1.72 2.89 1.06.55 5.79.12 8.91.79 3.12.66 8.51 4.01 13.28 3.73l-.51-.56c3.07.9 6 .59 6 .59s-.65-2.47-3.94-2.92Zm-17.77-2.87c.81-.06 1.69-.12 2.55-.19-.32.03-.64.07-1 .11-.51.06-1.03.08-1.55.08Zm6.1-.48c.65-.06 1.06-.09 1.06-.09s.23.26.63.66c-.38-.32-.66-.53-.76-.55-.13-.03-.41-.04-.93-.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M97.53 49.96c-10.3 5.63-14.92 8.15-14.92 8.15s-.28 3.55-2.88 7.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.78 26.74C69.96 40.66 69.73 40.51 68.23 41.09c-2.25.86-3.65.09-6.44-.3-2.79-.39-7.81.78-10.77 1.37-2.96.6-7.62.66-7.97 3.06-.35 2.4 2.21 4.98 6.16 4.97h.5c3.92-.03 7.69-.84 9.16-.64 1.47.2 5.45 7.03 14.81 6.29"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m21.55 28.94 18.21 14.11s.51.4 1.25.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m70.42 71.02 1.03 1s3.25 3.14 6.16.75c2.36-1.94 1.83-4.3.66-6.02 0 0-4.38-6.05-7.06-8.23-.37-.21-.85-.59-.85-.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.71 77.34c-.2 2.38-1.77 3.43-1.77 3.43-3.16 2.53-7.13-.72-7.13-.72l-1.91-1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.9 73.05s-.01 2.96-2.35 4.37c-2.77 1.68-5.78-.65-5.78-.65l-1.88-1.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.51 81.27c-.17.5-.47.97-.89 1.36l-.1.1c-1.37 1.26-3.68 1.37-5.39.24 0 0-5.08-3.21-12.02-9.66C32.21 66.27 30.2 61 30.2 61S18.16 55.18 8.39 50.47"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentHelp104 = (PaymentHelp104);
;// ./src/Picto/GeneratedPictoComponents/PaymentHelp56.tsx


var PaymentHelp56_excluded = ["className"];
function PaymentHelp56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentHelp56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentHelp56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentHelp56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentHelp56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentHelp56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentHelp56_objectSpread(PaymentHelp56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.86 43.22c.19.1.36.18.51.24.67.25 1.43.23 2.04-.14-1.85 0-2.73-3.8-3.77-4.96-.87-.97-2.1-1.53-3.12-2.34-2.47-1.97-3.56-5.34-6.12-7.19-1.01-.73-2.18-1.18-3.35-1.62-1.89-.7-3.82-1.39-5.83-1.67-.92-.13-3.27-.66-3.94.17 2.45 1.18 4.9 2.36 7.35 3.55l4.4 2.14.19.42c.19.42 1.27 1.85 1.76 2.66s2.91 3.11 2.91 3.11l3.7 3.22s.15.13.39.33",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.68 34.36c1.56-2.03 1.8-4.47 1.8-4.47 1.45-.8 2.91-1.59 4.36-2.38.45-.24 1.57-.95 2.36-1.72.99-.96 1.48-2.03-.45-2.47-.86-.19-1.76.02-2.49.51l-4.46 2.96c-.82.54-1.65 1.1-2.22 1.9-.32.46-.54.97-.75 1.49-.3.75-.17 1.6.32 2.23l1.52 1.96ZM37.55 27.09c-1.45-.2-3.31-2.2-4.74-2.76-1.42-.56-5.33.23-6.84.16-.33-.01-.65-.11-.95-.23-.77-.31-1.19-.16-1.45.11.07.11.17.2.27.3-.01.08-.15 1 .92 1.56.57.3 3.12.07 4.8.42 1.68.36 4.58 2.16 7.15 2.01l-.28-.31c1.65.49 3.24.32 3.24.32s-.35-1.33-2.12-1.57Zm-9.56-1.54c.44-.03.91-.07 1.38-.1-.18.02-.35.04-.55.06-.27.03-.55.04-.83.04Zm3.27-.26.58-.05s.12.14.34.36c-.21-.17-.36-.29-.41-.3-.07-.01-.22-.02-.51 0Zm3.93 2.56Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.52 25.5c-5.55 3.03-8.03 4.39-8.03 4.39s-.15 1.95-1.59 4.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.19 13c-8.52 7.5-8.64 7.42-9.45 7.72-1.21.46-1.97.05-3.47-.16-1.5-.21-4.21.42-5.8.74-1.59.32-4.1.35-4.29 1.65-.19 1.29 1.19 2.68 3.32 2.68h.27c2.11-.02 4.14-.45 4.93-.35.79.11 2.94 3.79 7.97 3.39"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.51 42.36c-.09.27-.25.52-.48.73l-.06.05c-.74.68-1.98.74-2.9.13 0 0-2.73-1.73-6.47-5.2-4.26-3.79-5.33-6.63-5.33-6.63L4.53 25.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.6 14.18 9.81 7.6s.46.38.84.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.92 36.85.55.54s1.75 1.69 3.32.4c1.27-1.04.99-2.32.36-3.24 0 0-2.36-3.26-3.8-4.43-.39-.32-.15-.13-.41-.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.38 40.25c-.11 1.28-.96 1.85-.96 1.85-1.7 1.36-3.84-.39-3.84-.39l-1.03-.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.25 37.93s0 1.59-1.27 2.35c-1.49.9-3.11-.35-3.11-.35l-1.01-.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentHelp56 = (PaymentHelp56);
;// ./src/Picto/GeneratedPictoComponents/PaymentPlan104.tsx


var PaymentPlan104_excluded = ["className"];
function PaymentPlan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentPlan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentPlan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentPlan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentPlan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentPlan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentPlan104_objectSpread(PaymentPlan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.47 44.63c-3.76.18-7.56 1.38-10.46 3.85-2.77 2.36-3.79 6.1-2.5 9.52 1.94 5.15 7.31 7.58 12.57 7.1 4.85-.44 9.68-2.79 12.59-6.77 3.05-4.18 2.76-10.29-1.14-13.88-2.48-2.28-5.86-3.1-9.14-3.35-3.46-.27-6.97.1-10.4.52-.77.1-1.44.59-1.44 1.43 0 .7.66 1.53 1.44 1.43 2.85-.35 5.73-.65 8.6-.6 2.38.04 4.91.3 7 1.33 2.14 1.05 3.51 2.77 4.09 5 .24.92.29 1.6.2 2.71 0 .07-.05.36 0 .08-.02.13-.04.26-.07.39-.04.22-.1.43-.16.64-.06.21-.13.42-.2.63-.04.12-.09.25-.14.37.11-.27-.06.12-.07.14a11.56 11.56 0 0 1-3.61 4.2c-1.77 1.26-3.41 2-5.47 2.51-1.14.28-1.77.38-2.92.41-1.13.04-1.92-.02-2.84-.22-1.93-.41-3.39-1.17-4.71-2.62-1.99-2.18-2.65-5.67-.58-8.03 2.27-2.58 6.03-3.76 9.37-3.92 1.84-.09 1.85-2.96 0-2.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.7 40.17c5.69-10.65 11.19-16.12 15.27-18.92 1.48-1.02.85-3.32-.94-3.44l-10.62-.68-5.8 6.63-.38 15.76c-.03 1.38 1.82 1.87 2.47.65Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.56 59.94v-4.97l-.71-.16c-2.62-.6-3.91-1.98-3.91-4.09 0-2.71 2-4.46 4.67-4.71V44.1h1.75v1.93c2.32.32 4.28 1.82 4.51 4.51h-2.53c-.12-1.15-.74-2.07-1.98-2.37v4.71l1.04.23c2.35.55 3.77 1.95 3.77 4.25 0 2.83-1.91 4.51-4.86 4.76v2.28h-1.75v-2.3c-2.95-.32-4.9-2.14-4.97-5.04h2.62c.07 1.45.83 2.55 2.35 2.87Zm.05-7.45v-4.37c-1.43.23-2.21 1.15-2.21 2.35 0 .97.58 1.61 2.21 2.02Zm1.7 2.85v4.65c1.45-.23 2.37-1.1 2.37-2.41 0-1.08-.62-1.84-2.3-2.21l-.07-.02Z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.21 85.5H21.84c-4.19 0-7.59-3.4-7.59-7.59V24.76c0-4.19 3.4-7.59 7.59-7.59h53.15c4.19 0 7.59 3.4 7.59 7.59v25.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.58 49.79v9.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.48 10.28v15.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.11 10.28v15.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.25 34.5h68.33"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.56 71.96c-.28 4.69.46 13.43 8.54 19.1.68.47.17 1.55-.62 1.34-3.16-.82-7.47-2.95-9.56-8.46 0 0-2.54-6.46.22-12.36.35-.74 1.47-.43 1.42.38Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.2",
        cy: "78.04",
        r: "14.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.76 78.57 4.61 4.61L83.65 72.9"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentPlan104 = (PaymentPlan104);
;// ./src/Picto/GeneratedPictoComponents/PaymentPlan56.tsx


var PaymentPlan56_excluded = ["className"];
function PaymentPlan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PaymentPlan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PaymentPlan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PaymentPlan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PaymentPlan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PaymentPlan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PaymentPlan56_objectSpread(PaymentPlan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.94 24.08c-2.02.1-4.07.75-5.63 2.07-1.49 1.27-2.04 3.29-1.34 5.13 1.05 2.77 3.94 4.08 6.77 3.82 2.61-.24 5.21-1.5 6.78-3.65 1.64-2.25 1.49-5.54-.62-7.47-1.34-1.23-3.16-1.67-4.92-1.8-1.87-.14-3.75.05-5.6.28-.41.05-.77.32-.77.77 0 .38.36.82.77.77 1.54-.19 3.08-.35 4.63-.33 1.28.02 2.64.16 3.77.72 1.15.57 1.89 1.49 2.2 2.69.13.5.16.86.11 1.46 0 .04-.03.19 0 .04-.01.07-.02.14-.04.21-.02.12-.05.23-.08.34-.03.11-.07.23-.11.34-.02.07-.05.13-.08.2.06-.15-.03.07-.04.08-.47.93-1.16 1.7-1.95 2.26-.96.68-1.84 1.08-2.95 1.35-.61.15-.95.2-1.57.22-.61.02-1.04-.01-1.53-.12-1.04-.22-1.83-.63-2.53-1.41-1.07-1.18-1.43-3.05-.31-4.33 1.22-1.39 3.25-2.02 5.04-2.11.99-.05 1-1.59 0-1.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.37 21.68c3.06-5.74 6.03-8.68 8.22-10.19.8-.55.46-1.79-.5-1.85l-5.72-.37-3.12 3.57-.21 8.49c-.02.75.98 1.01 1.33.35Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.96 32.34v-2.66l-.38-.09c-1.4-.32-2.09-1.06-2.09-2.19 0-1.45 1.07-2.39 2.5-2.52v-1.02h.93v1.03c1.24.17 2.29.97 2.41 2.41h-1.35c-.06-.61-.39-1.11-1.06-1.27v2.52l.55.12c1.25.29 2.02 1.04 2.02 2.28 0 1.51-1.02 2.41-2.59 2.55v1.22h-.93v-1.23c-1.57-.17-2.62-1.14-2.66-2.69h1.4c.04.77.44 1.37 1.25 1.54Zm.02-3.98v-2.34c-.76.12-1.18.62-1.18 1.25 0 .52.31.86 1.18 1.08Zm.91 1.52v2.48c.77-.12 1.27-.59 1.27-1.29 0-.58-.33-.98-1.23-1.18h-.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.72 46.09H12.67c-2.26 0-4.09-1.83-4.09-4.09V13.39c0-2.26 1.83-4.09 4.09-4.09h28.62c2.26 0 4.09 1.83 4.09 4.09v13.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.38 26.86v5.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.1 5.59v8.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.74 5.59v8.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.59 18.63h36.79"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.73 38.74c-.15 2.52.25 7.23 4.6 10.28.36.25.09.83-.34.72-1.7-.44-4.02-1.59-5.15-4.55 0 0-1.37-3.48.12-6.66.19-.4.79-.23.77.21Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.95",
        cy: "42.08",
        r: "8.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.94 42.36 2.48 2.48 5.53-5.53"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PaymentPlan56 = (PaymentPlan56);
;// ./src/Picto/GeneratedPictoComponents/PromoCombined104.tsx


var PromoCombined104_excluded = ["className"];
function PromoCombined104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoCombined104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoCombined104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoCombined104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoCombined104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoCombined104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoCombined104_objectSpread(PromoCombined104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.86 24.58c.36 0 .71-.36.71-.71 0-3.04 2.5-5.54 5.54-5.54.54-.18.89-.54.89-.89s-.36-.71-.71-.71c-3.04 0-5.54-2.5-5.54-5.54-.18-.54-.54-.89-.89-.89s-.89.36-.89.71c0 3.04-2.5 5.54-5.54 5.54-.36.18-.71.54-.71.89s.36.71.71.71c1.43 0 2.86.54 3.93 1.61a5.547 5.547 0 0 1 1.61 3.93c0 .18 0 .36.18.54.18.36.36.36.71.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.87 83.7c-2.14 0-3.69-1.75-3.69-3.69 0-.39-.2-.58-.59-.58s-.58.2-.58.58c0 2.14-1.75 3.69-3.69 3.69-.39 0-.58.19-.58.58s.19.58.58.58c.97 0 1.94.39 2.72 1.17.78.78 1.17 1.75 1.17 2.72 0 .39.19.58.58.58s.58-.19.58-.58c0-2.14 1.75-3.69 3.69-3.69.39 0 .58-.19.58-.58s-.39-.78-.78-.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.38 47.21-2.62 2.59c-.57.57-.9 1.37-.9 2.2s.33 1.64.9 2.21l5.22 5.16c.55.52.8 1.31.67 2.08l-1.33 7.38c-.15.83.04 1.69.51 2.36.46.66 1.16 1.09 1.92 1.19l7.13.97c.76.1 1.43.6 1.75 1.32l3.07 6.78c.33.73.95 1.3 1.7 1.56.63.22 1.53.16 2.21-.22l6.3-3.6c.35-.19.73-.29 1.11-.29s.76.1 1.1.3l6.16 3.51c.71.4 1.56.57 2.34.31s1.37-.82 1.71-1.57l.68-1.5c.2-.44-.04-.96-.5-1.09-11.86-3.52-32.07-15.83-39.1-31.65"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.93 54.92c.76-.75 1.2-1.81 1.2-2.92s-.44-2.16-1.2-2.92l-5.22-5.16a1.32 1.32 0 0 1-.37-1.2l1.32-7.38c.19-1.09-.05-2.22-.67-3.1-.62-.89-1.58-1.48-2.61-1.61l-7.14-.97c-.42-.05-.78-.34-.98-.74l-3.07-6.79c-.45-.99-1.29-1.76-2.28-2.09-1-.34-2.11-.23-3.02.29l-6.31 3.6c-.37.21-.82.21-1.21 0l-6.3-3.6c-.93-.52-2.03-.63-3.02-.29-1 .34-1.84 1.1-2.29 2.09l-3.07 6.79c-.18.4-.55.69-.98.74l-7.12.97c-1.04.13-1.99.73-2.61 1.61-.62.89-.86 2.01-.67 3.09l1.32 7.39c.08.44-.06.89-.39 1.2l-5.22 5.16c-.76.75-1.19 1.81-1.19 2.92s.44 2.16 1.19 2.92l5.22 5.16c.32.31.46.75.39 1.2l-1.32 7.38c-.19 1.09.05 2.22.67 3.11.62.89 1.57 1.48 2.61 1.61l7.12.97c.42.05.8.34.98.74l3.07 6.79a3.98 3.98 0 0 0 2.27 2.09c.39.13.78.19 1.18.19.64 0 1.29-.16 1.85-.48l6.3-3.6c.38-.21.83-.21 1.21 0l6.31 3.6c.91.52 2.02.63 3.02.29 1-.35 1.83-1.1 2.28-2.09l3.07-6.79c.19-.4.55-.69.98-.74l7.14-.97c1.04-.13 1.99-.72 2.61-1.62.62-.89.86-2.02.67-3.09l-1.32-7.38c-.08-.44.05-.89.37-1.2l5.22-5.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.99 45s2.38-.41 1 2.45c-2.45 5.1 7.64 11.57 9.02 11.06S52.31 64 52.31 64L38.5 50.36l6.67-6.25L47 45Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.49 50.36h-27M51.99 64.86l-13.5-14.5 5.87-6.34h15.26l5.87 6.34-13.5 14.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.7 50.36 5.29-6.34 5.28 6.34-5.28 14.5-5.29-14.5zM44.36 44.02l2.34 6.34M59.62 44.02l-2.35 6.34"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoCombined104 = (PromoCombined104);
;// ./src/Picto/GeneratedPictoComponents/PromoCombined56.tsx


var PromoCombined56_excluded = ["className"];
function PromoCombined56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoCombined56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoCombined56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoCombined56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoCombined56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoCombined56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoCombined56_objectSpread(PromoCombined56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.87 25.42-1.43 1.41a1.711 1.711 0 0 0 0 2.4l2.84 2.81c.3.29.44.71.36 1.13l-.72 4.02c-.08.45.02.92.28 1.28.25.36.63.59 1.04.65l3.88.53c.41.05.78.33.96.72l1.67 3.7c.18.4.52.71.93.85.34.12.84.09 1.2-.12l3.43-1.96a1.2 1.2 0 0 1 1.2 0l3.44 1.96c.37.21.8.25 1.2.12.41-.14.73-.44.92-.85l.58-1.27c-6.38-1.71-17.86-8.54-21.78-17.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.61 13.7c.19 0 .38-.19.38-.38a3 3 0 0 1 2.98-2.98c.29-.1.48-.29.48-.48s-.19-.38-.38-.38a3 3 0 0 1-2.98-2.98c-.1-.29-.29-.48-.48-.48s-.48.19-.48.38a3 3 0 0 1-2.98 2.98c-.19.1-.38.29-.38.48s.19.38.38.38c.77 0 1.54.29 2.12.87.58.58.87 1.35.87 2.12 0 .1 0 .19.1.29.1.19.19.19.38.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.92 45.53c-1.15 0-1.99-.94-1.99-1.99 0-.21-.11-.31-.32-.31s-.31.11-.31.31c0 1.15-.94 1.99-1.99 1.99-.21 0-.31.1-.31.31s.1.31.31.31c.52 0 1.05.21 1.46.63.42.42.63.94.63 1.46 0 .21.1.31.31.31s.31-.1.31-.31c0-1.15.94-1.99 1.99-1.99.21 0 .31-.1.31-.31s-.21-.42-.42-.42"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.65 29.57c.41-.41.64-.98.64-1.57s-.24-1.16-.64-1.57l-2.81-2.78a.719.719 0 0 1-.2-.64l.71-3.97c.1-.59-.03-1.19-.36-1.67-.33-.48-.85-.8-1.4-.87l-3.84-.52a.698.698 0 0 1-.53-.4l-1.65-3.65c-.24-.53-.69-.95-1.23-1.13-.54-.18-1.13-.12-1.63.16l-3.4 1.94c-.2.12-.44.12-.65 0l-3.39-1.94c-.5-.28-1.09-.34-1.63-.16-.54.18-.99.59-1.23 1.13l-1.65 3.65c-.1.22-.3.37-.53.4l-3.84.52c-.56.07-1.07.39-1.41.87-.33.48-.46 1.08-.36 1.66l.71 3.98a.69.69 0 0 1-.21.64l-2.81 2.78c-.41.41-.64.98-.64 1.57s.24 1.16.64 1.57l2.81 2.78c.17.17.25.41.21.64l-.71 3.97c-.1.59.03 1.19.36 1.67.33.48.85.8 1.41.87l3.84.52c.23.03.43.18.53.4l1.65 3.65c.24.54.69.94 1.22 1.13a2.071 2.071 0 0 0 1.64-.16l3.39-1.94c.21-.12.45-.12.65 0l3.4 1.94c.49.28 1.09.34 1.63.16.54-.19.98-.59 1.23-1.13l1.65-3.65c.1-.22.3-.37.53-.4l3.84-.52c.56-.07 1.07-.39 1.4-.87.33-.48.46-1.09.36-1.66L41.64 33a.71.71 0 0 1 .2-.64l2.81-2.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.25 24.05s1.3-.22.55 1.34c-1.34 2.79 4.17 6.32 4.92 6.04s-2.57 3-2.57 3l-7.54-7.45 3.64-3.41 1 .48Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.26 27.12H20.72M27.99 34.93l-7.27-7.81 3.16-3.42h8.21l3.17 3.42-7.27 7.81z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.14 27.12 2.85-3.42 2.84 3.42-2.84 7.81-2.85-7.81zM23.88 23.7l1.26 3.42M32.09 23.7l-1.26 3.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoCombined56 = (PromoCombined56);
;// ./src/Picto/GeneratedPictoComponents/PromoData104.tsx


var PromoData104_excluded = ["className"];
function PromoData104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoData104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoData104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoData104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoData104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoData104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoData104_objectSpread(PromoData104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.38 47.21-2.62 2.59c-.57.57-.9 1.37-.9 2.2s.33 1.64.9 2.21l5.22 5.16c.55.52.8 1.31.67 2.08l-1.33 7.38c-.15.83.04 1.69.51 2.36.46.66 1.16 1.09 1.92 1.19l7.13.97c.76.1 1.43.6 1.75 1.32l3.07 6.78c.33.73.95 1.3 1.7 1.56.63.22 1.53.16 2.21-.22l6.3-3.6c.35-.19.73-.29 1.11-.29s.76.1 1.1.3l6.16 3.51c.71.4 1.56.57 2.34.31s1.37-.82 1.71-1.57l.65-1.44a.847.847 0 0 0-.54-1.16C51.58 75.31 31.42 63.02 24.4 47.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.86 24.58c.36 0 .71-.36.71-.71 0-3.04 2.5-5.54 5.54-5.54.54-.18.89-.54.89-.89s-.36-.71-.71-.71c-3.04 0-5.54-2.5-5.54-5.54-.18-.54-.54-.89-.89-.89s-.89.36-.89.71c0 3.04-2.5 5.54-5.54 5.54-.36.18-.71.54-.71.89s.36.71.71.71c1.43 0 2.86.54 3.93 1.61a5.547 5.547 0 0 1 1.61 3.93c0 .18 0 .36.18.54.18.36.36.36.71.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.87 83.7c-2.14 0-3.69-1.75-3.69-3.69 0-.39-.2-.58-.59-.58s-.58.2-.58.58c0 2.14-1.75 3.69-3.69 3.69-.39 0-.58.19-.58.58s.19.58.58.58c.97 0 1.94.39 2.72 1.17.78.78 1.17 1.75 1.17 2.72 0 .39.19.58.58.58s.58-.19.58-.58c0-2.14 1.75-3.69 3.69-3.69.39 0 .58-.19.58-.58s-.39-.78-.78-.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.95 54.92c.76-.75 1.2-1.81 1.2-2.92s-.44-2.16-1.2-2.92l-5.22-5.16a1.32 1.32 0 0 1-.37-1.2l1.32-7.38c.19-1.09-.05-2.22-.67-3.1-.62-.89-1.58-1.48-2.61-1.61l-7.14-.97c-.42-.05-.78-.34-.98-.74l-3.07-6.79c-.45-.99-1.29-1.76-2.28-2.09-1-.34-2.11-.23-3.02.29l-6.31 3.6c-.37.21-.82.21-1.21 0l-6.3-3.6c-.93-.52-2.03-.63-3.02-.29-1 .34-1.84 1.1-2.29 2.09l-3.07 6.79c-.18.4-.55.69-.98.74l-7.12.97c-1.04.13-1.99.72-2.61 1.61-.62.89-.86 2.01-.67 3.09l1.32 7.39c.08.44-.06.89-.39 1.2l-5.22 5.16c-.76.75-1.19 1.81-1.19 2.92s.44 2.16 1.19 2.92l5.22 5.16c.32.31.46.75.39 1.2l-1.32 7.38c-.19 1.09.05 2.22.67 3.11.62.89 1.57 1.48 2.61 1.61l7.12.97c.42.05.8.34.98.74l3.07 6.79a3.98 3.98 0 0 0 2.27 2.09c.39.13.78.19 1.18.19.64 0 1.29-.16 1.85-.48l6.3-3.6c.38-.21.83-.21 1.21 0l6.31 3.6c.91.52 2.02.63 3.02.29 1-.35 1.83-1.1 2.28-2.09l3.07-6.79c.19-.4.55-.69.98-.74l7.14-.97c1.04-.13 1.99-.72 2.61-1.62.62-.89.86-2.02.67-3.09l-1.32-7.38c-.08-.44.05-.89.37-1.2l5.22-5.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.85 47.67-2.52.98c-.65-1.73-2.04-2.86-4.25-2.86-3.14 0-5.16 2.38-5.16 5.98s2.06 6.05 5.16 6.05c2.09 0 4.32-1.13 4.58-4.18h-3.79v-2.26h6.19v8.54h-2.38v-2.26c-1.03 1.58-2.83 2.54-5.02 2.54-4.3 0-7.68-3.38-7.68-8.45s3.53-8.45 8.11-8.45c3.34 0 5.81 1.82 6.75 4.34ZM54.74 43.61h6.89c3.26 0 5.09 1.75 5.09 4.18 0 1.66-.82 2.98-2.54 3.46 2.21.58 3.17 2.04 3.17 4.01 0 2.76-1.92 4.68-5.59 4.68h-7.01V43.62Zm2.86 2.4v4.13h3.86c1.58 0 2.4-.74 2.4-2.06s-.82-2.06-2.4-2.06H57.6Zm6.86 9.02c0-1.56-.98-2.5-2.9-2.5H57.6v4.99h3.96c1.92 0 2.9-.94 2.9-2.5Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoData104 = (PromoData104);
;// ./src/Picto/GeneratedPictoComponents/PromoData56.tsx


var PromoData56_excluded = ["className"];
function PromoData56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoData56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoData56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoData56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoData56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoData56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoData56_objectSpread(PromoData56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.87 25.42-1.43 1.41a1.711 1.711 0 0 0 0 2.4l2.84 2.81c.3.29.44.71.36 1.13l-.72 4.02c-.08.45.02.92.28 1.28.25.36.63.59 1.04.65l3.88.53c.41.05.78.33.96.72l1.67 3.7c.18.4.52.71.93.85.34.12.84.09 1.2-.12l3.43-1.96a1.2 1.2 0 0 1 1.2 0l3.44 1.96c.37.21.8.25 1.2.12.41-.14.73-.44.92-.85l.58-1.27c-6.38-1.71-17.86-8.54-21.78-17.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.62 13.7c.19 0 .38-.19.38-.38a3 3 0 0 1 2.98-2.98c.29-.1.48-.29.48-.48s-.19-.38-.38-.38A3 3 0 0 1 10.1 6.5c-.1-.29-.29-.48-.48-.48s-.48.19-.48.38a3 3 0 0 1-2.98 2.98c-.19.1-.38.29-.38.48s.19.38.38.38c.77 0 1.54.29 2.12.87.58.58.87 1.35.87 2.12 0 .1 0 .19.1.29.1.19.19.19.38.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.93 45.53c-1.15 0-1.99-.94-1.99-1.99 0-.21-.11-.31-.32-.31s-.31.11-.31.31c0 1.15-.94 1.99-1.99 1.99-.21 0-.31.1-.31.31s.1.31.31.31c.52 0 1.05.21 1.46.63.42.42.63.94.63 1.46 0 .21.1.31.31.31s.31-.1.31-.31c0-1.15.94-1.99 1.99-1.99.21 0 .31-.1.31-.31s-.21-.42-.42-.42"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.66 29.57c.41-.41.64-.98.64-1.57s-.24-1.16-.64-1.57l-2.81-2.78a.719.719 0 0 1-.2-.64l.71-3.97c.1-.59-.03-1.19-.36-1.67-.33-.48-.85-.8-1.4-.87l-3.84-.52a.698.698 0 0 1-.53-.4l-1.65-3.65c-.24-.53-.69-.95-1.23-1.13-.54-.18-1.13-.12-1.63.16l-3.4 1.94c-.2.12-.44.12-.65 0l-3.39-1.94c-.5-.28-1.09-.34-1.63-.16-.54.18-.99.59-1.23 1.13l-1.65 3.65c-.1.22-.3.37-.53.4l-3.84.52c-.56.07-1.07.39-1.41.87-.33.48-.46 1.08-.36 1.66l.71 3.98a.69.69 0 0 1-.21.64l-2.81 2.78c-.41.41-.64.98-.64 1.57s.24 1.16.64 1.57l2.81 2.78c.17.17.25.41.21.64l-.71 3.97c-.1.59.03 1.19.36 1.67.33.48.85.8 1.41.87l3.84.52c.23.03.43.18.53.4l1.65 3.65c.24.54.69.94 1.22 1.13a2.071 2.071 0 0 0 1.64-.16l3.39-1.94c.21-.12.45-.12.65 0l3.4 1.94c.49.28 1.09.34 1.63.16.54-.19.98-.59 1.23-1.13l1.65-3.65c.1-.22.3-.37.53-.4l3.84-.52c.56-.07 1.07-.39 1.4-.87.33-.48.46-1.09.36-1.66L41.65 33a.71.71 0 0 1 .2-.64l2.81-2.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.59 25.77-1.37.53c-.35-.94-1.11-1.55-2.3-1.55-1.7 0-2.8 1.29-2.8 3.24s1.12 3.28 2.8 3.28c1.13 0 2.34-.61 2.48-2.26h-2.05v-1.22h3.35v4.63h-1.29V31.2c-.56.86-1.54 1.38-2.72 1.38-2.33 0-4.16-1.83-4.16-4.58s1.91-4.58 4.39-4.58c1.81 0 3.15.99 3.65 2.35ZM29.75 23.57h3.73c1.77 0 2.76.95 2.76 2.26 0 .9-.44 1.61-1.38 1.87 1.2.31 1.72 1.1 1.72 2.17 0 1.5-1.04 2.54-3.03 2.54h-3.8v-8.84Zm1.55 1.3v2.24h2.09c.86 0 1.3-.4 1.3-1.12s-.44-1.12-1.3-1.12H31.3Zm3.72 4.89c0-.84-.53-1.35-1.57-1.35H31.3v2.7h2.15c1.04 0 1.57-.51 1.57-1.35Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoData56 = (PromoData56);
;// ./src/Picto/GeneratedPictoComponents/PromoDiscount104.tsx


var PromoDiscount104_excluded = ["className"];
function PromoDiscount104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoDiscount104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoDiscount104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoDiscount104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoDiscount104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoDiscount104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoDiscount104_objectSpread(PromoDiscount104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.86 24.58c.36 0 .71-.36.71-.71 0-3.04 2.5-5.54 5.54-5.54.54-.18.89-.54.89-.89s-.36-.71-.71-.71c-3.04 0-5.54-2.5-5.54-5.54-.18-.54-.54-.89-.89-.89s-.89.36-.89.71c0 3.04-2.5 5.54-5.54 5.54-.36.18-.71.54-.71.89s.36.71.71.71c1.43 0 2.86.54 3.93 1.61a5.547 5.547 0 0 1 1.61 3.93c0 .18 0 .36.18.54.18.36.36.36.71.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.87 83.7c-2.14 0-3.69-1.75-3.69-3.69 0-.39-.2-.58-.59-.58s-.58.2-.58.58c0 2.14-1.75 3.69-3.69 3.69-.39 0-.58.19-.58.58s.19.58.58.58c.97 0 1.94.39 2.72 1.17.78.78 1.17 1.75 1.17 2.72 0 .39.19.58.58.58s.58-.19.58-.58c0-2.14 1.75-3.69 3.69-3.69.39 0 .58-.19.58-.58s-.39-.78-.78-.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.38 47.21-2.62 2.59c-.57.57-.9 1.37-.9 2.2s.33 1.64.9 2.21l5.22 5.16c.55.52.8 1.31.67 2.08l-1.33 7.38c-.15.83.04 1.69.51 2.36.46.66 1.16 1.09 1.92 1.19l7.13.97c.76.1 1.43.6 1.75 1.32l3.07 6.78c.33.73.95 1.3 1.7 1.56.63.22 1.53.16 2.21-.22l6.3-3.6c.35-.19.73-.29 1.11-.29s.76.1 1.1.3l6.2 3.53c.68.39 1.51.54 2.26.3s1.4-.82 1.75-1.58l.49-1.07c.3-.66-.04-1.43-.73-1.64-11.91-3.68-31.73-15.88-38.68-31.52"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.95 54.92c.76-.75 1.2-1.81 1.2-2.92s-.44-2.16-1.2-2.92l-5.22-5.16a1.32 1.32 0 0 1-.37-1.2l1.32-7.38c.19-1.09-.05-2.22-.67-3.1-.62-.89-1.58-1.48-2.61-1.61l-7.14-.97c-.42-.05-.78-.34-.98-.74l-3.07-6.79c-.45-.99-1.29-1.76-2.28-2.09-1-.34-2.11-.23-3.02.29l-6.31 3.6c-.37.21-.82.21-1.21 0l-6.3-3.6c-.93-.52-2.03-.63-3.02-.29-1 .34-1.84 1.1-2.29 2.09l-3.07 6.79c-.18.4-.55.69-.98.74l-7.12.97c-1.04.13-1.99.73-2.61 1.61-.62.89-.86 2.01-.67 3.09l1.32 7.39c.08.44-.06.89-.39 1.2l-5.22 5.16c-.76.75-1.19 1.81-1.19 2.92s.44 2.16 1.19 2.92l5.22 5.16c.32.31.46.75.39 1.2l-1.32 7.38c-.19 1.09.05 2.22.67 3.11.62.89 1.57 1.48 2.61 1.61l7.12.97c.42.05.8.34.98.74l3.07 6.79a3.98 3.98 0 0 0 2.27 2.09c.39.13.78.19 1.18.19.64 0 1.29-.16 1.85-.48l6.3-3.6c.38-.21.83-.21 1.21 0l6.31 3.6c.91.52 2.02.63 3.02.29 1-.35 1.83-1.1 2.28-2.09l3.07-6.79c.19-.4.55-.69.98-.74l7.14-.97c1.04-.13 1.99-.72 2.61-1.62.62-.89.86-2.02.67-3.09l-1.32-7.38c-.08-.44.05-.89.37-1.2l5.22-5.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M50.76 59.43v-6.27l-.9-.2c-3.31-.75-4.93-2.49-4.93-5.16 0-3.42 2.52-5.63 5.89-5.95v-2.41h2.2v2.44c2.93.41 5.4 2.29 5.69 5.69h-3.19c-.15-1.45-.93-2.61-2.5-2.99v5.95l1.31.29c2.96.7 4.76 2.47 4.76 5.37 0 3.57-2.41 5.69-6.12 6v2.87h-2.21v-2.9c-3.71-.41-6.18-2.7-6.26-6.35h3.31c.09 1.83 1.04 3.22 2.96 3.63Zm.06-9.4v-5.51c-1.8.29-2.79 1.45-2.79 2.96 0 1.22.73 2.03 2.79 2.55Zm2.15 3.6v5.86c1.83-.29 2.99-1.39 2.99-3.05 0-1.36-.78-2.32-2.9-2.78l-.09-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoDiscount104 = (PromoDiscount104);
;// ./src/Picto/GeneratedPictoComponents/PromoDiscount56.tsx


var PromoDiscount56_excluded = ["className"];
function PromoDiscount56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PromoDiscount56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PromoDiscount56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PromoDiscount56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PromoDiscount56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PromoDiscount56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PromoDiscount56_objectSpread(PromoDiscount56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.87 25.42-1.43 1.41a1.711 1.711 0 0 0 0 2.4l2.84 2.81c.3.29.44.71.36 1.13l-.72 4.02c-.08.45.02.92.28 1.28.25.36.63.59 1.04.65l3.88.53c.41.05.78.33.96.72l1.67 3.7c.18.4.52.71.93.85.34.12.84.09 1.2-.12l3.43-1.96a1.2 1.2 0 0 1 1.2 0l3.44 1.96c.37.21.8.25 1.2.12.41-.14.73-.44.92-.85l.58-1.27c-6.38-1.71-17.86-8.54-21.78-17.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.62 13.7c.19 0 .38-.19.38-.38a3 3 0 0 1 2.98-2.98c.29-.1.48-.29.48-.48s-.19-.38-.38-.38A3 3 0 0 1 10.1 6.5c-.1-.29-.29-.48-.48-.48s-.48.19-.48.38a3 3 0 0 1-2.98 2.98c-.19.1-.38.29-.38.48s.19.38.38.38c.77 0 1.54.29 2.12.87.58.58.87 1.35.87 2.12 0 .1 0 .19.1.29.1.19.19.19.38.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.93 45.53c-1.15 0-1.99-.94-1.99-1.99 0-.21-.11-.31-.32-.31s-.31.11-.31.31c0 1.15-.94 1.99-1.99 1.99-.21 0-.31.1-.31.31s.1.31.31.31c.52 0 1.05.21 1.46.63.42.42.63.94.63 1.46 0 .21.1.31.31.31s.31-.1.31-.31c0-1.15.94-1.99 1.99-1.99.21 0 .31-.1.31-.31s-.21-.42-.42-.42"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.66 29.57c.41-.41.64-.98.64-1.57s-.24-1.16-.64-1.57l-2.81-2.78a.719.719 0 0 1-.2-.64l.71-3.97c.1-.59-.03-1.19-.36-1.67-.33-.48-.85-.8-1.4-.87l-3.84-.52a.698.698 0 0 1-.53-.4l-1.65-3.65c-.24-.53-.69-.95-1.23-1.13-.54-.18-1.13-.12-1.63.16l-3.4 1.94c-.2.12-.44.12-.65 0l-3.39-1.94c-.5-.28-1.09-.34-1.63-.16-.54.18-.99.59-1.23 1.13l-1.65 3.65c-.1.22-.3.37-.53.4l-3.84.52c-.56.07-1.07.39-1.41.87-.33.48-.46 1.08-.36 1.66l.71 3.98a.69.69 0 0 1-.21.64l-2.81 2.78c-.41.41-.64.98-.64 1.57s.24 1.16.64 1.57l2.81 2.78c.17.17.25.41.21.64l-.71 3.97c-.1.59.03 1.19.36 1.67.33.48.85.8 1.41.87l3.84.52c.23.03.43.18.53.4l1.65 3.65c.24.54.69.94 1.22 1.13a2.071 2.071 0 0 0 1.64-.16l3.39-1.94c.21-.12.45-.12.65 0l3.4 1.94c.49.28 1.09.34 1.63.16.54-.19.98-.59 1.23-1.13l1.65-3.65c.1-.22.3-.37.53-.4l3.84-.52c.56-.07 1.07-.39 1.4-.87.33-.48.46-1.09.36-1.66L41.65 33a.71.71 0 0 1 .2-.64l2.81-2.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.38 31.76v-3.24l-.47-.1c-1.71-.39-2.55-1.29-2.55-2.67 0-1.77 1.3-2.91 3.04-3.08v-1.25h1.14v1.26c1.51.21 2.79 1.18 2.94 2.94h-1.65c-.08-.75-.48-1.35-1.29-1.54v3.08l.67.15c1.53.36 2.46 1.28 2.46 2.78 0 1.84-1.25 2.94-3.17 3.1v1.49h-1.14v-1.5c-1.92-.21-3.19-1.4-3.24-3.29h1.71c.04.95.54 1.67 1.53 1.88Zm.03-4.86v-2.85c-.93.15-1.44.75-1.44 1.53 0 .63.38 1.05 1.44 1.32Zm1.11 1.86v3.03c.95-.15 1.54-.72 1.54-1.58 0-.71-.4-1.2-1.5-1.44l-.04-.02Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PromoDiscount56 = (PromoDiscount56);
;// ./src/Picto/GeneratedPictoComponents/Receipt104.tsx


var Receipt104_excluded = ["className"];
function Receipt104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Receipt104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Receipt104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Receipt104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Receipt104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Receipt104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Receipt104_objectSpread(Receipt104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.08 16.38v.41c0 2.97 2.41 5.38 5.38 5.38h3.87V10.99h-3.87c-2.97 0-5.38 2.41-5.38 5.38ZM88.54 11h-3.87v11.18h3.87c2.97 0 5.38-2.41 5.38-5.38v-.41c0-2.97-2.41-5.38-5.38-5.38ZM22.72 14.66H81.6a2.77 2.77 0 0 0 2.77-2.77s-64.42 0-64.42 0a2.77 2.77 0 0 0 2.77 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.63 48.38c0-1.54 2.36-1.73 2.48-.2.93 12.49 2.31 37.38 3.28 38.05s7.71-1.25 10.04-1.45c1.08-.09 2.13-.33 3.12.1l13.93 6.07c1.75.76 1.74 3.26-.02 4.01-.07.03-.14.03-.21.01l-18.61-4.99a.407.407 0 0 0-.19 0l-8.24 2.98c-2.72.99-5.6-1.03-5.6-3.93l.02-40.67Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.53 93.07-11.28-3.2a7.415 7.415 0 0 0-4.15.02l-12.21 3.58c-1.29.38-2.66.4-3.96.07l-14.5-3.71a7.363 7.363 0 0 0-4.21.15l-8.81 2.92c-1.51.5-3.06-.62-3.06-2.19V11h65.16v79.85c0 1.54-1.48 2.65-2.97 2.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.46 11h3.87v11.18h-3.87c-2.97 0-5.38-2.41-5.38-5.38v-.41c0-2.97 2.41-5.38 5.38-5.38ZM84.67 11h3.87c2.97 0 5.38 2.41 5.38 5.38v.41c0 2.97-2.41 5.38-5.38 5.38h-3.87V10.99Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.48 71.89h42.17M30.48 60.06h42.17M51.56 43.35h21.09M51.56 30.87h21.09"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.64 44.04v-6.05l-.87-.2c-3.19-.73-4.76-2.41-4.76-4.98 0-3.3 2.44-5.43 5.69-5.74v-2.32h2.13v2.35c2.83.39 5.21 2.21 5.49 5.49h-3.08c-.14-1.4-.9-2.52-2.41-2.88v5.74l1.26.28c2.86.67 4.59 2.38 4.59 5.18 0 3.44-2.33 5.49-5.91 5.8v2.77h-2.13v-2.8c-3.59-.39-5.97-2.6-6.05-6.13h3.19c.08 1.76 1.01 3.11 2.86 3.5Zm.06-9.07v-5.32c-1.74.28-2.69 1.4-2.69 2.86 0 1.18.7 1.96 2.69 2.46Zm2.07 3.47v5.66c1.76-.28 2.89-1.34 2.89-2.94 0-1.32-.76-2.24-2.8-2.69l-.08-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Receipt104 = (Receipt104);
;// ./src/Picto/GeneratedPictoComponents/Receipt56.tsx


var Receipt56_excluded = ["className"];
function Receipt56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Receipt56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Receipt56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Receipt56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Receipt56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Receipt56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Receipt56_objectSpread(Receipt56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M11.12 25.75c0-.76 1.15-.85 1.23-.1.61 6.42 1.09 19.78 1.76 20.1.71.33 3.82-.45 5.2-.75.54-.12 1.1-.19 1.61.04l7.31 3.19c.89.39.88 1.65 0 2.03l-.07.03s-.06.01-.09 0l-9.68-2.59h-.08l-4.32 1.57c-1.39.5-2.87-.53-2.87-2.01v-21.5Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m43.44 49.49-6.68-1.92c-.18-.05-.38-.05-.56 0l-7.93 2.36c-.17.05-.36.05-.53 0l-9.15-2.38c-.19-.05-.38-.04-.57.02l-5.4 1.82c-.79.26-1.6-.33-1.6-1.16V6.03h33.96v42.28c0 .81-.77 1.4-1.55 1.18Z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.34 30.16v-4.32l-.62-.14c-2.28-.52-3.4-1.72-3.4-3.56 0-2.36 1.74-3.88 4.06-4.1v-1.66h1.52v1.68c2.02.28 3.72 1.58 3.92 3.92h-2.2c-.1-1-.64-1.8-1.72-2.06v4.1l.9.2c2.04.48 3.28 1.7 3.28 3.7 0 2.46-1.66 3.92-4.22 4.14v1.98h-1.52v-2c-2.56-.28-4.26-1.86-4.32-4.38h2.28c.06 1.26.72 2.22 2.04 2.5Zm.04-6.48v-3.8c-1.24.2-1.92 1-1.92 2.04 0 .84.5 1.4 1.92 1.76Zm1.48 2.48v4.04c1.26-.2 2.06-.96 2.06-2.1 0-.94-.54-1.6-2-1.92l-.06-.02Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Receipt56 = (Receipt56);
;// ./src/Picto/GeneratedPictoComponents/RecurringPayment104.tsx


var RecurringPayment104_excluded = ["className"];
function RecurringPayment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RecurringPayment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RecurringPayment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RecurringPayment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RecurringPayment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RecurringPayment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RecurringPayment104_objectSpread(RecurringPayment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.98 73.13c4.48 0 5.11-3.23 5.11-7.21v-5.04c0-3.98-.62-7.21-5.1-7.21H43.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.77 46.45-5.4 7.21 5.4 7.21M39.05 53.66c-4.48 0-5.11 3.23-5.11 7.21v5.04c0 3.98.62 7.21 5.1 7.21h21.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m55.25 80.34 5.41-7.21-5.41-7.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M17.47 41.75c5.99-11.21 11.78-16.96 16.07-19.91 1.56-1.07.9-3.49-.99-3.61l-11.18-.72-6.1 6.98-.4 16.59c-.04 1.46 1.92 1.96 2.6.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.58 53.02v30c0 4.47-3.62 8.1-8.1 8.1H23.79c-4.47 0-8.1-3.62-8.1-8.1v-56.7c0-4.47 3.62-8.1 8.1-8.1h56.69c4.47 0 8.1 3.63 8.1 8.1v27.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.21 10.89v16.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.81 10.89v16.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.69 35.26h72.89"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RecurringPayment104 = (RecurringPayment104);
;// ./src/Picto/GeneratedPictoComponents/RecurringPayment56.tsx


var RecurringPayment56_excluded = ["className"];
function RecurringPayment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RecurringPayment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RecurringPayment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RecurringPayment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RecurringPayment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RecurringPayment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RecurringPayment56_objectSpread(RecurringPayment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.38 38.92c2.54 0 2.9-1.84 2.9-4.1v-2.87c0-2.26-.35-4.1-2.9-4.1H23.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.17 23.76-3.07 4.1 3.07 4.1M20.65 27.86c-2.54 0-2.9 1.84-2.9 4.1v2.87c0 2.26.35 4.1 2.9 4.1h12.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.86 43.01 3.07-4.09-3.07-4.1"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.21 22.73c3.24-6.07 6.37-9.18 8.7-10.78.84-.58.49-1.89-.53-1.96l-7.05.45-2.31 2.93-.22 8.98c-.02.79 1.04 1.06 1.41.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.99 29.12v16.45c0 2.45-1.99 4.44-4.44 4.44H12.46c-2.45 0-4.44-1.99-4.44-4.44V14.48c0-2.45 1.99-4.44 4.44-4.44h31.09c2.45 0 4.44 1.99 4.44 4.44v14.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.82 6.01v8.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M19.06 6.01v8.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.02 19.38h39.97"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RecurringPayment56 = (RecurringPayment56);
;// ./src/Picto/GeneratedPictoComponents/Shop104.tsx


var Shop104_excluded = ["className"];
function Shop104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Shop104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Shop104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Shop104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Shop104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Shop104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Shop104_objectSpread(Shop104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.42 32.97a.875.875 0 0 0-.51-1.11c-2.85-1.08-4.29-.56-7.19-4.34-.32-.42-1.02.01-.92.54l.88 5.14c.13.36.47.6.86.58l6.1-.24c.35-.01.67-.24.79-.58ZM32.56 51.58c-.14.99 3.56 1.09 3.36 1.08l1.48-5.03-.02 3.35c0 2.17-1.61 3.94-3.61 3.94s-3.6-1.78-3.6-3.99l.02-3.44.07-10.25c0-.97.05-2.56.16-3.49l2.15.19-.34 2.05.34 15.6ZM66.1 51.58c-.14.99 3.56 1.09 3.36 1.08l1.48-5.03-.02 3.35c0 2.17-1.61 3.94-3.61 3.94s-3.6-1.78-3.6-3.99l.02-3.44.07-10.25c0-.97.05-2.56.16-3.49l2.15.19-.34 2.05.34 15.6ZM48.5 91.86c-4.4 0-10.97.02-15.99.02-5.75 0-10.41-4.66-10.41-10.41V60.31c0-2.59 3.3-3.7 4.85-1.63 6.83 9.2 3.34 24.14 21.85 30.16 1.54.5 1.32 3.02-.31 3.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.89 33.98c.33-.52.51-1.6-.03-1.73-4.79-1.18-7.4-3.65-8.56-10.1-.13-.72-.94-.47-1.06.28L47.79 33.1c-.03.54.2 1.02.56 1.19l10.59.09c.33.15.71 0 .95-.39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.62 32.83 1.43-9.97M49.94 17.13l.44-2.82a2.596 2.596 0 0 1 2.96-2.16l27.22 4.25c1.41.22 2.38 1.55 2.16 2.96l-2.27 14.52M61.69 17.54l9.11 1.43"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.3 24.69 2.49 8.4M23.87 33.81l-2.42-8.45c-.39-1.37.4-2.8 1.77-3.19l17.24-4.94c1.03-.29 2.09.08 2.72.86.07.09.13.18.19.27M29.93 24.19l5.98-1.71M70.71 33.88h9.74c.99 0 1.8.76 1.8 1.71v44.35c0 6.59-5.63 11.94-12.57 11.94H33.79c-6.94 0-12.57-5.35-12.57-11.94V35.59c0-.94.81-1.71 1.8-1.71h9.9M37.92 33.88h27.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.42 50.82.04-3 .07-9.71c.07-11.72 8.77-20.88 19.4-20.81 10.62.07 19.22 9.34 19.14 21.07L71 47.82l-.02 3a2.38 2.38 0 1 1-4.76 0v-3.04l.08-9.1c.05-9.41-6.41-16.8-14.41-16.86-8-.07-14.55 7.24-14.6 16.65l-.07 9.31-.02 3.03c0 1.33-1.07 2.39-2.38 2.39s-2.38-1.07-2.38-2.38"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Shop104 = (Shop104);
;// ./src/Picto/GeneratedPictoComponents/Shop56.tsx


var Shop56_excluded = ["className"];
function Shop56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Shop56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Shop56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Shop56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Shop56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Shop56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Shop56_objectSpread(Shop56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.75 18a.471.471 0 0 0-.28-.6c-1.54-.59-2.32-.3-3.89-2.35-.18-.23-.55 0-.5.29l.48 2.78c.07.19.26.32.46.31l3.3-.13c.19 0 .36-.13.43-.31ZM18.23 28.21c-.07.54 1.95.59 1.84.58l.81-2.72v1.81c-.01 1.17-.89 2.13-1.99 2.13s-1.97-.96-1.97-2.16v-1.86l.05-5.54c0-.52.03-1.38.09-1.89l1.17.1-.19 1.11.19 8.43ZM36.46 28.21c-.08.54 2.09.59 1.97.58l.87-2.72v1.81c-.01 1.17-.96 2.13-2.13 2.13s-2.11-.96-2.11-2.16v-1.86l.06-5.54c0-.52.03-1.38.09-1.89l1.26.1-.2 1.11.2 8.43ZM26.84 50.17c-2.38 0-5.93.01-8.65.01a5.63 5.63 0 0 1-5.63-5.63V33.1c0-1.4 1.79-2 2.62-.88 3.7 4.98 1.81 13.06 11.82 16.31.84.27.71 1.63-.17 1.63Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.61 17.77c.15-.26.22-.78-.05-.83-2.32-.47-3.63-1.61-4.31-4.68-.08-.34-.46-.21-.5.15l-.97 5.17c0 .26.12.49.29.56l5.09-.17c.16.07.34-.02.45-.21Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.55 17.8.81-5.68M27.87 8.87l.25-1.6c.13-.8.86-1.36 1.64-1.24l14.98 2.34c.78.12 1.31.87 1.18 1.67l-1.29 8.25M34.55 9.1l5.18.81"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.19 13.22 1.36 4.6M13.46 18.22l-1.33-4.63c-.22-.75.22-1.53.97-1.75l9.44-2.71c.56-.16 1.14.04 1.49.47.04.05.07.1.11.15M16.77 12.95l3.28-.94M39.1 18.25h5.33c.54 0 .98.42.98.93v24.29c0 3.61-3.08 6.54-6.89 6.54H18.87c-3.8 0-6.89-2.93-6.89-6.54V19.18c0-.51.44-.93.98-.93h5.42M21.15 18.25h15.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.13 27.53.02-1.64.04-5.32c.04-6.42 4.8-11.44 10.62-11.4 5.82.04 10.52 5.12 10.48 11.54l-.04 5.18v1.64h-.01c0 .72-.58 1.31-1.31 1.31s-1.31-.58-1.31-1.31v-1.66l.04-4.98c.03-5.15-3.51-9.2-7.89-9.23-4.38-.04-7.97 3.96-8 9.12l-.04 5.1v1.66c0 .72-.58 1.31-1.31 1.31s-1.31-.58-1.31-1.31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Shop56 = (Shop56);
;// ./src/Picto/GeneratedPictoComponents/TrackOrder104.tsx


var TrackOrder104_excluded = ["className"];
function TrackOrder104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TrackOrder104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TrackOrder104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TrackOrder104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TrackOrder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TrackOrder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TrackOrder104_objectSpread(TrackOrder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.98 48.23c.49-.62.47-1.49-.03-2.09-3.32-3.97-8.22-8.3-10.55-13.38-2.17-4.74-2.52-9.96-.99-14.66.56-1.71-1.72-2.91-2.86-1.52-2.21 2.71-3.85 6.72-2.79 12.1 1.62 8.24 9.84 18.05 13.08 21.67.68.76 1.88.73 2.52-.07l1.62-2.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.66 75.89c-.16 0-.32-.02-.48-.06l-4.32-1.1-4.32 1.1c-.58.15-1.19.02-1.66-.35-.46-.36-.72-.89-.72-1.47v-5.57c0-.55.45-1 1-1s1 .45 1 1v5.45l4.45-1.16c.16-.04.33-.04.49 0l4.46 1.13a1.002 1.002 0 0 1 1.99.15c0 .55-.26 1.11-.72 1.47-.34.27-.75.41-1.18.41Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.51 50.43c.3.61.92 1.03 1.63 1.03.71 0 1.33-.42 1.63-1.03l10.55-16.46c1.59-2.35 2.52-5.18 2.52-8.23 0-8.11-6.58-14.68-14.69-14.68s-14.69 6.57-14.69 14.68c0 3.05.93 5.88 2.52 8.23L76.5 50.43Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.47 25.76c0 3.48-2.82 6.3-6.3 6.3s-6.3-2.82-6.3-6.3 2.82-6.3 6.3-6.3 6.3 2.82 6.3 6.3Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.04 67.44v5.57c0 .57-.54.99-1.1.85l-4.41-1.16-4.41 1.16a.876.876 0 0 1-1.1-.85v-5.57"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m10.76 79.13-.02 13.01c0 1.03.83 1.86 1.86 1.86h11.2c1.38 0 2.09-2.38.72-2.53-7.75-.82-8.36-9.59-10.68-13.26-.89-1.41-3.08-.75-3.08.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.32 42.44H18.86c-5.11 0-9.25 4.61-9.25 10.29 0 5.68 4.14 10.29 9.25 10.29h63.96c5.54 0 10.02 4.55 10.02 10.16s-4.49 10.16-10.02 10.16h-34.8",
      className: "shadeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.49 41.03H19.85c-5.13 0-9.29 4.6-9.29 10.28s4.16 10.28 9.29 10.28h64.24c5.56 0 10.07 4.54 10.07 10.14 0 5.6-4.51 10.14-10.07 10.14H49.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "13.36",
        y: "65.1",
        width: "26.34",
        height: "31.02",
        rx: "1",
        ry: "1",
        transform: "rotate(90 26.535 80.615)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TrackOrder104 = (TrackOrder104);
;// ./src/Picto/GeneratedPictoComponents/TrackOrder56.tsx


var TrackOrder56_excluded = ["className"];
function TrackOrder56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TrackOrder56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TrackOrder56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TrackOrder56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TrackOrder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TrackOrder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TrackOrder56_objectSpread(TrackOrder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.82 28.28c.24-.3.23-.73-.02-1.03-1.63-1.95-4.04-4.08-5.18-6.58-1.06-2.33-1.24-4.9-.49-7.21.27-.84-.85-1.43-1.4-.75-1.09 1.33-1.89 3.31-1.37 5.95.8 4.05 4.84 8.87 6.43 10.65.34.37.92.36 1.24-.04l.8-1Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.35 28.93c.15.3.45.5.8.5.35 0 .65-.21.8-.5l5.15-8.04a7.125 7.125 0 0 0 1.23-4.02c0-3.96-3.21-7.17-7.18-7.17a7.172 7.172 0 0 0-5.95 11.19l5.14 8.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.24 16.88c0 1.7-1.38 3.08-3.08 3.08s-3.08-1.38-3.08-3.08 1.38-3.08 3.08-3.08 3.08 1.38 3.08 3.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.63 37.35v2.85c0 .29-.28.51-.56.43l-2.25-.59-2.25.59a.45.45 0 0 1-.56-.43v-2.85"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.69 24.89H9.95c-2.5 0-4.52 2.25-4.52 5.03 0 2.78 2.02 5.03 4.52 5.03h31.24c2.7 0 4.9 2.22 4.9 4.96 0 2.74-2.19 4.96-4.9 4.96h-17"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M6.15 41.98v6.6c0 .52.41.94.93.94h5.68c.7 0 1.06-1.21.36-1.28-3.93-.41-4.24-4.86-5.42-6.72-.45-.72-1.56-.38-1.56.46Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.87 24.32h-20.5c-2.47 0-4.47 2.21-4.47 4.94 0 2.73 2 4.94 4.47 4.94h30.88c2.67 0 4.84 2.18 4.84 4.88 0 2.69-2.17 4.88-4.84 4.88h-16.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "7.25",
        y: "35.89",
        width: "12.67",
        height: "14.92",
        rx: "1",
        ry: "1",
        transform: "rotate(90 13.58 43.35)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TrackOrder56 = (TrackOrder56);
;// ./src/Picto/GeneratedPictoComponents/Chat104.tsx


var Chat104_excluded = ["className"];
function Chat104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Chat104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Chat104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Chat104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Chat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Chat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Chat104_objectSpread(Chat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M11 32.38v24.75c0 6.34 4.77 11.57 10.92 12.29.82.1 1.45.77 1.45 1.6v11.97c0 1.29 1.44 2.06 2.51 1.34l18.51-12.34c1.22-.82.82-2.71-.64-2.94-9.81-1.52-32.76-8.13-32.76-36.67",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.12 20H23.38C16.55 20 11 25.54 11 32.38v24.75c0 6.83 5.54 12.38 12.38 12.38v16.5l24.75-16.5h33c6.83 0 12.38-5.54 12.38-12.38V32.38c0-6.83-5.54-12.38-12.38-12.38Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.66 44.5a5.16 5.16 0 1 1-10.32 0 5.16 5.16 0 0 1 10.32 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.16 44.5a5.16 5.16 0 1 1-10.32 0 5.16 5.16 0 0 1 10.32 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.66 44.5a5.16 5.16 0 1 1-10.32 0 5.16 5.16 0 0 1 10.32 0Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Chat104 = (Chat104);
;// ./src/Picto/GeneratedPictoComponents/Chat56.tsx


var Chat56_excluded = ["className"];
function Chat56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Chat56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Chat56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Chat56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Chat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Chat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Chat56_objectSpread(Chat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M6 18.6v13.2c0 3.37 2.52 6.15 5.78 6.55.47.06.82.46.82.93v6.16c0 .75.84 1.2 1.46.78l9.58-6.38c.71-.48.47-1.58-.38-1.71C17.92 37.26 6 33.62 6 18.6",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.4 12H12.6C8.96 12 6 14.96 6 18.6v13.2c0 3.64 2.96 6.6 6.6 6.6v8.8l13.2-8.8h17.6c3.64 0 6.6-2.96 6.6-6.6V18.6c0-3.64-2.96-6.6-6.6-6.6Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.95 25.3c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.75 25.3c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.55 25.3c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Chat56 = (Chat56);
;// ./src/Picto/GeneratedPictoComponents/Disruptions104.tsx


var Disruptions104_excluded = ["className"];
function Disruptions104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Disruptions104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Disruptions104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Disruptions104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Disruptions104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Disruptions104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Disruptions104_objectSpread(Disruptions104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.81 60.96c.55-.92 1.95-.57 2 .5.35 7.04 2.9 21.57 17.69 25.39.91.23.73 1.58-.21 1.58-12.82 0-35.3-1.03-35.3-1.03L24.8 60.96Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m8 88.32 44.45-73.7L96 88.32H8z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m50.71 42.52-4.85 15.57c-.21.76.36 1.51 1.14 1.51l5.79-.03c.79 0 1.36.74 1.15 1.5L50.2 75.53c-.08.31-.53.24-.52-.08l.7-13.4-8.56.19 5.94-19.56 2.94-.15Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m59.76 43.57-4.37 11.67h5.86c.83 0 1.3 1.09.82 1.87L50.5 78.19c-.62 1-1.98.35-1.81-.88l1.72-15.27h-7.55c-.71 0-1.2-.83-.94-1.6l5.87-17.77c.15-.45.52-.75.94-.75h10.12c.73 0 1.22.87.92 1.65Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Disruptions104 = (Disruptions104);
;// ./src/Picto/GeneratedPictoComponents/Disruptions56.tsx


var Disruptions56_excluded = ["className"];
function Disruptions56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Disruptions56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Disruptions56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Disruptions56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Disruptions56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Disruptions56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Disruptions56_objectSpread(Disruptions56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.68 32.98a.561.561 0 0 1 1.05.24c.26 3.68 1.74 11.25 9.52 13.09.48.11.4.82-.09.83-6.7.14-18.47-.16-18.47-.16l7.99-14Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.08 46.98 28.14 8.76l22.59 38.22H5.08z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.32 24.28-2.3 7.37c-.1.36.17.71.54.71h2.74c.37-.02.64.34.55.69l-1.77 6.85c-.04.15-.25.11-.25-.04l.33-6.34-4.06.09 2.81-9.26 1.39-.07Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.64 24.9-2.11 5.65h2.83c.4 0 .63.53.4.91l-5.6 10.2c-.3.48-.96.17-.88-.42l.83-7.39h-3.66c-.34 0-.58-.4-.46-.78l2.84-8.6c.07-.22.25-.37.46-.37h4.9c.35 0 .59.42.45.8Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Disruptions56 = (Disruptions56);
;// ./src/Picto/GeneratedPictoComponents/GetInTouch104.tsx


var GetInTouch104_excluded = ["className"];
function GetInTouch104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GetInTouch104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GetInTouch104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GetInTouch104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GetInTouch104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GetInTouch104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GetInTouch104_objectSpread(GetInTouch104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.54 87.03h-.02c-2.86-1.84-6.41-1.99-9.38-3.62C46.62 80.52 43 76 40.49 70.76c-2.83 2.2-6.38 3.53-10.25 3.53h-.02v13.02c0 4.01 1.37 5.4 5.39 5.4H64.8c.19-2.28-1.34-4.44-3.27-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.6 19.11v-2.4c0-3.08-2.49-5.57-5.57-5.57H35.6c-3.08 0-5.57 2.49-5.57 5.57v24.14M74.6 47.89v39.4c0 3.08-2.49 5.57-5.57 5.57H35.6c-3.08 0-5.57-2.49-5.57-5.57v-13M50.46 14.86h3.71M46.74 89.14h11.14"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.97 33.53a2.01 2.01 0 1 1-4.02 0 2.01 2.01 0 0 1 4.02 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.39 33.53a2.01 2.01 0 1 1-4.02 0 2.01 2.01 0 0 1 4.02 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.81 33.53a2.01 2.01 0 1 1-4.02 0 2.01 2.01 0 0 1 4.02 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.34 28.65v9.63c0 2.46 1.84 4.49 4.22 4.78.34.04.6.34.6.68v4.49c0 .55.61.88 1.07.57l6.99-4.65c.52-.35.34-1.15-.28-1.25-3.9-.63-12.59-3.29-12.59-14.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.92 52.45c1.85.64 5.37 9.74 9.53 11.7 3.36 1.58 6.46-.86 7.7 0 1.24.86-3.13 2.88-4.26 2.79s-6.68-.63-11.04-6.83c-4.36-6.19-3.4-8.24-1.93-7.66"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "30.25",
        cy: "57.57",
        r: "16.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.62 23.83H63.15c-2.66 0-4.82 2.16-4.82 4.82v9.63c0 2.66 2.16 4.82 4.82 4.82v6.42l9.63-6.42h12.84c2.66 0 4.82-2.16 4.82-4.82v-9.63c0-2.66-2.16-4.82-4.82-4.82Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.89 66.94c-2.01 0-5.21-.86-9.27-4.92-7.6-7.6-4.21-12.28-4.06-12.47l1.15-1.15c.77-.77 2.15-.77 2.92 0l2.34 2.34c.81.8.81 2.09.02 2.9l-.02.02-1.05 1.1c.67 1.1 1.53 2.15 2.49 3.16l.33.33c.95.95 2.01 1.77 3.16 2.49l1.05-1.05c.77-.77 2.15-.77 2.92 0l2.34 2.34c.38.38.62.91.62 1.48s-.24 1.05-.62 1.48c0 0-2.34 1.96-4.3 1.96Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GetInTouch104 = (GetInTouch104);
;// ./src/Picto/GeneratedPictoComponents/GetInTouch56.tsx


var GetInTouch56_excluded = ["className"];
function GetInTouch56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GetInTouch56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GetInTouch56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GetInTouch56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GetInTouch56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GetInTouch56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GetInTouch56_objectSpread(GetInTouch56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.14 46.86h-.01c-1.54-.99-3.45-1.07-5.05-1.95-2.97-1.55-4.92-3.99-6.27-6.81a8.931 8.931 0 0 1-5.52 1.9v7.01c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.17 10.29V9c0-1.66-1.34-3-3-3h-18c-1.66 0-3 1.34-3 3v13M40.17 25.79V47c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3v-7M27.17 8h2M25.17 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.68 18.06c0 .6-.48 1.08-1.08 1.08s-1.08-.48-1.08-1.08.48-1.08 1.08-1.08 1.08.48 1.08 1.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.14 18.06c0 .6-.48 1.08-1.08 1.08s-1.08-.48-1.08-1.08.48-1.08 1.08-1.08 1.08.48 1.08 1.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.59 18.06c0 .6-.48 1.08-1.08 1.08s-1.08-.48-1.08-1.08.48-1.08 1.08-1.08 1.08.48 1.08 1.08Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.41 15.42v5.19c0 1.32.99 2.42 2.27 2.57.18.02.32.18.32.37v2.42c0 .29.33.47.57.31l3.76-2.51c.28-.19.18-.62-.15-.67-2.1-.34-6.78-1.77-6.78-7.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.8 28.24c1 .34 2.89 5.24 5.13 6.3 1.81.85 3.48-.46 4.15 0s-1.69 1.55-2.29 1.5-3.6-.34-5.95-3.68c-2.35-3.34-1.83-4.44-1.04-4.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.29",
        cy: "31",
        r: "9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.1 12.83H34a2.59 2.59 0 0 0-2.59 2.59v5.19A2.59 2.59 0 0 0 34 23.2v3.46l5.19-3.46h6.91a2.59 2.59 0 0 0 2.59-2.59v-5.19a2.59 2.59 0 0 0-2.59-2.59Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.79 36.04c-1.08 0-2.81-.46-4.99-2.65-4.09-4.09-2.26-6.61-2.19-6.72l.62-.62c.41-.41 1.16-.41 1.57 0l1.26 1.26c.43.43.44 1.13 0 1.56s-.57.6-.57.6c.36.59.82 1.16 1.34 1.7l.18.18c.51.51 1.08.95 1.7 1.34l.57-.57c.41-.41 1.16-.41 1.57 0l1.26 1.26c.21.21.33.49.33.8s-.13.57-.33.8c0 0-1.26 1.05-2.32 1.05Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GetInTouch56 = (GetInTouch56);
;// ./src/Picto/GeneratedPictoComponents/Mail104.tsx


var Mail104_excluded = ["className"];
function Mail104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Mail104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Mail104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Mail104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Mail104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mail104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Mail104_objectSpread(Mail104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.41 73.05c-1.86-.75-23.45-12.32-24.54-12.32s-1.46 1.09-.98 1.53c.49.43 9.95 5.71 11.92 6.89 1.97 1.18 1.59 3.91-.82 3.91s-4.61.05-4.61 1.19 14.96.49 16.41.49 4.47-.93 2.61-1.68ZM13.59 73.05c1.86-.75 23.45-12.32 24.54-12.32s1.46 1.09.98 1.53c-.49.43-9.95 5.71-11.92 6.89-1.97 1.18-1.59 3.91.82 3.91s4.61.05 4.61 1.19-14.96.49-16.41.49-4.47-.93-2.61-1.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M89.12 29.09c4.71 0 4.88 4.66 4.88 4.66v36.5c0 2.57-2.19 4.66-4.89 4.66H14.89c-2.7 0-4.89-2.09-4.89-4.66v-36.5s-.06-3.04 2.35-4.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.89 57.73 91.9 73.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.11 57.73 12.1 73.4"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.43 30.3c3.26 2.05 16.05 9.17 38.37 21.37 1.82.11 3.6-.95 2.11-2.55S25.8 36.51 26.46 34c.92-3.52 6.27-1.1 7.43-2.62.9-1.18-.49-2.29-.49-2.29l-19.18.04-1.79 1.17Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m11 30.54 39.66 20.8c1.01.55 2.27.54 3.28-.01l39.1-20.37s-1.16-1.97-3.91-1.88H14.91s-2.33-.09-3.91 1.45Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mail104 = (Mail104);
;// ./src/Picto/GeneratedPictoComponents/Mail56.tsx


var Mail56_excluded = ["className"];
function Mail56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Mail56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Mail56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Mail56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Mail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Mail56_objectSpread(Mail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.08 38.81C47 38.4 34.48 32 33.85 32s-.85.6-.57.84 5.77 3.15 6.91 3.81c1.14.65.92 2.16-.48 2.16s-2.67.03-2.67.66 8.68.27 9.52.27 2.6-.51 1.52-.93ZM7.98 38.78c1.09-.43 13.82-7.04 14.46-7.04s.86.62.58.87c-.29.25-5.86 3.26-7.03 3.93-1.16.67-.94 2.23.48 2.23s2.72.03 2.72.68-8.82.28-9.67.28-2.64-.53-1.54-.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.37 15.89c2.66 0 2.63 2.45 2.63 2.45v19.21C50 38.9 48.85 40 47.44 40H8.6c-1.41 0-2.56-1.1-2.56-2.45V18.34s-.03-1.6 1.23-2.15"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.67 30.96 48.9 39.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.37 30.96 7.14 39.2"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M7.25 16.74c1.56.97 7.7 4.33 18.4 10.1.87.05 1.73-.45 1.01-1.21s-13-5.96-12.69-7.14c.44-1.66 3.01-.52 3.56-1.24.43-.56-.23-1.08-.23-1.08l-9.2.02-.86.55Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m6.54 16.77 20.8 10.77c.53.29 1.19.28 1.71 0l20.46-10.66s-.43-.94-2.05-.98H8.63s-1.46 0-2.09.87Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mail56 = (Mail56);
;// ./src/Picto/GeneratedPictoComponents/NotificationCall104.tsx


var NotificationCall104_excluded = ["className"];
function NotificationCall104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationCall104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationCall104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationCall104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationCall104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCall104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationCall104_objectSpread(NotificationCall104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.35-2.03-22.84 2.05-33.24.96-2.63 1.75-4.22-.89-6.04l-.12.21L12.16 63.2a6.17 6.17 0 0 0 2.26 8.44l20.11 11.61c1.11-1.6.91-3.84.01-5.57Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.7",
        y: "13.91",
        width: "37.58",
        height: "68.62",
        rx: "6",
        ry: "6",
        transform: "rotate(30 42.485 48.236)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.2 32.9c1.89 2.17-.32 16.35 3.54 21.91 3.12 4.49 8.86 3.65 9.8 5.66.94 2.01-6.1 1.37-7.47.42-1.37-.95-8.04-5.72-9.04-16.81-1-11.1 1.73-13 3.17-11.17"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.32 88.36c18.73-4.56 30.22-23.44 25.67-42.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 76.02c11.92-2.9 19.23-14.91 16.33-26.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.32 100.69c25.55-6.21 41.22-31.96 35-57.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.07 60.88c-2.56-1.48-6-4.93-8.19-13.09-4.09-15.26 3.67-18.73 4-18.87.17-.05 2.3-.62 2.3-.62 1.54-.41 3.3.61 3.71 2.14l1.26 4.7c.44 1.6-.5 3.26-2.11 3.7H44l-2.15.64c.04 1.89.37 3.86.85 5.84l.18.67c.51 1.92 1.26 3.73 2.19 5.48l2.11-.57c1.54-.41 3.3.61 3.71 2.14l1.26 4.7c.21.77.12 1.61-.3 2.34s-1.08 1.16-1.88 1.43c0 0-4.42.77-6.92-.67Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCall104 = (NotificationCall104);
;// ./src/Picto/GeneratedPictoComponents/NotificationCall56.tsx


var NotificationCall56_excluded = ["className"];
function NotificationCall56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationCall56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationCall56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationCall56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationCall56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCall56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationCall56_objectSpread(NotificationCall56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.4 18.65c.98 1.13-.17 8.52 1.84 11.41 1.62 2.34 4.61 1.9 5.1 2.95.49 1.05-3.18.71-3.89.22s-4.19-2.98-4.71-8.76c-.52-5.78.9-6.77 1.65-5.82"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.17 47.49c8.26-2.21 13.16-10.7 10.95-18.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.71 42.05c5.25-1.41 8.37-6.81 6.97-12.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.63 52.93c11.26-3.02 17.94-14.59 14.92-25.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.36 33.51c-1.37-.79-3.21-2.64-4.38-7-2.19-8.17 1.97-10.03 2.14-10.1.09-.03 1.23-.33 1.23-.33.82-.22 1.77.33 1.99 1.15l.67 2.52c.24.86-.27 1.75-1.13 1.98h-.02l-1.15.34c.02 1.01.2 2.07.45 3.13l.1.36c.28 1.03.67 2 1.17 2.94l1.13-.3c.82-.22 1.77.33 1.99 1.15l.67 2.52c.11.41.07.86-.16 1.25s-.58.62-1.01.77c0 0-2.37.41-3.7-.36Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.72 44.14c-.69-1.55-2.12-2.47-2.91-3.96-3.49-6.21-1.57-13.15 1.14-19.73.65-1.66 1.67-4.07.19-5.11l-.08.13L6.79 35c-2.48 3-.33 4.96 1.33 5.92l10.97 6.34c.7-1.03 1.09-2.07.62-3.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "12.88",
        y: "6.65",
        width: "22.27",
        height: "40.67",
        rx: "4",
        ry: "4",
        transform: "rotate(30 24.011 26.986)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.42 8.34 5.04 2.9M10.59 41.03l7.97 4.6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCall56 = (NotificationCall56);
;// ./src/Picto/GeneratedPictoComponents/NotificationEmail104.tsx


var NotificationEmail104_excluded = ["className"];
function NotificationEmail104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationEmail104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationEmail104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationEmail104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationEmail104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationEmail104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationEmail104_objectSpread(NotificationEmail104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.35-2.03-22.84 2.05-33.24.96-2.63 1.75-4.22-.89-6.04l-.12.21L12.16 63.2a6.17 6.17 0 0 0 2.26 8.44l20.11 11.61c1.11-1.6.91-3.84.01-5.57Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.7",
        y: "13.91",
        width: "37.58",
        height: "68.62",
        rx: "6",
        ry: "6",
        transform: "rotate(30 42.485 48.236)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m35.75 35.91-1.26 2.18c.51-.88 1.75-1.74 2.65-.43.9 1.31 4.4 7.03 4.64 7.52.24.48 1.3 1.66 2.07 1.33-.54-1.02-2.79-4.78-6.76-11.29-.46-.3-.91-.07-1.35.7ZM49.5 55.88c-.37-.47-4.23-6.68-4.51-6.85s-.54.06-.48.25c.06.18 1.72 2.96 2.06 3.56.33.6-.17 1.25-.8.89s-1.2-.68-1.37-.38 3.8 2.36 4.17 2.58 1.3.43.93-.04Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.32 88.36c18.73-4.56 30.22-23.44 25.67-42.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 76.02c11.92-2.9 19.23-14.91 16.33-26.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.32 100.69c25.55-6.21 41.22-31.96 35-57.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.63 34.3 19.36 11.17c.71.41.96 1.28.57 1.95l-5.5 9.52c-.39.67-1.27.89-1.98.48L30.72 46.25c-.71-.41-.96-1.28-.57-1.95l5.5-9.52c.39-.67 1.27-.89 1.98-.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.92 34.56 6.68 10.93c.18.29.51.48.86.49l12.66.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.31 48.69 5.73 8.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.67 46.02-10.44-.59"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationEmail104 = (NotificationEmail104);
;// ./src/Picto/GeneratedPictoComponents/NotificationEmail56.tsx


var NotificationEmail56_excluded = ["className"];
function NotificationEmail56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationEmail56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationEmail56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationEmail56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationEmail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationEmail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationEmail56_objectSpread(NotificationEmail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.71 44.14c-.69-1.55-2.12-2.47-2.91-3.96-3.49-6.21-1.57-13.15 1.14-19.73.65-1.66 1.67-4.07.19-5.11l-.08.13L6.78 35c-2.78 3-.33 4.96 1.33 5.92l10.97 6.34c.7-1.03 1.09-2.07.62-3.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "12.87",
        y: "6.65",
        width: "22.27",
        height: "40.67",
        rx: "4",
        ry: "4",
        transform: "rotate(30 24.011 26.986)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.42 8.34 5.03 2.9M10.59 41.03l7.96 4.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m21.28 17.87-.78 1.18c.32-.48 1.03-.91 1.48-.16.45.76 2.16 4.05 2.28 4.33.11.28.65.96 1.09.8-.26-.58-1.36-2.75-3.3-6.49-.24-.18-.5-.07-.77.35ZM28.59 30c-.19-.27-2.17-3.81-2.32-3.91s-.3 0-.27.1c.03.1.88 1.68 1.05 2.02.17.34-.12.65-.46.42s-.64-.43-.74-.29 2.03 1.49 2.23 1.63.7.31.51.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.16 47.49c8.26-2.21 13.16-10.7 10.95-18.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.7 42.05c5.25-1.41 8.37-6.81 6.97-12.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.62 52.93c11.26-3.02 17.94-14.59 14.92-25.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.64 17.26 10.5 7c.38.26.5.76.25 1.12l-3.44 5.16c-.24.36-.75.45-1.13.2l-10.5-7c-.38-.26-.5-.76-.25-1.12l3.44-5.16c.24-.36.75-.45 1.13-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.24 17.38 3.36 6.4c.09.17.27.29.46.31l7.12.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.45 25.65 2.9 5.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.93 23.97-5.86-.71"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationEmail56 = (NotificationEmail56);
;// ./src/Picto/GeneratedPictoComponents/NotificationMessage104.tsx


var NotificationMessage104_excluded = ["className"];
function NotificationMessage104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationMessage104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationMessage104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationMessage104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationMessage104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationMessage104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationMessage104_objectSpread(NotificationMessage104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.35-2.03-22.84 2.05-33.24.96-2.63 1.75-4.22-.89-6.04l-.12.21L12.16 63.2a6.17 6.17 0 0 0 2.26 8.44l20.11 11.61c1.11-1.6.91-3.84.01-5.57Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.7",
        y: "13.91",
        width: "37.58",
        height: "68.62",
        rx: "6",
        ry: "6",
        transform: "rotate(30 42.485 48.236)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.38 34.78-3.95 6.84c-.96 1.66-.57 3.73.82 4.95.34.3.44.78.21 1.17l-1.35 2.34c-.37.64.12 1.44.86 1.39l5.31-.34c.82-.05 1.17-1.06.56-1.62-2.62-2.38-6.59-7.57-2.46-14.73"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.32 88.36c18.73-4.56 30.22-23.44 25.67-42.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 76.02c11.92-2.9 19.23-14.91 16.33-26.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.32 100.69c25.55-6.21 41.22-31.96 35-57.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.15 42.78-15.96-9.22a3.956 3.956 0 0 0-5.4 1.45l-3.95 6.84a3.956 3.956 0 0 0 1.45 5.4l-2.63 4.56 9.47-.61 9.12 5.27c1.89 1.09 4.31.44 5.4-1.45l3.95-6.84c1.09-1.89.44-4.31-1.45-5.4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.14 43.1c-.45.79-1.46 1.06-2.25.6s-1.06-1.46-.6-2.25 1.46-1.06 2.25-.6 1.06 1.46.6 2.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.7 45.73c-.45.79-1.46 1.06-2.25.6s-1.06-1.46-.6-2.25 1.46-1.06 2.25-.6 1.06 1.46.6 2.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.26 48.37c-.45.79-1.46 1.06-2.25.6s-1.06-1.46-.6-2.25 1.46-1.06 2.25-.6 1.06 1.46.6 2.25Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationMessage104 = (NotificationMessage104);
;// ./src/Picto/GeneratedPictoComponents/NotificationMessage56.tsx


var NotificationMessage56_excluded = ["className"];
function NotificationMessage56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationMessage56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationMessage56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationMessage56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationMessage56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationMessage56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationMessage56_objectSpread(NotificationMessage56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.72 44.14c-.69-1.55-2.12-2.47-2.91-3.96-3.49-6.21-1.57-13.15 1.14-19.73.65-1.66 1.67-4.07.19-5.11l-.08.13L6.79 35c-2.48 3-.33 4.96 1.33 5.92l10.97 6.34c.7-1.03 1.09-2.07.62-3.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "12.88",
        y: "6.65",
        width: "22.27",
        height: "40.67",
        rx: "4",
        ry: "4",
        transform: "rotate(30 24.011 26.986)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.42 8.34 5.04 2.9M10.59 41.03l7.97 4.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m21.14 17.86-2.28 3.95c-.55.96-.33 2.15.47 2.85.2.17.25.45.12.68l-.78 1.35c-.21.37.07.83.5.8l3.06-.2c.48-.03.67-.61.32-.93-1.51-1.37-3.8-4.37-1.42-8.5",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.17 47.49c8.26-2.21 13.16-10.7 10.95-18.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.71 42.05c5.25-1.41 8.37-6.81 6.97-12.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.63 52.93c11.26-3.02 17.94-14.59 14.92-25.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.65 22.22-9.44-5.45a2.345 2.345 0 0 0-3.19.85l-2.33 4.04c-.64 1.12-.26 2.54.85 3.19l-1.56 2.7 5.6-.36 5.39 3.11c1.12.64 2.54.26 3.19-.85l2.33-4.04c.64-1.12.26-2.54-.85-3.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.78 22.41c-.27.47-.86.62-1.33.36s-.62-.86-.36-1.33.86-.62 1.33-.36.62.86.36 1.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.47 23.96c-.27.47-.86.62-1.33.36s-.62-.86-.36-1.33.86-.62 1.33-.36.62.86.36 1.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.17 25.52c-.27.47-.86.62-1.33.36s-.62-.86-.36-1.33.86-.62 1.33-.36.62.86.36 1.33Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationMessage56 = (NotificationMessage56);
;// ./src/Picto/GeneratedPictoComponents/NotificationReminder104.tsx


var NotificationReminder104_excluded = ["className"];
function NotificationReminder104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationReminder104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationReminder104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationReminder104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationReminder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationReminder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationReminder104_objectSpread(NotificationReminder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.53 77.68c-1.33-2.57-3.87-4.19-5.37-6.66-6.56-10.35-2.03-22.84 2.05-33.24.96-2.63 1.75-4.22-.89-6.04l-.12.21L12.16 63.2a6.17 6.17 0 0 0 2.26 8.44l20.11 11.61c1.11-1.6.91-3.84.01-5.57Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.7",
        y: "13.91",
        width: "37.58",
        height: "68.62",
        rx: "6",
        ry: "6",
        transform: "rotate(30 42.485 48.236)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.99 16.77 8.49 4.9M19.84 71.94l13.44 7.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.75 52.16c-.26-1.57-1.42-5.93 1.18-10.44 1.26-2.18 2.87-3.87 5.68-5.62 1.24-.77.67-2.69-.71-2.41-1.92.39-3.9 1.27-5.08 3.15-.71 1.13-1.63 2.42-2.6 3.7-.66 1.59-1.59 3.08-2.66 4.43a8.09 8.09 0 0 1-1.87 1.73c-.29.2-.58.38-.88.56-.2.76.05 1.59.74 1.98l2.18 1.26s.07.05.11.07c.48.36 4.16 3.07 3.91 1.6ZM42.04 56.32A3.685 3.685 0 0 1 37 57.67a3.685 3.685 0 0 1-1.35-5.04"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.32 88.36c18.73-4.56 30.22-23.44 25.67-42.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.32 76.02c11.92-2.9 19.23-14.91 16.33-26.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.32 100.69c25.55-6.21 41.22-31.96 35-57.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.04 56.32A3.685 3.685 0 0 1 37 57.67a3.685 3.685 0 0 1-1.35-5.04M48.87 32.99l.8-1.38c.53-.91 1.7-1.23 2.61-.7l.25.15c.91.53 1.23 1.7.7 2.61l-.8 1.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.71 48.53h.01c3.05-5.27 1.67-11.77-3.07-14.51s-11.06-.68-14.11 4.6c-2.52 4.36-4.89 7.56-6.74 8.71-.54.34-.55 1.15-.03 1.45l18.53 10.7c.51.3 1.22-.12 1.24-.75.06-2.18 1.65-5.84 4.17-10.19Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationReminder104 = (NotificationReminder104);
;// ./src/Picto/GeneratedPictoComponents/NotificationReminder56.tsx


var NotificationReminder56_excluded = ["className"];
function NotificationReminder56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationReminder56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationReminder56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationReminder56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationReminder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationReminder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationReminder56_objectSpread(NotificationReminder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.02 44.14c-.69-1.55-2.12-2.47-2.91-3.96-3.49-6.21-1.57-13.15 1.14-19.73.65-1.66 1.67-4.07.19-5.11l-.08.13L7.09 35c-2.48 3-.33 4.96 1.33 5.92l10.97 6.34c.7-1.03 1.09-2.07.62-3.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "13.18",
        y: "6.65",
        width: "22.27",
        height: "40.67",
        rx: "4",
        ry: "4",
        transform: "rotate(30 24.31 26.986)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.73 8.34 5.03 2.9M10.9 41.03l7.96 4.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.65 27.83c-.14-.81-.74-3.08.61-5.42.65-1.13 1.49-2.01 2.95-2.92.64-.4.35-1.4-.37-1.25-1 .2-2.02.66-2.64 1.63-.37.59-.84 1.25-1.35 1.92-.34.82-.82 1.6-1.38 2.3-.28.36-.59.64-.97.9-.15.1-.3.19-.46.29-.11.4.03.82.38 1.03l1.13.65s.04.02.06.04c.25.19 2.16 1.59 2.03.83ZM24.39 29.99c-.53.92-1.7 1.23-2.62.7s-1.23-1.7-.7-2.62"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.47 47.49c8.26-2.21 13.16-10.7 10.95-18.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.01 42.05c5.25-1.41 8.37-6.81 6.97-12.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.93 52.93c11.26-3.02 17.94-14.59 14.92-25.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.67 30.13c-.56.97-1.79 1.3-2.76.74s-1.3-1.79-.74-2.76M28.41 17.37l.44-.76c.29-.5.93-.67 1.43-.38l.14.08c.5.29.67.93.38 1.43l-.44.76M31.05 25.87c1.67-2.88.92-6.44-1.68-7.93s-6.05-.37-7.71 2.52c-1.38 2.38-2.67 4.13-3.69 4.76-.3.18-.3.63-.02.79l10.13 5.85c.28.16.67-.06.68-.41.04-1.19.9-3.19 2.28-5.57Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationReminder56 = (NotificationReminder56);
;// ./src/Picto/GeneratedPictoComponents/Notifications104.tsx


var Notifications104_excluded = ["className"];
function Notifications104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Notifications104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Notifications104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Notifications104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Notifications104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Notifications104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Notifications104_objectSpread(Notifications104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75 18v-2c0-3.31-2.69-6-6-6H35c-3.31 0-6 2.69-6 6v72c0 3.31 2.69 6 6 6h34c3.31 0 6-2.69 6-6V66M50 14h4M46 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.71 56.61c0 2.6-2.11 4.71-4.71 4.71s-4.71-2.11-4.71-4.71M71.21 55.39c-1.29-1.57-5.35-5.65-5.35-12.29 0-3.22.7-6.1 2.69-9.84.87-1.64-.98-3.4-2.33-2.21-1.87 1.65-3.5 3.89-3.61 6.72-.07 1.71-.26 3.71-.52 5.74.29 2.18.21 4.42-.11 6.58-.16 1.1-.48 2.1-.96 3.11-.19.4-.4.79-.61 1.18.26.97 1.07 1.72 2.08 1.72h3.39c.76.09 6.55.74 5.34-.73Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.37 26.48v-2.04c0-1.35 1.09-2.44 2.44-2.44h.37c1.35 0 2.44 1.09 2.44 2.44v2.04M79.71 56.61c0 2.6-2.11 4.71-4.71 4.71s-4.71-2.11-4.71-4.71M87.64 40.56h.02c0-7.78-5.66-14.08-12.65-14.08s-12.65 6.3-12.65 14.08c0 6.42-.58 11.47-1.9 13.92-.39.72.13 1.63.89 1.63h27.29c.76 0 1.28-.91.89-1.63-1.32-2.45-1.9-7.5-1.9-13.92Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Notifications104 = (Notifications104);
;// ./src/Picto/GeneratedPictoComponents/Notifications56.tsx


var Notifications56_excluded = ["className"];
function Notifications56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Notifications56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Notifications56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Notifications56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Notifications56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Notifications56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Notifications56_objectSpread(Notifications56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.73 30.47c0 1.31-1.06 2.38-2.38 2.38s-2.38-1.06-2.38-2.38M37.44 29.86c-.65-.79-2.7-2.85-2.7-6.2 0-1.62.35-3.08 1.36-4.96.44-.83-.49-1.72-1.18-1.12-.95.83-1.76 1.96-1.82 3.39-.03.86-.13 1.87-.26 2.9.15 1.1.11 2.23-.06 3.32-.08.56-.24 1.06-.49 1.57-.1.2-.2.4-.31.59.13.49.54.87 1.05.87H34.73c.38.05 3.3.37 2.69-.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.11 14.88v-1.06c0-.7.57-1.27 1.27-1.27h.19c.7 0 1.27.57 1.27 1.27v1.06M41.92 30.55c0 1.35-1.1 2.45-2.45 2.45s-2.45-1.1-2.45-2.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.05 22.2h.01c0-4.05-2.95-7.32-6.58-7.32s-6.58 3.28-6.58 7.32c0 3.34-.3 5.97-.99 7.24-.2.37.07.85.46.85h14.19c.39 0 .66-.47.46-.85-.69-1.28-.99-3.9-.99-7.24Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.15 47c-1.6-1.01-3.59-1.1-5.26-2-7.15-3.68-8.68-12.16-9.78-19.32-.32-1.79-.39-2.94-2.5-3.1v23.54c0 2.21 1.82 4 4.07 4.01h15.3c.11-1.26-.74-2.45-1.83-3.13Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.47 10.19V9.14C39.47 7.4 38.06 6 36.33 6H18.52c-1.74 0-3.14 1.41-3.14 3.14v37.71c0 1.74 1.41 3.14 3.14 3.14h17.81c1.74 0 3.14-1.41 3.14-3.14V35.33M26.38 8.1h2.09M24.28 47.9h6.29"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Notifications56 = (Notifications56);
;// ./src/Picto/GeneratedPictoComponents/PayPhone104.tsx


var PayPhone104_excluded = ["className"];
function PayPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PayPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PayPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PayPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PayPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PayPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PayPhone104_objectSpread(PayPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.64 24h5.81l.64 4.39-2.11.47-3.12-1.69-1.75-2.54.53-.63zM42.62 24h-5.81l-.64 4.39 2.11.47 3.12-1.69 1.75-2.54-.53-.63zM34.6 30.27s.11-.06.3-.14c1.43-.62 3.17-.2 4.1.89.51.59 2.12 1.52 3.6 2.22 2.6 1.23 9.46 1.61 13.18 1.55s4.93-.55 4.88 1.36c-.02.8-27.19.62-27.19.62l1.12-6.5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.19 37.6v2.35s.47 1.93-2.29 1.73c-2.77-.2-16.02-.23-21.68-.01-3.36.13-1.92 2.13-5.87 3.83-6.32 2.72-8.91.49-8.91.49l.21-7.98 38.54-.4ZM48.56 59.26s.16 1.13-.76 1.54-1.48 2.69-1.48 3.99v10.99c0 .73.76 2.56 1.63 2.56s.61 1.2.61 1.2l-5.6-.19.24-5.02 1.83-.74-.53-8.23-1.53-2.14v-3.94h5.6Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.37 94 .3-56.4M71.48 37.6V94M44.35 49.32h15.56c3.67 0 6.65 2.98 6.65 6.65v30.24c0 1.22-.99 2.22-2.22 2.22H39.91c-1.22 0-2.22-.99-2.22-2.22V55.97c0-3.67 2.98-6.65 6.65-6.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.3 65.34v8.02c1.11.01 2.01.76 2.01 1.66v3.58c0 .91-.91 1.65-2.03 1.65h-3.91c-1.11 0-2.03-.74-2.03-1.65v-3.58c0-.91.92-1.66 2.03-1.66h.13v-8.02h-.13c-1.11 0-2.03-.75-2.03-1.66V60.1c0-.91.92-1.65 2.03-1.65h3.91c1.13 0 2.03.74 2.03 1.65v3.58c0 .9-.9 1.65-2.01 1.66Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.04",
        cy: "18.61",
        r: ".48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.35 14.86c.11 0 .23-.04.32-.12.9-.81 2.09-1.25 3.36-1.25s2.47.44 3.36 1.25c.2.18.5.16.67-.04.18-.2.16-.5-.04-.68-1.07-.96-2.49-1.49-4-1.49s-2.93.53-4 1.49c-.2.18-.21.48-.04.68.09.11.23.16.36.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.37 15.39c-.2.17-.23.47-.06.68.17.2.47.23.67.06.55-.46 1.28-.71 2.06-.71s1.51.25 2.06.71c.09.08.2.11.31.11.14 0 .27-.06.37-.17.17-.2.14-.51-.06-.68-.72-.61-1.66-.94-2.67-.94s-1.95.33-2.67.94ZM50.79 16.73c-.22.15-.28.45-.13.67.09.14.24.21.4.21.09 0 .18-.03.27-.08.36-.25 1.07-.25 1.43 0 .22.15.51.09.66-.13.15-.22.09-.52-.13-.67-.68-.46-1.82-.46-2.5 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.45 28.77-.28 1.63c-.06.29-.25.37-.42.37h-1.29l.54-2.99c-.54-.25-1.1-.41-1.54-.41s-.76.11-.99.38c-.16.19-.24.43-.24.71 0 .85.67 2.03 1.81 2.99 1.02.85 2.14 1.33 2.96 1.33.41 0 .74-.12.95-.37.17-.19.24-.44.24-.73 0-.83-.67-1.98-1.76-2.92Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "53.26",
        y: "63.44",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "53.26",
        y: "68.25",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "53.26",
        y: "73.23",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56.61",
        y: "63.44",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56.61",
        y: "68.25",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56.61",
        y: "73.23",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "60.1",
        y: "63.47",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "60.1",
        y: "68.25",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "60.1",
        y: "73.23",
        width: "1.93",
        height: "2.17",
        rx: ".12",
        ry: ".12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.14 25.59a.42.42 0 0 0-.42.35l-.18.99h1.63l-.7 3.85h1.29c.17 0 .37-.08.43-.37l.59-3.47h1.17c.21 0 .38-.14.42-.35l.18-.99h-4.41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.64 36.77 3.81-12.62a.87.87 0 0 1 .84-.62h6.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.72 29.08s3.39.36 5.31-1.54c1.91-1.9 3.21-6.22 10.8-6.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.05 29.08s-3.82.36-5.72-1.54-3.18-6.22-10.69-6.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.43 36.16-3.65-12.01a.867.867 0 0 0-.83-.62h-7.8M44.01 23.1V12.81S43.47 10 51.45 10s8.2 2.21 8.2 2.21v10.88M31.2 37.11h41.86"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PayPhone104 = (PayPhone104);
;// ./src/Picto/GeneratedPictoComponents/PayPhone56.tsx


var PayPhone56_excluded = ["className"];
function PayPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PayPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PayPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PayPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PayPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PayPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PayPhone56_objectSpread(PayPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.8 20.32v1.24s.25 1.02-1.21.91c-1.46-.11-8.42-.12-11.39 0-1.77.07-1.01 1.12-3.08 2.01-3.32 1.43-4.68.26-4.68.26l.11-4.19 20.25-.21ZM25.92 31.7s.08.6-.4.81-.78 1.41-.78 2.09v5.77c0 .38.4 1.34.86 1.34s.32.63.32.63l-2.94-.1.12-2.64.96-.39-.28-4.33-.81-1.12v-2.07h2.94Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.81 13.2h3.3l.37 2.5-1.21.27L33.5 15l-.99-1.44.3-.36zM23.02 13.2h-3.3l-.37 2.5 1.21.27 1.77-.97.99-1.44-.3-.36zM18.38 16.43s.06-.04.17-.08c.81-.35 1.8-.11 2.33.51.29.34 1.2.86 2.05 1.26 1.48.7 5.38.92 7.49.88s2.8-.31 2.78.77c-.01.46-15.46.36-15.46.36l.64-3.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.84",
        cy: "10.35",
        r: ".25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.94 8.42c.06 0 .12-.02.16-.06.46-.41 1.08-.64 1.73-.64s1.27.23 1.73.64c.1.09.26.08.35-.02.09-.1.08-.26-.02-.35-.55-.5-1.28-.77-2.06-.77s-1.51.27-2.06.77c-.1.09-.11.25-.02.35.05.05.12.08.18.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.46 8.69c-.1.09-.12.24-.03.35.09.1.24.12.35.03.28-.24.66-.37 1.06-.37s.78.13 1.06.37a.245.245 0 0 0 .35-.03c.09-.1.07-.26-.03-.35-.37-.31-.86-.48-1.37-.48s-1.01.17-1.37.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.19 9.38c-.11.08-.14.23-.07.34.05.07.13.11.2.11.05 0 .1-.01.14-.04.19-.13.55-.13.74 0 .11.08.27.05.34-.07.08-.11.05-.27-.07-.34-.35-.24-.94-.24-1.29 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.31 15.67-.14.84c-.03.15-.13.19-.22.19h-.66l.28-1.54c-.28-.13-.56-.21-.79-.21s-.39.06-.51.2c-.08.1-.12.22-.12.37 0 .44.34 1.04.93 1.54.53.44 1.1.68 1.53.68.21 0 .38-.06.49-.19.09-.1.12-.23.12-.37 0-.43-.35-1.02-.91-1.51Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.73",
        y: "33.75",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.73",
        y: "36.27",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.73",
        y: "38.87",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "30.47",
        y: "33.75",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "30.47",
        y: "36.27",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "30.47",
        y: "38.87",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "32.3",
        y: "33.78",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "32.3",
        y: "36.27",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "32.3",
        y: "38.87",
        width: "1.01",
        height: "1.13",
        rx: ".12",
        ry: ".12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.1 14c-.11 0-.2.07-.22.18l-.1.52h.85l-.36 2.01h.68c.09 0 .19-.04.22-.2l.31-1.81h.61c.11 0 .2-.07.22-.18l.1-.52h-2.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.58 49.75.16-29.43M37.99 20.32v29.43M25.12 26.43h5.54c2.63 0 4.76 2.13 4.76 4.76v13.43c0 1.22-.99 2.22-2.22 2.22H22.57c-1.22 0-2.22-.99-2.22-2.22V31.19c0-2.63 2.13-4.76 4.76-4.76Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.89 34.79v4.18c.58 0 1.05.4 1.05.87v1.87c0 .48-.47.86-1.06.86h-2.04c-.58 0-1.06-.38-1.06-.86v-1.87c0-.48.48-.87 1.06-.87h.07v-4.18h-.07c-.58 0-1.06-.39-1.06-.87v-1.87c0-.48.48-.86 1.06-.86h2.04c.59 0 1.06.38 1.06.86v1.87c0 .47-.47.86-1.05.87Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.73 19.96 2.01-6.65c.06-.19.24-.33.44-.33h3.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.35 15.91s1.79.19 2.79-.81 1.69-3.28 5.69-3.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.38 15.91s-2.01.19-3.01-.81-1.67-3.28-5.63-3.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.15 19.63-1.92-6.33a.472.472 0 0 0-.44-.33h-4.11M23.72 12.77V7.34s-.28-1.48 3.92-1.48 4.32 1.17 4.32 1.17v5.75M16.97 20.14h22.04"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PayPhone56 = (PayPhone56);
;// ./src/Picto/GeneratedPictoComponents/Phone104.tsx


var Phone104_excluded = ["className"];
function Phone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Phone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Phone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Phone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Phone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Phone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Phone104_objectSpread(Phone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.04 36.43c7.36 2.53 21.34 38.68 37.85 46.46 13.35 6.29 25.65-3.42 30.57 0 4.92 3.42-12.43 11.45-16.91 11.07-4.48-.38-26.52-2.52-43.85-27.12-17.33-24.6-13.51-32.73-7.66-30.41"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.55 93.95c-7.97 0-20.69-3.42-36.82-19.55C-.45 44.22 13.02 25.62 13.59 24.86c.34-.36 4.56-4.55 4.56-4.55 3.04-3.04 8.54-3.04 11.58 0l9.3 9.3c3.2 3.16 3.23 8.31.07 11.51l-.07.07-4.18 4.36c2.66 4.36 6.07 8.54 9.87 12.53l1.33 1.33c3.79 3.79 7.97 7.02 12.53 9.87l4.18-4.18c3.04-3.04 8.54-3.04 11.58 0l9.3 9.3c1.52 1.52 2.47 3.61 2.47 5.89s-.95 4.17-2.47 5.89c0 0-9.3 7.78-17.08 7.78Z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.55 54.41c.62-19.22-14.46-35.29-33.67-35.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.9 54.01c.39-12.23-9.2-22.46-21.43-22.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M98.2 54.82c.84-26.2-19.71-48.13-45.92-48.97"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Phone104 = (Phone104);
;// ./src/Picto/GeneratedPictoComponents/Phone56.tsx


var Phone56_excluded = ["className"];
function Phone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Phone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Phone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Phone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Phone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Phone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Phone56_objectSpread(Phone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.48 21.22c3.67 1.27 10.66 19.33 18.91 23.21 6.67 3.14 12.82-1.71 15.27 0 2.46 1.71-6.21 5.72-8.45 5.53-2.24-.19-13.25-1.26-21.91-13.55-8.66-12.29-6.75-16.35-3.83-15.19"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.21 49.96c-3.98 0-10.34-1.71-18.4-9.77C.74 25.12 7.47 15.82 7.76 15.44c.17-.18 2.28-2.28 2.28-2.28 1.52-1.52 4.27-1.52 5.79 0l4.65 4.65c1.6 1.58 1.61 4.15.04 5.75l-.04.04-2.09 2.18c1.33 2.18 3.03 4.27 4.93 6.26l.66.67c1.9 1.9 3.98 3.51 6.26 4.93l2.09-2.09c1.52-1.52 4.27-1.52 5.79 0l4.65 4.65c.76.76 1.23 1.8 1.23 2.94s-.47 2.09-1.23 2.94c0 0-4.65 3.89-8.53 3.89Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.87 30.24c.34-10.56-7.95-19.4-18.51-19.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.91 30.01c.22-6.72-5.06-12.35-11.78-12.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.83 30.46C52.29 16.05 40.99 4 26.59 3.54"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Phone56 = (Phone56);
;// ./src/Picto/GeneratedPictoComponents/Picto4G104.tsx


var Picto4G104_excluded = ["className"];
function Picto4G104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto4G104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto4G104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto4G104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto4G104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4G104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto4G104_objectSpread(Picto4G104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("text", {
      transform: "translate(15.94 143.91)",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("tspan", {
        x: "0",
        y: "0",
        children: "4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("tspan", {
        x: "28.32",
        y: "0",
        children: "G"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.46 88.82c-11.75-1.77-25.2-4.09-34.23-12.06-7.97-9.03-10.29-22.47-12.06-34.23-.66-3.76-.81-6.19-5.17-6.54V85.56c0 .15.02.29.02.44 0 .14 0 .28.02.42.01.14.04.27.06.4.02.15.04.29.07.44.02.12.06.24.09.36.04.15.07.3.12.45.03.1.08.2.11.31.06.16.11.31.17.47.05.11.1.21.15.32.07.14.13.28.2.42.06.11.13.21.19.32.08.13.15.25.23.37.07.11.16.21.24.32.08.11.16.22.25.33.09.11.19.21.28.31.09.09.17.19.26.28.1.1.21.2.32.29.09.08.18.17.28.25.12.1.25.19.37.28.09.07.18.14.28.21.13.09.28.17.42.25.09.06.18.12.28.17.15.08.3.15.45.22.09.04.19.09.28.14.16.07.34.13.51.19.09.03.18.07.27.1.16.05.33.09.5.13.1.03.21.06.31.08.16.03.32.05.48.07.12.02.23.04.35.05.15.02.31.02.46.02.13 0 .26.02.4.02h49.57c-.35-4.37-2.78-4.52-6.54-5.18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "10",
          width: "84",
          height: "84",
          rx: "8",
          ry: "8",
          className: "stroke"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondaryinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.46 55.52h5.58v4.77h-5.58v7.96h-5.48v-7.96H23.86V54.9l13.35-19.07h7.25v19.69Zm-5.48 0V41.6l-9.73 13.92h9.73ZM82.17 43.88l-5.01 1.96c-1.29-3.43-4.05-5.67-8.44-5.67-6.25 0-10.25 4.72-10.25 11.87s4.1 12.02 10.25 12.02c4.15 0 8.58-2.24 9.11-8.3H70.3v-4.48h12.3v16.98h-4.72v-4.48c-2.05 3.15-5.63 5.05-9.97 5.05-8.54 0-15.26-6.72-15.26-16.78s7.01-16.78 16.12-16.78c6.63 0 11.54 3.62 13.4 8.63Z"
        })
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4G104 = (Picto4G104);
;// ./src/Picto/GeneratedPictoComponents/Picto4G56.tsx


var Picto4G56_excluded = ["className"];
function Picto4G56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto4G56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto4G56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto4G56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto4G56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4G56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto4G56_objectSpread(Picto4G56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.96 47.29c-6.16-.93-13.2-2.14-17.93-6.32-4.17-4.73-5.39-11.77-6.32-17.93-.34-1.97-.43-3.24-2.71-3.42v25.97c0 .08 0 .15.01.23 0 .07 0 .15.01.22 0 .07.02.14.03.21.01.08.02.15.04.23.01.06.03.12.05.19l.06.24c.02.05.04.11.06.16l.09.24c.02.06.05.11.08.17.03.07.07.15.11.22.03.06.07.11.1.17.04.07.08.13.12.2.04.06.08.11.12.17.04.06.08.12.13.17.05.06.1.11.15.16.05.05.09.1.14.15.05.05.11.1.17.15.05.04.09.09.15.13.06.05.13.1.19.15l.14.11c.07.05.14.09.22.13l.15.09.24.12c.05.02.1.05.15.07.09.04.18.07.27.1.05.02.09.04.14.05.08.03.17.05.26.07.05.01.11.03.16.04.08.02.17.03.25.04.06 0 .12.02.18.03.08 0 .16 0 .24.01.07 0 .14.01.21.01h25.97c-.18-2.29-1.45-2.37-3.42-2.71Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "6",
        width: "44",
        height: "44",
        rx: "4",
        ry: "4",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.64 29.69h2.77v2.37h-2.77v3.96h-2.72v-3.96h-7.51v-2.68l6.63-9.47h3.6v9.78Zm-2.72 0v-6.92l-4.83 6.92h4.83ZM42.38 23.91l-2.49.97c-.64-1.71-2.01-2.82-4.19-2.82-3.1 0-5.09 2.34-5.09 5.9s2.04 5.97 5.09 5.97c2.06 0 4.26-1.11 4.52-4.12h-3.74v-2.23h6.11v8.43h-2.34v-2.23c-1.02 1.56-2.79 2.51-4.95 2.51-4.24 0-7.58-3.34-7.58-8.34s3.48-8.34 8-8.34c3.29 0 5.73 1.8 6.65 4.29Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4G56 = (Picto4G56);
;// ./src/Picto/GeneratedPictoComponents/Picto4GX104.tsx


var Picto4GX104_excluded = ["className"];
function Picto4GX104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto4GX104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto4GX104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto4GX104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto4GX104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4GX104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto4GX104_objectSpread(Picto4GX104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.46 88.82c-11.75-1.77-25.2-4.09-34.23-12.06-7.97-9.03-10.29-22.47-12.06-34.23-.66-3.76-.81-6.19-5.17-6.54V85.56c0 .15.02.29.02.44 0 .14 0 .28.02.42.01.14.04.27.06.4.02.15.04.29.07.44.02.12.06.24.09.36.04.15.07.3.12.45.03.1.08.2.11.31.06.16.11.31.17.47.05.11.1.21.15.32.07.14.13.28.2.42.06.11.13.21.19.32.08.13.15.25.23.37.07.11.16.21.24.32.08.11.16.22.25.33.09.11.19.21.28.31.09.09.17.19.26.28.1.1.21.2.32.29.09.08.18.17.28.25.12.1.25.19.37.28.09.07.18.14.28.21.13.09.28.17.42.25.09.06.18.12.28.17.15.08.3.15.45.22.09.04.19.09.28.14.16.07.34.13.51.19.09.03.18.07.27.1.16.05.33.09.5.13.1.03.21.06.31.08.16.03.32.05.48.07.12.02.23.04.35.05.15.02.31.02.46.02.13 0 .26.02.4.02h49.57c-.35-4.37-2.78-4.52-6.54-5.18Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10",
        y: "10",
        width: "84",
        height: "84",
        rx: "8",
        ry: "8",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.36 54.47h4.21v3.6h-4.21v6.01h-4.14v-6.01H19.81V54l10.08-14.4h5.47v14.87Zm-4.14 0V43.96l-7.34 10.51h7.34ZM63.11 45.69l-3.78 1.48c-.97-2.59-3.06-4.28-6.37-4.28-4.72 0-7.74 3.56-7.74 8.96s3.1 9.07 7.74 9.07c3.13 0 6.48-1.69 6.88-6.26h-5.69v-3.38h9.29v12.81h-3.56v-3.38c-1.55 2.38-4.25 3.82-7.52 3.82-6.44 0-11.52-5.08-11.52-12.67s5.29-12.67 12.17-12.67c5 0 8.71 2.74 10.11 6.52ZM71.36 39.6l6.12 8.89 6.16-8.89h4.75l-8.31 11.95 8.96 12.53h-4.82l-6.73-9.54-6.69 9.54h-4.86l8.93-12.6-8.28-11.88h4.79Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4GX104 = (Picto4GX104);
;// ./src/Picto/GeneratedPictoComponents/Picto4GX56.tsx


var Picto4GX56_excluded = ["className"];
function Picto4GX56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto4GX56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto4GX56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto4GX56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto4GX56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto4GX56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto4GX56_objectSpread(Picto4GX56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.96 47.29c-6.16-.93-13.2-2.14-17.93-6.32-4.17-4.73-5.39-11.77-6.32-17.93-.34-1.97-.43-3.24-2.71-3.42v25.97c0 .08 0 .15.01.23 0 .07 0 .15.01.22 0 .07.02.14.03.21.01.08.02.15.04.23.01.06.03.12.05.19l.06.24c.02.05.04.11.06.16l.09.24c.02.06.05.11.08.17.03.07.07.15.11.22.03.06.07.11.1.17.04.07.08.13.12.2.04.06.08.11.12.17.04.06.08.12.13.17.05.06.1.11.15.16.05.05.09.1.14.15.05.05.11.1.17.15.05.04.09.09.15.13.06.05.13.1.19.15l.14.11c.07.05.14.09.22.13l.15.09.24.12c.05.02.1.05.15.07.09.04.18.07.27.1.05.02.09.04.14.05.08.03.17.05.26.07.05.01.11.03.16.04.08.02.17.03.25.04.06 0 .12.02.18.03.08 0 .16 0 .24.01.07 0 .14.01.21.01h25.97c-.18-2.29-1.45-2.37-3.42-2.71Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "6",
        width: "44",
        height: "44",
        rx: "4",
        ry: "4",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.07 29.03h2.09v1.79h-2.09v2.99h-2.06v-2.99h-5.67V28.8l5.01-7.15h2.72v7.39Zm-2.06 0v-5.22l-3.65 5.22h3.65ZM33.86 24.67l-1.88.73c-.48-1.29-1.52-2.13-3.17-2.13-2.34 0-3.84 1.77-3.84 4.45s1.54 4.51 3.84 4.51c1.56 0 3.22-.84 3.42-3.11H29.4v-1.68h4.61v6.37h-1.77v-1.68c-.77 1.18-2.11 1.9-3.74 1.9-3.2 0-5.72-2.52-5.72-6.29s2.63-6.29 6.04-6.29c2.49 0 4.33 1.36 5.02 3.24ZM37.96 21.65 41 26.07l3.06-4.42h2.36l-4.13 5.94 4.45 6.22h-2.4L41 29.07l-3.33 4.74h-2.41l4.43-6.26-4.11-5.9h2.38Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto4GX56 = (Picto4GX56);
;// ./src/Picto/GeneratedPictoComponents/Picto5G104.tsx


var Picto5G104_excluded = ["className"];
function Picto5G104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto5G104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto5G104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto5G104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto5G104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto5G104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto5G104_objectSpread(Picto5G104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("text", {
      transform: "translate(17 143.91)",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("tspan", {
        x: "0",
        y: "0",
        children: "5G"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.46 88.82c-11.75-1.77-25.2-4.09-34.23-12.06-7.97-9.03-10.29-22.47-12.06-34.23-.66-3.76-.81-6.19-5.17-6.54V85.56c0 .15.02.29.02.44 0 .14 0 .28.02.42.01.14.04.27.06.4.02.15.04.29.07.44.02.12.06.24.09.36.04.15.07.3.12.45.03.1.08.2.11.31.06.16.11.31.17.47.05.11.1.21.15.32.07.14.13.28.2.42.06.11.13.21.19.32.08.13.15.25.23.37.07.11.16.21.24.32.08.11.16.22.25.33.09.11.19.21.28.31.09.09.17.19.26.28.1.1.21.2.32.29.09.08.18.17.28.25.12.1.25.19.37.28.09.07.18.14.28.21.13.09.28.17.42.25.09.06.18.12.28.17.15.08.3.15.45.22.09.04.19.09.28.14.16.07.34.13.51.19.09.03.18.07.27.1.16.05.33.09.5.13.1.03.21.06.31.08.16.03.32.05.48.07.12.02.23.04.35.05.15.02.31.02.46.02.13 0 .26.02.4.02h49.57c-.35-4.37-2.78-4.52-6.54-5.18Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "10",
          y: "10",
          width: "84",
          height: "84",
          rx: "8",
          ry: "8",
          className: "stroke"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondaryinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.44 59.08c.29 3 2.34 5.29 5.86 5.29 3.77 0 6.1-2.34 6.1-6.82 0-4.15-2.19-6.58-5.67-6.58-2.57 0-4.58 1.38-5.53 3.43h-5.25l1.91-18.41h18.93v4.86H32.44l-.86 8.25c1.48-1.53 3.67-2.67 6.68-2.67 5.67 0 9.87 4.1 9.87 11.11s-4.82 11.35-11.87 11.35c-6.34 0-11.06-3.43-11.54-9.82h5.72ZM81.26 44.06l-5.01 1.96c-1.29-3.43-4.05-5.67-8.44-5.67-6.25 0-10.25 4.72-10.25 11.87s4.1 12.02 10.25 12.02c4.15 0 8.58-2.24 9.11-8.3h-7.53v-4.48h12.3v16.98h-4.72v-4.48c-2.05 3.15-5.63 5.05-9.97 5.05-8.54 0-15.26-6.72-15.26-16.78s7.01-16.78 16.12-16.78c6.63 0 11.54 3.62 13.4 8.63Z"
        })
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto5G104 = (Picto5G104);
;// ./src/Picto/GeneratedPictoComponents/Picto5G56.tsx


var Picto5G56_excluded = ["className"];
function Picto5G56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Picto5G56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Picto5G56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Picto5G56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Picto5G56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Picto5G56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Picto5G56_objectSpread(Picto5G56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.96 47.29c-6.16-.93-13.2-2.14-17.93-6.32-4.17-4.73-5.39-11.77-6.32-17.93-.34-1.97-.43-3.24-2.71-3.42v25.97c0 .08 0 .15.01.23 0 .07 0 .15.01.22 0 .07.02.14.03.21.01.08.02.15.04.23.01.06.03.12.05.19l.06.24c.02.05.04.11.06.16l.09.24c.02.06.05.11.08.17.03.07.07.15.11.22.03.06.07.11.1.17.04.07.08.13.12.2.04.06.08.11.12.17.04.06.08.12.13.17.05.06.1.11.15.16.05.05.09.1.14.15.05.05.11.1.17.15.05.04.09.09.15.13.06.05.13.1.19.15l.14.11c.07.05.14.09.22.13l.15.09.24.12c.05.02.1.05.15.07.09.04.18.07.27.1.05.02.09.04.14.05.08.03.17.05.26.07.05.01.11.03.16.04.08.02.17.03.25.04.06 0 .12.02.18.03.08 0 .16 0 .24.01.07 0 .14.01.21.01h25.97c-.18-2.29-1.45-2.37-3.42-2.71Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "6",
        width: "44",
        height: "44",
        rx: "4",
        ry: "4",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.2 31.41c.14 1.49 1.16 2.63 2.91 2.63 1.87 0 3.03-1.16 3.03-3.39 0-2.06-1.09-3.27-2.82-3.27-1.28 0-2.27.69-2.75 1.71h-2.6l.95-9.14h9.4v2.42h-7.13l-.43 4.1c.73-.76 1.82-1.33 3.32-1.33 2.82 0 4.9 2.04 4.9 5.52s-2.39 5.64-5.9 5.64c-3.15 0-5.49-1.71-5.73-4.88h2.84ZM42.45 23.95l-2.49.97c-.64-1.71-2.01-2.82-4.19-2.82-3.1 0-5.09 2.34-5.09 5.9s2.04 5.97 5.09 5.97c2.06 0 4.26-1.11 4.52-4.12h-3.74v-2.23h6.11v8.43h-2.34v-2.23c-1.02 1.56-2.79 2.51-4.95 2.51-4.24 0-7.58-3.34-7.58-8.34s3.48-8.34 8-8.34c3.29 0 5.73 1.8 6.66 4.29Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Picto5G56 = (Picto5G56);
;// ./src/Picto/GeneratedPictoComponents/CoverageMobile104.tsx


var CoverageMobile104_excluded = ["className"];
function CoverageMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageMobile104_objectSpread(CoverageMobile104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.4 43.9c-3.5 0-6.3-2.8-6.3-6.3v-.7c.1-.7-.8-1.2-1.3-.7-1.4 1.3-2.1 3.3-1.8 5.4.4 2.7 2.6 5 5.3 5.3 2.2.3 4.3-.5 5.6-2.1.4-.5 0-1.2-.6-1.1-.2.1-.5.2-.9.2",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.2 46.7 68 94M49.8 46.7 36 94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "40",
        r: "7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.8 51 47 57l14 13-24 21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.2 51 7.8 6-14 13 24 21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.6 21.6c-10.1 10.1-10.1 26.6 0 36.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 16c-13.3 13.2-13.3 34.8 0 48M76 64c13.3-13.2 13.3-34.8 0-48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.3 10.3c-16.4 16.4-16.4 43 0 59.4M81.7 69.7c16.4-16.4 16.4-43 0-59.4M70.4 58.4c10.2-10.1 10.2-26.6 0-36.8"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMobile104 = (CoverageMobile104);
;// ./src/Picto/GeneratedPictoComponents/CoverageMobile56.tsx


var CoverageMobile56_excluded = ["className"];
function CoverageMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageMobile56_objectSpread(CoverageMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.12 23.41c-1.77 0-3.21-1.44-3.21-3.21 0-.12 0-.23.02-.34.04-.37-.39-.6-.65-.35-.7.68-1.09 1.67-.94 2.75.19 1.39 1.32 2.52 2.72 2.72 1.14.16 2.17-.28 2.85-1.05.21-.24.01-.61-.3-.56-.16.03-.32.04-.49.04",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.15 24.85 7.23 24.8M26.86 24.85l-7.24 24.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "21.37",
        r: "3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.49 27.13-4.11 3.14 7.33 6.81-12.57 11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.51 27.13 4.11 3.14-7.33 6.81 12.57 11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.37 11.74c-5.32 5.32-5.32 13.94 0 19.26M37.63 31c5.32-5.32 5.32-13.94 0-19.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.41 8.77c-6.96 6.96-6.96 18.23 0 25.19M40.59 33.96c6.96-6.96 6.96-18.23 0-25.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.44 5.81c-8.59 8.59-8.59 22.52 0 31.11M43.56 36.92c8.59-8.59 8.59-22.52 0-31.11"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMobile56 = (CoverageMobile56);
;// ./src/Picto/GeneratedPictoComponents/CoverageNetwork104.tsx


var CoverageNetwork104_excluded = ["className"];
function CoverageNetwork104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageNetwork104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageNetwork104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageNetwork104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageNetwork104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageNetwork104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageNetwork104_objectSpread(CoverageNetwork104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.83 48.28v39.93c0 1.24 1.18 2.13 2.37 1.79l4.83-1.38c1.87-.53 2.51-2.78 1.31-4.31-5.79-7.38-6.34-27.48-6.36-34.13 0-1.15-1.01-2.04-2.15-1.9Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.76 10.55H14.7c-1.1 0-2 .9-2 2v69.62c0 1.1.9 2 2 2H16M64.83 18.57l23.48-7.22a2 2 0 0 1 2.59 1.91v68c0 .88-.57 1.65-1.41 1.91l-24.65 7.59M56 87.72l8.83 3.03V18.57l-26.07-8.02v19.46"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.97 89.67c-2.19-1.4-4.88-1.52-7.16-2.77-9.74-5.1-11.82-16.84-13.32-26.74-.43-2.47-.53-4.07-3.4-4.3V88.45c0 3.06 2.48 5.54 5.54 5.55h20.83c.14-1.74-1.01-3.39-2.49-4.33Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "20",
        y: "34.42",
        width: "32",
        height: "60",
        rx: "4",
        ry: "4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.86 38.79h2M31.86 90.25h8M29.18 63.76v4.76M33.46 62.17v6.35M37.73 60.59v7.93M42.01 59v9.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageNetwork104 = (CoverageNetwork104);
;// ./src/Picto/GeneratedPictoComponents/CoverageNetwork56.tsx


var CoverageNetwork56_excluded = ["className"];
function CoverageNetwork56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageNetwork56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageNetwork56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageNetwork56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageNetwork56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageNetwork56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageNetwork56_objectSpread(CoverageNetwork56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35 25.86v21.45c0 .66.64 1.14 1.27.96l3.31-.95c.71-.2.94-1.09.42-1.62-3.22-3.24-3.25-13.39-3.1-17.71.04-1.11-.8-2.05-1.9-2.13Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21 5.59H8c-.55 0-1 .45-1 1v37.54c0 .55.45 1 1 1h.77M35 9.9l12.71-3.91c.64-.2 1.29.28 1.29.96v36.68c0 .44-.29.83-.71.96L35 48.68M29.36 46.93 35 48.67V9.9L21 5.59v10.54"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.29 48.1c-1.17-.75-2.61-.81-3.82-1.48-5.2-2.72-6.31-8.98-7.11-14.27-.23-1.32-.29-2.17-1.82-2.29v17.38a2.96 2.96 0 0 0 2.96 2.96h11.11c.08-.93-.54-1.81-1.33-2.31Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18 20h2M17 48h4M14.96 33.19v3M17.65 32.19v4M20.35 31.19v5M23.04 30.19v6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.5",
        y: "18",
        width: "17",
        height: "32",
        rx: "2",
        ry: "2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageNetwork56 = (CoverageNetwork56);
;// ./src/Picto/GeneratedPictoComponents/FailedConnection104.tsx


var FailedConnection104_excluded = ["className"];
function FailedConnection104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FailedConnection104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FailedConnection104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FailedConnection104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FailedConnection104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FailedConnection104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FailedConnection104_objectSpread(FailedConnection104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.52 53.74c-1.21-12.33 5.57-21.64 10.71-26.83 1.49-1.5-.49-3.69-2.63-2.86-11.15 4.29-19.2 15.73-17.78 30.16 1.27 13 10.07 22.83 20.04 27.67.35.17.75.25 1.16.25h1.82c1.99 0 3.01-1.98 1.6-3.14-5.94-4.88-13.77-13.55-14.92-25.26Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.03 21.64C78.54 26.98 86.5 38.51 86.5 51.89c0 18.46-15.16 33.41-33.86 33.41S18.78 70.35 18.78 51.89c0-16.45 12.04-30.12 27.92-32.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.68 83.82s16.86 5.65 41.48-1.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.97 85.88s16.08 4.77 40.28-1.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m96.62 81.29-.67-1.94-1-2.92-.67-1.94-7.36 2.52-.95.33-2.89.99 2.33 6.8 2.89-.99 8.31-2.85Zm-1.27-.62-6.41 2.2-.34-1 6.41-2.2.34 1Zm-7.09.23-.33-.97 6.41-2.2.33.97-6.41 2.2Zm5.41-5.14.34 1-6.41 2.2-.34-1 6.41-2.2Zm-7.63 8.1-1.68-4.91 1.95-.67.68 1.97.33.97.68 1.97-1.95.67ZM16.8 81.17l-7.49-2.1-.74 2.64-.65 2.31L7.37 86l8.46 2.38 2.94.83 1.94-6.92-3.92-1.1Zm-.83 2.97-.28.98-6.53-1.83.28-.98 6.53 1.83Zm.56-2-.28 1.01-6.53-1.83.28-1.01 6.53 1.83Zm-7.64 2.15 6.53 1.83-.28 1.01-6.53-1.83.28-1.01Zm9.19 3.67-1.98-.56.28-1.01.83-2.97.28-1.01 1.98.56-1.4 5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.41 40.41 23.18 23.18M63.59 40.41 40.41 63.59"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FailedConnection104 = (FailedConnection104);
;// ./src/Picto/GeneratedPictoComponents/FailedConnection56.tsx


var FailedConnection56_excluded = ["className"];
function FailedConnection56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FailedConnection56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FailedConnection56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FailedConnection56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FailedConnection56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FailedConnection56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FailedConnection56_objectSpread(FailedConnection56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.04 28.39c-.65-6.69 3.02-11.74 5.81-14.55.81-.82-.26-2-1.42-1.55-6.05 2.33-10.41 8.53-9.64 16.36.69 7.05 5.46 12.38 10.87 15 .19.09.41.14.63.14h.99c1.08 0 1.63-1.07.87-1.7-3.22-2.65-7.47-7.35-8.09-13.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.21 10.47c6.3 2.93 10.66 9.24 10.66 16.56 0 10.11-8.3 18.29-18.54 18.29S9.79 37.13 9.79 27.03c0-9.01 6.59-16.49 15.29-18.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.87 44.51s9.23 3.09 22.71-1.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.44 45.64s8.81 2.61 22.05-.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.38 43.12-.36-1.06-.53-1.55-.36-1.06-4.51 1.54-1.58.54 1.26 3.68 1.58-.54 4.51-1.54Zm-.64-.31-3.56 1.22-.2-.59 3.56-1.22.2.59Zm-3.92.14-.2-.58 3.56-1.22.2.58-3.56 1.22Zm3.19-2.29-3.56 1.22-.2-.59 3.56-1.22.2.59Zm-4.41 3.91-.94-2.73 1.11-.38.37 1.08.2.58.37 1.08-1.11.38ZM8.77 43.09l-4.1-1.15-.44 1.58-.3 1.08-.3 1.08 4.59 1.29 1.61.45 1.05-3.75-2.1-.59Zm-.14.49-.17.6-3.62-1.02.17-.6 3.62 1.02Zm-.31 1.09-.16.59-3.62-1.02.16-.58 3.62 1.02Zm-3.92.07 3.62 1.02-.17.6-3.62-1.02.17-.6Zm5.07 2.07-1.13-.32.31-1.1.3-1.08.17-.6 1.13.32-.78 2.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m21.42 21.52 13.11 13.1M34.53 21.52l-13.11 13.1"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FailedConnection56 = (FailedConnection56);
;// ./src/Picto/GeneratedPictoComponents/InternetOptimiser104.tsx


var InternetOptimiser104_excluded = ["className"];
function InternetOptimiser104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetOptimiser104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetOptimiser104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetOptimiser104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetOptimiser104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetOptimiser104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetOptimiser104_objectSpread(InternetOptimiser104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M17.9 94h22.6c4.5 0 3.5-3.8.1-4.4-3.1-.6-8.3 0-11.3-.3-3.4-.4-7-1.6-9.4-4.2-2.7-2.8-4.3-7.8-4.5-11.6-.3-4.1-1.9-29.8-4.9-29.5v40c.1 7.4 5.1 9.8 7.4 10z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.3 19h3.1c1.4 0 2.5 1.1 2.5 2.5v3.1c0 1.4-1.1 2.5-2.5 2.5h-3.1c-1.4 0-2.5-1.1-2.5-2.5v-3.1c0-1.4 1.1-2.5 2.5-2.5z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.7 79.4V84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.7 37.7v30.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.7",
        cy: "73.7",
        r: "5.7",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.7",
        cy: "73.7",
        r: "5.7",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.3 68.2V84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.3 37.7v18.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "79.3",
        cy: "62.2",
        r: "5.7",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.2 79.4V84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.2 37.7v29.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.2",
        cy: "73.7",
        r: "5.7",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.9 10h60.2C88.7 10 94 15.3 94 21.9v60.2C94 88.7 88.7 94 82.1 94H21.9C15.3 94 10 88.7 10 82.1V21.9C10 15.3 15.3 10 21.9 10z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.1 19.7h3.1c1.4 0 2.5 1.1 2.5 2.5v3.1c0 1.4-1.1 2.5-2.5 2.5h-3.1c-1.4 0-2.5-1.1-2.5-2.5v-3.1c0-1.4 1.2-2.5 2.5-2.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.7 19.7h3.1c1.4 0 2.5 1.1 2.5 2.5v3.1c0 1.4-1.1 2.5-2.5 2.5h-3.1c-1.4 0-2.5-1.1-2.5-2.5v-3.1c0-1.4 1.1-2.5 2.5-2.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.7 19.7h3.1c1.4 0 2.5 1.1 2.5 2.5v3.1c0 1.4-1.1 2.5-2.5 2.5h-3.1c-1.4 0-2.5-1.1-2.5-2.5v-3.1c0-1.4 1.1-2.5 2.5-2.5z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.8 41.3v-3.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.8 84V52.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "60.8",
        cy: "47.1",
        r: "5.7",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.3 19h3.1c1.4 0 2.5 1.1 2.5 2.5v3.1c0 1.4-1.1 2.5-2.5 2.5h-3.1c-1.4 0-2.5-1.1-2.5-2.5v-3.1c0-1.4 1.1-2.5 2.5-2.5z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetOptimiser104 = (InternetOptimiser104);
;// ./src/Picto/GeneratedPictoComponents/InternetOptimiser56.tsx


var InternetOptimiser56_excluded = ["className"];
function InternetOptimiser56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetOptimiser56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetOptimiser56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetOptimiser56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetOptimiser56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetOptimiser56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetOptimiser56_objectSpread(InternetOptimiser56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.6",
        cy: "12.9",
        r: "2.1",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M10.2 50H22c2.4 0 1.8-2 0-2.3-1.6-.3-4.4 0-5.9-.2-1.8-.2-3.6-.8-4.9-2.2-1.4-1.5-2.2-4.1-2.4-6.1-.1-2.1-1-15.6-2.5-15.4v20.9c0 4 2.6 5.2 3.9 5.3z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.2 42.3v2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.2 20.5v15.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.2",
        cy: "39.3",
        r: "3",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.2",
        cy: "39.3",
        r: "3",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.3 36.5v8.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.3 20.5V30"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.3",
        cy: "33.3",
        r: "3",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.9 42.3v2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.9 20.5V36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.9",
        cy: "39.3",
        r: "3",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 6h31.5c3.4 0 6.2 2.8 6.2 6.2v31.5c0 3.4-2.8 6.2-6.2 6.2H12.2C8.8 50 6 47.2 6 43.8V12.2C6 8.8 8.8 6 12.2 6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.2",
        cy: "13.2",
        r: "2.1",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.9",
        cy: "13.2",
        r: "2.1",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.3",
        cy: "13.2",
        r: "2.1",
        className: "stroke"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.6 22.4v-1.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.6 44.8V28.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.6",
        cy: "25.4",
        r: "3",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.6",
        cy: "12.9",
        r: "2.1",
        className: "stroke"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetOptimiser56 = (InternetOptimiser56);
;// ./src/Picto/GeneratedPictoComponents/LatencyOptimiser104.tsx


var LatencyOptimiser104_excluded = ["className"];
function LatencyOptimiser104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LatencyOptimiser104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LatencyOptimiser104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LatencyOptimiser104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function LatencyOptimiser104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, LatencyOptimiser104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", LatencyOptimiser104_objectSpread(LatencyOptimiser104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.73 80.25c-.56-.41-1.15-.6-1.73-.78-.46-.15-.9-.28-1.3-.54-3.74-2.23-4.92-7.55-5.88-13.28l-.04-.21c-.22-1.17-.42-2.28-1.92-2.36l-.54-.03.02.55 1.96 15.19c.3 2.19 3.19 5.3 5.57 5.3l5.19-.81v-.42c.02-1.19-.67-2.13-1.32-2.61ZM70.68 87.45c-1.59-1.01-3.37-1.53-5.09-2.04-1.46-.43-2.97-.87-4.33-1.61-12-6.28-14.98-19.99-17.2-34.69l-.09-.54c-.5-2.9-.89-5.19-4.82-5.51l-.53-.04v45.11c-.01 4.3 1.58 5.91 5.86 5.91h29.65l.04-.46c.19-2.26-1.18-4.67-3.49-6.14Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M81.23 30.2s1.87-.73 1.69.63c-.17 1.37-3.62 14.23 6.34 21.6l.43 4.68H76.76V39.86l-4.47-.37 8.93-9.29Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.14 40.66 11.88-12.93 11.84 12.93h-5.39v17.25H76.54V40.66h-5.39Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.06 66.94-4.27 1.26c-1.79.53-2.32 1.38-2.67 2.14-.08.17-5.06 9.11-5.06 9.11-.06.15-.35.69-.43.82 0 0-.02.05-.03.06-.7 1.46-1.8 2.44-3.27 2.92l-.3.09c-1.5.41-2.89.17-3.04.14-.01 0-.06-.01-.06-.01-3.87-.43-4.91-4.17-5.14-4.98-.06-.2-.13-.67-.13-.7 0 0-1.44-12.84-2.29-15.72-.82-2.8-.42-5.85 1.07-8.36 1.29-2.17 3.27-3.67 5.6-4.25l.52-.12c1.23-.26 8.56-1.24 14.52-3.26h.01c2.05-.65 3.85-1.4 5.78-2.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.93 58.28-2.06.3-.31-2.1c-.19-1.26-1.36-2.14-2.62-1.95s-2.14 1.36-1.95 2.62l.31 2.1-2.06.3c-1.26.19-2.14 1.36-1.95 2.62s1.36 2.14 2.62 1.95l2.06-.3.31 2.1a2.311 2.311 0 0 0 2.62 1.95 2.311 2.311 0 0 0 1.95-2.62l-.31-2.1 2.06-.3a2.311 2.311 0 0 0 1.95-2.62 2.311 2.311 0 0 0-2.62-1.95ZM83 63.45v24.82c0 3.16-2.46 5.73-5.5 5.73h-33c-3.04 0-5.5-2.56-5.5-5.73V15.73c0-3.16 2.46-5.73 5.5-5.73h33c3.04 0 5.5 2.56 5.5 5.73v5.73M59.17 13.82h3.66M55.5 90.18h11"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_LatencyOptimiser104 = (LatencyOptimiser104);
;// ./src/Picto/GeneratedPictoComponents/LatencyOptimiser56.tsx


var LatencyOptimiser56_excluded = ["className"];
function LatencyOptimiser56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LatencyOptimiser56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LatencyOptimiser56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LatencyOptimiser56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function LatencyOptimiser56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, LatencyOptimiser56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", LatencyOptimiser56_objectSpread(LatencyOptimiser56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.56 46.64c-1.49-.96-3.34-1.04-4.9-1.89-6.67-3.49-8.09-11.52-9.11-18.29-.3-1.69-.37-2.78-2.33-2.94V46.78c0 2.09.71 2.82 2.81 2.82h15.23c.1-1.19-.69-2.32-1.7-2.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.78 43.43c-.46-.34-1-.34-1.48-.64-2.03-1.21-2.59-4.2-3.02-6.72-.12-.63-.16-1.04-.74-1.07v.06l.97 7.42c.13.95 1.47 2.41 2.47 2.41l2.36-.37c0-.45-.25-.86-.56-1.09Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.7 16.33s1.09-.43.99.37-2.11 8.31 3.7 12.62l.25 2.73h-7.55V21.98l-2.61-.22 5.22-5.43Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.49 22.23 44 15.14l6.49 7.09h-2.95v9.46h-7.09v-9.46h-2.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.23 34.1v12.95c0 1.65-1.3 2.99-2.91 2.99H23.87c-1.61 0-2.91-1.34-2.91-2.99V9.19c0-1.65 1.3-2.99 2.91-2.99h17.45c1.61 0 2.91 1.34 2.91 2.99v2.99M31.63 8.2h1.94M29.69 48.05h5.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.38 36.04-2.3.68c-.96.28-1.25.74-1.44 1.15-.04.09-2.73 4.91-2.73 4.91-.03.08-.19.37-.23.44 0 0-.01.03-.02.03-.38.79-.97 1.31-1.76 1.57-.05.02-.11.03-.16.05-.81.22-1.56.09-1.64.08h-.03c-2.09-.23-2.64-2.25-2.77-2.68-.03-.11-.07-.36-.07-.38 0 0-.78-6.92-1.23-8.47s-.23-3.16.58-4.51c.7-1.17 1.76-1.98 3.02-2.29l.28-.06c.66-.14 4.61-.67 7.82-1.76 1.11-.35 2.23-.76 3.27-1.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.85 31.37-1.11.16-.17-1.13a1.242 1.242 0 1 0-2.46.36l.17 1.13-1.11.16a1.242 1.242 0 1 0 .36 2.46l1.11-.16.17 1.13a1.242 1.242 0 1 0 2.46-.36l-.17-1.13 1.11-.16a1.242 1.242 0 1 0-.36-2.46Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_LatencyOptimiser56 = (LatencyOptimiser56);
;// ./src/Picto/GeneratedPictoComponents/NBNHealth104.tsx


var NBNHealth104_excluded = ["className"];
function NBNHealth104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NBNHealth104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NBNHealth104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NBNHealth104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NBNHealth104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBNHealth104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NBNHealth104_objectSpread(NBNHealth104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.31 90.18c-16.06-.24-37.22-.14-53.28-.44-2.67-.05-4.45 0-6.94-1.02-6.43-2.61-5.05-9.93-6.79-15.19-.7-2.15-3.29-2.23-3.29.28v13.06c0 6.46 3.75 5.97 3.75 5.97h72.95s-.77-2.59-6.4-2.67Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.43 92.77c0 .06-.13.11-.32.15h.41l-.08-.15Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.91 46.46h.68c1 0 1.82.81 1.82 1.82v19.76h-4.32V48.28c0-1 .81-1.82 1.82-1.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.46 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.75 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.04 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11",
        y: "68.2",
        width: "82",
        height: "24.72",
        rx: "4.32",
        ry: "4.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.25 75.26v5.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.71 76.61a5.4 5.4 0 0 0-1.5 5.96c.79 2.11 2.8 3.5 5.05 3.5s4.26-1.4 5.05-3.5a5.4 5.4 0 0 0-1.5-5.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.1 53.02h4.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.75 14.01S54.05 16.87 52 17c-3.04.19-5.87 5.57-5.91 8.65-.18 14.07 12.57 21.07 15.82 24.07s.39 7.17.39 7.17l-2.09.87-24.22-23.42-2.23-6.53L34.99 21l3-4.72 2.73-2.5 5.74-1.51 4.86-.04 1.91.77 1.52 1.01Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.19 15.6c-5.9-5.32-14.94-5.05-20.51.62l-1.47 1.47-1.47-1.47c-5.57-5.67-14.61-5.94-20.51-.62-2.9 2.7-4.58 6.46-4.66 10.43a14.62 14.62 0 0 0 4.27 10.59l20.27 20.27c.56.56 1.31.87 2.09.87s1.54-.31 2.09-.87l20.27-20.27c2.8-2.8 4.35-6.63 4.27-10.59-.07-3.96-1.75-7.73-4.66-10.43Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.21 25.08v17.84M51.29 33.15h17.84"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBNHealth104 = (NBNHealth104);
;// ./src/Picto/GeneratedPictoComponents/NBNHealth56.tsx


var NBNHealth56_excluded = ["className"];
function NBNHealth56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NBNHealth56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NBNHealth56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NBNHealth56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NBNHealth56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBNHealth56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NBNHealth56_objectSpread(NBNHealth56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.72 48.02c-8.62-.13-19.97-.07-28.59-.24-1.43-.03-2.39 0-3.72-.55-3.45-1.4-2.71-5.33-3.64-8.15-.38-1.15-1.77-1.2-1.77.15v7.01c0 3.47 2.01 3.21 2.01 3.21h39.15s-.41-1.39-3.43-1.43Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.64 49.41s-.07.06-.17.08h.22l-.04-.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.08 24.56h.37c.54 0 .97.44.97.97v10.6H14.1v-10.6c0-.54.44-.97.97-.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.05 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.84 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.63 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "36.23",
        width: "44",
        height: "13.26",
        rx: "2.32",
        ry: "2.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.26 40.02v2.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.36 40.74c-.91.79-1.23 2.07-.81 3.2.42 1.13 1.5 1.88 2.71 1.88s2.29-.75 2.71-1.88c.42-1.13.1-2.4-.81-3.2"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.1 28.09h2.32"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.33 7.27s-.37 1.54-1.48 1.6c-1.63.1-3.15 2.99-3.17 4.65-.1 7.56 6.75 11.32 8.5 12.93s.21 3.85.21 3.85l-1.12.47-13.01-12.58-1.2-3.51.66-3.66 1.61-2.53 1.47-1.34 3.08-.81 2.61-.02 1.02.41.82.54Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.2 8.01a7.958 7.958 0 0 0-11.01.33l-.79.79-.79-.79a7.958 7.958 0 0 0-11.01-.33 7.826 7.826 0 0 0-.21 11.27l10.88 10.88a1.565 1.565 0 0 0 2.24 0l10.88-10.88c1.5-1.5 2.33-3.56 2.29-5.68a7.801 7.801 0 0 0-2.5-5.59Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.41 12.82v10.36M27.22 17.5h10.37"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBNHealth56 = (NBNHealth56);
;// ./src/Picto/GeneratedPictoComponents/NetworkSpeed104.tsx


var NetworkSpeed104_excluded = ["className"];
function NetworkSpeed104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NetworkSpeed104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NetworkSpeed104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NetworkSpeed104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NetworkSpeed104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeed104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NetworkSpeed104_objectSpread(NetworkSpeed104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.86 32.03c3.76 3.78 14.34.81 7.57-6.93C68.9 11.92 49.76 8.55 34.14 16.7c-6.91 3.6-13.16 9.33-16.52 16.43-3.52 7.45-4.02 15.74-3.91 23.86.07 5.33 8.35 5.34 8.28 0-.08-6.26 1.64-12.34 3.98-18.25 2.43-6.14 7.72-8.53 13.39-11.71 9.8-4.01 23.59-4.98 33.5 5ZM78 56.55C75.45 71.11 67.51 79.99 52.26 81.7c-3.49.39-3.53 5.92 0 5.52C69.9 85.24 80.98 74.24 84 57.02c.61-3.48-5.39-3.97-6-.47Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.31 51.83C90.4 73.92 73.43 91.9 52.42 92c-21.01.09-38.12-17.74-38.21-39.83C14.12 30.08 31.09 12.09 52.1 12c21.01-.09 38.12 17.74 38.21 39.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.33 55.17c.07 17.16-13.78 31.13-30.94 31.2-17.16.07-31.13-13.78-31.2-30.94-.07-17.16 13.78-31.13 30.94-31.2 17.16-.07 31.13 13.78 31.2 30.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.12 77-2.53-2.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.14 55.16h-5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.07 33.33-2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.23 24.32v5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.41 33.38 2.53 2.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.39 55.23h5.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.46 77.05 2.53-2.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52.26 50.35a4.98 4.98 0 1 0 .001 9.961 4.98 4.98 0 0 0-.001-9.961Zm1 5.69c-.39.55-1.16.68-1.71.28a1.22 1.22 0 0 1-.28-1.71 1.22 1.22 0 0 1 1.71-.28c.55.39.68 1.16.28 1.71Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M71.18 68.37c-4.03-3.9-15.97-14.82-17.07-15.62-1.41-1-3.36-.68-4.37.73-1.01 1.4-.68 3.36.73 4.36 1.11.79 15.3 8.55 20.29 11.11.37.19.72-.29.42-.58ZM53.26 56.04c-.39.55-1.16.68-1.71.28a1.22 1.22 0 0 1-.28-1.71 1.22 1.22 0 0 1 1.71-.28c.55.39.68 1.16.28 1.71Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeed104 = (NetworkSpeed104);
;// ./src/Picto/GeneratedPictoComponents/NetworkSpeed56.tsx


var NetworkSpeed56_excluded = ["className"];
function NetworkSpeed56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NetworkSpeed56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NetworkSpeed56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NetworkSpeed56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NetworkSpeed56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NetworkSpeed56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NetworkSpeed56_objectSpread(NetworkSpeed56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.73 16.65c2.03 2.04 7.73.44 4.08-3.74C36.59 5.8 26.43 4.61 18 9.01c-3.72 1.94-7.25 4.4-9.06 8.24-1.9 4.02-2.17 8.49-2.11 12.87.04 2.87 4.5 2.88 4.47 0-.05-3.38.89-6.66 2.15-9.84.89-2.25 2.5-3.57 4.4-4.72 2.47-1.5 5.18-2.61 8.04-2.98 4.34-.56 9.1.32 12.84 4.08ZM47 28.01c-1.58 9.04-7.53 17.94-17 19-2.17.24-1.85 2.67.35 2.43 10.95-1.23 17.75-8.58 19.62-19.28C50.35 28 47 28.01 47 28.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.66 28.01c.05 11.92-9.57 21.62-21.49 21.67-11.92.05-21.62-9.57-21.67-21.49-.05-11.92 9.57-21.62 21.49-21.67 11.92-.05 21.62 9.57 21.67 21.49Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.45 43.18-1.66-1.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.45 28h-3.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.29 12.97-1.66 1.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.24 6.5v3.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.1 12.9 1.67 1.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.58 28.05h3.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.92 43.4 1.67-1.66"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28.08 24.67a3.461 3.461 0 0 0 0 6.92 3.461 3.461 0 0 0 0-6.92Zm.69 3.95c-.27.38-.8.47-1.19.2s-.47-.8-.2-1.19c.27-.38.8-.47 1.19-.2.38.27.47.8.2 1.19Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.22 37.18c-2.8-2.71-11.09-10.29-11.86-10.85-.98-.7-2.33-.47-3.03.5-.7.98-.47 2.33.5 3.03.77.55 10.63 5.94 14.1 7.72.26.13.5-.2.29-.41Zm-12.45-8.56c-.27.38-.8.47-1.19.2s-.47-.8-.2-1.19c.27-.38.8-.47 1.19-.2.38.27.47.8.2 1.19Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NetworkSpeed56 = (NetworkSpeed56);
;// ./src/Picto/GeneratedPictoComponents/RaisedSurface104.tsx


var RaisedSurface104_excluded = ["className"];
function RaisedSurface104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RaisedSurface104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RaisedSurface104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RaisedSurface104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RaisedSurface104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RaisedSurface104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RaisedSurface104_objectSpread(RaisedSurface104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M37.85 48.07a3.224 3.224 0 0 1-2.04 2.82s.31-31.02.31-31.02l21.87-.51c.66 1.69-.46 3.53-2.26 3.76-13.47 1.73-17.06 10.33-17.88 24.96Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "35.26",
      y: "19.38",
      width: "33.36",
      height: "33.36",
      rx: "1.01",
      ry: "1.01",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "61.46",
      cy: "45.66",
      r: "2.1",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.77 66.01h5.59v18.63l-5.59-18.63z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.23 66.01h-5.59v18.63h.49l5.1-18.63z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 66.01h82V54.83H11v11.18z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.45 66.01 7.18 18.63h7.73l-5.59-18.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m85.55 66.01-7.18 18.63h-7.73l5.59-18.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.45 66.01 7.18 18.63h7.73V66.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m85.55 66.01-7.18 18.63h-7.73V66.01"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RaisedSurface104 = (RaisedSurface104);
;// ./src/Picto/GeneratedPictoComponents/RaisedSurface56.tsx


var RaisedSurface56_excluded = ["className"];
function RaisedSurface56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RaisedSurface56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RaisedSurface56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RaisedSurface56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RaisedSurface56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RaisedSurface56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RaisedSurface56_objectSpread(RaisedSurface56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.4 25.99c-.04.67-.47 1.26-1.1 1.51s.16-16.65.16-16.65l11.74-.28c.35.91-.25 1.89-1.21 2.02-7.23.93-9.15 5.54-9.59 13.39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "19.02",
      y: "10.6",
      width: "17.9",
      height: "17.9",
      rx: ".54",
      ry: ".54",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "33.08",
      cy: "24.7",
      r: "1.13",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15 35.52h3v10l-3-10z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41 35.52h-3v10h.26l2.74-10z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 35.52h44v-6H6v6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10 35.52 3.85 10H18l-3-10"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46 35.52-3.85 10H38l3-10"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10 35.52 3.85 10H18v-10"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46 35.52-3.85 10H38v-10"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RaisedSurface56 = (RaisedSurface56);
;// ./src/Picto/GeneratedPictoComponents/Satellite104.tsx


var Satellite104_excluded = ["className"];
function Satellite104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Satellite104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Satellite104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Satellite104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Satellite104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Satellite104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Satellite104_objectSpread(Satellite104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.27 59.15c4.39-3.65 15.99 15.42 26.72 11.39l-7.27 7.27-19.45-18.67ZM25.65 20.65C30.04 17 41.64 36.07 52.37 32.04l-7.27 7.27-19.45-18.67ZM36.1 64.75c4.77 2.81 10.81 5.64 13.62 3.98.6-.36 1.34.22 1.28.91-.45 4.83-2.6 7.03-3.71 7.86-.35.26-.84.23-1.15-.08l-11.09-11.3c-.71-.73.18-1.88 1.06-1.36ZM46.76 50.3l9.72 9.72 17.18-17.18c.69-.69-.21-1.78-1.02-1.22-7.98 5.53-18.79 11.36-25.57 8.25-.28-.13-.52.22-.3.44Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.84 73.76c0 4.82 3.91 8.73 8.73 8.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.85 73.76c0 7.58 6.14 13.72 13.72 13.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.86 73.76c0 10.34 8.38 18.71 18.71 18.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.74 21.72h18.37v36.64c0 .54-.44.99-.99.99h-16.4c-.54 0-.99-.44-.99-.99V21.72Z",
        transform: "rotate(-135 62.926 40.533)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.76 56.72c5.65-5.65 15.08-5.38 21.06.6 5.98 5.98 6.25 15.41.6 21.06L25.76 56.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 77.867 63.743)",
        d: "M64.48 57.24h26.76v13.02H64.48z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.28 51.17 22.04 22.04M82.47 59.15l-9.21 9.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(-135 39.702 25.59)",
        d: "M26.32 19.08h26.76V32.1H26.32z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.28 38.17 30.24 16.13M35.1 30.2l9.21-9.21M32.6 71.04l-.06-7.01M33.36 71.34l6.96.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "29.7",
        cy: "74.2",
        r: "3.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.71 55.36 2.92-2.92M48.92 59.29l2.92-2.92"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Satellite104 = (Satellite104);
;// ./src/Picto/GeneratedPictoComponents/Satellite56.tsx


var Satellite56_excluded = ["className"];
function Satellite56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Satellite56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Satellite56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Satellite56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Satellite56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Satellite56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Satellite56_objectSpread(Satellite56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.07 31.85c2.36-1.96 8.61 8.3 14.39 6.14l-3.92 3.92-10.47-10.05ZM13.81 11.12c2.36-1.96 8.61 8.3 14.39 6.14l-3.92 3.92-10.47-10.05ZM19.44 34.86c2.57 1.51 5.82 3.04 7.33 2.14.32-.19.72.12.69.49-.24 2.6-1.4 3.79-2 4.23-.19.14-.45.12-.62-.05l-5.97-6.09c-.38-.39.1-1.01.57-.73ZM25.18 27.08l5.23 5.23 9.25-9.25c.37-.37-.12-.96-.55-.66-4.3 2.98-10.12 6.12-13.77 4.44-.15-.07-.28.12-.16.24Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.76 39.72a4.7 4.7 0 0 0 4.7 4.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.07 39.72c0 4.08 3.31 7.39 7.39 7.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.39 39.72c0 5.57 4.51 10.08 10.08 10.08"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.94 11.7h9.89v19.27c0 .54-.44.99-.99.99h-7.92c-.54 0-.99-.44-.99-.99V11.7Z",
        transform: "rotate(-135 33.884 21.827)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.87 30.54c3.04-3.04 8.12-2.9 11.34.32 3.22 3.22 3.37 8.3.32 11.34L13.86 30.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 41.922 34.325)",
        d: "M34.72 30.82h14.41v7.01H34.72z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.15 27.55 11.87 11.87M44.4 31.85l-4.95 4.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(-135 21.378 13.78)",
        d: "M14.17 10.28h14.41v7.01H14.17z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.15 20.55 16.28 8.69M18.9 16.26l4.96-4.96M17.55 38.25l-.03-3.77M17.97 38.41l3.74.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.99",
        cy: "39.95",
        r: "1.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.08 29.81 1.57-1.57M26.34 31.93l1.57-1.58"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Satellite56 = (Satellite56);
;// ./src/Picto/GeneratedPictoComponents/SpeedOptimiser104.tsx


var SpeedOptimiser104_excluded = ["className"];
function SpeedOptimiser104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SpeedOptimiser104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SpeedOptimiser104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SpeedOptimiser104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SpeedOptimiser104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SpeedOptimiser104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SpeedOptimiser104_objectSpread(SpeedOptimiser104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M70.76 87.45c-1.59-1.01-3.37-1.53-5.09-2.04-1.46-.43-2.97-.87-4.33-1.61-12-6.28-14.98-19.99-17.2-34.69l-.09-.54c-.5-2.9-.89-5.19-4.82-5.51l-.53-.04V74c-1.32.06-12.15.33-18.51-5.95a56.998 56.998 0 0 1-5.42-6.15c-1.33-1.71-1.99-2.52-3.15-2.4-.57.07-.96.28-1.17.64-.3.52-.1 1.13.07 1.54l9.22 21.22a2.985 2.985 0 0 0 2.77 1.86c.38 0 .76-.07 1.13-.22L38.68 78v10.12c0 4.3 1.59 5.91 5.88 5.91h29.65l.04-.46c.19-2.26-1.18-4.67-3.49-6.14Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.07 65.7-7.18-16.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.7 77.56-15.71 6.82c-1.01.44-2.19-.02-2.63-1.04l-10.2-23.48c-.44-1.01.03-2.19 1.04-2.63l23.48-10.2c1.01-.44 2.19.03 2.63 1.04l1.34 3.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.36 51.54-4.58 1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.95 77.98-4.58 1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.58 61-4.59 1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.42 65.24-4.58 2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.29 61.24 16 71.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.84 82.33 14.69 56.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.11 73.73-4.59 2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.07 56.28-3.45 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.08 63.45v24.82c0 3.16-2.46 5.73-5.5 5.73h-33c-3.04 0-5.5-2.56-5.5-5.73V15.73c0-3.16 2.46-5.73 5.5-5.73h33c3.04 0 5.5 2.56 5.5 5.73v5.73M59.25 13.82h3.67M55.58 90.18h11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M80.08 35.04s-1.03 3.8.44 6.29c1.47 2.48 6.8 1.48 6.8 1.48s3.58.05 1.04 3.65c-2.55 3.6-9.08 10.84-9.08 10.84l3.31-12.07H71.44l8.65-10.19",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.78 39.19h11.79L77.06 60.9l5.52-15.67H71.43L85.61 27.1l-2.83 12.09z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SpeedOptimiser104 = (SpeedOptimiser104);
;// ./src/Picto/GeneratedPictoComponents/SpeedOptimiser56.tsx


var SpeedOptimiser56_excluded = ["className"];
function SpeedOptimiser56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SpeedOptimiser56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SpeedOptimiser56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SpeedOptimiser56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SpeedOptimiser56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SpeedOptimiser56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SpeedOptimiser56_objectSpread(SpeedOptimiser56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.8 46.18c-.86-.55-1.81-.83-2.73-1.1-.79-.23-1.53-.45-2.22-.83-6.18-3.24-7.73-10.36-8.88-18l-.05-.28c-.27-1.56-.5-2.9-2.74-3.08l-.53-.04v16.21c-.32-.06-.63-.09-.92-.05-.23.01-5.76.29-8.94-2.84-1.35-1.33-2.12-2.33-2.64-2.99-.62-.8-1-1.28-1.64-1.28h-.13c-.45.06-.66.27-.76.45-.23.39-.04.84.02.99l4.52 10.4c.27.67.91 1.07 1.6 1.07.22 0 .44-.04.66-.13l8.24-3.58v5.65c0 2.4.93 3.33 3.31 3.33h15.75l.04-.46c.1-1.27-.66-2.62-1.94-3.43Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M42.45 18.84s-.53 1.96.23 3.25 3.51.76 3.51.76 1.85.02.53 1.88-4.69 5.6-4.69 5.6l1.71-6.23h-5.76l4.46-5.26",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.82 20.84h6.28L40.77 32.4l2.95-8.35h-5.94l7.55-9.65-1.51 6.44z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.94 34.12v13c0 1.66-1.31 3-2.92 3H23.51c-1.61 0-2.92-1.34-2.92-3v-38c0-1.66 1.31-3 2.92-3h17.51c1.61 0 2.92 1.34 2.92 3v3M31.29 8.12h1.95M29.35 48.12h5.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.53 35.99-4.2-9.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.87 41.06-8.16 3.54c-.53.23-1.14-.01-1.37-.54L5.05 31.87c-.23-.53.01-1.14.54-1.37l12.19-5.29c.53-.23 1.14.01 1.37.54l1.2 2.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.69 27.55-2.38 1.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.21 41.28-2.38 1.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.38 32.46 6 33.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.34 34.67-2.38 1.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.82 32.31 8.08 37.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.19 43.54 7.4 30.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.25 39.08-2.38 1.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.48 29.83-2.21.96"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SpeedOptimiser56 = (SpeedOptimiser56);
;// ./src/Picto/GeneratedPictoComponents/StarlinkSatellite104.tsx


var StarlinkSatellite104_excluded = ["className"];
function StarlinkSatellite104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StarlinkSatellite104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StarlinkSatellite104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StarlinkSatellite104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StarlinkSatellite104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StarlinkSatellite104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StarlinkSatellite104_objectSpread(StarlinkSatellite104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.23 33.42s10.92 8.56 21.49 9.43l15.59 11.11-2 .21s-29.6-11.32-35.09-20.75Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.36 73.98 42.63 17.13M50.34 48.06l.02 25.92-39.37 13.56M50.36 73.98l17.03 19.15M71.09 55.28l-60.1-44.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.27 11.75c.54.02 1.07.19 1.51.51l55.01 38.49c.33.23.22.74-.17.81l-20.3 3.81c-.41.08-.83.03-1.23-.08-40.1-10.83-60.1-44.42-60.1-44.42l25.29.88Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StarlinkSatellite104 = (StarlinkSatellite104);
;// ./src/Picto/GeneratedPictoComponents/StarlinkSatellite56.tsx


var StarlinkSatellite56_excluded = ["className"];
function StarlinkSatellite56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StarlinkSatellite56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StarlinkSatellite56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StarlinkSatellite56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StarlinkSatellite56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StarlinkSatellite56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StarlinkSatellite56_objectSpread(StarlinkSatellite56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M17.64 18.25s5.72 4.49 11.27 4.95l8.18 5.83-1.05.11s-15.53-5.94-18.4-10.88Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.15 39.52 22.36 8.99M27.14 25.93l.01 13.59L6.5 46.63M27.15 39.52l8.94 10.05M38.02 29.71 6.5 6.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.76 6.88c.28 0 .56.1.79.27L49.4 27.34c.17.12.11.39-.09.42l-10.65 2c-.22.04-.43.01-.65-.04C16.99 24.04 6.5 6.42 6.5 6.42l13.26.46Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StarlinkSatellite56 = (StarlinkSatellite56);
;// ./src/Picto/GeneratedPictoComponents/TelstraAir104.tsx


var TelstraAir104_excluded = ["className"];
function TelstraAir104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraAir104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraAir104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraAir104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraAir104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraAir104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraAir104_objectSpread(TelstraAir104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.1 87.4c-15.9 0-30.5-9.1-37.4-23.5-5.5-11.4-5.4-24.6-.1-35.7.6-1.2-1-2.2-1.8-1.2-7.5 9.7-10.5 22.4-7.7 34.7C14.6 77.3 26.7 89.4 42.3 93c12.3 2.8 25-.2 34.7-7.7 1-.8 0-2.4-1.1-1.8-5.6 2.5-11.6 3.9-17.8 3.9z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "42",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.3 69.7-7.4-24.5c-.2-.7-.9-1.1-1.6-1.1h-.1c-.7 0-1.3.4-1.5 1.1l-7.5 24.5c-.1.4-.1.9.2 1.2.3.3.7.5 1.1.5.6 0 1.2-.4 1.4-1l1.8-5.8h9.2l1.8 5.8c.2.6.8 1 1.4 1 .4 0 .8-.2 1.1-.5.2-.3.3-.8.1-1.2zM32.6 62l3.8-12.7L40.1 62h-7.5zm18 8.2c0 .7.6 1.2 1.3 1.2.4 0 .7-.1 1-.3.3-.2.4-.6.5-.9V53.1c0-.4-.2-.7-.5-.9-.3-.2-.6-.4-1-.3-.3 0-.7.1-1 .3-.3.2-.4.6-.4.9l.1 17.1zm26.3-18.1v-.4c0-4.1-3.4-7.4-7.5-7.4h-6.8c-.3 0-.7.1-1 .3-.3.2-.4.6-.4.9v24.6c0 .3.2.7.4.9.3.2.6.4 1 .3.4 0 .7-.1 1-.3.3-.2.5-.6.5-1V59.4h4.1l5.5 11.4c.2.4.7.7 1.2.7.4.1.8 0 1.1-.3.3-.2.5-.6.5-1 0-.2 0-.4-.1-.6l-5.1-10.4c3.3-.8 5.6-3.8 5.6-7.1zm-2.9 0c0 1.2-.5 2.4-1.3 3.3-.9.9-2.1 1.4-3.3 1.4h-5.2V47h5.2c1.2 0 2.4.5 3.3 1.4.9.9 1.3 2.1 1.3 3.3v.4zm-22-7.6c-1 0-1.8.8-1.8 1.8S51 48 52 48s1.8-.8 1.8-1.8-.8-1.7-1.8-1.7M64.4 35c-.4 0-.7-.1-1-.4-6.3-6.2-16.5-6.2-22.8 0-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9c7.4-7.3 19.3-7.3 26.7 0 .4.4.5 1 .3 1.5s-.8.8-1.3.8zm-3.6 4.2c-.4 0-.7-.2-1-.4-2.1-2.1-4.9-3.3-7.9-3.3s-5.8 1.2-7.9 3.3c-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9c2.6-2.6 6.1-4.1 9.8-4.1s7.2 1.5 9.8 4.1c.4.4.5 1 .3 1.5-.1.4-.6.8-1.2.8zm-3.6 4.1c-.4 0-.7-.2-1-.4-2.3-2.3-6.1-2.3-8.4 0-.5.5-1.4.5-1.9 0s-.5-1.4 0-1.9c3.4-3.4 8.9-3.4 12.2 0 .5.5.5 1.4 0 1.9-.2.3-.6.4-.9.4z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraAir104 = (TelstraAir104);
;// ./src/Picto/GeneratedPictoComponents/TelstraAir56.tsx


var TelstraAir56_excluded = ["className"];
function TelstraAir56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraAir56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraAir56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraAir56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraAir56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraAir56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraAir56_objectSpread(TelstraAir56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.51 46.49c-8.45 0-16.15-4.84-19.82-12.45a21.995 21.995 0 0 1-.17-18.74c.3-.65-.6-1.18-1.04-.61a21.986 21.986 0 0 0-3.92 18.19 22.013 22.013 0 0 0 16.56 16.56c6.43 1.47 13.06-.04 18.17-3.91.58-.44.04-1.34-.61-1.04a22 22 0 0 1-9.17 2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "22",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.4 37.55-4-13.18a.865.865 0 0 0-.87-.58h-.04c-.37 0-.71.23-.83.58l-4.01 13.18c-.08.22-.04.47.11.65.14.19.37.29.6.28.34.02.65-.2.75-.52l.94-3.14h4.96l.94 3.14c.1.33.41.54.75.52.23.01.46-.09.6-.28.14-.19.18-.43.11-.65Zm-6.87-4.18 2.03-6.85 2.03 6.85h-4.06Zm9.74 4.45c.03.38.35.67.72.66.19.01.39-.05.53-.18.15-.13.23-.31.24-.51v-9.22c0-.19-.1-.38-.24-.51a.745.745 0 0 0-.53-.18.76.76 0 0 0-.52.19c-.14.13-.22.31-.23.5l.03 9.24Zm14.12-9.78v-.19a4.025 4.025 0 0 0-4.05-3.98H33.7c-.19 0-.37.06-.51.19s-.22.31-.22.5v13.26c0 .19.09.37.23.5s.33.2.52.19c.2.02.4-.04.55-.17.15-.13.25-.32.27-.52v-5.85h2.22l2.95 6.14c.12.24.37.39.65.39.21.04.43-.02.59-.16a.727.727 0 0 0 .21-.89l-2.74-5.61a3.876 3.876 0 0 0 2.96-3.81Zm-1.56 0c.01.66-.25 1.31-.71 1.78-.47.47-1.11.74-1.77.74h-2.8v-5.22h2.8c.66 0 1.3.27 1.77.74s.73 1.11.72 1.77v.19ZM28 23.95a.939.939 0 1 0 0 1.88.939.939 0 1 0 0-1.88m6.68-5.13c-.19 0-.38-.07-.51-.21-3.4-3.36-8.88-3.36-12.28 0-.29.28-.75.28-1.04 0a.749.749 0 0 1 0-1.04c3.96-3.95 10.39-3.95 14.35 0 .21.21.27.52.15.8s-.38.45-.68.45Zm-1.93 2.26c-.19 0-.38-.08-.51-.22-1.12-1.12-2.65-1.76-4.24-1.76s-3.12.63-4.24 1.76a.73.73 0 0 1-1.04 0 .73.73 0 0 1 0-1.04c1.4-1.4 3.3-2.18 5.28-2.18s3.88.79 5.28 2.18c.21.21.26.53.15.8-.11.27-.38.45-.67.46Zm-1.96 2.25c-.19 0-.38-.08-.51-.22a3.199 3.199 0 0 0-4.51 0 .73.73 0 0 1-1.04 0 .73.73 0 0 1 0-1.04 4.666 4.666 0 0 1 6.58 0c.28.29.28.75 0 1.04-.14.14-.33.22-.52.22Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraAir56 = (TelstraAir56);
;// ./src/Picto/GeneratedPictoComponents/WiFi104.tsx


var WiFi104_excluded = ["className"];
function WiFi104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WiFi104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WiFi104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WiFi104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WiFi104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFi104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WiFi104_objectSpread(WiFi104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M56.1 80.11a8.42 8.42 0 0 1-8.37-9.32c.11-.96-1.03-1.58-1.72-.91-1.83 1.78-2.85 4.38-2.46 7.22.51 3.66 3.47 6.63 7.13 7.13a8.4 8.4 0 0 0 7.49-2.75c.55-.62.04-1.61-.78-1.48-.42.07-.85.1-1.29.1",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.31 75.9a8.42 8.42 0 1 1-16.84 0 8.42 8.42 0 0 1 16.84 0Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.77 48.92c-17.06-17.06-44.71-17.06-61.76 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.54 60.15c-10.85-10.85-28.45-10.85-39.3 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M94 37.69c-23.26-23.26-60.96-23.26-84.22 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFi104 = (WiFi104);
;// ./src/Picto/GeneratedPictoComponents/WiFi56.tsx


var WiFi56_excluded = ["className"];
function WiFi56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WiFi56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WiFi56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WiFi56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WiFi56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFi56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WiFi56_objectSpread(WiFi56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.4 40.34a4.4 4.4 0 1 1-8.8 0 4.4 4.4 0 0 1 8.8 0Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.92 42.28c-2.18 0-3.95-1.77-3.95-3.95 0-.14 0-.28.02-.42.05-.45-.48-.74-.8-.43-.86.83-1.34 2.05-1.15 3.38.24 1.71 1.63 3.11 3.34 3.34 1.4.19 2.67-.35 3.51-1.29.26-.29.02-.75-.37-.69-.2.03-.4.05-.6.05",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.13 26.24c-8.91-8.91-23.36-8.91-32.27 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.27 32.11c-5.67-5.67-14.86-5.67-20.53 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50 20.38c-12.15-12.15-31.85-12.15-44 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFi56 = (WiFi56);
;// ./src/Picto/GeneratedPictoComponents/Window104.tsx


var Window104_excluded = ["className"];
function Window104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Window104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Window104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Window104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Window104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Window104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Window104_objectSpread(Window104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.29 47.15v28.41c0 .15.12.26.26.26h12.57c.96 0 1.41-1.19.68-1.81-4.97-4.27-9.05-13.85-11.47-27.03-.23-1.24-2.05-1.08-2.05.18ZM66.76 76.14h14.47c.27 0 .49-.22.49-.49V46.31c0-1.56-2.24-1.78-2.56-.26-2.78 13.02-7.28 21.94-13.5 26.78-1.39 1.08-.66 3.3 1.11 3.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 92.93h82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.86 20.43h27.86v55.71H53.86z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.29 20.43h27.85v55.71H22.29V20.43z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.02 14.29h69.96c.56 0 1.02.46 1.02 1.02v65.97c0 .56-.46 1.02-1.02 1.02H17.02c-.56 0-1.02-.46-1.02-1.02V15.3c0-.56.46-1.02 1.02-1.02Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.14 40.86 10.51 10.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.71 40.86 5.26 5.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.14 46.43 5.26 5.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.57 42.71 10.51 10.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.14 42.71 5.26 5.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.57 48.29 5.25 5.25"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Window104 = (Window104);
;// ./src/Picto/GeneratedPictoComponents/Window56.tsx


var Window56_excluded = ["className"];
function Window56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Window56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Window56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Window56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Window56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Window56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Window56_objectSpread(Window56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12 24.73v15.95c0 .08.06.14.14.14h6.17c.7 0 1.07-.85.57-1.35-2.57-2.53-4.67-7.76-5.89-14.83-.1-.6-.99-.53-.99.08ZM35.64 41h8.03c.18 0 .33-.15.33-.33V24.98c0-.85-1.21-.96-1.39-.14-1.53 7.13-4.02 11.97-7.47 14.54-.7.52-.37 1.62.5 1.62Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.5 49.5h43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29 11h15v30H29z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12 11h15v30H12V11z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 8h36c.55 0 1 .45 1 1v34c0 .55-.45 1-1 1H10c-.55 0-1-.45-1-1V9c0-.55.45-1 1-1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34 22 5.66 5.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37 22 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34 25 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17 23 5.66 5.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20 23 2.83 2.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17 26 2.83 2.83"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Window56 = (Window56);
;// ./src/Picto/GeneratedPictoComponents/Add104.tsx


var Add104_excluded = ["className"];
function Add104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Add104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Add104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Add104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Add104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Add104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Add104_objectSpread(Add104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.63 22.52c-.68 1.69-12.32 32.04 5.79 54.96C36.31 87.47 46.48 91.77 52 93.59c-4.12.05-10.3-.46-17.01-3.37-16.15-7.01-21.84-22.1-22.6-24.22-2.77-7.73-2.5-14.34-2.28-17 1.17-14.38 9.73-23.68 12.52-26.48Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "10",
      y: "10",
      width: "84",
      height: "84",
      rx: "42",
      ry: "42",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 37v30M67 52H37"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Add104 = (Add104);
;// ./src/Picto/GeneratedPictoComponents/Add56.tsx


var Add56_excluded = ["className"];
function Add56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Add56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Add56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Add56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Add56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Add56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Add56_objectSpread(Add56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.9 12.76C8.53 22.91 9.5 34.04 15.69 41.6c4.19 5.11 9.6 7.15 12.45 7.97-2.04.14-5.37.1-9.05-1.37C11.3 45.09 8.18 38.08 7.5 36.42c-.45-1.09-1.81-4.68-1.57-9.43.1-1.96.39-7.71 4.59-12.18a15.5 15.5 0 0 1 2.38-2.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "6.14",
      y: "6",
      width: "44",
      height: "44",
      rx: "22",
      ry: "22",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.14 20v16M36.14 28h-16"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Add56 = (Add56);
;// ./src/Picto/GeneratedPictoComponents/ChangePlan104.tsx


var ChangePlan104_excluded = ["className"];
function ChangePlan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ChangePlan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ChangePlan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ChangePlan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ChangePlan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ChangePlan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ChangePlan104_objectSpread(ChangePlan104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.1 49.4c0-.2 1.2.4 1.3.5.7.4 1.1.8 1.4 1.5 1.2 2.5.9 5.3.7 8-.1 3.3.1 6.5.5 9.8.3 2.8.6 5.8 2 8.4 1.2 2.3 3.5 3.2 5.9 4.1 1.5.6 2.3 1.8 2.5 3.3H12.6s-1.5-.5-1.5-3.6v-32zM56.9 57.1c0-.2 1.2.4 1.3.5.7.4 1.1.8 1.4 1.5 1.2 2.5.9 5.3.7 8-.2 3.3.1 6.5.5 9.8.3 2.8.6 5.8 2 8.4 1.2 2.3 3.6 3.2 5.9 4.1 1.5.6 2.3 1.8 2.5 3.3H58.4s-1.5-.5-1.5-3.6v-32z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.4 26.2h33.4c.8 0 1.4.6 1.4 1.4v56.3c0 .8-.6 1.4-1.4 1.4H12.4c-.8 0-1.4-.6-1.4-1.4V27.7c0-.8.6-1.5 1.4-1.5zM18.2 62.4h23.3M18.2 71.8h23.3M58.2 33.9h33.4c.8 0 1.4.6 1.4 1.4v56.3c0 .8-.6 1.4-1.4 1.4H58.2c-.8 0-1.4-.6-1.4-1.4V35.3c0-.8.6-1.4 1.4-1.4z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.8 49.2v-4.3l-.6-.1c-2.3-.5-3.4-1.7-3.4-3.6 0-2.4 1.7-3.9 4.1-4.1v-1.7h1.5v1.7c2 .3 3.7 1.6 3.9 3.9H24c-.1-1-.6-1.8-1.7-2.1V43l.9.2c2 .5 3.3 1.7 3.3 3.7 0 2.5-1.7 3.9-4.2 4.1v2h-1.5v-2c-2.6-.3-4.3-1.9-4.3-4.4h2.3c0 1.3.7 2.3 2 2.6zm0-6.5v-3.8c-1.2.2-1.9 1-1.9 2 0 .9.5 1.4 1.9 1.8zm1.5 2.5v4c1.3-.2 2.1-1 2.1-2.1 0-.9-.6-1.6-2.1-1.9.1 0 0 0 0 0z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.8 56.2v-4.3l-.6-.1c-2.3-.5-3.4-1.7-3.4-3.6 0-2.4 1.7-3.9 4.1-4.1v-1.7h1.5v1.7c2 .3 3.7 1.6 3.9 3.9H70c-.1-1-.6-1.8-1.7-2.1V50l.9.2c2 .5 3.3 1.7 3.3 3.7 0 2.5-1.7 3.9-4.2 4.1v2h-1.5v-2c-2.6-.3-4.3-1.9-4.3-4.4h2.3c0 1.3.6 2.3 2 2.6zm0-6.5v-3.8c-1.2.2-1.9 1-1.9 2 0 .9.5 1.4 1.9 1.8zm1.5 2.5v4c1.3-.2 2.1-1 2.1-2.1-.1-.9-.6-1.6-2.1-1.9z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.1 15.9 67 24.3l-8.4-1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.7 20.7c2.8-5.6 9.8-9.1 16.4-8.3 6.6.8 12.6 5.8 13.9 11.9M64 70h23.3M64 79.4h23.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ChangePlan104 = (ChangePlan104);
;// ./src/Picto/GeneratedPictoComponents/ChangePlan56.tsx


var ChangePlan56_excluded = ["className"];
function ChangePlan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ChangePlan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ChangePlan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ChangePlan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ChangePlan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ChangePlan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ChangePlan56_objectSpread(ChangePlan56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.6 26.7c0-.1.7.2.7.2.4.2.6.4.8.8.7 1.3.4 2.8.4 4.2-.1 1.7.1 3.4.2 5.1.2 1.5.3 3 1 4.4.6 1.2 1.9 1.7 3.1 2.2.8.3 1.2.9 1.3 1.8H7.3s-.8-.3-.8-1.9c0 0 0-16.8.1-16.8zM30.5 30.7c0-.1.6.2.7.2.4.2.6.4.8.8.7 1.3.5 2.8.4 4.2-.1 1.7 0 3.4.2 5.1.2 1.5.3 3 1 4.4.6 1.2 1.9 1.7 3.1 2.2.8.3 1.2.9 1.3 1.8h-6.7s-.8-.3-.8-1.9V30.7z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.9 14.5H24c.8 0 1.4.6 1.4 1.4V44c0 .8-.6 1.4-1.4 1.4H7.9c-.8 0-1.4-.6-1.4-1.4V15.9c0-.8.6-1.4 1.4-1.4zM10.3 33.5h12.2M10.3 38.4h12.2M31.9 18.5H48c.8 0 1.4.6 1.4 1.4V48c0 .8-.6 1.4-1.4 1.4H31.9c-.8 0-1.4-.6-1.4-1.4V19.9c0-.8.6-1.4 1.4-1.4z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M11.9 26.4v-2.2l-.3-.1c-1.1-.3-1.7-.9-1.7-1.8 0-1.2.9-1.9 2-2v-.8h.8v.8c1 .1 1.9.8 2 2h-1.1c-.1-.5-.3-.9-.9-1v2l.4.1c1 .2 1.6.9 1.6 1.9 0 1.2-.8 2-2.1 2.1v1h-.8v-1c-1.3-.1-2.1-.9-2.2-2.2h1.1c.2.5.6 1 1.2 1.2zm.1-3.3v-1.9c-.6.1-1 .5-1 1s.2.7 1 .9zm.7 1.3v2c.6-.1 1-.5 1-1s-.3-.9-1-1z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36 30.4v-2.2l-.3-.1c-1.1-.3-1.7-.9-1.7-1.8 0-1.2.9-1.9 2-2v-.8h.8v.8c1 .1 1.9.8 2 2h-1.1c0-.5-.3-.9-.9-1v2l.5.1c1 .2 1.6.9 1.6 1.9 0 1.2-.8 2-2.1 2.1v1H36v-1c-1.3-.1-2.1-.9-2.2-2.2h1.1c.1.5.4 1 1.1 1.2zm0-3.3v-1.9c-.6.1-1 .5-1 1s.3.7 1 .9zm.7 1.3v2c.6-.1 1-.5 1-1 .1-.5-.2-.9-1-1z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.4 9.1-.5 4.4-4.4-.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20 11.6c1.5-2.9 5.1-4.8 8.6-4.3 3.5.4 6.6 3 7.3 6.2M34.3 37.5h12.2M34.3 42.4h12.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ChangePlan56 = (ChangePlan56);
;// ./src/Picto/GeneratedPictoComponents/Compare104.tsx


var Compare104_excluded = ["className"];
function Compare104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Compare104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Compare104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Compare104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Compare104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Compare104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Compare104_objectSpread(Compare104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.1 34c0-.3 1.8.6 2 .7 1 .6 1.6 1.2 2.1 2.3 1.8 3.7 1.3 7.8 1.1 11.8-.2 4.8.1 9.6.7 14.4.5 4.2.9 8.5 2.9 12.3 1.8 3.4 5.2 4.8 8.6 6 2.2.8 3.4 2.6 3.7 4.9H14.4s-2.2-.8-2.2-5.3c-.1-.1-.1-46.9-.1-47.1z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.4 31.6V14.7c0-1.5-1.2-2.7-2.7-2.7H14.8c-1.5 0-2.7 1.2-2.7 2.7v68.9c0 1.5 1.2 2.7 2.7 2.7h42.9c1.5 0 2.7-1.2 2.7-2.7V72.4M66.9 57.7H46.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.2 65.4-7.7-7.7 7.7-7.7M21.3 52.8h15.8M21.3 63.8h15.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.6 38.6v-4.8l-.7-.2c-2.5-.6-3.7-1.9-3.7-3.9 0-2.6 1.9-4.3 4.5-4.5v-1.8h1.7v1.9c2.2.3 4.1 1.7 4.3 4.3h-2.4c-.1-1.1-.7-2-1.9-2.3v4.5l1 .2c2.2.5 3.6 1.9 3.6 4.1 0 2.7-1.8 4.3-4.6 4.5v2.2h-1.7v-2.2c-2.8-.3-4.7-2-4.8-4.8h2.5c.1 1.4.8 2.5 2.2 2.8zm.1-7.1v-4.2c-1.4.2-2.1 1.1-2.1 2.2-.1.9.5 1.6 2.1 2zm1.6 2.7v4.4c1.4-.2 2.3-1.1 2.3-2.3 0-1-.6-1.7-2.3-2.1.1 0 0 0 0 0z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.9 91.9h23.2c1.5 0 2.8-1.2 2.8-2.7v-67c0-1.5-1.2-2.7-2.8-2.7H65.9M79.7 44.7H59.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m72.1 52.3 7.6-7.6-7.6-7.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Compare104 = (Compare104);
;// ./src/Picto/GeneratedPictoComponents/Compare56.tsx


var Compare56_excluded = ["className"];
function Compare56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Compare56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Compare56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Compare56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Compare56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Compare56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Compare56_objectSpread(Compare56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M6.5 18.3c0-.2 1 .3 1.1.4.6.3.9.6 1.1 1.2 1 2 .7 4.2.6 6.3-.1 2.6.1 5.2.4 7.7.3 2.2.5 4.6 1.5 6.6.9 1.8 2.8 2.6 4.6 3.2 1.2.4 1.8 1.4 2 2.6H7.7s-1.2-.4-1.2-2.8V18.3z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.5 17V7.9c0-.8-.6-1.4-1.4-1.4H8c-.8 0-1.4.7-1.4 1.4V45c0 .8.7 1.4 1.4 1.4h23.1c.8 0 1.4-.7 1.4-1.4v-6M36 31.1H25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.2 35.2 25 31.1l4.2-4.1M11.5 28.4H20M11.5 34.4H20"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M13.2 20.6v-2.4l-.3-.1c-1.2-.3-1.9-1-1.9-2 0-1.3 1-2.1 2.2-2.2V13h.8v.9c1.1.1 2 .9 2.2 2.2H15c-.1-.6-.4-1-.9-1.1v2.3l.5.1c1.1.3 1.8.9 1.8 2 0 1.4-.9 2.2-2.3 2.3v1.1h-.8v-1.1c-1.4-.1-2.3-1-2.4-2.4h1.2c0 .6.4 1.1 1.1 1.3zm0-3.6v-2.1c-.7.1-1.1.6-1.1 1.1.1.5.4.8 1.1 1zm.9 1.4v2.2c.7-.1 1.1-.5 1.1-1.1 0-.6-.3-.9-1.1-1.1z",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.5 49.5H48c.8 0 1.5-.7 1.5-1.5V12c0-.8-.7-1.5-1.5-1.5H35.5M42.9 24.1h-11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.8 28.2 4.1-4.1-4.1-4.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Compare56 = (Compare56);
;// ./src/Picto/GeneratedPictoComponents/Download104.tsx


var Download104_excluded = ["className"];
function Download104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Download104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Download104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Download104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Download104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Download104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Download104_objectSpread(Download104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 61v27c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M40 90h12M44 14h4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.75 46.12v9.33h-35.5v-9.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.32 39.71 69 48.03l-8.32-8.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 28.06v19.97"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Download104 = (Download104);
;// ./src/Picto/GeneratedPictoComponents/Download56.tsx


var Download56_excluded = ["className"];
function Download56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Download56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Download56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Download56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Download56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Download56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Download56_objectSpread(Download56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 34v13c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v2M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.71 24.83v5.03H27.59v-5.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.63 21.38-4.48 4.48-4.48-4.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.15 15.11v10.75"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Download56 = (Download56);
;// ./src/Picto/GeneratedPictoComponents/Edit104.tsx


var Edit104_excluded = ["className"];
function Edit104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Edit104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Edit104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Edit104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Edit104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Edit104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Edit104_objectSpread(Edit104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M92.24 30.77c4.4-4.4-.48-10.96-4.24-14.75-3.79-3.76-10.35-8.64-14.75-4.24l-4.49 4.49 18.98 18.98 4.49-4.49Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m87.75 35.26 4.49-4.49c4.4-4.4-.48-10.96-4.24-14.75-3.79-3.76-10.35-8.64-14.75-4.24l-4.49 4.49",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M82.26 29.77 30.45 82.56s-9.11 7.6-19.7 10.77 24.7-5.77 24.7-5.77l52.3-52.29-5.5-5.5Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.41 86.1 6.51 6.51-7.84 1.34 1.33-7.85z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.76 35.26-52.31 52.3c-12.83 4.99-25.37 6.4-25.37 6.4s1.41-12.54 6.4-25.37l52.29-52.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.48 68.58 18.97 18.98M68.49 26.53 21.46 73.56M77.48 35.53 30.45 82.56M64.28 20.76l18.98 18.98 4.49-4.47-18.98-18.99-4.49 4.48z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Edit104 = (Edit104);
;// ./src/Picto/GeneratedPictoComponents/Edit56.tsx


var Edit56_excluded = ["className"];
function Edit56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Edit56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Edit56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Edit56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Edit56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Edit56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Edit56_objectSpread(Edit56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.41 16.9c2.31-2.31-.25-5.74-2.22-7.73-1.99-1.97-5.42-4.53-7.73-2.22L37.11 9.3l9.95 9.95 2.35-2.35Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m47.06 19.25 2.35-2.35c2.31-2.31-.25-5.74-2.22-7.73-1.99-1.97-5.42-4.53-7.73-2.22L37.11 9.3",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.18 16.37 17.02 44.04s-4.78 3.98-10.33 5.65c-5.55 1.66 12.95-3.02 12.95-3.02l27.42-27.41-2.88-2.88Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m7.04 45.9 3.41 3.41-4.1.7.69-4.11z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.06 19.25 19.64 46.66c-6.73 2.61-13.3 3.35-13.3 3.35s.74-6.57 3.35-13.3L37.1 9.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.7 36.72 9.94 9.94M36.96 14.67 12.31 39.33M41.68 19.39 17.02 44.04M34.75 11.65l9.95 9.95 2.36-2.35-9.95-9.95-2.36 2.35z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Edit56 = (Edit56);
;// ./src/Picto/GeneratedPictoComponents/Home104.tsx


var Home104_excluded = ["className"];
function Home104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Home104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Home104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Home104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Home104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Home104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Home104_objectSpread(Home104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.89 91.59.39-4.83c.01-.13.12-.22.25-.21l4.18.33c1.67.13 3.31.56 4.8 1.32 2.28 1.16 5.11 2.18 8.47 3.03.53.13.44.91-.11.9l-17.53-.08c-.26 0-.46-.22-.44-.47Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "43.71",
      cy: "72.73",
      r: "1.84",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.89 56.15h18.43v31.33H29.89z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.04 87.47h22.11V93H28.04z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.09 11.76c1-.96 2.54-1.02 3.61-.18l.21.18 40.54 38.7c1.1 1.05 1.14 2.8.09 3.91a2.756 2.756 0 0 1-3.69.28l-.21-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21 40.54-38.7ZM59.02 59.45c1.71 6.11 4.99 10.41 9.86 12.91 1.09.56.69 2.21-.54 2.21H58.28V59.55c0-.44.62-.52.74-.09Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.17 49.29V93H18.91v-3.33l-.08-40.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.53 56.15h18.43v18.43H57.53zM11.46 93h81.08M23.76 36.85V19.3h9.59v8.46l-9.59 9.09z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.09 11.76c1-.96 2.54-1.02 3.61-.18l.21.18 40.54 38.7c1.1 1.05 1.14 2.8.09 3.91a2.756 2.756 0 0 1-3.69.28l-.21-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21 40.54-38.7Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Home104 = (Home104);
;// ./src/Picto/GeneratedPictoComponents/Home56.tsx


var Home56_excluded = ["className"];
function Home56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Home56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Home56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Home56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Home56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Home56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Home56_objectSpread(Home56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m15.46 49.51.18-2.31a.27.27 0 0 1 .29-.25l2.08.16c.98.08 1.92.36 2.8.79.95.47 2.07.89 3.36 1.26.44.13.34.77-.11.77l-8.22-.02c-.22 0-.4-.19-.38-.41Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "23.96",
      cy: "39.13",
      r: "1",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.46 30.13h10v17h-10zM15.46 47.13h12v3h-12z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.42 6.04c.54-.52 1.38-.55 1.96-.1l.11.1 22 21c.6.57.62 1.52.05 2.12-.54.56-1.4.62-2 .15l-.12-.1L28.46 9.2 7.49 29.21c-.56.54-1.43.55-2.01.06l-.11-.11c-.54-.56-.55-1.43-.06-2.01l.11-.11 22-21ZM32.35 32.21c.91 3.03 2.55 5.21 4.94 6.55.67.37.42 1.37-.34 1.37h-5.01s-.07-.03-.07-.07v-7.78c0-.28.4-.35.48-.08Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.46 26.41v23.72H10.5v-1.81l-.04-21.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.46 30.13h10v10h-10zM6.46 50.13h44M13.13 19.66v-9.53h5.21v4.6l-5.21 4.93z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.42 6.04c.54-.52 1.38-.55 1.96-.1l.11.1 22 21c.6.57.62 1.52.05 2.12-.54.56-1.4.62-2 .15l-.12-.1L28.46 9.2 7.49 29.21c-.56.54-1.43.55-2.01.06l-.11-.11c-.54-.56-.55-1.43-.06-2.01l.11-.11 22-21Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Home56 = (Home56);
;// ./src/Picto/GeneratedPictoComponents/IOTUpdate104.tsx


var IOTUpdate104_excluded = ["className"];
function IOTUpdate104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IOTUpdate104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IOTUpdate104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IOTUpdate104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IOTUpdate104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOTUpdate104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOTUpdate104_objectSpread(IOTUpdate104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.95 61.24c0-2.83-6.78-4.47-9.61-4.47l-9.91-.7a12.75 12.75 0 0 1-11.98-8.54c-1.78-5.1-.14-10.76 4.07-14.14a5.149 5.149 0 0 0 2.01-3.37c.3-2.41 1.16-6.22 3.81-8.02 2.65-2.15 5.88-3.46 9.28-3.75 2.01 0 2.49 1.2 5.53 1.72 3.39.6 6.46-4.13-.98-6.96A22.626 22.626 0 0 0 38.29 11a17.27 17.27 0 0 0-12.41 4.99 17.748 17.748 0 0 0-5.29 12.45v.98a16.847 16.847 0 0 0-8.4 18.99c1.9 7.51 8.67 12.75 16.42 12.71h25.33v.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.29 30.27s-1.14 1.86.16 2.75c1.3.88 7.12 2.93 7.88 8.02.62 4.01 3.09 5.23 3.79 4.57.7-.66 1.18-4.93-3.23-9.4a25.71 25.71 0 0 0-8.6-5.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.94 20.35s1 2.33 2.71 2.01c1.7-.32 8.94-3.73 13.42-.12 3.53 2.83 6.42 2.01 6.5.86.08-1.14-2.79-4.95-9.71-5.27-4.44-.1-8.84.77-12.91 2.53Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.28 82.72c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.98 90.81c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.06 86.02c-.21.04-.42.06-.63.07a3.175 3.175 0 0 1-3.11-3.85c.13-.3 0-.4-.37-.3a3.2 3.2 0 0 0-1.28 3.01 3.182 3.182 0 0 0 5.72 1.44c.11-.34-.03-.44-.33-.37Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.32 83.25 2.35-1.12.3-.16a9.6 9.6 0 0 0 4.41-8.14V61.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.15",
        cy: "84.14",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68 61.36v9.47a9.624 9.624 0 0 0 4.41 8.14l.3.16 2.49 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "79.21",
        cy: "81.07",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.08",
        cy: "88.99",
        r: "4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.88 61.72v22.66"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.11 61.26h3.51c8.05.2 14.88-5.86 15.62-13.88.75-8.02-4.85-15.24-12.8-16.52-.9-5.52-4.61-10.17-9.79-12.28s-11.08-1.37-15.58 1.96a17.488 17.488 0 0 0-15.38-9.4c-4.64-.07-9.11 1.73-12.41 4.99a17.748 17.748 0 0 0-5.29 12.45v.98a16.847 16.847 0 0 0-8.4 18.99c1.9 7.51 8.67 12.75 16.42 12.71h34.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.03 23.07c-.89-2.87-2.49-5.37-4.57-7.34"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOTUpdate104 = (IOTUpdate104);
;// ./src/Picto/GeneratedPictoComponents/IOTUpdate56.tsx


var IOTUpdate56_excluded = ["className"];
function IOTUpdate56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IOTUpdate56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IOTUpdate56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IOTUpdate56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IOTUpdate56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOTUpdate56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOTUpdate56_objectSpread(IOTUpdate56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.04 32.96c0-1.52-3.64-2.4-5.15-2.4l-5.32-.38a6.844 6.844 0 0 1-6.43-4.58 6.815 6.815 0 0 1 2.19-7.58c.58-.44.97-1.09 1.08-1.81.16-1.29.62-3.34 2.04-4.3a9.128 9.128 0 0 1 4.98-2.01c1.08 0 1.33.65 2.97.93 1.82.32 3.46-2.22-.53-3.73a12.17 12.17 0 0 0-4.23-1.08c-2.49-.04-4.89.93-6.66 2.68a9.557 9.557 0 0 0-2.84 6.68v.53a9.035 9.035 0 0 0 4.3 17.01h13.59v.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.64 16.34s-.61 1 .09 1.47 3.82 1.57 4.23 4.3c.33 2.15 1.66 2.81 2.03 2.45.38-.36.63-2.65-1.73-5.05-1.3-1.37-2.87-2.45-4.62-3.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.51 11.02s.54 1.25 1.45 1.08c.91-.17 4.8-2 7.2-.06 1.89 1.52 3.44 1.08 3.49.46.04-.61-1.5-2.66-5.21-2.83-2.38-.05-4.74.41-6.93 1.36Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.71 44.5c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.2 48.76c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.67 46.17c-.11.02-.23.04-.34.04a1.73 1.73 0 0 1-1.69-2.09c.07-.16 0-.22-.2-.16-.51.37-.79 1-.7 1.64a1.74 1.74 0 0 0 3.12.79c.06-.19-.01-.24-.18-.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.83 44.77 1.26-.6.16-.09c1.48-.96 2.38-2.6 2.37-4.37v-6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.59 33.02v5.08c0 1.77.88 3.41 2.37 4.37l.16.09 1.33.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.59",
        cy: "45.24",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.6",
        cy: "43.6",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.04",
        cy: "47.85",
        r: "2.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.94 33.21v12.16"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.33 32.97h1.89a8.21 8.21 0 0 0 8.38-7.45c.4-4.3-2.6-8.18-6.87-8.87a8.602 8.602 0 0 0-5.25-6.59 8.617 8.617 0 0 0-8.36 1.05 9.4 9.4 0 0 0-8.25-5.05c-2.49-.04-4.89.93-6.66 2.68a9.557 9.557 0 0 0-2.84 6.68v.53a9.035 9.035 0 0 0 4.3 17.01h18.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.63 12.48a9.28 9.28 0 0 0-1.21-2.49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOTUpdate56 = (IOTUpdate56);
;// ./src/Picto/GeneratedPictoComponents/PhoneSound104.tsx


var PhoneSound104_excluded = ["className"];
function PhoneSound104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PhoneSound104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PhoneSound104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PhoneSound104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PhoneSound104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PhoneSound104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PhoneSound104_objectSpread(PhoneSound104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.39 52.39c3.91-3.91 3.91-10.24 0-14.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.43 56.43c6.14-6.14 6.14-16.09 0-22.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.47 60.47c8.37-8.37 8.37-21.94 0-30.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.08 65.87c11.35-11.35 11.35-29.75 0-41.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 67v21c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v8M44 14h4M40 90h12"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PhoneSound104 = (PhoneSound104);
;// ./src/Picto/GeneratedPictoComponents/PhoneSound56.tsx


var PhoneSound56_excluded = ["className"];
function PhoneSound56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PhoneSound56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PhoneSound56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PhoneSound56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PhoneSound56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PhoneSound56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PhoneSound56_objectSpread(PhoneSound56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 36v11c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v4M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.23 28.2a5.233 5.233 0 0 0 0-7.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.35 30.32c3.21-3.22 3.21-8.43 0-11.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.47 32.44c4.38-4.38 4.38-11.49 0-15.88"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.36 35.26c5.95-5.95 5.95-15.58 0-21.53"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PhoneSound56 = (PhoneSound56);
;// ./src/Picto/GeneratedPictoComponents/Pin104.tsx


var Pin104_excluded = ["className"];
function Pin104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Pin104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Pin104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Pin104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Pin104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Pin104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Pin104_objectSpread(Pin104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "29.74",
        y: "16.3",
        width: "43.33",
        height: "71.67",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M29.74 87.97h43.33V16.3H29.74v71.67z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "28.55",
        y: "16.3",
        width: "43.33",
        height: "71.67",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M28.55 87.97h43.34V16.3H28.55v71.67z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "30.93",
        y: "16.3",
        width: "43.33",
        height: "71.67",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M30.93 87.97h43.33V16.3H30.93v71.67z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "32.11",
        y: "16.3",
        width: "43.33",
        height: "71.67",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M32.11 87.97h43.34V16.3H32.11v71.67z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "27.53",
        y: "11.06",
        width: "48.94",
        height: "80.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M27.53 92h48.94V11.06H27.53V92z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "27.53",
        y: "11.06",
        width: "48.94",
        height: "80.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M27.53 92h48.94V11.06H27.53V92z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "27.53",
        y: "11.06",
        width: "48.94",
        height: "80.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M27.53 92h48.94V11.06H27.53V92z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "27.53",
        y: "11.06",
        width: "48.94",
        height: "80.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M27.53 92h48.94V11.06H27.53V92z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.11 56.65c-.04-.2-.33-.2-.35.01-.16 1.95-.34 4.84.07 4.84h2.86c.47 0 .64-.61.24-.86-1.12-.7-2.36-1.91-2.82-3.99ZM44.62 56.65c-.04-.2-.33-.2-.35.01-.16 1.95-.34 4.84.07 4.84h2.86c.47 0 .64-.61.24-.86-1.12-.7-2.36-1.91-2.82-3.99ZM54.95 56.65c-.04-.2-.33-.2-.35.01-.16 1.95-.34 4.84.07 4.84h2.86c.47 0 .64-.61.24-.86-1.12-.7-2.36-1.91-2.82-3.99ZM65.25 56.65c-.04-.2-.33-.2-.35.01-.16 1.95-.34 4.84.07 4.84h2.86c.47 0 .64-.61.24-.86-1.12-.7-2.36-1.91-2.82-3.99Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.61-13.98-18.64-27.49-.59-3.37 2.04-15.82-4.17-14.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91ZM54.91 44.55c-2.35.09-5.65-1.86-7.61-4.19-.48.72-.82 1.55-.94 2.44 1.39 1.39 3.15 2.46 5.22 2.59.29.02.57-.01.85-.06.87-.15 2.71-.52 2.47-.78ZM53.26 37.29c.07-.04.04-.15-.04-.16-1.33-.14-2.55-1.44-2.71-2.74-.01-.11-.15-.14-.21-.05 0 0-1.31 1.66-1.11 2.21.16.46-.02.05-.02.07.05.93 3.43 1.32 3.43 1.32l.66-.66Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.07 56.82a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.72 56.82a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.43 56.82a1.25 1.25 0 1 0-2.5 0 1.25 1.25 0 0 0 2.5 0"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M67.53 58.07a1.25 1.25 0 1 1 0-2.5 1.25 1.25 0 0 1 0 2.5"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "53.88",
        y: "51.65",
        width: "6.59",
        height: "10.35",
        rx: "1",
        ry: "1",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "43.53",
        y: "51.65",
        width: "6.59",
        height: "10.35",
        rx: "1",
        ry: "1",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.18",
        y: "51.65",
        width: "6.59",
        height: "10.35",
        rx: "1",
        ry: "1",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "64.24",
        y: "51.65",
        width: "6.59",
        height: "10.35",
        rx: "1",
        ry: "1",
        className: "stroke"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "29",
          y: "10",
          width: "46",
          height: "84",
          rx: "6",
          ry: "6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50 14h4M46 90h12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M57.85 43.5c-.4-2.83-2.84-5.01-5.78-5.01s-5.38 2.18-5.78 5.01"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60 38c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.82 35.65c0 1.56-1.26 2.82-2.82 2.82s-2.82-1.26-2.82-2.82 1.26-2.82 2.82-2.82 2.82 1.26 2.82 2.82Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Pin104 = (Pin104);
;// ./src/Picto/GeneratedPictoComponents/Pin56.tsx


var Pin56_excluded = ["className"];
function Pin56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Pin56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Pin56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Pin56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Pin56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Pin56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Pin56_objectSpread(Pin56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "16.53",
        y: "10.47",
        width: "22.94",
        height: "37.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M16.53 48.41h22.94V10.47H16.53v37.94z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "16.53",
        y: "10.47",
        width: "22.94",
        height: "37.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M16.53 48.41h22.94V10.47H16.53v37.94z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "16.53",
        y: "10.47",
        width: "22.94",
        height: "37.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M16.53 48.41h22.94V10.47H16.53v37.94z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "16.53",
        y: "10.47",
        width: "22.94",
        height: "37.94",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M16.53 48.41h22.94V10.47H16.53v37.94z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "17.43",
        y: "12.58",
        width: "20.66",
        height: "34.17",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M17.43 46.74h20.66V12.58H17.43v34.16z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "16.95",
        y: "12.58",
        width: "20.66",
        height: "34.17",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M16.95 46.74H37.6V12.58H16.95v34.16z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "17.91",
        y: "12.58",
        width: "20.66",
        height: "34.17",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M17.91 46.74h20.66V12.58H17.91v34.16z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "18.4",
        y: "12.58",
        width: "20.66",
        height: "34.17",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M18.4 46.74h20.65V12.58H18.4v34.16z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.98 47.08c-1.51-.97-3.38-1.05-4.96-1.92-6.75-3.53-8.43-7.09-9.46-13.95-.3-1.71 1.04-8.03-2.12-7.54v22.57c0 2.12 1.72 3.84 3.84 3.84h14.43c.1-1.21-.7-2.35-1.72-3ZM29.81 26.07c-1.85-.48-3.67-1.26-4.9-2.73-.3.45-.51.97-.59 1.53.87.87 1.98 1.55 3.28 1.63.18.01.36 0 .54-.04.54-.1 1.82-.23 1.68-.4ZM28.95 21.26c.06-.04.03-.12-.03-.13-1.02-.12-1.95-1.18-2.07-2.25-.01-.09-.11-.12-.16-.04 0 0-.64.63-.49 1.09.12.38.54 1.29.56 1.3 1.38.74 1.69.58 1.69.58l.51-.54Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40 35.92v11c0 1.66-1.34 3-3 3H19c-1.66 0-3-1.34-3-3v-38c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v27ZM27 7.92h2M25 47.92h6"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.77 24.92c-.26-1.82-1.83-3.23-3.73-3.23s-3.46 1.4-3.72 3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.16 21.38a5.15 5.15 0 1 1-10.298.002 5.15 5.15 0 0 1 10.298-.002Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.83 19.86a1.82 1.82 0 1 1-3.64 0 1.82 1.82 0 0 1 3.64 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.6 31.72c-.02-.1-.17-.1-.17 0-.08.97-.17 2.41.03 2.41h1.43c.24 0 .32-.31.12-.43-.56-.35-1.18-.95-1.41-1.99ZM24.37 31.72c-.02-.1-.17-.1-.17 0-.08.97-.17 2.41.03 2.41h1.43c.24 0 .32-.31.12-.43-.56-.35-1.18-.95-1.41-1.99ZM29.26 31.72c-.02-.1-.17-.1-.17 0-.08.97-.17 2.41.03 2.41h1.43c.24 0 .32-.31.12-.43-.56-.35-1.18-.95-1.41-1.99ZM34.16 31.72c-.02-.1-.17-.1-.17 0-.08.97-.17 2.41.03 2.41h1.43c.24 0 .32-.31.12-.43-.56-.35-1.18-.95-1.41-1.99Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.88",
        y: "29.5",
        width: "3.09",
        height: "4.85",
        rx: ".47",
        ry: ".47",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.03",
        y: "29.5",
        width: "3.09",
        height: "4.85",
        rx: ".47",
        ry: ".47",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "19.18",
        y: "29.5",
        width: "3.09",
        height: "4.85",
        rx: ".47",
        ry: ".47",
        className: "stroke"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.74",
        y: "29.5",
        width: "3.09",
        height: "4.85",
        rx: ".47",
        ry: ".47",
        className: "stroke"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.17 31.89c0-.33-.27-.6-.6-.6s-.6.27-.6.6.27.6.6.6.6-.27.6-.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.32 31.89c0-.33-.27-.6-.6-.6s-.6.27-.6.6.27.6.6.6.6-.27.6-.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.02 31.89c0-.33-.27-.6-.6-.6s-.6.27-.6.6.27.6.6.6.6-.27.6-.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.28 32.49c-.33 0-.6-.27-.6-.6s.27-.6.6-.6.6.27.6.6-.27.6-.6.6"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Pin56 = (Pin56);
;// ./src/Picto/GeneratedPictoComponents/Preferences104.tsx


var Preferences104_excluded = ["className"];
function Preferences104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Preferences104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Preferences104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Preferences104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Preferences104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Preferences104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Preferences104_objectSpread(Preferences104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M47.78 56.14s-1.09 1.87.02 2.36 6.5-.97 6.94 2.06-.5 4.65.35 5.18 2.37 0 2.37 0l1.45-4.27-.49-4.08-2.47-2.2-4.07-.75-4.09.73-.02.96Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.37 67.81v8.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.37 26.44v27.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.39 60.78c0 3.88-3.14 7.03-7.02 7.03s-7.02-3.15-7.02-7.03 3.15-7.02 7.02-7.02 7.02 3.15 7.02 7.02Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.48 50.27c0-.77 1.51-1.85 2.16-1.92 3.8-.41 3.01 14.49 3.69 17.2 1.18 4.72 2.26 10.25 5.71 13.92 3.14 3.34 7.68 4.88 12.13 5.41 3.83.45 10.62-.34 14.6.42 4.47.85 5.72 5.71-.11 5.71H22.4s-9.46-6.23-9.46-12.86c0 0 .54-27.38.54-27.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.61 42.92s-1.09 1.87.02 2.36 6.5-.97 6.94 2.06c.45 3.03-.5 4.65.35 5.18s2.37 0 2.37 0l1.45-4.27-.49-4.08-2.47-2.2-4.07-.75-4.09.73-.02.96ZM68.6 35.45s-1.09 1.87.02 2.36 6.5-.97 6.94 2.06-.5 4.65.35 5.18 2.37 0 2.37 0l1.45-4.27-.49-4.08-2.47-2.2-4.07-.75-4.09.73-.02.96Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.71 55.28v20.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.71 26.5v14.72"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.08 46.56v29.68"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.08 26.5v7.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M79.4 40.23a6.32 6.32 0 1 1-12.641-.001 6.32 6.32 0 0 1 12.641.001Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.74 48.25c0 3.88-3.14 7.03-7.03 7.03s-7.03-3.15-7.03-7.03 3.15-7.03 7.03-7.03 7.03 3.14 7.03 7.03Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "12.46",
          y: "13",
          width: "79.08",
          height: "77.87",
          rx: "14.6",
          ry: "14.6"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Preferences104 = (Preferences104);
;// ./src/Picto/GeneratedPictoComponents/Preferences56.tsx


var Preferences56_excluded = ["className"];
function Preferences56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Preferences56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Preferences56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Preferences56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Preferences56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Preferences56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Preferences56_objectSpread(Preferences56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.03 30.1s-.58 1 .01 1.26 3.48-.52 3.72 1.1-.27 2.49.19 2.77 1.27 0 1.27 0l.77-2.28-.26-2.18-1.32-1.18-2.18-.4-2.19.39v.52Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.33 36.35v4.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.33 14.81v14.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.99 32.69c0 2.02-1.64 3.66-3.66 3.66s-3.66-1.64-3.66-3.66 1.64-3.66 3.66-3.66 3.66 1.64 3.66 3.66Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.82 27.24c0-.39.79-.94 1.13-.98 1.98-.21 1.57 7.39 1.93 8.77.62 2.4 1.18 5.22 2.99 7.09 1.64 1.7 4.01 2.49 6.34 2.76 2 .23 5.55-.17 7.63.21 2.34.43 2.99 2.91-.06 2.91h-15.3s-4.95-3.18-4.95-6.56c0 0 .28-13.96.28-14.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.21 23.42s-.57.98.01 1.23 3.4-.51 3.63 1.08-.26 2.43.18 2.71 1.24 0 1.24 0l.76-2.23-.26-2.13-1.29-1.15-2.13-.39-2.14.38v.5ZM36.64 19.51s-.57.98.01 1.23 3.4-.51 3.63 1.08-.26 2.43.18 2.71 1.24 0 1.24 0l.76-2.23-.26-2.13-1.29-1.15-2.13-.39-2.14.38v.5Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.57 29.73v10.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.57 14.81v7.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.02 25.21v15.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.02 14.81v3.84"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.3 21.93c0 1.81-1.47 3.28-3.28 3.28s-3.28-1.47-3.28-3.28 1.47-3.28 3.28-3.28 3.28 1.47 3.28 3.28Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.21 26.09a3.64 3.64 0 1 1-7.28 0 3.64 3.64 0 0 1 7.28 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "7.58",
          y: "7.81",
          width: "41.02",
          height: "40.39",
          rx: "7.57",
          ry: "7.57"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Preferences56 = (Preferences56);
;// ./src/Picto/GeneratedPictoComponents/Profile104.tsx


var Profile104_excluded = ["className"];
function Profile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Profile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Profile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Profile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Profile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Profile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Profile104_objectSpread(Profile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.65 55.43c2.13.33 4.19.14 6.08-.46 1-.32.98-1.86-.01-2.17-7.52-2.39-13.48-8.78-15.77-16.9-.33-1.17-1.88-1.2-2.17-.01-.49 1.97-.63 4.09-.35 6.28.88 6.82 5.94 12.31 12.22 13.27ZM26.18 70.7c-1.8 3.23-3.04 6.81-3.59 10.61A43.462 43.462 0 0 0 53.36 94c4.33 0 8.51-.63 12.46-1.81 1.09-.32.99-1.91-.13-2.09-14.31-2.37-26.99-9.51-36.34-19.74-.9-.98-2.52-.83-3.17.34Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "41",
        r: "15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.68 81.72C79.6 67.18 67.1 56 51.99 56S24.39 67.17 22.3 81.7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "42",
        className: "strokeprimary"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Profile104 = (Profile104);
;// ./src/Picto/GeneratedPictoComponents/Profile56.tsx


var Profile56_excluded = ["className"];
function Profile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Profile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Profile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Profile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Profile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Profile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Profile56_objectSpread(Profile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.05 29.82c1.11.16 2.19.07 3.18-.23.52-.16.51-.93 0-1.09-3.93-1.19-7.04-4.38-8.24-8.44-.17-.58-.98-.6-1.13 0a8.19 8.19 0 0 0-.18 3.14c.46 3.4 3.1 6.15 6.39 6.63ZM14.73 37.74c-.95 1.7-1.6 3.58-1.89 5.58C16.98 47.45 22.7 50 29.02 50c2.28 0 4.48-.33 6.55-.95.57-.17.52-1-.07-1.1-7.53-1.25-14.2-5-19.11-10.38-.47-.52-1.33-.43-1.67.18Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.01",
        cy: "22.66",
        r: "7.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.17 43.47C42.11 36.04 35.72 30.33 28 30.33s-14.1 5.7-15.17 13.13"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "22",
        className: "strokeprimary"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Profile56 = (Profile56);
;// ./src/Picto/GeneratedPictoComponents/ProfileCompletion104.tsx


var ProfileCompletion104_excluded = ["className"];
function ProfileCompletion104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProfileCompletion104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProfileCompletion104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProfileCompletion104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ProfileCompletion104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ProfileCompletion104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ProfileCompletion104_objectSpread(ProfileCompletion104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.56 71.96c-.28 4.69.46 13.43 8.54 19.1.68.47.17 1.55-.62 1.34-3.16-.82-7.47-2.95-9.56-8.46 0 0-2.54-6.46.22-12.36.35-.74 1.47-.43 1.42.38Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "78.2",
        cy: "78.04",
        r: "14.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m70.76 78.57 4.61 4.61L85.65 72.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.91 55.74c2.16.3 4.23.13 6.14-.43 1.01-.29 1-1.73-.01-2.03-7.61-2.23-13.62-8.18-15.95-15.74-.33-1.09-1.9-1.11-2.19-.01-.49 1.83-.64 3.81-.35 5.85.89 6.35 6.01 11.47 12.36 12.36ZM26.43 70.87a28.556 28.556 0 0 0-3.32 9.85C30.39 88 40.45 92.5 51.56 92.5c4 0 7.87-.59 11.52-1.68 1-.3.91-1.77-.12-1.94-13.23-2.2-24.96-8.83-33.6-18.33-.83-.91-2.33-.77-2.93.31Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.79 91.13A40.95 40.95 0 0 1 52 92.86c-22.56 0-40.86-18.29-40.86-40.86S29.44 11.14 52 11.14 92.86 29.43 92.86 52c0 4.18-.63 8.21-1.79 12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "41.3",
        r: "14.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.79 61.21a29.062 29.062 0 0 0-16.8-5.32c-14.7 0-26.85 10.86-28.88 25"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ProfileCompletion104 = (ProfileCompletion104);
;// ./src/Picto/GeneratedPictoComponents/ProfileCompletion56.tsx


var ProfileCompletion56_excluded = ["className"];
function ProfileCompletion56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ProfileCompletion56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ProfileCompletion56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ProfileCompletion56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ProfileCompletion56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ProfileCompletion56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ProfileCompletion56_objectSpread(ProfileCompletion56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.73 38.74c-.15 2.52.25 7.23 4.6 10.28.36.25.09.83-.34.72-1.7-.44-4.02-1.59-5.15-4.55 0 0-1.37-3.48.12-6.66.19-.4.79-.23.77.21Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.95",
        cy: "42.08",
        r: "8.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.94 42.36 2.48 2.48 5.53-5.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.88 30.02c1.16.16 2.28.07 3.31-.23.54-.16.54-.93 0-1.09-4.1-1.2-7.34-4.4-8.59-8.48-.18-.59-1.02-.6-1.18 0-.27.99-.34 2.05-.19 3.15.48 3.42 3.23 6.17 6.65 6.65ZM14.23 38.16c-.9 1.61-1.51 3.4-1.79 5.3 3.92 3.92 9.34 6.35 15.32 6.35 2.16 0 4.24-.32 6.2-.9.54-.16.49-.95-.06-1.05a31.476 31.476 0 0 1-18.09-9.87c-.45-.49-1.26-.41-1.58.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.35 49.07c-2.01.6-4.14.93-6.35.93-12.15 0-22-9.85-22-22S15.85 6 28 6s22 9.85 22 22c0 2.25-.34 4.42-.96 6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "22.24",
        r: "7.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.04 32.96a15.615 15.615 0 0 0-9.05-2.87c-7.91 0-14.46 5.85-15.55 13.46"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ProfileCompletion56 = (ProfileCompletion56);
;// ./src/Picto/GeneratedPictoComponents/Search104.tsx


var Search104_excluded = ["className"];
function Search104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Search104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Search104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Search104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Search104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Search104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Search104_objectSpread(Search104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.13 58.87s7.48 8.27 7.48 17.48c0 7.72 12.68 15.55 12.68 15.55l-5.35 1.93-24.46-24.9 9.65-10.06Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.48 68.93 20.68 22.03c2.35 2.75 5.79 3.68 7.76 2.11 1.16-.93 2.48-2.08 3.74-3.42 1.26-1.34 2.35-2.73 3.23-3.96 1.49-2.09.61-5.74-1.99-8.23L68 56.39"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.81 64.39C46.83 74.51 21.8 68.56 12.07 48.17c-.54-1.14-2.28-.52-1.95.7 1.4 5.1 4.1 9.92 8.11 13.93 9.77 9.77 24.35 11.77 36.11 6.04l6.48-4.45Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.23 65.79c.88 0 1.59-1.59 0-1.75-16.02-1.68-26.31-31.17-14.91-43.69 0 0 0-1.04-.88-.39-6.75 4.99-13.58 9.05-9.42 27.88C20.18 66.68 41.23 65.8 41.23 65.8Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.62 22.4c10 10 10 26.22 0 36.22s-26.22 10-36.22 0-10-26.22 0-36.22 26.22-10 36.22 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.8 18.23c12.31 12.31 12.31 32.26 0 44.57-12.31 12.31-32.26 12.31-44.57 0-12.31-12.31-12.31-32.26 0-44.57 12.31-12.31 32.26-12.31 44.57 0Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Search104 = (Search104);
;// ./src/Picto/GeneratedPictoComponents/Search56.tsx


var Search56_excluded = ["className"];
function Search56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Search56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Search56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Search56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Search56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Search56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Search56_objectSpread(Search56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.44 33.1c-10.88 4.59-18.86 1.99-23.49-7.71-.26-.54-1.09-.25-.93.33.66 2.43 2.25 4.72 4.16 6.63 4.65 4.65 11.58 5.6 17.17 2.87l3.08-2.11Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.12 33.76c.42 0 .77-.76 0-.84-7.72-.81-12.67-15.01-7.18-21.04 0 0 0-.5-.42-.19-3.25 2.4-6.54 4.36-4.54 13.43s12.14 8.65 12.14 8.65Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.34 30.33s4.14 4.58 4.14 9.67c0 4.27 7.02 8.61 7.02 8.61l-2.96 1.07L29 35.9l5.34-5.57Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.87 35.54 11.59 12.35c1.32 1.54 3.25 2.07 4.35 1.18a19.781 19.781 0 0 0 3.9-4.14c.83-1.17.34-3.22-1.11-4.62L35.32 28.5"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.45 12.74c4.89 4.89 4.89 12.82 0 17.7-4.89 4.89-12.82 4.89-17.7 0-4.89-4.89-4.89-12.82 0-17.7 4.89-4.89 12.82-4.89 17.7 0Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.49 10.71c6.02 6.02 6.02 15.77 0 21.78-6.02 6.01-15.77 6.01-21.78 0-6.02-6.02-6.02-15.77 0-21.78 6.02-6.02 15.77-6.02 21.78 0Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Search56 = (Search56);
;// ./src/Picto/GeneratedPictoComponents/Services104.tsx


var Services104_excluded = ["className"];
function Services104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Services104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Services104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Services104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Services104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Services104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Services104_objectSpread(Services104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 67v21c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v8M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.08 59.97c.8-.7.27-1.99-.79-1.95-1.76.07-3.59-.12-5.43-.61-5.85-1.57-10.17-5.77-11.58-10.6-.12-.4-.71-.33-.71.08-.07 6.04 4.07 11.64 10.35 13.33 2.77.74 5.55.62 8.06-.2.03-.01.06-.02.08-.05h.01ZM72.22 51.68c.89-.34.59-1.66-.36-1.61s-1.9-.01-2.88-.28c-2.79-.75-4.98-2.6-6.2-4.94-.3-.57-1.16-.24-1.02.39.71 3.05 2.03 5.48 5.06 6.49 2.13.71 4.04.47 5.4-.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.15 30.16c8.37 0 15.15 6.78 15.15 15.15s-6.78 15.15-15.15 15.15S54 53.68 54 45.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.73 45.31c0 4.18-3.39 7.58-7.58 7.58s-7.58-3.39-7.58-7.58 3.39-7.58 7.58-7.58 7.58 3.39 7.58 7.58Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Services104 = (Services104);
;// ./src/Picto/GeneratedPictoComponents/Services56.tsx


var Services56_excluded = ["className"];
function Services56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Services56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Services56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Services56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Services56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Services56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Services56_objectSpread(Services56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 36v11c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v4M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.07 31.02c.1-.09.02-.25-.12-.22-1.42.3-2.97.27-4.52-.15-3.24-.87-5.63-3.19-6.41-5.87-.06-.22-.39-.19-.39.05-.04 3.35 2.25 6.45 5.74 7.38 1.53.41 3.08.34 4.46-.11.02 0 .03-.02.05-.03l1.2-1.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.85 27.17c.15-.16 0-.43-.22-.39-.8.14-1.58.18-2.41-.04a5.173 5.173 0 0 1-3.27-2.6c-.16-.3-.61-.13-.54.2.38 1.61.95 2.99 2.55 3.52 1.77.59 3.39-.17 3.88-.7Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.24 16.24c4.51 0 8.16 3.65 8.16 8.16s-3.65 8.16-8.16 8.16-8.16-3.65-8.16-8.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.32 24.4c0 2.25-1.83 4.08-4.08 4.08s-4.08-1.83-4.08-4.08 1.83-4.08 4.08-4.08 4.08 1.83 4.08 4.08Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Services56 = (Services56);
;// ./src/Picto/GeneratedPictoComponents/Settings104.tsx


var Settings104_excluded = ["className"];
function Settings104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Settings104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Settings104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Settings104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Settings104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Settings104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Settings104_objectSpread(Settings104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v5M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m65.17 31.23-.09-.09a2.982 2.982 0 0 0-4.21 0 2.982 2.982 0 0 0 0 4.21s.09.09.09.09c.7.72.9 1.79.49 2.71v.12c-.39.9-1.27 1.48-2.25 1.49h-.08c-1.56 0-2.97 1.12-3.13 2.67a2.976 2.976 0 0 0 2.96 3.28h.13c.98 0 1.86.59 2.25 1.49.41.92.21 1.99-.49 2.71l-.09.09a2.982 2.982 0 0 0 0 4.21 2.982 2.982 0 0 0 4.21 0s.09-.09.09-.09c.72-.7 1.79-.9 2.71-.49-7.56-7.06-2.59-22.39-2.59-22.39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.67 37.27a5.45 5.45 0 1 1 0 10.9c-3.01 0-5.46-2.44-5.46-5.45s2.44-5.45 5.46-5.45Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.67 47.19c-.41.92-.21 1.99.49 2.71l.09.09a2.982 2.982 0 0 1 0 4.21 2.982 2.982 0 0 1-4.21 0l-.09-.09c-.72-.7-1.79-.9-2.71-.49-.9.38-1.48 1.27-1.49 2.25v.25c0 1.64-1.33 2.97-2.97 2.97s-2.98-1.33-2.98-2.97v-.13c-.02-1.01-.66-1.9-1.61-2.25a2.47 2.47 0 0 0-2.71.49l-.09.09a2.982 2.982 0 0 1-4.21 0 2.982 2.982 0 0 1 0-4.21l.09-.09c.7-.72.9-1.79.49-2.71-.39-.9-1.27-1.48-2.25-1.49h-.25c-1.64 0-2.98-1.33-2.98-2.98s1.33-2.97 2.98-2.97h.13c1.01-.02 1.9-.66 2.25-1.61.41-.92.21-1.99-.49-2.71l-.09-.09a2.982 2.982 0 0 1 0-4.21 2.982 2.982 0 0 1 4.21 0l.09.09c.72.7 1.79.9 2.71.49h.12c.9-.39 1.48-1.27 1.49-2.25v-.25c0-1.64 1.33-2.98 2.98-2.98s2.97 1.33 2.97 2.98v.13c0 .98.59 1.86 1.49 2.25.92.41 1.99.21 2.71-.49l.09-.09a2.982 2.982 0 0 1 4.21 0 2.982 2.982 0 0 1 0 4.21l-.09.09c-.7.72-.9 1.79-.49 2.71v.12c.39.9 1.27 1.48 2.25 1.49h.25c1.64 0 2.98 1.33 2.98 2.98s-1.33 2.97-2.98 2.97h-.13c-.98 0-1.86.59-2.25 1.49Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Settings104 = (Settings104);
;// ./src/Picto/GeneratedPictoComponents/Settings56.tsx


var Settings56_excluded = ["className"];
function Settings56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Settings56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Settings56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Settings56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Settings56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Settings56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Settings56_objectSpread(Settings56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v2M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.04 16.77a1.6 1.6 0 0 0-2.27 0l-.03.03c-.62.62-.61 1.63.03 2.23s.05.05.05.05c.38.39.48.96.26 1.46v.06c-.21.48-.68.8-1.21.8h-.04c-.8 0-1.55.55-1.67 1.34-.16 1 .61 1.86 1.58 1.86h.07a1.337 1.337 0 0 1 .95 2.26 1.65 1.65 0 0 0-.21 2.08l.18.27c.54.81 1.73.79 2.25-.03s.05-.05.05-.05c.39-.38.96-.48 1.46-.26-3.87-3.61-1.64-11.26-1.41-12 .01-.04 0-.08-.03-.11Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.59 20.07c1.62 0 2.94 1.31 2.94 2.94s-1.31 2.94-2.94 2.94-2.94-1.31-2.94-2.94 1.32-2.94 2.94-2.94Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.52 25.41c-.22.49-.11 1.07.26 1.46l.05.05a1.6 1.6 0 0 1 0 2.27 1.6 1.6 0 0 1-2.27 0l-.05-.05c-.39-.38-.96-.48-1.46-.26-.48.21-.8.68-.8 1.21v.14c0 .88-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6v-.07c-.01-.54-.36-1.02-.87-1.21-.49-.22-1.07-.11-1.46.26l-.05.05a1.6 1.6 0 0 1-2.27 0 1.6 1.6 0 0 1 0-2.27l.05-.05c.38-.39.48-.96.26-1.46-.21-.48-.68-.8-1.21-.8h-.14c-.89 0-1.6-.72-1.6-1.6s.72-1.6 1.6-1.6h.07c.54-.01 1.02-.36 1.21-.87.22-.49.11-1.07-.26-1.46l-.05-.05a1.6 1.6 0 0 1 0-2.27 1.6 1.6 0 0 1 2.27 0l.05.05c.39.38.96.48 1.46.26h.06c.48-.21.8-.68.8-1.21v-.14c0-.88.72-1.6 1.6-1.6s1.6.72 1.6 1.6v.07a1.337 1.337 0 0 0 2.26.95l.05-.05a1.6 1.6 0 0 1 2.27 0 1.6 1.6 0 0 1 0 2.27l-.05.05c-.38.39-.48.96-.26 1.46v.06c.21.48.68.8 1.21.8h.14c.88 0 1.6.72 1.6 1.6s-.72 1.6-1.6 1.6h-.07c-.53 0-1 .32-1.21.8Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Settings56 = (Settings56);
;// ./src/Picto/GeneratedPictoComponents/Share104.tsx


var Share104_excluded = ["className"];
function Share104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Share104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Share104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Share104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Share104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Share104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Share104_objectSpread(Share104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.15 93.91c1.56-.01 1.88-2.08.41-2.53-7.72-2.4-12.43-9.1-14.3-15.43-.39-1.29-2.26-1.27-2.62.04-.63 2.33-.74 5.77 1.28 10.25 2.6 5.76 10.11 7.71 15.24 7.67h-.02Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.15 37.86c1.56-.01 1.88-2.08.41-2.53-7.72-2.4-12.43-9.1-14.3-15.43-.39-1.29-2.26-1.27-2.62.04-.63 2.33-.74 5.77 1.28 10.25 2.6 5.76 10.11 7.71 15.24 7.67h-.02Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.78 65.91c1.56-.01 1.88-2.08.41-2.53-7.72-2.4-12.43-9.1-14.3-15.43-.39-1.29-2.26-1.27-2.62.04-.63 2.33-.74 5.77 1.28 10.25 2.6 5.76 10.11 7.71 15.24 7.67h-.02Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.32 58.66 30.16 15.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m67.12 30.44-30.6 15.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M94 24c0 7.73-6.27 14-14 14s-14-6.27-14-14 6.27-14 14-14 14 6.27 14 14Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M94 80c0 7.73-6.27 14-14 14s-14-6.27-14-14 6.27-14 14-14 14 6.27 14 14Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38 52c0 7.73-6.27 14-14 14s-14-6.27-14-14 6.27-14 14-14a13.995 13.995 0 0 1 14 14Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Share104 = (Share104);
;// ./src/Picto/GeneratedPictoComponents/Share56.tsx


var Share56_excluded = ["className"];
function Share56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Share56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Share56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Share56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Share56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Share56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Share56_objectSpread(Share56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.41 49.73c.82 0 .99-1.09.22-1.33-4.06-1.26-6.53-4.78-7.52-8.11-.2-.68-1.19-.67-1.37.02-.33 1.23-.39 3.03.68 5.39 1.37 3.03 5.32 4.06 8.01 4.04Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.61 20.72c.82 0 .99-1.09.22-1.33-4.06-1.26-6.53-4.78-7.52-8.11-.2-.68-1.19-.67-1.37.02-.33 1.23-.39 3.03.68 5.39 1.37 3.03 5.32 4.06 8.01 4.04Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.11 35.07c.82 0 .99-1.09.22-1.33-4.06-1.26-6.53-4.78-7.52-8.11-.2-.68-1.19-.67-1.37.02-.33 1.23-.39 3.03.68 5.39 1.37 3.03 5.32 4.06 8.01 4.04Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.31 31.49 15.8 7.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.92 16.71-16.03 8.01"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50 13.33c0 4.05-3.28 7.33-7.33 7.33s-7.33-3.28-7.33-7.33S38.62 6 42.67 6 50 9.28 50 13.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50 42.67c0 4.05-3.28 7.33-7.33 7.33s-7.33-3.28-7.33-7.33 3.28-7.33 7.33-7.33S50 38.62 50 42.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.67 28c0 4.05-3.28 7.33-7.33 7.33S6.01 32.05 6.01 28s3.28-7.33 7.33-7.33a7.343 7.343 0 0 1 7.34 7.34Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Share56 = (Share56);
;// ./src/Picto/GeneratedPictoComponents/Signin104.tsx


var Signin104_excluded = ["className"];
function Signin104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Signin104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Signin104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Signin104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Signin104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Signin104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Signin104_objectSpread(Signin104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 61v27c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M40 90h12M44 14h4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.36 24h9.33v35.51h-9.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m66.95 33.44 8.32 8.32-8.32 8.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.31 41.76h19.97"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Signin104 = (Signin104);
;// ./src/Picto/GeneratedPictoComponents/Signin56.tsx


var Signin56_excluded = ["className"];
function Signin56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Signin56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Signin56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Signin56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Signin56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Signin56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Signin56_objectSpread(Signin56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 34v13c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v2M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.5 12.92h5.03v19.13H39.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.05 18 4.48 4.48-4.48 4.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.78 22.48h10.75"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Signin56 = (Signin56);
;// ./src/Picto/GeneratedPictoComponents/Swipe104.tsx


var Swipe104_excluded = ["className"];
function Swipe104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Swipe104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Swipe104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Swipe104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Swipe104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Swipe104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Swipe104_objectSpread(Swipe104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.39 47.28c0 3.37-1.46 6.4-3.78 8.5-.17.16-.35.3-.53.45s-.53.66-.56.42c-2.06-14.3-8.64-16.92-9.9-11.53-.63 2.69.92 7.84 3.32 13.61.13.32-.7-.02-1.04-.05-5.83-.53-10.41-5.43-10.41-11.4 0-6.32 5.13-11.45 11.45-11.45s11.45 5.13 11.45 11.45Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.43 91.19c-2.98-1.91-3.01-3.5-6.11-5.2-.59-.34-6.52-9.65-6.85-10.16-1.98-2.97-1.98-5.21.54-6.19 1.09-.42 5.25 2.76 4.53 1.25-.93-1.98-1.71-4.05-2.38-6.17l-.02.05-.03-.09c-1.07-3.25-4.19-5.55-8.11-5.86V86.44c0 4.18 3.38 7.56 7.56 7.57h15.25c.2-2.38-2.36-1.52-4.38-2.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.32 69.72s.64.78.65 1.53.5 2.06 1.6 3.33 4.61 6.42 5.86 8.2c1.26 1.78 5.23 6.03 7.89 7.34 2.48 1.22 7.1 3.96 4.02 3.4s-5.05-1.97-7.75-3.79-4.65-4.02-6.87-7.85c-2.21-3.83-5.17-7.57-5.17-7.57s-2-2.34-1.12-3.47l.88-1.12ZM40.51 47.07s1.69-.04 2.91 3.84c1.22 3.88 4.86 15.12 5.42 17.32.56 2.2.88 9.15.92 10s-.36 1.71-1.44 1.97l-.65-5.99s-.53-4.44-.9-5.72c-.37-1.29-5.18-17.65-5.18-17.65l-1.08-3.77ZM69.79 53.98c-.42.77-.29 2.28-.11 3.25.25 1.35.29 2.11-.86 2.55l-.97-2.87 1.93-2.93ZM53.79 54.92c-.3 1.39.79 3.69 1.45 5.57.66 1.88 1.88 4.22-.28 5.36l-2.89-8.4 1.72-2.52ZM61.41 53.08c-.39 1.05-.22 2.47.28 3.82s1.51 2.98-.67 3.99l-1.64-5.09 2.04-2.72Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29 44.58V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v28.5M50 14h4"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.53 66.3-7.18-21a3.712 3.712 0 0 0-4.69-2.43c-1.96.64-3.06 2.78-2.43 4.76 0 0 5.33 18.19 6.04 20.58s1.29 8.89 1.29 8.89c-3.31-.63-5.24-3.91-7.32-5.56-2.08-1.65-4.21-2.53-6.05-1.44s-1.49 2.76-.87 3.73 3.09 4.01 5.94 8.65c2.85 4.64 4.77 6.55 7.94 8.56 1.72 1.09 5.18 2.22 7.73 2.94l-1.05.02H35.01c-3.31 0-6-2.69-6-6V59.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.9 58.61c-.62-1.98.47-4.12 2.43-4.76 1.96-.64 4.07.45 4.69 2.43l1.62 4.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.47 57.57c-.62-1.98.47-4.12 2.43-4.76 1.96-.64 4.07.45 4.69 2.43l1.62 4.75M67.8 58.71c-.62-1.98.47-4.12 2.43-4.76 1.96-.64 4.07.45 4.69 2.43l1.62 4.75s2.18 4.51 3.67 9.53c1.49 5.02.05 11.06.46 12.42s.66 1.72 1.73 2.86M47.55 77.1s.17 2.91.74 4.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.83 52H10.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.52 45.48 10 52l6.52 6.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.17 52h14.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.48 58.52 94 52l-6.52-6.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Swipe104 = (Swipe104);
;// ./src/Picto/GeneratedPictoComponents/Swipe56.tsx


var Swipe56_excluded = ["className"];
function Swipe56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Swipe56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Swipe56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Swipe56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Swipe56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Swipe56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Swipe56_objectSpread(Swipe56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.29 28H6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.42 24.58 6 28l3.42 3.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.71 28H50"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.58 31.42 50 28l-3.42-3.42"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.02 46.9c-1.56-1-3.49-1.09-5.12-1.98-.31-.18-.59-.34-.87-.5-3.59-2.23-5.58-5.82-6.81-9.77v.03s-.02-.03-.02-.05c-.56-1.7-2.2-2.91-4.25-3.07v14.46c0 2.19 1.77 3.96 3.96 3.97H34.8c.1-1.25-.72-2.42-1.78-3.1Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.95 24.11V9.14C15.95 7.4 17.36 6 19.09 6H36.9c1.74 0 3.14 1.41 3.14 3.14v14.93M40.05 31.98v14.87c0 1.74-1.41 3.14-3.14 3.14H19.1c-1.74 0-3.14-1.41-3.14-3.14V32.02M26.95 8.1h2.1M24.86 47.9h6.28"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Swipe56 = (Swipe56);
;// ./src/Picto/GeneratedPictoComponents/SwitchOff104.tsx


var SwitchOff104_excluded = ["className"];
function SwitchOff104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SwitchOff104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SwitchOff104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SwitchOff104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SwitchOff104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SwitchOff104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SwitchOff104_objectSpread(SwitchOff104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.62 69.35C82.61 70 83.61 62 87.41 55.63c1.65-2.85 6.2-.63 6.18 1.53-.82 8.66-8.11 15.44-16.99 15.44H54.28s.86-3.59 10.33-3.25Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.54 72.6H41c-9.42 0-17.06-7.64-17.06-17.06S31.58 38.48 41 38.48h35.54c9.42 0 17.06 7.64 17.06 17.06S85.96 72.6 76.54 72.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.54 55.54c0 6.3 5.1 11.4 11.4 11.4s11.4-5.1 11.4-11.4c0-6.3-5.1-11.4-11.4-11.4s-11.4 5.1-11.4 11.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.63 28.66V20.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.51 29.59 32.48 22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.88 32.34-3.94-6.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.17 36.7-5.56-5.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.8 42.4-6.81-3.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.04 49.03-7.59-2.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.1 56.15H6.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.87 55.54H37.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.56 49.01-6.52 6.53 6.52 6.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SwitchOff104 = (SwitchOff104);
;// ./src/Picto/GeneratedPictoComponents/SwitchOff56.tsx


var SwitchOff56_excluded = ["className"];
function SwitchOff56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SwitchOff56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SwitchOff56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SwitchOff56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SwitchOff56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SwitchOff56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SwitchOff56_objectSpread(SwitchOff56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.58 37.17c4.4.16 6.98-.61 8.66-1.82.67-.48 1.5-.56 1.95-1.15.54-.71 1.08-1.57 1.49-2.35.34-.66.25-1.71.63-2.35.92-1.59 3.46-.35 3.45.86-.46 4.84-4.53 8.62-9.48 8.62H27.82s.48-2.01 5.77-1.81Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.43 38.78h19.14c5.07 0 9.19-4.11 9.19-9.19s-4.11-9.19-9.19-9.19H21.43c-5.07 0-9.19 4.11-9.19 9.19s4.11 9.19 9.19 9.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.11 29.6c0 3.39 2.75 6.14 6.14 6.14s6.14-2.75 6.14-6.14-2.75-6.14-6.14-6.14-6.14 2.75-6.14 6.14Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.54 15.25v-4.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.66 15.75-1.11-4.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.04 17.23-2.14-3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.93 19.59-3.03-3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m8.55 22.66-3.71-2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m7.05 26.23-4.14-1.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.53 30.07H2.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.98 29.81h-8.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.71 26.16-3.69 3.65 3.69 3.65"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SwitchOff56 = (SwitchOff56);
;// ./src/Picto/GeneratedPictoComponents/SwitchOn104.tsx


var SwitchOn104_excluded = ["className"];
function SwitchOn104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SwitchOn104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SwitchOn104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SwitchOn104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SwitchOn104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SwitchOn104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SwitchOn104_objectSpread(SwitchOn104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M39.45 69.35c-4.02.57-5.88-1.16-7.68-3.04-1.17.4-2.41.63-3.72.63-6.27 0-11.35-5.05-11.39-11.31-2.14.04-4.25.54-6.18 1.53.82 8.66 8.11 15.44 16.99 15.44h22.32s-.95-4.59-10.33-3.25Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63 72.6H27.46c-9.42 0-17.06-7.64-17.06-17.06s7.64-17.06 17.06-17.06H63c9.42 0 17.06 7.64 17.06 17.06S72.42 72.6 63 72.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.46 55.54c0 6.3-5.1 11.4-11.4 11.4s-11.4-5.1-11.4-11.4 5.1-11.4 11.4-11.4 11.4 5.1 11.4 11.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.37 28.66V20.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.49 29.59 71.52 22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m76.12 32.34 3.94-6.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.83 36.7 5.56-5.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m86.2 42.4 6.81-3.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m88.96 49.03 7.59-2.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.9 56.15h7.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.13 55.54h15.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m60.44 49.01 6.52 6.53-6.52 6.52"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SwitchOn104 = (SwitchOn104);
;// ./src/Picto/GeneratedPictoComponents/SwitchOn56.tsx


var SwitchOn56_excluded = ["className"];
function SwitchOn56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SwitchOn56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SwitchOn56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SwitchOn56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SwitchOn56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SwitchOn56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SwitchOn56_objectSpread(SwitchOn56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.65 37.19c-4.4.16-6.98-.61-8.66-1.82-.67-.48-1.5-.56-1.95-1.15-.54-.71-1.08-1.57-1.49-2.35-.34-.66-.25-1.71-.63-2.35-.92-1.59-3.46-.35-3.45.86C5.93 35.22 10 39 14.95 39h12.46s-.48-2.01-5.77-1.81Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.69 15.26v-4.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.58 15.77 1.1-4.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m41.19 17.24 2.15-3.67"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m44.3 19.6 3.03-3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.68 22.67 3.72-2.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.19 26.24 4.13-1.09"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.7 30.08h4.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.25 29.82h8.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32.52 26.17 3.69 3.65-3.69 3.65"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.8 38.8H14.66c-5.07 0-9.19-4.11-9.19-9.19s4.11-9.19 9.19-9.19H33.8c5.07 0 9.19 4.11 9.19 9.19s-4.11 9.19-9.19 9.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.12 29.61c0 3.39-2.75 6.14-6.14 6.14S8.84 33 8.84 29.61s2.75-6.14 6.14-6.14 6.14 2.75 6.14 6.14Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SwitchOn56 = (SwitchOn56);
;// ./src/Picto/GeneratedPictoComponents/TransferRequest104.tsx


var TransferRequest104_excluded = ["className"];
function TransferRequest104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TransferRequest104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TransferRequest104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TransferRequest104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TransferRequest104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TransferRequest104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TransferRequest104_objectSpread(TransferRequest104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.69 52.04c.02-.23 1.42.48 1.53.54.81.45 1.22.92 1.63 1.76 1.43 2.89.98 6.06.83 9.16-.17 3.73.11 7.46.54 11.16.38 3.24.72 6.59 2.23 9.53 1.36 2.65 4.04 3.7 6.68 4.69 1.72.64 2.65 2 2.88 3.82H49.44s-1.75-.59-1.75-4.09V52.05ZM23 28.04c.02-.23 1.42.48 1.53.54.81.45 1.22.92 1.63 1.76 1.43 2.89.98 6.06.83 9.16-.17 3.73.11 7.46.54 11.16.38 3.24.72 6.59 2.23 9.53 1.36 2.65 4.04 3.7 6.68 4.69 1.72.64 2.65 2 2.88 3.82H24.75S23 68.11 23 64.61V28.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.86 45.83v44.46c0 1.57-1.23 2.83-2.75 2.83H49.98c-1.51 0-2.75-1.28-2.75-2.83V37.67c0-1.57 1.23-2.83 2.75-2.83h32.71c.38 0 .74.16 1 .44l8.8 9.57c.24.26.38.61.38.98Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.22 35.64v7.98c0 1.62 1.23 2.94 2.75 2.94h7.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.81 69.28h-21.6c-1.54 0-2.78-1.2-2.78-2.69v-52.9c0-1.48 1.25-2.69 2.78-2.69h41.08c1.54 0 2.78 1.2 2.78 2.69v20.74"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.87 60.91c1.23 5.06 4.59 10.51 10.37 12.66 1.11.41.8 2.03-.38 1.99-3.88-.14-9.52-1.92-11.31-6.56-1.4-3.61-1.21-6.32-.66-8.14.31-1.02 1.73-.99 1.98.05"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.89 81.8 6.1 6.1-6.1 6.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.65 87.9h-15.8c-4.51 0-6.77-2.26-6.77-6.77V61.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m64.08 63.24 4.15 4.14 9.24-9.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "70.04",
        cy: "62.76",
        r: "12.87"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TransferRequest104 = (TransferRequest104);
;// ./src/Picto/GeneratedPictoComponents/TransferRequest56.tsx


var TransferRequest56_excluded = ["className"];
function TransferRequest56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TransferRequest56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TransferRequest56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TransferRequest56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TransferRequest56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TransferRequest56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TransferRequest56_objectSpread(TransferRequest56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26 29.02c0-.12.73.24.78.27.41.23.63.47.84.9.73 1.48.5 3.11.43 4.69-.09 1.91.06 3.82.28 5.72.19 1.66.37 3.38 1.14 4.88.7 1.36 2.07 1.9 3.42 2.4.88.33 1.36 1.03 1.47 1.95H26.9s-.89-.3-.89-2.09V29.01ZM13 16.02c0-.12.73.24.78.27.41.23.63.47.84.9.73 1.48.5 3.11.43 4.69-.09 1.91.06 3.82.28 5.72.19 1.66.37 3.38 1.14 4.88.7 1.36 2.07 1.9 3.42 2.4.88.33 1.36 1.03 1.47 1.95H13.9s-.89-.3-.89-2.09V16.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50 24.51v23.63c0 .83-.65 1.51-1.46 1.51H27.2c-.8 0-1.46-.68-1.46-1.51V20.17c0-.83.65-1.51 1.46-1.51h17.39c.2 0 .39.09.53.23l4.68 5.09c.13.14.2.33.2.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.35 19.1v4.24c0 .86.65 1.56 1.46 1.56h3.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.52 36.98H14.04c-.82 0-1.48-.64-1.48-1.43V7.43c0-.79.66-1.43 1.48-1.43h21.84c.82 0 1.48.64 1.48 1.43v11.02"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.43 32.5c.65 2.7 2.44 5.6 5.52 6.74.59.22.43 1.08-.2 1.06-2.07-.08-5.07-1.02-6.02-3.49-.74-1.92-.64-3.37-.35-4.33.17-.54.92-.53 1.06.03"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.06 43.64 3.24 3.24-3.24 3.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.06 46.88h-8.4c-2.4 0-3.6-1.2-3.6-3.6v-10.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.71 33.77 2.2 2.2 4.91-4.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.87",
        cy: "33.51",
        r: "6.84"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TransferRequest56 = (TransferRequest56);
;// ./src/Picto/GeneratedPictoComponents/Translate104.tsx


var Translate104_excluded = ["className"];
function Translate104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Translate104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Translate104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Translate104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Translate104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Translate104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Translate104_objectSpread(Translate104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {}), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.64 56.74c0-.73-.6-1.26-1.33-1.33-36.95-3.65-35.75-23.39-37-36.08a.85.85 0 0 0-.86-.76.87.87 0 0 0-.87.87v36.64c0 1.1.9 2 2 2h36.71c.74 0 1.34-.6 1.34-1.34Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M88.13 89.48c0-.73-.6-1.33-1.33-1.33-18.07-.1-34.03-3.73-36.99-21.09-.07-.43-.42-.76-.86-.76a.87.87 0 0 0-.87.87v21.65c0 1.1.9 2 2 2h36.71c.74 0 1.34-.6 1.34-1.34Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "11.03",
          y: "11.99",
          width: "45.5",
          height: "47.02",
          rx: "6",
          ry: "6",
          transform: "rotate(180 33.78 35.5)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.22 44.74h24.75c3.31 0 6 2.69 6 6v35.02c0 3.31-2.69 6-6 6h-33.5c-3.31 0-6-2.69-6-6V66.77"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m77.37 77.73-1.74-4.97H64.8l-1.74 4.97h-3.98l8.11-23.16h6.06l8.07 23.16h-3.95Zm-7.45-19.65-3.88 11.1h8.38l-3.88-11.1h-.61Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.43 25.48v-3.41h-8.55v-2.58h-4.27v2.58h-9.34v3.41h3.37c.84 4.36 2.84 8.66 5.72 12.47a31.886 31.886 0 0 1-5.09 4.52l2.14 3.01c1.95-1.38 3.74-2.97 5.34-4.68 1.61 1.72 3.39 3.3 5.34 4.68l2.14-3.01a31.886 31.886 0 0 1-5.09-4.52c2.87-3.82 4.87-8.12 5.72-12.47h2.58Zm-10.68 9.5c-2.09-2.96-3.6-6.21-4.34-9.5h8.69c-.75 3.29-2.25 6.54-4.34 9.5Z"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Translate104 = (Translate104);
;// ./src/Picto/GeneratedPictoComponents/Translate56.tsx


var Translate56_excluded = ["className"];
function Translate56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Translate56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Translate56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Translate56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Translate56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Translate56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Translate56_objectSpread(Translate56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {}), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.76 30.51c0-.39-.32-.66-.7-.7C7.65 27.89 8.28 17.52 7.63 10.86a.446.446 0 0 0-.45-.4c-.25 0-.45.2-.45.45v19.25c0 .58.47 1.05 1.05 1.05h19.29c.39 0 .7-.31.7-.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.93 47.7c0-.39-.31-.7-.7-.7-9.49-.05-17.88-1.96-19.43-11.08-.04-.23-.22-.4-.45-.4-.25 0-.45.2-.45.45v11.37c0 .58.47 1.05 1.05 1.05h19.29c.39 0 .7-.31.7-.7Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "6.43",
          y: "7",
          width: "23.9",
          height: "24.7",
          rx: "3",
          ry: "3",
          transform: "rotate(180 18.375 19.35)"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.32 24.2H46.4c1.7 0 3.08 1.38 3.08 3.08v18.47a3.15 3.15 0 0 1-3.15 3.15h-17.6a3.15 3.15 0 0 1-3.15-3.15v-9.98"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m41.28 41.53-.91-2.61h-5.69l-.91 2.61h-2.09l4.26-12.17h3.18l4.24 12.17h-2.08Zm-3.92-10.32-2.04 5.83h4.4l-2.04-5.83h-.32Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M23.97 14.09V12.3h-4.49v-1.36h-2.24v1.36h-4.91v1.79h1.77c.44 2.29 1.49 4.55 3 6.55-.79.87-1.69 1.68-2.67 2.37l1.12 1.58c1.02-.73 1.96-1.56 2.81-2.46.84.9 1.78 1.73 2.81 2.46l1.12-1.58c-.98-.7-1.88-1.5-2.67-2.37 1.51-2 2.56-4.26 3-6.55h1.35Zm-5.61 4.99c-1.1-1.56-1.89-3.26-2.28-4.99h4.56c-.39 1.73-1.18 3.44-2.28 4.99Z"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Translate56 = (Translate56);
;// ./src/Picto/GeneratedPictoComponents/Electricity104.tsx


var Electricity104_excluded = ["className"];
function Electricity104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Electricity104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Electricity104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Electricity104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Electricity104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Electricity104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Electricity104_objectSpread(Electricity104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.75 54.87c3.24.23 7.05 1.57 7.83 1.24-3.63-2.36-9.79-5.02-9.45-13.97.21-5.62 2-10.23 3.84-13.57.67-1.22-1.11-2.34-2.2-1.37-3.8 3.39-6.96 7.87-7.66 15.38-.35 2.99-.21 6.01.41 8.98l-.3-.17c1.21 5.09 4.07 9.78 8.23 13.51 4.04 3.7 6.61 8.45 7.33 13.52.08.6.48 1.11 1.06 1.38.46.22.71.68.66 1.13l-.55 5.2c-.03.76 1.51 1.64 2.37 1.67l.85.09c1.15 3.66 3.11 4.94 5.04 5.46 1.03.28 1.95-.61 1.62-1.51-.44-1.19-.23-2.54 1.15-3.73l-1.21-.04c-.38-.01-.76-.16-1-.43-1.98-2.27-5.89-6.73-4.47-7.71 4.31-2.97-10.11-24.1-15.48-25.78"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.82 51.88c1.22 5.01 3.84 9.61 7.67 13.27 3.63 3.46 6.04 8.17 6.88 13.3.14.87.89 1.51 1.78 1.51h19.89c.88 0 1.63-.63 1.78-1.5.87-5.1 3.34-9.83 7.18-13.6 3.7-3.64 6.06-8.45 7.23-13.38-33.07 13.12-52.41.41-52.41.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.97 42.5c1.16-12.79 11.2-23.09 23.85-24.5 1.05-.12 2.09-.17 3.13-.17 6.68 0 12.98 2.41 18.01 6.95 5.73 5.17 9.02 12.57 9.02 20.31s-2.9 14.32-8.15 19.49c-3.84 3.78-6.31 8.5-7.18 13.6-.15.87-.9 1.51-1.78 1.51H42.98c-.88 0-1.64-.64-1.78-1.51-.85-5.14-3.25-9.84-6.88-13.3-6.07-5.79-9.11-13.94-8.34-22.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.79 87.7H44.63c-1.18 0-2.13-.95-2.13-2.13V80.2c0-.13.1-.23.23-.23h20.21c.23 0 .41.18.41.41v4.77c0 1.41-1.15 2.56-2.56 2.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.14 87.7c.5 3.22 3.25 5.69 6.61 5.69s6.11-2.47 6.61-5.69H46.14Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m89.55 53.16-6.46-2.35m6.33-21.17-6.18 2.99M73.67 11.5l-4.14 5.48M52.92 4.94v6.87M33.1 11l3.69 5.8m-19.91 9.38 5.94 3.46m-8.37 21.83 6.85-.59"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Electricity104 = (Electricity104);
;// ./src/Picto/GeneratedPictoComponents/Electricity56.tsx


var Electricity56_excluded = ["className"];
function Electricity56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Electricity56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Electricity56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Electricity56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Electricity56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Electricity56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Electricity56_objectSpread(Electricity56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.09 29.37c1.73.12 3.75.83 4.17.66-1.93-1.26-5.21-2.67-5.03-7.44.11-2.99 1.06-5.44 2.04-7.22.36-.65-.59-1.24-1.17-.73-2.02 1.8-3.7 4.19-4.08 8.19-.19 1.59-.11 3.2.22 4.78l-.16-.09c.65 2.71 2.17 5.2 4.38 7.19 2.15 1.97 3.52 4.5 3.9 7.19.04.32.26.59.56.74.24.12.38.36.35.6l-.29 2.77c-.01.4.8.87 1.26.89l.45.05c.61 1.95 1.65 2.63 2.68 2.9.55.15 1.04-.32.86-.8-.23-.64-.12-1.35.61-1.98l-.65-.02c-.2 0-.41-.09-.53-.23-1.05-1.21-3.13-3.58-2.38-4.1 2.29-1.58-5.38-12.83-8.24-13.72"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 27.93c.66 2.7 2.07 5.18 4.13 7.14 1.95 1.86 3.25 4.4 3.71 7.16.08.47.48.82.96.82h10.71c.47 0 .88-.34.96-.81.47-2.75 1.8-5.29 3.87-7.33 1.99-1.96 3.26-4.55 3.89-7.21-17.81 7.06-28.22.22-28.22.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.99 22.88c.63-6.89 6.03-12.43 12.84-13.19a15.9 15.9 0 0 1 1.68-.09c3.6 0 6.99 1.3 9.7 3.74 3.08 2.78 4.86 6.77 4.86 10.94s-1.56 7.71-4.39 10.49c-2.07 2.03-3.4 4.58-3.86 7.33-.08.47-.48.81-.96.81H23.15c-.48 0-.88-.35-.96-.82-.46-2.77-1.75-5.3-3.71-7.16-3.27-3.12-4.9-7.5-4.49-12.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.73 47.22h-8.7c-.63 0-1.15-.51-1.15-1.15v-2.89c0-.07.06-.13.13-.13h10.88c.12 0 .22.1.22.22v2.57c0 .76-.62 1.38-1.38 1.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.85 47.22c.27 1.73 1.75 3.06 3.56 3.06s3.29-1.33 3.56-3.06h-7.12Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.22 28.62-3.48-1.27m3.41-11.39-3.33 1.61M39.67 6.19l-2.23 2.95M28.5 2.66v3.7m-10.68-.44 1.98 3.12M9.09 14.09l3.2 1.86M7.78 27.71l3.69-.32"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Electricity56 = (Electricity56);
;// ./src/Picto/GeneratedPictoComponents/ElectricityMeter104.tsx


var ElectricityMeter104_excluded = ["className"];
function ElectricityMeter104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElectricityMeter104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElectricityMeter104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElectricityMeter104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElectricityMeter104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElectricityMeter104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElectricityMeter104_objectSpread(ElectricityMeter104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.87 22.61c-.75-.41-1.67.14-1.67.99v7.7c0 1 0 4.7 1.1 5.3 1.7 1 4.1 0 6.1 0l6.8-.2 8.3-.2 7.9-.2 5.4-.1c.5.1 1-.8.4-.8L29 33.6c-1.5 0-2.9-1.7-3.3-4.5l-1.27-5.74c-.07-.32-.28-.59-.56-.75ZM17.2 73.4c3.09 6.04 10.01 6.84 13.44 7.53.78.16.79 1.28.01 1.46-10.72 2.53-15.75-1.12-17.26-3.19-1.6-2.2-1.4-23.2-.1-26.5 1.1-2.7 2.1 17.1 3.9 20.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.46 55.76c-.8.94-1.43 2.15-1.56 4.04-.1.8 0 1.6.2 2.4H35c.3 1.4 1 2.6 2.1 3.6 1 1 1.6 2.2 1.8 3.6 0 .2.2.4.4.4l-.1 1.7c0 .2.4.4.6.4h.2c.5 1.5 1.3 1.5 2 1.5-.4-.4-1.88-1.07-1.38-1.57l.41-.26c-.7-.7 4.18-.97 4.18-1.17.2-1.4 1-3.7 2-4.7s1.6-2.2 1.9-3.6c-4.9 1.9-12.7 1.4-12.7-2.5 0-1.48.36-2.71.75-3.63 0-.38-.25-.42-.69-.21Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.2 26.8-1.9-2.5M48 24.1l5.4 7M25 20.4h34c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H25c-1.1 0-2-.9-2-2v-12c-.1-1.1.8-2 2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.8 32V19.5c0-3.5-2.8-6.3-6.3-6.3H18.8c-3.5 0-6.3 2.8-6.3 6.3v57.1c0 3.5 2.8 6.3 6.3 6.3h48.8c2.1 0 3.9-1 5-2.6M28.6 83.6v5.8c0 .6.6 1.1 1.2 1.1H33c.7 0 1.2-.5 1.2-1.1v-5.8M49.6 83.6v5.8c0 .6.6 1.1 1.2 1.1H54c.7 0 1.2-.5 1.2-1.1v-5.8M39.1 83.6v5.8c0 .6.6 1.1 1.2 1.1h3.1c.7 0 1.2-.5 1.2-1.1v-5.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.15 67.54a7.86 7.86 0 0 1-4.81-7.25c0-4.35 3.52-7.87 7.87-7.87s7.87 3.52 7.87 7.87a7.86 7.86 0 0 1-4.81 7.25M44.4 71.21a2.19 2.19 0 1 1-4.38 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.27 67.53v2.25c0 .55-.45 1-1 1h-4.12c-.55 0-1-.45-1-1v-2.25M31.49 60.28h-1.31M52.91 60.28h1.31M33.13 54.92l-1.31-.76M33.13 65.53l-1.31.76M51.51 65.53l1.31.76M51.51 54.92l1.31-.76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M80.14 73.63c.39-.48.4-1.17 0-1.65-3.34-4.06-8.4-8.43-10.74-13.68-2.47-5.16-2.56-10.98-.41-16.08.55-1.32-1.12-2.42-2.15-1.43-2.76 2.65-5.27 7.09-4.04 13.41 1.64 8.46 10.31 18.61 13.35 21.97.55.6 1.5.57 2.01-.06l1.98-2.48Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.5 76c.4.9 1.5 1.3 2.4.9.4-.2.7-.5.9-.9l10.6-16.4c4.6-6.7 2.8-15.8-3.9-20.4S69.6 36.4 65 43.1c-3.4 5-3.4 11.5 0 16.5L75.5 76Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.5 51.3c0 3.5-2.8 6.3-6.3 6.3s-6.3-2.8-6.3-6.3 2.8-6.3 6.3-6.3 6.3 2.8 6.3 6.3Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElectricityMeter104 = (ElectricityMeter104);
;// ./src/Picto/GeneratedPictoComponents/ElectricityMeter56.tsx


var ElectricityMeter56_excluded = ["className"];
function ElectricityMeter56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ElectricityMeter56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ElectricityMeter56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ElectricityMeter56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ElectricityMeter56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ElectricityMeter56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ElectricityMeter56_objectSpread(ElectricityMeter56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.52 18.9-15.72-.81c-.81 0-1.56-.92-1.78-2.42l-.92-4.15c0-.11.11-.05-.22-.05h-.16c-.32 0-.59.11-.59.22v5.17c0 .54 0 2.53.59 2.85.92.54 2.21 0 3.28 0l3.66-.11 4.47-.11 4.25-.11 2.91-.05c.27.05.54-.43.22-.43ZM9.44 39.52c2.26 4.42 9.37 4.31 8.18 4.63-6.52 1.88-9.37-.32-10.23-1.51-.86-1.18-.75-12.49-.05-14.27.59-1.45 1.13 9.21 2.1 11.15Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.76 30.08c-.41.5-.73 1.14-.79 2.12-.05.43 0 .86.11 1.29h-.05c.16.75.54 1.4 1.13 1.94.54.54.86 1.18.97 1.94 0 .11.11.22.22.22l-.05.92c0 .11.22.22.32.22h.11c.27.81.26.45.64.45-.22-.22-.32-.54-.05-.81h-.22c-.38-.38 2.43-.34 2.43-.45.11-.75.54-1.99 1.08-2.53s.86-1.18 1.02-1.94c-2.64 1.02-6.84.75-6.84-1.35 0-.72.16-1.34.35-1.81.04-.26-.1-.31-.36-.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.36 14.43-1.02-1.35M26.02 12.98l2.91 3.77M13.64 10.98h18.31c.59 0 1.08.48 1.08 1.08v6.46c0 .59-.48 1.08-1.08 1.08H13.64c-.59 0-1.08-.48-1.08-1.08v-6.46c-.05-.59.43-1.08 1.08-1.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.92 17.23V10.5a3.38 3.38 0 0 0-3.39-3.39H10.3a3.38 3.38 0 0 0-3.39 3.39v30.75a3.38 3.38 0 0 0 3.39 3.39h26.28c1.13 0 2.1-.54 2.69-1.4M15.58 45.02v3.12c0 .32.32.59.65.59h1.72c.38 0 .65-.27.65-.59v-3.12M26.89 45.02v3.12c0 .32.32.59.65.59h1.72c.38 0 .65-.27.65-.59v-3.12M21.23 45.02v3.12c0 .32.32.59.65.59h1.67c.38 0 .65-.27.65-.59v-3.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.26 36.37a4.242 4.242 0 0 1 1.65-8.15c2.34 0 4.24 1.9 4.24 4.24 0 1.76-1.07 3.26-2.59 3.91M24.08 38.35c0 .65-.53 1.18-1.18 1.18s-1.18-.53-1.18-1.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.56 36.36v.87c0 .48-.45.87-1 .87h-1.3c-.55 0-1-.39-1-.87v-.87M17.13 32.46h-.7M28.67 32.46h.71M18.02 29.57l-.71-.41M18.02 35.29l-.71.4M27.91 35.29l.71.4M27.91 29.57l.71-.41"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.34 39.63c.2-.25.21-.61 0-.87-1.8-2.19-4.53-4.55-5.8-7.38-1.34-2.81-1.38-5.98-.18-8.74.29-.67-.57-1.27-1.1-.77-1.52 1.41-2.94 3.83-2.27 7.31.89 4.57 5.59 10.07 7.21 11.85.29.31.78.3 1.05-.04l1.09-1.36Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.83 40.92c.22.48.81.7 1.29.48.22-.11.38-.27.48-.48l5.71-8.83c2.48-3.61 1.51-8.51-2.1-10.98s-8.56-1.51-11.04 2.1a7.868 7.868 0 0 0 0 8.88l5.65 8.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.14 27.62c0 1.88-1.51 3.39-3.39 3.39s-3.39-1.51-3.39-3.39 1.51-3.39 3.39-3.39 3.39 1.51 3.39 3.39Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ElectricityMeter56 = (ElectricityMeter56);
;// ./src/Picto/GeneratedPictoComponents/Energy104.tsx


var Energy104_excluded = ["className"];
function Energy104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Energy104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Energy104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Energy104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Energy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Energy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Energy104_objectSpread(Energy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.08 56.15c2.79.19 6.07 1.35 6.73 1.06-3.12-2.03-8.42-4.32-8.13-12.02.18-4.84 1.72-8.8 3.31-11.68.58-1.05-.96-2.01-1.89-1.18-3.27 2.91-5.99 6.77-6.59 13.24-.3 2.57-.18 5.17.35 7.73l-.26-.15c1.04 4.38 3.5 8.41 7.08 11.62 3.48 3.19 5.69 7.27 6.3 11.63.07.51.42.95.91 1.19.4.19.61.58.57.98l-.47 4.48c-.02.65 1.3 1.41 2.04 1.44l.73.08c.99 3.15 2.67 4.25 4.33 4.7.88.24 1.67-.52 1.39-1.3-.38-1.03-.2-2.19.99-3.21l-1.04-.04c-.33-.01-.66-.14-.86-.37-1.71-1.95-5.07-5.79-3.85-6.63 3.71-2.55-8.7-20.73-13.32-22.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.13 54.37s6.2-8.01 8.91-15.38a.809.809 0 0 0-.4-1c-.17-.09-.34-.16-.42-.21-2.09 3.99-5.45 8.1-10.33 12.17a24.344 24.344 0 0 0-3.14 3.72l-.01.01c-2.6 3.83-4.12 8.46-4.12 13.44 0 9.37 5.39 17.47 13.23 21.41.68.38 1.61-.11.9-.85-5.01-5.33-14.76-18.57-4.63-33.32Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.8 57.57c-20.14 3.97-31.6-3.56-31.6-3.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.68 84.56a5.692 5.692 0 0 0 6.46 4.81 5.685 5.685 0 0 0 4.81-4.81H34.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.91 23.84c2.3 7.51-.64 17.15-11.86 26.51a22.78 22.78 0 0 0-3 3.58c-7.18 10.54-4.44 24.91 6.1 32.08 10.54 7.18 24.91 4.44 32.08-6.1 2.61-3.84 4.01-8.38 4-13.02 0-23.61-27.32-43.05-27.32-43.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.96 77.77H32c-.75 0-1.4-.55-1.52-1.3-.68-4.32-2.74-8.3-5.88-11.34a23.267 23.267 0 0 1-7.1-19.11c.99-10.89 9.46-19.6 20.32-20.89.9-.1 1.8-.15 2.7-.15 5.68 0 11.16 2.13 15.35 5.97 2.26 2.05 4.07 4.49 5.36 7.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.17 84.56H33.38c-1 0-1.82-.82-1.82-1.82v-4.58c0-.11.09-.19.2-.2H49c.19 0 .35.16.35.35v4.07c0 1.21-.98 2.18-2.18 2.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m58.15 19.58-3.53 4.69M40.46 14.04v5.86M23.56 19.16l3.14 4.94M9.73 32.1l5.05 2.95M7.65 53.67l5.84-.5"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m76.56 47.37 3.98 4.92 2.82 6.57 2.43 6.04.49 5.46v4.11l-.49 3.6-3.04 6.49-5.68 4.52-6.75.96s-8.3-13.99 1.55-22.13c8.15-6.73.65-.51 2.72-2.15l1.98-5.34-.06-4.82-.39-4.11-.6-3.01-.37-1.45 1.42.37",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.41 89.97c-2.96-.23-5.68-1.81-7.45-4.19-3.48-4.69-8.36-13.79-2.02-22.11.55-.72 1.62-.79 2.21-.1 1.4 1.64 4.64 4.66 6.43 4.64 6.59-.06 7.74-11.33 5.53-20.31-2.07-8.41 21.65 21.37 6.1 37.88a13.415 13.415 0 0 1-10.68 4.19h-.12Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Energy104 = (Energy104);
;// ./src/Picto/GeneratedPictoComponents/Energy56.tsx


var Energy56_excluded = ["className"];
function Energy56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Energy56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Energy56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Energy56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Energy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Energy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Energy56_objectSpread(Energy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.11 46.09c-2.65-3.17-6.35-9.66-1.54-16.66 0 0 1.86-2.6 3.34-5.58.29-.44-.07-.53-.89-.35-.96 1.21-2.15 2.43-3.6 3.65-.6.59-1.14 1.23-1.62 1.93-3.85 5.67-2.38 13.4 3.3 17.26l.6.39c.57-.05.78-.23.42-.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.18 30.33c1.47.1 3.2.71 3.55.56-1.65-1.07-4.43-2.27-4.28-6.33.09-2.55.91-4.63 1.74-6.15.31-.55-.5-1.06-1-.62-1.72 1.53-3.15 3.57-3.47 6.97-.16 1.36-.1 2.73.19 4.07l-.14-.08c.55 2.31 1.84 4.43 3.73 6.12 1.83 1.68 3 3.83 3.32 6.12.04.27.22.5.48.63.21.1.32.31.3.51l-.25 2.36c-.01.34.68.74 1.07.76l.38.04c.52 1.66 1.41 2.24 2.28 2.47.47.13.88-.28.73-.68-.2-.54-.11-1.15.52-1.69l-.55-.02c-.17 0-.35-.07-.45-.19-.9-1.03-2.67-3.05-2.03-3.49 1.95-1.35-4.58-10.92-7.01-11.68"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.82 31C15.97 33.14 9.8 29.09 9.8 29.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.67 45.53c.24 1.68 1.8 2.84 3.48 2.59 1.34-.2 2.4-1.25 2.59-2.59h-6.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.03 12.84c1.24 4.04-.34 9.24-6.39 14.27-.6.59-1.14 1.23-1.62 1.93-3.86 5.68-2.39 13.41 3.28 17.28 5.68 3.86 13.41 2.39 17.28-3.28 1.41-2.07 2.16-4.51 2.15-7.01 0-12.71-14.71-23.18-14.71-23.18Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.06 41.43c-.07.4-.29.45-.7.45h-9.13c-.41 0-.75-.3-.82-.7-.37-2.32-1.48-4.47-3.16-6.11-2.79-2.66-4.2-6.45-3.82-10.29.53-5.86 5.1-10.56 10.94-11.25.48-.06.97-.08 1.46-.08 3.06 0 6.01 1.15 8.27 3.21 1.22 1.1 2.19 2.42 2.89 3.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.4 45.53h-7.42c-.54 0-.98-.44-.98-.98v-2.47c0-.06.05-.1.11-.11h9.28c.1 0 .19.08.19.19v2.19c0 .65-.53 1.18-1.18 1.18Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.31 10.54-1.9 2.53M21.79 7.56v3.15M12.69 10.32l1.69 2.66M5.24 17.29l2.72 1.58M4.12 28.9l3.14-.27"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m41.2 24.92 2.18 2.69 1.55 3.6 1.33 3.31.27 2.99v2.25l-.27 1.97-1.67 3.56-3.11 2.47-3.7.52s-4.55-7.66.85-12.12c4.46-3.69.35-.28 1.49-1.18l1.08-2.93-.03-2.64-.22-2.25-.33-1.65-.2-.79.78.2",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.89 48.45c-1.63-.13-3.12-.99-4.09-2.3-1.91-2.58-4.59-7.58-1.11-12.14.3-.39.89-.43 1.21-.05.77.9 2.55 2.56 3.53 2.55 3.62-.03 4.25-6.22 3.04-11.16-1.14-4.62 11.89 11.74 3.35 20.81a7.388 7.388 0 0 1-5.86 2.3h-.06Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Energy56 = (Energy56);
;// ./src/Picto/GeneratedPictoComponents/EnergySolar104.tsx


var EnergySolar104_excluded = ["className"];
function EnergySolar104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnergySolar104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnergySolar104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnergySolar104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnergySolar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergySolar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnergySolar104_objectSpread(EnergySolar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.79 83.2s.76-3.27.75-3.3c0-.02 0-.04.01-.06 0 0 3.63-13.65 3.89-13.56.21.07.53.25.53.48-.06 2.39-.51 4.12-.58 6.52-.06 1.98-.35 3.96.87 5.54 1 1.31 5.48 2.72 5.45 4.19 0 .08-.04.15-.1.2-.06.05-.14.07-.22.06l-10.6-.07ZM72.39 84.1s-.13-3.4-.14-3.42a.064.064 0 0 1 0-.06s-1.38-14.39-1.1-14.38c.22 0 .59.11.65.32.58 2.36 3.18 10.57 4.79 11.79 1.33 1.01 7.18 2.83 7.55 4.27.02.08 0 .16-.05.23s-.12.11-.2.12L72.4 84.1ZM38.31 84.17s.57-3.65.55-3.68v-.07s2.86-15.28 3.16-15.2c.24.06.61.24.63.48.13 2.63-.22 4.57-.1 7.2.1 2.18-.06 4.37 1.41 6.01 1.21 1.35 6.24 2.53 6.33 4.15 0 .09-.03.17-.1.23-.06.06-.15.09-.24.08l-11.64.79Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.67 84H38.12c-.4 0-.72-.26-.73-.59 0-.04 0-.08.01-.12l4.36-22.28c.04-.31.35-.54.72-.54H63.1c.37 0 .68.23.72.54l2.57 22.28c.08.33-.18.64-.57.7-.05 0-.1.01-.16.01ZM40.05 72.93h25.18M56.26 60.54l2.1 23.35M48.87 60.9l-2.12 22.99M70.95 73.83h21.23M83.25 62.49l4.09 21.46M76.44 62.62l2.32 21.08M93.32 84.02H72.81c-.36 0-.67-.24-.67-.54 0-.04 0-.08.01-.12l-2.66-20.52c.03-.28.32-.5.66-.5h19.36c.34 0 .63.21.66.5l3.82 20.52c.07.3-.16.59-.52.65-.05 0-.1.01-.14 0ZM33.24 73.94H12.3M22.06 62.76l-6.38 21.22M28.86 62.87l-4.7 20.83M10.32 84h20.23c.36 0 .68-.23.71-.53v-.11l4.35-20.25c0-.28-.27-.49-.61-.49H15.9c-.34 0-.64.21-.69.49L9.72 83.36c-.09.3.11.58.46.64.05 0 .09.01.14 0ZM20.15 84.58v4.2M52.43 84.17l-.03 4.37M81.83 84.17v4.62M81.83 88.79H20.15M68.83 88.93l-.04 1.79M39.7 88.98l-.03 1.79"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.75 36.78c-4.49-2.11-6.4-5.15-6.38-10.16-.04-2.77-1.8-3.17-2.21-3.25-1.3-.15-2.52.64-2.9 1.89-1.25 3.83-1.14 7.2.4 9.92 2.03 3.66 4.45 5.24 6.64 5.96 1.06.33 2.16.52 3.28.54 1.31.19 2.55-.61 2.91-1.89.19-1.28-.52-2.53-1.73-3.01Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.83 21.24c5.46 0 9.89 4.43 9.89 9.89s-4.43 9.89-9.89 9.89-9.89-4.43-9.89-9.89 4.43-9.89 9.89-9.89M45.76 18.89l-1.87-3.23M40.58 24.07l-3.23-1.87M38.69 31.14h-3.73M40.58 38.21l-3.23 1.87M45.76 43.39l-1.87 3.23M52.83 45.28v3.74M59.9 43.39l1.87 3.23M65.08 38.21l3.23 1.87M66.98 31.14h3.72M65.08 24.07l3.23-1.87M59.9 18.89l1.87-3.23M52.83 13.23v3.73"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergySolar104 = (EnergySolar104);
;// ./src/Picto/GeneratedPictoComponents/EnergySolar56.tsx


var EnergySolar56_excluded = ["className"];
function EnergySolar56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnergySolar56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnergySolar56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnergySolar56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnergySolar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergySolar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnergySolar56_objectSpread(EnergySolar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.15 46.09s.36-2.35.36-2.37v-.04s1.84-9.83 2.03-9.78c.15.04.39.15.4.31.08 1.69-.14 2.94-.07 4.63.06 1.4-.04 2.81.91 3.87.78.87 4.01 1.63 4.07 2.67 0 .06-.02.11-.06.15-.04.04-.1.06-.15.05l-7.49.51ZM39.44 47.09s-.07-1.94-.08-1.95v-.04s-.79-8.2-.63-8.19c.13 0 .34.06.37.18.33 1.34 1.81 6.02 2.73 6.72.76.58 4.09 1.61 4.3 2.44.01.05 0 .09-.03.13-.03.04-.07.06-.12.07l-6.55.64ZM3.82 46.91s.49-2.1.48-2.12v-.04s2.33-8.77 2.5-8.71c.14.04.34.16.34.31-.04 1.54-.33 2.65-.37 4.19-.04 1.27-.22 2.54.56 3.56.65.84 3.52 1.75 3.5 2.69 0 .05-.03.1-.07.13a.18.18 0 0 1-.14.04l-6.81-.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.89 45.71H19.42c-.23 0-.42-.15-.42-.34v-.07l2.54-12.98c.02-.18.2-.32.42-.31h12.01c.22 0 .4.14.42.31l1.92 12.98c.04.19-.1.37-.33.41h-.09ZM20.55 39.26h14.66M29.99 32.04l1.22 13.6M25.67 32.12l-1.22 13.52M38.71 41.06h12.17M45.76 34.56l2.35 12.3M41.86 34.63l1.33 12.09M51.53 46.91H39.77c-.21 0-.38-.14-.39-.31v-.07l-1.53-11.77c.02-.16.18-.29.38-.28h11.1c.19 0 .36.12.38.28l2.19 11.77c.04.17-.09.34-.3.37h-.08ZM17.09 41.13H5.08M10.68 34.72 7.02 46.88M14.58 34.78l-2.69 11.94M3.95 46.89h11.6c.21 0 .39-.13.41-.31v-.07l2.49-11.61c0-.16-.16-.28-.35-.28H7.15c-.19 0-.36.12-.4.28L3.6 46.51c-.05.17.06.33.26.37h.08ZM9.59 47.22v2.41M28.09 45.64l-.02 3.86M44.94 46.99v2.65M44.94 49.64H9.59M37.49 49.72l-.02 1.03M20.79 49.74l-.02 1.03"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.58 18.84c-2.44-1.15-3.49-2.81-3.47-5.54-.02-1.51-.98-1.73-1.2-1.77-.71-.08-1.37.35-1.58 1.03-.68 2.09-.62 3.92.22 5.4 1.11 2 2.42 2.86 3.62 3.25.58.18 1.18.28 1.79.3.71.11 1.39-.33 1.58-1.03.11-.7-.29-1.38-.94-1.64Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 10.37c2.98 0 5.39 2.41 5.39 5.39s-2.41 5.39-5.39 5.39-5.39-2.41-5.39-5.39 2.41-5.39 5.39-5.39M24.14 9.09l-1.02-1.76M21.32 11.91l-1.76-1.02M20.28 15.76h-2.02M21.32 19.62l-1.76 1.01M24.14 22.44l-1.02 1.76M27.99 23.47v2.03M31.85 22.44l1.01 1.76M34.67 19.62l1.76 1.01M35.7 15.76h2.03M34.67 11.91l1.76-1.02M31.85 9.09l1.01-1.76M27.99 6v2.03"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergySolar56 = (EnergySolar56);
;// ./src/Picto/GeneratedPictoComponents/EnergyWind104.tsx


var EnergyWind104_excluded = ["className"];
function EnergyWind104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnergyWind104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnergyWind104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnergyWind104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnergyWind104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergyWind104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnergyWind104_objectSpread(EnergyWind104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.79 42.18c.99-.63 2.1-1.25 3.31-1.83 3.66-1.75 7.35-2.25 9.5-1.19.12-.14.23-.27.33-.41a2.744 2.744 0 0 1-1.87-2.59c0-.73.29-1.4.75-1.9-2.35-.41-6.22 1.37-9.8 4.55-1.14.97-2.21 1.92-3.2 2.8-.33 1.19.03 1.32.97.56ZM89.02 43.49a32.88 32.88 0 0 1-3.09-1.86c-3.35-2.28-5.71-5.1-6.06-7.25-.77-.18-1.46-.22-2.04-.13.47.49.76 1.16.76 1.89 0 .99-.53 1.85-1.31 2.34 1.53 1.71 4.42 3.47 7.93 4.76 1.18.45 2.37.88 3.56 1.29.9-.34 1.42-.69.25-1.05ZM75.82 33.38c.62 0 1.19.21 1.65.56.59-.73 1.03-1.88 1.24-3.33 0-.02-.03-.03-.04-.01-.34.3-.78.46-1.24.46-2.18-.11-3.09-4.66-2.44-10.06.22-2.24.69-4.45 1.39-6.58.12-.35.13-.72.04-1.08a.519.519 0 0 0-.63-.38c-.19.05-.34.19-.38.38-.84 3.21-1.53 6.47-2.05 9.75-.81 4.71-.45 8.95.91 10.78.44-.3.97-.47 1.54-.48h.01ZM12.07 48.32c1.68-1.47 4.16-3.08 7.07-4.47 4.45-2.13 8.95-2.74 11.55-1.45.15-.17.28-.33.4-.5-1.32-.45-2.28-1.68-2.28-3.16 0-.89.35-1.7.92-2.31-2.86-.5-7.57 1.67-11.92 5.54-2.47 2.11-4.71 4.13-6.48 5.79-.22 1.04.02 1.24.74.55ZM50.77 48.86c-1.89-.77-4.08-1.94-6.3-3.45-4.08-2.78-6.95-6.21-7.38-8.82-.94-.22-1.78-.27-2.49-.16.57.6.93 1.41.93 2.3 0 1.21-.64 2.26-1.59 2.85 1.87 2.08 5.38 4.22 9.65 5.79 2.25.86 4.52 1.66 6.81 2.38.84-.34 1.03-.64.37-.9ZM32.18 35.37c.76 0 1.44.26 2.01.68.72-.89 1.25-2.29 1.51-4.05 0-.02-.04-.03-.05-.02-.42.36-.95.56-1.51.56-2.65-.13-3.76-5.67-2.97-12.25.27-2.72.83-5.41 1.69-8.01.15-.42.16-.88.04-1.31a.631.631 0 0 0-.76-.47c-.23.06-.41.24-.47.47-1.03 3.91-1.86 7.87-2.49 11.86-.99 5.74-.55 10.9 1.11 13.12.53-.36 1.18-.58 1.88-.58h.01ZM73.84 42.6l-4.3 38.49c-.07.57-.28 1.8.28 1.89h6.93c.43.06.84-.24.91-.67a.8.8 0 0 0-.07-.48l-1.44-2.86c-.76-1.55-1.14-3.26-1.13-4.99 0-2.9.24-32.76.24-32.76.01-.72-1.08-.86-1.19-.14 0 .01-.23 1.52-.23 1.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "75.82",
        cy: "36.14",
        r: ".81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.76 46.6-5.23 46.84c-.09.69-.34 2.19.35 2.3h8.43a.993.993 0 0 0 1.11-.82c.03-.2 0-.4-.09-.59l-1.76-3.48c-.92-1.89-1.39-3.97-1.37-6.07 0-3.53.29-39.86.29-39.86.02-.88-1.32-1.05-1.45-.17 0 .02-.28 1.85-.28 1.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "32.18",
        cy: "38.74",
        r: ".99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m77.32 39.17 4.25 42.85c-1.32.81-12.39.83-11.3.01l3.91-42.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.02 33.97c-.07-.01-.13-.04-.21-.05-2.46-.4-6.35 1.62-9.93 4.7-3.09 2.62-5.73 5.11-7.39 6.76a.76.76 0 0 0-.23.53c0 .41.33.74.74.74.07 0 .14 0 .21-.02 2.25-.62 5.73-1.65 9.55-3.02 3.63-1.26 6.65-3.03 8.17-4.87M76.99 38.64c1.55 1.78 4.54 3.53 8.09 4.84 3.99 1.5 7.68 2.58 9.52 3.07.07.02.14.03.21.03.2 0 .39-.07.53-.22.28-.29.27-.76-.02-1.05-1.35-1.35-4.12-4-7.42-6.71-3.63-3.01-7.55-5.02-9.95-4.67-.05 0-.09.02-.14.03M77.8 33.97c1.48-1.92 1.73-6.21.92-10.93-.69-4.21-1.61-7.94-2.09-9.78a.74.74 0 0 0-.54-.54c-.4-.1-.8.14-.9.54-.6 2.26-1.44 5.79-2.1 9.78-.8 4.71-.54 9.01.93 10.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.81 33.38c-1.53 0-2.76 1.25-2.75 2.77s1.25 2.76 2.77 2.75c1.52 0 2.75-1.24 2.75-2.76 0-1.52-1.24-2.76-2.76-2.76h-.01ZM34.03 42.69l5.15 51.88c-1.61.98-15.07 1.01-13.76.01l4.76-51.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.03 36.17s-.04-.05-.05-.07c-.08-.02-.16-.05-.25-.06-2.99-.49-7.73 1.97-12.08 5.71-3.76 3.19-6.98 6.22-8.99 8.22-.18.17-.28.4-.28.65 0 .5.4.9.9.91.09.01.17 0 .25-.02 2.74-.75 6.97-2.01 11.62-3.68 4.42-1.54 8.1-3.69 9.95-5.92M33.6 41.77c1.89 2.16 5.52 4.3 9.85 5.89 4.86 1.83 9.34 3.14 11.58 3.74.08.02.17.03.25.04.24.01.48-.09.65-.26.34-.36.33-.93-.02-1.27-1.64-1.64-5.02-4.86-9.03-8.16-4.42-3.66-9.19-6.11-12.11-5.68-.06 0-.11.03-.17.03-.05.06-.09.12-.14.18M34.59 36.09c1.8-2.33 2.11-7.55 1.12-13.29-.85-5.13-1.96-9.66-2.55-11.9a.903.903 0 0 0-.66-.66.905.905 0 0 0-1.09.66c-.73 2.75-1.75 7.04-2.55 11.9-.98 5.74-.66 10.97 1.13 13.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.16 35.37c-1.86 0-3.36 1.52-3.35 3.37 0 1.86 1.52 3.36 3.37 3.35 1.85 0 3.35-1.51 3.35-3.36 0-1.85-1.5-3.35-3.36-3.36h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.11 33.88a11.973 11.973 0 0 1 6.63-12.17M42.43 22.14c4.6 1.85 7.58 6.34 7.5 11.3M20.59 32.64c0-.23 0-.45.02-.68.14-1.94.94-3.78 2.27-5.21M40.91 27.24c2 1.02 3.51 2.79 4.23 4.91"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergyWind104 = (EnergyWind104);
;// ./src/Picto/GeneratedPictoComponents/EnergyWind56.tsx


var EnergyWind56_excluded = ["className"];
function EnergyWind56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnergyWind56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnergyWind56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnergyWind56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnergyWind56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnergyWind56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnergyWind56_objectSpread(EnergyWind56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.51 23.51c.7-.58 1.67-1.2 2.8-1.74 1.86-.89 3.75-1.15 4.84-.61.06-.07.12-.14.17-.21-.55-.19-.95-.71-.96-1.32 0-.37.15-.71.38-.97-1.2-.21-3.17.7-4.99 2.32-.99.84-1.89 1.65-2.61 2.33-.26.35.12.43.37.19ZM49.08 23.66c-.67-.31-1.41-.73-2.15-1.23-1.71-1.16-2.91-2.6-3.09-3.69-.39-.09-.74-.11-1.04-.06.24.25.38.59.38.96 0 .51-.27.95-.67 1.19.78.87 2.25 1.77 4.04 2.43.79.3 1.59.59 2.39.85.25-.11.51-.22.13-.44ZM41.78 18.22c.32 0 .61.11.84.29.3-.37.52-.96.63-1.7 0 0-.01-.01-.02 0-.18.15-.4.23-.63.23-1.11-.06-1.58-2.38-1.24-5.13.11-1.14.35-2.27.71-3.36a.94.94 0 0 0 .02-.55.272.272 0 0 0-.32-.2c-.1.02-.17.1-.2.2-.43 1.64-.78 3.3-1.04 4.97-.41 2.4-.23 4.56.46 5.5.22-.15.49-.24.79-.24ZM40.76 22.92l-2.19 19.62c-.04.29-.14.92.15.96h3.53a.406.406 0 0 0 .42-.59l-.74-1.46c-.39-.79-.58-1.66-.57-2.54 0-1.48.12-16.7.12-16.7 0-.37-.55-.44-.61-.07 0 0-.12.77-.12.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.14 25.5c.93-.77 2.23-1.6 3.74-2.32 2.49-1.19 5-1.53 6.46-.81.08-.09.15-.19.23-.28-.74-.25-1.27-.94-1.28-1.77 0-.5.2-.95.51-1.29-1.6-.28-4.23.93-6.67 3.1-1.32 1.12-2.52 2.21-3.49 3.11-.35.47.16.57.49.25ZM26.93 25.7c-.9-.42-1.88-.97-2.87-1.65-2.28-1.55-3.89-3.47-4.13-4.93-.52-.12-.99-.14-1.39-.08.32.34.51.78.51 1.28 0 .67-.36 1.26-.89 1.59 1.04 1.16 3.01 2.36 5.4 3.24 1.06.4 2.12.78 3.19 1.13.34-.15.68-.29.17-.59ZM17.17 18.44c.42 0 .81.15 1.12.38.4-.5.7-1.28.84-2.26 0-.01-.02-.02-.03 0-.23.2-.53.31-.84.31-1.48-.07-2.1-3.17-1.66-6.85.15-1.52.47-3.03.95-4.48.08-.24.09-.49.02-.73a.355.355 0 0 0-.43-.26c-.13.03-.23.13-.26.26-.58 2.19-1.04 4.4-1.39 6.63-.55 3.21-.31 6.09.62 7.34.3-.2.66-.32 1.05-.32ZM15.82 24.72l-2.93 26.19c-.05.39-.19 1.22.19 1.28h4.71a.55.55 0 0 0 .57-.79l-.98-1.95a7.557 7.557 0 0 1-.77-3.4c0-1.97.16-22.29.16-22.29 0-.49-.74-.59-.81-.1 0 0-.16 1.03-.16 1.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.17",
        cy: "20.32",
        r: ".55"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.15 21.92 2.94 29.63c-.9.55-8.43.56-7.69 0l2.66-28.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.99 18.88-.02-.02c-.05-.01-.1-.03-.16-.04-1.67-.27-4.32 1.1-6.76 3.2-2.11 1.78-3.9 3.48-5.03 4.6-.1.09-.15.22-.15.36 0 .28.22.51.5.51s.1 0 .14-.01c1.53-.42 3.9-1.13 6.5-2.06 2.47-.86 4.52-2.07 5.56-3.31M17.98 22.02c1.06 1.21 3.08 2.41 5.5 3.3 2.72 1.02 5.22 1.76 6.48 2.09.05.01.09.02.14.02.14 0 .27-.05.36-.15.19-.2.19-.52-.01-.71-.92-.92-2.81-2.72-5.05-4.56-2.47-2.05-5.14-3.42-6.77-3.18-.04 0-.07.02-.11.02-.02.03-.05.06-.08.09M18.36 18.88l.15-.03c1.02-1.3 1.2-4.22.64-7.44-.47-2.87-1.1-5.4-1.43-6.66a.53.53 0 0 0-.37-.37.5.5 0 0 0-.61.37 72.97 72.97 0 0 0-1.43 6.66c-.55 3.22-.36 6.15.65 7.44H16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.17 18.44c-1.04 0-1.88.85-1.87 1.89s.85 1.88 1.89 1.87c1.04 0 1.87-.85 1.87-1.88 0-1.04-.84-1.88-1.88-1.88Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.84 17.6a6.68 6.68 0 0 1 3.71-6.81M23.13 11.04a6.684 6.684 0 0 1 4.19 6.32M10.91 16.91c0-.13 0-.25.01-.38.08-1.09.53-2.12 1.27-2.91M22.27 13.89c1.12.57 1.97 1.56 2.37 2.75"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.52 20.74 2.27 22.87c-.69.42-6.51.44-5.94 0L40.9 21.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.85 18.4-.02-.02c-.04 0-.08-.02-.12-.03-1.29-.21-3.33.85-5.22 2.47a69.775 69.775 0 0 0-3.88 3.55.39.39 0 0 0 .27.67s.07 0 .11-.01c1.18-.32 3.01-.87 5.01-1.59 1.91-.66 3.49-1.59 4.29-2.56M42.38 20.82c.81.94 2.37 1.86 4.24 2.55 2.1.79 4.03 1.35 5 1.61.04 0 .07.02.11.02.11 0 .21-.04.28-.11.15-.15.14-.4-.01-.55-.71-.71-2.17-2.1-3.9-3.52-1.91-1.58-3.96-2.64-5.23-2.45-.03 0-.06.01-.09.02-.02.02-.04.04-.06.07M42.68 18.4s.07-.02.11-.02c.78-1 .92-3.25.5-5.74-.36-2.21-.85-4.17-1.1-5.14a.39.39 0 0 0-.76 0c-.32 1.19-.76 3.04-1.1 5.14-.42 2.49-.28 4.74.5 5.74h.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.76 18.06c-.8 0-1.45.65-1.45 1.46s.65 1.45 1.46 1.45a1.451 1.451 0 0 0 0-2.9Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnergyWind56 = (EnergyWind56);
;// ./src/Picto/GeneratedPictoComponents/Gas104.tsx


var Gas104_excluded = ["className"];
function Gas104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gas104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gas104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gas104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gas104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gas104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gas104_objectSpread(Gas104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.44 48.88S41.4 38.6 44.87 29.14c.18-.49-.04-1.05-.51-1.29-.22-.11-.43-.21-.53-.27-2.69 5.12-6.99 10.4-13.26 15.62a30.59 30.59 0 0 0-4.02 4.77l-.01.02a30.612 30.612 0 0 0-5.29 17.25c0 12.03 6.92 22.42 16.98 27.47.87.48 2.06-.14 1.16-1.09-6.42-6.84-18.94-23.83-5.94-42.76Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.37 7.91c3.07 10.04-.86 22.85-15.8 35.31a30.59 30.59 0 0 0-4.02 4.77l-.02.02a30.612 30.612 0 0 0-5.29 17.25c0 16.99 13.77 30.76 30.76 30.76s30.75-13.77 30.76-30.76c0-31.45-36.38-57.35-36.38-57.35Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.71 44.01 62.56 50 66 58l2.95 7.35.6 6.64v5l-.6 4.38-3.71 7.91-6.92 5.5-8.22 1.16S39.99 78.9 51.99 68.98c9.92-8.2.79-.62 3.32-2.62l2.41-6.51-.08-5.87-.48-5-.73-3.67-.45-1.77 1.73.45",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.78 96.03c-3.57-.28-6.85-2.18-8.99-5.05-4.19-5.65-10.08-16.63-2.43-26.65.66-.87 1.96-.95 2.66-.12 1.68 1.98 5.59 5.62 7.75 5.6 7.95-.07 9.33-13.65 6.66-24.48-2.49-10.13 26.09 25.76 7.35 45.66-3.31 3.51-8.05 5.39-12.87 5.05-.05 0-.09 0-.14-.01Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gas104 = (Gas104);
;// ./src/Picto/GeneratedPictoComponents/Gas56.tsx


var Gas56_excluded = ["className"];
function Gas56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gas56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gas56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gas56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gas56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gas56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gas56_objectSpread(Gas56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m30.93 23.31 2.67 3.3 1.9 4.41 1.63 4.05.33 3.66v2.76l-.33 2.42-2.04 4.36-3.81 3.03-4.53.64s-5.57-9.39 1.04-14.85c5.47-4.52.43-.34 1.83-1.44l1.33-3.59-.04-3.23-.26-2.76-.4-2.02-.25-.97.95.25",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.01 26.32s4.39-5.81 6.16-11.02c.16-.6-.44-.38-.57-.45-1.45 2.76-3.77 5.6-7.14 8.41-.8.78-1.53 1.64-2.17 2.57-1.8 2.65-2.85 5.85-2.85 9.29 0 6.48 3.73 12.07 9.14 14.79.14-.11.91 0 .5-.55C17.62 45.68 11 36.49 18 26.3Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.97 4.26c1.65 5.4-.46 12.3-8.51 19.01-.8.78-1.53 1.64-2.17 2.57-1.8 2.65-2.85 5.85-2.85 9.29 0 9.15 7.41 16.56 16.56 16.56s16.56-7.41 16.56-16.56c0-16.93-19.59-30.88-19.59-30.88Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.18 51.67c-1.93-.15-3.71-1.18-4.86-2.73-2.27-3.06-5.45-8.99-1.32-14.41.36-.47 1.06-.51 1.44-.06.91 1.07 3.03 3.04 4.19 3.03 4.3-.04 5.04-7.38 3.6-13.24-1.35-5.48 14.11 13.93 3.98 24.7a8.765 8.765 0 0 1-6.96 2.73h-.08Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gas56 = (Gas56);
;// ./src/Picto/GeneratedPictoComponents/GasMeter104.tsx


var GasMeter104_excluded = ["className"];
function GasMeter104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GasMeter104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GasMeter104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GasMeter104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GasMeter104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GasMeter104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GasMeter104_objectSpread(GasMeter104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.24 73.45c.57 2.32.28 5.24-1.43 5.25-.46 0-1.3-.8-1.66-1.2a.363.363 0 0 0-.51-.04l-.06.06c-1.64 2.13-.38 4.5.52 5.72.46.62 1.16 1.02 1.93 1.08.32.02.65.01.96-.03.52-.08 1-.31 1.4-.66 4.86-4.15-1.7-12.45-1.15-10.2v.02ZM18.35 78.7c3.66 11.42 23 9.28 22.81 11.5-19.09 4.87-24.96-4.2-26.99-6.82-2.07-2.67-2.32-20.88-.69-24.92 1.4-3.45 3.33 15.44 4.87 20.24ZM25.78 31.77c-.75-.41-1.67.14-1.67.99v7.7c0 1 0 4.7 1.1 5.3 1.7 1 4.1 0 6.1 0l6.8-.2 8.3-.2 7.9-.2 5.4-.1c.5.1 1-.8.4-.8l-29.2-1.5c-1.5 0-2.9-1.7-3.3-4.5l-1.27-5.74c-.07-.32-.28-.59-.56-.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.16 36.08-1.91-2.45M49.91 33.44l5.44 6.98M74.41 41.05V27.87c0-3.46-2.8-6.26-6.26-6.26H19.44c-3.46 0-6.26 2.8-6.26 6.26v50.85c0 6.91 5.6 12.52 12.52 12.52h36.19c3.44 0 6.56-1.39 8.82-3.64M23.98 12.42h6.16c1.93 0 3.5 1.57 3.5 3.5v5.65H20.47v-5.65c0-1.93 1.57-3.5 3.5-3.5h.01ZM20.45 16.36h13.21M57.45 12.42h6.16c1.93 0 3.5 1.57 3.5 3.5v5.65H53.94v-5.65c0-1.93 1.57-3.5 3.5-3.5ZM53.93 16.36h13.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.63",
        y: "29.68",
        width: "38.01",
        height: "16.06",
        rx: "2.03",
        ry: "2.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.18 84.39c-.82-.06-1.57-.5-2.05-1.15-.96-1.29-2.3-3.8-.56-6.09.15-.2.45-.22.61-.03.38.45 1.28 1.28 1.77 1.28 1.82-.02 2.13-3.12 1.52-5.59-.59-2.39 6.4 6.43 1.22 10.87-.42.36-.94.61-1.49.68-.29.04-.63.06-1.03.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.07 60.41c.87 2.73-.24 6.22-4.48 9.61-.42.39-.81.83-1.14 1.3a8.063 8.063 0 0 0-1.5 4.69c0 4.62 3.9 8.37 8.72 8.37s8.72-3.75 8.72-8.37c0-8.56-10.31-15.61-10.31-15.61Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M80.12 83.03c.41-.51.42-1.24 0-1.74-3.33-4.02-8.34-8.4-10.7-13.58a19.617 19.617 0 0 1-.56-15.77c.56-1.42-1.18-2.62-2.27-1.55-2.69 2.67-5.04 7.05-3.82 13.24 1.66 8.43 10.21 18.49 13.3 21.9.58.64 1.59.6 2.13-.07l1.93-2.42Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.53 85.39a1.799 1.799 0 0 0 3.26 0l10.56-16.43c4.55-6.72 2.79-15.85-3.93-20.4s-15.85-2.79-20.4 3.93a14.68 14.68 0 0 0 0 16.47l10.51 16.43Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.49 60.72c0 3.48-2.82 6.3-6.3 6.3s-6.3-2.82-6.3-6.3 2.82-6.3 6.3-6.3 6.3 2.82 6.3 6.3Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GasMeter104 = (GasMeter104);
;// ./src/Picto/GeneratedPictoComponents/GasMeter56.tsx


var GasMeter56_excluded = ["className"];
function GasMeter56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GasMeter56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GasMeter56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GasMeter56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GasMeter56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GasMeter56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GasMeter56_objectSpread(GasMeter56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.82 39.55c.31 1.25.15 2.82-.77 2.83-.25 0-.7-.43-.89-.65a.19.19 0 0 0-.27-.02l-.03.03c-.88 1.15-.2 2.42.28 3.08.25.33.62.55 1.04.58.17.01.35 0 .52-.02.28-.04.54-.17.75-.36 2.62-2.23-.92-6.7-.62-5.49ZM9.88 42.38c1.97 6.15 13.91 6.03 12.34 6.42-10.28 2.62-13.49-2.49-14.59-3.9-1.11-1.44-1.25-11.24-.37-13.42.75-1.86 1.79 8.31 2.62 10.9ZM32.42 23.93l-15.76-.8c-.83 0-1.55-.9-1.79-2.41l-.93-4.14c-.01-.11.1-.07-.23-.07h-.15c-.34 0-.61.1-.61.21v5.19c0 .53 0 2.54.59 2.88.93.53 2.21 0 3.28-.03l3.68-.08 4.5-.1 4.23-.09 2.9-.06c.33 0 .58-.5.3-.5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.24 19.43-1.03-1.32M26.87 18.01l2.93 3.75M40.07 22.1V15c0-1.86-1.51-3.37-3.37-3.37H10.47c-1.86 0-3.37 1.51-3.37 3.37v27.38c0 3.72 3.02 6.74 6.74 6.74h19.49c1.85 0 3.53-.75 4.75-1.96M12.91 6.69h3.32c1.04 0 1.88.85 1.88 1.88v3.04h-7.09V8.57c0-1.04.85-1.88 1.88-1.88ZM11.01 8.81h7.11M30.93 6.69h3.32c1.04 0 1.88.85 1.88 1.88v3.04h-7.09V8.57c0-1.04.85-1.88 1.88-1.88ZM29.04 8.81h7.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "13.26",
        y: "15.98",
        width: "20.47",
        height: "8.65",
        rx: "1.09",
        ry: "1.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.25 45.44c-.44-.03-.84-.27-1.11-.62-.52-.7-1.24-2.05-.3-3.28.08-.11.24-.12.33-.01.21.24.69.69.95.69.98 0 1.15-1.68.82-3.01-.32-1.29 3.44 3.46.66 5.85-.23.19-.51.33-.8.37-.15.02-.34.03-.55.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.66 32.53c.47 1.47-.13 3.35-2.41 5.17-.23.21-.43.45-.61.7-.51.72-.81 1.59-.81 2.53 0 2.49 2.1 4.51 4.7 4.51s4.69-2.02 4.7-4.51c0-4.61-5.55-8.4-5.55-8.4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.25 44.58c.16-.2.17-.48 0-.68-1.79-2.2-4.58-4.6-5.87-7.44a10.57 10.57 0 0 1 .08-9.34c.26-.51-.36-1.02-.82-.67-1.72 1.31-3.62 3.88-2.84 7.81.92 4.71 5.84 10.35 7.33 11.98.23.25.61.23.82-.03l1.3-1.63Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.67 45.98c.23.48.8.69 1.29.47.2-.1.37-.26.47-.47l5.69-8.85A7.902 7.902 0 0 0 46 26.15a7.902 7.902 0 0 0-10.98 2.12 7.923 7.923 0 0 0 0 8.87l5.66 8.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.96 32.7c0 1.87-1.52 3.39-3.39 3.39s-3.39-1.52-3.39-3.39 1.52-3.39 3.39-3.39 3.39 1.52 3.39 3.39Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GasMeter56 = (GasMeter56);
;// ./src/Picto/GeneratedPictoComponents/GreenEnergy104.tsx


var GreenEnergy104_excluded = ["className"];
function GreenEnergy104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GreenEnergy104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GreenEnergy104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GreenEnergy104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GreenEnergy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GreenEnergy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GreenEnergy104_objectSpread(GreenEnergy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.41 46.25c-1.36-1.02-3.4-.79-4.61-1.98-.6-.59-.89-1.44-1.44-2.07-1.52-1.7-4.21-1.17-6.42-1.65-1.59-.34-2.98-1.23-4.34-2.11-.78-.5-1.6-1.05-1.99-1.91-.39-.85-.12-2.09.77-2.36 1.13-.35 2.25 1.01 3.38.69 1.14-.32 1.23-1.83 1.61-2.94.62-1.82 2.38-2.95 4.01-3.93l4.61-2.77c.6-.36 1.29-.92 1.13-1.61-.19-.92-1.7-1.12-1.76-2.05-.1-1.38 2.84-1.3 2.69-2.67-.08-.72-1-.94-1.71-.97-1.56-.07-3.11-.12-4.67-.12-1.04 0-2.2.06-2.89.85-.4.46-.55 1.09-.87 1.61-.32.52-.96.97-1.51.7.32-1.13-.33-2.31-1.44-2.63-.37-.11-.76-.1-1.13 0 .53 4.45-.42 9.26-2.93 13.39-1.43 2.27-3.32 3.61-5.19 4.41.65.59 1.07 1.46 1.78 2.02 1.73 1.34 4.58.25 6.16 1.77 1.07 1.03 1.01 2.76.82 4.24s-.4 3.16.51 4.34c.47.62 1.18.99 1.77 1.5 1.79 1.57 2.2 4.17 2.43 6.56.22 2.39.45 4.97 2 6.77.45.53 1.17.99 1.81.75.83-.32.91-1.44 1.04-2.33.32-2.29 1.84-4.21 3.46-5.83 1.36-1.35 2.87-2.63 3.71-4.36.83-1.74.75-4.13-.78-5.28ZM26.44 84.45 12.67 70.51c-.45-.46-1.18-.47-1.65-.02L7.1 74.23c-.53.5-.27 1.4.44 1.54l3.51.69c1.9.38 3.68 1.22 5.18 2.45l10.45 7.78c.63.52 1.5-.38.94-.97 0 0-1.17-1.26-1.18-1.26ZM75.87 34.34c-2.04-.36-4.05-1.01-6.12-1.28-1.56-.2-3.27-.14-4.53.81-1.86 1.38-2.1 4.07-2.17 6.42-.03.96-.03 2.01.57 2.76s1.65.95 2.6.94 1.91-.18 2.84.01c1.45.3 2.61 1.47 3.29 2.82.67 1.34.94 2.84 1.2 4.32l1.23 7.13c.13.76.97 1.14 1.63.75.98-.58 1.74-1.66 2.32-2.69 1.94-3.45 3.26-7.22 3.9-11.14.33-2.01.48-4.05.45-6.08-.02-1.23-.19-2.95-1.53-3.56-.73-.33-1.63-.42-2.03-1.01-1.22.1-2.45.04-3.65-.19ZM64.18 74.16c0 .67-.52 1.22-1.18 1.25l-15.88.61c-.51 0-.91-.42-.91-.93s.41-.93.91-.93h17.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M93.16 63.16c.89-.84-.32-2.23-1.28-1.46l-20.3 16.49a10.219 10.219 0 0 1-6.88 2.67H31.67c-1.33 0-2.61.52-3.57 1.45l-1.45 1.41L14.4 71.35c-.12.11-.23.22-.35.33L30.52 88.3l2.01-1.96c.6-.58 1.4-.91 2.23-.91H64.7c2.54 0 4.99-.95 6.88-2.67l21.31-19.4s.11-.08.26-.22Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.32 30.08c.77 2.3-.41 4.78-2.71 5.51-2.31.77-4.79-.48-5.59-2.78M86.72 28.43l-11.67 3.92M73.44 12.77 68.5 23.08M73.19 21.46l-3.17-1.5M66.13 15l-3.41-1.51M75.15 17.5l-2.89-1.4M65.61 16.19l-3.41-1.51M43.42 15.45c4.09-1.84 8.69-2.71 13.48-2.34 3.09.24 6.02.97 8.73 2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.18 35.73c.45 2.35.58 4.81.4 7.3a27.77 27.77 0 0 1-7.56 17.1M68.67 68.06c3.67-.31 17.03-9.67 17.03-9.67s3.6-2.43 6.6.1c3 2.53.6 4.88.6 4.88l-21.31 19.4a10.219 10.219 0 0 1-6.88 2.67H35.55c-1.33 0-2.61.52-3.57 1.45l-1.45 1.41M9.66 71.94l2.5-2.18 21.41 21.62-2.49 2.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.54 74h17.3c2.69 0 4.87-2.21 4.87-4.94 0-2.73-2.18-4.94-4.87-4.94H50.48c-1.71 0-3.33-.72-4.56-1.92-2.53-2.46-6.43-4.04-10.82-4.04-3.7 0-7.15.97-9.52 2.94-2.52 2.1-7.35 6.6-11.53 10.59M68.04 21.41c-2.14-1.13-3.01-3.74-1.85-5.86 1.13-2.15 3.79-2.97 5.97-1.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.53 34.7.6-2.81c.17-.8-.58-1.48-1.36-1.24l-.89.28c-1 .31-2.07-.18-2.51-1.14-1.04-2.26-1.22-4.88.03-7.75.92-1.87 4.95-4.01 4.8-4.4.18-.66-6.12 2.33-7.33 5.69-2.48 5.68.62 10.4 4.95 13.24l.78.52.44-.14.24-1.13.24-1.12Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.6 36.6c2.5-.57 5.38-1.95 7.37-5.11 4.16-6.84 4.06-15.53 0-21.38a.92.92 0 0 0-1.4-.14c-5.63 5.5-16.23 6.7-19.13 12.61-2.69 6.17.67 11.32 5.39 14.4l.92.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.03 40.13c0-8.57 3.85-16.23 9.89-21.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.14 55.49a27.8 27.8 0 0 1-4.06-16.72c.04-.6.11-1.2.19-1.78"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GreenEnergy104 = (GreenEnergy104);
;// ./src/Picto/GeneratedPictoComponents/GreenEnergy56.tsx


var GreenEnergy56_excluded = ["className"];
function GreenEnergy56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GreenEnergy56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GreenEnergy56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GreenEnergy56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GreenEnergy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GreenEnergy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GreenEnergy56_objectSpread(GreenEnergy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.67 24.9c-.73-.55-1.83-.43-2.48-1.07-.32-.32-.48-.77-.78-1.12-.82-.92-2.27-.63-3.46-.89-.85-.18-1.6-.66-2.34-1.14-.42-.27-.86-.57-1.07-1.03-.21-.46-.06-1.12.42-1.27.61-.19 1.21.54 1.82.37.61-.17.66-.98.87-1.58.33-.98 1.28-1.59 2.16-2.12l2.48-1.49c.32-.19.69-.5.61-.87-.1-.5-.91-.6-.95-1.11-.05-.74 1.53-.7 1.45-1.44-.04-.39-.54-.51-.92-.52-.84-.04-1.67-.06-2.51-.07-.56 0-1.19.03-1.56.46-.22.25-.3.59-.47.87-.17.28-.52.52-.81.38.17-.61-.18-1.24-.78-1.42-.2-.06-.41-.06-.61 0 .29 2.4-.23 4.99-1.58 7.21a6.003 6.003 0 0 1-2.79 2.37c.35.32.58.79.96 1.09.93.72 2.46.14 3.32.95.58.55.55 1.49.44 2.28s-.22 1.7.27 2.34c.26.33.64.53.95.81.96.84 1.19 2.25 1.31 3.53.12 1.28.24 2.68 1.08 3.64.24.29.63.54.98.4.45-.17.49-.78.56-1.26.17-1.23.99-2.27 1.86-3.14.73-.73 1.55-1.41 2-2.35.45-.93.4-2.22-.42-2.84ZM14.38 45.47l-7.41-7.51a.63.63 0 0 0-.89-.01l-2.11 2.01c-.28.27-.15.75.24.83l1.89.37c1.02.2 1.98.65 2.79 1.32l5.63 4.19c.34.28.81-.2.5-.52l-.63-.68ZM40.99 18.49c-1.1-.19-2.18-.55-3.3-.69-.84-.11-1.76-.07-2.44.43-1 .74-1.13 2.19-1.17 3.46-.01.52-.01 1.08.31 1.49s.89.51 1.4.51 1.03-.1 1.53 0c.78.16 1.41.79 1.77 1.52.36.72.51 1.53.65 2.33l.66 3.84c.07.41.52.61.88.4.53-.31.94-.89 1.25-1.45 1.05-1.86 1.76-3.89 2.1-6 .18-1.08.26-2.18.24-3.28-.01-.66-.1-1.59-.82-1.92-.39-.18-.88-.23-1.09-.54-.66.06-1.32.02-1.97-.1ZM34.7 39.93c0 .36-.28.66-.64.67l-8.55.33c-.27 0-.49-.22-.49-.5s.22-.5.49-.5h9.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.3 34.01c.48-.45-.17-1.2-.69-.79L38.68 42.1a5.5 5.5 0 0 1-3.71 1.44H17.18c-.72 0-1.4.28-1.92.78l-.78.76-6.6-6.66c-.06.06-.12.12-.19.18l8.87 8.95 1.08-1.05c.32-.31.75-.49 1.2-.49h16.12a5.5 5.5 0 0 0 3.71-1.44l11.48-10.44s.06-.04.14-.12Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.08 16.2c.41 1.24-.22 2.58-1.46 2.97-1.24.41-2.58-.26-3.01-1.5M46.83 15.31l-6.29 2.11M39.69 6.88l-2.66 5.55M39.55 11.55l-1.71-.81M35.75 8.08l-1.84-.82M40.6 9.43l-1.56-.76M35.47 8.72l-1.84-.82M24.56 7.9c1.93-.7 4.04-1.01 6.22-.84 1.66.13 3.24.52 4.7 1.14M23.52 8.32c.34-.15.68-.29 1.04-.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.39 19.24c.24 1.27.31 2.59.22 3.93-.27 3.59-1.78 6.79-4.07 9.21M37.11 36.65c1.98-.16 9.17-5.2 9.17-5.2s1.94-1.31 3.55.06.33 2.63.33 2.63L38.68 44.58a5.5 5.5 0 0 1-3.71 1.44h-15.7c-.72 0-1.4.28-1.92.78l-.78.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m5.34 38.74 1.34-1.18 11.54 11.65-1.35 1.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.2 39.85h9.32c1.45 0 2.62-1.19 2.62-2.66 0-1.47-1.17-2.66-2.62-2.66h-7.19c-.92 0-1.79-.39-2.46-1.04-1.36-1.32-3.46-2.17-5.82-2.17-1.99 0-3.85.52-5.13 1.58-1.36 1.13-3.96 3.55-6.21 5.7M36.77 11.53c-1.15-.61-1.62-2.01-1-3.15.61-1.16 2.04-1.6 3.21-1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m14.96 18.69.37-1.73c.07-.33-.24-.62-.56-.51l-.31.1c-.77.24-1.63-.14-1.91-.9-.4-1.12-.41-2.39.19-3.76.49-1.01 2.48-2.06 2.59-2.37.17-.56-3.35 1.33-3.95 3.06-1.33 3.06.33 5.6 2.67 7.13l.42.28.24-.07.13-.61.13-.6Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.23 19.71c1.35-.31 2.9-1.05 3.97-2.75 2.24-3.68 2.19-8.36 0-11.51a.5.5 0 0 0-.76-.07c-3.03 2.96-8.74 3.61-10.3 6.79-1.45 3.32.36 6.09 2.9 7.75l.36.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.7 22.13v-.52c0-4.62 2.07-8.74 5.32-11.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.98 29.99a14.995 14.995 0 0 1-2.26-9.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GreenEnergy56 = (GreenEnergy56);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveNetworksCentre104.tsx


var AdaptiveNetworksCentre104_excluded = ["className"];
function AdaptiveNetworksCentre104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveNetworksCentre104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveNetworksCentre104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveNetworksCentre104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveNetworksCentre104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveNetworksCentre104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveNetworksCentre104_objectSpread(AdaptiveNetworksCentre104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.14 92.48 24.8-.22c-.07 0-.27-.18-.33-.22-1-.66-1.97-.99-3.25-1.12-.68-.07-1.36-.1-2.05-.16-1.47-.12-2.92-.3-4.37-.54-1.33-.22-2.66-.5-3.95-.84-8.34-2.17-15.29-7.16-19.23-13.54-.42-.68-.81-1.37-1.17-2.07s-.67-1.36-.97-2.05-.55-1.32-.79-1.99c-.23-.63-.44-1.27-.63-1.91-.18-.59-.34-1.19-.49-1.79a43.4 43.4 0 0 1-.37-1.64c-.1-.48-.19-.97-.27-1.46-.07-.41-.13-.83-.19-1.24-.19-1.29-1.32-2.34-2.85-2.66l-.24-.05-.52 18.22 4.16 8.9 6.38 4.98 6.32 1.37Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.15 69.25c1.7.18 17.58.51 18.96-.29-24.1-3.29-24.92-6.07-24.92-15.87-1.49 1.09-3.84 4.5-3.43 7.24.79 5.27 3.43 8.27 9.39 8.91Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.75 39.37-5.91-2.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.03 30.1 4.98 4.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.44 30.35-3.7-5.39"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.64 51.17a9.69 9.69 0 0 1-.67-3.54c0-5.34 4.33-9.67 9.67-9.67 1.93 0 3.72.56 5.23 1.54a12.29 12.29 0 0 1 10.61-6.09c6.79 0 12.29 5.5 12.29 12.29v.36c5.4 1.31 9.4 6.04 9.4 11.68 0 6.65-5.56 12.04-12.43 12.04H35.08a9.36 9.36 0 0 1-9.36-9.36c0-4.68 3.44-8.56 7.92-9.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.99",
        y: "11",
        width: "82",
        height: "82",
        rx: "19.09",
        ry: "19.09"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveNetworksCentre104 = (AdaptiveNetworksCentre104);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveNetworksCentre56.tsx


var AdaptiveNetworksCentre56_excluded = ["className"];
function AdaptiveNetworksCentre56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveNetworksCentre56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveNetworksCentre56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveNetworksCentre56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveNetworksCentre56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveNetworksCentre56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveNetworksCentre56_objectSpread(AdaptiveNetworksCentre56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.69 49-.17-.12c-.53-.35-1.06-.53-1.74-.6-.36-.04-.73-.06-1.1-.09-.78-.07-1.57-.16-2.34-.29-.71-.12-1.42-.27-2.12-.45-4.47-1.16-8.19-3.84-10.3-7.25-.22-.36-.43-.73-.63-1.11s-.36-.73-.52-1.1-.29-.71-.42-1.07c-.12-.34-.23-.68-.34-1.02-.09-.32-.18-.64-.26-.96-.07-.29-.14-.58-.2-.88l-.15-.78c-.04-.22-.07-.44-.1-.66-.1-.69-.71-1.25-1.53-1.42l-.13-.03v8.37l1.56 5.63 2.82 2.55 2.64 1.47h14.58l.42-.21Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.16 37.02c.94.1 9.68.28 10.44-.16-13.27-1.81-13.72-3.34-13.72-8.74-.82.6-2.11 2.48-1.89 3.99.43 2.9 1.89 4.55 5.17 4.91Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.76 21.24-3.35-1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.79 15.97 2.83 2.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.14 16.12-2.1-3.07"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.04 27.22A5.15 5.15 0 0 1 25.62 21a6.546 6.546 0 0 1 5.66-3.24c3.62 0 6.55 2.93 6.55 6.55v.19c2.88.7 5.01 3.22 5.01 6.23 0 3.54-2.97 6.42-6.63 6.42H18.8c-2.76 0-4.99-2.23-4.99-4.99 0-2.5 1.83-4.56 4.22-4.93Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6.58",
        y: "6.58",
        width: "42.84",
        height: "42.84",
        rx: "10",
        ry: "10"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveNetworksCentre56 = (AdaptiveNetworksCentre56);
;// ./src/Picto/GeneratedPictoComponents/BroadbandEnterpriseSim104.tsx


var BroadbandEnterpriseSim104_excluded = ["className"];
function BroadbandEnterpriseSim104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandEnterpriseSim104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandEnterpriseSim104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandEnterpriseSim104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandEnterpriseSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandEnterpriseSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandEnterpriseSim104_objectSpread(BroadbandEnterpriseSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34 21.45c0-.78.84-1.26 1.52-.86 5.04 2.95 6.03 10.52 6.4 15.75.53 7.31-.53 14.63-.04 21.94.42 6.34 1.04 17.39 8.71 19.39 7.41 1.93 20.9 2.19 19.28 13.57-.15 1.02-1.07 2.75-2.29 2.75H37.36c-1.82 0-3.31-1.2-3.36-3.06-.01-.44 0-.88 0-1.32V21.44Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47 85h10M70 82.05V92c0 1.1-.9 2-2 2H36c-1.1 0-2-.9-2-2V12c0-1.1.9-2 2-2h32c1.1 0 2 .9 2 2v22.94"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.45 28.83c3.5 5.15 5.55 11.34 5.55 18s-2.05 12.85-5.55 18M82 33.07c1.62 2.38 2.83 5.06 3.53 7.93M15.55 64.83c-3.5-5.15-5.55-11.34-5.55-18 0-6.67 2.05-12.85 5.55-18M22 60.6c-2.67-3.94-4.24-8.67-4.24-13.76s1.57-9.83 4.24-13.77M66.01 68.58 66 72.76M71.41 68.6v4.18M71.43 60.61v-4.06M66.02 60.59l.01-4.06M76.89 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.99 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandEnterpriseSim104 = (BroadbandEnterpriseSim104);
;// ./src/Picto/GeneratedPictoComponents/BroadbandEnterpriseSim56.tsx


var BroadbandEnterpriseSim56_excluded = ["className"];
function BroadbandEnterpriseSim56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandEnterpriseSim56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandEnterpriseSim56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandEnterpriseSim56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandEnterpriseSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandEnterpriseSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandEnterpriseSim56_objectSpread(BroadbandEnterpriseSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.76 12.74c0-.4.43-.65.78-.44 2.59 1.52 3.1 5.4 3.29 8.09.27 3.75-.27 7.51-.02 11.27.22 3.25.53 8.93 4.48 9.96 3.81.99 10.74 1.13 9.9 6.97-.07.52-.55 1.41-1.17 1.41H20.5c-.93 0-1.7-.62-1.73-1.57V12.74Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.44 44.89h5.12M37.21 44.83v3.67c0 .55-.45 1-1 1H19.78c-.55 0-1-.45-1-1v-41c0-.55.45-1 1-1h16.43c.55 0 1 .45 1 1v12.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.57 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-1.54-.55-6.61-2.89-8.37-7.14-1.76-4.24-1.41-5.66-2.32-5.94-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.66 16.14a16.365 16.365 0 0 1 0 18.43M43.36 18.31c.95 1.39 1.62 2.98 1.95 4.69M9.34 34.57a16.365 16.365 0 0 1 0-18.43M12.64 32.4c-1.37-2.02-2.17-4.44-2.17-7.04s.8-5.03 2.17-7.05M35.4 37.02l-.01 2.68M38.12 37.03v2.68M38.13 33.5v-2.69M35.4 33.49l.01-2.7M40.92 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.2 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.41 26.86-.08 14.06c0 .51-.47.91-1.05.91H31.45c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandEnterpriseSim56 = (BroadbandEnterpriseSim56);
;// ./src/Picto/GeneratedPictoComponents/BroadbandMobileSim104.tsx


var BroadbandMobileSim104_excluded = ["className"];
function BroadbandMobileSim104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandMobileSim104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandMobileSim104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandMobileSim104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandMobileSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobileSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobileSim104_objectSpread(BroadbandMobileSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.49 40.43s4.87 1.8 5.26 1.97c2.72 1.19 4.56 2.21 6.22 4.41 4.03 5.33 3.78 11.84 5.32 17.76.98 3.79 2.37 7.95 5.47 11.1 4.06 4.13 10.02 4.29 16.01 5.29 4.69.78 12.77 2.67 13.53 7.22H57.22c-9.23 0-18.45.16-27.69.04-1.77-.02-4.48-1.4-5.57-2.65-1.59-1.83-1.46-2.67-1.45-4.79.01-3.07.01-6.14.01-9.2V40.43Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.09 65.89H31.91c-1.1 0-2-.9-2-2V43.75c0-1.1.9-2 2-2h27.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.2",
        cy: "77.56",
        r: "2.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.69 82.06c-.85 3.51-4.01 6.12-7.78 6.12H30.49c-4.42 0-8-3.58-8-8V36.75c0-4.42 3.58-8 8-8h43.44c3.82 0 7.01 2.67 7.81 6.24"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.23 15.81c3-.3 6.04.29 8.73 1.9s4.65 4 5.82 6.78M77.24 19.67c2.29-.23 4.61.23 6.67 1.45 2.06 1.23 3.56 3.06 4.45 5.19M26.77 15.81c-3-.3-6.04.29-8.73 1.9-2.69 1.61-4.65 4-5.82 6.78M26.76 19.67c-2.29-.23-4.61.23-6.67 1.45-2.06 1.23-3.56 3.06-4.45 5.19M75.02 68.49l-.01 4.13M80.42 68.51l-.01 4.13M80.43 60.78l.01-4.34M75.03 60.76l.01-4.34M85.9 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m93 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobileSim104 = (BroadbandMobileSim104);
;// ./src/Picto/GeneratedPictoComponents/BroadbandMobileSim56.tsx


var BroadbandMobileSim56_excluded = ["className"];
function BroadbandMobileSim56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandMobileSim56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandMobileSim56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandMobileSim56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandMobileSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobileSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobileSim56_objectSpread(BroadbandMobileSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 21.77s2.62.97 2.83 1.06c1.47.64 2.45 1.19 3.35 2.37 2.17 2.87 2.04 6.38 2.86 9.56.53 2.04 1.28 4.28 2.94 5.98 2.18 2.22 5.4 2.31 8.62 2.85 2.52.42 6.87 1.44 7.28 3.89h-9.2c-4.97 0-9.94.08-14.91.02-.95-.01-2.41-.75-3-1.43-.86-.99-.79-1.44-.78-2.58V21.76Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.44 35.48H17.11c-.55 0-1-.45-1-1v-11c0-.55.45-1 1-1h15.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.11",
        cy: "41.76",
        r: "1.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.54 44.83a4.987 4.987 0 0 1-4.41 2.65H17.11c-2.76 0-5-2.24-5-5v-22c0-2.76 2.24-5 5-5h21.98c2.46 0 4.51 1.78 4.92 4.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.58 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-1.54-.55-6.61-2.89-8.37-7.14-1.76-4.24-1.41-5.66-2.32-5.94-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.58 8.51c1.62-.16 3.25.16 4.7 1.02s2.51 2.15 3.13 3.65M41.59 10.59c1.23-.12 2.48.12 3.59.78s1.92 1.65 2.4 2.79M14.42 8.51c-1.62-.16-3.25.16-4.7 1.02s-2.51 2.15-3.13 3.65M14.41 10.59c-1.23-.12-2.48.12-3.59.78s-1.92 1.65-2.4 2.79M40.4 37.3v2.03M43.13 37.31l-.01 2.03M43.13 33.16l.01-1.96M40.41 33.15v-1.96M45.92 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.21 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.42 26.86-.08 14.06c0 .51-.47.91-1.05.91H36.46c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobileSim56 = (BroadbandMobileSim56);
;// ./src/Picto/GeneratedPictoComponents/Document104.tsx


var Document104_excluded = ["className"];
function Document104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Document104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Document104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Document104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Document104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Document104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Document104_objectSpread(Document104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM19.04 60.45l1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.19 52.39h43.33M29.19 65.26h43.33M29.19 78.12H54.3M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.06 92.68h33.22c2.16 0 3.94-1.83 3.94-4.06V24.93c0-.52-.19-1.02-.54-1.4L72.07 9.81c-.37-.4-.89-.63-1.43-.63H23.78c-2.17 0-3.94 1.82-3.94 4.06v75.38c0 2.23 1.77 4.06 3.94 4.06H57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.19 39.53h43.33",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Document104 = (Document104);
;// ./src/Picto/GeneratedPictoComponents/Document56.tsx


var Document56_excluded = ["className"];
function Document56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Document56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Document56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Document56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Document56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Document56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Document56_objectSpread(Document56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m11.01 32.94.45 13.85c0 1.66 1.34 3 3 3h15.77c2.55 0 1.48-1.83.39-1.92-7.9-.63-17.44-5.88-18.65-14.81 0-.83-.95-.78-.95-.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.99 14.18v33.1c0 1.17-.92 2.11-2.05 2.11H13.06c-1.12 0-2.05-.95-2.05-2.11V8.1c0-1.17.92-2.11 2.05-2.11h24.35a1 1 0 0 1 .74.33l6.55 7.13c.18.2.28.46.28.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.58 6.4v5.94c0 1.21.92 2.19 2.05 2.19h5.35"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.87 28.68h22.52M15.87 35.25h22.52M15.87 41.82h13.48"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M15.87 22.11h22.52",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Document56 = (Document56);
;// ./src/Picto/GeneratedPictoComponents/DownloadDoc104.tsx


var DownloadDoc104_excluded = ["className"];
function DownloadDoc104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DownloadDoc104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DownloadDoc104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DownloadDoc104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DownloadDoc104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DownloadDoc104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DownloadDoc104_objectSpread(DownloadDoc104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.66 51.64c3.55 18.56 13.8 23.37 16.89 25.77 3.2 2.49 3.74 5.56 3.22 6.3H14.25s-3.12-.15-3.12-3.87V43.31c1.65 0 3.54 8.32 3.54 8.32",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.12 83.71H15.56c-2.44 0-4.42-1.98-4.42-4.43V15.54c0-2.45 1.98-4.43 4.42-4.43h37.48c1.17 0 2.3.47 3.13 1.3l9.67 9.69c.83.83 1.3 1.96 1.3 3.14v6.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.78 11.24v8.33c0 2.47 2.01 4.48 4.5 4.48h7.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.18 56.4c2.38 11.73 11.36 26.62 19.56 33.48.88.72.26 2.35-.88 2.08-17.27-3.16-25.11-18.68-20.88-35.64.26-1.17 1.94-1.08 2.2.09",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "64.52",
        cy: "64.15",
        rx: "28.35",
        ry: "28.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.53 65.25v7.72H49.52v-7.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.66 59.25 6.86 7.71 6.86-7.71M64.52 50.67v15.44"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DownloadDoc104 = (DownloadDoc104);
;// ./src/Picto/GeneratedPictoComponents/DownloadDoc56.tsx


var DownloadDoc56_excluded = ["className"];
function DownloadDoc56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DownloadDoc56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DownloadDoc56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DownloadDoc56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DownloadDoc56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DownloadDoc56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DownloadDoc56_objectSpread(DownloadDoc56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M8.36 27.81c1.87 9.76 7.26 12.29 8.88 13.56 1.68 1.31 1.97 2.92 1.69 3.31H8.13s-1.64-.08-1.64-2.03V23.44c.87 0 1.86 4.37 1.86 4.37",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.23 44.68H8.84c-1.28 0-2.32-1.04-2.33-2.33V8.82c0-1.29 1.04-2.33 2.32-2.33h19.72c.62 0 1.21.25 1.64.68l5.09 5.1c.44.44.68 1.03.68 1.65v3.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.94 6.56v4.38c0 1.3 1.06 2.36 2.37 2.36h4.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.78 30.32c1.25 6.17 5.98 14 10.29 17.61.46.38.14 1.23-.46 1.09-9.08-1.66-13.21-9.82-10.98-18.75.14-.62 1.02-.57 1.16.05",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.48 34.97v4.06H26.69v-4.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.59",
        cy: "34.39",
        rx: "14.91",
        ry: "15.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.98 31.81 3.61 4.06 3.61-4.06M34.59 27.3v8.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DownloadDoc56 = (DownloadDoc56);
;// ./src/Picto/GeneratedPictoComponents/EnterpriseCloud104.tsx


var EnterpriseCloud104_excluded = ["className"];
function EnterpriseCloud104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnterpriseCloud104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnterpriseCloud104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnterpriseCloud104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnterpriseCloud104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnterpriseCloud104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnterpriseCloud104_objectSpread(EnterpriseCloud104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.57 78.84c2.53.27 26.11.76 28.17-.43-35.8-4.89-37.03-9.02-37.03-23.58-2.22 1.62-5.7 6.69-5.1 10.76 1.17 7.83 5.1 12.29 13.95 13.24Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.93 51.36a14.52 14.52 0 0 1-1.01-5.33c0-8.04 6.52-14.56 14.56-14.56 2.9 0 5.61.85 7.88 2.31 3.21-5.48 9.17-9.17 15.98-9.17 10.22 0 18.51 8.29 18.51 18.51v.54c8.13 1.97 14.16 9.1 14.16 17.59 0 10.01-8.38 18.13-18.72 18.13H25.1c-7.79 0-14.1-6.31-14.1-14.1 0-7.05 5.17-12.89 11.93-13.93Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.28 31.5-7.69-4.3m6.19-8.3 6.31 6.15m6.31-4.99-4.5-7.57"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnterpriseCloud104 = (EnterpriseCloud104);
;// ./src/Picto/GeneratedPictoComponents/EnterpriseCloud56.tsx


var EnterpriseCloud56_excluded = ["className"];
function EnterpriseCloud56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EnterpriseCloud56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EnterpriseCloud56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EnterpriseCloud56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EnterpriseCloud56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EnterpriseCloud56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EnterpriseCloud56_objectSpread(EnterpriseCloud56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.97 41.83c1.29.14 13.35.39 14.4-.22C10.07 39.11 9.45 37 9.45 29.56c-1.13.83-2.92 3.42-2.6 5.5.6 4 2.6 6.28 7.13 6.77Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.97 27.67c-.34-.85-.52-1.78-.52-2.76 0-4.16 3.37-7.53 7.53-7.53 1.5 0 2.9.44 4.07 1.2a9.575 9.575 0 0 1 8.26-4.74c5.29 0 9.57 4.28 9.57 9.57v.28c4.2 1.02 7.32 4.7 7.32 9.09 0 5.18-4.33 9.37-9.68 9.37H14.09c-4.03 0-7.29-3.26-7.29-7.29 0-3.64 2.67-6.66 6.17-7.2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.12 16.86-3.93-2.2m3.17-4.24 3.22 3.14m3.22-2.55-2.3-3.87"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EnterpriseCloud56 = (EnterpriseCloud56);
;// ./src/Picto/GeneratedPictoComponents/GlobalNetworks104.tsx


var GlobalNetworks104_excluded = ["className"];
function GlobalNetworks104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GlobalNetworks104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GlobalNetworks104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GlobalNetworks104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GlobalNetworks104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalNetworks104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalNetworks104_objectSpread(GlobalNetworks104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.21 13.28s4.91 1.78 3.05 3.66c-1.86 1.88-17.13 10.98-18.04 33.75.88 12.17 6.03 23.71 14.74 32.26 3.25 3.19 7.22 6.43 12.03 9.46l-2.03.81-8.57-1.83-5.06-3.4-6.59-5.54-5.99-6.81-5.62-10.4-1.53-6.13-.6-13.04 2.52-8.44 3.81-7.08 3.46-5.5 5.68-4.56 5.28-4.06 3.45-3.15Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M94 52c0 1.03-.04 2.06-.11 3.07a41.831 41.831 0 0 1-6.92 20.21C79.44 86.57 66.59 94 52 94c-.83 0-1.66-.02-2.48-.07-.49-.03-.98-.07-1.47-.11-16.82-1.57-30.77-13.06-35.92-28.57-.66-1.98-1.17-4.03-1.53-6.13-.39-2.31-.6-4.69-.6-7.11 0-8.63 2.6-16.66 7.07-23.33C24.6 17.42 37.43 10.01 52 10.01c.68 0 1.35.02 2.02.05 5.74.27 11.18 1.7 16.09 4.05 10.46 5 18.52 14.21 22 25.43 1.22 3.94 1.88 8.13 1.88 12.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.18 50.06c-.02.19-.03.37-.05.56-.73 9.34.18 18.29 2.41 26.31 1.74 6.27 4.3 11.98 7.51 16.88M49.52 93.93c.82.05 1.65.07 2.48.07 14.59 0 27.44-7.44 34.97-18.72a41.693 41.693 0 0 0 6.92-20.21c.07-1.01.11-2.04.11-3.07 0-4.34-.66-8.53-1.88-12.48-3.48-11.22-11.55-20.42-22-25.43a41.75 41.75 0 0 0-16.09-4.05c-4.09 4.73-7.6 10.45-10.28 16.9a74.09 74.09 0 0 0-3.54 10.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.19 31.11c-.56-6.13-1.95-11.88-4.08-17.02a41.75 41.75 0 0 0-16.09-4.05c-.67-.03-1.34-.05-2.02-.05-14.56 0-27.39 7.41-34.93 18.67C12.6 35.33 10 43.36 10 51.99c0 2.42.21 4.8.6 7.11.36 2.1.87 4.15 1.53 6.13 5.15 15.51 19.09 27 35.92 28.57M65.83 72.9a80.64 80.64 0 0 0 5.13-12.67 79.519 79.519 0 0 0 3.21-16.08M49.52 93.93c3.36-2.84 6.52-6.19 9.4-9.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.7 79.47a78.17 78.17 0 0 1-15.16-2.53C29.94 74.06 20.77 69.05 14 62.67a45.446 45.446 0 0 1-3.4-3.56c-.39-2.31-.6-4.69-.6-7.11 0-8.63 2.6-16.66 7.07-23.33C24.6 17.41 37.43 10 52 10c.68 0 1.35.02 2.02.05 5.74.27 11.18 1.7 16.09 4.05 10.46 5 18.52 14.21 22 25.43 1.22 3.94 1.88 8.13 1.88 12.48 0 1.03-.04 2.06-.11 3.07a41.831 41.831 0 0 1-6.92 20.21c-5.66 2.07-11.86 3.46-18.41 4.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.88 34.28c-4.61-2.23-9.6-4.06-14.89-5.41-3.44-.88-6.87-1.51-10.24-1.92-9.48-1.14-18.6-.48-26.67 1.72-4.47 6.67-7.07 14.7-7.07 23.33 0 2.42.21 4.8.6 7.11.36 2.1.87 4.15 1.53 6.13 5.15 15.51 19.09 27 35.92 28.57M49.52 93.93c.82.05 1.65.07 2.48.07 14.59 0 27.44-7.44 34.97-18.72a41.693 41.693 0 0 0 6.92-20.21c-3.49-5.16-8.17-9.95-13.81-14.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.97 46.57c-7.75 4.41-14.21 9.95-18.97 16.1-.66.85-1.28 1.71-1.87 2.58 5.15 15.51 19.09 27 35.92 28.57M68.07 36.42c-5.55.27-11.28 1.16-17.05 2.74a81.71 81.71 0 0 0-6.21 1.97M49.52 93.93c.82.05 1.65.07 2.48.07 14.59 0 27.44-7.44 34.97-18.72a41.693 41.693 0 0 0 6.92-20.21c.07-1.01.11-2.04.11-3.07 0-4.34-.66-8.53-1.88-12.48-3.5-1.17-7.24-2.04-11.15-2.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.52 93.93c.82.05 1.65.07 2.48.07 14.59 0 27.44-7.44 34.97-18.72a41.693 41.693 0 0 0 6.92-20.21c.07-1.01.11-2.04.11-3.07 0-4.34-.66-8.53-1.88-12.48-3.48-11.22-11.55-20.42-22-25.43a41.75 41.75 0 0 0-16.09-4.05c-.67-.03-1.34-.05-2.02-.05-14.56 0-27.39 7.41-34.93 18.67-4.47 6.67-7.07 14.7-7.07 23.33 0 2.42.21 4.8.6 7.11.36 2.1.87 4.15 1.53 6.13 5.15 15.51 19.09 27 35.92 28.57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.93 39.08s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08c.03 2.02 1.82 3.59 2.49 3.99 1.42.85.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34ZM77.9 32.77s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08c.03 2.02 1.85 3.55 2.49 3.99 1.19.81.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34ZM64.87 73.21s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08c.03 2.02 1.79 3.65 2.49 3.99 1.69.82.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.56 44.16c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53 6.53 2.92 6.53 6.53ZM81 37.63c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53S81 34.02 81 37.63ZM68.64 78.27c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53 6.53 2.92 6.53 6.53Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalNetworks104 = (GlobalNetworks104);
;// ./src/Picto/GeneratedPictoComponents/GlobalNetworks56.tsx


var GlobalNetworks56_excluded = ["className"];
function GlobalNetworks56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GlobalNetworks56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GlobalNetworks56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GlobalNetworks56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GlobalNetworks56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalNetworks56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalNetworks56_objectSpread(GlobalNetworks56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.05 7.57s2.67.18 1.66 1.19-9.24 5.93-9.73 18.21c.48 6.57 3.25 12.8 7.95 17.41 1.75 1.72 3.89 3.47 6.49 5.11l-1.1.44-4.62-.99-2.73-1.84-3.56-2.99-3.23-3.67-3.03-5.61-.83-3.31L6 24.48l1.36-4.56 2.06-3.82 1.87-2.97 3.07-2.46 2.85-2.19 1.85-.92Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.99 27.99c0 .54-.02 1.08-.06 1.61-.28 3.9-1.58 7.51-3.63 10.58-3.94 5.91-10.67 9.8-18.31 9.8-.44 0-.87-.01-1.3-.04-.26-.01-.52-.03-.77-.06-8.81-.82-16.11-6.84-18.81-14.96a20.36 20.36 0 0 1-.8-3.21C6.1 30.5 6 29.25 6 27.99c0-4.52 1.36-8.72 3.7-12.22C13.64 9.88 20.36 6 27.99 6c.36 0 .71 0 1.06.03 3.01.14 5.85.89 8.42 2.12 5.48 2.62 9.7 7.44 11.52 13.32.64 2.06.99 4.26.99 6.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.76 26.98c0 .1-.02.2-.02.29-.38 4.89.09 9.58 1.26 13.78.91 3.28 2.25 6.27 3.93 8.84M26.7 49.95c.43.03.86.04 1.3.04 7.64 0 14.37-3.89 18.31-9.8A21.921 21.921 0 0 0 50 28c0-2.27-.35-4.47-.99-6.53-1.82-5.88-6.05-10.7-11.52-13.32a21.841 21.841 0 0 0-8.42-2.12c-2.14 2.48-3.98 5.47-5.38 8.85-.74 1.78-1.37 3.67-1.85 5.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.61 17.06c-.3-3.21-1.02-6.22-2.14-8.91a21.841 21.841 0 0 0-8.42-2.12c-.35-.02-.7-.03-1.06-.03-7.63 0-14.34 3.88-18.29 9.77C7.36 19.26 6 23.47 6 27.99c0 1.27.11 2.51.31 3.72.19 1.1.46 2.17.8 3.21 2.7 8.12 10 14.14 18.81 14.96M35.24 38.94a41.67 41.67 0 0 0 2.68-6.64c.87-2.83 1.43-5.66 1.68-8.42M26.7 49.95c1.76-1.49 3.42-3.24 4.92-5.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.93 42.38a40.39 40.39 0 0 1-7.94-1.33c-5.55-1.51-10.35-4.13-13.9-7.47-.64-.6-1.23-1.22-1.78-1.86C6.1 30.51 6 29.26 6 28c0-4.52 1.36-8.72 3.7-12.22 3.94-5.89 10.66-9.77 18.29-9.77.36 0 .71 0 1.06.03 3.01.14 5.85.89 8.42 2.12 5.48 2.62 9.7 7.44 11.52 13.32a22.011 22.011 0 0 1 .93 8.14c-.28 3.9-1.58 7.51-3.63 10.58-2.96 1.08-6.21 1.81-9.64 2.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.83 18.71a40.743 40.743 0 0 0-7.8-2.83c-1.8-.46-3.6-.79-5.36-1-4.96-.6-9.74-.25-13.96.9-2.34 3.49-3.7 7.7-3.7 12.22 0 1.27.11 2.51.31 3.72.19 1.1.46 2.17.8 3.21 2.7 8.12 10 14.14 18.81 14.96M26.7 49.95c.43.03.86.04 1.3.04 7.64 0 14.37-3.89 18.31-9.8 2.05-3.07 3.34-6.68 3.63-10.58-1.83-2.7-4.28-5.21-7.23-7.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.03 25.15c-4.06 2.31-7.44 5.21-9.93 8.43-.34.44-.67.89-.98 1.35 2.7 8.12 10 14.14 18.81 14.96M36.41 19.83c-2.91.14-5.91.61-8.93 1.43-1.11.3-2.19.65-3.25 1.03M26.7 49.95c.43.03.86.04 1.3.04 7.64 0 14.37-3.89 18.31-9.8A21.921 21.921 0 0 0 50 28c0-2.27-.35-4.47-.99-6.53a31.51 31.51 0 0 0-5.84-1.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.7 49.95c.43.03.86.04 1.3.04 7.64 0 14.37-3.89 18.31-9.8A21.921 21.921 0 0 0 50 28c0-2.27-.35-4.47-.99-6.53-1.82-5.88-6.05-10.7-11.52-13.32a21.841 21.841 0 0 0-8.42-2.12c-.35-.02-.7-.03-1.06-.03-7.63 0-14.34 3.88-18.29 9.77-2.34 3.49-3.7 7.7-3.7 12.22 0 1.27.11 2.51.31 3.72.19 1.1.46 2.17.8 3.21 2.7 8.12 10 14.14 18.81 14.96"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.45 21.24s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41-1.08-1.45-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68ZM41.01 17.66s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41-1.08-1.45-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68ZM34.29 39.06s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41-1.08-1.45-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.62 23.89c0 1.89-1.53 3.42-3.42 3.42s-3.42-1.53-3.42-3.42 1.53-3.42 3.42-3.42 3.42 1.53 3.42 3.42ZM43.18 20.47c0 1.89-1.53 3.42-3.42 3.42s-3.42-1.53-3.42-3.42 1.53-3.42 3.42-3.42 3.42 1.53 3.42 3.42ZM36.71 41.75c0 1.89-1.53 3.42-3.42 3.42s-3.42-1.53-3.42-3.42 1.53-3.42 3.42-3.42 3.42 1.53 3.42 3.42Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalNetworks56 = (GlobalNetworks56);
;// ./src/Picto/GeneratedPictoComponents/IOT104.tsx


var IOT104_excluded = ["className"];
function IOT104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IOT104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IOT104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IOT104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IOT104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOT104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOT104_objectSpread(IOT104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.9 34.83s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08 1.83 3.59 2.49 3.99c1.99 1.2.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34ZM86.57 18.14s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08 1.85 3.56 2.49 3.99c1.32.89.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34ZM22.57 83.14s.54 1.19-.94 1.9-4.47 1.06-4.44 3.08 1.79 3.66 2.49 3.99c1.87.89.96 2.2.96 2.2l-4.88-.81-2.15-2.87-.29-3.43 1.02-2.54 2.13-1.93 3.2-1.04 1.17.1 1.72 1.34Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.53 40c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53 6.53 2.92 6.53 6.53ZM90.53 23.45c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53 6.53 2.92 6.53 6.53ZM26.53 88c0 3.6-2.92 6.53-6.53 6.53s-6.53-2.92-6.53-6.53 2.92-6.53 6.53-6.53 6.53 2.92 6.53 6.53ZM25.46 82.78 41.29 68M78.95 29.01 65.48 43.64M26.74 43.22l11.62 5.6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.62 9.95s.67 1.46-1.15 2.32-5.47 1.29-5.42 3.76 2.19 4.46 3.05 4.88c2.24 1.09 1.17 2.69 1.17 2.69l-5.96-.99-2.63-3.5-.35-4.19 1.24-3.1 2.61-2.36 3.91-1.27 1.43.13 2.11 1.64ZM84.54 76.06s.67 1.46-1.15 2.32-5.47 1.29-5.42 3.76 2.24 4.37 3.05 4.88c1.55.98 1.17 2.69 1.17 2.69l-5.96-.99-2.63-3.5-.35-4.19 1.24-3.1 2.61-2.36 3.91-1.27 1.43.13 2.11 1.64ZM62.57 42.62s1.5 3.28-2.6 5.23c-4.1 1.96-12.31 2.91-12.22 8.46.09 5.55 5.18 9.66 6.86 10.99 3.39 2.69 2.64 6.06 2.64 6.06l-13.42-2.24-5.91-7.89-.8-9.44 2.8-6.99 5.87-5.31 8.82-2.87 3.21.29 4.74 3.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.84",
        cy: "56.29",
        r: "17.19",
        transform: "rotate(-77.15 53.835 56.292)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.47",
        cy: "15.89",
        r: "7.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.84 76.43-8.6-8.25M44.2 42.06 30.71 22.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "80.44",
        cy: "82.23",
        r: "7.56"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOT104 = (IOT104);
;// ./src/Picto/GeneratedPictoComponents/IOT56.tsx


var IOT56_excluded = ["className"];
function IOT56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IOT56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IOT56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IOT56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IOT56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IOT56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IOT56_objectSpread(IOT56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.22 19.43s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41L8.7 23.2l-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68ZM45.29 10.55s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41-1.08-1.45-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68ZM13.09 43.94s.27.6-.48.96-2.26.53-2.24 1.55.88 1.9 1.26 2.01.48 1.11.48 1.11l-2.46-.41-1.08-1.45-.15-1.73.51-1.28 1.08-.97 1.62-.53.59.05.87.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.26 22c0 1.89-1.53 3.42-3.42 3.42S8.42 23.89 8.42 22s1.53-3.42 3.42-3.42 3.42 1.53 3.42 3.42ZM47.42 13c0 1.89-1.53 3.42-3.42 3.42s-3.42-1.53-3.42-3.42S42.11 9.58 44 9.58s3.42 1.53 3.42 3.42ZM15.42 46.62c0 1.89-1.53 3.42-3.42 3.42s-3.42-1.53-3.42-3.42S10.11 43.2 12 43.2s3.42 1.53 3.42 3.42ZM14.4 44.07l8.11-7.69M41.79 16.09l-6.9 7.62M15.06 23.49l5.95 2.91"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.47 23.14s.78 1.71-1.36 2.73-6.43 1.52-6.38 4.42 2.71 5.04 3.58 5.74c1.77 1.41 1.38 3.16 1.38 3.16l-7-1.17-3.09-4.12-.42-4.93 1.46-3.65 3.06-2.77 4.6-1.5 1.68.15 2.48 1.93ZM16.96 6.12s.35.77-.61 1.23-2.9.69-2.88 1.99 1.16 2.37 1.62 2.59c1.19.58.62 1.43.62 1.43l-3.16-.53-1.39-1.86-.19-2.22.66-1.65 1.38-1.25 2.08-.68.76.07 1.12.87ZM44.6 40.25s.35.77-.61 1.23-2.9.69-2.88 1.99 1.19 2.32 1.62 2.59c.82.52.62 1.43.62 1.43l-3.16-.53-1.39-1.86-.19-2.22.66-1.65 1.38-1.25 2.08-.68.76.07 1.12.87Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28.93",
        cy: "30.29",
        rx: "8.8",
        ry: "8.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42.48",
        cy: "43.49",
        rx: "3.87",
        ry: "3.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "14.92",
        cy: "9.27",
        rx: "3.87",
        ry: "3.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.69 40.77-4.41-4.3M24 22.89l-6.91-10.36"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IOT56 = (IOT56);
;// ./src/Picto/GeneratedPictoComponents/LatestInvoices104.tsx


var LatestInvoices104_excluded = ["className"];
function LatestInvoices104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LatestInvoices104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LatestInvoices104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LatestInvoices104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function LatestInvoices104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, LatestInvoices104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", LatestInvoices104_objectSpread(LatestInvoices104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.43 62.91c3.68-6.88 7.23-10.42 9.87-12.23.96-.66.55-2.14-.61-2.22l-6.87-.44-3.75 4.29-.25 10.19c-.02.9 1.18 1.2 1.6.42Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.61 43.86v9.95M93 69.74v18.42c0 2.75-2.22 4.97-4.97 4.97H53.21c-2.75 0-4.97-2.22-4.97-4.97V53.34c0-2.75 2.22-4.97 4.97-4.97h34.82A4.97 4.97 0 0 1 93 53.34v16.65M80.49 43.86v9.95M48.24 58.7H93"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 31.64v5.42c1.68-.27 2.77-1.28 2.77-2.81 0-1.26-.73-2.14-2.68-2.57l-.08-.03Zm-1.98-3.32v-5.09c-1.67.27-2.57 1.34-2.57 2.74 0 1.13.67 1.88 2.57 2.35ZM27.92 37v-5.79l-.83-.19c-3.05-.7-4.56-2.31-4.56-4.77 0-3.16 2.34-5.2 5.45-5.49v-2.22h2.04v2.25c2.71.37 4.99 2.12 5.25 5.25h-2.95c-.13-1.34-.86-2.41-2.31-2.76v5.49l1.21.27c2.74.64 4.39 2.28 4.39 4.96 0 3.29-2.23 5.25-5.66 5.55v2.65h-2.04v-2.68c-3.44-.37-5.71-2.49-5.79-5.87h3.05c.08 1.68.97 2.98 2.74 3.35Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.68 84.75c-6.03 0-10.99-4.96-10.99-10.99 0-1.49.3-2.91.85-4.21.17-.41-.38-.73-.65-.37a10.928 10.928 0 0 0-2.12 8.42c.75 4.63 4.44 8.32 9.07 9.07 3.16.51 6.13-.37 8.42-2.12.35-.27.04-.82-.37-.65-1.3.55-2.72.85-4.21.85M15.07 51.17c4.08 21.34 15.88 26.87 19.43 29.64 3.68 2.87 4.3 6.39 3.7 7.25H14.59S11 87.89 11 83.61V41.6c1.9 0 4.07 9.57 4.07 9.57"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.44 73.91c.11.63.17 1.27.17 1.91 0 6.03-4.96 10.99-10.99 10.99s-10.99-4.96-10.99-11 4.96-10.99 10.99-10.99c1.93 0 3.83.51 5.5 1.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.39 68.59 69.6 79.39l-3.24-3.24M44.06 88.06H15.72a4.71 4.71 0 0 1-4.7-4.71V15.57c0-2.6 2.1-4.71 4.7-4.71h39.86c1.25 0 2.44.5 3.33 1.38l10.28 10.31c.88.88 1.38 2.08 1.38 3.33v18.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.36 11.01v8.86c0 2.63 2.14 4.76 4.79 4.76h8.33"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_LatestInvoices104 = (LatestInvoices104);
;// ./src/Picto/GeneratedPictoComponents/LatestInvoices56.tsx


var LatestInvoices56_excluded = ["className"];
function LatestInvoices56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function LatestInvoices56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? LatestInvoices56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : LatestInvoices56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function LatestInvoices56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, LatestInvoices56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", LatestInvoices56_objectSpread(LatestInvoices56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.65 33.72c1.93-3.61 3.79-5.46 5.18-6.41.5-.34.29-1.12-.32-1.16l-3.6-.23-1.96 2.25-.13 5.34c-.01.47.62.63.84.22Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.52 23.73v5.22M49.5 37.3v9.66c0 1.44-1.17 2.61-2.61 2.61H28.63c-1.44 0-2.61-1.17-2.61-2.61V28.7c0-1.44 1.17-2.61 2.61-2.61h18.26c1.44 0 2.61 1.17 2.61 2.61v8.73M42.94 23.73v5.22M26.03 31.51H49.5"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.44 17.32v2.84c.88-.14 1.45-.67 1.45-1.48 0-.66-.38-1.12-1.41-1.35l-.04-.02Zm-1.04-1.74v-2.67c-.87.14-1.35.7-1.35 1.44 0 .59.35.98 1.35 1.23Zm-.03 4.55v-3.04l-.44-.1c-1.6-.37-2.39-1.21-2.39-2.5 0-1.66 1.22-2.73 2.86-2.88v-1.16h1.07v1.18c1.42.2 2.61 1.11 2.76 2.76h-1.55c-.07-.7-.45-1.26-1.21-1.45v2.88l.63.14c1.44.34 2.3 1.19 2.3 2.6 0 1.73-1.17 2.76-2.97 2.91v1.39h-1.07v-1.41c-1.8-.2-3-1.3-3.04-3.08h1.6c.04.88.51 1.56 1.44 1.76Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.84 45.17c-3.16 0-5.76-2.6-5.76-5.76 0-.78.16-1.53.45-2.21.09-.22-.2-.38-.34-.19a5.688 5.688 0 0 0-1.11 4.41c.39 2.43 2.33 4.36 4.76 4.76 1.66.27 3.22-.19 4.41-1.11.19-.14.02-.43-.19-.34-.68.29-1.43.45-2.21.45M8.64 27.56c2.14 11.19 8.33 14.09 10.19 15.55 1.93 1.5 2.26 3.35 1.94 3.8H8.39s-1.88-.09-1.88-2.33V22.55c.99 0 2.14 5.02 2.14 5.02"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.44 39.49c.06.33.09.67.09 1 0 3.16-2.6 5.76-5.76 5.76s-5.76-2.6-5.76-5.77 2.6-5.76 5.76-5.76c1.01 0 2.01.27 2.88.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.89 36.7-5.66 5.66-1.7-1.69M23.84 46.91H8.98c-1.36 0-2.46-1.1-2.47-2.47V8.9c0-1.36 1.1-2.47 2.46-2.47h20.9c.65 0 1.28.26 1.74.72l5.39 5.4c.46.46.72 1.09.72 1.75v9.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.28 6.5v4.65c0 1.38 1.12 2.5 2.51 2.5h4.37"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_LatestInvoices56 = (LatestInvoices56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesAccess104.tsx


var ManageDevicesAccess104_excluded = ["className"];
function ManageDevicesAccess104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesAccess104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesAccess104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesAccess104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesAccess104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesAccess104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesAccess104_objectSpread(ManageDevicesAccess104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.28 53.67c1.71 2.67 2.34 5.69 4.03 8.94 6.19 11.91 14.82 18.31 29.74 18.26 3.06-.01 7.54.3 8.15 3.22l-.26-1.06H18.41c-8.02 0-6.77 1.17-6.77-6.76V50.84c2.13-.17 3.49 1.04 4.64 2.84Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11",
        y: "20",
        width: "82",
        height: "64",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 30h82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.64",
        cy: "25",
        r: "1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.64",
        cy: "25",
        r: "1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.64",
        cy: "25",
        r: "1.64"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.72 61.34h11.23v1.41H24.72v-1.41ZM34.45 52.71l-.71-1.22-2.7 1.56v-3.11h-1.4v3.11l-2.7-1.56-.71 1.22 2.7 1.56-2.7 1.56.71 1.22 2.7-1.56v3.12h1.4v-3.12l2.7 1.56.71-1.22-2.7-1.56 2.7-1.56zM39.16 61.34h11.23v1.41H39.16v-1.41ZM48.89 52.71l-.71-1.22-2.7 1.56v-3.11h-1.4v3.11l-2.7-1.56-.71 1.22 2.7 1.56-2.7 1.56.71 1.22 2.7-1.56v3.12h1.4v-3.12l2.7 1.56.71-1.22-2.7-1.56 2.7-1.56zM53.6 61.34h11.23v1.41H53.6v-1.41ZM63.33 52.71l-.71-1.22-2.7 1.56v-3.11h-1.4v3.11l-2.7-1.56-.71 1.22 2.7 1.56-2.7 1.56.71 1.22 2.7-1.56v3.12h1.4v-3.12l2.7 1.56.71-1.22-2.7-1.56 2.7-1.56zM68.04 61.34h11.23v1.41H68.04v-1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m77.77 52.71-.71-1.22-2.7 1.56v-3.11h-1.4v3.11l-2.7-1.56-.71 1.22 2.7 1.56-2.7 1.56.71 1.22 2.7-1.56v3.12h1.4v-3.12l2.7 1.56.71-1.22-2.7-1.56 2.7-1.56z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesAccess104 = (ManageDevicesAccess104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesAccess56.tsx


var ManageDevicesAccess56_excluded = ["className"];
function ManageDevicesAccess56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesAccess56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesAccess56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesAccess56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesAccess56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesAccess56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesAccess56_objectSpread(ManageDevicesAccess56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.14 28.86c.9 1.4 1.23 3 2.12 4.71 3.26 6.27 7.8 9.64 15.65 9.61 1.61 0 3.97.16 4.29 1.69l-.14-.56h-20.8c-4.22 0-3.57.62-3.57-3.56V27.36c1.12-.09 1.84.55 2.44 1.49Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6.36",
        y: "11.13",
        width: "43.16",
        height: "33.69",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.36 16.4h43.17"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "9.33",
        cy: "13.76",
        r: ".86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "11.96",
        cy: "13.76",
        r: ".86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.6",
        cy: "13.76",
        r: ".86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.59 32.89h5.91v.74h-5.91v-.74ZM18.71 28.35l-.37-.64-1.43.82v-1.64h-.74v1.64l-1.42-.82-.37.64 1.42.82-1.42.82.37.65 1.42-.82v1.64h.74v-1.64l1.43.82.37-.65-1.42-.82 1.42-.82zM21.19 32.89h5.91v.74h-5.91v-.74ZM26.31 28.35l-.37-.64-1.42.82v-1.64h-.75v1.64l-1.42-.82-.37.64 1.42.82-1.42.82.37.65 1.42-.82v1.64h.75v-1.64l1.42.82.37-.65-1.42-.82 1.42-.82zM28.79 32.89h5.91v.74h-5.91v-.74ZM33.91 28.35l-.37-.64-1.42.82v-1.64h-.74v1.64l-1.43-.82-.37.64 1.42.82-1.42.82.37.65 1.43-.82v1.64h.74v-1.64l1.42.82.37-.65-1.42-.82 1.42-.82zM36.39 32.89h5.91v.74h-5.91v-.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.51 28.35-.37-.64-1.42.82v-1.64h-.74v1.64l-1.42-.82-.38.64 1.43.82-1.43.82.38.65 1.42-.82v1.64h.74v-1.64l1.42.82.37-.65-1.42-.82 1.42-.82z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesAccess56 = (ManageDevicesAccess56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesEnrolled104.tsx


var ManageDevicesEnrolled104_excluded = ["className"];
function ManageDevicesEnrolled104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesEnrolled104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesEnrolled104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesEnrolled104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesEnrolled104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesEnrolled104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesEnrolled104_objectSpread(ManageDevicesEnrolled104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.38 30.57v43.46h41.94c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.88 44.62c-.23 3.99.39 11.44 7.28 16.27.58.4.15 1.32-.53 1.14-2.69-.7-6.37-2.51-8.15-7.21 0 0-2.17-5.5.19-10.53.3-.63 1.25-.37 1.21.33Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.31 77.19H45.66M10.99 74.03h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7a3.15 3.15 0 0 1-3.15-3.15v-1.15c0-1.1.9-2 2-2ZM89.99 73.4V26.58c0-1.61-1.31-2.91-2.91-2.91H17.3c-1.61 0-2.91 1.31-2.91 2.91V73.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "27.87",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "49.8",
        r: "12.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.46 50.25 3.92 3.93 8.76-8.76"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesEnrolled104 = (ManageDevicesEnrolled104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesEnrolled56.tsx


var ManageDevicesEnrolled56_excluded = ["className"];
function ManageDevicesEnrolled56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesEnrolled56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesEnrolled56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesEnrolled56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesEnrolled56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesEnrolled56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesEnrolled56_objectSpread(ManageDevicesEnrolled56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.75 16.46v23.4h22.59c.13-1.02-.71-1.84-2.52-2.46-2.72-.93-10.68-4.93-13.79-12.19-3.1-7.25-2.48-9.68-4.07-10.15-.12-.03-.23-.07-.34-.09-.95-.23-1.86.51-1.86 1.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.55 24.03c-.13 2.15.21 6.16 3.92 8.76.31.22.08.71-.29.61-1.45-.38-3.43-1.35-4.39-3.88 0 0-1.17-2.96.1-5.67.16-.34.68-.2.65.18Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.4 41.56h-6.81M6.16 39.86h43.67c.73 0 1.32.59 1.32 1.32 0 1.15-.93 2.08-2.08 2.08H6.91c-1.15 0-2.08-.93-2.08-2.08 0-.73.59-1.32 1.32-1.32ZM48.45 39.52V14.31c0-.87-.7-1.57-1.57-1.57H9.31c-.87 0-1.57.7-1.57 1.57v25.21"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "15.01",
      r: ".57",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.89",
        cy: "26.81",
        r: "6.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.48 27.06 2.11 2.11 4.72-4.71"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesEnrolled56 = (ManageDevicesEnrolled56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesLock104.tsx


var ManageDevicesLock104_excluded = ["className"];
function ManageDevicesLock104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesLock104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesLock104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesLock104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesLock104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesLock104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesLock104_objectSpread(ManageDevicesLock104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.35 30.57v43.46h41.94c.25-1.89-1.31-3.42-4.68-4.57C46.57 67.73 31.77 60.3 26 46.83c-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.63 50.04c0-.25.5-.62.73-.63 1.26-.14 1.5 4.42 1.74 5.32.23 1.71.89 3.34 1.91 4.73a6.407 6.407 0 0 0 4.04 1.81c1.28.16 3.05.32 4.37.57 1.33.25 1.91 1.91 0 1.91h-10.7a2.41 2.41 0 0 1-2.08-2.46V50.04"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.27 77.19H45.62M10.95 74.03h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15H12.1a3.15 3.15 0 0 1-3.15-3.15v-1.15c0-1.1.9-2 2-2ZM89.95 73.4V27.91c0-.73-.25-1.88-.55-2.55 0 0-.76-1.7-2.37-1.7H18.59c-.73 0-1.88.25-2.55.55l-1.15 1.15c-.3.67-.55 1.82-.55 2.55v45.48"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52.15",
      cy: "27.87",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.08 46h15.78c.78-.02 1.54.29 2.1.84s.86 1.31.85 2.1v12.62c0 1.59-1.29 2.89-2.89 2.89H44.14c-.78.01-1.52-.29-2.08-.83a2.89 2.89 0 0 1-.87-2.06V48.94c-.01-.77.29-1.52.83-2.07a2.88 2.88 0 0 1 2.06-.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.98 50.92a2.748 2.748 0 0 0-1.48 5.05v1.93c0 1.03.46 1.88 1.48 1.88 1.03 0 1.47-.85 1.47-1.88v-1.93a2.735 2.735 0 0 0 1.18-3.08 2.733 2.733 0 0 0-2.65-1.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.43 46v-4.59a7.746 7.746 0 0 1 7.72-7.78c4.16.07 7.49 3.45 7.51 7.61v4.73H56.5v-4.61a4.487 4.487 0 0 0-4.18-4.53 4.41 4.41 0 0 0-3.26 1.21c-.88.83-1.37 1.99-1.38 3.19v4.73l-3.25.03Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesLock104 = (ManageDevicesLock104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesLock56.tsx


var ManageDevicesLock56_excluded = ["className"];
function ManageDevicesLock56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesLock56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesLock56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesLock56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesLock56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesLock56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesLock56_objectSpread(ManageDevicesLock56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.41 26.95c0-.14.27-.33.39-.34.68-.08.81 2.38.93 2.86.12.92.48 1.8 1.03 2.55.59.57 1.36.92 2.18.98.69.08 1.64.17 2.35.31.71.14 1.03 1.03 0 1.03h-5.76c-.66-.09-1.14-.66-1.12-1.33v-6.06"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.64 16.5v23.4h22.59c.13-1.02-.71-1.84-2.52-2.46-2.72-.93-10.68-4.93-13.79-12.19-3.1-7.25-2.48-9.68-4.07-10.15-.12-.03-.23-.07-.34-.09-.95-.23-1.86.51-1.86 1.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.3 41.56h-6.81M6.05 39.86h43.67c.73 0 1.32.59 1.32 1.32 0 1.15-.93 2.08-2.08 2.08H6.81c-1.15 0-2.08-.93-2.08-2.08 0-.73.59-1.32 1.32-1.32ZM48.35 39.52V14.31c0-.87-.7-1.57-1.57-1.57H9.21c-.87 0-1.57.7-1.57 1.57v25.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.89",
        cy: "15.01",
        r: ".57",
        className: "strokeprimaryinverted"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.73 24.77h8.5c.42 0 .83.15 1.13.45.3.3.47.71.46 1.13v6.8c0 .86-.7 1.55-1.55 1.55h-8.5c-.42 0-.82-.15-1.12-.45-.3-.29-.47-.69-.47-1.11v-6.8c0-.42.15-.82.45-1.12.29-.3.69-.46 1.11-.46Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 27.42c-.65 0-1.23.43-1.41 1.06-.18.63.07 1.3.61 1.66v1.04c0 .55.25 1.01.8 1.01s.79-.46.79-1.01v-1.04c.56-.35.82-1.03.64-1.66a1.47 1.47 0 0 0-1.43-1.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.92 24.77V22.3c0-1.11.43-2.17 1.21-2.95s1.84-1.23 2.94-1.23c2.24.04 4.04 1.86 4.04 4.1v2.55h-1.7v-2.48c.02-1.28-.97-2.35-2.25-2.44a2.4 2.4 0 0 0-1.76.65c-.47.45-.74 1.07-.74 1.72v2.55l-1.75.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesLock56 = (ManageDevicesLock56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesMonitor104.tsx


var ManageDevicesMonitor104_excluded = ["className"];
function ManageDevicesMonitor104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesMonitor104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesMonitor104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesMonitor104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesMonitor104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesMonitor104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesMonitor104_objectSpread(ManageDevicesMonitor104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.56 30.57v43.46H56.5c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M50.13 34.65s2.99 26.57 4.67 27.83c1.68 1.27 0 0 0 0L49.18 62V34.01l.95.64Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.49 77.19H45.84M11.16 74.03h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7a3.15 3.15 0 0 1-3.15-3.15v-1.15c0-1.1.9-2 2-2ZM90.16 73.4V26.58c0-1.61-1.31-2.91-2.91-2.91H17.48c-1.61 0-2.91 1.31-2.91 2.91V73.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.92",
        y: "48.57",
        width: "22.88",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 41.365 51.575)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "38.06",
        y: "45.71",
        width: "28.6",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 52.36 48.71)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "54.78",
        y: "51.43",
        width: "17.16",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 63.365 54.435)"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52.16",
      cy: "27.87",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesMonitor104 = (ManageDevicesMonitor104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesMonitor56.tsx


var ManageDevicesMonitor56_excluded = ["className"];
function ManageDevicesMonitor56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesMonitor56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesMonitor56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesMonitor56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesMonitor56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesMonitor56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesMonitor56_objectSpread(ManageDevicesMonitor56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M7.86 16.43v23.4h22.59c.13-1.02-.71-1.84-2.52-2.46-2.72-.93-10.68-4.93-13.79-12.19-3.1-7.25-2.48-9.68-4.07-10.15-.12-.03-.23-.07-.34-.09-.95-.23-1.86.51-1.86 1.48Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.52 41.53h-6.81M6.28 39.83h43.67c.73 0 1.32.59 1.32 1.32 0 1.15-.93 2.08-2.08 2.08H7.03c-1.15 0-2.08-.93-2.08-2.08 0-.73.59-1.32 1.32-1.32ZM48.57 39.49V14.28c0-.87-.7-1.57-1.57-1.57H9.43c-.87 0-1.57.7-1.57 1.57v25.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.11",
        cy: "14.97",
        r: ".57",
        className: "strokeprimaryinverted"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.02 18.63s1.61 14.3 2.52 14.99l-3.03-.26V18.29l.51.35Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.14",
        y: "26.12",
        width: "12.32",
        height: "3.23",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 22.295 27.735)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "20.52",
        y: "24.58",
        width: "15.4",
        height: "3.23",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 28.215 26.195)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.52",
        y: "27.66",
        width: "9.24",
        height: "3.23",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 34.145 29.275)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesMonitor56 = (ManageDevicesMonitor56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesSettings104.tsx


var ManageDevicesSettings104_excluded = ["className"];
function ManageDevicesSettings104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesSettings104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesSettings104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesSettings104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesSettings104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesSettings104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesSettings104_objectSpread(ManageDevicesSettings104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.2 30.64V74.1h41.94c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.12 77.19H45.48M10.8 74.03h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7a3.15 3.15 0 0 1-3.15-3.15v-1.15c0-1.1.9-2 2-2ZM89.8 73.4V26.58c0-1.61-1.31-2.91-2.91-2.91H17.11c-1.61 0-2.91 1.31-2.91 2.91V73.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "51.8",
      cy: "27.87",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.47 38.47 2.88-1.12c.28-.11.59.03.71.31l.91 2.31c1.14-.18 2.3-.15 3.42.08l.88-2.02c.17-.41.65-.6 1.06-.43h.02l2.34 1.02c.41.18.6.66.42 1.07l-.9 2.07c.93.68 1.73 1.51 2.37 2.47l2.31-.91c.28-.11.59.03.71.3l1.12 2.88c.11.28-.03.59-.3.71l-2.31.91c.18 1.14.15 2.3-.08 3.42l2.27.99c.27.12.4.44.28.71l-1.24 2.83c-.12.27-.45.4-.72.28l-2.28-.99c-.68.93-1.52 1.73-2.48 2.37l.91 2.31c.11.28-.03.59-.31.71l-2.88 1.12a.558.558 0 0 1-.71-.3l-.91-2.31c-1.14.18-2.3.15-3.42-.08l-.99 2.27c-.12.27-.45.4-.72.28L45 60.49a.543.543 0 0 1-.28-.71l1.01-2.31a9.479 9.479 0 0 1-2.37-2.48l-2.31.91a.554.554 0 0 1-.71-.31l-1.12-2.88c-.11-.28.03-.59.31-.71l2.31-.91c-.17-1.14-.15-2.3.08-3.42l-2.28-.99a.554.554 0 0 1-.28-.72l1.23-2.83c.12-.28.43-.41.71-.29l2.3 1c.68-.93 1.51-1.74 2.47-2.37l-.91-2.31c-.1-.28.04-.59.32-.7Zm4.23 5.84a5.576 5.576 0 0 0-3.52 7.05 5.576 5.576 0 0 0 7.05 3.52 5.576 5.576 0 0 0 3.52-7.05 5.574 5.574 0 0 0-7.05-3.51Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesSettings104 = (ManageDevicesSettings104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesSettings56.tsx


var ManageDevicesSettings56_excluded = ["className"];
function ManageDevicesSettings56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesSettings56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesSettings56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesSettings56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesSettings56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesSettings56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesSettings56_objectSpread(ManageDevicesSettings56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.65 16.5v23.4h22.59c.13-1.02-.71-1.84-2.52-2.46-2.72-.93-10.68-4.93-13.79-12.19-3.1-7.25-2.48-9.68-4.07-10.15-.12-.03-.23-.07-.34-.09-.95-.23-1.86.51-1.86 1.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.3 41.56h-6.81M6.06 39.86h43.67c.73 0 1.32.59 1.32 1.32 0 1.15-.93 2.08-2.08 2.08H6.81c-1.15 0-2.08-.93-2.08-2.08 0-.73.59-1.32 1.32-1.32ZM48.35 39.52V14.31c0-.87-.7-1.57-1.57-1.57H9.22c-.87 0-1.57.7-1.57 1.57v25.21"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "27.89",
      cy: "15.01",
      r: ".57",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.48 20.72 1.55-.6c.15-.06.32.02.38.17l.49 1.24c.61-.1 1.24-.08 1.84.04l.47-1.09c.09-.22.35-.32.57-.23l1.26.55c.22.1.32.36.23.58l-.49 1.12c.5.36.93.81 1.28 1.33l1.24-.49c.15-.06.32.01.38.16l.6 1.55a.29.29 0 0 1-.16.38l-1.24.49c.1.61.08 1.24-.04 1.84l1.22.53c.15.06.22.24.15.38l-.67 1.53c-.07.15-.24.21-.39.15l-1.23-.54c-.36.5-.82.93-1.33 1.28l.49 1.24c.06.15-.02.32-.17.38l-1.55.61a.29.29 0 0 1-.38-.16l-.49-1.24c-.61.1-1.24.08-1.84-.04l-.53 1.22c-.07.15-.24.21-.39.15l-1.53-.67c-.15-.06-.22-.24-.15-.38l.54-1.25c-.5-.36-.93-.82-1.28-1.33l-1.24.49a.296.296 0 0 1-.38-.17l-.6-1.55c-.06-.15.02-.32.17-.38l1.24-.49c-.09-.61-.08-1.24.04-1.84l-1.23-.54a.301.301 0 0 1-.15-.39l.66-1.52a.29.29 0 0 1 .38-.16l1.24.54c.36-.5.81-.93 1.33-1.28l-.49-1.24c-.06-.15.02-.32.17-.38Zm2.28 3.14a3.001 3.001 0 1 0 3.8 1.89c-.03-.1-.07-.19-.11-.29a3.011 3.011 0 0 0-3.68-1.61Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesSettings56 = (ManageDevicesSettings56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesShield104.tsx


var ManageDevicesShield104_excluded = ["className"];
function ManageDevicesShield104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesShield104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesShield104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesShield104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesShield104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesShield104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesShield104_objectSpread(ManageDevicesShield104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.4 30.7v43.46h41.94c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.32 77.19H45.68M11 74.03h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7A3.15 3.15 0 0 1 9 77.18v-1.15c0-1.1.9-2 2-2ZM90 73.4V26.58c0-1.61-1.31-2.91-2.91-2.91H17.31c-1.61 0-2.91 1.31-2.91 2.91V73.4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "27.87",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.01 36.37c4.92 0 8.7.78 10.52 1.24.72.18 1.23.83 1.25 1.57.02 1.03.06 2.66.04 4.64-.05 6.56-1.46 16.79-11.22 20.56-.39.15-.81.15-1.2 0-9.75-3.77-11.17-13.99-11.22-20.56-.02-1.99.02-3.61.04-4.64.02-.75.54-1.39 1.25-1.58 1.82-.46 5.59-1.24 10.51-1.24H52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.01 39.28c3.61 0 6.37.59 7.71.95.53.14.91.63.92 1.2.02.79.04 2.03.03 3.54-.03 5.01-1.07 12.81-8.22 15.69-.28.11-.59.11-.87 0-7.15-2.88-8.19-10.67-8.22-15.69 0-1.51 0-2.76.03-3.54.02-.57.39-1.06.92-1.2 1.33-.35 4.1-.95 7.71-.95Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesShield104 = (ManageDevicesShield104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesShield56.tsx


var ManageDevicesShield56_excluded = ["className"];
function ManageDevicesShield56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesShield56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesShield56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesShield56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesShield56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesShield56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesShield56_objectSpread(ManageDevicesShield56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.75 16.53v23.4h22.59c.13-1.02-.71-1.84-2.52-2.46-2.72-.93-10.68-4.93-13.79-12.19-3.1-7.25-2.48-9.68-4.07-10.15-.12-.03-.23-.07-.34-.09-.95-.23-1.86.51-1.86 1.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.41 41.56H24.6M6.16 39.86h43.67c.73 0 1.32.59 1.32 1.32 0 1.15-.93 2.08-2.08 2.08H6.92c-1.15 0-2.08-.93-2.08-2.08 0-.73.59-1.32 1.32-1.32ZM48.46 39.52V14.31c0-.87-.7-1.57-1.57-1.57H9.32c-.87 0-1.57.7-1.57 1.57v25.21"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "15.01",
      r: ".57",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 19.58c2.65 0 4.68.42 5.66.67.39.1.66.45.67.84.01.56.03 1.43.02 2.5-.03 3.53-.78 9.04-6.04 11.07-.21.08-.44.08-.64 0-5.25-2.03-6.02-7.53-6.04-11.07 0-1.07 0-1.94.02-2.5 0-.4.29-.75.67-.85.98-.25 3.01-.67 5.66-.67h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 21.15c1.94 0 3.43.32 4.15.51.28.08.49.34.5.64 0 .42.02 1.09.02 1.9-.02 2.7-.58 6.9-4.43 8.45-.15.06-.32.06-.47 0-3.85-1.55-4.41-5.75-4.43-8.45 0-.81 0-1.48.02-1.9 0-.31.21-.57.5-.64.72-.19 2.21-.51 4.15-.51Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesShield56 = (ManageDevicesShield56);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesUnenrolled104.tsx


var ManageDevicesUnenrolled104_excluded = ["className"];
function ManageDevicesUnenrolled104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesUnenrolled104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesUnenrolled104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesUnenrolled104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesUnenrolled104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesUnenrolled104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesUnenrolled104_objectSpread(ManageDevicesUnenrolled104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.14 63.05s2.68-2.59 4.41 2.6c1.73 5.19 5.95 12 13.41 15.14 7.46 3.14 14.34 8.07 13.71 11.46-7.8-4.03-31.16-16.68-31.16-16.68l-.38-12.52Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 43.16a5.77 5.77 0 0 0-3.11 10.63v4.05c0 2.17.94 3.95 3.11 3.95h.02c2.17 0 3.11-1.78 3.11-3.95v-4.05a5.77 5.77 0 0 0-3.11-10.63H52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.23 44.1c0-.54 1.06-1.31 1.52-1.35 2.66-.29 3.17 9.3 3.65 11.22.83 3.32 1.59 7.22 4.01 9.81 2.2 2.35 5.39 3.44 8.51 3.81 2.69.32 6.4.67 9.19 1.2 3.14.6 4.02 4.02-.08 4.02H33.59s-4.37-.53-4.37-5.21V44.11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.81 20.81h12.86a2.86 2.86 0 0 1 2.86 2.86v50.52c0 1.07-.6 2.05-1.55 2.54L53.31 91.55c-.82.43-1.8.43-2.63 0L22.01 76.73a2.86 2.86 0 0 1-1.55-2.54V23.67a2.86 2.86 0 0 1 2.86-2.86h13.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.39 20.81h17.38"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.28 66.71c0 3.35 2.74 6.09 6.09 6.09h33.3c3.35 0 6.09-2.74 6.09-6.09V40.08c0-3.35-2.74-6.09-6.09-6.09h-33.3c-3.35 0-6.09 2.74-6.09 6.09v26.63Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 43.16a5.77 5.77 0 0 0-3.11 10.63v4.05c0 2.17.94 3.95 3.11 3.95h.02c2.17 0 3.11-1.78 3.11-3.95v-4.05a5.77 5.77 0 0 0-3.11-10.63H52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.38 24.21v2.88h6.74v-3.15c0-8.73-7.09-15.89-15.79-16.01-8.93-.12-16.23 7.45-16.23 16.38v9.68h6.74V23.94c0-5.27 4.41-9.52 9.74-9.26 4.98.25 8.8 4.54 8.8 9.53Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesUnenrolled104 = (ManageDevicesUnenrolled104);
;// ./src/Picto/GeneratedPictoComponents/ManageDevicesUnenrolled56.tsx


var ManageDevicesUnenrolled56_excluded = ["className"];
function ManageDevicesUnenrolled56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ManageDevicesUnenrolled56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ManageDevicesUnenrolled56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ManageDevicesUnenrolled56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ManageDevicesUnenrolled56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ManageDevicesUnenrolled56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ManageDevicesUnenrolled56_objectSpread(ManageDevicesUnenrolled56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.38 33.95s1.44-1.4 2.38 1.4c.93 2.79 3.2 6.46 7.22 8.15 4.02 1.69 7.72 4.35 7.38 6.17-4.2-2.17-16.78-8.98-16.78-8.98l-.2-6.74Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 23.24c-1.72 0-3.11 1.39-3.11 3.11 0 1.1.57 2.06 1.43 2.62v2.18c0 1.17.5 2.13 1.67 2.13H28c1.17 0 1.67-.96 1.67-2.13v-2.18c.86-.55 1.43-1.52 1.43-2.62 0-1.72-1.39-3.11-3.11-3.11h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.74 23.75c0-.29.57-.7.82-.73 1.43-.16 1.71 5.01 1.96 6.04.45 1.79.86 3.89 2.16 5.28 1.18 1.27 2.9 1.85 4.58 2.05 1.45.17 3.45.36 4.95.65 1.69.32 2.16 2.17-.04 2.17H18.09s-2.35-.29-2.35-2.81V23.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.51 11.21h6.93c.85 0 1.54.69 1.54 1.54v27.2c0 .58-.32 1.11-.83 1.37L28.71 49.3c-.44.23-.97.23-1.41 0l-15.44-7.98c-.51-.26-.83-.79-.83-1.37v-27.2c0-.85.69-1.54 1.54-1.54h7.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.36 11.21h9.36"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.77 35.92c0 1.81 1.48 3.28 3.28 3.28h17.93c1.81 0 3.28-1.48 3.28-3.28V21.58c0-1.81-1.48-3.28-3.28-3.28H19.05c-1.8 0-3.28 1.48-3.28 3.28v14.34Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 23.24c-1.72 0-3.11 1.39-3.11 3.11 0 1.1.57 2.06 1.43 2.62v2.18c0 1.17.5 2.13 1.67 2.13H28c1.17 0 1.67-.96 1.67-2.13v-2.18c.86-.55 1.43-1.52 1.43-2.62 0-1.72-1.39-3.11-3.11-3.11h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.05 13.04v1.55h3.63v-1.7c0-4.7-3.82-8.56-8.5-8.62-4.81-.07-8.74 4.01-8.74 8.82v5.21h3.63v-5.41a5 5 0 0 1 5.24-4.99c2.68.13 4.74 2.45 4.74 5.13Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ManageDevicesUnenrolled56 = (ManageDevicesUnenrolled56);
;// ./src/Picto/GeneratedPictoComponents/MobileSim104.tsx


var MobileSim104_excluded = ["className"];
function MobileSim104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MobileSim104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MobileSim104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MobileSim104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MobileSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileSim104_objectSpread(MobileSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43 14h4M39 90h12M68 82.05V88c0 3.31-2.69 6-6 6H28c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v18.96"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.45 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.01 68.53v4.28M69.42 68.55l-.01 4.28M69.43 60.64l.01-4.23M64.03 60.62l.01-4.23M74.9 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.61 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileSim104 = (MobileSim104);
;// ./src/Picto/GeneratedPictoComponents/MobileSim56.tsx


var MobileSim56_excluded = ["className"];
function MobileSim56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MobileSim56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MobileSim56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MobileSim56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MobileSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileSim56_objectSpread(MobileSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.21 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.25 8h2M21.25 48h6M36.25 44.83V47c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v10.6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.91 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38h10.81c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-.46-.16-1.23-.49-2.13-.97-2.13-1.14-5-3.19-6.24-6.17-.3-.72-.54-1.36-.73-1.93-.95-2.76-.83-3.78-1.58-4.01-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.73 37.26v2.09M37.46 37.27l-.01 2.09M37.46 33.24l.01-2.15M34.74 33.23v-2.15M40.25 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.54 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.75 26.86-.08 14.06c0 .51-.47.91-1.05.91H30.79c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileSim56 = (MobileSim56);
;// ./src/Picto/GeneratedPictoComponents/TabletSim104.tsx


var TabletSim104_excluded = ["className"];
function TabletSim104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TabletSim104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TabletSim104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TabletSim104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TabletSim104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TabletSim104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TabletSim104_objectSpread(TabletSim104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.74 93.77v-1.04s-4.14 0-15.54-8.29c-11.4-8.29-13.47-20.72-14.5-33.15s0-17.42-5.17-17.42V85.06c0 6.69 1.01 8.71 8.7 8.71h26.6c-.05-.34-.08.35-.08 0Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.82 88.97h11.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.68",
        cy: "15.01",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.05 82.21v6.63c0 2.76-2.24 5-5 5H18.31c-2.76 0-5-2.24-5-5V15.16c0-2.76 2.24-5 5-5h52.73c2.76 0 5 2.24 5 5V34.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.14 50.39.04 24.86c-.31 2.7 1.2 2.74 2.68 2.74l21.43.02c.79 0 1.23-.98.68-1.56-.47-.49-1.23-.93-2.27-1.3-3.05-1.09-13.1-5.73-16.6-14.14-3.5-8.41-2.8-11.23-4.59-11.77-1.19-.36-1.37.44-1.37 1.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.7 68.67v4.12M78.1 68.69v4.13M78.12 60.57l.01-4.02M72.72 60.55v-4.02M83.59 58.81l-.02 11.68c0 1.52-1.26 2.75-2.82 2.74l-10.73-.05c-1.55 0-2.81-1.25-2.81-2.77l.02-11.68c0-1.52 1.26-2.75 2.82-2.74l10.73.05c1.55 0 2.81 1.25 2.81 2.77Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m80.3 68.09-9.82-.04c-1.79 0-3.26-1.39-3.26-3.06v-.8c0-1.68 1.47-3.04 3.27-3.03l9.82.04c1.79 0 3.26 1.39 3.26 3.06v.8c0 1.68-1.47 3.04-3.27 3.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m90.69 48-.16 27.86c0 1-.94 1.81-2.1 1.81l-23.67-.03c-1.15 0-2.08-.81-2.08-1.82l.18-34.19c0-1.17 1.1-2.11 2.45-2.11l17.31.02c1.28 0 2.07.32 2.72.89l4.28 4.29c.8.82 1.06 1.63 1.05 3.27Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TabletSim104 = (TabletSim104);
;// ./src/Picto/GeneratedPictoComponents/TabletSim56.tsx


var TabletSim56_excluded = ["className"];
function TabletSim56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TabletSim56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TabletSim56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TabletSim56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TabletSim56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TabletSim56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TabletSim56_objectSpread(TabletSim56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.59 49.86v-.54s-2.17 0-8.13-4.34-7.05-10.84-7.59-17.35 0-9.12-2.71-9.12V45.3c0 3.5.53 4.56 4.55 4.56h13.92c-.03-.18-.04.18-.04 0Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.4 47.34h6.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.47",
        cy: "8.65",
        r: ".51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.89 44.83v2.57c0 1.39-1.13 2.51-2.51 2.51H10.55c-1.39 0-2.51-1.13-2.51-2.51V8.6c0-1.39 1.13-2.51 2.51-2.51h27.83c1.39 0 2.51 1.13 2.51 2.51v11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.12 28.06.02 12.54c-.15 1.36.61 1.38 1.35 1.38H46.3c.4 0 .62-.49.34-.78-.24-.25-.62-.47-1.15-.65-1.54-.55-6.61-2.89-8.37-7.14-1.76-4.24-1.41-5.66-2.32-5.94-.6-.18-.69.22-.69.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.95 37.28v2.05M41.67 37.3v2.04M41.68 33.18v-1.93M38.96 33.16v-1.92M44.47 32.29v5.94c-.01.77-.65 1.4-1.44 1.39l-5.45-.02c-.79 0-1.43-.63-1.43-1.41v-5.94c.01-.77.65-1.4 1.44-1.39l5.45.02c.79 0 1.43.63 1.43 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.76 37-4.9-.02c-.9 0-1.63-.7-1.62-1.55v-.41c0-.85.74-1.55 1.63-1.54l4.9.02c.9 0 1.63.7 1.62 1.55v.41c0 .85-.74 1.55-1.63 1.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.96 26.86-.08 14.06c0 .51-.47.91-1.05.91H35c-.58-.01-1.04-.42-1.04-.93l.09-17.25c0-.59.55-1.07 1.22-1.07h8.66c.64.01 1.04.17 1.36.46l2.14 2.17c.4.41.53.82.53 1.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TabletSim56 = (TabletSim56);
;// ./src/Picto/GeneratedPictoComponents/TelstraConnect104.tsx


var TelstraConnect104_excluded = ["className"];
function TelstraConnect104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraConnect104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraConnect104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraConnect104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraConnect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraConnect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraConnect104_objectSpread(TelstraConnect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("clipPath", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.88 42.6c-7.62 1.79-4.13 10.64-1.47 14.95.11.18.37.04.3-.15-3.53-9.66-.37-13.31 1.31-14.49.15-.11.04-.34-.14-.3Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.88 42.6c-7.62 1.79-4.13 10.64-1.47 14.95.11.18.37.04.3-.15-3.53-9.66-.37-13.31 1.31-14.49.15-.11.04-.34-.14-.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.59 41.98h7.17v16.31h-7.17zM39.68 58.94s-.09-.04-.13-.01c-.03.03-.04.09-.01.13 8.01 10.34 20.42 14.6 25.38 11.4 1.36-4.15-11.42 1.62-25.25-11.51Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m57.85 49.63-1.53 8.97c-.32 1.61-1.38 2.05-2.32 2.05h-7.07l2.98-16.43c-2.98-1.36-6.01-2.25-8.43-2.25s-4.17.62-5.42 2.11c-.88 1.06-1.31 2.37-1.31 3.92 0 4.67 3.67 11.15 9.96 16.44 5.6 4.68 11.77 7.29 16.26 7.29 2.24 0 4.04-.69 5.23-2.05.94-1.06 1.31-2.43 1.31-3.99 0-4.54-3.7-10.9-9.66-16.07Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.52 91.01s1.13-1.94-.02-2.45c-1.15-.51-6.76 1.01-7.21-2.14-.46-3.15.52-4.83-.36-5.38-.88-.55-2.46 0-2.46 0l-1.51 4.44.51 4.24 2.57 2.29 4.23.78 4.25-.76.02-1h-.01ZM18.89 40.28c0-.86.09-2.15 2.41-2.14 4.26.02 4.53 10.13 4.32 17.49-.15 5.42 2.31 13.09 6.15 17.18 3.5 3.72 9.11 4.71 14.07 5.3 4.27.5 11.7 0 16.13.84 4.98.95 5.95 6.72-.55 6.72H22.8c-2.32 0-4.23-1.83-4.32-4.16-.1-2.68-.2-6.37-.2-10.17 0 0 .6-30.5.6-31.03M22.56 23.04s1.13-1.94-.02-2.45c-1.15-.51-6.76 1.01-7.21-2.14-.46-3.15.52-4.83-.36-5.38-.88-.55-2.46 0-2.46 0L11 17.51l.51 4.24 2.57 2.29 4.23.78 4.25-.76.02-1h-.01ZM49.61 49.44c.25-1.17.14-1.7.09-1.66-.06.05-2.2 12.53-2.2 12.53h6.71c-4.27 0-5.89-4.63-4.6-10.88ZM62.17 33.4c3.21.24 5.09 1.36 5.72 2.43.1.18.37.12.4-.08l.51-2.78a.222.222 0 0 0-.22-.26H57.99s.1.4 4.18.69Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.98 85.99H22.01c-2.21 0-4-1.79-4-4V25.02M25.03 18.01h56.96c2.21 0 4 1.79 4 4v56.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "85.99",
        cy: "85.99",
        r: "7.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.03",
        cy: "18.01",
        r: "7.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.15 32.26c-1.12 0-2.05.75-2.31 1.93l-.99 5.42h8.89l-3.81 21.05H54c.95 0 2.01-.44 2.32-2.05l3.24-19h6.4c1.12 0 2.06-.75 2.31-1.93l1-5.42H45.16Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraConnect104 = (TelstraConnect104);
;// ./src/Picto/GeneratedPictoComponents/TelstraConnect56.tsx


var TelstraConnect56_excluded = ["className"];
function TelstraConnect56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraConnect56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraConnect56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraConnect56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraConnect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraConnect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraConnect56_objectSpread(TelstraConnect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.65 23.07c-3.99.94-2.17 5.58-.77 7.84.06.09.2.02.16-.08-1.85-5.07-.19-6.98.69-7.6.08-.06.02-.18-.08-.16ZM21.55 31.64s-.05-.02-.07 0c-.02.02-.02.05 0 .07 4.2 5.42 10.71 7.66 13.31 5.98.71-2.17-5.99.85-13.24-6.04Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.07 26.76-.8 4.7c-.17.85-.72 1.08-1.22 1.08h-3.71l1.56-8.62c-1.56-.71-3.15-1.18-4.42-1.18s-2.19.32-2.84 1.11c-.46.56-.69 1.24-.69 2.06 0 2.45 1.93 5.85 5.23 8.62 2.94 2.45 6.17 3.82 8.53 3.82 1.17 0 2.12-.36 2.74-1.08.49-.56.69-1.28.69-2.09 0-2.38-1.94-5.72-5.07-8.43Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.75 26.66c.13-.61.08-.89.05-.87-.03.02-1.15 6.57-1.15 6.57h3.52c-2.24 0-3.09-2.43-2.41-5.7ZM10.64 21.86c0-.45.05-1.13 1.26-1.12 2.23 0 2.37 5.31 2.26 9.17-.08 2.84 1.21 6.86 3.23 9.01 1.83 1.95 4.78 2.47 7.38 2.78 2.24.26 6.13 0 8.46.44 2.61.5 3.12 3.52-.29 3.52H12.69c-1.22 0-2.22-.96-2.26-2.18-.05-1.41-.1-3.34-.1-5.33 0 0 .32-15.99.32-16.27M48.21 48.46s.59-1.02-.01-1.29c-.61-.27-3.54.53-3.78-1.12-.24-1.65.27-2.53-.19-2.82-.46-.29-1.29 0-1.29 0l-.79 2.33.27 2.22 1.35 1.2 2.22.41 2.23-.4v-.52ZM12.57 12.81s.59-1.02-.01-1.29c-.61-.27-3.54.53-3.78-1.12-.24-1.65.27-2.53-.19-2.82-.46-.29-1.29 0-1.29 0l-.79 2.33.27 2.22 1.35 1.2 2.22.41 2.23-.4v-.52ZM33.34 18.25c1.68.12 2.67.71 3 1.27.05.09.19.06.21-.04l.27-1.46c.01-.07-.04-.14-.11-.14h-5.55s.05.21 2.19.36Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.05 45.82H12.28a2.1 2.1 0 0 1-2.1-2.1V13.97M13.97 10.18h29.76c1.16 0 2.1.94 2.1 2.1V41.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.83",
        cy: "45.82",
        r: "3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "10.19",
        cy: "10.18",
        r: "3.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.41 17.65c-.59 0-1.08.39-1.21 1.01l-.52 2.84h4.66l-2 11.04h3.71c.5 0 1.05-.23 1.22-1.08l1.7-9.96h3.35c.59 0 1.08-.39 1.21-1.01l.52-2.84H24.41Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraConnect56 = (TelstraConnect56);
;// ./src/Picto/GeneratedPictoComponents/UnderseaCable104.tsx


var UnderseaCable104_excluded = ["className"];
function UnderseaCable104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnderseaCable104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnderseaCable104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnderseaCable104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnderseaCable104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnderseaCable104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnderseaCable104_objectSpread(UnderseaCable104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.99 79.24c-7.51 1.18-15.08 1.37-22.61.69-1.62-.15-1.62 8.77 0 8.92 7.53.68 15.11.49 22.61-.69v-8.92ZM77.55 79.74c-12.26 3.14-24.94.61-37.22-.96-1.62-.21-1.71 9.99-.08 10.05 13.07.42 25.07.42 38.89-.72 1.64-.14 0-8.77-1.6-8.36ZM84.7 82.08c-.19-.01-1.15 7.33-.07 7.3 2.81-.1 5.09-.55 8.65-.55 1.4 0 1.41-3.62 1.51-6.08.09-2.13-9.22-.61-10.09-.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.33 63.66h7.69V92.1h-7.69zM76.33 63.66h7.79V92.1h-7.79z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 13.9c7 0 7 4 14 4s7-4 14-4 7 4 14 4 7-4 14-4 7 4 14.01 4 7-4 14.01-4M10 26.63c7 0 7 4 14 4s7-4 14-4 7 4 14 4 7-4 14-4 7 4 14.01 4 7-4 14.01-4M10 39.37c7 0 7 4 14 4s7-4 14-4 7 4 14 4 7-4 14-4 7 4 14.01 4 7-4 14.01-4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.01 66.71h22.32M10.01 88.82h22.32M85 66.71h8.66M85 88.82h8.66M40.26 66.71h35.69M40.26 88.82h35.69M32.33 63.66h7.69V92.1h-7.69zM76.33 63.66h7.79V92.1h-7.79z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnderseaCable104 = (UnderseaCable104);
;// ./src/Picto/GeneratedPictoComponents/UnderseaCable56.tsx


var UnderseaCable56_excluded = ["className"];
function UnderseaCable56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnderseaCable56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnderseaCable56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnderseaCable56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnderseaCable56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnderseaCable56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnderseaCable56_objectSpread(UnderseaCable56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.11 42.19c-3.9.61-7.84.71-11.75.36-.84-.08-.84 4.56 0 4.63 3.91.35 7.85.25 11.75-.36v-4.63ZM41.27 42.45c-6.37 1.63-12.96.32-19.34-.5-.84-.11-.89 5.19-.04 5.22 6.79.22 13.03.22 20.21-.38.85-.07 0-4.56-.83-4.35ZM44.99 43.67c-.1 0-.6 3.81-.04 3.79 1.46-.05 2.64-.29 4.49-.29.73 0 .73-1.88.79-3.16.05-1.11-4.79-.32-5.24-.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.77 34.1h4v14.78h-4zM40.63 34.1h4.05v14.78h-4.05z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.17 35.68h11.6M6.17 47.17h11.6M45.14 35.68h4.5M45.14 47.17h4.5M21.89 35.68h18.55M21.89 47.17h18.55M17.77 34.1h4v14.78h-4zM40.63 34.1h4.05v14.78h-4.05z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.17 8.28c3.64 0 3.64 2 7.27 2s3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.28-2M6.17 14.9c3.64 0 3.64 2 7.27 2s3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.28-2M6.17 21.51c3.64 0 3.64 2 7.27 2s3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.27-2 3.64 2 7.28 2 3.64-2 7.28-2"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnderseaCable56 = (UnderseaCable56);
;// ./src/Picto/GeneratedPictoComponents/UnderseaCableNetwork104.tsx


var UnderseaCableNetwork104_excluded = ["className"];
function UnderseaCableNetwork104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnderseaCableNetwork104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnderseaCableNetwork104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnderseaCableNetwork104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnderseaCableNetwork104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnderseaCableNetwork104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnderseaCableNetwork104_objectSpread(UnderseaCableNetwork104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.22 13.28s4.91 1.78 3.05 3.66c-1.86 1.88-17.13 10.98-18.04 33.75.88 12.17 6.03 23.71 14.74 32.26 3.25 3.19 7.22 6.43 12.03 9.46l-2.03.81-8.57-1.83-5.06-3.4-6.59-5.54-5.99-6.81-5.62-10.4-1.53-6.13-.6-13.04 2.52-8.44 3.81-7.08 3.46-5.5 5.68-4.56 5.28-4.06 3.45-3.15Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.16 58.89h-.14s-.74-.1-2-.29a.993.993 0 0 1-.84-1.13c.08-.55.58-.92 1.13-.85 1.25.18 1.98.28 1.99.28a1 1 0 0 1-.14 1.99ZM85.2 58.01c-.05 0-.1 0-.15-.01l-1.99-.31c-.54-.09-.92-.6-.83-1.15.09-.55.6-.92 1.15-.83l1.98.31c.55.08.92.6.83 1.14-.08.49-.5.85-.99.85ZM79.27 57.04c-.06 0-.11 0-.17-.01-.65-.11-1.31-.22-1.98-.34a1 1 0 1 1 .35-1.97c.67.12 1.32.23 1.97.34.54.09.91.61.82 1.15-.08.49-.51.83-.99.83ZM73.35 55.99c-.06 0-.12 0-.19-.02-.66-.12-1.32-.25-1.98-.38a.999.999 0 0 1 .38-1.96c.65.13 1.31.25 1.96.38.54.1.9.62.8 1.17-.09.48-.51.81-.98.81ZM67.45 54.8c-.07 0-.14 0-.21-.02-.67-.14-1.32-.29-1.97-.44a1 1 0 0 1-.75-1.2c.12-.54.66-.88 1.2-.75.63.15 1.28.29 1.94.43.54.12.88.65.77 1.19-.1.47-.52.79-.98.79ZM61.61 53.41c-.09 0-.17-.01-.26-.03-.69-.18-1.34-.37-1.96-.56a1.003 1.003 0 0 1 .58-1.92c.6.18 1.23.36 1.9.54.53.14.85.69.71 1.23a.99.99 0 0 1-.96.74ZM55.91 51.49c-.14 0-.29-.03-.43-.1l-.13-.06c-.57-.28-1.13-.58-1.7-.9a.988.988 0 0 1-.37-1.36c.27-.48.88-.65 1.36-.37.53.3 1.05.58 1.58.84l.13.06c.5.24.71.84.47 1.33-.17.36-.53.57-.9.57ZM50.78 48.39c-.2 0-.4-.06-.58-.18-.55-.39-1.09-.79-1.64-1.2-.44-.33-.53-.96-.2-1.4.33-.44.96-.53 1.4-.19.53.4 1.06.79 1.59 1.16.45.32.56.94.24 1.39-.19.28-.5.42-.82.42ZM46.03 44.72c-.22 0-.45-.07-.63-.23-.51-.42-1.03-.85-1.55-1.29a1 1 0 1 1 1.29-1.53c.51.43 1.02.86 1.53 1.27a1 1 0 0 1 .14 1.41.99.99 0 0 1-.77.36ZM41.45 40.84c-.23 0-.46-.08-.65-.24l-1.52-1.31a.999.999 0 1 1 1.3-1.52l1.52 1.31a.999.999 0 0 1-.65 1.76ZM36.87 36.94c-.22 0-.45-.08-.64-.23-.51-.42-1.03-.84-1.54-1.25-.43-.35-.5-.97-.16-1.41.34-.43.97-.5 1.41-.16.52.42 1.04.84 1.56 1.27.43.35.49.98.13 1.41a.99.99 0 0 1-.77.36ZM32.13 33.26a.96.96 0 0 1-.58-.19c-.54-.39-1.08-.76-1.62-1.11-.46-.3-.59-.92-.29-1.39a1 1 0 0 1 1.38-.29c.56.37 1.12.75 1.68 1.16a1.006 1.006 0 0 1-.58 1.82ZM27.03 30.11c-.15 0-.3-.03-.44-.1-.6-.29-1.18-.55-1.75-.77a.993.993 0 0 1-.57-1.29c.2-.52.78-.77 1.29-.57.62.24 1.26.52 1.91.84.5.25.7.84.45 1.34-.17.35-.53.56-.9.56ZM21.33 28.36h-.09c-.29-.02-.57-.04-.85-.04-.55 0-1-.45-1-1s.45-1 1-1c.34 0 .68.02 1.02.05a.998.998 0 0 1-.09 1.99ZM27.11 44.5c-.13 0-.25-.02-.38-.07a.998.998 0 0 1-.55-1.3c.25-.62.57-1.27.95-1.92.28-.48.89-.64 1.37-.36.48.28.64.89.36 1.37-.33.57-.61 1.13-.83 1.66-.16.39-.53.62-.93.62ZM30.35 39.48a.99.99 0 0 1-.66-.25c-.42-.36-.46-1-.09-1.41.82-.94 1.44-1.5 1.47-1.53a.997.997 0 0 1 1.41.07c.37.41.34 1.04-.06 1.41 0 0-.57.52-1.31 1.37-.2.23-.47.34-.75.34ZM79.15 68.57a.993.993 0 0 1-.69-1.72c.02-.02.41-.42.92-1.39.26-.49.86-.68 1.35-.42.49.26.67.86.42 1.35-.68 1.28-1.23 1.82-1.33 1.92-.19.18-.43.26-.68.26ZM81.69 63.2a1.011 1.011 0 0 1-.97-1.27c.16-.57.31-1.19.45-1.88.11-.54.63-.89 1.18-.78.54.11.89.64.78 1.18-.14.7-.3 1.37-.48 2.01-.12.44-.52.73-.96.73ZM47.31 65.36c-.55 0-1-.45-1-1 0-.09 0-.89.14-2.11a1 1 0 1 1 1.99.21c-.12 1.14-.12 1.86-.12 1.89 0 .55-.45 1-1 1ZM48.16 59.43a1.004 1.004 0 0 1-.97-1.25c.17-.67.37-1.34.6-1.99.18-.52.75-.8 1.27-.62.52.18.8.75.62 1.27-.21.6-.39 1.22-.55 1.84-.12.45-.52.75-.97.75ZM50.36 53.86a1 1 0 0 1-.87-1.49c.35-.62.73-1.22 1.13-1.78.32-.45.95-.55 1.39-.23.45.32.55.95.23 1.4-.36.5-.7 1.04-1.01 1.6-.18.33-.52.51-.87.51ZM49.88 43.6a1.001 1.001 0 0 1-.93-1.36c.01-.03.3-.77.91-1.92.26-.49.87-.67 1.35-.41s.67.86.42 1.35c-.55 1.03-.81 1.7-.81 1.71-.15.39-.53.64-.93.64ZM52.86 38.4c-.2 0-.41-.06-.59-.19-.45-.33-.54-.95-.22-1.4.41-.56.84-1.11 1.28-1.63a1 1 0 1 1 1.53 1.29c-.41.48-.81 1-1.19 1.52a1 1 0 0 1-.81.41ZM56.91 33.98a.999.999 0 0 1-.65-1.76c.53-.46 1.08-.89 1.64-1.29.45-.32 1.07-.22 1.4.23s.22 1.07-.23 1.4c-.51.37-1.01.76-1.5 1.18-.19.16-.42.24-.65.24ZM61.93 30.73c-.38 0-.74-.22-.91-.58-.23-.5 0-1.1.49-1.33.63-.29 1.29-.55 1.95-.78.52-.18 1.09.1 1.27.62.18.52-.1 1.09-.62 1.27-.6.2-1.19.44-1.76.7-.13.06-.28.09-.42.09Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.01 10C47.82 9.5 49 13 44 19c-3.39 4.06 1 3.96 10 6 3.81.86 16.29-1.87 14.29 7.13-.68 3.04 6.72 7.87 7.72 14.87.65 4.57 5.64 0 10-2 5.58-2.56 4.73-7.08 5.15-8.24M61.65 76.11c-.21 3.41-4.83 4.13-5 7-.15 2.55 3.29 5.56 5.32 5.01 2.19-.59 3.47-2.06 6.68-5.01 3.18-2.93 9-2 12-8 1.06-2.13-4.3-3.26-5-5-1.62-3.99-6.93-7-9-6-2.23 1.08-5.96 5.58-6 8-.04 1.99 1.11 2.28 1 4ZM10.01 52s4.95-5.79 8.95-5.79 8.6.43 9.6 2.43-2.55 14.23-.55 14.23S33 65.38 36 66.38s14.01.63 13 2.63-5 5-8 5-3 2.49-3 4.49 3.59 4.51 6.59 7.51-.62 7.22-.62 7.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M94.01 52c0 1.03-.04 2.06-.11 3.07a41.831 41.831 0 0 1-6.92 20.21C79.45 86.57 66.6 94 52.01 94c-.83 0-1.66-.02-2.48-.07-.49-.03-.98-.07-1.47-.11-16.82-1.57-30.77-13.06-35.92-28.57-.66-1.98-1.17-4.03-1.53-6.13-.39-2.31-.6-4.69-.6-7.11 0-8.63 2.6-16.66 7.07-23.33 7.53-11.26 20.36-18.67 34.93-18.67.68 0 1.35.02 2.02.05 5.74.27 11.18 1.7 16.09 4.05 10.46 5 18.52 14.21 22 25.43C93.34 43.48 94 47.67 94 52.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnderseaCableNetwork104 = (UnderseaCableNetwork104);
;// ./src/Picto/GeneratedPictoComponents/UnderseaCableNetwork56.tsx


var UnderseaCableNetwork56_excluded = ["className"];
function UnderseaCableNetwork56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnderseaCableNetwork56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnderseaCableNetwork56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnderseaCableNetwork56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnderseaCableNetwork56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnderseaCableNetwork56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnderseaCableNetwork56_objectSpread(UnderseaCableNetwork56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.43 7.15s2.64.96 1.64 1.97-9.22 5.91-9.71 18.17c.48 6.55 3.25 12.77 7.94 17.37 1.75 1.72 3.89 3.46 6.48 5.1l-1.09.44-4.61-.98-2.72-1.83-3.55-2.98-3.23-3.66-3.03-5.6-.83-3.3-.32-7.02 1.36-4.55 2.05-3.81 1.86-2.96 3.06-2.45 2.84-2.19 1.86-1.7Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.09 31.71h-.07s-.4-.05-1.08-.15a.533.533 0 0 1-.45-.61c.04-.29.31-.5.61-.46.68.1 1.07.15 1.07.15a.542.542 0 0 1-.07 1.08ZM45.88 31.24h-.08l-1.07-.17a.55.55 0 0 1-.45-.62.55.55 0 0 1 .62-.45l1.06.17a.538.538 0 0 1-.08 1.07ZM42.68 30.72h-.09c-.35-.06-.71-.12-1.07-.18a.541.541 0 0 1-.44-.62c.05-.29.33-.49.62-.44.36.06.71.12 1.06.18.29.05.49.33.44.62-.04.26-.27.45-.53.45ZM39.5 30.15h-.1c-.35-.07-.71-.13-1.06-.2a.535.535 0 0 1-.42-.63.55.55 0 0 1 .63-.43c.35.07.7.14 1.06.2.29.06.48.34.43.63-.05.26-.27.44-.53.44ZM36.32 29.51s-.08 0-.11-.01c-.36-.08-.71-.16-1.06-.24a.534.534 0 1 1 .25-1.04c.34.08.69.16 1.05.23a.536.536 0 0 1-.12 1.06ZM33.17 28.76s-.09 0-.14-.02c-.37-.1-.72-.2-1.05-.3a.542.542 0 0 1-.36-.67c.09-.28.39-.45.67-.36.32.1.66.19 1.02.29.29.08.46.37.38.66-.06.24-.28.4-.52.4ZM30.11 27.72c-.08 0-.16-.02-.23-.05l-.07-.03c-.31-.15-.61-.31-.92-.49a.532.532 0 0 1-.2-.73c.15-.26.48-.35.73-.2.29.16.57.31.85.45l.07.03c.27.13.38.45.25.72-.09.19-.29.31-.49.31ZM27.34 26.06a.5.5 0 0 1-.31-.1c-.29-.21-.59-.42-.88-.65a.541.541 0 0 1-.11-.75.53.53 0 0 1 .75-.1c.29.22.57.43.86.63.24.17.3.51.13.75-.1.15-.27.23-.44.23ZM24.78 24.08c-.12 0-.24-.04-.34-.12-.28-.23-.55-.46-.83-.69a.53.53 0 0 1-.06-.76.53.53 0 0 1 .76-.06c.27.23.55.46.82.69a.545.545 0 0 1-.35.96ZM22.32 21.99c-.12 0-.25-.04-.35-.13l-.82-.7a.538.538 0 1 1 .7-.82l.82.7a.538.538 0 0 1-.35.95ZM19.85 19.89c-.12 0-.24-.04-.34-.12-.28-.23-.55-.45-.83-.67a.54.54 0 1 1 .68-.84c.28.22.56.45.84.69a.545.545 0 0 1-.35.96ZM17.3 17.91a.5.5 0 0 1-.31-.1c-.29-.21-.58-.41-.87-.6a.535.535 0 0 1-.15-.75c.16-.25.5-.32.75-.15.3.2.6.41.9.62.24.17.3.51.12.75-.11.15-.27.23-.44.23ZM14.55 16.22c-.08 0-.16-.02-.24-.06-.32-.16-.64-.3-.94-.41a.539.539 0 0 1-.31-.7c.11-.28.42-.41.7-.31.33.13.68.28 1.03.45.27.13.38.45.24.72-.09.19-.29.3-.48.3ZM11.49 15.27h-.05c-.15-.01-.31-.02-.46-.02-.3 0-.54-.24-.54-.54s.24-.54.54-.54c.18 0 .37 0 .55.02a.536.536 0 0 1-.05 1.07ZM14.6 23.96c-.07 0-.14-.01-.2-.04a.538.538 0 0 1-.3-.7c.14-.34.31-.68.51-1.03.15-.26.48-.34.74-.19.26.15.34.48.19.74-.18.31-.33.61-.45.9a.55.55 0 0 1-.5.34ZM16.34 21.26c-.13 0-.25-.04-.35-.13a.539.539 0 0 1-.05-.76c.44-.5.78-.81.79-.82.22-.2.56-.18.76.04.2.22.19.56-.03.76 0 0-.31.28-.71.74-.11.12-.26.18-.4.18ZM42.62 36.92a.56.56 0 0 1-.4-.17c-.2-.22-.19-.55.03-.76.01-.01.22-.23.5-.75a.54.54 0 0 1 .95.51c-.37.69-.66.98-.72 1.03-.1.09-.23.14-.36.14ZM43.99 34.03s-.1 0-.14-.02a.547.547 0 0 1-.38-.66c.08-.31.17-.64.24-1.01a.54.54 0 0 1 .64-.42c.29.06.48.34.42.64-.08.38-.16.74-.26 1.08-.07.24-.28.4-.52.4ZM25.48 35.2c-.3 0-.54-.24-.54-.54 0-.05 0-.48.07-1.13a.538.538 0 1 1 1.07.11c-.07.61-.07 1-.07 1.02 0 .3-.24.54-.54.54ZM25.93 32s-.09 0-.14-.02a.543.543 0 0 1-.39-.66c.09-.36.2-.72.32-1.07.1-.28.4-.43.68-.34.28.1.43.4.33.68-.11.32-.21.66-.3.99-.06.24-.28.4-.52.4ZM27.12 29c-.09 0-.18-.02-.26-.07a.53.53 0 0 1-.2-.73c.19-.33.39-.66.61-.96.17-.24.51-.3.75-.12.24.17.3.51.12.75-.19.27-.38.56-.55.86-.1.18-.28.27-.47.27ZM26.86 23.48a.547.547 0 0 1-.51-.74c0-.02.16-.42.49-1.03.14-.26.47-.36.73-.22s.36.47.22.73c-.29.55-.44.92-.44.92a.54.54 0 0 1-.5.34ZM28.46 20.68a.55.55 0 0 1-.32-.1.542.542 0 0 1-.12-.75c.22-.3.45-.6.69-.88a.53.53 0 0 1 .76-.06c.23.19.26.53.06.76-.22.26-.44.54-.64.82-.11.14-.27.22-.44.22ZM30.64 18.3a.538.538 0 0 1-.35-.95c.29-.25.58-.48.88-.7.24-.17.58-.12.75.12s.12.58-.12.75c-.27.2-.55.41-.81.64-.1.09-.23.13-.35.13ZM33.35 16.55c-.2 0-.4-.12-.49-.31-.12-.27 0-.59.27-.71.34-.16.69-.3 1.05-.42.28-.1.59.05.68.33.1.28-.05.59-.33.68-.32.11-.64.24-.95.38-.07.03-.15.05-.22.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.01 5.38c-2.26-.27-1.62 1.62-4.31 4.85-1.82 2.19.54 2.13 5.38 3.23 2.05.46 8.77-1.01 7.7 3.84-.36 1.64 3.62 4.24 4.16 8.01.35 2.46 3.04 0 5.38-1.08 3-1.38 2.55-3.81 2.77-4.44M33.2 40.98c-.12 1.84-2.6 2.23-2.69 3.77-.08 1.37 1.77 2.99 2.87 2.7 1.18-.32 1.87-1.11 3.6-2.7 1.71-1.58 4.85-1.08 6.46-4.31.57-1.15-2.31-1.76-2.69-2.69-.87-2.15-3.73-3.77-4.85-3.23-1.2.58-3.21 3-3.23 4.31-.02 1.07.6 1.23.54 2.15ZM5.39 28s2.67-3.12 4.82-3.12 4.63.23 5.17 1.31-1.37 7.66-.3 7.66 2.68 1.35 4.3 1.89 7.55.34 7 1.42-2.69 2.69-4.31 2.69-1.62 1.34-1.62 2.42 1.93 2.43 3.55 4.04-.33 3.89-.33 3.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.62 28c0 .56-.02 1.11-.06 1.65-.29 4.01-1.62 7.72-3.73 10.88C42.78 46.61 35.86 50.61 28 50.61c-.45 0-.89-.01-1.33-.04-.27-.01-.53-.04-.79-.06-9.06-.84-16.57-7.03-19.34-15.38-.35-1.07-.63-2.17-.83-3.3-.21-1.25-.32-2.52-.32-3.83 0-4.65 1.4-8.97 3.81-12.56C13.26 9.38 20.17 5.39 28.01 5.39c.37 0 .73 0 1.09.03 3.09.15 6.02.91 8.66 2.18 5.63 2.69 9.97 7.65 11.85 13.69.66 2.12 1.01 4.38 1.01 6.72Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnderseaCableNetwork56 = (UnderseaCableNetwork56);
;// ./src/Picto/GeneratedPictoComponents/UnifiedComms104.tsx


var UnifiedComms104_excluded = ["className"];
function UnifiedComms104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnifiedComms104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnifiedComms104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnifiedComms104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnifiedComms104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnifiedComms104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnifiedComms104_objectSpread(UnifiedComms104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.78 33.81c1.04 0 2.01-.28 2.85-.75a9.356 9.356 0 0 1-7.86-7.86c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77ZM77.47 33.81c1.04 0 2.01-.28 2.85-.75a9.356 9.356 0 0 1-7.86-7.86c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77ZM52.45 82.61c1.04 0 2.01-.28 2.85-.75A9.356 9.356 0 0 1 47.44 74c-.48.84-.75 1.81-.75 2.85 0 3.19 2.58 5.77 5.77 5.77Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.43",
        cy: "77.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.99",
        cy: "76.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.08 88c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "77.33",
        cy: "28.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.9",
        cy: "27.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.99 39c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.93",
        cy: "28.02",
        r: "6.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.5",
        cy: "27.5",
        r: "15.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.59 39c3.2-2.22 5.03-4 10.4-4 4.36 0 6.8 1.63 9.53 4 .24.2-4.71 3.98-9.53 4-5.48.02-11.12-3.5-10.4-4Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m60.06 40.51-7.91 7.9M43.71 40.33l7.91 7.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 56.67v-8.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnifiedComms104 = (UnifiedComms104);
;// ./src/Picto/GeneratedPictoComponents/UnifiedComms56.tsx


var UnifiedComms56_excluded = ["className"];
function UnifiedComms56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UnifiedComms56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UnifiedComms56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UnifiedComms56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UnifiedComms56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UnifiedComms56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UnifiedComms56_objectSpread(UnifiedComms56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.03 18.91c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89ZM40.38 18.91c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89ZM27.87 44.32c.52 0 1-.14 1.42-.38-2.03-.3-3.63-1.9-3.93-3.93-.24.42-.38.91-.38 1.42a2.89 2.89 0 0 0 2.88 2.89Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.86",
        cy: "41.53",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.64",
        cy: "41.27",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.68 47.02c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.31",
        cy: "16.02",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.1",
        cy: "15.75",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.14 21.51c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.1",
        cy: "16.02",
        r: "3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "15.89",
        cy: "15.75",
        r: "7.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.93 21.51c1.6-1.11 2.52-2 5.2-2 2.18 0 3.4.82 4.77 2 .12.1-2.35 1.99-4.77 2-2.74.01-5.56-1.75-5.2-2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.67 23.26-3.95 3.96M23.5 23.17l3.95 3.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.64 31.35v-4.22"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UnifiedComms56 = (UnifiedComms56);
;// ./src/Picto/GeneratedPictoComponents/UploadDoc104.tsx


var UploadDoc104_excluded = ["className"];
function UploadDoc104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UploadDoc104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UploadDoc104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UploadDoc104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UploadDoc104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UploadDoc104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UploadDoc104_objectSpread(UploadDoc104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.66 51.64c3.55 18.56 13.8 23.37 16.89 25.77 3.2 2.49 3.74 5.56 3.22 6.3H14.25s-3.12-.15-3.12-3.87V43.31c1.65 0 3.54 8.32 3.54 8.32",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.12 83.71H15.56c-2.44 0-4.42-1.98-4.42-4.43V15.54c0-2.45 1.98-4.43 4.42-4.43h37.48c1.17 0 2.3.47 3.13 1.3l9.67 9.69c.83.83 1.3 1.96 1.3 3.14v6.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.78 11.24v8.33c0 2.47 2.01 4.48 4.5 4.48h7.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.18 56.4c2.38 11.73 11.36 26.62 19.56 33.48.88.72.26 2.35-.88 2.08-17.27-3.16-25.11-18.68-20.88-35.64.26-1.17 1.94-1.08 2.2.09",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "64.52",
        cy: "64.15",
        rx: "28.35",
        ry: "28.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.53 65.25v7.72H49.52v-7.72M71.38 58.39l-6.86-7.72-6.86 7.72M64.52 66.96V51.53"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UploadDoc104 = (UploadDoc104);
;// ./src/Picto/GeneratedPictoComponents/UploadDoc56.tsx


var UploadDoc56_excluded = ["className"];
function UploadDoc56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function UploadDoc56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? UploadDoc56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : UploadDoc56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function UploadDoc56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, UploadDoc56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", UploadDoc56_objectSpread(UploadDoc56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M8.36 27.81c1.87 9.76 7.26 12.29 8.89 13.56 1.68 1.31 1.97 2.92 1.69 3.32H8.14s-1.64-.08-1.64-2.04V23.43c.87 0 1.86 4.38 1.86 4.38",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.22 44.68H8.83c-1.28 0-2.33-1.04-2.33-2.33V8.82c0-1.29 1.04-2.33 2.33-2.33h19.72c.62 0 1.21.25 1.65.68l5.09 5.1c.44.44.68 1.03.68 1.65v3.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.94 6.56v4.38c0 1.3 1.06 2.36 2.37 2.36h4.12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.78 30.32c1.25 6.17 5.98 14.01 10.29 17.61.46.38.14 1.23-.46 1.09-9.09-1.66-13.21-9.83-10.99-18.75.14-.62 1.02-.57 1.16.05",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "34.59",
        cy: "34.39",
        rx: "14.92",
        ry: "15.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.48 34.97v4.06H26.69v-4.06M38.2 31.36l-3.61-4.06-3.61 4.06M34.59 35.87v-8.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_UploadDoc56 = (UploadDoc56);
;// ./src/Picto/GeneratedPictoComponents/Video104.tsx


var Video104_excluded = ["className"];
function Video104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Video104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Video104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Video104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Video104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Video104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Video104_objectSpread(Video104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M47.7 90.32C12.82 74.22 21.27 35.31 24.48 24.3c.27-.93-.84-1.64-1.56-1-17.22 14.88-9.58 42-9.58 42 5.92 19.53 23.84 25.21 33.82 26.86 1.11.18 1.56-1.36.54-1.83Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "52",
      r: "41",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m65.37 50.19-10.39-6.12-10.37-6.12c-.3-.17-.64-.26-.99-.25a1.89 1.89 0 0 0-1.85 1.93V64.1c0 .34.08.68.25.98.52.9 1.68 1.21 2.58.69l10.37-6.11 10.39-6.12a1.964 1.964 0 0 0 0-3.34Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Video104 = (Video104);
;// ./src/Picto/GeneratedPictoComponents/Video56.tsx


var Video56_excluded = ["className"];
function Video56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Video56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Video56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Video56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Video56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Video56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Video56_objectSpread(Video56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.74 48.1C7.45 39.65 11.89 19.25 13.57 13.47c.14-.49-.44-.86-.82-.53-9.03 7.8-5.02 22.03-5.02 22.03 3.1 10.24 12.5 13.22 17.73 14.08.58.1.82-.71.28-.96Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "28",
      r: "21.5",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m35.01 27.05-5.45-3.21-5.44-3.21a.96.96 0 0 0-.52-.13c-.55.01-.98.46-.97 1.01v12.83c0 .18.04.36.13.52.27.47.88.63 1.35.36l5.44-3.2L35 28.81c.14-.08.25-.2.34-.34.3-.48.15-1.12-.34-1.42Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Video56 = (Video56);
;// ./src/Picto/GeneratedPictoComponents/Arts104.tsx


var Arts104_excluded = ["className"];
function Arts104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Arts104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Arts104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Arts104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Arts104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Arts104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Arts104_objectSpread(Arts104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.26 39.94c-3.97 5.36-11.43 6.67-16.99 2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.72 32.69a3.587 3.587 0 0 1 2.95-3.13 3.61 3.61 0 0 1 3.85 1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.31 30.22c.16-1.59 1.35-2.89 2.92-3.18s3.15.5 3.86 1.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.67 64.93c-.71 11.48 7.09 25.05 19.54 27.32 3.05.51 6.19.32 9.16-.56-1.24.04-2.49-.04-3.71-.24-10.4-1.86-17.53-11.68-19.2-21.54a5.885 5.885 0 0 0-5.78-4.98Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.7 58.19c-13.37 2.27-26.2-9.51-28.28-21.41-.67-3.71-2.12-11.98-3.53-19.93l-.93-.06a3.37 3.37 0 0 0-2.75.96c-.72.72-1.08 1.73-.96 2.75 1.26 7.11 2.08 11.72 3.32 18.83 2.1 11.92 14.86 23.7 28.3 21.43 3.05-.6 5.92-1.87 8.41-3.71-1.16.49-2.36.87-3.58 1.13Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.67 64.93c-.69 11.48 7.13 25.05 19.56 27.32 13.39 2.27 26.2-9.51 28.3-21.43l3.34-18.89c.12-1.02-.23-2.03-.96-2.76a3.358 3.358 0 0 0-2.76-.96c-6.67.4-13.37 0-19.95-1.23-2.47-.45-4.87-.97-7.15-1.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.39 15.46a83.177 83.177 0 0 0 19.18-5.57c.92-.46 1.99-.47 2.92-.03.93.44 1.6 1.28 1.82 2.28 1.26 7.11 2.06 11.72 3.32 18.83 2.12 11.9-5.91 27.37-19.26 29.81-13.56 2.17-26.3-9.6-28.41-21.52L9.65 20.37a3.37 3.37 0 0 1 .96-2.75c.72-.72 1.73-1.08 2.75-.96 6.7.42 13.42.02 20.02-1.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.17 77.93c-3.96-5.36-11.42-6.68-16.97-2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.43 58.07a3.587 3.587 0 0 0 6.78 1.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73 60.47a3.587 3.587 0 0 0 2.95 3.13 3.61 3.61 0 0 0 3.85-1.93"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Arts104 = (Arts104);
;// ./src/Picto/GeneratedPictoComponents/Arts56.tsx


var Arts56_excluded = ["className"];
function Arts56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Arts56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Arts56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Arts56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Arts56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Arts56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Arts56_objectSpread(Arts56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.98 34.96c-.38 6.18 3.82 13.49 10.52 14.71 1.64.28 3.33.17 4.93-.3-.67.02-1.34-.02-2-.13-5.6-1-9.44-6.29-10.34-11.6a3.167 3.167 0 0 0-3.11-2.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.61 31.33c-7.2 1.22-14.11-5.12-15.23-11.53-.36-2-1.14-6.45-1.9-10.73l-.5-.03c-.55-.06-1.09.13-1.48.52-.39.39-.58.93-.52 1.48.68 3.83 1.12 6.31 1.79 10.14 1.13 6.42 8 12.76 15.24 11.54 1.64-.32 3.19-1.01 4.53-2-.62.26-1.27.47-1.93.61Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.98 22.86a6.757 6.757 0 0 1-9.15 1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.92 18.96c.1-.85.74-1.54 1.59-1.69.84-.15 1.69.27 2.07 1.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.24 17.63c.08-.86.73-1.56 1.57-1.71s1.69.27 2.08 1.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.98 34.96c-.37 6.18 3.84 13.49 10.53 14.71 7.21 1.22 14.11-5.12 15.24-11.54l1.8-10.17a1.789 1.789 0 0 0-2-2c-3.59.22-7.2 0-10.74-.66-1.33-.24-2.62-.52-3.85-.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.98 8.32c3.55-.58 7.02-1.59 10.33-3 .49-.25 1.07-.25 1.57-.02.5.24.86.69.98 1.23.68 3.83 1.11 6.31 1.79 10.14 1.14 6.41-3.18 14.74-10.37 16.05-7.3 1.17-14.16-5.17-15.3-11.59L5.2 10.96c-.06-.55.13-1.09.52-1.48.39-.39.93-.58 1.48-.52 3.61.23 7.23.01 10.78-.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.39 43.16a6.723 6.723 0 0 0-9.14-1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.91 32.47c.09.85.74 1.55 1.58 1.7.85.15 1.69-.28 2.07-1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.22 33.76c.1.85.74 1.54 1.59 1.69.84.15 1.69-.27 2.07-1.04"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Arts56 = (Arts56);
;// ./src/Picto/GeneratedPictoComponents/Entertainment104.tsx


var Entertainment104_excluded = ["className"];
function Entertainment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Entertainment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Entertainment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Entertainment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Entertainment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Entertainment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Entertainment104_objectSpread(Entertainment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "19.12",
        y: "13.27",
        width: "71.74",
        height: "75.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M19.12 89.1h71.74V13.27H19.12V89.1z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "19.12",
        y: "13.27",
        width: "71.74",
        height: "75.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M19.12 89.1h71.74V13.27H19.12V89.1z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "19.12",
        y: "13.27",
        width: "71.74",
        height: "75.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M19.12 89.1h71.74V13.27H19.12V89.1z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "34.33",
        y: "18.7",
        width: "55.07",
        height: "58.21",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M34.33 76.91h55.06V18.7H34.33v58.21z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "19.12",
        y: "13.27",
        width: "71.88",
        height: "75.84",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M19.12 89.1h71.74V13.27H19.12V89.1z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.88",
        width: "77.87",
        height: "82.32",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.88",
        width: "77.87",
        height: "82.32",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.88",
        width: "77.87",
        height: "82.32",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.88",
        width: "77.87",
        height: "82.32",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.88",
        width: "77.87",
        height: "82.32",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "15.14",
        y: "10.82",
        width: "77.87",
        height: "82.38",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M15.14 93.2h77.88V10.88H15.14V93.2z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.71 52.71 2.28 8.21h5.17c-3-3.17-5.41-6.49-6.8-8.52-.23-.34-.76-.09-.65.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.38 44.15S68.13 58.3 66.59 61.6c3.17-7.93 8.54-20.17 8.54-20.17l2.25 2.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.65 30.88c-1.5.75-2.78 1.98-3.56 3.6-1.89 3.9-.26 8.6 3.64 10.49 1.08.52 2.22.77 3.34.79.08-.02.16-.05.23-.07-10.32-5.58-3.65-14.8-3.65-14.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.55 73.28 52.4 61.76l-.38 29.55h8.56s5.44-13.55 22.98-13.17v-4.86H56.55ZM19.26 76.47h26.53c.71 0 1.33-.32 1.5-.77l.81-2.19H19.26v2.96Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.61 53.46-3.1.98-.98-3.1 3.1-.98.98 3.1z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.78 60.37-3.1.98-.98-3.1 3.11-.98.97 3.1z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.12 48.89-3.1.98-.98-3.1 3.1-.98.98 3.1z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.29 55.8-3.1.98-.98-3.1 3.11-.98.97 3.1z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.73 60.52 51 58.2l-5.03-15.97c-.68-2.17-3-3.38-5.18-2.7l-17.27 5.44-7.53 2.37c2.17-.68 4.48.52 5.16 2.69l3.32 10.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m75.26 60.74 8.46-15.14a7.81 7.81 0 0 1-5-.62 7.724 7.724 0 0 1-3.59-3.55l-8.2 19.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.54 33.82a4.224 4.224 0 0 1 1.96 5.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.21 41.33a7.854 7.854 0 0 1-10.49 3.64 7.854 7.854 0 0 1-3.64-10.49 7.854 7.854 0 0 1 10.49-3.64 7.854 7.854 0 0 1 3.64 10.49Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.09 60.73h31.92v30.59H20.09V74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.86 74.15v17.17H51.99V60.73h31.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.11 60.75-7.1 12.53h34.5l4.52-12.53H20.11zM83.9 60.75l7.09 12.53H56.55l-4.52-12.53H83.9z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.88 15.81c-1.83 3.7-1.36 9.4 1.58 14.67 2.4 4.3 5.89 7.35 9.33 8.55.71.25 1.25-.67.69-1.16-8.62-7.63-11-18.26-11.6-22.06"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.69 57.18c-.22 0-.45-.07-.64-.23a1 1 0 0 1-.14-1.41c.28-.33.52-.67.75-1 .31-.46.93-.58 1.39-.27.46.31.58.93.27 1.39-.26.39-.55.78-.86 1.15a.99.99 0 0 1-.77.36ZM61.98 53.09c-.1 0-.2-.02-.3-.05a.999.999 0 0 1-.65-1.26c.3-.94.45-1.91.45-2.89 0-.55.44-1.06.99-1.06s.99.38 1 .93v.07c0 1.26-.18 2.43-.54 3.56-.13.43-.53.7-.95.7ZM61.93 46.46c-.43 0-.82-.27-.95-.7-.52-1.67-1.28-2.74-1.29-2.75a.994.994 0 0 1 .23-1.39 1 1 0 0 1 1.39.22c.04.05.95 1.33 1.58 3.33a.997.997 0 0 1-.66 1.25c-.1.03-.2.05-.3.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m55.12 31.25-6.17-11.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.83 26.93 4.41-2.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.3 29.58 4.42-2.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.35 24.29 4.42-2.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.61 20.93c4.01 7.2 3.42 15.17-1.32 17.81-4.74 2.64-11.83-1.06-15.84-8.26-4.01-7.2-3.42-15.17 1.32-17.81 4.74-2.64 11.83 1.06 15.84 8.26Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Entertainment104 = (Entertainment104);
;// ./src/Picto/GeneratedPictoComponents/Entertainment56.tsx


var Entertainment56_excluded = ["className"];
function Entertainment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Entertainment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Entertainment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Entertainment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Entertainment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Entertainment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Entertainment56_objectSpread(Entertainment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "7.45",
        y: "3.42",
        width: "46.62",
        height: "49.28",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M7.45 52.7h46.62V3.42H7.45V52.7z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "4.48",
        width: "42.91",
        height: "45.36",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.84h42.91V4.48H8.37v45.36z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "4.48",
        width: "42.91",
        height: "45.36",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.84h42.91V4.48H8.37v45.36z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "4.48",
        width: "42.91",
        height: "45.36",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.84h42.91V4.48H8.37v45.36z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "4.48",
        width: "42.91",
        height: "45.36",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.84h42.91V4.48H8.37v45.36z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "4.48",
        width: "42.91",
        height: "45.36",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.84h42.91V4.48H8.37v45.36z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "8.37",
        y: "3.61",
        width: "43.26",
        height: "45.73",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M8.37 49.34h43.25V3.61H8.37v45.73z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "10.41",
        y: "4.69",
        width: "40.36",
        height: "42.66",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M10.41 47.35h40.36V4.69H10.41v42.66z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "7.86",
        y: "3.88",
        width: "43.23",
        height: "45.7",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M7.86 49.58h43.23V3.88H7.86v45.7z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "17.02",
        y: "7.16",
        width: "33.18",
        height: "35.08",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M17.02 42.23h33.19V7.16H17.02v35.07z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "7.86",
        y: "3.88",
        width: "43.23",
        height: "45.7",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M7.86 49.58h43.23V3.88H7.86v45.7z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m14.17 28.01-1.82.58-.58-1.83 1.83-.57.57 1.82z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m15.45 32.08-1.82.58-.58-1.83 1.83-.57.57 1.82z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m22.72 25.32-1.83.58-.57-1.83 1.82-.57.58 1.82z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24 29.39-1.83.58-.57-1.83 1.83-.57.57 1.82z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.47 30.86c-.13 0-.27-.04-.38-.14a.589.589 0 0 1-.08-.83c.16-.2.31-.4.44-.59.18-.27.55-.34.82-.16.27.18.34.55.16.82-.16.23-.33.46-.51.68-.12.14-.29.22-.46.22ZM34.82 28.44c-.06 0-.12 0-.18-.03a.601.601 0 0 1-.39-.74c.18-.56.27-1.13.27-1.72 0-.33.26-.63.59-.63.32 0 .59.22.59.55v.04a7 7 0 0 1-.32 2.11c-.08.25-.31.41-.56.41ZM34.79 24.5c-.25 0-.49-.16-.57-.42-.31-.99-.76-1.63-.77-1.63a.6.6 0 0 1 .13-.83c.26-.19.63-.13.83.13.02.03.57.79.94 1.97.1.31-.08.65-.39.74-.06.02-.12.03-.18.03Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.46 6.37c-1.09 2.22-.81 5.62.94 8.78 1.43 2.58 3.53 4.4 5.59 5.12.42.15.75-.4.41-.7-5.16-4.57-6.59-10.93-6.94-13.2"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.4 15.71 27 9.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.49 13.33 2.43-1.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.3 14.79 2.43-1.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.67 11.87 2.44-1.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.43 10.02c2.21 3.97 1.88 8.36-.73 9.82-2.61 1.45-6.52-.58-8.73-4.55-2.21-3.97-1.88-8.36.73-9.82 2.61-1.45 6.52.58 8.73 4.55Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m9.76 27.16 1.37 4.95h3.12c-1.81-1.91-3.26-3.91-4.1-5.14-.14-.21-.46-.05-.39.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.49 22.23s-5.58 8.53-6.51 10.52c1.91-4.78 5.15-12.16 5.15-12.16l1.35 1.64Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.9 14.6a4.416 4.416 0 0 0 1.92 8.37c.04-.01.09-.03.13-.04-5.81-3.14-2.06-8.32-2.05-8.33"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m30.43 39.57-2.5-6.94-.23 17.82h5.16s3.28-8.17 13.86-7.94v-2.93H30.44ZM8.31 41.48h16c.43 0 .8-.19.9-.47l.49-1.32H8.31v1.79Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.51 32.36-.44-1.4-3.03-9.62a2.478 2.478 0 0 0-3.12-1.62L10.51 23l-4.54 1.43c1.31-.41 2.7.31 3.11 1.62l2 6.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m41.69 32.49 5.1-9.12c-.98.2-2.04.1-3.01-.38a4.737 4.737 0 0 1-2.17-2.14l-4.94 11.46"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.29 16.27a2.54 2.54 0 0 1 1.18 3.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.1 20.79a4.73 4.73 0 1 1-8.51-4.13 4.73 4.73 0 0 1 8.51 4.13Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M8.45 32.49h19.23v18.43H8.45V40.48"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.87 40.57v10.35h-19.2V32.49h19.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m8.46 32.5-4.28 7.55h20.79l2.73-7.55H8.46zM46.9 32.5l4.27 7.55H30.42L27.7 32.5h19.2z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Entertainment56 = (Entertainment56);
;// ./src/Picto/GeneratedPictoComponents/EntertainmentPackages104.tsx


var EntertainmentPackages104_excluded = ["className"];
function EntertainmentPackages104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EntertainmentPackages104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EntertainmentPackages104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EntertainmentPackages104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EntertainmentPackages104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EntertainmentPackages104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EntertainmentPackages104_objectSpread(EntertainmentPackages104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.47 79.75c-1.01.25-1.89.88-2.45 1.76-1.1 1.73-3.08 4.88-4.85 7.87-2.64 4.42-6.24 3.19-6.24 3.19a6.216 6.216 0 0 1-4.81-6.22l-1.28-13.82c-.4-2.39 0-4.84 1.11-6.98l1.32 13.93a6.555 6.555 0 0 0 5.05 6.65s3.08.76 6.56-3.38c2.43-2.92 2.53-3.58 6.93-4.16l-1.32 1.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.99 76.04c1.86.98 6.24 4.16 9.29 5.92 4.42 2.62 7-.17 7-.17a6.224 6.224 0 0 0 1.24-7.78l-5.57-12.76c-.68-1.8-1.77-3.41-3.19-4.7.33.6.61 1.22.85 1.86l5.57 12.76c1.49 2.55.98 5.8-1.23 7.76 0 0-2.58 2.8-7 .19a71.29 71.29 0 0 0-6.89-2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.56 65.42c-9.03-1.92-16.07-8.98-17.94-17.98l-5.14-23.73c-.14-.63-.5-.42-.5.05l.16 46.26c0 1.45 1.18 2.63 2.63 2.64l29.08-.12-.03-2.14c-.45-1.03 1.61-2.89.51-3.12l-8.76-1.86Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.81 81.42h20.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.69 73.58H13.78c-1.97 0-3.57-1.6-3.57-3.57V23.42c0-1.97 1.6-3.57 3.57-3.57h76.44c1.97 0 3.57 1.6 3.57 3.57v46.6c0 1.25-.64 2.35-1.62 2.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.85 81.42V73.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.49 54.76s7.76-2.58 11.46 6.5l5.57 12.76a6.25 6.25 0 0 1-1.24 7.78s-2.58 2.79-7 .17c-2.97-1.86-6.2-3.57-8.02-4.57-.92-.51-2.01-.64-3.03-.37l-2.84.72-4.98 1.26-2.84.72c-1.03.28-1.92.94-2.47 1.86-1.11 1.75-3.1 4.88-4.85 7.86-2.64 4.42-6.24 3.19-6.24 3.19a6.216 6.216 0 0 1-4.81-6.22L42.92 72.6c-1.13-9.75 6.87-11.14 6.91-11.14l12.46-2.1a12.1 12.1 0 0 0 1.97-.5l11.24-4.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.51",
        cy: "61.93",
        r: "2.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "78.84",
        cy: "71.29",
        r: "2.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "82.36",
        cy: "65.51",
        r: "2.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "72.99",
        cy: "67.7",
        r: "2.27"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.25 75.71-.09-.35c-.12-.48-.42-.9-.85-1.15a1.91 1.91 0 0 0-1.42-.21h-.32c-.54.14-1.11.06-1.59-.22s-.82-.74-.96-1.28c-.11-.44-.08-.9.11-1.32h-.19c-1.12.28-1.8 1.42-1.52 2.54.14.54.48 1.01.96 1.3s1.06.37 1.6.23l2.01-.45.63 2.06c.14.54.48 1.01.96 1.3.48.29 1.06.37 1.6.23.61-.17 1.12-.6 1.37-1.19-1.04.16-2.03-.48-2.32-1.49Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.42 68.96-2.17.56-.56-2.17A2.22 2.22 0 0 0 52 65.72c-.57.14-1.06.5-1.36 1-.3.5-.39 1.1-.24 1.67l.56 2.17-2.19.56c-.57.14-1.06.51-1.35 1.02-.3.51-.38 1.11-.23 1.68.14.57.5 1.06 1 1.36.5.3 1.1.39 1.67.24l2.14-.41.56 2.17a2.232 2.232 0 0 0 2.69 1.6 2.2 2.2 0 0 0 1.6-2.69l-.56-2.17 2.17-.56c.57-.14 1.06-.5 1.36-1 .3-.5.39-1.1.24-1.67-.12-.58-.46-1.09-.96-1.41s-1.1-.43-1.68-.3Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EntertainmentPackages104 = (EntertainmentPackages104);
;// ./src/Picto/GeneratedPictoComponents/EntertainmentPackages56.tsx


var EntertainmentPackages56_excluded = ["className"];
function EntertainmentPackages56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EntertainmentPackages56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EntertainmentPackages56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EntertainmentPackages56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EntertainmentPackages56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EntertainmentPackages56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EntertainmentPackages56_objectSpread(EntertainmentPackages56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.6 42.69c-.55.14-1.02.48-1.32.95-.59.93-1.66 2.63-2.61 4.24-1.42 2.38-3.36 1.72-3.36 1.72a3.35 3.35 0 0 1-2.59-3.35l-.69-7.44c-.21-1.29 0-2.61.6-3.76l.71 7.5a3.53 3.53 0 0 0 2.72 3.58s1.66.41 3.53-1.82c1.31-1.57 1.36-1.93 3.73-2.24l-.71.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.34 40.69c1 .53 3.36 2.24 5 3.19 2.38 1.41 3.77-.09 3.77-.09a3.356 3.356 0 0 0 .67-4.19l-3-6.87c-.36-.97-.95-1.84-1.72-2.53.18.32.33.66.46 1l3 6.87c.8 1.37.53 3.12-.66 4.18 0 0-1.39 1.51-3.77.1-1.21-.6-2.45-1.14-3.71-1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.28 35.29a12.48 12.48 0 0 1-9.61-9.68l-2.7-13.19c-.09-.17-.24-.13-.24.12v25.23c0 .78.63 1.41 1.41 1.42l15.85.43.16-3.32-4.87-1.01Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.28 43.84h11.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.99 39.62H7.42A1.92 1.92 0 0 1 5.5 37.7V12.61c0-1.06.86-1.92 1.92-1.92h41.16c1.06 0 1.92.86 1.92 1.92V37.7c0 .67-.35 1.27-.87 1.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.92 43.84v-4.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.65 29.48s4.18-1.39 6.17 3.5l3 6.87c.8 1.38.52 3.13-.67 4.19 0 0-1.39 1.5-3.77.09-1.6-1-3.34-1.92-4.32-2.46-.5-.27-1.08-.35-1.63-.2l-1.53.39-2.68.68-1.53.39c-.56.15-1.03.51-1.33 1-.6.94-1.67 2.63-2.61 4.23-1.42 2.38-3.36 1.72-3.36 1.72a3.35 3.35 0 0 1-2.59-3.35l-.69-7.44c-.61-5.25 3.7-6 3.72-6l6.71-1.13c.36-.06.72-.15 1.06-.27l6.05-2.21Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.2",
        cy: "33.34",
        r: "1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.45",
        cy: "38.38",
        r: "1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.35",
        cy: "35.27",
        r: "1.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.3",
        cy: "36.45",
        r: "1.22"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.21 40.76-.05-.19a.994.994 0 0 0-.46-.62.966.966 0 0 0-.76-.11h-.17c-.29.08-.6.03-.85-.12-.26-.15-.44-.4-.52-.69-.06-.24-.04-.49.06-.71h-.1c-.6.15-.97.77-.82 1.37.07.29.26.54.52.7s.57.2.86.12l1.08-.24.34 1.11a1.127 1.127 0 0 0 1.38.82c.33-.09.6-.33.74-.64-.56.09-1.1-.26-1.25-.8Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.92 37.13-1.17.3-.3-1.17c-.16-.64-.81-1.04-1.45-.88a1.181 1.181 0 0 0-.86 1.44l.3 1.17-1.18.3a1.182 1.182 0 0 0-.85 1.45 1.181 1.181 0 0 0 1.44.86l1.15-.22.3 1.17c.17.64.81 1.02 1.45.86.31-.08.57-.27.73-.55.16-.27.21-.6.13-.9l-.3-1.17 1.17-.3a1.181 1.181 0 0 0 .86-1.44c-.06-.31-.25-.59-.52-.76s-.59-.23-.9-.16Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EntertainmentPackages56 = (EntertainmentPackages56);
;// ./src/Picto/GeneratedPictoComponents/Foxtel104.tsx


var Foxtel104_excluded = ["className"];
function Foxtel104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Foxtel104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Foxtel104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Foxtel104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Foxtel104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Foxtel104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Foxtel104_objectSpread(Foxtel104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.56 65.42c-9.03-1.92-16.07-8.98-17.94-17.98l-5.14-23.73c-.14-.63-.5-.42-.5.05l.16 46.26c0 1.45 1.18 2.63 2.63 2.64h43.39l-.55-1.68c-.45-1.03-1.28-1.16-2.38-1.39l-19.66-4.17Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.81 80.82h47.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.15 73v7.82"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.85 80.82V73"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.67 72.98h3.55c1.97 0 3.57-1.6 3.57-3.57V22.82c0-1.97-1.6-3.57-3.57-3.57H13.78c-1.97 0-3.57 1.6-3.57 3.57v46.6c0 1.97 1.6 3.57 3.57 3.57h57.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20 72.98h50.79"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M72.26 70.31c-.04-.52-.74-.42-.75.1l-.24 13.32c.02 6.66 4.24 5.76 4.24 5.76l5.19-.51c.72-.03.88-1.48 0-1.93-.96-.48-7.11.52-8.44-16.74Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.92 60.26h-2.17v-2.32c0-.39-.32-.71-.71-.71h-1.55c-.39 0-.71.32-.71.71v2.32h-2.17c-.39 0-.71.32-.71.71v1.55c0 .39.32.71.71.71h2.17v2.21c0 .39.32.71.71.71h1.55c.39 0 .71-.32.71-.71v-2.21h2.17c.39 0 .71-.32.71-.71v-1.55c0-.39-.32-.71-.71-.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.1 72.41c0 .89-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.1 78.03c0 .88-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.1 83.65c0 .89-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.6 72.41c0 .89-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.6 78.03c0 .88-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.6 83.65c0 .89-.72 1.6-1.6 1.6s-1.6-.72-1.6-1.6.72-1.6 1.6-1.6 1.6.72 1.6 1.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M82.69 89.58h-8.86c-1.68 0-3.04-1.5-3.04-3.35V56.29c0-1.85 1.36-3.34 3.04-3.34h8.86c1.68 0 3.04 1.5 3.04 3.34v29.94c0 1.85-1.36 3.35-3.04 3.35Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Foxtel104 = (Foxtel104);
;// ./src/Picto/GeneratedPictoComponents/Foxtel56.tsx


var Foxtel56_excluded = ["className"];
function Foxtel56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Foxtel56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Foxtel56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Foxtel56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Foxtel56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Foxtel56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Foxtel56_objectSpread(Foxtel56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.32 36.54a12.48 12.48 0 0 1-9.61-9.68l-2.7-13.19c-.09-.17-.24-.13-.24.12v25.23c0 .78.63 1.41 1.41 1.42h21.05l-1.33-2.12-8.58-1.78Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.11 44.8H38.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.43 40.68v4.12"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.57 44.8v-4.12"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.28 40.67h2.36c1.04 0 1.88-.84 1.88-1.88V14.23c0-1.04-.84-1.88-1.88-1.88H8.36c-1.04 0-1.88.84-1.88 1.88v24.56c0 1.04.84 1.88 1.88 1.88h30.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.64 40.67H38.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M39.18 39.26c-.02-.27-.39-.22-.39.05l-.12 7.02c.01 3.51 2.23 3.04 2.23 3.04l2.73-.27c.38-.01.46-.78 0-1.02-.51-.25-3.74.27-4.45-8.82Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.27 33.96h-1.14v-1.22a.37.37 0 0 0-.37-.37h-.82a.37.37 0 0 0-.37.37v1.22h-1.14a.37.37 0 0 0-.37.37v.82c0 .21.17.37.37.37h1.14v1.16c0 .21.17.37.37.37h.82c.21 0 .37-.17.37-.37v-1.16h1.14c.21 0 .37-.17.37-.37v-.82a.37.37 0 0 0-.37-.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.73 40.37c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.73 43.33c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.73 46.29c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.63 40.37c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.63 43.33c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.63 46.29c0 .47-.38.84-.84.84s-.85-.38-.85-.84.38-.84.85-.84.84.38.84.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.67 49.42H40c-.88 0-1.6-.79-1.6-1.76V31.88c0-.97.72-1.76 1.6-1.76h4.67c.89 0 1.6.79 1.6 1.76v15.78c0 .97-.72 1.76-1.6 1.76Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Foxtel56 = (Foxtel56);
;// ./src/Picto/GeneratedPictoComponents/Gaming104.tsx


var Gaming104_excluded = ["className"];
function Gaming104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gaming104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gaming104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gaming104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gaming104_objectSpread(Gaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m98.37 67.73-.43-3.21c.02 2.11-.51 7.33-5.78 9.42l-.04.02c-.24.12-2.43 1.15-5.11 1.12-2.88-.04-5.28-1.27-7.14-3.66L68.4 59.93c-.34-.77-2.02-3.12-5.96-3.17l-17.63-.23c-4.25-.06-5.85 2.64-6.09 3.09L27 70.72c-1.92 2.34-4.36 3.51-7.23 3.47-2.78-.04-5.02-1.22-5.04-1.23-.02 0-.03-.02-.05-.02-5.25-2.25-6.17-7.52-6.1-9.64l-.57 2.76c-.05.33-.48 8.57 6.4 11.52.02.01 1.47.66 4.41.7 3.05.04 6.36-1.97 8.39-4.44l11.91-10.8c.06-.12 1.43-2.91 5.63-2.85l17.62.23c4.2.06 5.5 2.88 5.51 2.92l12.34 12.04c1.97 2.53 3.71 3.75 6.76 3.8h2.46c3.29-1.16 2.79-.56 2.85-.58 6.92-2.74 6.1-10.54 6.06-10.86"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.43 23.7c-2.13-.24-4.14-.46-8.38-.57-4.25-.1-8.3 1.54-11.41 4.62-3.27 3.23-4.59 7.81-5.05 11.76-.4 3.51-3.58 28.11-3.58 28.11-.04.32-.79 7.79 5.63 10.4 0 0 2.49 1.21 5.15 1.17 2.8-.04 4.91-1.43 6.97-3.66 2.06-2.23 10.98-10.9 12.22-12.13 1.24-1.23 4.32-3.72 8.74-3.78h12.92c4.42.06 7.5 2.55 8.74 3.78 1.24 1.23 10.16 9.9 12.22 12.13 2.06 2.23 4.17 3.62 6.97 3.66 2.66.04 5.15-1.17 5.15-1.17 6.43-2.6 5.67-10.08 5.63-10.4 0 0-3.18-24.6-3.58-28.11-.46-3.94-1.78-8.52-5.05-11.76-3.11-3.08-7.16-4.72-11.41-4.62-4.24.1-6.25.33-8.38.57-3 .33-30.52.33-33.52 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.98 61.17c.31-2.45.65-5.1.98-7.62M11.22 67.12c.11-.86.24-1.83.37-2.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.1 35.87c-1.84 0-3.32-1.49-3.32-3.32 0-.12.02-.23.04-.35a3.29 3.29 0 0 0-1.37 2.68c0 1.84 1.49 3.32 3.32 3.32 1.72 0 3.11-1.31 3.29-2.98-.55.4-1.22.65-1.96.65ZM86.69 43.5c-1.84 0-3.32-1.49-3.32-3.32 0-.12.02-.23.04-.35a3.29 3.29 0 0 0-1.37 2.68c0 1.84 1.49 3.32 3.32 3.32 1.72 0 3.11-1.31 3.29-2.98-.55.4-1.22.65-1.96.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.37 46.24-.05-.47c-.06-.63-.37-1.22-.87-1.62-.49-.4-1.13-.59-1.76-.52l-.4-.06c-.71.08-1.42-.13-1.97-.58a2.69 2.69 0 0 1-.98-1.81c-.06-.58.07-1.16.39-1.66l-.24-.03a2.694 2.694 0 0 0-2.41 2.95c.07.72.43 1.37.98 1.83s1.28.66 1.99.59l2.63-.19.42 2.74c.07.72.43 1.37.98 1.83.56.45 1.28.66 1.99.59a2.7 2.7 0 0 0 1.97-1.26c-1.35.01-2.5-.98-2.67-2.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.48 51.12c-1.84 0-3.32-1.49-3.32-3.32 0-.12.02-.23.04-.35a3.29 3.29 0 0 0-1.37 2.68c0 1.84 1.49 3.32 3.32 3.32 1.72 0 3.11-1.31 3.29-2.98-.55.4-1.22.65-1.96.65ZM71.95 43.5c-1.84 0-3.32-1.49-3.32-3.32 0-.12.02-.23.04-.35a3.29 3.29 0 0 0-1.37 2.68c0 1.84 1.49 3.32 3.32 3.32 1.72 0 3.11-1.31 3.29-2.98-.55.4-1.22.65-1.96.65Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "77.97",
        cy: "49.62",
        r: "3.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "42.76",
        y: "40.81",
        width: "7.26",
        height: "4.23",
        rx: ".19",
        ry: ".19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "53.87",
        y: "40.81",
        width: "7.26",
        height: "4.23",
        rx: ".19",
        ry: ".19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "77.97",
        cy: "34.88",
        r: "3.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "85.34",
        cy: "42.25",
        r: "3.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "70.6",
        cy: "42.25",
        r: "3.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.56 38.43h-2.41v-2.17a3.26 3.26 0 0 0-6.52 0v2.17h-2.31a3.26 3.26 0 0 0 0 6.52h2.31v2.4a3.26 3.26 0 0 0 6.52 0v-2.4h2.41a3.26 3.26 0 0 0 0-6.52Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gaming104 = (Gaming104);
;// ./src/Picto/GeneratedPictoComponents/Gaming56.tsx


var Gaming56_excluded = ["className"];
function Gaming56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gaming56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gaming56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gaming56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gaming56_objectSpread(Gaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.97 36.47-.23-1.73c0 1.14-.27 3.95-3.11 5.07h-.02c-.13.07-1.31.63-2.75.61-1.55-.02-2.84-.68-3.84-1.97l-5.94-5.95c-.12-.12-.23-.24-.32-.39-.3-.51-1.22-1.54-3.13-1.56l-9.49-.13c-2.29-.03-3.15 1.42-3.28 1.67l-6.31 5.98c-1.04 1.26-2.35 1.89-3.89 1.87-1.5-.02-2.7-.66-2.71-.66 0 0-.02 0-.02-.01-2.83-1.21-3.32-4.05-3.28-5.19l-.31 1.49c-.03.18-.26 4.62 3.44 6.2.01 0 .79.35 2.37.37 1.64.02 3.42-1.06 4.52-2.39l6.42-5.81c.03-.06.77-1.57 3.03-1.54l9.49.13c2.26.03 2.96 1.55 2.96 1.57l6.64 6.48c1.06 1.36 2 2.02 3.64 2.04h1.32c1.77-.62 1.5-.3 1.53-.31 3.73-1.48 3.29-5.67 3.27-5.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.37 24.88-.03-.25a1.271 1.271 0 0 0-1.4-1.14l-.21-.03a1.422 1.422 0 0 1-1.57-1.27c-.03-.31.04-.62.21-.88l-.13-.02c-.79.08-1.36.78-1.28 1.57.04.38.23.73.52.97s.68.35 1.06.31l1.4-.1.22 1.46c.04.38.23.73.52.97.3.24.68.35 1.06.31.43-.05.82-.3 1.05-.67-.72 0-1.33-.52-1.43-1.24Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.62 12.76c-1.14-.13-2.23-.25-4.51-.3-2.29-.05-4.47.83-6.15 2.49-1.76 1.74-2.47 4.21-2.72 6.33-.21 1.89-1.93 15.13-1.93 15.13-.02.17-.43 4.2 3.03 5.6 0 0 1.34.65 2.77.63 1.51-.02 2.64-.77 3.75-1.97 1.11-1.2 5.91-5.87 6.58-6.53.67-.66 2.32-2 4.71-2.03h6.96c2.38.03 4.04 1.37 4.71 2.03.67.66 5.47 5.33 6.58 6.53 1.11 1.2 2.24 1.95 3.75 1.97 1.43.02 2.77-.63 2.77-.63 3.46-1.4 3.05-5.43 3.03-5.6 0 0-1.71-13.24-1.93-15.13-.25-2.12-.96-4.59-2.72-6.33-1.68-1.66-3.86-2.54-6.15-2.49-2.28.05-3.37.18-4.51.3-1.62.18-16.43.18-18.05 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.45 32.94c.17-1.32.35-2.74.53-4.1M6.04 36.14c.06-.46.13-.99.2-1.56"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.68 27.48c-.98 0-1.77-.79-1.77-1.77 0-.06.01-.12.02-.19a1.767 1.767 0 0 0 1.04 3.2c.92 0 1.66-.7 1.75-1.59-.29.21-.65.35-1.04.35ZM38.66 23.42c-.98 0-1.77-.79-1.77-1.77 0-.06.01-.12.02-.19a1.767 1.767 0 0 0 1.04 3.2c.92 0 1.66-.7 1.75-1.59-.29.21-.65.35-1.04.35ZM42.47 19.36c-.98 0-1.77-.79-1.77-1.77 0-.06.01-.12.02-.19a1.767 1.767 0 0 0 1.04 3.2c.92 0 1.66-.7 1.75-1.59-.29.21-.65.35-1.04.35ZM46.52 23.42c-.98 0-1.77-.79-1.77-1.77 0-.06.01-.12.02-.19a1.767 1.767 0 0 0 1.04 3.2c.92 0 1.66-.7 1.75-1.59-.29.21-.65.35-1.04.35Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.11",
        y: "21.99",
        width: "3.87",
        height: "2.25",
        rx: ".1",
        ry: ".1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.02",
        y: "21.99",
        width: "3.87",
        height: "2.25",
        rx: ".1",
        ry: ".1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.87",
        cy: "18.83",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.8",
        cy: "22.75",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.94",
        cy: "22.75",
        r: "1.77"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.67 20.72h-1.29v-1.16a1.741 1.741 0 0 0-3.48 0v1.16h-1.23a1.741 1.741 0 0 0 0 3.48h1.23v1.28a1.741 1.741 0 0 0 3.48 0V24.2h1.29a1.741 1.741 0 0 0 0-3.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.87",
        cy: "26.68",
        r: "1.77"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gaming56 = (Gaming56);
;// ./src/Picto/GeneratedPictoComponents/Movies104.tsx


var Movies104_excluded = ["className"];
function Movies104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Movies104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Movies104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Movies104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Movies104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Movies104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Movies104_objectSpread(Movies104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.56 65.42c-9.03-1.92-16.07-8.98-17.94-17.98l-5.14-23.73c-.14-.63-.5-.42-.5.05l.16 46.26c0 1.45 1.18 2.63 2.63 2.64h43.39l-.55-1.68c-.45-1.03-1.28-1.16-2.38-1.39l-19.66-4.17Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.81 81.42h37.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57 73.58H13.78c-1.97 0-3.57-1.6-3.57-3.57V23.42c0-1.97 1.6-3.57 3.57-3.57h76.44c1.97 0 3.57 1.6 3.57 3.57v46.6c0 1.97-1.6 3.57-3.57 3.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.85 81.42V73.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m56.15 70.21 9.22 21.23c.56 1.29 2.01 1.9 3.24 1.37l17.81-7.74c.66-.29.66-1.28-.01-1.58-.57-.25-1.36-.35-2.37-.29-2.94.18-13.01-.16-19.02-6.08s-6.47-8.58-8.16-8.4c-1.13.12-.98.88-.71 1.49Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.2 83.58 77.05 57.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "59.2",
        y: "59.62",
        width: "29.6",
        height: "29.6",
        rx: "2",
        ry: "2",
        transform: "rotate(-23.47 74.002 74.428)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.52 60.26-4.58 1.99M90.9 77.24l-4.59 1.99M69.11 86.7l-4.58 1.99M61.74 69.72l-4.59 1.99M63.58 73.96l-4.58 2M86.85 68.91 61.16 80.06M71 91.05 59.85 65.37M67.27 82.45l-4.59 2M85.37 64.5l-4.59 2M89.05 72.99l-4.58 2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Movies104 = (Movies104);
;// ./src/Picto/GeneratedPictoComponents/Movies56.tsx


var Movies56_excluded = ["className"];
function Movies56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Movies56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Movies56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Movies56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Movies56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Movies56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Movies56_objectSpread(Movies56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.42 35.44a12.48 12.48 0 0 1-9.61-9.68l-2.7-13.19c-.09-.17-.24-.13-.24.12v25.23c0 .78.63 1.41 1.41 1.42h21.05L27 37.22l-8.58-1.78Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.33 39.68-20.91-.06A1.92 1.92 0 0 1 5.5 37.7V12.61c0-1.06.86-1.92 1.92-1.92h41.16c1.06 0 1.92.86 1.92 1.92V37.7s.12 1.98-2.05 1.98"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.28 43.84h18.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.92 43.84v-4.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.45 38.19 5.98 13.78c.36.84 1.3 1.24 2.1.89l11.56-5.02c.43-.19.43-.83 0-1.03-.37-.16-.88-.23-1.54-.19-1.91.11-8.44-.1-12.35-3.95-3.9-3.85-4.2-5.57-5.3-5.45-.73.08-.63.57-.46.97Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.82 46.9-7-16.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.62",
        y: "31.86",
        width: "18.58",
        height: "18.58",
        rx: "2",
        ry: "2",
        transform: "rotate(-23.47 38.907 41.15)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.89 32.27-2.88 1.25M49.51 42.92l-2.88 1.25M35.84 48.86l-2.88 1.25M31.21 38.2l-2.88 1.25M32.37 40.87l-2.88 1.25M46.97 37.69l-16.12 7M37.03 51.59l-7-16.12M34.68 46.2l-2.88 1.25M46.04 34.93l-2.88 1.25M48.36 40.26l-2.88 1.25"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Movies56 = (Movies56);
;// ./src/Picto/GeneratedPictoComponents/Music104.tsx


var Music104_excluded = ["className"];
function Music104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Music104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Music104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Music104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Music104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Music104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Music104_objectSpread(Music104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75 29.76c-.02-.35-.19-.67-.45-.89s-.84-.48-1.19-.43l-31.63 4.28c-.43.04-.76.4-.76.83v2.73l30.94-4.59c.34-.05.69.05.96.27s.43.55.44.89L73 63.92c.51.11 1.81 1.36 1.81.8s.2-34.96.2-34.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.66 86.21c-2.82.53-5.74-.25-7.92-2.12a9.535 9.535 0 0 1-3.34-7.49c.01-1.11.18-2.22.51-3.28a12.195 12.195 0 0 0-1.81 6.38 9.52 9.52 0 0 0 3.34 7.49 9.517 9.517 0 0 0 7.92 2.13c2.8-.45 5.32-1.74 7.28-3.63.71-.68-.14-1.79-.98-1.28-1.51.91-3.21 1.53-4.99 1.8Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.35 80.78a9.5 9.5 0 0 1-7.93-2.12 9.523 9.523 0 0 1-3.34-7.5c0-1.11.17-2.22.49-3.28a12.264 12.264 0 0 0-1.81 6.4 9.489 9.489 0 0 0 3.34 7.49 9.53 9.53 0 0 0 7.92 2.12c2.79-.44 5.31-1.73 7.28-3.61.71-.68-.14-1.8-.99-1.29-1.5.91-3.18 1.53-4.95 1.8Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m92.9 19.08-6.36 1.12M88.77 11.28l-4.71 4.26M82.21 6.1l-2.31 5.18M16 99l3.73-4.76M10.53 94.24l5.28-3.53M7.1 86.62l5.59-.99"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.49 26.9v41.33c-1.72-.69-3.6-.91-5.44-.63-6.32.99-11.06 6.3-11.33 12.69a9.52 9.52 0 0 0 3.34 7.49 9.517 9.517 0 0 0 7.92 2.13c6.32-.99 11.06-6.3 11.33-12.69v-.13l.13-39.88c0-.41.32-.75.73-.8l29.64-4.15c.32-.04.65.06.9.26.25.21.4.51.42.84v29.73c-1.72-.69-3.6-.92-5.44-.65-6.37.9-11.22 6.19-11.55 12.62a9.489 9.489 0 0 0 3.34 7.49 9.53 9.53 0 0 0 7.92 2.12c6.32-.98 11.07-6.3 11.33-12.69v-.13l.16-51.28c-.02-.65-.31-1.25-.81-1.67-.5-.42-1.14-.6-1.78-.51l-37.94 5.27a3.237 3.237 0 0 0-2.86 3.23Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Music104 = (Music104);
;// ./src/Picto/GeneratedPictoComponents/Music56.tsx


var Music56_excluded = ["className"];
function Music56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Music56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Music56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Music56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Music56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Music56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Music56_objectSpread(Music56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.44 16.53c-.01-.18-.1-.34-.23-.45s-.43-.24-.61-.22l-16.21 2.19c-.22.02-.39.21-.39.43v1.4l15.86-2.35c.18-.03.35.02.49.14s.22.28.22.46l-.16 15.92c.26.06.93.7.93.41s.1-17.92.1-17.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.23 45.46c-1.45.27-2.94-.13-4.06-1.08a4.886 4.886 0 0 1-1.71-3.84c0-.57.09-1.14.26-1.68-.6.98-.93 2.12-.93 3.27a4.886 4.886 0 0 0 5.77 4.93 6.94 6.94 0 0 0 3.73-1.86c.36-.35-.07-.92-.5-.66-.77.47-1.64.79-2.56.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.55 42.68c-1.45.27-2.94-.13-4.07-1.09a4.892 4.892 0 0 1-1.71-3.85c0-.57.09-1.14.25-1.68-.6.99-.93 2.12-.93 3.28-.04 1.47.59 2.88 1.71 3.84s2.61 1.35 4.06 1.08c1.43-.23 2.72-.89 3.73-1.85.37-.35-.07-.92-.51-.66-.77.46-1.63.78-2.54.92Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.86 10.17-3.39.59M47.66 6.01l-2.51 2.27M44.16 3.25l-1.23 2.76M8.88 52.75l1.99-2.53M5.97 50.22l2.81-1.89M4.14 46.15l2.98-.52"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.19 15.06v21.18c-.88-.36-1.85-.47-2.79-.33a6.882 6.882 0 0 0-5.81 6.5 4.886 4.886 0 0 0 5.77 4.93 6.882 6.882 0 0 0 5.81-6.5v-.07l.07-20.44c0-.21.16-.39.37-.41l15.19-2.13c.17-.02.33.03.46.14.13.11.21.26.22.43V33.6a5.41 5.41 0 0 0-2.79-.33 6.886 6.886 0 0 0-5.92 6.47c-.04 1.47.59 2.88 1.71 3.84s2.61 1.35 4.06 1.08c3.24-.5 5.67-3.23 5.81-6.5v-.07l.08-26.28c0-.33-.16-.64-.41-.86a1.16 1.16 0 0 0-.91-.26l-19.44 2.7c-.84.1-1.47.81-1.47 1.65Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Music56 = (Music56);
;// ./src/Picto/GeneratedPictoComponents/Sporting104.tsx


var Sporting104_excluded = ["className"];
function Sporting104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Sporting104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Sporting104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Sporting104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Sporting104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Sporting104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Sporting104_objectSpread(Sporting104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.4 69.2c-9.09 14.12-33.86 14.37-55.32.56A64.37 64.37 0 0 1 12.3 51.6a59.47 59.47 0 0 0 23.01 26.07c21.46 13.9 46.22 13.59 55.34-.6 4.54-7.05 4.3-16.21.27-25.35-.41-.92-1.82-.49-1.64.5 1.11 6.21.27 12.1-2.88 16.97Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.15 26.06c12.43-4.85 30.75-1.72 47.38 9.34 17.69 11.78 28.29 29.24 27.9 43.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.48 26.31-4.1 6.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.41 29.25-4.1 6.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m61.88 31.65-4.1 6.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m66 34.47-4.1 6.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m70.48 37.8-4.1 6.67"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.95 27.08c9.07-14.21 33.84-14.37 55.29-.54 21.46 13.83 31.5 36.47 22.41 50.53s-33.88 14.5-55.34.6C13.86 63.77 3.83 41.2 12.95 27.08"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Sporting104 = (Sporting104);
;// ./src/Picto/GeneratedPictoComponents/Sporting56.tsx


var Sporting56_excluded = ["className"];
function Sporting56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Sporting56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Sporting56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Sporting56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Sporting56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Sporting56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Sporting56_objectSpread(Sporting56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.24 37.2c-4.76 7.4-17.74 7.53-28.98.29-3.9-2.47-7.24-5.7-9.84-9.51 3.85 6.37 7.1 10.59 12.05 13.66 11.24 7.28 24.21 7.12 28.99-.31 2.22-3.45 2.26-7.87.53-12.33-.25-.64-1.19-.41-1.11.28.34 2.9-.16 5.63-1.65 7.93Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.39 14.6c6.51-2.54 16.11-.9 24.82 4.89 9.26 6.17 14.82 15.32 14.61 22.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.47 14.73-2.14 3.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.06 16.28-2.15 3.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.4 17.53-2.15 3.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.56 19.01-2.15 3.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.9 20.76-2.15 3.49"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.76 15.14c4.75-7.44 17.73-7.53 28.97-.28 11.24 7.25 16.5 19.1 11.74 26.47-4.76 7.37-17.75 7.59-28.99.31C8.24 34.36 2.99 22.53 7.76 15.14"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Sporting56 = (Sporting56);
;// ./src/Picto/GeneratedPictoComponents/TV104.tsx


var TV104_excluded = ["className"];
function TV104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TV104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TV104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TV104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TV104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TV104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TV104_objectSpread(TV104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.43 65.44a23.178 23.178 0 0 1-17.85-17.98l-4.99-24.68c-.26-.27-.47.56-.47 1.02v46.24a2.64 2.64 0 0 0 2.62 2.64H64.3c.52 0 .59-.74.09-.85l-29.96-6.39Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.81 81.42h58.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.15 73.6v7.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.85 81.42V73.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.21",
        y: "19.85",
        width: "83.57",
        height: "53.73",
        rx: "3.57",
        ry: "3.57"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TV104 = (TV104);
;// ./src/Picto/GeneratedPictoComponents/TV56.tsx


var TV56_excluded = ["className"];
function TV56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TV56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TV56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TV56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TV56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TV56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TV56_objectSpread(TV56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.42 35.44a12.48 12.48 0 0 1-9.61-9.68l-2.7-13.19c-.09-.17-.24-.13-.24.12v25.23c0 .78.63 1.41 1.41 1.42H34.6c.27 0 .31-.38.05-.44l-16.23-3.46Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.28 43.84h31.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.08 39.63v4.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.92 43.84v-4.21"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "5.5",
        y: "10.69",
        width: "45",
        height: "28.93",
        rx: "1.92",
        ry: "1.92"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TV56 = (TV56);
;// ./src/Picto/GeneratedPictoComponents/TelstraTV104.tsx


var TelstraTV104_excluded = ["className"];
function TelstraTV104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraTV104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraTV104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraTV104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraTV104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraTV104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraTV104_objectSpread(TelstraTV104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.56 65.28A23.178 23.178 0 0 1 16.71 47.3l-5.17-23.87c-.14-.6-.6-.27-.6.19l.3 46.26a2.64 2.64 0 0 0 2.62 2.64h48.72c.75 0 .86-1.08.13-1.23l-28.16-6.01Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.81 81.42H55.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63 73.58H13.78c-1.97 0-3.57-1.6-3.57-3.57V23.42c0-1.97 1.6-3.57 3.57-3.57h76.44c1.97 0 3.57 1.6 3.57 3.57v46.6c0 1.97-1.6 3.57-3.57 3.57h-6.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.85 81.42V73.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M65.9 91.75c-1.14-3.37-2.41-9.3-.26-14.35 2.73-6.42 4.63-7.58 3.98-8.82-.43-.83-.97-.48-1.36-.09L55.4 81.44c-.44.44-.33 1.68-.32 2.23.01.49.18 1.28.55 1.64l5.62 6.19 4.65.25Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "64.66",
        y: "56.39",
        width: "14.75",
        height: "37.51",
        rx: "4",
        ry: "4",
        transform: "rotate(45 72.037 75.139)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.72 66.77-3.31-3.31M74.62 75.87l-3.31-3.31M72.14 78.35l-3.32-3.31M57.97 92.52l-3.32-3.31M78.76 71.73l-3.31-3.32M75.45 71.73l3.31-3.32"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraTV104 = (TelstraTV104);
;// ./src/Picto/GeneratedPictoComponents/TelstraTV56.tsx


var TelstraTV56_excluded = ["className"];
function TelstraTV56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraTV56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraTV56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraTV56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraTV56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraTV56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraTV56_objectSpread(TelstraTV56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M18.67 35.46c-4.81-1.03-8.55-4.8-9.54-9.61L6.35 13.12c-.04-.29-.27-.17-.27.08l.14 24.73c0 .77.63 1.4 1.4 1.41h25.72c.44 0 .51-.64.08-.73l-14.74-3.14Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.39 43.8h17.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.88 39.61H7.56a1.91 1.91 0 0 1-1.91-1.91V12.78c0-1.05.85-1.91 1.91-1.91h40.88c1.05 0 1.91.85 1.91 1.91V37.7c0 1.05-.85 1.91-1.91 1.91h-3.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.97 43.8v-4.18"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.43 49.32c-.61-1.8-1.29-4.97-.14-7.67 1.46-3.43 2.48-4.05 2.13-4.72-.23-.44-.52-.26-.73-.05l-6.88 6.92c-.23.23-.18.9-.17 1.19 0 .26.1.68.29.88l3.01 3.31 2.49.14Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "34.77",
        y: "30.41",
        width: "7.89",
        height: "20.06",
        rx: "2.14",
        ry: "2.14",
        transform: "rotate(45 38.716 40.447)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.96 35.97-1.77-1.78M40.1 40.83l-1.77-1.77M38.77 42.16 37 40.39M31.19 49.74l-1.77-1.77M42.31 38.62l-1.77-1.77M40.54 38.62l1.77-1.77"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraTV56 = (TelstraTV56);
;// ./src/Picto/GeneratedPictoComponents/Ticket104.tsx


var Ticket104_excluded = ["className"];
function Ticket104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Ticket104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Ticket104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ticket104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Ticket104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Ticket104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Ticket104_objectSpread(Ticket104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.05 57.18-2.53-9.45c-.37-1.37.45-2.78 1.82-3.15l.61-.16-.28-1.36-7.15 4.59 2.43 7.29 4.6 4.51 2.14-.51a2.58 2.58 0 0 1-1.64-1.77ZM82.11 54.41a.99.99 0 0 1-.96-.74c-1.38-5.15 1.06-10.63 5.8-13.05.49-.25 1.09-.06 1.34.44s.06 1.09-.44 1.34c-3.9 1.99-5.91 6.51-4.78 10.75a.994.994 0 0 1-.97 1.25ZM20.44 81.67c-.18-.94 1-1.51 1.6-.77 2.89 3.6 10.3 8.55 28.16 3.46l-24.45 6.55s-2.17.77-2.81-1.09c-.44-1.28-1.9-4.98-2.5-8.15Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.69 32.41c-.26 0-.51-.13-.65-.38l-1.38-2.38a.746.746 0 0 1 1.29-.75l1.38 2.38a.746.746 0 0 1-.64 1.12ZM56.85 27.49c-.26 0-.51-.13-.65-.38l-.99-1.72a.746.746 0 0 1 1.29-.75l.99 1.72a.746.746 0 0 1-.64 1.12ZM54.34 23.13c-.26 0-.51-.13-.65-.38l-1-1.72a.746.746 0 0 1 1.29-.75l1 1.72a.746.746 0 0 1-.64 1.12ZM76.19 77.7c-.33 0-.63-.22-.72-.56l-.54-2a.75.75 0 1 1 1.45-.39l.54 2c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM74.87 72.75c-.33 0-.63-.22-.72-.56l-.51-1.89a.75.75 0 1 1 1.45-.39l.51 1.89c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM73.58 67.97c-.33 0-.63-.22-.72-.56l-.52-1.95a.75.75 0 1 1 1.45-.39l.52 1.95c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM72.29 63.14c-.33 0-.63-.22-.72-.56l-.53-1.97a.75.75 0 1 1 1.45-.39l.53 1.97c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM70.98 58.26c-.33 0-.63-.22-.72-.56l-.52-1.92a.75.75 0 1 1 1.45-.39l.52 1.92c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM69.69 53.43c-.33 0-.63-.22-.72-.56l-.51-1.89a.75.75 0 1 1 1.45-.39l.51 1.89c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM68.4 48.61c-.33 0-.63-.22-.72-.56l-.5-1.86a.75.75 0 1 1 1.45-.39l.5 1.86c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM67.1 43.75c-.33 0-.63-.22-.72-.56l-.49-1.84a.75.75 0 1 1 1.45-.39l.49 1.84c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM65.8 38.92c-.33 0-.63-.22-.72-.56l-.5-1.85a.75.75 0 1 1 1.45-.39l.5 1.85c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03ZM64.53 34.16c-.33 0-.63-.22-.72-.56l-.52-1.95a.75.75 0 1 1 1.45-.39l.52 1.95c.11.4-.13.81-.53.92a.68.68 0 0 1-.19.03Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m85 57.26 7.59-4.38c1.23-.71 1.65-2.28.94-3.51l-4.81-8.33c-.52-.89-1.51-1.4-2.51-1.28M73.73 28.61a9.428 9.428 0 0 1 2.82-4.7c.88-.8 1.05-2.12.46-3.15l-4.89-8.47a2.568 2.568 0 0 0-3.51-.94L7.8 46.46a2.568 2.568 0 0 0-.94 3.51l4.89 8.47c.59 1.03 1.83 1.54 2.96 1.18 1.36-.44 2.78-.56 4.15-.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.6 59.08c4.35-.23 8.41 2.6 9.58 6.97s-.93 8.85-4.81 10.83c-1.06.54-1.57 1.77-1.26 2.92l2.49 9.29a2.582 2.582 0 0 0 3.15 1.82l67.83-18.17a2.582 2.582 0 0 0 1.82-3.15l-2.49-9.29c-.31-1.15-1.36-1.96-2.55-1.9-4.35.23-8.41-2.6-9.58-6.97s.93-8.85 4.81-10.83c1.06-.54 1.57-1.77 1.26-2.92l-2.53-9.45a2.582 2.582 0 0 0-3.15-1.82L13.34 44.59a2.582 2.582 0 0 0-1.82 3.15l2.53 9.45c.31 1.15 1.36 1.96 2.55 1.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.06 51.07 2.56 2.91c.13.15.33.22.53.2l3.85-.45c.5-.06.85.48.59.91l-1.98 3.33c-.1.17-.11.38-.03.56l1.62 3.52a.6.6 0 0 1-.68.84l-3.78-.85c-.19-.04-.4.01-.54.15l-2.85 2.63c-.37.34-.97.11-1.01-.39l-.36-3.86a.596.596 0 0 0-.31-.47l-3.38-1.9c-.44-.24-.4-.88.06-1.08l3.56-1.53c.18-.08.32-.24.35-.44l.76-3.8c.1-.49.72-.66 1.05-.28ZM35.59 60.91l1.28 1.45c.13.15.33.22.53.2l1.92-.23c.5-.06.85.48.59.91l-.99 1.66c-.1.17-.11.38-.03.56l.81 1.76a.6.6 0 0 1-.68.84l-1.89-.43c-.19-.04-.4.01-.54.15l-1.42 1.31c-.37.34-.97.11-1.01-.39l-.18-1.93a.596.596 0 0 0-.31-.47l-1.69-.95c-.44-.24-.4-.88.06-1.08l1.78-.76c.18-.08.32-.24.35-.44l.38-1.9c.1-.49.72-.66 1.05-.28ZM60.38 54.52l1.28 1.45c.13.15.33.22.53.2l1.92-.23c.5-.06.85.48.59.91l-.99 1.66c-.1.17-.11.38-.03.56l.81 1.76a.6.6 0 0 1-.68.84l-1.89-.43c-.19-.04-.4.01-.54.15l-1.42 1.31c-.37.34-.97.11-1.01-.39l-.18-1.93a.596.596 0 0 0-.31-.47l-1.69-.95c-.44-.24-.4-.88.06-1.08l1.78-.76c.18-.08.32-.24.35-.44l.38-1.9c.1-.49.72-.66 1.05-.28Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Ticket104 = (Ticket104);
;// ./src/Picto/GeneratedPictoComponents/Ticket56.tsx


var Ticket56_excluded = ["className"];
function Ticket56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Ticket56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Ticket56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Ticket56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Ticket56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Ticket56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Ticket56_objectSpread(Ticket56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.71 44.57c-.09-.49.54-.77.85-.38 1.54 1.93 5.51 4.61 15.12 1.87l-13.12 3.51s-1.17.42-1.51-.59c-.24-.69-1.03-2.71-1.35-4.42ZM8.2 31.72l-1.4-5.24c-.2-.76.25-1.54 1.01-1.75l.34-.09-.16-.75-3.97 2.54 1.35 4.05 2.55 2.5 1.19-.28c-.44-.15-.78-.51-.91-.98ZM44.86 29.07c-.23 0-.45-.14-.51-.35-.73-2.44.56-5.05 3.09-6.19.26-.12.58-.03.72.21s.03.52-.23.64c-2.08.95-3.15 3.09-2.54 5.1.08.25-.09.51-.38.58-.05.01-.09.02-.14.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.63 42.49c-.18 0-.34-.12-.39-.3l-.45-1.7c-.06-.21.07-.43.28-.49.22-.05.43.07.49.28l.45 1.7c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM40.67 38.89c-.18 0-.34-.12-.39-.3l-.26-.98c-.06-.21.07-.43.28-.49.22-.05.43.07.49.28l.26.98c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM39.91 36.04c-.18 0-.34-.12-.39-.3l-.25-.93c-.06-.21.07-.43.28-.49.21-.05.43.07.49.28l.25.93c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM39.15 33.2c-.18 0-.34-.12-.39-.3l-.25-.92c-.06-.21.07-.43.28-.49.22-.05.43.07.49.28l.25.92c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM38.38 30.34c-.18 0-.34-.12-.39-.3l-.25-.95c-.06-.21.07-.43.28-.49.21-.06.43.07.49.28l.25.95c.06.21-.07.43-.28.49-.03 0-.07.01-.1.01ZM37.62 27.52c-.18 0-.34-.12-.39-.3l-.26-.96c-.06-.21.07-.43.28-.49.21-.05.43.07.49.28l.26.96c.06.21-.07.43-.28.49-.03 0-.07.01-.1.01ZM36.87 24.7c-.18 0-.34-.12-.39-.3l-.25-.95c-.06-.21.07-.43.28-.49.22-.06.43.07.49.28l.25.95c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM36.12 21.9c-.18 0-.34-.12-.39-.3l-.27-1.01c-.06-.21.07-.43.28-.49.21-.06.43.07.49.28l.27 1.01c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM35.34 19.01c-.18 0-.34-.12-.39-.3l-.25-.93c-.06-.21.07-.43.28-.49.22-.06.43.07.49.28l.25.93c.06.21-.07.43-.28.49-.04 0-.07.01-.1.01ZM31.06 15.5c-.14 0-.27-.07-.35-.2l-.53-.92a.407.407 0 0 1 .15-.55c.19-.11.44-.04.55.15l.53.92c.11.19.04.44-.15.55-.06.04-.13.05-.2.05ZM29.73 13.21c-.14 0-.27-.07-.35-.2l-.53-.92a.407.407 0 0 1 .15-.55c.19-.11.44-.04.55.15l.53.92c.11.19.04.44-.15.55-.06.04-.13.05-.2.05ZM32.75 18.17c-.14 0-.27-.07-.35-.2l-.79-1.37a.407.407 0 0 1 .15-.55c.19-.11.44-.04.55.15l.79 1.37c.11.19.04.44-.15.55-.06.04-.13.05-.2.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.09 28.39c-.63-2.35.5-4.75 2.58-5.81.57-.29.84-.95.67-1.57l-1.36-5.07a1.37 1.37 0 0 0-1.69-.97L7.91 24.72c-.74.2-1.17.95-.97 1.69l1.36 5.07c.17.62.73 1.05 1.37 1.02a5.055 5.055 0 0 1 2.56 9.55c-.57.29-.84.95-.67 1.57l1.34 4.98c.2.74.95 1.17 1.69.97l36.39-9.75c.74-.2 1.17-.95.97-1.69l-1.34-4.98c-.17-.62-.73-1.05-1.37-1.02a5.055 5.055 0 0 1-5.14-3.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.18 31.5 4.08-2.35c.66-.38.89-1.23.51-1.89l-2.58-4.47c-.28-.48-.45-.74-.99-.68M40.12 16.11c.24-.96.76-1.84 1.52-2.53.47-.43.57-1.14.25-1.69l-2.63-4.55c-.38-.66-1.23-.89-1.89-.51L4.71 25.7c-.66.38-.89 1.23-.51 1.89l2.63 4.55c.32.55.98.83 1.59.63.73-.24 1.61-.3 2.35-.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.47 28.2 1.37 1.56c.07.08.18.12.28.11l2.07-.24c.27-.03.45.26.32.49l-1.06 1.79a.35.35 0 0 0-.02.3l.87 1.89c.11.24-.1.51-.37.45l-2.03-.46c-.1-.02-.21 0-.29.08l-1.53 1.41c-.2.18-.52.06-.54-.21l-.19-2.07c0-.11-.07-.2-.16-.25l-1.81-1.02a.324.324 0 0 1 .03-.58l1.91-.82c.1-.04.17-.13.19-.23l.41-2.04c.05-.26.38-.35.56-.15ZM19.85 33.48l.68.78c.07.08.18.12.28.11l1.03-.12c.27-.03.45.26.32.49l-.53.89a.35.35 0 0 0-.02.3l.43.94c.11.24-.1.51-.37.45l-1.01-.23c-.1-.02-.21 0-.29.08l-.76.7c-.2.18-.52.06-.54-.21l-.1-1.03c0-.11-.07-.2-.16-.25l-.9-.51a.324.324 0 0 1 .03-.58l.95-.41c.1-.04.17-.13.19-.23l.2-1.02c.05-.26.38-.35.56-.15ZM33.15 30.05l.68.78c.07.08.18.12.28.11l1.03-.12c.27-.03.45.26.32.49l-.53.89a.35.35 0 0 0-.02.3l.43.94c.11.24-.1.51-.37.45l-1.01-.23c-.1-.02-.21 0-.29.08l-.76.7c-.2.18-.52.06-.54-.21l-.1-1.03c0-.11-.07-.2-.16-.25l-.9-.51a.324.324 0 0 1 .03-.58l.95-.41c.1-.04.17-.13.19-.23l.2-1.02c.05-.26.38-.35.56-.15Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Ticket56 = (Ticket56);
;// ./src/Picto/GeneratedPictoComponents/EarnPoints104.tsx


var EarnPoints104_excluded = ["className"];
function EarnPoints104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EarnPoints104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EarnPoints104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EarnPoints104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EarnPoints104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EarnPoints104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EarnPoints104_objectSpread(EarnPoints104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.75 53.69c-.2-1.55-2.33-1.82-2.93-.38-2.75 6.56-4.05 17.99 5.64 27.79 7.89 7.98 18.38 6.82 24.55 5.14 1.23-.34 1.1-2.11-.16-2.3-21.05-3.13-25.96-21.41-27.1-30.24ZM41.21 38.59s11.94 1.15 17.79 13V29.55s-7.57-.43-17.77-4.52l-.02 13.55ZM62.16 77.89l5.03.3V30.24h-5.03v47.65zM91.05 25.04l-3.43 1.61V74.6l3.7-1.65-.27-47.91z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "66.27",
        cy: "22.83",
        rx: "25.06",
        ry: "6.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.32 22.83v9.59c0 3.72-11.22 6.73-25.06 6.73S41.2 36.14 41.2 32.42v-10.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.33",
        cy: "63.25",
        r: "24.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.21 23.36-.02 15.23s16.05 1.68 20.36 20.07c0 0 2.54 10.17-4.48 19.33 0 0 23.94 2.51 34.24-5.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.47 68.47s24.47 1.33 29.85-5.45M61.47 58.55s24.47 1.33 29.85-5.45M57.4 48.46s28.55 1.97 33.93-4.81M91.32 72.81V25.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m34.24 71.07 1.11-6.08h-5.97l.39-2.2c.12-.67.68-1.16 1.33-1.16h4.83l.9-5.06c.12-.67.68-1.15 1.33-1.15h2.01l-1.11 6.21h5.96l-.39 2.2c-.12.67-.68 1.16-1.33 1.16h-4.83l-.9 4.94c-.12.67-.68 1.15-1.33 1.15h-2.01Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EarnPoints104 = (EarnPoints104);
;// ./src/Picto/GeneratedPictoComponents/EarnPoints56.tsx


var EarnPoints56_excluded = ["className"];
function EarnPoints56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EarnPoints56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EarnPoints56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EarnPoints56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EarnPoints56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EarnPoints56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EarnPoints56_objectSpread(EarnPoints56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.48 28.26c-.07-.64-.92-.8-1.2-.22-1.66 3.38-2.82 10 2.74 15.62 4.25 4.3 9.89 3.67 13.22 2.77.67-.18.61-1.14-.08-1.24C12.28 43.43 9.95 32.71 9.49 28.26ZM22.19 20.78s6.43.62 9.58 7V15.91s-4.08-.23-9.57-2.43v7.3ZM33.47 41.94l2.71.16V16.28h-2.71v25.66zM49.02 13.49l-1.84.86v25.82l1.99-.89-.15-25.79z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "35.68",
        cy: "12.29",
        rx: "13.49",
        ry: "3.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.17 12.29v5.16c0 2-6.04 3.62-13.49 3.62s-13.49-1.62-13.49-3.62v-5.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.1",
        cy: "34.06",
        r: "13.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.19 12.58v8.2s8.63.9 10.95 10.81c0 0 1.37 5.48-2.41 10.41 0 0 12.89 1.35 18.44-2.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.1 36.87s13.18.71 16.08-2.93M33.1 31.53s13.18.71 16.08-2.93M30.91 26.09s15.37 1.06 18.27-2.59M49.17 39.21V13.49"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m18.42 38.16.6-3.28h-3.21l.21-1.18c.06-.36.37-.62.72-.62h2.6l.49-2.72c.06-.36.37-.62.72-.62h1.08l-.6 3.34h3.21l-.21 1.18c-.06.36-.37.62-.72.62h-2.6l-.48 2.66c-.07.36-.37.62-.72.62h-1.08Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EarnPoints56 = (EarnPoints56);
;// ./src/Picto/GeneratedPictoComponents/Feedback104.tsx


var Feedback104_excluded = ["className"];
function Feedback104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Feedback104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Feedback104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Feedback104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Feedback104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Feedback104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Feedback104_objectSpread(Feedback104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.64 42.83c-.9-.65-.29-2.04.8-1.86C84.67 43.03 94 54.04 94 67.31s-9.33 24.28-21.56 26.34c-1.09.18-1.7-1.21-.8-1.86 5.35-3.88 15.23-12.66 15.23-24.48 0-11.83-9.89-20.6-15.23-24.48ZM56.11 36.62c0-11.86-9.99-20.64-15.31-24.48-.88-.63-.28-1.99.78-1.81 12.27 2.01 21.66 13.01 21.66 26.29S53.85 60.9 41.58 62.91c-1.07.17-1.66-1.18-.78-1.81 5.33-3.84 15.31-12.62 15.31-24.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.76 67.31C40.76 82.05 52.68 94 67.38 94S94 82.05 94 67.31 82.08 40.62 67.38 40.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 36.62c0 14.7 11.92 26.62 26.62 26.62 14.7 0 26.62-11.92 26.62-26.62C63.24 21.92 51.32 10 36.62 10 21.92 10 10 21.92 10 36.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.88 77.44c-4.56-4.91-11.96-4.91-16.52 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.68 43.05c4.56 4.9 11.96 4.9 16.52 0"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.61 29.28c0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75-1.23-2.75-2.75-2.75-2.75 1.23-2.75 2.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.76 29.28c0 1.52 1.23 2.75 2.75 2.75s2.75-1.23 2.75-2.75-1.23-2.75-2.75-2.75-2.75 1.23-2.75 2.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.29 59.95c0 1.52 1.23 2.76 2.75 2.76s2.75-1.24 2.75-2.76-1.23-2.76-2.75-2.76-2.75 1.24-2.75 2.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.44 59.95c0 1.52 1.23 2.76 2.75 2.76s2.75-1.24 2.75-2.76-1.23-2.76-2.75-2.76-2.75 1.24-2.75 2.76"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Feedback104 = (Feedback104);
;// ./src/Picto/GeneratedPictoComponents/Feedback56.tsx


var Feedback56_excluded = ["className"];
function Feedback56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Feedback56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Feedback56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Feedback56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Feedback56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Feedback56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Feedback56_objectSpread(Feedback56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.31 23.38c-.45-.33-.14-1.03.41-.94 6.4 1.05 11.29 6.78 11.29 13.7s-4.89 12.65-11.29 13.7c-.55.09-.86-.62-.41-.94 2.78-2 7.98-6.58 7.98-12.75 0-6.18-5.2-10.75-7.98-12.75ZM30.03 19.87c0-6.05-4.99-10.56-7.8-12.62-.49-.36-.16-1.15.44-1.04 6.29 1.14 11.07 6.82 11.07 13.66s-4.78 12.52-11.07 13.66c-.6.11-.94-.68-.44-1.04 2.81-2.06 7.8-6.58 7.8-12.62Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.26 36.13c0 7.66 6.21 13.87 13.87 13.87S50 43.79 50 36.13s-6.21-13.87-13.87-13.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 19.87c0 7.66 6.21 13.87 13.87 13.87 7.66 0 13.87-6.21 13.87-13.87S27.53 6 19.87 6 6 12.21 6 19.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.87 41.39c-2.38-2.55-6.23-2.55-8.61 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.73 16.04a1.43 1.43 0 1 0 2.86 0c0-.79-.64-1.44-1.43-1.44s-1.43.64-1.43 1.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.04 16.04a1.43 1.43 0 1 0 2.86 0c0-.79-.64-1.44-1.43-1.44s-1.43.64-1.43 1.44"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.52 23.22c2.38 2.55 6.23 2.55 8.61 0"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.47 32.3a1.43 1.43 0 1 0 2.86 0c0-.79-.64-1.44-1.43-1.44s-1.43.64-1.43 1.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.78 32.3a1.43 1.43 0 1 0 2.86 0c0-.79-.64-1.44-1.43-1.44s-1.43.64-1.43 1.44"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Feedback56 = (Feedback56);
;// ./src/Picto/GeneratedPictoComponents/Membership104.tsx


var Membership104_excluded = ["className"];
function Membership104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Membership104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Membership104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Membership104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Membership104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Membership104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Membership104_objectSpread(Membership104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.91 55.74c1.94.27 3.81.16 5.56-.27 1.21-.3 1.25-1.96.06-2.34a23.712 23.712 0 0 1-15.46-15.66c-.32-1.07-1.86-1.09-2.15-.01-.51 1.85-.66 3.85-.37 5.93.89 6.35 6.01 11.47 12.36 12.36ZM26.76 70.4a29.056 29.056 0 0 0-3.65 10.49C30.5 88.28 40.72 92.86 52 92.86c3.39 0 6.68-.41 9.83-1.19 1.48-.37 1.42-2.52-.07-2.81-12.88-2.56-24.26-9.27-32.68-18.7-.65-.73-1.83-.59-2.32.25Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "40.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "41.3",
        r: "14.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 92.86c11.27 0 21.48-4.57 28.87-11.95-2.02-14.14-14.18-25.02-28.88-25.02s-26.85 10.86-28.88 25C30.5 88.29 40.72 92.86 52 92.86Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m22.24 58.7 1.11-6.08h-5.97l.39-2.2c.12-.67.68-1.16 1.33-1.16h4.83l.9-5.06c.12-.67.68-1.15 1.33-1.15h2.01l-1.11 6.21h5.96l-.39 2.2c-.12.67-.68 1.16-1.33 1.16h-4.83l-.9 4.94c-.12.67-.68 1.15-1.33 1.15h-2.01Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Membership104 = (Membership104);
;// ./src/Picto/GeneratedPictoComponents/Membership56.tsx


var Membership56_excluded = ["className"];
function Membership56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Membership56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Membership56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Membership56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Membership56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Membership56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Membership56_objectSpread(Membership56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.75 30c1.2.19 2.35.1 3.42-.21.55-.16.52-.94-.03-1.11a12.761 12.761 0 0 1-8.67-8.89c-.13-.47-.77-.49-.92-.03a7.993 7.993 0 0 0-.31 3.73c.52 3.32 3.2 5.99 6.51 6.51ZM14.51 37.73a15.576 15.576 0 0 0-2.07 5.83C16.42 47.54 21.92 50 28 50c2.02 0 3.97-.27 5.83-.78.68-.19.63-1.15-.06-1.28a31.934 31.934 0 0 1-18.21-10.28c-.29-.33-.82-.3-1.04.07Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "22.24",
        r: "7.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 50c6.07 0 11.56-2.46 15.55-6.43C42.46 35.95 35.91 30.1 28 30.1s-14.46 5.85-15.55 13.46a21.94 21.94 0 0 0 15.56 6.45Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m12.49 32.21.6-3.28H9.88l.21-1.18c.06-.36.37-.62.72-.62h2.6l.49-2.72c.06-.36.37-.62.72-.62h1.08l-.6 3.34h3.21l-.21 1.18c-.06.36-.37.62-.72.62h-2.6l-.48 2.66c-.07.36-.37.62-.72.62H12.5Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Membership56 = (Membership56);
;// ./src/Picto/GeneratedPictoComponents/RedeemPoints104.tsx


var RedeemPoints104_excluded = ["className"];
function RedeemPoints104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RedeemPoints104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RedeemPoints104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RedeemPoints104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RedeemPoints104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RedeemPoints104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RedeemPoints104_objectSpread(RedeemPoints104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.29 78.85c-1.7 3.77 1.66 5.87 1.66 5.87 2.57 1.38 4.47.56 5.59-.34.5-.4.24-1.21-.4-1.24-3.7-.15-5.05-2.5-5.55-4.2-.18-.62-1.03-.68-1.3-.09ZM41.49 66.8l21.21-.6c1.58-.05 1.97-2.5.42-2.76-12.9-2.19-20-9.18-24.48-12.59-1.08-.82-2.58.2-2.22 1.51l3.67 13.4c.17.63.76 1.06 1.41 1.04ZM33.37 78.82c-1.74 3.79 1.65 5.9 1.65 5.9 2.61 1.4 4.53.53 5.65-.39.47-.39.19-1.16-.43-1.19-3.75-.13-5.11-2.53-5.59-4.24a.684.684 0 0 0-1.28-.09Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "78.89",
        cy: "80.38",
        rx: "5.09",
        ry: "5.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "37.53",
        cy: "80.38",
        rx: "5.09",
        ry: "5.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.15 18.54h10.4c.86 0 1.61.59 1.81 1.43l11.8 45.97-3.94 7.35c-.3 1.04.49 2.08 1.57 2.08h41.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.72 65.94h40.07c.8 0 1.51-.51 1.77-1.27l5.2-24.5c.41-1.21-.49-2.46-1.77-2.46l-53.17-1.86"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m57.56 57.2 1.11-6.08H52.7l.39-2.2c.12-.67.68-1.16 1.33-1.16h4.83l.9-5.06c.12-.67.68-1.15 1.33-1.15h2.01l-1.11 6.21h5.96l-.39 2.2c-.12.67-.68 1.16-1.33 1.16h-4.83l-.9 4.94c-.12.67-.68 1.15-1.33 1.15h-2.01Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RedeemPoints104 = (RedeemPoints104);
;// ./src/Picto/GeneratedPictoComponents/RedeemPoints56.tsx


var RedeemPoints56_excluded = ["className"];
function RedeemPoints56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RedeemPoints56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RedeemPoints56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RedeemPoints56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RedeemPoints56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RedeemPoints56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RedeemPoints56_objectSpread(RedeemPoints56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.94 42.43c-.92 2.03.89 3.15.89 3.15 1.38.74 2.4.3 3.01-.18a.37.37 0 0 0-.22-.66c-1.99-.08-2.72-1.34-2.98-2.26a.372.372 0 0 0-.7-.05ZM22.31 35.95l11.4-.32c.85-.03 1.06-1.34.22-1.48-6.93-1.18-10.75-4.93-13.16-6.77-.58-.44-1.38.11-1.19.81l1.97 7.2c.09.34.41.57.76.56ZM17.95 42.42c-.93 2.04.88 3.17.88 3.17 1.41.75 2.44.29 3.04-.21.25-.21.1-.63-.23-.64-2.02-.07-2.74-1.36-3.01-2.28-.09-.33-.54-.36-.69-.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42.41",
        cy: "43.25",
        rx: "2.73",
        ry: "2.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "20.18",
        cy: "43.25",
        rx: "2.73",
        ry: "2.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.7 10.02h5.59c.46 0 .87.32.97.77l6.34 24.7-2.12 3.95c-.16.56.26 1.12.84 1.12h22.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.9 35.49h21.53a1 1 0 0 0 .95-.68l2.79-13.17a.998.998 0 0 0-.95-1.32l-28.57-1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.28 30.8.6-3.28h-3.21l.21-1.18c.06-.36.37-.62.72-.62h2.6l.49-2.72c.06-.36.37-.62.72-.62h1.08l-.6 3.34h3.21l-.21 1.18c-.06.36-.37.62-.72.62h-2.6l-.48 2.66c-.07.36-.37.62-.72.62h-1.08Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RedeemPoints56 = (RedeemPoints56);
;// ./src/Picto/GeneratedPictoComponents/Rewards104.tsx


var Rewards104_excluded = ["className"];
function Rewards104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Rewards104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Rewards104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Rewards104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Rewards104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Rewards104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Rewards104_objectSpread(Rewards104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.55 73.28 52.4 61.76l-.38 29.55h8.56s5.44-13.55 22.98-13.17v-4.86H56.55ZM19.26 76.47h26.53c.71 0 1.33-.32 1.5-.77l.81-2.19H19.26v2.96ZM36.72 60.73l7.71-3.38c.53-.28.44-1.17-.16-1.4-.51-.2-1.19-.25-2.04-.15-2.48.29-11.08.45-16.75-4.55s-6.31-7.34-7.73-7.1c-.95.16-.75.82-.46 1.35l8.26 15.24s9.75-.26 11.18-.02ZM49.03 33.04c-.69-.08-1.36-.28-1.93-.66l-.1-.07c-.29-.21-.54-.47-.73-.77-.1-.15-.18-.3-.25-.46-.03-.08-.06-.16-.09-.25-.02-.06-.04-.11-.1-.14-.11-.05-.24.03-.3.12-.1.15-.11.39-.12.56-.03.36-.03.74.03 1.1.06.36.19.7.41 1 .43.58 1.2.89 1.92.8.47-.06.92-.28 1.27-.6.19-.17.36-.58-.02-.62ZM61 31.09c.43.58 1.2.89 1.92.8.47-.06.92-.28 1.27-.6.19-.17.36-.58-.02-.62-.69-.08-1.36-.28-1.93-.66l-.1-.07c-.29-.21-.54-.47-.73-.77-.1-.15-.18-.3-.25-.46-.03-.08-.06-.16-.09-.25-.02-.06-.04-.11-.1-.14-.11-.05-.24.03-.3.12-.1.15-.11.39-.12.56-.03.36-.03.74.03 1.1.06.36.19.7.41 1ZM62.14 61.48l-.82-.27c-1.51-1.26-.42-11.14-.42-11.14 0-3.54-1.42-2.95-1.42-2.95-3.25 4.58-2.81 14.23-2.81 14.23l5.46.13Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m21.52 45.15-3.08 1.64M23.53 48.93l-3.11 1.66M39.21 35.72l-3.22 1.71M47.32 50.8l-3.27 1.75M43 43.4 22.93 54.1M45.79 55.82 33.93 33.56M29.77 60.63l-10.1-18.95M27.56 56.48l-3.1 1.66M41.21 39.5l-3.2 1.71M45.39 46.98l-3.36 1.79M20.09 60.73h31.92v30.59H20.09V74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.86 74.15v17.17H51.99V60.73h31.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.11 60.75-7.1 12.53h34.5l4.52-12.53H20.11zM83.9 60.75l7.09 12.53H56.55l-4.52-12.53H83.9zM66.14 28.95V13.71c0-1.02-.83-1.81-1.8-1.81-.1 0-.21 0-.32.03L52.27 14c-.86.15-1.29.9-1.29 1.78v15.81M51.25 19.77l14.72-2.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "47.77",
        cy: "31.91",
        r: "3.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "62.98",
        cy: "29.51",
        r: "3.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m61.11 60.49 20.31-20.31M71.05 52.67l-2.18-2.19M69.34 54.37l-2.18-2.18M72.74 50.98l-2.19-2.18M57.18 60.63h20.64c.32 0 1.11-1.08 1.3-1.29 1.03-1.13 1.93-2.37 2.69-3.69 2.24-3.92 2.9-8.5 1.46-12.82-1.36-4.1-5.98-4.93-9.78-4.66-4.71.34-9.39 2.66-12.39 6.33-2.6 3.19-3.79 7.33-4.03 11.38-.03.43-.1 4.73.1 4.73ZM16.19 43.09l20.95-11.52 12.49 22.8-11.62 6.36-12.46.02-9.36-17.66z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m78.77 30.39 1.11-6.08h-5.97l.39-2.2c.12-.67.68-1.16 1.33-1.16h4.83l.9-5.06c.12-.67.68-1.15 1.33-1.15h2.01l-1.11 6.21h5.96l-.39 2.2c-.12.67-.68 1.16-1.33 1.16H83l-.9 4.94c-.12.67-.68 1.15-1.33 1.15h-2.01Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Rewards104 = (Rewards104);
;// ./src/Picto/GeneratedPictoComponents/Rewards56.tsx


var Rewards56_excluded = ["className"];
function Rewards56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Rewards56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Rewards56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Rewards56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Rewards56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Rewards56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Rewards56_objectSpread(Rewards56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.45 39.46-2.24-6.2L28 49.17h4.61s2.93-7.3 12.37-7.09v-2.62H30.44ZM10.37 41.17h14.29c.38 0 .72-.17.81-.42l.44-1.18H10.38v1.59ZM19.77 32.7l4.15-1.82c.29-.15.24-.63-.08-.76-.27-.11-.64-.13-1.1-.08-1.34.16-5.96.24-9.02-2.45-3.05-2.69-3.4-3.95-4.16-3.82-.51.09-.4.44-.25.73l4.45 8.21s5.25-.14 6.02-.01ZM26.4 17.79c-.37-.04-.73-.15-1.04-.36-.02-.01-.04-.03-.05-.04a1.523 1.523 0 0 1-.52-.66c-.02-.04-.03-.09-.05-.13 0-.03-.02-.06-.05-.08-.06-.03-.13.01-.16.06-.05.08-.06.21-.07.3-.02.2-.02.4.02.59.03.19.1.38.22.54.23.31.65.48 1.04.43.25-.03.49-.15.68-.32.1-.09.19-.31-.01-.33ZM32.85 16.74c.23.31.65.48 1.04.43.25-.03.49-.15.68-.32.1-.09.19-.31-.01-.33-.37-.04-.73-.15-1.04-.36-.02-.01-.04-.03-.05-.04a1.523 1.523 0 0 1-.52-.66c-.02-.04-.03-.09-.05-.13 0-.03-.02-.06-.05-.08-.06-.03-.13.01-.16.06-.05.08-.06.21-.07.3-.02.2-.02.4.02.59.03.19.1.38.22.54ZM33.46 33.1l-.44-.15c-.81-.68-.22-6-.22-6 0-1.91-.76-1.59-.76-1.59-1.75 2.47-1.51 7.66-1.51 7.66l2.94.07Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.59 24.31-1.66.88M12.67 26.35l-1.67.89M21.11 19.23l-1.73.93M25.48 27.35l-1.76.94M23.15 23.37l-10.8 5.76M24.66 30.06l-6.39-11.99M16.03 32.65l-5.44-10.2M14.84 30.41l-1.67.89M22.19 21.27l-1.72.92M24.44 25.3l-1.81.96M10.82 32.7h17.19v16.47H10.82v-9.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.15 39.93v9.24H27.99V32.7h17.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.83 32.71-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.71l3.81 6.75H30.45l-2.43-6.75h17.16zM35.61 15.59V7.38a.97.97 0 0 0-.97-.97c-.06 0-.11 0-.17.02l-6.33 1.12c-.47.08-.7.49-.7.96v8.51M27.59 10.64l7.93-1.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "25.72",
        cy: "17.18",
        r: "1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.91",
        cy: "15.89",
        r: "1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.9 32.57 10.94-10.93M38.26 28.36l-1.18-1.18M37.34 29.28l-1.18-1.18M39.17 27.45l-1.18-1.17M30.79 32.65h11.12c.17 0 .6-.58.7-.69.55-.61 1.04-1.27 1.45-1.99 1.21-2.11 1.56-4.57.79-6.9-.73-2.21-3.22-2.65-5.27-2.51-2.54.18-5.06 1.43-6.67 3.41-1.4 1.72-2.04 3.95-2.17 6.13-.01.23-.05 2.55.06 2.55ZM8.72 23.2 20 17l6.72 12.28-6.25 3.42-6.71.01-5.04-9.51z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m42.42 16.36.6-3.28h-3.21l.21-1.18c.06-.36.37-.62.72-.62h2.6l.49-2.72c.06-.36.37-.62.72-.62h1.08l-.6 3.34h3.21l-.21 1.18c-.06.36-.37.62-.72.62h-2.6l-.48 2.66c-.07.36-.37.62-.72.62h-1.08Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Rewards56 = (Rewards56);
;// ./src/Picto/GeneratedPictoComponents/TelstraPlus104.tsx


var TelstraPlus104_excluded = ["className"];
function TelstraPlus104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlus104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlus104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlus104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlus104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlus104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraPlus104_objectSpread(TelstraPlus104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.31 36.3c-13.75 3.23-7.46 19.2-2.66 26.98.2.32.68.07.55-.28-6.36-17.44-.66-24.03 2.37-26.16.28-.2.07-.62-.26-.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.96 65.82a.158.158 0 0 0-.22-.02c-.07.06-.07.16-.02.22 14.46 18.67 36.85 26.35 45.81 20.57 2.46-7.49-20.61 2.92-45.57-20.78Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.87 48.66c.45-2.11.26-3.08.16-2.99S33.07 68.3 33.07 68.3h12.11c-7.7 0-10.62-8.36-8.3-19.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.55 19.71c5.79.42 9.2 2.45 10.32 4.38.18.32.66.22.73-.14l.92-5.01c.05-.25-.14-.47-.4-.47H52s.17.71 7.54 1.25Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.74 49.01 48.98 65.2c-.57 2.91-2.49 3.7-4.19 3.7H32.03l5.38-29.66c-5.37-2.46-10.85-4.06-15.22-4.06S14.66 36.3 12.42 39c-1.58 1.91-2.37 4.28-2.37 7.08 0 8.43 6.63 20.13 17.98 29.67 10.12 8.44 21.25 13.16 29.35 13.16 4.04 0 7.3-1.24 9.44-3.71 1.68-1.91 2.36-4.39 2.36-7.2 0-8.19-6.68-19.68-17.44-29Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.82 17.64c-2.03 0-3.71 1.36-4.16 3.49l-1.8 9.77h16.05l-6.89 37.99h12.76c1.7 0 3.62-.79 4.19-3.7l5.84-34.29h11.54c2.03 0 3.71-1.35 4.16-3.48l1.8-9.79H28.82Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m74.05 59.66 2.24-11.89h-12.1l.78-4.29a2.755 2.755 0 0 1 2.71-2.26h9.8l1.83-9.88c.24-1.3 1.38-2.25 2.7-2.25h4.07l-2.24 12.13h12.09l-.78 4.29a2.755 2.755 0 0 1-2.71 2.26h-9.79l-1.82 9.65a2.752 2.752 0 0 1-2.7 2.24h-4.07Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraPlus104 = (TelstraPlus104);
;// ./src/Picto/GeneratedPictoComponents/TelstraPlus56.tsx


var TelstraPlus56_excluded = ["className"];
function TelstraPlus56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraPlus56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraPlus56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraPlus56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraPlus56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraPlus56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraPlus56_objectSpread(TelstraPlus56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.34 19.21c-9.37 1.28-4.09 12.08-1.56 15.5-5.36-13.11 1.56-15.5 1.56-15.5Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.67 35.24s-.08-.04-.12 0c-.03.03-.04.08 0 .12 7.56 9.76 19.27 13.78 23.95 10.76 1.28-3.92-10.77 1.53-23.83-10.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.59 26.27c.24-1.1.14-1.61.08-1.56S17.6 36.54 17.6 36.54h6.33c-4.03 0-5.55-4.37-4.34-10.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.45 11.14c3.96.29 5.79 2.02 5.6 3.18l.71-3.84H27.51s.09.37 3.94.65Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.37 26.46-1.44 8.47c-.3 1.52-1.3 1.94-2.19 1.94h-6.67l2.81-15.51c-2.81-1.28-5.67-2.12-7.96-2.12s-3.94.59-5.11 1.99c-.83 1-1.24 2.24-1.24 3.7 0 4.41 3.47 10.52 9.4 15.51 5.29 4.41 11.11 6.88 15.35 6.88 2.11 0 3.82-.65 4.94-1.94.88-1 1.23-2.3 1.23-3.76 0-4.28-3.49-10.29-9.12-15.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.39 10.05c-1.06 0-1.94.71-2.17 1.83l-.94 5.11h8.39l-3.6 19.87h6.67c.89 0 1.89-.41 2.19-1.94l3.05-17.93h6.04c1.06 0 1.94-.71 2.18-1.82l.94-5.12H15.39Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m39.04 32.02 1.17-6.22h-6.33l.41-2.24c.12-.68.72-1.18 1.42-1.18h5.12l.96-5.17c.13-.68.72-1.18 1.41-1.18h2.13l-1.17 6.34h6.32l-.41 2.24c-.12.68-.72 1.18-1.42 1.18h-5.12l-.95 5.04c-.13.68-.72 1.17-1.41 1.17h-2.13Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraPlus56 = (TelstraPlus56);
;// ./src/Picto/GeneratedPictoComponents/VIP104.tsx


var VIP104_excluded = ["className"];
function VIP104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function VIP104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? VIP104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : VIP104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function VIP104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, VIP104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", VIP104_objectSpread(VIP104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.86 61.29s1.12 8.47-5.31 10.16c0 0-6.34 1.12-8.98-1.43 0 0-1.76 4.47-2.38 4.27l2 3.31s2.36-1.4 2.28-2.61c0 0 11.53 3.87 15.72-8.13l-3.33-5.57ZM28.05 63.14l-3.49 5.57s7.76 10.16 16.29 6.55c0 0 .57 2.38 3.09 2.33l1.51-3-2.43-4.62s-12.93 8.02-14.98-6.83ZM34.72 34.79c-.1-1.25-1.8-1.56-2.31-.42-2.66 6.01-4.14 16.88 5.05 26.17 7.4 7.48 16.52 5.74 21.74 3.79 1.17-.44.97-2.16-.27-2.32C39 59.37 35.33 42.67 34.71 34.8Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.73 60.24 18.22 81.6l13.39-3.19L37.17 91l8.29-16.4M75.27 60.24 85.78 81.6l-13.39-3.19L66.83 91l-8.29-16.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "51.8",
        cy: "44.37",
        r: "21.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.28 18.42c1.11-3.69 4.58-6.22 8.52-6.22s7.41 2.53 8.52 6.22l.06.19.16-.12c3.12-2.34 7.45-2.4 10.63-.15 3.19 2.26 4.47 6.3 3.15 9.92l-.07.18h.2c3.94-.11 7.48 2.32 8.69 5.98 1.21 3.66-.18 7.66-3.43 9.83l-.17.11.17.11c3.25 2.17 4.64 6.17 3.43 9.83-1.22 3.65-4.76 6.09-8.69 5.99h-.2l.07.18c1.32 3.62.04 7.66-3.15 9.92a9.036 9.036 0 0 1-10.63-.15l-.16-.12-.06.19c-1.11 3.69-4.58 6.22-8.52 6.22s-7.41-2.53-8.52-6.22l-.06-.19-.16.12c-3.12 2.34-7.45 2.4-10.63.15-3.19-2.26-4.47-6.3-3.15-9.92l.07-.19h-.2c-3.94.11-7.48-2.33-8.69-5.98-1.21-3.66.18-7.66 3.43-9.83l.17-.11-.17-.11c-3.25-2.17-4.64-6.17-3.43-9.83 1.22-3.65 4.76-6.09 8.69-5.98h.2l-.07-.18c-1.32-3.62-.04-7.66 3.15-9.92a9.036 9.036 0 0 1 10.63.15l.16.12.06-.19Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m49.04 52.19 1.11-6.08h-5.97l.39-2.2c.12-.67.68-1.16 1.33-1.16h4.83l.9-5.06c.12-.67.68-1.15 1.33-1.15h2.01l-1.11 6.21h5.96l-.39 2.2c-.12.67-.68 1.16-1.33 1.16h-4.83l-.9 4.94c-.12.67-.68 1.15-1.33 1.15h-2.01Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_VIP104 = (VIP104);
;// ./src/Picto/GeneratedPictoComponents/VIP56.tsx


var VIP56_excluded = ["className"];
function VIP56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function VIP56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? VIP56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : VIP56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function VIP56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, VIP56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", VIP56_objectSpread(VIP56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.31 33s.6 4.56-2.86 5.47c0 0-3.42.6-4.84-.77 0 0-.95 2.41-1.28 2.3l1.08 1.78s1.27-.75 1.23-1.4c0 0 6.21 2.08 8.47-4.38l-1.79-3ZM15.1 34l-1.88 3s4.18 5.47 8.77 3.53c0 0 .31 1.28 1.66 1.25l.82-1.61-1.31-2.49S16.2 42 15.09 34ZM18.69 18.63c-.05-.64-.93-.8-1.19-.22-1.46 3.22-2.32 9.13 2.68 14.18 4.03 4.07 9.01 3.07 11.8 2 .61-.23.49-1.12-.15-1.2C20.94 32 19.01 22.84 18.7 18.63Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.47 32.44-5.66 11.5 7.21-1.72L20.01 49l4.47-8.83M40.53 32.44l5.66 11.5-7.21-1.72L35.99 49l-4.47-8.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.89",
        cy: "23.89",
        r: "11.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.31 9.94c.6-1.98 2.46-3.35 4.58-3.35s3.98 1.36 4.58 3.35l.03.1.09-.06a4.88 4.88 0 0 1 5.72-.08c1.71 1.22 2.4 3.39 1.69 5.34l-.04.1h.11c2.12-.06 4.02 1.25 4.68 3.21.65 1.97-.1 4.12-1.84 5.29l-.09.06.09.06c1.75 1.17 2.5 3.32 1.84 5.29-.65 1.96-2.56 3.28-4.68 3.22h-.11l.04.1c.71 1.95.02 4.12-1.69 5.33a4.88 4.88 0 0 1-5.72-.08l-.09-.06-.03.1c-.6 1.99-2.46 3.35-4.58 3.35s-3.98-1.36-4.58-3.35l-.03-.1-.09.06a4.88 4.88 0 0 1-5.72.08c-1.71-1.21-2.4-3.39-1.69-5.33l.04-.1h-.11c-2.12.06-4.02-1.25-4.68-3.21-.65-1.97.1-4.12 1.84-5.29l.09-.06-.09-.06c-1.75-1.17-2.5-3.32-1.84-5.29.65-1.97 2.56-3.28 4.68-3.22h.11l-.04-.1c-.71-1.95-.02-4.12 1.69-5.34a4.88 4.88 0 0 1 5.72.08l.09.06.03-.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m26.21 28 .6-3.28H23.6l.21-1.18c.06-.36.37-.62.72-.62h2.6l.49-2.72c.06-.36.37-.62.72-.62h1.08l-.6 3.34h3.21l-.21 1.18c-.06.36-.37.62-.72.62h-2.6l-.48 2.66c-.07.36-.37.62-.72.62h-1.08Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_VIP56 = (VIP56);
;// ./src/Picto/GeneratedPictoComponents/DriverLicence104.tsx


var DriverLicence104_excluded = ["className"];
function DriverLicence104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DriverLicence104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DriverLicence104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DriverLicence104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DriverLicence104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DriverLicence104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DriverLicence104_objectSpread(DriverLicence104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.82 65.05c-1.54-2.5-2.11-4.81-3.66-6.86-1.04-1.37-2.28-2.3-4.22-2.17v19.52c0 6.09 1.29 5.19 8.57 5.19H52s-2.92-1.38-7.17-1.66c-15.78-1.05-21.39-4.88-27.02-14.02ZM89.87 23.44H14.52a4.3 4.3 0 0 0-4.3 4.3v6.7h83.95v-6.7a4.3 4.3 0 0 0-4.3-4.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.94 59.01a16.095 16.095 0 0 0-3.91 7.85c-.32 1.67 1.71 3.14 4.24 3.14H83c-7.93-1.19-13.56-5.34-17.06-10.99ZM76.53 52.47c-3.48-1-6.24-3.68-7.29-7.09-.15-.49-.87-.5-1 0-.23.83-.29 1.72-.16 2.64.41 2.86 2.75 5.17 5.65 5.57.99.13 1.94.05 2.81-.2.46-.13.45-.78 0-.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10 34h84M14.67 23h74.66c2.58 0 4.67 2.16 4.67 4.83v48.34c0 2.67-2.09 4.83-4.67 4.83H14.67C12.09 81 10 78.84 10 76.17V27.83c0-2.67 2.09-4.83 4.67-4.83ZM21 46h36M21 54h36M21 62h26.53"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.59 70c-2.13 0-3.83-1.5-3.57-3.21C63.16 59.49 68.08 54 73.99 54s10.84 5.49 11.97 12.79c.27 1.71-1.44 3.21-3.57 3.21H65.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "74",
        cy: "48",
        r: "6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DriverLicence104 = (DriverLicence104);
;// ./src/Picto/GeneratedPictoComponents/DriverLicence56.tsx


var DriverLicence56_excluded = ["className"];
function DriverLicence56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DriverLicence56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DriverLicence56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DriverLicence56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DriverLicence56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DriverLicence56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DriverLicence56_objectSpread(DriverLicence56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.75 35.99c-.73-1.21-1-2.33-1.74-3.32-.5-.67-1.08-1.12-2-1.05v9.46c0 1.93 2.54 2.93 6 2.93l14-.41s-1.34-.67-3.36-.8c-7.5-.51-10.22-2.36-12.9-6.79ZM47.75 12H8.25C7 12 6 13.23 6 14.74V19h44v-4.26c0-1.51-1.01-2.74-2.25-2.74Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35 32c-.95 1.14-1.02 3.2-1.31 4.83-.16.9.85 1.09 2.1 1.09H44c-3.89-.64-7.28-2.88-9-5.92ZM40.55 28.46c-1.69-.43-3.02-1.59-3.54-3.06-.07-.21-.42-.22-.49 0-.11.36-.14.74-.08 1.14.2 1.24 1.33 2.23 2.74 2.4.48.06.94.02 1.36-.09.22-.06.22-.34 0-.39Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 19h44M8.44 12.38h39.11c1.35 0 2.44 1.16 2.44 2.6v26.03c0 1.44-1.09 2.6-2.44 2.6H8.44c-1.35 0-2.44-1.16-2.44-2.6V14.99c0-1.44 1.09-2.6 2.44-2.6ZM11.11 25h19M11.11 29h19M11 33h14"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.26 38.28c-1.06 0-1.92-.84-1.78-1.81.57-4.1 3.03-7.19 5.99-7.19s5.42 3.09 5.99 7.19c.13.96-.72 1.81-1.78 1.81h-8.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.46",
        cy: "26.24",
        r: "3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DriverLicence56 = (DriverLicence56);
;// ./src/Picto/GeneratedPictoComponents/IDGeneric104.tsx


var IDGeneric104_excluded = ["className"];
function IDGeneric104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IDGeneric104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IDGeneric104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IDGeneric104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IDGeneric104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IDGeneric104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IDGeneric104_objectSpread(IDGeneric104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.27 51.75h-.01.01zM43.38 51.59c-.69.1-1.4.15-2.11.15-8.29 0-15-6.71-15-15 0-1.17.14-2.3.38-3.4.19-.82-1.01-1.21-1.35-.44-1.05 2.35-1.5 5.02-1.19 7.82.77 6.86 6.31 12.4 13.17 13.17 2.29.26 4.48 0 6.48-.67.97-.33.63-1.77-.38-1.63ZM76.51 82a10.217 10.217 0 0 0-2.49 5c-.2 1.07 1.09 2 2.7 2H88c-5.05-.76-9.26-3.4-11.49-7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.37 69.69c-1.02-3.22-1.4-6.21-2.42-8.85-.69-1.77-1.51-2.97-2.79-2.8v25.18c0 7.85.85 6.69 5.67 6.69H38s-1.93-1.78-4.74-2.14c-10.45-1.35-14.16-6.29-17.88-18.08ZM48.77 60.03h42.25c1.33 0 2.41 1.08 2.41 2.41v3.76H46.36v-3.76c0-1.33 1.08-2.41 2.41-2.41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41 90H14c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4h42c6.63 0 12 5.37 12 12v33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.67 60h42.67c1.47 0 2.67 1.27 2.67 2.83v28.33c0 1.56-1.19 2.83-2.67 2.83H48.67c-1.47 0-2.67-1.27-2.67-2.83V62.83c0-1.56 1.19-2.83 2.67-2.83ZM46 67h48M52.5 74h17M52.5 80h17"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.01",
        cy: "39",
        r: "15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.08 53.17c-1.21-2.22-2.2-3.61-2.93-5.5-.04-.1-.08-.19-.11-.3-.97-2.61-1.49-5.64-1.55-8.38-.08-2.88.33-5.75 1.23-8.49.63-1.87 1.47-3.67 2.53-5.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.71 29.62c-1.06.52-2.14.97-3.26 1.33a24.98 24.98 0 0 1-8.44 1.21c-2.82-.06-5.63-.62-8.3-1.66-1.01-.38-2.01-.85-2.97-1.39M27.74 48.89c1.06-.6 2.17-1.1 3.3-1.51a24.89 24.89 0 0 1 7.98-1.54c2.74-.08 5.5.3 8.13 1.12 1.23.38 2.41.86 3.57 1.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.96 53.15c1.29-2.26 2.33-3.88 3.07-5.89.04-.11.07-.21.11-.31.87-2.49 1.33-5.37 1.41-7.95.08-2.72-.29-5.44-1.09-8.05-.62-2.03-1.51-3.98-2.67-5.81M39.01 54V24M54.01 39h-30M75.75 89c-1.33 0-2.4-.94-2.23-2.01C74.23 82.43 77.31 79 81 79s6.77 3.43 7.48 7.99c.17 1.07-.9 2.01-2.23 2.01H75.74Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "81",
        cy: "75.5",
        r: "3.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IDGeneric104 = (IDGeneric104);
;// ./src/Picto/GeneratedPictoComponents/IDGeneric56.tsx


var IDGeneric56_excluded = ["className"];
function IDGeneric56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IDGeneric56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IDGeneric56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IDGeneric56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IDGeneric56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IDGeneric56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IDGeneric56_objectSpread(IDGeneric56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M7.1 32.13c.55 1.42.76 3.03 1.3 4.77 2 6.35 4 9.01 9.63 9.74 1.51.2 2.55 1.15 2.55 1.15H8.64c-2.6 0-3.06.62-3.06-3.6V30.63c.69-.09 1.13.55 1.5 1.51Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21 48H8.07C6.93 48 6 47.06 6 45.9V8.1C6 6.94 6.93 6 8.07 6h21.72C33.22 6 36 8.82 36 12.3V30"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.44 33h23.11c.8 0 1.44.63 1.44 1.42v14.17c0 .78-.65 1.42-1.44 1.42H25.44c-.8 0-1.44-.63-1.44-1.42V34.42c0-.78.65-1.42 1.44-1.42ZM28 38h9M28 42h7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.33 27.72a7.998 7.998 0 0 1-9.13-7.92c0-.62.07-1.23.2-1.81.1-.44-.54-.65-.72-.23-.56 1.25-.8 2.68-.64 4.17.41 3.66 3.37 6.61 7.02 7.02 1.22.14 2.39 0 3.46-.36.52-.17.34-.95-.2-.87ZM39.52 41.74c-.75.87-1.29 1.99-1.51 3.24-.12.69.66 1.29 1.64 1.29h6.85c-3.07-.49-5.62-2.2-6.98-4.53Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.01",
        cy: "21",
        r: "8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.37 28.56c-.65-1.18-1.17-1.93-1.56-2.93-.02-.05-.04-.1-.06-.16-.52-1.39-.79-3.01-.83-4.47-.04-1.53.17-3.07.66-4.53.34-1 .78-1.96 1.35-2.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.25 16c-.57.28-1.14.52-1.74.71-1.45.47-2.98.69-4.5.65-1.5-.03-3-.33-4.43-.89-.54-.2-1.07-.45-1.59-.74M14.99 26.27c.57-.32 1.16-.59 1.76-.81 1.37-.51 2.81-.78 4.25-.82 1.46-.04 2.93.16 4.33.6.66.2 1.29.46 1.91.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.65 28.55c.69-1.21 1.24-2.07 1.64-3.14.02-.06.04-.11.06-.17.46-1.33.71-2.86.75-4.24a13.139 13.139 0 0 0-2-7.39M21.01 29V13M29.01 21h-16M39.35 46.47c-.8 0-1.44-.61-1.34-1.3.43-2.95 2.27-5.17 4.49-5.17s4.06 2.22 4.49 5.17c.1.69-.54 1.3-1.34 1.3h-6.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.5",
        cy: "38",
        r: "2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IDGeneric56 = (IDGeneric56);
;// ./src/Picto/GeneratedPictoComponents/PassportAustralia104.tsx


var PassportAustralia104_excluded = ["className"];
function PassportAustralia104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PassportAustralia104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PassportAustralia104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PassportAustralia104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PassportAustralia104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PassportAustralia104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PassportAustralia104_objectSpread(PassportAustralia104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.57 39.43c-.08.52.09 1.14-.06 1.63-.79 2.52-.89 2.56-2.07 4.28-.57.82-1.21 1.61-2.4 1.65a4.34 4.34 0 0 1-2.02-.53c-1.64-.79-3.32-1.51-4.93-2.36-1.44-.76-2.87-1.94-4.48-2.38a4.962 4.962 0 0 0-3.29.36l-4.28 2.13c-.64.36-1.35.62-2.09.79-1.62.28-2.9-.74-3.55-1.95-.99-1.88-1.18-3.78-.68-5.81 0 0 .42-3.58 1-4.23-1.85 1.43-3.66 6.4-3.93 7.8-.45 2.32 1.26 6.07 1.98 7.17.72 1.1 1.52 1.31 1.96 1.38 3.19.67 7.36-5.68 14.61-2.64 1.91.8 7.39 5.12 10.98 4.52 2.02-.36 6.55-7.32 4.4-10.84-.18-.3-.99-.72-1.15-.98Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.86 59c-.57-.04-1.11-.28-1.53-.67-2.02-1.78-1.74-3.69-1.4-3.85.13-.05.85.26 1.74.29.74.01 1.48-.11 2.17-.37.91-.44.78 1.36.23 2.72-.41 1.05-.54 1.83-1.22 1.88Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.87 63.12c1.47 2.78 2.02 5.92 3.47 9.3C32.68 84.81 38 90 52.98 91.42c4.03.38 6.8 2.25 6.8 2.25H28c-6.91 0-8.13 1.22-8.13-7.03V60.18c1.84-.18 3.01 1.08 4 2.95Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35 70h34M40 77h24M24 10h48c6.62 0 12 5.38 12 12v60c0 6.62-5.38 12-12 12H24c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.07 39.32c-.45 2.64 1.26 6.93 1.98 8.18.72 1.26 1.52 1.49 1.96 1.58 3.19.77 7.36-6.48 14.6-3.01 1.91.91 7.39 5.84 10.98 5.16 2.02-.41 5.93-8.53 3.77-12.53-1.85-3.45-2.51-3.68-3.82-5.65-1.56-2.41-4.01-6.4-5.02-6.93-1.24-.64-1.03 1.47-1.12 2.17-.11.94 0 1.92-.23 2.86-.17.66-.15.7-.74.62-.87-.13-3.74-1.77-4.26-2.17-.89-.7.06-1.66.49-2.46.03-.05.05-.11.04-.17.02-.58-4.05-.36-4.55-.38-.51-.02-5.33 3.77-6.94 4.94-1.6 1.17-6.71 5.14-7.15 7.78ZM64.44 59c-.57-.04-1.11-.28-1.53-.67-2.02-1.78-1.74-3.69-1.4-3.85.13-.05.85.26 1.74.29.74.01 1.48-.11 2.17-.37.91-.44.78 1.36.23 2.72-.41 1.05-.54 1.83-1.22 1.88Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PassportAustralia104 = (PassportAustralia104);
;// ./src/Picto/GeneratedPictoComponents/PassportAustralia56.tsx


var PassportAustralia56_excluded = ["className"];
function PassportAustralia56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PassportAustralia56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PassportAustralia56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PassportAustralia56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PassportAustralia56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PassportAustralia56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PassportAustralia56_objectSpread(PassportAustralia56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.25 21.32c-.05.28.05.62-.03.89-.43 1.37-.49 1.4-1.14 2.33-.31.45-.67.88-1.32.9-.39 0-.78-.11-1.11-.29-.9-.43-1.82-.82-2.71-1.28-.79-.41-1.58-1.06-2.46-1.3-.61-.14-1.26-.07-1.81.2l-2.35 1.16c-.35.2-.74.34-1.15.43-.89.15-1.59-.4-1.95-1.06-.54-1.03-.65-2.06-.37-3.17 0 0 .23-1.95.55-2.31-1.02.78-2.01 3.49-2.16 4.25-.24 1.26.69 3.31 1.09 3.91.4.6.83.71 1.08.75 1.75.37 4.05-3.1 8.03-1.44 1.05.44 4.06 2.79 6.03 2.47 1.11-.2 3.6-4 2.42-5.91-.1-.17-.54-.39-.63-.53ZM34.21 32c-.31-.02-.61-.15-.84-.37-1.11-.97-.95-2.02-.77-2.1.07-.03.47.14.95.16.41 0 .81-.06 1.19-.2.5-.24.43.74.13 1.49-.23.57-.3 1-.67 1.03Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M13.39 33.33c.78 1.5 1.06 3.19 1.83 5.01 2.81 6.67 5.61 9.47 13.49 10.23 2.12.21 3.58 1.21 3.58 1.21H15.57c-3.64 0-4.28.66-4.28-3.79V31.74c.97-.1 1.58.58 2.1 1.59Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19 37.69h18M22 41.46h12M13 6h26c3.31 0 6 2.69 6 6v32c0 3.31-2.69 6-6 6H13c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.35 21.26c-.24 1.44.69 3.78 1.09 4.46.4.69.83.81 1.08.86 1.75.42 4.04-3.54 8.03-1.64 1.05.5 4.06 3.19 6.03 2.81 1.11-.22 3.26-4.65 2.07-6.84-1.02-1.88-1.38-2.01-2.1-3.08-.86-1.31-2.2-3.49-2.76-3.78-.68-.35-.57.8-.61 1.19-.06.51 0 1.05-.13 1.56-.09.36-.08.38-.4.34-.48-.07-2.05-.96-2.34-1.19-.49-.38.04-.91.27-1.34.02-.03.03-.06.02-.09.01-.31-2.22-.2-2.5-.21-.28-.01-2.93 2.06-3.81 2.7-.88.64-3.69 2.8-3.93 4.25ZM34.33 32c-.31-.02-.61-.15-.84-.37-1.11-.97-.95-2.02-.77-2.1.07-.03.47.14.95.16.41 0 .81-.06 1.19-.2.5-.24.43.74.13 1.49-.23.57-.3 1-.67 1.03Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PassportAustralia56 = (PassportAustralia56);
;// ./src/Picto/GeneratedPictoComponents/PassportInternational104.tsx


var PassportInternational104_excluded = ["className"];
function PassportInternational104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PassportInternational104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PassportInternational104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PassportInternational104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PassportInternational104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PassportInternational104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PassportInternational104_objectSpread(PassportInternational104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23 63.12c1.47 2.78 2.02 5.92 3.47 9.3 5.34 12.39 10.66 17.58 25.64 19 4.03.38 6.8 2.25 6.8 2.25H27.13c-6.91 0-8.13 1.22-8.13-7.03V60.18c1.84-.18 3.01 1.08 4 2.95Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35 70h34M40 77h24M24 10h48c6.62 0 12 5.38 12 12v60c0 6.62-5.38 12-12 12H24c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.4 55.6c-8.84 0-16-7.16-16-16 0-1.24.14-2.45.41-3.62.2-.88-1.07-1.3-1.44-.47-1.12 2.51-1.6 5.35-1.27 8.34.82 7.31 6.73 13.23 14.05 14.05 2.44.27 4.77 0 6.91-.72 1.04-.35.67-1.89-.41-1.74-.73.1-1.49.16-2.26.16",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "42",
        r: "16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.73 57.11c-1.3-2.37-2.34-3.85-3.13-5.86-.04-.1-.09-.2-.12-.32-1.03-2.78-1.59-6.02-1.65-8.93-.09-3.07.35-6.14 1.31-9.06.67-1.99 1.57-3.91 2.7-5.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.48 31.99c-1.13.55-2.28 1.03-3.48 1.42-2.91.95-5.97 1.38-9 1.3-3.01-.07-6.01-.66-8.86-1.77-1.07-.41-2.14-.9-3.17-1.48M39.97 52.54c1.13-.64 2.31-1.18 3.52-1.61 2.74-1.01 5.62-1.57 8.51-1.65 2.92-.09 5.86.32 8.67 1.19 1.31.41 2.57.91 3.81 1.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.28 57.1c1.38-2.41 2.49-4.13 3.27-6.28.04-.12.08-.22.12-.33.93-2.66 1.42-5.73 1.5-8.48.09-2.9-.31-5.81-1.17-8.58-.66-2.17-1.61-4.25-2.85-6.2M52 58V26M68 42H36"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PassportInternational104 = (PassportInternational104);
;// ./src/Picto/GeneratedPictoComponents/PassportInternational56.tsx


var PassportInternational56_excluded = ["className"];
function PassportInternational56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PassportInternational56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PassportInternational56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PassportInternational56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PassportInternational56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PassportInternational56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PassportInternational56_objectSpread(PassportInternational56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M13.39 33.33c.78 1.5 1.06 3.19 1.83 5.01 2.81 6.67 5.61 9.47 13.49 10.23 2.12.21 3.58 1.21 3.58 1.21H15.57c-3.64 0-4.28.66-4.28-3.79V31.74c.97-.1 1.58.58 2.1 1.59Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19 37.69h18M22 41.46h12M13 6h26c3.31 0 6 2.69 6 6v32c0 3.31-2.69 6-6 6H13c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.2 29.29c-4.42 0-8-3.58-8-8 0-.62.07-1.23.2-1.81.1-.44-.54-.65-.72-.23-.56 1.25-.8 2.68-.64 4.17.41 3.66 3.37 6.61 7.02 7.02 1.22.14 2.39 0 3.46-.36.52-.17.34-.95-.2-.87-.37.05-.75.08-1.13.08",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "22.49",
        r: "8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.37 30.05c-.65-1.18-1.17-1.93-1.56-2.93-.02-.05-.04-.1-.06-.16-.52-1.39-.79-3.01-.83-4.47-.04-1.53.17-3.07.66-4.53.34-1 .78-1.96 1.35-2.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.24 17.49c-.57.28-1.14.52-1.74.71-1.45.47-2.98.69-4.5.65-1.5-.03-3-.33-4.43-.89-.54-.2-1.07-.45-1.59-.74M21.99 27.77c.57-.32 1.16-.59 1.76-.81 1.37-.51 2.81-.78 4.25-.82 1.46-.04 2.93.16 4.33.6.66.2 1.29.46 1.91.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.64 30.04c.69-1.21 1.24-2.07 1.64-3.14.02-.06.04-.11.06-.17.46-1.33.71-2.86.75-4.24a13.139 13.139 0 0 0-2-7.39M28 30.49v-16M36 22.49H20"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PassportInternational56 = (PassportInternational56);
;// ./src/Picto/GeneratedPictoComponents/Australia104.tsx


var Australia104_excluded = ["className"];
function Australia104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Australia104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Australia104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Australia104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Australia104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Australia104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Australia104_objectSpread(Australia104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.15 42.44c-.21 1.45-.04 3.13-.15 4.55-.14 1.85-.44 3.69-.87 5.49-.87 3.61-2.3 7.08-4.24 10.25-1.64 2.67-3.48 5.23-7.53 4.49-1.01-.18-1.97-.58-2.86-1.08-4.22-2.32-8.55-4.39-12.7-6.85-3.57-2.11-7.08-5.41-11.06-6.64-2.56-.79-5.86-.22-8.15 1.04-3.53 1.96-7.05 3.92-10.58 5.89-1.64.91-3.32 1.84-5.16 2.2-3.95.76-7.16-2.06-8.77-5.44-2.45-5.14-3.06-11.25-1.84-16.8 0-.02.01-.05.02-.07.29-1.29-1.28-2.14-2.17-1.17-2.53 2.76-4.5 5.58-4.9 7.96-1.09 6.46 3.13 16.93 4.9 20.01 1.77 3.02 3.75 3.65 4.84 3.86 7.87 1.88 18.18-15.84 36.11-7.35 4.69 2.24 18.23 14.28 27.09 12.61 5.05-.99 14.64-20.84 9.33-30.63-.46-.85-.89-1.6-1.29-2.3ZM82.75 89.34c-1.35.05-2.92-1.15-3.07-1.35-4.06-3.54-3.49-7.35-2.81-7.66.26-.1 1.72.52 3.49.57 1.72.05 3.86-.47 4.38-.73 1.82-.89 1.56 2.71.47 5.42-.83 2.08-1.09 3.65-2.45 3.75Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.18 46.26c-1.09 6.46 3.13 16.93 4.9 20.01 1.77 3.02 3.75 3.65 4.84 3.86 7.87 1.88 18.18-15.84 36.11-7.35 4.69 2.24 18.23 14.28 27.09 12.61 5.05-.99 14.64-20.84 9.33-30.63-4.58-8.44-6.2-8.96-9.43-13.81-3.86-5.89-9.9-15.63-12.4-16.93-3.07-1.56-2.55 3.59-2.76 5.31-.26 2.29 0 4.69-.57 6.98-.42 1.61-.37 1.72-1.82 1.51-2.14-.31-9.22-4.32-10.52-5.31-2.19-1.72.16-4.06 1.2-6.04.1-.1.1-.26.1-.42.05-1.41-10.06-.89-11.25-.94-1.36-.05-13.18 9.27-17.14 12.14-3.96 2.87-16.57 12.56-17.66 19.02ZM82.75 89.34c-1.35.05-2.92-1.15-3.07-1.35-4.06-3.54-3.49-7.35-2.81-7.66.26-.1 1.72.52 3.49.57 1.72.05 3.86-.47 4.38-.73 1.82-.89 1.56 2.71.47 5.42-.83 2.08-1.09 3.65-2.45 3.75Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Australia104 = (Australia104);
;// ./src/Picto/GeneratedPictoComponents/Australia56.tsx


var Australia56_excluded = ["className"];
function Australia56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Australia56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Australia56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Australia56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Australia56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Australia56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Australia56_objectSpread(Australia56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.51 23.24c-.11.76-.02 1.64-.08 2.38-.08.97-.23 1.93-.46 2.88-.45 1.89-1.2 3.71-2.22 5.37-.74 1.2-1.55 2.35-3.1 2.41-.92.04-1.8-.34-2.61-.78-2.13-1.16-4.3-2.21-6.38-3.44-1.87-1.11-3.71-2.83-5.79-3.48-1.34-.42-3.07-.12-4.27.55-1.85 1.02-3.69 2.06-5.54 3.08-.86.48-1.74.96-2.7 1.15-2.07.4-3.75-1.08-4.59-2.85-1.29-2.69-1.6-5.9-.96-8.8.28-1.25-1.24.14-.29-1.7-2.4 2.11-3.06 3.2-3.41 5.22-.57 3.38 1.64 8.87 2.57 10.48.93 1.58 1.96 1.91 2.54 2.02 4.12.98 9.52-8.3 18.91-3.85 2.46 1.17 9.55 7.48 14.19 6.6 2.65-.52 7.67-10.92 4.88-16.05-.24-.45-.46-.84-.68-1.21ZM44.11 47.81c-.71.03-1.53-.6-1.61-.71-2.13-1.86-1.83-3.85-1.47-4.01.14-.05.9.27 1.83.3.9.03 2.02-.25 2.29-.38.96-.46.82 1.42.25 2.84-.44 1.09-.57 1.91-1.28 1.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.09 25.24c-.57 3.38 1.64 8.87 2.57 10.48.93 1.58 1.96 1.91 2.54 2.02 4.12.98 9.52-8.3 18.91-3.85 2.46 1.17 9.55 7.48 14.19 6.6 2.65-.52 7.67-10.92 4.88-16.05-2.4-4.42-3.25-4.69-4.94-7.23-2.02-3.08-5.19-8.19-6.5-8.87-1.61-.82-1.34 1.88-1.45 2.78-.14 1.2 0 2.46-.3 3.66-.22.85-.19.9-.96.79-1.12-.16-4.83-2.26-5.51-2.78-1.15-.9.08-2.13.63-3.17.05-.05.05-.14.05-.22.03-.74-5.27-.46-5.89-.49-.71-.03-6.9 4.86-8.98 6.36-2.07 1.5-8.68 6.58-9.25 9.96ZM44.11 47.81c-.71.03-1.53-.6-1.61-.71-2.13-1.86-1.83-3.85-1.47-4.01.14-.05.9.27 1.83.3.9.03 2.02-.25 2.29-.38.96-.46.82 1.42.25 2.84-.44 1.09-.57 1.91-1.28 1.96Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Australia56 = (Australia56);
;// ./src/Picto/GeneratedPictoComponents/CoverageMap104.tsx


var CoverageMap104_excluded = ["className"];
function CoverageMap104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageMap104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageMap104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageMap104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageMap104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMap104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageMap104_objectSpread(CoverageMap104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.82 69.78h-.83c-.55 0-1-.45-1-1s.45-1 1-1h.83c.55 0 1 .45 1 1s-.45 1-1 1ZM92.77 46.43a.99.99 0 0 1-.93-.64c-.2-.51.05-1.09.57-1.3l.8-.32a1.004 1.004 0 0 1 .73 1.87l-.8.32c-.12.05-.24.07-.36.07ZM21.34 33.67c-.34 0-.66-.17-.85-.48-.16-.26-.3-.52-.44-.78a.993.993 0 0 1 .41-1.35.993.993 0 0 1 1.35.41c.12.23.25.46.39.68a1.006 1.006 0 0 1-.85 1.53ZM58.88 26.73c-.24 0-.48-.09-.67-.26-.41-.37-.44-1-.07-1.41l.56-.62a.997.997 0 1 1 1.48 1.34l-.56.62c-.2.22-.47.33-.74.33ZM45.42 64.48c-.55 0-1-.45-1-1v-.68c0-.55.45-1 1-1s1 .45 1 1v.68c0 .55-.45 1-1 1ZM86.35 87.35c-.41 0-.79-.25-.94-.65-.19-.52.07-1.09.59-1.29.38-.14.74-.33 1.06-.57.45-.32 1.07-.22 1.4.22.32.45.22 1.07-.22 1.4-.47.34-.99.62-1.54.82-.11.04-.23.06-.35.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.17 43.78c-.21 1.44-.04 3.11-.15 4.52-.14 1.84-.43 3.67-.86 5.46-.86 3.59-2.28 7.04-4.21 10.18-1.63 2.66-3.46 5.19-7.49 4.46-1-.18-1.95-.58-2.85-1.07-4.2-2.3-8.49-4.36-12.62-6.81-3.54-2.1-7.04-5.38-10.99-6.6-2.55-.79-5.82-.22-8.1 1.04-3.51 1.94-7.01 3.9-10.51 5.85-1.63.91-3.3 1.83-5.13 2.18-3.92.76-7.11-2.05-8.72-5.41-2.44-5.11-3.04-11.18-1.83-16.69 0-.02.01-.05.02-.07.29-1.28-1.27-2.13-2.16-1.16-2.51 2.74-4.47 5.54-4.87 7.91-1.09 6.42 3.11 16.83 4.87 19.88 1.76 3 3.73 3.62 4.81 3.83 7.82 1.86 18.07-15.74 35.88-7.3 4.66 2.23 18.12 14.19 26.92 12.53 5.02-.98 14.55-20.71 9.27-30.44-.46-.84-.88-1.59-1.28-2.29ZM82.82 90.39c-1.35.05-2.9-1.14-3.05-1.35-4.04-3.52-3.47-7.3-2.8-7.61.26-.1 1.71.52 3.47.57 1.71.05 3.83-.47 4.35-.73 1.81-.88 1.55 2.69.47 5.38-.83 2.07-1.09 3.62-2.43 3.73Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M9.97 47.71c-1.1 6.48 3.13 16.97 4.91 20.06 1.78 3.03 3.76 3.66 4.86 3.86 7.89 1.88 18.23-15.88 36.19-7.36 4.7 2.25 18.28 14.31 27.16 12.64 5.07-.99 14.68-20.89 9.35-30.71-4.6-8.46-6.22-8.98-9.45-13.84-3.86-5.9-9.92-15.67-12.43-16.97-3.08-1.57-2.56 3.6-2.77 5.33-.26 2.3 0 4.7-.57 7-.42 1.62-.37 1.72-1.83 1.51-2.14-.31-9.24-4.33-10.55-5.33-2.19-1.72.16-4.07 1.2-6.06.1-.1.1-.26.1-.42.05-1.41-10.08-.89-11.28-.94-1.36-.05-13.21 9.3-17.18 12.17-3.97 2.87-16.61 12.59-17.71 19.06ZM82.73 90.91c-1.36.05-2.92-1.15-3.08-1.36-4.07-3.55-3.5-7.36-2.82-7.68.26-.1 1.72.52 3.5.57 1.72.05 3.86-.47 4.39-.73 1.83-.89 1.57 2.72.47 5.43-.84 2.09-1.1 3.66-2.45 3.76Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.42 68.03c-.55 0-1-.45-1-1v-.68c0-.55.45-1 1-1s1 .45 1 1v.68c0 .55-.45 1-1 1ZM90.67 85.32c-.41 0-.79-.25-.94-.65-.19-.52.07-1.09.59-1.29.38-.14.74-.33 1.06-.57.45-.32 1.07-.22 1.4.22s.22 1.07-.22 1.4c-.47.34-.99.62-1.54.82-.11.04-.23.06-.35.06ZM93.22 80.9c-.5 0-.94-.38-.99-.89-.04-.4-.13-.83-.25-1.29a1 1 0 0 1 .72-1.22 1 1 0 0 1 1.22.72c.14.55.24 1.08.3 1.57a1 1 0 0 1-.88 1.1h-.11ZM91.48 75.7c-.37 0-.72-.2-.9-.56-.19-.38-.39-.78-.61-1.18a.997.997 0 0 1 .4-1.36c.48-.26 1.09-.09 1.36.4.23.43.45.84.65 1.25.25.5.04 1.1-.45 1.34-.14.07-.29.1-.44.1ZM88.73 71c-.32 0-.64-.16-.83-.45-.25-.37-.5-.74-.76-1.12a.996.996 0 0 1 .25-1.39.996.996 0 0 1 1.39.25c.27.39.53.78.79 1.16.31.46.18 1.08-.28 1.39-.17.11-.36.17-.55.17ZM85.54 66.6c-.3 0-.59-.13-.79-.39-.29-.37-.59-.75-.9-1.13a1.002 1.002 0 1 1 1.56-1.26c.31.39.62.77.92 1.16a1 1 0 0 1-.17 1.4c-.18.14-.4.21-.61.21ZM82.01 62.33c-.28 0-.56-.12-.75-.34-.32-.36-.64-.73-.97-1.1a.998.998 0 1 1 1.49-1.33c.33.37.66.75.98 1.11.36.42.32 1.05-.1 1.41-.19.17-.42.25-.66.25ZM78.31 58.25c-.27 0-.53-.1-.73-.31-.31-.33-.63-.67-.96-1a.996.996 0 1 1 1.44-1.38c.33.34.65.68.97 1.02a.996.996 0 0 1-.73 1.68ZM74.47 54.34c-.25 0-.51-.1-.7-.29-.33-.33-.67-.66-1.01-.99a.987.987 0 0 1-.02-1.41.987.987 0 0 1 1.41-.02c.35.33.69.67 1.03 1 .39.39.4 1.02.01 1.41-.2.2-.45.3-.71.3ZM70.51 50.56c-.24 0-.49-.09-.68-.27-.34-.32-.69-.63-1.04-.95a.997.997 0 1 1 1.34-1.48l1.05.96c.41.37.43 1.01.06 1.41-.2.21-.47.32-.73.32ZM66.35 46.84a.99.99 0 0 1-.66-.25c-.36-.31-.72-.63-1.09-.94a.999.999 0 1 1 1.3-1.52c.37.32.74.63 1.1.95.42.36.46.99.1 1.41-.2.23-.48.34-.75.34ZM62.24 43.36c-.22 0-.45-.07-.63-.23-.4-.33-.79-.65-1.19-.97a1.002 1.002 0 1 1 1.26-1.56c.4.32.8.65 1.2.98a1 1 0 0 1 .14 1.41 1 1 0 0 1-.77.37ZM57.91 39.9c-.21 0-.43-.07-.61-.21-.4-.31-.8-.62-1.21-.92-.44-.33-.52-.96-.19-1.4.33-.44.96-.52 1.4-.19.41.31.81.62 1.22.93.44.34.52.97.18 1.4-.2.25-.49.39-.79.39ZM53.48 36.59c-.2 0-.41-.06-.59-.19-.42-.31-.84-.61-1.26-.91a.994.994 0 0 1-.23-1.39c.32-.45.94-.56 1.39-.23.42.3.85.61 1.28.92.45.32.55.95.22 1.4a1 1 0 0 1-.81.41ZM49.01 33.46c-.19 0-.39-.06-.56-.17-.44-.29-.87-.58-1.3-.87a.998.998 0 0 1-.28-1.39 1 1 0 0 1 1.39-.28c.44.29.88.58 1.32.88.46.31.58.93.27 1.39-.19.29-.51.44-.83.44ZM44.38 30.45c-.18 0-.36-.05-.53-.15-.43-.27-.85-.52-1.28-.78a.995.995 0 0 1-.34-1.37c.28-.47.9-.63 1.37-.34.43.26.86.52 1.3.79.47.29.61.91.32 1.38a.99.99 0 0 1-.85.47ZM39.61 27.65c-.16 0-.33-.04-.48-.12-.44-.24-.87-.48-1.3-.71a.996.996 0 0 1-.41-1.35c.26-.49.86-.67 1.35-.41.44.23.88.48 1.33.72a1.003 1.003 0 0 1-.49 1.88ZM34.77 25.16c-.14 0-.29-.03-.43-.1-.47-.22-.93-.43-1.39-.64-.5-.22-.73-.82-.51-1.32.22-.5.82-.73 1.32-.51.47.21.94.43 1.43.66.5.24.71.83.48 1.33-.17.36-.53.57-.9.57ZM29.7 23.06c-.12 0-.24-.02-.36-.07-.47-.18-.93-.35-1.39-.52a.998.998 0 0 1-.6-1.28c.19-.52.76-.79 1.28-.6.47.17.94.35 1.43.53.52.2.77.78.57 1.29a.99.99 0 0 1-.93.64ZM24.34 21.69h-.12c-.43-.05-.85-.08-1.23-.08-.55 0-1-.45-.99-1.01s.43-.99 1.01-.99c.46 0 .95.04 1.45.09.55.06.94.56.88 1.11-.06.51-.49.88-.99.88ZM18.62 24.05c-.26 0-.51-.1-.71-.29a.996.996 0 0 1 0-1.41l.74-.74a.996.996 0 1 1 1.41 1.41l-.74.74c-.2.2-.45.29-.71.29ZM9 66c-.55 0-1-.45-1-1 0-1.07.4-1.71.74-2.15a.99.99 0 0 1 1.4-.16c.43.34.51.97.16 1.4-.17.22-.31.43-.31.91 0 .55-.45 1-1 1ZM19.34 29.62c-.4 0-.77-.24-.93-.63-.24-.59-.44-1.17-.59-1.71-.15-.53.16-1.08.69-1.24.53-.15 1.08.16 1.24.69.14.48.31.99.52 1.52.2.51-.05 1.09-.56 1.3-.12.05-.25.07-.37.07ZM11.15 69.5c-.06 0-.12 0-.18-.02-.28-.05-.55-.11-.8-.17a.996.996 0 0 1-.72-1.22c.14-.53.68-.86 1.22-.72.21.05.43.1.67.14a.998.998 0 0 1-.18 1.98ZM99.87 41.14a.998.998 0 0 1-.94-1.34c.07-.19.09-.35.05-.47a.447.447 0 0 0-.08-.17.996.996 0 0 1 .24-1.39.994.994 0 0 1 1.39.24c.17.24.29.49.37.76.16.52.13 1.11-.09 1.72-.15.41-.53.66-.94.66ZM96.25 38.17h-.13c-.46-.06-.97-.11-1.51-.14a.996.996 0 1 1 .11-1.99c.6.03 1.16.08 1.67.15a1 1 0 0 1 .86 1.12c-.07.5-.5.87-.99.87ZM89.2 38.13c-.52 0-.96-.4-1-.93a.997.997 0 0 1 .92-1.07c.59-.04 1.16-.08 1.7-.1a.996.996 0 1 1 .09 1.99c-.53.02-1.08.06-1.65.1h-.07ZM83.76 38.71a1 1 0 0 1-.13-1.99c.55-.07 1.08-.14 1.6-.21a.994.994 0 0 1 1.11.87.987.987 0 0 1-.87 1.11c-.51.06-1.04.13-1.57.2h-.14ZM78.4 39.56c-.48 0-.9-.34-.98-.83-.1-.54.27-1.06.81-1.16.52-.09 1.04-.18 1.55-.27.54-.09 1.06.28 1.15.82.09.54-.28 1.06-.82 1.15-.5.08-1.01.17-1.53.26-.06.01-.12.02-.17.02ZM73.16 40.56c-.46 0-.88-.32-.98-.8-.11-.54.24-1.07.78-1.18.48-.1.95-.2 1.42-.29.54-.11 1.07.24 1.18.78.11.54-.24 1.07-.78 1.18-.46.09-.93.19-1.41.29-.07.01-.14.02-.2.02ZM67.7 41.77c-.45 0-.86-.31-.97-.77a.992.992 0 0 1 .75-1.2c.54-.13 1.07-.25 1.59-.37.54-.12 1.07.22 1.2.75.12.54-.22 1.07-.75 1.2-.52.12-1.05.24-1.58.36-.08.02-.15.03-.23.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.33 43.36a1 1 0 0 1-.25-1.97l1.34-.34a.995.995 0 0 1 1.21.73.995.995 0 0 1-.73 1.21l-1.33.34c-.08.02-.17.03-.25.03ZM57.11 44.51c-.44 0-.84-.29-.96-.73a.997.997 0 0 1 .69-1.23l1.59-.44c.53-.15 1.08.17 1.23.7s-.17 1.08-.7 1.23l-1.58.44c-.09.03-.18.04-.27.04ZM51.94 46.01c-.43 0-.83-.28-.96-.71-.16-.53.14-1.09.67-1.25l1.52-.45a.998.998 0 0 1 1.24.68.994.994 0 0 1-.68 1.24l-1.51.45c-.1.03-.19.04-.29.04ZM46.68 47.65a.999.999 0 0 1-.3-1.95l1.51-.48a.992.992 0 0 1 1.25.65.992.992 0 0 1-.65 1.25l-1.5.48c-.1.03-.21.05-.31.05ZM41.45 49.39c-.42 0-.8-.26-.95-.67-.18-.52.1-1.09.62-1.27.55-.19 1.1-.38 1.66-.57.52-.18 1.09.1 1.27.63s-.1 1.09-.63 1.27c-.55.19-1.1.37-1.65.56a.96.96 0 0 1-.33.06ZM36.33 51.21c-.41 0-.79-.25-.94-.65a.993.993 0 0 1 .59-1.28c.5-.19 1.01-.37 1.52-.55a.998.998 0 0 1 1.28.6.998.998 0 0 1-.6 1.28c-.51.18-1.01.37-1.5.55-.11.04-.23.06-.35.06ZM31.27 53.15c-.4 0-.77-.24-.93-.63-.2-.51.05-1.09.56-1.3.49-.19.98-.39 1.48-.58.51-.2 1.09.05 1.29.57.2.51-.06 1.09-.57 1.29-.49.19-.98.38-1.46.58-.12.05-.25.07-.37.07ZM26.22 55.24c-.39 0-.76-.23-.92-.6-.22-.51.01-1.1.52-1.31.47-.2.94-.4 1.42-.61.51-.22 1.09.02 1.31.53s-.02 1.1-.53 1.31c-.48.2-.94.4-1.41.6-.13.06-.26.08-.4.08ZM21.2 57.52c-.37 0-.73-.21-.9-.57a.99.99 0 0 1 .47-1.33c.51-.24 1.02-.49 1.55-.73.5-.23 1.1-.01 1.33.49.23.5.01 1.1-.49 1.33-.52.24-1.03.48-1.53.72-.14.07-.29.1-.43.1ZM16.37 60c-.35 0-.69-.19-.88-.51-.27-.48-.09-1.09.39-1.36.45-.25.91-.5 1.39-.75a.996.996 0 0 1 1.35.42c.26.49.07 1.09-.42 1.35-.46.25-.92.49-1.35.73-.15.08-.32.13-.48.13ZM12 62.44a.97.97 0 0 1-.81-.42c-.32-.45-.22-1.07.23-1.4.41-.3.86-.6 1.33-.91a1 1 0 0 1 1.38.29 1 1 0 0 1-.29 1.38c-.45.29-.87.58-1.26.86a.98.98 0 0 1-.58.19ZM96.74 44.55c-.3 0-.6-.14-.8-.4-.33-.44-.25-1.07.19-1.4.2-.15.39-.3.56-.44a1.002 1.002 0 1 1 1.26 1.56c-.2.16-.4.32-.62.48-.18.14-.39.2-.6.2ZM46.26 71.19c-.43 0-.82-.27-.95-.7-.04-.14-.09-.29-.12-.44-.13-.54.2-1.08.73-1.21.54-.13 1.08.2 1.21.73.03.11.06.22.09.32a.99.99 0 0 1-.66 1.25c-.1.03-.2.05-.3.05ZM49.27 71.25c-.32 0-.64-.15-.83-.44a.999.999 0 0 1 .27-1.39c.29-.19.6-.46.94-.8a.987.987 0 0 1 1.41 0c.39.39.4 1.02 0 1.41-.43.43-.85.79-1.24 1.05-.17.12-.37.17-.56.17ZM52.31 67.69c-.19 0-.38-.05-.54-.16a.99.99 0 0 1-.29-1.38c.32-.49.64-1.01.96-1.57.28-.48.89-.64 1.37-.36.48.28.64.89.36 1.37-.34.58-.68 1.13-1.01 1.65-.19.29-.51.46-.84.46ZM55.05 62.83a1.01 1.01 0 0 1-.9-1.45c.2-.39.39-.79.59-1.19.24-.5.84-.71 1.33-.47.5.24.71.84.47 1.33-.2.42-.4.83-.6 1.23-.18.35-.53.55-.9.55ZM57.3 57.92c-.13 0-.26-.03-.39-.08a.991.991 0 0 1-.53-1.31c.2-.48.4-.96.6-1.46a.998.998 0 1 1 1.85.75c-.2.5-.41 1-.61 1.49-.16.38-.53.61-.92.61ZM59.3 52.8a.998.998 0 0 1-.94-1.34c.18-.49.35-.98.52-1.47.18-.52.75-.8 1.27-.62.52.18.8.75.62 1.27-.17.51-.35 1.01-.53 1.5-.15.41-.53.66-.94.66ZM61.04 47.57a.99.99 0 0 1-.95-1.29c.15-.5.3-1 .44-1.49.15-.53.71-.83 1.24-.68.53.15.84.71.68 1.24-.15.5-.3 1.01-.45 1.52-.13.43-.53.71-.96.71Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.69 41.71c-.08 0-.16 0-.24-.03a.995.995 0 0 1-.73-1.21c.12-.47.23-.94.33-1.4a1 1 0 1 1 1.95.45c-.11.47-.22.95-.34 1.43-.11.46-.52.76-.97.76ZM63.67 36.79c-.06 0-.11 0-.17-.01-.54-.09-.91-.61-.82-1.15.08-.48.16-.94.22-1.4.08-.55.58-.92 1.13-.85.55.08.92.59.85 1.13-.07.47-.15.95-.23 1.44-.08.49-.51.83-.98.83ZM64.28 31.69h-.06a.999.999 0 0 1-.94-1.06c.03-.58.05-1.14.04-1.65 0-.55.44-1 .99-1.01.55 0 1 .44 1 .99 0 .56-.01 1.15-.05 1.78-.03.53-.47.94-1 .94ZM64.06 26.42c-.31 0-.62-.15-.81-.42-.21-.14-.83-.32-1.04-.38-.11-.03-.21-.06-.28-.09a.999.999 0 0 1-.63-1.27c.18-.52.74-.8 1.27-.63l.21.06c.93.27 1.79.57 2.16 1.23a1 1 0 0 1-.87 1.49Zm-.79-.4Zm-.09-.11Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMap104 = (CoverageMap104);
;// ./src/Picto/GeneratedPictoComponents/CoverageMap56.tsx


var CoverageMap56_excluded = ["className"];
function CoverageMap56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CoverageMap56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CoverageMap56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CoverageMap56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CoverageMap56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CoverageMap56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CoverageMap56_objectSpread(CoverageMap56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.75 23.65c-.11.79-.02 1.7-.08 2.47-.08 1.01-.24 2-.47 2.99-.47 1.96-1.25 3.85-2.31 5.57-.89 1.45-1.89 2.84-4.09 2.44-.55-.1-1.07-.32-1.56-.58-2.3-1.26-4.64-2.39-6.9-3.72-1.94-1.15-3.85-2.94-6.01-3.61-1.39-.43-3.18-.12-4.43.57-1.92 1.06-3.83 2.13-5.75 3.2-.89.5-1.8 1-2.8 1.19-2.15.41-3.89-1.12-4.77-2.96-1.33-2.79-1.66-6.12-1-9.13v-.04c.16-.7-.7-1.17-1.18-.63-1.37 1.5-2.45 3.03-2.67 4.33-.59 3.51 1.7 9.2 2.66 10.87.96 1.64 2.04 1.98 2.63 2.1 4.28 1.02 9.88-8.61 19.62-3.99 2.55 1.22 9.91 7.76 14.72 6.85 2.75-.54 7.96-11.33 5.07-16.65-.25-.46-.48-.87-.7-1.25ZM44.18 49.14c-.74.03-1.59-.62-1.67-.74-2.21-1.93-1.9-3.99-1.53-4.16.14-.06.93.28 1.9.31.93.03 2.1-.25 2.38-.4.99-.48.85 1.47.25 2.94-.45 1.13-.59 1.98-1.33 2.04Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.19 37.66h-.45c-.3 0-.55-.24-.55-.55s.24-.55.55-.55h.45c.3 0 .55.24.55.55s-.24.55-.55.55ZM49.68 24.93a.548.548 0 0 1-.2-1.06l.44-.17c.28-.11.6.03.71.31.11.28-.03.6-.31.71l-.44.17c-.07.03-.13.04-.2.04ZM10.74 17.97c-.18 0-.36-.09-.46-.26-.09-.14-.16-.29-.24-.43-.14-.27-.04-.6.22-.74s.6-.04.74.22c.07.12.13.25.21.37.16.26.08.59-.18.75-.09.05-.19.08-.29.08ZM31.21 14.19c-.13 0-.26-.05-.37-.14a.55.55 0 0 1-.04-.77l.31-.34c.2-.22.55-.24.77-.04.22.2.24.55.04.77l-.31.34c-.11.12-.25.18-.4.18ZM23.87 34.77c-.3 0-.55-.24-.55-.55v-.37c0-.3.24-.55.55-.55s.55.24.55.55v.37c0 .3-.24.55-.55.55ZM46.18 47.23a.547.547 0 0 1-.19-1.06c.21-.08.4-.18.58-.31a.545.545 0 0 1 .64.88c-.26.19-.54.34-.84.45-.06.02-.13.03-.19.03Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.77 25.67c-.59 3.51 1.7 9.19 2.66 10.86.96 1.64 2.04 1.98 2.63 2.09 4.27 1.02 9.87-8.6 19.6-3.99 2.55 1.22 9.9 7.75 14.71 6.84 2.74-.54 7.95-11.31 5.06-16.63-2.49-4.58-3.37-4.87-5.12-7.5-2.09-3.2-5.37-8.49-6.73-9.19-1.67-.85-1.39 1.95-1.5 2.88-.14 1.24 0 2.55-.31 3.79-.23.88-.2.93-.99.82-1.16-.17-5.01-2.35-5.71-2.89-1.19-.93.08-2.21.65-3.28.06-.06.06-.14.06-.23.03-.76-5.46-.48-6.11-.51-.74-.03-7.16 5.03-9.31 6.59-2.15 1.56-8.99 6.82-9.59 10.32ZM44.17 49.06c-.74.03-1.58-.62-1.67-.74-2.21-1.92-1.9-3.99-1.53-4.16.14-.06.93.28 1.9.31.93.03 2.09-.25 2.38-.4.99-.48.85 1.47.25 2.94-.45 1.13-.59 1.98-1.33 2.04Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.63 36.64a.56.56 0 0 1-.56-.56v-.38a.56.56 0 1 1 1.12 0v.38c0 .31-.25.56-.56.56ZM48.78 46.26a.55.55 0 0 1-.52-.36c-.11-.29.04-.61.33-.71.21-.08.41-.18.59-.32.25-.18.6-.12.78.12s.12.6-.12.78c-.26.19-.55.34-.86.46-.06.02-.13.04-.19.04ZM50.2 43.8c-.28 0-.52-.21-.55-.49-.02-.22-.07-.46-.14-.72-.08-.3.1-.6.4-.68.3-.08.6.1.68.4.08.31.14.6.17.87.03.31-.19.58-.49.61h-.06ZM49.23 40.91c-.2 0-.4-.11-.5-.31-.11-.21-.22-.43-.34-.65a.546.546 0 0 1 .22-.75c.27-.15.61-.05.75.22.13.24.25.47.36.69.14.28.02.61-.25.74-.08.04-.16.06-.25.06ZM47.7 38.3c-.18 0-.36-.09-.46-.25-.14-.21-.28-.41-.42-.62-.18-.25-.11-.6.14-.77.25-.18.6-.11.77.14.15.22.3.43.44.64.17.26.1.6-.15.77-.09.06-.2.09-.31.09ZM45.93 35.85a.55.55 0 0 1-.44-.21c-.16-.21-.33-.42-.5-.63a.564.564 0 0 1 .08-.78c.24-.19.59-.15.78.08.17.22.34.43.51.64.19.24.14.59-.1.78-.1.08-.22.12-.34.12ZM43.97 33.42c-.14 0-.28-.06-.38-.17-.18-.2-.35-.41-.54-.61a.505.505 0 0 1 .04-.71c.21-.18.52-.17.71.04.18.21.37.42.54.62.18.21.16.52-.05.71-.09.08-.21.12-.33.12ZM41.91 31.21a.56.56 0 0 1-.4-.17l-.53-.56a.565.565 0 0 1 .01-.79c.22-.21.57-.21.79.01l.54.57c.21.22.2.57-.02.79-.11.1-.24.15-.38.15ZM39.78 29.03c-.14 0-.28-.05-.39-.16-.19-.18-.37-.37-.56-.55a.555.555 0 0 1-.01-.79c.21-.22.56-.23.79-.01.19.19.38.37.57.56.22.22.22.57 0 .79a.56.56 0 0 1-.4.17ZM37.57 26.93c-.13 0-.27-.05-.38-.15-.19-.18-.38-.35-.58-.53a.565.565 0 0 1-.04-.79c.21-.23.56-.24.79-.04.2.18.39.36.58.53.23.21.24.56.03.79-.11.12-.26.18-.41.18ZM35.27 24.86c-.13 0-.26-.05-.36-.14-.2-.17-.4-.35-.6-.52a.554.554 0 0 1 .72-.84c.21.18.41.35.61.53.23.2.26.55.05.78-.11.13-.26.19-.42.19ZM32.78 22.82c-.13 0-.26-.05-.36-.14-.2-.17-.4-.35-.6-.52a.554.554 0 0 1 .72-.84c.21.18.41.35.61.53.23.2.26.55.05.78-.11.13-.26.19-.42.19ZM30.57 21.01c-.12 0-.24-.04-.34-.12-.22-.17-.45-.34-.67-.51a.567.567 0 0 1-.11-.78c.19-.24.53-.29.78-.11.23.17.45.34.68.52a.557.557 0 0 1-.34 1ZM28.11 19.17c-.11 0-.23-.03-.33-.11-.24-.17-.47-.34-.7-.51a.56.56 0 0 1 .65-.91c.24.17.47.34.71.51a.558.558 0 0 1-.33 1.01ZM25.63 17.43a.5.5 0 0 1-.31-.1l-.72-.48a.552.552 0 0 1-.16-.77c.17-.26.51-.33.77-.16.24.16.49.32.73.49.25.17.32.52.15.77-.11.16-.28.24-.46.24ZM23.05 15.76c-.1 0-.2-.03-.29-.08-.24-.15-.47-.29-.71-.43a.555.555 0 0 1 .57-.95c.24.14.48.29.72.44.26.16.34.5.18.77a.56.56 0 0 1-.47.26ZM20.4 14.2c-.09 0-.18-.02-.27-.07-.24-.14-.49-.27-.72-.39a.558.558 0 0 1-.23-.75c.14-.27.48-.37.75-.23.24.13.49.26.74.4a.56.56 0 0 1-.27 1.05ZM17.71 12.82c-.08 0-.16-.02-.24-.05-.26-.12-.52-.24-.77-.35-.28-.12-.41-.45-.28-.73.12-.28.45-.41.73-.28.26.12.52.24.79.36.28.13.4.46.26.74-.09.2-.29.32-.5.32ZM14.9 11.65c-.07 0-.13-.01-.2-.04-.26-.1-.52-.2-.77-.29a.544.544 0 0 1-.33-.71c.1-.29.42-.44.71-.33.26.09.52.19.79.3.29.11.43.43.32.72a.56.56 0 0 1-.52.36ZM11.92 10.89h-.07c-.24-.03-.47-.04-.68-.05-.31 0-.55-.25-.55-.56s.24-.55.56-.55c.25 0 .53.02.81.05.3.04.52.31.49.62-.03.28-.27.49-.55.49ZM8.73 12.2a.555.555 0 0 1-.39-.95l.41-.41c.22-.22.57-.22.79 0 .22.22.22.57 0 .79l-.41.41c-.11.11-.25.16-.39.16ZM3.39 35.52a.56.56 0 0 1-.56-.56c0-.6.22-.95.41-1.19a.556.556 0 0 1 .87.69c-.09.12-.17.24-.17.5 0 .31-.25.56-.56.56ZM9.14 15.29c-.22 0-.43-.13-.52-.35-.13-.33-.24-.65-.33-.95-.08-.3.09-.6.38-.69.3-.08.6.09.69.38.08.27.17.55.29.84a.558.558 0 0 1-.52.76ZM4.58 37.46h-.1c-.16-.03-.31-.06-.45-.1a.555.555 0 0 1-.4-.68c.08-.3.38-.48.68-.4.12.03.24.06.37.08.3.06.5.34.45.65-.05.27-.28.46-.55.46ZM53.9 21.7a.548.548 0 0 1-.52-.74c.04-.11.05-.2.03-.26-.01-.04-.02-.07-.04-.09-.18-.25-.12-.6.13-.77.25-.18.6-.12.77.13.09.13.16.27.2.42.09.29.07.62-.05.96-.08.23-.3.37-.52.37ZM51.88 20.05h-.07c-.26-.03-.54-.06-.84-.08-.31-.02-.54-.28-.52-.59s.28-.54.59-.52c.33.02.64.05.93.08.3.04.52.32.48.62-.04.28-.28.48-.55.48ZM47.96 20.03c-.29 0-.53-.22-.55-.52a.55.55 0 0 1 .51-.59l.95-.06c.3-.01.57.22.58.53s-.22.57-.53.58c-.29.01-.6.03-.92.06h-.04ZM44.94 20.35c-.27 0-.51-.2-.55-.48-.04-.3.17-.58.48-.63.3-.04.6-.08.89-.11.3-.03.58.18.62.49.04.3-.18.58-.49.62-.29.03-.58.07-.88.11h-.08ZM41.96 20.82c-.26 0-.5-.19-.55-.46-.05-.3.15-.59.45-.64.29-.05.58-.1.86-.15.3-.05.59.15.64.46.05.3-.15.59-.46.64-.28.05-.56.09-.85.15h-.1ZM39.05 21.38c-.26 0-.49-.18-.54-.44-.06-.3.13-.59.43-.66.27-.06.53-.11.79-.16a.556.556 0 0 1 .21 1.09c-.26.05-.52.1-.78.16-.04 0-.08.01-.11.01ZM36.02 22.05c-.25 0-.48-.17-.54-.43-.07-.3.12-.6.41-.67.3-.07.59-.14.89-.2.3-.07.6.12.66.42.07.3-.12.6-.42.66-.29.07-.58.13-.88.2-.04.01-.09.01-.13.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.03 22.93c-.25 0-.47-.17-.54-.42-.08-.3.1-.6.4-.68l.74-.19c.3-.07.6.11.67.4.07.3-.11.6-.4.67l-.74.19s-.09.02-.14.02ZM27.25 24.4a.556.556 0 0 1-.16-1.09l.84-.25c.29-.09.6.08.69.38.09.29-.08.6-.38.69l-.84.25c-.05.02-.11.02-.16.02ZM30.37 23.59a.556.556 0 0 1-.16-1.09l.84-.25c.29-.09.6.08.69.38.09.29-.08.6-.38.69l-.84.25c-.05.02-.11.02-.16.02ZM24.33 25.31c-.24 0-.45-.15-.53-.39-.09-.29.07-.61.36-.7l.84-.27c.29-.09.6.07.7.36.09.29-.07.6-.36.7l-.83.27c-.06.02-.11.03-.17.03ZM21.42 26.28c-.23 0-.45-.14-.53-.38-.1-.29.05-.61.34-.71.31-.11.61-.21.92-.32.29-.1.61.06.7.35s-.06.61-.35.7c-.31.1-.61.21-.92.31-.06.02-.12.03-.18.03ZM18.58 27.3a.55.55 0 0 1-.52-.36c-.11-.29.04-.61.33-.71.28-.1.56-.21.84-.31a.552.552 0 1 1 .38 1.04c-.28.1-.56.2-.84.31-.06.02-.13.03-.19.03ZM15.76 28.37c-.22 0-.43-.13-.52-.35-.11-.29.03-.61.31-.72.27-.11.54-.21.82-.32a.558.558 0 0 1 .4 1.04c-.27.11-.55.21-.81.32-.07.03-.14.04-.2.04ZM12.96 29.53c-.21 0-.42-.13-.51-.34a.55.55 0 0 1 .29-.73c.26-.11.52-.22.79-.34.28-.12.61.01.73.3s-.01.61-.3.73c-.26.11-.53.22-.78.33-.07.03-.15.05-.22.05ZM10.17 30.8c-.21 0-.41-.12-.5-.32a.552.552 0 0 1 .26-.74c.28-.13.57-.27.86-.41.28-.13.61 0 .74.27.13.28 0 .61-.27.74-.29.13-.57.27-.85.4-.08.04-.16.05-.24.05ZM7.48 32.18c-.2 0-.39-.1-.49-.29a.56.56 0 0 1 .22-.76c.25-.14.51-.28.77-.42.27-.14.61-.04.75.23s.04.61-.23.75c-.26.14-.51.27-.75.41-.09.05-.18.07-.27.07ZM5.06 33.54a.56.56 0 0 1-.45-.23.56.56 0 0 1 .13-.78c.23-.17.48-.33.74-.5.26-.17.6-.09.77.16.17.26.09.6-.16.77-.25.16-.48.32-.7.48-.1.07-.21.1-.32.1ZM52.15 23.59c-.17 0-.33-.08-.44-.22a.55.55 0 0 1 .11-.78c.11-.08.21-.16.31-.25a.555.555 0 0 1 .7.86c-.11.09-.22.18-.34.27-.1.08-.22.11-.33.11ZM24.1 38.4c-.24 0-.46-.15-.53-.39-.02-.08-.05-.16-.07-.25-.07-.3.11-.6.41-.67.3-.07.6.11.67.41.02.06.03.12.05.18a.566.566 0 0 1-.53.73ZM25.77 38.43c-.18 0-.35-.09-.46-.24-.17-.25-.11-.6.15-.77.16-.11.34-.26.52-.45.22-.22.57-.22.79 0 .22.22.22.57 0 .79-.24.24-.47.44-.69.59-.1.06-.2.1-.31.1ZM27.46 36.45a.553.553 0 0 1-.46-.86c.18-.27.36-.56.54-.87.15-.27.49-.35.76-.2.27.15.35.5.2.76-.19.32-.38.63-.56.92-.11.16-.28.25-.47.25ZM28.98 33.75a.562.562 0 0 1-.5-.81l.33-.66a.555.555 0 1 1 1 .48c-.11.23-.22.46-.33.68-.1.19-.29.31-.5.31ZM30.24 31.02c-.07 0-.14-.01-.22-.04a.563.563 0 0 1-.3-.73l.33-.81c.11-.28.44-.42.72-.31.28.11.42.44.31.72-.11.28-.23.56-.34.83-.09.21-.3.34-.51.34ZM31.35 28.18a.544.544 0 0 1-.52-.74c.1-.27.19-.54.29-.82a.558.558 0 0 1 1.05.37c-.1.28-.2.56-.29.83-.08.23-.3.37-.52.37ZM32.32 25.27c-.05 0-.11 0-.16-.02a.556.556 0 0 1-.37-.69c.08-.28.17-.55.25-.83.09-.29.39-.46.69-.38.29.09.46.39.38.69-.08.28-.16.56-.25.84-.07.24-.29.39-.53.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.23 22.01s-.09 0-.13-.02a.554.554 0 0 1-.41-.67c.06-.26.13-.52.19-.78.07-.3.37-.48.67-.42.3.07.49.37.42.67-.06.26-.12.53-.19.8-.06.25-.29.42-.54.42ZM33.78 19.28h-.09a.548.548 0 0 1-.45-.64c.05-.26.09-.52.12-.78.04-.3.33-.51.63-.47.3.04.51.33.47.63-.04.26-.08.53-.13.8s-.28.46-.55.46ZM34.12 16.45h-.03a.552.552 0 0 1-.52-.59c.02-.32.03-.63.02-.92 0-.31.24-.56.55-.56.3 0 .55.25.56.55 0 .31 0 .64-.03.99-.02.3-.26.52-.55.52ZM33.99 13.52c-.18 0-.35-.08-.45-.23-.12-.08-.46-.18-.58-.21-.06-.02-.12-.03-.16-.05a.552.552 0 0 1-.35-.7c.1-.29.41-.45.7-.35l.12.04c.52.15.99.32 1.2.68a.556.556 0 0 1-.48.83Zm-.44-.22Zm-.05-.07Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CoverageMap56 = (CoverageMap56);
;// ./src/Picto/GeneratedPictoComponents/GlobalMapMarker104.tsx


var GlobalMapMarker104_excluded = ["className"];
function GlobalMapMarker104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GlobalMapMarker104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GlobalMapMarker104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GlobalMapMarker104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GlobalMapMarker104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalMapMarker104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalMapMarker104_objectSpread(GlobalMapMarker104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.18 53.63c1.14 9.84 6.44 29.37 30 38.39 1.52.58 1.19 2.83-.44 2.91-10.83.52-31.32-2.85-33.79-35.11 0 0 .45-2.58 1.74-6.43.43-1.29 2.33-1.11 2.49.24Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.74 42.71s1.54.89 3.82.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.15 40.4c7.09 7.41 10.51 18.08 8.22 28.86-3.68 17.32-20.71 28.38-38.03 24.7-17.32-3.68-28.38-20.71-24.7-38.03a31.936 31.936 0 0 1 8.86-16.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.68 50.91c1.24 3.24 2.27 6.55 3.63 9.76 2.13 5.04 3.22.44 7.29 2.7 3.98 2.2 6.82 4.9 7.43 9.01.32 2.21-.06 8.77 2.02 9.56 2.88 1.08 6.76-.39 9.75-.37 3.3.03 7.14.33 9.26-2.26 2.45-2.99 4.4-6.27 6.44-9.49 1.04-1.64 6.22-.31 7.5.6s2.33 3.6 2.47 6.44c.08 1.63 1.16 1.63.9 2.62"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.9 64.26 39.96 43.13c-2.21-3.69-3.51-8.14-3.51-12.93 0-6.31 2.24-12.03 5.87-16.19 1.18-1.35-.56-3.23-2.03-2.2-5.28 3.68-8.74 9.79-8.74 16.72 0 4.24 1.29 8.17 3.51 11.43l14.62 22.88c.41.83 1.25 1.4 2.21 1.43Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.69 62.83c.41.85 1.28 1.43 2.27 1.44.99 0 1.85-.59 2.27-1.44L68.9 39.95c2.21-3.26 3.5-7.2 3.5-11.43 0-11.27-9.14-20.4-20.42-20.4s-20.42 9.13-20.42 20.4c0 4.24 1.3 8.17 3.51 11.43l14.62 22.88Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.75 28.53c0 4.83-3.92 8.75-8.75 8.75s-8.75-3.92-8.75-8.75 3.92-8.75 8.75-8.75 8.75 3.92 8.75 8.75Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalMapMarker104 = (GlobalMapMarker104);
;// ./src/Picto/GeneratedPictoComponents/GlobalMapMarker56.tsx


var GlobalMapMarker56_excluded = ["className"];
function GlobalMapMarker56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function GlobalMapMarker56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? GlobalMapMarker56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : GlobalMapMarker56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function GlobalMapMarker56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, GlobalMapMarker56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", GlobalMapMarker56_objectSpread(GlobalMapMarker56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.54 24.2s-1.08 17.78 16.94 24.48c.78.29.61 1.42-.22 1.47-5.86.36-17.51-1.24-18.9-19.29 0 0 .52-2.94 2.17-6.66Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.57 20.01c4.01 4.08 5.96 10.03 4.68 16.04-2.03 9.53-11.39 15.61-20.92 13.58-9.53-2.02-15.61-11.39-13.58-20.92.73-3.42 2.4-6.39 4.68-8.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.66 21.45s.84.49 2.1.43M11.81 25.75c.68 1.79 1.25 3.61 2 5.39 1.17 2.78 1.77.24 4.02 1.49 2.2 1.22 3.76 2.71 4.1 4.97.18 1.22-.03 4.84 1.12 5.27 1.59.6 3.73-.22 5.38-.2 1.82.02 3.94.18 5.11-1.25 1.35-1.65 2.43-3.46 3.55-5.24.58-.91 3.43-.17 4.14.33s1.28 1.98 1.36 3.55c.05.9.64.9.5 1.44"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.95 33.3-6.57-11.62c-1.22-2.03-1.93-4.48-1.93-7.11 0-4.06 1.69-7.67 4.31-9.99.54-.48-.06-1.32-.7-1-3.73 1.82-6.3 5.64-6.3 10.07 0 2.33.71 4.5 1.93 6.29l8.04 12.58c.22.46.69.77 1.22.79Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.73 32.51c.23.47.7.79 1.25.79a1.4 1.4 0 0 0 1.25-.79l8.07-12.58c1.22-1.79 1.93-3.96 1.93-6.29 0-6.2-5.03-11.22-11.23-11.22S16.77 7.44 16.77 13.64c0 2.33.71 4.49 1.93 6.29l8.04 12.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.81 13.65c0 2.66-2.16 4.81-4.81 4.81s-4.81-2.16-4.81-4.81S25.35 8.84 28 8.84s4.81 2.15 4.81 4.81Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_GlobalMapMarker56 = (GlobalMapMarker56);
;// ./src/Picto/GeneratedPictoComponents/MapMarker104.tsx


var MapMarker104_excluded = ["className"];
function MapMarker104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MapMarker104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MapMarker104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MapMarker104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MapMarker104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarker104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MapMarker104_objectSpread(MapMarker104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52.28",
      cy: "85.01",
      rx: "15.69",
      ry: "2.8",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.5 75.98c-7.74 1.69-12.93 4.79-12.93 8.33 0 5.35 11.81 9.69 26.39 9.69s26.39-4.34 26.39-9.69c0-3.54-5.87-6.82-13.6-8.51"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52.18 82.2 36.61 54.65c-2.89-4.81-4.57-10.61-4.57-16.86 0-9.61 3.98-18.16 10.19-23.67 1.27-1.13-.13-3.14-1.66-2.39-8.83 4.32-14.91 13.38-14.91 23.87 0 5.53 1.69 10.66 4.57 14.91L49.3 80.34a3.317 3.317 0 0 0 2.88 1.86Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.3 80.34a3.32 3.32 0 0 0 2.96 1.87c1.29-.01 2.41-.76 2.96-1.87l19.13-29.83c2.88-4.25 4.57-9.38 4.57-14.91C78.92 20.91 67 9 52.3 9S25.68 20.91 25.68 35.6c0 5.52 1.69 10.66 4.57 14.91l19.07 29.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.72 35.62c0 6.3-5.11 11.41-11.41 11.41S40.9 41.92 40.9 35.62s5.11-11.41 11.41-11.41 11.41 5.11 11.41 11.41Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarker104 = (MapMarker104);
;// ./src/Picto/GeneratedPictoComponents/MapMarker56.tsx


var MapMarker56_excluded = ["className"];
function MapMarker56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MapMarker56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MapMarker56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MapMarker56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MapMarker56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MapMarker56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MapMarker56_objectSpread(MapMarker56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "27.42",
      cy: "46.33",
      rx: "9.42",
      ry: "1.68",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.09 41.07c-4.56.99-7.62 2.82-7.62 4.91 0 3.15 6.96 5.71 15.55 5.71s15.55-2.56 15.55-5.71c0-2.09-3.46-4.02-8.01-5.01"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.38 29.98c-1.59-2.65-2.52-5.84-2.52-9.27 0-5.47 2.35-10.31 5.96-13.33.65-.54 0-1.58-.78-1.24-5.12 2.27-8.7 7.39-8.7 13.36 0 3.04.93 5.86 2.52 8.2l10.49 16.41c.29.6.89 1 1.59 1.02l-8.56-15.15Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.36 44.1c.3.61.92 1.02 1.63 1.03.71 0 1.33-.42 1.63-1.03l10.52-16.41c1.59-2.34 2.51-5.16 2.51-8.2 0-8.08-6.55-14.63-14.64-14.63s-14.64 6.55-14.64 14.63c0 3.04.93 5.86 2.52 8.2L26.38 44.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.29 19.51c0 3.46-2.81 6.28-6.28 6.28s-6.28-2.81-6.28-6.28 2.81-6.28 6.28-6.28 6.28 2.81 6.28 6.28Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MapMarker56 = (MapMarker56);
;// ./src/Picto/GeneratedPictoComponents/Cyclone104.tsx


var Cyclone104_excluded = ["className"];
function Cyclone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cyclone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cyclone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cyclone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cyclone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cyclone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cyclone104_objectSpread(Cyclone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M50.35 56.23c-3.01-1.5-4.21-3.82-4.01-7.77.07-2.18-1.12-2.43-1.4-2.48-.89-.07-1.75.6-2.06 1.6-1 3.06-1.05 5.71-.09 7.8 1.26 2.81 2.86 3.97 4.34 4.45.72.22 1.47.33 2.23.31.89.11 1.78-.58 2.07-1.59.18-1.02-.27-1.97-1.08-2.31Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "50.88",
      r: "9.67",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.73 90.49c-1.79-.08-3.58-.31-5.34-.69-14.85-3.25-24.63-16.49-23.24-31.49.07-.76.79-1.33 1.64-1.26.84.07 1.46.75 1.38 1.51-1.26 13.61 7.53 25.61 20.9 28.53 2.08.46 4.22.67 6.34.64.87-.02 1.53.6 1.55 1.37.02.77-.65 1.4-1.48 1.41-.59 0-1.17 0-1.75-.03ZM14.18 41.76c-.28.03-.56 0-.83-.11-.71-.29-.99-1.03-.61-1.64 1.07-1.75 2.39-3.4 3.93-4.89 9.84-9.55 26.53-11.41 39.69-4.42.67.36.85 1.12.4 1.7-.45.58-1.36.76-2.03.41-11.94-6.34-27.03-4.7-35.89 3.89a22.65 22.65 0 0 0-3.52 4.37c-.24.39-.68.64-1.15.69Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.34 79.44c-.42 0-.83-.26-1.06-.73-.98-2.01-1.76-4.17-2.3-6.42-3.47-14.35 2.84-29.62 15-36.31.62-.34 1.35-.01 1.63.74.28.75 0 1.63-.61 1.97-11.04 6.07-16.78 19.85-13.66 32.76.49 2.01 1.18 3.94 2.06 5.74.35.71.15 1.62-.43 2.04-.2.14-.41.21-.63.21Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.36 14.57c2.37-.08 4.79.1 7.23.58 15.37 3.04 25.88 16.81 25.27 31.99M12.57 41.01c1.2-2.05 2.65-4 4.35-5.8 10.77-11.37 28.04-12.9 40.55-4.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.66 79.97c-1.3-1.98-2.4-4.15-3.26-6.48-5.38-14.71.93-30.85 14.22-38.21M63.33 89.77c-2.37.15-4.8.03-7.24-.38-15.45-2.6-26.34-16.08-26.16-31.27M91.31 59.04c-.97 2.17-2.2 4.26-3.69 6.24-9.47 12.47-26.47 15.87-39.84 8.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.84 24.08c1.21 2.04 2.2 4.26 2.94 6.62 4.68 14.95-2.4 30.77-16.02 37.49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cyclone104 = (Cyclone104);
;// ./src/Picto/GeneratedPictoComponents/Cyclone56.tsx


var Cyclone56_excluded = ["className"];
function Cyclone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Cyclone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Cyclone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Cyclone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Cyclone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Cyclone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Cyclone56_objectSpread(Cyclone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.16 30.45c-1.57-.78-2.19-1.99-2.09-4.05.04-1.14-.58-1.27-.73-1.29-.46-.04-.91.31-1.07.83-.52 1.6-.54 2.98-.05 4.06.66 1.46 1.49 2.07 2.26 2.32.37.12.77.17 1.16.16.46.05.93-.3 1.08-.83.09-.53-.14-1.03-.56-1.2Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28.02",
      cy: "27.67",
      r: "5.04",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.05 48.3c-.93-.04-1.87-.16-2.78-.36-7.74-1.69-12.83-8.59-12.1-16.4.04-.4.41-.69.85-.65.43.04.76.39.72.79-.66 7.09 3.92 13.34 10.88 14.86 1.09.24 2.2.35 3.3.33.45-.01.8.31.81.71 0 .4-.34.73-.77.73-.3 0-.61 0-.91-.01ZM8.32 22.91c-.14.02-.29 0-.43-.06-.37-.15-.52-.54-.32-.86.56-.91 1.25-1.77 2.05-2.55 5.13-4.97 13.82-5.94 20.67-2.3.35.19.44.58.21.88-.23.3-.71.4-1.06.21-6.22-3.3-14.08-2.45-18.69 2.03-.72.7-1.33 1.46-1.83 2.28-.12.2-.35.33-.6.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.09 42.54c-.22 0-.43-.14-.55-.38-.51-1.05-.92-2.17-1.2-3.34-1.81-7.48 1.48-15.43 7.81-18.91.32-.18.7 0 .85.38.15.39 0 .85-.32 1.03-5.75 3.16-8.74 10.34-7.11 17.07.25 1.05.61 2.05 1.07 2.99.18.37.08.84-.23 1.06-.1.07-.22.11-.33.11Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23 8.75c1.24-.04 2.5.05 3.76.3 8 1.58 13.48 8.76 13.17 16.66M7.48 22.53a16.24 16.24 0 0 1 2.27-3.02c5.61-5.92 14.6-6.72 21.12-2.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.26 42.82c-.68-1.03-1.25-2.16-1.7-3.37-2.8-7.66.49-16.07 7.41-19.9M33.92 47.92c-1.23.08-2.5.02-3.77-.2-8.05-1.36-13.72-8.38-13.63-16.29M48.5 31.91c-.5 1.13-1.14 2.22-1.92 3.25-4.94 6.5-13.79 8.27-20.75 4.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.52 13.7c.63 1.06 1.15 2.22 1.53 3.45 2.44 7.79-1.25 16.03-8.34 19.53"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Cyclone56 = (Cyclone56);
;// ./src/Picto/GeneratedPictoComponents/CycloneandStorms104.tsx


var CycloneandStorms104_excluded = ["className"];
function CycloneandStorms104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CycloneandStorms104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CycloneandStorms104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CycloneandStorms104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CycloneandStorms104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CycloneandStorms104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CycloneandStorms104_objectSpread(CycloneandStorms104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75 91.15a17.9 17.9 0 0 1-3.01-.34c-8.39-1.69-14.01-9.04-13.37-17.49.03-.43.43-.75.91-.72.47.03.83.41.79.84-.58 7.67 4.48 14.33 12.03 15.85 1.18.24 2.38.34 3.57.3.49-.02.87.32.89.76.02.43-.35.79-.82.81-.33.01-.66.01-.99 0ZM48.35 63.91c-.16.02-.32 0-.47-.06-.4-.16-.56-.58-.34-.93.6-.99 1.35-1.91 2.21-2.75 5.54-5.37 14.93-6.42 22.33-2.49.38.2.48.63.22.96-.25.33-.76.43-1.14.23-6.72-3.57-15.21-2.64-20.19 2.19-.78.75-1.44 1.58-1.98 2.46-.13.22-.38.36-.64.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.09 85.32c-.24 0-.47-.15-.6-.41-.55-1.13-.99-2.35-1.3-3.61-1.95-8.08 1.6-16.67 8.44-20.43.35-.19.76 0 .92.42.16.42 0 .92-.34 1.11-6.21 3.41-9.44 11.16-7.68 18.43.27 1.13.66 2.22 1.16 3.23.2.4.09.91-.24 1.15-.11.08-.23.12-.35.12Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.66 48.4c1.34-.05 2.7.06 4.07.33 8.65 1.71 14.56 9.46 14.22 18M47.9 63.27c.67-1.15 1.49-2.25 2.45-3.26 6.06-6.4 15.77-7.26 22.81-2.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.14 85.19c-.73-1.12-1.35-2.33-1.83-3.64-3.03-8.28.52-17.36 8-21.5M76.46 90.7c-1.33.09-2.7.02-4.07-.21-8.69-1.46-14.82-9.05-14.72-17.59M92.2 73.41c-.54 1.22-1.24 2.4-2.08 3.51-5.33 7.02-14.89 8.93-22.41 4.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.75 53.74c.68 1.15 1.24 2.4 1.66 3.73 2.63 8.41-1.35 17.31-9.01 21.09"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.63 60.47a2.25 2.25 0 0 0-1.96-1.83l-7.22-.51c-5.29-.02-10-3.38-11.74-8.38-1.74-5-.14-10.55 3.99-13.86 1.06-.8 1.77-1.99 1.97-3.3.29-2.36 1.14-6.09 3.73-7.86 2.6-2.11 5.77-3.39 9.1-3.68 1.97 0 2.44 1.18 5.43 1.69 3.32.59 6.33-4.05-.96-6.82a22.267 22.267 0 0 0-7.72-1.97c-4.55-.07-8.94 1.69-12.17 4.89a17.423 17.423 0 0 0-5.19 12.21v.96a16.518 16.518 0 0 0-8.23 18.62c1.86 7.36 8.5 12.5 16.09 12.46h12.67c1.4 0 2.45-1.26 2.2-2.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.42 32.86s-1.12 1.83.16 2.69c1.28.86 6.98 2.87 7.72 7.86.61 3.93 3.03 5.13 3.71 4.48.69-.65 1.16-4.84-3.16-9.22-2.38-2.5-5.25-4.48-8.43-5.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.6 23.13s.98 2.28 2.65 1.97c1.67-.31 8.77-3.66 13.15-.12 3.46 2.77 6.29 1.97 6.37.85.08-1.12-2.73-4.86-9.51-5.17-4.35-.09-8.67.75-12.66 2.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.86 71.26c-1.69-.84-2.37-2.15-2.26-4.37.04-1.23-.63-1.37-.79-1.4-.5-.04-.99.34-1.16.9-.56 1.72-.59 3.21-.05 4.39.71 1.58 1.61 2.23 2.44 2.5.4.13.83.18 1.26.17.5.06 1-.33 1.16-.9.1-.57-.15-1.11-.61-1.3Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.12 49.63c.73-7.86-4.75-14.94-12.54-16.19-.88-5.41-4.51-9.97-9.59-12.04a15.705 15.705 0 0 0-15.27 1.92 17.17 17.17 0 0 0-15.08-9.22 16.98 16.98 0 0 0-12.17 4.89 17.423 17.423 0 0 0-5.19 12.21v.96a16.518 16.518 0 0 0-8.23 18.62c1.86 7.36 8.5 12.5 16.09 12.46h14.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.64 25.81c-.88-2.81-2.45-5.27-4.48-7.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "70.09",
        cy: "68.82",
        r: "5.44",
        className: "strokeprimary"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CycloneandStorms104 = (CycloneandStorms104);
;// ./src/Picto/GeneratedPictoComponents/CycloneandStorms56.tsx


var CycloneandStorms56_excluded = ["className"];
function CycloneandStorms56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function CycloneandStorms56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? CycloneandStorms56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : CycloneandStorms56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function CycloneandStorms56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, CycloneandStorms56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", CycloneandStorms56_objectSpread(CycloneandStorms56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.88 48.21c-.52-.01-1.03-.07-1.54-.17-4.29-.86-7.17-4.63-6.85-8.96.02-.22.22-.39.47-.37.24.02.42.21.41.43-.3 3.93 2.29 7.34 6.16 8.12.6.12 1.22.17 1.83.15.25-.01.44.17.45.39 0 .22-.18.41-.42.41h-.51ZM26.37 34.13c-.08 0-.16 0-.24-.03-.21-.08-.28-.3-.18-.47.31-.5.69-.98 1.13-1.41 2.83-2.75 7.64-3.29 11.43-1.27.19.1.24.32.12.49-.13.17-.39.22-.58.12-3.44-1.83-7.79-1.35-10.34 1.12-.4.39-.74.81-1.01 1.26a.46.46 0 0 1-.33.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.06 44.99c-.12 0-.24-.08-.31-.21-.28-.58-.51-1.2-.66-1.85-1-4.13.82-8.53 4.32-10.46.18-.1.39 0 .47.21.08.22 0 .47-.18.57-3.18 1.75-4.83 5.72-3.93 9.44.14.58.34 1.14.59 1.65.1.2.04.47-.12.59-.06.04-.12.06-.18.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.51 26.22c.68-.02 1.38.03 2.08.17 4.43.87 7.46 4.84 7.28 9.22M25.93 33.84c.34-.59.76-1.15 1.25-1.67 3.1-3.28 8.08-3.72 11.68-1.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.12 45.06a9.042 9.042 0 0 1 3.16-12.88M40.55 47.89c-.68.04-1.38 0-2.09-.11a9.043 9.043 0 0 1-7.54-9.01M48.61 39.03c-.28.63-.63 1.23-1.06 1.8-2.73 3.59-7.63 4.57-11.48 2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.31 28.96c.35.59.63 1.23.85 1.91 1.35 4.31-.69 8.86-4.61 10.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.23 32.41c-.09-.5-.5-.88-1-.94l-3.7-.26a6.389 6.389 0 0 1-6.01-4.29c-.89-2.56-.07-5.4 2.04-7.09.55-.41.91-1.02 1.01-1.69.15-1.21.58-3.12 1.91-4.03a8.491 8.491 0 0 1 4.66-1.88c1.01 0 1.25.6 2.78.87 1.7.3 3.24-2.07-.49-3.49-1.25-.57-2.59-.91-3.96-1.01-2.33-.04-4.58.87-6.23 2.51a8.96 8.96 0 0 0-2.66 6.25v.49a8.438 8.438 0 0 0-4.21 9.53c.95 3.77 4.35 6.4 8.24 6.38h6.49c.72 0 1.26-.65 1.13-1.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.05 18.27s-.57.94.08 1.38c.65.44 3.57 1.47 3.96 4.03.31 2.01 1.55 2.63 1.9 2.29.35-.33.59-2.48-1.62-4.72a12.913 12.913 0 0 0-4.32-2.98Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.82 13.29s.5 1.17 1.36 1.01c.86-.16 4.49-1.87 6.73-.06 1.77 1.42 3.22 1.01 3.26.43.04-.57-1.4-2.49-4.87-2.65-2.23-.05-4.44.38-6.48 1.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.24 37.99c-.87-.43-1.21-1.1-1.16-2.24.02-.63-.32-.7-.4-.71-.26-.02-.51.17-.59.46-.29.88-.3 1.65-.03 2.25.36.81.83 1.14 1.25 1.28.21.06.42.09.64.09.26.03.51-.17.6-.46.05-.29-.08-.57-.31-.66Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.29",
        cy: "36.68",
        r: "2.79",
        className: "strokeprimary"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.55 26.85c.37-4.02-2.43-7.65-6.42-8.29-.45-2.77-2.31-5.11-4.91-6.17s-5.56-.69-7.82.98a8.788 8.788 0 0 0-7.72-4.72c-2.33-.03-4.57.87-6.23 2.51a8.96 8.96 0 0 0-2.66 6.25v.49a8.438 8.438 0 0 0-4.21 9.53c.95 3.77 4.35 6.4 8.24 6.38h7.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.87 14.66a8.48 8.48 0 0 0-2.3-3.68"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_CycloneandStorms56 = (CycloneandStorms56);
;// ./src/Picto/GeneratedPictoComponents/Earthquake104.tsx


var Earthquake104_excluded = ["className"];
function Earthquake104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Earthquake104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Earthquake104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Earthquake104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Earthquake104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Earthquake104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Earthquake104_objectSpread(Earthquake104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.51 38.45c-.15 4.98 7.33.87 6.14-1.96m.36 0c3.92 1.49 3.95-1.34 5.13-3.05 1.69-2.44 3.46-2.34 6.13-2.21 1.88-.23 3.56-2.58 1.94-4.21-.22-.23-.48-.19-.77-.33-.45-.22 2.04-.32 2.26-3.37.17-2.33-1.02-3.24-1.47-3.72 0 0-.68.12-.34-.52.3-.56 2.17.03 2.21-3.18.03-2.25-3.09-3.36-5.32-3.34-8.54.1-12.23 3.2-14.39 5.1-4.64 4.02-6.48 6.45-7.58 10.18-.52 1.8-.86 3.65-1.01 5.48 0 .02.52 6.6.52 6.63-.44 2.36 3.73 4.22 5.77 1.63",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.48 52.15c-6.21-2.16-10.84-7.86-11.3-14.83-.61-9.3 6.43-17.33 15.72-17.94s17.33 6.43 17.94 15.72c.47 7.11-3.54 13.49-9.62 16.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.5 44.92a9.712 9.712 0 0 1-5.17-7.95c-.35-5.35 3.7-9.97 9.04-10.32s9.97 3.7 10.32 9.04c.23 3.43-1.36 6.56-3.93 8.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.23 58.93c-8.76-3.04-15.29-11.08-15.94-20.91-.86-13.11 9.06-24.44 22.17-25.3 13.11-.86 24.44 9.06 25.3 22.17.66 10.03-5 19.02-13.56 23.07"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.54 65.12c-.07-.4-.36-.69-.71-.8 0-.37-.19-.73-.54-.91a.99.99 0 0 0-1.34.45l-5.23 10.43-15.83-.67c-.5-.02-1.02.4-1.04.96-.02.55.41 1.02.96 1.04l16.25.69h.04c.04 0 .07-.02.1-.02.04 0 .08.03.12.03.37 0 .72-.2.89-.55l3.82-7.61c.24-.47.94-.37 1.02.15l3.53 20.73c.09.5.52.86 1 .85.05 0 .1 0 .16-.01.54-.1.91-.63.81-1.18l-4.01-23.56Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.33 73.5h16.55L39.45 62l6.19 27.16 6.95-48.49 5.42 38.9 7.34-12.46 5.8 15.98 6.57-10.23h15.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.48 73.39c0 1.25-1.01 2.26-2.26 2.26s-2.26-1.01-2.26-2.26 1.01-2.26 2.26-2.26 2.26 1.01 2.26 2.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.99 38.12c0 1.41-1.14 2.55-2.55 2.55s-2.55-1.14-2.55-2.55 1.14-2.55 2.55-2.55 2.55 1.14 2.55 2.55Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Earthquake104 = (Earthquake104);
;// ./src/Picto/GeneratedPictoComponents/Earthquake56.tsx


var Earthquake56_excluded = ["className"];
function Earthquake56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Earthquake56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Earthquake56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Earthquake56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Earthquake56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Earthquake56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Earthquake56_objectSpread(Earthquake56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.59 21.8c-.08 2.56 3.77.45 3.16-1.01m.18.01c2.02.77 2.03-.69 2.64-1.57.87-1.25 1.78-1.2 3.15-1.14.97-.12 1.83-1.33 1-2.16-.12-.12-.25-.1-.4-.17-.23-.11 1.05-.16 1.16-1.73.09-1.2-.52-1.67-.75-1.91 0 0-.35.06-.17-.27.15-.29 1.11.01 1.14-1.64.02-1.16-1.59-1.73-2.74-1.72-4.39.05-6.29 1.65-7.4 2.62-2.39 2.07-3.33 3.32-3.9 5.24-.27.93-.44 1.88-.52 2.82l.27 3.41c-.23 1.21 1.92 2.17 2.97.84",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.23 28.85a8.694 8.694 0 0 1-5.82-7.63c-.32-4.78 3.31-8.92 8.09-9.23 4.78-.32 8.92 3.31 9.23 8.09a8.68 8.68 0 0 1-4.95 8.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.76 25.14a4.992 4.992 0 1 1 7.3-4.75c.12 1.76-.7 3.37-2.02 4.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.07 32.34c-4.5-1.56-7.87-5.7-8.2-10.76-.44-6.74 4.66-12.57 11.41-13.02s12.57 4.66 13.02 11.41c.34 5.16-2.57 9.78-6.98 11.87"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.18 35.52a.52.52 0 0 0-.37-.41c0-.19-.1-.38-.28-.47a.517.517 0 0 0-.69.23l-2.69 5.37-8.14-.34c-.26 0-.52.21-.54.49-.01.28.21.52.49.54l8.36.35h.02c.02 0 .03 0 .05-.01.02 0 .04.01.06.01.19 0 .37-.1.46-.28l1.97-3.92c.12-.24.48-.19.53.08l1.82 10.66c.04.26.27.44.51.44h.08c.28-.05.47-.32.42-.61l-2.06-12.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.72 39.84h8.52l3.38-5.92 3.18 13.97 3.58-24.94 2.78 20.01 3.78-6.41 2.98 8.22 3.39-5.26h7.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.29 39.78a1.16 1.16 0 1 1-2.322-.002 1.16 1.16 0 0 1 2.322.002Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.61 21.63c0 .72-.59 1.31-1.31 1.31s-1.31-.59-1.31-1.31.59-1.31 1.31-1.31 1.31.59 1.31 1.31Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Earthquake56 = (Earthquake56);
;// ./src/Picto/GeneratedPictoComponents/Fire104.tsx


var Fire104_excluded = ["className"];
function Fire104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Fire104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Fire104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fire104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Fire104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Fire104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Fire104_objectSpread(Fire104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.39 53.78c-.55-.32-1.26-.15-1.61.38-5.97 9.21-12.5 25.02-3.43 33.6 1.72 1.63 4.01 2.55 6.35 2.94.21.03.42.07.63.09 5.62.7 12.62-.62 17.07-4.46.78-.67.09-1.95-.89-1.65-3.44 1.07-7.2 1.36-10.49.95h-.1c-3.35-.44-6.46-2.11-8.49-4.83-5.15-6.9-2.59-17.16 1.43-25.42.28-.58.08-1.28-.49-1.6Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.59 90.59c.21.03.42.07.63.09 8.41 1.04 19.9-2.4 21.37-12.08.05-.33.09-.67.11-1.01.29-3.97-2.86-6.61-6.57-9.69-5.47-4.54-8.86-16.29-7.26-23.63.49-2.26-1.5-1.08-2.5-.39-2.84 1.95-5.15 5.16-7.14 7.91-6.25 8.65-14.85 26.54-4.98 35.87 1.72 1.63 4.01 2.55 6.35 2.94Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.11 47.39c.73-.83 2.04.06 1.54 1.04-2.12 4.23-4.54 9.35-5.25 11.94-1.12 4.09-3.57 15.36-.81 21.62.66 1.49-.59 3.11-2.15 2.67-3.59-1.02-6.75-7.46-6.74-10.29 0-1.95.59-5.18 1.24-8.15.95-4.38 3.02-8.44 5.98-11.8l6.19-7.04Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.59 86.84a27.47 27.47 0 0 1-2.13-3.25C11.2 59.75 36.39 48.13 46.56 31.13c2.83-4.73 4.26-9.9 2.29-16.08-.46-1.43.86-2.91 2.29-2.48 6.19 1.87 16.36 14.49 15.04 43.64-.06 1.42 7.32-1.8 5.64-10.71-.41-2.17 10.35 9.35 11.51 17.99 0 .05.01.1.02.15.85 6.41.33 13.88-4.01 20.59",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Fire104 = (Fire104);
;// ./src/Picto/GeneratedPictoComponents/Fire56.tsx


var Fire56_excluded = ["className"];
function Fire56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Fire56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Fire56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Fire56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Fire56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Fire56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Fire56_objectSpread(Fire56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.7 28.94a.633.633 0 0 0-.84.2c-3.11 4.8-6.51 13.03-1.79 17.49.9.85 2.09 1.33 3.31 1.53.11.02.22.03.33.05 2.93.36 6.57-.32 8.89-2.32.4-.35.04-1.02-.46-.86-1.79.56-3.75.71-5.46.5h-.05c-1.74-.23-3.37-1.1-4.42-2.51-2.68-3.59-1.35-8.93.75-13.23.15-.3.04-.67-.25-.84Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.33 48.1c.11.02.22.03.33.05 4.38.54 10.36-1.25 11.12-6.29.03-.17.05-.35.06-.53.15-2.06-1.49-3.44-3.42-5.04-2.85-2.36-4.61-8.48-3.78-12.31.26-1.18-.78-.56-1.3-.2-1.48 1.01-2.68 2.68-3.72 4.12-3.25 4.5-7.73 13.82-2.6 18.68.9.85 2.09 1.33 3.31 1.53Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.83 25.61c.38-.43 1.06.03.8.54-1.1 2.2-2.37 4.87-2.73 6.21-.58 2.13-1.86 8-.42 11.26.34.78-.31 1.62-1.12 1.39-1.87-.53-3.51-3.88-3.51-5.36 0-1.01.31-2.7.65-4.24.5-2.28 1.57-4.39 3.11-6.14l3.22-3.66Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.91 46.15c-.42-.55-.79-1.11-1.11-1.69C6.9 32.05 20.01 26 25.31 17.15c1.47-2.46 2.22-5.15 1.19-8.37-.24-.75.45-1.52 1.19-1.29 3.22.97 8.52 7.54 7.83 22.72-.03.74 3.81-.94 2.94-5.57-.21-1.13 5.39 4.87 5.99 9.37 0 .03 0 .05.01.08.44 3.34.17 7.23-2.09 10.72",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Fire56 = (Fire56);
;// ./src/Picto/GeneratedPictoComponents/Floods104.tsx


var Floods104_excluded = ["className"];
function Floods104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Floods104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Floods104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Floods104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Floods104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Floods104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Floods104_objectSpread(Floods104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.16 76.68c1.65-1.54 3.67-2.45 5.86-2.45 2.34 0 4.49 1.04 6.19 2.78M25.64 77.59C24 79.11 21.99 80 19.83 80s-4.29-.95-5.96-2.55M51.16 76.68c-1.74 1.91-3.99 3.06-6.45 3.06s-4.61-1.1-6.34-2.93M76.82 77.21c-1.78 2.09-4.14 3.37-6.72 3.37s-5.1-1.36-6.89-3.56M25.64 77.59c1.78-2.1 4.14-3.38 6.73-3.38 2.25 0 4.33.96 6 2.59M77.05 76.9c1.65-1.54 3.67-2.45 5.86-2.45 2.34 0 4.49 1.04 6.19 2.78M50.24 87.78c-1.86 1.52-4.13 2.41-6.59 2.41s-4.87-.95-6.75-2.55M24.36 88.43c-1.86 1.52-4.13 2.41-6.59 2.41s-4.87-.95-6.75-2.55M79.17 86.87c-1.97 1.91-4.53 3.06-7.31 3.06s-5.23-1.1-7.18-2.93M24.42 88.36c1.88-1.58 4.2-2.52 6.71-2.52 2.11 0 4.08.66 5.77 1.8M50.24 87.78c2.01-2.1 4.69-3.38 7.63-3.38 2.55 0 4.91.96 6.8 2.59M79.17 86.87c1.87-1.54 4.16-2.45 6.64-2.45 2.65 0 5.08 1.04 7.01 2.78"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.51 72.97-.32-12.57c-.03-1.3 1.08-2.37 2.48-2.4l5.59-.11-.57.4c-.99.69-1.5 1.4-1.54 2.1L48.56 73c-.06 1.23-1.14 2.21-2.47 2.24-1.4.04-2.56-.98-2.59-2.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.48 15.2c.92-.83 2.3-.86 3.25-.09l.18.16 35.71 35.31c.97.96.98 2.52 0 3.49-.91.91-2.35.97-3.32.18l-.19-.17-34.02-33.65-35.41 32.21c-.95.86-2.39.86-3.33.02l-.18-.18c-.87-.94-.86-2.37-.02-3.31l.18-.18L51.48 15.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.55 74.14.13-26.01M82.3 49.36l-.37 22.28M27.35 37.11l.33-15.67 8.61.17-.15 7.56-8.79 7.94zM43.63 74.77V57.4l16.04-.2.01 13.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.48 15.2c.92-.83 2.3-.86 3.25-.09l.18.16 35.71 35.31c.97.96.98 2.52 0 3.49-.91.91-2.35.97-3.32.18l-.19-.17-34.02-33.65-35.41 32.21c-.95.86-2.39.86-3.33.02l-.18-.18c-.87-.94-.86-2.37-.02-3.31l.18-.18L51.48 15.2Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Floods104 = (Floods104);
;// ./src/Picto/GeneratedPictoComponents/Floods56.tsx


var Floods56_excluded = ["className"];
function Floods56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Floods56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Floods56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Floods56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Floods56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Floods56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Floods56_objectSpread(Floods56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.51 40.63c.86-.81 1.91-1.28 3.06-1.28 1.22 0 2.34.54 3.23 1.45M14.19 41.1c-.85.79-1.9 1.26-3.03 1.26s-2.24-.49-3.11-1.33M27.51 40.63c-.91.99-2.08 1.59-3.37 1.59s-2.41-.57-3.31-1.53M40.9 40.9c-.93 1.09-2.16 1.76-3.51 1.76s-2.66-.71-3.59-1.86M14.19 41.1c.93-1.09 2.16-1.76 3.51-1.76 1.18 0 2.26.5 3.13 1.35M41.02 40.74c.86-.81 1.91-1.28 3.06-1.28 1.22 0 2.34.54 3.23 1.45M27.03 46.42c-.97.79-2.16 1.26-3.44 1.26s-2.54-.49-3.52-1.33M13.52 46.76c-.97.79-2.16 1.26-3.44 1.26s-2.54-.49-3.52-1.33M42.13 45.94c-1.03.99-2.36 1.59-3.82 1.59s-2.73-.57-3.75-1.53M13.56 46.72c.98-.83 2.19-1.31 3.5-1.31 1.1 0 2.13.34 3.01.94M27.03 46.42c1.05-1.09 2.45-1.76 3.98-1.76 1.33 0 2.56.5 3.55 1.35M42.13 45.94c.97-.81 2.17-1.28 3.46-1.28 1.38 0 2.65.54 3.66 1.45"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.52 38.69-.17-6.56c-.02-.68.56-1.24 1.3-1.25l2.92-.06-.3.21c-.51.36-.78.73-.8 1.1l-.31 6.58c-.03.64-.59 1.15-1.29 1.17-.73.02-1.33-.51-1.35-1.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.68 8.55c.48-.44 1.2-.45 1.69-.05l.1.09L48.1 27.01c.51.5.51 1.32 0 1.82a1.3 1.3 0 0 1-1.73.09l-.1-.09-17.76-17.56-18.47 16.81a1.3 1.3 0 0 1-1.74.01L8.21 28c-.45-.49-.45-1.24-.01-1.73l.09-.09L27.68 8.55Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.58 39.3.07-13.57M43.76 26.37 43.56 38M15.08 19.98l.17-8.18 4.5.09-.08 3.95-4.59 4.14zM23.58 39.63v-9.06l8.37-.11.01 6.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.68 8.55c.48-.44 1.2-.45 1.69-.05l.1.09L48.1 27.01c.51.5.51 1.32 0 1.82a1.3 1.3 0 0 1-1.73.09l-.1-.09-17.76-17.56-18.47 16.81a1.3 1.3 0 0 1-1.74.01L8.21 28c-.45-.49-.45-1.24-.01-1.73l.09-.09L27.68 8.55Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Floods56 = (Floods56);
;// ./src/Picto/GeneratedPictoComponents/Storm104.tsx


var Storm104_excluded = ["className"];
function Storm104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Storm104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Storm104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Storm104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Storm104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Storm104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Storm104_objectSpread(Storm104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m57.64 49.91-5.55 18.03c-.24.87.41 1.74 1.31 1.74l6.64-.03c.9 0 1.56.86 1.32 1.73l-4.28 16.74c-.09.35-.61.27-.59-.09l.65-16.29-6.16.14c-1.8.04-3.11-1.69-2.6-3.41l5.91-18.37 3.36-.18Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m66.85 50.91-4.52 12.98h6.06c.85 0 1.35 1.22.84 2.08L57.26 89.42c-.65 1.11-2.05.39-1.88-.98l1.67-15.96a.93.93 0 0 0-.93-1.03h-6.78c-.73 0-1.24-.93-.97-1.79l6.07-19.77c.16-.51.54-.84.97-.84h10.47c.75 0 1.26.97.96 1.84Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.81 60.37c-7.42-1.1-13.3-5.18-14.9-9.57-1.78-4.87-.14-10.28 4.09-13.5 1.09-.78 1.82-1.93 2.02-3.22.3-2.3 1.17-5.94 3.83-7.66 2.66-2.06 5.91-3.3 9.33-3.58 2.02 0 3.71.75 5.56 1.65 3.41.57 6.49-3.94-.99-6.64-2.5-1.09-5.18-1.74-7.92-1.91-4.66-.07-9.16 1.65-12.47 4.77-3.35 3.14-5.26 7.42-5.32 11.89v.94C13.17 37.02 9.69 44.5 11.6 51.67c1.79 6.72 7.88 11.54 15.05 12.09.73.06 9.01-.06 13.32-.23.83-.03 1.22-1.01.71-1.66s-1.16-1.09-3.87-1.5Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.02 34.34s-1.15 1.78.16 2.62c1.31.84 7.15 2.8 7.92 7.66.62 3.83 3.1 5 3.81 4.37.71-.63 1.19-4.71-3.24-8.98a25.637 25.637 0 0 0-8.64-5.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.54 24.86s1.01 2.22 2.72 1.91c1.71-.31 8.99-3.56 13.48-.11 3.55 2.7 6.45 1.91 6.53.82.08-1.09-2.8-4.73-9.75-5.04-4.46-.09-8.88.73-12.98 2.41Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.34 63.92c8.09.2 14.95-5.6 15.7-13.25s-4.87-14.55-12.86-15.78c-.9-5.27-4.63-9.71-9.83-11.73s-11.14-1.31-15.66 1.87c-3.01-5.48-8.95-8.93-15.46-8.98-4.66-.07-9.16 1.65-12.47 4.77-3.35 3.14-5.26 7.42-5.32 11.89v.94C13.57 37.13 10.09 44.61 12 51.78c1.91 7.17 8.72 12.18 16.5 12.14h14.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.64 27.46c-.9-2.74-2.51-5.13-4.6-7.01"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Storm104 = (Storm104);
;// ./src/Picto/GeneratedPictoComponents/Storm56.tsx


var Storm56_excluded = ["className"];
function Storm56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Storm56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Storm56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Storm56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Storm56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Storm56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Storm56_objectSpread(Storm56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.18 26.72-2.9 9.43c-.13.46.21.91.68.91l3.47-.02c.47 0 .81.45.69.91l-2.24 8.76c-.05.18-.32.14-.31-.05l.34-8.52-3.22.07a1.39 1.39 0 0 1-1.36-1.79l3.09-9.61 1.76-.09Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m36 27.25-2.36 6.79h3.17c.45 0 .7.64.44 1.09L30.99 47.4c-.34.58-1.07.2-.98-.51l.88-8.35a.49.49 0 0 0-.48-.54h-3.55c-.38 0-.65-.48-.51-.93l3.18-10.34c.08-.26.28-.44.51-.44h5.47c.39 0 .66.51.5.96Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.29 32.19c-3.88-.58-6.96-2.71-7.8-5-.93-2.55-.08-5.38 2.14-7.06.57-.41.95-1.01 1.05-1.68.16-1.2.61-3.11 2-4.01a9.109 9.109 0 0 1 4.88-1.87c1.05 0 1.94.39 2.91.86 1.78.3 3.39-2.06-.52-3.48-1.31-.57-2.71-.91-4.14-1-2.44-.04-4.79.86-6.53 2.49-1.75 1.64-2.75 3.88-2.78 6.22v.49c-3.59 1.82-5.41 5.74-4.41 9.49.94 3.52 4.12 6.04 7.87 6.32.38.03 4.71-.03 6.97-.12.44-.02.64-.53.37-.87s-.61-.57-2.02-.78Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.37 18.58s-.6.93.08 1.37c.69.44 3.74 1.46 4.14 4.01.33 2 1.62 2.61 1.99 2.28.37-.33.62-2.46-1.7-4.7a13.582 13.582 0 0 0-4.52-2.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.51 13.62s.53 1.16 1.42 1c.9-.16 4.7-1.86 7.05-.06 1.86 1.41 3.37 1 3.42.43.04-.57-1.47-2.47-5.1-2.63-2.33-.05-4.65.38-6.79 1.26Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.96 34.05c4.23.1 7.82-2.93 8.21-6.93.39-4-2.55-7.61-6.73-8.25-.47-2.76-2.42-5.08-5.14-6.14s-5.83-.68-8.19.98c-1.57-2.87-4.68-4.67-8.09-4.7-2.44-.03-4.79.86-6.53 2.49-1.75 1.64-2.75 3.88-2.78 6.22v.49C8.12 20.03 6.3 23.95 7.3 27.7s4.56 6.37 8.63 6.35h7.66"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.61 14.98a8.58 8.58 0 0 0-2.4-3.67"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Storm56 = (Storm56);
;// ./src/Picto/GeneratedPictoComponents/Placeholder104.tsx


var Placeholder104_excluded = ["className"];
function Placeholder104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Placeholder104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Placeholder104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Placeholder104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Placeholder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Placeholder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Placeholder104_objectSpread(Placeholder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.31 60.15c-7.48-3.39-4.66-12.12-4.66-12.12-7.56 7.49-4.48 14.2 4.66 12.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.39 38.08 34.22.44c-15.7-9.54-17.36-15.97-17.36-15.97s-6.91 2.79-26.47 6.27c-16.79 2.99-1.42 26.37.29 36.56l-.29-19.66c0-4.97 4.24-7.63 9.61-7.63ZM72.75 90.16c-18.95-4.55-1.73-33.74-1.73-33.74-5.63.49-24.44 29.32-25.54 32.47l27.26 1.27Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.82 90.16c-14.31-3.44-1.3-25.47-1.3-25.47-4.25.37-18.45 22.14-19.28 24.52l20.58.96Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m24 89.41 17.55-22.77c1.61-2.28 5-2.28 6.61 0l7.12 8.03",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.25",
        cy: "54.28",
        r: "7.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.96 72.05-8.78-35.37a6.076 6.076 0 0 1 4.43-7.36l61.04-15.16a6.076 6.076 0 0 1 7.36 4.43l5.01 20.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18.96",
        y: "38.8",
        width: "75.04",
        height: "50.61",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.85 89.41 67.2 57.84c1.61-2.28 5-2.28 6.61 0l20.2 28.57"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Placeholder104 = (Placeholder104);
;// ./src/Picto/GeneratedPictoComponents/Placeholder56.tsx


var Placeholder56_excluded = ["className"];
function Placeholder56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Placeholder56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Placeholder56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Placeholder56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Placeholder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Placeholder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Placeholder56_objectSpread(Placeholder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.78 32.27c-3.92-1.78-2.44-6.35-2.44-6.35-3.96 3.92-2.35 7.44 2.44 6.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.11 20.71 17.92.23c-8.22-5-9.09-8.37-9.09-8.37s-3.62 1.46-13.86 3.29c-8.79 1.57-.74 13.81.15 19.15l-.15-10.3c0-2.6 2.22-4 5.03-4ZM38.87 47.99c-9.93-2.39-.9-17.67-.9-17.67-2.95.26-12.8 15.36-13.38 17.01l14.28.66Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.75 47.99c-7.38-1.77-.67-13.14-.67-13.14-2.19.19-9.52 11.42-9.94 12.64l10.62.49Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m13.33 47.6 9.2-11.93c.85-1.19 2.62-1.19 3.46 0l3.73 4.21",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "18.7",
        cy: "29.19",
        r: "3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.7 38.5 6.1 19.97a3.18 3.18 0 0 1 2.32-3.85l31.97-7.94a3.18 3.18 0 0 1 3.85 2.32l2.63 10.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.7",
        y: "21.09",
        width: "39.3",
        height: "26.51",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.25 47.6 11.71-16.54c.85-1.19 2.62-1.19 3.46 0l10.33 14.59"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Placeholder56 = (Placeholder56);
;// ./src/Picto/GeneratedPictoComponents/Accessories104.tsx


var Accessories104_excluded = ["className"];
function Accessories104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Accessories104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Accessories104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Accessories104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Accessories104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Accessories104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Accessories104_objectSpread(Accessories104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.93 52.1s5.01.38 6.19-.81l-.28-1.57s-4.27 1.41-6.3.01l.39 2.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.9 40.67s1.49 6.15 11.37 7.63c0 0-3.9 4.07-9.11.79 0 0-4.16-2.41-2.26-8.42Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.52 37.38-.01-5.42 6.96-.01.01 5.4M39.54 49.42l.01 5.4 6.96-.01-.01-5.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.01",
        cy: "43.39",
        r: "6.96"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.61 35.18c.07-.35 1.95.39 2.08.48 1.64 1.04 2.04 3.39 1.75 5.16-.7 4.21-1.69 8.89-1.1 13.16.24 1.75.96 2.73 2.36 3.69.97.67 2.43 1.47 2.13 2.88l-12.32-.81s5.08-24.47 5.1-24.56ZM52.4 61.15l-.38 29.55h8.56s5.44-13.55 22.98-13.17v-4.86H56.55L52.4 61.15ZM19.26 75.85h26.53c.71 0 1.33-.32 1.5-.77l.81-2.19H19.26v2.96ZM21.12 39.63c.5 1.09 2.97 5.38 5.34 3.83l1.15 7.26s-2.82 3.53-4.86-.82l-1.63-10.27ZM13.93 34.45s3.32 2.89 6.15 1.4l.35 2.2s-1.96 2.65-4.74.75c0 0-2.19-1.87-1.76-4.35ZM29.89 25.74c.2 1.21 1.83 3.01 4.58 2.12l-.82 7.48s-3.74 2.73-4.58-2.12l.82-7.48ZM34.82 17.86s3.74 3.18 6.88 1.48l.42 2.45s-2.15 2.98-5.28.9c0 0-2.47-2.05-2.02-4.83Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "64.29",
        y: "24.39",
        width: "10.99",
        height: "11.68",
        rx: "1.38",
        ry: "1.38",
        transform: "rotate(12.18 69.818 30.232)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.11 60.13-7.1 12.54h34.5l4.52-12.54H20.11zM83.9 60.13l7.09 12.54H56.55l-4.52-12.54H83.9z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 60.11V90.7h31.87V72.89M51.93 60.11V90.7H20.06V72.89M54.24 59.93l8.52-39.22c.22-1 1.21-1.64 2.21-1.42l22.35 4.87a1.86 1.86 0 0 1 1.42 2.23l-7.58 33.56-26.92-.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "21.51",
        y: "29.17",
        width: "4.98",
        height: "22.98",
        rx: "2.49",
        ry: "2.49",
        transform: "rotate(-9 23.97 40.625)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.42 30.19c1.17 0 2.12.95 2.12 2.12v5.95c0 .91-.74 1.64-1.64 1.64h-.48c-2.68 0-4.86-2.18-4.86-4.86s2.18-4.86 4.86-4.86Z",
        transform: "rotate(-9 17.06 35.03)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.83",
        y: "13.2",
        width: "5.03",
        height: "22.98",
        rx: "2.52",
        ry: "2.52",
        transform: "rotate(-173.74 32.338 24.69)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.45 13.9h.38c.91 0 1.64.74 1.64 1.64v6.43c0 .91-.74 1.64-1.64 1.64h-.38c-2.68 0-4.86-2.18-4.86-4.86s2.18-4.86 4.86-4.86Z",
        transform: "rotate(-173.74 39.034 18.753)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Accessories104 = (Accessories104);
;// ./src/Picto/GeneratedPictoComponents/Accessories56.tsx


var Accessories56_excluded = ["className"];
function Accessories56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Accessories56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Accessories56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Accessories56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Accessories56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Accessories56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Accessories56_objectSpread(Accessories56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.5 28.06s2.7.21 3.33-.44l-.15-.84s-2.3.76-3.39 0l.21 1.27Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.87 21.9s.8 3.31 6.12 4.11c0 0-2.1 2.19-4.91.42 0 0-2.24-1.3-1.22-4.53Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.28 20.13v-2.92l3.74-.01.01 2.91M21.29 26.61l.01 2.91 3.74-.01v-2.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.16",
        cy: "23.36",
        r: "3.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.1 18.94c.04-.19 1.05.21 1.12.26.88.56 1.1 1.82.94 2.78-.38 2.27-.91 4.78-.59 7.09.13.94.52 1.47 1.27 1.99.52.36 1.31.79 1.15 1.55l-6.63-.44 2.74-13.23ZM28.21 32.93 28 48.84h4.61s2.93-7.3 12.37-7.09v-2.62H30.44l-2.24-6.2ZM10.37 40.84h14.29c.38 0 .72-.17.81-.42l.44-1.18H10.38v1.59ZM11.63 22.3c.21.46 1.25 2.25 2.24 1.61l.48 3.04s-1.18 1.48-2.04-.34l-.68-4.3ZM7.66 18.48s1.56 1.36 2.88.66l.16 1.03s-.92 1.24-2.22.35c0 0-1.03-.88-.82-2.04ZM16.63 14.7c.08.5.75 1.23 1.88.87l-.34 3.06s-1.53 1.12-1.87-.87l.34-3.06ZM19.27 10.14s1.69 1.32 3.15.58l.18 1.03s-1.01 1.27-2.43.41c0 0-1.12-.85-.9-2.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "34.98",
        y: "13.52",
        width: "5.18",
        height: "5.5",
        rx: "1",
        ry: "1",
        transform: "rotate(12.18 37.569 16.278)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.83 32.38-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.38l3.81 6.75H30.45l-2.43-6.75h17.16zM29.2 32.27l4.59-21.12c.12-.54.65-.88 1.19-.77L47.01 13c.54.12.89.66.76 1.2l-4.08 18.07H29.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.99 32.37v16.47h17.16v-9.59M27.96 32.37v16.47H10.8v-9.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.42",
        y: "7.44",
        width: "2.46",
        height: "11.26",
        rx: "1.23",
        ry: "1.23",
        transform: "rotate(-173.74 17.65 13.067)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.4 7.72c.81 0 1.47.66 1.47 1.47v1.82c0 .81-.66 1.47-1.47 1.47-1.2 0-2.17-.97-2.17-2.17v-.42c0-1.2.97-2.17 2.17-2.17Z",
        transform: "rotate(-173.74 21.049 10.103)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11.34",
        y: "16.27",
        width: "2.46",
        height: "11.26",
        rx: "1.23",
        ry: "1.23",
        transform: "rotate(-6.26 12.56 21.872)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.52 16.55c.81 0 1.47.66 1.47 1.47v1.82c0 .81-.66 1.47-1.47 1.47-1.2 0-2.17-.97-2.17-2.17v-.42c0-1.2.97-2.17 2.17-2.17Z",
        transform: "rotate(-6.26 9.144 18.934)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Accessories56 = (Accessories56);
;// ./src/Picto/GeneratedPictoComponents/BroadbandHome104.tsx


var BroadbandHome104_excluded = ["className"];
function BroadbandHome104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandHome104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandHome104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandHome104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandHome104_objectSpread(BroadbandHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34 21.45c0-.78.84-1.26 1.52-.86 5.04 2.95 6.03 10.52 6.4 15.75.53 7.31-.53 14.63-.04 21.94.42 6.34 1.04 17.39 8.71 19.39 7.41 1.93 20.9 2.19 19.28 13.57-.15 1.02-1.07 2.75-2.29 2.75H37.36c-1.82 0-3.31-1.2-3.36-3.06-.01-.44 0-.88 0-1.32V21.44Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.45 28.83c3.5 5.15 5.55 11.34 5.55 18s-2.05 12.85-5.55 18M82 33.07c2.67 3.94 4.24 8.67 4.24 13.76S84.67 56.66 82 60.6M15.55 64.83c-3.5-5.15-5.55-11.34-5.55-18 0-6.67 2.05-12.85 5.55-18M22 60.6c-2.67-3.94-4.24-8.67-4.24-13.76s1.57-9.83 4.24-13.77"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "34",
        y: "10",
        width: "36",
        height: "84",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47 85h10"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandHome104 = (BroadbandHome104);
;// ./src/Picto/GeneratedPictoComponents/BroadbandHome56.tsx


var BroadbandHome56_excluded = ["className"];
function BroadbandHome56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandHome56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandHome56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandHome56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandHome56_objectSpread(BroadbandHome56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.76 12.74c0-.4.43-.65.78-.44 2.59 1.52 3.1 5.4 3.29 8.09.27 3.75-.27 7.51-.02 11.27.22 3.25.53 8.93 4.48 9.96 3.81.99 10.74 1.13 9.9 6.97-.07.52-.55 1.41-1.17 1.41H20.5c-.93 0-1.7-.62-1.73-1.57V12.74Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.66 16.14a16.365 16.365 0 0 1 0 18.43M43.36 18.31c1.37 2.02 2.17 4.44 2.17 7.04s-.8 5.03-2.17 7.05M9.34 34.57a16.365 16.365 0 0 1 0-18.43M12.64 32.4c-1.37-2.02-2.17-4.44-2.17-7.04s.8-5.03 2.17-7.05"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18.79",
        y: "6.5",
        width: "18.43",
        height: "43",
        rx: "1",
        ry: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.44 44.89h5.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandHome56 = (BroadbandHome56);
;// ./src/Picto/GeneratedPictoComponents/BroadbandMobile104.tsx


var BroadbandMobile104_excluded = ["className"];
function BroadbandMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobile104_objectSpread(BroadbandMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M22.49 40.43s4.87 1.8 5.26 1.97c2.72 1.19 4.56 2.21 6.22 4.41 4.03 5.33 3.78 11.84 5.32 17.76.98 3.79 2.37 7.95 5.47 11.1 4.06 4.13 10.02 4.29 16.01 5.29 4.69.78 12.77 2.67 13.53 7.22H57.22c-9.23 0-18.45.16-27.69.04-1.77-.02-4.48-1.4-5.57-2.65-1.59-1.83-1.46-2.67-1.45-4.79.01-3.07.01-6.14.01-9.2V40.43Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.23 15.81c3-.3 6.04.29 8.73 1.9 2.69 1.61 4.65 4 5.82 6.78M77.24 19.67c2.29-.23 4.61.23 6.67 1.45 2.06 1.23 3.56 3.06 4.45 5.19M26.77 15.81c-3-.3-6.04.29-8.73 1.9-2.69 1.61-4.65 4-5.82 6.78M26.76 19.67c-2.29-.23-4.61.23-6.67 1.45-2.06 1.23-3.56 3.06-4.45 5.19"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "22.49",
        y: "28.75",
        width: "59.43",
        height: "59.43",
        rx: "8",
        ry: "8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.92",
        y: "41.75",
        width: "45.19",
        height: "24.14",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52.2",
        cy: "77.56",
        r: "2.47"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobile104 = (BroadbandMobile104);
;// ./src/Picto/GeneratedPictoComponents/BroadbandMobile56.tsx


var BroadbandMobile56_excluded = ["className"];
function BroadbandMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BroadbandMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BroadbandMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BroadbandMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BroadbandMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BroadbandMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BroadbandMobile56_objectSpread(BroadbandMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.11 21.77s2.62.97 2.83 1.06c1.47.64 2.45 1.19 3.35 2.37 2.17 2.87 2.04 6.38 2.86 9.56.53 2.04 1.28 4.28 2.94 5.98 2.18 2.22 5.4 2.31 8.62 2.85 2.52.42 6.87 1.44 7.28 3.89h-9.2c-4.97 0-9.94.08-14.91.02-.95-.01-2.41-.75-3-1.43-.86-.99-.79-1.44-.78-2.58V21.76Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.58 8.51c1.62-.16 3.25.16 4.7 1.02s2.51 2.15 3.13 3.65M41.59 10.59c1.23-.12 2.48.12 3.59.78s1.92 1.65 2.4 2.79M14.42 8.51c-1.62-.16-3.25.16-4.7 1.02s-2.51 2.15-3.13 3.65M14.41 10.59c-1.23-.12-2.48.12-3.59.78s-1.92 1.65-2.4 2.79"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "12.11",
        y: "15.48",
        width: "32",
        height: "32",
        rx: "5",
        ry: "5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.11",
        y: "22.48",
        width: "24.33",
        height: "13",
        rx: "1",
        ry: "1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.11",
        cy: "41.76",
        r: "1.33"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BroadbandMobile56 = (BroadbandMobile56);
;// ./src/Picto/GeneratedPictoComponents/Charger104.tsx


var Charger104_excluded = ["className"];
function Charger104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Charger104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Charger104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Charger104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Charger104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Charger104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Charger104_objectSpread(Charger104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.03 87.76c-12.52-2.68-27.98-10.8-35.55-28.66-6.41-15.13-4.87-22.72-6.66-25.37-.42-.62-1.39-.53-1.75.12-3.15 5.77-4.97 12.36-4.97 19.4 0 22.41 18.17 40.57 40.57 40.57 4.39 0 8.58-.73 12.53-2.02.72-.24.95-1.17.41-1.7-1-.97-2.48-1.9-4.58-2.34h-.01Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m93.33 34.85.19-.02-.02.04a5.298 5.298 0 0 1-2.97 2.43 5.47 5.47 0 0 1-6.92-3.44l4.23-1.39c.52.99 1.93 2.66 5.48 2.39Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M76.97 12.23h.02c-1.23-.09-2.57.07-3.17 1.06l-.1.19h.01s-.28 3.07 2.85 4.71l-2.11 5.14c-1.28-.65-3.04-2.75-3.47-4.12-.43-1.37-.29-2.84.39-4.11a5.498 5.498 0 0 1 5.6-2.88Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.46 14.53c-5.35-2.53-11.33-3.94-17.65-3.94C28.94 10.59 10.4 29.13 10.4 52s18.54 41.41 41.41 41.41S93.22 74.87 93.22 52c0-4.79-.81-9.38-2.3-13.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m80.1 11.84-6.03 12.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m79.79 22.47-3.9-1.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m71.16 14.57-4.18-1.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m82.19 17.62-3.53-1.71"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m70.53 16.02-4.18-1.85"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.44 22.4a5.26 5.26 0 0 1-2.64-3.1c-.42-1.35-.29-2.81.38-4.06 1.41-2.65 4.69-3.66 7.33-2.26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M93.86 31.29c.47 1.33.38 2.8-.25 4.07a5.257 5.257 0 0 1-3.07 2.67c-2.82.95-5.88-.58-6.84-3.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m95.56 29.27-14.27 4.79"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m46.83 44 .58.03s-1.16 4.87.61 7.62 8.16 1.63 8.16 1.63 4.3.05 1.24 4.03c-3.05 3.98-12.1 12.52-12.1 12.52l5.18-13.87H37.13l9.42-11.39",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.57 29.41 37.35 54.97c-.12.14-.02.35.16.35h12.7l-6.84 17.11c-.09.22.18.39.35.22l22.93-24.23c.13-.14.03-.36-.15-.36H52.93l6-18.45c.07-.22-.21-.38-.36-.2Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Charger104 = (Charger104);
;// ./src/Picto/GeneratedPictoComponents/Charger56.tsx


var Charger56_excluded = ["className"];
function Charger56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Charger56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Charger56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Charger56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Charger56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Charger56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Charger56_objectSpread(Charger56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m25.68 23.68.43-.29s-.58 2.61.3 4.08 4.05.87 4.05.87 2.13.03.62 2.16-6.37 6.7-6.37 6.7l2.93-7.42H21l4.68-6.1",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m31.12 17.71-10.1 12.17c-.06.07-.01.17.08.17h6.05l-3.26 8.14c-.04.1.09.19.17.1l10.92-11.53c.06-.07.02-.17-.07-.17h-6.46l2.86-8.78c.03-.1-.1-.18-.17-.09Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.98 46.25c-6.39-1.37-14.29-5.51-18.15-14.63-3.27-7.72-2.48-11.6-3.4-12.95-.21-.32-.71-.27-.89.06A20.55 20.55 0 0 0 6 28.63c0 11.44 9.28 20.71 20.71 20.71 2.24 0 4.38-.37 6.4-1.03.37-.12.49-.6.21-.87-.51-.5-1.27-.97-2.34-1.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.48 19.23h.1c-.33.59-.87 1.03-1.51 1.24-1.46.49-3.04-.3-3.54-1.76l2.16-.71c.26.5.99 1.36 2.8 1.22Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.13 7.69c-.63-.05-1.31.04-1.62.54l-.05.1s-.14 1.57 1.45 2.41l-1.08 2.62c-.65-.33-1.55-1.4-1.77-2.1a2.7 2.7 0 0 1 .2-2.1 2.821 2.821 0 0 1 2.86-1.47Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.51 8.64c-2.77-1.3-5.86-2.04-9.12-2.04-11.82 0-21.4 9.58-21.4 21.4s9.58 21.4 21.4 21.4 21.4-9.58 21.4-21.4c0-2.47-.42-4.85-1.19-7.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.01 7.25-3.11 6.51"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m41.85 12.74-2.02-.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.39 8.66-2.16-.95"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.09 10.24-1.83-.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.06 9.41-2.15-.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.57 12.71c-.65-.33-1.15-.91-1.36-1.6a2.7 2.7 0 0 1 .2-2.1 2.81 2.81 0 0 1 3.79-1.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.12 17.3c.24.69.2 1.45-.13 2.1s-.9 1.15-1.59 1.38c-1.46.49-3.04-.3-3.54-1.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m50 16.26-7.38 2.47"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Charger56 = (Charger56);
;// ./src/Picto/GeneratedPictoComponents/Devices104.tsx


var Devices104_excluded = ["className"];
function Devices104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Devices104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Devices104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Devices104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Devices104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Devices104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Devices104_objectSpread(Devices104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.48 91c1.19 0 1.62-1.58.58-2.16-2.47-1.38-6.04-3.61-10.95-7.18-11.42-8.3-13.49-20.76-14.53-33.21C22.54 36 23.58 31 18.4 31v51.27c0 6.7 1.01 8.73 8.72 8.73h21.37Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M78.72 90.75c-2.09-1.34-4.67-1.45-6.85-2.65-9.32-4.88-11.31-16.11-12.74-25.58-.41-2.33-.51-3.84-3.13-4.1v32.57h.09a5.303 5.303 0 0 0 5.09 3.9h19.93c.14-1.67-.97-3.24-2.38-4.14Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "56",
        y: "36",
        width: "32",
        height: "58",
        rx: "4",
        ry: "4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.5 40h3M68 90h8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "46",
      cy: "14",
      r: "1",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 91H22c-2.21 0-4-1.79-4-4V14c0-2.21 1.79-4 4-4h50c2.21 0 4 1.79 4 4v17M40 86h12"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Devices104 = (Devices104);
;// ./src/Picto/GeneratedPictoComponents/Devices56.tsx


var Devices56_excluded = ["className"];
function Devices56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Devices56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Devices56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Devices56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Devices56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Devices56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Devices56_objectSpread(Devices56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.14 47.8c-1.11-.71-2.48-.77-3.63-1.4-4.94-2.59-6-8.54-6.75-13.56-.22-1.25-.27-2.06-1.73-2.18v16.53c0 1.55 1.26 2.81 2.81 2.81H44.4c.07-.88-.51-1.72-1.26-2.2Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.34 48.95c.61 0 .83-.81.29-1.1-1.26-.7-3.08-1.84-5.59-3.67-5.83-4.24-6.89-10.6-7.42-16.96-.53-6.36 0-8.91-2.65-8.91V44.49c0 3.42.52 4.46 4.45 4.46h10.92Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.1",
        y: "20",
        width: "16",
        height: "30",
        rx: "2",
        ry: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.53 22h1M37.03 48h4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22 47h6M28 49H12.03c-1.1 0-2-.9-2-2V8c0-1.1.9-2 2-2h28c1.1 0 2 .9 2 2v9"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "26.03",
      cy: "8",
      r: ".5",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Devices56 = (Devices56);
;// ./src/Picto/GeneratedPictoComponents/ESIM104.tsx


var ESIM104_excluded = ["className"];
function ESIM104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ESIM104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ESIM104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ESIM104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ESIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ESIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ESIM104_objectSpread(ESIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.81 88.06c-2.83-1.81-6.32-1.96-9.26-3.58-12.6-6.6-15.29-21.78-17.23-34.59-.56-3.2-.69-5.26-4.4-5.56v43.99c0 3.96 1.35 5.34 5.31 5.34h28.8c.19-2.26-1.31-4.38-3.22-5.6Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.43 63.49v24.79c0 3.16-2.46 5.72-5.49 5.72H23.97c-3.03 0-5.49-2.56-5.49-5.72V15.82c0-3.16 2.46-5.72 5.49-5.72h32.96c3.03 0 5.49 2.56 5.49 5.72v5.72M38.62 13.91h3.67M34.96 90.19h10.99"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.25 44.54s-.02.1-.02.17c0 .26.06.49.17.69.12.2.27.37.46.51s.4.25.64.32.49.11.74.11c.47 0 .88-.09 1.23-.26s.67-.4.95-.7l1.86 1.45c-.59.62-1.24 1.07-1.97 1.35-.72.28-1.5.41-2.33.41-.64 0-1.23-.09-1.77-.27-.54-.18-1.02-.44-1.42-.79-.4-.35-.72-.78-.95-1.29-.23-.51-.35-1.1-.35-1.76 0-.78.14-1.52.41-2.19s.65-1.27 1.14-1.77c.48-.5 1.06-.9 1.74-1.18.67-.29 1.41-.43 2.22-.43.6 0 1.15.09 1.64.26.5.17.92.42 1.28.74.35.32.63.73.83 1.2.2.48.29 1.03.29 1.65a8.489 8.489 0 0 1-.23 1.79h-6.56Zm4.17-1.8c.01-.06.02-.12.02-.18v-.18c0-.4-.14-.74-.43-1.01s-.7-.4-1.24-.4c-.33 0-.63.06-.89.17-.26.12-.49.26-.69.43-.2.17-.36.36-.48.57-.12.21-.21.41-.26.61h3.97ZM57.56 38.7c-.27-.34-.62-.62-1.06-.82-.43-.2-.85-.3-1.26-.3-.21 0-.42.02-.63.06-.21.04-.41.11-.58.21-.17.1-.32.24-.43.4-.12.17-.17.38-.17.63 0 .22.05.4.14.55.09.15.23.28.4.39.18.11.39.21.63.3s.52.19.83.28c.44.15.9.31 1.38.49.48.18.91.41 1.3.71.39.29.72.66.97 1.09.26.43.39.98.39 1.63 0 .75-.14 1.39-.41 1.94-.28.54-.65.99-1.11 1.35-.47.36-1 .62-1.6.79-.6.17-1.22.26-1.86.26-.93 0-1.83-.16-2.7-.49-.87-.32-1.59-.79-2.17-1.39l2.06-2.09c.32.39.74.72 1.26.98s1.04.39 1.55.39c.23 0 .46-.02.68-.07.22-.05.41-.13.58-.24.17-.11.3-.26.39-.44.1-.18.15-.4.15-.66s-.06-.45-.18-.62c-.12-.17-.3-.33-.52-.47-.23-.14-.51-.27-.84-.39-.34-.12-.72-.24-1.15-.38-.42-.13-.82-.29-1.22-.48-.4-.18-.75-.42-1.07-.71-.31-.29-.56-.64-.75-1.05-.19-.41-.28-.91-.28-1.5 0-.72.15-1.34.44-1.85.29-.51.68-.94 1.16-1.27.48-.33 1.02-.57 1.62-.73.6-.15 1.21-.23 1.82-.23.73 0 1.48.13 2.25.4s1.44.67 2.01 1.19l-2 2.11ZM61.23 35.32h3.16v13h-3.16zM78.18 48.33l.07-9.2h-.05l-3.38 9.2h-2.21l-3.28-9.2h-.06l.08 9.2h-2.96V35.32h4.47l2.96 8.34h.07l2.83-8.34h4.55v13.01h-3.09zM81.62 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M79.5 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M77.37 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M75.25 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M73.13 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M71 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M68.88 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M66.75 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M64.63 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M62.51 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M60.38 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M58.26 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M56.13 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M54.01 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M51.89 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M49.76 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M87.17 32.72c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 34.78c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 36.83c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 38.89c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 40.95c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 43.01c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 45.07c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 47.13c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 49.19c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 51.24c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M87.17 53.3c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.92 34.85c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63c0 .17-.07.33-.18.45-.11.11-.27.19-.45.19M36.24 33.38c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M37.65 31.98c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M39.05 30.58c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M40.46 29.18c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 36.83c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 38.89c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 40.95c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 43.01c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 45.07c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 47.13c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 49.19c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 51.24c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M34.83 53.3c-.35 0-.63-.28-.63-.63s.28-.63.63-.63.63.28.63.63-.28.63-.63.63M47.64 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M45.51 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M43.39 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M41.27 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M39.14 57.68c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M81.62 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M79.5 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M77.37 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M75.25 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M73.13 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M71 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M68.88 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M66.75 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M64.63 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M62.51 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M60.38 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M58.26 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M56.13 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M54.01 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M51.89 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M49.76 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M47.64 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M45.51 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M43.39 27.15c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M41.3 27.24c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M83.74 57.64c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M85.66 56.65c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M86.52 54.73c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.74 57.64c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M85.66 56.65c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M86.52 54.73c0-.35.28-.63.63-.63s.63.28.63.63-.28.63-.63.63-.63-.28-.63-.63M83.74 27.14c0 .35.28.63.63.63s.63-.28.63-.63-.28-.63-.63-.63-.63.28-.63.63M85.66 28.14c0 .35.28.63.63.63s.63-.28.63-.63-.28-.63-.63-.63-.63.28-.63.63M86.52 30.06c0 .35.28.63.63.63s.63-.28.63-.63-.28-.63-.63-.63-.63.28-.63.63M38.24 57.64c0-.35-.28-.63-.63-.63s-.63.28-.63.63.28.63.63.63.63-.28.63-.63M36.33 56.65c0-.35-.28-.63-.63-.63s-.63.28-.63.63.28.63.63.63.63-.28.63-.63M35.47 54.73c0-.35-.28-.63-.63-.63s-.63.28-.63.63.28.63.63.63.63-.28.63-.63"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ESIM104 = (ESIM104);
;// ./src/Picto/GeneratedPictoComponents/ESIM56.tsx


var ESIM56_excluded = ["className"];
function ESIM56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ESIM56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ESIM56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ESIM56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ESIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ESIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ESIM56_objectSpread(ESIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28.61 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.95 23.52v.08c0 .13.03.25.09.35.06.1.14.19.23.26.1.07.2.13.32.16.12.04.25.06.38.06.23 0 .44-.04.62-.13s.34-.2.48-.35l.94.73c-.3.31-.63.54-.99.68s-.76.21-1.18.21c-.32 0-.62-.04-.89-.13s-.51-.22-.72-.4c-.2-.18-.36-.39-.48-.65s-.18-.56-.18-.89c0-.4.07-.76.21-1.11s.33-.64.57-.89c.24-.25.54-.45.88-.6.34-.14.71-.22 1.12-.22.3 0 .58.04.83.13s.46.21.64.38c.18.16.32.37.42.61.1.24.15.52.15.83 0 .11-.01.25-.03.42-.02.17-.05.33-.09.48h-3.31Zm2.11-.91v-.18c0-.2-.07-.37-.22-.51s-.35-.2-.63-.2c-.17 0-.32.03-.45.09s-.25.13-.35.22c-.1.09-.18.18-.24.29-.06.11-.11.21-.13.31h2ZM31.67 20.57c-.14-.17-.31-.31-.53-.41-.22-.1-.43-.15-.63-.15-.11 0-.21 0-.32.03-.11.02-.21.05-.29.11-.09.05-.16.12-.22.2-.06.08-.09.19-.09.32 0 .11.02.2.07.28.05.07.11.14.2.19.09.06.2.11.32.15.12.05.26.09.42.14.22.07.45.16.69.25.24.09.46.21.66.36s.36.33.49.55c.13.22.19.49.19.82 0 .38-.07.7-.21.98-.14.27-.33.5-.56.68-.23.18-.5.31-.81.4-.3.09-.61.13-.94.13-.47 0-.92-.08-1.36-.25-.44-.16-.8-.4-1.09-.7l1.04-1.06c.16.2.37.36.63.5.26.13.52.2.78.2.12 0 .23-.01.34-.04a.686.686 0 0 0 .49-.34c.05-.09.07-.2.07-.33s-.03-.23-.09-.31a.866.866 0 0 0-.26-.24 1.73 1.73 0 0 0-.43-.19c-.17-.06-.36-.12-.58-.19-.21-.07-.42-.15-.62-.24s-.38-.21-.54-.36c-.16-.14-.28-.32-.38-.53-.1-.21-.14-.46-.14-.75 0-.36.07-.68.22-.94.15-.26.34-.47.58-.64.24-.17.51-.29.81-.37.3-.08.61-.12.92-.12.37 0 .75.07 1.13.2.39.14.72.34 1.01.6l-1.01 1.07ZM33.52 18.87h1.59v6.56h-1.59zM42.07 25.42l.04-4.64h-.03l-1.71 4.64h-1.11l-1.65-4.64h-.03l.03 4.64h-1.49v-6.55h2.26l1.49 4.2h.04l1.42-4.2h2.3v6.55h-1.56zM43.8 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M42.73 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M41.66 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M40.59 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M39.52 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M38.45 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M37.38 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M36.31 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M35.24 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M34.17 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M33.09 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M32.02 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M30.95 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M29.88 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M28.81 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M27.74 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M46.6 17.55c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 18.59c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 19.63c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 20.67c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 21.7c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 22.74c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 23.78c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 24.82c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 25.86c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 26.89c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M46.6 27.93c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.26 18.63c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32c0 .09-.03.17-.09.23a.31.31 0 0 1-.22.09M20.92 17.88c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M21.63 17.18c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M22.34 16.47c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M23.05 15.77c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 19.63c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 20.67c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 21.7c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 22.74c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 23.78c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 24.82c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 25.86c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 26.89c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M20.21 27.93c-.18 0-.32-.14-.32-.32s.14-.32.32-.32.32.14.32.32-.14.32-.32.32M26.67 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M25.6 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M24.53 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M23.46 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M22.38 30.14c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M43.8 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M42.73 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M41.66 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M40.59 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M39.52 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M38.45 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M37.38 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M36.31 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M35.24 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M34.17 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M33.09 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M32.02 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M30.95 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M29.88 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M28.81 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M27.74 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M26.67 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M25.6 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M24.53 14.74c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M23.47 14.79c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M44.88 30.12c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M45.84 29.62c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M46.27 28.65c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.88 30.12c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M45.84 29.62c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M46.27 28.65c0-.18.14-.32.32-.32s.32.14.32.32-.14.32-.32.32-.32-.14-.32-.32M44.88 14.74c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32M45.84 15.24c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32M46.27 16.21c0 .18.14.32.32.32s.32-.14.32-.32-.14-.32-.32-.32-.32.14-.32.32M21.93 30.12c0-.18-.14-.32-.32-.32s-.32.14-.32.32.14.32.32.32.32-.14.32-.32M20.96 29.62c0-.18-.14-.32-.32-.32s-.32.14-.32.32.14.32.32.32.32-.14.32-.32M20.53 28.65c0-.18-.14-.32-.32-.32s-.32.14-.32.32.14.32.32.32.32-.14.32-.32"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.65 33v14c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M22.65 8h2M20.65 48h6M22.65 8h2M20.65 48h6"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ESIM56 = (ESIM56);
;// ./src/Picto/GeneratedPictoComponents/Headphones104.tsx


var Headphones104_excluded = ["className"];
function Headphones104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Headphones104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Headphones104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Headphones104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Headphones104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Headphones104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Headphones104_objectSpread(Headphones104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m94 60.66-.87 11.66-4.41 10.24c-.06.45-4.52 4.06-4.96 4.17l-5.99 2.99c-.26.06-4.02.83-4.25.71l-4.47-.7c-.99-.52-.65-2.01.47-2.05 5.9-.2 15.55-2.37 19.54-13.77 1.77-5.06 2.31-10.57 2.18-15.83-.03-1.39.82-2.34 1.88-2.69l.89 5.26ZM10.41 60.66l.87 11.66 4.41 10.24c.06.45 4.52 4.06 4.96 4.17l5.99 2.99c.26.06 4.02.83 4.25.71l4.47-.7c.99-.52.65-2.01-.47-2.05-5.9-.2-15.55-2.37-19.54-13.77-1.77-5.06-2.31-10.57-2.18-15.83.03-1.39-.82-2.34-1.88-2.69l-.89 5.26ZM12.62 50.83c-.06 0-.13 0-.19-.02a.96.96 0 0 1-.75-1.13c1.51-7.45 4.13-13.93 7.78-19.24 12.03-17.46 31.59-16.8 31.78-16.79.12-.02 5.49-.6 12.56 1.3.51.14.81.66.67 1.17-.13.51-.65.81-1.17.67-6.69-1.8-11.91-1.24-11.96-1.24-.39 0-18.9-.61-30.31 15.97-3.51 5.1-6.03 11.34-7.49 18.54a.95.95 0 0 1-.93.76Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.97 57.23-2.78 3.88M42.47 63.07 38.4 65.6M45.31 70.57l-4.72.8M67.22 57.23l2.77 3.88M61.72 63.07l4.07 2.53M58.88 70.57l4.72.8"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21 60.93s3.76 12.56 13.62 21.45M69.06 82.38c9.86-8.9 13.62-21.45 13.62-21.45"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M92.24 50.55c7.69 39.44-18.63 40.04-21.61 39.68-4.96-.61-8.93-3.84-6.77-10.57s11.79-23.08 17.31-24.29c5.53-1.2 7.69 2.89 7.69 2.89s.24-37.49-37.03-38.34h-.04c-37.25.83-37.01 38.33-37.01 38.33s2.16-4.09 7.69-2.89c5.53 1.2 15.15 17.56 17.31 24.29 2.16 6.73-1.8 9.96-6.77 10.57-2.98.37-29.31-.24-21.61-39.68C19.11 11.11 51.81 13.7 51.81 13.7h.04s32.7-2.59 40.39 36.85Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Headphones104 = (Headphones104);
;// ./src/Picto/GeneratedPictoComponents/Headphones56.tsx


var Headphones56_excluded = ["className"];
function Headphones56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Headphones56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Headphones56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Headphones56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Headphones56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Headphones56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Headphones56_objectSpread(Headphones56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.04 32.56-.45 6.11-2.31 5.37c-.03.23-2.37 2.13-2.6 2.19l-3.14 1.57c-.14.03-2.11.43-2.23.37l-2.34-.37c-.52-.27-.34-1.05.25-1.07 3.09-.1 8.15-1.24 10.24-7.22.93-2.65 1.21-5.54 1.14-8.3-.02-.73.43-1.22.98-1.41l.47 2.76ZM6.22 32.56l.45 6.11 2.31 5.37c.03.23 2.37 2.13 2.6 2.19l3.14 1.57c.14.03 2.11.43 2.23.37l2.34-.37c.52-.27.34-1.05-.25-1.07-3.09-.1-8.15-1.24-10.24-7.22-.93-2.65-1.21-5.54-1.14-8.3.02-.73-.43-1.22-.98-1.41l-.47 2.76ZM7.37 27.4h-.1a.495.495 0 0 1-.39-.59c.79-3.91 2.17-7.3 4.08-10.09 6.31-9.16 16.56-8.82 16.66-8.81.06-.01 2.88-.32 6.58.68.27.07.42.35.35.61-.07.27-.34.43-.61.35-3.51-.94-6.24-.65-6.27-.65-.21 0-9.91-.32-15.89 8.37-1.84 2.67-3.16 5.95-3.92 9.72-.05.24-.26.4-.49.4Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.77 32.69s1.97 6.59 7.14 11.25M36.96 43.94c5.17-4.67 7.14-11.25 7.14-11.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.11 27.26c4.03 20.67-9.77 20.99-11.33 20.8-2.6-.32-4.68-2.01-3.55-5.54 1.13-3.53 6.18-12.1 9.07-12.73 2.9-.63 4.03 1.51 4.03 1.51s.13-19.65-19.41-20.1h-.02C8.37 11.64 8.49 31.3 8.49 31.3s1.13-2.14 4.03-1.51c2.9.63 7.94 9.21 9.07 12.73 1.13 3.53-.94 5.22-3.55 5.54-1.56.19-15.36-.13-11.33-20.8C10.77 6.58 27.92 7.94 27.92 7.94h.02s17.14-1.36 21.18 19.32Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.14 30.76-1.46 2.03M23.02 33.81l-2.13 1.34M24.51 37.75l-2.47.42M35.99 30.76l1.46 2.03M33.11 33.81l2.14 1.34M31.63 37.75l2.47.42"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Headphones56 = (Headphones56);
;// ./src/Picto/GeneratedPictoComponents/InternetExtras104.tsx


var InternetExtras104_excluded = ["className"];
function InternetExtras104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetExtras104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetExtras104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetExtras104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetExtras104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetExtras104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetExtras104_objectSpread(InternetExtras104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.92 71.27-.48 1.86c-.26.98-.89 1.67-1.86 1.41-.98-.26-1.19-1.17-.93-2.15l.43-1.65a.42.42 0 0 0-.08-.36 2.68 2.68 0 0 1-.49-2.35 2.702 2.702 0 0 1 3.31-1.86c1.17.29 2 1.33 2.04 2.53.03 1.21-.74 2.29-1.89 2.65l-.04-.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.24 68.15 2.75-17.52c.08-.51-.66-.68-.81-.18l-6.16 20.66c-.9 3.03-.2 6.31 1.86 8.71l9.94 11.79c.32.38.92-.02.69-.47L59.2 79.38a17.707 17.707 0 0 1-1.95-11.24Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m70.33 59.96 1.24-4.74a5.723 5.723 0 0 1 2.63-3.49c1.31-.77 2.86-.98 4.33-.6a5.71 5.71 0 0 1 3.48 2.64c.76 1.31.98 2.86.59 4.32l-1.19 4.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.4 63.84-15.08-3.88c-1.52-.4-3.08.5-3.49 2.02l-3.16 12.07c-.19.73-.09 1.5.29 2.16.38.65 1 1.13 1.73 1.32l15.1 3.96c.73.19 1.5.09 2.16-.29.65-.38 1.13-1 1.32-1.73l3.16-12.07c.22-.74.12-1.53-.26-2.2s-1.02-1.15-1.76-1.34Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m67.17 95 18.57-6.91a9.303 9.303 0 0 0 5.89-6.69l6.41-27.86c.16-.72-.26-1.45-.97-1.67a23.553 23.553 0 0 1-15.17-13.2 23.579 23.579 0 0 1-19.67 4.01c-.73-.15-1.45.28-1.65 1l-8.12 27.41c-.9 3.03-.2 6.31 1.86 8.71l12.85 15.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m74.92 71.27-.48 1.86c-.26.98-.89 1.67-1.86 1.41-.98-.26-1.19-1.17-.93-2.15l.48-1.86c-.63-.67-.87-1.62-.63-2.51a2.702 2.702 0 0 1 3.31-1.86c1.17.29 2 1.33 2.04 2.53.03 1.21-.74 2.29-1.89 2.65l-.04-.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.82 28.67c0-5.01-4.06-9.06-9.06-9.06"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M86 28.67c0-7.86-6.38-14.24-14.24-14.24"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.07 83.35a3.956 3.956 0 0 1-3.16-2.9c-.27-1.04-.56-1.86-1.92-1.86H15.46c-1.73 0-3.13 1.53-3.13 3.42s1.4 3.42 3.13 3.42h34.68c1.67 0 3.68-.29 2.85-1.75l-1.93-.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.68 45.93c0-1.67 1.86-2.02 2.34-.41 3.25 13 2.82 24.42 14.24 31.01.61.35.41 1.47-.28 1.47h-16.3V45.93Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.57 85.42v2.49h-4.96v-2.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.33 78.88H49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53 85.31H16.05c-2.05 0-3.71-1.66-3.71-3.71V30.41c0-2.05 1.66-3.71 3.71-3.71h53.62c2.05 0 3.71 1.66 3.71 3.71v6.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.54 73.81h6.65"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetExtras104 = (InternetExtras104);
;// ./src/Picto/GeneratedPictoComponents/InternetExtras56.tsx


var InternetExtras56_excluded = ["className"];
function InternetExtras56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetExtras56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetExtras56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetExtras56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetExtras56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetExtras56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetExtras56_objectSpread(InternetExtras56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.02 35.59 1.63-10.39c.05-.3-.39-.4-.48-.11l-3.65 12.25a5.49 5.49 0 0 0 1.1 5.16l5.89 6.99c.19.23.55-.01.41-.28l-3.74-6.97a10.485 10.485 0 0 1-1.16-6.66Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.34 37.76-.26 1c-.14.53-.48.9-1 .76-.53-.14-.64-.63-.5-1.16l.26-1c-.34-.36-.47-.87-.34-1.35.22-.77 1.01-1.21 1.78-1 .63.16 1.08.72 1.1 1.36.02.65-.4 1.23-1.02 1.43l-.02-.04Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.87 31.67.67-2.55c.2-.79.71-1.47 1.42-1.88.7-.41 1.54-.53 2.33-.32.79.21 1.46.72 1.87 1.42.41.7.53 1.54.32 2.33l-.64 2.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.91 33.76-8.12-2.09c-.82-.22-1.66.27-1.88 1.09l-1.7 6.5c-.1.39-.05.81.16 1.16.2.35.54.61.93.71l8.13 2.13c.39.1.81.05 1.16-.16.35-.2.61-.54.71-.93l1.7-6.5c.12-.4.07-.83-.14-1.19s-.55-.62-.95-.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.17 50.54 10-3.72c1.6-.58 2.8-1.94 3.17-3.6l3.45-15a.766.766 0 0 0-.52-.9 12.68 12.68 0 0 1-8.17-7.11 12.71 12.71 0 0 1-10.59 2.16.763.763 0 0 0-.89.54l-4.37 14.76c-.49 1.63-.11 3.4 1 4.69l6.92 8.18Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.34 37.76-.26 1c-.14.53-.48.9-1 .76-.53-.14-.64-.63-.5-1.16l.26-1c-.34-.36-.47-.87-.34-1.35.22-.77 1.01-1.21 1.78-1 .63.16 1.08.72 1.1 1.36.02.65-.4 1.23-1.02 1.43l-.02-.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.21 14.67c0-2.7-2.18-4.88-4.88-4.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46 14.67C46 10.44 42.57 7 38.33 7"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.83 24.12c0-.9 1-1.09 1.26-.22 1.75 7 1.52 13.15 7.67 16.7.33.19.22.79-.15.79H6.83V24.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.39 44.25c-1.18-.12-1.76-1.22-1.72-2.4 0-.11-.09-.18-.37-.18H8.61C7 41.67 7 42.5 7 43.51c0 1.02.72 1.84 1.61 1.84h17.82c.86 0 1.56-.35 1.47-.94l-1.51-.16Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.69 45.38v1.34h-2.67v-1.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.64 41.86h19.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29 45.32H8.64c-1.1 0-2-.9-2-2V15.76c0-1.1.9-2 2-2h28.87c1.1 0 2 .9 2 2v2.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.29 39.13h3.58"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetExtras56 = (InternetExtras56);
;// ./src/Picto/GeneratedPictoComponents/Laptop104.tsx


var Laptop104_excluded = ["className"];
function Laptop104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Laptop104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Laptop104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Laptop104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Laptop104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Laptop104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Laptop104_objectSpread(Laptop104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.06 30.25v43.46H56c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.32 77.58H45.68M14.4 73.79V26.98c0-1.61 1.31-2.91 2.91-2.91h69.77c1.61 0 2.91 1.31 2.91 2.91V73.8M11 74.43h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7A3.15 3.15 0 0 1 9 77.58v-1.15c0-1.1.9-2 2-2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "28.27",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Laptop104 = (Laptop104);
;// ./src/Picto/GeneratedPictoComponents/Laptop56.tsx


var Laptop56_excluded = ["className"];
function Laptop56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Laptop56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Laptop56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Laptop56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Laptop56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Laptop56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Laptop56_objectSpread(Laptop56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M8.59 16.69v22.24h21.46c.13-.97-.67-1.75-2.39-2.34-2.58-.89-10.15-4.69-13.1-11.58-2.95-6.89-2.35-9.2-3.87-9.64l-.33-.09c-.9-.22-1.77.49-1.77 1.41Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.24 40.93h-6.48M7.56 39.4h40.93c.55 0 1 .45 1 1v.31c0 .99-.81 1.8-1.8 1.8H8.36c-.99 0-1.8-.81-1.8-1.8v-.31c0-.55.45-1 1-1ZM8.75 39.24V14.78c0-.73.6-1.33 1.33-1.33h36.03c.73 0 1.33.6 1.33 1.33v24.46"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "28",
      cy: "15.86",
      rx: ".52",
      ry: ".53",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Laptop56 = (Laptop56);
;// ./src/Picto/GeneratedPictoComponents/Mobile104.tsx


var Mobile104_excluded = ["className"];
function Mobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Mobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Mobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Mobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Mobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Mobile104_objectSpread(Mobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29",
        y: "10",
        width: "46",
        height: "84",
        rx: "6",
        ry: "6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50 14h4M46 90h12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mobile104 = (Mobile104);
;// ./src/Picto/GeneratedPictoComponents/Mobile56.tsx


var Mobile56_excluded = ["className"];
function Mobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Mobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Mobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Mobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Mobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Mobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Mobile56_objectSpread(Mobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16",
        y: "6",
        width: "24",
        height: "44",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27 8h2M25 48h6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Mobile56 = (Mobile56);
;// ./src/Picto/GeneratedPictoComponents/PhoneCase104.tsx


var PhoneCase104_excluded = ["className"];
function PhoneCase104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PhoneCase104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PhoneCase104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PhoneCase104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PhoneCase104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PhoneCase104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PhoneCase104_objectSpread(PhoneCase104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M65.71 35.66c-.02-2.18.02-3.97.05-5.13-1.1.19-1.99.39-2.6.56s-1.05.73-1.07 1.39c-.02.92-.05 2.36-.04 4.11.04 5.83 1.25 14.9 9.57 18.25.1.04.2.05.3.05-5.24-5.4-6.17-13.54-6.2-19.25v.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.12 26.6c5.72 0 10.12.91 12.23 1.45.83.21 1.43.96 1.46 1.82.03 1.2.06 3.1.05 5.4-.05 7.63-1.7 19.53-13.05 23.92-.45.17-.94.17-1.39 0-11.35-4.39-12.99-16.28-13.05-23.92-.02-2.31.02-4.2.05-5.4.02-.87.62-1.62 1.46-1.83 2.12-.54 6.51-1.45 12.22-1.45h.03Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.12 29.99c4.2 0 7.41.69 8.97 1.11.61.16 1.05.73 1.07 1.39.02.92.05 2.36.04 4.11-.04 5.83-1.25 14.9-9.57 18.25-.33.13-.69.13-1.02 0-8.32-3.34-9.53-12.42-9.57-18.25 0-1.76 0-3.21.04-4.11.02-.66.46-1.24 1.07-1.39 1.55-.41 4.77-1.1 8.97-1.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "27.09",
        y: "14",
        width: "18.42",
        height: "18.42",
        rx: "2.31",
        ry: "2.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PhoneCase104 = (PhoneCase104);
;// ./src/Picto/GeneratedPictoComponents/PhoneCase56.tsx


var PhoneCase56_excluded = ["className"];
function PhoneCase56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PhoneCase56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PhoneCase56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PhoneCase56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PhoneCase56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PhoneCase56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PhoneCase56_objectSpread(PhoneCase56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.37 19.44c0-1.14 0-2.08.02-2.69-.58.1-1.04.21-1.36.29s-.55.38-.56.73c0 .48-.02 1.23-.02 2.16.02 3.05.65 7.81 5.01 9.56.05.02.11.02.16.03-2.75-2.83-3.23-7.09-3.25-10.09Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.73 14.7c3 0 5.3.48 6.41.76.44.11.75.5.76.96.01.63.03 1.62.02 2.83-.03 4-.89 10.23-6.84 12.53-.24.09-.49.09-.73 0-5.94-2.3-6.81-8.53-6.84-12.53 0-1.21 0-2.2.02-2.83 0-.46.33-.85.76-.96 1.11-.28 3.41-.76 6.4-.76h.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.73 16.47c2.2 0 3.88.36 4.7.58.32.09.55.38.56.73 0 .48.02 1.24.02 2.16-.02 3.05-.65 7.81-5.01 9.56-.17.07-.36.07-.53 0-4.36-1.75-4.99-6.5-5.01-9.56 0-.92 0-1.68.02-2.16 0-.35.24-.65.56-.73.81-.22 2.5-.58 4.7-.58Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.07 46.9c-1.56-1-3.49-1.09-5.12-1.98-6.96-3.65-8.45-12.03-9.52-19.11-.31-1.77-.38-2.91-2.43-3.07v23.29c0 2.19 1.77 3.96 3.96 3.97h14.89c.1-1.25-.72-2.42-1.78-3.1Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "15.14",
        y: "8.1",
        width: "9.65",
        height: "9.65",
        rx: "1.21",
        ry: "1.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.1 34.81v12.05c0 1.74-1.41 3.14-3.14 3.14H16.15c-1.74 0-3.14-1.41-3.14-3.14V9.14C13.01 7.4 14.42 6 16.15 6h17.81c1.74 0 3.14 1.41 3.14 3.14v2.62"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PhoneCase56 = (PhoneCase56);
;// ./src/Picto/GeneratedPictoComponents/SIM104.tsx


var SIM104_excluded = ["className"];
function SIM104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SIM104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SIM104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SIM104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SIM104_objectSpread(SIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.23 50.61c-3.87-11.29-3.34-15.49-6.41-16.43-2.46-.75-2.83.92-2.83 2.39l.09 51.27c-.63 5.56 2.48 5.64 5.52 5.65l44.2.03c1.63 0 2.54-2.02 1.41-3.22-.97-1.02-2.53-1.91-4.68-2.68-1.72-.61-3.63-2.07-6.94-3.79h-.9l-24.6-.1c-3.23-.01-5.84-2.59-5.83-5.75l.96-27.38"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M60.36 83.88s-3.07-.03-3.29-3.05S63.91 63.22 59.45 56c-4.42-7.15-14.23-8.66-23.47-4.31-7.24 3.41-4.71-2.09-4.71-2.09l2.09-2.55 5.14-1.03h11.29l10.63.15 3.45 1.4 3.64 4.59-.96 12.02-.29 16.04-3.28 2.99-2.63.68",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.24 72.92-.02 10.93M55.09 72.97l-.02 10.93M55.12 57.05l.02-10.7M43.27 57l.02-10.7M67.11 52.44l-.05 25.63c0 3.34-2.77 6.03-6.18 6.02l-23.53-.1c-3.41-.01-6.16-2.73-6.15-6.07l.05-25.63c0-3.34 2.77-6.03 6.18-6.02l23.53.1c3.41.01 6.16 2.73 6.15 6.07Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m59.91 72.79-21.53-.09c-3.93-.02-7.15-3.04-7.14-6.71v-1.76c0-3.68 3.24-6.67 7.17-6.66l21.53.09c3.93.02 7.15 3.04 7.14 6.71v1.76c0 3.68-3.24 6.67-7.17 6.66Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.69 28.74-.35 61.11c-.01 2.2-2.07 3.97-4.6 3.97l-51.91-.06c-2.53 0-4.57-1.79-4.56-3.98l.39-74.99c.01-2.56 2.42-4.64 5.37-4.63l37.97.05c2.8 0 4.55.71 5.98 1.96l9.4 9.41c1.75 1.79 2.31 3.58 2.31 7.16Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SIM104 = (SIM104);
;// ./src/Picto/GeneratedPictoComponents/SIM56.tsx


var SIM56_excluded = ["className"];
function SIM56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SIM56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SIM56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SIM56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SIM56_objectSpread(SIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.3 26.24c-2.11-6.17-1.32-8.13-3-8.63-1.35-.41-1.54.5-1.54 1.31l.05 27.99c-.34 3.04 1.35 3.08 3.02 3.08l24.13.02c.89 0 1.39-1.1.77-1.76-.53-.56-1.38-1.04-2.56-1.46-.94-.33-1.98-1.13-3.79-2.07h-.49l-13.43-.05c-1.76 0-3.19-1.41-3.18-3.14l.02-15.28"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.39 44.57s-1.59-.02-1.7-1.58 3.54-9.12 1.23-12.86-7.13-4.38-11.91-2.13c-3.75 1.77-2.69-1.19-2.69-1.19l1.08-1.32 2.66-.53h5.85l5.51.08 1.79.72 1.88 2.38-.5 6.23-.15 8.31-1.7 1.55-1.36.35",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.5 38.74-.01 5.97M29.59 38.76l-.02 5.97M29.6 30.87l.01-6.01M23.52 30.85l.01-6.01M35.83 28.17l-.02 13.26c0 1.73-1.43 3.12-3.2 3.11l-12.17-.05c-1.76 0-3.19-1.41-3.18-3.14l.02-13.26c0-1.73 1.43-3.12 3.2-3.11l12.17.05c1.76 0 3.19 1.41 3.18 3.14Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32 38.7-10.94-.05c-2 0-3.63-1.57-3.63-3.47v-.91c0-1.9 1.64-3.45 3.64-3.44l10.94.05c2 0 3.63 1.57 3.63 3.47v.91c0 1.9-1.64 3.45-3.64 3.44Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.5 38.74-.01 5.58M29.59 38.76l-.01 5.59M29.6 30.87l.01-5.72M23.52 30.85l.01-5.72M35.83 28.17l-.02 13.26c0 1.73-1.43 3.12-3.2 3.11l-12.17-.05c-1.76 0-3.19-1.41-3.18-3.14l.02-13.26c0-1.73 1.43-3.12 3.2-3.11l12.17.05c1.76 0 3.19 1.41 3.18 3.14Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m32 38.7-10.94-.05c-2 0-3.63-1.57-3.63-3.47v-.91c0-1.9 1.64-3.45 3.64-3.44l10.94.05c2 0 3.63 1.57 3.63 3.47v.91c0 1.9-1.64 3.45-3.64 3.44Z"
        })]
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.63 16.06-.18 31.38c0 1.13-1.05 2.04-2.34 2.04l-26.41-.03c-1.29 0-2.33-.92-2.32-2.04l.2-38.52c0-1.32 1.23-2.38 2.73-2.38l19.32.03c1.42 0 2.31.36 3.04 1l4.78 4.83c.89.92 1.18 1.84 1.17 3.68Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SIM56 = (SIM56);
;// ./src/Picto/GeneratedPictoComponents/SmartWiFiBooster104.tsx


var SmartWiFiBooster104_excluded = ["className"];
function SmartWiFiBooster104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SmartWiFiBooster104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SmartWiFiBooster104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SmartWiFiBooster104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SmartWiFiBooster104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartWiFiBooster104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SmartWiFiBooster104_objectSpread(SmartWiFiBooster104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.48 46.1c0-1.08 1.53-1.32 1.84-.29C36 90.99 60 74.99 71 78.99c2.27.83 2.43 2.08.01 2.11l-50.58.55.05-35.56Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.6 90.45h-9.59a.58.58 0 0 1-.58-.58v-1.42c0-.32.26-.58.58-.58h9.59c.32 0 .58.26.58.58v1.42c0 .32-.26.58-.58.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.84 81.53h60.87s.26 5.9-6.26 5.9H26.62s-5.78-.79-5.78-5.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.92 90.45h-9.59a.58.58 0 0 1-.58-.58v-1.49c0-.32.26-.58.58-.58h9.59c.32 0 .58.26.58.58v1.49c0 .32-.26.58-.58.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.55 73.3h-5.89c-.61 0-1.12-.5-1.12-1.12v-.6c0-.62.5-1.12 1.12-1.12h5.89c.61 0 1.12.5 1.12 1.12v.6c0 .61-.5 1.12-1.12 1.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.21 39.07-43.82-.29c-.96 0-1.73-.73-1.72-1.62v-1.19c.02-.88.8-1.6 1.76-1.6l43.82.29c.96 0 1.73.73 1.72 1.62v1.19c-.02.88-.8 1.6-1.76 1.59"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.88 26.01a9.065 9.065 0 0 0-12.82 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.54 22.35c-5.56-5.56-14.58-5.56-20.14 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.2 18.69c-7.58-7.58-19.88-7.58-27.46 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.89 90.99h-7.55c-.74 0-1.36-.61-1.36-1.36v-.73c0-.74.61-1.36 1.36-1.36h7.55c.75 0 1.36.61 1.36 1.36v.73c0 .74-.61 1.36-1.36 1.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.32 87.43H27.66c-3.97 0-7.22-3.25-7.22-7.22v-38.6c0-3.97 3.25-7.22 7.22-7.22h47.67c3.97 0 7.22 3.25 7.22 7.22v38.6c0 3.97-3.25 7.22-7.22 7.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.65 90.99H66.1c-.75 0-1.36-.61-1.36-1.36v-.73c0-.74.61-1.36 1.36-1.36h7.55c.75 0 1.36.61 1.36 1.36v.73c0 .74-.61 1.36-1.36 1.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.55 73.3h-5.89c-.61 0-1.12-.5-1.12-1.12v-.6c0-.62.5-1.12 1.12-1.12h5.89c.61 0 1.12.5 1.12 1.12v.6c0 .61-.5 1.12-1.12 1.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.21 39.07-43.82-.29c-.96 0-1.73-.73-1.72-1.62v-1.19c.02-.88.8-1.6 1.76-1.6l43.82.29c.96 0 1.73.73 1.72 1.62v1.19c-.02.88-.8 1.6-1.76 1.59Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.71 81.52H21.34"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartWiFiBooster104 = (SmartWiFiBooster104);
;// ./src/Picto/GeneratedPictoComponents/SmartWiFiBooster56.tsx


var SmartWiFiBooster56_excluded = ["className"];
function SmartWiFiBooster56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SmartWiFiBooster56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SmartWiFiBooster56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SmartWiFiBooster56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SmartWiFiBooster56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartWiFiBooster56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SmartWiFiBooster56_objectSpread(SmartWiFiBooster56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.17 48.7h-5.16c-.17 0-.31-.14-.31-.31v-.77c0-.17.14-.31.31-.31h5.16c.17 0 .31.14.31.31v.77c0 .17-.14.31-.31.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.22 43.9H44s.14 3.18-3.37 3.18h-26.3s-3.11-.42-3.11-3.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.96 48.7H15.8c-.17 0-.31-.14-.31-.31v-.8c0-.17.14-.31.31-.31h5.16c.17 0 .31.14.31.31v.8c0 .17-.14.31-.31.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.37 39.47H26.2c-.33 0-.6-.27-.6-.6v-.32c0-.33.27-.6.6-.6h3.17c.33 0 .6.27.6.6v.32c0 .33-.27.6-.6.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.42 21.04-23.59-.15c-.51 0-.93-.39-.93-.87v-.64c0-.48.43-.86.95-.86l23.59.15c.51 0 .93.39.93.87v.64c0 .48-.43.86-.95.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.02 26.33c0-.54.76-.66.92-.14 6.79 22.45 18.72 14.5 24.18 16.49 1.13.41 1.21 1.03 0 1.05L10.99 44l.02-17.67Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.17 14.01a4.87 4.87 0 0 0-6.9 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.14 12.03a7.671 7.671 0 0 0-10.84 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.11 10.06c-4.08-4.08-10.7-4.08-14.79 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.4 48.99h-4.07c-.4 0-.73-.33-.73-.73v-.39c0-.4.33-.73.73-.73h4.07c.4 0 .73.33.73.73v.39c0 .4-.33.73-.73.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.56 47.08H14.89A3.9 3.9 0 0 1 11 43.19V22.41a3.9 3.9 0 0 1 3.89-3.89h25.67a3.9 3.9 0 0 1 3.89 3.89v20.78a3.9 3.9 0 0 1-3.89 3.89Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.66 48.99h-4.07c-.4 0-.73-.33-.73-.73v-.39c0-.4.33-.73.73-.73h4.07c.4 0 .73.33.73.73v.39c0 .4-.33.73-.73.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.37 39.47H26.2c-.33 0-.6-.27-.6-.6v-.32c0-.33.27-.6.6-.6h3.17c.33 0 .6.27.6.6v.32c0 .33-.27.6-.6.6Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.42 21.04-23.59-.15c-.51 0-.93-.39-.93-.87v-.64c0-.48.43-.86.95-.86l23.59.15c.51 0 .93.39.93.87v.64c0 .48-.43.86-.95.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44 43.9H11.49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartWiFiBooster56 = (SmartWiFiBooster56);
;// ./src/Picto/GeneratedPictoComponents/Tablet104.tsx


var Tablet104_excluded = ["className"];
function Tablet104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Tablet104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Tablet104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Tablet104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Tablet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Tablet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Tablet104_objectSpread(Tablet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.58 93.94c1.84.02 2.53-2.39.97-3.35-2.29-1.41-5.26-3.39-9.04-6.13-11.4-8.29-13.47-20.72-14.5-33.15s0-17.42-5.17-17.42V85.08c0 6.69 1.01 8.71 8.7 8.71l19.05.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.14 88.97h11.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "20.63",
        y: "10.16",
        width: "62.73",
        height: "83.68",
        rx: "5",
        ry: "5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "15.01",
      r: "1.05",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Tablet104 = (Tablet104);
;// ./src/Picto/GeneratedPictoComponents/Tablet56.tsx


var Tablet56_excluded = ["className"];
function Tablet56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Tablet56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Tablet56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Tablet56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Tablet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Tablet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Tablet56_objectSpread(Tablet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.57 49.96c.86 0 1.19-1.11.46-1.57-1.22-.75-2.87-1.85-5.03-3.42-5.96-4.34-7.05-10.84-7.59-17.35-.54-6.51 0-9.12-2.71-9.12v26.79c0 3.5.53 4.56 4.55 4.56l10.32.11Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.93 47.34h6.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11.57",
        y: "6.09",
        width: "32.86",
        height: "43.83",
        rx: "2.51",
        ry: "2.51"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "8.65",
      r: ".51",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Tablet56 = (Tablet56);
;// ./src/Picto/GeneratedPictoComponents/TelstraLocator104.tsx


var TelstraLocator104_excluded = ["className"];
function TelstraLocator104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraLocator104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraLocator104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraLocator104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraLocator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraLocator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraLocator104_objectSpread(TelstraLocator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.57 28.13c.11 0-.28-.74-.35-.81-.22-.25-.52-.39-.82-.5-.61-.22-1.27-.24-1.91-.36-1.8-.34-3.31-1.57-4.32-3.07-.51-.76-.94-1.6-1.25-2.46-.63-1.75-.63-3.45-2.16-4.72-.07-.06-.15-.12-.24-.13h-.09c-.66.16-.76 2.9-.78 3.27-.17 2.91 0 5.87.27 8.77h11.65ZM34.73 52.83c-4.08 5.92-3.23 13.9-3.17 14.46 0 .02 0 .04.01.06 4.44 22.48 20.57 19.47 27.01 17.29.73-.25.63-1.3-.14-1.41-26.53-3.87-24.47-22.19-22.41-29.78.21-.79-.84-1.29-1.3-.62Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.34 28.7v9.32M56.66 28.7v9.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "65.05",
        r: "21.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "65.05",
        r: "27.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.38 18.37c0-3.49 2.97-6.32 6.62-6.32s6.62 2.84 6.62 6.32v9.41c0 .44-.38.81-.84.81H46.23c-.47 0-.84-.36-.84-.81v-9.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "18.12",
        r: "2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.2 79.02V67.84H38.02l23.3-12.11L49.2 79.02z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.04 33.8c2.94.66 5.64 2.17 7.7 4.53 2.06 2.37 3.17 5.25 3.41 8.26M75.85 37.47c2.25.5 4.31 1.65 5.88 3.46s2.43 4.02 2.61 6.32M26.96 33.8c-2.94.66-5.64 2.17-7.7 4.53-2.06 2.37-3.17 5.25-3.41 8.26M28.15 37.47c-2.25.5-4.31 1.65-5.88 3.46-1.57 1.81-2.43 4.02-2.61 6.32"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraLocator104 = (TelstraLocator104);
;// ./src/Picto/GeneratedPictoComponents/TelstraLocator56.tsx


var TelstraLocator56_excluded = ["className"];
function TelstraLocator56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TelstraLocator56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TelstraLocator56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TelstraLocator56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TelstraLocator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TelstraLocator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TelstraLocator56_objectSpread(TelstraLocator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31 15.15c.06 0-.15-.4-.19-.44-.12-.13-.28-.21-.44-.27-.33-.12-.69-.13-1.03-.19-.97-.18-1.78-.85-2.33-1.65-.27-.41-.51-.86-.67-1.32-.34-.94-.34-1.85-1.16-2.54-.04-.03-.08-.06-.13-.07H25c-.35.08-.41 1.56-.42 1.76-.09 1.57 0 3.16.15 4.72H31ZM18.84 28.25c-2.38 3.23-1.87 7.76-1.84 7.99v.03c2.43 12.3 11.36 10.43 14.7 9.25.35-.12.29-.63-.07-.68-14.71-2.07-13.3-12.31-12.17-16.27.11-.38-.39-.63-.62-.31Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "35",
        r: "14.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.44 9.95c0-1.87 1.6-3.4 3.56-3.4s3.56 1.52 3.56 3.4v5.06c0 .24-.2.43-.45.43H24.9c-.25 0-.45-.19-.45-.43V9.95ZM25.5 15.5v5M30.5 15.5v5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "35",
        r: "11.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "9.82",
        r: "1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.5 42.5v-6h-6L33 30l-6.5 12.5z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.59 19.71c-1.21.28-2.32.9-3.16 1.88s-1.29 2.17-1.38 3.41M13.94 17.73c-1.58.36-3.03 1.18-4.13 2.46S8.12 23.03 8 24.65M40.59 19.71c1.21.28 2.32.9 3.16 1.88s1.29 2.17 1.38 3.41M41.24 17.73c1.58.36 3.03 1.18 4.13 2.46s1.69 2.84 1.81 4.46"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TelstraLocator56 = (TelstraLocator56);
;// ./src/Picto/GeneratedPictoComponents/Watch104.tsx


var Watch104_excluded = ["className"];
function Watch104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Watch104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Watch104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Watch104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Watch104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Watch104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Watch104_objectSpread(Watch104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.43 83.1s16.68-5.69 28.97 8.46l3.57-15.47H35.06l1.37 7.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.01 40.66v23.4c0 3.77 5.12 12.84 11.6 12.84h23.02c.2-1.58-1.08-2.85-3.86-3.81-4.16-1.45-16.37-7.64-21.13-18.86-4.76-11.23-3.8-14.98-6.24-15.71-.15-.04-.3-.09-.44-.12-1.49-.38-2.94.73-2.94 2.27Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M39.79 39.62 52.17 52l7.73-7.73",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.9 28.67 2.94-14.1c.52-2.51 3.05-4.57 5.62-4.57h17.11c2.57 0 5.09 2.06 5.62 4.57l2.94 14.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.9 75.33 2.94 14.1c.52 2.51 3.05 4.57 5.62 4.57h17.11c2.57 0 5.09-2.06 5.62-4.57l2.94-14.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.07 27h21.87C70.7 27 77 33.3 77 41.06v21.88C77 70.7 70.7 77 62.94 77H41.06C33.3 77 27 70.7 27 62.94V41.07c0-7.76 6.3-14.06 14.06-14.06Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Watch104 = (Watch104);
;// ./src/Picto/GeneratedPictoComponents/Watch56.tsx


var Watch56_excluded = ["className"];
function Watch56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Watch56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Watch56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Watch56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Watch56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Watch56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Watch56_objectSpread(Watch56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.84 44.29s8.74-2.98 15.17 4.43l1.87-8.1H19.12l.72 3.67Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.91 22.06v12.26c0 1.97 2.68 6.73 6.08 6.73h12.06c.1-.83-.57-1.49-2.02-2-2.18-.76-8.57-4-11.07-9.88-2.49-5.88-1.99-7.85-3.27-8.23-.08-.02-.16-.05-.23-.06-.78-.2-1.54.38-1.54 1.19Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.6 21.52 28.09 28l4.05-4.05",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.13 15.38 1.46-6.98c.27-1.31 1.6-2.39 2.94-2.39h8.96c1.35 0 2.67 1.08 2.94 2.39l1.42 6.82.06.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.11 40.46 1.47 7.15c.27 1.31 1.6 2.39 2.94 2.39h8.96c1.35 0 2.67-1.08 2.94-2.39l1.46-7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.27 14.9h11.46c4.06 0 7.36 3.3 7.36 7.36v11.46c0 4.06-3.3 7.36-7.36 7.36H22.27c-4.06 0-7.36-3.3-7.36-7.36V22.26c0-4.06 3.3-7.36 7.36-7.36Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Watch56 = (Watch56);
;// ./src/Picto/GeneratedPictoComponents/WiFiBooster104.tsx


var WiFiBooster104_excluded = ["className"];
function WiFiBooster104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WiFiBooster104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WiFiBooster104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WiFiBooster104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WiFiBooster104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFiBooster104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WiFiBooster104_objectSpread(WiFiBooster104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M39.57 22.46c-.22.17-.35.48-.35.82L35.74 87.1v1.24c.03.8-.04 1.86.53 2.4.57.54 4.26.52 5.04.47 0 0-.41-2.96 2.46-2.96 2.66 0 14.55.04 16.92.04s2.02 2.93 2.02 2.93h3.39c2.12 0 1.93-1.64 2.06-2.57 1.47-10.65-10.72-10.9-17.37-12.7-6.97-1.88-7.25-12.23-7.54-18.15-.36-6.85.36-13.7 0-20.55-.27-4.9.47-11.98-2.96-14.74a.562.562 0 0 0-.36-.14c-.12 0-.23.04-.34.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.39 34.07c6.57 9.76 6.57 22.58 0 32.33M78.65 37.88c5.02 7.46 5.02 17.27 0 24.73M19.61 66.41c-6.57-9.76-6.57-22.58 0-32.33M25.35 62.61c-5.02-7.46-5.02-17.27 0-24.73"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M64.53 13.04c0-.67-.4-1.22-.88-1.22H40.47c-.49 0-.88.55-.88 1.22l-3.27 77.92c0 .67.5 1.22 1.12 1.22h4.32v-.91c0-1.13.83-2.04 1.86-2.04h16.89c1.03 0 1.86.91 1.86 2.04v.91h4.32c.62 0 1.12-.55 1.12-1.22l-3.27-77.92Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFiBooster104 = (WiFiBooster104);
;// ./src/Picto/GeneratedPictoComponents/WiFiBooster56.tsx


var WiFiBooster56_excluded = ["className"];
function WiFiBooster56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WiFiBooster56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WiFiBooster56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WiFiBooster56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WiFiBooster56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WiFiBooster56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WiFiBooster56_objectSpread(WiFiBooster56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.2 12.63c-.11.09-.18.25-.18.43l-1.83 33.36v.65c.01.42-.02.97.28 1.25.3.28 2.24.27 2.64.25 0 0-.21-1.55 1.29-1.55 1.4 0 7.63.02 8.87.02s1.06 1.53 1.06 1.53h1.78c1.11 0 1.01-.86 1.08-1.35.77-5.57-5.62-5.7-9.11-6.64-3.66-.98-3.8-6.39-3.95-9.49-.19-3.58.19-7.16 0-10.74-.14-2.56.25-6.26-1.55-7.71a.28.28 0 0 0-.19-.07c-.06 0-.12.02-.18.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.77 18.68a14.98 14.98 0 0 1 0 16.81M41.77 20.66a11.45 11.45 0 0 1 0 12.85M10.88 35.49a14.98 14.98 0 0 1 0-16.81M13.87 33.51a11.45 11.45 0 0 1 0-12.85"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.38 7.75c0-.35-.21-.63-.46-.63H21.79c-.26 0-.46.28-.46.63l-1.71 40.5c0 .35.26.63.58.63h2.26v-.47c0-.58.44-1.06.98-1.06h8.84c.54 0 .98.47.98 1.06v.47h2.26c.32 0 .58-.28.58-.63l-1.71-40.5Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WiFiBooster56 = (WiFiBooster56);
;// ./src/Picto/GeneratedPictoComponents/Security104.tsx


var Security104_excluded = ["className"];
function Security104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Security104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Security104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Security104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Security104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Security104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Security104_objectSpread(Security104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.14 65.05s2.68-2.59 4.41 2.6c1.73 5.19 5.95 12 13.41 15.14 7.46 3.14 14.34 8.07 13.71 11.46-7.8-4.03-31.16-16.68-31.16-16.68l-.38-12.52Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.81 22.81h12.86a2.86 2.86 0 0 1 2.86 2.86v50.52c0 1.07-.6 2.05-1.55 2.54L53.31 93.55c-.82.43-1.8.43-2.63 0L22.01 78.73a2.86 2.86 0 0 1-1.55-2.54V25.67a2.86 2.86 0 0 1 2.86-2.86h13.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.39 22.81h17.38"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 45.16a5.77 5.77 0 0 0-3.11 10.63v4.05c0 2.17.94 3.95 3.11 3.95h.02c2.17 0 3.11-1.78 3.11-3.95v-4.05a5.77 5.77 0 0 0-3.11-10.63H52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.23 46.1c0-.54 1.06-1.31 1.52-1.35 2.66-.29 3.17 9.3 3.65 11.22.83 3.32 1.59 7.22 4.01 9.81 2.2 2.35 5.39 3.44 8.51 3.81 2.69.32 6.4.67 9.19 1.2 3.14.6 4.02 4.02-.08 4.02H33.59s-4.37-.53-4.37-5.21V46.11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.28 68.71c0 3.35 2.74 6.09 6.09 6.09h33.3c3.35 0 6.09-2.74 6.09-6.09V42.08c0-3.35-2.74-6.09-6.09-6.09h-33.3c-3.35 0-6.09 2.74-6.09 6.09v26.63Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.1 35.99v-9.68c0-8.93 7.3-16.5 16.23-16.38 8.7.12 15.79 7.27 15.79 16.01v10.05h-6.74v-9.78c0-4.99-3.82-9.28-8.8-9.53-5.32-.26-9.74 3.99-9.74 9.26v10.05H36.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 45.16a5.77 5.77 0 0 0-3.11 10.63v4.05c0 2.17.94 3.95 3.11 3.95h.02c2.17 0 3.11-1.78 3.11-3.95v-4.05a5.77 5.77 0 0 0-3.11-10.63H52Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Security104 = (Security104);
;// ./src/Picto/GeneratedPictoComponents/Security56.tsx


var Security56_excluded = ["className"];
function Security56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Security56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Security56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Security56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Security56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Security56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Security56_objectSpread(Security56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.38 35.01s1.44-1.4 2.38 1.4c.93 2.79 3.2 6.46 7.22 8.15 4.02 1.69 7.72 4.35 7.38 6.17-4.2-2.17-16.78-8.98-16.78-8.98l-.2-6.74Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.51 12.27h6.93c.85 0 1.54.69 1.54 1.54v27.2c0 .58-.32 1.11-.83 1.37l-15.44 7.98c-.44.23-.97.23-1.41 0l-15.44-7.98c-.51-.26-.83-.79-.83-1.37v-27.2c0-.85.69-1.54 1.54-1.54h7.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.36 12.27h9.36"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.74 24.81c0-.29.57-.7.82-.73 1.43-.16 1.71 5.01 1.96 6.04.45 1.79.86 3.89 2.16 5.28 1.18 1.27 2.9 1.85 4.58 2.05 1.45.17 3.45.36 4.95.65 1.69.32 2.16 2.17-.04 2.17H18.09s-2.35-.29-2.35-2.81V24.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.3c-1.72 0-3.11 1.39-3.11 3.11 0 1.1.57 2.06 1.43 2.62v2.18c0 1.17.5 2.13 1.67 2.13H28c1.17 0 1.67-.96 1.67-2.13v-2.18c.86-.55 1.43-1.52 1.43-2.62 0-1.72-1.39-3.11-3.11-3.11h-.01Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.77 36.99c0 1.81 1.48 3.28 3.28 3.28h17.93c1.81 0 3.28-1.48 3.28-3.28V22.65c0-1.81-1.48-3.28-3.28-3.28H19.05c-1.8 0-3.28 1.48-3.28 3.28v14.34Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.3c-1.72 0-3.11 1.39-3.11 3.11 0 1.1.57 2.06 1.43 2.62v2.18c0 1.17.5 2.13 1.67 2.13H28c1.17 0 1.67-.96 1.67-2.13v-2.18c.86-.55 1.43-1.52 1.43-2.62 0-1.72-1.39-3.11-3.11-3.11h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.44 19.37v-5.21c0-4.81 3.93-8.88 8.74-8.82 4.69.06 8.5 3.92 8.5 8.62v5.41h-3.63V14.1c0-2.68-2.06-5-4.74-5.13a4.994 4.994 0 0 0-5.24 4.99v5.41h-3.63Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Security56 = (Security56);
;// ./src/Picto/GeneratedPictoComponents/SecurityHome104.tsx


var SecurityHome104_excluded = ["className"];
function SecurityHome104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityHome104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityHome104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityHome104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityHome104_objectSpread(SecurityHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.82 93.1c1.18 0 1.42-1.64.31-2-13.41-4.4-23.91-10.62-28.29-27.86-1.21-4.76-.58-6-2.32-5.2l-.27 2.05.07 29.65v3.36h30.5ZM50.08 11.22a2.796 2.796 0 0 1 3.64-.18l.21.18 40.86 39a2.792 2.792 0 0 1 .09 3.94c-1 1.04-2.61 1.14-3.72.28l-.22-.19L52 17.09 13.07 54.25c-1.04 1-2.66 1.02-3.73.1l-.21-.2c-1-1.04-1.02-2.66-.1-3.73l.2-.21 40.85-38.99Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.23 67.17s1.54-1.49 2.54 1.5c1.25 3.87 4.07 7.04 7.78 8.71 4.29 1.86 8.25 4.64 7.89 6.59-4.57-2.32-18-9.51-18-9.51l-.22-7.3Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.43 49.05V93.1H18.65v-3.36l-.08-40.69M11.14 93.1h81.72M23.54 36.51V18.82h9.67v8.53l-9.67 9.16z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.08 11.22a2.796 2.796 0 0 1 3.64-.18l.21.18 40.86 39a2.792 2.792 0 0 1 .09 3.94c-1 1.04-2.61 1.14-3.72.28l-.22-.19L52 17.09 13.07 54.25c-1.04 1-2.66 1.02-3.73.1l-.21-.2c-1-1.04-1.02-2.66-.1-3.73l.2-.21 40.85-38.99Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M61.08 42.9h7.43c.44 0 .86.17 1.17.47.31.31.49.73.49 1.16v29.06c0 .61-.34 1.18-.89 1.45l-16.53 8.52c-.47.26-1.05.26-1.52 0l-16.49-8.52c-.55-.27-.9-.83-.89-1.45V44.51c0-.44.17-.86.49-1.16.31-.31.73-.48 1.17-.47h7.56"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.02 42.88h10.01"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.98 56.27c0-.32.61-.74.87-.78 1.52-.17 1.86 5.35 2.1 6.46.3 2.02 1.09 3.93 2.3 5.57a7.978 7.978 0 0 0 4.9 2.19c1.54.19 3.71.37 5.29.69 1.58.32 2.3 2.32 0 2.32H41.38a2.926 2.926 0 0 1-2.41-2.93V56.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.98 55.73c-1.84 0-3.32 1.49-3.32 3.32-.02 1.12.53 2.17 1.47 2.79v2.34c0 1.24.54 2.27 1.86 2.27 1.24 0 1.86-1.02 1.86-2.27v-2.34c.96-.6 1.55-1.65 1.54-2.79 0-.89-.36-1.75-1-2.38-.64-.63-1.5-.97-2.4-.95Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "38.91",
        y: "50.46",
        width: "26.17",
        height: "22.34",
        rx: "3.51",
        ry: "3.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.84 50.46v-5.57c-.02-5.16 4.13-9.36 9.29-9.42 5.07.08 9.14 4.21 9.14 9.29v5.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.98 55.73c-1.84 0-3.32 1.49-3.32 3.32-.02 1.12.53 2.17 1.47 2.79v2.34c0 1.24.54 2.27 1.86 2.27 1.24 0 1.86-1.02 1.86-2.27v-2.34c.96-.6 1.55-1.65 1.54-2.79 0-.89-.36-1.75-1-2.38-.64-.63-1.5-.97-2.4-.95Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.39 50.14v-5.39a5.424 5.424 0 0 0-5.07-5.48 5.35 5.35 0 0 0-5.57 5.33v5.78"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityHome104 = (SecurityHome104);
;// ./src/Picto/GeneratedPictoComponents/SecurityHome56.tsx


var SecurityHome56_excluded = ["className"];
function SecurityHome56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityHome56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityHome56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityHome56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityHome56_objectSpread(SecurityHome56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.9 50c.7 0 .8-1 .2-1.2-7.8-2.5-13.8-6.1-16.4-16.1-.7-2.8-.3-3.5-1.3-3l-.1 1.2V50h17.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27 6c.5-.5 1.4-.6 2-.1V6l22 21c.6.6.6 1.5 0 2.1-.5.6-1.4.6-2 .1l-21-20-21 20c-.6.5-1.4.5-2 .1l-.1-.1c-.5-.6-.6-1.4-.1-2L5 27 27 6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.4 36.2s.8-.8 1.4.8c.7 2.1 2.2 3.8 4.2 4.7 2.3 1 4.4 2.5 4.2 3.5-2.5-1.2-9.7-5.1-9.7-5.1l-.1-3.9z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46 26.4v23.7H10V26.4M6 50.1h44M12.7 19.7v-9.6h5.2v4.6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27 6c.5-.5 1.4-.6 2-.1V6l22 21c.6.6.6 1.5 0 2.1-.5.6-1.4.6-2 .1l-21-20-21 20c-.6.5-1.4.5-2 .1l-.1-.1c-.5-.6-.6-1.4-.1-2L5 27 27 6z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.9 23.1h4c.2 0 .5.1.6.2.2.2.3.4.3.6v15.6c0 .3-.2.6-.5.8L28.4 45c-.3.1-.6.1-.8 0l-8.9-4.6c-.3-.2-.5-.5-.5-.8V24c0-.2.1-.5.3-.6s.4-.3.6-.2h4.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.3 23.1h5.4"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21 30.3c0-.2.3-.4.5-.4.8-.1 1 2.9 1.1 3.5.2 1.1.6 2.1 1.2 3 .7.7 1.6 1.1 2.6 1.2.8.1 2 .2 2.9.4s1.2 1.2 0 1.2h-7c-.8-.2-1.3-.9-1.3-1.6v-7.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 30c-1 0-1.8.8-1.8 1.8 0 .6.3 1.2.8 1.5v1.3c0 .7.3 1.2 1 1.2s1-.5 1-1.2v-1.3c.5-.3.8-.9.8-1.5 0-.5-.2-.9-.5-1.3-.4-.3-.8-.5-1.3-.5z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.8 27.2h10.3c1 0 1.9.8 1.9 1.9v8.3c0 1-.8 1.9-1.9 1.9H22.8c-1 0-1.9-.8-1.9-1.9v-8.3c.1-1.1.9-1.9 1.9-1.9z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.1 27.2v-3c0-2.8 2.2-5 5-5.1 2.7 0 4.9 2.3 4.9 5v2.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 30c-1 0-1.8.8-1.8 1.8 0 .6.3 1.2.8 1.5v1.3c0 .7.3 1.2 1 1.2s1-.5 1-1.2v-1.3c.5-.3.8-.9.8-1.5 0-.5-.2-.9-.5-1.3-.4-.3-.8-.5-1.3-.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.9 27v-2.9c0-1.5-1.2-2.9-2.7-3-.8 0-1.5.2-2.1.8-.6.5-.9 1.3-.9 2.1v3.1"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityHome56 = (SecurityHome56);
;// ./src/Picto/GeneratedPictoComponents/SecurityInternet104.tsx


var SecurityInternet104_excluded = ["className"];
function SecurityInternet104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityInternet104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityInternet104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityInternet104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityInternet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityInternet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityInternet104_objectSpread(SecurityInternet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.6 46.26c0-.3.59-.72.85-.74 1.49-.17 1.76 5.2 2.04 6.26.27 2.02 1.04 3.93 2.25 5.57a7.606 7.606 0 0 0 4.75 2.14c1.5.19 3.58.37 5.14.67 1.56.3 2.25 2.25 0 2.25H64.04a2.843 2.843 0 0 1-2.45-2.9V46.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.34 45.74a3.232 3.232 0 0 0-1.75 5.94v2.27c0 1.21.54 2.21 1.75 2.21s1.73-1 1.73-2.21v-2.27a3.223 3.223 0 0 0 1.39-3.63 3.228 3.228 0 0 0-3.12-2.32Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.43 23.62c0-.74.8-1.2 1.45-.82 4.8 2.81 5.75 10.03 6.11 15.03.5 6.97-.5 13.96-.04 20.93.4 6.04.99 16.58 8.31 18.5 7.07 1.84 19.94 2.09 18.39 12.94-.14.97-1.02 2.63-2.18 2.63H32.64c-1.73 0-3.16-1.15-3.21-2.92-.01-.42 0-.84 0-1.26V23.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.14 56.87s1.5-1.45 2.47 1.45c1.18 3.73 3.88 6.8 7.43 8.45 4.18 1.86 8.02 4.51 7.67 6.41-4.36-2.25-17.42-9.29-17.42-9.29l-.15-7.02Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.15 33.24h8.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.71 73.45v17.59c0 1.03-.83 1.86-1.86 1.86H31.34c-1.03 0-1.86-.83-1.86-1.86V12.89c0-1.03.83-1.86 1.86-1.86h30.51c1.03 0 1.86.83 1.86 1.86v14.74M41.85 83.34h9.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.55 33.24h6.84c.89.01 1.6.73 1.6 1.62v28.23c0 .6-.34 1.15-.87 1.43L75.09 72.8c-.47.22-1.02.22-1.49 0l-16.03-8.3c-.53-.28-.87-.83-.87-1.43V34.79c0-.89.71-1.61 1.6-1.62h6.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.52 64.17a30.318 30.318 0 0 1-5.27-17.11c0-6.34 1.95-12.22 5.27-17.12M23.65 60.14a23.262 23.262 0 0 1 0-26.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.04 40.62h18.57c.92-.02 1.82.34 2.47.99.66.65 1.02 1.54 1 2.47v14.86c0 1.88-1.52 3.4-3.4 3.4H65.11c-.91.01-1.79-.34-2.45-.97a3.45 3.45 0 0 1-1.03-2.42V44.09c-.01-.91.34-1.79.98-2.44.64-.65 1.51-1.02 2.42-1.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.34 45.74a3.232 3.232 0 0 0-1.75 5.94v2.27c0 1.21.54 2.21 1.75 2.21s1.73-1 1.73-2.21v-2.27a3.223 3.223 0 0 0 1.39-3.63 3.228 3.228 0 0 0-3.12-2.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.45 40.62v-5.4c0-2.42.94-4.74 2.64-6.46s4.02-2.69 6.44-2.7a8.99 8.99 0 0 1 8.84 8.95v5.57h-3.71v-5.42c.04-2.8-2.13-5.14-4.92-5.33a5.198 5.198 0 0 0-5.46 5.18v5.57l-3.83.04Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityInternet104 = (SecurityInternet104);
;// ./src/Picto/GeneratedPictoComponents/SecurityInternet56.tsx


var SecurityInternet56_excluded = ["className"];
function SecurityInternet56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityInternet56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityInternet56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityInternet56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityInternet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityInternet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityInternet56_objectSpread(SecurityInternet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.85 12.71c0-.4.43-.65.78-.44 2.59 1.52 3.1 5.4 3.29 8.09.27 3.75-.27 7.51-.02 11.27.22 3.25.53 8.93 4.48 9.96 3.81.99 10.74 1.13 9.9 6.97-.07.52-.55 1.41-1.17 1.41H17.59c-.93 0-1.7-.62-1.73-1.57V12.71Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.77 30.61s.81-.78 1.33.78a7.543 7.543 0 0 0 4 4.55c2.25 1 4.32 2.43 4.13 3.45-2.35-1.21-9.38-5-9.38-5l-.08-3.78Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.77 17.89h4.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.31 39v9.47c0 .55-.45 1-1 1H16.88c-.55 0-1-.45-1-1v-41c0-.55.45-1 1-1h16.43c.55 0 1 .45 1 1v7.4M22.53 44.86h5.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.99 17.89h3.68c.48 0 .86.39.86.87v15.2c0 .32-.18.62-.47.77l-8.63 4.46c-.25.12-.55.12-.8 0L31 34.72a.87.87 0 0 1-.47-.77V18.72c0-.48.38-.86.86-.87h3.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.17 24.9c0-.16.32-.39.46-.4.8-.09.95 2.8 1.1 3.37.14 1.09.56 2.12 1.21 3 .69.67 1.6 1.08 2.56 1.15.81.1 1.93.2 2.77.36.84.16 1.21 1.21 0 1.21h-6.78c-.77-.11-1.34-.78-1.32-1.56V24.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.03 24.62c-.77 0-1.45.51-1.66 1.25-.22.74.08 1.53.72 1.95v1.22c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.22c.66-.41.97-1.21.75-1.95-.22-.75-.9-1.26-1.68-1.25Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.43 34.54a16.365 16.365 0 0 1 0-18.43M12.74 32.37c-1.37-2.02-2.17-4.44-2.17-7.04s.8-5.03 2.17-7.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.02 21.86h10a1.825 1.825 0 0 1 1.87 1.86v8c0 1.01-.82 1.83-1.83 1.83h-10c-.49 0-.97-.18-1.32-.52-.35-.34-.55-.81-.55-1.31v-8c0-.49.18-.96.53-1.31.34-.35.81-.55 1.3-.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.03 24.62c-.77 0-1.45.51-1.66 1.25-.22.74.08 1.53.72 1.95v1.22c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.22c.66-.41.97-1.21.75-1.95-.22-.75-.9-1.26-1.68-1.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.24 21.86v-2.91c0-1.3.51-2.55 1.42-3.48s2.16-1.45 3.47-1.45c2.63.04 4.75 2.19 4.76 4.82v3h-2v-2.92a2.835 2.835 0 0 0-2.65-2.87 2.805 2.805 0 0 0-2.94 2.79v3l-2.06.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityInternet56 = (SecurityInternet56);
;// ./src/Picto/GeneratedPictoComponents/SecurityMobile104.tsx


var SecurityMobile104_excluded = ["className"];
function SecurityMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityMobile104_objectSpread(SecurityMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.72 56.87s1.5-1.45 2.47 1.45c1.18 3.73 3.88 6.8 7.43 8.45 4.18 1.86 8.02 4.51 7.67 6.41-4.36-2.25-17.42-9.29-17.42-9.29l-.15-7.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.63 87.04c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63V87.3c0 4.01 1.37 5.41 5.38 5.41H58.9c.19-2.29-1.33-4.44-3.26-5.68Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.72 33.24h8.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.12 33.24h6.84c.89.01 1.6.73 1.6 1.62v28.23c0 .6-.34 1.15-.87 1.43L69.66 72.8c-.47.22-1.02.22-1.49 0l-16.03-8.3c-.53-.28-.87-.83-.87-1.43V34.79c0-.89.71-1.61 1.6-1.62h6.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.7 78.02v9.29c0 3.08-2.49 5.57-5.57 5.57H29.7c-3.08 0-5.57-2.49-5.57-5.57V16.73c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v3.71M44.56 14.88h3.71M40.84 89.16h11.15"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.17 46.26c0-.3.59-.72.85-.74 1.49-.17 1.76 5.2 2.04 6.26.27 2.02 1.04 3.93 2.25 5.57a7.606 7.606 0 0 0 4.75 2.14c1.5.19 3.58.37 5.14.67 1.56.3 2.25 2.25 0 2.25H58.61a2.843 2.843 0 0 1-2.45-2.9V46.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.91 45.74a3.232 3.232 0 0 0-1.75 5.94v2.27c0 1.21.54 2.21 1.75 2.21s1.73-1 1.73-2.21v-2.27a3.223 3.223 0 0 0 1.39-3.63 3.228 3.228 0 0 0-3.12-2.32Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.61 40.62h18.57c.92-.02 1.82.34 2.47.99.66.65 1.02 1.54 1 2.47v14.86c0 1.88-1.52 3.4-3.4 3.4H59.68c-.91.01-1.79-.34-2.45-.97a3.45 3.45 0 0 1-1.03-2.42V44.09c-.01-.91.34-1.79.98-2.44.64-.65 1.51-1.02 2.42-1.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.91 45.74a3.232 3.232 0 0 0-1.75 5.94v2.27c0 1.21.54 2.21 1.75 2.21s1.73-1 1.73-2.21v-2.27a3.223 3.223 0 0 0 1.39-3.63 3.228 3.228 0 0 0-3.12-2.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.02 40.62v-5.4c0-2.42.94-4.74 2.64-6.46s4.02-2.69 6.44-2.7a8.99 8.99 0 0 1 8.84 8.95v5.57h-3.71v-5.42c.04-2.8-2.13-5.14-4.92-5.33a5.198 5.198 0 0 0-5.46 5.18v5.57l-3.83.04Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityMobile104 = (SecurityMobile104);
;// ./src/Picto/GeneratedPictoComponents/SecurityMobile56.tsx


var SecurityMobile56_excluded = ["className"];
function SecurityMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SecurityMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SecurityMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SecurityMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SecurityMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SecurityMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SecurityMobile56_objectSpread(SecurityMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.77 30.61s.81-.78 1.33.78a7.543 7.543 0 0 0 4 4.55c2.25 1 4.32 2.43 4.13 3.45-2.35-1.21-9.38-5-9.38-5l-.08-3.78Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.95 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.77 17.89h4.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.99 17.89h3.68c.48 0 .86.39.86.87v15.2c0 .32-.18.62-.47.77l-8.63 4.46c-.25.12-.55.12-.8 0L28 34.72a.87.87 0 0 1-.47-.77V18.72c0-.48.38-.86.86-.87h3.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.99 42v5c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v2M23.99 8h2M21.99 48h6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.17 24.9c0-.16.32-.39.46-.4.8-.09.95 2.8 1.1 3.37.14 1.09.56 2.12 1.21 3 .69.67 1.6 1.08 2.56 1.15.81.1 1.93.2 2.77.36.84.16 1.21 1.21 0 1.21h-6.78c-.77-.11-1.34-.78-1.32-1.56V24.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.03 24.62c-.77 0-1.45.51-1.66 1.25-.22.74.08 1.53.72 1.95v1.22c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.22c.66-.41.97-1.21.75-1.95-.22-.75-.9-1.26-1.68-1.25Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.02 21.86h10a1.825 1.825 0 0 1 1.87 1.86v8c0 1.01-.82 1.83-1.83 1.83h-10c-.49 0-.97-.18-1.32-.52-.35-.34-.55-.81-.55-1.31v-8c0-.49.18-.96.53-1.31.34-.35.81-.55 1.3-.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.03 24.62c-.77 0-1.45.51-1.66 1.25-.22.74.08 1.53.72 1.95v1.22c0 .65.29 1.19.94 1.19.65 0 .93-.54.93-1.19v-1.22c.66-.41.97-1.21.75-1.95-.22-.75-.9-1.26-1.68-1.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.24 21.86v-2.91c0-1.3.51-2.55 1.42-3.48s2.16-1.45 3.47-1.45c2.63.04 4.75 2.19 4.76 4.82v3h-2v-2.92a2.835 2.835 0 0 0-2.65-2.87 2.805 2.805 0 0 0-2.94 2.79v3l-2.06.02Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SecurityMobile56 = (SecurityMobile56);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveCollaborationCloud104.tsx


var AdaptiveCollaborationCloud104_excluded = ["className"];
function AdaptiveCollaborationCloud104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveCollaborationCloud104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveCollaborationCloud104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveCollaborationCloud104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveCollaborationCloud104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveCollaborationCloud104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveCollaborationCloud104_objectSpread(AdaptiveCollaborationCloud104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.07 77.78c1.71.18 13.23.47 20.89.24 1-.03 1.07-1.48.08-1.63-27.21-4.21-29.49-8.42-29.64-20.27-.01-.75-.95-1.11-1.45-.54-1.96 2.22-4.04 6.03-3.56 9.21 1.15 7.68 5 12.06 13.69 12.99Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.52 78.32H25.61c-7.64 0-13.83-6.19-13.83-13.83 0-6.92 5.08-12.65 11.71-13.67-.64-1.62-.99-3.39-.99-5.23 0-7.89 6.4-14.28 14.28-14.28 2.85 0 5.5.83 7.73 2.27 3.15-5.38 8.99-8.99 15.68-8.99 10.03 0 18.16 8.13 18.16 18.16v.53c7.98 1.94 13.89 8.93 13.89 17.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.23 60.53c0 1.84-.29 3.61-.82 5.28"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.03 67.18c2.07.71 2.64 7.5 10.99 12.3 3.75 1.77 6.83-.22 8.22.74 1.38.96-3.49 3.21-4.75 3.11s-7.45-.71-12.31-7.61c-4.87-6.91-3.79-9.19-2.15-8.54"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.88 31.34-7.55-4.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.41 18.98 6.19 6.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.79 20.12-4.41-7.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "69.31",
        cy: "72.67",
        r: "18.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.49 83.33c-2.24 0-5.81-.96-10.34-5.49-8.47-8.47-4.69-13.7-4.53-13.91l1.28-1.28c.85-.85 2.4-.85 3.29-.04l2.61 2.61c.86.93.87 2.37-.02 3.27l-.02.02-1.17 1.22c.75 1.22 1.7 2.4 2.77 3.52l.37.37c1.06 1.06 2.24 1.97 3.52 2.77l1.17-1.17c.85-.85 2.4-.85 3.25 0l2.61 2.61c.43.43.69 1.01.69 1.65s-.27 1.17-.69 1.65c0 0-2.61 2.18-4.8 2.18Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveCollaborationCloud104 = (AdaptiveCollaborationCloud104);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveCollaborationCloud56.tsx


var AdaptiveCollaborationCloud56_excluded = ["className"];
function AdaptiveCollaborationCloud56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveCollaborationCloud56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveCollaborationCloud56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveCollaborationCloud56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveCollaborationCloud56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveCollaborationCloud56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveCollaborationCloud56_objectSpread(AdaptiveCollaborationCloud56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.26 40.78c.87.09 6.76.24 10.68.12.51-.01.55-.76.04-.84-13.91-2.15-15.07-4.3-15.15-10.36 0-.39-.48-.57-.74-.28-1 1.13-2.06 3.08-1.82 4.71.59 3.93 2.56 6.16 6.99 6.64Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.72 41.05H14.03a7.073 7.073 0 0 1-1.09-14.06c-.33-.83-.51-1.73-.51-2.67a7.302 7.302 0 0 1 11.25-6.14c1.61-2.75 4.6-4.6 8.02-4.6 5.13 0 9.28 4.16 9.28 9.28v.27c4.08.99 7.1 4.56 7.1 8.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.08 31.96c0 .94-.15 1.85-.42 2.7"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M31.62 35.36c1.06.36 1.35 3.84 5.62 6.29 1.92.9 3.49-.11 4.2.38s-1.78 1.64-2.43 1.59-3.81-.36-6.29-3.89c-2.49-3.53-1.94-4.7-1.1-4.36",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.61 17.04-3.85-2.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.86 10.72 3.17 3.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.19 11.3-2.26-3.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "36.37",
        cy: "38.17",
        r: "9.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.01 43.61c-1.14 0-2.97-.49-5.28-2.81-4.33-4.33-2.4-7-2.31-7.11l.65-.65c.44-.44 1.23-.44 1.68-.02l1.33 1.33c.44.47.44 1.21 0 1.67h-.01l-.6.64c.38.63.87 1.23 1.42 1.8l.19.19c.54.54 1.14 1.01 1.8 1.42l.6-.6c.44-.44 1.23-.44 1.66 0l1.33 1.33c.22.22.35.52.35.85s-.14.6-.35.85c0 0-1.33 1.12-2.45 1.12Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveCollaborationCloud56 = (AdaptiveCollaborationCloud56);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveCollaborationPhone104.tsx


var AdaptiveCollaborationPhone104_excluded = ["className"];
function AdaptiveCollaborationPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveCollaborationPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveCollaborationPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveCollaborationPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveCollaborationPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveCollaborationPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveCollaborationPhone104_objectSpread(AdaptiveCollaborationPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.36 25.63s1.11 16.44 13.8 21.98c0 0-10.06 3.15-15.28-7.48 0 0-4.18-11.24 1.48-14.5ZM27.27 61.03c.92 2.62 2.15 17.45 26.51 21.59.97.17 1.01 1.56.05 1.75-7.04 1.43-21.34 2.29-31.8-10.59a.15.15 0 0 1-.04-.11c-.02-.74-.18-8.2 3.27-12.73.1-.13 1.4-1.65 2.01.09Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "48.2",
        cy: "34.18",
        r: "13.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.05 84.86c-2.22.42-4.51.64-6.85.64-20.28 0-36.73-16.44-36.73-36.73S27.92 12.04 48.2 12.04s36.73 16.44 36.73 36.73c0 2.1-.18 4.15-.51 6.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.98 73.67c0-13.57 11.74-25.68 26.22-25.68 6.56 0 12.63 2.59 17.3 6.68"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.2 69.2c1.95.67 5.65 10.24 10.02 12.3 3.54 1.67 6.79-.91 8.09 0 1.3.91-3.29 3.03-4.48 2.93s-7.02-.67-11.61-7.18-3.58-8.67-2.03-8.05"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "74.95",
        cy: "74.38",
        r: "17.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.83 84.43c-2.11 0-5.48-.91-9.75-5.18-7.99-7.99-4.42-12.92-4.27-13.12.09-.1 1.21-1.2 1.21-1.2.8-.8 2.26-.8 3.1-.04l2.46 2.46c.81.87.82 2.24-.02 3.08l-.02.02-1.11 1.15c.7 1.15 1.61 2.26 2.61 3.32l.35.35c1 1 2.11 1.86 3.32 2.61l1.11-1.11c.8-.8 2.26-.8 3.07 0l2.46 2.46c.4.4.65.96.65 1.56s-.25 1.1-.65 1.56c0 0-2.46 2.06-4.52 2.06Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveCollaborationPhone104 = (AdaptiveCollaborationPhone104);
;// ./src/Picto/GeneratedPictoComponents/AdaptiveCollaborationPhone56.tsx


var AdaptiveCollaborationPhone56_excluded = ["className"];
function AdaptiveCollaborationPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AdaptiveCollaborationPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AdaptiveCollaborationPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AdaptiveCollaborationPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AdaptiveCollaborationPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AdaptiveCollaborationPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AdaptiveCollaborationPhone56_objectSpread(AdaptiveCollaborationPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.34 14.2s.58 8.61 7.22 11.51c0 0-5.27 1.65-8-3.92 0 0-2.19-5.88.77-7.59ZM15.05 32.73c.48 1.37 1.13 9.13 13.88 11.3.51.09.53.82.02.92-3.69.75-11.17 1.2-16.65-5.55-.01-.02-.02-.04-.02-.06-.01-.39-.09-4.29 1.71-6.66.05-.07.73-.86 1.05.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.01",
        cy: "18.67",
        r: "7.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.6 45.2c-1.16.22-2.36.33-3.59.33-10.62 0-19.23-8.61-19.23-19.23S15.39 7.08 26.01 7.08s19.23 8.61 19.23 19.23c0 1.1-.09 2.17-.27 3.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.28 39.34c0-7.11 6.15-13.44 13.73-13.44 3.44 0 6.61 1.35 9.06 3.49"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.43 37c1.02.35 2.96 5.36 5.25 6.44 1.85.87 3.56-.47 4.24 0s-1.72 1.59-2.34 1.53-3.68-.35-6.08-3.76c-2.4-3.41-1.87-4.54-1.06-4.22"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.02",
        cy: "39.72",
        r: "9.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.57 44.98c-1.1 0-2.87-.47-5.1-2.71-4.18-4.18-2.32-6.76-2.24-6.87l.63-.63c.42-.42 1.18-.42 1.62-.02l1.29 1.29c.42.46.43 1.17 0 1.61s-.58.61-.58.61c.37.6.84 1.18 1.37 1.74l.18.18c.53.53 1.1.97 1.74 1.37l.58-.58c.42-.42 1.18-.42 1.61 0l1.29 1.29c.21.21.34.5.34.82s-.13.58-.34.82c0 0-1.29 1.08-2.37 1.08Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AdaptiveCollaborationPhone56 = (AdaptiveCollaborationPhone56);
;// ./src/Picto/GeneratedPictoComponents/AddPhone104.tsx


var AddPhone104_excluded = ["className"];
function AddPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AddPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AddPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AddPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AddPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AddPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AddPhone104_objectSpread(AddPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.87 37.37s1.27-1.69 2.7-1.03S61 42 64 47s7 7 11 7 5.18 2.27 5.18 2.27l-4.5 2.06-4.37-.26-5.14-1.54-3.99-3.99-2.7-4.37-.89-4.76 1.28-6.04",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 65v22.29c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v5.57M44.57 14.86h3.72M40.86 89.14H52"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "73.22",
        cy: "43.41",
        r: "14.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.22 37.41v12M67.22 43.41h12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AddPhone104 = (AddPhone104);
;// ./src/Picto/GeneratedPictoComponents/AddPhone56.tsx


var AddPhone56_excluded = ["className"];
function AddPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AddPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AddPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AddPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AddPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AddPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AddPhone56_objectSpread(AddPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.27 19.88s.72-.95 1.52-.58-.89 3.2.81 6.02 3.95 3.95 6.21 3.95 2.93 1.28 2.93 1.28l-2.54 1.16-2.47-.15-2.9-.87-2.25-2.25-1.52-2.47-.51-2.69.72-3.41",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "39.55",
        cy: "23.5",
        r: "8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.55 20.22v6.56M36.27 23.5h6.56"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AddPhone56 = (AddPhone56);
;// ./src/Picto/GeneratedPictoComponents/AppMyTelstra104.tsx


var AppMyTelstra104_excluded = ["className"];
function AppMyTelstra104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AppMyTelstra104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AppMyTelstra104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AppMyTelstra104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AppMyTelstra104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AppMyTelstra104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AppMyTelstra104_objectSpread(AppMyTelstra104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.62 42.4c-9.71 2.28-5.27 13.55-1.87 19.05.14.22.48.05.39-.2-4.49-12.31-.47-16.96 1.67-18.47.2-.14.05-.44-.18-.39Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.37 63.24s-.11-.05-.16-.01-.05.11-.01.16c10.21 13.18 26.02 18.6 32.34 14.52 1.73-5.29-14.55 2.06-32.17-14.67Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.51 51.37 55.56 62.8c-.4 2.06-1.76 2.61-2.96 2.61h-9.01l3.8-20.94c-3.79-1.73-7.66-2.87-10.75-2.87s-5.31.79-6.9 2.69c-1.12 1.35-1.67 3.02-1.67 5 0 5.95 4.68 14.21 12.69 20.95 7.14 5.96 15 9.29 20.72 9.29 2.85 0 5.16-.87 6.67-2.62 1.19-1.35 1.66-3.1 1.66-5.08 0-5.78-4.72-13.89-12.31-20.48Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.01 51.12c.32-1.49.18-2.17.11-2.11s-2.8 15.98-2.8 15.98h8.55c-5.44 0-7.5-5.9-5.86-13.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.02 30.69c4.09.3 6.49 1.73 7.29 3.09.13.22.47.16.52-.1l.65-3.54a.29.29 0 0 0-.28-.34H57.7s.12.5 5.33.88Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.89 54.74c.06.5.12 1.01.19 1.51.08.59.17 1.19.27 1.78.11.67.23 1.34.37 2 .15.73.31 1.46.49 2.19.19.78.4 1.56.63 2.33.24.82.5 1.63.79 2.43s.62 1.68.97 2.5.75 1.7 1.17 2.53C23.71 79.8 30.66 85.9 39 88.55c1.3.41 2.62.75 3.95 1.02 1.44.29 2.9.51 4.37.66.68.07 1.37.11 2.05.2 1.28.16 2.25.56 3.25 1.37.06.05.25.26.33.26l-24.8.27s-16.86-.8-16.33-21.8V51.44l.22.06a3.81 3.81 0 0 1 2.85 3.25Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "10.99",
        y: "11",
        width: "82",
        height: "82",
        rx: "19.09",
        ry: "19.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.33 29.23c-1.43 0-2.62.96-2.94 2.47l-1.27 6.9h11.33l-4.86 26.82h9.01c1.2 0 2.56-.56 2.96-2.61l4.12-24.21h8.15c1.44 0 2.62-.95 2.94-2.46l1.27-6.91H41.32Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AppMyTelstra104 = (AppMyTelstra104);
;// ./src/Picto/GeneratedPictoComponents/AppMyTelstra56.tsx


var AppMyTelstra56_excluded = ["className"];
function AppMyTelstra56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function AppMyTelstra56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? AppMyTelstra56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : AppMyTelstra56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function AppMyTelstra56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, AppMyTelstra56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", AppMyTelstra56_objectSpread(AppMyTelstra56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.82 22.52c-5.06 1.19-2.74 7.06-.98 9.92.07.12.25.03.2-.1-2.34-6.41-.24-8.84.87-9.62.1-.07.03-.23-.1-.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.69 33.37s-.06-.03-.08 0c-.02.02-.03.06 0 .08 5.32 6.87 13.55 9.69 16.85 7.57.9-2.76-7.58 1.08-16.76-7.64Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.75 27.19-1.01 5.96c-.21 1.07-.91 1.36-1.54 1.36h-4.69l1.98-10.91c-1.98-.9-3.99-1.49-5.6-1.49s-2.77.41-3.59 1.4c-.58.7-.87 1.57-.87 2.61 0 3.1 2.44 7.4 6.61 10.91 3.72 3.1 7.82 4.84 10.8 4.84 1.49 0 2.69-.46 3.47-1.36.62-.7.87-1.61.87-2.65 0-3.01-2.46-7.24-6.41-10.67Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.28 27.06c.17-.78.1-1.13.06-1.1s-1.46 8.32-1.46 8.32h4.45c-2.83 0-3.91-3.07-3.05-7.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.62 16.41c2.13.16 3.38.9 3.8 1.61.07.12.24.08.27-.05l.34-1.84c.02-.09-.05-.17-.15-.17h-7.03s.06.26 2.77.46Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.64 29.45c.03.26.07.53.1.79.04.31.09.62.14.93.06.35.12.7.19 1.05.08.38.16.76.26 1.14.1.41.21.82.33 1.22.13.43.26.85.41 1.28s.33.88.51 1.31.39.89.61 1.32c2.07 4.08 5.71 7.28 10.07 8.66.68.22 1.37.39 2.07.54.76.15 1.52.27 2.29.35.36.04.72.06 1.07.1.67.08 1.18.3 1.7.72.03.02.13.14.17.14l-12.99.14s-8.83-.42-8.55-11.42v-10l.12.03c.8.21 1.4.88 1.5 1.7Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6.58",
        y: "6.58",
        width: "42.84",
        height: "42.84",
        rx: "10",
        ry: "10"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.32 15.65c-.75 0-1.36.5-1.53 1.29l-.66 3.59h5.9L24.5 34.5h4.69c.63 0 1.33-.29 1.54-1.36l2.15-12.61h4.25c.75 0 1.37-.5 1.53-1.28l.66-3.6h-16Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_AppMyTelstra56 = (AppMyTelstra56);
;// ./src/Picto/GeneratedPictoComponents/Appointment104.tsx


var Appointment104_excluded = ["className"];
function Appointment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Appointment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Appointment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Appointment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Appointment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Appointment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Appointment104_objectSpread(Appointment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.72 42.54c5.76-11.79 11.32-17.85 15.45-20.95 1.5-1.13.86-3.68-.95-3.8l-10.74-.76-5.87 7.34-.39 17.45c-.03 1.53 1.84 2.07 2.5.72Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.28 75.08v10.33c0 4.67-3.78 8.45-8.45 8.45H18.67c-4.67 0-8.45-3.78-8.45-8.45V26.25c0-4.67 3.78-8.45 8.45-8.45h59.16c4.67 0 8.45 3.78 8.45 8.45v21.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.02 10.14v16.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.21 10.14v16.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.21 43.95h76.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.54 64.09h10.9M20.54 75.85h10.9M20.54 87.39h10.9M40.96 64.09h10.9M40.96 75.85h10.9M40.96 87.39h10.9M61.34 52.33h10.9M61.34 64.09h10.9M40.96 52.33h10.9"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M81.7 59s3.23.58 2.04 2.53-11.55 11.51-11.72 13.3c-.17 1.78 2.51 5.27 2.51 5.27l-4.76 5.27-8.54 1.27 1.45-7.54 3.86-5.38L81.7 59Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M95.21 52.82c1.78 1.78 2.06 3.44 1.94 4.36L71.18 83.15c-4.09 4.09-10.17 3.75-10.17 3.75s-.35-6.08 3.75-10.17l25.97-25.97c.92-.12 2.59.17 4.36 1.95l.12.12Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.42 54.97 6.12 5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65 77.42 5.74 5.74"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Appointment104 = (Appointment104);
;// ./src/Picto/GeneratedPictoComponents/Appointment56.tsx


var Appointment56_excluded = ["className"];
function Appointment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Appointment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Appointment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Appointment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Appointment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Appointment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Appointment56_objectSpread(Appointment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.29 22.78c3.22-6.02 6.33-9.11 8.63-10.69.84-.57.48-1.88-.53-1.94l-6-.39-3.28 3.75-.22 8.91c-.02.78 1.03 1.06 1.4.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.34 41.47v4.42c0 2.47-2 4.48-4.48 4.48H10.51c-2.47 0-4.48-2-4.48-4.48V14.54c0-2.47 2-4.48 4.48-4.48h31.35c2.47 0 4.48 2.01 4.48 4.48V28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.08 6v8.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.16 6v8.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.03 23.92h40.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.98 35.1h5.49M11.98 41.01h5.49M11.98 46.82h5.49M23.44 35.1h5.49M23.44 41.01h5.49M23.44 46.82h5.49M34.52 29.18H40M34.52 35.1H40M23.44 29.18h5.49"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M43.93 34.3s1.49.26.94 1.15-5.31 5.24-5.39 6.06 1.15 2.4 1.15 2.4l-2.19 2.4-3.93.58.67-3.43 1.77-2.45 6.97-6.7Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.22 31.17c.82.82.95 1.58.89 2L39.19 45.09c-1.88 1.88-4.67 1.72-4.67 1.72s-.16-2.79 1.72-4.67l11.92-11.92c.42-.05 1.19.08 2 .89l.05.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.65 32.16 2.81 2.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.35 42.47 2.64 2.63"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Appointment56 = (Appointment56);
;// ./src/Picto/GeneratedPictoComponents/Bundles104.tsx


var Bundles104_excluded = ["className"];
function Bundles104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bundles104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bundles104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bundles104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bundles104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bundles104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bundles104_objectSpread(Bundles104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.38 60.39c-.79-1.16-2.1-1.79-2.96-2.89-3.75-4.6-2.28-10.86-.92-16.08.31-1.32.6-2.13-.77-2.85l-.05.11-6.88 16.04c-.65 1.52.05 3.27 1.57 3.93l4.92 2.11h5.3c-.06-.12-.13-.24-.21-.36ZM41.83 59.91l-.17-.53s-2.11.69-9.29-1.61c-7.18-2.31-10.32-8.28-12.93-14.43-2.61-6.15-2.92-8.86-5.55-7.99l.05.17 8.31 25.24h17.03l2.55-.84ZM56.55 73.28 52.4 61.76l-.38 29.55h8.56s5.44-13.55 22.98-13.17v-4.86H56.55ZM19.26 76.47h26.53c.71 0 1.33-.32 1.5-.77l.81-2.19H19.26v2.96Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "26.62",
      cy: "20.64",
      r: ".82",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.29 60.76-5.38-2.3a2.488 2.488 0 0 1-1.31-3.28l11.11-25.91a2.488 2.488 0 0 1 3.28-1.31l12.11 5.19c1.27.54 1.86 2.01 1.31 3.28L82.06 60.57M83.46 33l1.46.63M70.7 57.12l4.36 1.87M35.98 58.55l5.97-1.97M22.14 60.76 10.76 26.17c-.52-1.57.34-3.27 1.91-3.79l26.21-8.63c1.57-.52 3.27.34 3.79 1.91L54.8 52.52c.52 1.57-.34 3.27-1.91 3.79l-13.42 4.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.09 60.73h31.92v30.59H20.09V74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.86 74.15v17.17H51.99V60.73h31.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.11 60.75-7.1 12.53h34.5l4.52-12.53H20.11zM83.9 60.75l7.09 12.53H56.55l-4.52-12.53H83.9z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m56.83 29.6-3.34 3.52c-.41.34-.2.55 0 .75l3.02 2.89c.11.11.31.03.31-.13 0-.13-.05-.3-.15-.49-.28-.56-1.07-2.57-.43-4.23.64-1.66 1.12-1.96.94-2.28-.12-.21-.25-.12-.35-.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.44 57.18c-.22 0-.45-.07-.64-.23a1 1 0 0 1-.14-1.41c.28-.33.52-.67.75-1 .31-.46.93-.58 1.39-.27.46.31.58.93.27 1.39-.26.39-.55.78-.86 1.15a.99.99 0 0 1-.77.36ZM60.73 53.09c-.1 0-.2-.02-.3-.05a.999.999 0 0 1-.65-1.26c.3-.94.45-1.91.45-2.89 0-.55.44-1.06.99-1.06s.99.38 1 .93v.07c0 1.26-.18 2.43-.54 3.56-.13.43-.53.7-.95.7ZM60.68 46.46c-.43 0-.82-.27-.95-.7-.52-1.67-1.28-2.74-1.29-2.75a.994.994 0 0 1 .23-1.39 1 1 0 0 1 1.39.22c.04.05.95 1.33 1.58 3.33a.997.997 0 0 1-.66 1.25c-.1.03-.2.05-.3.05Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m62.42 33-5.01 5.19c-.18.19-.5.17-.72-.04l-4.42-4.23c-.22-.21-.24-.52-.06-.71l6.14-6.37c.21-.22.58-.2.84.04l3.24 3.1c.24.23.33.43.35.65l.04 1.57c0 .29-.09.49-.39.8Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bundles104 = (Bundles104);
;// ./src/Picto/GeneratedPictoComponents/Bundles56.tsx


var Bundles56_excluded = ["className"];
function Bundles56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bundles56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bundles56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bundles56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bundles56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bundles56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bundles56_objectSpread(Bundles56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.13 32.52c-.42-.62-1.13-.96-1.59-1.56-2.02-2.48-1.23-5.85-.49-8.66.17-.71.32-1.15-.42-1.54l-.03.06-3.7 8.64c-.35.82.03 1.76.84 2.11l2.65 1.14h2.85c-.03-.07-.07-.13-.11-.19ZM22.53 32.26l-.09-.28s-1.14.37-5-.87c-3.87-1.24-5.56-4.46-6.96-7.77-1.4-3.31-1.57-4.77-2.99-4.3l.03.09 4.47 13.59h9.17l1.37-.45ZM30.45 39.46l-2.24-6.2L28 49.17h4.61s2.93-7.3 12.37-7.09v-2.62H30.44ZM10.37 41.17h14.29c.38 0 .72-.17.81-.42l.44-1.18H10.38v1.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "14.33",
      cy: "11.11",
      r: ".49",
      className: "strokeprimaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.39 32.71-2.89-1.24c-.68-.29-1-1.08-.71-1.77l5.98-13.95c.29-.68 1.08-1 1.77-.71l6.52 2.8c.68.29 1 1.08.71 1.77l-5.57 13M44.94 17.77l.78.34M38.07 30.76l2.35 1M19.37 31.52l3.22-1.05M11.92 32.71 5.79 14.09c-.28-.85.18-1.76 1.03-2.04l14.11-4.64c.85-.28 1.76.18 2.04 1.03l6.53 19.85c.28.85-.18 1.76-1.03 2.04l-7.23 2.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.82 32.7h17.19v16.47H10.82v-9.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.15 39.93v9.24H27.99V32.7h17.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.83 32.71-3.82 6.75h18.57l2.44-6.75H10.83zM45.18 32.71l3.81 6.75H30.45l-2.43-6.75h17.16z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m30.73 15.81-1.96 2.06c-.24.2-.12.32 0 .44l1.75 1.67c.06.06.18.02.18-.08 0-.08-.03-.17-.08-.28-.16-.33-.62-1.5-.24-2.47.38-.97.66-1.15.56-1.33-.07-.12-.15-.07-.2-.01Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.47 30.79c-.12 0-.24-.04-.34-.12a.54.54 0 0 1-.07-.76c.15-.18.28-.36.4-.54.17-.25.5-.31.75-.14.25.17.31.5.14.75-.14.21-.3.42-.46.62-.11.13-.26.2-.42.2ZM32.7 28.59c-.05 0-.11 0-.16-.03a.542.542 0 0 1-.35-.68c.16-.5.24-1.03.24-1.56 0-.3.24-.57.54-.57.29 0 .53.2.54.5v.04c0 .68-.1 1.31-.29 1.92-.07.23-.28.38-.51.38ZM32.68 25.02c-.23 0-.44-.15-.51-.38-.28-.9-.69-1.48-.7-1.48a.54.54 0 0 1 .12-.75.54.54 0 0 1 .75.12c.02.03.51.71.85 1.79.09.28-.07.59-.35.67-.05.02-.11.02-.16.02Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m33.61 17.77-2.7 2.79c-.1.1-.27.09-.39-.02l-2.38-2.28c-.12-.11-.13-.28-.03-.38l3.31-3.43c.11-.12.31-.11.45.02l1.74 1.67c.13.12.18.23.19.35l.02.84c0 .16-.05.27-.21.43Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bundles56 = (Bundles56);
;// ./src/Picto/GeneratedPictoComponents/ClickAndCollect104.tsx


var ClickAndCollect104_excluded = ["className"];
function ClickAndCollect104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ClickAndCollect104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ClickAndCollect104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ClickAndCollect104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ClickAndCollect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ClickAndCollect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ClickAndCollect104_objectSpread(ClickAndCollect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M80.68 21.73C76.82 20.58 74 37.48 70.24 38.56l9.66.29 2.24-17.12h-1.45ZM31.61 55.6c-.12.9 3.23.98 3.04.98l1.34-4.55-.02 3.03c0 1.96-1.46 3.57-3.27 3.57s-3.26-1.61-3.26-3.62l.02-3.11.07-9.28c0-.88.05-2.32.14-3.16l1.95.17-.31 1.86.31 14.12ZM65.64 55.57c-.12.91 3.26 1 3.07.99l1.35-4.6-.02 3.06c0 1.99-1.48 3.6-3.3 3.6s-3.29-1.63-3.29-3.65l.02-3.15.07-9.38c0-.89.05-2.34.14-3.2l1.97.17-.32 1.87.31 14.27ZM52.42 96.19H28.36c-4.81 0-8.72-3.91-8.72-8.72v-30.5c9.99 8.98 18.57 35.71 32.78 39.22Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.74 27.04 3.99 3.99c.64.64 3.2 1.18 4.49-.11l4.56-4.56c-.23-.31-.7-.27-1.41.11-1.07.58-4.54 1.94-7.4.97-2.86-.97-3.31-1.8-3.92-1.44-.04.02-.07.04-.11.07-.36.23-.46.71-.19.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.59 22.27c.32.69 1.88 3.41 3.38 2.43l.73 4.6s-1.79 2.24-3.08-.52l-1.03-6.5ZM29.04 18.98s2.1 1.83 3.9.89l.22 1.39s-1.24 1.68-3 .48c0 0-1.39-1.18-1.11-2.76ZM39.15 13.47c.13.77 1.16 1.91 2.9 1.34l-.52 4.74s-2.37 1.73-2.9-1.35l.52-4.74ZM42.27 8.48s2.37 2.01 4.36.94l.27 1.55s-1.36 1.89-3.34.57c0 0-1.56-1.3-1.28-3.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m79.07 86.6 4.4 4.44 1.07 1.33 2.3 3.15 1.86-1.28-9.94-11.5c-.08-.1-.16-.18-.25-.26-.78-.68-1.94-.36-2.57.46-.14.19-.39.33-.83.26-1.04-.15-5.61-6.15-5.61-6.15l4.57 14.3 4-5.3 1 .56",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M87.97 78.66 67.06 68.05c-.62-.31-1.31.28-1.08.94l7.67 22.16a.77.77 0 0 0 1.41.11l3.06-5.73 8.72 10c.28.32.77.35 1.09.07l2.5-2.18c.32-.28.35-.77.07-1.09l-8.72-10 6.1-2.25c.63-.23.68-1.11.08-1.41Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.01 96.56H32.22c-7.31 0-13.24-5.28-13.24-11.79V40.99c0-.93.85-1.68 1.89-1.68H31.3M71.11 39.31h10.26c1.04 0 1.89.75 1.89 1.68v28.04M38.39 39.31H64.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.39 53.85.04-2.49.07-8.06c.07-9.73 8.86-17.33 19.58-17.27 10.72.06 19.4 7.75 19.32 17.48l-.07 7.84-.02 2.49c0 1.09-1.08 1.98-2.41 1.98s-2.41-.89-2.41-1.98v-2.52l.08-7.55c.05-7.81-6.47-13.95-14.54-13.99-8.07-.06-14.69 6.01-14.74 13.82l-.07 7.72-.02 2.51c0 1.1-1.08 1.99-2.41 1.99s-2.41-.89-2.41-1.98M45.9 38.73l1.2-7.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.96 25.56 1.08-6.94c.24-1.55 1.64-2.62 3.11-2.39l28.46 4.44c1.48.23 2.48 1.68 2.24 3.23l-2.17 14.67M60.88 22.45l9.52 1.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.59 27.14 2.28 3.21c.41.57.41 1.37 0 1.78l-2.71 2.71c-.41.41-1.21.41-1.78 0l-3.21-2.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.2 19.76-3.4-2.47c-.61-.44-1.44-.47-1.84-.06l-2.71 2.71c-.41.41-.38 1.24.06 1.84l2.47 3.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m25.88 28.38-3.46 3.46a3.145 3.145 0 0 1-4.45 0l-3.46-3.46a3.145 3.145 0 0 1 0-4.45l3.46-3.46a3.145 3.145 0 0 1 4.45 0l3.46 3.46a3.145 3.145 0 0 1 0 4.45Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.82",
        y: "15.78",
        width: "3.24",
        height: "14.93",
        rx: "1.62",
        ry: "1.62",
        transform: "rotate(-9 35.439 23.245)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.82 16.44c.76 0 1.38.62 1.38 1.38v3.87c0 .59-.48 1.07-1.07 1.07h-.31a3.15 3.15 0 1 1 0-6.3Z",
        transform: "rotate(-9 30.934 19.566)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "39.23",
        y: "5.41",
        width: "3.27",
        height: "14.93",
        rx: "1.63",
        ry: "1.63",
        transform: "rotate(-173.74 40.864 12.87)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.13 5.86h.25c.59 0 1.07.48 1.07 1.07v4.18c0 .59-.48 1.07-1.07 1.07h-.25a3.15 3.15 0 1 1 0-6.3Z",
        transform: "rotate(-173.74 45.206 9.012)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ClickAndCollect104 = (ClickAndCollect104);
;// ./src/Picto/GeneratedPictoComponents/ClickAndCollect56.tsx


var ClickAndCollect56_excluded = ["className"];
function ClickAndCollect56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ClickAndCollect56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ClickAndCollect56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ClickAndCollect56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ClickAndCollect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ClickAndCollect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ClickAndCollect56_objectSpread(ClickAndCollect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m41.97 46.18 2.39 2.41.58.72 1.25 1.71 1.01-.69-5.39-6.24a.927.927 0 0 0-.14-.14c-.42-.37-1.05-.2-1.39.25-.08.1-.21.18-.45.14-.56-.08-3.04-3.34-3.04-3.34l2.48 7.75 2.17-2.87.54.31",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m46.29 42.36-10.65-5.41c-.32-.16-.67.15-.55.48L39 48.72c.11.32.56.36.72.06l1.56-2.92 4.44 5.09c.14.16.39.18.55.04l1.27-1.11c.16-.14.18-.39.04-.55l-4.44-5.09 3.11-1.15c.32-.12.35-.56.04-.72Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.34 11.76c-2.07-.62-3.58 8.43-5.59 9.01l5.17.16 1.2-9.17h-.78ZM17.06 29.9c-.07.48 1.73.53 1.63.52l.72-2.44v1.62c-.01 1.05-.79 1.91-1.76 1.91s-1.74-.86-1.74-1.94V27.9l.05-4.97c0-.47.03-1.24.08-1.69l1.04.09-.17.99.16 7.56ZM35.29 29.88c-.07.49 1.75.53 1.64.53l.72-2.46v1.64c-.01 1.06-.8 1.93-1.78 1.93s-1.76-.87-1.76-1.96v-1.68l.05-5.02c0-.47.03-1.25.08-1.71l1.05.09-.17 1 .17 7.64ZM28.21 51.63H15.33c-2.58 0-4.67-2.09-4.67-4.67V30.63c5.35 4.81 9.94 19.12 17.55 21Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m7.27 15.05 2.14 2.14c.34.34 1.72.63 2.4-.06l2.44-2.44c-.12-.17-.37-.15-.76.06-.57.31-2.43 1.04-3.96.52-1.53-.52-1.77-.97-2.1-.77a.21.21 0 0 0-.06.04c-.19.12-.24.38-.1.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.13 12.05c.17.37 1.01 1.82 1.81 1.3l.39 2.46s-.96 1.2-1.65-.28l-.55-3.48ZM15.69 10.29s1.13.98 2.09.47l.12.75s-.67.9-1.61.25c0 0-.74-.63-.6-1.48ZM21.1 7.34c.07.41.62 1.02 1.55.72l-.28 2.54s-1.27.93-1.55-.72l.28-2.54ZM22.77 4.67s1.27 1.08 2.33.5l.14.83s-.73 1.01-1.79.31c0 0-.84-.7-.69-1.64Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.51 52H17.19c-3.93 0-7.12-2.84-7.12-6.34V22.12c0-.5.46-.91 1.02-.91h5.61M38.1 21.21h5.52c.56 0 1.02.41 1.02.91V37.2M20.51 21.21h13.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.74 29.03.02-1.34.04-4.33c.04-5.23 4.76-9.32 10.53-9.29 5.77.03 10.43 4.17 10.39 9.4l-.04 4.22v1.34h-.01c0 .59-.58 1.06-1.29 1.06s-1.29-.48-1.29-1.06v-1.35l.04-4.06c.03-4.2-3.48-7.5-7.82-7.52-4.34-.03-7.9 3.23-7.93 7.43l-.04 4.15v1.35c0 .59-.58 1.06-1.29 1.06s-1.29-.48-1.29-1.06M24.55 20.9l.64-4.13"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.65 13.82.58-3.73c.13-.83.88-1.41 1.67-1.29l15.3 2.39c.79.12 1.33.9 1.2 1.74l-1.17 7.89M32.6 12.15l5.12.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m14.16 14.67 1.22 1.73c.22.31.22.74 0 .96l-1.46 1.46c-.22.22-.65.22-.96 0l-1.73-1.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.19 10.7 8.36 9.37c-.33-.24-.77-.25-.99-.03L5.91 10.8c-.22.22-.2.66.03.99l1.33 1.83"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m13.78 15.34-1.86 1.86c-.66.66-1.73.66-2.39 0l-1.86-1.86a1.69 1.69 0 0 1 0-2.39l1.86-1.86a1.69 1.69 0 0 1 2.39 0l1.86 1.86c.66.66.66 1.73 0 2.39Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18.05",
        y: "8.56",
        width: "1.74",
        height: "8.03",
        rx: ".87",
        ry: ".87",
        transform: "rotate(-9 18.893 12.546)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.98 8.91c.41 0 .74.33.74.74v2.08c0 .32-.26.57-.57.57h-.17c-.94 0-1.7-.76-1.7-1.7s.76-1.7 1.7-1.7Z",
        transform: "rotate(-9 16.487 10.63)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "20.96",
        y: "2.98",
        width: "1.76",
        height: "8.03",
        rx: ".88",
        ry: ".88",
        transform: "rotate(-173.74 21.836 6.995)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.67 3.22h.13c.32 0 .57.26.57.57v2.25c0 .32-.26.57-.57.57h-.13c-.94 0-1.7-.76-1.7-1.7s.76-1.7 1.7-1.7Z",
        transform: "rotate(-173.74 24.175 4.922)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ClickAndCollect56 = (ClickAndCollect56);
;// ./src/Picto/GeneratedPictoComponents/DataPacks104.tsx


var DataPacks104_excluded = ["className"];
function DataPacks104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DataPacks104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DataPacks104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DataPacks104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DataPacks104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPacks104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DataPacks104_objectSpread(DataPacks104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 63v25c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54 35s2.99 21 4.67 22l-5.62-.38V34.49L54 35ZM76 40.38s2.99 15.59 4.67 16.33l-5.62-.28V40.01l.95.38ZM64.81 28.64s2.99 26.57 4.67 27.83c1.68 1.27 0 0 0 0l-5.62-.48V28l.95.64Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42 38v12M36 44h12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "44.61",
        y: "42.56",
        width: "22.88",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 56.05 45.56)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "52.75",
        y: "39.7",
        width: "28.6",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 67.05 42.7)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "69.47",
        y: "45.42",
        width: "17.16",
        height: "6",
        rx: ".38",
        ry: ".38",
        transform: "rotate(-90 78.05 48.42)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPacks104 = (DataPacks104);
;// ./src/Picto/GeneratedPictoComponents/DataPacks56.tsx


var DataPacks56_excluded = ["className"];
function DataPacks56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DataPacks56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DataPacks56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DataPacks56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DataPacks56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPacks56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DataPacks56_objectSpread(DataPacks56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 34v13c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v4M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.15 19.63s1.49 10.44 2.32 10.93l-2.79-.19v-11l.47.25ZM41.1 22.24s1.49 7.75 2.32 8.12l-2.79-.14v-8.16l.47.19ZM34.95 16.47s1.49 13.2 2.32 13.83l-2.79-.24V16.15l.47.32Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.48 20.5v6M19.48 23.5h6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.36",
        y: "23.38",
        width: "11.25",
        height: "3",
        rx: ".19",
        ry: ".19",
        transform: "rotate(-90 29.98 24.88)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.95",
        y: "21.97",
        width: "14.07",
        height: "3",
        rx: ".19",
        ry: ".19",
        transform: "rotate(-90 35.985 23.475)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.74",
        y: "24.79",
        width: "8.44",
        height: "3",
        rx: ".19",
        ry: ".19",
        transform: "rotate(-90 41.965 26.285)"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPacks56 = (DataPacks56);
;// ./src/Picto/GeneratedPictoComponents/DataPool104.tsx


var DataPool104_excluded = ["className"];
function DataPool104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DataPool104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DataPool104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DataPool104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DataPool104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPool104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DataPool104_objectSpread(DataPool104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.89 86.68c-1.63-.4-3.28.11-4.94-.17-7.02-1.06-10.96-7.92-14.12-13.76-.82-1.45-1.25-2.42-3.03-1.94l.05.13 7.72 21.04c.7 1.91 1.57 2.34 3.41 1.68l13.39-4.83c-.31-1.12-1.38-1.89-2.49-2.16ZM75.7 89.78c-.99-1.35-2.57-2.01-3.64-3.29-4.65-5.31-3.23-13.09-1.88-19.6.3-1.64.6-2.66-1.05-3.42l-.05.13-7.66 21.1c-.69 1.91-.31 2.8 1.51 3.47l13.28 4.85c.48-1.06.16-2.34-.5-3.25Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.3 88.23-15.22 5.49c-1.44.52-3.04-.22-3.56-1.65L10.17 58.43c-.52-1.43.22-3.01 1.66-3.53l15.22-5.49c1.44-.52 3.04.22 3.56 1.65L42.96 84.7c.52 1.43-.22 3.01-1.66 3.53ZM19.76 55.68l1.7-.61M30.04 89.03l5.11-1.85M82.63 54.99l1.69.62M69.05 87.11l5.07 1.85M78.05 93.79l-15.1-5.51a2.766 2.766 0 0 1-1.65-3.54L73.55 51c.52-1.43 2.1-2.17 3.53-1.65l15.1 5.51c1.43.52 2.17 2.11 1.65 3.54L81.58 92.14a2.755 2.755 0 0 1-3.53 1.65Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.91 12.83c11.85-4.31 25.65-1.72 35.18 7.76.52.51 1.01 1.04 1.49 1.58M19.08 48.45c-1.2-9.87 1.98-20.17 9.54-27.76 2.07-2.08 4.35-3.83 6.77-5.26M60.1 77.06a33.679 33.679 0 0 1-16.86-.38M81.34 27.34c3.7 6.27 5.19 13.48 4.46 20.51"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m50.66 38.53-2.74 1.07c-.71-1.88-2.22-3.11-4.63-3.11-3.42 0-5.62 2.59-5.62 6.5s2.25 6.58 5.62 6.58c2.27 0 4.7-1.23 4.99-4.55h-4.13v-2.46h6.74v9.3H48.3V49.4c-1.12 1.72-3.08 2.77-5.46 2.77-4.68 0-8.36-3.68-8.36-9.19s3.84-9.19 8.83-9.19c3.63 0 6.32 1.98 7.34 4.73ZM54.34 34.12h7.5c3.55 0 5.54 1.91 5.54 4.55 0 1.8-.89 3.24-2.77 3.76 2.4.63 3.45 2.22 3.45 4.36 0 3-2.09 5.09-6.09 5.09h-7.63V34.12Zm3.11 2.61v4.49h4.21c1.72 0 2.61-.81 2.61-2.25s-.89-2.25-2.61-2.25h-4.21Zm7.48 9.82c0-1.7-1.07-2.72-3.16-2.72h-4.31v5.43h4.31c2.09 0 3.16-1.02 3.16-2.72Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPool104 = (DataPool104);
;// ./src/Picto/GeneratedPictoComponents/DataPool56.tsx


var DataPool56_excluded = ["className"];
function DataPool56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DataPool56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DataPool56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DataPool56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DataPool56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DataPool56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DataPool56_objectSpread(DataPool56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.53 7.23c6.67-2.43 14.45-.97 19.81 4.37.29.29.57.59.84.89M10.23 27.29c-.67-5.56 1.11-11.36 5.37-15.63 1.17-1.17 2.45-2.16 3.81-2.96M33.33 43.4c-3.12.73-6.4.66-9.49-.21M45.29 15.4c2.08 3.53 2.92 7.59 2.51 11.55"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimaryinverted",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.26 22.62-1.46.57c-.38-1-1.19-1.66-2.47-1.66-1.83 0-3 1.38-3 3.47s1.2 3.51 3 3.51c1.21 0 2.51-.65 2.66-2.42h-2.2v-1.31h3.6v4.96h-1.38v-1.31c-.6.92-1.65 1.48-2.91 1.48-2.5 0-4.46-1.96-4.46-4.9s2.05-4.9 4.71-4.9c1.94 0 3.37 1.06 3.92 2.52ZM30.23 20.26h4c1.9 0 2.96 1.02 2.96 2.42 0 .96-.47 1.73-1.48 2.01 1.28.33 1.84 1.18 1.84 2.33 0 1.6-1.12 2.72-3.25 2.72h-4.07v-9.47Zm1.66 1.4v2.4h2.24c.92 0 1.39-.43 1.39-1.2s-.47-1.2-1.39-1.2h-2.24Zm3.98 5.24c0-.91-.57-1.45-1.69-1.45h-2.3v2.9h2.3c1.12 0 1.69-.54 1.69-1.45Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.22 47.36c-.95-.23-1.91.07-2.87-.1-4.08-.62-6.36-4.6-8.2-7.99-.48-.84-.73-1.4-1.76-1.12l.03.08 4.48 12.22c.41 1.11.91 1.36 1.98.98l7.77-2.8c-.18-.65-.8-1.1-1.44-1.25ZM43.08 49.7c-.57-.78-1.49-1.17-2.11-1.91-2.7-3.08-1.88-7.6-1.09-11.38.18-.95.35-1.54-.61-1.99l-.03.08-4.45 12.25c-.4 1.11-.18 1.63.88 2.02l7.71 2.81c.28-.61.09-1.36-.29-1.88Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.69 48.7-7.95 2.87c-.75.27-1.59-.11-1.86-.86L5.43 33.15c-.27-.75.11-1.57.87-1.84l7.95-2.87c.75-.27 1.59.11 1.86.86l6.45 17.56c.27.75-.11 1.57-.87 1.84ZM10.45 31.71l.89-.33M15.81 49.12l2.67-.97M45.82 31.35l.88.32M38.73 48.12l2.65.96M43.43 51.6l-7.88-2.88c-.75-.27-1.13-1.1-.86-1.85l6.4-17.62c.27-.75 1.1-1.14 1.85-.86l7.88 2.88c.75.27 1.13 1.1.86 1.85l-6.4 17.62c-.27.75-1.1 1.14-1.85.86Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DataPool56 = (DataPool56);
;// ./src/Picto/GeneratedPictoComponents/DeviceLocator104.tsx


var DeviceLocator104_excluded = ["className"];
function DeviceLocator104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DeviceLocator104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DeviceLocator104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DeviceLocator104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DeviceLocator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceLocator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DeviceLocator104_objectSpread(DeviceLocator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75 63v25c0 3.31-2.69 6-6 6H35c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M50 14h4M46 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.51 64.43c.51-.64.49-1.54-.03-2.17-3.44-4.11-8.51-8.59-10.92-13.86-2.24-4.9-2.61-10.31-1.03-15.18.58-1.77-1.78-3.01-2.96-1.57-2.29 2.81-3.99 6.96-2.89 12.53 1.68 8.54 10.19 18.69 13.55 22.44.71.79 1.95.75 2.61-.07l1.68-2.11Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.89 66.71c.31.63.95 1.06 1.69 1.07.73 0 1.38-.44 1.69-1.07L76.2 49.66c1.65-2.43 2.61-5.36 2.61-8.52 0-8.4-6.81-15.2-15.21-15.2s-15.21 6.81-15.21 15.2c0 3.16.97 6.09 2.61 8.52l10.9 17.05Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.13 41.16a6.521 6.521 0 0 1-13.04 0 6.521 6.521 0 0 1 13.04 0Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceLocator104 = (DeviceLocator104);
;// ./src/Picto/GeneratedPictoComponents/DeviceLocator56.tsx


var DeviceLocator56_excluded = ["className"];
function DeviceLocator56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DeviceLocator56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DeviceLocator56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DeviceLocator56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DeviceLocator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceLocator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DeviceLocator56_objectSpread(DeviceLocator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25 48h6M40 34v13c0 1.66-1.34 3-3 3H19c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v4M27 8h2"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.44 34.65c.27-.33.26-.81-.02-1.13-1.8-2.15-4.45-4.49-5.7-7.24-1.17-2.56-1.36-5.39-.54-7.93.3-.93-.93-1.57-1.55-.82-1.2 1.47-2.08 3.64-1.51 6.55.88 4.46 5.32 9.76 7.08 11.72.37.41 1.02.39 1.36-.04l.88-1.1Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.02 35.84c.16.33.5.56.88.56s.72-.23.88-.56l5.71-8.9c.86-1.27 1.36-2.8 1.36-4.45 0-4.39-3.56-7.94-7.95-7.94s-7.95 3.55-7.95 7.94c0 1.65.5 3.18 1.37 4.45l5.69 8.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.33 22.5c0 1.88-1.53 3.41-3.41 3.41s-3.41-1.53-3.41-3.41 1.53-3.41 3.41-3.41 3.41 1.52 3.41 3.41Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceLocator56 = (DeviceLocator56);
;// ./src/Picto/GeneratedPictoComponents/DeviceProtect104.tsx


var DeviceProtect104_excluded = ["className"];
function DeviceProtect104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DeviceProtect104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DeviceProtect104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DeviceProtect104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DeviceProtect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceProtect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DeviceProtect104_objectSpread(DeviceProtect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.32 65.61c-4.39-1.85-6.88-5.86-7.89-8.91s-2.6-1.53-2.6-1.53l.22 7.37s13.75 7.44 18.34 9.82c.37-1.99-3.68-4.9-8.07-6.74ZM55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.31 30.3h7.57c.93 0 1.69.75 1.69 1.69v29.74c0 .63-.35 1.21-.91 1.5l-16.88 8.72c-.49.25-1.06.25-1.55 0l-16.88-8.72c-.56-.29-.91-.87-.91-1.5V31.99c0-.93.75-1.69 1.69-1.69h7.75M63.93 30.3h10.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 78v10c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v1M44 14h4M40 90h12"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 43.46a3.397 3.397 0 0 0-1.83 6.26v2.38c0 1.28.55 2.33 1.83 2.33h.01c1.28 0 1.83-1.05 1.83-2.33v-2.38a3.397 3.397 0 0 0-1.83-6.26H69Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.43 58.54c-1.64-.31-3.83-.52-5.41-.71-1.84-.22-3.72-.86-5.01-2.24-1.43-1.52-1.87-3.82-2.36-5.77-.28-1.13-.58-6.77-2.15-6.6-.27.03-.89.48-.89.8v13.83c0 2.75 2.57 3.07 2.57 3.07h13.21c2.41 0 1.9-2.01.05-2.37Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "55.63",
        y: "38.06",
        width: "26.78",
        height: "22.85",
        rx: "3.59",
        ry: "3.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.64 38.06v-5.7c0-5.25 4.3-9.71 9.55-9.64 5.12.07 9.3 4.28 9.3 9.42v5.91h-3.97v-5.76c0-2.94-2.25-5.46-5.18-5.61a5.466 5.466 0 0 0-5.73 5.45v5.91h-3.97ZM69 43.46a3.397 3.397 0 0 0-1.83 6.26v2.38c0 1.28.55 2.33 1.83 2.33h.01c1.28 0 1.83-1.05 1.83-2.33v-2.38a3.397 3.397 0 0 0-1.83-6.26H69Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceProtect104 = (DeviceProtect104);
;// ./src/Picto/GeneratedPictoComponents/DeviceProtect56.tsx


var DeviceProtect56_excluded = ["className"];
function DeviceProtect56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function DeviceProtect56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? DeviceProtect56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : DeviceProtect56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function DeviceProtect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, DeviceProtect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", DeviceProtect56_objectSpread(DeviceProtect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.96 36.5c-2.31-.97-3.62-3.08-4.15-4.69-.54-1.61-1.37-.8-1.37-.8l.12 3.88s7.24 3.92 9.65 5.17c.19-1.05-1.94-2.58-4.25-3.55ZM29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.9 17.91h3.98c.49 0 .89.4.89.89v15.65c0 .33-.19.64-.48.79l-8.88 4.59a.89.89 0 0 1-.81 0l-8.88-4.59a.899.899 0 0 1-.48-.79V18.8c0-.49.4-.89.89-.89h4.08M34.33 17.91h5.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 43v4c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v2M24 8h2M22 48h6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.28 32.78c-.87-.16-2.02-.27-2.85-.37-.97-.12-1.96-.45-2.64-1.18-.75-.8-.99-2.01-1.24-3.04-.15-.59-.3-3.56-1.13-3.47-.14.02-.47.25-.47.42v7.28c0 1.45 1.35 1.61 1.35 1.61h6.95c1.27 0 1-1.06.02-1.25Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 24.84c-.99 0-1.79.8-1.79 1.79 0 .63.33 1.19.82 1.51v1.25c0 .67.29 1.22.96 1.22.67 0 .96-.55.96-1.22v-1.25c.5-.32.82-.87.82-1.51 0-.99-.8-1.79-1.79-1.79Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.96",
        y: "22",
        width: "14.09",
        height: "12.03",
        rx: "1.89",
        ry: "1.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.08 22v-3c0-2.77 2.26-5.11 5.03-5.07A4.97 4.97 0 0 1 42 18.89V22h-2.09v-3.03c0-1.55-1.18-2.88-2.73-2.95a2.88 2.88 0 0 0-3.02 2.87V22h-2.09ZM37 24.84c-.99 0-1.79.8-1.79 1.79 0 .63.33 1.19.82 1.51v1.25c0 .67.29 1.22.96 1.22.67 0 .96-.55.96-1.22v-1.25c.5-.32.82-.87.82-1.51 0-.99-.8-1.79-1.79-1.79Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_DeviceProtect56 = (DeviceProtect56);
;// ./src/Picto/GeneratedPictoComponents/FieldExecution104.tsx


var FieldExecution104_excluded = ["className"];
function FieldExecution104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FieldExecution104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FieldExecution104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FieldExecution104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FieldExecution104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FieldExecution104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FieldExecution104_objectSpread(FieldExecution104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.34 46.27c2.27-2.66 8.73-2.8 6.64.22-.64.94-2.46 4.77-3.04 5.71.06 4.06.14 8.12.2 12.18.06 3.92.86 8.29.1 12.16-1.27 6.47-11.34 4.81-16.83 4.93-.44 0-.82-.05-1.15-.15-2.13.89-4.71.98-7.5-.15-3.8-1.52-1.21-6.59 2.57-5.07 3.28 1.32 2.08-5.72 2.36-7.32.44-2.42 3.17-8.67 4.34-10.88 2.43-4.61 6.19-8.22 10.92-11.19.44-.26.9-.39 1.35-.43l.04-.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77 50.49C89.44 56 88.06 75.58 88.06 75.58h3.04c1.64 0 2.97 1.34 2.97 2.97s-1.34 2.97-2.97 2.97H13.06c-1.63 0-2.97-1.34-2.97-2.97s1.34-2.97 2.97-2.97h3.04s.94-24.68 21.75-31.14c0 0 1.56-.51 3.67-.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.51 64.68V50.67s0-12.98 12.98-12.98c1.05 0 2.01.09 2.89.24 0 0 3.62.56 4.14 2.5M65.46 47.41v17.27"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.47 27.86c-1.32 13.04 8.12 9.41 7.81 14.6v1.83h-1.13a.53.53 0 0 1-.5-.54v-2.47a9.626 9.626 0 0 1-3.16-1.31l-1.75 1.75c-.21.21-.55.21-.76 0l-2.13-2.2a.537.537 0 0 1 0-.76l1.75-1.75a9.675 9.675 0 0 1-1.28-3.14h-2.47c-.3 0-.54-.24-.54-.54v-3.04c0-.3.24-.54.54-.54h2.45c.16-.69.34-1.37.61-2 .09-.41.65-.28.57.12Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.61 17.53c8.13 5.95 9.89 17.37 3.93 25.5-5.95 8.13-17.37 9.89-25.5 3.93-8.13-5.95-9.89-17.37-3.93-25.5 5.95-8.13 17.37-9.89 25.5-3.93Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m66.27 24.45 2.17-2.15c.21-.21.55-.21.76 0l1.73 1.73c.96-.61 2.02-1.05 3.14-1.28v-2.18c0-.44.35-.8.79-.81h2.54c.45 0 .81.36.81.81v2.24c1.11.25 2.17.69 3.13 1.3l1.73-1.73c.21-.21.55-.21.76 0l2.15 2.17c.21.21.21.55 0 .76l-1.73 1.73c.61.96 1.05 2.02 1.28 3.14h2.45c.3 0 .54.24.54.54v3.06c0 .3-.25.54-.55.54h-2.46a9.688 9.688 0 0 1-1.31 3.13l1.73 1.73c.21.21.21.55 0 .76l-2.17 2.16c-.21.21-.55.21-.76 0l-1.73-1.73c-.96.61-2.02 1.05-3.14 1.28v2.45c0 .3-.25.54-.55.54h-3.06c-.3 0-.54-.24-.54-.54v-2.5a9.472 9.472 0 0 1-3.13-1.31l-1.73 1.73c-.21.21-.55.21-.76 0l-2.15-2.17a.537.537 0 0 1 0-.76l1.73-1.73a9.675 9.675 0 0 1-1.28-3.14H64.2c-.3 0-.54-.25-.54-.55v-3.05c0-.3.23-.54.53-.55h2.48a9.45 9.45 0 0 1 1.3-3.13l-1.73-1.73c-.21-.21-.2-.55.01-.76Zm6.15 3.63a5.518 5.518 0 0 0-.4 7.79 5.518 5.518 0 0 0 7.79.4 5.518 5.518 0 0 0 0-8.19 5.525 5.525 0 0 0-7.39 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.57 59-.65 3.83c-.13.69-.59.87-.99.87h-3.02l1.27-7.01c-1.27-.58-2.57-.96-3.6-.96s-1.78.27-2.31.9c-.37.45-.56 1.01-.56 1.68 0 1.99 1.57 4.76 4.26 7.01 2.39 1.99 5.03 3.11 6.95 3.11.96 0 1.73-.29 2.24-.88.4-.45.56-1.04.56-1.7 0-1.94-1.58-4.65-4.13-6.86Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.13 51.57c-.48 0-.88.32-.99.83l-.43 2.32h3.81l-1.64 9.01h3.03c.4 0 .86-.19.99-.88l1.39-8.13h2.74c.48 0 .88-.32.99-.83l.43-2.32H49.12Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FieldExecution104 = (FieldExecution104);
;// ./src/Picto/GeneratedPictoComponents/FieldExecution56.tsx


var FieldExecution56_excluded = ["className"];
function FieldExecution56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function FieldExecution56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? FieldExecution56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : FieldExecution56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function FieldExecution56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, FieldExecution56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", FieldExecution56_objectSpread(FieldExecution56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.11 25.8c1.19-1.39 4.56-1.46 3.47.11-.33.49-1.29 2.49-1.59 2.98.03 2.12.07 4.24.1 6.37.03 2.05.45 4.33.05 6.36-.67 3.38-5.93 2.52-8.8 2.58-.23 0-.43-.03-.6-.08-1.11.47-2.46.51-3.92-.08-1.99-.8-.63-3.44 1.34-2.65 1.72.69 1.09-2.99 1.23-3.82.23-1.26 1.66-4.53 2.27-5.69 1.27-2.41 3.23-4.3 5.71-5.85.23-.13.47-.21.71-.22h.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.93 28c6.5 2.88 5.78 13.11 5.78 13.11h1.59c.86 0 1.55.7 1.55 1.55s-.7 1.55-1.55 1.55H7.5c-.85 0-1.55-.7-1.55-1.55s.7-1.55 1.55-1.55h1.59s.49-12.9 11.37-16.28c0 0 .82-.27 1.92-.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.33 35.42V28.1s0-6.78 6.78-6.78c.55 0 1.05.05 1.51.13 0 0 1.89.29 2.17 1.31M34.9 26.39v9.03"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.47 16.17c-.69 6.82 4.24 4.92 4.08 7.63v.95h-.59c-.15 0-.26-.13-.26-.28v-1.29c-.59-.13-1.15-.36-1.65-.68l-.92.92c-.11.11-.29.11-.4 0l-1.11-1.15a.284.284 0 0 1 0-.4l.92-.92c-.32-.5-.54-1.06-.67-1.64h-1.29c-.15 0-.28-.13-.28-.28v-1.59c0-.15.13-.28.28-.28h1.28c.08-.36.18-.71.32-1.05.05-.21.34-.15.3.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.95 10.77c4.25 3.11 5.17 9.08 2.06 13.33s-9.08 5.17-13.33 2.06-5.17-9.08-2.06-13.33 9.08-5.17 13.33-2.06Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.32 14.39 1.13-1.12c.11-.11.29-.11.4 0l.91.91c.5-.32 1.06-.55 1.64-.67v-1.14c0-.23.18-.42.41-.42h1.32c.23 0 .42.19.42.42v1.17c.58.13 1.13.36 1.64.68l.91-.91c.11-.11.29-.11.4 0l1.12 1.13c.11.11.11.29 0 .4l-.91.91c.32.5.55 1.06.67 1.64h1.28c.16 0 .28.13.28.28v1.6c0 .16-.13.28-.29.28h-1.29c-.13.58-.36 1.14-.68 1.64l.91.91c.11.11.11.29 0 .4l-1.13 1.13c-.11.11-.29.11-.4 0l-.91-.91c-.5.32-1.06.55-1.64.67v1.28c0 .16-.13.28-.29.28h-1.6a.28.28 0 0 1-.28-.28v-1.31c-.58-.13-1.14-.36-1.64-.68l-.91.91c-.11.11-.29.11-.4 0l-1.12-1.13a.284.284 0 0 1 0-.4l.91-.91c-.32-.5-.54-1.06-.67-1.64h-1.29c-.16 0-.28-.13-.28-.29v-1.6c0-.16.12-.28.28-.29h1.3c.13-.58.36-1.14.68-1.64l-.91-.91c-.11-.11-.1-.29 0-.4Zm3.21 1.89a2.88 2.88 0 0 0-.21 4.07 2.88 2.88 0 0 0 4.07.21 2.88 2.88 0 0 0 .21-4.07l-.21-.21a2.88 2.88 0 0 0-3.86 0Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.2 32.45-.34 2c-.07.36-.31.46-.52.46h-1.58l.67-3.66c-.66-.3-1.34-.5-1.88-.5s-.93.14-1.21.47c-.2.24-.29.53-.29.88 0 1.04.82 2.49 2.22 3.67 1.25 1.04 2.63 1.63 3.63 1.63.5 0 .9-.15 1.17-.46.21-.24.29-.54.29-.89 0-1.01-.83-2.43-2.16-3.58Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.36 28.56c-.25 0-.46.17-.52.43l-.22 1.21h1.99l-.86 4.71h1.58c.21 0 .45-.1.52-.46l.72-4.25H31c.25 0 .46-.17.52-.43l.22-1.21h-5.4Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_FieldExecution56 = (FieldExecution56);
;// ./src/Picto/GeneratedPictoComponents/Gift104.tsx


var Gift104_excluded = ["className"];
function Gift104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gift104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gift104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gift104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gift104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gift104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gift104_objectSpread(Gift104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M17.79 48.56c1.27 0 4.81-.65 5.74.24.24.23.38.55.51.86 2.21 5.23 4.29 10.56 7.16 15.46 3.47 5.94 8.51 9.7 13.31 14.36 1.31 1.27 2.75 2.43 3.78 3.96s1.78 3.29 2.09 4.84H21.42a3.6 3.6 0 0 1-3.61-3.6V48.56Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M86.29 48.47V85.7c0 1.73-1.41 3.14-3.14 3.14h-62.3c-1.73 0-3.14-1.4-3.14-3.14V48.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "14.02",
        y: "38.47",
        width: "75.96",
        height: "9.02",
        rx: "1",
        ry: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.99 37.36v50.93M51.94 37.36c-.06-.22-1.08-.3-1.26-.33-3.42-.61-6.74-1.55-10.02-2.73-5.24-1.87-12.27-4.61-14.91-9.95-2.93-5.93 2.46-11.01 8.21-9.54 6.63 1.69 11.08 9.18 14.12 14.69.71 1.28 1.38 2.57 2.02 3.88.63 1.27 1.47 2.61 1.84 3.98ZM52 37.36c.06-.22 1.08-.3 1.26-.33 3.42-.61 6.74-1.55 10.02-2.73 5.24-1.87 12.27-4.61 14.91-9.95 2.93-5.93-2.46-11.01-8.21-9.54-6.63 1.69-11.08 9.18-14.12 14.69-.71 1.28-1.38 2.57-2.02 3.88-.63 1.27-1.47 2.61-1.84 3.98Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gift104 = (Gift104);
;// ./src/Picto/GeneratedPictoComponents/Gift56.tsx


var Gift56_excluded = ["className"];
function Gift56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Gift56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Gift56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Gift56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Gift56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Gift56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Gift56_objectSpread(Gift56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M9.58 26.15c.69 0 2.59-.35 3.09.13.13.12.2.3.27.46 1.19 2.82 2.31 5.68 3.85 8.32 1.87 3.2 4.58 5.22 7.17 7.73.7.68 1.48 1.31 2.03 2.13s.96 1.77 1.12 2.61h-15.6c-1.07 0-1.95-.86-1.95-1.94V26.14Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.51 25.85v18.87c0 1.73-1.41 3.14-3.14 3.14H12.62c-1.73 0-3.14-1.4-3.14-3.14V25.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "7.46",
        y: "20.67",
        width: "41.09",
        height: "4.96",
        rx: "1",
        ry: "1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.97 20.12c-.03-.12-.58-.16-.68-.18-1.84-.33-3.63-.84-5.4-1.47-2.82-1.01-6.61-2.48-8.03-5.36-1.58-3.19 1.33-5.93 4.42-5.14 3.57.91 5.97 4.95 7.6 7.91.38.69.74 1.38 1.09 2.09.34.69.79 1.41.99 2.15ZM28 20.12c.03-.12.58-.16.68-.18 1.84-.33 3.63-.84 5.4-1.47 2.82-1.01 6.61-2.48 8.03-5.36 1.58-3.19-1.33-5.93-4.42-5.14-3.57.91-5.97 4.95-7.6 7.91-.38.69-.74 1.38-1.09 2.09-.34.69-.79 1.41-.99 2.15ZM27.99 20.12v27.42"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Gift56 = (Gift56);
;// ./src/Picto/GeneratedPictoComponents/IRCallingPack104.tsx


var IRCallingPack104_excluded = ["className"];
function IRCallingPack104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IRCallingPack104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IRCallingPack104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IRCallingPack104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IRCallingPack104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IRCallingPack104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IRCallingPack104_objectSpread(IRCallingPack104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 65v22.29c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v5.57M44.57 14.86h3.72M40.86 89.14H52"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.41 55.84c-8.08 0-14.62-6.55-14.62-14.62 0-1.14.13-2.25.38-3.31.19-.81-.98-1.19-1.31-.43a14.59 14.59 0 0 0-1.16 7.62c.75 6.69 6.15 12.09 12.84 12.84 2.23.25 4.37 0 6.32-.66.95-.32.62-1.73-.37-1.59-.67.1-1.36.14-2.06.14"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M87.84 43.41c0 8.08-6.55 14.62-14.62 14.62S58.6 51.48 58.6 43.41s6.55-14.62 14.62-14.62 14.62 6.55 14.62 14.62Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M68.4 57.22c-1.18-2.17-2.14-3.52-2.86-5.36-.04-.09-.08-.19-.11-.29-.94-2.54-1.45-5.5-1.52-8.16-.08-2.81.32-5.61 1.2-8.28a24.43 24.43 0 0 1 2.47-5.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M84.62 35.26c-1.04.5-2.09.94-3.18 1.3-2.66.87-5.45 1.26-8.23 1.18a24.14 24.14 0 0 1-8.1-1.62c-.98-.37-1.95-.82-2.9-1.36"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.22 53.05a21.75 21.75 0 0 1 3.22-1.48c2.5-.93 5.13-1.44 7.78-1.5 2.67-.08 5.36.29 7.92 1.09 1.2.37 2.35.84 3.48 1.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.04 57.21c1.26-2.21 2.27-3.78 2.99-5.74l.11-.31c.85-2.43 1.3-5.24 1.37-7.75.08-2.65-.28-5.31-1.06-7.84-.61-1.98-1.47-3.88-2.61-5.66"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M73.22 58.04V28.79"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M87.84 43.41H58.59"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IRCallingPack104 = (IRCallingPack104);
;// ./src/Picto/GeneratedPictoComponents/IRCallingPack56.tsx


var IRCallingPack56_excluded = ["className"];
function IRCallingPack56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function IRCallingPack56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? IRCallingPack56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : IRCallingPack56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function IRCallingPack56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, IRCallingPack56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", IRCallingPack56_objectSpread(IRCallingPack56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.75 30.3a7.998 7.998 0 0 1-7.79-9.81c.1-.44-.53-.65-.72-.24-.56 1.25-.8 2.68-.64 4.17.41 3.66 3.37 6.61 7.02 7.02 1.22.14 2.39 0 3.46-.36.52-.17.34-.95-.21-.87-.37.05-.75.08-1.13.08"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.55 23.5c0 4.42-3.58 8-8 8s-8-3.58-8-8 3.58-8 8-8 8 3.58 8 8Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.92 31.06c-.65-1.19-1.17-1.93-1.56-2.93-.02-.05-.04-.1-.06-.16-.52-1.39-.79-3.01-.83-4.47-.04-1.53.17-3.07.65-4.53.33-1 .79-1.96 1.35-2.86"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M45.79 19.04c-.57.28-1.14.52-1.74.71-1.45.47-2.98.69-4.5.65-1.51-.04-3-.33-4.43-.89-.54-.2-1.07-.45-1.59-.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.53 28.77c.57-.32 1.16-.59 1.76-.81 1.37-.51 2.81-.79 4.25-.82 1.46-.04 2.93.16 4.33.6.65.2 1.29.46 1.91.76"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M42.19 31.05c.69-1.21 1.24-2.07 1.64-3.14.02-.06.04-.11.06-.17.47-1.33.71-2.87.75-4.24.04-1.45-.15-2.9-.58-4.29-.33-1.08-.81-2.12-1.43-3.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.55 31.5v-16"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.55 23.5h-16"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_IRCallingPack56 = (IRCallingPack56);
;// ./src/Picto/GeneratedPictoComponents/InternationalCalls104.tsx


var InternationalCalls104_excluded = ["className"];
function InternationalCalls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalCalls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalCalls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalCalls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternationalCalls104_objectSpread(InternationalCalls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.73 39.42c.72 11.83 5.61 32.71 29.6 44.9 1.89.96 1.13 3.83-.98 3.69-12.7-.82-34.62-7.48-34.24-43.65 0-.18.03-.37.08-.54.19-.65.75-2.47 1.77-4.99.77-1.92 3.63-1.48 3.76.58Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.43 14.09c-3.38 2.18-6.87 4.15-10.19 6.46-5.2 3.62.27 3.75-1.3 8.91-1.54 5.04-3.91 8.91-8.43 10.58-2.43.9-9.96 2.04-10.34 4.59-.53 3.52 2.07 7.56 2.76 10.96.76 3.75 1.34 8.17 4.79 9.94 3.98 2.05 8.17 3.48 12.3 5.01 2.11.78 1.13 6.54 1.13 8.64M66.93 17.86s-1.6 4.87 2.91 9.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.49 87.02c-8.47 1.51-17.5.09-25.48-4.65C13.38 71.88 7.59 49.09 18.08 31.46 28.57 13.83 51.36 8.04 68.99 18.53c6.69 3.98 11.68 9.73 14.71 16.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M85.02 79.45c-2.81 4.41-7.79 10.66-14.66 10.3-2.93-.15-6.89-.65-7.19-4.35-.05-.63-.04-2.7.51-3.09.99-.71 3.51 1.07 4.36 1.47 2.69 1.25 5.78 1.11 8.59.36 1.36-.36 2.62-.9 3.82-1.62 1.05-.63 2.09-1.79 2.72-2.87.56-.97 1.69-1.24 1.85-.19Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.18 88.72c3.93-2.02 9.33-6.92 13.2-18.96 7.23-22.52-4.12-28.27-4.59-28.5-.26-.09-3.4-1.09-3.4-1.09-2.27-.73-4.98.67-5.71 2.93l-2.23 6.94c-.78 2.37.51 4.91 2.88 5.69l.05.02 3.16 1.09c-.2 2.82-.83 5.75-1.69 8.67l-.32.99c-.91 2.83-2.15 5.48-3.67 8.04l-3.12-1c-2.27-.73-4.98.67-5.71 2.93l-2.23 6.94c-.36 1.13-.3 2.4.27 3.53.58 1.12 1.52 1.82 2.71 2.28 0 0 6.55 1.48 10.39-.49Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalCalls104 = (InternationalCalls104);
;// ./src/Picto/GeneratedPictoComponents/InternationalCalls56.tsx


var InternationalCalls56_excluded = ["className"];
function InternationalCalls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalCalls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalCalls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalCalls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternationalCalls56_objectSpread(InternationalCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M10.32 22.15c.74 6.34 3.93 16.91 16.41 22.84 1.15.55.72 2.27-.55 2.21-6.93-.33-18.24-3.77-18.83-22.71 0-.11 0-.22.03-.33.08-.33.29-1.12.67-2.24s2.11-1 2.25.23Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.38 7.59c-1.82 1.18-3.7 2.24-5.49 3.48-2.8 1.95.15 2.02-.7 4.8-.83 2.71-2.11 4.8-4.54 5.7-1.31.48-5.36 1.1-5.57 2.47-.29 1.9 1.12 4.07 1.49 5.9.41 2.02.72 4.4 2.58 5.35 2.14 1.1 4.4 1.87 6.63 2.7 1.14.42.61 3.52.61 4.65M36.04 9.61s-.86 2.62 1.57 5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.42 46.86c-4.56.81-9.43.05-13.72-2.5-9.49-5.65-12.61-17.92-6.96-27.41S27.66 4.34 37.15 9.99c3.6 2.14 6.29 5.24 7.92 8.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M34.01 44.31c.36 0 .73.05 1.07.14.53.14.91.63 1.46.8a7.888 7.888 0 0 0 2.93.35c2.21-.15 4-1.37 5.51-2.97.7-.74.91-.14.81.33 0 0-1.99 5.7-8.17 5.37 0 0-5.12.29-3.6-4.02Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.02 47.77c2.12-1.09 5.02-3.73 7.11-10.21 3.89-12.12-2.22-15.22-2.47-15.35-.14-.05-1.83-.59-1.83-.59-1.22-.39-2.68.36-3.07 1.58l-1.2 3.74c-.42 1.27.28 2.65 1.55 3.06h.03l1.7.6c-.11 1.52-.45 3.09-.91 4.67l-.17.53c-.49 1.52-1.16 2.95-1.98 4.33l-1.68-.54c-1.22-.39-2.68.36-3.07 1.58l-1.2 3.74c-.2.61-.16 1.29.15 1.9s.82.98 1.46 1.23c0 0 3.53.8 5.59-.26Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalCalls56 = (InternationalCalls56);
;// ./src/Picto/GeneratedPictoComponents/InternationalMobileCalls104.tsx


var InternationalMobileCalls104_excluded = ["className"];
function InternationalMobileCalls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalMobileCalls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalMobileCalls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalMobileCalls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalMobileCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalMobileCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternationalMobileCalls104_objectSpread(InternationalMobileCalls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.79 39.87c1.18 11.81 6.91 32.64 31.61 43.88 1.9.86 1.27 3.71-.81 3.67-12.71-.26-35.09-5.91-36.2-42.26 0-.18.01-.36.06-.53.17-.67.67-2.57 1.62-5.21.7-1.94 3.52-1.59 3.72.46Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.71 13.95c-3.38 2.18-6.87 4.15-10.19 6.46-5.2 3.62.27 3.75-1.3 8.91-1.54 5.04-3.91 8.91-8.43 10.58-2.43.9-9.96 2.04-10.34 4.59-.53 3.52 2.07 7.56 2.76 10.96.76 3.75 1.34 8.17 4.79 9.94 3.98 2.05 8.17 3.48 12.3 5.01 2.11.78 1.13 6.54 1.13 8.64M67.21 17.71s-1.6 4.87 2.91 9.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.87 86.18a36.988 36.988 0 0 1-25.69-3.29C15.02 73.35 8.02 50.9 17.56 32.74c9.53-18.16 31.99-25.16 50.15-15.62 6.89 3.62 12.18 9.1 15.56 15.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M83.39 88.1c-1.84-1.17-4.11-1.28-6.02-2.33-8.2-4.29-9.95-14.16-11.2-22.49-.36-2.08-.45-3.42-2.86-3.61v28.6c0 2.58.88 3.47 3.45 3.47h18.73c.12-1.47-.85-2.85-2.09-3.64Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "63.12",
        y: "39.41",
        width: "28.72",
        height: "52.44",
        rx: "4",
        ry: "4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M76.28 43.65h2.39M73.9 87.61h7.15"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalMobileCalls104 = (InternationalMobileCalls104);
;// ./src/Picto/GeneratedPictoComponents/InternationalMobileCalls56.tsx


var InternationalMobileCalls56_excluded = ["className"];
function InternationalMobileCalls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternationalMobileCalls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternationalMobileCalls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternationalMobileCalls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternationalMobileCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternationalMobileCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternationalMobileCalls56_objectSpread(InternationalMobileCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M10.17 22c.74 6.34 3.93 16.91 16.41 22.84 1.15.55.72 2.27-.55 2.21-6.93-.33-18.24-3.77-18.83-22.71 0-.11 0-.22.03-.33.08-.33.29-1.12.67-2.24s2.11-1 2.25.23Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.54 7.51c-1.82 1.18-3.7 2.24-5.49 3.48-2.8 1.95.15 2.02-.7 4.8-.83 2.71-2.11 4.8-4.54 5.7-1.31.48-5.36 1.1-5.57 2.47-.29 1.9 1.12 4.07 1.49 5.9.41 2.02.72 4.4 2.58 5.35 2.14 1.1 4.4 1.87 6.63 2.7 1.14.42.61 3.52.61 4.65M36.19 9.54s-.86 2.62 1.57 5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.7 46.41c-4.51 1.05-9.41.55-13.83-1.77-9.78-5.13-13.55-17.22-8.41-27 5.13-9.78 17.22-13.55 27-8.41 3.71 1.95 6.56 4.9 8.38 8.34"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.9 47.44c-.99-.63-2.21-.69-3.24-1.25-4.41-2.31-5.36-7.63-6.03-12.11-.2-1.12-.24-1.84-1.54-1.95v15.4c0 1.39.47 1.87 1.86 1.87h10.09c.06-.79-.46-1.53-1.13-1.96Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.99",
        y: "21.22",
        width: "15.46",
        height: "28.24",
        rx: "1.93",
        ry: "1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.08 23.5h1.28M39.79 47.17h3.85"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternationalMobileCalls56 = (InternationalMobileCalls56);
;// ./src/Picto/GeneratedPictoComponents/Internet104.tsx


var Internet104_excluded = ["className"];
function Internet104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Internet104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Internet104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Internet104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Internet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Internet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Internet104_objectSpread(Internet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M16.28 53.67c1.71 2.67 2.34 5.69 4.03 8.94 6.19 11.91 14.82 18.31 29.74 18.26 3.06-.01 7.54.3 8.15 3.22l-.26-1.06H18.41c-8.02 0-6.77 1.17-6.77-6.76V50.84c2.13-.17 3.49 1.04 4.64 2.84Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11",
        y: "20",
        width: "82",
        height: "64",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 30h82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.82 72.95c-10.37 0-18.77-8.4-18.77-18.77 0-1.46.17-2.88.48-4.25.24-1.03-1.26-1.52-1.69-.55-1.31 2.94-1.88 6.28-1.49 9.78.96 8.58 7.9 15.52 16.48 16.48 2.86.32 5.6 0 8.11-.84 1.22-.41.79-2.22-.48-2.04-.86.12-1.75.19-2.65.19"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.77 57c0 10.37-8.4 18.77-18.77 18.77S33.23 67.37 33.23 57 41.63 38.23 52 38.23 70.77 46.63 70.77 57Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.82 74.73c-1.52-2.78-2.75-4.52-3.67-6.88-.05-.12-.1-.24-.14-.38-1.21-3.26-1.86-7.06-1.94-10.48-.1-3.6.41-7.2 1.54-10.63.79-2.34 1.84-4.59 3.17-6.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.64 45.26c-1.33.65-2.68 1.21-4.08 1.67-3.41 1.11-7 1.62-10.56 1.52a30.57 30.57 0 0 1-10.39-2.08 27.82 27.82 0 0 1-3.72-1.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.89 69.37c1.33-.75 2.71-1.38 4.13-1.89 3.21-1.19 6.59-1.84 9.98-1.93 3.43-.1 6.88.37 10.17 1.4 1.54.48 3.02 1.07 4.47 1.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.19 74.71c1.62-2.83 2.92-4.85 3.84-7.37.05-.14.09-.26.14-.39 1.09-3.12 1.67-6.72 1.76-9.95.1-3.4-.36-6.81-1.37-10.07a30.05 30.05 0 0 0-3.34-7.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 75.77V38.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.77 57H33.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "16.64",
        cy: "25",
        r: "1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "21.64",
        cy: "25",
        r: "1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "26.64",
        cy: "25",
        r: "1.64"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Internet104 = (Internet104);
;// ./src/Picto/GeneratedPictoComponents/Internet56.tsx


var Internet56_excluded = ["className"];
function Internet56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Internet56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Internet56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Internet56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Internet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Internet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Internet56_objectSpread(Internet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M8.99 26.38c.96 1.75 1.32 3.74 2.27 5.88 3.49 7.83 8.35 12.04 16.76 12.01 1.73 0 4.25.2 4.59 2.11l-.15-.7H10.2c-4.52 0-3.82.77-3.82-4.45V24.51c1.2-.11 1.97.68 2.61 1.87Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "11.84",
        width: "43.99",
        height: "34.33",
        rx: "3",
        ry: "3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 17.2h43.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.42 40.03c-5.74 0-10.39-4.65-10.39-10.39 0-.81.09-1.6.27-2.35.13-.57-.69-.84-.93-.31a10.51 10.51 0 0 0-.83 5.41c.53 4.75 4.37 8.59 9.12 9.12 1.58.18 3.1 0 4.49-.47.68-.23.44-1.23-.27-1.13-.48.07-.97.1-1.46.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.59 31c0 5.85-4.74 10.59-10.59 10.59S17.41 36.85 17.41 31 22.15 20.41 28 20.41 38.59 25.15 38.59 31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.52 41c-.86-1.57-1.55-2.55-2.07-3.88-.03-.07-.06-.13-.08-.21-.68-1.84-1.05-3.98-1.1-5.91-.06-2.03.23-4.06.87-5.99.44-1.32 1.04-2.59 1.79-3.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.26 24.38c-.75.37-1.51.68-2.3.94-1.92.63-3.95.91-5.96.86-1.99-.05-3.97-.44-5.86-1.17-.71-.27-1.41-.6-2.1-.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.04 37.98c.75-.42 1.53-.78 2.33-1.07 1.81-.67 3.71-1.04 5.63-1.09 1.93-.06 3.88.21 5.74.79.87.27 1.7.61 2.52 1.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.49 40.99c.91-1.6 1.65-2.73 2.17-4.16l.08-.22c.62-1.76.94-3.79.99-5.61.06-1.91-.2-3.84-.77-5.68-.44-1.43-1.07-2.81-1.89-4.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 41.59V20.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.59 31H17.41"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "9.68",
        cy: "14.54",
        r: ".82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "12.18",
        cy: "14.54",
        r: ".82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "14.68",
        cy: "14.54",
        r: ".82"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Internet56 = (Internet56);
;// ./src/Picto/GeneratedPictoComponents/InternetCalls104.tsx


var InternetCalls104_excluded = ["className"];
function InternetCalls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetCalls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetCalls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetCalls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetCalls104_objectSpread(InternetCalls104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M60 92c-17.7.3-33.1-13.3-39-25.6-6.8-14.2-5-34 4.9-46.2-12.1 9.8-17.7 25.7-14.2 41s15.4 27.2 30.7 30.7c3 .7 6.1 1 9.1 1L60 92z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.9 92c-2.7.5-5.4.8-8.2.8-22.6 0-40.9-18.3-40.9-40.9S29.1 11 51.7 11c14.7 0 27.7 7.8 34.9 19.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.2 90.6c-3-4.8-5.7-9.8-8-15-.1-.3-.2-.5-.3-.8-2.6-7.3-4-15-4.2-22.8-.2-7.9.9-15.7 3.4-23.2 1.7-5.1 4-10 6.9-14.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.5 26.4c-2.9 1.4-5.8 2.6-8.9 3.6-7.4 2.4-15.2 3.5-23 3.3-7.8-.2-15.4-1.7-22.6-4.5-2.8-1-5.6-2.3-8.2-3.8M51.1 69.8c1.9-.1 3.7-.1 5.6 0M20.3 78c2.9-1.6 5.9-3 9-4.1 7-2.6 14.3-3.9 21.8-4.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.7 33.9c-.3-1.3-.7-2.6-1.1-3.9-1.7-5.6-4.2-10.9-7.3-15.8M51.6 92.9V11.1M69.1 52H10.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M67.6 86.7c11.2 2 18.9-12.6 18.9-12.6-1.2 1.5-2.5 2.9-3.9 4.1-3 2.7-7 4.1-11 4-1.3-.1-2.7-.3-3.9-.7-.5-.2-.9-.3-1.3-.5-1-.4-1.5-1.4-2.5-1.8-.6-.2-1.3-.4-1.9-.5-3.8 7.5 5.6 8.1 5.6 8z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M89.1 69.3c9.8-21.3-.7-28.3-1.2-28.6l-3.2-1.5c-2.3-.9-4.9 0-6 2.2l-3 6.6c-1 2.2-.1 4.9 2.2 5.9l3 1.4c-.6 2.9-1.5 5.7-2.7 8.4l-.4.9c-1.2 2.7-2.8 5.2-4.6 7.5l-3-1.3c-2.3-.9-4.8.1-5.9 2.3l-3 6.6c-.5 1.1-.6 2.4-.1 3.5s1.3 2 2.4 2.5c0 0 6.3 2.2 10.3.7 0 0 8.1-1.7 15.2-17.1z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetCalls104 = (InternetCalls104);
;// ./src/Picto/GeneratedPictoComponents/InternetCalls56.tsx


var InternetCalls56_excluded = ["className"];
function InternetCalls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetCalls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetCalls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetCalls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetCalls56_objectSpread(InternetCalls56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M31.6 47.7c-6.5-1-16.3-6.2-19.2-12.2-3.3-7-2.3-17.1 2.5-23.1C8.9 17.2 6.2 25 8 32.5s7.6 13.3 15 15c1.5.3 3 .5 4.5.5l4.1-.3z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.5 47.6c-1.3.3-2.6.4-4 .4-11.1 0-20-9-20-20s9-20 20-20c7.2 0 13.5 3.8 17.1 9.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.9 46.9c-1.5-2.4-2.8-4.8-3.9-7.3-.1-.1-.1-.3-.1-.4-1.3-3.6-2-7.4-2.1-11.2-.1-3.8.4-7.7 1.6-11.3.8-2.5 2-4.9 3.4-7.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.1 15.5c-1.4.7-2.9 1.3-4.3 1.8-3.6 1.2-7.4 1.7-11.2 1.6-3.8-.1-7.5-.9-11.1-2.2-1.4-.5-2.7-1.1-4-1.9M27.2 36.7h2.7M12.2 40.7c1.4-.8 2.9-1.5 4.4-2 3.4-1.2 7-1.9 10.6-2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.3 19.1c-.2-.6-.3-1.3-.5-1.9-.8-2.7-2-5.3-3.6-7.7M27.5 48V8M36.3 28H7.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36 45c5.5 1 9.2-6.2 9.2-6.2-.6.7-1.2 1.4-1.9 2-1.5 1.3-3.4 2-5.4 2-.7 0-1.3-.2-1.9-.4-.2-.1-.4-.2-.7-.3-.5-.2-.8-.7-1.2-.9-.3-.1-.6-.2-.9-.2-1.8 3.7 2.8 4 2.8 4z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.5 36.5c4.8-10.4-.4-13.9-.6-14l-1.6-.7c-1.1-.5-2.4 0-2.9 1.1L40 26.1c-.5 1.1 0 2.4 1.1 2.9l1.5.7c-.3 1.4-.7 2.8-1.3 4.1l-.3.4c-.6 1.3-1.4 2.5-2.2 3.7l-1.5-.7c-1.1-.4-2.4 0-2.9 1.1l-1.5 3.2c-.2.5-.3 1.2-.1 1.7.2.5.7 1 1.2 1.2 0 0 3.1 1.1 5 .3.1.1 4-.7 7.5-8.2z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetCalls56 = (InternetCalls56);
;// ./src/Picto/GeneratedPictoComponents/InternetMobileCalls104.tsx


var InternetMobileCalls104_excluded = ["className"];
function InternetMobileCalls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetMobileCalls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetMobileCalls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetMobileCalls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetMobileCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetMobileCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetMobileCalls104_objectSpread(InternetMobileCalls104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.1 89.2c-16.3 0-29.4-12.9-35.2-25-6.7-14-4.9-33.4 4.8-45.4-12 9.6-17.4 25.3-14 40.3s15.2 26.7 30.1 30.1c3 .7 6 1 8.9 1l5.4-1z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.6 89.1c-1.7.2-3.4.3-5.1.3-21.6 0-39.2-17.5-39.2-39.2S29.8 11 51.5 11c14.1 0 26.5 7.5 33.4 18.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.5 87.3c-2.9-4.6-5.4-9.4-7.7-14.4-.1-.2-.2-.5-.3-.8-2.5-7-3.9-14.4-4.1-21.9-.2-7.5.9-15 3.2-22.2 1.6-4.9 3.9-9.6 6.6-14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82 25.7c-2.8 1.4-5.6 2.5-8.5 3.5-7.1 2.3-14.6 3.4-22.1 3.2-7.4-.2-14.7-1.7-21.7-4.4-2.7-1-5.3-2.2-7.8-3.6M22 76.1c2.8-1.5 5.6-2.8 8.6-3.9 6.7-2.4 13.7-3.8 20.9-3.9 1.7-.1 3.3-.1 5 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.5 29.2c-1.6-5.4-4-10.5-7-15.2M74.9 34.4c-.4-1.7-.8-3.5-1.4-5.2M51.5 89.4V11M56.5 50.2H12.2"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M83.4 88.1c-1.8-1.2-4.1-1.3-6-2.3-8.2-4.3-9.9-14.2-11.2-22.5-.4-2.1-.4-3.4-2.9-3.6V88.3c0 2.6.9 3.5 3.4 3.5h18.7c.2-1.5-.8-2.9-2-3.7z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.1 39.4h20.7c2.2 0 4 1.8 4 4v44.4c0 2.2-1.8 4-4 4H67.1c-2.2 0-4-1.8-4-4V43.4c0-2.2 1.8-4 4-4zM76.3 43.7h2.4M73.9 87.6h7.2"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetMobileCalls104 = (InternetMobileCalls104);
;// ./src/Picto/GeneratedPictoComponents/InternetMobileCalls56.tsx


var InternetMobileCalls56_excluded = ["className"];
function InternetMobileCalls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function InternetMobileCalls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? InternetMobileCalls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : InternetMobileCalls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function InternetMobileCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, InternetMobileCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", InternetMobileCalls56_objectSpread(InternetMobileCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.89 46.94c-6.47-1-15.58-6.22-18.46-12.24-3.32-6.95-2.31-17.09 2.53-23.08a19.982 19.982 0 0 0-6.95 20.06c1.72 7.47 7.55 13.3 15.01 15.01 1.48.34 2.97.5 4.45.5l3.42-.25Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.63 46.94c-.86.11-1.73.17-2.62.17-11.05 0-20-8.95-20-20s8.96-20 20-20c7.22 0 13.54 3.82 17.06 9.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.43 46a66.018 66.018 0 0 1-3.91-7.33 2.74 2.74 0 0 1-.15-.4 35.713 35.713 0 0 1-2.07-11.16c-.11-3.84.44-7.68 1.64-11.33.84-2.51 1.97-4.9 3.38-7.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.61 14.6c-1.41.69-2.86 1.29-4.35 1.78A33.27 33.27 0 0 1 28.01 18c-3.79-.1-7.54-.85-11.07-2.22a27.88 27.88 0 0 1-4-1.85M13.01 40.29c1.41-.79 2.88-1.45 4.4-2 3.41-1.25 7.01-1.92 10.64-2 .85-.03 1.7-.02 2.54.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.26 16.38c-.83-2.73-2.03-5.33-3.56-7.74M39.96 19.01c-.2-.88-.43-1.76-.7-2.63M28.01 47.11v-40M30.6 27.11H8.01"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.9 47.44c-.99-.63-2.21-.69-3.24-1.25-4.41-2.31-5.36-7.63-6.03-12.11-.2-1.12-.24-1.84-1.54-1.95v15.4c0 1.39.47 1.87 1.86 1.87h10.09c.06-.79-.46-1.53-1.13-1.96Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.99",
        y: "21.22",
        width: "15.46",
        height: "28.24",
        rx: "1.93",
        ry: "1.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.08 23.5h1.28M39.79 47.17h3.85"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_InternetMobileCalls56 = (InternetMobileCalls56);
;// ./src/Picto/GeneratedPictoComponents/Landline104.tsx


var Landline104_excluded = ["className"];
function Landline104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Landline104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Landline104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Landline104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Landline104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Landline104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Landline104_objectSpread(Landline104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.31 17.41h3.06v71.12h-3.06zM32.64 89.68C20.1 86.03 20.67 75.7 20.67 75.7s-.99-46.21-.99-51.46-3.16-11.75-3.16-11.75 0 2 .01 5.34a2.21 2.21 0 0 0-1.29-.42h-2.05a2.2 2.2 0 0 0-2.2 2.2v66.72c0 1.21.98 2.2 2.2 2.2h2.05c.56 0 1.07-.22 1.46-.57.3 5.57 4.1 4.72 4.1 4.72h13.9c-.17-2.01-2.08-3-2.08-3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.52 89.16h-.85c-2.58 0-4.67-2.09-4.67-4.67v-63.1c0-2.58 2.09-4.67 4.67-4.67h.58M41.31 16.72h47.02c2.58 0 4.67 2.09 4.67 4.67v63.1c0 2.58-2.09 4.67-4.67 4.67H41.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.52",
        y: "11",
        width: "24.79",
        height: "81.98",
        rx: "3.85",
        ry: "3.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.31 89.06c0 2.12-1.72 3.84-3.84 3.84h-17.1c-2.12 0-3.84-1.72-3.84-3.84V14.84c0-2.12 1.72-3.84 3.84-3.84h17.1c2.12 0 3.84 1.72 3.84 3.84v74.22"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "49.14",
        y: "49.13",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "62.41",
        y: "49.13",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "75.68",
        y: "49.13",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "49.3",
        y: "62.47",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "62.57",
        y: "62.47",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "75.84",
        y: "62.47",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "49.3",
        y: "75.82",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "62.57",
        y: "75.82",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "75.84",
        y: "75.82",
        width: "9.69",
        height: "7.63",
        rx: "1.45",
        ry: "1.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.62 39c-3.3-.64-6.27-3.27-7.52-6.39l-1.14-3.97c-.22-.76-1.34-.6-1.34.19v10.93c0 1.24 1 2.24 2.24 2.24H64.2c1 0 1.19-1.43.23-1.69L59.63 39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "49.14",
      y: "24.34",
      width: "36.23",
      height: "18.03",
      rx: "2.24",
      ry: "2.24",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Landline104 = (Landline104);
;// ./src/Picto/GeneratedPictoComponents/Landline56.tsx


var Landline56_excluded = ["className"];
function Landline56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Landline56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Landline56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Landline56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Landline56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Landline56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Landline56_objectSpread(Landline56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.39 9.86H24v37.3h-1.61zM17.85 47.77c-6.57-1.92-6.28-7.33-6.28-7.33s-.52-24.24-.52-26.99-1.66-6.16-1.66-6.16v2.82c-.19-.14-.42-.24-.68-.24H7.64c-.64 0-1.15.52-1.15 1.15v35c0 .64.52 1.15 1.15 1.15h1.07c.3 0 .56-.12.77-.31.15 2.93 2.15 2.48 2.15 2.48h7.29c-.09-1.05-1.09-1.57-1.09-1.57Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.77 9.5h24.28c1.35 0 2.45 1.1 2.45 2.45v33.1c0 1.35-1.1 2.45-2.45 2.45H22.4M9.39 47.5h-.44c-1.35 0-2.45-1.1-2.45-2.45v-33.1c0-1.35 1.1-2.45 2.45-2.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "9.39",
        y: "6.5",
        width: "13",
        height: "43",
        rx: "2.02",
        ry: "2.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "9.39",
        y: "6.5",
        width: "13",
        height: "42.96",
        rx: "2.02",
        ry: "2.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "26.5",
        y: "26.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.46",
        y: "26.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "40.42",
        y: "26.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "26.58",
        y: "33.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.54",
        y: "33.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "40.5",
        y: "33.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "26.58",
        y: "40.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.54",
        y: "40.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "40.5",
        y: "40.5",
        width: "5.08",
        height: "4",
        rx: ".76",
        ry: ".76"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.88 21.11c-1.96-.38-3.73-1.96-4.47-3.83l-.68-2.38c-.13-.45-.79-.36-.79.11v6.55c0 .74.6 1.34 1.33 1.34h7.33c.6 0 .71-.85.13-1.01l-2.86-.79Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "26.5",
      y: "13.5",
      width: "19",
      height: "9.46",
      rx: "1.18",
      ry: "1.18",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Landline56 = (Landline56);
;// ./src/Picto/GeneratedPictoComponents/Legal104.tsx


var Legal104_excluded = ["className"];
function Legal104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Legal104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Legal104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Legal104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Legal104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Legal104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Legal104_objectSpread(Legal104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.37 53.77c-.03-.63 7.22 8.2 21.85 5.94 2.27-.35 3.59 2.44 1.88 3.97-1.84 1.65-4.9 3.09-9.95 3.23h-.17c-1.13-.04-12.98-.43-13.61-13.14ZM8.02 61.28c0-.59 6.27 7.93 21.5 6.05 1.88-.23 2.86 2.13 1.44 3.37-1.84 1.61-5.04 3.06-10.58 2.96h-.13c-1.01-.07-12.08-.69-12.22-12.38Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 29.22v61.7M40.06 90.92h23.77"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.97 23.25c0 3.3-2.68 5.97-5.97 5.97s-5.97-2.67-5.97-5.97 2.67-5.97 5.97-5.97 5.97 2.67 5.97 5.97ZM7 59.74l14.32-32.71 14.26 32.71M45.57 23.25l-30.89 3.78M89.32 17.93 58.43 21.7M35.64 59.75c0 7.91-6.41 14.32-14.32 14.32S7 67.66 7 59.75h28.64ZM97 52.58 82.68 19.86 68.42 52.58M68.36 52.59c0 7.91 6.41 14.32 14.32 14.32S97 60.5 97 52.59H68.36Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Legal104 = (Legal104);
;// ./src/Picto/GeneratedPictoComponents/Legal56.tsx


var Legal56_excluded = ["className"];
function Legal56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Legal56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Legal56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Legal56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Legal56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Legal56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Legal56_objectSpread(Legal56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.93 28.8c-.02-.31 3.42 4.08 10.46 3.28 1.43-.16 2.09 1.74.87 2.49-.96.59-2.34 1.04-4.32 1.1h-.12c-.68-.03-6.56-.45-6.87-6.87ZM5.15 32.57c0-.3 3.56 4.25 11.29 3.33.96-.11 1.52 1.1.79 1.73-.94.81-2.57 1.54-5.38 1.5h-.08c-.59-.04-6.54-.63-6.61-6.56Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 16.42v31.52M21.9 47.94h12.14"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.05 13.37a3.05 3.05 0 1 1-6.1 0 3.05 3.05 0 1 1 6.1 0ZM5.02 32.01l7.31-16.71 7.28 16.71M24.72 13.37 8.94 15.3M47.06 10.65l-15.78 1.93M19.64 32.02c0 4.04-3.28 7.31-7.31 7.31s-7.31-3.27-7.31-7.31h14.63ZM50.98 28.35l-7.31-16.71-7.28 16.71M36.36 28.36c0 4.04 3.28 7.31 7.31 7.31s7.31-3.27 7.31-7.31H36.35Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Legal56 = (Legal56);
;// ./src/Picto/GeneratedPictoComponents/MBBRoaming104.tsx


var MBBRoaming104_excluded = ["className"];
function MBBRoaming104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MBBRoaming104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MBBRoaming104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MBBRoaming104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MBBRoaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MBBRoaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MBBRoaming104_objectSpread(MBBRoaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.07 83.02c-4.07-.45-8.11-1.15-12.1-2.09-3.93-.78-7.53-2.75-10.31-5.64a13.785 13.785 0 0 1-2.44-5.35c-.51-1.95-.84-4.08-1.5-6.05-.55-1.58-1.42-4.04-3.34-4.39-.82-.16-2.69-.21-2.69 1.02v24.67c0 1.54 1.6 7.32 6.64 7.32h47.36c.96 0 .59-2.79.45-3.18-1.95-4.27-7.81-3.9-11.71-4.92-3.36-.59-6.91-.94-10.35-1.39Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.82 11.01h66.37c4.31 0 7.81 3.5 7.81 7.81v66.37C93 89.5 89.5 93 85.19 93H18.82c-4.31 0-7.81-3.5-7.81-7.81V18.82c0-4.31 3.5-7.81 7.81-7.81Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.58 38.34h46.85c2.16 0 3.9 1.75 3.9 3.9v27.33c0 2.16-1.75 3.9-3.9 3.9H28.58c-2.16 0-3.9-1.75-3.9-3.9V42.24c0-2.16 1.75-3.9 3.9-3.9Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.07 21.31c-1.25-.57-2.52-.94-3.53-.94s-1.75.26-2.27.89c-.38.46-.57 1.05-.55 1.65 0 1.96 1.54 4.67 4.18 6.89 2.35 1.96 4.94 3.06 6.82 3.06.94 0 1.7-.29 2.19-.86.39-.44.55-1.02.55-1.67 0-1.9-1.55-4.57-4.05-6.73",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.68 81.28c-1.45 0-2.77.88-3.32 2.22s-.24 2.89.79 3.92a3.588 3.588 0 0 0 6.12-2.56c0-.95-.38-1.86-1.05-2.53a3.594 3.594 0 0 0-2.54-1.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.19 62.83h-.05a.46.46 0 0 1-.34-.21l-1.73-2.72-2.72-1.73a.45.45 0 0 1-.21-.35c-.01-.14.04-.28.14-.38l.99-.95c.12-.12.3-.15.46-.11l2.16.66 2.6-2.86-5.88-2.26c-.15-.06-.25-.18-.29-.34s.01-.31.12-.42l1.01-1.04a1.81 1.81 0 0 1 1.63-.53l6.47 1.12c.39-.44 2.42-2.63 3.94-2.63.43 0 .77.15 1.03.4.29.31.42.71.37 1.11 0 1.25-1.64 2.94-2.63 3.85l1.14 6.41c.11.6-.09 1.22-.53 1.64l-1.01.98c-.11.11-.27.15-.42.12a.441.441 0 0 1-.33-.29l-2.29-5.88-2.87 2.68.66 2.17c.05.16 0 .34-.11.46l-.95.96a.47.47 0 0 1-.33.14ZM49.08 16.3c-.48 0-.89.34-.97.81l-.42 2.27h3.73l-1.6 8.82h2.96c.4 0 .84-.18.97-.86l1.36-7.96h2.69c.48 0 .89-.34.97-.81l.42-2.27h-10.1Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.84 56.22v5.54M52.98 58.46v3.12M64.7 52.23v9.35M70.55 50.05v11.71"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MBBRoaming104 = (MBBRoaming104);
;// ./src/Picto/GeneratedPictoComponents/MBBRoaming56.tsx


var MBBRoaming56_excluded = ["className"];
function MBBRoaming56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MBBRoaming56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MBBRoaming56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MBBRoaming56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MBBRoaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MBBRoaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MBBRoaming56_objectSpread(MBBRoaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.42 43.89a51.82 51.82 0 0 1-6.2-1.07c-2.02-.4-3.86-1.41-5.28-2.89a7.12 7.12 0 0 1-1.25-2.74c-.26-1-.43-2.09-.77-3.1-.28-.81-.73-2.07-1.71-2.25-.42-.08-1.38-.11-1.38.52V45c0 .79.82 3.75 3.4 3.75h24.26c.49 0 .3-1.43.23-1.63-1-2.19-4-2-6-2.52-1.72-.3-3.54-.48-5.3-.71Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11 7h34c2.21 0 4 1.79 4 4v34c0 2.21-1.79 4-4 4H11c-2.21 0-4-1.79-4-4V11c0-2.21 1.79-4 4-4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16 21h24c1.1 0 2 .9 2 2v14c0 1.1-.9 2-2 2H16c-1.1 0-2-.9-2-2V23c0-1.1.9-2 2-2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.54 12.21c-.64-.29-1.29-.48-1.81-.48s-.89.13-1.16.45c-.19.24-.29.54-.28.84 0 1 .79 2.39 2.14 3.53 1.2 1 2.53 1.56 3.49 1.56.48 0 .87-.15 1.12-.44.2-.23.28-.52.28-.86 0-.97-.79-2.34-2.07-3.45",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.83 43c-.75 0-1.42.45-1.7 1.14s-.12 1.48.4 2.01a1.844 1.844 0 0 0 3.14-1.32c0-.49-.19-.95-.54-1.3-.35-.34-.81-.54-1.3-.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.92 33.34h-.03c-.08 0-.14-.05-.18-.12l-.93-1.46-1.46-.93a.247.247 0 0 1-.12-.19c0-.08.02-.15.08-.21l.53-.51c.07-.06.16-.08.25-.06l1.16.36 1.4-1.53-3.15-1.21c-.08-.03-.14-.1-.15-.18s0-.17.06-.23l.54-.56c.23-.23.56-.34.88-.29l3.47.6c.21-.24 1.3-1.41 2.11-1.41.23 0 .41.08.55.22.16.17.23.38.2.6 0 .67-.88 1.58-1.41 2.06l.61 3.44c.06.32-.05.65-.29.88l-.54.52c-.06.06-.15.08-.23.06a.273.273 0 0 1-.18-.15l-1.23-3.15-1.54 1.44.36 1.16c.03.09 0 .18-.06.25l-.51.52s-.11.07-.18.07ZM26.52 9.64c-.25 0-.46.17-.5.41l-.21 1.16h1.91l-.82 4.51h1.52c.2 0 .43-.09.5-.44l.69-4.07h1.38c.24 0 .46-.17.5-.41l.21-1.16h-5.17Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.5 30.16V33M28.5 31.31v1.6M34.5 28.12v4.79M37.5 27v6"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MBBRoaming56 = (MBBRoaming56);
;// ./src/Picto/GeneratedPictoComponents/MobileAccelerator104.tsx


var MobileAccelerator104_excluded = ["className"];
function MobileAccelerator104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MobileAccelerator104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MobileAccelerator104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MobileAccelerator104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MobileAccelerator104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileAccelerator104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileAccelerator104_objectSpread(MobileAccelerator104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.45 48.95c-.64 2.16-4.43 1.64-3.78-.55 3.26-10.93 12.55-16.65 24.66-16.83h.04c2.41 0 2.84 3.47.39 3.5-10.23.15-18.49 4.43-21.31 13.88Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.35 50.42c0 2.08 1.69 3.77 3.77 3.77s3.77-1.69 3.77-3.77-1.69-3.77-3.77-3.77-3.77 1.69-3.77 3.77Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 65v22.29c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v5.57M44.57 14.86h3.72M40.86 89.14H52"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.94 46.3c.41-.04.55.53.17.68l-14.38 5.87c-1.35.34-2.71-.47-3.05-1.82-.32-1.25.36-2.52 1.54-2.96l.28-.09 15.44-1.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.23 53.01h-3.47c-.05-11.79 9.47-21.39 21.27-21.44 11.79-.05 21.4 9.47 21.44 21.26h-3.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.08 38.05 2.32 2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.03 31.57v3.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m84.01 38.05-2.34 2.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileAccelerator104 = (MobileAccelerator104);
;// ./src/Picto/GeneratedPictoComponents/MobileAccelerator56.tsx


var MobileAccelerator56_excluded = ["className"];
function MobileAccelerator56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MobileAccelerator56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MobileAccelerator56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MobileAccelerator56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MobileAccelerator56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MobileAccelerator56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MobileAccelerator56_objectSpread(MobileAccelerator56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.95 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.99 35v12c0 1.66-1.34 3-3 3h-18c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M23.99 8h2M21.99 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.24 26.36c-.35 1.16-2.39.88-2.03-.3 1.76-5.88 6.76-8.96 13.28-9.06h.02c1.3 0 1.53 1.87.21 1.89-5.51.08-9.95 2.38-11.47 7.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.18 27.15c0 1.12.91 2.03 2.03 2.03 1.12 0 2.03-.91 2.03-2.03 0-1.12-.91-2.03-2.03-2.03-1.12 0-2.03.91-2.03 2.03Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.24 24.93c.21-.02.29.27.09.35l-7.78 3.18c-.72.18-1.46-.26-1.64-.98-.17-.67.2-1.36.83-1.6l.15-.05 8.36-.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.58 28.55h-1.87c-.03-6.35 5.1-11.52 11.45-11.55 6.35-.03 11.52 5.1 11.55 11.45h-1.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.12 20.49 1.24 1.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.17 17v1.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.23 20.49-1.26 1.14"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MobileAccelerator56 = (MobileAccelerator56);
;// ./src/Picto/GeneratedPictoComponents/MoveHouse104.tsx


var MoveHouse104_excluded = ["className"];
function MoveHouse104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MoveHouse104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MoveHouse104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MoveHouse104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MoveHouse104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MoveHouse104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MoveHouse104_objectSpread(MoveHouse104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.89 39.93 2.78 8.85c.18.58.81.91 1.39.73l13.6-5.19c1.06-.33 1.41-1.31.3-1.36-3.44-.15-14.52-.93-17.55-4.95-.64-.85-1.65-.57-.52 1.92Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.47 28.19 25.46-9.27 7.87 21.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.3 22.36 2.07 5.68-5.11.48-4.22 2.92-2.07-5.69"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.81 69.8 1.37 4.36c1.06-1.17 9.25 2.04 8.86 3.97l8.1-2.82c4.44-1.15 2.71-2.12 1.51-2.17-3.71-.17-16.21-1.69-19.47-6.03-.69-.91-1.65-.7-.37 2.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.53 50 32.94-11.99 11.37 31.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m61.14 42.52 2.72 7.47-6.72.62-5.54 3.84-2.72-7.47M57.49 78.85l32.68-11.9c1.26-.46 2.66.19 3.12 1.46l.02.06c.46 1.26-.19 2.66-1.46 3.12L58.77 83.63"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "49.37",
          cy: "83.56",
          r: "9.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.37 85.87c-1.34 2.88-4.77 4.13-7.65 2.78s-4.13-4.77-2.78-7.65M47.73 73.81 29.04 22.47a5.283 5.283 0 0 0-2.78-3.03c-.69-.33-1.44-.49-2.24-.49-.62 0-1.24.11-1.84.32l-11.51 4.19c-.62.22-1.12.68-1.4 1.29-.28.59-.3 1.26-.06 1.9.34.94 1.29 1.59 2.3 1.59.28 0 .57-.05.84-.15l11.92-4.33 18.95 52.05"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MoveHouse104 = (MoveHouse104);
;// ./src/Picto/GeneratedPictoComponents/MoveHouse56.tsx


var MoveHouse56_excluded = ["className"];
function MoveHouse56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function MoveHouse56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? MoveHouse56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : MoveHouse56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function MoveHouse56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, MoveHouse56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", MoveHouse56_objectSpread(MoveHouse56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.84 22.16 1.56 4.97c.1.33.45.51.78.41l7.63-2.91c.6-.19.79-.73.17-.76-1.93-.09-8.14-.52-9.84-2.78-.36-.47-.93-.32-.29 1.08Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.83 15.18 14.16-5.16 4.38 12.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.2 11.93 1.15 3.17-2.85.26-2.34 1.63-1.15-3.17"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.25 37.28.86 2.73c.66-.73 5.8 1.28 5.56 2.49l5.08-1.77c2.79-.72 1.7-1.33.95-1.36-2.32-.1-10.17-1.06-12.21-3.78-.43-.57-1.04-.44-.23 1.69Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m21.89 27.61 17.16-6.24 5.93 16.28"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.15 23.72 1.41 3.89-3.49.32-2.89 2-1.42-3.89M31.24 42.65l17.03-6.2c.66-.24 1.39.1 1.63.76v.03c.25.66-.09 1.39-.75 1.63l-17.24 6.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "27.01",
          cy: "45.1",
          r: "4.9"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.62 46.31c-.7 1.5-2.48 2.15-3.98 1.45s-2.15-2.48-1.45-3.98M26.16 40.02l-9.74-26.75c-.26-.71-.77-1.27-1.45-1.58-.36-.17-.75-.26-1.16-.26-.32 0-.65.06-.96.17l-6 2.18c-.33.12-.58.35-.73.67a1.291 1.291 0 0 0 1.17 1.82c.15 0 .3-.03.44-.08l6.21-2.26 9.87 27.13"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_MoveHouse56 = (MoveHouse56);
;// ./src/Picto/GeneratedPictoComponents/NBN104.tsx


var NBN104_excluded = ["className"];
function NBN104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NBN104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NBN104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NBN104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NBN104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBN104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NBN104_objectSpread(NBN104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.38 85.59c-15.35 0-29.34-8.78-36.01-22.6a39.984 39.984 0 0 1-.24-34.24c.54-1.16-1.02-2.14-1.8-1.13a39.972 39.972 0 0 0 22.8 63.31 39.96 39.96 0 0 0 33.24-7.26c1.01-.77.03-2.33-1.12-1.8a39.738 39.738 0 0 1-16.87 3.72Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "40.86"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.27 45.47v2.26c1.01-1.7 2.67-2.64 4.75-2.64 3.08 0 5.38 2.01 5.38 6.19v10.08h-3.65V51.4c0-2.1-1.19-3.17-2.99-3.17-2.14 0-3.49 1.45-3.49 3.49v9.65h-3.65v-15.9h3.65ZM59.31 53.42c0 5.03-2.95 8.33-6.82 8.33-2.2 0-3.96-1.13-5-2.83v2.45h-3.65V38.43h3.65v9.39c1.04-1.67 2.8-2.73 5-2.73 3.87 0 6.82 3.3 6.82 8.33Zm-11.91 0c0 3.3 1.67 5.34 4.12 5.34s4.12-2.04 4.12-5.34-1.67-5.34-4.12-5.34-4.12 2.01-4.12 5.34ZM66.15 45.47v2.26c1.01-1.7 2.67-2.64 4.75-2.64 3.08 0 5.38 2.01 5.38 6.19v10.08h-3.65V51.4c0-2.1-1.19-3.17-2.99-3.17-2.14 0-3.49 1.45-3.49 3.49v9.65H62.5v-15.9h3.65ZM77.57 44.16c-2.4 0-4.15-1.84-4.15-4.17s1.75-4.15 4.15-4.15 4.15 1.84 4.15 4.15-1.75 4.17-4.15 4.17Zm0-.89c1.93 0 3.18-1.4 3.18-3.27s-1.25-3.25-3.18-3.25-3.18 1.4-3.18 3.25 1.25 3.27 3.18 3.27Zm.32-5.26c1.11 0 1.48.59 1.48 1.22s-.32.88-.7 1.02c.43.11.63.36.63.8v.7c0 .12.02.16.09.25h-1.06c-.07-.07-.11-.13-.11-.23v-.61c0-.41-.18-.52-.54-.52h-.73V42h-1.07v-3.99h2Zm-.93.86v.91h.86c.29 0 .45-.18.45-.46s-.16-.45-.45-.45h-.86Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBN104 = (NBN104);
;// ./src/Picto/GeneratedPictoComponents/NBN56.tsx


var NBN56_excluded = ["className"];
function NBN56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NBN56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NBN56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NBN56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NBN56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NBN56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NBN56_objectSpread(NBN56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.44 46.09c-8.26 0-15.8-4.73-19.39-12.17a21.51 21.51 0 0 1-.19-18.3c.29-.64-.59-1.17-1.01-.61-5.11 6.77-5.99 16.27-1.16 24.29a20.68 20.68 0 0 0 7.02 7.02c8.01 4.83 17.51 3.95 24.28-1.15.56-.42.03-1.3-.61-1.01a21.391 21.391 0 0 1-8.94 1.93Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "22",
        className: "stroke"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.52 24.52v1.27c.56-.95 1.49-1.48 2.65-1.48 1.72 0 3.01 1.12 3.01 3.46v5.64h-2.04v-5.57c0-1.18-.67-1.78-1.67-1.78-1.2 0-1.95.81-1.95 1.95v5.4h-2.04v-8.89h2.04ZM31.83 28.97c0 2.81-1.65 4.66-3.81 4.66-1.23 0-2.21-.63-2.79-1.58v1.37h-2.04V20.59h2.04v5.26c.58-.93 1.56-1.53 2.79-1.53 2.16 0 3.81 1.85 3.81 4.66Zm-6.66 0c0 1.85.93 2.99 2.3 2.99s2.3-1.14 2.3-2.99-.93-2.99-2.3-2.99-2.3 1.12-2.3 2.99ZM35.74 24.52v1.27c.56-.95 1.49-1.48 2.65-1.48 1.72 0 3.01 1.12 3.01 3.46v5.64h-2.04v-5.57c0-1.18-.67-1.78-1.67-1.78-1.2 0-1.95.81-1.95 1.95v5.4H33.7v-8.89h2.04ZM41.98 23.79c-1.34 0-2.32-1.03-2.32-2.33s.98-2.32 2.32-2.32 2.32 1.03 2.32 2.32-.98 2.33-2.32 2.33Zm0-.5c1.08 0 1.78-.78 1.78-1.83s-.7-1.82-1.78-1.82-1.78.78-1.78 1.82.7 1.83 1.78 1.83Zm.18-2.94c.62 0 .83.33.83.68s-.18.49-.39.57c.24.06.35.2.35.45v.39c0 .07 0 .09.05.14h-.59s-.06-.07-.06-.13v-.34c0-.23-.1-.29-.3-.29h-.41v.76h-.6v-2.23h1.12Zm-.52.48v.51h.48c.16 0 .25-.1.25-.26s-.09-.25-.25-.25h-.48Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NBN56 = (NBN56);
;// ./src/Picto/GeneratedPictoComponents/NewMobile104.tsx


var NewMobile104_excluded = ["className"];
function NewMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NewMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NewMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NewMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NewMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NewMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NewMobile104_objectSpread(NewMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.99 48.61h.13V36.93h3.05v15.15h-4.75L41.03 40.2h-.2v11.88h-3.05V36.93h4.9l5.3 11.68ZM53.95 36.93h10.5v2.76h-7.33v3.19h6.53v2.76h-6.53v3.68h7.56v2.76H53.96V36.93ZM81.89 52.09h-3.03l-2.94-10.01-2.96 10.01h-3.05l-4.57-15.15h3.32l2.92 10.21 2.96-10.21h2.72l2.99 10.3 2.92-10.3h3.3L81.9 52.09Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.57 14.86h3.72M40.86 89.14H52"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 59.43v27.86c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v11.14"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NewMobile104 = (NewMobile104);
;// ./src/Picto/GeneratedPictoComponents/NewMobile56.tsx


var NewMobile56_excluded = ["className"];
function NewMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NewMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NewMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NewMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NewMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NewMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NewMobile56_objectSpread(NewMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 32v15c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v6M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.84 26.18h.07v-6.29h1.64v8.16h-2.56l-2.9-6.4h-.11v6.4h-1.64v-8.16h2.64l2.86 6.29ZM29.05 19.89h5.65v1.49h-3.95v1.72h3.52v1.49h-3.52v1.98h4.07v1.49h-5.77V19.9ZM44.09 28.05h-1.63l-1.58-5.39-1.6 5.39h-1.64l-2.46-8.16h1.79l1.57 5.5 1.6-5.5h1.46l1.61 5.54 1.57-5.54h1.78l-2.46 8.16Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NewMobile56 = (NewMobile56);
;// ./src/Picto/GeneratedPictoComponents/News104.tsx


var News104_excluded = ["className"];
function News104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function News104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? News104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : News104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function News104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, News104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", News104_objectSpread(News104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M84.69 82.05c.15 0 .27-.11.3-.26s-.04-.29-.17-.36c-3.81-1.66-6.58-3.83-6.58-11.34V49.26c.23-2.38-1.49-4.5-3.87-4.78h-1.22v27.87c0 5.24 4.18 9.52 9.42 9.65",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.16 72.36c0 2.57 1.02 5.03 2.83 6.84a9.672 9.672 0 0 0 6.84 2.83h.21c5.34 0 9.67-4.33 9.67-9.67V37.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.53 37.95v34.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.08 59.94h43.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.88 51.1h19.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.88 42.28h19.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.88 33.44h19.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.08 68.78h43.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.16 72.36V23.33c0-2.14-1.73-3.87-3.87-3.87H15.24c-2.14 0-3.87 1.73-3.87 3.87v49c0 5.34 4.33 9.67 9.67 9.67h61.54c-5.24-.14-9.41-4.42-9.42-9.65Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.68 38.37c-1.55-.71-3.14-1.18-4.41-1.18s-2.18.33-2.83 1.11c-.47.58-.71 1.31-.69 2.05 0 2.44 1.92 5.83 5.21 8.59 2.94 2.44 6.15 3.81 8.5 3.81 1.17 0 2.11-.36 2.73-1.07.49-.55.68-1.27.68-2.08 0-2.37-1.93-5.7-5.05-8.4",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.19 32.12c-.6 0-1.11.42-1.21 1.01l-.52 2.83h4.65l-2 11h3.69c.49 0 1.05-.23 1.21-1.07l1.69-9.93h3.35c.6 0 1.11-.42 1.21-1.01l.52-2.83h-12.6Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_News104 = (News104);
;// ./src/Picto/GeneratedPictoComponents/News56.tsx


var News56_excluded = ["className"];
function News56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function News56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? News56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : News56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function News56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, News56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", News56_objectSpread(News56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.6 44.18c.08 0 .15-.06.16-.14s-.02-.16-.09-.19c-2.05-.9-3.54-2.06-3.54-6.1V26.54c.12-1.28-.8-2.43-2.08-2.57h-.66v15.01c0 2.82 2.25 5.12 5.07 5.2",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.4 38.96c0 1.38.55 2.71 1.53 3.68a5.2 5.2 0 0 0 3.68 1.53h.11c2.88 0 5.21-2.33 5.21-5.21V20.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.98 20.43v18.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.81 32.28h23.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.17 27.52h10.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.17 22.77h10.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.17 18.01h10.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.81 37.04h23.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.4 38.96V12.57c0-1.15-.93-2.08-2.08-2.08H8.21c-1.15 0-2.08.93-2.08 2.08v26.39c0 2.88 2.33 5.21 5.21 5.21h33.14a5.202 5.202 0 0 1-5.07-5.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.63 20.44c-.84-.38-1.7-.63-2.38-.63s-1.18.18-1.53.6c-.25.31-.39.71-.37 1.11 0 1.32 1.04 3.15 2.81 4.64 1.58 1.32 3.32 2.06 4.59 2.06.63 0 1.14-.19 1.48-.58.26-.3.37-.69.37-1.13 0-1.28-1.04-3.08-2.73-4.53",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M13.29 17.06c-.32 0-.6.23-.65.55l-.28 1.53h2.51l-1.08 5.94h1.99c.27 0 .57-.12.65-.58l.91-5.36h1.81c.32 0 .6-.23.65-.54l.28-1.53h-6.8Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_News56 = (News56);
;// ./src/Picto/GeneratedPictoComponents/OneNumber104.tsx


var OneNumber104_excluded = ["className"];
function OneNumber104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function OneNumber104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? OneNumber104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : OneNumber104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function OneNumber104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OneNumber104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", OneNumber104_objectSpread(OneNumber104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 72.93V88c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v13.2M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.57 61.18 12.79 3.97c.39-.84-.11-1.78-1.56-2.79-2.07-1.56-7.79-7.07-8.49-14.13-.7-7.06.48-8.99-.76-9.81l-.22-.14c-.36-.22-.8-.26-1.2-.11-.4.15-.7.47-.83.88l-4.03 12.99c-.58 2.1.7 8.02 4.3 9.14Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.22 52.45c-2.8-5.97.28-12.53 1.75-15.1a.62.62 0 0 0-.64-.92l-2.67.41c-.23.03-.42.19-.49.41l-4.29 12.26c-.1.28.02.59.28.74l5.2 3.01c.54.31 1.13-.26.87-.82Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m61.03 41.34 4.58 9.09 5.68-2.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "51.5",
        y: "36.16",
        width: "28.03",
        height: "28.03",
        rx: "7.79",
        ry: "7.79",
        transform: "rotate(-73.45 65.51 50.178)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m55.33 37.05-7.5-.98a3.5 3.5 0 0 0-3.55 2.27l-3.11 9.44c-.43 1.51.21 3.13 1.56 3.94l7.26 4.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m75.46 63.54 7.67.79c1.55.08 2.96-.86 3.49-2.32l3.11-9.45c.42-1.51-.21-3.13-1.56-3.94l-7.26-4.19"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OneNumber104 = (OneNumber104);
;// ./src/Picto/GeneratedPictoComponents/OneNumber56.tsx


var OneNumber56_excluded = ["className"];
function OneNumber56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function OneNumber56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? OneNumber56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : OneNumber56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function OneNumber56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, OneNumber56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", OneNumber56_objectSpread(OneNumber56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.99 46.83c-1.56-1-3.48-1.08-5.11-1.97-6.95-3.64-8.44-12.01-9.5-19.08-.31-1.76-.38-2.9-2.43-3.07v23.25a3.96 3.96 0 0 0 3.95 3.96h14.86c.1-1.24-.72-2.42-1.78-3.09Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 38.47v8.32c0 1.73-1.4 3.14-3.14 3.14H16.08c-1.73 0-3.14-1.4-3.14-3.14V9.14c0-1.73 1.4-3.14 3.14-3.14h17.78C35.59 6 37 7.4 37 9.14v6.99M23.93 8.09h2.09M21.84 47.83h6.27"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.13 32.78 6.69 2.08c.2-.44-.06-.93-.81-1.46-1.08-.81-4.07-3.7-4.44-7.39-.37-3.69.25-4.7-.4-5.13l-.11-.07a.702.702 0 0 0-.63-.06c-.21.08-.37.25-.43.46L27.89 28c-.3 1.1.37 4.19 2.25 4.78Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.28 28.22c-1.47-3.13.15-6.56.92-7.9a.32.32 0 0 0-.33-.48l-1.4.21c-.12.02-.22.1-.26.21l-2.24 6.41c-.05.15 0 .31.14.39l2.73 1.58c.28.16.58-.14.45-.43Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.52",
        y: "19.7",
        width: "14.66",
        height: "14.66",
        rx: "4.07",
        ry: "4.07",
        transform: "rotate(-73.45 35.854 27.031)"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.61 20.07-4.01-.42c-.81-.06-1.57.42-1.86 1.19l-1.63 4.94c-.22.79.11 1.64.81 2.06l3.8 2.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.98 33.95 4.09.48c.81.04 1.55-.45 1.82-1.21l1.63-4.94c.22-.79-.11-1.63-.81-2.06l-3.8-2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.51 22.41 2.39 4.75 2.97-1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_OneNumber56 = (OneNumber56);
;// ./src/Picto/GeneratedPictoComponents/PeaceOfMind104.tsx


var PeaceOfMind104_excluded = ["className"];
function PeaceOfMind104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PeaceOfMind104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PeaceOfMind104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PeaceOfMind104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PeaceOfMind104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PeaceOfMind104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PeaceOfMind104_objectSpread(PeaceOfMind104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.83 91.97c-12.04-1.86-30.14-4.65-30.14-4.65l2.34-11.85s11.84.27 17.55 7.48c3.4 4.29 7 6.77 10.19 8.2.54.35.62.63.06.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.53 80.83s-8.32-7.28-4.16-14.56c2.3-4.02 5.84-6.11 8.54-7.17.44-.17.73.45.33.69-1.91 1.15-4.13 2.87-5.37 5.11-2.41 4.4-2.69 9.6 6.49 13.05.28.1.36.47.13.65-1.73 1.41-5.97 2.23-5.97 2.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m59.37 77.89 5.84-5.11c1.5-1.31 2.02-3.51 1.04-5.25 0-.01-.01-.02-.02-.04l-2.89-7.16c-.47-.91-.2-2.02.63-2.61.89-.63 2.12-.44 2.78.43l4.59 3.83c.71.59 1.24 1.36 1.54 2.23l3.48 8.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.06 81.56 71.07 77l10.04-5.53c.87-.48 1.64-1.14 2.25-1.93l5.63-7.3a2.05 2.05 0 0 1 2.59-.71c.98.47 1.41 1.64.97 2.63L88.67 73c-.34.79-.85 1.49-1.49 2.06-3.07 2.75-12.67 11.13-18.63 13.82-4.49 2.03-15.62 3.89-19.51 4.5-.9.14-1.81.14-2.71 0l-35.64-6.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.9 68.9 15.43 2.86c2.38.4 4.8-.45 6.41-2.24l9.38-10.46c1-1.11 2.27-1.93 3.7-2.38l7.38-2.32c1.44-.19 2.75.83 2.94 2.26.19 1.44-.83 2.75-2.27 2.94l-7.44 5.7-1 7.62 9.28 5.29"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.72 74.58s5.43-.23 4.93 6.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17.81 88.71c-2.12 3.43-4.26 5.24-5.77 4.72-2.51-.86-2.1-8.68.92-17.46 3.02-8.78 7.11-14.32 10.01-14.33 0 0 2.8 1.32.55 7.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.78 58.71 10.19 2.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.93 13.44c-21.57-9.25-44.62 4.38-36.98 17.12 8.22 13.69 51.35-6.16 45.53 19.51"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PeaceOfMind104 = (PeaceOfMind104);
;// ./src/Picto/GeneratedPictoComponents/PeaceOfMind56.tsx


var PeaceOfMind56_excluded = ["className"];
function PeaceOfMind56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PeaceOfMind56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PeaceOfMind56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PeaceOfMind56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PeaceOfMind56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PeaceOfMind56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PeaceOfMind56_objectSpread(PeaceOfMind56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.29 49.01 6.9 46.64l1.21-6.15s6.14.14 9.1 3.88c1.72 2.17 3.23 3.23 4.86 3.98.54.13.48.5.22.66Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.12 43.27s-4.31-3.77-2.16-7.55c1.28-2.24 3.3-3.32 4.73-3.83.35-.16.4-.05.26.24-1.06.59-2.45 1.56-3.18 2.88-1.28 2.33-1.4 5.09 3.66 6.87-.66.87-3.32 1.38-3.32 1.38"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.14 41.75 3.03-2.65c.78-.68 1.05-1.82.54-2.72 0 0 0-.01-.01-.02l-1.5-3.71c-.24-.47-.1-1.05.33-1.35.46-.33 1.1-.23 1.44.23l2.38 1.99c.37.31.64.71.8 1.16l1.8 4.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.83 43.65 10.37-2.37 5.21-2.87c.45-.25.85-.59 1.17-1l2.92-3.79c.3-.44.87-.6 1.34-.37.51.25.73.85.5 1.36l-2.01 4.58c-.18.41-.44.77-.77 1.07-1.59 1.43-6.57 5.77-9.66 7.17-2.33 1.05-8.1 2.02-10.12 2.33-.47.07-.94.07-1.4 0L6.9 46.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.12 37.09 8 1.48c1.23.21 2.49-.23 3.32-1.16l4.86-5.42c.52-.58 1.18-1 1.92-1.24l3.83-1.2c.74-.1 1.43.43 1.52 1.17.1.75-.43 1.43-1.17 1.52l-3.86 2.95-.52 3.95 4.81 2.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.62 40.03s2.81-.12 2.56 3.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.59 47.36c-1.1 1.78-2.21 2.72-2.99 2.45-1.3-.45-1.09-4.5.48-9.05 1.56-4.55 3.68-7.43 5.19-7.43 0 0 1.45.68.29 4.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m7.98 31.8 5.29 1.52"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.36 8.33C19.17 3.54 7.22 10.6 11.19 17.21c4.26 7.1 26.63-3.2 23.61 10.12",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PeaceOfMind56 = (PeaceOfMind56);
;// ./src/Picto/GeneratedPictoComponents/Perfect104.tsx


var Perfect104_excluded = ["className"];
function Perfect104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Perfect104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Perfect104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Perfect104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Perfect104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Perfect104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Perfect104_objectSpread(Perfect104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.13 29.3c3.45 2.67 5.67 2.29 5.67 2.29l.54 3.53-7.66-2.63-.22-1.86c-.11-.92.93-1.9 1.67-1.33Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M54.98 30.77c1.43 3.76 3.79 4.06 3.79 4.06l.42 3.2-5.95-2.39.04-4.49c0-.94 1.36-1.26 1.7-.38Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M60.86 31.6c.33 5.53 1.44 5.61 1.44 5.61l-.61 4.29-2.12-3.22c-.13-.16-.02-5.27.63-6.84.14-.34.64-.21.66.16Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.2 87.88-3.83-17.06s1.17.2 2.85-.91c.97-.64 2.28-.13 2.46 1.02 1.55 10.08 6.47 14.79 6.47 14.79l-7.95 2.16Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M49.91 54.15s-2 2.42-5.18 4.67c-1.3.92-7.55 1.19-10.76-.65-3.18-1.82-7.29-10.04-7.29-10.04s2.2 3.17 6.63 6.68c2.75 2.18 7.62 3.81 10.78 1.02 1.05-.93 1.51-2.71 2.04-4.75.38-1.45 2.39-1.52 2.89-.11.57 1.62.89 3.18.89 3.18"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M75.25 73.71c-.59-1.86-2.12-2.32-6.86-1.89M49.69 77.38c-5.9 2.97-10.43 6.57-9.73 8.82"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M52.24 86.14s-1.29-8.39-3.67-15.41c0-.01-.02-.02-.03-.02-3.59.51-14.95-5.31-14.95-5.32-1.71-1.25-5.07-5.35-5.71-6.66l-3.31-6.78c-.38-1.36.45-2.76 1.86-3.15s2.86.41 3.24 1.76v.01l4.78 4.54a6.44 6.44 0 0 0 4.56 1.78l2.83-.04c1.39-.02 2.65-.84 3.23-2.1l1.67-3.61c.74-1.59.46-3.46-.71-4.77l-3.45-3.85c-1.51-1.26-4.2-.41-5.8.77-.01 0-.02.02-.03.03l-6.76 3.79c-.85.58-1.99.47-2.69-.24-.75-.77-.72-1.97.06-2.74l3.21-4.95c.49-.76 1.19-1.38 2.02-1.8 0 0 5.85-3.75 8.01-4.54 2.63-.96 17.79 4.85 18.8 6.38 2.71 4.08 5.92 19.97 6.29 21.69 2.06 9.57 5.23 19.5 5.23 19.5"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.95 33.62-1.11-9.53-.44-2.15-2.9-9.71a2.752 2.752 0 0 1 5.21-1.76l3.97 10.54.87 3.33 1.81 11.83"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m53.36 36.17.06-8.76-.21-4.53-.8-7.94c-.11-1.05.33-2.14 1.23-2.68 1.75-1.05 3.83.04 4.1 1.9l1.23 8.42c.13 1.82.27 3.64.4 5.46l.02 11.2"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.37 31.87c.36-1.97.73-3.93 1.09-5.9l.6-5.18a2.16 2.16 0 0 1 2.24-1.91c1.24.05 2.13 1.22 2.05 2.46l-.41 6.47-.75 5.2-2.63 11.47"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M47.37 87.88s-1.73-.02-.13 1.49 15.61.66 20.79-1.49 6.81.58 8.29 2.52c0 0 1.66 1.97 2.9.92s-4.01-13.95-4.01-13.95-4.01 2.77-5.11 3.78-7.81 3.34-7.81 3.34l-7.74 2.07-6.23 1.3h-.95Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m80.99 94.33-5.71-20.52"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.48 97.88-3.5-11.58"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.98 86.3c1 2.83 9.71 2.32 19.46-1.13 9.75-3.45 16.84-8.54 15.84-11.36"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Perfect104 = (Perfect104);
;// ./src/Picto/GeneratedPictoComponents/Perfect56.tsx


var Perfect56_excluded = ["className"];
function Perfect56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Perfect56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Perfect56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Perfect56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Perfect56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Perfect56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Perfect56_objectSpread(Perfect56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.34 15.93c1.8 1.4 2.97 1.2 2.97 1.2l.28 1.85-4.01-1.38-.11-.97c-.06-.48.49-.99.87-.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.45 16.7c.75 1.97 1.99 2.13 1.99 2.13l.22 1.68-3.12-1.25.02-2.35c0-.49.71-.66.89-.2Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.53 17.13c.17 2.9.75 2.94.75 2.94l-.32 2.25-1.11-1.69c-.07-.09 0-2.76.33-3.58.07-.18.33-.11.34.08Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27 46.6-2-8.93s.61.11 1.49-.48c.51-.34 1.2-.07 1.29.53.81 5.28 3.39 7.74 3.39 7.74l-4.16 1.13Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M25.33 27.27s-.58 2.94-2.25 4.11c-.68.48-3.95.62-5.64-.34-1.67-.95-3.82-5.26-3.82-5.26s1.15 1.66 3.47 3.5c1.44 1.14 3.99 1.99 5.64.54.55-.49.79-1.42 1.07-2.49.2-.76 1.25-.8 1.52-.06"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.88 38.83c-.31-1-1.77-1.15-4.3-.91M25.68 41.04c-3.16 1.61-5.07 3.35-4.7 4.57"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M26.98 45.93s-.68-4.44-1.95-8.16c0 0 0-.01-.02-.01-1.9.27-7.92-2.81-7.92-2.82-.9-.66-2.68-2.83-3.02-3.53l-1.76-3.59c-.2-.72.24-1.46.99-1.67s1.51.22 1.72.93l2.53 2.4c.65.62 1.52.96 2.41.94l1.5-.02c.74-.01 1.4-.44 1.71-1.11l.88-1.91c.39-.84.24-1.83-.38-2.52l-1.83-2.04c-.8-.67-2.23-.22-3.07.41 0 0-.01 0-.02.01l-3.58 2.01c-.45.3-1.06.25-1.42-.13-.4-.41-.38-1.05.03-1.45l1.7-2.62c.26-.4.63-.73 1.07-.95 0 0 3.1-1.98 4.24-2.4 1.39-.51 9.42 2.57 9.96 3.38 1.44 2.16 3.14 10.58 3.33 11.49 1.09 5.07 2.6 9.77 2.6 9.77"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m23.65 18.11-.59-5.05-.23-1.14-1.54-5.14a1.458 1.458 0 0 1 2.76-.93l2.1 5.58.46 1.76.96 6.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.58 19.46.03-4.64-.11-2.4-.42-4.21c-.06-.56.17-1.13.65-1.42.93-.56 2.03.02 2.17 1.01l.65 4.46.21 2.89v5.93"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M30.76 17.19c.19-1.04.39-2.08.58-3.12l.32-2.74c.07-.59.58-1.04 1.19-1.01.66.03 1.13.65 1.09 1.3l-.22 3.42-.4 2.76-1.39 6.07"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M24.23 46.3s-.97-.01-.07.84 8.81.37 11.73-.84 3.84.33 4.68 1.42c0 0 .94 1.11 1.64.52s-2.27-7.87-2.27-7.87-2.26 1.56-2.88 2.14-4.41 1.89-4.41 1.89l-4.37 1.17-3.52.73h-.54Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.99 50-3.07-11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.88 51.91 21 45.7"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21 45.7c.54 1.52 5.21 1.25 10.43-.6 5.23-1.85 9.03-4.58 8.49-6.09"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Perfect56 = (Perfect56);
;// ./src/Picto/GeneratedPictoComponents/PoleInspection104.tsx


var PoleInspection104_excluded = ["className"];
function PoleInspection104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PoleInspection104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PoleInspection104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PoleInspection104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PoleInspection104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PoleInspection104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PoleInspection104_objectSpread(PoleInspection104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M68.25 60.77s5.26 4.27 6.11 9.8c.71 4.63 9.06 8.17 9.06 8.17l-3.04 1.65-17-12.69 4.86-6.93Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.38 67.7 14.46 11.31c1.67 1.43 3.82 1.68 4.86.54.61-.67 1.29-1.48 1.93-2.4.63-.92 1.16-1.85 1.57-2.68.7-1.4-.17-3.51-1.96-4.76l-15.1-10.63"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.62 86.15.13 7.16s-3.25 2.81-6.11 0c0 0-.48-.99 1.09-1.78s3.34-2.08 3.54-3.24c0 0 1.39-13.57-2.55-14.23s-1.2-1.81-1.2-1.81l5.23-.25-.13 14.15ZM52.89 22.47l-3.04-.32c-1.37 0-1.37 1.84-.41 2.98.06.07.09.14.14.19.55.58 1.63 1.06 2.82 2.17.24.22.41.52.49.83.29 1.09.92 3.69.56 4.66-.47 1.25 1.53 0 1.53 0l-.12-9.57c-.03-.98-1-.95-1.98-.95ZM48.73 16l5.92-.25.13-3.28-1.13-1.73h-3.66l-1.26 1.03V16z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "50.75",
        cy: "52.74",
        r: "15.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.03 37.31c8.53 6.25 10.38 18.24 4.13 26.77-6.25 8.53-18.24 10.38-26.77 4.13-8.53-6.25-10.38-18.24-4.13-26.77 6.25-8.53 18.24-10.38 26.77-4.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "33.42",
        y: "16.43",
        width: "37.8",
        height: "5.4",
        rx: "2.28",
        ry: "2.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.24 16.26v-3.73c0-1.4-1.13-2.53-2.53-2.53h-2.13c-1.4 0-2.53 1.13-2.53 2.53v3.73M55.24 21.83v11.78M48.04 22.26V33M35.69 21.83S28.69 35 10 34.3M71.22 17.96s5.97 7.3 22.78 6.19M55.24 71.91v22.04M48.04 71.72V94"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "35.55",
        y: "12.47",
        width: "3.44",
        height: "2.98",
        rx: ".86",
        ry: ".86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "66",
        y: "12.47",
        width: "3.44",
        height: "2.98",
        rx: ".64",
        ry: ".64"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PoleInspection104 = (PoleInspection104);
;// ./src/Picto/GeneratedPictoComponents/PoleInspection56.tsx


var PoleInspection56_excluded = ["className"];
function PoleInspection56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PoleInspection56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PoleInspection56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PoleInspection56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PoleInspection56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PoleInspection56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PoleInspection56_objectSpread(PoleInspection56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.94 32.06s2.6 2.11 3.02 4.85c.35 2.29 4.48 4.04 4.48 4.04l-1.5.82-8.41-6.27 2.41-3.43Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.5 35.81 6.88 5.39c.79.68 1.82.8 2.31.26.29-.32.62-.71.92-1.14.3-.44.55-.88.75-1.28.33-.66-.08-1.67-.93-2.27l-7.19-5.06"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.53 46.25.07 3.96s-1.79 1.55-3.38 0c0 0-.27-.55.6-.99s1.85-1.15 1.95-1.79c0 0 .77-7.5-1.41-7.87s-.67-1-.67-1l2.89-.14-.07 7.82ZM28.51 12.5l-1.68-.17c-.76 0-.76 1.02-.22 1.65.03.04.05.08.08.11.3.32.9.59 1.56 1.2.13.12.23.29.27.46.16.6.51 2.04.31 2.58-.26.69.85 0 .85 0l-.07-5.29c-.02-.54-.55-.53-1.09-.53ZM26.22 9.25l3.27-.13.07-1.82-.62-.95h-2.03l-.69.56v2.34z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "27.5",
        cy: "28.39",
        r: "7.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.41 20.31c4.47 3.27 5.44 9.55 2.16 14.02-3.27 4.47-9.55 5.44-14.02 2.16-4.47-3.27-5.44-9.55-2.16-14.02 3.27-4.47 9.55-5.44 14.02-2.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "18.43",
        y: "9.37",
        width: "19.8",
        height: "2.83",
        rx: "1.41",
        ry: "1.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.86 9.28V7.32c0-.73-.59-1.33-1.33-1.33h-1.12c-.73 0-1.33.59-1.33 1.33v1.96M29.86 12.2v6.17M26.09 12.42v5.63M19.62 12.2s-3.67 6.9-13.46 6.53M37.83 9.81s3.52 4.19 12.33 3.61M29.86 38.43v11.54M26.09 38.33V50"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "19.62",
        y: "7",
        width: "2.04",
        height: "1.87",
        rx: ".51",
        ry: ".51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "34.83",
        y: "7",
        width: "2.16",
        height: "1.87",
        rx: ".34",
        ry: ".34"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PoleInspection56 = (PoleInspection56);
;// ./src/Picto/GeneratedPictoComponents/PortMobile104.tsx


var PortMobile104_excluded = ["className"];
function PortMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortMobile104_objectSpread(PortMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M83.7 35.89s.3 2.11-1.19 2.66-2.92-5.15-8.62-6.58c-5.7-1.43-9.98 0-12.83 2.85s-5.31 2.08-5.31 2.08l1.74-4.68 3.3-2.93 4.77-2.57h5.68l5.04 1.19 4.03 2.76 3.39 5.22",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.27 49.65c2.53 5.53 8.11 9.38 14.59 9.38 8.85 0 16.03-7.18 16.03-16.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.39 36.23c-2.55-5.47-8.1-9.26-14.54-9.26-8.85 0-16.03 7.18-16.03 16.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.3 46.7 4.59-4.59 4.59 4.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m58.41 39.82-4.58 4.58-4.59-4.58"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56 87.82c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69.86 65.34v22.87c0 3.16-2.56 5.72-5.72 5.72H29.83c-3.16 0-5.72-2.56-5.72-5.72V15.79c0-3.16 2.56-5.72 5.72-5.72h34.31c3.16 0 5.72 2.56 5.72 5.72v5.72M45.08 13.88h3.81M41.27 90.12H52.7"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortMobile104 = (PortMobile104);
;// ./src/Picto/GeneratedPictoComponents/PortMobile56.tsx


var PortMobile56_excluded = ["className"];
function PortMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortMobile56_objectSpread(PortMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.09 19.74s.11 1.04-.63 1.33-1.35-2.5-4.15-3.1-4.93.17-6.39 1.62-2.66 1.12-2.66 1.12l.94-2.34 1.68-1.5 2.4-1.35 2.81-.1 2.47.5 1.94 1.29 1.59 2.52",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.02 26.94c1.26 2.75 4.04 4.67 7.26 4.67 4.41 0 7.98-3.57 7.98-7.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.52 20.26a7.984 7.984 0 0 0-7.24-4.61c-4.41 0-7.98 3.57-7.98 7.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.98 25.47 2.28-2.28 2.29 2.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.59 22.04-2.29 2.29-2.28-2.29"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortMobile56 = (PortMobile56);
;// ./src/Picto/GeneratedPictoComponents/PortPhone104.tsx


var PortPhone104_excluded = ["className"];
function PortPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortPhone104_objectSpread(PortPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M83.53 30.78s.3 2.11-1.19 2.66-2.92-5.15-8.62-6.58c-5.7-1.43-9.98 0-12.83 2.85s-5.31 2.08-5.31 2.08l1.74-4.68 3.3-2.93 4.77-2.57h5.68l5.04 1.19 4.03 2.76 3.39 5.22",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.88 44.65c2.53 5.53 8.11 9.38 14.59 9.38 8.85 0 16.03-7.18 16.03-16.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.01 31.23c-2.55-5.47-8.1-9.26-14.54-9.26-8.85 0-16.03 7.18-16.03 16.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m80.92 41.7 4.58-4.59 4.59 4.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m58.03 34.82-4.59 4.58-4.59-4.58"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M16.39 40.45c6.52 2.25 18.92 34.3 33.57 41.2 11.84 5.58 22.75-3.03 27.11 0 4.36 3.03-11.02 10.15-15 9.81-3.98-.33-23.52-2.23-38.88-24.05-15.37-21.82-11.98-29.02-6.8-26.97"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.48 91.34c-7.13 0-18.5-3.06-32.92-17.48-26.99-26.99-14.94-43.62-14.43-44.3.3-.32 4.07-4.07 4.07-4.07 2.72-2.72 7.64-2.72 10.35 0l8.32 8.32a7.27 7.27 0 0 1 .06 10.29l-.06.06-3.73 3.9c2.38 3.9 5.43 7.64 8.83 11.2l1.19 1.19c3.39 3.39 7.13 6.28 11.2 8.83l3.73-3.73c2.72-2.71 7.64-2.71 10.35 0l8.32 8.32c1.36 1.36 2.21 3.22 2.21 5.26s-.85 3.73-2.21 5.26c0 0-8.32 6.96-15.27 6.96Z"
        })
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortPhone104 = (PortPhone104);
;// ./src/Picto/GeneratedPictoComponents/PortPhone56.tsx


var PortPhone56_excluded = ["className"];
function PortPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortPhone56_objectSpread(PortPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.98 20.06c3.57 1.23 10.35 18.76 18.35 22.53 6.48 3.05 12.44-1.66 14.82 0 2.39 1.66-6.03 5.55-8.2 5.37-2.17-.18-12.86-1.22-21.26-13.15-8.4-11.93-6.55-15.87-3.72-14.75"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M36.29 48.12c-4.02 0-10.42-1.72-18.55-9.85-15.2-15.2-8.41-24.57-8.12-24.95.17-.18 2.3-2.29 2.3-2.29 1.53-1.53 4.3-1.53 5.83 0l4.68 4.68a4.104 4.104 0 0 1 .04 5.8l-.04.04-2.1 2.2c1.34 2.2 3.06 4.3 4.97 6.31l.67.67c1.91 1.91 4.02 3.54 6.31 4.97l2.1-2.1c1.53-1.53 4.3-1.53 5.83 0l4.68 4.69c.77.76 1.24 1.82 1.24 2.96s-.48 2.1-1.24 2.96c0 0-4.68 3.92-8.6 3.92Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.57 15.07s.11 1.04-.63 1.33-1.35-2.5-4.15-3.1-4.93.17-6.39 1.62c-1.46 1.46-2.66 1.12-2.66 1.12l.94-2.34 1.68-1.5 2.4-1.35 2.81-.1 2.47.5 1.94 1.29 1.59 2.52",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.76 22.31c1.26 2.75 4.04 4.67 7.26 4.67 4.41 0 7.98-3.57 7.98-7.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.26 15.63a7.984 7.984 0 0 0-7.24-4.61c-4.41 0-7.98 3.57-7.98 7.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.72 20.84 2.29-2.28 2.28 2.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.33 17.42-2.28 2.28-2.29-2.28"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortPhone56 = (PortPhone56);
;// ./src/Picto/GeneratedPictoComponents/PortSIM104.tsx


var PortSIM104_excluded = ["className"];
function PortSIM104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortSIM104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortSIM104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortSIM104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortSIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortSIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortSIM104_objectSpread(PortSIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.2 49.04c-3.97-11.58-2.49-15.26-5.63-16.21-2.53-.77-2.9.94-2.9 2.45l.09 52.56c-.65 5.7 2.54 5.79 5.66 5.79l45.32.03c1.67 0 2.61-2.07 1.44-3.3-.99-1.04-2.59-1.96-4.8-2.74-1.76-.63-3.72-2.13-7.11-3.89h-.92l-25.22-.1c-3.31-.01-5.98-2.65-5.98-5.89l.05-28.7",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m35.79 72.99-.01 10.95M47.69 73.04l-.02 10.95M47.72 57.26l.02-10.76M35.82 57.21l.02-10.76M59.89 52.34l-.05 25.92c0 3.38-2.8 6.1-6.25 6.08l-23.8-.1c-3.44-.01-6.23-2.76-6.22-6.14l.05-25.92c0-3.38 2.8-6.1 6.25-6.08l23.8.1c3.44.01 6.23 2.76 6.22 6.14Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m52.4 72.91-21.38-.09c-3.91-.02-7.1-3.07-7.09-6.78v-1.78c0-3.72 3.21-6.74 7.12-6.73l21.38.09c3.91.02 7.1 3.07 7.09 6.78v1.78c0 3.72-3.21 6.74-7.12 6.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m74.94 64.87-.15 25.14c-.01 2.2-2.06 3.99-4.58 3.99l-51.63-.06c-2.52 0-4.55-1.79-4.54-4l.39-75.29c.01-2.57 2.4-4.65 5.34-4.65l37.77.05c2.78 0 4.52.71 5.94 1.96l9.35 9.45c1.74 1.8 2.3 3.59 2.3 7.19"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M87.78 39.76s.21 1.48-.83 1.86-2.04-3.6-6.03-4.6-6.98 0-8.98 1.99-3.72 1.45-3.72 1.45l1.22-3.27 2.31-2.05 3.33-1.8h3.97l3.53.83 2.82 1.93 2.37 3.65",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.24 50.61c1.9 4.17 6.11 7.06 10.99 7.06 6.67 0 12.07-5.4 12.07-12.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.17 40.51c-1.92-4.12-6.1-6.97-10.95-6.97-6.67 0-12.07 5.4-12.07 12.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m86.84 48.39 3.45-3.45 3.46 3.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m69.61 43.21-3.46 3.45-3.45-3.45"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortSIM104 = (PortSIM104);
;// ./src/Picto/GeneratedPictoComponents/PortSIM56.tsx


var PortSIM56_excluded = ["className"];
function PortSIM56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PortSIM56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PortSIM56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PortSIM56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PortSIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PortSIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PortSIM56_objectSpread(PortSIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.7 26.28c-2.11-6.17-1.32-8.13-3-8.63-1.35-.41-1.54.5-1.54 1.31l.05 27.99c-.34 3.04 1.35 3.08 3.02 3.08l24.13.02c.89 0 1.39-1.1.77-1.76-.53-.56-1.38-1.04-2.56-1.46-.94-.33-1.98-1.13-3.79-2.07h-.49l-13.43-.05c-1.76 0-3.19-1.41-3.18-3.14l.02-15.28",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.4 39.46-.01 5.58M25.63 39.48l-.01 5.59M25.65 31.11l.01-5.62M19.42 31.08l.01-5.62M32.02 28.51 32 42.09c0 1.77-1.47 3.19-3.27 3.19l-12.47-.05c-1.8 0-3.26-1.45-3.26-3.21l.02-13.58c0-1.77 1.47-3.19 3.27-3.19l12.47.05c1.8 0 3.26 1.45 3.26 3.21Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m28.1 39.28-11.2-.05c-2.05 0-3.72-1.61-3.71-3.55v-.93c0-1.95 1.68-3.53 3.73-3.52l11.2.05c2.05 0 3.72 1.61 3.71 3.55v.93c0 1.95-1.68 3.53-3.73 3.52Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m39.91 35.07-.08 13.17c0 1.15-1.08 2.09-2.4 2.09l-27.04-.03c-1.32 0-2.38-.94-2.38-2.09l.21-39.44c0-1.35 1.26-2.44 2.8-2.44l19.79.03c1.46 0 2.37.37 3.11 1.03l4.9 4.95c.91.94 1.21 1.88 1.2 3.77"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M47.12 22.72s.11.81-.46 1.02-1.12-1.98-3.31-2.53-3.83 0-4.93 1.09-2.04.8-2.04.8l.67-1.79 1.27-1.13 1.83-.99h2.18l1.94.46 1.55 1.06 1.3 2",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.91 28.53a6.503 6.503 0 0 0 5.92 3.8 6.5 6.5 0 0 0 6.5-6.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.72 23.08a6.49 6.49 0 0 0-5.89-3.76 6.5 6.5 0 0 0-6.5 6.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.47 27.33 1.86-1.86 1.86 1.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.19 24.54-1.86 1.86-1.86-1.86"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PortSIM56 = (PortSIM56);
;// ./src/Picto/GeneratedPictoComponents/PostPaid104.tsx


var PostPaid104_excluded = ["className"];
function PostPaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PostPaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PostPaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PostPaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PostPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PostPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PostPaid104_objectSpread(PostPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M71.29 56.48c-1.44-1.04-3.25-1.2-4.76-2.14-6.44-3.85-7.54-12.19-8.29-19.22-.23-1.76-.26-2.89-2.18-3.12v.15l-.88 23.86c-.08 2.16.6 2.94 2.66 3.02l15.02.57c.14-1.23-.6-2.42-1.57-3.12Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.22 30h22.56c1.78 0 3.22 1.44 3.22 3.22v22.56c0 1.78-1.44 3.22-3.22 3.22H58.22C56.44 59 55 57.56 55 55.78V33.22c0-1.78 1.44-3.22 3.22-3.22ZM75.9 28v4M63.01 28v4M55 36.96h29M75.98 42.21h4.52M67.86 42.21h4.52M59.5 48.21h4.52M67.86 48.21h4.52M75.98 48.21h4.52M67.86 54.21h4.52M59.5 54.21h4.52"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PostPaid104 = (PostPaid104);
;// ./src/Picto/GeneratedPictoComponents/PostPaid56.tsx


var PostPaid56_excluded = ["className"];
function PostPaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PostPaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PostPaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PostPaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PostPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PostPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PostPaid56_objectSpread(PostPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 34v13c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 34v13c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M39.05 28.87c-.72-.52-1.64-.6-2.4-1.08-3.24-1.94-3.8-6.14-4.17-9.68-.11-.88-.13-1.45-1.1-1.57v.08l-.45 12.01c-.04 1.09.3 1.48 1.34 1.52l7.56.29c.07-.62-.3-1.22-.79-1.57Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.67 16.49h11.67c.92 0 1.67.7 1.67 1.56v10.9c0 .86-.75 1.56-1.67 1.56H32.67c-.92 0-1.67-.7-1.67-1.56v-10.9c0-.86.75-1.56 1.67-1.56ZM42.25 15.5v2M34.75 15.5v2M31 20.18h15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.67 16.49h11.67c.92 0 1.67.7 1.67 1.56v10.9c0 .86-.75 1.56-1.67 1.56H32.67c-.92 0-1.67-.7-1.67-1.56v-10.9c0-.86.75-1.56 1.67-1.56ZM42.25 15.5v2M34.75 15.5v2M31 20.18h15M41.9 22.66h2.15M32.99 25.51h2.15M37.42 25.51h2.16M37.42 22.66h2.16M41.9 25.51h2.15M37.42 28.36h2.16M32.99 28.36h2.15"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PostPaid56 = (PostPaid56);
;// ./src/Picto/GeneratedPictoComponents/PrePaid104.tsx


var PrePaid104_excluded = ["className"];
function PrePaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PrePaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PrePaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PrePaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PrePaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PrePaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PrePaid104_objectSpread(PrePaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M65.13 32.48c.82-.8-.16-2.1-1.16-1.54-4.67 2.62-7.82 7.56-7.82 13.23 0 3.11.95 6 2.57 8.41.06.09.13.17.22.23l2.73 2.39c.88.31.95-.13.67-.64-1.68-2.76-2.48-5.56-2.48-9.14 0-5.16 2.04-9.79 5.27-12.95Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "71.67",
      cy: "44",
      r: "15.95",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M70.9 49.64v-4.97l-.71-.16c-2.62-.6-3.91-1.98-3.91-4.09 0-2.71 2-4.46 4.67-4.71V33.8h1.75v1.93c2.32.32 4.28 1.82 4.51 4.51h-2.53c-.12-1.15-.74-2.07-1.98-2.37v4.71l1.04.23c2.35.55 3.77 1.95 3.77 4.25 0 2.83-1.91 4.51-4.85 4.76v2.28h-1.75v-2.3c-2.95-.32-4.9-2.14-4.97-5.04h2.62c.07 1.45.83 2.55 2.35 2.87Zm.05-7.45v-4.37c-1.43.23-2.21 1.15-2.21 2.35 0 .97.58 1.61 2.21 2.02Zm1.7 2.85v4.65c1.45-.23 2.37-1.1 2.37-2.41 0-1.08-.62-1.84-2.3-2.21l-.07-.02Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PrePaid104 = (PrePaid104);
;// ./src/Picto/GeneratedPictoComponents/PrePaid56.tsx


var PrePaid56_excluded = ["className"];
function PrePaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PrePaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PrePaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PrePaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PrePaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PrePaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PrePaid56_objectSpread(PrePaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.42 17.38c.44-.45-.08-1.18-.62-.86-2.5 1.47-4.19 4.24-4.19 7.43 0 1.74.51 3.37 1.38 4.72.03.05.07.09.12.13l1.46 1.34c.47.17.51-.07.36-.36-.9-1.55-1.33-3.12-1.33-5.13 0-2.9 1.09-5.5 2.82-7.27Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "38.63",
      cy: "23.87",
      r: "8.37",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.26 27.23v-2.59l-.37-.08c-1.37-.31-2.04-1.03-2.04-2.13 0-1.42 1.04-2.33 2.44-2.46v-1h.91v1.01c1.21.17 2.23.95 2.35 2.35h-1.32c-.06-.6-.38-1.08-1.03-1.24v2.46l.54.12c1.22.29 1.97 1.02 1.97 2.22 0 1.47-1 2.35-2.53 2.48v1.19h-.91v-1.2c-1.54-.17-2.56-1.12-2.59-2.63h1.37c.04.76.43 1.33 1.23 1.5Zm.02-3.89v-2.28c-.74.12-1.15.6-1.15 1.22 0 .5.3.84 1.15 1.06Zm.89 1.49v2.42c.76-.12 1.24-.58 1.24-1.26 0-.56-.32-.96-1.2-1.15h-.04Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PrePaid56 = (PrePaid56);
;// ./src/Picto/GeneratedPictoComponents/PriorityAssistance104.tsx


var PriorityAssistance104_excluded = ["className"];
function PriorityAssistance104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PriorityAssistance104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PriorityAssistance104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PriorityAssistance104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PriorityAssistance104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PriorityAssistance104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PriorityAssistance104_objectSpread(PriorityAssistance104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.68 23.96h2.79v64.95h-2.79zM30.76 89.97C19.31 86.64 19.83 77.2 19.83 77.2s-.9-42.2-.9-47-2.89-10.73-2.89-10.73v4.88c-.33-.24-.74-.38-1.18-.38h-1.87c-1.11 0-2.01.9-2.01 2.01v60.94c0 1.11.9 2.01 2.01 2.01h1.87c.51 0 .98-.2 1.33-.52.27 5.09 3.74 4.31 3.74 4.31h12.69c-.16-1.84-1.9-2.74-1.9-2.74h.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.4 43.68c-3.01-.58-5.73-2.99-6.87-5.84l-1.04-3.63c-.2-.69-1.22-.55-1.22.17v9.98c0 1.13.91 2.05 2.05 2.05h11.27c.91 0 1.09-1.31.21-1.54l-4.38-1.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.04 89.49h-.78c-2.36 0-4.27-1.91-4.27-4.27V27.6c0-2.36 1.91-4.27 4.27-4.27h.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.04",
        y: "18.11",
        width: "22.64",
        height: "74.87",
        rx: "3.52",
        ry: "3.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "45.83",
        y: "52.93",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "57.95",
        y: "52.93",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "70.07",
        y: "52.93",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "45.98",
        y: "65.12",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "58.1",
        y: "65.12",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "70.22",
        y: "65.12",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "45.98",
        y: "77.31",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "58.1",
        y: "77.31",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "70.22",
        y: "77.31",
        width: "8.85",
        height: "6.97",
        rx: "1.32",
        ry: "1.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.8 46.76H47.88c-1.13 0-2.05-.92-2.05-2.05V32.33c0-1.13.92-2.05 2.05-2.05h2.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.26 23.33H38.68v66.16h42.94c2.36 0 4.27-1.91 4.27-4.27v-46.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M69.96 12.6s-.5 2.05-1.97 2.15c-2.18.14-4.21 4-4.24 6.21-.13 10.1 9.02 15.12 11.35 17.28 2.33 2.15.28 5.15.28 5.15l-1.5.62L56.5 27.2l-1.6-4.69.88-4.89 2.15-3.39 1.96-1.79 4.12-1.08 3.49-.03 1.37.55 1.09.72Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.88 20.54v12.81M67.48 26.34h12.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.89 44c.56 0 1.1-.22 1.5-.62l14.55-14.55a10.49 10.49 0 0 0 3.06-7.6c-.06-2.85-1.26-5.55-3.34-7.49-4.23-3.82-10.72-3.62-14.72.44l-1.06 1.06-1.06-1.06c-4-4.07-10.49-4.26-14.72-.44a10.495 10.495 0 0 0-.28 15.09l14.55 14.55c.4.4.94.62 1.5.62"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PriorityAssistance104 = (PriorityAssistance104);
;// ./src/Picto/GeneratedPictoComponents/PriorityAssistance56.tsx


var PriorityAssistance56_excluded = ["className"];
function PriorityAssistance56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function PriorityAssistance56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? PriorityAssistance56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : PriorityAssistance56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function PriorityAssistance56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, PriorityAssistance56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", PriorityAssistance56_objectSpread(PriorityAssistance56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.89 12.93h1.5v34.89h-1.5zM16.64 48.38c-6.15-1.79-5.87-6.86-5.87-6.86s-.49-22.67-.49-25.24-1.55-5.76-1.55-5.76v2.62c-.18-.13-.4-.21-.63-.21H7.09c-.59 0-1.08.48-1.08 1.08v32.73c0 .59.48 1.08 1.08 1.08H8.1c.27 0 .52-.11.72-.28.15 2.73 2.01 2.32 2.01 2.32h6.82c-.08-.99-1.02-1.47-1.02-1.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.88 23.52c-1.62-.31-3.08-1.6-3.69-3.13l-.56-1.95c-.11-.37-.66-.29-.66.09v5.36c0 .61.49 1.1 1.1 1.1h6.05c.49 0 .58-.7.11-.83l-2.35-.64Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.73 48.13h-.42a2.29 2.29 0 0 1-2.29-2.29V14.88a2.29 2.29 0 0 1 2.29-2.29h.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "8.73",
        y: "9.79",
        width: "12.16",
        height: "40.21",
        rx: "1.89",
        ry: "1.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.74",
        y: "28.49",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.24",
        y: "28.49",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.75",
        y: "28.49",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.81",
        y: "35.03",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.32",
        y: "35.03",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.83",
        y: "35.03",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "24.81",
        y: "41.58",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "31.32",
        y: "41.58",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.83",
        y: "41.58",
        width: "4.75",
        height: "3.74",
        rx: ".71",
        ry: ".71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36 25.17H25.84c-.61 0-1.1-.49-1.1-1.1v-6.65c0-.61.49-1.1 1.1-1.1h1.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.11 12.59h-6.22v35.53h23.06a2.29 2.29 0 0 0 2.29-2.29V20.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M37.63 6.86s-.27 1.1-1.06 1.15c-1.17.07-2.26 2.14-2.27 3.33-.07 5.41 4.84 8.1 6.09 9.26 1.25 1.15.15 2.76.15 2.76l-.8.33-9.32-9.01-.86-2.51.47-2.62 1.15-1.82 1.05-.96 2.21-.58 1.87-.02.73.3.58.39Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.73 11.12v6.86M36.3 14.55h6.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.73 23.69c.3 0 .59-.12.8-.33l7.8-7.8a5.6 5.6 0 0 0 1.64-4.07 5.643 5.643 0 0 0-1.79-4.01 5.701 5.701 0 0 0-7.89.24l-.57.57-.57-.57a5.711 5.711 0 0 0-7.89-.24 5.603 5.603 0 0 0-1.79 4.01c-.03 1.52.57 3 1.64 4.07l7.8 7.8c.22.22.5.33.8.33"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_PriorityAssistance56 = (PriorityAssistance56);
;// ./src/Picto/GeneratedPictoComponents/Roaming104.tsx


var Roaming104_excluded = ["className"];
function Roaming104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Roaming104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Roaming104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Roaming104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Roaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Roaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Roaming104_objectSpread(Roaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.54 84.55h-6.61c-1.66 0-3.87.5-5.43-.28-4.12-2.08 1.73-5.57 4.28-4.91 2.28.59 3.73 1.55 6.27 1.51 2.2-.03 4.37-.5 6.56-.52 3.13-.02 9.13-.34 10.76 3.91-1.78.9-4.75.3-6.75.3h-9.08Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.58 29.79c6.7-8.79 17.28-14.46 29.18-14.46 16 0 29.61 10.25 34.62 24.54M22.32 73.86C17.78 67.76 15.1 60.19 15.1 52c0-1.28.07-2.54.19-3.79M86.23 64.55c-5.12 14.07-18.62 24.12-34.47 24.12a36.5 36.5 0 0 1-15.67-3.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.74 84.74h26.81c3.12 0 4.22-4.13 1.51-5.68-1.52-.87-3.68-1.48-6.75-1.48 0 0-7.08-9.2-17.61 1.32 0 0-3.44-.67-5.67 1.15-1.92 1.57-.77 4.69 1.71 4.69Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.59 57.88c-3.52 0-7.05 0-10.57.01-.49 0-.98-.09-1.46-.22-.87-.23-.97.12-1.54-.63-2.92-3.79-5.9-7.55-8.76-11.38-3.27-4.38-5.05-8.43-8.92-12.31-.5-.5-1.08-1.18-.77-1.8.24-.47.9-.59 1.4-.39.49.2.85.63 1.19 1.04 5.83 7.08 11.08 13.89 19.08 18.55 4.18 2.43 4.47 3.14 7.92 4.53a4.35 4.35 0 0 1 2.45 2.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.66 50.15 49.6 73.38c-.29.31-.69.48-1.12.48h-6.31c-1.24 0-1.97-1.39-1.26-2.41l14.54-20.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.55 41.62-7.67-7.66c-.19-.19-.05-.5.21-.5h7.47l13.99 8.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.5 51.37h21.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.9 51.37h20.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.35 58.25H30.57c-.87 0-1.68-.4-2.21-1.09L8.43 31.11c-.37-.48-.02-1.17.58-1.17h5.21c.56 0 1.09.2 1.52.55L31.7 43.85c.18.15.41.24.65.24 10.49 0 20.99.05 31.48.09 4.83.02 9.66-.15 14.49-.24 6.38-.12 19.96.3 17.26 8.87-2.5 7.94-21.11 5.42-28.41 5.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Roaming104 = (Roaming104);
;// ./src/Picto/GeneratedPictoComponents/Roaming56.tsx


var Roaming56_excluded = ["className"];
function Roaming56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Roaming56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Roaming56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Roaming56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Roaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Roaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Roaming56_objectSpread(Roaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.54 31.54h-5.62c-.26 0-.52-.05-.78-.12-.46-.12-.52.06-.82-.33-1.55-2.02-3.14-4.01-4.66-6.05-1.74-2.33-2.68-4.48-4.74-6.55-.26-.26-.58-.63-.41-.96.13-.25.48-.31.74-.21.26.11.45.33.63.55 3.1 3.76 5.89 7.39 10.15 9.87 2.22 1.29 2.38 1.67 4.21 2.41.61.25 1.09.75 1.3 1.38Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.37 27.64 26.83 39.79c-.15.16-.36.25-.58.25h-3.3a.802.802 0 0 1-.66-1.26l7.6-10.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.24 23.18-4.01-4.01a.15.15 0 0 1 .11-.26h3.91l7.32 4.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.8 28.28h11.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.07 28.28h10.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.13 31.88h-8.25c-.45 0-.88-.21-1.16-.57L5.29 17.68a.38.38 0 0 1 .3-.61h2.73c.29 0 .57.1.8.29l8.35 6.99c.1.08.22.12.34.12 5.49 0 10.98.03 16.47.05 2.53 0 5.05-.08 7.58-.12 3.34-.06 10.44.16 9.03 4.64-1.31 4.15-11.04 2.84-14.86 2.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.57 46.18H6.95c-.91 0-2.11.28-2.97-.16-2.25-1.14.95-3.04 2.34-2.68 1.25.32 2.04.84 3.43.82 1.2-.02 2.39-.28 3.59-.28 1.71-.01 4.99-.18 5.88 2.14-.97.49-2.59.16-3.69.16h-4.97Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.3 15.61c3.74-4.9 9.64-8.07 16.28-8.07 8.93 0 16.52 5.72 19.31 13.69M11.16 40.2a20.405 20.405 0 0 1-3.92-14.31M46.82 35c-2.86 7.85-10.39 13.46-19.23 13.46-3.13 0-6.09-.7-8.74-1.96"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M4.7 46.27h14.96c1.74 0 2.36-2.31.84-3.17-.85-.48-2.05-.82-3.77-.82 0 0-3.95-5.13-9.83.74 0 0-1.92-.37-3.16.64-1.07.87-.43 2.62.95 2.62Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Roaming56 = (Roaming56);
;// ./src/Picto/GeneratedPictoComponents/RoamingOn104.tsx


var RoamingOn104_excluded = ["className"];
function RoamingOn104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RoamingOn104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RoamingOn104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RoamingOn104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RoamingOn104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RoamingOn104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RoamingOn104_objectSpread(RoamingOn104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.57 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.99 14h4M74.99 62.71V88c0 3.31-2.69 6-6 6h-34c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v10.18M45.99 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.25 52.48s1.05.51 3.79-2.12c2.03-1.95 1.68-1.45 6.48-6.81 0 0 1.12-1.04.39-1.67s-2.96 1.93-2.96 1.93l-4.44 5.01-3.34.06-3.32-1.12-1.37 2.08 2.51 1.74 2.25.9ZM86.58 29s.58.66 0 1.56-5.54 7.46-8.57 7.46c-3.59 0-4.17-.75-7.63-1.54-2.4-.55-5.14-1.56-5.91-.51s-1.54 1.29-1.54 1.29l-5.27-2.24 2.57-3.35 4.78.64 12.56 2.17 7.41-5.96 1.61.5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m67.12 60.13-4.11-6.47-6.47-4.11 2.27-2.18 5.63 1.73 7.5-8.23-15-5.78 2.33-2.4c.73-.75 1.78-1.09 2.8-.91l15.5 2.68.26-.32c.21-.24 5.16-5.83 8.38-5.83h.13c.56 0 1.09.23 1.48.62.42.45.62 1.06.54 1.67 0 3.19-5.63 8.1-5.83 8.31l-.32.26 2.73 15.35c.18 1.04-.16 2.09-.92 2.82l-2.33 2.25-5.85-15-8.25 7.71 1.73 5.63-2.19 2.21Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RoamingOn104 = (RoamingOn104);
;// ./src/Picto/GeneratedPictoComponents/RoamingOn56.tsx


var RoamingOn56_excluded = ["className"];
function RoamingOn56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function RoamingOn56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? RoamingOn56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : RoamingOn56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function RoamingOn56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, RoamingOn56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", RoamingOn56_objectSpread(RoamingOn56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40 33.19V47c0 1.66-1.34 3-3 3H19c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v5.09M27 8h2M25 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.34 27.88s.57.28 2.05-1.15c1.1-1.06.91-.78 3.51-3.68 0 0 .6-.56.21-.9s-1.6 1.04-1.6 1.04l-2.4 2.71-1.81.03-1.8-.6-.74 1.12 1.36.94 1.22.49ZM46.32 15.45s.31.35 0 .84-3 4.03-4.63 4.03c-1.94 0-2.25-.41-4.12-.83-1.3-.3-2.78-.84-3.2-.28s-.83.7-.83.7l-2.85-1.21 1.39-1.81 2.58.34 6.79 1.17 4.01-3.22.87.27Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m35.99 31.91-2.16-3.4-3.4-2.16 1.19-1.14 2.96.91 3.95-4.33-7.89-3.04 1.22-1.26c.38-.39.93-.57 1.47-.48l8.15 1.41.14-.17c.11-.13 2.71-3.07 4.41-3.07h.07c.29 0 .57.12.78.33.22.24.33.56.29.88 0 1.68-2.96 4.26-3.07 4.37l-.17.14 1.43 8.07c.1.54-.08 1.1-.48 1.48l-1.23 1.18-3.08-7.89-4.34 4.05.91 2.96-1.15 1.16Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_RoamingOn56 = (RoamingOn56);
;// ./src/Picto/GeneratedPictoComponents/SMS104.tsx


var SMS104_excluded = ["className"];
function SMS104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SMS104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SMS104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SMS104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SMS104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SMS104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SMS104_objectSpread(SMS104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 61v27c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M40 90h12M44 14h4"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.54 33.7v13.2c0 3.37 2.52 6.15 5.78 6.55.47.06.82.46.82.93v6.16c0 .75.84 1.2 1.46.78l9.58-6.38c.71-.48.47-1.58-.38-1.71-5.34-.87-17.26-4.51-17.26-19.53"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M87.94 27.1h-30.8c-3.64 0-6.6 2.96-6.6 6.6v13.2c0 3.64 2.96 6.6 6.6 6.6v8.8l13.2-8.8h17.6c3.64 0 6.6-2.96 6.6-6.6V33.7c0-3.64-2.96-6.6-6.6-6.6Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.49 40.4c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.29 40.4c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.09 40.4c0 1.52-1.23 2.75-2.75 2.75s-2.75-1.23-2.75-2.75 1.23-2.75 2.75-2.75 2.75 1.23 2.75 2.75Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SMS104 = (SMS104);
;// ./src/Picto/GeneratedPictoComponents/SMS56.tsx


var SMS56_excluded = ["className"];
function SMS56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SMS56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SMS56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SMS56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SMS56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SMS56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SMS56_objectSpread(SMS56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.93 47.43c-1.61-1.03-3.59-1.12-5.26-2.03-7.16-3.75-8.69-12.37-9.79-19.65-.32-1.82-.39-2.99-2.5-3.16v23.94c0 2.25 1.82 4.07 4.07 4.08h15.31c.11-1.28-.75-2.49-1.83-3.18Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.15 32.85v14.54c0 1.78-1.45 3.23-3.23 3.23h-18.3c-1.78 0-3.23-1.45-3.23-3.23V8.62c0-1.78 1.45-3.23 3.23-3.23h18.31c1.78 0 3.23 1.45 3.23 3.23v3.23M21.54 48.46H28M23.69 7.54h2.16"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.22 18.15v7.11c0 1.81 1.36 3.31 3.11 3.53.25.03.44.25.44.5v3.32c0 .41.45.65.79.42l5.16-3.44c.38-.26.25-.85-.2-.92-2.88-.47-9.3-2.43-9.3-10.51"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M47.35 14.59H30.77a3.55 3.55 0 0 0-3.55 3.55v7.11a3.55 3.55 0 0 0 3.55 3.55v4.74l7.11-4.74h9.48a3.55 3.55 0 0 0 3.55-3.55v-7.11a3.55 3.55 0 0 0-3.55-3.55Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.8 21.76c0 .82-.66 1.48-1.48 1.48s-1.48-.66-1.48-1.48.66-1.48 1.48-1.48 1.48.66 1.48 1.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.54 21.76c0 .82-.66 1.48-1.48 1.48s-1.48-.66-1.48-1.48.66-1.48 1.48-1.48 1.48.66 1.48 1.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.28 21.76c0 .82-.66 1.48-1.48 1.48s-1.48-.66-1.48-1.48.66-1.48 1.48-1.48 1.48.66 1.48 1.48Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SMS56 = (SMS56);
;// ./src/Picto/GeneratedPictoComponents/SendOldPhone104.tsx


var SendOldPhone104_excluded = ["className"];
function SendOldPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SendOldPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SendOldPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SendOldPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SendOldPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SendOldPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SendOldPhone104_objectSpread(SendOldPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.64 87.02c-2.86-1.83-6.4-1.99-9.38-3.63-12.77-6.68-15.5-22.07-17.46-35.05-.57-3.24-.7-5.33-4.46-5.63v44.57c0 4.01 1.37 5.41 5.38 5.41h29.19c.19-2.29-1.33-4.44-3.26-5.68Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.71 60v27.29c0 3.08-2.49 5.57-5.57 5.57H29.71c-3.08 0-5.57-2.49-5.57-5.57V16.71c0-3.08 2.49-5.57 5.57-5.57h33.43c3.08 0 5.57 2.49 5.57 5.57v10.57M44.57 14.86h3.72M40.86 89.14H52"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.1 42.71.85 3.16c-.34-1.28.01-3.21 2.05-2.84 2.03.37 10.52 2.42 11.18 2.65.67.22 2.72.33 3.12-.68-1.43-.44-6.97-1.83-16.6-4.17-.7.14-.9.77-.6 1.88ZM83.11 48.43c-.77-.09-10.03-2.26-10.44-2.15s-.44.56-.21.67c.23.11 4.3 1.14 5.16 1.38.86.24.99 1.3.08 1.55s-1.72.48-1.61.91 5.66-1.32 6.21-1.47 1.58-.8.81-.89Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.34 39.5 28.08-7.52c1.02-.27 2.06.29 2.32 1.27l3.7 13.81c.26.97-.36 1.98-1.38 2.26l-28.08 7.52c-1.02.27-2.06-.29-2.32-1.27l-3.7-13.81c-.26-.97.36-1.98 1.38-2.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.93 40.39 16.2 3.91c.44.1.91-.02 1.24-.34l11.86-11.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m72.65 45.68 13.32 2.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m65.93 47.48-10.15 9.07"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SendOldPhone104 = (SendOldPhone104);
;// ./src/Picto/GeneratedPictoComponents/SendOldPhone56.tsx


var SendOldPhone56_excluded = ["className"];
function SendOldPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SendOldPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SendOldPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SendOldPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SendOldPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SendOldPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SendOldPhone56_objectSpread(SendOldPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 32v15c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v6M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.05 23 .46 1.7c-.18-.69 0-1.73 1.1-1.53 1.1.2 5.66 1.3 6.02 1.43.36.12 1.46.18 1.68-.37-.77-.24-3.75-.99-8.94-2.25-.38.08-.48.41-.32 1.01ZM44.75 26.08c-.42-.05-5.4-1.22-5.62-1.16s-.24.3-.12.36 2.32.61 2.78.74c.46.13.53.7.05.83s-.93.26-.87.49 3.05-.71 3.34-.79.85-.43.44-.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.18 21.27 15.12-4.05c.55-.15 1.11.16 1.25.68l1.99 7.44c.14.52-.19 1.07-.74 1.22l-15.12 4.05c-.55.15-1.11-.16-1.25-.68l-1.99-7.44c-.14-.52.19-1.07.74-1.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.96 21.75 8.72 2.11c.24.06.49-.01.67-.18l6.38-6.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.12 24.6 7.17 1.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.5 25.57-5.47 4.88"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SendOldPhone56 = (SendOldPhone56);
;// ./src/Picto/GeneratedPictoComponents/SharedWiFi104.tsx


var SharedWiFi104_excluded = ["className"];
function SharedWiFi104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SharedWiFi104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SharedWiFi104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SharedWiFi104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SharedWiFi104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SharedWiFi104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SharedWiFi104_objectSpread(SharedWiFi104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.31 90.18c-16.06-.24-37.22-.14-53.28-.44-2.67-.05-4.45 0-6.94-1.02-6.43-2.61-5.05-9.93-6.79-15.19-.7-2.15-3.29-2.23-3.29.28v13.06c0 6.46 3.75 5.97 3.75 5.97h72.95s-.77-2.59-6.4-2.67Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.91 46.46h.68c1 0 1.82.81 1.82 1.82v19.76h-4.32V48.28c0-1 .81-1.82 1.82-1.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.46 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.75 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.04 80.9c0 1.71 1.38 3.09 3.09 3.09s3.09-1.38 3.09-3.09-1.38-3.09-3.09-3.09c-.82 0-1.61.32-2.19.9-.58.58-.9 1.37-.9 2.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11",
        y: "68.2",
        width: "82",
        height: "24.72",
        rx: "4.32",
        ry: "4.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.25 75.26v5.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.71 76.61a5.4 5.4 0 0 0-1.5 5.96c.79 2.11 2.8 3.5 5.05 3.5s4.26-1.4 5.05-3.5a5.4 5.4 0 0 0-1.5-5.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.1 53.02h4.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.09 50.27s-1.66 1.19-.42-1.06 13.94-5.42 20.16-4.3c6.22 1.12 7.11-2.6 8.09-5.34 0 0 1.16-2.82 2.82-1.91 1.66.91.52 11.76.52 11.76s-5.43 1.77-6.92.86-9.69 0-9.69 0H46.08Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M70.39 22.92h4.05c1.68 0 3.04 1.36 3.04 3.04v21.27c0 1.68-1.36 3.04-3.04 3.04H46.08c-1.68 0-3.04-1.36-3.04-3.04V25.96c0-1.68 1.36-3.04 3.04-3.04h4.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53.1 18.96 7.17-7.18 7.17 7.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.27 41.66V11.78"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SharedWiFi104 = (SharedWiFi104);
;// ./src/Picto/GeneratedPictoComponents/SharedWiFi56.tsx


var SharedWiFi56_excluded = ["className"];
function SharedWiFi56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SharedWiFi56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SharedWiFi56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SharedWiFi56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SharedWiFi56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SharedWiFi56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SharedWiFi56_objectSpread(SharedWiFi56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.72 48.02c-8.62-.13-19.97-.07-28.59-.24-1.43-.03-2.39 0-3.72-.55-3.45-1.4-2.71-5.33-3.64-8.15-.38-1.15-1.77-1.2-1.77.15v7.01c0 3.47 2.01 3.21 2.01 3.21h39.15s-.41-1.39-3.43-1.43Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.08 24.56h.37c.54 0 .97.44.97.97v10.6H14.1v-10.6c0-.54.44-.97.97-.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.05 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.84 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.63 43.04c0 .92.74 1.66 1.66 1.66.92 0 1.66-.74 1.66-1.66 0-.92-.74-1.66-1.66-1.66-.44 0-.86.17-1.17.49-.31.31-.49.73-.48 1.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6",
        y: "36.23",
        width: "44",
        height: "13.26",
        rx: "2.32",
        ry: "2.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.26 40.02v2.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.36 40.74c-.91.79-1.23 2.07-.81 3.2.42 1.13 1.5 1.88 2.71 1.88s2.29-.75 2.71-1.88.1-2.4-.81-3.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.1 28.09h2.32"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.01 26.65s-.86.62-.22-.55 7.25-2.82 10.48-2.24c3.23.58 3.7-1.35 4.21-2.78 0 0 .6-1.47 1.47-.99s.27 6.11.27 6.11-2.82.92-3.6.45-5.03 0-5.03 0h-7.57Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.87 11.94h2.17c.9 0 1.63.73 1.63 1.63v11.41c0 .9-.73 1.63-1.63 1.63H24.82c-.9 0-1.63-.73-1.63-1.63V13.57c0-.9.73-1.63 1.63-1.63h2.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.59 9.81 3.85-3.85 3.85 3.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.44 21.99V5.96"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SharedWiFi56 = (SharedWiFi56);
;// ./src/Picto/GeneratedPictoComponents/SmartHome104.tsx


var SmartHome104_excluded = ["className"];
function SmartHome104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SmartHome104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SmartHome104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SmartHome104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SmartHome104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartHome104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SmartHome104_objectSpread(SmartHome104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.83 61.15c-.56.06-.98.53-.98 1.09l.05 27.43v1.48c0 1.02.83 1.85 1.85 1.85h23.89c2 0 2.58-2.74.75-3.53C34 84.56 25.05 75.42 21.4 63.37c-.14-.47-.27-.94-.4-1.41-.14-.52-.63-.87-1.17-.82ZM50.09 11.76c1-.96 2.54-1.02 3.61-.18l.21.18 40.54 38.7c1.1 1.05 1.14 2.8.09 3.91a2.756 2.756 0 0 1-3.69.28l-.21-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21 40.54-38.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.17 49.29V93H18.91v-3.33l-.08-40.38M11.46 93h81.08M23.76 36.85V19.3h9.59v8.46l-9.59 9.09z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.09 11.76c1-.96 2.54-1.02 3.61-.18l.21.18 40.54 38.7c1.1 1.05 1.14 2.8.09 3.91a2.756 2.756 0 0 1-3.69.28l-.21-.18L52 17.58 13.37 54.46a2.76 2.76 0 0 1-3.7.1l-.21-.19a2.76 2.76 0 0 1-.1-3.7l.19-.21 40.54-38.7Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.28 74.9a2.29 2.29 0 1 1-4.58 0c0-1.27 1.02-2.29 2.29-2.29s2.29 1.02 2.29 2.29",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.87 56.52c4.66-4.58 11.09-7.38 18.13-7.38s13.47 2.81 18.13 7.38M42.98 65.63c2.33-2.2 5.53-3.58 9.02-3.58s6.7 1.38 9.03 3.58"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartHome104 = (SmartHome104);
;// ./src/Picto/GeneratedPictoComponents/SmartHome56.tsx


var SmartHome56_excluded = ["className"];
function SmartHome56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SmartHome56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SmartHome56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SmartHome56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SmartHome56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SmartHome56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SmartHome56_objectSpread(SmartHome56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.39 32.07.03 15.87v1.81h16.34c.65 0 .79-.9.18-1.1-7.19-2.38-12.95-7.7-15.16-14.98-.18-.6-.28-.92-.4-1.52-.14-.86-.98-.55-.98-.07ZM26.96 6.04c.54-.52 1.38-.55 1.96-.1l.11.1 22 21c.6.57.62 1.52.05 2.12-.54.56-1.4.62-2 .15l-.12-.1L28 9.2 7.04 29.21c-.56.54-1.43.55-2.01.06l-.11-.11c-.54-.56-.55-1.43-.06-2.01l.11-.11 21.99-21Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46 26.41v23.72H10.04v-1.81L10 26.41M6 50.13h44M12.68 19.66v-9.53h5.2v4.6l-5.2 4.93z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.96 6.04c.54-.52 1.38-.55 1.96-.1l.11.1 22 21c.6.57.62 1.52.05 2.12-.54.56-1.4.62-2 .15l-.12-.1L28 9.2 7.04 29.21c-.56.54-1.43.55-2.01.06l-.11-.11c-.54-.56-.55-1.43-.06-2.01l.11-.11 21.99-21Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.24 40.3a1.24 1.24 0 1 1-2.48 0c0-.69.55-1.24 1.24-1.24s1.24.55 1.24 1.24",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.16 30.33c2.53-2.48 6.02-4.01 9.84-4.01s7.31 1.52 9.84 4.01M23.1 35.28c1.26-1.2 3-1.94 4.9-1.94s3.63.75 4.9 1.94"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SmartHome56 = (SmartHome56);
;// ./src/Picto/GeneratedPictoComponents/Telstra104.tsx


var Telstra104_excluded = ["className"];
function Telstra104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Telstra104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Telstra104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Telstra104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Telstra104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Telstra104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Telstra104_objectSpread(Telstra104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.34 37.13c-13.28 3.12-7.2 18.54-2.56 26.06.19.31.65.07.53-.27-6.15-16.84-.64-23.2 2.29-25.26.27-.19.07-.6-.25-.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.99 65.63a.168.168 0 0 0-.22-.02c-.06.06-.07.15-.02.22C40.72 83.86 62.34 91.28 70.99 85.7c2.37-7.23-19.9 2.82-44.01-20.07Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m58.65 49.4-2.66 15.64c-.55 2.81-2.4 3.58-4.05 3.58H39.61l5.19-28.64c-5.19-2.37-10.48-3.92-14.7-3.92s-7.27 1.08-9.44 3.68c-1.53 1.85-2.29 4.13-2.29 6.84 0 8.14 6.4 19.44 17.37 28.66 9.77 8.15 20.52 12.71 28.34 12.71 3.9 0 7.05-1.2 9.12-3.58 1.63-1.85 2.28-4.24 2.28-6.95 0-7.91-6.45-19-16.84-28.01Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.29 49.06c.43-2.04.25-2.97.15-2.89s-3.83 21.85-3.83 21.85h11.7c-7.44 0-10.26-8.07-8.02-18.96Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.19 21.1c5.59.41 8.88 2.37 9.97 4.23.18.31.64.21.7-.14l.89-4.84a.391.391 0 0 0-.38-.46H58.91s.17.69 7.28 1.2Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.52 19.11c-1.96 0-3.58 1.31-4.02 3.37l-1.73 9.44h15.5l-6.65 36.69h12.33c1.65 0 3.5-.76 4.05-3.58l5.64-33.12h11.15c1.96 0 3.59-1.3 4.02-3.36l1.74-9.45H36.53Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Telstra104 = (Telstra104);
;// ./src/Picto/GeneratedPictoComponents/Telstra56.tsx


var Telstra56_excluded = ["className"];
function Telstra56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Telstra56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Telstra56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Telstra56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Telstra56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Telstra56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Telstra56_objectSpread(Telstra56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.21 20.1c-6.62 1.56-3.59 9.24-1.28 12.99.09.15.33.04.26-.13-3.06-8.4-.32-11.57 1.14-12.59.13-.09.03-.3-.13-.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.04 34.31s-.08-.04-.11 0c-.03.03-.04.08 0 .11 6.96 8.99 17.74 12.68 22.05 9.9 1.18-3.61-9.92 1.41-21.94-10Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m31.82 26.22-1.33 7.79c-.27 1.4-1.2 1.78-2.02 1.78h-6.14l2.59-14.28c-2.59-1.18-5.22-1.95-7.33-1.95s-3.62.54-4.7 1.84c-.76.92-1.14 2.06-1.14 3.41 0 4.06 3.19 9.69 8.66 14.28 4.87 4.06 10.23 6.33 14.13 6.33 1.95 0 3.52-.6 4.55-1.79.81-.92 1.13-2.11 1.13-3.47 0-3.94-3.22-9.47-8.4-13.96Z",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.66 26.05c.22-1.02.12-1.48.07-1.44S22.82 35.5 22.82 35.5h5.83c-3.71 0-5.11-4.02-4-9.45Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.58 12.11c2.79.2 4.43 1.18 4.97 2.11.09.15.32.11.35-.07l.44-2.41a.195.195 0 0 0-.19-.23h-9.2s.08.34 3.63.6Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.79 11.12c-.98 0-1.79.65-2 1.68l-.86 4.71h7.73L22.34 35.8h6.14c.82 0 1.74-.38 2.02-1.78l2.81-16.51h5.56c.98 0 1.79-.65 2-1.68l.87-4.71H20.8Z",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Telstra56 = (Telstra56);
;// ./src/Picto/GeneratedPictoComponents/TradeIn104.tsx


var TradeIn104_excluded = ["className"];
function TradeIn104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TradeIn104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TradeIn104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TradeIn104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TradeIn104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TradeIn104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TradeIn104_objectSpread(TradeIn104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.23 88.23c-2.34-1.5-5.23-1.63-7.67-2.97-10.44-5.47-12.67-18.04-14.27-28.66-.46-2.65-.57-4.36-3.65-4.61v34.92c0 3.28 2.66 5.94 5.94 5.95h22.33c.15-1.87-1.09-3.63-2.67-4.64Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.07 71.66v16.49c0 2.6-2.11 4.71-4.71 4.71H15.65c-2.6 0-4.71-2.11-4.71-4.71V31.61c0-2.6 2.11-4.71 4.71-4.71h26.71c2.6 0 4.71 2.11 4.71 4.71v40.06M27.43 30.03h3.14M24.29 89.73h9.42"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m78.67 18.54-2.95 7.69-7.97-4.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.74 20.05c3.04-6.15 10.66-9.91 17.86-9.04 7.2.86 13.72 6.31 15.22 13.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.5",
        cy: "51.85",
        r: "16.5"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M75.59 58.2v-5.54l-.8-.18c-2.92-.67-4.36-2.21-4.36-4.57 0-3.03 2.23-4.98 5.21-5.26v-2.13h1.95v2.16c2.59.36 4.77 2.03 5.03 5.03H79.8c-.13-1.28-.82-2.31-2.21-2.64v5.26l1.15.26c2.62.62 4.21 2.18 4.21 4.75 0 3.15-2.13 5.03-5.41 5.31v2.54h-1.95v-2.57c-3.28-.36-5.46-2.39-5.54-5.62h2.92c.08 1.62.92 2.85 2.62 3.21Zm.05-8.31v-4.87c-1.59.26-2.46 1.28-2.46 2.62 0 1.08.64 1.8 2.46 2.26Zm1.9 3.18v5.18c1.62-.26 2.64-1.23 2.64-2.69 0-1.21-.69-2.05-2.56-2.46l-.08-.03Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TradeIn104 = (TradeIn104);
;// ./src/Picto/GeneratedPictoComponents/TradeIn56.tsx


var TradeIn56_excluded = ["className"];
function TradeIn56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TradeIn56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TradeIn56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TradeIn56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TradeIn56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TradeIn56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TradeIn56_objectSpread(TradeIn56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.37 47.1c-1.24-.79-2.78-.86-4.07-1.57-5.54-2.9-6.73-9.57-7.57-15.21-.25-1.41-.3-2.31-1.93-2.44v18.53c0 1.74 1.41 3.15 3.15 3.16H21.8c.08-.99-.58-1.93-1.42-2.46h-.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.59 38.31v8.75a2.5 2.5 0 0 1-2.5 2.5H8.92a2.5 2.5 0 0 1-2.5-2.5V17.05a2.5 2.5 0 0 1 2.5-2.5h14.17a2.5 2.5 0 0 1 2.5 2.5v21.26M15.17 16.21h1.66M13.5 47.89h5"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.95 10.53-1.54 4.02-4.15-2.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.69 11.32c1.59-3.21 5.56-5.17 9.32-4.72 3.76.45 7.16 3.29 7.94 6.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.82",
        cy: "27.91",
        r: "8.61"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.35 31.23v-2.89l-.42-.09c-1.53-.35-2.28-1.15-2.28-2.38 0-1.58 1.16-2.6 2.72-2.74v-1.11h1.02v1.12c1.35.19 2.49 1.06 2.62 2.62h-1.47c-.07-.67-.43-1.2-1.15-1.38v2.74l.6.13c1.36.32 2.19 1.14 2.19 2.48 0 1.65-1.11 2.62-2.82 2.77v1.33h-1.02v-1.34c-1.71-.19-2.85-1.24-2.89-2.93h1.53c.04.84.48 1.49 1.37 1.67Zm.02-4.34v-2.54c-.83.13-1.28.67-1.28 1.36 0 .56.33.94 1.28 1.18Zm.99 1.66v2.7c.84-.13 1.38-.64 1.38-1.41 0-.63-.36-1.07-1.34-1.28h-.04Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TradeIn56 = (TradeIn56);
;// ./src/Picto/GeneratedPictoComponents/Unlimited104.tsx


var Unlimited104_excluded = ["className"];
function Unlimited104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Unlimited104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Unlimited104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Unlimited104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Unlimited104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Unlimited104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Unlimited104_objectSpread(Unlimited104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.63 38.85c5.32 0 9.96 3.77 14.13 8.81 2.36 2.85 6.82.87 3.85-2.11-6.36-6.36-11.91-11.04-18.06-11.04-3.62 0-7.4 1.14-10.25 3.43-2.99 2.4-4.88 5.29-6.49 8.7-1.05 2.24 2.46 2.77 3.52.53 0 0 3.85-8.31 13.3-8.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.31 56.96c-.73 2.42-3.37 8.02-10.84 9.25-4.55.26-10.37-1.17-13.26-6.31-1.1-1.95-7.33-1.7-5.46 2.17 3.17 6.58 12.17 9.89 19.63 8.8 3.3-.48 5.92-2.24 8.18-4.53 2.36-2.41 4.24-5.16 5.19-8.29.62-2.06-2.81-3.15-3.43-1.09"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m52.88 47.43 7.61-7.63c6.93-6.95 18.18-6.95 25.12 0 6.94 6.96 6.94 18.23 0 25.18-6.94 6.96-18.18 6.96-25.12 0l-.25-.19-24.93-25c-6.93-6.95-18.18-6.95-25.11 0-6.93 6.96-6.93 18.23 0 25.18 6.94 6.96 18.18 6.96 25.11 0l6.93-6.94",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.72 28.75V21.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m78.02 29.57 1.79-6.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.88 32 3.47-6.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m88.92 35.86 4.91-4.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m92.79 40.89 6.01-3.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m95.22 46.75 6.71-1.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M96.05 53.04H103"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Unlimited104 = (Unlimited104);
;// ./src/Picto/GeneratedPictoComponents/Unlimited56.tsx


var Unlimited56_excluded = ["className"];
function Unlimited56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Unlimited56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Unlimited56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Unlimited56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Unlimited56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Unlimited56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Unlimited56_objectSpread(Unlimited56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M4.53 30.63c-.02-1.51.44-5.17 4.18-7.21 2.36-.96 5.68-1.2 8.06 1.2.91.91 3.45.19 1.82-1.67-2.77-3.17-7.38-3.98-11.14-2.02-1.66.87-3.17 2.24-3.97 3.95-.85 1.79-.97 3.79-.94 5.74.02 1.28 2.01 1.29 1.99 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.09 29.32c.02 1.31-.41 4.49-3.9 6.26-2.2.84-5.3 1.04-7.53-1.04-.85-.79-3.22-.17-1.7 1.45 2.59 2.75 6.89 3.46 10.4 1.75 1.55-.75 2.96-1.95 3.71-3.43.79-1.56.9-3.29.88-4.98-.02-1.11-1.88-1.12-1.86 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.13 17.14V13.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m40.52 17.58.97-3.61"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.68 18.89 1.87-3.24"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m46.4 20.97 2.64-2.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.48 23.68 3.24-1.87"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m49.79 26.84 3.62-.97"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.24 30.23h3.75"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m27.32 26.88 3.94-3.95c3.59-3.6 9.41-3.6 13 0s3.59 9.44 0 13.03a9.174 9.174 0 0 1-13 0l-.13-.1-12.9-12.94a9.174 9.174 0 0 0-13 0c-3.59 3.6-3.59 9.44 0 13.03 3.59 3.6 9.41 3.6 13 0l3.59-3.59",
      className: "strokeprimary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Unlimited56 = (Unlimited56);
;// ./src/Picto/GeneratedPictoComponents/Upgrade104.tsx


var Upgrade104_excluded = ["className"];
function Upgrade104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Upgrade104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Upgrade104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Upgrade104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Upgrade104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Upgrade104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Upgrade104_objectSpread(Upgrade104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.59 88.09c-2.98-1.91-6.66-2.07-9.77-3.78-13.3-6.96-16.13-22.97-18.17-36.49-.59-3.37-.73-5.55-4.64-5.86v44.46c0 4.18 3.38 7.56 7.56 7.57h28.42c.2-2.38-1.38-4.62-3.4-5.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69 65v23c0 3.31-2.69 6-6 6H29c-3.31 0-6-2.69-6-6V16c0-3.31 2.69-6 6-6h34c3.31 0 6 2.69 6 6v6M44 14h4M40 90h12"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M62.46 32.48c.82-.8-.16-2.1-1.16-1.54-4.67 2.62-7.82 7.56-7.82 13.23 0 3.11.95 6 2.57 8.41.06.09.13.17.22.23L59 55.2c.88.31.95-.13.67-.64-1.68-2.76-2.48-5.56-2.48-9.14 0-5.16 2.04-9.79 5.27-12.95Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.47 58.96c-6.08-2.25-10.42-8.1-10.42-14.96 0-8.81 7.14-15.95 15.95-15.95S84.95 35.19 84.95 44c0 6.86-4.34 12.71-10.42 14.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.74 43.63 69 37.37l6.26 6.26"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M69 59.01V37.37"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Upgrade104 = (Upgrade104);
;// ./src/Picto/GeneratedPictoComponents/Upgrade56.tsx


var Upgrade56_excluded = ["className"];
function Upgrade56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Upgrade56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Upgrade56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Upgrade56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Upgrade56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Upgrade56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Upgrade56_objectSpread(Upgrade56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.96 46.86c-1.54-.99-3.45-1.07-5.05-1.95-6.88-3.6-8.35-11.88-9.4-18.87-.31-1.74-.38-2.87-2.4-3.03v24c0 2.16.74 2.91 2.9 2.91h15.72c.1-1.23-.72-2.39-1.76-3.06Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37 35v12c0 1.66-1.34 3-3 3H16c-1.66 0-3-1.34-3-3V9c0-1.66 1.34-3 3-3h18c1.66 0 3 1.34 3 3v3M24 8h2M22 48h6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.2 17.82c.43-.42-.08-1.1-.61-.81-2.45 1.37-4.1 3.97-4.1 6.94 0 1.63.5 3.15 1.35 4.41.03.05.07.09.12.12l1.43 1.25c.46.16.5-.07.35-.33-.88-1.45-1.3-2.92-1.3-4.79 0-2.71 1.07-5.14 2.76-6.79Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.73 31.72a8.367 8.367 0 0 1-5.46-7.85c0-4.62 3.75-8.37 8.37-8.37s8.37 3.75 8.37 8.37c0 3.6-2.27 6.67-5.47 7.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m35.35 23.67 3.28-3.29 3.29 3.29"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M38.63 31.74V20.38"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Upgrade56 = (Upgrade56);
;// ./src/Picto/GeneratedPictoComponents/WeCare104.tsx


var WeCare104_excluded = ["className"];
function WeCare104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WeCare104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WeCare104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WeCare104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WeCare104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WeCare104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WeCare104_objectSpread(WeCare104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M94.56 61.51s.66 1.11.66 2.65-5.75 6.86-9.34 8.07-2.98 3.42-2.71 5.13c0 0 .2 1.81-.93 1.82s-5.16-9.32-5.16-9.32 3.34-.34 4.38-.3 4.85-2.52 4.85-2.52l4.4-1.92 2.25-2.72 1.59-.89ZM9.76 61.09s-.66 1.11-.66 2.65 5.75 6.86 9.34 8.07 2.98 3.42 2.71 5.13c0 0-.2 1.81.93 1.82s5.16-9.32 5.16-9.32-3.34-.34-4.38-.3-4.85-2.52-4.85-2.52l-4.4-1.92-2.25-2.72-1.59-.89Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M95.22 58.27c-.53-.93-2.59-.83-5.29.07M79.54 64.18c-2.47 2.07-3.8 4-3.22 4.99M9.23 58.27c.53-.93 2.59-.83 5.29.07M24.91 64.18c2.47 2.07 3.8 4 3.22 4.99"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m55.58 58.46.12-.66s.02-.05.05-.07c.24-.16.46-.3.63-.43 1.61-1.24 4.16-2.43 5.31-3.64 3.57-3.5 6.26-8.22 6.4-11.87.13-3.35-2.06-5.72-2.87-7.61-.03-.06.02-.14.09-.15 1.71-.1 3.79 3.23 4.27 4.03 7.06 11.87-11.85 19.72-13.85 20.51-.08.03-.15-.04-.14-.12ZM33.29 55.21s-7.05-3.69-12.22 4.39l-3.91 6.95 5.3 2.81 1.89-5.58 4.67-4.13 7.59-.6L46.18 63l.16-.28c.07-.13.03-.29-.1-.36l-12.95-7.14Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M31.77 30.73c2.05-2.3 4-4.84 5.83-6.43 1.19-1.02 3.17-2.06 4.97-2.67 2.19-.75 4.94-.68 5.91.59.66.87.59 2.95-2.42 4.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.51 62.62s6.75-11.04 8.75-14.86c2.58-4.94 6.24-13.54 12.22-18.63 6.91-5.88 14.07-2.09 14.07-2.09s3.06 1.55 4.25 4.22c.47 1.05.33 1.87-.02 2.48-.73 1.29-2.43 1.7-3.7.94-.32-.19-.65-.46-.97-.81-1.5-1.66-3.62-1.58-3.62-1.58-1.39-.02-3.09 1.06-4.05 1.77-.5.37-.87.88-1.08 1.46-.57 1.61-1.75 5.05-1.84 6.28-.03.34 0 .66.11.98.45 1.29 1.31 3.06 2.19 4.74 1.59 3.04 3.85 5.68 6.61 7.72.77.57 1.61 1.2 2.43 1.84 1.28.99 5.15 2.7 3.45 5.5-1.7 2.8-4.78.85-6.14.15-.9-.47-2.78-1.25-3.68-1.7-10.07-5.07-15.44.88-16.19 2.22l-.22.4-2.62 4.73M72.65 30.71c-2.05-2.3-3.98-4.82-5.81-6.4-1.19-1.02-3.17-2.06-4.97-2.67-2.19-.75-4.94-.68-5.91.59-.66.87-.59 2.95 2.42 4.22"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.93 62.62s-6.75-11.04-8.75-14.86c-2.58-4.94-6.24-13.54-12.22-18.63-6.91-5.88-14.07-2.09-14.07-2.09s-3.06 1.55-4.25 4.22c-.47 1.05-.33 1.87.02 2.48.73 1.29 2.43 1.7 3.7.94.32-.19.65-.46.97-.81 1.5-1.66 3.62-1.58 3.62-1.58 1.39-.02 3.09 1.06 4.05 1.77.5.37.87.88 1.08 1.46.57 1.61 1.75 5.05 1.84 6.28.03.34 0 .66-.11.98-.45 1.29-1.31 3.06-2.19 4.74a22.659 22.659 0 0 1-6.61 7.72c-.77.57-1.61 1.2-2.43 1.84-1.28.99-5.15 2.7-3.45 5.5 1.7 2.8 4.78.85 6.14.15.9-.47 2.78-1.25 3.68-1.7 10.07-5.07 15.44.88 16.19 2.22l.22.4 2.62 4.73"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m6.04 64.05 3.19-5.78"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m19.51 84.36 8.62-15.19"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m95.22 58.27 2.74 4.94"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m84.42 84.85-8.1-15.68"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.13 69.17c-.87 1.51-5.81.3-11.03-2.71s-8.74-6.68-7.87-8.19M76.32 69.17c.87 1.51 5.81.3 11.03-2.71s8.74-6.68 7.87-8.19"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WeCare104 = (WeCare104);
;// ./src/Picto/GeneratedPictoComponents/WeCare56.tsx


var WeCare56_excluded = ["className"];
function WeCare56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WeCare56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WeCare56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WeCare56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WeCare56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WeCare56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WeCare56_objectSpread(WeCare56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.01 34s.35.58.35 1.39-3.01 3.59-4.89 4.23-1.56 1.79-1.42 2.69c0 0 .11.95-.49.95s-2.7-4.88-2.7-4.88 1.75-.18 2.29-.16 2.54-1.32 2.54-1.32l2.3-1.01 1.18-1.42L50 34ZM5.61 33.74s-.35.59-.35 1.42 3.08 3.68 5.01 4.33 1.6 1.83 1.45 2.75c0 0-.11.97.5.97s2.77-5 2.77-5-1.79-.18-2.35-.16-2.6-1.35-2.6-1.35l-2.36-1.03-1.21-1.46-.85-.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "strokesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M50.03 32.1c-.28-.49-1.18-.5-2.62-.02M41.72 35.24c-1.31 1.09-2.01 2.12-1.71 2.65M5.36 31.97c.28-.49 1.37-.44 2.81.04M14.1 35.29c1.31 1.09 2.01 2.12 1.71 2.65"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.9 31.99.06-.34s.01-.03.02-.04c.13-.08.24-.16.33-.22.83-.64 2.16-1.26 2.75-1.88 1.85-1.82 3.24-4.26 3.31-6.15.07-1.74-1.07-2.97-1.49-3.94-.01-.03 0-.07.05-.08.89-.05 1.96 1.67 2.21 2.09 3.66 6.15-6.14 10.22-7.17 10.63-.04.02-.08-.02-.07-.06ZM18.36 30.3s-3.65-1.91-6.33 2.27L10 36.17l2.74 1.45.98-2.89 2.42-2.14 3.93-.31 4.96 2.04.08-.14c.04-.07.01-.15-.05-.19l-6.71-3.7Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17.44 17.75c1.06-1.19 2.07-2.5 3.01-3.32.61-.53 1.64-1.06 2.57-1.38 1.13-.39 2.55-.35 3.05.3.34.45.31 1.52-1.25 2.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7.49 34.22s3.49-5.7 4.52-7.68c1.33-2.55 3.22-6.99 6.31-9.62 3.57-3.04 7.27-1.08 7.27-1.08s1.58.8 2.2 2.18c.24.54.17.97-.01 1.28-.38.66-1.25.88-1.91.48-.16-.1-.34-.24-.5-.42-.78-.86-1.87-.81-1.87-.81-.72-.01-1.59.55-2.09.92-.26.19-.45.45-.56.76-.29.83-.9 2.61-.95 3.24-.01.17 0 .34.06.5.23.67.68 1.58 1.13 2.45.82 1.57 1.99 2.94 3.42 3.99.4.3.83.62 1.26.95.66.51 2.66 1.4 1.78 2.84-.88 1.44-2.47.44-3.17.08-.46-.24-1.43-.64-1.9-.88-5.2-2.62-7.97.46-8.36 1.14l-.11.21-1.35 2.44M38.55 17.74c-1.06-1.19-2.05-2.49-3-3.31-.61-.53-1.64-1.06-2.57-1.38-1.13-.39-2.55-.35-3.05.3-.34.45-.31 1.52 1.25 2.18"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.51 34.22s-3.49-5.7-4.52-7.68c-1.33-2.55-3.22-6.99-6.31-9.62-3.57-3.04-7.27-1.08-7.27-1.08s-1.58.8-2.2 2.18c-.24.54-.17.97.01 1.28.38.66 1.25.88 1.91.48.16-.1.34-.24.5-.42.78-.86 1.87-.81 1.87-.81.72-.01 1.59.55 2.09.92.26.19.45.45.56.76.29.83.9 2.61.95 3.24.01.17 0 .34-.06.5-.23.67-.68 1.58-1.13 2.45-.82 1.57-1.99 2.94-3.42 3.99-.4.3-.83.62-1.26.95-.66.51-2.66 1.4-1.78 2.84.88 1.44 2.47.44 3.17.08.46-.24 1.43-.64 1.9-.88 5.2-2.62 7.97.46 8.36 1.14l.11.21 1.35 2.44"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m3.61 35.2 1.75-3.23"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m10.85 46.11 4.95-8.17"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m50.15 32.23 1.65 2.59"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m44.53 46.45-4.51-8.57"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M15.8 37.94c-.47.81-3.45.18-6.26-1.44-2.8-1.62-4.65-3.72-4.18-4.53M40.02 37.88c.47.81 3.28.3 6.08-1.31 2.8-1.62 4.4-3.65 3.93-4.47"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WeCare56 = (WeCare56);
;// ./src/Picto/GeneratedPictoComponents/Building104.tsx


var Building104_excluded = ["className"];
function Building104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Building104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Building104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Building104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Building104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Building104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Building104_objectSpread(Building104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.89 30.61v62.03l7.14-.14-.35-.95a25.16 25.16 0 0 1-1.56-8.28l-.93-52.66h-4.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.21 41.08h22.54v-.04H55.21v.04z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.21 50.73h22.54v-.03H55.21v.03z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.21 60.39h22.54v-.03H55.21v.03z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.21 70.05h22.54v-.03H55.21v.03z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.21 79.71h22.54v-.04H55.21v.04z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.4 93.15V31.4H55.21v61.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.58 20.14v73.02l7.14-.17-.51-1.63a30.68 30.68 0 0 1-1.39-8.72l-.94-62.5h-4.3Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.56 10 1 9.25 1.84.86-7.15.03V10h4.31z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.24 20.14h28.97v-9.66H26.24v9.66z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.87 26.49v-6.35H16.58v73.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 35.72h.04V32.5h-.04v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.88 35.72h.03V32.5h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 35.72h.03V32.5h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 46.99h.04v-3.22h-.04v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.88 46.99h.03v-3.22h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 46.99h.03v-3.22h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 58.26h.04v-3.23h-.04v3.23z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.88 58.26h.03v-3.23h-.03v3.23z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 58.26h.03v-3.23h-.03v3.23z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 69.52h.04V66.3h-.04v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.88 69.52h.03V66.3h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 69.52h.03V66.3h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.22 80.79h.04v-3.22h-.04v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.88 80.79h.03v-3.22h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 80.79h.03v-3.22h-.03v3.22z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.14 93.17h83.7v-.04h-83.7v.04z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Building104 = (Building104);
;// ./src/Picto/GeneratedPictoComponents/Building56.tsx


var Building56_excluded = ["className"];
function Building56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Building56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Building56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Building56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Building56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Building56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Building56_objectSpread(Building56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.05 16.96v32.62l3.76-.08-.19-.52c-.51-1.38-.79-2.84-.81-4.31l-.49-27.72h-2.26Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.62 49.85V17.37H29.69v32.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.69 22.46h11.85v-.01H29.69v.01z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.69 27.54h11.85v-.02H29.69v.02z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.69 32.62h11.85v-.02H29.69v.02z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.69 37.7h11.85v-.02H29.69v.02z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.69 42.78h11.85v-.02H29.69v.02z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.37 11.45v38.4l3.76-.09-.42-1.36c-.36-1.16-.55-2.36-.57-3.57l-.5-33.39H9.38Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.72 6.12.53 4.86.97.46-3.76.01V6.12h2.26z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.45 11.45h15.24V6.37H14.45v5.08z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.77 15.05v-3.6H9.37v38.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 19.65h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.52 19.65h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 19.65h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 25.57h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.52 25.57h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 25.57h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 31.5h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.52 31.5h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 31.5h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 37.42h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.52 37.42h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 37.42h.02v-1.69h-.02v1.69z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.44 43.35h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.52 43.35h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.6 43.35h.02v-1.7h-.02v1.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M5.99 49.86h44.02v-.02H5.99v.02z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Building56 = (Building56);
;// ./src/Picto/GeneratedPictoComponents/BusinessIdeas104.tsx


var BusinessIdeas104_excluded = ["className"];
function BusinessIdeas104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessIdeas104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessIdeas104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessIdeas104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessIdeas104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessIdeas104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessIdeas104_objectSpread(BusinessIdeas104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60 74.75v1.2a2.77 2.77 0 0 1-2.77 2.77H45.12c-2.19 0-3.97-1.78-3.97-3.97.01-.88.72-1.59 1.6-1.6h.84v1.91c.01.79.64 1.42 1.43 1.43h13.1c.79 0 1.44-.64 1.45-1.43v-1.53c.3.33.45.77.42 1.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.94 93.48H21.11c-2.67 0-4.83-1.56-4.83-3.53V66.11c.02 1.41.36 2.79 1.01 4.04.04.07.11.11.19.11h26.44c-.26.27-.4.64-.4 1.01v1.16H21.37c-.63.03-1.12.56-1.09 1.19.01.26.11.52.29.71 8.16 7.74 26.07 13.35 38.01 16.5 1.98.48 1.47 2.63-.65 2.63ZM87.98 70.38v1.77c0 .11-.08.19-.19.19H59.5v-1.16c0-.38-.14-.74-.4-1.01h28.61c.11-.03.23.03.26.14v.07Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.67 36.35H35.3a3.817 3.817 0 0 0-3.97 3.53v6.37h5.34v-3.24c0-1.05.85-1.91 1.91-1.91h19.34M87.22 72.42v19.34c0 .96-.78 1.74-1.74 1.74H18.42c-.95 0-1.72-.77-1.72-1.72V72.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.39 73.15h-24.8c-1.45 0-2.63-1.18-2.63-2.63V48.95c0-1.45 1.18-2.63 2.63-2.63h43.7M59.51 73.15h25.9c1.45 0 2.63-1.18 2.63-2.63V47.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "43.52",
        y: "69.73",
        width: "15.98",
        height: "6.81",
        rx: "2.75",
        ry: "2.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M65.82 37.69c1.46.3 1.29.24 1.64.06-1.71-1.17-4.59-2.45-4.58-7.16 0-2.23.43-4.17.98-5.76.33-.95-.95-1.63-1.53-.8-1.18 1.68-2.05 3.83-2.21 6.94-.08 1.61-.02 3.18.34 4.69-.09-.04-.14-.07-.14-.07.64 2.62 2.01 5.03 4.01 6.94 1.9 1.81 3.16 4.27 3.6 6.96.04.26.19.49.4.63.25.17.41.43.39.72l-.16 2.66c0 .4.72.83 1.12.83l.39.03c.46 1.49 1.13 2.2 1.82 2.55.64.32 1.32-.27 1.21-.98-.08-.52.06-1.09.56-1.61h-.41c-.28 0-.55-.13-.71-.36-.74-1.05-.44-2.34-.15-3.12.13-.34.45-.57.82-.57h6.05c.46 0 .85-.33.93-.79.45-2.67 1.75-5.14 3.76-7.12 1.5-1.48 2.58-3.32 3.28-5.28.25-.69-.43-1.35-1.13-1.1-8.98 3.21-15.89 2.76-20.29 1.71Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M87.75 35.36c-17.3 6.86-27.42.21-27.42.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M59.88 30.67c.61-6.69 5.86-12.08 12.48-12.82.55-.06 1.09-.09 1.64-.09 3.49 0 6.79 1.26 9.42 3.63 3 2.7 4.72 6.58 4.72 10.63s-1.51 7.49-4.27 10.19c-2.01 1.98-3.3 4.45-3.75 7.12-.08.46-.47.79-.93.79H68.78c-.46 0-.86-.34-.93-.79-.44-2.69-1.7-5.15-3.6-6.96-3.18-3.03-4.76-7.29-4.36-11.7Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M78.1 54.32h-8.46c-.62 0-1.12-.5-1.12-1.12v-2.81c0-.07.05-.12.12-.12h10.58c.12 0 .21.1.21.21v2.5c0 .74-.6 1.34-1.34 1.34Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M70.44 54.32c.26 1.68 1.7 2.98 3.46 2.98s3.2-1.29 3.46-2.98h-6.92Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m93.07 23.94-3.24 1.57m-5-11.05-2.17 2.87m-8.69-6.3v3.59M63.6 14.2l1.93 3.03m-10.41 4.91 3.11 1.81"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessIdeas104 = (BusinessIdeas104);
;// ./src/Picto/GeneratedPictoComponents/BusinessIdeas56.tsx


var BusinessIdeas56_excluded = ["className"];
function BusinessIdeas56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessIdeas56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessIdeas56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessIdeas56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessIdeas56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessIdeas56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessIdeas56_objectSpread(BusinessIdeas56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.13 40v.64c0 .81-.66 1.48-1.48 1.48h-6.46c-1.17 0-2.12-.95-2.12-2.12 0-.47.38-.85.85-.85h.45v1.02c0 .42.34.76.76.76h6.99c.42 0 .77-.34.77-.76v-.81c.16.18.24.41.22.65Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.03 49.99H11.38c-1.42 0-2.57-.83-2.57-1.88V35.39c0 .75.19 1.49.54 2.16.02.04.06.06.1.06h14.1a.78.78 0 0 0-.21.54v.62H11.53a.6.6 0 0 0-.58.64c0 .14.06.28.16.38 4.36 4.13 13.91 7.12 20.28 8.8 1.06.25.78 1.4-.35 1.4ZM47.05 37.67v.95a.1.1 0 0 1-.1.1H31.86v-.62c0-.2-.08-.39-.21-.54h15.26c.06-.02.12.02.14.08v.03Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.82 19.51H18.95c-1.1-.05-2.04.79-2.12 1.88v3.4h2.85v-1.73c0-.56.46-1.02 1.02-1.02h10.32M46.65 38.76v10.32c0 .51-.41.93-.93.93H9.94c-.51 0-.92-.41-.92-.92V38.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.26 39.14H10.03c-.78 0-1.4-.63-1.4-1.4V26.23c0-.78.63-1.4 1.4-1.4h23.31M31.86 39.14h13.82c.78 0 1.4-.63 1.4-1.4V25.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "23.33",
        y: "37.32",
        width: "8.53",
        height: "3.63",
        rx: "1.47",
        ry: "1.47"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.23 20.23c.78.16.69.13.87.03-.91-.62-2.45-1.31-2.45-3.82 0-1.19.23-2.23.52-3.07.18-.51-.51-.87-.81-.43-.63.9-1.09 2.05-1.18 3.7-.04.86-.01 1.7.18 2.5s-.07-.04-.07-.04a7.56 7.56 0 0 0 2.14 3.7c1.01.97 1.68 2.28 1.92 3.71.02.14.1.26.21.33.13.09.22.23.21.39l-.08 1.42c0 .21.39.44.6.44l.21.02c.25.8.6 1.18.97 1.36.34.17.71-.14.65-.52-.04-.28.03-.58.3-.86h-.22c-.15 0-.29-.07-.38-.19-.39-.56-.23-1.25-.08-1.67.07-.18.24-.3.44-.3h3.23c.25 0 .46-.18.5-.42.24-1.42.93-2.74 2-3.8.8-.79 1.38-1.77 1.75-2.82a.466.466 0 0 0-.6-.59c-4.79 1.71-8.48 1.47-10.82.91Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.93 18.99c-9.23 3.66-14.63.11-14.63.11"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M32.06 16.48c.32-3.57 3.13-6.44 6.66-6.84.29-.03.58-.05.87-.05 1.86 0 3.62.67 5.03 1.94 1.6 1.44 2.52 3.51 2.52 5.67s-.81 4-2.28 5.44a6.914 6.914 0 0 0-2 3.8c-.04.24-.25.42-.5.42h-5.55c-.25 0-.46-.18-.5-.42-.24-1.43-.91-2.75-1.92-3.71-1.69-1.61-2.54-3.89-2.33-6.24Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.78 29.1h-4.51c-.33 0-.6-.27-.6-.6V27s.03-.06.06-.06h5.64c.06 0 .11.05.11.11v1.33c0 .39-.32.71-.71.71Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M37.69 29.1c.14.9.91 1.59 1.84 1.59s1.71-.69 1.85-1.59h-3.69Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m49.77 12.89-1.73.84m-2.67-5.9-1.16 1.53M39.57 6v1.92m-5.53-.23 1.03 1.62m-5.56 2.62 1.66.97"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessIdeas56 = (BusinessIdeas56);
;// ./src/Picto/GeneratedPictoComponents/BusinessOperation104.tsx


var BusinessOperation104_excluded = ["className"];
function BusinessOperation104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessOperation104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessOperation104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessOperation104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessOperation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessOperation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessOperation104_objectSpread(BusinessOperation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.95 30.01c-2.89 28.6 17.81 20.65 17.12 32.01v4h-2.48c-.63-.04-1.11-.57-1.1-1.19V59.4c-2.46-.53-4.81-1.5-6.93-2.87l-3.85 3.85c-.46.46-1.21.46-1.67 0l-4.68-4.83c-.46-.46-.46-1.21 0-1.67l3.85-3.85a21.49 21.49 0 0 1-2.81-6.89h-5.41c-.65 0-1.17-.53-1.17-1.17v-6.66c0-.65.53-1.17 1.17-1.17h5.39c.35-1.52.75-2.99 1.33-4.39.19-.89 1.43-.62 1.24.27Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m16.74 21.39 4.81-4.77c.47-.46 1.22-.46 1.69 0l3.85 3.85c2.13-1.36 4.49-2.32 6.97-2.85v-4.83c-.01-.98.77-1.78 1.75-1.79h5.64c.99 0 1.79.8 1.79 1.79v4.96c2.47.55 4.82 1.52 6.95 2.89l3.85-3.85c.46-.47 1.22-.47 1.69 0l4.77 4.81c.47.46.47 1.22 0 1.69l-3.85 3.85c1.36 2.13 2.33 4.49 2.85 6.97h5.45c.66 0 1.19.53 1.19 1.19v6.79a1.21 1.21 0 0 1-1.21 1.19h-5.47c-.55 2.47-1.53 4.82-2.91 6.95l3.85 3.85c.46.47.46 1.22 0 1.69l-4.81 4.79c-.46.47-1.22.47-1.69 0l-3.85-3.85a21.153 21.153 0 0 1-6.97 2.85v5.45a1.21 1.21 0 0 1-1.21 1.19h-6.79c-.66 0-1.19-.53-1.19-1.19v-5.56c-2.47-.54-4.83-1.53-6.95-2.91l-3.85 3.85c-.47.46-1.22.46-1.69 0l-4.77-4.81c-.46-.47-.46-1.22 0-1.69l3.85-3.85c-1.35-2.14-2.31-4.5-2.85-6.97h-5.47a1.21 1.21 0 0 1-1.19-1.21v-6.77c-.01-.66.51-1.2 1.17-1.21h5.52c.54-2.47 1.52-4.82 2.89-6.95l-3.85-3.85c-.46-.47-.44-1.23.03-1.69Zm13.64 8.04c-5.02 4.53-5.42 12.27-.89 17.29s12.27 5.42 17.29.89 5.42-12.27.89-17.29c-.28-.31-.58-.61-.89-.89-4.66-4.19-11.73-4.19-16.4 0Z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M61.64 73.17c4.44 18.3 15.86 8.96 17.88 16.4l.87 2.58-1.62.5c-.41.1-.83-.13-.96-.54l-1.15-3.48c-1.7.18-3.42.05-5.08-.37l-1.67 3.29c-.2.4-.68.56-1.08.37l-4.1-2.06c-.4-.2-.56-.68-.37-1.08l1.65-3.27a14.362 14.362 0 0 1-3.31-3.85l-3.5 1.14a.786.786 0 0 1-1.01-.47v-.03l-1.42-4.35c-.15-.41.06-.86.47-1.01h.03l3.48-1.15c-.09-.87-.16-1.74-.15-2.61 0-.83.92-.86 1.06 0Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m56.56 67.96 2.08-4.14c.19-.4.68-.57 1.08-.37h.02l3.33 1.67c1.07-1.34 2.38-2.48 3.85-3.37l-1.04-3.14c-.21-.65.14-1.34.78-1.56l3.62-1.19c.64-.22 1.34.13 1.56.77l1.04 3.16c1.71-.2 3.45-.07 5.12.37l1.67-3.33c.21-.39.7-.55 1.1-.35l4.16 2.08c.4.2.55.69.35 1.09l-1.65 3.31a14.69 14.69 0 0 1 3.35 3.85l3.54-1.17c.42-.14.88.09 1.02.52L93 70.62c.14.43-.09.89-.52 1.04l-3.52 1.15c.18 1.72.05 3.46-.37 5.14l3.31 1.65c.4.21.56.71.37 1.12l-2.1 4.14c-.21.4-.69.56-1.1.37l-3.31-1.67a14.607 14.607 0 0 1-3.85 3.37l1.15 3.52c.15.42-.07.88-.49 1.03h-.03l-4.39 1.46a.829.829 0 0 1-1.04-.52l-1.17-3.48c-1.72.18-3.46.06-5.14-.37l-1.65 3.31c-.19.4-.68.57-1.08.37h-.02l-4.16-2.08a.837.837 0 0 1-.37-1.1l1.67-3.31a14.69 14.69 0 0 1-3.35-3.85l-3.5 1.06a.85.85 0 0 1-1.04-.52l-1.44-4.41c-.14-.42.08-.88.51-1.02.02 0 .03-.01.05-.02l3.52-1.15c-.19-1.72-.08-3.46.33-5.14l-3.31-1.67a.831.831 0 0 1-.4-1.1Zm10.6 2.25c-2.28 4.01-.87 9.11 3.14 11.39 4.01 2.28 9.11.87 11.39-3.14 2.28-4.01.87-9.11-3.14-11.39a8.353 8.353 0 0 0-11.38 3.14Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessOperation104 = (BusinessOperation104);
;// ./src/Picto/GeneratedPictoComponents/BusinessOperation56.tsx


var BusinessOperation56_excluded = ["className"];
function BusinessOperation56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessOperation56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessOperation56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessOperation56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessOperation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessOperation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessOperation56_objectSpread(BusinessOperation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M11.34 16.2c-1.55 15.35 9.56 11.08 9.19 17.18v2.15H19.2a.629.629 0 0 1-.59-.64v-2.91c-1.32-.29-2.58-.81-3.72-1.54l-2.07 2.07c-.25.25-.65.25-.9 0l-2.51-2.59a.634.634 0 0 1 0-.9l2.07-2.07c-.71-1.13-1.22-2.39-1.51-3.7h-2.9c-.35 0-.63-.28-.63-.63v-3.57c0-.35.28-.63.63-.63H9.96c.19-.82.4-1.61.71-2.36.1-.48.77-.33.67.14Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m9.08 11.58 2.58-2.56c.25-.25.66-.25.91 0l2.07 2.07c1.15-.73 2.41-1.24 3.74-1.53V6.97c0-.52.41-.95.94-.96h3.02c.53 0 .96.43.96.96v2.66c1.32.29 2.59.82 3.73 1.55l2.07-2.07c.25-.25.65-.25.91 0l2.56 2.58c.25.25.25.65 0 .91l-2.07 2.07c.73 1.14 1.25 2.41 1.53 3.74h2.92c.35 0 .64.29.64.64v3.65c0 .36-.3.64-.65.64h-2.93c-.29 1.33-.82 2.59-1.56 3.73l2.07 2.07c.25.25.25.66 0 .91l-2.58 2.57c-.25.25-.65.25-.91 0l-2.07-2.07c-1.14.73-2.41 1.25-3.74 1.53V35c0 .36-.3.64-.65.64h-3.65c-.35 0-.64-.29-.64-.64v-2.98c-1.33-.29-2.59-.82-3.73-1.56l-2.07 2.07c-.25.25-.66.25-.91 0l-2.56-2.58a.646.646 0 0 1 0-.91l2.07-2.07c-.72-1.15-1.24-2.41-1.53-3.74H6.62c-.36 0-.64-.3-.64-.65v-3.63c0-.35.28-.64.63-.65h2.96c.29-1.32.82-2.59 1.55-3.73L9.05 12.5a.637.637 0 0 1 .02-.91Zm7.32 4.32a6.575 6.575 0 0 0-.48 9.28 6.575 6.575 0 0 0 9.28.48 6.575 6.575 0 0 0 0-9.76 6.58 6.58 0 0 0-8.8 0Z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.17 39.36c2.38 9.82 8.51 4.81 9.59 8.8l.46 1.38-.87.27a.44.44 0 0 1-.52-.29l-.62-1.87c-.91.09-1.84.03-2.73-.2l-.9 1.77c-.11.21-.36.3-.58.2l-2.2-1.1a.443.443 0 0 1-.2-.58l.89-1.76a7.85 7.85 0 0 1-1.78-2.07l-1.88.61a.419.419 0 0 1-.54-.25v-.01l-.76-2.33c-.08-.22.03-.46.25-.54h.01l1.87-.62c-.05-.47-.09-.93-.08-1.4 0-.45.49-.46.57 0Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m30.45 36.56 1.12-2.22c.1-.22.36-.31.58-.2l1.79.9c.58-.72 1.27-1.33 2.07-1.81l-.56-1.68c-.11-.35.07-.72.42-.84l1.94-.64c.34-.12.72.07.84.41l.56 1.69c.92-.1 1.85-.04 2.75.2l.9-1.79c.11-.21.37-.29.59-.19l2.23 1.12c.21.11.3.37.19.58l-.89 1.78c.71.58 1.32 1.28 1.8 2.07l1.9-.63c.23-.07.47.05.55.28l.78 2.4c.08.23-.05.48-.28.56l-1.89.62c.09.92.03 1.86-.2 2.76l1.78.89c.22.11.3.38.2.6l-1.13 2.22c-.11.21-.37.3-.59.2l-1.78-.9c-.58.72-1.27 1.33-2.07 1.81l.62 1.89c.08.23-.04.47-.27.55h-.01l-2.35.78a.444.444 0 0 1-.56-.28l-.63-1.87c-.92.1-1.86.03-2.76-.2l-.89 1.78c-.1.22-.36.31-.58.2l-2.23-1.12a.455.455 0 0 1-.2-.59l.9-1.78a8.114 8.114 0 0 1-1.8-2.07l-1.88.57a.457.457 0 0 1-.56-.28l-.77-2.36c-.08-.23.05-.47.27-.55h.03l1.89-.62c-.1-.92-.04-1.86.18-2.76l-1.78-.9a.45.45 0 0 1-.22-.59Zm5.69 1.21a4.484 4.484 0 0 0 1.68 6.11c2.15 1.22 4.89.47 6.11-1.68 1.22-2.15.47-4.89-1.68-6.11-.13-.08-.27-.14-.41-.21-2.1-.92-4.57-.11-5.7 1.89Z",
      className: "strokesecondary"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessOperation56 = (BusinessOperation56);
;// ./src/Picto/GeneratedPictoComponents/BusinessSoftware104.tsx


var BusinessSoftware104_excluded = ["className"];
function BusinessSoftware104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessSoftware104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessSoftware104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessSoftware104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessSoftware104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessSoftware104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessSoftware104_objectSpread(BusinessSoftware104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.02 63.86-.97 2.22-1.38-.6a.706.706 0 0 1-.32-.93l1.31-3.01c-1.24-.89-2.3-2-3.15-3.26l-3.06 1.2a.728.728 0 0 1-.93-.4l-1.42-3.81c-.14-.37.04-.78.4-.93l3.06-1.2c-.23-1.49-.19-3.02.11-4.5l-3-1.31a.712.712 0 0 1-.37-.93l1.61-3.69c.16-.36.57-.52.93-.37h.01l2.98 1.3c.89-1.2 1.98-2.23 3.23-3.05-10.13 16.5 4.16 16.94.94 23.26ZM46.77 58.81l-.14 1.64-1.02-.11a.486.486 0 0 1-.4-.53l.2-2.21c-.99-.31-1.91-.8-2.73-1.43l-1.72 1.42c-.21.17-.51.15-.69-.06L38.5 55.4a.491.491 0 0 1 .06-.69l1.71-1.41c-.47-.92-.78-1.91-.9-2.93l-2.22-.22a.488.488 0 0 1-.45-.51v-.02l.26-2.75c.02-.26.24-.46.51-.45h.02l2.21.2c.31-.98.8-1.9 1.44-2.71-3 12.92 6.35 10.09 5.64 14.9Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m71.02 36.19 3.82-1.48c.37-.14.79.04.94.41l1.2 3.06c1.51-.24 3.05-.2 4.55.1l1.17-2.68c.23-.54.86-.8 1.4-.57h.02l3.1 1.35c.55.24.8.88.56 1.42l-1.2 2.75c1.24.9 2.3 2.01 3.15 3.28l3.06-1.2c.37-.15.79.03.94.4l1.48 3.82c.15.37-.03.79-.4.94l-3.06 1.2c.24 1.51.21 3.05-.1 4.55l3.02 1.32c.37.16.53.58.37.95l-1.64 3.77c-.17.36-.59.53-.96.37l-3.03-1.32c-.9 1.24-2.01 2.3-3.29 3.15l1.2 3.06c.14.37-.04.79-.41.94l-3.82 1.49a.722.722 0 0 1-.94-.4l-1.2-3.06c-1.51.24-3.05.2-4.55-.1l-1.32 3.02c-.17.36-.59.53-.96.37l-3.77-1.64c-.37-.16-.53-.58-.37-.95v-.01l1.34-3.07c-1.24-.9-2.31-2.01-3.15-3.29l-3.06 1.2a.735.735 0 0 1-.94-.41l-1.48-3.82c-.14-.37.04-.79.41-.94l3.06-1.2c-.23-1.51-.2-3.05.1-4.55l-3.03-1.32a.738.738 0 0 1-.37-.96l1.64-3.75a.72.72 0 0 1 .94-.39h.01l3.05 1.33c.9-1.24 2.01-2.3 3.28-3.15l-1.2-3.06c-.14-.37.05-.79.43-.93Zm5.62 7.75a7.398 7.398 0 0 0-4.67 9.37 7.398 7.398 0 0 0 9.37 4.67 7.398 7.398 0 0 0 4.39-10.08 7.41 7.41 0 0 0-9.09-3.96ZM39.27 41.28l2.15-1.79a.49.49 0 0 1 .69.05l1.44 1.73c.92-.49 1.92-.8 2.95-.94l.18-1.99c.04-.41.4-.71.81-.67l2.29.21c.41.04.71.39.68.8l-.19 2c1 .31 1.93.79 2.75 1.44l1.73-1.44a.5.5 0 0 1 .69.07l1.8 2.16c.17.21.14.52-.07.69l-1.72 1.43c.48.92.79 1.91.93 2.94l2.25.2c.27.03.47.26.44.53l-.27 2.83c-.03.27-.27.47-.54.45l-2.23-.21c-.32 1-.81 1.93-1.44 2.76l1.43 1.72c.17.22.14.53-.07.71l-2.16 1.79c-.21.17-.52.14-.7-.06l-1.43-1.73c-.92.49-1.92.8-2.95.94l-.21 2.23c-.02.27-.25.47-.52.45h-.02l-2.79-.25a.508.508 0 0 1-.45-.54l.19-2.21c-1-.31-1.93-.8-2.76-1.44l-1.72 1.43a.49.49 0 0 1-.69-.05l-1.8-2.16a.513.513 0 0 1 .06-.7l1.73-1.43c-.48-.92-.79-1.91-.93-2.94l-2.2-.26a.508.508 0 0 1-.45-.54l.26-2.79c.02-.27.26-.47.53-.44h.03l2.23.21c.31-1 .79-1.93 1.42-2.77l-1.43-1.73a.514.514 0 0 1 .04-.71Zm5.33 3.81a5.054 5.054 0 0 0-1.01 7.07 5.054 5.054 0 0 0 7.07 1.01 5.054 5.054 0 0 0 1.01-7.07 5.046 5.046 0 0 0-7.07-1.01Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.06 30.25v43.46H56c.25-1.89-1.31-3.42-4.68-4.57-5.04-1.73-19.84-9.16-25.61-22.63-5.77-13.47-4.6-17.97-7.56-18.84-.22-.06-.43-.12-.64-.17-1.77-.43-3.46.95-3.46 2.75Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.32 77.58H45.68M90 70.75v3.04M14.4 73.79V26.98c0-1.61 1.31-2.91 2.91-2.91h69.77c1.61 0 2.91 1.31 2.91 2.91v3.84M11 74.43h82c1.1 0 2 .9 2 2v1.15a3.15 3.15 0 0 1-3.15 3.15h-79.7A3.15 3.15 0 0 1 9 77.58v-1.15c0-1.1.9-2 2-2Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "28.27",
      rx: "1.05",
      ry: "1.06",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessSoftware104 = (BusinessSoftware104);
;// ./src/Picto/GeneratedPictoComponents/BusinessSoftware56.tsx


var BusinessSoftware56_excluded = ["className"];
function BusinessSoftware56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessSoftware56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessSoftware56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessSoftware56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessSoftware56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessSoftware56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessSoftware56_objectSpread(BusinessSoftware56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m38.79 33.35-.48 1.1-.68-.3a.35.35 0 0 1-.16-.46l.65-1.49c-.61-.44-1.14-.99-1.55-1.61l-1.51.59a.358.358 0 0 1-.46-.2l-.7-1.88c-.07-.18.02-.39.2-.46l1.51-.59c-.11-.74-.09-1.49.05-2.22l-1.48-.65c-.18-.08-.26-.28-.18-.46l.79-1.82c.08-.18.28-.26.46-.18l1.47.64c.44-.59.98-1.1 1.6-1.51-5 8.15 2.06 8.37.47 11.49ZM25.82 30.86l-.07.81-.5-.06a.24.24 0 0 1-.2-.26l.1-1.09a4.37 4.37 0 0 1-1.35-.71l-.85.7c-.1.09-.25.07-.34-.03l-.88-1.05c-.09-.1-.07-.25.03-.34l.84-.7c-.23-.45-.39-.94-.45-1.45l-1.09-.11c-.13 0-.23-.12-.22-.25l.13-1.36c0-.13.12-.23.25-.22l1.09.1c.15-.49.39-.94.71-1.34-1.48 6.38 3.14 4.99 2.79 7.36Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37.8 19.68 1.89-.73c.18-.07.39.02.46.2l.59 1.51a6.3 6.3 0 0 1 2.25.05l.58-1.32c.11-.27.42-.39.69-.28h.01l1.53.67c.27.12.39.43.28.7l-.59 1.36c.61.44 1.14.99 1.56 1.62l1.51-.59c.18-.07.39.02.46.2l.73 1.89c.07.18-.02.39-.2.46l-1.51.59c.12.75.1 1.51-.05 2.25l1.49.65c.18.08.26.29.18.47l-.81 1.86c-.08.18-.29.26-.47.18l-1.5-.65a6.21 6.21 0 0 1-1.63 1.56l.59 1.51c.07.18-.02.39-.2.46l-1.89.74a.358.358 0 0 1-.46-.2l-.59-1.51a6.3 6.3 0 0 1-2.25-.05l-.65 1.49c-.08.18-.29.26-.47.18l-1.86-.81c-.18-.08-.26-.29-.18-.47l.66-1.52a6.21 6.21 0 0 1-1.56-1.63l-1.51.59a.358.358 0 0 1-.46-.2l-.73-1.89c-.07-.18.02-.39.2-.46l1.51-.59c-.11-.75-.1-1.51.05-2.25l-1.5-.65c-.18-.08-.26-.29-.18-.47l.81-1.86c.08-.18.28-.27.47-.19l1.51.66c.44-.61.99-1.14 1.62-1.56l-.59-1.51c-.07-.18.03-.39.21-.46Zm2.78 3.83a3.655 3.655 0 0 0-2.31 4.63 3.655 3.655 0 0 0 4.63 2.31 3.655 3.655 0 0 0 2.17-4.98 3.67 3.67 0 0 0-4.49-1.96ZM22.12 22.2l1.06-.88c.1-.09.25-.07.34.03l.71.86c.45-.24.95-.4 1.46-.46l.09-.98c.02-.2.2-.35.4-.33l1.13.11c.2.02.35.19.33.4l-.09.99c.49.15.95.39 1.36.71l.86-.71c.11-.08.26-.07.34.04l.89 1.07c.08.1.07.26-.03.34l-.85.71c.24.45.39.95.46 1.45l1.11.1c.13.01.23.13.22.26l-.13 1.4c-.01.13-.13.23-.27.22l-1.1-.1c-.16.49-.4.95-.71 1.36l.71.85c.08.11.07.26-.03.35l-1.07.88c-.1.08-.26.07-.34-.03l-.71-.85c-.45.24-.95.4-1.46.46l-.1 1.1c0 .13-.13.23-.26.22l-1.38-.12a.248.248 0 0 1-.22-.27l.09-1.09c-.49-.15-.96-.4-1.36-.71l-.85.71c-.1.09-.25.07-.34-.03l-.89-1.07c-.08-.1-.07-.26.03-.34l.85-.71c-.24-.45-.39-.95-.46-1.45l-1.09-.13a.254.254 0 0 1-.22-.27l.13-1.38c.01-.13.13-.23.26-.22h.02l1.1.1c.15-.49.39-.96.7-1.37l-.71-.85c-.09-.1-.08-.26.02-.35Zm2.64 1.88c-1.1.83-1.33 2.39-.5 3.49.83 1.1 2.39 1.33 3.49.5 1.1-.83 1.33-2.39.5-3.49-.05-.07-.11-.13-.16-.2a2.493 2.493 0 0 0-3.33-.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M8.59 16.69v22.24h21.46c.13-.97-.67-1.75-2.39-2.34-2.58-.89-10.15-4.69-13.1-11.58-2.95-6.89-2.35-9.2-3.87-9.64l-.33-.09c-.9-.22-1.77.49-1.77 1.41Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.24 40.93h-6.48M7.56 39.4h40.93c.55 0 1 .45 1 1v.31c0 .99-.81 1.8-1.8 1.8H8.36c-.99 0-1.8-.81-1.8-1.8v-.31c0-.55.45-1 1-1ZM47.45 36.84v2.4M8.75 39.24V14.78c0-.73.6-1.33 1.33-1.33h36.03c.73 0 1.33.6 1.33 1.33v2.47"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "28",
      cy: "15.86",
      rx: ".52",
      ry: ".53",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessSoftware56 = (BusinessSoftware56);
;// ./src/Picto/GeneratedPictoComponents/BusinessStrategy104.tsx


var BusinessStrategy104_excluded = ["className"];
function BusinessStrategy104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessStrategy104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessStrategy104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessStrategy104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessStrategy104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessStrategy104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessStrategy104_objectSpread(BusinessStrategy104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M79.47 65.18s3.23.58 2.04 2.53-11.55 11.51-11.72 13.3c-.17 1.78 2.51 5.27 2.51 5.27l-4.76 5.27L59 92.82l1.45-7.54 3.86-5.38 15.16-14.72Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M95.93 55.82c1.93 1.93 2.24 3.73 2.11 4.73L69.86 88.72c-4.44 4.44-11.04 4.06-11.04 4.06s-.37-6.6 4.06-11.04l28.18-28.18c1-.12 2.81.19 4.73 2.11l.13.13Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m87.48 58.16 6.64 6.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.15 82.51 6.23 6.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.95 26H73.86C72.28 26 71 24.48 71 22.61V10c0-.55-.45-1-1-1s-1 .45-1 1v12.61c0 2.97 2.18 5.39 4.86 5.39h10.09c.55 0 1-.45 1-1s-.45-1-1-1ZM19.04 60.45l1.15 26.68c0 3.09 2.51 5.6 5.6 5.6h25.17c2.04 0 2.61-2.79.73-3.58-10.53-4.43-24.81-12.09-29.22-27.58-1.02-4.07-3.45-1.78-3.43-1.11Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.05 50.23c-5.25-1.95-8.3-6.9-9.41-11.5-.23-.94-1.52-.97-1.8-.04-.5 1.65-.67 4.11.59 7.39 1.63 4.21 6.75 5.83 10.27 5.96 1.07.04 1.35-1.43.35-1.81Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M29.19 65.02h43.33M29.19 78.12h30.33M70.97 9.95v11.43c0 2.33 1.76 4.21 3.94 4.21h10.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M85.22 52.27V24.93c0-.52-.19-1.02-.54-1.4L72.07 9.81c-.37-.4-.89-.63-1.43-.63H23.78c-2.17 0-3.94 1.82-3.94 4.06v75.38c0 2.23 1.77 4.06 3.94 4.06h29.6M72.12 92.68h9.16c2.16 0 3.94-1.83 3.94-4.06v-9.18M48.06 92.68h.62"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.89",
        cy: "40.18",
        r: "12.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.93 41 3.43 3.43 7.6-7.61"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessStrategy104 = (BusinessStrategy104);
;// ./src/Picto/GeneratedPictoComponents/BusinessStrategy56.tsx


var BusinessStrategy56_excluded = ["className"];
function BusinessStrategy56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function BusinessStrategy56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? BusinessStrategy56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : BusinessStrategy56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function BusinessStrategy56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, BusinessStrategy56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", BusinessStrategy56_objectSpread(BusinessStrategy56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.26 36.71s1.49.26.94 1.15-5.31 5.24-5.39 6.06 1.15 2.4 1.15 2.4l-2.19 2.4-3.93.58.67-3.43 1.77-2.45 6.97-6.7Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.83 30.24c1 1 1.16 1.93 1.09 2.45L37.33 47.28c-2.3 2.3-5.71 2.1-5.71 2.1s-.19-3.42 2.1-5.71l14.59-14.59c.52-.06 1.45.1 2.45 1.09l.07.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.45 31.45 3.44 3.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m33.85 44.06 3.23 3.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.01 32.64.59 13.81c0 1.6 1.3 2.9 2.9 2.9h13.03c1.06 0 1.35-1.45.38-1.86-5.45-2.3-12.85-6.26-15.13-14.28-.53-2.11-1.79-.92-1.77-.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.41 27.34c-2.72-1.01-4.3-3.57-4.87-5.95a.48.48 0 0 0-.93-.02c-.26.86-.35 2.13.31 3.83.84 2.18 3.49 3.02 5.32 3.08.56.02.7-.74.18-.94Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.27 35h22.44M16.27 41.78h15.7M37.9 6.49v5.92c0 1.2.91 2.18 2.04 2.18h5.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.28 28.4V14.24c0-.27-.1-.53-.28-.72l-6.53-7.1a1 1 0 0 0-.74-.33H13.47c-1.13 0-2.04.94-2.04 2.1v39.03c0 1.16.92 2.1 2.04 2.1H28.8M38.5 49.32h4.75c1.12 0 2.04-.95 2.04-2.1v-4.76M26.04 49.32h.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.85",
        cy: "22.14",
        r: "6.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.76 22.57 1.77 1.77 3.94-3.94"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_BusinessStrategy56 = (BusinessStrategy56);
;// ./src/Picto/GeneratedPictoComponents/Store104.tsx


var Store104_excluded = ["className"];
function Store104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Store104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Store104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Store104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Store104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Store104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Store104_objectSpread(Store104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M23.33 59.32s1.2-1.72 2.03-.16.26 20.76 8.45 25.67 10.02 5.32 10.02 5.32l.62 3.79H22.54l.79-34.62Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.54 93.93V53.76h21.91v40.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.55 73.56h21.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.95 69.83v7.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m24.07 14.85-1.45 20.19v.46c.03 3.32 2.75 5.99 6.09 5.99s6.05-2.67 6.09-5.99v-.46l1.22-20.19H24.08Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.93 14.84 1.49 20.19v.46c0 3.34-2.73 6.05-6.09 6.05s-6.09-2.71-6.09-6.05v-.46l-1.22-20.19h11.91Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.9 14.84v20.64c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05V14.9l-12.17-.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.94 41.14v52.85M14.03 94V41.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.77 53.82h31.65v28H51.77z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.73 67.58h31.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.94 10h25.48a3.64 3.64 0 0 1 3.65 3.63v1.21H12.85v-1.21c0-2.01 1.64-3.63 3.65-3.63h47.44Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.42 14.85H12.81l-2.43 20.58c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c-.03 3.34 2.68 6.07 6.04 6.1s6.11-2.66 6.14-6c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05a6.044 6.044 0 0 0 3.01 5.26c1.88 1.09 4.2 1.11 6.09.04s3.06-3.06 3.07-5.22c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05L93.2 15.03l-9.74-.17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.38 93.99h85.21"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Store104 = (Store104);
;// ./src/Picto/GeneratedPictoComponents/Store56.tsx


var Store56_excluded = ["className"];
function Store56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Store56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Store56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Store56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Store56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Store56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Store56_objectSpread(Store56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M11.46 32.07s.63-.91 1.07-.08.14 10.97 4.46 13.56c4.33 2.59 5.29 2.81 5.29 2.81l.33 2H11.04l.42-18.29Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.27 50V29.01h11.45V50"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.28 39.36h11.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.57 37.41v3.82"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.4 8.15-.77 10.72v.24a3.225 3.225 0 0 0 3.23 3.18c1.77 0 3.21-1.42 3.23-3.18v-.24l.65-10.72H12.4Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.11 8.15.79 10.72v.24c0 1.77-1.45 3.21-3.23 3.21s-3.23-1.44-3.23-3.21v-.24l-.65-10.72h6.32Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.52 8.15V19.1c0 1.77 1.45 3.21 3.23 3.21s3.23-1.44 3.23-3.21V8.18l-6.46-.03Z"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.88 22.18v28.35M7.08 50.53V22.3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.33 28.98h16.98V44H27.33z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.31 36.36h16.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.86 5.47h13.67c1.08 0 1.96.87 1.96 1.95v.65H6.45v-.65c0-1.08.88-1.95 1.96-1.95h25.45Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M44.31 8.07H6.43L5.12 19.11c0 1.79 1.46 3.25 3.27 3.25s3.27-1.45 3.27-3.25c-.01 1.79 1.44 3.26 3.24 3.27s3.28-1.43 3.29-3.22c0 1.79 1.46 3.25 3.27 3.25s3.27-1.45 3.27-3.25c0 1.16.61 2.24 1.62 2.82 1.01.59 2.25.59 3.27.02s1.64-1.64 1.65-2.8c0 1.79 1.46 3.25 3.27 3.25s3.27-1.45 3.27-3.25c0 1.79 1.46 3.25 3.27 3.25s3.27-1.45 3.27-3.25a3.26 3.26 0 0 0 3.27 3.25c1.8 0 3.27-1.45 3.27-3.25L49.58 8.16l-5.22-.09Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.12 50.53h45.72"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Store56 = (Store56);
;// ./src/Picto/GeneratedPictoComponents/StoreAddress104.tsx


var StoreAddress104_excluded = ["className"];
function StoreAddress104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreAddress104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreAddress104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreAddress104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreAddress104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreAddress104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreAddress104_objectSpread(StoreAddress104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.07 14.85-1.45 20.19v.46c.03 3.32 2.75 5.99 6.09 5.99s6.05-2.67 6.09-5.99v-.46l1.22-20.19H24.08Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m81.93 14.84 1.49 20.19v.46c0 3.34-2.73 6.05-6.09 6.05s-6.09-2.71-6.09-6.05v-.46l-1.22-20.19h11.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.9 14.84v20.64c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05V14.9l-12.17-.06Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.33 59.32s1.2-1.72 2.03-.16.26 20.76 8.45 25.67 10.02 5.32 10.02 5.32l.62 3.79H22.54l.79-34.62Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.94 41.14V57M14.03 94V41.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.42 56v-2.18H51.77v28h15.27"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.73 67.58H67"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.94 10h25.48a3.64 3.64 0 0 1 3.65 3.63v1.21H12.85v-1.21c0-2.01 1.64-3.63 3.65-3.63h47.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.42 14.85H12.81l-2.43 20.58c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c-.03 3.34 2.68 6.07 6.04 6.1s6.11-2.66 6.14-6c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05a6.044 6.044 0 0 0 3.01 5.26c1.88 1.09 4.2 1.11 6.09.04s3.06-3.06 3.07-5.22c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05L93.2 15.03l-9.74-.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.38 93.99H75"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.54 93.93V53.76h21.91v40.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.55 73.56h21.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.95 69.83v7.3"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.7 93.49-8.98-14.04a12.533 12.533 0 0 1-.85-12.56c1.13-2.28 2.9-4.12 5.04-5.34.83-.47 1.68.15.95 1.32 0 0 .48-1.63-1.78 3.33s-2.52 7.84-1.48 10.71 8.45 14.29 8.02 15.93.17 1.48.17 1.48l-1.08-.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.81 61.55c.82-.47 1.66.15.93 1.3 0 0-.16.27-1.76 3.28"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.61 93.09a1.505 1.505 0 0 0 2.74 0l8.87-13.82a12.345 12.345 0 0 0-2.08-16.17c-4.66-4.1-11.64-4.1-16.3 0a12.345 12.345 0 0 0-2.08 16.17l8.84 13.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "83.02",
        cy: "72.36",
        r: "5.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreAddress104 = (StoreAddress104);
;// ./src/Picto/GeneratedPictoComponents/StoreAddress56.tsx


var StoreAddress56_excluded = ["className"];
function StoreAddress56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreAddress56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreAddress56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreAddress56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreAddress56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreAddress56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreAddress56_objectSpread(StoreAddress56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.1 49.69-4.65-7.27a6.496 6.496 0 0 1 2.17-9.27c.43-.24.87.08.49.68l-.92 1.72c-1.33 2.49-1.31 4.06-.77 5.54s4.38 7.4 4.15 8.25.09.77.09.77l-.56-.43Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.68 49.53c.13.28.41.46.71.46s.59-.18.71-.46l4.61-7.19a6.418 6.418 0 0 0-9.56-8.41 6.418 6.418 0 0 0-1.08 8.41l4.6 7.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.41",
        cy: "38.76",
        r: "2.75"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.15 8.69 12.4 19v.23c.02 1.69 1.42 3.06 3.15 3.06s3.14-1.36 3.15-3.06V19l.63-10.31h-6.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.13 8.68.77 10.31v.23c0 1.71-1.41 3.09-3.15 3.09s-3.15-1.38-3.15-3.09v-.23l-.63-10.31h6.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.98 8.68V19.21c0 1.71 1.41 3.09 3.15 3.09s3.15-1.38 3.15-3.09V8.7l-6.31-.03Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 32.07s.63-.91 1.07-.08.14 10.97 4.46 13.56c4.33 2.59 5.29 2.81 5.29 2.81l.33 2H11.69l.42-18.29Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.4 22.29v8.31M7.59 49.98V22.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.93 30.07v-1.14H27.36V43.6h8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.34 36.14h7.99"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.73 5.98h13.35c1.06 0 1.91.85 1.91 1.9v.63H6.97v-.63c0-1.05.86-1.9 1.91-1.9h24.85Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.93 8.52H6.95L5.67 19.3c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c-.01 1.75 1.4 3.18 3.16 3.2s3.2-1.39 3.21-3.14c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.13.59 2.18 1.58 2.75.98.57 2.2.58 3.19.02s1.6-1.6 1.61-2.74c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17L49.04 8.61l-5.1-.09Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.68 49.97h33.84"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 49.94V28.9h11.47v21.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 39.27h11.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.35 37.32v3.82"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreAddress56 = (StoreAddress56);
;// ./src/Picto/GeneratedPictoComponents/StoreClock104.tsx


var StoreClock104_excluded = ["className"];
function StoreClock104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreClock104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreClock104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreClock104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreClock104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreClock104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreClock104_objectSpread(StoreClock104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.14 72.54c-.28 4.69.46 13.43 8.54 19.1.68.47.17 1.55-.62 1.34-3.16-.82-7.47-2.95-9.56-8.46 0 0-2.54-6.46.22-12.36.35-.74 1.47-.43 1.42.38Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "80.71",
        cy: "79",
        r: "14.88",
        className: "strokesecondary"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.04 69.55v10.9h7.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.07 14.85-1.45 20.19v.46c.03 3.32 2.75 5.99 6.09 5.99s6.05-2.67 6.09-5.99v-.46l1.22-20.19H24.08Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m81.93 14.84 1.49 20.19v.46c0 3.34-2.73 6.05-6.09 6.05s-6.09-2.71-6.09-6.05v-.46l-1.22-20.19h11.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.9 14.84v20.64c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05V14.9l-12.17-.06Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.33 59.32s1.2-1.72 2.03-.16.26 20.76 8.45 25.67 10.02 5.32 10.02 5.32l.62 3.79H22.54l.79-34.62Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M91.94 41.14V61M14.03 94V41.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.42 59.36v-5.54H51.77v28h9.74"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M51.73 67.58H64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M63.94 10h25.48a3.64 3.64 0 0 1 3.65 3.63v1.21H12.85v-1.21c0-2.01 1.64-3.63 3.65-3.63h47.44Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M83.42 14.85H12.81l-2.43 20.58c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c-.03 3.34 2.68 6.07 6.04 6.1s6.11-2.66 6.14-6c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05a6.044 6.044 0 0 0 3.01 5.26c1.88 1.09 4.2 1.11 6.09.04s3.06-3.06 3.07-5.22c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05L93.2 15.03l-9.74-.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M10.38 93.99h55.44"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.54 93.93V53.76h21.91v40.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.55 73.56h21.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.95 69.83v7.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreClock104 = (StoreClock104);
;// ./src/Picto/GeneratedPictoComponents/StoreClock56.tsx


var StoreClock56_excluded = ["className"];
function StoreClock56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreClock56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreClock56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreClock56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreClock56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreClock56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreClock56_objectSpread(StoreClock56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.24 37.69c-.16 2.76.27 7.9 5.03 11.24.4.28.1.91-.37.79-1.86-.48-4.4-1.73-5.63-4.98 0 0-1.5-3.8.13-7.27.2-.44.87-.26.84.23Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.77",
        cy: "41.46",
        r: "8.54",
        className: "strokesecondary"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.86 36.3v5.86h4.28"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.15 8.69 12.4 19v.23c.02 1.69 1.42 3.06 3.15 3.06s3.14-1.36 3.15-3.06V19l.63-10.31h-6.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.13 8.68.77 10.31v.23c0 1.71-1.41 3.09-3.15 3.09s-3.15-1.38-3.15-3.09v-.23l-.63-10.31h6.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.98 8.68V19.21c0 1.71 1.41 3.09 3.15 3.09s3.15-1.38 3.15-3.09V8.7l-6.31-.03Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 32.07s.63-.91 1.07-.08.14 10.97 4.46 13.56 5.29 2.81 5.29 2.81l.33 2H11.69l.42-18.29Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M48.4 22.29V32M7.59 49.98V22.41"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.93 31v-2.07H27.36V43.6H31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.34 36.14h4.65"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.73 5.98h13.35c1.06 0 1.91.85 1.91 1.9v.63H6.97v-.63c0-1.05.86-1.9 1.91-1.9h24.85Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.93 8.52H6.95L5.67 19.3c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c-.01 1.75 1.4 3.18 3.16 3.2s3.2-1.39 3.21-3.14c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.13.59 2.18 1.58 2.75.98.57 2.2.58 3.19.02s1.6-1.6 1.61-2.74c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17L49.04 8.61l-5.1-.09Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.68 49.97h27.8"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 49.94V28.9h11.47v21.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 39.27h11.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.35 37.32v3.82"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreClock56 = (StoreClock56);
;// ./src/Picto/GeneratedPictoComponents/StoreSuccess104.tsx


var StoreSuccess104_excluded = ["className"];
function StoreSuccess104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreSuccess104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreSuccess104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreSuccess104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreSuccess104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreSuccess104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreSuccess104_objectSpread(StoreSuccess104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.14 72.54c-.28 4.69.46 13.43 8.54 19.1.68.47.17 1.55-.62 1.34-3.16-.82-7.47-2.95-9.56-8.46 0 0-2.54-6.46.22-12.36.35-.74 1.47-.43 1.42.38Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "80.71",
          cy: "79",
          r: "14.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m73.26 79.53 4.61 4.61 10.28-10.28"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m24.07 14.85-1.45 20.19v.46c.03 3.32 2.75 5.99 6.09 5.99s6.05-2.67 6.09-5.99v-.46l1.22-20.19H24.08Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m81.93 14.84 1.49 20.19v.46c0 3.34-2.73 6.05-6.09 6.05s-6.09-2.71-6.09-6.05v-.46l-1.22-20.19h11.91Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.9 14.84v20.64c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05V14.9l-12.17-.06Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.33 59.32s1.2-1.72 2.03-.16.26 20.76 8.45 25.67 10.02 5.32 10.02 5.32l.62 3.79H22.54l.79-34.62Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.94 41.14V61M14.03 94V41.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.42 59.36v-5.54H51.77v28h9.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.73 67.58H64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.94 10h25.48a3.64 3.64 0 0 1 3.65 3.63v1.21H12.85v-1.21c0-2.01 1.64-3.63 3.65-3.63h47.44Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.42 14.85H12.81l-2.43 20.58c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c-.03 3.34 2.68 6.07 6.04 6.1s6.11-2.66 6.14-6c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05a6.044 6.044 0 0 0 3.01 5.26c1.88 1.09 4.2 1.11 6.09.04s3.06-3.06 3.07-5.22c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05c0 3.34 2.73 6.05 6.09 6.05s6.09-2.71 6.09-6.05L93.2 15.03l-9.74-.17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.38 93.99h55.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.54 93.93V53.76h21.91v40.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.55 73.56h21.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.95 69.83v7.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreSuccess104 = (StoreSuccess104);
;// ./src/Picto/GeneratedPictoComponents/StoreSuccess56.tsx


var StoreSuccess56_excluded = ["className"];
function StoreSuccess56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function StoreSuccess56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? StoreSuccess56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : StoreSuccess56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function StoreSuccess56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, StoreSuccess56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", StoreSuccess56_objectSpread(StoreSuccess56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.24 37.69c-.16 2.76.27 7.9 5.03 11.24.4.28.1.91-.37.79-1.86-.48-4.4-1.73-5.63-4.98 0 0-1.5-3.8.13-7.27.2-.44.87-.26.84.23Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "41.77",
          cy: "41.46",
          r: "8.54"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m37.5 41.77 2.64 2.64 5.9-5.9"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "shadeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M13.15 8.69 12.4 19v.23c.02 1.69 1.42 3.06 3.15 3.06s3.14-1.36 3.15-3.06V19l.63-10.31h-6.19Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m43.13 8.68.77 10.31v.23c0 1.71-1.41 3.09-3.15 3.09s-3.15-1.38-3.15-3.09v-.23l-.63-10.31h6.17Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.98 8.68V19.21c0 1.71 1.41 3.09 3.15 3.09s3.15-1.38 3.15-3.09V8.7l-6.31-.03Z"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.11 32.07s.63-.91 1.07-.08.14 10.97 4.46 13.56 5.29 2.81 5.29 2.81l.33 2H11.69l.42-18.29Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.4 22.29V32M7.59 49.98V22.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.93 31v-2.07H27.36V43.6H31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.34 36.14h4.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.73 5.98h13.35c1.06 0 1.91.85 1.91 1.9v.63H6.97v-.63c0-1.05.86-1.9 1.91-1.9h24.85Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.93 8.52H6.95L5.67 19.3c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c-.01 1.75 1.4 3.18 3.16 3.2s3.2-1.39 3.21-3.14c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.13.59 2.18 1.58 2.75.98.57 2.2.58 3.19.02s1.6-1.6 1.61-2.74c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17c0 1.75 1.43 3.17 3.19 3.17s3.19-1.42 3.19-3.17L49.04 8.61l-5.1-.09Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M5.68 49.97h27.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 49.94V28.9h11.47v21.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.05 39.27h11.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.35 37.32v3.82"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_StoreSuccess56 = (StoreSuccess56);
;// ./src/Picto/GeneratedPictoComponents/EmptyStateBox104.tsx


var EmptyStateBox104_excluded = ["className"];
function EmptyStateBox104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EmptyStateBox104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EmptyStateBox104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EmptyStateBox104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EmptyStateBox104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateBox104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EmptyStateBox104_objectSpread(EmptyStateBox104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m45.48 59.27-28.45-6.54v7.43l27.65 6.18c1.08.24 2.14-.48 2.48-1.68L52 47.54l-.87-.17-5.65 11.91ZM52.72 47.07l-.72.14 3.82 16.1c.3 1.25 1.37 2.03 2.48 1.8l28.67-5.91v-6.46l-28.45 6.54-5.8-12.2Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.68 53.04V70.6L52 78.48l35.32-7.88V53.04M52 78.28V48"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.59 37.9s2.81.06 2.35 2.03-7.05.62-7.37 1.97c-.31 1.35 2.24.75 2.04 2.45s-2.06 1.42-2.06 1.42l-21.13-3.23 26.17-4.64Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.88 42.06 7 50.84l38.41 7.69 6.45-11.81M87.12 42.06 97 50.84l-38.41 7.69-6.42-11.77M52 37.47l6.59-6.59 35.32 4.6-6.79 6.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.2 37.47-6.58-6.59-35.33 4.6 6.79 6.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.32 42.06 52 46.65l-35.32-4.59L52 37.47l35.32 4.59z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateBox104 = (EmptyStateBox104);
;// ./src/Picto/GeneratedPictoComponents/EmptyStateBox56.tsx


var EmptyStateBox56_excluded = ["className"];
function EmptyStateBox56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EmptyStateBox56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EmptyStateBox56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EmptyStateBox56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EmptyStateBox56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateBox56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EmptyStateBox56_objectSpread(EmptyStateBox56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.49 31.84 9.17 28.56v3.72l14.89 3.1c.58.12 1.15-.24 1.34-.84l2.61-8.58-.47-.09-3.04 5.97ZM28.39 25.72l-.39.07 2.06 8.07c.16.63.74 1.02 1.34.9l15.44-2.96v-3.24l-15.32 3.28-3.12-6.12Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.98 28.56v9.45L28 42.26l19.02-4.25v-9.45M28 42.15v-16.3"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.25 20.39s1.42.03 1.19 1.03-3.57.31-3.73 1 1.13.38 1.03 1.24-1.04.72-1.04.72L12 22.74l13.25-2.35Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.09 22.65-5.32 4.73 20.68 4.13 3.47-6.35M46.91 22.65l5.32 4.73-20.68 4.13-3.46-6.33M28 20.18l3.55-3.55 19.02 2.47-3.66 3.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.11 20.18-3.55-3.55L5.54 19.1l3.66 3.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.02 22.65 28 25.12 8.98 22.65 28 20.18l19.02 2.47z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateBox56 = (EmptyStateBox56);
;// ./src/Picto/GeneratedPictoComponents/EmptyStateTray104.tsx


var EmptyStateTray104_excluded = ["className"];
function EmptyStateTray104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EmptyStateTray104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EmptyStateTray104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EmptyStateTray104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EmptyStateTray104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateTray104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EmptyStateTray104_objectSpread(EmptyStateTray104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.4 83.6c-2.26-.87-5.04-.94-7.39-1.72C17.95 78.71 15.8 71.4 14.25 65.24c-.45-1.54-.55-2.53-3.51-2.67v20.27c0 1.91 2.56 3.45 5.72 3.45h21.52c.15-1.09-1.05-2.11-2.57-2.69Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M94 58.48v23.53c0 2.37-1.84 4.29-4.1 4.29H14.1c-2.27 0-4.1-1.92-4.1-4.29V58.48",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M86.5 57.88s-8.91 1.04-18.92-8.69c-8.39-8.16-44.85-6.66-44.85-6.66l1.25-5.01 56.55-.1 5.97 20.47Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.28 76.26H61.7M22.51 18.38 10.16 56.32c-.5 2.84-.2 7.08 6.95 7.08h9.29c.21 0 .38.33.38.73v9.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.34 36.85H78.9c1.14 0 2.1-.85 2.24-1.98L81.92 20c.07-1.35.26-1.62-.93-1.62H23.37c-1.13 0-.92.86-.92 2.37l.6 13.79c-.06 1.22 1.15 2.31 2.3 2.31ZM61.72 76.26H42.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m81.96 18.53 11.88 37.79c.5 2.84.2 7.08-6.95 7.08H77.6c-.21 0-.38.33-.38.73v9.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m86.89 63.4-5.62-24.9a2.118 2.118 0 0 0-2.06-1.65H24.97c-.96 0-1.8.65-2.04 1.58L17.12 63.4M82 18.65l-.82 15.43c-.22 1.62-.15 3.26.21 4.85l.97 4.39"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.58 18.52.4 15.56c.22 1.62.15 3.26-.21 4.85l-.97 4.39M56.33 76.26h17.6c2.12 0 3.3-1.27 3.3-2.85v-8.96M47.68 76.26h-17.6c-2.12 0-3.3-1.27-3.3-2.85v-8.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.37 18.38c-1.13 0-1-.07-.92 2.37l.6 13.79"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateTray104 = (EmptyStateTray104);
;// ./src/Picto/GeneratedPictoComponents/EmptyStateTray56.tsx


var EmptyStateTray56_excluded = ["className"];
function EmptyStateTray56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function EmptyStateTray56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? EmptyStateTray56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : EmptyStateTray56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function EmptyStateTray56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, EmptyStateTray56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", EmptyStateTray56_objectSpread(EmptyStateTray56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M20.33 43.32c-1.29-.5-2.89-.54-4.24-.99-5.77-1.82-7-6.01-7.89-9.54-.26-.88-.32-1.45-2.01-1.53v11.63c0 1.09 1.47 1.98 3.28 1.98h12.34c.08-.62-.6-1.21-1.47-1.54Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.99 29v13.54c0 1.36-.96 2.46-2.15 2.46H8.14c-1.19 0-2.15-1.1-2.15-2.46V29",
      className: "strokesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.05 29.05s-4.71.55-10.01-4.6c-4.44-4.32-23.73-3.53-23.73-3.53l.66-2.65 29.92-.06 3.16 10.83Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.9 38.54h10.17M12.34 8.42 6.08 28.09c-.26 1.49-.11 3.71 3.64 3.71h4.86c.11 0 .2.17.2.38V37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.03 17.89h28.06c.6 0 1.13-.33 1.15-1.14L43.7 9c0-.62.21-.78-.31-.78l-30.53.1c-.72 0-.53.1-.48.8l.46 7.74c.08.6.59 1.04 1.2 1.04ZM33.08 38.54H22.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.7 8.27 6.21 19.82c.26 1.49.11 3.71-3.64 3.71h-4.86c-.11 0-.2.17-.2.38V37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.23 31.65-2.91-12.89c-.11-.5-.56-.86-1.08-.86H13.83c-.5 0-.94.34-1.07.83L9.8 31.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.34 8.42.46 8.02c.11.85.08 1.71-.11 2.54l-.51 2.3M30.26 38.54h9.22c1.11 0 1.73-.67 1.73-1.49v-4.7M25.73 38.54h-9.22c-1.11 0-1.73-.67-1.73-1.49v-4.7M43.74 8.38l-.45 7.48c-.07 1.37-.09 2.31.09 3.14l.58 2.58"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_EmptyStateTray56 = (EmptyStateTray56);
;// ./src/Picto/GeneratedPictoComponents/Error104.tsx


var Error104_excluded = ["className"];
function Error104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Error104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Error104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Error104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Error104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Error104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Error104_objectSpread(Error104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.5 85.51c-4.97-2.09-11.1-2.28-16.28-4.15-22.16-7.64-26.89-25.23-30.29-40.07-.74-2.78-1.06-4.83-3.94-5.81v33.09L35.42 92h32.73c.33-2.61-2.31-5.08-5.66-6.49Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.43 12 12 35.43v33.14L35.43 92h33.14L92 68.57V35.43L68.57 12H35.43z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m37 37 30 30M67 37 37 67"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Error104 = (Error104);
;// ./src/Picto/GeneratedPictoComponents/Error56.tsx


var Error56_excluded = ["className"];
function Error56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Error56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Error56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Error56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Error56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Error56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Error56_objectSpread(Error56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.25 44.76c-2.48-1.05-5.55-1.14-8.14-2.07-11.08-3.82-13.45-12.61-15.14-20.03-.37-1.39-.53-2.41-1.97-2.91v16.54l11.72 11.72h16.37c.16-1.31-1.15-2.54-2.83-3.24Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.72 8 8 19.72v16.56L19.72 48h16.56L48 36.28V19.72L36.28 8H19.72z",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m20.35 20.35 15.3 15.3M35.65 20.35l-15.3 15.3"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Error56 = (Error56);
;// ./src/Picto/GeneratedPictoComponents/ErrorServer104.tsx


var ErrorServer104_excluded = ["className"];
function ErrorServer104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ErrorServer104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ErrorServer104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ErrorServer104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ErrorServer104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ErrorServer104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ErrorServer104_objectSpread(ErrorServer104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.09 58.49 30 30M78.09 58.49l-30 30"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.51 72.84c2.09.27 21.63.76 23.34-.43C12 71 9.68 60.39 22.34 44.88c-9.87 2.13-11.89 10.65-11.38 14.72.97 7.83 4.22 12.29 11.55 13.24Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M22.15 36.14c-.27 2.09-1 7.03.19 8.74 4.15-8.87 7.74-17.4 22.29-17.4-1.62-1.84-5.16-3.4-9.23-2.89-7.83.97-12.29 4.22-13.24 11.55Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.4 73.49H24.92c-7.21 0-13.61-5.16-14.61-12.3a14.407 14.407 0 0 1 12.03-16.31c-.82-2.09-1.17-4.41-.96-6.82.64-7.26 6.72-13.08 14-13.45 3.27-.17 6.31.72 8.83 2.35 3.29-5.6 9.36-9.36 16.32-9.36 10.43 0 18.89 8.46 18.89 18.89 0 .18-.01.37-.01.55 8.3 2.02 14.44 9.29 14.44 17.95 0 4.7-1.81 9-4.79 12.26-2.29 2.5-5.29 4.23-8.54 5.2"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ErrorServer104 = (ErrorServer104);
;// ./src/Picto/GeneratedPictoComponents/ErrorServer56.tsx


var ErrorServer56_excluded = ["className"];
function ErrorServer56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function ErrorServer56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ErrorServer56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ErrorServer56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function ErrorServer56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, ErrorServer56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", ErrorServer56_objectSpread(ErrorServer56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.84 39.78c1.13.15 11.68.41 12.61-.23-18.51-1.12-19.09-7.23-12.7-14.87-5.33 1.15-6.42 5.75-6.15 7.95.52 4.23 2.28 6.64 6.24 7.15Z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M11.91 19.86c-.15 1.14-.55 3.84.1 4.78 2.27-4.85 4.23-9.51 12.18-9.51-.88-1.01-2.82-1.86-5.05-1.58-4.28.53-6.72 2.31-7.24 6.32Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.49 31.5 42.99 48M42.99 31.5 26.49 48"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.03 39.92H13.29c-3.94 0-7.44-2.82-7.99-6.73a7.882 7.882 0 0 1 6.58-8.92 8.129 8.129 0 0 1-.52-3.73c.35-3.97 3.67-7.15 7.65-7.36 1.79-.09 3.45.39 4.83 1.28 1.8-3.06 5.12-5.12 8.92-5.12 5.7 0 10.33 4.63 10.33 10.33v.3c4.54 1.1 7.89 5.08 7.89 9.81 0 2.57-.99 4.92-2.62 6.7-1.25 1.37-2.89 2.31-4.67 2.84"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_ErrorServer56 = (ErrorServer56);
;// ./src/Picto/GeneratedPictoComponents/Information104.tsx


var Information104_excluded = ["className"];
function Information104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Information104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Information104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Information104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Information104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Information104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Information104_objectSpread(Information104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.56 90.27c1.05.7.45 2.32-.81 2.19-17.78-1.95-35.96-19.79-35.96-40.41s14.28-36.39 33.13-39.88c1.88-.35 2.92 2.1 1.37 3.22-8.58 6.15-23.27 19.22-23.27 36.66 0 19.1 17.61 32.96 25.53 38.22Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.5 51.89c0 22.16-17.96 40.12-40.12 40.12S12.25 74.05 12.25 51.89s17.97-40.13 40.13-40.13S92.5 29.72 92.5 51.88Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.56 33.96c0-1.92 1.62-3.42 3.54-3.42s3.48 1.5 3.48 3.42-1.56 3.48-3.48 3.48-3.54-1.56-3.54-3.48Zm6.18 9.66v30h-5.28v-30h5.28Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Information104 = (Information104);
;// ./src/Picto/GeneratedPictoComponents/Information56.tsx


var Information56_excluded = ["className"];
function Information56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Information56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Information56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Information56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Information56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Information56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Information56_objectSpread(Information56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.5 46.39c.44.29.21.99-.32.94-9.94-.92-17.77-9.24-17.86-19.44C8.23 17.55 16.12 9 26.25 8.09c.42-.04.62.51.26.74-3.53 2.31-12.81 9.31-12.73 19.01.08 9.4 8.92 16.1 12.71 18.55Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.19 27.57c0 11.05-8.95 20-20 20s-20-8.95-20-20 8.95-20 20-20 20 8.95 20 20Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.25 18.97c0-.96.81-1.71 1.77-1.71s1.74.75 1.74 1.71-.78 1.74-1.74 1.74-1.77-.78-1.77-1.74Zm3.09 4.83v15H26.7v-15h2.64Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Information56 = (Information56);
;// ./src/Picto/GeneratedPictoComponents/NoBills104.tsx


var NoBills104_excluded = ["className"];
function NoBills104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NoBills104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NoBills104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NoBills104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NoBills104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NoBills104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NoBills104_objectSpread(NoBills104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: ".16",
        y: "-2.93",
        width: "103.66",
        height: "103.66",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M.16 100.73h103.66V-2.93H.16v103.66z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "36.68",
        y: "-29.41",
        width: "60.22",
        height: "103.66",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M36.68-29.41V74.24h60.21V-29.41H36.68z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "4.68",
        y: "-25.72",
        width: "97.15",
        height: "97.15",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M4.68-25.72v97.16h97.16v-97.16H4.68z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.66 39.49c1.98 0 3.59-1.6 3.59-3.59s-1.61-3.58-3.59-3.58a3.585 3.585 0 1 0 0 7.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.28 33.79c0-4.09-.99-9.75-2.58-12.2-2.75-4.24-6.12-3.78-10.41-2.92-9.95 2 11.45 6.63 10.93 40.07 3.4 4.58 2.07-5.31 2.07-7.9V33.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.08 88.65c-.22-7.97-.28-12.73-.29-15.33 0-1.73.42-3.42 1.24-4.97l3.84-6.43V60.1h-4.76l-4.76 8.91v27.12c0 1.44 4.72.61 4.72-7.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.26 79.63c2.18-4.96 6.28-15.24 14.34-17.03 4.71-1.05 8.27-1.63 10.69-1.76.94-.05 1.87-.15 2.8-.31 2.44-.41 2.69-1.42.21-1.42H23.45L11.34 79.29c-2.26 4.45 6.74 5.3 8.92.34"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.37 59.11H28.21V28.19c0-5.26 4.26-9.51 9.51-9.51h7.14c5.26 0 9.51 4.26 9.51 9.51v30.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.26 96.7V59.11h-4.75l-4.76 8.9V96.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.72 13.92c-7.88 0-14.27 6.39-14.27 14.27v30.92h66.6c1.31 0 2.38-1.07 2.38-2.38V28.19c0-7.88-6.39-14.27-14.27-14.27H37.73Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.29 82.89H13.38c-1.85 0-2.99-2.02-2.04-3.6l12.11-20.18h35.68L48.55 80.27a4.764 4.764 0 0 1-4.26 2.63Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M93.49 35.62H68.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.08 35.68a3.36 3.36 0 1 0 6.722-.002 3.36 3.36 0 0 0-6.722.002Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.29 36.31v6.88c0 .51.24.93.54.93h2.38c.3 0 .54-.41.54-.93v-7.71c0-.48-.23-.88-.51-.88h-1.95c-.55 0-.99.77-.99 1.71ZM38.85 45.09v-.35c0-2.56.31-3.6 2.91-5.67 1.82-1.44 3.04-2.42 3.04-4.17 0-1.93-1.43-3.19-3.57-3.19-2.52 0-3.99 1.79-4.1 3.96H33.1c.07-4.06 3.01-7.39 8.05-7.39 4.76 0 7.7 2.87 7.7 6.79 0 3.68-2.62 5.18-4.69 6.55-1.37.95-1.79 1.72-1.79 3.12v.35h-3.54Zm4.34 5.18c0 1.47-1.15 2.63-2.59 2.63s-2.62-1.16-2.62-2.63 1.15-2.59 2.62-2.59 2.59 1.16 2.59 2.59Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NoBills104 = (NoBills104);
;// ./src/Picto/GeneratedPictoComponents/NoBills56.tsx


var NoBills56_excluded = ["className"];
function NoBills56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NoBills56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NoBills56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NoBills56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NoBills56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NoBills56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NoBills56_objectSpread(NoBills56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "-.16",
        y: "-1.1",
        width: "55.65",
        height: "55.65",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M-.16 54.56H55.5V-1.1H-.16v55.66z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "19.45",
        y: "-15.31",
        width: "32.33",
        height: "55.65",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M19.45-15.31v55.65h32.33v-55.65H19.45z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "2.27",
        y: "-13.33",
        width: "52.16",
        height: "52.16",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M2.27-13.33v52.16h52.16v-52.16H2.27z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.01 21.68c1.06 0 1.93-.86 1.93-1.93s-.86-1.92-1.93-1.92-1.93.86-1.93 1.92.86 1.93 1.93 1.93Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.48 48.08c-.12-4.28-.15-6.83-.15-8.23 0-.93.23-1.84.67-2.67l2.06-3.45v-.98h-2.55l-2.55 4.79V52.1c0 .77 2.53.32 2.53-4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.63 43.23c1.17-2.66 3.37-8.18 7.7-9.14 2.53-.56 4.44-.88 5.74-.95.5-.03 1.01-.08 1.5-.17 1.31-.22 1.44-.76.11-.76H12.34l-6.5 10.83c-1.21 2.39 3.62 2.85 4.79.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.9 18.62c0-2.2-.53-5.23-1.39-6.55-1.48-2.28-3.29-2.03-5.59-1.57-5.34 1.07 6.15 3.56 5.87 21.51 1.83 2.46 1.11-2.85 1.11-4.24v-9.16Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.26 52.4V32.21h-2.55L29.15 37v15.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.01 7.95a7.66 7.66 0 0 0-7.66 7.66v16.6h35.76c.71 0 1.28-.57 1.28-1.28V15.61a7.66 7.66 0 0 0-7.66-7.66H20.02Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.54 44.98H6.94c-.99 0-1.61-1.08-1.1-1.93l6.5-10.84H31.5l-5.68 11.36a2.56 2.56 0 0 1-2.28 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.95 32.21H14.9v-16.6c0-2.82 2.29-5.11 5.11-5.11h3.83c2.82 0 5.11 2.29 5.11 5.11v16.6Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.77 19.97v3.69c0 .27.13.5.29.5h1.28c.16 0 .29-.22.29-.5v-4.14c0-.26-.12-.47-.27-.47h-1.05c-.29 0-.53.41-.53.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.95 19.6H36.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.09 19.64a1.799 1.799 0 1 0 3.598.002 1.799 1.799 0 0 0-3.598-.002Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M20.6 24.85v-.18c0-1.31.16-1.85 1.5-2.92.94-.74 1.57-1.24 1.57-2.14 0-.99-.74-1.64-1.84-1.64-1.3 0-2.05.92-2.11 2.04h-2.07c.04-2.09 1.55-3.8 4.14-3.8 2.45 0 3.96 1.48 3.96 3.49 0 1.89-1.35 2.67-2.41 3.37-.7.49-.92.88-.92 1.6v.18H20.6Zm2.23 2.67c0 .76-.59 1.35-1.33 1.35s-1.35-.59-1.35-1.35.59-1.33 1.35-1.33 1.33.59 1.33 1.33Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NoBills56 = (NoBills56);
;// ./src/Picto/GeneratedPictoComponents/NotificationCentre104.tsx


var NotificationCentre104_excluded = ["className"];
function NotificationCentre104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationCentre104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationCentre104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationCentre104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationCentre104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCentre104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationCentre104_objectSpread(NotificationCentre104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: ".35",
        y: "4.22",
        width: "103.66",
        height: "60.22",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M.35 64.44h103.66V4.22H.35v60.22z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: ".16",
        y: "-2.93",
        width: "103.66",
        height: "103.66",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M.16 100.73h103.66V-2.93H.16v103.66z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "4.04",
        y: "-.72",
        width: "97.15",
        height: "97.15",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M4.04 96.43h97.16V-.72H4.04v97.15z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.28 33.79c0-4.09-.99-9.75-2.58-12.2-2.75-4.24-6.12-3.78-10.41-2.92-9.95 2 11.45 6.63 10.93 40.07 3.4 4.58 2.07-5.31 2.07-7.9V33.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.08 88.65c-.22-7.97-.28-12.73-.29-15.33 0-1.73.42-3.42 1.24-4.97l3.84-6.43V60.1h-4.76l-4.76 8.91v27.12c0 1.44 4.72.61 4.72-7.47"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.26 79.63c2.18-4.96 6.28-15.24 14.34-17.03 4.71-1.05 8.27-1.63 10.69-1.76.94-.05 1.87-.15 2.8-.31 2.44-.41 2.69-1.42.21-1.42H23.45L11.34 79.29c-2.26 4.45 6.74 5.3 8.92.34"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.29 26.91c.62-4.65 4.61-8.24 9.43-8.24h7.14c5.26 0 9.51 4.26 9.51 9.51V59.1H28.21v-3.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.26 96.7V59.11h-4.75l-4.76 8.9V96.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.45 56.75v2.35h66.6c1.31 0 2.38-1.07 2.38-2.38V28.18c0-7.88-6.39-14.27-14.27-14.27H37.73c-7.88 0-14.27 6.39-14.27 14.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.29 82.89H13.38c-1.85 0-2.99-2.02-2.04-3.6l12.11-20.18h35.68L48.55 80.27a4.764 4.764 0 0 1-4.26 2.63Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M66.07 9.83h6.88c.51 0 .93-.24.93-.54V6.91c0-.3-.41-.54-.93-.54h-7.71c-.48 0-.88.23-.88.51v1.95c0 .55.77.99 1.71.99Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.66 39.49c1.98 0 3.59-1.6 3.59-3.59s-1.61-3.58-3.59-3.58a3.585 3.585 0 1 0 0 7.17Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m12.19 39.08.85 3.16c-.34-1.28.01-3.21 2.05-2.84 2.03.37 10.52 2.42 11.18 2.65.67.22 2.72.33 3.12-.68-1.43-.44-6.97-1.83-16.6-4.17-.7.14-.9.77-.6 1.88ZM43.2 44.81c-.77-.09-10.03-2.26-10.44-2.15s-.44.56-.21.67c.23.11 4.3 1.14 5.16 1.38.86.24.99 1.3.08 1.55s-1.72.48-1.61.91 5.66-1.32 6.21-1.47 1.58-.8.81-.89Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.38 7.63v24.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.44 39.04a3.36 3.36 0 1 0-.002-6.722 3.36 3.36 0 0 0 .002 6.722Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.43 35.88 28.08-7.52c1.02-.27 2.06.29 2.32 1.27l3.7 13.81c.26.97-.36 1.98-1.38 2.26l-28.08 7.52c-1.02.27-2.06-.29-2.32-1.27l-3.7-13.81c-.26-.97.36-1.98 1.38-2.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.02 36.76 16.2 3.91c.44.1.91-.02 1.24-.34L41.32 28.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m32.74 42.05 13.32 2.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.01 43.85-10.14 9.08"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCentre104 = (NotificationCentre104);
;// ./src/Picto/GeneratedPictoComponents/NotificationCentre56.tsx


var NotificationCentre56_excluded = ["className"];
function NotificationCentre56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function NotificationCentre56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? NotificationCentre56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : NotificationCentre56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function NotificationCentre56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, NotificationCentre56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", NotificationCentre56_objectSpread(NotificationCentre56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "-.06",
        y: "2.75",
        width: "55.65",
        height: "32.33",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M-.06 35.08H55.6V2.75H-.06v32.33z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "-.16",
        y: "-1.1",
        width: "55.65",
        height: "55.65",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M-.16 54.56H55.5V-1.1H-.16v55.66z"
          })
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "1.93",
        y: ".09",
        width: "52.16",
        height: "52.16",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M1.93 52.25h52.16V.09H1.93v52.16z"
          })
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.48 48.08c-.12-4.28-.15-6.83-.15-8.23 0-.93.23-1.84.67-2.67l2.06-3.45v-.98h-2.55l-2.55 4.79V52.1c0 .77 2.53.32 2.53-4.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.63 43.23c1.17-2.66 3.37-8.18 7.7-9.14 2.53-.56 4.44-.88 5.74-.95.5-.03 1.01-.08 1.5-.17 1.31-.22 1.44-.76.11-.76H12.34l-6.5 10.83c-1.21 2.39 3.62 2.85 4.79.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.9 18.62c0-2.2-.53-5.23-1.39-6.55-1.48-2.28-3.29-2.03-5.59-1.57-5.34 1.07 6.15 3.56 5.87 21.51 1.83 2.46 1.11-2.85 1.11-4.24v-9.16Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.26 52.4V32.21h-2.55L29.15 37v15.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.35 30.92v1.3h35.76c.71 0 1.28-.57 1.28-1.28V15.62a7.66 7.66 0 0 0-7.66-7.66H20.02a7.66 7.66 0 0 0-7.66 7.66v.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.54 44.98H6.94c-.99 0-1.61-1.08-1.1-1.93l6.5-10.84H31.5l-5.68 11.36a2.56 2.56 0 0 1-2.28 1.41Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.9 15.61c0-2.82 2.29-5.11 5.11-5.11h3.83c2.82 0 5.11 2.29 5.11 5.11v16.6H14.9v-1.85"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.23 5.75h3.69c.27 0 .5-.13.5-.29V4.18c0-.16-.22-.29-.5-.29h-4.14c-.26 0-.47.12-.47.27v1.05c0 .29.41.53.92.53Z",
      className: "strokesecondaryinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.01 21.68c1.06 0 1.93-.86 1.93-1.93s-.86-1.92-1.93-1.92-1.93.86-1.93 1.92.86 1.93 1.93 1.93Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadesecondary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m6.3 22.02.46 1.7c-.18-.69 0-1.73 1.1-1.53 1.1.2 5.66 1.3 6.02 1.43.36.12 1.46.18 1.68-.37-.77-.24-3.75-.99-8.94-2.25-.38.08-.48.41-.32 1.01ZM23 25.11c-.42-.05-5.4-1.22-5.62-1.16s-.24.3-.12.36 2.32.61 2.78.74c.46.13.53.7.05.83s-.93.26-.87.49 3.05-.71 3.34-.79.85-.43.44-.48Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.86 4.58v13.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.89 21.44a1.799 1.799 0 1 0 .002-3.598 1.799 1.799 0 0 0-.002 3.598Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m6.44 20.3 15.12-4.05c.55-.15 1.11.16 1.25.68l1.99 7.44c.14.52-.19 1.07-.74 1.22L8.94 29.64c-.55.15-1.11-.16-1.25-.68L5.7 21.52c-.14-.52.19-1.07.74-1.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m6.21 20.78 8.72 2.11c.24.06.49-.01.67-.18l6.38-6.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m17.37 23.62 7.17 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.75 24.59-5.46 4.89"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_NotificationCentre56 = (NotificationCentre56);
;// ./src/Picto/GeneratedPictoComponents/SomethingWentWrong104.tsx


var SomethingWentWrong104_excluded = ["className"];
function SomethingWentWrong104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SomethingWentWrong104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SomethingWentWrong104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SomethingWentWrong104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SomethingWentWrong104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SomethingWentWrong104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SomethingWentWrong104_objectSpread(SomethingWentWrong104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.99 90.47c1.05.7.45 2.32-.81 2.19-17.78-1.95-35.96-19.79-35.96-40.41S26.5 15.86 45.36 12.38c1.88-.35 2.92 2.1 1.37 3.22-8.58 6.15-23.27 19.22-23.27 36.66 0 19.1 17.61 32.96 25.53 38.22Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.55 52c0 22.4-18.15 40.55-40.55 40.55S11.45 74.39 11.45 52 29.61 11.45 52 11.45 92.55 29.6 92.55 52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.22 68.84c7.06-7.06 18.5-7.06 25.56 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.8 42.68a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.8 42.68a4.3 4.3 0 1 1-8.6 0 4.3 4.3 0 0 1 8.6 0"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SomethingWentWrong104 = (SomethingWentWrong104);
;// ./src/Picto/GeneratedPictoComponents/SomethingWentWrong56.tsx


var SomethingWentWrong56_excluded = ["className"];
function SomethingWentWrong56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SomethingWentWrong56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SomethingWentWrong56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SomethingWentWrong56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SomethingWentWrong56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SomethingWentWrong56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SomethingWentWrong56_objectSpread(SomethingWentWrong56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.98 46.74c.44.29.21.99-.32.94-9.94-.92-17.77-9.24-17.86-19.44-.09-10.34 7.8-18.89 17.93-19.8.42-.04.62.51.26.74-3.53 2.31-12.81 9.31-12.73 19.01.08 9.4 8.92 16.1 12.71 18.55Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48 28c0 11.05-8.95 20-20 20S8 39.05 8 28 16.95 8 28 8s20 8.95 20 20Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.7 36.31c3.48-3.48 9.13-3.48 12.61 0"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.78 23.4c0 1.13-.92 2.05-2.05 2.05s-2.05-.92-2.05-2.05.92-2.05 2.05-2.05 2.05.92 2.05 2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.32 23.4c0 1.13-.92 2.05-2.05 2.05s-2.05-.92-2.05-2.05.92-2.05 2.05-2.05 2.05.92 2.05 2.05"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SomethingWentWrong56 = (SomethingWentWrong56);
;// ./src/Picto/GeneratedPictoComponents/Success104.tsx


var Success104_excluded = ["className"];
function Success104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Success104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Success104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Success104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Success104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Success104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Success104_objectSpread(Success104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.2 86.2c-20 0-36.4-16.4-36.4-36.4 0-4.9 1-9.6 2.8-13.9.6-1.4-1.3-2.4-2.1-1.2-5.8 7.6-8.7 17.4-7 27.9 2.5 15.3 14.7 27.5 30 30 10.5 1.7 20.3-1.2 27.9-7 1.2-.9.1-2.7-1.2-2.2-4.4 1.8-9.1 2.8-14 2.8"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59 11.9V2.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m67.7 13.1 2.5-9.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m75.8 16.4 4.8-8.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m82.8 21.7 6.8-6.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m88.1 28.7 8.3-4.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m91.5 36.8 9.3-2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.6 45.5h9.6"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.2 50.3c.4 2.1.6 4.2.6 6.3 0 20-16.4 36.4-36.4 36.4S10.9 76.6 10.9 56.6s16.4-36.4 36.4-36.4c6.4 0 12.7 1.7 18.2 4.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.7 32.7 44 68.4 33.2 57.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Success104 = (Success104);
;// ./src/Picto/GeneratedPictoComponents/Success56.tsx


var Success56_excluded = ["className"];
function Success56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Success56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Success56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Success56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Success56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Success56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Success56_objectSpread(Success56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.7 13.9C4.6 33.6 20.9 49.7 40.5 43.7c.4-.1.6.4.3.6-4.8 3.4-17.1 10-27.9-3.4C3.5 29.2 9.5 19 15.2 13.5c.2-.3.7 0 .5.4z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.9 6.1v2.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.5 7-1.1 2.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m51.4 9.6-2 1.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54 13.5-2.6 1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.9 18h-2.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.6 25c.2 1.2.3 2.4.3 3.5 0 11.2-9.2 20.4-20.4 20.4S8.1 39.7 8.1 28.5 17.3 8.1 28.5 8.1c3.6 0 7.1.9 10.2 2.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m46.6 15.1-20 20-6-6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Success56 = (Success56);
;// ./src/Picto/GeneratedPictoComponents/Warning104.tsx


var Warning104_excluded = ["className"];
function Warning104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Warning104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Warning104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Warning104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Warning104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Warning104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Warning104_objectSpread(Warning104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M35.46 66.45c-1.8 6.53-.48 14.36 4.98 18.51 1.44 1.1 2.42 1.97 2.37 3.79-2.74-.18-32.79-.26-32.8-.49-.35-9.41 11.96-22.01 16.57-30.11 6.44-11.33 14.61-23.76 21.37-34.91 1.4-2.31 2.67-4.95 4.51-7.96 3.72 6.4 2.1 13.8.04 17.2C45.66 43.79 39 53.6 35.47 66.45",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m8 88.32 44.45-73.7L96 88.32H8z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M57.39 75.25c0 1.98-1.54 3.52-3.52 3.52s-3.52-1.54-3.52-3.52 1.54-3.52 3.52-3.52 3.52 1.54 3.52 3.52Zm-6.27-34.31h5.5l-1.1 26.51h-3.35l-1.04-26.51Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Warning104 = (Warning104);
;// ./src/Picto/GeneratedPictoComponents/Warning56.tsx


var Warning56_excluded = ["className"];
function Warning56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Warning56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Warning56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Warning56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Warning56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Warning56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Warning56_objectSpread(Warning56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M19.73 35.38c-.9 3.27-.24 7.18 2.49 9.26.72.55 1.21.98 1.18 1.9-1.37-.09-16.4-.13-16.4-.25-.17-4.71 5.98-11 8.28-15.05 3.22-5.67 7.31-11.88 10.69-17.46.7-1.16 1.33-2.48 2.25-3.98 1.86 3.2 1.05 6.9.02 8.6-3.42 5.65-6.75 10.56-8.52 16.99",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6 46.32 28.23 9.47 50 46.32H6z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.07 39.22c0 .99-.77 1.76-1.76 1.76s-1.76-.77-1.76-1.76.77-1.76 1.76-1.76 1.76.77 1.76 1.76Zm-3.13-17.16h2.75l-.55 13.25h-1.68l-.52-13.25Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Warning56 = (Warning56);
;// ./src/Picto/GeneratedPictoComponents/Help104.tsx


var Help104_excluded = ["className"];
function Help104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Help104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Help104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Help104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Help104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Help104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Help104_objectSpread(Help104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.07 24.89C21.93 35.67 13.66 73.74 47.79 89.5c1 .46.56 1.97-.53 1.79-9.76-1.61-27.3-7.17-33.09-26.28 0 0-7.48-26.54 9.37-41.1.71-.62 1.79.07 1.53.98Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.12 52c0 22.16-17.96 40.12-40.12 40.12S11.88 74.16 11.88 52 29.84 11.88 52 11.88 92.12 29.84 92.12 52Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.24 60.12v-.6c0-4.74.6-6.36 5.22-9.96 2.88-2.22 5.52-3.96 5.52-7.92s-2.76-6.66-7.26-6.66c-5.1 0-7.92 3.48-8.1 7.68h-5.16c.12-6 4.5-12.06 13.32-12.06 8.16 0 12.42 5.1 12.42 11.22 0 6.42-4.68 9-7.86 11.34-2.58 1.98-3.36 2.76-3.36 6.36v.6h-4.74Zm6.18 8.52c0 2.16-1.68 3.84-3.84 3.84s-3.84-1.68-3.84-3.84 1.68-3.84 3.84-3.84 3.84 1.68 3.84 3.84Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Help104 = (Help104);
;// ./src/Picto/GeneratedPictoComponents/Help56.tsx


var Help56_excluded = ["className"];
function Help56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Help56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Help56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Help56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Help56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Help56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Help56_objectSpread(Help56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.6 14.24c-1.53 5.14-6.06 24.85 11.73 32.7.43.19.25.84-.22.77-4.76-.7-14.03-3.33-17.02-13.21v-.01c-.07-.24-3.71-13.5 4.85-20.68.31-.26.78.04.66.42Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "20"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M26.12 32.06v-.3c0-2.37.3-3.18 2.61-4.98 1.44-1.11 2.76-1.98 2.76-3.96s-1.38-3.33-3.63-3.33c-2.55 0-3.96 1.74-4.05 3.84h-2.58c.06-3 2.25-6.03 6.66-6.03 4.08 0 6.21 2.55 6.21 5.61 0 3.21-2.34 4.5-3.93 5.67-1.29.99-1.68 1.38-1.68 3.18v.3h-2.37Zm3.09 4.26c0 1.08-.84 1.92-1.92 1.92s-1.92-.84-1.92-1.92.84-1.92 1.92-1.92 1.92.84 1.92 1.92Z",
      className: "strokeprimaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Help56 = (Help56);
;// ./src/Picto/GeneratedPictoComponents/Installation104.tsx


var Installation104_excluded = ["className"];
function Installation104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Installation104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Installation104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Installation104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Installation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Installation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Installation104_objectSpread(Installation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.62 12.89s1.56-1.41 1.98.32c.42 1.73.01 2.21.73 4.56.72 2.35.97 21.72.97 21.72h-1.55l-.49-20.2-1.55-3.58-.09-2.82ZM56.9 59.78c-.47-1.32-.54-4.27-.84-5.62-.17-.77-.58-1.42-.96-2.09-.71-1.28-1.42-2.63-1.6-4.1s.48-2.94 1.19-4.23l-.12-3.94c-.02-.61-.53.02-1.13.04l-4.35.13c-.6.02-1.08.53-1.06 1.13l.08 2.46c0 .14.06.28.17.38l2.87 2.8c.41.4.44 1.05.08 1.49l-2.72 3.27c-.09.1.13 8.44.14 8.57 0 0 8.43.22 8.25-.28Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m57.91 43.63-3.26.1M52.81 39.83l-.65-20.08-1.51-2.68-.14-4.36c0-.3.27-.56.62-.57l4.75-.15c.35-.01.65.23.66.53l.14 4.36-1.34 2.77.65 20.08-3.17.1ZM61.71 60.07l-.28-8.62c0-.13-.06-.26-.15-.36L58.36 48c-.39-.42-.4-1.07-.02-1.49l2.68-2.98c.1-.11.15-.24.14-.39l-.08-2.46c-.02-.61-.53-1.08-1.13-1.06l-10.86.35c-.6.02-1.08.53-1.06 1.13l.08 2.46c0 .14.06.28.17.38l2.87 2.8c.41.4.44 1.05.08 1.49l-2.72 3.27a.54.54 0 0 0-.13.37l.26 8.2h13.07ZM51.38 43.84l3.27-.11"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M74.37 28.2s3.45-1.05 2.55 2.46.13 6.69 1.66 8.03 1.24 3.89-1.04 7.82-6.94 13.61-6.94 13.61l-5.14-.28 9.8-19.16.37-.57s-5.27-4.22-1.26-11.93ZM33.1 50.99l3.35 9.07-5.64.05-.92-2.49 1.71-6.68 1.5.05zM11.44 32.46s1.22-1.63 2.29-.12 2.19 4.36 6.18 3.09l-.8 2.35-3.89 1.62s-1.3-.15-1.68-1.19l-2.1-5.74ZM19.78 29.95s.95-2.3 2.28-.79 2.73 3.68 5.79 2.92c3.07-.76 3.07 1.62 3.07 1.62l-7 2.64s-1.74.08-2.13-.99-2.01-5.4-2.01-5.4ZM52.51 61.27 52.11 92h8.88s5.64-14.09 23.84-13.69v-5.06H56.82l-4.31-11.98ZM18.14 76.56h27.52c.74 0 1.38-.33 1.55-.8l.84-2.28H18.13v3.08Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.09 60.19V92h33.06V73.48M73.07 60.07l8.82-16.62c4.08.52 8.04-1.14 10.04-5.02s1.14-7.82-1.44-10.79c-.32-.37-.94-.17-.99.32l-.58 5.81a.57.57 0 0 1-.23.4l-4.3 3.07a.57.57 0 0 1-.59.04l-4.16-2.15a.54.54 0 0 1-.3-.5v-5.29c.01-.16.08-.32.21-.42l4.39-3.83c.37-.32.18-.94-.31-.99-3.91-.39-7.68 1.33-9.61 5.07-2 3.88-1.06 8.07 1.73 11.11L65.58 60.01l7.49.07ZM43 60.07l-2.35-6.42-5.6-3.98-3.45 1.27-1.71 6.68.92 2.49L43 60.07z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.05 49.67-3.45 1.27-5.63-15.35 3.45-1.27 5.63 15.35zM21.37 34.29c-1.15.42-1.89 1.46-1.95 2.57-.04.69-.44 1.3-1.09 1.54l-2.34.86c-1 .37-2.1-.11-2.45-1.06l-2.44-6.65c-.35-.96.18-2.03 1.18-2.4l2.9-1.07c.36-.13.76 0 .98.32.71 1.06 2.12 1.52 3.43 1.04l1.78 4.86ZM19.61 29.43l-.39-1.07c-.32-.86.13-1.82.99-2.14l17.08-6.29c1-.37 2.1.11 2.45 1.06a.59.59 0 0 1-.37.77c-2.14.7-9.27 3.42-7.56 8.1l.58 1.58c.32.86-.13 1.82-.99 2.14l-7.48 2.76c-.86.32-1.82-.13-2.13-.99l-.39-1.07-1.78-4.86ZM19.02 60.21l-7.36 13.04h35.78l4.7-13.04H19.02z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m85.19 60.21 7.35 13.04H56.82l-4.69-13.04h33.06zM52.03 60.19V92H18.97V73.48"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Installation104 = (Installation104);
;// ./src/Picto/GeneratedPictoComponents/Installation56.tsx


var Installation56_excluded = ["className"];
function Installation56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Installation56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Installation56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Installation56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Installation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Installation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Installation56_objectSpread(Installation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.33 5.76s.8-.73 1.02.16 0 1.14.38 2.35.5 11.18.5 11.18h-.8l-.25-10.4-.8-1.84-.05-1.45ZM29.56 29.9c-.24-.68-.28-2.2-.43-2.89-.09-.39-.3-.73-.49-1.08-.37-.66-.73-1.35-.82-2.11s.25-1.51.61-2.18l-.06-2.03c-.01-.31-.27.01-.58.02l-2.24.07c-.31.01-.56.27-.55.58l.04 1.27c0 .07.03.14.09.19l1.48 1.44c.21.21.23.54.04.77l-1.4 1.68c-.04.05.07 4.34.07 4.41 0 0 4.34.11 4.25-.15Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m27.38 19.45-.34-10.42-.79-1.39-.07-2.26c0-.16.14-.29.32-.3L28.96 5c.18 0 .34.12.34.27l.07 2.26-.7 1.44.34 10.42-1.65.05ZM31.78 25.34l-1.52-1.6a.559.559 0 0 1 0-.77l1.39-1.54c.05-.05.08-.13.07-.2l-.04-1.28a.57.57 0 0 0-.59-.55l-5.64.18a.57.57 0 0 0-.55.59l.04 1.28c0 .07.03.14.09.2l1.49 1.45c.21.21.23.54.04.77l-1.41 1.7c-.04.05-.07.12-.07.19l.14 4.26M26.64 21.52l3.08-.1M31.78 25.34 32 30"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M40.39 12.69s1.83-.56 1.36 1.31.07 3.55.88 4.27.66 2.07-.55 4.16-3.68 7.23-3.68 7.23l-2.73-.15 5.2-10.18.19-.3s-2.8-2.24-.67-6.33ZM17.55 25.02l1.72 4.67-2.9.02-.46-1.28.87-3.43.77.02zM5.32 14.7s.63-.84 1.18-.06 1.13 2.24 3.18 1.59l-.41 1.21-2 .83s-.67-.08-.87-.61l-1.08-2.95ZM10.14 13.28s.49-1.18 1.17-.4 1.4 1.89 2.98 1.5c1.58-.39 1.58.83 1.58.83l-3.6 1.36s-.89.04-1.1-.51-1.03-2.78-1.03-2.78ZM28.44 31.7l-.21 15.79h4.56s2.9-7.24 12.25-7.04v-2.6h-14.4l-2.21-6.15ZM9.9 39.34h14.14c.38 0 .71-.17.8-.41l.43-1.17H9.9v1.58Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M28.02 30.14V48h18.57V37.6M39.81 30.07l4.95-9.34c2.29.29 4.51-.64 5.64-2.82 1.08-2.1.64-4.39-.81-6.06a.313.313 0 0 0-.55.18l-.33 3.26c0 .09-.06.17-.13.23l-2.41 1.73c-.1.07-.22.08-.33.02l-2.34-1.21a.299.299 0 0 1-.17-.28v-2.97c0-.09.05-.18.12-.24l2.46-2.15c.21-.18.1-.53-.18-.56-2.2-.22-4.31.75-5.4 2.85-1.12 2.18-.59 4.53.97 6.24l-5.71 11.08 4.2.04ZM22.92 30.07l-1.32-3.6-3.15-2.24-1.93.71-.96 3.75.51 1.4 6.85-.02z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m18.45 24.23-1.93.71-3.16-8.62 1.93-.71 3.16 8.62zM10.78 15.59c-.65.24-1.06.82-1.1 1.44-.02.39-.25.73-.61.86l-1.31.48c-.56.21-1.18-.06-1.38-.6l-1.37-3.74c-.2-.54.1-1.14.66-1.35l1.63-.6c.2-.07.43 0 .55.18.4.59 1.19.85 1.93.58l1 2.73Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m9.79 12.86-.22-.6a.937.937 0 0 1 .55-1.2l9.59-3.53c.56-.21 1.18.06 1.38.6.07.18-.03.37-.21.43-1.2.39-5.21 1.92-4.24 4.55l.33.89a.937.937 0 0 1-.55 1.2l-4.2 1.55a.934.934 0 0 1-1.2-.56l-.22-.6-1-2.73ZM9.46 30.15l-4.14 7.32h20.1l2.63-7.32H9.46zM46.62 30.15l4.12 7.32H30.68l-2.63-7.32h18.57z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M27.99 30.14V48H9.43V37.6"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Installation56 = (Installation56);
;// ./src/Picto/GeneratedPictoComponents/SupportPhone104.tsx


var SupportPhone104_excluded = ["className"];
function SupportPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SupportPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SupportPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SupportPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SupportPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SupportPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SupportPhone104_objectSpread(SupportPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.17 84.8s-1.29-2.35-1.8-1.03 1.43 2.4-.77 3.86-6.94.64-6.94.64l-1.93 2.7-.79 1.66 5.8-.89 4.31-.6 3.4.47 2.57.77-.64-3.73-3.21-3.86Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M58.23 85.71s1.29-2.35 1.8-1.03-1.43 2.4.77 3.86 6.94.64 6.94.64l1.93 2.7.79 1.66-5.8-.89-4.31-.6-3.4.47-2.57.77.64-3.73 3.21-3.86Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M75.06 34.7c.19-4.26-.78-5.12-2.83-8.86-.04-.35-.04-.71 0-1.06 1.03-2.43 1.43-5.08 1.15-7.71-.2-.89-.56-1.73-1.08-2.49 0 0-.78-1.76-.82-1.56l-.33-.37c-4.79 3.08-13.17.74-18.44 0-4.94-.65-10.05-1.11-14.39 1.63-7.43 4.66-8.77 12.39-9.49 20.58 0 0-1.46-.63 1.73 1.82.64.49-.33 3.57-.33 3.72 1.19 2.9.92-.48 1.05-2.66v-.09s5.12-18.58 20.83-18.97c15.71-.39 19.04 16.96 19.04 16.96.11.69 1.17 3.4 1.19 3.81.3 3.9.92-1.67 1.07-3.84.02-.52 1.67-.48 1.65-.91Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.93 96.57c.93-.85 1.93-1.62 2.99-2.3 4.69-2.82 9.53-5.39 14.5-7.69 6.63-3.31 11.05-5.97 11.87-13.58"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.3 73c.74 7.82 5.72 10.24 12.42 13.65 4.97 2.3 9.81 4.86 14.5 7.69 1 .6 1.95 1.28 2.84 2.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.74 47.99c0 4.35 2.84 4.55 2.84 7.06s-2.9 2.6-2.9 2.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.1 43.57a5.884 5.884 0 0 1 7.73 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.55 43.57a5.884 5.884 0 0 1 7.73 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.02 34.41c-.2-3.26-1.35-6.4-3.32-9.03 6.54-10.53-6.18-17.96-6.18-17.96-3.53 3.06-9.56 2.99-13.59 2.99-15.87 0-22.69 12.04-23.19 24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.71 65c-2.27 1.3-4.76.11-5.73-.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.9 18.85c11.71 0 21.21 12.63 21.21 28.22s-9.5 28.22-21.21 28.22-21.21-12.63-21.21-28.22 9.5-28.22 21.21-28.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m62.19 77 8.27 16.55s-6.71-1.41-10.12-1.49c-3.59-.08-7.18 1.41-8.41 4.39l10.26-19.44Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m41.65 77.02-8.26 16.52s6.71-1.41 10.12-1.49c3.59-.08 7.19 1.41 8.41 4.39L41.65 77.02Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.81",
        cy: "47.95",
        r: "1.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.34",
        cy: "47.95",
        r: "1.97"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.57 38.36s-.55-.45-.94 0 0 12.62-8.09 12.07l-.64 5.12s8.21 2.1 10.06-3.08-.4-14.11-.4-14.11ZM20.8 38.36s.55-.45.94 0 0 12.62 8.09 12.07l.64 5.12s-8.21 2.1-10.06-3.08c-1.86-5.18.4-14.11.4-14.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M62.5 67.25c.52-.14.45-.73-.06-.7-2.69.13-4.72-1.09-5.65-2.34-.19-.26-.69.04-.74.36-.09.58-.32 1.6.58 2.43.77 1.4 3.48 1.13 5.88.26Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.44 35.12c1.43-17.87 13.2-26.2 27.5-26.2s25.52 7.7 27.38 24.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.66 56.54V34.87h-4.33s-6.5 0-6.5 6.5v8.67s0 6.5 6.5 6.5h4.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.08 34.87v21.67h4.33s6.5 0 6.5-6.5v-8.67s0-6.5-6.5-6.5h-4.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.28 56.54s-.13 9.01-14.06 9.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.23 68.6h-3.66c-1.1 0-1.99-.89-1.99-1.99V64.5c0-1.1.89-1.99 1.99-1.99h3.66c1.1 0 1.99.89 1.99 1.99v2.11c0 1.1-.89 1.99-1.99 1.99Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SupportPhone104 = (SupportPhone104);
;// ./src/Picto/GeneratedPictoComponents/SupportPhone56.tsx


var SupportPhone56_excluded = ["className"];
function SupportPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function SupportPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? SupportPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SupportPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function SupportPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, SupportPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", SupportPhone56_objectSpread(SupportPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokeprimaryinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokeprimaryinverted",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "22.31",
          cy: "32.31",
          r: "1.31"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "33.31",
          cy: "32.31",
          r: "1.31"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.98 22.97c.13-2.95-.54-3.54-1.97-6.13-.03-.24-.03-.49 0-.73.72-1.68.99-3.52.8-5.33-.14-.62-.39-1.2-.75-1.72 0 0-.54-1.22-.57-1.08l-.23-.26c-3.33 2.13-9.14.51-12.8 0-3.43-.45-6.97-.77-9.99 1.13-5.16 3.23-6.09 8.58-6.59 14.24 0 0-1.02-.44 1.2 1.26.44.34-.23 2.47-.23 2.57.82 2.01.64-.33.73-1.84v-.06s3.55-12.86 14.46-13.13c10.91-.27 13.22 11.74 13.22 11.74.08.48.81 2.35.82 2.64.21 2.7.64-1.16.74-2.66.01-.36 1.16-.33 1.15-.63Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.89 32.68c0 3.07 2.01 3.21 2.01 4.98s-2.05 1.84-2.05 1.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.67 29.56a4.127 4.127 0 0 1 5.45 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.58 29.56a4.127 4.127 0 0 1 5.45 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.33 23.1c-.14-2.3-.95-4.52-2.34-6.37C46.6 9.3 37.62 4.05 37.62 4.05c-2.49 2.16-6.75 2.11-9.6 2.11-11.2 0-16.02 8.5-16.37 16.94"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.58 44.69c-1.6.92-3.36.08-4.05-.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.01 12.11c8.27 0 14.97 8.92 14.97 19.92s-6.7 19.92-14.97 19.92-14.97-8.92-14.97-19.92 6.7-19.92 14.97-19.92Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.99 25.43s-.42-.34-.71 0 0 9.52-6.11 9.11l-.48 3.86s6.19 1.59 7.59-2.32-.3-10.64-.3-10.64ZM5.78 25.47s.42-.34.71 0 0 9.52 6.11 9.11l.48 3.86s-6.19 1.59-7.59-2.32c-1.4-3.91.3-10.64.3-10.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shadeprimary",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.3 46.86c.36-.09.3-.57-.06-.56-1.89.02-3.35-1.01-4.05-2.04-.14-.21-.48 0-.51.26-.05.46-.17 1.27.48 1.95.58 1.14 2.48 1 4.14.38Z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M7.84 23.58C8.86 10.91 17.2 5 27.34 5s18.21 4.53 19.42 18.4"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M12.96 38.77V23.4H9.89s-4.61 0-4.61 4.61v6.15s0 4.61 4.61 4.61h3.07Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M43.05 23.4v15.37h3.07s4.61 0 4.61-4.61v-6.15s0-4.61-4.61-4.61h-3.07Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M46.03 38.77s-.09 6.39-9.97 6.39"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M34.65 47.33h-2.6c-.78 0-1.41-.63-1.41-1.41v-1.49c0-.78.63-1.41 1.41-1.41h2.6c.78 0 1.41.63 1.41 1.41v1.49c0 .78-.63 1.41-1.41 1.41Z"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_SupportPhone56 = (SupportPhone56);
;// ./src/Picto/GeneratedPictoComponents/Technician104.tsx


var Technician104_excluded = ["className"];
function Technician104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Technician104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Technician104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Technician104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Technician104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Technician104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Technician104_objectSpread(Technician104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
        className: "shade",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M41.19 69.81a16.81 16.81 0 0 1-7.04-8.23c-.85-2.12-2.93-5.01-2.51-2.73.43 3.86.43 7.76 0 11.63l.24 5.05c-.37 1.06-.37 2.01 1.08 1.99l6.82-.13a1.854 1.854 0 0 0 1.3-2.99 1.864 1.864 0 0 0 .99-2.68c.2-.76-.16-1.57-.87-1.91Z"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M45.3 93.59c-.34-.15-.93-1.01-1.27-1.17-.82-1.14-1.95-2.1-2.77-3.24-.79-1.1-1.5-2.45-2.47-3.39-1.63-1.57-3.51.14-4.85 1.07-.11.07-1.26 1.27-2.03 1.77l-2.15 1.73s.62.63 1.86 1.09c1.86.7 3.02-1.54 5.08-1.09s1.6.51 4.11 2.25c1.83 1.27 2.07 1.85 3.28 1.41l1.2-.44Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M59.95 93.88c1.2.44 1.45-.15 3.28-1.41 2.51-1.74 2.06-1.8 4.11-2.25s3.21 1.79 5.08 1.09c1.24-.46 1.86-1.09 1.86-1.09l-2.15-1.73c-.77-.5-1.92-1.69-2.03-1.77-1.34-.94-3.22-2.65-4.85-1.07-.98.94-1.69 2.3-2.47 3.39-.82 1.14-1.95 2.1-2.77 3.24-.33.16-.92 1.02-1.27 1.17l1.2.44Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.67 40.65a6.144 6.144 0 0 1 8.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.81 40.61a6.121 6.121 0 0 1 8.08 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.63 56.3.07 21.31 9.68-.04"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.19 95.1c.47-.46.97-.9 1.49-1.32 1.61-1.22 2.64-2.09 4.32-3.21 2.4-1.6 6.21-4.06 8.66-5.51 5.64-3.58 5.12-6.31 5.11-14.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.96 70.15c.03 8.12 1.1 12.26 6.76 15.77 5.28 3.19 7.6 4.9 11.49 7.76.56.44 1.09.91 1.6 1.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.74 83.81c-4.51 3.88-8 5.83-13.8 5.85-5.79.02-9.39-1.61-13.96-5.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.11 55.1c-2.51-.25-5.08-2.32-6.38-5.45-1.72-4.12-.62-8.5 2.47-9.79.68-.29 1.4-.4 2.13-.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.95 39.4c.83-.1 1.65-.01 2.42.31 3.09 1.27 4.23 5.64 2.53 9.77-1.32 3.21-3.95 5.32-6.51 5.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.16 35.07c.53 2.57.81 5.27.82 8.06.06 16.73-9.84 30.32-22.11 30.36C39.6 73.53 29.61 60 29.56 43.27c0-2.78.26-5.47.76-8.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.85 45.24c0 4.55 2.99 4.75 2.99 7.43s-3.01 2.73-3.01 2.73"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M49.83 62.8c2.01 1 4.44.63 6.05-.93",
      className: "strokeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.57",
        cy: "45.22",
        r: "2.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "59.8",
        cy: "45.16",
        r: "2.06"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M41.75 12.8c-.23.02-2.71.57-2.93.73-2.39 1.74-4.88 3.73-6.11 6.44-.59 1.3-2.26 3.63-2.48 5.04-.14.93.25 6.89-1.4 6.11-1.91-.9-6.52 4.13.69 3.67 1.55-.1 4.33.37 4.55.36 2.78-.07 7.07.36 7.71-3.44.38-2.27-.02-4.84-.05-7.13-.03-2.38.54-4.83.51-7.21.29-.56.22-2.33.55-2.87 1.05-1.77.12-3.26-1.03-1.69Z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.34 28.35V18.26s0-9.35 9.35-9.35 9.35 9.35 9.35 9.35v10.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M58.04 11.09c1.47.28 2.61.65 2.61.65 13.11 4.07 13.7 19.61 13.7 19.61h1.91c1.03 0 1.87.84 1.87 1.87s-.84 1.87-1.87 1.87H27.11c-1.03 0-1.87-.84-1.87-1.87s.84-1.87 1.87-1.87h1.91s.59-15.54 13.7-19.61c0 0 .99-.32 2.31-.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "strokesecondary",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.07 93.9c-1.23-1.55-2.4-2.99-3.63-3.9-.08-.06-.25-.18-.33-.24l7.76-4.84c3.49 1.96 6.7 5.33 9.09 9.25"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M58.07 94.08c2.36-3.96 5.48-7.24 9.03-9.18l8.24 5.17c-1.43.98-3.35 2.25-4.78 4.1"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Technician104 = (Technician104);
;// ./src/Picto/GeneratedPictoComponents/Technician56.tsx


var Technician56_excluded = ["className"];
function Technician56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Technician56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Technician56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Technician56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Technician56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Technician56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Technician56_objectSpread(Technician56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.41 47.8a11.161 11.161 0 0 1-4.69-5.48c-.57-1.41-1.96-3.34-1.67-1.82.28 2.58.28 5.17 0 7.75l.16 3.37c-.25.71-.25 1.34.72 1.32l4.54-.09c.45-.04.84-.32 1.02-.74.18-.42.12-.9-.16-1.25.35-.12.62-.39.74-.74s.09-.73-.09-1.04c.14-.51-.11-1.04-.58-1.28Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.35",
        cy: "30.56",
        r: "1.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "33.6",
        cy: "30.56",
        r: "1.34"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.48 27.14a4.306 4.306 0 0 1 5.67 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.8 27.12a4.306 4.306 0 0 1 5.67 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m13.83 38.13.05 14.95 6.8-.02v-5.19"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.47 37.29c-1.76-.17-3.56-1.63-4.48-3.83-1.21-2.89-.43-5.97 1.73-6.87.48-.2.99-.28 1.5-.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.54 26.26a3.4 3.4 0 0 1 1.7.22c2.17.89 2.97 3.96 1.78 6.86-.92 2.25-2.77 3.73-4.57 3.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.99 23.23c.37 1.8.57 3.7.58 5.66.04 11.74-6.91 21.28-15.52 21.31-8.61.03-15.62-9.47-15.66-21.21 0-1.95.18-3.84.53-5.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.03 30.36c0 3.19 2.1 3.34 2.1 5.21s-2.11 1.92-2.11 1.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.97 43.39c1.53 1.03 3.38.64 4.62-.95"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.11 7.14c-.17.01-1.96.41-2.12.53-1.72 1.26-3.52 2.69-4.41 4.64-.43.94-1.63 2.62-1.79 3.63-.1.67.18 4.97-1.01 4.41-1.38-.65-4.7 2.98.5 2.65 1.12-.07 3.12.26 3.28.26 2-.05 5.1.26 5.56-2.48.28-1.64-.01-3.49-.04-5.14-.03-1.72.39-3.48.37-5.2.21-.4.16-1.68.39-2.07.76-1.28.09-2.35-.74-1.22Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.44 18.3v-7.07s0-6.55 6.55-6.55 6.55 6.55 6.55 6.55v7.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.44 6.21c1.03.2 1.83.45 1.83.45 9.18 2.85 9.59 13.74 9.59 13.74h1.34c.72 0 1.31.59 1.31 1.31s-.59 1.31-1.31 1.31H10.78c-.72 0-1.31-.59-1.31-1.31s.59-1.31 1.31-1.31h1.34s.41-10.89 9.59-13.74c0 0 .69-.22 1.62-.41"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Technician56 = (Technician56);
;// ./src/Picto/GeneratedPictoComponents/Troubleshoot104.tsx


var Troubleshoot104_excluded = ["className"];
function Troubleshoot104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Troubleshoot104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Troubleshoot104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Troubleshoot104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Troubleshoot104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Troubleshoot104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Troubleshoot104_objectSpread(Troubleshoot104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M25.42 25.37c-3.2 11.29-10.64 47.89 21.88 63.7 1.14.56.58 2.3-.67 2.06-9.94-1.85-26.41-7.69-31.98-26.1 0 0-7.37-26.15 8.99-40.79.81-.73 2.08.07 1.78 1.12Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89 15 73.69 30.31M15 15l15.31 15.31M15 89l15.31-15.31M89 89 73.69 73.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.12 52c0 22.16-17.96 40.12-40.12 40.12S11.88 74.16 11.88 52 29.84 11.88 52 11.88 92.12 29.84 92.12 52Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M55.84 68.64c0 2.16-1.68 3.84-3.84 3.84s-3.84-1.68-3.84-3.84S49.84 64.8 52 64.8s3.84 1.68 3.84 3.84ZM49 31.2h6l-1.2 28.92h-3.66L49 31.2Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Troubleshoot104 = (Troubleshoot104);
;// ./src/Picto/GeneratedPictoComponents/Troubleshoot56.tsx


var Troubleshoot56_excluded = ["className"];
function Troubleshoot56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Troubleshoot56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Troubleshoot56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Troubleshoot56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Troubleshoot56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Troubleshoot56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Troubleshoot56_objectSpread(Troubleshoot56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M14.58 14.34c-1.55 5.24-5.93 24.7 11.61 32.56.45.2.26.89-.23.82-4.81-.74-13.9-3.42-16.86-13.18v-.01c-.07-.25-3.68-13.44 4.79-20.63.33-.28.82.04.7.45Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m47.13 8.87-8.24 8.24M8.87 8.87l8.24 8.24M8.87 47.13l8.24-8.24M47.13 47.13l-8.24-8.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "20"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M30.42 36.32c0 1.08-.84 1.92-1.92 1.92s-1.92-.84-1.92-1.92.84-1.92 1.92-1.92 1.92.84 1.92 1.92ZM27 17.6h3l-.6 14.46h-1.83L27 17.6Z",
      className: "strokesecondaryinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Troubleshoot56 = (Troubleshoot56);
;// ./src/Picto/GeneratedPictoComponents/Calendar104.tsx


var Calendar104_excluded = ["className"];
function Calendar104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Calendar104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Calendar104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Calendar104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Calendar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Calendar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Calendar104_objectSpread(Calendar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.91 42.75C21.4 30.6 27.67 24.37 32.33 21.18c1.69-1.16.97-3.79-1.07-3.92l-12.11-.78-6.62 7.56-.44 17.97c-.04 1.58 2.08 2.13 2.82.74Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.61 61.76h11.78M23.61 74.48h11.78M23.61 86.95h11.78M45.68 61.76h11.78M45.68 74.48h11.78M45.68 86.95h11.78M67.71 74.48h11.78M67.71 49.05h11.78M67.71 61.76h11.78M45.68 49.05h11.78"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.89 54.19V86.7c0 4.85-3.93 8.78-8.78 8.78H21.67c-4.85 0-8.78-3.93-8.78-8.78V25.26c0-4.85 3.93-8.78 8.78-8.78h61.44c4.85 0 8.78 3.93 8.78 8.78v29.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M69.81 8.53v17.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.7 8.53v17.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.9 39.3h78.99"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Calendar104 = (Calendar104);
;// ./src/Picto/GeneratedPictoComponents/Calendar56.tsx


var Calendar56_excluded = ["className"];
function Calendar56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Calendar56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Calendar56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Calendar56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Calendar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Calendar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Calendar56_objectSpread(Calendar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.39 21.9c3.13-5.77 6.15-8.82 8.43-10.44.9-.63.48-2.04-.61-2.11l-5.86-.38-3.33 3.81-.21 8.7c-.02.89 1.16 1.19 1.58.41Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.4 29.1v17.04a4.6 4.6 0 0 1-4.6 4.6H11.6a4.6 4.6 0 0 1-4.6-4.6V13.93a4.6 4.6 0 0 1 4.6-4.6h32.21a4.6 4.6 0 0 1 4.6 4.6v15.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.83 5.16v9.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.43 5.16v9.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7 19.35h41.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.6 31.63h6.37M12.6 38.5h6.37M12.6 45.24h6.37M24.53 31.63h6.36M24.53 38.5h6.36M24.53 45.24h6.36M36.43 38.5h6.37M36.43 24.76h6.37M36.43 31.63h6.37M24.53 24.76h6.36"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Calendar56 = (Calendar56);
;// ./src/Picto/GeneratedPictoComponents/Clock104.tsx


var Clock104_excluded = ["className"];
function Clock104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Clock104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Clock104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Clock104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Clock104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Clock104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Clock104_objectSpread(Clock104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.87 77.24c-17.12-.12-30.97-13.97-31.09-31.09 0-3.8.71-7.54 2.05-11.04.52-1.35-1.32-2.31-2.16-1.14a31.09 31.09 0 0 0-5.15 24.79 31.082 31.082 0 0 0 23.76 23.76c8.77 1.91 17.77-.08 24.82-5.17 1.17-.84.21-2.68-1.14-2.16a30.945 30.945 0 0 1-11.09 2.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "31.09"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 29.22v22.75h16.56"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Clock104 = (Clock104);
;// ./src/Picto/GeneratedPictoComponents/Clock56.tsx


var Clock56_excluded = ["className"];
function Clock56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Clock56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Clock56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Clock56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Clock56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Clock56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Clock56_objectSpread(Clock56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.03 41.02c-8.83-.06-15.97-7.21-16.04-16.04 0-1.87.33-3.71.96-5.45.27-.75-.73-1.27-1.18-.62-3.54 5.1-4 12.09-.26 17.97 1.18 1.85 2.76 3.44 4.61 4.61 5.89 3.75 12.89 3.28 17.99-.27.65-.45.13-1.45-.61-1.18-1.74.64-3.59.97-5.48.97Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "19.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "16.04"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 16.25v11.73h8.54"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Clock56 = (Clock56);
;// ./src/Picto/GeneratedPictoComponents/History104.tsx


var History104_excluded = ["className"];
function History104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function History104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? History104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : History104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function History104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, History104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", History104_objectSpread(History104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.2 74.1c-15.9-.1-28.8-13-28.9-28.9 0-3.5.6-7 1.9-10.3.5-1.2-1.2-2.2-2-1.1-4.7 6.6-6.6 14.9-4.8 23.1 2.4 11 11 19.7 22.1 22.1 8.2 1.8 16.5-.1 23.1-4.8 1.1-.8.2-2.5-1.1-2-3.2 1.2-6.7 1.9-10.3 1.9z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M53.3 32.9V52h14.1"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.7 88.5c-2.4.7-4.9 1.3-7.4 1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16 60.5c-.3-1.2-.5-2.5-.7-3.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.6 74.7c-1.4-2-2.7-4.1-3.8-6.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.3 85.2c-2.3-1.3-4.4-2.8-6.3-4.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.9 90c-2.4-.3-4.7-.8-7-1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.9 43.9c3.7-17.3 19-30.2 37.4-30.2 21.1 0 38.3 17.1 38.3 38.3 0 17.2-11.3 31.7-26.9 36.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "53.3",
        cy: "52",
        r: "27.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.3 41.6 15.4 45l-3.3-6.9"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_History104 = (History104);
;// ./src/Picto/GeneratedPictoComponents/History56.tsx


var History56_excluded = ["className"];
function History56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function History56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? History56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : History56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function History56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, History56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", History56_objectSpread(History56_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadeprimary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.4 39.9c-8.6-.1-15.5-7-15.6-15.6 0-1.9.4-3.8 1-5.5.3-.7-.7-1.2-1.1-.6-2.5 3.5-3.5 8-2.6 12.4 1.3 6 5.9 10.6 11.9 11.9 4.4 1 8.9 0 12.4-2.6.6-.4.1-1.3-.6-1.1-1.6.7-3.4 1.1-5.4 1.1z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "strokesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.7 17.7V28h7.6"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 32.6c-.1-.7-.3-1.3-.4-2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.2 40.2c-.8-1.1-1.5-2.2-2-3.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.5 45.9c-1.2-.7-2.3-1.5-3.4-2.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.3 48.5c-1.3-.1-2.5-.4-3.7-.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.8 47.7c-1.3.4-2.6.7-4 .8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 23.7c2-9.3 10.2-16.3 20.1-16.3 11.4 0 20.6 9.2 20.6 20.6 0 9.2-6.1 17.1-14.5 19.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28.7",
        cy: "28",
        r: "14.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12 22.4-3.7 1.8-1.8-3.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_History56 = (History56);
;// ./src/Picto/GeneratedPictoComponents/Bus104.tsx


var Bus104_excluded = ["className"];
function Bus104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bus104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bus104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bus104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bus104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bus104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bus104_objectSpread(Bus104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.62 70.22c.54.01.06 2.62 2.02 3.49 1.16.52 2.42.08 2.66.51.25.44-.72 1.41-1.86 1.55-1.49.18-2.94-1.1-3.47-2.18-.8-1.62.19-3.38.64-3.37ZM76.11 70.22c.54.01.06 2.62 2.02 3.49 1.16.52 2.42.08 2.66.51.25.44-.72 1.41-1.86 1.55-1.49.18-2.94-1.1-3.47-2.18-.8-1.62.19-3.38.64-3.37ZM35.34 73c.38.01.04 2.16 1.41 2.88.81.43 1.68.07 1.86.42.17.36-.5 1.16-1.3 1.28-1.04.15-2.05-.91-2.42-1.8-.56-1.34.13-2.79.45-2.78ZM66 73c.38.01.04 2.16 1.41 2.88.81.43 1.68.07 1.86.42.17.36-.5 1.16-1.3 1.28-1.04.15-2.05-.91-2.42-1.8-.56-1.34.13-2.79.45-2.78ZM36.21 63.11c-3.25.56-10.47 2.05-12.54-1.11-.45-.68-.5-1.33-.59-2.3-.81-8.85-1.23-6.79-1.28-11-.09-7.81 1.13-18.78 1.89-18.78 3.69 0 .22 6.98 1.97 14.6.85 3.69 1.58 6.87 3 9.12 3.57 5.68 11.88 6.15 27.58 6.82 22.34.96 22.18-.62 22.18 1.96 0 .4 1.1.92-.38 1.01-32.23 1.92-27.59-2.79-41.84-.33Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "78.05",
        cy: "72.33",
        rx: "3.62",
        ry: "3.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.57 29.92h59.1v33.52H22.78l-.21-33.52Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "67.32",
        cy: "74.94",
        rx: "2.79",
        ry: "2.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "25.92",
        cy: "72.33",
        rx: "3.62",
        ry: "3.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.65",
        cy: "74.94",
        rx: "2.79",
        ry: "2.98"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.55 23.65c-.41-.04-.81-.04-1.21.06-.65.16-1.48.44-1.45-.5.03-.8-.07-1.59.04-2.39.08-.59.29-1.24.6-1.75.04-.07.1-.15.18-.15.07 0 .12.07.14.14.03.19-.02.44-.01.63.02.77.03 1.3.19 1.63.32.66 1.35.74 1.78.77 11.23.76 16.85.54 16.85.54 4.18-.16 7.46-.33 7.46.81 0 .4-8.06.16-8.9.2-1.38.07-2.77.13-4.14.02-1.44-.12-2.78.19-4.24.24-1.9.07-3.87.15-5.75-.03-.51-.05-1.03-.17-1.54-.22Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17 25.11v50.18c0 4 3.04 7.24 6.8 7.24h56.37c3.76 0 6.8-3.24 6.8-7.24V25.13c0-3.03-1.77-5.74-4.44-6.79-7.21-2.84-17.79-5.87-30.75-5.84-12.77.03-23.21 3.01-30.36 5.82-2.66 1.05-4.43 3.76-4.43 6.79ZM23.91 83.2v6.75c0 .85 1.15 1.54 2.57 1.54h3.74c1.42 0 2.57-.69 2.57-1.54v-6.76M71.19 83.2v6.75c0 .85 1.15 1.54 2.57 1.54h3.74c1.42 0 2.57-.69 2.57-1.54v-6.76"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.17 18.8h29.64v5.64H37.26l-.09-5.64ZM46.94 71.12h10.09v4.83H46.97c0-1.61-.02-3.22-.03-4.83ZM23.46 24.72h7.69M72.8 24.04h7.69"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bus104 = (Bus104);
;// ./src/Picto/GeneratedPictoComponents/Bus56.tsx


var Bus56_excluded = ["className"];
function Bus56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Bus56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Bus56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Bus56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Bus56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Bus56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Bus56_objectSpread(Bus56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.12 38.01c.3 0 .03 1.44 1.11 1.92.64.28 1.33.05 1.47.28.14.24-.4.77-1.02.85-.82.1-1.62-.61-1.91-1.2-.44-.89.11-1.86.35-1.85ZM40.99 38.01c.3 0 .03 1.44 1.11 1.92.64.28 1.33.05 1.47.28.14.24-.4.77-1.02.85-.82.1-1.62-.61-1.91-1.2-.44-.89.11-1.86.35-1.85ZM18.56 39.54c.21 0 .02 1.19.77 1.58.45.23.93.04 1.02.23.1.2-.28.64-.71.7-.57.08-1.13-.5-1.33-.99-.31-.73.07-1.53.25-1.53ZM35.43 39.54c.21 0 .02 1.19.77 1.58.45.23.93.04 1.02.23.1.2-.28.64-.71.7-.57.08-1.13-.5-1.33-.99-.31-.73.07-1.53.25-1.53ZM19.14 34.1c-1.81.13-6.08 1.47-7.22-.26-.25-.37.05-1.08 0-1.61-.16-1.77-.59-2.62-.42-3.51.08-.44.19-.64.22-1.18.05-.77-.1-1.34-.13-1.47-.41-1.75-.81-10.2.8-9.88 2.27.45 1.53 3.15 1.67 7.21.07 2.08.16 4.27.94 5.51 1.96 3.12 6.53 3.38 15.17 3.75 12.29.53 12.68-.7 12.9 1.25.03.22 1.31.33.5.39-17.66 1.27-16.34-.78-24.41-.18Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "42.33",
        cy: "39.18",
        rx: "1.99",
        ry: "2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.54 15.86h32.77v18.43H11.66c-.04-6.14-.08-12.29-.11-18.43Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "36.42",
        cy: "40.62",
        rx: "1.54",
        ry: "1.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "13.66",
        cy: "39.18",
        rx: "1.99",
        ry: "2.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "19.56",
        cy: "40.62",
        rx: "1.54",
        ry: "1.64"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.31 12.64c-.74-.02-1.21 0-1.34-.23-.04-.07-.04-.15-.04-.26 0-.73-.03-.82-.03-.99 0 0 0-.15.01-.29.04-.34.32-.93.44-.93.19 0 .43.22.44.51.02.4.03.67.12.85.18.34.31.29.54.31 5.92.52 8.88.48 8.88.48 2.2-.04 4.54-.69 4.54.55 0 .13-3.42-.06-4.95-.05-.8 0-.85-.05-1.31 0-.39.04-.84.13-1.44 0-.11-.02-.48.18-.54.16-1.11-.32-2.24-.03-2.91.11 0 0-.57-.29-1.01-.27h-.28c-.57-.03-.62.08-1.13.07Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.22 38.52h5.55v2.66h-5.53c0-.89-.01-1.77-.02-2.66ZM12.3 13h4.23M39.44 12.62h4.23"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.75 13.21v27.6c0 2.2 1.67 3.98 3.74 3.98h31c2.07 0 3.74-1.78 3.74-3.98V13.22c0-1.67-.97-3.16-2.44-3.74C40.83 7.92 35 6.25 27.88 6.27a45.8 45.8 0 0 0-16.7 3.2c-1.47.58-2.43 2.07-2.43 3.73ZM12.55 45.16v3.71c0 .47.63.85 1.41.85h2.06c.78 0 1.41-.38 1.41-.85v-3.72M38.55 45.16v3.71c0 .47.63.85 1.41.85h2.06c.78 0 1.41-.38 1.41-.85v-3.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.84 9.74h16.3v3.1H19.89c-.02-1.03-.03-2.07-.05-3.1Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Bus56 = (Bus56);
;// ./src/Picto/GeneratedPictoComponents/Train104.tsx


var Train104_excluded = ["className"];
function Train104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Train104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Train104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Train104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Train104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Train104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Train104_objectSpread(Train104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.79 34.61c.71-.37 1.55.14 1.56.94.12 16.03 2.99 21.86 6.99 24.2 4.79 2.8 9.57.84 24.65 2.25 5.87.55 14.03-.75 12.05 1.91-14.36-.25-28.58-.21-42.94-.46-3.5-14.93-2.35-12.84-5.84-27.77l3.52-1.07ZM28.02 72.26c.7.02.07 3.39 2.62 4.51 1.51.67 3.13.11 3.45.67.32.57-.94 1.82-2.41 2-1.93.24-3.81-1.43-4.49-2.82-1.03-2.1.25-4.38.83-4.37ZM70.02 72.26c.7.02.07 3.39 2.62 4.51 1.51.67 3.13.11 3.45.67.32.57-.94 1.82-2.41 2-1.93.24-3.81-1.43-4.49-2.82-1.03-2.1.25-4.38.83-4.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.27 37 5.03 25.4c.19.93 1.48 1.64 3.03 1.64h41.32c1.54 0 2.84-.7 3.02-1.64l5.03-25.39c0-1.43-1.45-2.7-3.64-3.2-5.92-1.34-14.6-2.76-25.24-2.75-10.48.01-19.05 1.42-24.92 2.74-2.19.49-3.63 1.77-3.63 3.2Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "31",
        cy: "74",
        rx: "4.69",
        ry: "4.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "73",
        cy: "74",
        rx: "4.69",
        ry: "4.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.85 22.83c-.47-.05-.94-.05-1.4.07-.76.19-1.71.51-1.68-.58.03-.92-.08-1.85.04-2.77.09-.68.34-1.44.7-2.03.05-.08.12-.17.21-.17.08 0 .14.08.16.16.04.22-.02.51-.01.73.02.89.03 1.51.22 1.89.38.76 1.57.86 2.06.89 13.04.88 19.56.63 19.56.63 4.85-.19 8.66-.39 8.66.94 0 1.19-9.35.18-10.33.23-1.6.08-3.21.16-4.81.02-1.67-.14-3.23.21-4.92.28-2.2.08-4.49.18-6.67-.03-.6-.06-1.2-.19-1.79-.25Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.52 24.5 6.91 55.13c.25 2.1 2.04 3.68 4.16 3.68h56.78c2.12 0 3.9-1.58 4.16-3.68l6.91-55.11c0-3.21-2-6.08-5.01-7.19a99.407 99.407 0 0 0-34.68-6.18c-14.4.03-26.18 3.19-34.24 6.16a7.645 7.645 0 0 0-4.99 7.19Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.27 17.81H68.7v5.97H35.37c-.03-1.99-.07-3.98-.1-5.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "79.01",
        cy: "24.36",
        r: "3.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.96",
        cy: "24.36",
        r: "3.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.94 76.57h10.09M73.13 83.28 74.51 95h8.99l-3.42-11.6M30.52 90h42.96M30.87 83.29c-.46 3.89-.92 7.78-1.37 11.67h-8.99c1.13-3.85 2.27-7.71 3.4-11.56"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Train104 = (Train104);
;// ./src/Picto/GeneratedPictoComponents/Train56.tsx


var Train56_excluded = ["className"];
function Train56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function Train56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? Train56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Train56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function Train56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, Train56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", Train56_objectSpread(Train56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M32.26 12.06c1.87.06 4.27-.48 3.92.25q-.46.02-.92.05l-15.77.06c-.04-1.1-.05-1.42-.1-2.52.21.17.58-.08.79.33.26.5.34 1.04.61 1.19 1.24.73 2.8.53 5.4.52 0 0 2 0 6.07.11Z",
      className: "shadeprimary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m6.74 13.19 3.72 28.76c.14 1.13 1.1 1.98 2.24 1.98h30.57c1.14 0 2.1-.85 2.24-1.98l3.72-28.75c0-1.73-1.07-3.27-2.7-3.87A53.701 53.701 0 0 0 27.86 6 53.79 53.79 0 0 0 9.42 9.32c-1.62.6-2.69 2.15-2.69 3.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.99 9.59h18v3.22H19.04c-.02-1.07-.04-2.14-.05-3.22Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.54",
        cy: "13.12",
        r: "1.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "13.44",
        cy: "13.12",
        r: "1.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.28 40.77h5.43M39.38 43.92c.25 2.1.5 4.21.74 6.31h4.84c-.61-2.08-1.23-4.16-1.84-6.25M16.44 47.54h23.13M16.62 43.93c-.25 2.09-.49 4.19-.74 6.28h-4.84l1.83-6.23"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "shadesecondary",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.67 18.62c.37-.19 1.46.08 1.47.5.06 8.65 2.39 11.79 4.55 13.05 2.58 1.51 4.5.45 12.62 1.21 3.16.3 7.18-.29 6.71.82-7.73-.14-15.68-.15-23.42-.29-1.88-8.04-.8-6.5-2.68-14.54l.75-.75ZM15.09 38.19c.38.01.04 1.82 1.41 2.43.81.36 1.69.06 1.86.36.17.3-.5.98-1.3 1.08-1.04.13-2.05-.77-2.42-1.52-.56-1.13.13-2.36.45-2.35ZM37.7 38.19c.38.01.04 1.82 1.41 2.43.81.36 1.69.06 1.86.36.17.3-.5.98-1.3 1.08-1.04.13-2.05-.77-2.42-1.52-.56-1.13.13-2.36.45-2.35Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.53 19.92 2.71 13.68c.1.5.8.88 1.63.88h22.25c.83 0 1.53-.38 1.63-.88l2.71-13.67c0-.77-.78-1.46-1.96-1.72-3.19-.72-7.86-1.49-13.59-1.48-5.64 0-10.26.76-13.42 1.48-1.18.27-1.96.95-1.96 1.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "16.69",
        cy: "39.38",
        rx: "2.52",
        ry: "2.69"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "39.31",
        cy: "39.38",
        rx: "2.52",
        ry: "2.69"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_Train56 = (Train56);
;// ./src/Picto/GeneratedPictoComponents/TruckFire104.tsx


var TruckFire104_excluded = ["className"];
function TruckFire104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TruckFire104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TruckFire104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TruckFire104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TruckFire104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TruckFire104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TruckFire104_objectSpread(TruckFire104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "11.05",
        y: "74.53",
        width: "75.66",
        height: "3.47",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M11.05 74.53h75.66V78H11.05v-3.47z"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M71.55 36.11v-3.14h8.86v3.15l-8.86-.01z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M75.98 20.15v3.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.34 23.02 3.22 2.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.62 23.02-3.22 2.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M78.94 32.97s.01-5.03-2.98-5.03c-3.19 0-2.94 5.03-2.94 5.03h5.92ZM71.55 36.11v-3.14h8.86v3.15l-8.86-.01z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.12 49.38H5.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.24 49.38h-4.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.88 30.29H14.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.28 42.23H5.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.97 36.07h-5.78"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.33 60.35 1.18-13.72c.04-.45.66-.55.83-.13 1.04 2.48 3.28 6.97 6.72 9.31 3.02 2.06 6.6 3.39 9.14 4.16.48.15.37.85-.13.85H22.76a.43.43 0 0 1-.43-.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.88 74.53c-4.94 0-9.65.04-13.98.12-1.23.93-2.76 1.51-4.42 1.51a7.44 7.44 0 0 1-4.16-1.28c-9.25.31-15.27.82-15.27 1.39 0 .96 16.94 1.73 37.83 1.73s37.83-.78 37.83-1.73-16.94-1.73-37.83-1.73"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M94.47 48.93c-1.12-2.08-6.37-10.78-6.37-10.78s-.68-.93-1.58-1.44c-1.01-.57-2.98-.55-5.6-.58-5.91-.06-16.31.22-16.31.22l-.83 8.81H23.1l-1.28 16h-3.2v5.65h4.79c.88-3.08 3.69-5.35 7.06-5.35s6.19 2.28 7.06 5.37l37.17.03c.86-3.11 3.69-5.4 7.08-5.4s6.22 2.3 7.08 5.42h3.97l2.57-14.01s.19-1.84-.93-3.92Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.85 68.8c0 4.07-3.3 7.36-7.37 7.36s-7.37-3.3-7.37-7.36 3.3-7.36 7.37-7.36 7.37 3.3 7.37 7.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M89.15 68.8c0 4.07-3.3 7.36-7.37 7.36s-7.37-3.3-7.37-7.36 3.3-7.36 7.37-7.36 7.37 3.3 7.37 7.36Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.29 68.85c0 2.13-1.73 3.86-3.86 3.86s-3.86-1.73-3.86-3.86 1.73-3.86 3.86-3.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M85.64 68.85c0 2.13-1.73 3.86-3.86 3.86s-3.86-1.73-3.86-3.86 1.73-3.86 3.86-3.86"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.63 61.15h40.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.81 44.74-1.4 15.99v5.83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M90.73 50.57c-.12.22-12.67.14-12.67.14-.72 0-1.27-.58-1.21-1.28l.71-8.57c.06-.71.7-1.28 1.42-1.28h4.44c.72 0 1.6.51 1.96 1.13 0 0 5.46 9.66 5.35 9.87Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.15 50.75c-.54 0-.94-.58-.9-1.28l.8-8.61c.04-.71.52-1.28 1.05-1.28h4.38c.54 0 .94.58.9 1.28l-.78 8.61c-.04.7-.52 1.28-1.05 1.28h-4.4Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m31.13 34.54-.66 6.97M36.38 34.54l-.66 6.97M41.62 34.54l-.66 6.97M46.86 34.54l-.66 6.97M52.11 34.54l-.66 6.97M57.35 34.54l-.66 6.97M27.36 33.77h33.51M59.72 42.26H26.31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TruckFire104 = (TruckFire104);
;// ./src/Picto/GeneratedPictoComponents/TruckFire56.tsx


var TruckFire56_excluded = ["className"];
function TruckFire56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function TruckFire56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? TruckFire56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : TruckFire56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function TruckFire56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, TruckFire56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", TruckFire56_objectSpread(TruckFire56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "5.95",
        y: "40.13",
        width: "40.74",
        height: "1.87",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
          children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
            d: "M5.95 40.13h40.74V42H5.95v-1.87z"
          })
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M38.53 17.75h4.77v1.69h-4.77z",
      className: "shadesecondary"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadesecondaryinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.91 10.85v2.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.8 12.4 1.73 1.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.03 12.4-1.74 1.46"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokesecondary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.86 16.31H8.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.92 22.74H3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M8.6 19.42H5.49"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.82 26.59H4.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.51 17.75s0-2.71-1.61-2.71c-1.72 0-1.58 2.71-1.58 2.71h3.19ZM38.53 17.75h4.77v1.69h-4.77z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "shadeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.03 32.43.65-7.52c.03-.31.45-.38.57-.09.62 1.44 1.87 3.82 3.73 5.1 1.59 1.09 3.46 1.82 4.87 2.26.32.1.25.58-.09.58h-9.43c-.17 0-.31-.15-.3-.32Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.32 40.13c-2.66 0-5.2.02-7.53.07-.66.5-1.48.81-2.38.81-.83 0-1.6-.26-2.24-.69-4.98.17-8.22.44-8.22.75 0 .51 9.12.93 20.37.93s20.37-.42 20.37-.93-9.12-.93-20.37-.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "strokeprimary",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.87 26.34c-.6-1.12-3.43-5.8-3.43-5.8s-.36-.5-.85-.78c-.55-.31-1.6-.3-3.02-.31-3.18-.03-8.78.12-8.78.12l-.45 4.74h-21.9l-.69 8.61h-1.72v3.04h2.58c.47-1.66 1.99-2.88 3.8-2.88s3.33 1.23 3.8 2.89l20.01.02c.47-1.67 1.99-2.91 3.81-2.91s3.35 1.24 3.81 2.92h2.14l1.38-7.54s.1-.99-.5-2.11Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.38 37.05a3.971 3.971 0 0 1-7.94 0 3.971 3.971 0 0 1 7.94 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.01 37.05a3.971 3.971 0 0 1-7.94 0 3.971 3.971 0 0 1 7.94 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.47 37.07c0 1.15-.93 2.08-2.08 2.08s-2.08-.93-2.08-2.08.93-2.08 2.08-2.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.12 37.07c0 1.15-.93 2.08-2.08 2.08s-2.08-.93-2.08-2.08.93-2.08 2.08-2.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.65 32.93h21.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.36 24.09-.76 8.61v3.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.85 27.23c-.06.12-6.82.08-6.82.08-.39 0-.68-.31-.65-.69l.38-4.61c.03-.38.38-.69.76-.69h2.39c.39 0 .86.27 1.05.61 0 0 2.94 5.2 2.88 5.31Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.7 27.33c-.29 0-.51-.31-.48-.69l.43-4.63c.02-.38.28-.69.57-.69h2.36c.29 0 .51.31.48.69l-.42 4.63c-.02.38-.28.69-.57.69H36.7Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m16.76 18.6-.35 3.75M19.59 18.6l-.36 3.75M22.41 18.6l-.36 3.75M25.23 18.6l-.35 3.75M28.06 18.6l-.36 3.75M30.88 18.6l-.35 3.75M14.73 18.18h18.05M32.16 22.75H14.17"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_TruckFire56 = (TruckFire56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelAboutApp104.tsx


var WhiteLabelAboutApp104_excluded = ["className"];
function WhiteLabelAboutApp104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelAboutApp104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelAboutApp104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelAboutApp104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelAboutApp104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelAboutApp104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelAboutApp104_objectSpread(WhiteLabelAboutApp104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "67.11",
      cy: "38.3",
      r: "14.26",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.94",
        cy: "85.45",
        r: "2.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.42 46.42c0-.72-.59-1.31-1.31-1.31s-1.31.59-1.31 1.31.59 1.31 1.31 1.31 1.31-.59 1.31-1.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.25 52.55v33.08a7.09 7.09 0 0 1-7.09 7.09H29.73a7.09 7.09 0 0 1-7.09-7.09V18.36a7.09 7.09 0 0 1 7.09-7.09h30.43a7.09 7.09 0 0 1 7.09 7.09v5.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "67.11",
        cy: "38.3",
        r: "14.26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.9 34.41c0-2.33 1.89-4.21 4.21-4.21s4.21 1.89 4.21 4.21-1.89 4.21-4.21 4.21v4.21"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelAboutApp104 = (WhiteLabelAboutApp104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelAboutApp56.tsx


var WhiteLabelAboutApp56_excluded = ["className"];
function WhiteLabelAboutApp56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelAboutApp56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelAboutApp56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelAboutApp56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelAboutApp56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelAboutApp56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelAboutApp56_objectSpread(WhiteLabelAboutApp56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "35.9",
      cy: "20.67",
      r: "7.45",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.31",
        cy: "45.32",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.58 24.92c0-.38-.31-.68-.68-.68s-.68.31-.68.68.31.68.68.68.68-.31.68-.68"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.97 28.13v17.29c0 2.05-1.66 3.71-3.71 3.71H16.35c-2.05 0-3.71-1.66-3.71-3.71V10.25c0-2.05 1.66-3.71 3.71-3.71h15.91c2.05 0 3.71 1.66 3.71 3.71v2.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.9",
        cy: "20.67",
        r: "7.45"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.7 18.64c0-1.22.99-2.2 2.2-2.2s2.2.99 2.2 2.2-.99 2.2-2.2 2.2v2.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelAboutApp56 = (WhiteLabelAboutApp56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelAccountsPayments104.tsx


var WhiteLabelAccountsPayments104_excluded = ["className"];
function WhiteLabelAccountsPayments104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelAccountsPayments104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelAccountsPayments104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelAccountsPayments104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelAccountsPayments104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelAccountsPayments104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelAccountsPayments104_objectSpread(WhiteLabelAccountsPayments104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.33 60.22h59.35v6.17H33.33zM66.4 42.83c0-15.68-12.71-28.39-28.39-28.39S9.62 27.15 9.62 42.83c0 7.72 3.09 14.71 8.09 19.83 1.41-9.85 10.01-17.83 20.32-17.83 6.56 0 12.38 3.11 16.09 7.93h10.45c1.16-3.09 1.84-6.43 1.84-9.93Zm-28.39 2c-6.34 0-11.48-5.14-11.48-11.48s5.14-11.48 11.48-11.48 11.48 5.14 11.48 11.48-5.14 11.48-11.48 11.48Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.38 70.3c-13.45-2.24-23.7-13.93-23.7-28.01 0-15.68 12.71-28.39 28.39-28.39s28.39 12.71 28.39 28.39c0 3.59-.67 7.02-1.88 10.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.08",
        cy: "32.82",
        r: "11.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.42 52.54c-3.69-5-9.63-8.24-16.33-8.24-10.31 0-18.91 7.99-20.32 17.84 0 0 4.6 6.01 15.62 8.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.39 52.76h59.35v37.33H33.39zM92.74 65.86H33.39M33.39 59.68h59.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "37.8",
        y: "71.44",
        width: "29.68",
        height: "6.17",
        rx: "1.73",
        ry: "1.73"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelAccountsPayments104 = (WhiteLabelAccountsPayments104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelAccountsPayments56.tsx


var WhiteLabelAccountsPayments56_excluded = ["className"];
function WhiteLabelAccountsPayments56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelAccountsPayments56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelAccountsPayments56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelAccountsPayments56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelAccountsPayments56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelAccountsPayments56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelAccountsPayments56_objectSpread(WhiteLabelAccountsPayments56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.16 32.18h31.15v3.24H18.16zM35.52 23.05c0-8.23-6.67-14.9-14.9-14.9s-14.9 6.67-14.9 14.9c0 4.05 1.62 7.72 4.25 10.41.74-5.17 5.25-9.36 10.67-9.36 3.44 0 6.5 1.63 8.44 4.16h5.49c.61-1.62.96-3.38.96-5.22Zm-14.9 1.05a6.03 6.03 0 1 1 0-12.06 6.03 6.03 0 0 1 0 12.06Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.15 37.75c-7.06-1.18-12.44-7.31-12.44-14.7 0-8.23 6.67-14.9 14.9-14.9s14.9 6.67 14.9 14.9c0 1.88-.35 3.69-.99 5.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.61",
        cy: "18.07",
        r: "6.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.2 28.43a10.628 10.628 0 0 0-8.57-4.33c-5.41 0-9.93 4.19-10.67 9.37 0 0 2.42 3.16 8.2 4.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.16 28.54h31.15v19.6H18.16zM49.31 35.42H18.16M18.16 32.18h31.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "20.47",
        y: "38.35",
        width: "15.58",
        height: "3.24",
        rx: ".91",
        ry: ".91"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelAccountsPayments56 = (WhiteLabelAccountsPayments56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBank104.tsx


var WhiteLabelBank104_excluded = ["className"];
function WhiteLabelBank104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBank104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBank104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBank104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBank104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBank104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBank104_objectSpread(WhiteLabelBank104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "43.55",
      r: "13.79",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.49 56.34v20.67M46.44 77.01V56.34M43.1 82.66v-4.24c0-.92.74-1.66 1.66-1.66h14.37c.93 0 1.68.75 1.68 1.68v4.22M71.13 77.01V45.76M82.18 45.76v31.25M67.78 82.66v-4.24c0-.92.74-1.66 1.66-1.66h14.37c.93 0 1.68.75 1.68 1.68v4.22M21.76 76.75V46.4M32.81 46.4v30.35M18.43 82.66v-4.24c0-.92.74-1.66 1.66-1.66h14.37c.93 0 1.68.75 1.68 1.68v4.22M65.79 45.69l21.12-.11M17.08 45.95l21.13-.11M48.91 45.57c-.07.25-.1.52-.1.8 0 1.76 1.43 3.19 3.19 3.19s3.19-1.43 3.19-3.19-1.11-3.17-3.19-3.19c-2.02-.09-2.86-1.28-2.86-2.86a2.86 2.86 0 1 1 5.72 0M52 49.56v1.88M52 35.66v1.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M16.28 82.66h71.45v6.16H16.28zM13.88 47.61c-.86 0-1.72-.4-2.26-1.15a2.8 2.8 0 0 1 .62-3.91l36.14-26.3a5.587 5.587 0 0 1 6.51-.05l36.86 25.95c1.26.89 1.57 2.63.68 3.9a2.802 2.802 0 0 1-3.9.68L51.67 20.78 15.52 47.07c-.5.36-1.07.54-1.64.54Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "43.55",
        r: "13.79"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBank104 = (WhiteLabelBank104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBank56.tsx


var WhiteLabelBank56_excluded = ["className"];
function WhiteLabelBank56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBank56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBank56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBank56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBank56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBank56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBank56_objectSpread(WhiteLabelBank56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "23.45",
      r: "7.42",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.95 30.34v11.13M25 41.47V30.34M23.21 44.51v-2.29c0-.49.4-.9.9-.9h7.74c.5 0 .91.41.91.91v2.27M38.3 41.47V24.64M44.25 24.64v16.83M36.49 44.51v-2.29c0-.49.4-.9.9-.9h7.74c.5 0 .91.41.91.91v2.27M11.72 41.33V24.98M17.67 24.98v16.35M9.92 44.51v-2.29c0-.49.4-.9.9-.9h7.74c.5 0 .91.41.91.91v2.27M35.42 24.6l11.37-.06M9.2 24.74l11.38-.06M26.34 24.54c-.04.14-.05.28-.05.43a1.72 1.72 0 1 0 3.44 0c0-.95-.6-1.71-1.72-1.72-1.09-.05-1.54-.69-1.54-1.54a1.54 1.54 0 0 1 3.08 0M28 26.68v1.02M28 19.2v.97M8.76 44.51h38.47v3.32H8.76z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M7.47 25.63a1.503 1.503 0 0 1-.89-2.72L26.04 8.75a3.02 3.02 0 0 1 3.51-.03L49.4 22.69a1.506 1.506 0 1 1-1.74 2.46L27.81 11.18 8.35 25.34c-.27.19-.58.29-.88.29Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "23.45",
        r: "7.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBank56 = (WhiteLabelBank56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBillOverview104.tsx


var WhiteLabelBillOverview104_excluded = ["className"];
function WhiteLabelBillOverview104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBillOverview104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBillOverview104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBillOverview104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBillOverview104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBillOverview104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBillOverview104_objectSpread(WhiteLabelBillOverview104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.41 11.5v12.75c0 2.6 1.98 4.7 4.41 4.7h11.55L66.41 11.5Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.75 30.62v62.01h-63.5V11.37h44.83c.97 0 1.91.37 2.61 1.03l14.98 15.57c.69.71 1.07 1.66 1.07 2.65ZM29.07 79.54h44.76M29.07 66.48h43.87M52.73 50.98h20.51M52.73 37.21h20.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.41 11.79v12.46c0 2.6 1.98 4.7 4.41 4.7h11.55M30.58 47.23c0 2.79 2.54 5.05 5.68 5.05s5.68-2.26 5.68-5.05-2.55-5.05-5.68-5.05-5.68-2.26-5.68-5.05 2.54-5.05 5.68-5.05 5.68 2.26 5.68 5.05M36.26 28.09v3.99M36.26 52.28v3.99"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBillOverview104 = (WhiteLabelBillOverview104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBillOverview56.tsx


var WhiteLabelBillOverview56_excluded = ["className"];
function WhiteLabelBillOverview56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBillOverview56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBillOverview56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBillOverview56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBillOverview56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBillOverview56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBillOverview56_objectSpread(WhiteLabelBillOverview56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.54 6.81v6.67c0 1.36 1.03 2.46 2.31 2.46h6.04l-8.35-9.13Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.61 16.81v32.45H11.39V6.74h23.46c.51 0 1 .19 1.37.54l7.84 8.14c.36.37.56.87.56 1.39ZM16 42.41h23.42M16 35.58h22.96M28.38 27.47h10.73M28.38 20.26h10.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.54 6.96v6.52c0 1.36 1.03 2.46 2.31 2.46h6.04M16.79 25.5c0 1.46 1.33 2.64 2.97 2.64s2.97-1.18 2.97-2.64-1.33-2.64-2.97-2.64-2.97-1.18-2.97-2.64 1.33-2.64 2.97-2.64 2.97 1.18 2.97 2.64M19.77 15.49v2.09M19.77 28.15v2.08"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBillOverview56 = (WhiteLabelBillOverview56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBillPaid104.tsx


var WhiteLabelBillPaid104_excluded = ["className"];
function WhiteLabelBillPaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBillPaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBillPaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBillPaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBillPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBillPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBillPaid104_objectSpread(WhiteLabelBillPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "71.05",
        cy: "77.65",
        r: "15.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.97 11.33v12.2c0 2.48 1.89 4.5 4.22 4.5h11.05l-15.27-16.7Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.97 11.62v11.92c0 2.48 1.89 4.5 4.22 4.5h11.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.98 88.95H17.81V11.21H60.7c.93 0 1.82.35 2.5.99l14.33 14.89c.66.68 1.02 1.59 1.02 2.54V64.5M26.25 76.43h29.66M26.25 63.94h37.74M48.89 49.11H68.5M48.89 35.93H68.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.69 45.52c0 2.67 2.43 4.83 5.44 4.83s5.44-2.16 5.44-4.83-2.44-4.83-5.44-4.83-5.44-2.16-5.44-4.83 2.43-4.83 5.44-4.83 5.44 2.17 5.44 4.83M33.13 27.21v3.82M33.13 50.35v3.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "71.05",
        cy: "77.65",
        r: "15.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m63.99 78.07 4.9 4.9 10.95-10.94"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBillPaid104 = (WhiteLabelBillPaid104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBillPaid56.tsx


var WhiteLabelBillPaid56_excluded = ["className"];
function WhiteLabelBillPaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBillPaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBillPaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBillPaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBillPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBillPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBillPaid56_objectSpread(WhiteLabelBillPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.91",
        cy: "41.35",
        r: "7.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.19 6.83v6.35c0 1.29.98 2.34 2.2 2.34h5.75l-7.95-8.69Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.68 47.23H10.21V6.77h22.32c.48 0 .95.18 1.3.51l7.46 7.75c.34.35.53.83.53 1.32V34.5M14.6 40.71h15.43M14.6 34.21h19.97M26.38 26.49h10.21M26.38 19.64h10.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.19 6.98v6.2c0 1.29.98 2.34 2.2 2.34h5.75M15.35 24.63c0 1.39 1.27 2.51 2.83 2.51s2.83-1.13 2.83-2.51-1.27-2.51-2.83-2.51-2.83-1.12-2.83-2.51 1.27-2.51 2.83-2.51 2.83 1.13 2.83 2.51M18.18 15.1v1.98M18.18 27.14v1.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.91",
        cy: "41.35",
        r: "7.88"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.24 41.57 2.55 2.55 5.7-5.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBillPaid56 = (WhiteLabelBillPaid56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBroadbandMobile104.tsx


var WhiteLabelBroadbandMobile104_excluded = ["className"];
function WhiteLabelBroadbandMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBroadbandMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBroadbandMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBroadbandMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBroadbandMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBroadbandMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBroadbandMobile104_objectSpread(WhiteLabelBroadbandMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.02 36.95h49.96v28.14H27.02z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "17.74",
        y: "21.43",
        width: "68.62",
        height: "68.62",
        rx: "4.1",
        ry: "4.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.08 36.95h49.96v28.14H27.08zM8.62 23.19c0-6.08 4.92-11 11-11M2.4 22.93c0-9.38 7.6-16.98 16.98-16.98M95.4 23.19c0-6.08-4.92-11-11-11M101.6 22.93c0-9.38-7.6-16.98-16.98-16.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "79.95",
        r: "3.2"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBroadbandMobile104 = (WhiteLabelBroadbandMobile104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelBroadbandMobile56.tsx


var WhiteLabelBroadbandMobile56_excluded = ["className"];
function WhiteLabelBroadbandMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelBroadbandMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelBroadbandMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelBroadbandMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelBroadbandMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelBroadbandMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelBroadbandMobile56_objectSpread(WhiteLabelBroadbandMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M15.91 22.53h24.98V36.6H15.91z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28.4",
      cy: "44.03",
      r: "1.6",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11.24",
        y: "14.77",
        width: "34.31",
        height: "34.31",
        rx: "2.05",
        ry: "2.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.91 22.53h24.98V36.6H15.91zM6.68 15.65c0-3.04 2.46-5.5 5.5-5.5M3.57 15.52c0-4.69 3.8-8.49 8.49-8.49M50.07 15.65c0-3.04-2.46-5.5-5.5-5.5M53.17 15.52c0-4.69-3.8-8.49-8.49-8.49"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelBroadbandMobile56 = (WhiteLabelBroadbandMobile56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelCardAdded104.tsx


var WhiteLabelCardAdded104_excluded = ["className"];
function WhiteLabelCardAdded104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelCardAdded104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelCardAdded104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelCardAdded104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelCardAdded104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelCardAdded104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelCardAdded104_objectSpread(WhiteLabelCardAdded104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.17",
        cy: "64.83",
        r: "16.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.92 30.98h73.29v8.06H10.92z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M59.62 68.29h-48.7V22.26h73.29v26.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.42",
        y: "45.27",
        width: "36.46",
        height: "7.89",
        rx: "2.95",
        ry: "2.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.92 30.98h73.29M84.21 39.04H10.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "76.17",
        cy: "64.83",
        r: "16.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m68.29 65.31 5.48 5.47 12.22-12.22"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelCardAdded104 = (WhiteLabelCardAdded104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelCardAdded56.tsx


var WhiteLabelCardAdded56_excluded = ["className"];
function WhiteLabelCardAdded56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelCardAdded56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelCardAdded56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelCardAdded56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelCardAdded56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelCardAdded56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelCardAdded56_objectSpread(WhiteLabelCardAdded56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.58",
        cy: "34.68",
        r: "8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.61 17.06h38.16v4.2H6.61z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.78 36.48H6.61V12.52h38.16v14.42"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "9.48",
        y: "24.5",
        width: "18.98",
        height: "4.11",
        rx: "1.53",
        ry: "1.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.61 17.06h38.16M44.77 21.26H6.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.58",
        cy: "34.68",
        r: "8.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.48 34.93 2.85 2.85 6.37-6.37"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelCardAdded56 = (WhiteLabelCardAdded56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelChangePlan104.tsx


var WhiteLabelChangePlan104_excluded = ["className"];
function WhiteLabelChangePlan104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelChangePlan104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelChangePlan104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelChangePlan104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelChangePlan104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelChangePlan104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelChangePlan104_objectSpread(WhiteLabelChangePlan104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M80.28 34.33v9.17c0 1.87 1.42 3.38 3.18 3.38h8.31L80.29 34.33Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.34 26.55v8.61c0 1.87 1.42 3.38 3.18 3.38h8.31"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m67.96 15.67-1 8.32-8.33-.99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.98 20.4c2.76-5.57 9.67-8.97 16.19-8.19 6.52.78 12.44 5.72 13.75 11.78M92.75 48.08v44.61H57.2V34.23h22.12c.7 0 1.37.27 1.88.74l10.78 11.2c.49.51.77 1.2.77 1.91ZM63.54 83.27h22.07M63.54 73.88h22.07"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.63 60.03c0 2.01 1.83 3.63 4.09 3.63s4.09-1.63 4.09-3.63-1.83-3.63-4.09-3.63-4.09-1.62-4.09-3.63 1.83-3.63 4.09-3.63 4.09 1.63 4.09 3.63M68.72 46.27v2.87M68.72 63.67v2.86M46.81 39.74v44.61H11.26V25.9h22.12c.7 0 1.37.27 1.88.74l10.78 11.2c.49.51.77 1.2.77 1.91ZM17.6 74.93h22.08M17.6 65.54h22.08"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.69 51.69c0 2.01 1.83 3.63 4.09 3.63s4.09-1.63 4.09-3.63-1.83-3.63-4.09-3.63-4.09-1.62-4.09-3.63 1.83-3.63 4.09-3.63 4.09 1.63 4.09 3.63M22.78 37.93v2.86M22.78 55.33v2.86M80.28 34.54v8.96c0 1.87 1.42 3.38 3.18 3.38h8.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.34 26.55v8.61c0 1.87 1.42 3.38 3.18 3.38h8.31"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelChangePlan104 = (WhiteLabelChangePlan104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelChangePlan56.tsx


var WhiteLabelChangePlan56_excluded = ["className"];
function WhiteLabelChangePlan56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelChangePlan56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelChangePlan56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelChangePlan56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelChangePlan56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelChangePlan56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelChangePlan56_objectSpread(WhiteLabelChangePlan56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.79 14.55v4.67c0 .97.74 1.76 1.66 1.76h4.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.77 18.72v4.78c0 .97.74 1.76 1.66 1.76h4.33l-5.99-6.55Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.32 9.06-.52 4.34-4.35-.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.17 11.53c1.44-2.9 5.04-4.68 8.44-4.27s6.48 2.98 7.17 6.14M49.27 25.89v23.26H30.74V18.67h11.53c.36 0 .71.14.98.39l5.62 5.84c.26.27.4.62.4.99ZM34.04 43.34h11.51M34.04 39.34h11.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.77 18.83v4.67c0 .97.74 1.76 1.66 1.76h4.33M34.61 32.12c0 1.05.95 1.89 2.13 1.89s2.13-.85 2.13-1.89-.96-1.89-2.13-1.89-2.13-.85-2.13-1.89.95-1.89 2.13-1.89 2.13.85 2.13 1.89M36.74 24.94v1.5M36.74 34.01v1.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.79 14.44v4.78c0 .97.74 1.76 1.66 1.76h4.33l-5.99-6.55Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.29 21.61v23.26H6.76V14.39h11.53c.36 0 .71.14.98.39l5.62 5.84c.26.27.4.62.4.99ZM10.07 39.17h11.5M10.07 35.06h11.5"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.63 27.84c0 1.05.95 1.89 2.13 1.89s2.13-.85 2.13-1.89-.96-1.89-2.13-1.89-2.13-.85-2.13-1.89.95-1.89 2.13-1.89 2.13.85 2.13 1.89M12.77 20.66v1.5M12.77 29.73v1.5"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelChangePlan56 = (WhiteLabelChangePlan56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelChat104.tsx


var WhiteLabelChat104_excluded = ["className"];
function WhiteLabelChat104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelChat104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelChat104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelChat104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelChat104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelChat104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelChat104_objectSpread(WhiteLabelChat104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.51 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17ZM57.05 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17ZM73.59 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.4 21.52H20.6c-5.08 0-9.21 4.12-9.21 9.21V61.6c0 5.08 4.12 9.21 9.21 9.21h10.84l.12 9.01c.03 2.63 3.42 3.66 4.92 1.5L47.5 70.81h35.92c5.08 0 9.21-4.12 9.21-9.21V30.73c0-5.08-4.12-9.21-9.21-9.21Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.51 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17ZM57.05 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17ZM73.59 46.02c0 2.09-1.26 3.98-3.19 4.78-1.93.8-4.16.36-5.64-1.12a5.175 5.175 0 0 1-1.12-5.64c.8-1.93 2.69-3.19 4.78-3.19a5.17 5.17 0 0 1 5.17 5.17Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelChat104 = (WhiteLabelChat104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelChat56.tsx


var WhiteLabelChat56_excluded = ["className"];
function WhiteLabelChat56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelChat56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelChat56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelChat56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelChat56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelChat56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelChat56_objectSpread(WhiteLabelChat56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.98 24.87c0 1.1-.66 2.08-1.67 2.5s-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71ZM30.65 24.87c0 1.1-.66 2.08-1.67 2.5-1.01.42-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71ZM39.31 24.87c0 1.1-.66 2.08-1.67 2.5-1.01.42-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.45 12.03h-32.9c-2.66 0-4.82 2.16-4.82 4.82v16.17c0 2.66 2.16 4.82 4.82 4.82h5.68l.06 4.72c.02 1.38 1.79 1.92 2.57.78l5.77-5.5h18.81c2.66 0 4.82-2.16 4.82-4.82V16.85c0-2.66-2.16-4.82-4.82-4.82Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.98 24.87c0 1.1-.66 2.08-1.67 2.5s-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71ZM30.65 24.87c0 1.1-.66 2.08-1.67 2.5-1.01.42-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71ZM39.31 24.87c0 1.1-.66 2.08-1.67 2.5-1.01.42-2.18.19-2.95-.59a2.713 2.713 0 0 1-.59-2.95 2.713 2.713 0 0 1 2.5-1.67c1.5 0 2.71 1.21 2.71 2.71Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelChat56 = (WhiteLabelChat56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDataPacks104.tsx


var WhiteLabelDataPacks104_excluded = ["className"];
function WhiteLabelDataPacks104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDataPacks104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDataPacks104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDataPacks104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDataPacks104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDataPacks104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDataPacks104_objectSpread(WhiteLabelDataPacks104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "52.05",
        y: "31.08",
        width: "4.83",
        height: "22.1",
        rx: ".33",
        ry: ".33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "64.58",
        y: "25.56",
        width: "4.83",
        height: "27.63",
        rx: ".34",
        ry: ".34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "77.11",
        y: "36.61",
        width: "4.83",
        height: "16.58",
        rx: ".33",
        ry: ".33"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-stroke",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.95 54.31v31.41c0 4-3.24 7.24-7.24 7.24h-30.4c-4 0-7.24-3.24-7.24-7.24V18.28c0-4 3.24-7.24 7.24-7.24h30.4c4 0 7.24 3.24 7.24 7.24v5.46M38.99 34.84v11.59M33.19 40.63h11.59"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M56.55 28.58h-4.17c-1.56 0-2.83 1.27-2.83 2.83v21.44c0 1.56 1.27 2.83 2.83 2.83h4.17c1.56 0 2.83-1.27 2.83-2.83V31.41c0-1.56-1.27-2.83-2.83-2.83Zm.33 24.27c0 .18-.15.33-.33.33h-4.17c-.18 0-.33-.15-.33-.33V31.41c0-.18.15-.33.33-.33h4.17c.18 0 .33.15.33.33v21.44ZM69.07 23.06h-4.15c-1.57 0-2.84 1.27-2.84 2.84v26.95c0 1.57 1.27 2.84 2.84 2.84h4.15c1.57 0 2.84-1.27 2.84-2.84V25.9c0-1.57-1.27-2.84-2.84-2.84Zm.34 29.79c0 .19-.15.34-.34.34h-4.15c-.19 0-.34-.15-.34-.34V25.9c0-.19.15-.34.34-.34h4.15c.19 0 .34.15.34.34v26.95ZM81.61 34.11h-4.16c-1.56 0-2.83 1.27-2.83 2.83v15.91c0 1.56 1.27 2.83 2.83 2.83h4.16c1.56 0 2.83-1.27 2.83-2.83V36.94c0-1.56-1.27-2.83-2.83-2.83Zm.33 18.75c0 .18-.15.33-.33.33h-4.16c-.18 0-.33-.15-.33-.33V36.95c0-.18.15-.33.33-.33h4.16c.18 0 .33.15.33.33v15.91Z"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "44.5",
      cy: "85.56",
      r: "2.03"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDataPacks104 = (WhiteLabelDataPacks104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDataPacks56.tsx


var WhiteLabelDataPacks56_excluded = ["className"];
function WhiteLabelDataPacks56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDataPacks56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDataPacks56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDataPacks56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDataPacks56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDataPacks56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDataPacks56_objectSpread(WhiteLabelDataPacks56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "28.53",
        y: "17.02",
        width: "2.53",
        height: "11.6",
        rx: ".17",
        ry: ".17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "35.1",
        y: "14.12",
        width: "2.53",
        height: "14.5",
        rx: ".18",
        ry: ".18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "41.68",
        y: "19.92",
        width: "2.53",
        height: "8.7",
        rx: ".18",
        ry: ".18"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-stroke",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.34 29.42v16.27c0 2.1-1.7 3.8-3.8 3.8H16.59c-2.1 0-3.8-1.7-3.8-3.8V10.3c0-2.1 1.7-3.8 3.8-3.8h15.95c2.1 0 3.8 1.7 3.8 3.8v3.1M21.67 18.99v6.09M18.63 22.03h6.08"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.89 17.02c.1 0 .17.08.17.17v11.25c0 .1-.08.17-.17.17H28.7c-.1 0-.17-.08-.17-.17V17.19c0-.1.08-.17.17-.17h2.19m0-1.5H28.7c-.92 0-1.67.75-1.67 1.67v11.25c0 .92.75 1.67 1.67 1.67h2.19c.92 0 1.67-.75 1.67-1.67V17.19c0-.92-.75-1.67-1.67-1.67ZM37.46 14.12c.1 0 .18.08.18.18v14.15c0 .1-.08.18-.18.18h-2.18a.18.18 0 0 1-.18-.18V14.3c0-.1.08-.18.18-.18h2.18m0-1.5h-2.18c-.93 0-1.68.75-1.68 1.68v14.15c0 .93.75 1.68 1.68 1.68h2.18c.93 0 1.68-.75 1.68-1.68V14.3c0-.93-.75-1.68-1.68-1.68ZM44.04 19.92c.1 0 .18.08.18.18v8.35c0 .1-.08.18-.18.18h-2.18a.18.18 0 0 1-.18-.18V20.1c0-.1.08-.18.18-.18h2.18m0-1.5h-2.18c-.92 0-1.68.75-1.68 1.68v8.35c0 .92.75 1.68 1.68 1.68h2.18c.92 0 1.68-.75 1.68-1.68V20.1c0-.92-.75-1.68-1.68-1.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.57",
        cy: "45.61",
        r: "1.06",
        className: "WhiteLabel-strokeinverted"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDataPacks56 = (WhiteLabelDataPacks56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDataPool104.tsx


var WhiteLabelDataPool104_excluded = ["className"];
function WhiteLabelDataPool104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDataPool104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDataPool104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDataPool104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDataPool104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDataPool104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDataPool104_objectSpread(WhiteLabelDataPool104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M37.26 38.49h28.82v28.82H37.26z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.73 81.23H26.29c-3.83 0-6.93-3.1-6.93-6.93V18.23c0-3.83 3.1-6.93 6.93-6.93h24.44c3.83 0 6.93 3.1 6.93 6.93v4.63"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.68 38.49v-8.7c0-3.83 3.1-6.93 6.93-6.93h24.44c3.83 0 6.93 3.1 6.93 6.93v56.07c0 3.83-3.1 6.93-6.93 6.93H57.61c-3.83 0-6.93-3.1-6.93-6.93V67.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.26 38.49h28.82v28.82H37.26z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M57.66 47.47h-9.65c-1.27 0-2.29 1.02-2.29 2.29v3.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m55.33 44.86 2.33 2.61-2.17 2.44M45.7 58.33h9.65c1.27 0 2.29-1.02 2.29-2.29v-3.16"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.03 60.95-2.33-2.62 2.17-2.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.51",
        cy: "74.98",
        r: "1.72"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "69.83",
        cy: "86.54",
        r: "1.72"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDataPool104 = (WhiteLabelDataPool104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDataPool56.tsx


var WhiteLabelDataPool56_excluded = ["className"];
function WhiteLabelDataPool56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDataPool56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDataPool56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDataPool56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDataPool56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDataPool56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDataPool56_objectSpread(WhiteLabelDataPool56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M18.97 21.31h16.6v16.6h-16.6z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "19.69",
        cy: "42.33",
        r: ".99"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "37.73",
        cy: "48.99",
        r: ".99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.73 45.93H12.65c-2.2 0-3.99-1.79-3.99-3.99V9.64c0-2.2 1.79-3.99 3.99-3.99h14.08c2.2 0 3.99 1.79 3.99 3.99v2.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.7 21.31V16.3c0-2.2 1.79-3.99 3.99-3.99h14.08c2.2 0 3.99 1.79 3.99 3.99v32.3c0 2.2-1.79 3.99-3.99 3.99H30.69c-2.2 0-3.99-1.79-3.99-3.99V37.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.97 21.31h16.6v16.6h-16.6z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.72 26.48h-5.56c-.73 0-1.32.59-1.32 1.32v1.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.38 24.98 1.34 1.5-1.25 1.41M23.83 32.74h5.56c.73 0 1.32-.59 1.32-1.32V29.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.17 34.25-1.34-1.51 1.25-1.4"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDataPool56 = (WhiteLabelDataPool56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDelivery104.tsx


var WhiteLabelDelivery104_excluded = ["className"];
function WhiteLabelDelivery104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDelivery104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDelivery104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDelivery104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDelivery104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDelivery104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDelivery104_objectSpread(WhiteLabelDelivery104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "5.74",
        y: "17.07",
        width: "87.18",
        height: "64.55",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.74 81.62h87.17V17.07H5.74v64.55z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "5.74",
        y: "17.07",
        width: "87.18",
        height: "64.55",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.74 81.62h87.17V17.07H5.74v64.55z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m61.83 30.66-41.2-.11v35.27h45.68V35.15c0-2.48-2-4.48-4.48-4.49Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.96 71.12h5.77l2.86-14c.27-1.34.01-2.73-.73-3.87l-6.82-10.6a7.675 7.675 0 0 0-6.45-3.52H66.32v31.99h5.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M77.92 66.11a6.03 6.03 0 1 1 0 12.06 6.03 6.03 0 0 1 0-12.06ZM45.02 71.12H66.3v-5.31H25.54v5.31h7.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.31 35.2v30.62s-45.68.04-45.67 0V30.54l41.14.11c2.5 0 4.53 2.04 4.53 4.54ZM74.95 57.57h-3.18M85.04 43.72H71.57v9.01h19.91M38.82 66.11a6.03 6.03 0 1 1 0 12.06 6.03 6.03 0 0 1 0-12.06ZM76.28 43.93v8.09M25.88 51.21H11.3M23.35 57.17h-6.7M16.15 45.26h-3.82M22.81 39.3h-8.57"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDelivery104 = (WhiteLabelDelivery104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDelivery56.tsx


var WhiteLabelDelivery56_excluded = ["className"];
function WhiteLabelDelivery56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDelivery56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDelivery56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDelivery56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDelivery56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDelivery56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDelivery56_objectSpread(WhiteLabelDelivery56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("defs", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "3.09",
        y: "9.19",
        width: "46.94",
        height: "34.76",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M3.09 43.95h46.94V9.19H3.09v34.76z"
        })
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("mask", {
        x: "3.09",
        y: "9.19",
        width: "46.94",
        height: "34.76",
        maskUnits: "userSpaceOnUse",
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M3.09 43.95h46.94V9.19H3.09v34.76z"
        })
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m33.29 16.51-22.18-.06v18.99h24.6V18.93c0-1.33-1.08-2.41-2.41-2.42Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.21 38.3h3.11l1.54-7.54c.15-.72 0-1.47-.39-2.09l-3.67-5.71a4.138 4.138 0 0 0-3.47-1.9h-6.61v17.23h3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.96 35.6c1.79 0 3.25 1.45 3.25 3.25s-1.45 3.25-3.25 3.25c-1.79 0-3.25-1.45-3.25-3.25s1.45-3.25 3.25-3.25ZM24.24 38.3H35.7v-2.86H13.75v2.86h3.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.7 18.95v16.49s-24.6.02-24.59 0V16.45l22.15.06c1.35 0 2.44 1.1 2.44 2.44ZM40.36 31h-1.72M45.79 23.54h-7.25v4.85h10.72M20.9 35.6c1.79 0 3.25 1.45 3.25 3.25S22.7 42.1 20.9 42.1c-1.79 0-3.25-1.45-3.25-3.25s1.45-3.25 3.25-3.25ZM41.08 23.65v4.36M13.94 27.58H6.09M12.57 30.78h-3.6M8.7 24.37H6.64M12.28 21.16H7.67"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDelivery56 = (WhiteLabelDelivery56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDownload104.tsx


var WhiteLabelDownload104_excluded = ["className"];
function WhiteLabelDownload104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDownload104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDownload104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDownload104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDownload104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDownload104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDownload104_objectSpread(WhiteLabelDownload104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "43.41",
        cy: "85.78",
        r: "2.03",
        className: "WhiteLabel-strokeinverted"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M83.07 51.47v6.63c0 1.72-1.4 3.12-3.12 3.12H51.84c-1.72 0-3.12-1.4-3.12-3.12v-6.63",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.9 67.44v18.54c0 3.95-3.2 7.15-7.15 7.15H28.09c-3.95 0-7.15-3.2-7.15-7.15V18.2c0-3.95 3.2-7.15 7.15-7.15h30.66c3.95 0 7.15 3.2 7.15 7.15v3.81"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.07 51.47v6.63c0 1.72-1.4 3.12-3.12 3.12H51.84c-1.72 0-3.12-1.4-3.12-3.12v-6.63M65.9 30.39v21.08l9.57-9.57M56.33 41.9l9.57 9.57"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDownload104 = (WhiteLabelDownload104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelDownload56.tsx


var WhiteLabelDownload56_excluded = ["className"];
function WhiteLabelDownload56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelDownload56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelDownload56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelDownload56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelDownload56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelDownload56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelDownload56_objectSpread(WhiteLabelDownload56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.19 27.68v3.45c0 .9-.73 1.62-1.62 1.62H27.93c-.9 0-1.62-.73-1.62-1.62v-3.45",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.24 36v9.66a3.73 3.73 0 0 1-3.73 3.73H15.53a3.73 3.73 0 0 1-3.73-3.73V10.34a3.73 3.73 0 0 1 3.73-3.73h15.98a3.73 3.73 0 0 1 3.73 3.73v1.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.19 27.68v3.45c0 .9-.73 1.62-1.62 1.62H27.93c-.9 0-1.62-.73-1.62-1.62v-3.45M35.24 16.7v10.98l4.99-4.99M30.25 22.69l4.99 4.99"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.52",
        cy: "45.55",
        r: "1.06",
        className: "WhiteLabel-strokeinverted"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelDownload56 = (WhiteLabelDownload56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelESIM104.tsx


var WhiteLabelESIM104_excluded = ["className"];
function WhiteLabelESIM104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelESIM104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelESIM104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelESIM104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelESIM104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelESIM104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelESIM104_objectSpread(WhiteLabelESIM104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m56.7 35.14-6.08 6.84v11.95c0 .7.57 1.28 1.28 1.28H78c.7 0 1.28-.57 1.28-1.28V36.41c0-.7-.57-1.28-1.28-1.28H56.7Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.36 61.04v24.55a7.08 7.08 0 0 1-7.08 7.08H25.89a7.08 7.08 0 0 1-7.08-7.08V18.41a7.08 7.08 0 0 1 7.08-7.08h30.39a7.08 7.08 0 0 1 7.08 7.08v9.84"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m56.7 35.14-6.08 6.84v11.95c0 .7.57 1.28 1.28 1.28H78c.7 0 1.28-.57 1.28-1.28V36.41c0-.7-.57-1.28-1.28-1.28H56.7Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "41.08",
        cy: "85.4",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.89 27h7.64v2.5h-7.64zM50.76 59.79h7.64v2.5h-7.64zM41.25 58.33l-2.24 1.11a5.093 5.093 0 0 0 4.58 2.84h3.35v-2.5h-3.35c-1 0-1.9-.56-2.35-1.46ZM60.36 27H68v2.5h-7.64zM43.6 29.5h1.48V27H43.6c-2.82 0-5.12 2.29-5.12 5.12v.09l2.5-.09c0-1.44 1.17-2.62 2.62-2.62ZM38.48 47.49h2.5v7.64h-2.5zM38.48 36.03h2.5v7.64h-2.5zM83.95 39.46h2.5v7.64h-2.5zM62.23 59.79h7.64v2.5h-7.64zM83.81 27.64l-1.21 2.19c.83.46 1.35 1.34 1.35 2.29v3.52h2.5v-3.52a5.12 5.12 0 0 0-2.64-4.48ZM83.95 57.17c0 .32-.06.63-.17.92l2.34.88c.22-.58.33-1.18.33-1.8v-6.25h-2.5v6.25ZM81.33 59.79h-7.64v2.5h7.65c.38 0 .75-.04 1.12-.13l-.55-2.44c-.19.04-.42.07-.58.06ZM71.82 27h7.64v2.5h-7.64z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelESIM104 = (WhiteLabelESIM104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelESIM56.tsx


var WhiteLabelESIM56_excluded = ["className"];
function WhiteLabelESIM56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelESIM56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelESIM56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelESIM56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelESIM56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelESIM56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelESIM56_objectSpread(WhiteLabelESIM56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m30.46 19.17-3.18 3.58v6.26c0 .37.3.67.67.67h13.66c.37 0 .67-.3.67-.67v-9.17c0-.37-.3-.67-.67-.67H30.46Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.95 32.73v12.85c0 2.05-1.66 3.71-3.71 3.71H14.33c-2.05 0-3.71-1.66-3.71-3.71V10.42c0-2.05 1.66-3.71 3.71-3.71h15.91c2.05 0 3.71 1.66 3.71 3.71v5.15"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m30.46 19.17-3.18 3.58v6.26c0 .37.3.67.67.67h13.66c.37 0 .67-.3.67-.67v-9.17c0-.37-.3-.67-.67-.67H30.46Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "22.29",
        cy: "45.48",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.46 31.27-1.34.67a2.75 2.75 0 0 0 2.48 1.54h1.75v-1.5H23.6c-.49 0-.92-.27-1.14-.71ZM26.37 14.82h4v1.5h-4zM27.35 31.98h4v1.5h-4zM20.83 25.64h1.5v4h-1.5zM20.83 19.64h1.5v4h-1.5zM23.6 16.32h.77v-1.5h-.77a2.77 2.77 0 0 0-2.77 2.77v.05l1.5-.05c0-.7.57-1.27 1.27-1.27ZM32.37 14.82h4v1.5h-4zM44.63 30.71c0 .15-.03.3-.08.45l1.4.53c.12-.31.18-.64.18-.98v-3.27h-1.5v3.27ZM44.63 21.43h1.5v4h-1.5zM44.69 15.16l-.73 1.31c.41.22.66.65.66 1.12v1.84h1.5v-1.84c0-1.01-.55-1.94-1.43-2.43ZM33.35 31.98h4v1.5h-4zM43.35 31.98h-4v1.5h4c.21 0 .41-.02.62-.07l-.33-1.46c-.09.02-.19.03-.28.03ZM38.37 14.82h4v1.5h-4z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelESIM56 = (WhiteLabelESIM56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelEmptyStateBox104.tsx


var WhiteLabelEmptyStateBox104_excluded = ["className"];
function WhiteLabelEmptyStateBox104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelEmptyStateBox104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelEmptyStateBox104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelEmptyStateBox104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelEmptyStateBox104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelEmptyStateBox104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelEmptyStateBox104_objectSpread(WhiteLabelEmptyStateBox104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M84.52 40.29 52 36.06l-32.52 4.23L52 44.52l32.52-4.23z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.48 50.4v16.16L52 73.82l32.52-7.26V50.91M52 73.64v-28.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.67 40.29-9.1 8.08 35.37 7.08 5.59-10.93M84.33 40.29l9.1 8.08-35.37 7.08-5.59-9.92"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 36.06 58.06 30l32.52 4.23-6.25 6.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.19 36.06 46.12 30 13.6 34.23l6.25 6.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.52 40.29 52 44.52l-32.52-4.23L52 36.06l32.52 4.23z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelEmptyStateBox104 = (WhiteLabelEmptyStateBox104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelEmptyStateBox56.tsx


var WhiteLabelEmptyStateBox56_excluded = ["className"];
function WhiteLabelEmptyStateBox56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelEmptyStateBox56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelEmptyStateBox56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelEmptyStateBox56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelEmptyStateBox56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelEmptyStateBox56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelEmptyStateBox56_objectSpread(WhiteLabelEmptyStateBox56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M44.99 21.93 28 19.72l-16.99 2.21L28 24.14l16.99-2.21z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.01 27.21v8.45L28 39.45l16.99-3.79v-8.19M28 39.35V24.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.1 21.93-4.75 4.22 18.48 3.7 2.92-5.71M44.9 21.93l4.75 4.22-18.48 3.7-2.92-5.18M28 19.72l3.17-3.17 16.99 2.21-3.26 3.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.1 19.72-3.17-3.17-16.99 2.21 3.26 3.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.99 21.93 28 24.14l-16.99-2.21L28 19.72l16.99 2.21z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelEmptyStateBox56 = (WhiteLabelEmptyStateBox56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelError104.tsx


var WhiteLabelError104_excluded = ["className"];
function WhiteLabelError104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelError104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelError104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelError104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelError104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelError104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelError104_objectSpread(WhiteLabelError104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M68.81 14.04H35.19L11.42 36.27v31.45l23.77 22.24h33.62l23.77-22.24V36.27L68.81 14.04Zm14.27 46.89c0 2.2-.91 4.31-2.52 5.81l-13.9 13a7.956 7.956 0 0 1-5.44 2.15H42.79c-2.02 0-3.96-.77-5.44-2.15l-13.9-13a7.944 7.944 0 0 1-2.52-5.81V43.07c0-2.2.91-4.31 2.52-5.81l13.9-13a7.956 7.956 0 0 1 5.44-2.15h18.43c2.02 0 3.96.77 5.44 2.15l13.9 13a7.944 7.944 0 0 1 2.52 5.81v17.86Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M83.08 60.93c0 2.2-.91 4.31-2.52 5.81l-13.9 13a7.956 7.956 0 0 1-5.44 2.15H42.79c-2.02 0-3.96-.77-5.44-2.15l-13.9-13a7.944 7.944 0 0 1-2.52-5.81V43.07c0-2.2.91-4.31 2.52-5.81l13.9-13a7.956 7.956 0 0 1 5.44-2.15h18.43c2.02 0 3.96.77 5.44 2.15l13.9 13a7.944 7.944 0 0 1 2.52 5.81v17.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.81 14.04H35.19L11.42 36.27v31.45l23.77 22.24h33.62l23.77-22.24V36.27L68.81 14.04ZM40.08 64.09l24.01-24.01M63.92 63.92 39.91 39.91"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelError104 = (WhiteLabelError104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelError56.tsx


var WhiteLabelError56_excluded = ["className"];
function WhiteLabelError56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelError56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelError56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelError56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelError56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelError56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelError56_objectSpread(WhiteLabelError56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.81 8.12H19.2L6.75 19.77v16.47L19.2 47.89h17.61l12.45-11.65V19.77L36.81 8.12Zm7.47 24.56c0 1.15-.48 2.26-1.32 3.04l-7.28 6.81c-.77.72-1.79 1.12-2.85 1.12h-9.65c-1.06 0-2.08-.4-2.85-1.12l-7.28-6.81a4.178 4.178 0 0 1-1.32-3.04v-9.35c0-1.15.48-2.26 1.32-3.04l7.28-6.81c.77-.72 1.79-1.12 2.85-1.12h9.65c1.06 0 2.08.4 2.85 1.12l7.28 6.81c.84.79 1.32 1.89 1.32 3.04v9.35Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M44.28 32.68c0 1.15-.48 2.26-1.32 3.04l-7.28 6.81c-.77.72-1.79 1.12-2.85 1.12h-9.65c-1.06 0-2.08-.4-2.85-1.12l-7.28-6.81a4.178 4.178 0 0 1-1.32-3.04v-9.35c0-1.15.48-2.26 1.32-3.04l7.28-6.81c.77-.72 1.79-1.12 2.85-1.12h9.65c1.06 0 2.08.4 2.85 1.12l7.28 6.81c.84.79 1.32 1.89 1.32 3.04v9.35Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.81 8.12H19.2L6.75 19.77v16.47L19.2 47.89h17.61l12.45-11.65V19.77L36.81 8.12ZM21.76 34.33l12.57-12.57M34.24 34.24 21.67 21.67"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelError56 = (WhiteLabelError56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelFailedConnection104.tsx


var WhiteLabelFailedConnection104_excluded = ["className"];
function WhiteLabelFailedConnection104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelFailedConnection104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelFailedConnection104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelFailedConnection104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelFailedConnection104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelFailedConnection104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelFailedConnection104_objectSpread(WhiteLabelFailedConnection104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M91.17 72.94 60.99 20.67c-4-6.93-13.99-6.93-17.99 0L12.82 72.94c-4 6.93 1 15.58 9 15.58h60.36c8 0 12.99-8.66 9-15.58Zm-9.94 6.69H22.77c-1.57 0-2.56-1.7-1.77-3.07l29.23-50.63c.79-1.36 2.75-1.36 3.54 0L83 76.56c.79 1.36-.2 3.07-1.77 3.07Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 64.68c-1.49 0-2.7 1.21-2.7 2.7s1.21 2.7 2.7 2.7 2.7-1.21 2.7-2.7-1.21-2.7-2.7-2.7Z",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.52 55.74c2.95-2.9 7.02-4.67 11.48-4.67s8.53 1.78 11.48 4.67M46.29 61.51c1.48-1.4 3.5-2.27 5.71-2.27s4.24.87 5.71 2.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.17 72.94 60.99 20.67c-4-6.93-13.99-6.93-17.99 0L12.82 72.94c-4 6.93 1 15.58 9 15.58h60.36c8 0 12.99-8.66 9-15.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.23 79.63H22.77c-1.57 0-2.56-1.7-1.77-3.07l29.23-50.63c.79-1.36 2.75-1.36 3.54 0L83 76.56c.79 1.36-.2 3.07-1.77 3.07Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelFailedConnection104 = (WhiteLabelFailedConnection104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelFailedConnection56.tsx


var WhiteLabelFailedConnection56_excluded = ["className"];
function WhiteLabelFailedConnection56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelFailedConnection56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelFailedConnection56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelFailedConnection56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelFailedConnection56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelFailedConnection56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelFailedConnection56_objectSpread(WhiteLabelFailedConnection56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.48 38.95 32.7 11.62c-2.09-3.62-7.32-3.62-9.41 0L7.51 38.95c-2.09 3.62.52 8.15 4.7 8.15h31.55c4.18 0 6.79-4.53 4.7-8.15Zm-5.2 3.5H12.72c-.82 0-1.34-.89-.93-1.6l15.28-26.47a1.07 1.07 0 0 1 1.85 0L44.2 40.85c.41.71-.1 1.6-.93 1.6Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "36.04",
      r: "1.51",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22 29.96c1.54-1.51 3.67-2.44 6-2.44s4.46.93 6 2.44M25.01 32.97a4.35 4.35 0 0 1 5.98 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.48 38.95 32.7 11.62c-2.09-3.62-7.32-3.62-9.41 0L7.51 38.95c-2.09 3.62.52 8.15 4.7 8.15h31.55c4.18 0 6.79-4.53 4.7-8.15Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.28 42.45H12.72c-.82 0-1.34-.89-.93-1.6l15.28-26.47a1.07 1.07 0 0 1 1.85 0L44.2 40.85c.41.71-.1 1.6-.93 1.6Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelFailedConnection56 = (WhiteLabelFailedConnection56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelFeedback104.tsx


var WhiteLabelFeedback104_excluded = ["className"];
function WhiteLabelFeedback104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelFeedback104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelFeedback104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelFeedback104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelFeedback104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelFeedback104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelFeedback104_objectSpread(WhiteLabelFeedback104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.36 14.87H20.55a9.18 9.18 0 0 0-9.18 9.18v23.79a9.18 9.18 0 0 0 9.18 9.18h7.1l.08 6.49c.02 1.87 2.44 2.61 3.5 1.07l7.85-7.56h15.28a9.18 9.18 0 0 0 9.18-9.18V24.05a9.18 9.18 0 0 0-9.18-9.18Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.54 38.58h29.1v42.16H76.36l-.08 6.49c-.02 1.87-2.44 2.61-3.5 1.07l-7.85-7.56H40.47V57.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.36 14.87H20.55a9.18 9.18 0 0 0-9.18 9.18v23.79a9.18 9.18 0 0 0 9.18 9.18h7.1l.08 6.49c.02 1.87 2.44 2.61 3.5 1.07l7.85-7.56h15.28a9.18 9.18 0 0 0 9.18-9.18V24.05a9.18 9.18 0 0 0-9.18-9.18Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.08 28.86c0-3.52 2.85-6.37 6.37-6.37s6.37 2.85 6.37 6.37-2.85 6.37-6.37 6.37v6.4"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "37.54",
      cy: "47.94",
      r: "1.77",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelFeedback104 = (WhiteLabelFeedback104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelFeedback56.tsx


var WhiteLabelFeedback56_excluded = ["className"];
function WhiteLabelFeedback56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelFeedback56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelFeedback56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelFeedback56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelFeedback56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelFeedback56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelFeedback56_objectSpread(WhiteLabelFeedback56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.24 8.48H11.46c-2.67 0-4.83 2.16-4.83 4.83v12.51c0 2.67 2.16 4.83 4.83 4.83h3.73l.04 3.41c.01.98 1.28 1.37 1.84.56l4.13-3.97h8.03c2.67 0 4.83-2.16 4.83-4.83V13.31c0-2.67-2.16-4.83-4.83-4.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17 15.83a3.35 3.35 0 1 1 3.35 3.35v3.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "20.4",
        cy: "25.87",
        r: ".93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.07 20.94h15.3v22.17h-8.56l-.04 3.41c-.01.98-1.28 1.37-1.84.56l-4.13-3.97H21.94V30.65"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.24 8.48H11.46c-2.67 0-4.83 2.16-4.83 4.83v12.51c0 2.67 2.16 4.83 4.83 4.83h3.73l.04 3.41c.01.98 1.28 1.37 1.84.56l4.13-3.97h8.03c2.67 0 4.83-2.16 4.83-4.83V13.31c0-2.67-2.16-4.83-4.83-4.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M17 15.83a3.35 3.35 0 1 1 3.35 3.35v3.36"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "20.4",
      cy: "25.87",
      r: ".93",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelFeedback56 = (WhiteLabelFeedback56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelGift104.tsx


var WhiteLabelGift104_excluded = ["className"];
function WhiteLabelGift104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelGift104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelGift104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelGift104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelGift104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelGift104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelGift104_objectSpread(WhiteLabelGift104_objectSpread({
    width: "104",
    height: "104",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "14.02",
      y: "38.47",
      width: "75.96",
      height: "9.02",
      rx: "1",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M86.29 48.47V85.7c0 1.73-1.41 3.14-3.14 3.14h-62.3c-1.73 0-3.14-1.4-3.14-3.14V48.47",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "14.02",
      y: "38.47",
      width: "75.96",
      height: "9.02",
      rx: "1",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.99 37.36v50.93",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M51.94 37.36c-.06-.22-1.08-.3-1.26-.33-3.42-.61-6.74-1.55-10.02-2.73-5.24-1.87-12.27-4.61-14.91-9.95-2.93-5.93 2.46-11.01 8.21-9.54 6.63 1.69 11.08 9.18 14.12 14.69.71 1.28 1.38 2.57 2.02 3.88.63 1.27 1.47 2.61 1.84 3.98ZM52 37.36c.06-.22 1.08-.3 1.26-.33 3.42-.61 6.74-1.55 10.02-2.73 5.24-1.87 12.27-4.61 14.91-9.95 2.93-5.93-2.46-11.01-8.21-9.54-6.63 1.69-11.08 9.18-14.12 14.69-.71 1.28-1.38 2.57-2.02 3.88-.63 1.27-1.47 2.61-1.84 3.98Z",
      className: "WhiteLabel-stroke"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelGift104 = (WhiteLabelGift104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelGift56.tsx


var WhiteLabelGift56_excluded = ["className"];
function WhiteLabelGift56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelGift56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelGift56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelGift56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelGift56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelGift56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelGift56_objectSpread(WhiteLabelGift56_objectSpread({
    width: "56",
    height: "56",
    xmlns: "http://www.w3.org/2000/svg",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "7.46",
      y: "20.67",
      width: "41.09",
      height: "4.96",
      rx: "1",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M46.51 25.85v18.87c0 1.73-1.41 3.14-3.14 3.14H12.62c-1.73 0-3.14-1.4-3.14-3.14V25.84",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
      x: "7.46",
      y: "20.67",
      width: "41.09",
      height: "4.96",
      rx: "1",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M27.97 20.12c-.03-.12-.58-.16-.68-.18-1.84-.33-3.63-.84-5.4-1.47-2.82-1.01-6.61-2.48-8.03-5.36-1.58-3.19 1.33-5.93 4.42-5.14 3.57.91 5.97 4.95 7.6 7.91.38.69.74 1.38 1.09 2.09.34.69.79 1.41.99 2.15h.01ZM28 20.12c.03-.12.58-.16.68-.18 1.84-.33 3.63-.84 5.4-1.47 2.82-1.01 6.61-2.48 8.03-5.36 1.58-3.19-1.33-5.93-4.42-5.14-3.57.91-5.97 4.95-7.6 7.91-.38.69-.74 1.38-1.09 2.09-.34.69-.79 1.41-.99 2.15H28Z",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.99 20.12v27.42",
      className: "WhiteLabel-stroke"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelGift56 = (WhiteLabelGift56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelHelp104.tsx


var WhiteLabelHelp104_excluded = ["className"];
function WhiteLabelHelp104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelHelp104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelHelp104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelHelp104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelHelp104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelHelp104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelHelp104_objectSpread(WhiteLabelHelp104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 11.59c-22.32 0-40.41 18.09-40.41 40.41S29.68 92.41 52 92.41 92.41 74.32 92.41 52 74.32 11.59 52 11.59Zm0 71.7c-17.37 0-31.46-14.08-31.46-31.46S34.62 20.37 52 20.37s31.46 14.08 31.46 31.46S69.38 83.29 52 83.29Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "40.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "40.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.83",
        r: "31.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.63 42.65c0-4.62 3.75-8.37 8.37-8.37s8.37 3.75 8.37 8.37-3.75 8.37-8.37 8.37v8.41"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "51.77",
      cy: "67.39",
      r: "1.99",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelHelp104 = (WhiteLabelHelp104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelHelp56.tsx


var WhiteLabelHelp56_excluded = ["className"];
function WhiteLabelHelp56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelHelp56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelHelp56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelHelp56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelHelp56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelHelp56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelHelp56_objectSpread(WhiteLabelHelp56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28 6.72C16.25 6.72 6.72 16.25 6.72 28S16.25 49.28 28 49.28 49.28 39.75 49.28 28 39.75 6.72 28 6.72Zm0 37.76c-9.15 0-16.57-7.42-16.57-16.57S18.85 11.34 28 11.34s16.57 7.42 16.57 16.57S37.15 44.48 28 44.48Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "21.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "21.28"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.91",
        r: "16.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.59 23.08c0-2.44 1.97-4.41 4.41-4.41s4.41 1.97 4.41 4.41-1.97 4.41-4.41 4.41v4.43"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "27.88",
      cy: "36.11",
      r: "1.05",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelHelp56 = (WhiteLabelHelp56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInformation104.tsx


var WhiteLabelInformation104_excluded = ["className"];
function WhiteLabelInformation104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInformation104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInformation104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInformation104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInformation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInformation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInformation104_objectSpread(WhiteLabelInformation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 11.66c-22.32 0-40.41 18.09-40.41 40.41S29.68 92.48 52 92.48s40.41-18.09 40.41-40.41S74.32 11.66 52 11.66Zm0 71.94c-17.41 0-31.53-14.11-31.53-31.53S34.58 20.54 52 20.54s31.53 14.11 31.53 31.53S69.42 83.6 52 83.6Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "40.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "31.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 46.24v20.84"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "38.59",
      rx: "1.72",
      ry: "1.67",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInformation104 = (WhiteLabelInformation104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInformation56.tsx


var WhiteLabelInformation56_excluded = ["className"];
function WhiteLabelInformation56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInformation56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInformation56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInformation56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInformation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInformation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInformation56_objectSpread(WhiteLabelInformation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28 6.86c-11.7 0-21.18 9.48-21.18 21.18S16.3 49.22 28 49.22s21.18-9.48 21.18-21.18S39.7 6.86 28 6.86Zm0 37.71c-9.13 0-16.53-7.4-16.53-16.53S18.87 11.51 28 11.51s16.53 7.4 16.53 16.53S37.13 44.57 28 44.57Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "21.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "16.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 24.98v10.93"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "28",
        cy: "20.97",
        rx: ".9",
        ry: ".88"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInformation56 = (WhiteLabelInformation56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInstallation104.tsx


var WhiteLabelInstallation104_excluded = ["className"];
function WhiteLabelInstallation104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInstallation104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInstallation104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInstallation104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInstallation104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInstallation104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInstallation104_objectSpread(WhiteLabelInstallation104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m53.9 60.6 3.06 12.24 33.4-.15 1.52-.31-4.52-11.05-1.9-1.6-32.13.4.58.48Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.73 60.12 12.5 72.35l34.98.84 3.71-10.86 1.21-2.1-32.67-.12Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.4 60.24v31.81h33.06V73.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M73.38 60.12 82.2 43.5c4.08.52 8.04-1.14 10.04-5.02s1.14-7.82-1.44-10.79c-.32-.37-.94-.17-.99.32l-.58 5.81a.57.57 0 0 1-.23.4l-4.3 3.07a.57.57 0 0 1-.59.04l-4.16-2.15a.54.54 0 0 1-.3-.5v-5.29c0-.16.08-.32.21-.42l4.39-3.83c.37-.32.18-.94-.31-.99-3.91-.39-7.68 1.33-9.61 5.07-2 3.88-1.06 8.07 1.73 11.11L65.89 60.06l7.49.07Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m43.31 60.12-2.35-6.42-5.08-4.16-4.54 1.83-1.14 6.3.92 2.49 12.19-.04z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.88 49.54-4.54 1.83-5.63-15.35 4.54-1.83 5.63 15.35z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.68 34.34c-1.15.42-1.89 1.46-1.95 2.57-.04.69-.44 1.3-1.09 1.54l-2.34.86c-1 .37-2.1-.11-2.45-1.06l-2.44-6.65c-.35-.96.18-2.03 1.18-2.4l2.9-1.07c.36-.13.76 0 .98.32.71 1.06 2.12 1.52 3.43 1.04l1.78 4.86Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.92 29.48-.39-1.07c-.32-.86.13-1.82.99-2.14l17.08-6.29c1-.37 2.1.11 2.45 1.06a.59.59 0 0 1-.37.77c-2.14.7-9.27 3.42-7.56 8.1l.58 1.58c.32.86-.13 1.82-.99 2.14l-7.48 2.76c-.86.32-1.82-.13-2.13-.99l-.39-1.07-1.78-4.86h-.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.33 60.26 11.97 73.3h35.78l4.7-13.04H19.33z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m85.5 60.26 7.35 13.04H57.13l-4.69-13.04H85.5z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.34 60.24v31.81H19.28V73.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m52.12 39.88-.65-20.08-1.51-2.68-.14-4.36c0-.3.27-.56.62-.57l6.75-.15c.35-.01.65.23.66.53l.14 4.36-1.34 2.77.65 20.08-3.17.1h-2.01Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m62.02 60.12-.28-8.62c0-.13-.06-.26-.15-.36l-2.92-3.09c-.39-.42-.4-1.07-.02-1.49l2.68-2.98c.1-.11.15-.24.14-.39l-.08-2.46c-.02-.61-.53-1.08-1.13-1.06l-10.86.35c-.6.02-1.08.53-1.06 1.13l.08 2.46c0 .14.06.28.17.38l2.87 2.8c.41.4.44 1.05.08 1.49l-2.72 3.27a.54.54 0 0 0-.13.37l.26 8.2h13.07Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInstallation104 = (WhiteLabelInstallation104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInstallation56.tsx


var WhiteLabelInstallation56_excluded = ["className"];
function WhiteLabelInstallation56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInstallation56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInstallation56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInstallation56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInstallation56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInstallation56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInstallation56_objectSpread(WhiteLabelInstallation56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.86 32.63 1.65 6.59 17.98-.08.82-.17-2.43-5.95-1.03-.86-17.3.21.31.26Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.46 32.37-3.89 6.59 18.83.45 2-5.85.65-1.13-17.59-.06Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.05 32.44v17.13h17.8v-9.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.35 32.37 4.75-8.95c2.2.28 4.33-.61 5.41-2.7 1.08-2.09.61-4.21-.78-5.81-.17-.2-.51-.09-.53.17l-.31 3.13c-.01.09-.05.17-.12.22l-2.32 1.65c-.09.06-.22.08-.32.02l-2.24-1.16a.286.286 0 0 1-.16-.27v-2.85c0-.09.04-.17.11-.23l2.36-2.06c.2-.17.1-.51-.17-.53-2.11-.21-4.14.72-5.17 2.73-1.08 2.09-.57 4.35.93 5.98l-5.48 10.62 4.03.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.15 32.37-1.26-3.45-2.74-2.25-2.44.99-.62 3.39.5 1.34 6.56-.02z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.15 26.67-2.44.99-3.03-8.27 2.44-.98 3.03 8.26z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.51 18.49c-.62.23-1.02.79-1.05 1.38-.02.37-.24.7-.59.83l-1.26.46c-.54.2-1.13-.06-1.32-.57l-1.31-3.58c-.19-.52.1-1.09.64-1.29l1.56-.58c.19-.07.41 0 .53.17.38.57 1.14.82 1.85.56l.96 2.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.56 15.87-.21-.58a.9.9 0 0 1 .53-1.15l9.2-3.39c.54-.2 1.13.06 1.32.57.06.17-.03.36-.2.41-1.15.38-4.99 1.84-4.07 4.36l.31.85a.9.9 0 0 1-.53 1.15l-4.03 1.49a.9.9 0 0 1-1.15-.53l-.21-.58-.96-2.62Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m10.24 32.45-3.96 7.02h19.26l2.54-7.02H10.24z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m45.87 32.45 3.96 7.02H30.6l-2.53-7.02h17.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.02 32.44v17.13H10.21v-9.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m27.9 21.47-.35-10.81-.81-1.44-.08-2.35c0-.16.15-.3.33-.31l3.63-.08c.19 0 .35.12.36.29l.08 2.35-.72 1.49.35 10.81-1.71.05H27.9Z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m33.23 32.37-.15-4.64c0-.07-.03-.14-.08-.19l-1.57-1.66a.587.587 0 0 1-.01-.8l1.44-1.6c.05-.06.08-.13.08-.21l-.04-1.32a.591.591 0 0 0-.61-.57l-5.85.19c-.32.01-.58.29-.57.61l.04 1.32c0 .08.03.15.09.2l1.55 1.51c.22.22.24.57.04.8l-1.46 1.76c-.05.05-.07.12-.07.2l.14 4.42h7.04Z"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInstallation56 = (WhiteLabelInstallation56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternationalCalls104.tsx


var WhiteLabelInternationalCalls104_excluded = ["className"];
function WhiteLabelInternationalCalls104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternationalCalls104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternationalCalls104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternationalCalls104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternationalCalls104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternationalCalls104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternationalCalls104_objectSpread(WhiteLabelInternationalCalls104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.74 83.6a3.52 3.52 0 0 1 .32-4.98l6.21-5.47a6.756 6.756 0 0 0-2.61-2.53c-2.93-1.58-8.21-4.26-11.23-4.84-4.33-.83-3.83-4-3.83-7.17 0-2.38-1.41-5.41-2.11-6.78-.26-.51-.48-1.05-.59-1.61-1.77-8.6 3.7-8.29 3.7-8.29s9.67-1.17 13.34-5.84c2.29-2.91 2.31-8.09 2-11.57-.21-2.31.8-4.56 2.67-5.94l7.75-5.74c.33-.25.64-.53.92-.83-2.16-.38-4.38-.59-6.66-.59-21 0-38.02 17.02-38.02 38.02 0 18.62 13.39 34.1 31.07 37.37a25.15 25.15 0 0 1-1.75-1.9l-1.16-1.32ZM82.36 31.99A38.168 38.168 0 0 0 65.8 15.55c-.01.08-1.51 9.74 3.64 12.89 3.77 2.31 6.74 2.86 8.98 6.68l2.07-2.13a3.51 3.51 0 0 1 1.87-1Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M41.66 86.85c-17.68-3.27-31.07-18.76-31.07-37.39 0-21 17.02-38.02 38.02-38.02 14.7 0 27.45 8.34 33.77 20.54"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M55.66 92.2c36.29-8.81 37.79-39.01 37.75-43.13-.04-4.15-4.12-11.58-4.12-11.58-.14-.24-1.71-2.53-2.55-3.35l-1.26-1.23a3.525 3.525 0 0 0-4.99.07l-8.28 8.51a5.698 5.698 0 0 0 .11 8.05l4.4 4.28c-1.05 3.46-5.09 13.7-17.56 21.05L56 71.28a5.697 5.697 0 0 0-8.04-.51l-8.91 7.84a3.538 3.538 0 0 0-.32 4.98l1.16 1.32s4.91 6.14 10.74 7.46c2.11.48 5.02-.18 5.02-.18Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.28 73.15a6.688 6.688 0 0 0-2.62-2.52c-2.93-1.58-8.21-4.26-11.23-4.84-4.33-.83-3.83-4-3.83-7.17 0-2.38-1.41-5.41-2.11-6.78-.26-.51-.48-1.05-.59-1.61-1.77-8.6 3.7-8.29 3.7-8.29s9.67-1.17 13.34-5.84c2.29-2.91 2.31-8.09 2-11.57-.21-2.31.8-4.56 2.67-5.94l7.75-5.74c.33-.25.64-.53.92-.83M65.81 15.55c-.01.08-1.51 9.74 3.64 12.89 3.78 2.31 6.75 2.85 8.99 6.67"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternationalCalls104 = (WhiteLabelInternationalCalls104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternationalCalls56.tsx


var WhiteLabelInternationalCalls56_excluded = ["className"];
function WhiteLabelInternationalCalls56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternationalCalls56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternationalCalls56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternationalCalls56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternationalCalls56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternationalCalls56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternationalCalls56_objectSpread(WhiteLabelInternationalCalls56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M20.86 45.02c-.69-.79-.62-1.99.17-2.68l3.34-2.95a3.55 3.55 0 0 0-1.41-1.36c-1.58-.85-4.42-2.29-6.05-2.61-2.33-.45-2.06-2.15-2.06-3.86 0-1.28-.76-2.91-1.14-3.65-.14-.27-.26-.57-.32-.87-.95-4.63 1.99-4.46 1.99-4.46s5.21-.63 7.18-3.14c1.23-1.57 1.24-4.35 1.07-6.23-.11-1.25.43-2.46 1.44-3.2l4.17-3.09c.18-.13.34-.28.49-.45-1.16-.21-2.36-.32-3.58-.32C14.87 6.16 5.7 15.33 5.7 26.63c0 10.03 7.21 18.36 16.73 20.12-.59-.59-.94-1.02-.94-1.02l-.63-.71ZM44.35 17.23c-1.97-3.8-5.09-6.91-8.91-8.85 0 .04-.81 5.24 1.96 6.94 2.03 1.24 3.63 1.54 4.83 3.6l1.11-1.15c.28-.29.64-.47 1.01-.54Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M22.43 46.76C12.91 45 5.7 36.66 5.7 26.63c0-11.3 9.17-20.47 20.48-20.47 7.91 0 14.78 4.49 18.19 11.06"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.97 49.65c19.54-4.74 20.35-21.01 20.33-23.22-.02-2.23-2.22-6.23-2.22-6.23-.08-.13-.92-1.36-1.37-1.8l-.68-.66c-.75-.73-1.95-.71-2.69.04l-4.46 4.58c-1.18 1.21-1.15 3.15.06 4.34l2.37 2.3c-.57 1.86-2.74 7.38-9.46 11.34l-1.7-1.94a3.069 3.069 0 0 0-4.33-.27l-4.8 4.22c-.79.69-.86 1.89-.17 2.68l.63.71s2.64 3.3 5.78 4.02c1.14.26 2.7-.1 2.7-.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.38 39.39c-.33-.57-.82-1.04-1.41-1.36-1.58-.85-4.42-2.29-6.05-2.61-2.33-.45-2.06-2.15-2.06-3.86 0-1.28-.76-2.91-1.14-3.65-.14-.27-.26-.57-.32-.87-.95-4.63 1.99-4.46 1.99-4.46s5.21-.63 7.18-3.14c1.23-1.57 1.24-4.35 1.07-6.23-.11-1.25.43-2.46 1.44-3.2l4.17-3.09c.18-.13.34-.28.49-.45M35.43 8.37s-.81 5.24 1.96 6.94c2.03 1.25 3.63 1.53 4.84 3.59"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternationalCalls56 = (WhiteLabelInternationalCalls56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternationalMobileCall104.tsx


var WhiteLabelInternationalMobileCall104_excluded = ["className"];
function WhiteLabelInternationalMobileCall104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternationalMobileCall104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternationalMobileCall104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternationalMobileCall104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternationalMobileCall104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternationalMobileCall104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternationalMobileCall104_objectSpread(WhiteLabelInternationalMobileCall104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.85 11.05s-1.51 9.73 3.62 12.88c4.97 3.04 8.54 3.03 10.88 11.44h5.07c-2.76-10.63-9.99-19.44-19.57-24.31ZM48.66 6.93c-20.97 0-37.98 17.02-37.98 37.99S26.2 81.38 45.89 82.79c.06-.26.13-.5.15-.75.09-1.42.29-4.65.29-8.48 0-.92-.06-1.71-.13-2.39a6.663 6.663 0 0 0-3.48-5.1c-2.92-1.58-8.2-4.25-11.22-4.84-4.32-.83-3.83-3.99-3.83-7.16 0-2.37-1.4-5.41-2.12-6.77-.26-.52-.48-1.05-.59-1.6-1.77-8.59 3.7-8.28 3.7-8.28s9.66-1.16 13.32-5.83c2.28-2.91 2.3-8.08 1.99-11.57-.2-2.32.81-4.56 2.67-5.94l7.74-5.74c.33-.24.64-.53.92-.83a37.27 37.27 0 0 0-6.64-.59Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.61 80.64c-4.04 1.47-8.4 2.26-12.95 2.26-20.98 0-37.98-17.01-37.98-37.98S27.69 6.93 48.66 6.93c17.86 0 32.84 12.33 36.9 28.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.85 11.05s-1.51 9.73 3.62 12.88c4.97 3.04 8.55 3.01 10.89 11.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "61.61",
        y: "35.87",
        width: "31.14",
        height: "56.86",
        rx: "4.6",
        ry: "4.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.89 82.79c.06-.26.13-.5.15-.75.09-1.42.29-4.65.29-8.48 0-.92-.06-1.71-.13-2.39a6.663 6.663 0 0 0-3.48-5.1c-2.92-1.58-8.2-4.25-11.22-4.84-4.32-.83-3.83-3.99-3.83-7.16 0-2.37-1.4-5.41-2.12-6.77-.26-.52-.48-1.05-.59-1.6-1.77-8.59 3.7-8.28 3.7-8.28s9.66-1.16 13.32-5.83c2.28-2.91 2.3-8.08 1.99-11.57-.2-2.32.81-4.56 2.67-5.94l7.74-5.74c.33-.24.64-.53.92-.83"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "77.19",
      cy: "87.63",
      r: "1.4",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternationalMobileCall104 = (WhiteLabelInternationalMobileCall104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternationalMobileCall56.tsx


var WhiteLabelInternationalMobileCall56_excluded = ["className"];
function WhiteLabelInternationalMobileCall56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternationalMobileCall56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternationalMobileCall56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternationalMobileCall56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternationalMobileCall56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternationalMobileCall56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternationalMobileCall56_objectSpread(WhiteLabelInternationalMobileCall56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.38 4.99c-10.86 0-19.67 8.81-19.67 19.67s8.04 18.88 18.23 19.61c.03-.13.07-.26.08-.39.05-.73.15-2.41.15-4.39 0-.48-.03-.89-.07-1.24-.13-1.12-.8-2.1-1.8-2.64-1.51-.82-4.25-2.2-5.81-2.5-2.24-.43-1.98-2.07-1.98-3.7 0-1.23-.72-2.8-1.1-3.5-.13-.27-.25-.54-.3-.83-.91-4.45 1.91-4.29 1.91-4.29s5-.6 6.9-3.02c1.18-1.5 1.19-4.18 1.03-5.99-.1-1.2.42-2.36 1.38-3.08l4.01-2.97c.17-.12.33-.28.48-.43-1.11-.2-2.27-.3-3.44-.3ZM35.27 7.12s-.78 5.04 1.88 6.67c2.57 1.57 4.42 1.57 5.63 5.92h2.62A19.712 19.712 0 0 0 35.27 7.12Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-stroke",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "WhiteLabel-stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M33.08 43.15c-2.09.76-4.35 1.17-6.71 1.17-10.86 0-19.67-8.81-19.67-19.67S15.52 4.99 26.38 4.99c9.25 0 17 6.38 19.11 14.98"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.27 7.12s-.78 5.04 1.88 6.67c2.57 1.58 4.42 1.56 5.64 5.92"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
          x: "33.08",
          y: "19.97",
          width: "16.12",
          height: "29.44",
          rx: "2.38",
          ry: "2.38"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.94 44.27c.03-.13.07-.26.08-.39.05-.73.15-2.41.15-4.39 0-.48-.03-.89-.07-1.24-.13-1.12-.8-2.1-1.8-2.64-1.51-.82-4.25-2.2-5.81-2.5-2.24-.43-1.98-2.07-1.98-3.7 0-1.23-.72-2.8-1.1-3.5-.13-.27-.25-.54-.3-.83-.91-4.45 1.91-4.29 1.91-4.29s5-.6 6.9-3.02c1.18-1.5 1.19-4.18 1.03-5.99-.1-1.2.42-2.36 1.38-3.08l4.01-2.97c.17-.12.33-.28.48-.43"
        })]
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "41.15",
      cy: "46.77",
      r: ".72",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternationalMobileCall56 = (WhiteLabelInternationalMobileCall56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternet104.tsx


var WhiteLabelInternet104_excluded = ["className"];
function WhiteLabelInternet104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternet104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternet104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternet104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternet104_objectSpread(WhiteLabelInternet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m64.9 87.53 7.33-6.7 5.96 12.98 7.32-3.77-5.44-12.77 10.57.11L64.9 53.83v33.7z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M79.56 25.34c-2.6 1.27-5.23 2.37-7.97 3.27a61.13 61.13 0 0 1-20.64 2.97c-6.9-.17-13.77-1.53-20.31-4.07-2.47-.93-4.9-2.07-7.27-3.4"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.63 82.34c-4.23 1.7-8.84 2.63-13.68 2.63-20.26 0-36.68-16.42-36.68-36.68S30.69 11.6 50.95 11.6s36.68 16.42 36.68 36.68c0 7.2-2.07 13.91-5.65 19.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.88 82.94c-2.97-5.43-5.37-8.84-7.17-13.44-.1-.23-.2-.47-.27-.73-2.37-6.37-3.63-13.81-3.8-20.48-.2-7.04.8-14.07 3-20.78 1.54-4.57 3.6-8.97 6.2-13.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.37 72.46c2.6-1.47 5.3-2.7 8.07-3.7 6.27-2.33 12.87-3.6 19.51-3.77 4.51-.14 9.04.24 13.48 1.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M72.98 59.68c.76-3.83 1.18-7.74 1.28-11.4.2-6.64-.7-13.31-2.67-19.68-1.53-4.97-3.7-9.74-6.54-14.21"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.95 84.97V11.6"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M87.63 48.29H14.26"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M91.42 75.28 67.49 53.39c-.47-.43-1.07-.66-1.69-.66-.34 0-.68.07-1.01.21-.91.4-1.49 1.3-1.49 2.29v31.32c0 .99.59 1.89 1.49 2.29a2.515 2.515 0 0 0 2.7-.45l4.28-3.91 4.11 8.95c.28.62.81 1.1 1.46 1.32.27.09.54.14.82.14.39 0 .79-.09 1.14-.28l6.81-3.5a2.5 2.5 0 0 0 1.16-3.2l-3.56-8.35 6 .06h.02c1.03 0 1.95-.63 2.33-1.58.38-.96.13-2.06-.64-2.76Zm-6.45 13.61-6.81 3.5-5.54-12.06-6.81 6.23V55.24l23.93 21.89-9.82-.1 5.06 11.87Z",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternet104 = (WhiteLabelInternet104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelInternet56.tsx


var WhiteLabelInternet56_excluded = ["className"];
function WhiteLabelInternet56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelInternet56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelInternet56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelInternet56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelInternet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelInternet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelInternet56_objectSpread(WhiteLabelInternet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m34.35 46.97 4.02-3.67 3.27 7.11 4.01-2.06-2.98-7 5.8.05-14.12-12.9v18.47z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.36 43.67c-2.14.84-4.47 1.3-6.9 1.3-10.43 0-18.89-8.45-18.89-18.89S17.03 7.2 27.46 7.2s18.89 8.45 18.89 18.89c0 3.75-1.09 7.24-2.97 10.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.24 43.93c-1.53-2.8-2.76-4.55-3.69-6.92-.05-.12-.1-.24-.14-.38-1.22-3.28-1.87-7.11-1.96-10.54-.1-3.62.41-7.24 1.54-10.7.79-2.35 1.85-4.62 3.19-6.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.19 14.28c-1.34.65-2.69 1.22-4.1 1.68a31.479 31.479 0 0 1-10.63 1.53 30.92 30.92 0 0 1-10.45-2.09c-1.27-.48-2.52-1.06-3.74-1.75"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M13.26 38.53c1.34-.76 2.73-1.39 4.15-1.91a31.22 31.22 0 0 1 10.04-1.94 31 31 0 0 1 6.93.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.81 31.93c.39-1.96.6-3.96.65-5.84.1-3.42-.36-6.85-1.37-10.13a30.21 30.21 0 0 0-3.36-7.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.46 44.97V7.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.34 26.09H8.57"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.7 40.08 36.14 28.59a1.49 1.49 0 0 0-1.61-.26c-.54.24-.9.78-.9 1.37v16.44c0 .59.35 1.13.9 1.37.19.09.4.13.6.13.37 0 .73-.14 1.01-.39l2.06-1.88 2.05 4.46c.17.37.49.66.87.79.16.05.32.08.49.08.24 0 .47-.06.69-.17l3.57-1.84c.7-.36 1-1.2.69-1.92l-1.76-4.12 2.86.03h.01c.62 0 1.17-.38 1.4-.95.23-.58.08-1.24-.38-1.66Zm-6.17 1.06 2.66 6.23-3.57 1.84-2.91-6.33-3.57 3.27V29.71L47.7 41.2l-5.16-.05Z",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelInternet56 = (WhiteLabelInternet56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMail104.tsx


var WhiteLabelMail104_excluded = ["className"];
function WhiteLabelMail104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMail104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMail104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMail104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMail104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMail104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMail104_objectSpread(WhiteLabelMail104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M12.53 25.06 49.9 58.12c1.2 1.06 3 1.06 4.19 0l36.96-32.7c.6-.53.23-1.53-.58-1.53h-77.5c-.61 0-.9.76-.44 1.16Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.53 25.06 49.9 58.12c1.2 1.06 3 1.06 4.19 0l36.96-32.7c.6-.53.23-1.53-.58-1.53h-77.5c-.61 0-.9.76-.44 1.16Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "11.22",
        y: "23.9",
        width: "81.57",
        height: "56.2",
        rx: "2.25",
        ry: "2.25"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M46.32 54.81 11.99 79.24M92.29 79.54 57.85 54.81"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMail104 = (WhiteLabelMail104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMail56.tsx


var WhiteLabelMail56_excluded = ["className"];
function WhiteLabelMail56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMail56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMail56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMail56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMail56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMail56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMail56_objectSpread(WhiteLabelMail56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M7.38 13.92 26.91 31.2c.63.55 1.57.55 2.19 0l19.31-17.09c.32-.28.12-.8-.3-.8H7.61c-.32 0-.47.4-.23.61Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "6.69",
        y: "13.32",
        width: "42.62",
        height: "29.37",
        rx: "1.18",
        ry: "1.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.03 29.47 7.09 42.23M49.05 42.39 31.06 29.47M7.38 13.92 26.91 31.2c.63.55 1.57.55 2.19 0l19.31-17.09c.32-.28.12-.8-.3-.8H7.61c-.32 0-.47.4-.23.61Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMail56 = (WhiteLabelMail56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMobile104.tsx


var WhiteLabelMobile104_excluded = ["className"];
function WhiteLabelMobile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMobile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMobile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMobile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMobile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMobile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMobile104_objectSpread(WhiteLabelMobile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "67.03",
      cy: "38.3",
      r: "14.26",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.33 52.55v33.09a7.09 7.09 0 0 1-7.09 7.09H29.81a7.09 7.09 0 0 1-7.09-7.09V18.36a7.09 7.09 0 0 1 7.09-7.09h30.43a7.09 7.09 0 0 1 7.09 7.09v5.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "67.03",
        cy: "38.3",
        r: "14.26"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.02",
        cy: "85.45",
        r: "2.01"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m73.94 41.87-2.44-1.76a1.43 1.43 0 0 0-2.01.33l-.71.98c-3.32-1.54-4.59-4.03-4.94-4.87l1-1.19c.51-.61.44-1.52-.17-2.03l-2.29-1.94a.89.89 0 0 0-1.26.11l-.29.34c-.19.23-.34.48-.47.73-.03.05-.06.11-.09.17-1.27 2.72.13 4.96.13 4.96 1.35 3.55 6.55 7.09 9.53 7.62 2.77.49 3.95-1.85 3.95-1.85l.26-.36c.29-.4.2-.96-.2-1.25Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMobile104 = (WhiteLabelMobile104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMobile56.tsx


var WhiteLabelMobile56_excluded = ["className"];
function WhiteLabelMobile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMobile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMobile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMobile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMobile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMobile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMobile56_objectSpread(WhiteLabelMobile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "35.86",
      cy: "20.84",
      r: "7.45",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.01 28.29v17.29c0 2.05-1.66 3.71-3.71 3.71H16.39c-2.05 0-3.71-1.66-3.71-3.71V10.42c0-2.05 1.66-3.71 3.71-3.71H32.3c2.05 0 3.71 1.66 3.71 3.71v2.97"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.86",
        cy: "20.84",
        r: "7.45"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.35",
        cy: "45.48",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m39.47 22.71-1.27-.92a.751.751 0 0 0-1.05.17l-.37.51c-1.74-.81-2.4-2.1-2.58-2.55l.52-.62c.27-.32.23-.79-.09-1.06l-1.2-1.01a.472.472 0 0 0-.66.05l-.15.18c-.1.12-.18.25-.24.38-.02.03-.03.06-.05.09-.66 1.42.07 2.59.07 2.59.7 1.85 3.42 3.71 4.98 3.98 1.45.26 2.06-.97 2.06-.97l.14-.19c.15-.21.1-.5-.11-.65Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMobile56 = (WhiteLabelMobile56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMobileAndTablet104.tsx


var WhiteLabelMobileAndTablet104_excluded = ["className"];
function WhiteLabelMobileAndTablet104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMobileAndTablet104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMobileAndTablet104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMobileAndTablet104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMobileAndTablet104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMobileAndTablet104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMobileAndTablet104_objectSpread(WhiteLabelMobileAndTablet104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M40.45 41.71h28.66v28.66H40.45z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.75 87.76H23.58a6.89 6.89 0 0 1-6.89-6.89V17.88c0-3.8 3.08-6.89 6.89-6.89h42.96c3.8 0 6.89 3.08 6.89 6.89v11.91"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.75 40.77v-4.08c0-3.8 3.08-6.89 6.89-6.89h20.84c3.8 0 6.89 3.08 6.89 6.89v49.44c0 3.8-3.08 6.89-6.89 6.89H61.64a6.89 6.89 0 0 1-6.89-6.89V70.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M40.45 41.71h28.66v28.66H40.45zM54.78 48.89V63.4M62.04 56.04H47.53"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "45.06",
        cy: "78.44",
        r: "1.55"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "72.07",
        cy: "87.36",
        r: "1.55"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMobileAndTablet104 = (WhiteLabelMobileAndTablet104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelMobileAndTablet56.tsx


var WhiteLabelMobileAndTablet56_excluded = ["className"];
function WhiteLabelMobileAndTablet56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelMobileAndTablet56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelMobileAndTablet56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelMobileAndTablet56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelMobileAndTablet56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelMobileAndTablet56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelMobileAndTablet56_objectSpread(WhiteLabelMobileAndTablet56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M21.85 21.81h15.34v15.34H21.85z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.32",
        cy: "41.46",
        r: ".83"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.77",
        cy: "46.24",
        r: ".83"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.5 46.45H12.82c-2.04 0-3.69-1.65-3.69-3.69V9.05c0-2.04 1.65-3.69 3.69-3.69h22.99c2.04 0 3.69 1.65 3.69 3.69v6.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.5 21.3v-2.18c0-2.04 1.65-3.69 3.69-3.69h11.15c2.04 0 3.69 1.65 3.69 3.69v26.46c0 2.04-1.65 3.69-3.69 3.69H33.19c-2.04 0-3.69-1.65-3.69-3.69v-8.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.85 21.81h15.34v15.34H21.85zM29.52 25.65v7.76M33.4 29.48h-7.76"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelMobileAndTablet56 = (WhiteLabelMobileAndTablet56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelNetworkSpeed104.tsx


var WhiteLabelNetworkSpeed104_excluded = ["className"];
function WhiteLabelNetworkSpeed104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelNetworkSpeed104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelNetworkSpeed104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelNetworkSpeed104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelNetworkSpeed104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelNetworkSpeed104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelNetworkSpeed104_objectSpread(WhiteLabelNetworkSpeed104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M51.83 11.86C29.66 11.95 11.76 30 11.85 52.17c.09 22.17 18.14 40.07 40.31 39.98 22.17-.09 40.07-18.14 39.98-40.31C92.05 29.67 74 11.77 51.83 11.86Zm.3 72.95c-18.1.07-32.84-14.54-32.91-32.64-.07-18.1 14.54-32.84 32.64-32.91 18.1-.08 32.84 14.54 32.91 32.64.07 18.1-14.54 32.84-32.64 32.91Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.14 51.83C92.23 74 74.33 92.05 52.16 92.14c-22.17.09-40.22-17.81-40.31-39.98-.09-22.17 17.81-40.22 39.98-40.31C74 11.76 92.05 29.66 92.14 51.83Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.78 51.9c.07 18.1-14.54 32.84-32.64 32.91-18.1.07-32.84-14.54-32.91-32.64-.07-18.1 14.54-32.84 32.64-32.91 18.1-.08 32.84 14.54 32.91 32.64Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m75.06 74.9-2.67-2.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M84.57 51.85h-5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m75 28.83-2.67 2.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.96 19.32v5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m28.94 28.89 2.67 2.67"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.43 51.93h5.73"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29 74.95 2.66-2.67"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.95 65.79c-4.26-4.11-16.84-15.64-18.01-16.47a3.297 3.297 0 0 0-3.84 5.36c1.17.84 16.14 9.02 21.41 11.72.39.2.76-.31.44-.62Zm-18.9-13.01c-.41.58-1.22.72-1.8.3-.58-.42-.71-1.22-.3-1.8.42-.58 1.22-.71 1.8-.3.58.42.72 1.22.3 1.8Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelNetworkSpeed104 = (WhiteLabelNetworkSpeed104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelNetworkSpeed56.tsx


var WhiteLabelNetworkSpeed56_excluded = ["className"];
function WhiteLabelNetworkSpeed56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelNetworkSpeed56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelNetworkSpeed56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelNetworkSpeed56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelNetworkSpeed56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelNetworkSpeed56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelNetworkSpeed56_objectSpread(WhiteLabelNetworkSpeed56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M27.91 6.38c-11.94.05-21.58 9.77-21.53 21.7.05 11.94 9.77 21.58 21.71 21.53 11.94-.05 21.57-9.77 21.53-21.7-.05-11.94-9.77-21.58-21.7-21.53Zm.16 39.28c-9.75.04-17.68-7.83-17.72-17.58-.04-9.75 7.83-17.68 17.58-17.72 9.75-.04 17.68 7.83 17.72 17.58.04 9.75-7.83 17.68-17.58 17.72Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.62 27.91c.05 11.94-9.59 21.65-21.53 21.7-11.94.05-21.66-9.59-21.71-21.53-.05-11.94 9.59-21.66 21.53-21.7 11.94-.05 21.66 9.59 21.7 21.53Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.65 27.94c.04 9.75-7.83 17.68-17.58 17.72-9.75.04-17.68-7.83-17.72-17.58-.04-9.75 7.83-17.68 17.58-17.72 9.75-.04 17.68 7.83 17.72 17.58Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.42 40.33-1.44-1.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.54 27.92h-3.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m40.39 15.53-1.44 1.43"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.98 10.4v3.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.58 15.55 1.44 1.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M10.46 27.96h3.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m15.61 40.36 1.44-1.44"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M38.74 35.43c-2.29-2.21-9.07-8.42-9.7-8.87a1.777 1.777 0 1 0-2.07 2.89c.63.45 8.69 4.86 11.53 6.31.21.11.41-.17.24-.33Zm-10.18-7c-.22.31-.66.39-.97.16a.7.7 0 0 1-.16-.97.7.7 0 0 1 .97-.16c.31.22.39.66.16.97Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelNetworkSpeed56 = (WhiteLabelNetworkSpeed56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPayment104.tsx


var WhiteLabelPayment104_excluded = ["className"];
function WhiteLabelPayment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPayment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPayment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPayment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPayment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPayment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPayment104_objectSpread(WhiteLabelPayment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.33 49.49h66.03v7.26H11.33zM26.64 28.76h66.03v7.26H26.64z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.64 28.76h66.03v7.26H26.64z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.64 40.97V20.9h66.03v41.47H77.36"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26 41.63h51.36V83.1H11.33V41.63H26"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M11.33 49.49h66.03v7.26H11.33z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.28",
        y: "62.37",
        width: "32.85",
        height: "7.11",
        rx: "2.66",
        ry: "2.66"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPayment104 = (WhiteLabelPayment104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPayment56.tsx


var WhiteLabelPayment56_excluded = ["className"];
function WhiteLabelPayment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPayment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPayment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPayment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPayment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPayment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPayment56_objectSpread(WhiteLabelPayment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.8 26.69h34.41v3.79H6.8zM14.78 15.89h34.41v3.79H14.78z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.78 15.89h34.41v3.79H14.78z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.78 22.6V11.79H49.2V33.4h-7.98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.8 22.6h34.41v21.61H6.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.8 26.69h34.41v3.79H6.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "9.39",
        y: "33.4",
        width: "17.12",
        height: "3.71",
        rx: "1.38",
        ry: "1.38"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPayment56 = (WhiteLabelPayment56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPaymentCalendar104.tsx


var WhiteLabelPaymentCalendar104_excluded = ["className"];
function WhiteLabelPaymentCalendar104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPaymentCalendar104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPaymentCalendar104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPaymentCalendar104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPaymentCalendar104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPaymentCalendar104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPaymentCalendar104_objectSpread(WhiteLabelPaymentCalendar104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M10.86 17.19h82.29v19.76H10.86z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.69 52.89h29.66M47.69 65.05h17.07M47.69 77.12h29.68M92.96 36.95h-82.1M10.99 17.19h82.15v75.83H10.99z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.66 68.36c-.11.42-.17.84-.17 1.29 0 2.85 2.32 5.2 5.2 5.2s5.2-2.32 5.2-5.2-1.82-5.15-5.2-5.2c-3.27-.14-4.64-2.07-4.64-4.64s2.07-4.64 4.64-4.64 4.64 2.07 4.64 4.64M31.9 74.76v3.05M31.9 52.16v2.91M24.99 10.98v11.06M79.42 10.98v11.06"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPaymentCalendar104 = (WhiteLabelPaymentCalendar104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPaymentCalendar56.tsx


var WhiteLabelPaymentCalendar56_excluded = ["className"];
function WhiteLabelPaymentCalendar56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPaymentCalendar56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPaymentCalendar56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPaymentCalendar56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPaymentCalendar56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPaymentCalendar56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPaymentCalendar56_objectSpread(WhiteLabelPaymentCalendar56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M6.73 10h42.55v10.22H6.73z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.77 28.46h15.34M25.77 34.75h8.83M25.77 40.99h15.35M49.18 20.22H6.73M6.8 10h42.47v39.2H6.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M14.9 36.46c-.06.22-.09.43-.09.67a2.69 2.69 0 0 0 5.38 0c0-1.49-.94-2.66-2.69-2.69-1.69-.07-2.4-1.07-2.4-2.4s1.07-2.4 2.4-2.4 2.4 1.07 2.4 2.4M17.61 39.77v1.57M17.61 28.08v1.51M14.04 6.79v5.72M42.18 6.79v5.72"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPaymentCalendar56 = (WhiteLabelPaymentCalendar56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPaymentHelp104.tsx


var WhiteLabelPaymentHelp104_excluded = ["className"];
function WhiteLabelPaymentHelp104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPaymentHelp104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPaymentHelp104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPaymentHelp104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPaymentHelp104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPaymentHelp104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPaymentHelp104_objectSpread(WhiteLabelPaymentHelp104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12 71.04 4.93-4.93a3.223 3.223 0 0 1 4.56 0L37.58 82.2l-4.81 4.81a3.238 3.238 0 0 1-4.55.02L11.99 71.04Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.3 20.93c-3.2-3.73-8.54-4.88-12.55-1.47-4.01 3.41-4.57 9.12-1.42 13.16 2.62 3.36 10.54 10.44 13.13 12.73.29.26.44.38.6.43.15.04.31.04.46 0 .17-.05.31-.18.6-.43 2.6-2.29 10.52-9.37 13.13-12.73 3.15-4.04 2.65-9.78-1.42-13.16-4.08-3.38-9.33-2.26-12.53 1.47Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m22.74 66.33 11.72-11.72c.9-.9 2.13-1.41 3.4-1.41h26.12c1.5 0 2.91.7 3.82 1.89a4.826 4.826 0 0 1 .19 5.58l-.02.03a4.822 4.822 0 0 1-4.01 2.15H49.24"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m35.77 78.39 2.03-1.61c.69-.55 1.55-.85 2.43-.85h24.45c1.04 0 2.03-.41 2.76-1.14l23.41-23.41c1.36-1.36 1.53-3.5.4-5.05-1.98-2.71-5.92-3.02-8.3-.64L67.63 61.17M12 71.04l4.93-4.93a3.223 3.223 0 0 1 4.56 0L37.58 82.2l-4.81 4.81a3.238 3.238 0 0 1-4.55.02L11.99 71.04ZM64.3 20.93c-3.2-3.73-8.54-4.88-12.55-1.47-4.01 3.41-4.57 9.12-1.42 13.16 2.62 3.36 10.54 10.44 13.13 12.73.29.26.44.38.6.43.15.04.31.04.46 0 .17-.05.31-.18.6-.43 2.6-2.29 10.52-9.37 13.13-12.73 3.15-4.04 2.65-9.78-1.42-13.16-4.08-3.38-9.33-2.26-12.53 1.47Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.34 34.67c0 1.45 1.32 2.63 2.96 2.63s2.96-1.18 2.96-2.63-1.33-2.63-2.96-2.63-2.96-1.18-2.96-2.63 1.32-2.63 2.96-2.63 2.96 1.18 2.96 2.63M64.3 24.7v2.08M64.3 37.3v2.08"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPaymentHelp104 = (WhiteLabelPaymentHelp104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPaymentHelp56.tsx


var WhiteLabelPaymentHelp56_excluded = ["className"];
function WhiteLabelPaymentHelp56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPaymentHelp56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPaymentHelp56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPaymentHelp56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPaymentHelp56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPaymentHelp56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPaymentHelp56_objectSpread(WhiteLabelPaymentHelp56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m6.46 38.25 2.65-2.65c.68-.68 1.78-.68 2.46 0l8.67 8.67-2.59 2.59c-.67.67-1.77.68-2.45 0l-8.74-8.61Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.62 11.27c-1.72-2.01-4.6-2.63-6.76-.79-2.16 1.84-2.46 4.91-.77 7.09 1.41 1.81 5.67 5.62 7.07 6.85.16.14.23.21.33.23.08.02.17.02.25 0 .09-.03.17-.1.33-.23 1.4-1.23 5.66-5.05 7.07-6.85 1.69-2.17 1.43-5.27-.77-7.09-2.2-1.82-5.02-1.22-6.75.79Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m12.25 35.72 6.31-6.31c.49-.49 1.14-.76 1.83-.76h14.06c.81 0 1.57.38 2.06 1.02.67.88.71 2.08.1 3v.02c-.49.72-1.3 1.16-2.17 1.16h-7.93"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m19.26 42.21 1.09-.87c.37-.3.83-.46 1.31-.46h13.17c.56 0 1.09-.22 1.49-.62l12.61-12.61c.73-.73.82-1.88.22-2.72a2.953 2.953 0 0 0-4.47-.34l-8.25 8.33M6.46 38.25l2.65-2.65c.68-.68 1.78-.68 2.46 0l8.67 8.67-2.59 2.59c-.67.67-1.77.68-2.45 0l-8.74-8.61ZM34.62 11.27c-1.72-2.01-4.6-2.63-6.76-.79-2.16 1.84-2.46 4.91-.77 7.09 1.41 1.81 5.67 5.62 7.07 6.85.16.14.23.21.33.23.08.02.17.02.25 0 .09-.03.17-.1.33-.23 1.4-1.23 5.66-5.05 7.07-6.85 1.69-2.17 1.43-5.27-.77-7.09-2.2-1.82-5.02-1.22-6.75.79Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.03 18.67c0 .78.71 1.42 1.59 1.42s1.59-.63 1.59-1.42-.71-1.42-1.59-1.42-1.59-.63-1.59-1.42.71-1.42 1.59-1.42 1.59.63 1.59 1.42M34.62 13.3v1.12M34.62 20.08v1.12"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPaymentHelp56 = (WhiteLabelPaymentHelp56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPin104.tsx


var WhiteLabelPin104_excluded = ["className"];
function WhiteLabelPin104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPin104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPin104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPin104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPin104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPin104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPin104_objectSpread(WhiteLabelPin104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "85.43",
      r: "2",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.1 51.44c-2.47-.28-4.37-.96-5.76-1.7 1.72.97 3.68 1.56 5.76 1.7ZM65.65 37.84c0-7.54-6.11-13.65-13.65-13.65S38.35 30.3 38.35 37.84a13.6 13.6 0 0 0 3.88 9.53c.68-4.73 4.85-8.57 9.77-8.57-3.05 0-5.52-2.47-5.52-5.52s2.47-5.52 5.52-5.52 5.52 2.47 5.52 5.52S55.05 38.8 52 38.8c4.96 0 9.05 3.7 9.67 8.48l-.03.05c-.09.15-.2.3-.31.44 2.65-2.49 4.32-6.02 4.32-9.94ZM52 51.49c1.6 0 3.13-.29 4.56-.8-2.01.64-3.86.77-4.66.79h.1Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.23 47.36s.96 1.24 3.11 2.37c-1.15-.64-2.19-1.45-3.11-2.38ZM51.47 51.49h.43c-.27 0-.54-.02-.8-.04.12.01.24.03.37.05ZM60.84 48.33c.18-.17.34-.36.49-.55a13.655 13.655 0 0 1-4.77 2.91c1.46-.46 3-1.19 4.28-2.36ZM34.7 60.85h5.66v10.31H34.7zM44.35 60.85h5.66v10.31h-5.66zM53.99 60.85h5.66v10.31h-5.66zM63.64 60.85h5.66v10.31h-5.66z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "29.7",
        y: "11.29",
        width: "44.6",
        height: "81.42",
        rx: "7.09",
        ry: "7.09"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.7 60.85h5.66v10.31H34.7zM44.35 60.85h5.66v10.31h-5.66zM53.99 60.85h5.66v10.31h-5.66zM63.64 60.85h5.66v10.31h-5.66z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "33.28",
        r: "5.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.47 51.49s5.75.14 9.37-3.15c.32-.29.57-.63.8-1l.03-.05c-.62-4.79-4.72-8.48-9.67-8.48s-9.1 3.84-9.77 8.57c0 0 2.69 3.51 9.24 4.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "37.84",
        r: "13.65"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPin104 = (WhiteLabelPin104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPin56.tsx


var WhiteLabelPin56_excluded = ["className"];
function WhiteLabelPin56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPin56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPin56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPin56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPin56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPin56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPin56_objectSpread(WhiteLabelPin56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "45.48",
      r: "1.05",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.22 20.59c0-3.94-3.2-7.14-7.14-7.14s-7.14 3.2-7.14 7.14c0 1.94.78 3.7 2.03 4.98.35-2.47 2.54-4.48 5.11-4.48-1.59 0-2.89-1.29-2.89-2.89s1.29-2.89 2.89-2.89 2.89 1.29 2.89 2.89-1.29 2.89-2.89 2.89c2.59 0 4.73 1.93 5.06 4.44l-.02.03c-.07.12-.17.21-.25.32a7.123 7.123 0 0 0 2.35-5.28ZM18.95 32.63h2.96v5.39h-2.96zM24 32.63h2.96v5.39H24zM29.04 32.63H32v5.39h-2.96zM34.09 32.63h2.96v5.39h-2.96z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.34",
        y: "6.71",
        width: "23.32",
        height: "42.58",
        rx: "3.71",
        ry: "3.71"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.95 32.63h2.96v5.39h-2.96zM24 32.63h2.96v5.39H24zM29.04 32.63H32v5.39h-2.96zM34.09 32.63h2.96v5.39h-2.96z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "20.59",
        r: "7.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "18.21",
        r: "2.89"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M32.62 26.08c.17-.15.3-.33.42-.52l.02-.03c-.33-2.5-2.47-4.44-5.06-4.44s-4.76 2.01-5.11 4.48"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPin56 = (WhiteLabelPin56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPlaceholder104.tsx


var WhiteLabelPlaceholder104_excluded = ["className"];
function WhiteLabelPlaceholder104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPlaceholder104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPlaceholder104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPlaceholder104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPlaceholder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPlaceholder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsx)("svg", WhiteLabelPlaceholder104_objectSpread(WhiteLabelPlaceholder104_objectSpread({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0",
    y: "0",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "WhiteLabel-shade",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.8 87.4 22.3-31.6c1.6-2.3 5-2.3 6.6 0L92 84.4v3"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "32.2",
          cy: "52.3",
          r: "7.1"
        })]
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "WhiteLabel-stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m22 87.4 17.5-22.8c1.6-2.3 5-2.3 6.6 0l7.1 8"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "32.2",
          cy: "52.3",
          r: "7.1"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 65.1 10.1 31l73.6-14.8 4.1 20.6"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M17 36.8h75v50.6H17z"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m42.8 87.4 22.3-31.6c1.6-2.3 5-2.3 6.6 0L92 84.4"
        })]
      })]
    })
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPlaceholder104 = (WhiteLabelPlaceholder104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPlaceholder56.tsx


var WhiteLabelPlaceholder56_excluded = ["className"];
function WhiteLabelPlaceholder56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPlaceholder56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPlaceholder56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPlaceholder56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPlaceholder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPlaceholder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPlaceholder56_objectSpread(WhiteLabelPlaceholder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.07 47.07 12.03-17a2.179 2.179 0 0 1 3.56 0l10.87 15.38v1.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.36",
        cy: "28.15",
        r: "3.8"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m11.84 47.07 9.45-12.26a2.179 2.179 0 0 1 3.56 0l3.83 4.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "17.36",
        cy: "28.15",
        r: "3.8"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m9.13 35.06-3.7-18.38 39.61-7.97 2.24 11.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M9.13 19.81h40.4v27.25H9.13z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m23.07 47.07 12.03-17a2.179 2.179 0 0 1 3.56 0l10.87 15.38"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPlaceholder56 = (WhiteLabelPlaceholder56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPostPaid104.tsx


var WhiteLabelPostPaid104_excluded = ["className"];
function WhiteLabelPostPaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPostPaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPostPaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPostPaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPostPaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPostPaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPostPaid104_objectSpread(WhiteLabelPostPaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.49 27.22H92.5v11.12H54.49z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.63 61.36v24.41c0 3.99-3.23 7.22-7.22 7.22H27.47c-3.99 0-7.22-3.23-7.22-7.22V17.38c0-3.99 3.23-7.22 7.22-7.22h30.94c3.99 0 7.22 3.23 7.22 7.22v9.14"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.49 27.22h38.47v34.13H54.49zM60.37 24.41v5.72M87.1 24.41v5.72M54.49 38.36h37.62"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "42.94",
        cy: "85.58",
        r: "2.04",
        className: "WhiteLabel-strokeinverted"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPostPaid104 = (WhiteLabelPostPaid104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPostPaid56.tsx


var WhiteLabelPostPaid56_excluded = ["className"];
function WhiteLabelPostPaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPostPaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPostPaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPostPaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPostPaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPostPaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPostPaid56_objectSpread(WhiteLabelPostPaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.09 14.79H49v5.83H29.09z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "23.03",
      cy: "45.36",
      r: "1.07",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.92 32.67v12.79c0 2.09-1.69 3.78-3.78 3.78H14.93c-2.09 0-3.78-1.69-3.78-3.78V9.63c0-2.09 1.69-3.78 3.78-3.78h16.21c2.09 0 3.78 1.69 3.78 3.78v4.79"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.09 14.79h20.15v17.88H29.09zM32.17 13.32v2.99M46.17 13.32v2.99M29.09 20.62h19.7"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPostPaid56 = (WhiteLabelPostPaid56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPrePaid104.tsx


var WhiteLabelPrePaid104_excluded = ["className"];
function WhiteLabelPrePaid104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPrePaid104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPrePaid104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPrePaid104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPrePaid104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPrePaid104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPrePaid104_objectSpread(WhiteLabelPrePaid104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "67.35",
      cy: "37.99",
      r: "14.57",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.66 52.56v33.8c0 4-3.25 7.25-7.25 7.25H29.32c-4 0-7.25-3.25-7.25-7.25V17.64c0-4 3.25-7.25 7.25-7.25h31.09c4 0 7.25 3.25 7.25 7.25v5.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "67.35",
        cy: "37.99",
        r: "14.57"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.08 40.13c-.07.27-.11.55-.11.84 0 1.85 1.51 3.38 3.38 3.38s3.38-1.51 3.38-3.38-1.18-3.34-3.38-3.38c-2.13-.09-3.02-1.34-3.02-3.02s1.34-3.02 3.02-3.02 3.02 1.34 3.02 3.02M67.35 44.35v1.98M67.35 29.67v1.89"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.86",
        cy: "86.16",
        r: "2.05",
        className: "WhiteLabel-strokeinverted"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPrePaid104 = (WhiteLabelPrePaid104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPrePaid56.tsx


var WhiteLabelPrePaid56_excluded = ["className"];
function WhiteLabelPrePaid56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPrePaid56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPrePaid56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPrePaid56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPrePaid56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPrePaid56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPrePaid56_objectSpread(WhiteLabelPrePaid56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "34.8",
      cy: "20.23",
      r: "7.61",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "23.05",
      cy: "45.38",
      r: "1.07",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.96 27.84v17.64c0 2.09-1.69 3.78-3.78 3.78H14.94c-2.09 0-3.78-1.69-3.78-3.78V9.61c0-2.09 1.69-3.78 3.78-3.78h16.23c2.09 0 3.78 1.69 3.78 3.78v3.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "34.8",
        cy: "20.23",
        r: "7.61"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.09 21.35c-.04.14-.06.28-.06.44 0 .97.79 1.76 1.76 1.76s1.76-.79 1.76-1.76-.62-1.75-1.76-1.76c-1.11-.05-1.57-.7-1.57-1.57s.7-1.57 1.57-1.57 1.57.7 1.57 1.57M34.8 23.55v1.04M34.8 15.89v.99"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPrePaid56 = (WhiteLabelPrePaid56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelProfile104.tsx


var WhiteLabelProfile104_excluded = ["className"];
function WhiteLabelProfile104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelProfile104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelProfile104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelProfile104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelProfile104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelProfile104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelProfile104_objectSpread(WhiteLabelProfile104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("clipPath", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "52",
          cy: "38.87",
          r: "15.9"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 54.77c-8.78 0-15.9-7.12-15.9-15.9s7.12-15.9 15.9-15.9 15.9 7.12 15.9 15.9-7.12 15.9-15.9 15.9c14.27 0 26.06 10.64 27.86 24.43l-.1.16.35.1c6.92-7.09 11.2-16.77 11.2-27.46 0-21.71-17.6-39.31-39.31-39.31S12.69 30.29 12.69 52c0 10.68 4.27 20.35 11.19 27.44C25.82 65.82 37.85 54.77 52 54.77Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "39.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "52",
        r: "39.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "38.87",
        r: "15.9"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m79.76 79.35.1-.16C78.06 65.41 66.28 54.76 52 54.76S25.81 65.82 23.87 79.45"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelProfile104 = (WhiteLabelProfile104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelProfile56.tsx


var WhiteLabelProfile56_excluded = ["className"];
function WhiteLabelProfile56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelProfile56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelProfile56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelProfile56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelProfile56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelProfile56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelProfile56_objectSpread(WhiteLabelProfile56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("defs", {
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("clipPath", {
        children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
          cx: "28",
          cy: "20.93",
          r: "8.56"
        })
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28 29.49c-4.73 0-8.56-3.83-8.56-8.56s3.83-8.56 8.56-8.56 8.56 3.83 8.56 8.56-3.83 8.56-8.56 8.56c7.69 0 14.03 5.73 15 13.15l-.05.09.19.06c3.73-3.82 6.03-9.03 6.03-14.78 0-11.69-9.48-21.17-21.17-21.17S6.83 16.31 6.83 28c0 5.75 2.3 10.96 6.02 14.77 1.05-7.33 7.52-13.28 15.14-13.28Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "21.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "28",
        r: "21.17"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "20.93",
        r: "8.56"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.95 42.73.05-.09c-.97-7.42-7.31-13.15-15-13.15s-14.1 5.96-15.15 13.3"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelProfile56 = (WhiteLabelProfile56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoCombined104.tsx


var WhiteLabelPromoCombined104_excluded = ["className"];
function WhiteLabelPromoCombined104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoCombined104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoCombined104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoCombined104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoCombined104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoCombined104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoCombined104_objectSpread(WhiteLabelPromoCombined104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m90.36 48.38-6.45-4.37c-1.64-1.11-2.31-3.26-1.61-5.17l2.77-7.5c1.08-2.92-1.08-6.02-4.07-5.85l-7.68.43c-1.95.11-3.7-1.22-4.2-3.19l-1.98-7.77c-.77-3.02-4.26-4.21-6.58-2.24l-5.97 5.07a3.977 3.977 0 0 1-5.2 0l-5.97-5.07c-2.32-1.97-5.81-.78-6.58 2.24l-1.98 7.77c-.5 1.97-2.26 3.3-4.2 3.19l-7.68-.43c-2.98-.17-5.14 2.94-4.07 5.85l2.77 7.5c.7 1.9.03 4.06-1.61 5.17l-6.45 4.37c-2.51 1.7-2.51 5.54 0 7.23l6.45 4.37c1.64 1.11 2.31 3.26 1.61 5.17l-2.77 7.5c-1.08 2.92 1.08 6.02 4.07 5.85l7.68-.43c1.95-.11 3.7 1.22 4.2 3.19l1.98 7.77c.77 3.02 4.26 4.21 6.58 2.24l5.97-5.07a3.977 3.977 0 0 1 5.2 0l5.97 5.07c2.32 1.97 5.81.78 6.58-2.24l1.98-7.77c.5-1.97 2.26-3.3 4.2-3.19l7.68.43c2.98.17 5.14-2.94 4.07-5.85l-2.77-7.5c-.7-1.9-.03-4.06 1.61-5.17l6.45-4.37c2.51-1.7 2.51-5.54 0-7.23ZM68.97 49.6 54.61 64.9c-1.37 1.46-3.7 1.46-5.06-.01L35.02 49.23a4.146 4.146 0 0 1 .13-5.78l4.32-4.25c.78-.76 1.82-1.19 2.91-1.19h19.13c1.13 0 2.21.46 2.99 1.27 1.16 1.2 2.94 3.06 4.44 4.61a4.148 4.148 0 0 1 .03 5.72Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m90.36 48.38-6.45-4.37c-1.64-1.11-2.31-3.26-1.61-5.17l2.77-7.5c1.08-2.92-1.08-6.02-4.07-5.85l-7.68.43c-1.95.11-3.7-1.22-4.2-3.19l-1.98-7.77c-.77-3.02-4.26-4.21-6.58-2.24l-5.97 5.07a3.977 3.977 0 0 1-5.2 0l-5.97-5.07c-2.32-1.97-5.81-.78-6.58 2.24l-1.98 7.77c-.5 1.97-2.26 3.3-4.2 3.19l-7.68-.43c-2.98-.17-5.14 2.94-4.07 5.85l2.77 7.5c.7 1.9.03 4.06-1.61 5.17l-6.45 4.37c-2.51 1.7-2.51 5.54 0 7.23l6.45 4.37c1.64 1.11 2.31 3.26 1.61 5.17l-2.77 7.5c-1.08 2.92 1.08 6.02 4.07 5.85l7.68-.43c1.95-.11 3.7 1.22 4.2 3.19l1.98 7.77c.77 3.02 4.26 4.21 6.58 2.24l5.97-5.07a3.977 3.977 0 0 1 5.2 0l5.97 5.07c2.32 1.97 5.81.78 6.58-2.24l1.98-7.77c.5-1.97 2.26-3.3 4.2-3.19l7.68.43c2.98.17 5.14-2.94 4.07-5.85l-2.77-7.5c-.7-1.9-.03-4.06 1.61-5.17l6.45-4.37c2.51-1.7 2.51-5.54 0-7.23ZM68.97 49.6 54.61 64.9c-1.37 1.46-3.7 1.46-5.06-.01L35.02 49.23a4.146 4.146 0 0 1 .13-5.78l4.32-4.25c.78-.76 1.82-1.19 2.91-1.19h19.13c1.13 0 2.21.46 2.99 1.27 1.16 1.2 2.94 3.06 4.44 4.61a4.148 4.148 0 0 1 .03 5.72Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.34 46.25H69.6M42.99 38.91 52.05 66M60.75 38.91 51.84 66"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoCombined104 = (WhiteLabelPromoCombined104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoCombined56.tsx


var WhiteLabelPromoCombined56_excluded = ["className"];
function WhiteLabelPromoCombined56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoCombined56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoCombined56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoCombined56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoCombined56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoCombined56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoCombined56_objectSpread(WhiteLabelPromoCombined56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m48.07 26.11-3.38-2.29c-.86-.58-1.21-1.71-.84-2.7l1.45-3.92c.56-1.53-.57-3.15-2.13-3.06l-4.02.23c-1.02.06-1.94-.64-2.2-1.67l-1.03-4.06c-.4-1.58-2.23-2.2-3.44-1.17l-3.12 2.65c-.79.67-1.93.67-2.72 0l-3.12-2.65c-1.21-1.03-3.04-.41-3.44 1.17l-1.03 4.06c-.26 1.03-1.18 1.73-2.2 1.67l-4.02-.23c-1.56-.09-2.69 1.54-2.13 3.06l1.45 3.92c.37 1 .02 2.12-.84 2.7l-3.38 2.29c-1.31.89-1.31 2.9 0 3.78l3.38 2.29c.86.58 1.21 1.71.84 2.7L10.7 38.8c-.56 1.53.57 3.15 2.13 3.06l4.02-.23c1.02-.06 1.94.64 2.2 1.67l1.03 4.06c.4 1.58 2.23 2.2 3.44 1.17l3.12-2.65c.79-.67 1.93-.67 2.72 0l3.12 2.65c1.21 1.03 3.04.41 3.44-1.17l1.03-4.06c.26-1.03 1.18-1.73 2.2-1.67l4.02.23c1.56.09 2.69-1.54 2.13-3.06l-1.45-3.92c-.37-1-.02-2.12.84-2.7l3.38-2.29c1.31-.89 1.31-2.9 0-3.78Zm-11.19.64-7.51 8.01c-.72.77-1.93.76-2.65 0l-7.6-8.19c-.8-.86-.77-2.2.07-3.03l2.26-2.22c.41-.4.95-.62 1.52-.62h10.01c.59 0 1.15.24 1.56.66.61.63 1.54 1.6 2.32 2.41.8.83.81 2.15.02 2.99Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.36 10.11 3.12-2.65c1.21-1.03 3.04-.41 3.44 1.17l1.03 4.06c.26 1.03 1.18 1.73 2.2 1.67l4.02-.23c1.56-.09 2.69 1.54 2.13 3.06l-1.45 3.92c-.37 1-.02 2.12.84 2.7l3.38 2.29c1.31.89 1.31 2.9 0 3.78l-3.38 2.29c-.86.58-1.21 1.71-.84 2.7l1.45 3.92c.56 1.53-.57 3.15-2.13 3.06l-4.02-.23c-1.02-.06-1.94.64-2.2 1.67l-1.03 4.06c-.4 1.58-2.23 2.2-3.44 1.17l-3.12-2.65c-.79-.67-1.93-.67-2.72 0l-3.12 2.65c-1.21 1.03-3.04.41-3.44-1.17l-1.03-4.06c-.26-1.03-1.18-1.73-2.2-1.67l-4.02.23c-1.56.09-2.69-1.54-2.13-3.06l1.45-3.92c.37-1 .02-2.12-.84-2.7l-3.38-2.29c-1.31-.89-1.31-2.9 0-3.78l3.38-2.29c.86-.58 1.21-1.71.84-2.7l-1.45-3.92c-.56-1.53.57-3.15 2.13-3.06l4.02.23c1.02.06 1.94-.64 2.2-1.67l1.03-4.06c.4-1.58 2.23-2.2 3.44-1.17l3.12 2.65c.79.67 1.93.67 2.72 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m36.88 26.75-7.51 8.01c-.72.77-1.93.76-2.65 0l-7.6-8.19c-.8-.86-.77-2.2.07-3.03l2.26-2.22c.41-.4.95-.62 1.52-.62h10.01c.59 0 1.15.24 1.56.66.61.63 1.54 1.6 2.32 2.41s.81 2.15.02 2.99ZM18.76 24.99h18.45M23.29 21.15l4.74 14.17M32.58 21.15l-4.66 14.17"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoCombined56 = (WhiteLabelPromoCombined56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoData104.tsx


var WhiteLabelPromoData104_excluded = ["className"];
function WhiteLabelPromoData104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoData104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoData104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoData104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoData104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoData104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoData104_objectSpread(WhiteLabelPromoData104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m54.58 18 5.93-5.04c2.31-1.96 5.78-.78 6.54 2.22l1.97 7.72c.5 1.96 2.24 3.28 4.18 3.17l7.63-.43c2.97-.17 5.11 2.92 4.04 5.82l-2.75 7.46c-.7 1.89-.03 4.04 1.6 5.14l6.42 4.34c2.49 1.69 2.49 5.5 0 7.19l-6.42 4.34c-1.63 1.1-2.29 3.25-1.6 5.14l2.75 7.46c1.07 2.9-1.08 5.99-4.04 5.82l-7.63-.43c-1.94-.11-3.68 1.22-4.18 3.17l-1.97 7.72c-.76 3-4.23 4.18-6.54 2.22l-5.93-5.04a3.947 3.947 0 0 0-5.16 0l-5.93 5.04c-2.31 1.96-5.78.78-6.54-2.22l-1.97-7.72c-.5-1.96-2.24-3.28-4.18-3.17l-7.63.43c-2.97.17-5.11-2.92-4.04-5.82l2.75-7.46c.7-1.89.03-4.04-1.6-5.14l-6.42-4.34c-2.49-1.69-2.49-5.5 0-7.19l6.42-4.34c1.63-1.1 2.29-3.25 1.6-5.14l-2.75-7.46c-1.07-2.9 1.08-5.99 4.04-5.82l7.63.43c1.94.11 3.68-1.22 4.18-3.17l1.97-7.72c.76-3 4.23-4.18 6.54-2.22L49.42 18a3.947 3.947 0 0 0 5.16 0Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m54.58 18 5.93-5.04c2.31-1.96 5.78-.78 6.54 2.22l1.97 7.72c.5 1.96 2.24 3.28 4.18 3.17l7.63-.43c2.97-.17 5.11 2.92 4.04 5.82l-2.75 7.46c-.7 1.89-.03 4.04 1.6 5.14l6.42 4.34c2.49 1.69 2.49 5.5 0 7.19l-6.42 4.34c-1.63 1.1-2.29 3.25-1.6 5.14l2.75 7.46c1.07 2.9-1.08 5.99-4.04 5.82l-7.63-.43c-1.94-.11-3.68 1.22-4.18 3.17l-1.97 7.72c-.76 3-4.23 4.18-6.54 2.22l-5.93-5.04a3.947 3.947 0 0 0-5.16 0l-5.93 5.04c-2.31 1.96-5.78.78-6.54-2.22l-1.97-7.72c-.5-1.96-2.24-3.28-4.18-3.17l-7.63.43c-2.97.17-5.11-2.92-4.04-5.82l2.75-7.46c.7-1.89.03-4.04-1.6-5.14l-6.42-4.34c-2.49-1.69-2.49-5.5 0-7.19l6.42-4.34c1.63-1.1 2.29-3.25 1.6-5.14l-2.75-7.46c-1.07-2.9 1.08-5.99 4.04-5.82l7.63.43c1.94.11 3.68-1.22 4.18-3.17l1.97-7.72c.76-3 4.23-4.18 6.54-2.22L49.42 18a3.947 3.947 0 0 0 5.16 0Z",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m48.65 60.93-.38-1.96c-.53 1.03-2.24 2.27-4.48 2.29-2.07.02-3.9-.5-5.32-1.99-1.86-1.94-2.32-4.33-2.32-7.25s.38-5.24 2.32-7.18c1.36-1.36 3.4-2.09 5.32-2.09 2.19 0 4.08.81 5.29 2.04.88.91 1.54 2.04 1.64 3.6H47.4c-.05-.71-.4-1.18-.78-1.64-.63-.73-1.61-1.08-2.85-1.08-1.03 0-2.21.45-2.92 1.21-1.23 1.28-1.39 3.5-1.39 5.14s.18 3.93 1.41 5.22c.71.75 1.86 1.13 2.9 1.13 1.16 0 2.07-.4 2.67-1.03.96-1.01 1.16-2.12 1.16-3.48h-4.26v-2.69h7.4v9.77h-2.09ZM66.03 59.74c-1.38 1.06-3.05 1.21-4.76 1.21h-7.1V43.07h7.1c1.44 0 2.92.2 4.13.98 1.31.86 2.07 2.34 2.07 3.88s-.68 3.1-2.19 3.78c1.69.78 2.57 2.37 2.57 4.03s-.53 3.02-1.81 4.01ZM61.4 45.86h-4.01v4.48h4.08c1.46 0 2.7-.53 2.7-2.22s-1.31-2.27-2.77-2.27Zm.1 7.2h-4.11v4.96h4.01c1.51 0 3.15-.56 3.15-2.37 0-1.91-1.34-2.59-3.05-2.59Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoData104 = (WhiteLabelPromoData104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoData56.tsx


var WhiteLabelPromoData56_excluded = ["className"];
function WhiteLabelPromoData56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoData56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoData56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoData56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoData56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoData56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoData56_objectSpread(WhiteLabelPromoData56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m29.37 10.02 3.14-2.67c1.22-1.04 3.05-.41 3.46 1.18l1.04 4.08c.26 1.04 1.19 1.74 2.21 1.68l4.04-.23c1.57-.09 2.7 1.54 2.14 3.08l-1.45 3.94c-.37 1-.02 2.13.84 2.72l3.39 2.3c1.32.89 1.32 2.91 0 3.8l-3.39 2.3c-.86.58-1.21 1.72-.84 2.72l1.45 3.94c.57 1.53-.57 3.17-2.14 3.08l-4.04-.23c-1.02-.06-1.95.64-2.21 1.68l-1.04 4.08c-.4 1.59-2.24 2.21-3.46 1.18l-3.14-2.67c-.8-.68-1.94-.68-2.73 0l-3.14 2.67c-1.22 1.04-3.05.41-3.46-1.18L19 43.39c-.26-1.04-1.19-1.74-2.21-1.68l-4.04.23c-1.57.09-2.7-1.54-2.14-3.08l1.45-3.94c.37-1 .02-2.13-.84-2.72l-3.39-2.3c-1.32-.89-1.32-2.91 0-3.8l3.39-2.3c.86-.58 1.21-1.72.84-2.72l-1.45-3.94c-.57-1.53.57-3.17 2.14-3.08l4.04.23c1.02.06 1.95-.64 2.21-1.68l1.04-4.08c.4-1.59 2.24-2.21 3.46-1.18l3.14 2.67c.8.68 1.94.68 2.73 0Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m29.37 10.02 3.14-2.67c1.22-1.04 3.05-.41 3.46 1.18l1.04 4.08c.26 1.04 1.19 1.74 2.21 1.68l4.04-.23c1.57-.09 2.7 1.54 2.14 3.08l-1.45 3.94c-.37 1-.02 2.13.84 2.72l3.39 2.3c1.32.89 1.32 2.91 0 3.8l-3.39 2.3c-.86.58-1.21 1.72-.84 2.72l1.45 3.94c.57 1.53-.57 3.17-2.14 3.08l-4.04-.23c-1.02-.06-1.95.64-2.21 1.68l-1.04 4.08c-.4 1.59-2.24 2.21-3.46 1.18l-3.14-2.67c-.8-.68-1.94-.68-2.73 0l-3.14 2.67c-1.22 1.04-3.05.41-3.46-1.18L19 43.39c-.26-1.04-1.19-1.74-2.21-1.68l-4.04.23c-1.57.09-2.7-1.54-2.14-3.08l1.45-3.94c.37-1 .02-2.13-.84-2.72l-3.39-2.3c-1.32-.89-1.32-2.91 0-3.8l3.39-2.3c.86-.58 1.21-1.72.84-2.72l-1.45-3.94c-.57-1.53.57-3.17 2.14-3.08l4.04.23c1.02.06 1.95-.64 2.21-1.68l1.04-4.08c.4-1.59 2.24-2.21 3.46-1.18l3.14 2.67c.8.68 1.94.68 2.73 0Z",
      className: "WhiteLabel-stroke"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m26.23 32.72-.2-1.04c-.28.55-1.19 1.2-2.37 1.21-1.09.01-2.07-.27-2.81-1.05-.99-1.02-1.23-2.29-1.23-3.84s.2-2.77 1.23-3.8c.72-.72 1.8-1.11 2.81-1.11 1.16 0 2.16.43 2.8 1.08.47.48.81 1.08.87 1.9h-1.76c-.03-.37-.21-.63-.41-.87-.33-.39-.85-.57-1.51-.57-.55 0-1.17.24-1.54.64-.65.68-.73 1.85-.73 2.72s.09 2.08.75 2.76c.37.4.99.6 1.53.6.61 0 1.09-.21 1.41-.55.51-.53.61-1.12.61-1.84h-2.25v-1.43h3.92v5.17h-1.11ZM35.42 32.1c-.73.56-1.61.64-2.52.64h-3.76v-9.46h3.76c.76 0 1.55.11 2.18.52.69.45 1.09 1.24 1.09 2.05s-.36 1.64-1.16 2c.89.41 1.36 1.25 1.36 2.13s-.28 1.6-.96 2.12Zm-2.45-7.34h-2.12v2.37h2.16c.77 0 1.43-.28 1.43-1.17s-.69-1.2-1.47-1.2Zm.05 3.81h-2.17v2.62h2.12c.8 0 1.66-.29 1.66-1.25 0-1.01-.71-1.37-1.61-1.37Z"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoData56 = (WhiteLabelPromoData56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoDiscount104.tsx


var WhiteLabelPromoDiscount104_excluded = ["className"];
function WhiteLabelPromoDiscount104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoDiscount104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoDiscount104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoDiscount104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoDiscount104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoDiscount104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoDiscount104_objectSpread(WhiteLabelPromoDiscount104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m54.61 17.61 6-5.1c2.33-1.98 5.84-.79 6.61 2.25l1.99 7.81c.5 1.98 2.27 3.32 4.23 3.21l7.72-.44c3-.17 5.17 2.95 4.09 5.88l-2.78 7.54c-.71 1.91-.03 4.08 1.61 5.2l6.49 4.39c2.52 1.71 2.52 5.57 0 7.27l-6.49 4.39c-1.65 1.11-2.32 3.28-1.61 5.2l2.78 7.54c1.08 2.93-1.09 6.05-4.09 5.88l-7.72-.44c-1.96-.11-3.72 1.23-4.23 3.21l-1.99 7.81c-.77 3.04-4.28 4.23-6.61 2.25l-6-5.1a4.004 4.004 0 0 0-5.22 0l-6 5.1c-2.33 1.98-5.84.79-6.61-2.25l-1.99-7.81c-.5-1.98-2.27-3.32-4.23-3.21l-7.72.44c-3 .17-5.17-2.95-4.09-5.88l2.78-7.54c.71-1.91.03-4.08-1.61-5.2l-6.49-4.39c-2.52-1.71-2.52-5.57 0-7.27l6.49-4.39c1.65-1.11 2.32-3.28 1.61-5.2l-2.78-7.54c-1.08-2.93 1.09-6.05 4.09-5.88l7.72.44c1.96.11 3.72-1.23 4.23-3.21l1.99-7.81c.77-3.04 4.28-4.23 6.61-2.25l6 5.1a4.004 4.004 0 0 0 5.22 0Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m54.61 17.61 6-5.1c2.33-1.98 5.84-.79 6.61 2.25l1.99 7.81c.5 1.98 2.27 3.32 4.23 3.21l7.72-.44c3-.17 5.17 2.95 4.09 5.88l-2.78 7.54c-.71 1.91-.03 4.08 1.61 5.2l6.49 4.39c2.52 1.71 2.52 5.57 0 7.27l-6.49 4.39c-1.65 1.11-2.32 3.28-1.61 5.2l2.78 7.54c1.08 2.93-1.09 6.05-4.09 5.88l-7.72-.44c-1.96-.11-3.72 1.23-4.23 3.21l-1.99 7.81c-.77 3.04-4.28 4.23-6.61 2.25l-6-5.1a4.004 4.004 0 0 0-5.22 0l-6 5.1c-2.33 1.98-5.84.79-6.61-2.25l-1.99-7.81c-.5-1.98-2.27-3.32-4.23-3.21l-7.72.44c-3 .17-5.17-2.95-4.09-5.88l2.78-7.54c.71-1.91.03-4.08-1.61-5.2l-6.49-4.39c-2.52-1.71-2.52-5.57 0-7.27l6.49-4.39c1.65-1.11 2.32-3.28 1.61-5.2l-2.78-7.54c-1.08-2.93 1.09-6.05 4.09-5.88l7.72.44c1.96.11 3.72-1.23 4.23-3.21l1.99-7.81c.77-3.04 4.28-4.23 6.61-2.25l6 5.1a4.004 4.004 0 0 0 5.22 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M45.21 56.55a6.68 6.68 0 0 0-.23 1.73c0 3.84 3.13 7.01 7.01 7.01S59 62.16 59 58.28s-2.45-6.94-7.01-7.01c-4.41-.19-6.26-2.79-6.26-6.26s2.79-6.26 6.26-6.26 6.26 2.79 6.26 6.26M52.27 65.67v3.61M52.27 34.72v3.92"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoDiscount104 = (WhiteLabelPromoDiscount104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelPromoDiscount56.tsx


var WhiteLabelPromoDiscount56_excluded = ["className"];
function WhiteLabelPromoDiscount56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelPromoDiscount56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelPromoDiscount56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelPromoDiscount56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelPromoDiscount56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelPromoDiscount56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelPromoDiscount56_objectSpread(WhiteLabelPromoDiscount56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m29.36 10.11 3.12-2.65c1.21-1.03 3.04-.41 3.44 1.17l1.03 4.06c.26 1.03 1.18 1.73 2.2 1.67l4.01-.23c1.56-.09 2.69 1.54 2.13 3.06l-1.45 3.92c-.37 1-.02 2.12.84 2.7l3.37 2.28c1.31.89 1.31 2.9 0 3.78l-3.37 2.28c-.86.58-1.21 1.71-.84 2.7l1.45 3.92c.56 1.52-.57 3.15-2.13 3.06l-4.01-.23c-1.02-.06-1.94.64-2.2 1.67l-1.03 4.06c-.4 1.58-2.23 2.2-3.44 1.17l-3.12-2.65c-.79-.67-1.93-.67-2.72 0l-3.12 2.65c-1.21 1.03-3.04.41-3.44-1.17l-1.03-4.06c-.26-1.03-1.18-1.73-2.2-1.67l-4.01.23c-1.56.09-2.69-1.54-2.13-3.06l1.45-3.92c.37-1 .02-2.12-.84-2.7l-3.37-2.28c-1.31-.89-1.31-2.9 0-3.78l3.37-2.28c.86-.58 1.21-1.71.84-2.7l-1.45-3.92c-.56-1.52.57-3.15 2.13-3.06l4.01.23c1.02.06 1.94-.64 2.2-1.67l1.03-4.06c.4-1.58 2.23-2.2 3.44-1.17l3.12 2.65c.79.67 1.93.67 2.72 0Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.36 10.11 3.12-2.65c1.21-1.03 3.04-.41 3.44 1.17l1.03 4.06c.26 1.03 1.18 1.73 2.2 1.67l4.01-.23c1.56-.09 2.69 1.54 2.13 3.06l-1.45 3.92c-.37 1-.02 2.12.84 2.7l3.37 2.28c1.31.89 1.31 2.9 0 3.78l-3.37 2.28c-.86.58-1.21 1.71-.84 2.7l1.45 3.92c.56 1.52-.57 3.15-2.13 3.06l-4.01-.23c-1.02-.06-1.94.64-2.2 1.67l-1.03 4.06c-.4 1.58-2.23 2.2-3.44 1.17l-3.12-2.65c-.79-.67-1.93-.67-2.72 0l-3.12 2.65c-1.21 1.03-3.04.41-3.44-1.17l-1.03-4.06c-.26-1.03-1.18-1.73-2.2-1.67l-4.01.23c-1.56.09-2.69-1.54-2.13-3.06l1.45-3.92c.37-1 .02-2.12-.84-2.7l-3.37-2.28c-1.31-.89-1.31-2.9 0-3.78l3.37-2.28c.86-.58 1.21-1.71.84-2.7l-1.45-3.92c-.56-1.52.57-3.15 2.13-3.06l4.01.23c1.02.06 1.94-.64 2.2-1.67l1.03-4.06c.4-1.58 2.23-2.2 3.44-1.17l3.12 2.65c.79.67 1.93.67 2.72 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M24.47 30.37c-.08.29-.12.59-.12.9 0 2 1.63 3.65 3.65 3.65s3.65-1.63 3.65-3.65-1.27-3.61-3.65-3.65c-2.29-.1-3.25-1.45-3.25-3.25s1.45-3.25 3.25-3.25 3.25 1.45 3.25 3.25M28.14 34.98v2.01M28.14 19.01v2.04"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelPromoDiscount56 = (WhiteLabelPromoDiscount56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelReceipt104.tsx


var WhiteLabelReceipt104_excluded = ["className"];
function WhiteLabelReceipt104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelReceipt104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelReceipt104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelReceipt104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelReceipt104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelReceipt104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelReceipt104_objectSpread(WhiteLabelReceipt104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "52",
      cy: "40.92",
      r: "16.32",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m83.36 92.47-15.71-4.53L52 92.6l-17.92-4.66-13.44 4.53V11.4h62.72v81.07z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "40.92",
        r: "16.32"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M47.97 44.49c0 1.98 1.8 3.58 4.03 3.58s4.03-1.6 4.03-3.58-1.8-3.58-4.03-3.58-4.03-1.6-4.03-3.58 1.8-3.58 4.03-3.58 4.03 1.6 4.03 3.58M52 30.94v2.82M52 48.07v2.82"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelReceipt104 = (WhiteLabelReceipt104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelReceipt56.tsx


var WhiteLabelReceipt56_excluded = ["className"];
function WhiteLabelReceipt56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelReceipt56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelReceipt56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelReceipt56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelReceipt56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelReceipt56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelReceipt56_objectSpread(WhiteLabelReceipt56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "28",
      cy: "21.99",
      r: "8.52",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.38 48.92-8.21-2.37L28 48.99l-9.36-2.44-7.02 2.37V6.57h32.76v42.35z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "21.99",
        r: "8.52"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.9 23.86c0 1.03.94 1.87 2.1 1.87s2.1-.84 2.1-1.87-.94-1.87-2.1-1.87-2.1-.84-2.1-1.87.94-1.87 2.1-1.87 2.1.84 2.1 1.87M28 16.78v1.47M28 25.73v1.47"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelReceipt56 = (WhiteLabelReceipt56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelRecurringPayment104.tsx


var WhiteLabelRecurringPayment104_excluded = ["className"];
function WhiteLabelRecurringPayment104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelRecurringPayment104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelRecurringPayment104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelRecurringPayment104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelRecurringPayment104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelRecurringPayment104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelRecurringPayment104_objectSpread(WhiteLabelRecurringPayment104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M10.86 17.19h82.29v19.76H10.86z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-stroke",
      children: /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M65.03 74.62c4.48 0 5.11-3.23 5.11-7.21v-5.04c0-3.98-.62-7.21-5.1-7.21H43.42"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m48.82 47.94-5.4 7.21 5.4 7.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M39.1 55.15c-4.48 0-5.11 3.23-5.11 7.21v5.04c0 3.98.62 7.21 5.1 7.21h21.62"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m55.3 81.83 5.41-7.21-5.41-7.21"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M24.99 10.98v11.06M79.42 10.98v11.06M10.99 17.19h82.15v75.83H10.99zM92.96 36.95h-82.1"
        })]
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelRecurringPayment104 = (WhiteLabelRecurringPayment104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelRecurringPayment56.tsx


var WhiteLabelRecurringPayment56_excluded = ["className"];
function WhiteLabelRecurringPayment56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelRecurringPayment56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelRecurringPayment56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelRecurringPayment56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelRecurringPayment56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelRecurringPayment56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelRecurringPayment56_objectSpread(WhiteLabelRecurringPayment56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M5.85 9.4h44.31v10.64H5.85z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.06 19.9H5.85"
      }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
        className: "WhiteLabel-stroke",
        children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M35.01 40.18c2.41 0 2.75-1.74 2.75-3.88v-2.71c0-2.14-.33-3.88-2.75-3.88H23.37"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m26.29 25.81-2.91 3.88 2.91 3.89"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M21.05 29.69c-2.41 0-2.75 1.74-2.75 3.88v2.71c0 2.14.33 3.88 2.75 3.88h11.64"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "m29.78 44.06 2.91-3.88-2.91-3.88"
        }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
          d: "M5.92 9.26h44.24v40.83H5.92zM13.46 5.91v5.96M42.77 5.91v5.96"
        })]
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelRecurringPayment56 = (WhiteLabelRecurringPayment56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelRoaming104.tsx


var WhiteLabelRoaming104_excluded = ["className"];
function WhiteLabelRoaming104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelRoaming104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelRoaming104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelRoaming104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelRoaming104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelRoaming104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelRoaming104_objectSpread(WhiteLabelRoaming104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.12 11.31c-22.47 0-40.69 18.23-40.69 40.69s16.63 39.05 37.73 40.57c.05-.26.14-.54.16-.81.11-1.52.32-4.98.32-9.08 0-.98-.05-1.84-.14-2.56-.26-2.33-1.66-4.36-3.73-5.47-3.14-1.68-8.8-4.56-12.02-5.19-4.64-.89-4.1-4.28-4.1-7.68 0-2.54-1.51-5.78-2.26-7.26-.28-.54-.51-1.12-.63-1.72-1.89-9.2 3.96-8.87 3.96-8.87S40.08 42.69 44 37.69c2.45-3.12 2.47-8.66 2.14-12.39A7.09 7.09 0 0 1 49 18.94l8.29-6.13c.35-.26.68-.56.98-.89-2.31-.4-4.7-.63-7.12-.63h-.02ZM69.52 15.71s-1.61 10.43 3.89 13.79c5.26 3.21 9.06 3.23 11.56 11.93h5.43C87.38 30.19 79.68 20.87 69.52 15.7Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M91.82 52c0 22.47-18.22 40.69-40.69 40.69S10.43 74.47 10.43 52s18.22-40.69 40.69-40.69c18.45 0 34.04 12.28 39.02 29.12"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.16 92.57c.05-.26.14-.54.16-.81.11-1.52.32-4.98.32-9.08 0-.98-.05-1.84-.14-2.56-.26-2.33-1.66-4.36-3.73-5.47-3.14-1.68-8.8-4.56-12.02-5.19-4.64-.89-4.1-4.28-4.1-7.68 0-2.54-1.51-5.78-2.26-7.26-.28-.54-.51-1.12-.63-1.72-1.89-9.2 3.96-8.87 3.96-8.87S40.08 42.69 44 37.69c2.45-3.12 2.47-8.66 2.14-12.39A7.09 7.09 0 0 1 49 18.94l8.29-6.13c.35-.26.68-.56.98-.89M69.52 15.71s-1.61 10.43 3.89 13.79c5.36 3.27 9.21 3.21 11.71 12.43M67.12 50.7l-11.48-8.36 8.03-4.28 13.2 8.1"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m55.05 56.12-9.62-4.57-7.17 3.7 15.6 11.55 16.77-6.06-6.85 17.4 4.5-1.86c3.36-1.38 6.06-4.01 7.54-7.34l5.7-12.85 12.76-6.06s4.28-8.31-4.98-9.25L55.06 56.13Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelRoaming104 = (WhiteLabelRoaming104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelRoaming56.tsx


var WhiteLabelRoaming56_excluded = ["className"];
function WhiteLabelRoaming56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelRoaming56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelRoaming56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelRoaming56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelRoaming56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelRoaming56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelRoaming56_objectSpread(WhiteLabelRoaming56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.07 6c-12.14 0-22 9.86-22 22s8.99 21.11 20.4 21.93c.03-.14.08-.29.09-.44.06-.82.17-2.69.17-4.91 0-.53-.03-.99-.08-1.38-.14-1.26-.9-2.36-2.02-2.96-1.7-.91-4.76-2.46-6.5-2.8-2.51-.48-2.22-2.31-2.22-4.15 0-1.37-.81-3.13-1.22-3.92-.15-.29-.27-.61-.34-.93-1.02-4.97 2.14-4.79 2.14-4.79s5.6-.67 7.72-3.37c1.33-1.69 1.34-4.68 1.16-6.7-.12-1.34.46-2.64 1.54-3.44l4.48-3.32c.19-.14.37-.3.53-.48-1.25-.22-2.54-.34-3.85-.34ZM37.02 8.38s-.87 5.64 2.1 7.46c2.84 1.74 4.9 1.75 6.25 6.45h2.94c-1.63-6.07-5.8-11.11-11.29-13.91Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M49.07 28c0 12.15-9.85 22-22 22s-22-9.85-22-22 9.85-22 22-22c9.98 0 18.4 6.64 21.09 15.74"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M25.47 49.93c.03-.14.08-.29.09-.44.06-.82.17-2.69.17-4.91 0-.53-.03-.99-.08-1.38-.14-1.26-.9-2.36-2.02-2.96-1.7-.91-4.76-2.46-6.5-2.8-2.51-.48-2.22-2.31-2.22-4.15 0-1.37-.81-3.13-1.22-3.92-.15-.29-.27-.61-.34-.93-1.02-4.97 2.14-4.79 2.14-4.79s5.6-.67 7.72-3.37c1.33-1.69 1.34-4.68 1.16-6.7-.12-1.34.46-2.64 1.54-3.44l4.48-3.32c.19-.14.37-.3.53-.48M37.02 8.38s-.87 5.64 2.1 7.46c2.9 1.77 4.98 1.74 6.33 6.72M35.72 27.3l-6.21-4.52 4.34-2.31 7.13 4.38"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m29.19 30.23-5.2-2.47-3.87 2L28.55 36l9.07-3.28-3.7 9.41 2.43-1a7.602 7.602 0 0 0 4.07-3.97l3.08-6.94 6.9-3.28s2.31-4.49-2.69-5l-18.51 8.3Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelRoaming56 = (WhiteLabelRoaming56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSMS104.tsx


var WhiteLabelSMS104_excluded = ["className"];
function WhiteLabelSMS104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSMS104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSMS104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSMS104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSMS104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSMS104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSMS104_objectSpread(WhiteLabelSMS104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M54.06 25.73h21.45a5.83 5.83 0 0 1 5.83 5.83v15.09a5.83 5.83 0 0 1-5.83 5.83h-4.5l-.05 4.12c-.02 1.19-1.55 1.65-2.22.68l-4.98-4.79h-9.69a5.83 5.83 0 0 1-5.83-5.83V31.57a5.83 5.83 0 0 1 5.83-5.83Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.19 55.78v29.78a7.08 7.08 0 0 1-7.08 7.08H29.74a7.08 7.08 0 0 1-7.08-7.08V18.43a7.08 7.08 0 0 1 7.08-7.08h30.37a7.08 7.08 0 0 1 7.08 7.08v7.3"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M54.06 25.73h21.45a5.83 5.83 0 0 1 5.83 5.83v15.09a5.83 5.83 0 0 1-5.83 5.83h-4.5l-.05 4.12c-.02 1.19-1.55 1.65-2.22.68l-4.98-4.79h-9.69a5.83 5.83 0 0 1-5.83-5.83V31.57a5.83 5.83 0 0 1 5.83-5.83Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.93",
        cy: "85.38",
        r: "2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "58.76",
        cy: "39.09",
        r: "1.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "65.55",
        cy: "39.09",
        r: "1.87"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "72.33",
        cy: "39.09",
        r: "1.87"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSMS104 = (WhiteLabelSMS104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSMS56.tsx


var WhiteLabelSMS56_excluded = ["className"];
function WhiteLabelSMS56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSMS56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSMS56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSMS56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSMS56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSMS56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSMS56_objectSpread(WhiteLabelSMS56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M29.08 14.24h11.23a3.05 3.05 0 0 1 3.05 3.05v7.91a3.05 3.05 0 0 1-3.05 3.05h-2.36l-.03 2.16c0 .62-.81.87-1.16.35l-2.61-2.51h-5.08a3.05 3.05 0 0 1-3.05-3.05v-7.91a3.05 3.05 0 0 1 3.05-3.05Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.96 30.09v15.49c0 2.05-1.66 3.71-3.71 3.71H16.34c-2.05 0-3.71-1.66-3.71-3.71V10.42c0-2.05 1.66-3.71 3.71-3.71h15.91c2.05 0 3.71 1.66 3.71 3.71v3.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M29.08 14.24h11.23a3.05 3.05 0 0 1 3.05 3.05v7.91a3.05 3.05 0 0 1-3.05 3.05h-2.36l-.03 2.16c0 .62-.81.87-1.16.35l-2.61-2.51h-5.08a3.05 3.05 0 0 1-3.05-3.05v-7.91a3.05 3.05 0 0 1 3.05-3.05Z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-strokeinverted",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.3",
        cy: "45.48",
        r: "1.05"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "31.54",
        cy: "21.24",
        r: ".98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.1",
        cy: "21.24",
        r: ".98"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "38.65",
        cy: "21.24",
        r: ".98"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSMS56 = (WhiteLabelSMS56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSecurity104.tsx


var WhiteLabelSecurity104_excluded = ["className"];
function WhiteLabelSecurity104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSecurity104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSecurity104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSecurity104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSecurity104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSecurity104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSecurity104_objectSpread(WhiteLabelSecurity104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M68.18 34.86H35.83a5.82 5.82 0 0 0-5.82 5.82v25.84c0 3.21 2.6 5.82 5.82 5.82h32.35c3.21 0 5.82-2.6 5.82-5.82V40.68c0-3.21-2.6-5.82-5.82-5.82ZM55.05 54.07v4.88c0 1.68-1.37 3.05-3.05 3.05s-3.05-1.37-3.05-3.05v-4.88c-1.16-.91-1.92-2.31-1.92-3.9a4.97 4.97 0 1 1 9.94 0c0 1.59-.76 2.99-1.92 3.9Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M56.97 50.17a4.97 4.97 0 1 0-9.94 0c0 1.59.76 2.99 1.92 3.9v4.88c0 1.68 1.37 3.05 3.05 3.05s3.05-1.37 3.05-3.05v-4.88c1.16-.91 1.92-2.31 1.92-3.9Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.82 17.35h20.49v59.01c0 1.26-.73 2.4-1.88 2.93L53.34 92.6c-.85.39-1.83.39-2.68 0L21.57 79.29a3.227 3.227 0 0 1-1.88-2.93V17.35h20.48"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "30.01",
        y: "34.86",
        width: "43.99",
        height: "37.48",
        rx: "5.82",
        ry: "5.82"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52.58 11.11h-1.16c-7.32 0-13.25 5.93-13.25 13.25v10.49h5.94v-9.57c0-4.36 3.53-7.89 7.89-7.89s7.89 3.53 7.89 7.89v9.57h5.94V24.36c0-7.32-5.93-13.25-13.25-13.25Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSecurity104 = (WhiteLabelSecurity104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSecurity56.tsx


var WhiteLabelSecurity56_excluded = ["className"];
function WhiteLabelSecurity56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSecurity56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSecurity56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSecurity56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSecurity56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSecurity56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSecurity56_objectSpread(WhiteLabelSecurity56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M36.39 19.1H19.6c-1.67 0-3.02 1.35-3.02 3.02v13.41c0 1.67 1.35 3.02 3.02 3.02h16.79c1.67 0 3.02-1.35 3.02-3.02V22.12c0-1.67-1.35-3.02-3.02-3.02Zm-6.81 9.97v2.53c0 .87-.71 1.58-1.58 1.58s-1.58-.71-1.58-1.58v-2.53c-.6-.47-1-1.2-1-2.02 0-1.42 1.15-2.58 2.58-2.58s2.58 1.15 2.58 2.58c0 .82-.39 1.55-1 2.02Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.49 10.02h10.28v30.62c0 .65-.38 1.25-.97 1.52l-15.09 6.91c-.44.2-.95.2-1.39 0l-15.09-6.91c-.59-.27-.97-.86-.97-1.52V10.02h10.62"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("rect", {
        x: "16.59",
        y: "19.1",
        width: "22.82",
        height: "19.45",
        rx: "3.02",
        ry: "3.02"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M30.58 27.05c0-1.42-1.15-2.58-2.58-2.58s-2.58 1.15-2.58 2.58c0 .82.39 1.55 1 2.02v2.53c0 .87.71 1.58 1.58 1.58s1.58-.71 1.58-1.58v-2.53c.6-.47 1-1.2 1-2.02ZM35.18 19.1v-5.44c0-3.8-3.08-6.88-6.88-6.88h-.6a6.88 6.88 0 0 0-6.88 6.88v5.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.9 19.1v-4.96c0-2.26 1.83-4.1 4.1-4.1s4.1 1.83 4.1 4.1v4.96"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSecurity56 = (WhiteLabelSecurity56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelServices104.tsx


var WhiteLabelServices104_excluded = ["className"];
function WhiteLabelServices104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelServices104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelServices104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelServices104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelServices104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelServices104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelServices104_objectSpread(WhiteLabelServices104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "44.83",
      cy: "85.79",
      r: "2.03",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "67.31",
      cy: "38.25",
      r: "6.46",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "67.31",
        cy: "38.25",
        r: "6.46"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.36 52v33.98a7.17 7.17 0 0 1-7.17 7.17H29.45a7.17 7.17 0 0 1-7.17-7.17V18.02a7.17 7.17 0 0 1 7.17-7.17h30.74a7.17 7.17 0 0 1 7.17 7.17v6.51"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M63.9 24.96c7.34-1.88 14.81 2.54 16.69 9.88 1.88 7.34-2.54 14.81-9.88 16.69-7.34 1.88-14.81-2.54-16.69-9.88"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelServices104 = (WhiteLabelServices104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelServices56.tsx


var WhiteLabelServices56_excluded = ["className"];
function WhiteLabelServices56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelServices56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelServices56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelServices56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelServices56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelServices56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelServices56_objectSpread(WhiteLabelServices56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "35.92",
      cy: "20.88",
      r: "3.35",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
      cx: "24.29",
      cy: "45.48",
      r: "1.05",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.16 14.01a7.1 7.1 0 0 1 8.64 5.11c.97 3.8-1.31 7.66-5.11 8.64s-7.66-1.31-8.64-5.11"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.95 28v17.58c0 2.05-1.66 3.71-3.71 3.71H16.33c-2.05 0-3.71-1.66-3.71-3.71V10.42c0-2.05 1.66-3.71 3.71-3.71h15.91c2.05 0 3.71 1.66 3.71 3.71v2.95"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "35.92",
        cy: "20.88",
        r: "3.35"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelServices56 = (WhiteLabelServices56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSettings104.tsx


var WhiteLabelSettings104_excluded = ["className"];
function WhiteLabelSettings104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSettings104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSettings104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSettings104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSettings104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSettings104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSettings104_objectSpread(WhiteLabelSettings104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M82.06 36.79c-.26-.31-.56-.51-.97-.56l-3.37-.51c-.15-.41-.31-.82-.51-1.28.2-.31.51-.66.82-1.07.51-.66.87-1.12 1.07-1.43.2-.31.31-.61.31-.97 0-.51-.2-.82-.31-.92-.56-.77-1.68-1.99-3.57-3.72-.31-.26-.66-.41-1.02-.41-.51 0-.87.26-.97.36l-2.5 1.94c-.36-.15-.71-.31-1.07-.46l-.51-3.32c-.05-.41-.2-.77-.51-1.02-.31-.26-.66-.36-1.02-.36h-4.64c-.77 0-1.33.46-1.53 1.17-.15.66-.36 1.84-.56 3.52-.36.15-.71.31-1.07.46l-2.5-1.94c-.31-.26-.66-.36-1.02-.36-.51 0-1.07.31-2.55 1.73-1.07 1.02-1.73 1.79-2.14 2.35-.2.31-.31.61-.31.92 0 .26.05.61.41 1.02.77.92 1.43 1.73 1.94 2.45-.2.36-.36.77-.46 1.12l-3.42.51c-.26.05-.61.2-.92.56-.2.31-.31.61-.31.97v4.64c0 .36.1.71.31.97.15.36.46.56.87.61s3.32.51 3.32.51c.15.41.31.87.51 1.28-.2.31-.51.66-.82 1.07-.51.66-.87 1.12-1.07 1.43-.2.31-.31.61-.31.97s.1.66.31.97c.56.82 1.73 1.99 3.52 3.62.61.61 1.63.56 2.09.1l2.55-1.94c.36.15.71.31 1.07.46l.51 3.32c.05.41.2.77.56 1.02.31.26.66.36 1.02.36h4.64c.77 0 1.33-.46 1.53-1.17.15-.66.36-1.84.56-3.52.36-.15.71-.31 1.07-.46l2.55 1.99c.31.2.66.31.97.31.51 0 1.07-.31 2.55-1.73 1.02-1.02 1.73-1.79 2.09-2.3.26-.31.41-.61.41-1.02 0-.36-.15-.71-.41-1.02-.82-1.02-1.48-1.84-1.94-2.45.15-.36.31-.71.46-1.12l3.42-.51c.36-.05.71-.26.92-.56.2-.31.31-.61.31-.97v-4.64c0-.36-.1-.71-.36-.97Zm-16.43 9.69c-3.57 0-6.47-2.9-6.47-6.47s2.9-6.47 6.47-6.47 6.47 2.9 6.47 6.47-2.9 6.47-6.47 6.47Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "44.05",
        cy: "85.68",
        r: "2.02",
        className: "WhiteLabel-strokeinverted"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M66.53 56.94v28.94c0 3.95-3.2 7.15-7.15 7.15H28.73c-3.95 0-7.15-3.2-7.15-7.15V18.13c0-3.95 3.2-7.15 7.15-7.15h30.65c3.95 0 7.15 3.2 7.15 7.15v5.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M82.06 36.79c-.26-.31-.56-.51-.97-.56l-3.37-.51c-.15-.41-.31-.82-.51-1.28.2-.31.51-.66.82-1.07.51-.66.87-1.12 1.07-1.43.2-.31.31-.61.31-.97 0-.51-.2-.82-.31-.92-.56-.77-1.68-1.99-3.57-3.72-.31-.26-.66-.41-1.02-.41-.51 0-.87.26-.97.36l-2.5 1.94c-.36-.15-.71-.31-1.07-.46l-.51-3.32c-.05-.41-.2-.77-.51-1.02-.31-.26-.66-.36-1.02-.36h-4.64c-.77 0-1.33.46-1.53 1.17-.15.66-.36 1.84-.56 3.52-.36.15-.71.31-1.07.46l-2.5-1.94c-.31-.26-.66-.36-1.02-.36-.51 0-1.07.31-2.55 1.73-1.07 1.02-1.73 1.79-2.14 2.35-.2.31-.31.61-.31.92 0 .26.05.61.41 1.02.77.92 1.43 1.73 1.94 2.45-.2.36-.36.77-.46 1.12l-3.42.51c-.26.05-.61.2-.92.56-.2.31-.31.61-.31.97v4.64c0 .36.1.71.31.97.15.36.46.56.87.61s3.32.51 3.32.51c.15.41.31.87.51 1.28-.2.31-.51.66-.82 1.07-.51.66-.87 1.12-1.07 1.43-.2.31-.31.61-.31.97s.1.66.31.97c.56.82 1.73 1.99 3.52 3.62.61.61 1.63.56 2.09.1l2.55-1.94c.36.15.71.31 1.07.46l.51 3.32c.05.41.2.77.56 1.02.31.26.66.36 1.02.36h4.64c.77 0 1.33-.46 1.53-1.17.15-.66.36-1.84.56-3.52.36-.15.71-.31 1.07-.46l2.55 1.99c.31.2.66.31.97.31.51 0 1.07-.31 2.55-1.73 1.02-1.02 1.73-1.79 2.09-2.3.26-.31.41-.61.41-1.02 0-.36-.15-.71-.41-1.02-.82-1.02-1.48-1.84-1.94-2.45.15-.36.31-.71.46-1.12l3.42-.51c.36-.05.71-.26.92-.56.2-.31.31-.61.31-.97v-4.64c0-.36-.1-.71-.36-.97Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M65.63 46.47c-3.57 0-6.47-2.9-6.47-6.47s2.9-6.47 6.47-6.47 6.47 2.9 6.47 6.47-2.9 6.47-6.47 6.47Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSettings104 = (WhiteLabelSettings104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSettings56.tsx


var WhiteLabelSettings56_excluded = ["className"];
function WhiteLabelSettings56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSettings56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSettings56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSettings56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSettings56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSettings56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSettings56_objectSpread(WhiteLabelSettings56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.64 20.09c-.13-.16-.29-.27-.5-.29l-1.75-.27c-.08-.21-.16-.42-.27-.66.11-.16.27-.35.42-.56.27-.35.45-.58.56-.74a.85.85 0 0 0 .16-.5c0-.27-.11-.42-.16-.48-.29-.4-.88-1.03-1.86-1.94a.868.868 0 0 0-.53-.21c-.27 0-.45.13-.5.19l-1.3 1.01c-.19-.08-.37-.16-.56-.24l-.27-1.72c-.03-.21-.11-.4-.27-.53a.842.842 0 0 0-.53-.19h-2.42c-.4 0-.69.24-.8.61-.08.35-.19.96-.29 1.83-.19.08-.37.16-.56.24l-1.3-1.01a.842.842 0 0 0-.53-.19c-.27 0-.56.16-1.33.9-.56.53-.9.93-1.11 1.22-.11.16-.16.32-.16.48 0 .13.03.32.21.53.4.48.74.9 1.01 1.27-.11.19-.19.4-.24.58l-1.78.27c-.13.03-.32.11-.48.29a.85.85 0 0 0-.16.5v2.42c0 .19.05.37.16.5.08.19.24.29.45.32s1.72.27 1.72.27c.08.21.16.45.27.66-.11.16-.27.35-.42.56-.27.35-.45.58-.56.74-.11.16-.16.32-.16.5s.05.35.16.5c.29.42.9 1.04 1.83 1.88.32.32.85.29 1.09.05l1.33-1.01c.19.08.37.16.56.24l.27 1.72c.03.21.11.4.29.53.16.13.35.19.53.19h2.42c.4 0 .69-.24.8-.61.08-.35.19-.96.29-1.83.19-.08.37-.16.56-.24l1.33 1.03c.16.11.35.16.5.16.27 0 .56-.16 1.33-.9.53-.53.9-.93 1.09-1.19.13-.16.21-.32.21-.53 0-.19-.08-.37-.21-.53-.42-.53-.77-.96-1.01-1.27.08-.19.16-.37.24-.58l1.78-.27c.19-.03.37-.13.48-.29a.85.85 0 0 0 .16-.5v-2.42c0-.19-.05-.37-.19-.5Zm-8.55 5.04c-1.86 0-3.37-1.51-3.37-3.37s1.51-3.37 3.37-3.37 3.37 1.51 3.37 3.37-1.51 3.37-3.37 3.37Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "23.86",
        cy: "45.52",
        r: "1.05",
        className: "WhiteLabel-strokeinverted"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.56 30.57v15.05a3.72 3.72 0 0 1-3.72 3.72H15.9a3.72 3.72 0 0 1-3.72-3.72V10.38a3.72 3.72 0 0 1 3.72-3.72h15.94a3.72 3.72 0 0 1 3.72 3.72v2.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M43.64 20.09c-.13-.16-.29-.27-.5-.29l-1.75-.27c-.08-.21-.16-.42-.27-.66.11-.16.27-.35.42-.56.27-.35.45-.58.56-.74a.85.85 0 0 0 .16-.5c0-.27-.11-.42-.16-.48-.29-.4-.88-1.03-1.86-1.94a.868.868 0 0 0-.53-.21c-.27 0-.45.13-.5.19l-1.3 1.01c-.19-.08-.37-.16-.56-.24l-.27-1.72c-.03-.21-.11-.4-.27-.53a.842.842 0 0 0-.53-.19h-2.42c-.4 0-.69.24-.8.61-.08.35-.19.96-.29 1.83-.19.08-.37.16-.56.24l-1.3-1.01a.842.842 0 0 0-.53-.19c-.27 0-.56.16-1.33.9-.56.53-.9.93-1.11 1.22-.11.16-.16.32-.16.48 0 .13.03.32.21.53.4.48.74.9 1.01 1.27-.11.19-.19.4-.24.58l-1.78.27c-.13.03-.32.11-.48.29a.85.85 0 0 0-.16.5v2.42c0 .19.05.37.16.5.08.19.24.29.45.32s1.72.27 1.72.27c.08.21.16.45.27.66-.11.16-.27.35-.42.56-.27.35-.45.58-.56.74-.11.16-.16.32-.16.5s.05.35.16.5c.29.42.9 1.04 1.83 1.88.32.32.85.29 1.09.05l1.33-1.01c.19.08.37.16.56.24l.27 1.72c.03.21.11.4.29.53.16.13.35.19.53.19h2.42c.4 0 .69-.24.8-.61.08-.35.19-.96.29-1.83.19-.08.37-.16.56-.24l1.33 1.03c.16.11.35.16.5.16.27 0 .56-.16 1.33-.9.53-.53.9-.93 1.09-1.19.13-.16.21-.32.21-.53 0-.19-.08-.37-.21-.53-.42-.53-.77-.96-1.01-1.27.08-.19.16-.37.24-.58l1.78-.27c.19-.03.37-.13.48-.29a.85.85 0 0 0 .16-.5v-2.42c0-.19-.05-.37-.19-.5Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.09 25.12c-1.86 0-3.37-1.51-3.37-3.37s1.51-3.37 3.37-3.37 3.37 1.51 3.37 3.37-1.51 3.37-3.37 3.37Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSettings56 = (WhiteLabelSettings56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSignIn104.tsx


var WhiteLabelSignIn104_excluded = ["className"];
function WhiteLabelSignIn104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSignIn104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSignIn104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSignIn104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSignIn104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSignIn104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSignIn104_objectSpread(WhiteLabelSignIn104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M62.26 24.94h14.87c1.76 0 3.19 1.43 3.19 3.19v22.73c0 1.76-1.43 3.19-3.19 3.19H62.26",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M68.45 54.39v31.36c0 3.93-3.19 7.12-7.12 7.12H30.79c-3.93 0-7.12-3.19-7.12-7.12v-67.5c0-3.93 3.19-7.12 7.12-7.12h30.54c3.93 0 7.12 3.19 7.12 7.12v5.68"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M62.26 24.94h14.87c1.76 0 3.19 1.43 3.19 3.19v22.73c0 1.76-1.43 3.19-3.19 3.19H62.26M37.36 39.49h24.9l-9.8-9.8M52.46 49.3l9.8-9.81"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "46.06",
        cy: "85.55",
        r: "2.02",
        className: "WhiteLabel-strokeinverted"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSignIn104 = (WhiteLabelSignIn104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSignIn56.tsx


var WhiteLabelSignIn56_excluded = ["className"];
function WhiteLabelSignIn56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSignIn56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSignIn56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSignIn56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSignIn56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSignIn56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSignIn56_objectSpread(WhiteLabelSignIn56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M33.34 13.91h7.74c.92 0 1.66.74 1.66 1.66v11.84c0 .92-.74 1.66-1.66 1.66h-7.74",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M36.57 29.37v16.21c0 2.05-1.66 3.71-3.71 3.71h-15.9c-2.05 0-3.71-1.66-3.71-3.71V10.43c0-2.05 1.66-3.71 3.71-3.71h15.9c2.05 0 3.71 1.66 3.71 3.71v2.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.34 13.91h7.74c.92 0 1.66.74 1.66 1.66v11.84c0 .92-.74 1.66-1.66 1.66h-7.74M20.38 21.49h12.96l-5.1-5.11M28.24 26.59l5.1-5.1"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-strokeinverted",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "24.9",
        cy: "45.47",
        r: "1.05",
        className: "WhiteLabel-strokeinverted"
      })
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSignIn56 = (WhiteLabelSignIn56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSomethingWentWrong104.tsx


var WhiteLabelSomethingWentWrong104_excluded = ["className"];
function WhiteLabelSomethingWentWrong104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSomethingWentWrong104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSomethingWentWrong104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSomethingWentWrong104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSomethingWentWrong104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSomethingWentWrong104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSomethingWentWrong104_objectSpread(WhiteLabelSomethingWentWrong104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 11.66c-22.32 0-40.41 18.09-40.41 40.41S29.68 92.48 52 92.48s40.41-18.09 40.41-40.41S74.32 11.66 52 11.66Zm0 71.94c-17.41 0-31.53-14.11-31.53-31.53S34.58 20.54 52 20.54s31.53 14.11 31.53 31.53S69.42 83.6 52 83.6Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "40.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "31.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M52 57.76V36.92"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "52",
      cy: "65.41",
      rx: "1.72",
      ry: "1.67",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSomethingWentWrong104 = (WhiteLabelSomethingWentWrong104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSomethingWentWrong56.tsx


var WhiteLabelSomethingWentWrong56_excluded = ["className"];
function WhiteLabelSomethingWentWrong56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSomethingWentWrong56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSomethingWentWrong56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSomethingWentWrong56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSomethingWentWrong56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSomethingWentWrong56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSomethingWentWrong56_objectSpread(WhiteLabelSomethingWentWrong56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28 6.86c-11.7 0-21.18 9.48-21.18 21.18S16.3 49.22 28 49.22s21.18-9.48 21.18-21.18S39.7 6.86 28 6.86Zm0 37.71c-9.13 0-16.53-7.4-16.53-16.53S18.87 11.51 28 11.51s16.53 7.4 16.53 16.53S37.13 44.57 28 44.57Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "21.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "16.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28 31.02V20.09"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "28",
      cy: "35.03",
      rx: ".9",
      ry: ".88",
      className: "WhiteLabel-strokeinverted"
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSomethingWentWrong56 = (WhiteLabelSomethingWentWrong56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSuccess104.tsx


var WhiteLabelSuccess104_excluded = ["className"];
function WhiteLabelSuccess104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSuccess104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSuccess104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSuccess104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSuccess104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSuccess104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSuccess104_objectSpread(WhiteLabelSuccess104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M52 11.66c-22.32 0-40.41 18.09-40.41 40.41S29.68 92.48 52 92.48s40.41-18.09 40.41-40.41S74.32 11.66 52 11.66Zm0 71.94c-17.41 0-31.53-14.11-31.53-31.53S34.58 20.54 52 20.54s31.53 14.11 31.53 31.53S69.42 83.6 52 83.6Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "40.41"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "52",
        cy: "51.93",
        r: "31.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M67.24 41.29 45.09 63.46l-8.33-8.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSuccess104 = (WhiteLabelSuccess104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSuccess56.tsx


var WhiteLabelSuccess56_excluded = ["className"];
function WhiteLabelSuccess56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSuccess56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSuccess56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSuccess56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSuccess56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSuccess56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSuccess56_objectSpread(WhiteLabelSuccess56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M28 6.86c-11.7 0-21.18 9.48-21.18 21.18S16.3 49.22 28 49.22s21.18-9.48 21.18-21.18S39.7 6.86 28 6.86Zm0 37.71c-9.13 0-16.53-7.4-16.53-16.53S18.87 11.51 28 11.51s16.53 7.4 16.53 16.53S37.13 44.57 28 44.57Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "21.18"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "28",
        cy: "27.96",
        r: "16.53"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.99 22.39 24.38 34.01l-4.37-4.42"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSuccess56 = (WhiteLabelSuccess56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSupportPhone104.tsx


var WhiteLabelSupportPhone104_excluded = ["className"];
function WhiteLabelSupportPhone104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSupportPhone104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSupportPhone104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSupportPhone104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSupportPhone104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSupportPhone104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSupportPhone104_objectSpread(WhiteLabelSupportPhone104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.82 71.7h-8.83c-4.88 0-8.83-3.1-8.83-6.94V43.95c0-3.83 3.95-6.94 8.83-6.94h8.83v34.68ZM75.18 71.7h8.83c4.88 0 8.83-3.1 8.83-6.94V43.95c0-3.83-3.95-6.94-8.83-6.94h-8.83v34.68Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M61.8 89.04h5.95c7.76 0 14.05-4.55 14.05-12.8V71.7"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "56.42",
        cy: "88.58",
        rx: "4.42",
        ry: "4.33"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M28.82 71.7h-8.83c-4.88 0-8.83-3.1-8.83-6.94V43.95c0-3.83 3.95-6.94 8.83-6.94h8.83v34.68ZM75.18 71.7h8.83c4.88 0 8.83-3.1 8.83-6.94V43.95c0-3.83-3.95-6.94-8.83-6.94h-8.83v34.68Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.29 37.09c0-14.36 12.85-26.01 28.7-26.01s28.7 11.64 28.7 26.01"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSupportPhone104 = (WhiteLabelSupportPhone104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelSupportPhone56.tsx


var WhiteLabelSupportPhone56_excluded = ["className"];
function WhiteLabelSupportPhone56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelSupportPhone56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelSupportPhone56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelSupportPhone56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelSupportPhone56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelSupportPhone56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelSupportPhone56_objectSpread(WhiteLabelSupportPhone56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.89 38.29h-4.61c-2.55 0-4.61-1.62-4.61-3.62V23.8c0-2 2.07-3.62 4.61-3.62h4.61V38.3ZM40.11 38.29h4.61c2.55 0 4.61-1.62 4.61-3.62V23.8c0-2-2.07-3.62-4.61-3.62h-4.61V38.3Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M33.12 47.35h3.11c4.06 0 7.34-2.38 7.34-6.69v-2.37"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
        cx: "30.31",
        cy: "47.12",
        rx: "2.31",
        ry: "2.27"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M12.99 20.21c0-7.51 6.71-13.59 15-13.59s15 6.08 15 13.59"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M15.89 38.29h-4.61c-2.55 0-4.61-1.62-4.61-3.62V23.8c0-2 2.07-3.62 4.61-3.62h4.61V38.3ZM40.11 38.29h4.61c2.55 0 4.61-1.62 4.61-3.62V23.8c0-2-2.07-3.62-4.61-3.62h-4.61V38.3Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelSupportPhone56 = (WhiteLabelSupportPhone56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelTechnician104.tsx


var WhiteLabelTechnician104_excluded = ["className"];
function WhiteLabelTechnician104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelTechnician104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelTechnician104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelTechnician104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelTechnician104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelTechnician104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelTechnician104_objectSpread(WhiteLabelTechnician104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.55 33.51c23.63 7.33 21.09 35.35 21.09 35.35h3.45c1.86 0 3.37 1.52 3.37 3.37s-1.52 3.37-3.37 3.37H14.91c-1.85 0-3.37-1.52-3.37-3.37s1.52-3.37 3.37-3.37h3.45s-2.54-28.02 21.09-35.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M39.45 33.51c2.48-2.86 6.39-5.11 12.55-5.11s10.07 2.25 12.55 5.11"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M64.55 33.51c23.63 7.33 21.09 35.35 21.09 35.35h3.45c1.86 0 3.37 1.52 3.37 3.37s-1.52 3.37-3.37 3.37H14.91c-1.85 0-3.37-1.52-3.37-3.37s1.52-3.37 3.37-3.37h3.45s-2.54-28.02 21.09-35.35"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M35.14 68.86v-23.6S35.14 28.4 52 28.4s16.86 16.86 16.86 16.86v23.6"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelTechnician104 = (WhiteLabelTechnician104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelTechnician56.tsx


var WhiteLabelTechnician56_excluded = ["className"];
function WhiteLabelTechnician56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelTechnician56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelTechnician56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelTechnician56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelTechnician56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelTechnician56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelTechnician56_objectSpread(WhiteLabelTechnician56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.65 18.2c12.52 3.88 11.17 18.73 11.17 18.73h1.83c.98 0 1.79.8 1.79 1.79s-.8 1.79-1.79 1.79H8.35c-.98 0-1.79-.8-1.79-1.79s.8-1.79 1.79-1.79h1.83S8.83 22.09 21.35 18.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M21.35 18.2c1.31-1.51 3.39-2.71 6.65-2.71s5.33 1.19 6.65 2.71"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.65 18.2c12.52 3.88 11.17 18.73 11.17 18.73h1.83c.98 0 1.79.8 1.79 1.79s-.8 1.79-1.79 1.79H8.35c-.98 0-1.79-.8-1.79-1.79s.8-1.79 1.79-1.79h1.83S8.83 22.09 21.35 18.2"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M19.07 36.93V24.42s0-8.93 8.93-8.93 8.93 8.93 8.93 8.93v12.51"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelTechnician56 = (WhiteLabelTechnician56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelTrackOrder104.tsx


var WhiteLabelTrackOrder104_excluded = ["className"];
function WhiteLabelTrackOrder104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelTrackOrder104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelTrackOrder104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelTrackOrder104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelTrackOrder104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelTrackOrder104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelTrackOrder104_objectSpread(WhiteLabelTrackOrder104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.44 75.71-6.83-2.04-6.95 2.04v-8.9h13.78v8.9zM75.41 11.8c-7.23 0-13.09 5.86-13.09 13.09 0 10.45 12.37 22.91 12.37 22.91s13.82-12.12 13.82-22.91c0-7.23-5.86-13.09-13.09-13.09Zm0 17.46a5.27 5.27 0 1 1 .001-10.541 5.27 5.27 0 0 1-.001 10.541Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M88.51 24.9c0 10.78-13.82 22.91-13.82 22.91S62.32 35.35 62.32 24.9c0-7.23 5.86-13.09 13.09-13.09S88.5 17.67 88.5 24.9ZM12.09 66.81h30.92v26.24H12.09z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m34.44 75.71-6.83-2.04-6.95 2.04v-8.9h13.78v8.9z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.01 78.83h33.26c5.36 0 9.7-4.34 9.7-9.7s-4.46-9.7-9.7-9.7h-62.9.44c-5.44 0-9.84-4.41-9.84-9.84s4.41-9.84 9.84-9.84h-.44 41.31"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "75.41",
        cy: "23.99",
        r: "5.27"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelTrackOrder104 = (WhiteLabelTrackOrder104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelTrackOrder56.tsx


var WhiteLabelTrackOrder56_excluded = ["className"];
function WhiteLabelTrackOrder56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelTrackOrder56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelTrackOrder56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelTrackOrder56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelTrackOrder56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelTrackOrder56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelTrackOrder56_objectSpread(WhiteLabelTrackOrder56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.71 40.16-3.62-1.07-3.68 1.07v-4.7h7.3v4.7zM40.38 6.36c-3.83 0-6.93 3.1-6.93 6.93 0 5.53 6.54 12.12 6.54 12.12S47.3 19 47.3 13.29c0-3.82-3.1-6.93-6.93-6.93Zm0 9.23a2.791 2.791 0 0 1 0-5.58 2.791 2.791 0 0 1 0 5.58Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M6.89 35.46h16.35v13.88H6.89z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m18.71 40.16-3.62-1.07-3.68 1.07v-4.7h7.3v4.7z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M26.94 41.82h17.59c2.83 0 5.13-2.3 5.13-5.13s-2.3-5.13-5.13-5.13H11.27h.23c-2.87 0-5.21-2.33-5.21-5.21s2.33-5.21 5.21-5.21h-.23 21.85M47.3 13.29c0 5.7-7.31 12.12-7.31 12.12s-6.54-6.59-6.54-12.12c0-3.82 3.1-6.93 6.93-6.93s6.93 3.1 6.93 6.93Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("circle", {
        cx: "40.38",
        cy: "12.81",
        r: "2.79"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelTrackOrder56 = (WhiteLabelTrackOrder56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWarning104.tsx


var WhiteLabelWarning104_excluded = ["className"];
function WhiteLabelWarning104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWarning104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWarning104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWarning104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWarning104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWarning104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWarning104_objectSpread(WhiteLabelWarning104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "m91.34 74.49-31.18-54c-3.6-6.23-12.59-6.23-16.19 0l-31.18 54c-3.6 6.23.9 14.02 8.1 14.02h62.36c7.2 0 11.69-7.79 8.1-14.02Zm-9.72 5.15H23.58c-1.69 0-2.75-1.83-1.9-3.29L50.7 26.09a1.503 1.503 0 0 1 2.61 0l29.61 51.29c.58 1.01-.15 2.26-1.31 2.26Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "51.95",
      cy: "70",
      rx: "1.73",
      ry: "1.68",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m44.08 20.06-31.52 54.6c-3.52 6.1.88 13.72 7.92 13.72h63.05c7.04 0 11.44-7.62 7.92-13.72l-31.52-54.6c-3.52-6.1-12.32-6.1-15.84 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M51.95 62.3V41.34"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M50.69 26.09 21.67 76.35c-.85 1.46.21 3.29 1.9 3.29h58.04c1.16 0 1.89-1.26 1.31-2.26L53.31 26.09a1.503 1.503 0 0 0-2.61 0Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWarning104 = (WhiteLabelWarning104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWarning56.tsx


var WhiteLabelWarning56_excluded = ["className"];
function WhiteLabelWarning56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWarning56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWarning56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWarning56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWarning56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWarning56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWarning56_objectSpread(WhiteLabelWarning56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
      d: "M48.5 39.72 32.25 11.58c-1.87-3.25-6.56-3.25-8.44 0L7.57 39.72c-1.87 3.25.47 7.31 4.22 7.31h32.49c3.75 0 6.09-4.06 4.22-7.31Zm-5.07 2.68H13.19c-.88 0-1.43-.95-.99-1.72l15.12-26.19a.788.788 0 0 1 1.36 0l15.43 26.73a.79.79 0 0 1-.68 1.18Z",
      className: "WhiteLabel-shade"
    }), /*#__PURE__*/(0,jsx_runtime_.jsx)("ellipse", {
      cx: "27.97",
      cy: "37.38",
      rx: ".9",
      ry: ".88",
      className: "WhiteLabel-strokeinverted"
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.32 14.5 12.2 40.69c-.44.76.11 1.72.99 1.72h30.24c.6 0 .98-.65.68-1.18L28.68 14.5a.788.788 0 0 0-1.36 0Z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M27.97 33.37V22.44"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M23.87 11.36 7.45 39.81c-1.83 3.18.46 7.15 4.13 7.15h32.85c3.67 0 5.96-3.97 4.13-7.15L32.13 11.36c-1.83-3.18-6.42-3.18-8.26 0Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWarning56 = (WhiteLabelWarning56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWeCare104.tsx


var WhiteLabelWeCare104_excluded = ["className"];
function WhiteLabelWeCare104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWeCare104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWeCare104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWeCare104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWeCare104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWeCare104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWeCare104_objectSpread(WhiteLabelWeCare104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 20.182 68.56)",
        d: "M10.28 65.55h19.8v6.03h-19.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(135 83.818 68.565)",
        d: "M73.92 65.55h19.8v6.03h-19.8z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M34.11 34.88c1.83-2.06 3.58-4.34 5.22-5.75 1.06-.92 2.84-1.84 4.45-2.39 1.96-.67 4.42-.61 5.29.53.59.78.53 2.64-2.17 3.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m25.79 68.56 2.34-4.24.2-.36c.67-1.19 5.48-6.52 14.49-1.98.81.41 2.49 1.1 3.3 1.52 1.22.63 3.97 2.37 5.49-.13s-1.94-4.04-3.09-4.92c-.74-.57-1.48-1.13-2.18-1.64a20.419 20.419 0 0 1-5.92-6.91c-.79-1.5-1.56-3.09-1.96-4.24-.1-.28-.12-.57-.1-.87.09-1.1 1.14-4.18 1.65-5.62.18-.52.52-.98.96-1.31.86-.64 2.38-1.61 3.63-1.59 0 0 1.9-.07 3.24 1.41.29.32.59.55.87.73 1.14.68 2.66.31 3.31-.84.31-.55.44-1.28.02-2.22-1.07-2.38-3.8-3.78-3.8-3.78s-6.41-3.39-12.6 1.87C30.28 38 27.01 45.7 24.7 50.11c-1.32 2.53-4.98 8.61-6.79 11.59M70.7 34.86c-1.83-2.06-3.56-4.31-5.2-5.73-1.06-.92-2.84-1.84-4.45-2.39-1.96-.67-4.42-.61-5.29.53-.59.78-.53 2.64 2.17 3.78"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m79.05 68.56-2.34-4.24-.2-.36c-.67-1.19-5.48-6.52-14.49-1.98-.81.41-2.49 1.1-3.3 1.52-1.22.63-3.97 2.37-5.49-.13s1.94-4.04 3.09-4.92c.74-.57 1.48-1.13 2.18-1.64 2.47-1.83 4.49-4.19 5.92-6.91.79-1.5 1.56-3.09 1.96-4.24.1-.28.12-.57.1-.87-.09-1.1-1.14-4.18-1.65-5.62a2.79 2.79 0 0 0-.96-1.31c-.86-.64-2.38-1.61-3.63-1.59 0 0-1.9-.07-3.24 1.41-.29.32-.59.55-.87.73-1.14.68-2.66.31-3.31-.84-.31-.55-.44-1.28-.02-2.22 1.07-2.38 3.8-3.78 3.8-3.78s6.41-3.39 12.6 1.87C74.56 38 77.83 45.7 80.14 50.11c1.25 2.38 4.56 7.9 6.45 11.03"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 20.182 68.56)",
        d: "M10.28 65.55h19.8v6.03h-19.8z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(135 83.818 68.565)",
        d: "M73.92 65.55h19.8v6.03h-19.8z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWeCare104 = (WhiteLabelWeCare104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWeCare56.tsx


var WhiteLabelWeCare56_excluded = ["className"];
function WhiteLabelWeCare56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWeCare56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWeCare56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWeCare56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWeCare56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWeCare56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWeCare56_objectSpread(WhiteLabelWeCare56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-shade",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 11.445 36.61)",
        d: "M6.3 35.05h10.3v3.13H6.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(135 44.55 36.612)",
        d: "M39.4 35.05h10.3v3.13H39.4z"
      })]
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M18.7 19.09c.95-1.07 1.86-2.25 2.72-2.99.55-.48 1.48-.96 2.31-1.24 1.02-.35 2.3-.32 2.75.27.31.41.28 1.37-1.13 1.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m14.37 36.61 1.22-2.2.1-.19c.35-.62 2.85-3.39 7.53-1.03.42.21 1.29.57 1.71.79.63.33 2.07 1.23 2.86-.07s-1.01-2.1-1.61-2.56c-.38-.3-.77-.59-1.13-.85-1.28-.95-2.34-2.18-3.08-3.59-.41-.78-.81-1.61-1.02-2.21-.05-.15-.06-.3-.05-.45.04-.57.59-2.17.86-2.92.1-.27.27-.51.5-.68.45-.33 1.24-.84 1.89-.83 0 0 .99-.04 1.69.73.15.17.31.29.45.38.59.35 1.38.16 1.72-.44.16-.28.23-.67 0-1.15-.56-1.24-1.98-1.96-1.98-1.96s-3.33-1.76-6.55.97c-2.79 2.37-4.49 6.37-5.69 8.67-.71 1.35-2.68 4.63-3.6 6.14M37.72 19.08c-.95-1.07-1.85-2.24-2.71-2.98-.55-.48-1.48-.96-2.31-1.24-1.02-.35-2.3-.32-2.75.27-.31.41-.28 1.37 1.13 1.96"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "m42.06 36.61-1.22-2.2-.1-.19c-.35-.62-2.85-3.39-7.53-1.03-.42.21-1.29.57-1.71.79-.63.33-2.07 1.23-2.86-.07s1.01-2.1 1.61-2.56c.38-.3.77-.59 1.13-.85 1.28-.95 2.34-2.18 3.08-3.59.41-.78.81-1.61 1.02-2.21.05-.15.06-.3.05-.45-.04-.57-.59-2.17-.86-2.92-.1-.27-.27-.51-.5-.68-.45-.33-1.24-.84-1.89-.83 0 0-.99-.04-1.69.73-.15.17-.31.29-.45.38-.59.35-1.38.16-1.72-.44-.16-.28-.23-.67 0-1.15.56-1.24 1.98-1.96 1.98-1.96s3.33-1.76 6.55.97c2.79 2.37 4.49 6.37 5.69 8.67.64 1.21 2.3 4 3.3 5.64"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(45 11.445 36.61)",
        d: "M6.3 35.05h10.3v3.13H6.3z"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        transform: "rotate(135 44.55 36.612)",
        d: "M39.4 35.05h10.3v3.13H39.4z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWeCare56 = (WhiteLabelWeCare56);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWiFi104.tsx


var WhiteLabelWiFi104_excluded = ["className"];
function WhiteLabelWiFi104_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWiFi104_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWiFi104_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWiFi104_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWiFi104(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWiFi104_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWiFi104_objectSpread(WhiteLabelWiFi104_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 104",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.22 75.85c0 4.51-3.65 8.16-8.16 8.16s-8.16-3.65-8.16-8.16 3.65-8.16 8.16-8.16 8.16 3.65 8.16 8.16Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M81.98 49.7c-16.52-16.52-43.32-16.52-59.84 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M71.11 60.59c-10.51-10.51-27.56-10.51-38.07 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M92.86 38.84c-22.53-22.53-59.07-22.53-81.6 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M60.22 75.85c0 4.51-3.65 8.16-8.16 8.16s-8.16-3.65-8.16-8.16 3.65-8.16 8.16-8.16 8.16 3.65 8.16 8.16Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWiFi104 = (WhiteLabelWiFi104);
;// ./src/Picto/GeneratedPictoComponents/WhiteLabelWiFi56.tsx


var WhiteLabelWiFi56_excluded = ["className"];
function WhiteLabelWiFi56_ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function WhiteLabelWiFi56_objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? WhiteLabelWiFi56_ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : WhiteLabelWiFi56_ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function WhiteLabelWiFi56(props) {
  var className = props.className,
    other = objectWithoutProperties_default()(props, WhiteLabelWiFi56_excluded);
  return /*#__PURE__*/(0,jsx_runtime_.jsxs)("svg", WhiteLabelWiFi56_objectSpread(WhiteLabelWiFi56_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56",
    className: className
  }, other), {}, {
    children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("g", {
      className: "WhiteLabel-shade",
      children: /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.85 40.58a4.12 4.12 0 1 1-8.241-.001 4.12 4.12 0 0 1 8.241.001Z"
      })
    }), /*#__PURE__*/(0,jsx_runtime_.jsxs)("g", {
      className: "WhiteLabel-stroke",
      children: [/*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M42.82 27.38c-8.34-8.34-21.86-8.34-30.19 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M37.34 32.88c-5.31-5.31-13.9-5.31-19.21 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M48.32 21.9c-11.37-11.37-29.8-11.37-41.17 0"
      }), /*#__PURE__*/(0,jsx_runtime_.jsx)("path", {
        d: "M31.85 40.58a4.12 4.12 0 1 1-8.241-.001 4.12 4.12 0 0 1 8.241.001Z"
      })]
    })]
  }));
}
/* harmony default export */ const GeneratedPictoComponents_WhiteLabelWiFi56 = (WhiteLabelWiFi56);
;// ./src/Picto/GeneratedPictoComponents/index.tsx


































































































































































































































































































































































































































































































































































































































































































































/***/ }),

/***/ 6942:
/***/ ((module, exports) => {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),

/***/ 8732:
/***/ ((module) => {

"use strict";
module.exports = require("react/jsx-runtime");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Accessories104: () => (/* reexport */ GeneratedPictoComponents/* Accessories104 */.QPr),
  Accessories56: () => (/* reexport */ GeneratedPictoComponents/* Accessories56 */._Zu),
  AccountsPayments104: () => (/* reexport */ GeneratedPictoComponents/* AccountsPayments104 */.d0I),
  AccountsPayments56: () => (/* reexport */ GeneratedPictoComponents/* AccountsPayments56 */.REj),
  AdaptiveCollaborationCloud104: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveCollaborationCloud104 */.Utp),
  AdaptiveCollaborationCloud56: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveCollaborationCloud56 */.uZA),
  AdaptiveCollaborationPhone104: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveCollaborationPhone104 */.HcZ),
  AdaptiveCollaborationPhone56: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveCollaborationPhone56 */.xZ_),
  AdaptiveNetworksCentre104: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveNetworksCentre104 */.g4K),
  AdaptiveNetworksCentre56: () => (/* reexport */ GeneratedPictoComponents/* AdaptiveNetworksCentre56 */.oje),
  Add104: () => (/* reexport */ GeneratedPictoComponents/* Add104 */.vsu),
  Add56: () => (/* reexport */ GeneratedPictoComponents/* Add56 */.NXV),
  AddPhone104: () => (/* reexport */ GeneratedPictoComponents/* AddPhone104 */.fWu),
  AddPhone56: () => (/* reexport */ GeneratedPictoComponents/* AddPhone56 */.V7t),
  AdultFemale104: () => (/* reexport */ GeneratedPictoComponents/* AdultFemale104 */.eXj),
  AdultFemale56: () => (/* reexport */ GeneratedPictoComponents/* AdultFemale56 */.E3S),
  AdultMale104: () => (/* reexport */ GeneratedPictoComponents/* AdultMale104 */.tcT),
  AdultMale56: () => (/* reexport */ GeneratedPictoComponents/* AdultMale56 */.Zi1),
  AndrogynousPersonOne104: () => (/* reexport */ GeneratedPictoComponents/* AndrogynousPersonOne104 */.ch_),
  AndrogynousPersonOne56: () => (/* reexport */ GeneratedPictoComponents/* AndrogynousPersonOne56 */.Q8C),
  AndrogynousPersonTwo104: () => (/* reexport */ GeneratedPictoComponents/* AndrogynousPersonTwo104 */.Cx_),
  AndrogynousPersonTwo56: () => (/* reexport */ GeneratedPictoComponents/* AndrogynousPersonTwo56 */.AhW),
  AppMyTelstra104: () => (/* reexport */ GeneratedPictoComponents/* AppMyTelstra104 */.WSR),
  AppMyTelstra56: () => (/* reexport */ GeneratedPictoComponents/* AppMyTelstra56 */.qDK),
  Appointment104: () => (/* reexport */ GeneratedPictoComponents/* Appointment104 */.FOm),
  Appointment56: () => (/* reexport */ GeneratedPictoComponents/* Appointment56 */.hI1),
  Arts104: () => (/* reexport */ GeneratedPictoComponents/* Arts104 */.QEx),
  Arts56: () => (/* reexport */ GeneratedPictoComponents/* Arts56 */.ac3),
  Australia104: () => (/* reexport */ GeneratedPictoComponents/* Australia104 */.aIk),
  Australia56: () => (/* reexport */ GeneratedPictoComponents/* Australia56 */.O3F),
  AvatarAdultFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarAdultFemale104 */.v6m),
  AvatarAdultFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarAdultFemale56 */.jwJ),
  AvatarAdultMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarAdultMale104 */.Ah2),
  AvatarAdultMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarAdultMale56 */.I0M),
  AvatarAndrogynousPersonOne104: () => (/* reexport */ GeneratedPictoComponents/* AvatarAndrogynousPersonOne104 */.h9e),
  AvatarAndrogynousPersonOne56: () => (/* reexport */ GeneratedPictoComponents/* AvatarAndrogynousPersonOne56 */.Z1y),
  AvatarAndrogynousPersonTwo104: () => (/* reexport */ GeneratedPictoComponents/* AvatarAndrogynousPersonTwo104 */.BuJ),
  AvatarAndrogynousPersonTwo56: () => (/* reexport */ GeneratedPictoComponents/* AvatarAndrogynousPersonTwo56 */.nhX),
  AvatarBaby104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaby104 */.XAp),
  AvatarBaby56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaby56 */.xJt),
  AvatarBaldMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldMale104 */.Rjr),
  AvatarBaldMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldMale56 */.xX7),
  AvatarBaldManBeard104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldManBeard104 */.UQg),
  AvatarBaldManBeard56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldManBeard56 */.QT5),
  AvatarBaldManGlasses104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldManGlasses104 */.WG),
  AvatarBaldManGlasses56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBaldManGlasses56 */.AAs),
  AvatarBeardMan104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBeardMan104 */.pgS),
  AvatarBeardMan56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBeardMan56 */.$l4),
  AvatarBoy104: () => (/* reexport */ GeneratedPictoComponents/* AvatarBoy104 */.zHm),
  AvatarBoy56: () => (/* reexport */ GeneratedPictoComponents/* AvatarBoy56 */.RmD),
  AvatarCat104: () => (/* reexport */ GeneratedPictoComponents/* AvatarCat104 */.rcj),
  AvatarCat56: () => (/* reexport */ GeneratedPictoComponents/* AvatarCat56 */.voT),
  AvatarChild104: () => (/* reexport */ GeneratedPictoComponents/* AvatarChild104 */.b5x),
  AvatarChild56: () => (/* reexport */ GeneratedPictoComponents/* AvatarChild56 */.t8E),
  AvatarDoctorFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarDoctorFemale104 */.SHB),
  AvatarDoctorFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarDoctorFemale56 */.otz),
  AvatarDog104: () => (/* reexport */ GeneratedPictoComponents/* AvatarDog104 */.Hh7),
  AvatarDog56: () => (/* reexport */ GeneratedPictoComponents/* AvatarDog56 */.N0t),
  AvatarElderlyFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarElderlyFemale104 */.Gx1),
  AvatarElderlyFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarElderlyFemale56 */.Q1i),
  AvatarElderlyMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarElderlyMale104 */.N0n),
  AvatarElderlyMan56: () => (/* reexport */ GeneratedPictoComponents/* AvatarElderlyMan56 */.axd),
  AvatarFemaleOveralls104: () => (/* reexport */ GeneratedPictoComponents/* AvatarFemaleOveralls104 */.$NO),
  AvatarFemaleOveralls56: () => (/* reexport */ GeneratedPictoComponents/* AvatarFemaleOveralls56 */.Tjc),
  AvatarFirstNationsFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarFirstNationsFemale104 */.tMu),
  AvatarFirstNationsFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarFirstNationsFemale56 */.BOo),
  AvatarFirstNationsMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarFirstNationsMale104 */.CB9),
  AvatarFirstNationsMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarFirstNationsMale56 */.Qll),
  AvatarGirlPigTails104: () => (/* reexport */ GeneratedPictoComponents/* AvatarGirlPigTails104 */.SQV),
  AvatarGirlPigTails56: () => (/* reexport */ GeneratedPictoComponents/* AvatarGirlPigTails56 */.YsU),
  AvatarHatAndSunglasses104: () => (/* reexport */ GeneratedPictoComponents/* AvatarHatAndSunglasses104 */.jeu),
  AvatarHatAndSunglasses56: () => (/* reexport */ GeneratedPictoComponents/* AvatarHatAndSunglasses56 */.Rlz),
  AvatarHijabFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarHijabFemale104 */.FPx),
  AvatarHijabFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarHijabFemale56 */.juj),
  AvatarLady104: () => (/* reexport */ GeneratedPictoComponents/* AvatarLady104 */.dPE),
  AvatarLady56: () => (/* reexport */ GeneratedPictoComponents/* AvatarLady56 */.XMD),
  AvatarLadyGlasses104: () => (/* reexport */ GeneratedPictoComponents/* AvatarLadyGlasses104 */.xFb),
  AvatarLadyGlasses56: () => (/* reexport */ GeneratedPictoComponents/* AvatarLadyGlasses56 */.ni),
  AvatarLonghairGirl104: () => (/* reexport */ GeneratedPictoComponents/* AvatarLonghairGirl104 */.$E6),
  AvatarLonghairGirl56: () => (/* reexport */ GeneratedPictoComponents/* AvatarLonghairGirl56 */.Nvw),
  AvatarMiddleAgeFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarMiddleAgeFemale104 */.dlZ),
  AvatarMiddleAgeFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarMiddleAgeFemale56 */.nMy),
  AvatarMiddleAgeMan104: () => (/* reexport */ GeneratedPictoComponents/* AvatarMiddleAgeMan104 */.Vdx),
  AvatarMiddleAgeMan56: () => (/* reexport */ GeneratedPictoComponents/* AvatarMiddleAgeMan56 */.DyI),
  AvatarMoustacheMan104: () => (/* reexport */ GeneratedPictoComponents/* AvatarMoustacheMan104 */.sXJ),
  AvatarMoustacheMan56: () => (/* reexport */ GeneratedPictoComponents/* AvatarMoustacheMan56 */.a9B),
  AvatarOutbackMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarOutbackMale104 */.nXY),
  AvatarOutbackMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarOutbackMale56 */.V87),
  AvatarPerson104: () => (/* reexport */ GeneratedPictoComponents/* AvatarPerson104 */.WMr),
  AvatarPerson56: () => (/* reexport */ GeneratedPictoComponents/* AvatarPerson56 */.gUx),
  AvatarPersonAfro104: () => (/* reexport */ GeneratedPictoComponents/* AvatarPersonAfro104 */.yiK),
  AvatarPersonAfro56: () => (/* reexport */ GeneratedPictoComponents/* AvatarPersonAfro56 */.mB0),
  AvatarPersonBusiness104: () => (/* reexport */ GeneratedPictoComponents/* AvatarPersonBusiness104 */.M_z),
  AvatarPersonBusiness56: () => (/* reexport */ GeneratedPictoComponents/* AvatarPersonBusiness56 */.KoE),
  AvatarSunSmartMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarSunSmartMale104 */.P5),
  AvatarSunSmartMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarSunSmartMale56 */.pgU),
  AvatarTeen104: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeen104 */.La4),
  AvatarTeen56: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeen56 */.HaM),
  AvatarTeenFemale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeenFemale104 */.lx0),
  AvatarTeenFemale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeenFemale56 */.tLD),
  AvatarTeenGirl104: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeenGirl104 */.r9k),
  AvatarTeenGirl56: () => (/* reexport */ GeneratedPictoComponents/* AvatarTeenGirl56 */.xAC),
  AvatarTelstraHardHat104: () => (/* reexport */ GeneratedPictoComponents/* AvatarTelstraHardHat104 */.YoX),
  AvatarTelstraHardHat56: () => (/* reexport */ GeneratedPictoComponents/* AvatarTelstraHardHat56 */.aMR),
  AvatarTurbanMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarTurbanMale104 */.AxB),
  AvatarTurbanMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarTurbanMale56 */.YSO),
  AvatarYoungAdultMale104: () => (/* reexport */ GeneratedPictoComponents/* AvatarYoungAdultMale104 */.AVi),
  AvatarYoungAdultMale56: () => (/* reexport */ GeneratedPictoComponents/* AvatarYoungAdultMale56 */.EIq),
  Baby104: () => (/* reexport */ GeneratedPictoComponents/* Baby104 */.wbc),
  Baby56: () => (/* reexport */ GeneratedPictoComponents/* Baby56 */.SbQ),
  BaldMale104: () => (/* reexport */ GeneratedPictoComponents/* BaldMale104 */.gfv),
  BaldMale56: () => (/* reexport */ GeneratedPictoComponents/* BaldMale56 */.Aam),
  Bank104: () => (/* reexport */ GeneratedPictoComponents/* Bank104 */.GBo),
  Bank56: () => (/* reexport */ GeneratedPictoComponents/* Bank56 */.EJI),
  BillEmails104: () => (/* reexport */ GeneratedPictoComponents/* BillEmails104 */.aGk),
  BillEmails56: () => (/* reexport */ GeneratedPictoComponents/* BillEmails56 */.QAs),
  BillOverview104: () => (/* reexport */ GeneratedPictoComponents/* BillOverview104 */.CTE),
  BillOverview56: () => (/* reexport */ GeneratedPictoComponents/* BillOverview56 */.eoU),
  BillPaid104: () => (/* reexport */ GeneratedPictoComponents/* BillPaid104 */.F80),
  BillPaid56: () => (/* reexport */ GeneratedPictoComponents/* BillPaid56 */.pc),
  BroadbandEnterpriseSim104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandEnterpriseSim104 */.Zce),
  BroadbandEnterpriseSim56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandEnterpriseSim56 */.BCV),
  BroadbandHome104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandHome104 */.YsL),
  BroadbandHome56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandHome56 */.KSw),
  BroadbandMobile104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobile104 */.zhB),
  BroadbandMobile56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobile56 */.xik),
  BroadbandMobileSim104: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobileSim104 */.yOw),
  BroadbandMobileSim56: () => (/* reexport */ GeneratedPictoComponents/* BroadbandMobileSim56 */.Ysk),
  Building104: () => (/* reexport */ GeneratedPictoComponents/* Building104 */.ElF),
  Building56: () => (/* reexport */ GeneratedPictoComponents/* Building56 */.AAo),
  Bundles104: () => (/* reexport */ GeneratedPictoComponents/* Bundles104 */.Fe3),
  Bundles56: () => (/* reexport */ GeneratedPictoComponents/* Bundles56 */.V6E),
  Bus104: () => (/* reexport */ GeneratedPictoComponents/* Bus104 */.s$5),
  Bus56: () => (/* reexport */ GeneratedPictoComponents/* Bus56 */.GRV),
  BusinessIdeas104: () => (/* reexport */ GeneratedPictoComponents/* BusinessIdeas104 */.kxm),
  BusinessIdeas56: () => (/* reexport */ GeneratedPictoComponents/* BusinessIdeas56 */.c84),
  BusinessOperation104: () => (/* reexport */ GeneratedPictoComponents/* BusinessOperation104 */.HIS),
  BusinessOperation56: () => (/* reexport */ GeneratedPictoComponents/* BusinessOperation56 */.FhU),
  BusinessSoftware104: () => (/* reexport */ GeneratedPictoComponents/* BusinessSoftware104 */.Hrr),
  BusinessSoftware56: () => (/* reexport */ GeneratedPictoComponents/* BusinessSoftware56 */.pkN),
  BusinessStrategy104: () => (/* reexport */ GeneratedPictoComponents/* BusinessStrategy104 */.D1f),
  BusinessStrategy56: () => (/* reexport */ GeneratedPictoComponents/* BusinessStrategy56 */.D7j),
  Calendar104: () => (/* reexport */ GeneratedPictoComponents/* Calendar104 */.sm2),
  Calendar56: () => (/* reexport */ GeneratedPictoComponents/* Calendar56 */.a04),
  CardAdded104: () => (/* reexport */ GeneratedPictoComponents/* CardAdded104 */._x_),
  CardAdded56: () => (/* reexport */ GeneratedPictoComponents/* CardAdded56 */.Sy8),
  Cart104: () => (/* reexport */ GeneratedPictoComponents/* Cart104 */.Yer),
  Cart56: () => (/* reexport */ GeneratedPictoComponents/* Cart56 */.u_n),
  Cat104: () => (/* reexport */ GeneratedPictoComponents/* Cat104 */.Yyr),
  Cat56: () => (/* reexport */ GeneratedPictoComponents/* Cat56 */.eIj),
  ChangePlan104: () => (/* reexport */ GeneratedPictoComponents/* ChangePlan104 */.$$c),
  ChangePlan56: () => (/* reexport */ GeneratedPictoComponents/* ChangePlan56 */.VUw),
  Charger104: () => (/* reexport */ GeneratedPictoComponents/* Charger104 */.myR),
  Charger56: () => (/* reexport */ GeneratedPictoComponents/* Charger56 */.EEn),
  Chat104: () => (/* reexport */ GeneratedPictoComponents/* Chat104 */.cI7),
  Chat56: () => (/* reexport */ GeneratedPictoComponents/* Chat56 */.QBb),
  Child104: () => (/* reexport */ GeneratedPictoComponents/* Child104 */.SYq),
  Child56: () => (/* reexport */ GeneratedPictoComponents/* Child56 */.ijV),
  ClickAndCollect104: () => (/* reexport */ GeneratedPictoComponents/* ClickAndCollect104 */.PzM),
  ClickAndCollect56: () => (/* reexport */ GeneratedPictoComponents/* ClickAndCollect56 */.$9K),
  Clock104: () => (/* reexport */ GeneratedPictoComponents/* Clock104 */.uwy),
  Clock56: () => (/* reexport */ GeneratedPictoComponents/* Clock56 */.sQX),
  Compare104: () => (/* reexport */ GeneratedPictoComponents/* Compare104 */.xFn),
  Compare56: () => (/* reexport */ GeneratedPictoComponents/* Compare56 */.dNn),
  CoverageMap104: () => (/* reexport */ GeneratedPictoComponents/* CoverageMap104 */.yro),
  CoverageMap56: () => (/* reexport */ GeneratedPictoComponents/* CoverageMap56 */.WIc),
  CoverageMobile104: () => (/* reexport */ GeneratedPictoComponents/* CoverageMobile104 */.uUp),
  CoverageMobile56: () => (/* reexport */ GeneratedPictoComponents/* CoverageMobile56 */.upS),
  CoverageNetwork104: () => (/* reexport */ GeneratedPictoComponents/* CoverageNetwork104 */.qHv),
  CoverageNetwork56: () => (/* reexport */ GeneratedPictoComponents/* CoverageNetwork56 */.kxy),
  Cyclone104: () => (/* reexport */ GeneratedPictoComponents/* Cyclone104 */.P$D),
  Cyclone56: () => (/* reexport */ GeneratedPictoComponents/* Cyclone56 */.lkG),
  CycloneandStorms104: () => (/* reexport */ GeneratedPictoComponents/* CycloneandStorms104 */.c38),
  CycloneandStorms56: () => (/* reexport */ GeneratedPictoComponents/* CycloneandStorms56 */.Gl9),
  DataPacks104: () => (/* reexport */ GeneratedPictoComponents/* DataPacks104 */.OwO),
  DataPacks56: () => (/* reexport */ GeneratedPictoComponents/* DataPacks56 */.ASF),
  DataPool104: () => (/* reexport */ GeneratedPictoComponents/* DataPool104 */.MW9),
  DataPool56: () => (/* reexport */ GeneratedPictoComponents/* DataPool56 */.wfL),
  Deal104: () => (/* reexport */ GeneratedPictoComponents/* Deal104 */.S9t),
  Deal56: () => (/* reexport */ GeneratedPictoComponents/* Deal56 */.GmQ),
  Delivery104: () => (/* reexport */ GeneratedPictoComponents/* Delivery104 */.I1h),
  Delivery56: () => (/* reexport */ GeneratedPictoComponents/* Delivery56 */.Klo),
  DeviceLocator104: () => (/* reexport */ GeneratedPictoComponents/* DeviceLocator104 */.iF7),
  DeviceLocator56: () => (/* reexport */ GeneratedPictoComponents/* DeviceLocator56 */.OKz),
  DeviceProtect104: () => (/* reexport */ GeneratedPictoComponents/* DeviceProtect104 */.Nue),
  DeviceProtect56: () => (/* reexport */ GeneratedPictoComponents/* DeviceProtect56 */.pUO),
  Devices104: () => (/* reexport */ GeneratedPictoComponents/* Devices104 */.p5u),
  Devices56: () => (/* reexport */ GeneratedPictoComponents/* Devices56 */.pZ_),
  Disruptions104: () => (/* reexport */ GeneratedPictoComponents/* Disruptions104 */.WGS),
  Disruptions56: () => (/* reexport */ GeneratedPictoComponents/* Disruptions56 */.kY4),
  DoctorFemale104: () => (/* reexport */ GeneratedPictoComponents/* DoctorFemale104 */.JSp),
  DoctorFemale56: () => (/* reexport */ GeneratedPictoComponents/* DoctorFemale56 */.$hd),
  Document104: () => (/* reexport */ GeneratedPictoComponents/* Document104 */.HWe),
  Document56: () => (/* reexport */ GeneratedPictoComponents/* Document56 */.BZN),
  Dog104: () => (/* reexport */ GeneratedPictoComponents/* Dog104 */.i2u),
  Dog56: () => (/* reexport */ GeneratedPictoComponents/* Dog56 */.ih7),
  Download104: () => (/* reexport */ GeneratedPictoComponents/* Download104 */.QBH),
  Download56: () => (/* reexport */ GeneratedPictoComponents/* Download56 */.Kfi),
  DownloadDoc104: () => (/* reexport */ GeneratedPictoComponents/* DownloadDoc104 */.G2q),
  DownloadDoc56: () => (/* reexport */ GeneratedPictoComponents/* DownloadDoc56 */.KPY),
  DriverLicence104: () => (/* reexport */ GeneratedPictoComponents/* DriverLicence104 */.f9x),
  DriverLicence56: () => (/* reexport */ GeneratedPictoComponents/* DriverLicence56 */.xGl),
  ESIM104: () => (/* reexport */ GeneratedPictoComponents/* ESIM104 */.Qmz),
  ESIM56: () => (/* reexport */ GeneratedPictoComponents/* ESIM56 */.Az$),
  EarnPoints104: () => (/* reexport */ GeneratedPictoComponents/* EarnPoints104 */.xhX),
  EarnPoints56: () => (/* reexport */ GeneratedPictoComponents/* EarnPoints56 */.txR),
  Earthquake104: () => (/* reexport */ GeneratedPictoComponents/* Earthquake104 */.zAX),
  Earthquake56: () => (/* reexport */ GeneratedPictoComponents/* Earthquake56 */.Bbp),
  Edit104: () => (/* reexport */ GeneratedPictoComponents/* Edit104 */.I7o),
  Edit56: () => (/* reexport */ GeneratedPictoComponents/* Edit56 */.erH),
  ElderlyFemale104: () => (/* reexport */ GeneratedPictoComponents/* ElderlyFemale104 */.TiV),
  ElderlyFemale56: () => (/* reexport */ GeneratedPictoComponents/* ElderlyFemale56 */.jqV),
  ElderlyMale104: () => (/* reexport */ GeneratedPictoComponents/* ElderlyMale104 */.qOU),
  ElderyMale56: () => (/* reexport */ GeneratedPictoComponents/* ElderyMale56 */.Guf),
  Electricity104: () => (/* reexport */ GeneratedPictoComponents/* Electricity104 */.hMn),
  Electricity56: () => (/* reexport */ GeneratedPictoComponents/* Electricity56 */.XDi),
  ElectricityMeter104: () => (/* reexport */ GeneratedPictoComponents/* ElectricityMeter104 */.Wl_),
  ElectricityMeter56: () => (/* reexport */ GeneratedPictoComponents/* ElectricityMeter56 */.kjk),
  EmptyStateBox104: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateBox104 */.NNB),
  EmptyStateBox56: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateBox56 */.f0I),
  EmptyStateTray104: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateTray104 */.iBJ),
  EmptyStateTray56: () => (/* reexport */ GeneratedPictoComponents/* EmptyStateTray56 */.iyr),
  Energy104: () => (/* reexport */ GeneratedPictoComponents/* Energy104 */._Q_),
  Energy56: () => (/* reexport */ GeneratedPictoComponents/* Energy56 */.AkG),
  EnergySolar104: () => (/* reexport */ GeneratedPictoComponents/* EnergySolar104 */.FUz),
  EnergySolar56: () => (/* reexport */ GeneratedPictoComponents/* EnergySolar56 */.TxP),
  EnergyWind104: () => (/* reexport */ GeneratedPictoComponents/* EnergyWind104 */.yhb),
  EnergyWind56: () => (/* reexport */ GeneratedPictoComponents/* EnergyWind56 */.gNE),
  EnterpriseCloud104: () => (/* reexport */ GeneratedPictoComponents/* EnterpriseCloud104 */._TJ),
  EnterpriseCloud56: () => (/* reexport */ GeneratedPictoComponents/* EnterpriseCloud56 */.Qbz),
  Entertainment104: () => (/* reexport */ GeneratedPictoComponents/* Entertainment104 */.Q7K),
  Entertainment56: () => (/* reexport */ GeneratedPictoComponents/* Entertainment56 */.UgD),
  EntertainmentPackages104: () => (/* reexport */ GeneratedPictoComponents/* EntertainmentPackages104 */.Jr6),
  EntertainmentPackages56: () => (/* reexport */ GeneratedPictoComponents/* EntertainmentPackages56 */.jAx),
  Error104: () => (/* reexport */ GeneratedPictoComponents/* Error104 */.sZs),
  Error56: () => (/* reexport */ GeneratedPictoComponents/* Error56 */.uzh),
  ErrorServer104: () => (/* reexport */ GeneratedPictoComponents/* ErrorServer104 */.TXC),
  ErrorServer56: () => (/* reexport */ GeneratedPictoComponents/* ErrorServer56 */.pC6),
  FailedConnection104: () => (/* reexport */ GeneratedPictoComponents/* FailedConnection104 */.hpL),
  FailedConnection56: () => (/* reexport */ GeneratedPictoComponents/* FailedConnection56 */.ltI),
  Feedback104: () => (/* reexport */ GeneratedPictoComponents/* Feedback104 */.lIE),
  Feedback56: () => (/* reexport */ GeneratedPictoComponents/* Feedback56 */.r3K),
  FieldExecution104: () => (/* reexport */ GeneratedPictoComponents/* FieldExecution104 */.w_5),
  FieldExecution56: () => (/* reexport */ GeneratedPictoComponents/* FieldExecution56 */.Epc),
  Fire104: () => (/* reexport */ GeneratedPictoComponents/* Fire104 */.iU6),
  Fire56: () => (/* reexport */ GeneratedPictoComponents/* Fire56 */.OVP),
  FirstNationsFemale104: () => (/* reexport */ GeneratedPictoComponents/* FirstNationsFemale104 */.axl),
  FirstNationsFemale56: () => (/* reexport */ GeneratedPictoComponents/* FirstNationsFemale56 */.Irh),
  FirstNationsMale104: () => (/* reexport */ GeneratedPictoComponents/* FirstNationsMale104 */.JQZ),
  FirstNationsMale56: () => (/* reexport */ GeneratedPictoComponents/* FirstNationsMale56 */.f9g),
  Floods104: () => (/* reexport */ GeneratedPictoComponents/* Floods104 */.RZG),
  Floods56: () => (/* reexport */ GeneratedPictoComponents/* Floods56 */.zW),
  Foxtel104: () => (/* reexport */ GeneratedPictoComponents/* Foxtel104 */.qR6),
  Foxtel56: () => (/* reexport */ GeneratedPictoComponents/* Foxtel56 */.ay8),
  Gaming104: () => (/* reexport */ GeneratedPictoComponents/* Gaming104 */.Fj$),
  Gaming56: () => (/* reexport */ GeneratedPictoComponents/* Gaming56 */.Vl2),
  Gas104: () => (/* reexport */ GeneratedPictoComponents/* Gas104 */.vtR),
  Gas56: () => (/* reexport */ GeneratedPictoComponents/* Gas56 */.PJz),
  GasMeter104: () => (/* reexport */ GeneratedPictoComponents/* GasMeter104 */.Shi),
  GasMeter56: () => (/* reexport */ GeneratedPictoComponents/* GasMeter56 */.WEo),
  GetInTouch104: () => (/* reexport */ GeneratedPictoComponents/* GetInTouch104 */.Asf),
  GetInTouch56: () => (/* reexport */ GeneratedPictoComponents/* GetInTouch56 */.IdC),
  Gift104: () => (/* reexport */ GeneratedPictoComponents/* Gift104 */.ISd),
  Gift56: () => (/* reexport */ GeneratedPictoComponents/* Gift56 */.GCG),
  GlobalMapMarker104: () => (/* reexport */ GeneratedPictoComponents/* GlobalMapMarker104 */.$dF),
  GlobalMapMarker56: () => (/* reexport */ GeneratedPictoComponents/* GlobalMapMarker56 */.jZt),
  GlobalNetworks104: () => (/* reexport */ GeneratedPictoComponents/* GlobalNetworks104 */.KMy),
  GlobalNetworks56: () => (/* reexport */ GeneratedPictoComponents/* GlobalNetworks56 */.Yc$),
  GreenEnergy104: () => (/* reexport */ GeneratedPictoComponents/* GreenEnergy104 */.nC5),
  GreenEnergy56: () => (/* reexport */ GeneratedPictoComponents/* GreenEnergy56 */.R53),
  Headphones104: () => (/* reexport */ GeneratedPictoComponents/* Headphones104 */.v9L),
  Headphones56: () => (/* reexport */ GeneratedPictoComponents/* Headphones56 */.Zor),
  Help104: () => (/* reexport */ GeneratedPictoComponents/* Help104 */.vNJ),
  Help56: () => (/* reexport */ GeneratedPictoComponents/* Help56 */.FE_),
  HijabFemale104: () => (/* reexport */ GeneratedPictoComponents/* HijabFemale104 */.Khh),
  HijabFemale56: () => (/* reexport */ GeneratedPictoComponents/* HijabFemale56 */.COb),
  History104: () => (/* reexport */ GeneratedPictoComponents/* History104 */.ax6),
  History56: () => (/* reexport */ GeneratedPictoComponents/* History56 */.WmI),
  Home104: () => (/* reexport */ GeneratedPictoComponents/* Home104 */.rp8),
  Home56: () => (/* reexport */ GeneratedPictoComponents/* Home56 */.Bw6),
  IDGeneric104: () => (/* reexport */ GeneratedPictoComponents/* IDGeneric104 */.EVk),
  IDGeneric56: () => (/* reexport */ GeneratedPictoComponents/* IDGeneric56 */.ehO),
  IOT104: () => (/* reexport */ GeneratedPictoComponents/* IOT104 */.ilR),
  IOT56: () => (/* reexport */ GeneratedPictoComponents/* IOT56 */.yWR),
  IOTUpdate104: () => (/* reexport */ GeneratedPictoComponents/* IOTUpdate104 */.ZCJ),
  IOTUpdate56: () => (/* reexport */ GeneratedPictoComponents/* IOTUpdate56 */.VOZ),
  IRCallingPack104: () => (/* reexport */ GeneratedPictoComponents/* IRCallingPack104 */.sEK),
  IRCallingPack56: () => (/* reexport */ GeneratedPictoComponents/* IRCallingPack56 */.agt),
  Information104: () => (/* reexport */ GeneratedPictoComponents/* Information104 */.MFY),
  Information56: () => (/* reexport */ GeneratedPictoComponents/* Information56 */.O19),
  Installation104: () => (/* reexport */ GeneratedPictoComponents/* Installation104 */.sHe),
  Installation56: () => (/* reexport */ GeneratedPictoComponents/* Installation56 */.eh),
  InternationalCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternationalCalls104 */.FbT),
  InternationalCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternationalCalls56 */.HOF),
  InternationalMobileCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternationalMobileCalls104 */.fzU),
  InternationalMobileCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternationalMobileCalls56 */.hmm),
  Internet104: () => (/* reexport */ GeneratedPictoComponents/* Internet104 */.vUf),
  Internet56: () => (/* reexport */ GeneratedPictoComponents/* Internet56 */.dlB),
  InternetCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternetCalls104 */.kLK),
  InternetCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternetCalls56 */.OjF),
  InternetExtras104: () => (/* reexport */ GeneratedPictoComponents/* InternetExtras104 */.mZb),
  InternetExtras56: () => (/* reexport */ GeneratedPictoComponents/* InternetExtras56 */.aAp),
  InternetMobileCalls104: () => (/* reexport */ GeneratedPictoComponents/* InternetMobileCalls104 */.C78),
  InternetMobileCalls56: () => (/* reexport */ GeneratedPictoComponents/* InternetMobileCalls56 */.CWx),
  InternetOptimiser104: () => (/* reexport */ GeneratedPictoComponents/* InternetOptimiser104 */.TYU),
  InternetOptimiser56: () => (/* reexport */ GeneratedPictoComponents/* InternetOptimiser56 */.hTj),
  Landline104: () => (/* reexport */ GeneratedPictoComponents/* Landline104 */.Pdp),
  Landline56: () => (/* reexport */ GeneratedPictoComponents/* Landline56 */.LVH),
  Laptop104: () => (/* reexport */ GeneratedPictoComponents/* Laptop104 */._Ej),
  Laptop56: () => (/* reexport */ GeneratedPictoComponents/* Laptop56 */.uVd),
  LatencyOptimiser104: () => (/* reexport */ GeneratedPictoComponents/* LatencyOptimiser104 */.ezI),
  LatencyOptimiser56: () => (/* reexport */ GeneratedPictoComponents/* LatencyOptimiser56 */.k9Q),
  LatestInvoices104: () => (/* reexport */ GeneratedPictoComponents/* LatestInvoices104 */.Fie),
  LatestInvoices56: () => (/* reexport */ GeneratedPictoComponents/* LatestInvoices56 */.RS6),
  Legal104: () => (/* reexport */ GeneratedPictoComponents/* Legal104 */.tsg),
  Legal56: () => (/* reexport */ GeneratedPictoComponents/* Legal56 */.rB1),
  MBBRoaming104: () => (/* reexport */ GeneratedPictoComponents/* MBBRoaming104 */.CFv),
  MBBRoaming56: () => (/* reexport */ GeneratedPictoComponents/* MBBRoaming56 */.iAD),
  MIddleAgeFemale56: () => (/* reexport */ GeneratedPictoComponents/* MIddleAgeFemale56 */.Uv0),
  Mail104: () => (/* reexport */ GeneratedPictoComponents/* Mail104 */.r$C),
  Mail56: () => (/* reexport */ GeneratedPictoComponents/* Mail56 */.TBT),
  ManageDevicesAccess104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesAccess104 */.qN0),
  ManageDevicesAccess56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesAccess56 */.cj4),
  ManageDevicesEnrolled104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesEnrolled104 */.HU9),
  ManageDevicesEnrolled56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesEnrolled56 */.Jv6),
  ManageDevicesLock104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesLock104 */.h_F),
  ManageDevicesLock56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesLock56 */.T79),
  ManageDevicesMonitor104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesMonitor104 */.mMu),
  ManageDevicesMonitor56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesMonitor56 */.EKF),
  ManageDevicesSettings104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesSettings104 */.lvr),
  ManageDevicesSettings56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesSettings56 */.R3y),
  ManageDevicesShield104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesShield104 */.tv3),
  ManageDevicesShield56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesShield56 */.JhC),
  ManageDevicesUnenrolled104: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesUnenrolled104 */.SLB),
  ManageDevicesUnenrolled56: () => (/* reexport */ GeneratedPictoComponents/* ManageDevicesUnenrolled56 */.Up),
  MapMarker104: () => (/* reexport */ GeneratedPictoComponents/* MapMarker104 */.Ywy),
  MapMarker56: () => (/* reexport */ GeneratedPictoComponents/* MapMarker56 */.UzT),
  Membership104: () => (/* reexport */ GeneratedPictoComponents/* Membership104 */.Syz),
  Membership56: () => (/* reexport */ GeneratedPictoComponents/* Membership56 */.kmc),
  MiddleAgeFemale104: () => (/* reexport */ GeneratedPictoComponents/* MiddleAgeFemale104 */.M8b),
  MiddleAgeMale104: () => (/* reexport */ GeneratedPictoComponents/* MiddleAgeMale104 */.jVO),
  MiddleAgeMale56: () => (/* reexport */ GeneratedPictoComponents/* MiddleAgeMale56 */.H5g),
  Mobile104: () => (/* reexport */ GeneratedPictoComponents/* Mobile104 */.qdN),
  Mobile56: () => (/* reexport */ GeneratedPictoComponents/* Mobile56 */.c9y),
  MobileAccelerator104: () => (/* reexport */ GeneratedPictoComponents/* MobileAccelerator104 */.Zec),
  MobileAccelerator56: () => (/* reexport */ GeneratedPictoComponents/* MobileAccelerator56 */.PPY),
  MobileSim104: () => (/* reexport */ GeneratedPictoComponents/* MobileSim104 */.BCc),
  MobileSim56: () => (/* reexport */ GeneratedPictoComponents/* MobileSim56 */.ZgE),
  MoveHouse104: () => (/* reexport */ GeneratedPictoComponents/* MoveHouse104 */.FT5),
  MoveHouse56: () => (/* reexport */ GeneratedPictoComponents/* MoveHouse56 */.xRY),
  Movies104: () => (/* reexport */ GeneratedPictoComponents/* Movies104 */.r4),
  Movies56: () => (/* reexport */ GeneratedPictoComponents/* Movies56 */.DqT),
  Music104: () => (/* reexport */ GeneratedPictoComponents/* Music104 */.HWt),
  Music56: () => (/* reexport */ GeneratedPictoComponents/* Music56 */.FnS),
  NBN104: () => (/* reexport */ GeneratedPictoComponents/* NBN104 */.gNp),
  NBN56: () => (/* reexport */ GeneratedPictoComponents/* NBN56 */.edA),
  NBNHealth104: () => (/* reexport */ GeneratedPictoComponents/* NBNHealth104 */.eju),
  NBNHealth56: () => (/* reexport */ GeneratedPictoComponents/* NBNHealth56 */.Avv),
  NetworkSpeed104: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeed104 */.boV),
  NetworkSpeed56: () => (/* reexport */ GeneratedPictoComponents/* NetworkSpeed56 */.XaR),
  NewMobile104: () => (/* reexport */ GeneratedPictoComponents/* NewMobile104 */.SNl),
  NewMobile56: () => (/* reexport */ GeneratedPictoComponents/* NewMobile56 */.KWE),
  News104: () => (/* reexport */ GeneratedPictoComponents/* News104 */.H7H),
  News56: () => (/* reexport */ GeneratedPictoComponents/* News56 */.LdO),
  NoBills104: () => (/* reexport */ GeneratedPictoComponents/* NoBills104 */.B3j),
  NoBills56: () => (/* reexport */ GeneratedPictoComponents/* NoBills56 */.PSB),
  NotificationCall104: () => (/* reexport */ GeneratedPictoComponents/* NotificationCall104 */.Lxz),
  NotificationCall56: () => (/* reexport */ GeneratedPictoComponents/* NotificationCall56 */.TbB),
  NotificationCentre104: () => (/* reexport */ GeneratedPictoComponents/* NotificationCentre104 */.ug6),
  NotificationCentre56: () => (/* reexport */ GeneratedPictoComponents/* NotificationCentre56 */.C7v),
  NotificationEmail104: () => (/* reexport */ GeneratedPictoComponents/* NotificationEmail104 */.DVq),
  NotificationEmail56: () => (/* reexport */ GeneratedPictoComponents/* NotificationEmail56 */.n1w),
  NotificationMessage104: () => (/* reexport */ GeneratedPictoComponents/* NotificationMessage104 */.wVI),
  NotificationMessage56: () => (/* reexport */ GeneratedPictoComponents/* NotificationMessage56 */.kQL),
  NotificationReminder104: () => (/* reexport */ GeneratedPictoComponents/* NotificationReminder104 */.BdC),
  NotificationReminder56: () => (/* reexport */ GeneratedPictoComponents/* NotificationReminder56 */.RDZ),
  Notifications104: () => (/* reexport */ GeneratedPictoComponents/* Notifications104 */.ejq),
  Notifications56: () => (/* reexport */ GeneratedPictoComponents/* Notifications56 */.sHk),
  OneNumber104: () => (/* reexport */ GeneratedPictoComponents/* OneNumber104 */.JKR),
  OneNumber56: () => (/* reexport */ GeneratedPictoComponents/* OneNumber56 */.ZYu),
  OutbackMale104: () => (/* reexport */ GeneratedPictoComponents/* OutbackMale104 */.kj),
  OutbackMale56: () => (/* reexport */ GeneratedPictoComponents/* OutbackMale56 */.om6),
  PassportAustralia104: () => (/* reexport */ GeneratedPictoComponents/* PassportAustralia104 */.cwp),
  PassportAustralia56: () => (/* reexport */ GeneratedPictoComponents/* PassportAustralia56 */.OQY),
  PassportInternational104: () => (/* reexport */ GeneratedPictoComponents/* PassportInternational104 */.OEK),
  PassportInternational56: () => (/* reexport */ GeneratedPictoComponents/* PassportInternational56 */.YWh),
  PayPhone104: () => (/* reexport */ GeneratedPictoComponents/* PayPhone104 */.ECP),
  PayPhone56: () => (/* reexport */ GeneratedPictoComponents/* PayPhone56 */.qE5),
  Payment104: () => (/* reexport */ GeneratedPictoComponents/* Payment104 */.K44),
  Payment56: () => (/* reexport */ GeneratedPictoComponents/* Payment56 */.sCk),
  PaymentCalendar104: () => (/* reexport */ GeneratedPictoComponents/* PaymentCalendar104 */.SB$),
  PaymentCalendar56: () => (/* reexport */ GeneratedPictoComponents/* PaymentCalendar56 */.Ip5),
  PaymentHelp104: () => (/* reexport */ GeneratedPictoComponents/* PaymentHelp104 */.p_k),
  PaymentHelp56: () => (/* reexport */ GeneratedPictoComponents/* PaymentHelp56 */.r5L),
  PaymentPlan104: () => (/* reexport */ GeneratedPictoComponents/* PaymentPlan104 */.dmk),
  PaymentPlan56: () => (/* reexport */ GeneratedPictoComponents/* PaymentPlan56 */.hS6),
  PeaceOfMind104: () => (/* reexport */ GeneratedPictoComponents/* PeaceOfMind104 */.LCd),
  PeaceOfMind56: () => (/* reexport */ GeneratedPictoComponents/* PeaceOfMind56 */.rSY),
  Perfect104: () => (/* reexport */ GeneratedPictoComponents/* Perfect104 */.PBf),
  Perfect56: () => (/* reexport */ GeneratedPictoComponents/* Perfect56 */.RUz),
  Phone104: () => (/* reexport */ GeneratedPictoComponents/* Phone104 */.GFF),
  Phone56: () => (/* reexport */ GeneratedPictoComponents/* Phone56 */.__7),
  PhoneCase104: () => (/* reexport */ GeneratedPictoComponents/* PhoneCase104 */.q5w),
  PhoneCase56: () => (/* reexport */ GeneratedPictoComponents/* PhoneCase56 */.Yt1),
  PhoneSound104: () => (/* reexport */ GeneratedPictoComponents/* PhoneSound104 */.X7E),
  PhoneSound56: () => (/* reexport */ GeneratedPictoComponents/* PhoneSound56 */.pmP),
  Picto4G104: () => (/* reexport */ GeneratedPictoComponents/* Picto4G104 */.E4c),
  Picto4G56: () => (/* reexport */ GeneratedPictoComponents/* Picto4G56 */.CaI),
  Picto4GX104: () => (/* reexport */ GeneratedPictoComponents/* Picto4GX104 */.Aly),
  Picto4GX56: () => (/* reexport */ GeneratedPictoComponents/* Picto4GX56 */.ACQ),
  Picto5G104: () => (/* reexport */ GeneratedPictoComponents/* Picto5G104 */.dg),
  Picto5G56: () => (/* reexport */ GeneratedPictoComponents/* Picto5G56 */.tCC),
  Pin104: () => (/* reexport */ GeneratedPictoComponents/* Pin104 */.hhS),
  Pin56: () => (/* reexport */ GeneratedPictoComponents/* Pin56 */.bkA),
  Placeholder104: () => (/* reexport */ GeneratedPictoComponents/* Placeholder104 */.nJX),
  Placeholder56: () => (/* reexport */ GeneratedPictoComponents/* Placeholder56 */.vTw),
  PoleInspection104: () => (/* reexport */ GeneratedPictoComponents/* PoleInspection104 */.qyB),
  PoleInspection56: () => (/* reexport */ GeneratedPictoComponents/* PoleInspection56 */.kA1),
  PortMobile104: () => (/* reexport */ GeneratedPictoComponents/* PortMobile104 */.dVf),
  PortMobile56: () => (/* reexport */ GeneratedPictoComponents/* PortMobile56 */.tPE),
  PortPhone104: () => (/* reexport */ GeneratedPictoComponents/* PortPhone104 */.f9$),
  PortPhone56: () => (/* reexport */ GeneratedPictoComponents/* PortPhone56 */.pSK),
  PortSIM104: () => (/* reexport */ GeneratedPictoComponents/* PortSIM104 */.iWy),
  PortSIM56: () => (/* reexport */ GeneratedPictoComponents/* PortSIM56 */.e3H),
  PostPaid104: () => (/* reexport */ GeneratedPictoComponents/* PostPaid104 */.Ce6),
  PostPaid56: () => (/* reexport */ GeneratedPictoComponents/* PostPaid56 */.i7Z),
  PrePaid104: () => (/* reexport */ GeneratedPictoComponents/* PrePaid104 */.pxL),
  PrePaid56: () => (/* reexport */ GeneratedPictoComponents/* PrePaid56 */.HEv),
  Preferences104: () => (/* reexport */ GeneratedPictoComponents/* Preferences104 */.aK$),
  Preferences56: () => (/* reexport */ GeneratedPictoComponents/* Preferences56 */.cs1),
  PriorityAssistance104: () => (/* reexport */ GeneratedPictoComponents/* PriorityAssistance104 */.Wux),
  PriorityAssistance56: () => (/* reexport */ GeneratedPictoComponents/* PriorityAssistance56 */.ObM),
  Profile104: () => (/* reexport */ GeneratedPictoComponents/* Profile104 */.xMj),
  Profile56: () => (/* reexport */ GeneratedPictoComponents/* Profile56 */.hKF),
  ProfileCompletion104: () => (/* reexport */ GeneratedPictoComponents/* ProfileCompletion104 */.rCZ),
  ProfileCompletion56: () => (/* reexport */ GeneratedPictoComponents/* ProfileCompletion56 */.rU9),
  PromoCombined104: () => (/* reexport */ GeneratedPictoComponents/* PromoCombined104 */.QKK),
  PromoCombined56: () => (/* reexport */ GeneratedPictoComponents/* PromoCombined56 */.MFI),
  PromoData104: () => (/* reexport */ GeneratedPictoComponents/* PromoData104 */.dxk),
  PromoData56: () => (/* reexport */ GeneratedPictoComponents/* PromoData56 */.Ds7),
  PromoDiscount104: () => (/* reexport */ GeneratedPictoComponents/* PromoDiscount104 */.GDQ),
  PromoDiscount56: () => (/* reexport */ GeneratedPictoComponents/* PromoDiscount56 */.QtP),
  RaisedSurface104: () => (/* reexport */ GeneratedPictoComponents/* RaisedSurface104 */.NZ9),
  RaisedSurface56: () => (/* reexport */ GeneratedPictoComponents/* RaisedSurface56 */.tJd),
  Receipt104: () => (/* reexport */ GeneratedPictoComponents/* Receipt104 */.mhJ),
  Receipt56: () => (/* reexport */ GeneratedPictoComponents/* Receipt56 */.ysT),
  RecurringPayment104: () => (/* reexport */ GeneratedPictoComponents/* RecurringPayment104 */.jxB),
  RecurringPayment56: () => (/* reexport */ GeneratedPictoComponents/* RecurringPayment56 */.pSi),
  RedeemPoints104: () => (/* reexport */ GeneratedPictoComponents/* RedeemPoints104 */.nb7),
  RedeemPoints56: () => (/* reexport */ GeneratedPictoComponents/* RedeemPoints56 */.p8Q),
  Rewards104: () => (/* reexport */ GeneratedPictoComponents/* Rewards104 */.uhr),
  Rewards56: () => (/* reexport */ GeneratedPictoComponents/* Rewards56 */.MrV),
  Roaming104: () => (/* reexport */ GeneratedPictoComponents/* Roaming104 */.P2L),
  Roaming56: () => (/* reexport */ GeneratedPictoComponents/* Roaming56 */.Vp3),
  RoamingOn104: () => (/* reexport */ GeneratedPictoComponents/* RoamingOn104 */.kNs),
  RoamingOn56: () => (/* reexport */ GeneratedPictoComponents/* RoamingOn56 */.uHK),
  SIM104: () => (/* reexport */ GeneratedPictoComponents/* SIM104 */.riU),
  SIM56: () => (/* reexport */ GeneratedPictoComponents/* SIM56 */.PUQ),
  SMS104: () => (/* reexport */ GeneratedPictoComponents/* SMS104 */.nlH),
  SMS56: () => (/* reexport */ GeneratedPictoComponents/* SMS56 */.Trx),
  Satellite104: () => (/* reexport */ GeneratedPictoComponents/* Satellite104 */.FWK),
  Satellite56: () => (/* reexport */ GeneratedPictoComponents/* Satellite56 */.VoM),
  Search104: () => (/* reexport */ GeneratedPictoComponents/* Search104 */.iMn),
  Search56: () => (/* reexport */ GeneratedPictoComponents/* Search56 */.YOP),
  Security104: () => (/* reexport */ GeneratedPictoComponents/* Security104 */.MKc),
  Security56: () => (/* reexport */ GeneratedPictoComponents/* Security56 */.AR2),
  SecurityHome104: () => (/* reexport */ GeneratedPictoComponents/* SecurityHome104 */.TWq),
  SecurityHome56: () => (/* reexport */ GeneratedPictoComponents/* SecurityHome56 */.za5),
  SecurityInternet104: () => (/* reexport */ GeneratedPictoComponents/* SecurityInternet104 */.blr),
  SecurityInternet56: () => (/* reexport */ GeneratedPictoComponents/* SecurityInternet56 */.dMq),
  SecurityMobile104: () => (/* reexport */ GeneratedPictoComponents/* SecurityMobile104 */.u_c),
  SecurityMobile56: () => (/* reexport */ GeneratedPictoComponents/* SecurityMobile56 */._Vo),
  SendOldPhone104: () => (/* reexport */ GeneratedPictoComponents/* SendOldPhone104 */.J5G),
  SendOldPhone56: () => (/* reexport */ GeneratedPictoComponents/* SendOldPhone56 */.V5c),
  Services104: () => (/* reexport */ GeneratedPictoComponents/* Services104 */.GyB),
  Services56: () => (/* reexport */ GeneratedPictoComponents/* Services56 */.QIL),
  Settings104: () => (/* reexport */ GeneratedPictoComponents/* Settings104 */.T49),
  Settings56: () => (/* reexport */ GeneratedPictoComponents/* Settings56 */.NJv),
  Share104: () => (/* reexport */ GeneratedPictoComponents/* Share104 */.ZhN),
  Share56: () => (/* reexport */ GeneratedPictoComponents/* Share56 */.DQA),
  SharedWiFi104: () => (/* reexport */ GeneratedPictoComponents/* SharedWiFi104 */.mCS),
  SharedWiFi56: () => (/* reexport */ GeneratedPictoComponents/* SharedWiFi56 */.YS1),
  Shop104: () => (/* reexport */ GeneratedPictoComponents/* Shop104 */.iMj),
  Shop56: () => (/* reexport */ GeneratedPictoComponents/* Shop56 */.W7L),
  Signin104: () => (/* reexport */ GeneratedPictoComponents/* Signin104 */.YcG),
  Signin56: () => (/* reexport */ GeneratedPictoComponents/* Signin56 */.YxN),
  SmartHome104: () => (/* reexport */ GeneratedPictoComponents/* SmartHome104 */.WKQ),
  SmartHome56: () => (/* reexport */ GeneratedPictoComponents/* SmartHome56 */.CdG),
  SmartWiFiBooster104: () => (/* reexport */ GeneratedPictoComponents/* SmartWiFiBooster104 */.yCn),
  SmartWiFiBooster56: () => (/* reexport */ GeneratedPictoComponents/* SmartWiFiBooster56 */.GzR),
  SomethingWentWrong104: () => (/* reexport */ GeneratedPictoComponents/* SomethingWentWrong104 */.nF8),
  SomethingWentWrong56: () => (/* reexport */ GeneratedPictoComponents/* SomethingWentWrong56 */.Lj6),
  SpeedOptimiser104: () => (/* reexport */ GeneratedPictoComponents/* SpeedOptimiser104 */.nWK),
  SpeedOptimiser56: () => (/* reexport */ GeneratedPictoComponents/* SpeedOptimiser56 */.XSh),
  Sporting104: () => (/* reexport */ GeneratedPictoComponents/* Sporting104 */.coY),
  Sporting56: () => (/* reexport */ GeneratedPictoComponents/* Sporting56 */.SC9),
  StarlinkSatellite104: () => (/* reexport */ GeneratedPictoComponents/* StarlinkSatellite104 */.Zc),
  StarlinkSatellite56: () => (/* reexport */ GeneratedPictoComponents/* StarlinkSatellite56 */.VEW),
  Store104: () => (/* reexport */ GeneratedPictoComponents/* Store104 */.jlN),
  Store56: () => (/* reexport */ GeneratedPictoComponents/* Store56 */.jXv),
  StoreAddress104: () => (/* reexport */ GeneratedPictoComponents/* StoreAddress104 */.zhQ),
  StoreAddress56: () => (/* reexport */ GeneratedPictoComponents/* StoreAddress56 */.xiF),
  StoreClock104: () => (/* reexport */ GeneratedPictoComponents/* StoreClock104 */.Jlz),
  StoreClock56: () => (/* reexport */ GeneratedPictoComponents/* StoreClock56 */.NFH),
  StoreSuccess104: () => (/* reexport */ GeneratedPictoComponents/* StoreSuccess104 */.kd7),
  StoreSuccess56: () => (/* reexport */ GeneratedPictoComponents/* StoreSuccess56 */.cG7),
  Storm104: () => (/* reexport */ GeneratedPictoComponents/* Storm104 */.hQc),
  Storm56: () => (/* reexport */ GeneratedPictoComponents/* Storm56 */.tgD),
  Success104: () => (/* reexport */ GeneratedPictoComponents/* Success104 */.$OG),
  Success56: () => (/* reexport */ GeneratedPictoComponents/* Success56 */.n_b),
  SunSmartMale104: () => (/* reexport */ GeneratedPictoComponents/* SunSmartMale104 */.yvl),
  SunSmartMale56: () => (/* reexport */ GeneratedPictoComponents/* SunSmartMale56 */.a2o),
  SupportPhone104: () => (/* reexport */ GeneratedPictoComponents/* SupportPhone104 */.byX),
  SupportPhone56: () => (/* reexport */ GeneratedPictoComponents/* SupportPhone56 */.hjK),
  Swipe104: () => (/* reexport */ GeneratedPictoComponents/* Swipe104 */.akr),
  Swipe56: () => (/* reexport */ GeneratedPictoComponents/* Swipe56 */.cO9),
  SwitchOff104: () => (/* reexport */ GeneratedPictoComponents/* SwitchOff104 */.NAZ),
  SwitchOff56: () => (/* reexport */ GeneratedPictoComponents/* SwitchOff56 */.zTi),
  SwitchOn104: () => (/* reexport */ GeneratedPictoComponents/* SwitchOn104 */.Ds0),
  SwitchOn56: () => (/* reexport */ GeneratedPictoComponents/* SwitchOn56 */.R$E),
  TV104: () => (/* reexport */ GeneratedPictoComponents/* TV104 */.EsA),
  TV56: () => (/* reexport */ GeneratedPictoComponents/* TV56 */.Cct),
  Tablet104: () => (/* reexport */ GeneratedPictoComponents/* Tablet104 */.G_W),
  Tablet56: () => (/* reexport */ GeneratedPictoComponents/* Tablet56 */.Qyr),
  TabletSim104: () => (/* reexport */ GeneratedPictoComponents/* TabletSim104 */.H2V),
  TabletSim56: () => (/* reexport */ GeneratedPictoComponents/* TabletSim56 */.FJB),
  Technician104: () => (/* reexport */ GeneratedPictoComponents/* Technician104 */.II8),
  Technician56: () => (/* reexport */ GeneratedPictoComponents/* Technician56 */.wjg),
  Teen104: () => (/* reexport */ GeneratedPictoComponents/* Teen104 */.Qx8),
  Teen56: () => (/* reexport */ GeneratedPictoComponents/* Teen56 */._rh),
  TeenFemale104: () => (/* reexport */ GeneratedPictoComponents/* TeenFemale104 */.yau),
  TeenFemale56: () => (/* reexport */ GeneratedPictoComponents/* TeenFemale56 */.csD),
  Telstra104: () => (/* reexport */ GeneratedPictoComponents/* Telstra104 */.P8Q),
  Telstra56: () => (/* reexport */ GeneratedPictoComponents/* Telstra56 */.N5X),
  TelstraAir104: () => (/* reexport */ GeneratedPictoComponents/* TelstraAir104 */.Tef),
  TelstraAir56: () => (/* reexport */ GeneratedPictoComponents/* TelstraAir56 */.D2),
  TelstraConnect104: () => (/* reexport */ GeneratedPictoComponents/* TelstraConnect104 */.paw),
  TelstraConnect56: () => (/* reexport */ GeneratedPictoComponents/* TelstraConnect56 */.Jy_),
  TelstraLocator104: () => (/* reexport */ GeneratedPictoComponents/* TelstraLocator104 */.R4e),
  TelstraLocator56: () => (/* reexport */ GeneratedPictoComponents/* TelstraLocator56 */.rvT),
  TelstraPlus104: () => (/* reexport */ GeneratedPictoComponents/* TelstraPlus104 */.F77),
  TelstraPlus56: () => (/* reexport */ GeneratedPictoComponents/* TelstraPlus56 */.lJW),
  TelstraTV104: () => (/* reexport */ GeneratedPictoComponents/* TelstraTV104 */.d2l),
  TelstraTV56: () => (/* reexport */ GeneratedPictoComponents/* TelstraTV56 */.Hh1),
  Ticket104: () => (/* reexport */ GeneratedPictoComponents/* Ticket104 */.MNu),
  Ticket56: () => (/* reexport */ GeneratedPictoComponents/* Ticket56 */.cgG),
  TrackOrder104: () => (/* reexport */ GeneratedPictoComponents/* TrackOrder104 */.PuU),
  TrackOrder56: () => (/* reexport */ GeneratedPictoComponents/* TrackOrder56 */.jol),
  TradeIn104: () => (/* reexport */ GeneratedPictoComponents/* TradeIn104 */.zHC),
  TradeIn56: () => (/* reexport */ GeneratedPictoComponents/* TradeIn56 */.f1k),
  Train104: () => (/* reexport */ GeneratedPictoComponents/* Train104 */.mGY),
  Train56: () => (/* reexport */ GeneratedPictoComponents/* Train56 */.uLQ),
  TransferRequest104: () => (/* reexport */ GeneratedPictoComponents/* TransferRequest104 */.WDh),
  TransferRequest56: () => (/* reexport */ GeneratedPictoComponents/* TransferRequest56 */.GQJ),
  Translate104: () => (/* reexport */ GeneratedPictoComponents/* Translate104 */.QPi),
  Translate56: () => (/* reexport */ GeneratedPictoComponents/* Translate56 */.qj3),
  Troubleshoot104: () => (/* reexport */ GeneratedPictoComponents/* Troubleshoot104 */.oUq),
  Troubleshoot56: () => (/* reexport */ GeneratedPictoComponents/* Troubleshoot56 */.Gyd),
  TruckFire104: () => (/* reexport */ GeneratedPictoComponents/* TruckFire104 */.vo0),
  TruckFire56: () => (/* reexport */ GeneratedPictoComponents/* TruckFire56 */.nm5),
  TurbanMale104: () => (/* reexport */ GeneratedPictoComponents/* TurbanMale104 */.P8i),
  TurbanMale56: () => (/* reexport */ GeneratedPictoComponents/* TurbanMale56 */.rkx),
  UnderseaCable104: () => (/* reexport */ GeneratedPictoComponents/* UnderseaCable104 */.gVL),
  UnderseaCable56: () => (/* reexport */ GeneratedPictoComponents/* UnderseaCable56 */.yTN),
  UnderseaCableNetwork104: () => (/* reexport */ GeneratedPictoComponents/* UnderseaCableNetwork104 */.QP2),
  UnderseaCableNetwork56: () => (/* reexport */ GeneratedPictoComponents/* UnderseaCableNetwork56 */.e7c),
  UnifiedComms104: () => (/* reexport */ GeneratedPictoComponents/* UnifiedComms104 */.Dj4),
  UnifiedComms56: () => (/* reexport */ GeneratedPictoComponents/* UnifiedComms56 */.z9t),
  Unlimited104: () => (/* reexport */ GeneratedPictoComponents/* Unlimited104 */.x9o),
  Unlimited56: () => (/* reexport */ GeneratedPictoComponents/* Unlimited56 */.hps),
  Upgrade104: () => (/* reexport */ GeneratedPictoComponents/* Upgrade104 */.Kfj),
  Upgrade56: () => (/* reexport */ GeneratedPictoComponents/* Upgrade56 */.usf),
  UploadDoc104: () => (/* reexport */ GeneratedPictoComponents/* UploadDoc104 */.j9N),
  UploadDoc56: () => (/* reexport */ GeneratedPictoComponents/* UploadDoc56 */.ZCb),
  VIP104: () => (/* reexport */ GeneratedPictoComponents/* VIP104 */.fa_),
  VIP56: () => (/* reexport */ GeneratedPictoComponents/* VIP56 */.rOZ),
  Video104: () => (/* reexport */ GeneratedPictoComponents/* Video104 */.nc0),
  Video56: () => (/* reexport */ GeneratedPictoComponents/* Video56 */.Bpe),
  Warning104: () => (/* reexport */ GeneratedPictoComponents/* Warning104 */.KzG),
  Warning56: () => (/* reexport */ GeneratedPictoComponents/* Warning56 */.gtZ),
  Watch104: () => (/* reexport */ GeneratedPictoComponents/* Watch104 */.fKR),
  Watch56: () => (/* reexport */ GeneratedPictoComponents/* Watch56 */.$oy),
  WeCare104: () => (/* reexport */ GeneratedPictoComponents/* WeCare104 */.ZN$),
  WeCare56: () => (/* reexport */ GeneratedPictoComponents/* WeCare56 */.l1A),
  WhiteLabelAboutApp104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelAboutApp104 */.b_r),
  WhiteLabelAboutApp56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelAboutApp56 */.Hif),
  WhiteLabelAccountsPayments104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelAccountsPayments104 */.mjM),
  WhiteLabelAccountsPayments56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelAccountsPayments56 */.wFT),
  WhiteLabelBank104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBank104 */.ZEQ),
  WhiteLabelBank56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBank56 */.Zmq),
  WhiteLabelBillOverview104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBillOverview104 */.VAJ),
  WhiteLabelBillOverview56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBillOverview56 */.nJ9),
  WhiteLabelBillPaid104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBillPaid104 */.QA6),
  WhiteLabelBillPaid56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBillPaid56 */.G2E),
  WhiteLabelBroadbandMobile104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBroadbandMobile104 */.E1T),
  WhiteLabelBroadbandMobile56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelBroadbandMobile56 */.s4u),
  WhiteLabelCardAdded104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelCardAdded104 */.NDH),
  WhiteLabelCardAdded56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelCardAdded56 */.xp4),
  WhiteLabelChangePlan104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelChangePlan104 */.uH4),
  WhiteLabelChangePlan56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelChangePlan56 */.Gmf),
  WhiteLabelChat104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelChat104 */.vxK),
  WhiteLabelChat56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelChat56 */.vTY),
  WhiteLabelDataPacks104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDataPacks104 */.bPk),
  WhiteLabelDataPacks56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDataPacks56 */.xgE),
  WhiteLabelDataPool104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDataPool104 */.PH7),
  WhiteLabelDataPool56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDataPool56 */.Z4L),
  WhiteLabelDelivery104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDelivery104 */.hdJ),
  WhiteLabelDelivery56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDelivery56 */.Fr$),
  WhiteLabelDownload104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDownload104 */.L6n),
  WhiteLabelDownload56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelDownload56 */.nOp),
  WhiteLabelESIM104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelESIM104 */.Fy$),
  WhiteLabelESIM56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelESIM56 */.But),
  WhiteLabelEmptyStateBox104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelEmptyStateBox104 */.ibb),
  WhiteLabelEmptyStateBox56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelEmptyStateBox56 */._0),
  WhiteLabelError104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelError104 */.t6w),
  WhiteLabelError56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelError56 */.DXp),
  WhiteLabelFailedConnection104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelFailedConnection104 */.OOd),
  WhiteLabelFailedConnection56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelFailedConnection56 */.G1g),
  WhiteLabelFeedback104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelFeedback104 */.eZm),
  WhiteLabelFeedback56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelFeedback56 */.q_Z),
  WhiteLabelGift104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelGift104 */.l2),
  WhiteLabelGift56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelGift56 */.DHs),
  WhiteLabelHelp104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelHelp104 */.W3I),
  WhiteLabelHelp56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelHelp56 */.qe$),
  WhiteLabelInformation104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInformation104 */.N80),
  WhiteLabelInformation56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInformation56 */.DX6),
  WhiteLabelInstallation104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInstallation104 */.PaP),
  WhiteLabelInstallation56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInstallation56 */.DKi),
  WhiteLabelInternationalCalls104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternationalCalls104 */.sNB),
  WhiteLabelInternationalCalls56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternationalCalls56 */.CzF),
  WhiteLabelInternationalMobileCall104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternationalMobileCall104 */.LPl),
  WhiteLabelInternationalMobileCall56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternationalMobileCall56 */.dYY),
  WhiteLabelInternet104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternet104 */.Kmb),
  WhiteLabelInternet56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelInternet56 */.A89),
  WhiteLabelMail104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMail104 */.i15),
  WhiteLabelMail56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMail56 */.QpZ),
  WhiteLabelMobile104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMobile104 */.xAl),
  WhiteLabelMobile56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMobile56 */.DpP),
  WhiteLabelMobileAndTablet104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMobileAndTablet104 */.gwI),
  WhiteLabelMobileAndTablet56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelMobileAndTablet56 */.oNg),
  WhiteLabelNetworkSpeed104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelNetworkSpeed104 */.i89),
  WhiteLabelNetworkSpeed56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelNetworkSpeed56 */.CNK),
  WhiteLabelPayment104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPayment104 */.Fms),
  WhiteLabelPayment56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPayment56 */.tS6),
  WhiteLabelPaymentCalendar104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPaymentCalendar104 */.dDm),
  WhiteLabelPaymentCalendar56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPaymentCalendar56 */.lBq),
  WhiteLabelPaymentHelp104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPaymentHelp104 */.WGp),
  WhiteLabelPaymentHelp56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPaymentHelp56 */.Y2d),
  WhiteLabelPin104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPin104 */.w0r),
  WhiteLabelPin56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPin56 */.u8S),
  WhiteLabelPlaceholder104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPlaceholder104 */.sNH),
  WhiteLabelPlaceholder56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPlaceholder56 */.ONp),
  WhiteLabelPostPaid104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPostPaid104 */.Xe3),
  WhiteLabelPostPaid56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPostPaid56 */.Pcs),
  WhiteLabelPrePaid104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPrePaid104 */.kmf),
  WhiteLabelPrePaid56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPrePaid56 */.wpk),
  WhiteLabelProfile104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelProfile104 */.EnQ),
  WhiteLabelProfile56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelProfile56 */.owW),
  WhiteLabelPromoCombined104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoCombined104 */.hTM),
  WhiteLabelPromoCombined56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoCombined56 */.p7M),
  WhiteLabelPromoData104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoData104 */.CRn),
  WhiteLabelPromoData56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoData56 */.G60),
  WhiteLabelPromoDiscount104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoDiscount104 */.n2z),
  WhiteLabelPromoDiscount56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelPromoDiscount56 */.jgx),
  WhiteLabelReceipt104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelReceipt104 */.HMf),
  WhiteLabelReceipt56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelReceipt56 */.jK4),
  WhiteLabelRecurringPayment104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelRecurringPayment104 */.EM$),
  WhiteLabelRecurringPayment56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelRecurringPayment56 */.eYW),
  WhiteLabelRoaming104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelRoaming104 */.Q_$),
  WhiteLabelRoaming56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelRoaming56 */.KmN),
  WhiteLabelSMS104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSMS104 */.ma1),
  WhiteLabelSMS56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSMS56 */.YOr),
  WhiteLabelSecurity104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSecurity104 */.zzv),
  WhiteLabelSecurity56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSecurity56 */.FwZ),
  WhiteLabelServices104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelServices104 */.T2u),
  WhiteLabelServices56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelServices56 */.lJr),
  WhiteLabelSettings104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSettings104 */.m8_),
  WhiteLabelSettings56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSettings56 */.wwD),
  WhiteLabelSignIn104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSignIn104 */.J4O),
  WhiteLabelSignIn56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSignIn56 */.rrn),
  WhiteLabelSomethingWentWrong104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSomethingWentWrong104 */.EIm),
  WhiteLabelSomethingWentWrong56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSomethingWentWrong56 */.k9C),
  WhiteLabelSuccess104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSuccess104 */.gQz),
  WhiteLabelSuccess56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSuccess56 */.iSF),
  WhiteLabelSupportPhone104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSupportPhone104 */.ycN),
  WhiteLabelSupportPhone56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelSupportPhone56 */.iZ9),
  WhiteLabelTechnician104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelTechnician104 */.J2I),
  WhiteLabelTechnician56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelTechnician56 */.n1$),
  WhiteLabelTrackOrder104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelTrackOrder104 */.svY),
  WhiteLabelTrackOrder56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelTrackOrder56 */.MGw),
  WhiteLabelWarning104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWarning104 */.jc1),
  WhiteLabelWarning56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWarning56 */.FRY),
  WhiteLabelWeCare104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWeCare104 */.OC8),
  WhiteLabelWeCare56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWeCare56 */.W5O),
  WhiteLabelWiFi104: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWiFi104 */.KSp),
  WhiteLabelWiFi56: () => (/* reexport */ GeneratedPictoComponents/* WhiteLabelWiFi56 */.IqK),
  WiFi104: () => (/* reexport */ GeneratedPictoComponents/* WiFi104 */.ny$),
  WiFi56: () => (/* reexport */ GeneratedPictoComponents/* WiFi56 */.VhO),
  WiFiBooster104: () => (/* reexport */ GeneratedPictoComponents/* WiFiBooster104 */.ZBc),
  WiFiBooster56: () => (/* reexport */ GeneratedPictoComponents/* WiFiBooster56 */.L6U),
  Window104: () => (/* reexport */ GeneratedPictoComponents/* Window104 */.E30),
  Window56: () => (/* reexport */ GeneratedPictoComponents/* Window56 */.mJS),
  YoungAdultMale104: () => (/* reexport */ GeneratedPictoComponents/* YoungAdultMale104 */.V7K),
  YoungAdultMale56: () => (/* reexport */ GeneratedPictoComponents/* YoungAdultMale56 */.fuE),
  "default": () => (/* binding */ src_Picto)
});

// EXTERNAL MODULE: external "@babel/runtime/helpers/defineProperty"
var defineProperty_ = __webpack_require__(1116);
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty_);
// EXTERNAL MODULE: external "@babel/runtime/helpers/objectWithoutProperties"
var objectWithoutProperties_ = __webpack_require__(2462);
var objectWithoutProperties_default = /*#__PURE__*/__webpack_require__.n(objectWithoutProperties_);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(6942);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(2015);
// EXTERNAL MODULE: external "react/jsx-runtime"
var jsx_runtime_ = __webpack_require__(8732);
;// ./src/Picto/Picto.tsx


var _excluded = ["className", "children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { defineProperty_default()(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }



/**
 *
 * Illustrations help convey complex ideas in a simple way.
 * They should be meaningful and reflect a user's context and emotional state.
 * We use them to make technical information feel more human, and add some personality to the way we communicate.
 *
 * [View the Picto documentation on Confluence](https://confluence.tools.telstra.com/display/DCSYS/Pictograms+and+Illustrations)
 *
 * @version 1.0.0
 */

function Picto(props) {
  var className = props.className,
    children = props.children,
    other = objectWithoutProperties_default()(props, _excluded);
  var classes = classnames_default()('able-picto', className);
  var childProps = _objectSpread({
    className: classes,
    focusable: 'false',
    'aria-hidden': 'true'
  }, other);
  var SelectedPictogram = function SelectedPictogram() {
    return /*#__PURE__*/(0,external_react_.cloneElement)(children, childProps);
  };
  return /*#__PURE__*/(0,jsx_runtime_.jsx)(SelectedPictogram, {});
}
/* harmony default export */ const Picto_Picto = (Picto);
// EXTERNAL MODULE: ./src/Picto/Picto.scss
var src_Picto_Picto = __webpack_require__(493);
// EXTERNAL MODULE: ./src/Picto/GeneratedPictoComponents/index.tsx + 704 modules
var GeneratedPictoComponents = __webpack_require__(5547);
;// ./src/Picto/index.ts



/* harmony default export */ const src_Picto = (Picto_Picto);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});